import t, { useState as u, useEffect as l } from "react";
import { View as s, Text as p, Icon as r, Button as f } from "@vectord/ui";
import A from "lottie-react";
function g({ breakpoint: k }) {
  const [i, y] = u(() => window.innerWidth <= k);
  return l(() => {
    const a = () => {
      y(window.innerWidth <= k);
    };
    return window.addEventListener("resize", a), a(), () => {
      window.removeEventListener("resize", a);
    };
  }, [k]), i;
}
const w = [
  "Understand key skills for your target role",
  "How to master continuous upskilling?",
  "Navigate successful transitions between roles or industries",
  "Develop a strategic plan for faster career growth"
], I = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='X'%3e%3cpath%20id='Vector'%20d='M19.281%2018.2193C19.3507%2018.289%2019.406%2018.3717%2019.4437%2018.4628C19.4814%2018.5538%2019.5008%2018.6514%2019.5008%2018.75C19.5008%2018.8485%2019.4814%2018.9461%2019.4437%2019.0371C19.406%2019.1282%2019.3507%2019.2109%2019.281%2019.2806C19.2114%2019.3503%2019.1286%2019.4055%2019.0376%2019.4433C18.9465%2019.481%2018.849%2019.5004%2018.7504%2019.5004C18.6519%2019.5004%2018.5543%2019.481%2018.4632%2019.4433C18.3722%2019.4055%2018.2895%2019.3503%2018.2198%2019.2806L12.0004%2013.0603L5.78104%2019.2806C5.64031%2019.4213%205.44944%2019.5004%205.25042%2019.5004C5.05139%2019.5004%204.86052%2019.4213%204.71979%2019.2806C4.57906%2019.1399%204.5%2018.949%204.5%2018.75C4.5%2018.5509%204.57906%2018.3601%204.71979%2018.2193L10.9401%2012L4.71979%205.78058C4.57906%205.63985%204.5%205.44898%204.5%205.24996C4.5%205.05094%204.57906%204.86006%204.71979%204.71933C4.86052%204.5786%205.05139%204.49954%205.25042%204.49954C5.44944%204.49954%205.64031%204.5786%205.78104%204.71933L12.0004%2010.9396L18.2198%204.71933C18.3605%204.5786%2018.5514%204.49954%2018.7504%204.49954C18.9494%204.49954%2019.1403%204.5786%2019.281%204.71933C19.4218%204.86006%2019.5008%205.05094%2019.5008%205.24996C19.5008%205.44898%2019.4218%205.63985%2019.281%205.78058L13.0607%2012L19.281%2018.2193Z'%20fill='black'/%3e%3c/g%3e%3c/svg%3e", x = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='X'%3e%3cpath%20id='Vector'%20d='M12.854%2012.1462C12.9005%2012.1927%2012.9373%2012.2478%2012.9625%2012.3085C12.9876%2012.3692%2013.0006%2012.4343%2013.0006%2012.5C13.0006%2012.5657%2012.9876%2012.6307%2012.9625%2012.6914C12.9373%2012.7521%2012.9005%2012.8073%2012.854%2012.8537C12.8076%2012.9002%2012.7524%2012.937%2012.6917%2012.9622C12.631%2012.9873%2012.566%2013.0003%2012.5003%2013.0003C12.4346%2013.0003%2012.3695%2012.9873%2012.3088%2012.9622C12.2481%2012.937%2012.193%2012.9002%2012.1465%2012.8537L8.00028%208.70685L3.85403%2012.8537C3.76021%2012.9475%203.63296%2013.0003%203.50028%2013.0003C3.3676%2013.0003%203.24035%2012.9475%203.14653%2012.8537C3.05271%2012.7599%203%2012.6327%203%2012.5C3%2012.3673%203.05271%2012.24%203.14653%2012.1462L7.2934%207.99997L3.14653%203.85372C3.05271%203.7599%203%203.63265%203%203.49997C3%203.36729%203.05271%203.24004%203.14653%203.14622C3.24035%203.0524%203.3676%202.99969%203.50028%202.99969C3.63296%202.99969%203.76021%203.0524%203.85403%203.14622L8.00028%207.2931L12.1465%203.14622C12.2403%203.0524%2012.3676%202.99969%2012.5003%202.99969C12.633%202.99969%2012.7602%203.0524%2012.854%203.14622C12.9478%203.24004%2013.0006%203.36729%2013.0006%203.49997C13.0006%203.63265%2012.9478%203.7599%2012.854%203.85372L8.70715%207.99997L12.854%2012.1462Z'%20fill='white'/%3e%3c/g%3e%3c/svg%3e", m = [
  {
    h: 16,
    id: "0",
    p: "data:image/webp;base64,UklGRhwBAABXRUJQVlA4WAoAAAAQAAAADQAADwAAQUxQSLwAAAABgGvbtrFnxbZt206r0iqTLpVZqbZtvYFtO5VtG93/J88QEROAoKiutbkcf4aevH68n1YqCMhXbCe56puG9S17AoWnpgjNujTAYVsDHPMipZDoKqerFhJ2eyf6pbA8lzlIRO3DF4bDUd6ROYjH8N4aWtNR3BBbzEVyvsgj7kgT7XOSp0F18PsxGFJGkBxokwdFUYi+CgTTox51QCLoPBZAtWfLAMp+QxAqW77h2jatx5+ije+vKvxT8SMOQVZQOCA6AAAAsAEAnQEqDgAQAAFAJiWIAnRUAAT0AAD+55cOFQ/xMoyGAJA2lPHdZnOCdJUSrum/TkjVCSIFAgAAAA==",
    w: 14,
    e: 1
  },
  {
    h: 15,
    id: "1",
    p: "data:image/webp;base64,UklGRuwAAABXRUJQVlA4WAoAAAAQAAAADwAADgAAQUxQSG0AAAABcFpt27K8vwHZXaJrYgd36JY5DPA3miYbwN6ERiJbcP6IRpfqNkBETADctbHVgl8Aj93bZo6ddalHjQoF4ForbsQ1xOUUEQfXMbY9wnkl9WyeM5zU8CwxegV6/0j/FDEUboqRZ5McWOuTZ1tZAFZQOCBYAAAAEAIAnQEqEAAPAAFAJiWIAnQwSsGYgtroAAD+npc/Pvu1RiLnEaVDM/hnldhOyfo5zcSybONpELMCfZ4mLL16FckGJn72yZUwiGpak7jWvTySJS+W3PAAAA==",
    w: 16,
    e: 1
  },
  {
    h: 22,
    id: "2",
    p: "data:image/webp;base64,UklGRsABAABXRUJQVlA4WAoAAAAQAAAAEgAAFQAAQUxQSJwAAAABgGJt2zLlGfcZaBYdkpPZgNP/TCJ5d+nuloYtuLt0mru7PKPvu4WImADEdQY/hqEdJJmrqCPJDFnJd5RNlPpKkmeQ+g8YvS6xjDDmrKSVsZ9PT09PT1qcQBm17Uj6VM2bHqhub6d6ydSvevQhT5UOIKnKMAxjIk4NhL2xeiANxpizinaijhMhvib5mgaxmyRLIbfckfXQ5vfVIj5WUDgg/gAAANAFAJ0BKhMAFgA+bTKUR6QioiEoCACADYlkAMKZoDbACnb50ANUON05j4SOsYU55/u+nr79BdgA/vqtFpxydoAr41i3jDFOVnzETBVjXiDD67l007N+R7jf/3gZ/+Yu58ugFfFecWJ4yxNIViNn57SZDTtH2HL+qEfiJyK2MdoMiAghoK+yJOtnxEQ/3Y8aOp2NNf8JxXwqP+SqovzKl7uMTi5MM/2QriLUuFXrR2+rCvbi4qgPYhi6q51uJv7uTiDdDtz1vCl2lkxip8vwM1X0cF/4unc/tm+nfy5P8z8P6tpDwIfHITmsbvuIGzUhLPcvIv9SUY9/98sAAAAA",
    w: 19,
    e: 1
  },
  {
    h: 76,
    id: "3",
    p: "data:image/webp;base64,UklGRt4DAABXRUJQVlA4WAoAAAAQAAAASwAASwAAQUxQSCEAAAABHyAQIGMLciS4ERGRDCIBkpP4/4lWBhgi+j8BROzE9wUAVlA4IJYDAAAwEgCdASpMAEwAPm0ukkWkIqGYWd2oQAbEsoBiIt4FQ3ACxdbdAbtdOGuK45p/ljfPJW226n91XEYhhM24pZy/+8Ky0tlo2mmJCF30nMaZwBUOkUjoPsBrk/W/0cxrwdr3td+9WrimLdIHUMSceaclNxw6YVz6GFrj4jvFGRPMh/XZ0Rs45Awv9pSB9KdvGP/VpcmlbaxfzXIAAP75Qx8YTSL/sneahQ/zq3C7j/8ZyhapQUyLB+IKUu6Lr/X9AfPDoMRhMivw9c9NKqtQpIzlNmz4w52121AneTkFwC7j13Ut4jHpiibCeZ/f1Bo+Y2BNqc1HYFelAk/SCDUFIUcI1vbA1ssrSjWwqCGYoXgX/zu9l2SGrMRDSCSFVdPobHO8QJDNyTUYF0gLvE6Oz/dPfjUPcP/gwSIKxFFr/3z4gBLFtPrmjjou0+JELD0ikaCoVcvWgaLveIv7kGlDwiuzBd6Lj6IBkSwCeA0Uv6RLbLwYXvBvAi9RRuNuv1tMNM+nBWxOJ1hWaKB+gQcJG6WS0jdEC02O5Eec5bkReC/zBLXDusV1O1wfV/SiFnLwss1az5fZ2jp/8TryoFhojqzDSBb9feRNiQj8fRiuCauwIXciD9rQLwdWaqGG3bu0JulxDZ3fEM6gAEoTdL0HcKAqKpk14ZSIhthvkNUjwjQR2AF4bKHow9o96vHzciTl3WiyXGABLHoBskcZCKnzcwiViux4LW2hjftgd9lnRQBL4w6x3aqXbSLoiRQeZslm3qzf5ky6CHyaYV0/OBcpIViaGacMRXbKsRq70FF5GMDoMuCT/+JR34IIg9/kY+feLbkfTeEUS7ff+SPpThLZuXu7dQuZ/qiwSFQ1vYq0iMffLsyZhUW2vSOGmGmbfpRtQV+MuxWRG5yfBeBE24rZS+m2Ncdrq+qsLVucsDE+eG0twR/Nqt5jBJ4hPrJXvoAckVed0jVJo537jj1J61U2eZ+4QMSmx0lZBGuENzhz149MV8Fewd6Xi6kS+SY9UQtPE1awRz4/lBdEvcikOXpzusABMT7IQhUz/keofs3I3cjvkOjHtd9TgsOA4PFYiG2y7205r5m1uJf4/7I3Szrkvr16hAAZyVnH6ww/V15ysmU0iegeVqVP23Y7FPYahnlUwUABKlQB1LqpqWnA/ZDkbe9tcNbFBmDrABNq1GoZKqOVBd/Uq6SsBAigcNeAXLNPaoAu5S6IAAA=",
    w: 76,
    e: 1
  },
  {
    h: 43,
    id: "4",
    p: "data:image/webp;base64,UklGRqICAABXRUJQVlA4WAoAAAAQAAAAJQAAKgAAQUxQSNQAAAABgBDZdt3mQhCEB8EQBEEMGghmYDFIGKQMAsEQDOFBEITbj/X8rhFExAQg0fYx3gVqc5LcZQdPq+jJ81WzcdokjfOqsBEoAnMGITwYPARPRve8jeFXWmO8Z9m40JLMebEmHbzqweNtsye1X2cbxaP8a5SvAGzoOmBO/QM4qB+GjTdcUXjDDtQbfAAsOi8AMFRu+N9UC86bS1YErQb9SkcyL36QbBe8ZNWYG7IfsQXpPbQi/zvSIdwDHyh95kXCqRuUNlsgLZMV4v2kQ112ki/csDZDJlZQOCCoAQAA8AkAnQEqJgArAD5tMpRHJCMiISc4C2iADYlkAL5lic8Au2CgAP5nNt1gKAEMo8cT2laHGftWmr0GL0tV1D4q9Ir5AZFWqQVAu7kW6oDoA+UAnEYogAChYAD+6zS9wEj3aQvSNcMBZeJ66evFE3N10mHnug+hw2OdYoDRPfsukBCY5sU/AY3fhdd3+8vPdLJuH8N4LxL5i3yH2buk70Fvn/sntPv96+SO+10S9eE8Y0U3eitRxgODWAMgeBqBn8lj3m9rmrJMaf//9JwRWJtXQ++YZMnINZ76lJWmor6eUdIkPJkpOP6S5bGVeTlyacVKbwXPAIKVzwW+geB/jj01tDTyo3F8mj1dmUej8Ie3WUURfDG6IJC0/1GaS+OsOVpRWA2TES2KbzlF7OfuOyJMRaKld38Mg3+xkljB2UmAuCufbajidM6LO2acoEfQnPUbl72vtDzFlGF0CeI/QZaRwP6syacefyjdLsMBhpnIP//6Tb8jGa/owWKeFFzY44LkDZrJTZ6+8f+wfZLJZxomsbDC2qef/RS9ltoffv04ET8CKP/3M8gAAA==",
    w: 38,
    e: 1
  },
  {
    h: 92,
    id: "5",
    p: "data:image/webp;base64,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",
    w: 92,
    e: 1
  },
  {
    h: 43,
    id: "6",
    p: "data:image/webp;base64,UklGRqQCAABXRUJQVlA4WAoAAAAQAAAAJQAAKgAAQUxQSNQAAAABgBDZdt3mQhCEB8EQBEEMGghmYDFIGKQMAsEQDOFBEITbj/X8rhFExAQg0fYx3gVqc5LcZQdPq+jJ81WzcdokjfOqsBEoAnMGITwYPARPRve8jeFXWmO8Z9m40JLMebEmHbzqweNtsye1X2cbxaP8a5SvAGzoOmBO/QM4qB+GjTdcUXjDDtQbfAAsOi8AMFRu+N9UC86bS1YErQb9SkcyL36QbBe8ZNWYG7IfsQXpPbQi/zvSIdwDHyh95kXCqRuUNlsgLZMV4v2kQ112ki/csDZDJlZQOCCqAQAA0AkAnQEqJgArAD5tMpRHJCMiISc4C2iADYlkAL11ic8Wu2CgAP5nNstEFMl8b72laHGftWmr0GL0tV1D4q9Ir5AZ5+QQT9nLZZaWQLZ/31h6KYHwOHyAAP7rNL3ASPdpC9I1wssZOafp68SDc3XSYd+5r6HDY51CVZU9+y6QEJjKj78Bjd+F13fzy890sm6zvU83ox2UzOfzE733uGhn/sntbj/JPLXFDz60h6Tvb6Q854//CGhvgR/yEEyu/ksbAcFhU5ulh///pOBZk5fm77XRtcJVLPfUo0s1HserWlzlUu01LlpLlsatHO/1U3net59vaI4tWYKINfFP449Pch71bKWdkcsg+LfyGL+/9t1lFEXwxuh+wtP7YlM/HXXmzykYDJlVHMmhbrq9EJmiobAOECRXJ91HbLTJRsI9+bSt5vx1AfKWdvzaeskmaqv/zAnmWZHunqzSIAVPf6DM/fnO+hZfMqgJ6h6mzl19nhn//9JuR1wjL4JpOO2ggwnqxw6D1kps8/eN/YPslic4RLVEcA1eXf/opey20Pv36cBSIrA//czyAAAA",
    w: 38,
    e: 1
  },
  {
    h: 92,
    id: "7",
    p: "data:image/webp;base64,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",
    w: 92,
    e: 1
  },
  {
    h: 92,
    id: "8",
    p: "data:image/webp;base64,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",
    w: 92,
    e: 1
  },
  {
    h: 92,
    id: "9",
    p: "data:image/webp;base64,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",
    w: 92,
    e: 1
  },
  {
    h: 43,
    id: "10",
    p: "data:image/webp;base64,UklGRqICAABXRUJQVlA4WAoAAAAQAAAAJQAAKgAAQUxQSNQAAAABgBDZdt3mQhCEB8EQBEEMGghmYDFIGKQMAsEQDOFBEITbj/X8rhFExAQg0fYx3ga1OUnusoOnVfTk+arZOG2SxnlV2AgUgTmDEB4MHoIno3vexvArrTHes2xcaEnmvFiTDl714PG22ZPar7ON4lH+NcpXADZ0HTCn/gEc1A/DxhuuKLxhB+oNPgAWnRcAcJUb/jfVgvPmkhVBq0G/0pHMix8k2wUvWTXmhuxHbEF6D63I/450CPfAB0qfeZFw6galzRZIy2SFeD/pUJed5As3XKohE1ZQOCCoAQAA8AkAnQEqJgArAD5tMpRHJCMiISc4C2iADYlkAL5lic8Au2CgAP5nNt1gKAEMo8cT2laHGftWmr0GL0tV1D4q9Ir5AZFWqQVAu7kW6oDoA+UAnEYogAChYAD+6zS9wEj3aQvSNcMBZeJ66evFE3N10mHnug+hw2OdYoDRPfsukBCY5sU/AY3fhdd3+8vPdLJuH8N4LxL5i3yH2buk70Fvn/sntPv96+SO+10S9eE8Y0U3eitRxgODWAMgeBqBn8lj3m9rmrJMaf//9JwRWJtXQ++YZMnINZ76lJWmor6eUdIkPJkpOP6S5bGVeTlyacVKbwXPAIKVzwW+geB/jj01tDTyo3F8mj1dmUej8Ie3WUURfDG6IJC0/1GaS+OsOVpRWA2TES2KbzlF7OfuOyJMRaKld38Mg3+xkljB2UmAuCufbajidM6LO2acoEfQnPUbl72vtDzFlGF0CeI/QZaRwP6syacefyjdLsMBhpnIP//6Tb8jGa/owWKeFFzY44LkDZrJTZ6+8f+wfZLJZxomsbDC2qef/RS9ltoffv04ET8CKP/3M8gAAA==",
    w: 38,
    e: 1
  },
  {
    h: 87,
    id: "11",
    p: "data:image/webp;base64,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",
    w: 88,
    e: 1
  },
  {
    h: 22,
    id: "12",
    p: "data:image/webp;base64,UklGRsIBAABXRUJQVlA4WAoAAAAQAAAAEgAAFQAAQUxQSJ0AAAABgGLb2rLl/u64dYfkZDqJRf/yPwB0Au7J3dLPFNxdOs3dXe6vzzOFiJgAxHQGPoah7SVZoPCTZLas/DvCJkq9J8kzSN0HjFyXWEYYdVZSz+jPp6enpyeNTqCS2iZkfKrmTZdUNzVRvWTqVz36UKjKApBRZRiGMRGjGsKOaO2QBqLMWUU7EceJEF+TfM2E2E2SFZBb7sgaaIv6/IgNAFZQOCD+AAAA0AUAnQEqEwAWAD5tMpRHpCKiISgIAIANiWQAwpmgNsAKdvnQA1Q43TmPhI6xhTnn+76evv0F2AD++q0WnHJ2gCvjWLeMMU5WfMRMFWNeIMPruXTTs35HuN//eBn/5i7ny6AV8V5xYnjLE0hWI2fntJkNO0fYcv6oR+InIrYx2gyICCGgr7Ik62fERD/djxo6nY01/wnFfCo/5Kqi/MqXu4xOLkwz/ZCuItS4VetHb6sK9uLiqA9iGLqrnW4m/u5OIN0O3PW8KXaWTGKny/AzVfRwX/i6dz+2b6d/Lk/zPw/q2kPAh8chOaxu+4gbNSEs9y8i/1JRj3/3ywAAAAA=",
    w: 19,
    e: 1
  },
  {
    h: 77,
    id: "13",
    p: "data:image/webp;base64,UklGRsYFAABXRUJQVlA4WAoAAAAQAAAATAAATAAAQUxQSB8AAAABFyAQSFLYH3aNiAgHMgGLCUn/OAvgiOj/BKCuYr4dAFZQOCCABQAAkBgAnQEqTQBNAD5tLpRGJCKiISuXG4CADYlAGJoNIUAoWRWBHBE27t3LbzXXcf47wx8gjhqu4yfHkjoxXR8i883LRfWsv/cMdm7h64CRnq+L3+BMjbwjZ9wwcQrvRfbyRIJLI/7R6bMbfMT3JiWcBxu1Ojhe6dnZ+Xl8iUf6UCpAxQsZyZyaLH+V9hfV6kxpSGNI8ORyrrzWN1GtNaRstyWc1ibtf1qA6/aDYrqaQpXDNk/275aUy/2tdN93mSnEQoUgX0dmy+WGHCrWAAD+/SYIBOJTjZ36NhxX3y4Pj9XaMLiWtPWPWD16OxzkO28m5HYdCVqWNqnuXH77jGqmFSnpDmy9KfoYyNqg8k6MiLelPjn7GcwM+rKi5/bU4/Cgd3FlLlhF+tzzZ4ubSlwbB4MdS8UN5fhB1DU0jcRLNajHV0HECPgyzZ98nhVH2HDCNTxY9Cm/PCWOX+7Zv/3EP/uG3/7YNFQeWrTgh09GM3DJ0sEOqccCOYsL48+k/5xjIKXDIwveZvWLPlhrJoLn7BPyDCss+N5IRbh+1Dz46YQGg9ol6br3IRvkZIlYTL78oH+P95vJtyzvrUQlHwH0fx0ga5Pvz22mLF73qHq1P4d3U77PYrfSpSFIwSC6QJ12F0F2I/92V98S4oXFKd9TLxf/X/mMScrwdqsE+cUVtz5SzOnfkiCoJau4tvA8PZ1UnVA+t8pJqYs8I5/KQjZxYf/7qN4aHBWypvYhuuwf9jpyGnRQYsRSOD0I6k3BYWmdscw63bN1mnTkf87UPKdJToXcomMJL++JebKrxBJphEnidc+DmDQUH7JcJkGZguvPSD+II8XoHO2rG8ou9e0O3qEAuL1myr6sWFCMf4QeNMKfziaDs3szWJhpJcw/+g2IIgLDUOTaBRe2n1+gxSQWKccZn+avQTsr80s781fUvzHnRn3Lyx9FwNG7t53YXlybBd7YPxmFcaRDa/ak71phUfk4TCKcDrxNqbKJFJtjI4lfPVDOEPCtE81kCw7tInjmohzdyF64XgcjbjE8+x3oOjdOzadmoAWeVsjGDVDroONL7XxyiPdruJ+rZ6Jp8wxFKGbx+VBrFwhab4Rf5kqZKRDSKv391EiugTsvBXU929cjaoEx/sdT8d/ahcxKOXgixWUZ9f4jRwlUyXZPh4hPn8ZdC4zltlwOT+F0/W0HxQY4q5P09TfBJVd5SLMCmTBFQTA7cRR41DIVnU3mkWIxcUpNsMZs8X4MSGuIPwBJ2wsUoe830QBDc/NG7JrtJtx2KTJYdfp805sKkf2iXVCHO3ux1vpRuXxNcwwzoK5cbAbTpk4gAbaGPKJAxNwT+B4wg27q2mNv/2YcPddrfeXkhSxHxS2OYp+MYW64y9wSE4QQ4M+yCMtTtgppQcpS0eQ1S64vAxONknfEyBiCB+oscUVVJhugq2rbRsODiN/lSZRwPmvkRba+UNyf5GBzEcySEXf3IOC87g/Fs3MhRS3IM+/RtfAFqv0VfOh+E511wDxvD7lsdy06bn5nw8sKDCOuXMZ149YE2fmIRQ0z5qnCzcuRGwZQ0mF2WWqyeKqpcgev7Kc49P0bKcQNA2l73I07J+oT89PoX2j+0P7mjAxuHHCFSAwvKfcuVKBbLuq5L/pMccxT5cJrSJckfk+yMZBTfLrPhO1hNsI0HfEBNdFQ5o4e3JEZp2isIfezQoV8SXvE7/zL0xRUniOKARJgzho8blupz0Y/QAK6EIZkudH6rv8gk78FgpfHr0by8/dmjYLkL3NIqHrNk0Vi7RsWQGq3tf880lkVHmZc9JObtsRI48uXPY83cmx2E6edzTtudKzTehCVTOchSz8OdbdlEofqzbYvA7xjXIMGg3YcuoYAAA==",
    w: 77,
    e: 1
  },
  {
    id: "83",
    layers: [
      {
        ind: 82,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                7,
                4.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                14,
                9
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            -0.09
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            -0.02
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.06,
                            0.03
                          ],
                          [
                            0.05,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            0.02
                          ],
                          [
                            -0.06,
                            0
                          ],
                          [
                            -0.06,
                            -0.03
                          ],
                          [
                            -0.05,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.13
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.04
                          ],
                          [
                            -0.06,
                            0.03
                          ],
                          [
                            -0.06,
                            0
                          ],
                          [
                            -0.06,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.05
                          ],
                          [
                            0.06,
                            -0.03
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.06,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            0.09,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            10.09,
                            0.81
                          ],
                          [
                            10.09,
                            3.46
                          ],
                          [
                            9.94,
                            3.81
                          ],
                          [
                            9.59,
                            3.95
                          ],
                          [
                            9.24,
                            3.81
                          ],
                          [
                            9.09,
                            3.46
                          ],
                          [
                            9.09,
                            2.01
                          ],
                          [
                            5.97,
                            5.13
                          ],
                          [
                            5.81,
                            5.24
                          ],
                          [
                            5.62,
                            5.28
                          ],
                          [
                            5.43,
                            5.24
                          ],
                          [
                            5.27,
                            5.13
                          ],
                          [
                            3.97,
                            3.83
                          ],
                          [
                            1.34,
                            6.45
                          ],
                          [
                            0.99,
                            6.6
                          ],
                          [
                            0.64,
                            6.45
                          ],
                          [
                            0.5,
                            6.1
                          ],
                          [
                            0.64,
                            5.75
                          ],
                          [
                            3.62,
                            2.77
                          ],
                          [
                            3.78,
                            2.67
                          ],
                          [
                            3.97,
                            2.63
                          ],
                          [
                            4.16,
                            2.67
                          ],
                          [
                            4.32,
                            2.77
                          ],
                          [
                            5.63,
                            4.08
                          ],
                          [
                            8.39,
                            1.31
                          ],
                          [
                            6.95,
                            1.31
                          ],
                          [
                            6.59,
                            1.16
                          ],
                          [
                            6.45,
                            0.81
                          ],
                          [
                            6.59,
                            0.46
                          ],
                          [
                            6.95,
                            0.32
                          ],
                          [
                            9.59,
                            0.32
                          ],
                          [
                            9.94,
                            0.46
                          ],
                          [
                            10.09,
                            0.81
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.52,
                        0.32,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "86",
    layers: [
      {
        ind: 85,
        ty: 0,
        parent: 81,
        ks: {},
        w: 14,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "83"
      },
      {
        ind: 81,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              2
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "109",
    layers: [
      {
        ind: 108,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                5.5,
                6.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                11,
                13
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                0,
                                0
                              ],
                              [
                                7.55,
                                0
                              ],
                              [
                                7.55,
                                9.75
                              ],
                              [
                                0,
                                9.75
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            1,
                            1,
                            1,
                            1
                          ]
                        },
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "112",
    layers: [
      {
        ind: 111,
        ty: 0,
        parent: 107,
        ks: {},
        w: 11,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "109"
      },
      {
        ind: 107,
        ty: 3,
        parent: 106,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 106,
        ty: 3,
        ks: {
          a: {
            a: 0,
            k: [
              5.031,
              6.498
            ]
          },
          p: {
            a: 0,
            k: [
              5.031,
              6.498
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "100",
    layers: [
      {
        ind: 99,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                5,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                10,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                1.5,
                                0
                              ],
                              [
                                0.12,
                                -1.49
                              ]
                            ],
                            o: [
                              [
                                -0.09,
                                -1.36
                              ],
                              [
                                -1.3,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                6.11,
                                3.68
                              ],
                              [
                                3.76,
                                1.07
                              ],
                              [
                                1.34,
                                3.68
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.78,
                                0
                              ],
                              [
                                0,
                                -1.99
                              ],
                              [
                                0.01,
                                -0.11
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.29,
                                0
                              ],
                              [
                                -0.54,
                                0.59
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.26,
                                0
                              ],
                              [
                                0,
                                2.09
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -1.95
                              ],
                              [
                                1.84,
                                0
                              ],
                              [
                                0,
                                0.12
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.12,
                                1.67
                              ],
                              [
                                1.02,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.67,
                                0.74
                              ],
                              [
                                -1.72,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                0.68,
                                4.01
                              ],
                              [
                                0.68,
                                3.98
                              ],
                              [
                                3.79,
                                0.48
                              ],
                              [
                                6.79,
                                4
                              ],
                              [
                                6.78,
                                4.26
                              ],
                              [
                                1.34,
                                4.26
                              ],
                              [
                                3.91,
                                6.9
                              ],
                              [
                                6.16,
                                5.85
                              ],
                              [
                                6.6,
                                6.24
                              ],
                              [
                                3.89,
                                7.51
                              ],
                              [
                                0.68,
                                4.01
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0,
                            0,
                            0,
                            1
                          ]
                        },
                        r: 2,
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "103",
    layers: [
      {
        ind: 102,
        ty: 0,
        parent: 98,
        ks: {},
        w: 10,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "100"
      },
      {
        ind: 98,
        ty: 3,
        ks: {
          a: {
            a: 0,
            k: [
              5,
              5
            ]
          },
          p: {
            a: 0,
            k: [
              6,
              8
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "128",
    layers: [
      {
        ind: 127,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                5.5,
                6.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                11,
                13
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                0,
                                0
                              ],
                              [
                                7.55,
                                0
                              ],
                              [
                                7.55,
                                9.75
                              ],
                              [
                                0,
                                9.75
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            1,
                            1,
                            1,
                            1
                          ]
                        },
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "131",
    layers: [
      {
        ind: 130,
        ty: 0,
        parent: 126,
        ks: {},
        w: 11,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "128"
      },
      {
        ind: 126,
        ty: 3,
        parent: 125,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 125,
        ty: 3,
        ks: {
          a: {
            a: 0,
            k: [
              5.031,
              6.498
            ]
          },
          p: {
            a: 0,
            k: [
              5.031,
              6.498
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "119",
    layers: [
      {
        ind: 118,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                0.5,
                6.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                1,
                13
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0,
                            9.6
                          ],
                          [
                            0.63,
                            9.6
                          ],
                          [
                            0.63,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0,
                        0,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "122",
    layers: [
      {
        ind: 121,
        ty: 0,
        parent: 117,
        ks: {},
        w: 1,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "119"
      },
      {
        ind: 117,
        ty: 3,
        parent: 116,
        ks: {
          a: {
            a: 0,
            k: [
              0.5,
              6.5
            ]
          },
          p: {
            a: 0,
            k: [
              0.5,
              6.5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 116,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "136",
    layers: [
      {
        ind: 135,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3,
                6.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                6,
                13
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.76,
                            0
                          ],
                          [
                            -0.37,
                            0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0,
                            1.25
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.94
                          ],
                          [
                            0.32,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.33,
                            0.16
                          ],
                          [
                            -1.02,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.1,
                            7.65
                          ],
                          [
                            1.1,
                            3.34
                          ],
                          [
                            0.15,
                            3.34
                          ],
                          [
                            0.15,
                            2.76
                          ],
                          [
                            1.1,
                            2.76
                          ],
                          [
                            1.1,
                            0.66
                          ],
                          [
                            1.73,
                            0.66
                          ],
                          [
                            1.73,
                            2.76
                          ],
                          [
                            4.03,
                            2.76
                          ],
                          [
                            4.03,
                            3.34
                          ],
                          [
                            1.73,
                            3.34
                          ],
                          [
                            1.73,
                            7.59
                          ],
                          [
                            3.04,
                            8.87
                          ],
                          [
                            4,
                            8.63
                          ],
                          [
                            4,
                            9.23
                          ],
                          [
                            2.94,
                            9.46
                          ],
                          [
                            1.1,
                            7.65
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0,
                        0,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "153",
    layers: [
      {
        ind: 152,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                10,
                7
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                20,
                14
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0,
                            0
                          ],
                          [
                            14.89,
                            0
                          ],
                          [
                            14.89,
                            10.07
                          ],
                          [
                            0,
                            10.07
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        1,
                        1,
                        1,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "156",
    layers: [
      {
        ind: 155,
        ty: 0,
        parent: 151,
        ks: {},
        w: 20,
        h: 14,
        ip: 0,
        op: 565,
        st: 0,
        refId: "153"
      },
      {
        ind: 151,
        ty: 3,
        parent: 150,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 150,
        ty: 3,
        ks: {
          a: {
            a: 0,
            k: [
              9.931,
              6.717
            ]
          },
          p: {
            a: 0,
            k: [
              9.931,
              6.717
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "144",
    layers: [
      {
        ind: 143,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                5,
                7
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                10,
                14
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.93,
                            0
                          ],
                          [
                            -0.02,
                            0.64
                          ],
                          [
                            0.99,
                            0.29
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.88
                          ],
                          [
                            -1.87,
                            0
                          ],
                          [
                            0,
                            -1.88
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.82,
                            0
                          ],
                          [
                            0,
                            -0.58
                          ],
                          [
                            -0.95,
                            -0.27
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            -0.94
                          ],
                          [
                            1.73,
                            0
                          ],
                          [
                            0,
                            1.77
                          ]
                        ],
                        o: [
                          [
                            0.03,
                            0.63
                          ],
                          [
                            0.84,
                            0
                          ],
                          [
                            0.01,
                            -0.44
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.15,
                            -0.67
                          ],
                          [
                            0,
                            -1.75
                          ],
                          [
                            1.89,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.66
                          ],
                          [
                            -0.72,
                            0
                          ],
                          [
                            0,
                            0.26
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            2.37,
                            0.68
                          ],
                          [
                            -0.03,
                            1.95
                          ],
                          [
                            -2.12,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            2.42,
                            7.05
                          ],
                          [
                            3.88,
                            8.24
                          ],
                          [
                            5.31,
                            7.2
                          ],
                          [
                            4.14,
                            6.09
                          ],
                          [
                            2.96,
                            5.76
                          ],
                          [
                            0.44,
                            2.94
                          ],
                          [
                            3.79,
                            0
                          ],
                          [
                            7.1,
                            3.01
                          ],
                          [
                            5.03,
                            3.01
                          ],
                          [
                            3.77,
                            1.9
                          ],
                          [
                            2.5,
                            2.88
                          ],
                          [
                            3.55,
                            3.88
                          ],
                          [
                            4.71,
                            4.25
                          ],
                          [
                            7.39,
                            7.21
                          ],
                          [
                            3.88,
                            10.09
                          ],
                          [
                            0.34,
                            7.05
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0,
                        0,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "147",
    layers: [
      {
        ind: 146,
        ty: 0,
        parent: 142,
        ks: {},
        w: 10,
        h: 14,
        ip: 0,
        op: 565,
        st: 0,
        refId: "144"
      },
      {
        ind: 142,
        ty: 3,
        parent: 141,
        ks: {
          a: {
            a: 0,
            k: [
              5,
              7
            ]
          },
          p: {
            a: 0,
            k: [
              15,
              7
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 141,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "171",
    layers: [
      {
        ind: 170,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                10,
                7
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                20,
                14
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0,
                            0
                          ],
                          [
                            14.89,
                            0
                          ],
                          [
                            14.89,
                            10.07
                          ],
                          [
                            0,
                            10.07
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        1,
                        1,
                        1,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "174",
    layers: [
      {
        ind: 173,
        ty: 0,
        parent: 169,
        ks: {},
        w: 20,
        h: 14,
        ip: 0,
        op: 565,
        st: 0,
        refId: "171"
      },
      {
        ind: 169,
        ty: 3,
        parent: 168,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 168,
        ty: 3,
        ks: {
          a: {
            a: 0,
            k: [
              9.931,
              6.717
            ]
          },
          p: {
            a: 0,
            k: [
              9.931,
              6.717
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "162",
    layers: [
      {
        ind: 161,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                5,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                10,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1
                          ],
                          [
                            0.81,
                            0
                          ],
                          [
                            0,
                            -0.95
                          ],
                          [
                            -0.82,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.81,
                            0
                          ],
                          [
                            0,
                            -1
                          ],
                          [
                            -0.82,
                            0
                          ],
                          [
                            0,
                            0.96
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            3.7,
                            5.18
                          ],
                          [
                            5.3,
                            3.6
                          ],
                          [
                            3.7,
                            2.02
                          ],
                          [
                            2.04,
                            3.6
                          ],
                          [
                            3.7,
                            5.18
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.51,
                            0
                          ],
                          [
                            0,
                            2.14
                          ],
                          [
                            -1.69,
                            0
                          ],
                          [
                            -0.51,
                            -0.74
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.43,
                            0.64
                          ],
                          [
                            -1.69,
                            0
                          ],
                          [
                            0,
                            -2.14
                          ],
                          [
                            0.42,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            5.3,
                            6.18
                          ],
                          [
                            3.38,
                            7.06
                          ],
                          [
                            0,
                            3.6
                          ],
                          [
                            3.38,
                            0.14
                          ],
                          [
                            5.3,
                            1.02
                          ],
                          [
                            5.3,
                            0.28
                          ],
                          [
                            7.26,
                            0.28
                          ],
                          [
                            7.26,
                            6.93
                          ],
                          [
                            5.3,
                            6.93
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0,
                        0,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "165",
    layers: [
      {
        ind: 164,
        ty: 0,
        parent: 160,
        ks: {},
        w: 10,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "162"
      },
      {
        ind: 160,
        ty: 3,
        ks: {
          a: {
            a: 0,
            k: [
              5,
              5
            ]
          },
          p: {
            a: 0,
            k: [
              5,
              9
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "179",
    layers: [
      {
        ind: 178,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                5.5,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                11,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                1.02
                              ],
                              [
                                0.82,
                                0
                              ],
                              [
                                0,
                                -0.97
                              ],
                              [
                                -0.84,
                                0
                              ]
                            ],
                            o: [
                              [
                                0.82,
                                0
                              ],
                              [
                                0,
                                -1.01
                              ],
                              [
                                -0.84,
                                0
                              ],
                              [
                                0,
                                0.97
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                3.93,
                                5.3
                              ],
                              [
                                5.56,
                                3.69
                              ],
                              [
                                3.93,
                                2.08
                              ],
                              [
                                2.24,
                                3.69
                              ],
                              [
                                3.93,
                                5.3
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0.52,
                                0
                              ],
                              [
                                0,
                                2.18
                              ],
                              [
                                -1.72,
                                0
                              ],
                              [
                                -0.52,
                                -0.75
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            o: [
                              [
                                -0.43,
                                0.65
                              ],
                              [
                                -1.72,
                                0
                              ],
                              [
                                0,
                                -2.17
                              ],
                              [
                                0.43,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                5.56,
                                6.32
                              ],
                              [
                                3.59,
                                7.21
                              ],
                              [
                                0.16,
                                3.69
                              ],
                              [
                                3.59,
                                0.17
                              ],
                              [
                                5.56,
                                1.07
                              ],
                              [
                                5.56,
                                0.32
                              ],
                              [
                                7.55,
                                0.32
                              ],
                              [
                                7.55,
                                7.09
                              ],
                              [
                                5.56,
                                7.09
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0,
                            0,
                            0,
                            1
                          ]
                        },
                        r: 2,
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "184",
    layers: [
      {
        ind: 183,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                6.5,
                7
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                13,
                14
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            1.8,
                            0
                          ],
                          [
                            0,
                            2.8
                          ],
                          [
                            -2.84,
                            0
                          ],
                          [
                            -0.86,
                            -1.27
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.02,
                            0
                          ],
                          [
                            0,
                            -1.73
                          ],
                          [
                            -1.66,
                            0
                          ],
                          [
                            -0.53,
                            0.81
                          ]
                        ],
                        o: [
                          [
                            -0.86,
                            1.32
                          ],
                          [
                            -2.84,
                            0
                          ],
                          [
                            0,
                            -2.83
                          ],
                          [
                            1.77,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.53,
                            -0.78
                          ],
                          [
                            -1.66,
                            0
                          ],
                          [
                            0,
                            1.72
                          ],
                          [
                            1.04,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.16,
                            8.03
                          ],
                          [
                            4.98,
                            10.21
                          ],
                          [
                            0,
                            5.11
                          ],
                          [
                            4.98,
                            0
                          ],
                          [
                            9.11,
                            2.11
                          ],
                          [
                            7.4,
                            3.29
                          ],
                          [
                            4.98,
                            1.99
                          ],
                          [
                            2.12,
                            5.11
                          ],
                          [
                            4.98,
                            8.22
                          ],
                          [
                            7.46,
                            6.85
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0,
                        0,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "187",
    layers: [
      {
        ind: 114,
        ty: 0,
        td: 1,
        parent: 97,
        ks: {},
        w: 11,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "112"
      },
      {
        ind: 105,
        ty: 0,
        tt: 1,
        parent: 97,
        ks: {},
        w: 11,
        h: 14,
        ip: 0,
        op: 565,
        st: 0,
        refId: "103"
      },
      {
        ind: 97,
        ty: 3,
        parent: 96,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 133,
        ty: 0,
        td: 1,
        parent: 115,
        ks: {},
        w: 11,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "131"
      },
      {
        ind: 124,
        ty: 0,
        tt: 1,
        parent: 115,
        ks: {
          a: {
            a: 0,
            k: [
              1,
              1
            ]
          }
        },
        w: 2,
        h: 14,
        ip: 0,
        op: 565,
        st: 0,
        refId: "122"
      },
      {
        ind: 115,
        ty: 3,
        parent: 96,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 96,
        ty: 3,
        parent: 95,
        ks: {
          p: {
            a: 0,
            k: [
              49.833,
              0.612
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 138,
        ty: 0,
        parent: 134,
        ks: {},
        w: 6,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "136"
      },
      {
        ind: 134,
        ty: 3,
        parent: 95,
        ks: {
          p: {
            a: 0,
            k: [
              43,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 158,
        ty: 0,
        td: 1,
        parent: 140,
        ks: {},
        w: 20,
        h: 14,
        ip: 0,
        op: 565,
        st: 0,
        refId: "156"
      },
      {
        ind: 149,
        ty: 0,
        tt: 1,
        parent: 140,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        w: 20,
        h: 15,
        ip: 0,
        op: 565,
        st: 0,
        refId: "147"
      },
      {
        ind: 140,
        ty: 3,
        parent: 139,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 176,
        ty: 0,
        td: 1,
        parent: 159,
        ks: {},
        w: 20,
        h: 14,
        ip: 0,
        op: 565,
        st: 0,
        refId: "174"
      },
      {
        ind: 167,
        ty: 0,
        tt: 1,
        parent: 159,
        ks: {},
        w: 11,
        h: 15,
        ip: 0,
        op: 565,
        st: 0,
        refId: "165"
      },
      {
        ind: 159,
        ty: 3,
        parent: 139,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 139,
        ty: 3,
        parent: 95,
        ks: {
          p: {
            a: 0,
            k: [
              23.167,
              0.157
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 181,
        ty: 0,
        parent: 177,
        ks: {},
        w: 11,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "179"
      },
      {
        ind: 177,
        ty: 3,
        parent: 95,
        ks: {
          p: {
            a: 0,
            k: [
              12,
              4
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 186,
        ty: 0,
        parent: 182,
        ks: {},
        w: 13,
        h: 14,
        ip: 0,
        op: 565,
        st: 0,
        refId: "184"
      },
      {
        ind: 182,
        ty: 3,
        parent: 95,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 95,
        ty: 3,
        parent: 94,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 94,
        ty: 3,
        parent: 93,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 93,
        ty: 3,
        parent: 92,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 92,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              7e-3,
              8e-3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "217",
    layers: [
      {
        ind: 216,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                13.5,
                6.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                27,
                13
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.12,
                                0
                              ],
                              [
                                0.09,
                                0.09
                              ],
                              [
                                0,
                                0.12
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.09,
                                0.09
                              ],
                              [
                                0,
                                0.12
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.12
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.02,
                                -0.06
                              ],
                              [
                                0,
                                -0.06
                              ],
                              [
                                0.02,
                                -0.05
                              ],
                              [
                                0.04,
                                -0.04
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                -0.12
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                -0.12
                              ],
                              [
                                0.09,
                                -0.09
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                -0.12
                              ],
                              [
                                0.09,
                                -0.09
                              ],
                              [
                                0.12,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                0.04
                              ],
                              [
                                0.02,
                                0.05
                              ],
                              [
                                0,
                                0.06
                              ],
                              [
                                -0.02,
                                0.06
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                19.51,
                                4.9
                              ],
                              [
                                15.39,
                                9.03
                              ],
                              [
                                15.07,
                                9.16
                              ],
                              [
                                14.74,
                                9.03
                              ],
                              [
                                14.61,
                                8.7
                              ],
                              [
                                14.74,
                                8.38
                              ],
                              [
                                18.09,
                                5.04
                              ],
                              [
                                0.46,
                                5.04
                              ],
                              [
                                0.13,
                                4.9
                              ],
                              [
                                0,
                                4.58
                              ],
                              [
                                0.13,
                                4.26
                              ],
                              [
                                0.46,
                                4.12
                              ],
                              [
                                18.09,
                                4.12
                              ],
                              [
                                14.74,
                                0.78
                              ],
                              [
                                14.61,
                                0.46
                              ],
                              [
                                14.74,
                                0.13
                              ],
                              [
                                15.07,
                                0
                              ],
                              [
                                15.39,
                                0.13
                              ],
                              [
                                19.51,
                                4.26
                              ],
                              [
                                19.61,
                                4.41
                              ],
                              [
                                19.65,
                                4.58
                              ],
                              [
                                19.61,
                                4.75
                              ],
                              [
                                19.51,
                                4.9
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0.57,
                            0.63,
                            0.72,
                            1
                          ]
                        },
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "242",
    layers: [
      {
        ind: 241,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                40.5,
                7.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                81,
                15
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.34,
                            -0.11
                          ],
                          [
                            -0.19,
                            -0.27
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            0.41,
                            -0.31
                          ],
                          [
                            0.67,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.46,
                            0
                          ],
                          [
                            0.34,
                            0.11
                          ],
                          [
                            0.19,
                            0.26
                          ],
                          [
                            0,
                            0.63
                          ],
                          [
                            -0.41,
                            0.31
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.83,
                            9
                          ],
                          [
                            0.83,
                            2.93
                          ],
                          [
                            2.56,
                            2.93
                          ],
                          [
                            3.76,
                            3.09
                          ],
                          [
                            4.55,
                            3.66
                          ],
                          [
                            4.84,
                            4.71
                          ],
                          [
                            4.22,
                            6.13
                          ],
                          [
                            2.6,
                            6.59
                          ],
                          [
                            1.6,
                            6.59
                          ],
                          [
                            1.6,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.25,
                            0.2
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            0.27,
                            0.16
                          ],
                          [
                            0.53,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0.53,
                            0
                          ],
                          [
                            0.26,
                            -0.2
                          ],
                          [
                            0,
                            -0.44
                          ],
                          [
                            -0.26,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.6,
                            5.96
                          ],
                          [
                            2.51,
                            5.96
                          ],
                          [
                            3.68,
                            5.67
                          ],
                          [
                            4.07,
                            4.71
                          ],
                          [
                            3.66,
                            3.81
                          ],
                          [
                            2.47,
                            3.55
                          ],
                          [
                            1.6,
                            3.55
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.16
                          ],
                          [
                            -0.25,
                            0
                          ],
                          [
                            -0.14,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0.01
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.15,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.29
                          ],
                          [
                            0.22,
                            -0.17
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.06,
                            -0.01
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            6,
                            9
                          ],
                          [
                            6,
                            4.5
                          ],
                          [
                            6.63,
                            4.5
                          ],
                          [
                            6.7,
                            5.32
                          ],
                          [
                            6.72,
                            5.32
                          ],
                          [
                            7.29,
                            4.64
                          ],
                          [
                            8,
                            4.39
                          ],
                          [
                            8.48,
                            4.48
                          ],
                          [
                            8.34,
                            5.15
                          ],
                          [
                            8.13,
                            5.09
                          ],
                          [
                            7.9,
                            5.07
                          ],
                          [
                            7.3,
                            5.3
                          ],
                          [
                            6.76,
                            6.11
                          ],
                          [
                            6.76,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.33,
                            0.19
                          ],
                          [
                            0.19,
                            0.35
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.19,
                            0.35
                          ],
                          [
                            -0.31,
                            0.19
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.31,
                            -0.38
                          ],
                          [
                            0,
                            -0.64
                          ],
                          [
                            0,
                            -0.08
                          ],
                          [
                            0.01,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.26,
                            -0.29
                          ],
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.18,
                            0.06
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.09
                          ],
                          [
                            0.31,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.4,
                            0
                          ],
                          [
                            -0.32,
                            -0.19
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.31,
                            -0.19
                          ],
                          [
                            0.57,
                            0
                          ],
                          [
                            0.32,
                            0.38
                          ],
                          [
                            0,
                            0.08
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.47
                          ],
                          [
                            0.27,
                            0.29
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.13
                          ],
                          [
                            -0.24,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            10.95,
                            9.11
                          ],
                          [
                            9.85,
                            8.83
                          ],
                          [
                            9.07,
                            8.02
                          ],
                          [
                            8.79,
                            6.76
                          ],
                          [
                            9.07,
                            5.49
                          ],
                          [
                            9.84,
                            4.68
                          ],
                          [
                            10.8,
                            4.39
                          ],
                          [
                            12.13,
                            4.96
                          ],
                          [
                            12.6,
                            6.5
                          ],
                          [
                            12.59,
                            6.74
                          ],
                          [
                            12.57,
                            6.94
                          ],
                          [
                            9.54,
                            6.94
                          ],
                          [
                            9.98,
                            8.07
                          ],
                          [
                            11.04,
                            8.5
                          ],
                          [
                            11.63,
                            8.41
                          ],
                          [
                            12.16,
                            8.15
                          ],
                          [
                            12.43,
                            8.65
                          ],
                          [
                            11.77,
                            8.97
                          ],
                          [
                            10.95,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.23
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.25,
                            -0.25
                          ],
                          [
                            0.05,
                            -0.45
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.46
                          ],
                          [
                            -0.19,
                            -0.24
                          ],
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            0.24
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.53,
                            6.39
                          ],
                          [
                            11.93,
                            6.39
                          ],
                          [
                            11.64,
                            5.35
                          ],
                          [
                            10.82,
                            4.99
                          ],
                          [
                            9.97,
                            5.36
                          ],
                          [
                            9.53,
                            6.39
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.36,
                            0.16
                          ],
                          [
                            0.27,
                            0.27
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.29,
                            -0.14
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.22,
                            0.18
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            0.09,
                            0.12
                          ],
                          [
                            0.16,
                            0.09
                          ],
                          [
                            0.19,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            0.13
                          ],
                          [
                            0.13,
                            0.2
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            -0.16,
                            0.24
                          ],
                          [
                            -0.29,
                            0.14
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.31,
                            -0.14
                          ],
                          [
                            -0.21,
                            -0.22
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0.1
                          ],
                          [
                            0.29,
                            0
                          ],
                          [
                            0.21,
                            -0.16
                          ],
                          [
                            0,
                            -0.27
                          ],
                          [
                            -0.1,
                            -0.13
                          ],
                          [
                            -0.16,
                            -0.08
                          ],
                          [
                            -0.16,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            -0.14
                          ],
                          [
                            -0.11,
                            -0.2
                          ],
                          [
                            0,
                            -0.3
                          ],
                          [
                            0.17,
                            -0.27
                          ],
                          [
                            0.31,
                            -0.15
                          ],
                          [
                            0.43,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.36,
                            -0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            0.23
                          ],
                          [
                            0.3,
                            0.14
                          ],
                          [
                            0.4,
                            0
                          ],
                          [
                            0.22,
                            -0.19
                          ],
                          [
                            0,
                            -0.21
                          ],
                          [
                            -0.09,
                            -0.12
                          ],
                          [
                            -0.14,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            -0.08
                          ],
                          [
                            -0.18,
                            -0.13
                          ],
                          [
                            -0.12,
                            -0.2
                          ],
                          [
                            0,
                            -0.31
                          ],
                          [
                            0.16,
                            -0.25
                          ],
                          [
                            0.29,
                            -0.14
                          ],
                          [
                            0.37,
                            0
                          ],
                          [
                            0.31,
                            0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            -0.18
                          ],
                          [
                            -0.22,
                            -0.11
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0.19
                          ],
                          [
                            0.11,
                            0.12
                          ],
                          [
                            0.15,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0.1
                          ],
                          [
                            0.19,
                            0.14
                          ],
                          [
                            0.11,
                            0.2
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            -0.17,
                            0.26
                          ],
                          [
                            -0.31,
                            0.16
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.32,
                            9.11
                          ],
                          [
                            16.14,
                            8.87
                          ],
                          [
                            15.2,
                            8.21
                          ],
                          [
                            15.66,
                            7.68
                          ],
                          [
                            16.42,
                            8.23
                          ],
                          [
                            17.34,
                            8.43
                          ],
                          [
                            18.27,
                            8.17
                          ],
                          [
                            18.6,
                            7.45
                          ],
                          [
                            18.46,
                            6.95
                          ],
                          [
                            18.1,
                            6.63
                          ],
                          [
                            17.59,
                            6.37
                          ],
                          [
                            16.72,
                            5.99
                          ],
                          [
                            16.15,
                            5.68
                          ],
                          [
                            15.68,
                            5.18
                          ],
                          [
                            15.49,
                            4.43
                          ],
                          [
                            15.73,
                            3.6
                          ],
                          [
                            16.42,
                            3.03
                          ],
                          [
                            17.4,
                            2.82
                          ],
                          [
                            18.41,
                            3.03
                          ],
                          [
                            19.2,
                            3.57
                          ],
                          [
                            18.78,
                            4.07
                          ],
                          [
                            18.16,
                            3.65
                          ],
                          [
                            17.4,
                            3.49
                          ],
                          [
                            16.57,
                            3.73
                          ],
                          [
                            16.27,
                            4.38
                          ],
                          [
                            16.42,
                            4.86
                          ],
                          [
                            16.81,
                            5.17
                          ],
                          [
                            17.28,
                            5.39
                          ],
                          [
                            18.14,
                            5.76
                          ],
                          [
                            18.77,
                            6.12
                          ],
                          [
                            19.22,
                            6.63
                          ],
                          [
                            19.39,
                            7.38
                          ],
                          [
                            19.14,
                            8.26
                          ],
                          [
                            18.43,
                            8.88
                          ],
                          [
                            17.32,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.32,
                            0.19
                          ],
                          [
                            0.18,
                            0.35
                          ],
                          [
                            0,
                            0.5
                          ],
                          [
                            -0.2,
                            0.35
                          ],
                          [
                            -0.32,
                            0.18
                          ],
                          [
                            -0.38,
                            0
                          ],
                          [
                            -0.21,
                            -0.11
                          ],
                          [
                            -0.16,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.07
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.13,
                            -0.27
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            -0.25,
                            -0.32
                          ],
                          [
                            -0.41,
                            0
                          ],
                          [
                            -0.18,
                            0.09
                          ],
                          [
                            -0.14,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.11
                          ],
                          [
                            0.27,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.39,
                            0
                          ],
                          [
                            -0.32,
                            -0.18
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.5
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.34,
                            -0.18
                          ],
                          [
                            0.3,
                            0
                          ],
                          [
                            0.21,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            -0.12
                          ],
                          [
                            -0.14,
                            -0.07
                          ],
                          [
                            -0.27,
                            0
                          ],
                          [
                            -0.21,
                            0.14
                          ],
                          [
                            -0.12,
                            0.26
                          ],
                          [
                            0,
                            0.52
                          ],
                          [
                            0.26,
                            0.32
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0.18,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.18
                          ],
                          [
                            -0.25,
                            0.1
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            22.29,
                            9.11
                          ],
                          [
                            21.21,
                            8.83
                          ],
                          [
                            20.46,
                            8.03
                          ],
                          [
                            20.18,
                            6.76
                          ],
                          [
                            20.48,
                            5.47
                          ],
                          [
                            21.27,
                            4.67
                          ],
                          [
                            22.34,
                            4.39
                          ],
                          [
                            23.11,
                            4.55
                          ],
                          [
                            23.66,
                            4.92
                          ],
                          [
                            23.27,
                            5.42
                          ],
                          [
                            22.86,
                            5.13
                          ],
                          [
                            22.37,
                            5.02
                          ],
                          [
                            21.64,
                            5.24
                          ],
                          [
                            21.14,
                            5.85
                          ],
                          [
                            20.96,
                            6.76
                          ],
                          [
                            21.34,
                            8.01
                          ],
                          [
                            22.36,
                            8.48
                          ],
                          [
                            22.94,
                            8.35
                          ],
                          [
                            23.41,
                            8.03
                          ],
                          [
                            23.74,
                            8.54
                          ],
                          [
                            23.07,
                            8.96
                          ],
                          [
                            22.29,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.22
                          ],
                          [
                            0,
                            0.4
                          ],
                          [
                            -0.44,
                            0.26
                          ],
                          [
                            -0.96,
                            0.11
                          ],
                          [
                            0.05,
                            0.18
                          ],
                          [
                            0.14,
                            0.1
                          ],
                          [
                            0.25,
                            0
                          ],
                          [
                            0.23,
                            -0.1
                          ],
                          [
                            0.18,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.3,
                            0.12
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.25,
                            -0.34
                          ],
                          [
                            0,
                            -0.56
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.13
                          ],
                          [
                            0.29,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.37,
                            0
                          ],
                          [
                            -0.25,
                            -0.23
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.45,
                            -0.27
                          ],
                          [
                            0,
                            -0.19
                          ],
                          [
                            -0.05,
                            -0.17
                          ],
                          [
                            -0.13,
                            -0.11
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.23,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            -0.14
                          ],
                          [
                            0.31,
                            -0.13
                          ],
                          [
                            0.55,
                            0
                          ],
                          [
                            0.25,
                            0.33
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            0.17
                          ],
                          [
                            -0.25,
                            0.13
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.68,
                            9.11
                          ],
                          [
                            24.73,
                            8.78
                          ],
                          [
                            24.37,
                            7.83
                          ],
                          [
                            25.02,
                            6.7
                          ],
                          [
                            27.13,
                            6.15
                          ],
                          [
                            27.04,
                            5.6
                          ],
                          [
                            26.76,
                            5.19
                          ],
                          [
                            26.2,
                            5.02
                          ],
                          [
                            25.47,
                            5.17
                          ],
                          [
                            24.86,
                            5.5
                          ],
                          [
                            24.56,
                            4.97
                          ],
                          [
                            25.33,
                            4.59
                          ],
                          [
                            26.33,
                            4.39
                          ],
                          [
                            27.52,
                            4.9
                          ],
                          [
                            27.89,
                            6.24
                          ],
                          [
                            27.89,
                            9
                          ],
                          [
                            27.26,
                            9
                          ],
                          [
                            27.2,
                            8.46
                          ],
                          [
                            27.17,
                            8.46
                          ],
                          [
                            26.48,
                            8.92
                          ],
                          [
                            25.68,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.11
                          ],
                          [
                            -0.21,
                            0.19
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.3,
                            -0.19
                          ],
                          [
                            0,
                            -0.29
                          ],
                          [
                            -0.15,
                            -0.12
                          ],
                          [
                            -0.22,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.21,
                            0
                          ],
                          [
                            0.19,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.75,
                            0.09
                          ],
                          [
                            -0.3,
                            0.18
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.9,
                            8.5
                          ],
                          [
                            26.51,
                            8.34
                          ],
                          [
                            27.13,
                            7.9
                          ],
                          [
                            27.13,
                            6.65
                          ],
                          [
                            25.55,
                            7.07
                          ],
                          [
                            25.11,
                            7.78
                          ],
                          [
                            25.34,
                            8.33
                          ],
                          [
                            25.9,
                            8.5
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0.17
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.05
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            -0.01
                          ],
                          [
                            0.11,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.12,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.12
                          ],
                          [
                            0.04,
                            0.05
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0.03,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.03
                          ],
                          [
                            -0.07,
                            0.01
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            30.11,
                            9.11
                          ],
                          [
                            29.49,
                            8.85
                          ],
                          [
                            29.31,
                            8.09
                          ],
                          [
                            29.31,
                            2.41
                          ],
                          [
                            30.07,
                            2.41
                          ],
                          [
                            30.07,
                            8.15
                          ],
                          [
                            30.13,
                            8.41
                          ],
                          [
                            30.28,
                            8.48
                          ],
                          [
                            30.34,
                            8.48
                          ],
                          [
                            30.45,
                            8.46
                          ],
                          [
                            30.55,
                            9.04
                          ],
                          [
                            30.37,
                            9.09
                          ],
                          [
                            30.11,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.33,
                            0.19
                          ],
                          [
                            0.19,
                            0.35
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.19,
                            0.35
                          ],
                          [
                            -0.31,
                            0.19
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.31,
                            -0.38
                          ],
                          [
                            0,
                            -0.64
                          ],
                          [
                            0,
                            -0.08
                          ],
                          [
                            0.01,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.27,
                            -0.29
                          ],
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.18,
                            0.06
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.09
                          ],
                          [
                            0.31,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.4,
                            0
                          ],
                          [
                            -0.33,
                            -0.19
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.31,
                            -0.19
                          ],
                          [
                            0.57,
                            0
                          ],
                          [
                            0.32,
                            0.38
                          ],
                          [
                            0,
                            0.08
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.47
                          ],
                          [
                            0.27,
                            0.29
                          ],
                          [
                            0.22,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.13
                          ],
                          [
                            -0.24,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            33.49,
                            9.11
                          ],
                          [
                            32.4,
                            8.83
                          ],
                          [
                            31.62,
                            8.02
                          ],
                          [
                            31.34,
                            6.76
                          ],
                          [
                            31.62,
                            5.49
                          ],
                          [
                            32.38,
                            4.68
                          ],
                          [
                            33.35,
                            4.39
                          ],
                          [
                            34.68,
                            4.96
                          ],
                          [
                            35.15,
                            6.5
                          ],
                          [
                            35.14,
                            6.74
                          ],
                          [
                            35.12,
                            6.94
                          ],
                          [
                            32.09,
                            6.94
                          ],
                          [
                            32.53,
                            8.07
                          ],
                          [
                            33.58,
                            8.5
                          ],
                          [
                            34.18,
                            8.41
                          ],
                          [
                            34.7,
                            8.15
                          ],
                          [
                            34.97,
                            8.65
                          ],
                          [
                            34.32,
                            8.97
                          ],
                          [
                            33.49,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.23
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.25,
                            -0.25
                          ],
                          [
                            0.05,
                            -0.45
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.46
                          ],
                          [
                            -0.19,
                            -0.24
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.25,
                            0.24
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            32.07,
                            6.39
                          ],
                          [
                            34.48,
                            6.39
                          ],
                          [
                            34.19,
                            5.35
                          ],
                          [
                            33.37,
                            4.99
                          ],
                          [
                            32.52,
                            5.36
                          ],
                          [
                            32.07,
                            6.39
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.16
                          ],
                          [
                            -0.25,
                            0
                          ],
                          [
                            -0.14,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0.01
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.15,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.29
                          ],
                          [
                            0.22,
                            -0.17
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.06,
                            -0.01
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            36.26,
                            9
                          ],
                          [
                            36.26,
                            4.5
                          ],
                          [
                            36.89,
                            4.5
                          ],
                          [
                            36.95,
                            5.32
                          ],
                          [
                            36.98,
                            5.32
                          ],
                          [
                            37.55,
                            4.64
                          ],
                          [
                            38.26,
                            4.39
                          ],
                          [
                            38.74,
                            4.48
                          ],
                          [
                            38.59,
                            5.15
                          ],
                          [
                            38.39,
                            5.09
                          ],
                          [
                            38.16,
                            5.07
                          ],
                          [
                            37.55,
                            5.3
                          ],
                          [
                            37.02,
                            6.11
                          ],
                          [
                            37.02,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.49,
                        0.55,
                        0.65,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "266",
    layers: [
      {
        ind: 265,
        ty: 2,
        parent: 264,
        ks: {
          s: {
            a: 0,
            k: [
              157.14,
              162.5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "0"
      },
      {
        ind: 264,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "269",
    layers: [
      {
        ind: 268,
        ty: 0,
        parent: 263,
        ks: {},
        w: 11,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "266"
      },
      {
        ind: 263,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "320",
    layers: [
      {
        ind: 319,
        ty: 2,
        parent: 318,
        ks: {
          s: {
            a: 0,
            k: [
              162.5,
              160
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "1"
      },
      {
        ind: 318,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "323",
    layers: [
      {
        ind: 322,
        ty: 0,
        parent: 317,
        ks: {},
        w: 13,
        h: 12,
        ip: 0,
        op: 565,
        st: 0,
        refId: "320"
      },
      {
        ind: 317,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "358",
    layers: [
      {
        ind: 357,
        ty: 2,
        parent: 356,
        ks: {
          s: {
            a: 0,
            k: [
              200,
              195.45
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "2"
      },
      {
        ind: 356,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "361",
    layers: [
      {
        ind: 360,
        ty: 0,
        parent: 355,
        ks: {},
        w: 19,
        h: 21.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "358"
      },
      {
        ind: 355,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "372",
    layers: [
      {
        ind: 371,
        ty: 2,
        parent: 370,
        ks: {
          s: {
            a: 0,
            k: [
              200,
              200
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "3"
      },
      {
        ind: 370,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "375",
    layers: [
      {
        ind: 374,
        ty: 0,
        parent: 369,
        ks: {},
        w: 76,
        h: 76,
        ip: 0,
        op: 565,
        st: 0,
        refId: "372"
      },
      {
        ind: 369,
        ty: 3,
        parent: 368,
        ks: {
          p: {
            a: 0,
            k: [
              -6,
              -4
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 368,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              7,
              5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "379",
    layers: [
      {
        ind: 378,
        ty: 4,
        td: 1,
        parent: 367,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                31.739,
                31.739
              ]
            },
            r: {
              a: 0,
              k: 31
            },
            s: {
              a: 0,
              k: [
                63.478,
                63.478
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 377,
        ty: 0,
        tt: 1,
        parent: 367,
        ks: {
          a: {
            a: 0,
            k: [
              7,
              5
            ]
          }
        },
        w: 83,
        h: 81,
        ip: 0,
        op: 565,
        st: 0,
        refId: "375"
      },
      {
        ind: 367,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              7.053,
              7.053
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "384",
    layers: [
      {
        ind: 31,
        ty: 4,
        parent: 30,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 30,
        ty: 3,
        parent: 29,
        ks: {
          p: {
            a: 0,
            k: [
              28.394,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 33,
        ty: 4,
        parent: 32,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 32,
        ty: 3,
        parent: 29,
        ks: {
          p: {
            a: 0,
            k: [
              22.138,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 35,
        ty: 4,
        parent: 34,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ],
                  [
                    1.2,
                    11.3
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    10.1
                  ],
                  [
                    2.4,
                    10.5
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.7,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    3,
                    11.6
                  ],
                  [
                    2.7,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 34,
        ty: 3,
        parent: 29,
        ks: {
          p: {
            a: 0,
            k: [
              18.794,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 37,
        ty: 4,
        parent: 36,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 36,
        ty: 3,
        parent: 29,
        ks: {
          p: {
            a: 0,
            k: [
              12.426,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 39,
        ty: 4,
        parent: 38,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.9,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.8
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    4.6,
                    5.6
                  ],
                  [
                    5.3,
                    6.1
                  ],
                  [
                    5.3,
                    6.1
                  ],
                  [
                    4.6,
                    7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    2.4,
                    7.1
                  ],
                  [
                    2,
                    8.6
                  ],
                  [
                    2,
                    8.6
                  ],
                  [
                    2.4,
                    10
                  ],
                  [
                    3.6,
                    10.6
                  ],
                  [
                    3.6,
                    10.6
                  ],
                  [
                    4.3,
                    10.4
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    5.4,
                    11
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 38,
        ty: 3,
        parent: 29,
        ks: {
          p: {
            a: 0,
            k: [
              6.725,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 41,
        ty: 4,
        parent: 40,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    1.3,
                    9.6
                  ],
                  [
                    2.3,
                    10.2
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    4.5,
                    10.2
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.5,
                    8.7
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    2.5,
                    7.8
                  ],
                  [
                    1.7,
                    7.3
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    1.2,
                    4.5
                  ],
                  [
                    2.1,
                    3.7
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    4.9,
                    3.6
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    5.3,
                    5.3
                  ],
                  [
                    4.5,
                    4.8
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.5,
                    6.1
                  ],
                  [
                    2.9,
                    6.4
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    4.7,
                    7.2
                  ],
                  [
                    5.8,
                    8
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    5.9,
                    10.5
                  ],
                  [
                    4.9,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 40,
        ty: 3,
        parent: 29,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 29,
        ty: 3,
        parent: 28,
        ks: {
          p: {
            a: 0,
            k: [
              115.689,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 44,
        ty: 4,
        parent: 43,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 43,
        ty: 3,
        parent: 42,
        ks: {
          p: {
            a: 0,
            k: [
              20.548,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 46,
        ty: 4,
        parent: 45,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 45,
        ty: 3,
        parent: 42,
        ks: {
          p: {
            a: 0,
            k: [
              14.292,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 48,
        ty: 4,
        parent: 47,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.6,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.3,
                    6.7
                  ],
                  [
                    0.3,
                    5.6
                  ],
                  [
                    1.1,
                    5.5
                  ],
                  [
                    1.1,
                    4.9
                  ],
                  [
                    1.6,
                    3.3
                  ],
                  [
                    3.2,
                    2.7
                  ],
                  [
                    3.2,
                    2.7
                  ],
                  [
                    3.8,
                    2.8
                  ],
                  [
                    4.3,
                    2.9
                  ],
                  [
                    4.3,
                    2.9
                  ],
                  [
                    4,
                    4
                  ],
                  [
                    3.3,
                    3.8
                  ],
                  [
                    3.3,
                    3.8
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.6,
                    5.5
                  ],
                  [
                    3.8,
                    5.5
                  ],
                  [
                    3.8,
                    6.7
                  ],
                  [
                    2.6,
                    6.7
                  ],
                  [
                    2.6,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    6.9,
                    11.7
                  ],
                  [
                    6.9,
                    11.7
                  ],
                  [
                    5.5,
                    11.1
                  ],
                  [
                    5,
                    9.5
                  ],
                  [
                    5,
                    9.5
                  ],
                  [
                    5,
                    6.7
                  ],
                  [
                    4.2,
                    6.7
                  ],
                  [
                    4.2,
                    5.6
                  ],
                  [
                    5.1,
                    5.5
                  ],
                  [
                    5.3,
                    3.9
                  ],
                  [
                    6.5,
                    3.9
                  ],
                  [
                    6.5,
                    5.5
                  ],
                  [
                    8,
                    5.5
                  ],
                  [
                    8,
                    6.7
                  ],
                  [
                    6.5,
                    6.7
                  ],
                  [
                    6.5,
                    9.5
                  ],
                  [
                    7.3,
                    10.6
                  ],
                  [
                    7.3,
                    10.6
                  ],
                  [
                    7.6,
                    10.6
                  ],
                  [
                    7.9,
                    10.5
                  ],
                  [
                    7.9,
                    10.5
                  ],
                  [
                    8.2,
                    11.5
                  ],
                  [
                    7.6,
                    11.7
                  ],
                  [
                    6.9,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 47,
        ty: 3,
        parent: 42,
        ks: {
          p: {
            a: 0,
            k: [
              6.367,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 50,
        ty: 4,
        parent: 49,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 49,
        ty: 3,
        parent: 42,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 42,
        ty: 3,
        parent: 28,
        ks: {
          p: {
            a: 0,
            k: [
              88.07,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 53,
        ty: 4,
        parent: 52,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 52,
        ty: 3,
        parent: 51,
        ks: {
          p: {
            a: 0,
            k: [
              17.856,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 55,
        ty: 4,
        parent: 54,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    6.1,
                    5.5
                  ],
                  [
                    4.1,
                    8
                  ],
                  [
                    6.3,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    3.2,
                    9
                  ],
                  [
                    2.3,
                    10
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 54,
        ty: 3,
        parent: 51,
        ks: {
          p: {
            a: 0,
            k: [
              11.414,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 57,
        ty: 4,
        parent: 56,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.3,
                    5.5
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    1.6,
                    4.5
                  ],
                  [
                    1.6,
                    4.5
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.8,
                    3.7
                  ],
                  [
                    0.8,
                    3.7
                  ],
                  [
                    1,
                    3.1
                  ],
                  [
                    1.6,
                    2.8
                  ],
                  [
                    1.6,
                    2.8
                  ],
                  [
                    2.2,
                    3.1
                  ],
                  [
                    2.5,
                    3.7
                  ],
                  [
                    2.5,
                    3.7
                  ],
                  [
                    2.2,
                    4.2
                  ],
                  [
                    1.6,
                    4.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 56,
        ty: 3,
        parent: 51,
        ks: {
          p: {
            a: 0,
            k: [
              8.181,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 59,
        ty: 4,
        parent: 58,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.5,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    3.5
                  ],
                  [
                    2.5,
                    3.5
                  ],
                  [
                    2.5,
                    6.8
                  ],
                  [
                    5.7,
                    6.8
                  ],
                  [
                    5.7,
                    3.5
                  ],
                  [
                    7.2,
                    3.5
                  ],
                  [
                    7.2,
                    11.6
                  ],
                  [
                    5.7,
                    11.6
                  ],
                  [
                    5.7,
                    8
                  ],
                  [
                    2.5,
                    8
                  ],
                  [
                    2.5,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 58,
        ty: 3,
        parent: 51,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 51,
        ty: 3,
        parent: 28,
        ks: {
          p: {
            a: 0,
            k: [
              61.49,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 62,
        ty: 4,
        parent: 61,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.7,
                    0
                  ]
                ],
                v: [
                  [
                    1.3,
                    14.1
                  ],
                  [
                    1.3,
                    14.1
                  ],
                  [
                    0.9,
                    14
                  ],
                  [
                    0.5,
                    14
                  ],
                  [
                    0.5,
                    14
                  ],
                  [
                    0.8,
                    12.8
                  ],
                  [
                    1,
                    12.9
                  ],
                  [
                    1.2,
                    12.9
                  ],
                  [
                    1.2,
                    12.9
                  ],
                  [
                    2,
                    12.6
                  ],
                  [
                    2.4,
                    11.9
                  ],
                  [
                    2.4,
                    11.9
                  ],
                  [
                    2.5,
                    11.5
                  ],
                  [
                    0.1,
                    5.5
                  ],
                  [
                    1.6,
                    5.5
                  ],
                  [
                    2.6,
                    8.5
                  ],
                  [
                    2.9,
                    9.3
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.4,
                    9.3
                  ],
                  [
                    3.7,
                    8.5
                  ],
                  [
                    3.7,
                    8.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    6,
                    5.5
                  ],
                  [
                    3.8,
                    11.9
                  ],
                  [
                    2.8,
                    13.5
                  ],
                  [
                    1.3,
                    14.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.7
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 61,
        ty: 3,
        parent: 60,
        ks: {
          p: {
            a: 0,
            k: [
              27.407,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 64,
        ty: 4,
        parent: 63,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 63,
        ty: 3,
        parent: 60,
        ks: {
          p: {
            a: 0,
            k: [
              22.804,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 66,
        ty: 4,
        parent: 65,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 65,
        ty: 3,
        parent: 60,
        ks: {
          p: {
            a: 0,
            k: [
              16.437,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 68,
        ty: 4,
        parent: 67,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ],
                  [
                    1.2,
                    11.3
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    10.1
                  ],
                  [
                    2.4,
                    10.5
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.7,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    3,
                    11.6
                  ],
                  [
                    2.7,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 67,
        ty: 3,
        parent: 60,
        ks: {
          p: {
            a: 0,
            k: [
              13.093,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 70,
        ty: 4,
        parent: 69,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 69,
        ty: 3,
        parent: 60,
        ks: {
          p: {
            a: 0,
            k: [
              6.725,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 72,
        ty: 4,
        parent: 71,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    1.3,
                    9.6
                  ],
                  [
                    2.3,
                    10.2
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    4.5,
                    10.2
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.5,
                    8.7
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    2.5,
                    7.8
                  ],
                  [
                    1.7,
                    7.3
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    1.2,
                    4.5
                  ],
                  [
                    2.1,
                    3.7
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    4.9,
                    3.6
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    5.3,
                    5.3
                  ],
                  [
                    4.5,
                    4.8
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.5,
                    6.1
                  ],
                  [
                    2.9,
                    6.4
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    4.7,
                    7.2
                  ],
                  [
                    5.8,
                    8
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    5.9,
                    10.5
                  ],
                  [
                    4.9,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 71,
        ty: 3,
        parent: 60,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 60,
        ty: 3,
        parent: 28,
        ks: {
          p: {
            a: 0,
            k: [
              25.507,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 75,
        ty: 4,
        parent: 74,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    8.5
                  ],
                  [
                    2.3,
                    8.5
                  ],
                  [
                    0.9,
                    7.8
                  ],
                  [
                    0.4,
                    5.9
                  ],
                  [
                    0.4,
                    5.9
                  ],
                  [
                    0.9,
                    4
                  ],
                  [
                    2.3,
                    3.4
                  ],
                  [
                    2.3,
                    3.4
                  ],
                  [
                    3.7,
                    4
                  ],
                  [
                    4.2,
                    5.9
                  ],
                  [
                    4.2,
                    5.9
                  ],
                  [
                    3.7,
                    7.8
                  ],
                  [
                    2.3,
                    8.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    7.7
                  ],
                  [
                    2.3,
                    7.7
                  ],
                  [
                    2.9,
                    7.2
                  ],
                  [
                    3.2,
                    5.9
                  ],
                  [
                    3.2,
                    5.9
                  ],
                  [
                    2.9,
                    4.6
                  ],
                  [
                    2.3,
                    4.2
                  ],
                  [
                    2.3,
                    4.2
                  ],
                  [
                    1.7,
                    4.6
                  ],
                  [
                    1.4,
                    5.9
                  ],
                  [
                    1.4,
                    5.9
                  ],
                  [
                    1.7,
                    7.2
                  ],
                  [
                    2.3,
                    7.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2.6,
                    11.7
                  ],
                  [
                    7,
                    3.4
                  ],
                  [
                    7.8,
                    3.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    8.1,
                    11.7
                  ],
                  [
                    8.1,
                    11.7
                  ],
                  [
                    6.7,
                    11.1
                  ],
                  [
                    6.2,
                    9.2
                  ],
                  [
                    6.2,
                    9.2
                  ],
                  [
                    6.7,
                    7.3
                  ],
                  [
                    8.1,
                    6.6
                  ],
                  [
                    8.1,
                    6.6
                  ],
                  [
                    9.5,
                    7.3
                  ],
                  [
                    10,
                    9.2
                  ],
                  [
                    10,
                    9.2
                  ],
                  [
                    9.5,
                    11.1
                  ],
                  [
                    8.1,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    8.1,
                    10.9
                  ],
                  [
                    8.1,
                    10.9
                  ],
                  [
                    8.7,
                    10.5
                  ],
                  [
                    9,
                    9.2
                  ],
                  [
                    9,
                    9.2
                  ],
                  [
                    8.7,
                    7.9
                  ],
                  [
                    8.1,
                    7.5
                  ],
                  [
                    8.1,
                    7.5
                  ],
                  [
                    7.4,
                    7.9
                  ],
                  [
                    7.2,
                    9.2
                  ],
                  [
                    7.2,
                    9.2
                  ],
                  [
                    7.4,
                    10.5
                  ],
                  [
                    8.1,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 74,
        ty: 3,
        parent: 73,
        ks: {
          p: {
            a: 0,
            k: [
              12.661,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 77,
        ty: 4,
        parent: 76,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    11.7
                  ],
                  [
                    3,
                    11.7
                  ],
                  [
                    1.4,
                    11.4
                  ],
                  [
                    0.3,
                    10.6
                  ],
                  [
                    0.3,
                    10.6
                  ],
                  [
                    1,
                    9.7
                  ],
                  [
                    1.8,
                    10.3
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.9,
                    10.2
                  ],
                  [
                    4.3,
                    9.1
                  ],
                  [
                    4.3,
                    9.1
                  ],
                  [
                    3.9,
                    8
                  ],
                  [
                    2.9,
                    7.6
                  ],
                  [
                    2.9,
                    7.6
                  ],
                  [
                    2.2,
                    7.7
                  ],
                  [
                    1.6,
                    8
                  ],
                  [
                    1.6,
                    8
                  ],
                  [
                    0.9,
                    7.6
                  ],
                  [
                    1.2,
                    3.7
                  ],
                  [
                    5.4,
                    3.7
                  ],
                  [
                    5.4,
                    4.9
                  ],
                  [
                    2.4,
                    4.9
                  ],
                  [
                    2.2,
                    6.8
                  ],
                  [
                    2.7,
                    6.6
                  ],
                  [
                    3.3,
                    6.6
                  ],
                  [
                    3.3,
                    6.6
                  ],
                  [
                    4.5,
                    6.8
                  ],
                  [
                    5.4,
                    7.6
                  ],
                  [
                    5.7,
                    9
                  ],
                  [
                    5.7,
                    9
                  ],
                  [
                    5.4,
                    10.5
                  ],
                  [
                    4.3,
                    11.4
                  ],
                  [
                    3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 76,
        ty: 3,
        parent: 73,
        ks: {
          p: {
            a: 0,
            k: [
              6.33,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 79,
        ty: 4,
        parent: 78,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.1,
                    6.3
                  ],
                  [
                    1.6,
                    8.5
                  ],
                  [
                    3.7,
                    8.5
                  ],
                  [
                    3.7,
                    6.7
                  ],
                  [
                    3.7,
                    5.9
                  ],
                  [
                    3.8,
                    5.1
                  ],
                  [
                    3.8,
                    5.1
                  ],
                  [
                    3.7,
                    5.1
                  ],
                  [
                    3.4,
                    5.7
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    5,
                    11.6
                  ],
                  [
                    3.7,
                    11.6
                  ],
                  [
                    3.7,
                    9.6
                  ],
                  [
                    0.2,
                    9.6
                  ],
                  [
                    0.2,
                    8.6
                  ],
                  [
                    3.3,
                    3.7
                  ],
                  [
                    5,
                    3.7
                  ],
                  [
                    5,
                    8.5
                  ],
                  [
                    6,
                    8.5
                  ],
                  [
                    6,
                    9.6
                  ],
                  [
                    5,
                    9.6
                  ],
                  [
                    5,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 78,
        ty: 3,
        parent: 73,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 73,
        ty: 3,
        parent: 28,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 28,
        ty: 3,
        parent: 27,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 27,
        ty: 3,
        parent: 26,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 26,
        ty: 3,
        parent: 25,
        ks: {
          p: {
            a: 0,
            k: [
              22.167,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 88,
        ty: 0,
        parent: 80,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "86"
      },
      {
        ind: 80,
        ty: 3,
        parent: 25,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 25,
        ty: 3,
        parent: 24,
        ks: {
          p: {
            a: 0,
            k: [
              51.952,
              3.527
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 24,
        ty: 3,
        parent: 23,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              46.727
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 189,
        ty: 0,
        parent: 91,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              13.015
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              13.015
            ]
          }
        },
        w: 60.455,
        h: 13.775,
        ip: 0,
        op: 565,
        st: 0,
        refId: "187"
      },
      {
        ind: 91,
        ty: 3,
        parent: 90,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              13.015
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 194,
        ty: 4,
        parent: 193,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.22,
                    0.16
                  ],
                  [
                    -0.25,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.14,
                    -0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.06,
                    0.01
                  ],
                  [
                    0.09,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.15
                  ],
                  [
                    0.15,
                    -0.37
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.49,
                    8.51
                  ],
                  [
                    0.74,
                    8.51
                  ],
                  [
                    0.74,
                    4.11
                  ],
                  [
                    1.36,
                    4.11
                  ],
                  [
                    1.42,
                    4.9
                  ],
                  [
                    1.45,
                    4.9
                  ],
                  [
                    2,
                    4.24
                  ],
                  [
                    2.7,
                    4
                  ],
                  [
                    2.7,
                    4
                  ],
                  [
                    3.17,
                    4.09
                  ],
                  [
                    3.17,
                    4.09
                  ],
                  [
                    3.03,
                    4.74
                  ],
                  [
                    2.83,
                    4.69
                  ],
                  [
                    2.6,
                    4.67
                  ],
                  [
                    2.6,
                    4.67
                  ],
                  [
                    2.02,
                    4.9
                  ],
                  [
                    1.49,
                    5.68
                  ],
                  [
                    1.49,
                    5.68
                  ],
                  [
                    1.49,
                    8.51
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.15,
                    -0.28
                  ],
                  [
                    0.22,
                    -0.16
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.18,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.07,
                    -0.02
                  ],
                  [
                    -0.06,
                    -0.01
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0
                  ],
                  [
                    -0.2,
                    0.15
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 193,
        ty: 3,
        parent: 192,
        ks: {
          p: {
            a: 0,
            k: [
              20.34,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 196,
        ty: 4,
        parent: 195,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.32,
                    0.18
                  ],
                  [
                    0.19,
                    0.34
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.34
                  ],
                  [
                    -0.3,
                    0.19
                  ],
                  [
                    -0.33,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    -0.37
                  ],
                  [
                    0,
                    -0.63
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.08
                  ],
                  [
                    0.01,
                    -0.05
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.26,
                    -0.28
                  ],
                  [
                    -0.42,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.18,
                    0.06
                  ],
                  [
                    -0.16,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.09
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.53,
                    8.62
                  ],
                  [
                    2.53,
                    8.62
                  ],
                  [
                    1.46,
                    8.35
                  ],
                  [
                    0.7,
                    7.55
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.7,
                    5.08
                  ],
                  [
                    1.44,
                    4.28
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    3.7,
                    4.56
                  ],
                  [
                    4.15,
                    6.07
                  ],
                  [
                    4.15,
                    6.07
                  ],
                  [
                    4.15,
                    6.3
                  ],
                  [
                    4.13,
                    6.49
                  ],
                  [
                    4.13,
                    6.49
                  ],
                  [
                    1.15,
                    6.49
                  ],
                  [
                    1.59,
                    7.61
                  ],
                  [
                    2.62,
                    8.02
                  ],
                  [
                    2.62,
                    8.02
                  ],
                  [
                    3.21,
                    7.93
                  ],
                  [
                    3.72,
                    7.68
                  ],
                  [
                    3.72,
                    7.68
                  ],
                  [
                    3.98,
                    8.17
                  ],
                  [
                    3.34,
                    8.49
                  ],
                  [
                    2.53,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.39,
                    0
                  ],
                  [
                    -0.32,
                    -0.18
                  ],
                  [
                    -0.19,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.48
                  ],
                  [
                    0.19,
                    -0.34
                  ],
                  [
                    0.3,
                    -0.19
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.56,
                    0
                  ],
                  [
                    0.31,
                    0.37
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.08
                  ],
                  [
                    0,
                    0.08
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.03,
                    0.47
                  ],
                  [
                    0.26,
                    0.28
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0
                  ],
                  [
                    0.18,
                    -0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.12
                  ],
                  [
                    -0.24,
                    0.09
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.19,
                    0.23
                  ],
                  [
                    0.34,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.24
                  ],
                  [
                    0.05,
                    -0.44
                  ]
                ],
                v: [
                  [
                    1.14,
                    5.96
                  ],
                  [
                    1.14,
                    5.96
                  ],
                  [
                    3.5,
                    5.96
                  ],
                  [
                    3.21,
                    4.94
                  ],
                  [
                    2.41,
                    4.59
                  ],
                  [
                    2.41,
                    4.59
                  ],
                  [
                    1.58,
                    4.95
                  ],
                  [
                    1.14,
                    5.96
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.45
                  ],
                  [
                    -0.19,
                    -0.23
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    0
                  ],
                  [
                    -0.24,
                    0.24
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 195,
        ty: 3,
        parent: 192,
        ks: {
          p: {
            a: 0,
            k: [
              15.846,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 198,
        ty: 4,
        parent: 197,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    8.6
                  ],
                  [
                    1.5,
                    8.6
                  ],
                  [
                    0.9,
                    8.4
                  ],
                  [
                    0.7,
                    7.6
                  ],
                  [
                    0.7,
                    7.6
                  ],
                  [
                    0.7,
                    2.1
                  ],
                  [
                    1.5,
                    2.1
                  ],
                  [
                    1.5,
                    7.7
                  ],
                  [
                    1.6,
                    7.9
                  ],
                  [
                    1.7,
                    8
                  ],
                  [
                    1.7,
                    8
                  ],
                  [
                    1.8,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    2,
                    8.5
                  ],
                  [
                    1.8,
                    8.6
                  ],
                  [
                    1.5,
                    8.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 197,
        ty: 3,
        parent: 192,
        ks: {
          p: {
            a: 0,
            k: [
              13.536,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 200,
        ty: 4,
        parent: 199,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    0.22
                  ],
                  [
                    0,
                    0.39
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.43,
                    0.26
                  ],
                  [
                    -0.94,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.05,
                    0.17
                  ],
                  [
                    0.13,
                    0.11
                  ],
                  [
                    0.24,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.22,
                    -0.1
                  ],
                  [
                    0.18,
                    -0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.12
                  ],
                  [
                    -0.35,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.24,
                    -0.33
                  ],
                  [
                    0,
                    -0.55
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.13
                  ],
                  [
                    0.28,
                    0
                  ]
                ],
                v: [
                  [
                    1.76,
                    8.62
                  ],
                  [
                    1.76,
                    8.62
                  ],
                  [
                    0.84,
                    8.29
                  ],
                  [
                    0.47,
                    7.37
                  ],
                  [
                    0.47,
                    7.37
                  ],
                  [
                    1.12,
                    6.26
                  ],
                  [
                    3.17,
                    5.72
                  ],
                  [
                    3.17,
                    5.72
                  ],
                  [
                    3.1,
                    5.19
                  ],
                  [
                    2.82,
                    4.77
                  ],
                  [
                    2.27,
                    4.61
                  ],
                  [
                    2.27,
                    4.61
                  ],
                  [
                    1.55,
                    4.76
                  ],
                  [
                    0.95,
                    5.09
                  ],
                  [
                    0.95,
                    5.09
                  ],
                  [
                    0.66,
                    4.57
                  ],
                  [
                    1.42,
                    4.18
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    3.56,
                    4.49
                  ],
                  [
                    3.93,
                    5.81
                  ],
                  [
                    3.93,
                    5.81
                  ],
                  [
                    3.93,
                    8.51
                  ],
                  [
                    3.31,
                    8.51
                  ],
                  [
                    3.25,
                    7.99
                  ],
                  [
                    3.22,
                    7.99
                  ],
                  [
                    2.54,
                    8.43
                  ],
                  [
                    1.76,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.37,
                    0
                  ],
                  [
                    -0.24,
                    -0.22
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.48
                  ],
                  [
                    0.43,
                    -0.26
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.19
                  ],
                  [
                    -0.05,
                    -0.17
                  ],
                  [
                    -0.13,
                    -0.11
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.25,
                    0
                  ],
                  [
                    -0.22,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    -0.13
                  ],
                  [
                    0.3,
                    -0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.54,
                    0
                  ],
                  [
                    0.24,
                    0.33
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    0.17
                  ],
                  [
                    -0.24,
                    0.13
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.1
                  ],
                  [
                    -0.21,
                    0.19
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.29,
                    -0.18
                  ],
                  [
                    0,
                    -0.28
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.15,
                    -0.11
                  ],
                  [
                    -0.22,
                    0
                  ]
                ],
                v: [
                  [
                    1.98,
                    8.02
                  ],
                  [
                    1.98,
                    8.02
                  ],
                  [
                    2.58,
                    7.87
                  ],
                  [
                    3.17,
                    7.43
                  ],
                  [
                    3.17,
                    7.43
                  ],
                  [
                    3.17,
                    6.21
                  ],
                  [
                    1.64,
                    6.62
                  ],
                  [
                    1.2,
                    7.32
                  ],
                  [
                    1.2,
                    7.32
                  ],
                  [
                    1.42,
                    7.86
                  ],
                  [
                    1.98,
                    8.02
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0
                  ],
                  [
                    0.19,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.73,
                    0.09
                  ],
                  [
                    -0.29,
                    0.18
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.25
                  ],
                  [
                    0.15,
                    0.11
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 199,
        ty: 3,
        parent: 192,
        ks: {
          p: {
            a: 0,
            k: [
              8.969,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 202,
        ty: 4,
        parent: 201,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.31,
                    0.18
                  ],
                  [
                    0.18,
                    0.34
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.34
                  ],
                  [
                    -0.32,
                    0.18
                  ],
                  [
                    -0.37,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.1
                  ],
                  [
                    -0.15,
                    -0.14
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.14,
                    0.07
                  ],
                  [
                    0.18,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    -0.14
                  ],
                  [
                    0.12,
                    -0.26
                  ],
                  [
                    0,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.25,
                    -0.31
                  ],
                  [
                    -0.41,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.18,
                    0.09
                  ],
                  [
                    -0.13,
                    0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.1
                  ],
                  [
                    0.27,
                    0
                  ]
                ],
                v: [
                  [
                    2.48,
                    8.62
                  ],
                  [
                    2.48,
                    8.62
                  ],
                  [
                    1.43,
                    8.35
                  ],
                  [
                    0.69,
                    7.56
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.71,
                    5.06
                  ],
                  [
                    1.49,
                    4.27
                  ],
                  [
                    2.54,
                    4
                  ],
                  [
                    2.54,
                    4
                  ],
                  [
                    3.29,
                    4.15
                  ],
                  [
                    3.83,
                    4.51
                  ],
                  [
                    3.83,
                    4.51
                  ],
                  [
                    3.45,
                    5
                  ],
                  [
                    3.04,
                    4.72
                  ],
                  [
                    2.57,
                    4.61
                  ],
                  [
                    2.57,
                    4.61
                  ],
                  [
                    1.85,
                    4.83
                  ],
                  [
                    1.36,
                    5.43
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.56,
                    7.54
                  ],
                  [
                    2.55,
                    8.01
                  ],
                  [
                    2.55,
                    8.01
                  ],
                  [
                    3.12,
                    7.87
                  ],
                  [
                    3.58,
                    7.56
                  ],
                  [
                    3.58,
                    7.56
                  ],
                  [
                    3.91,
                    8.06
                  ],
                  [
                    3.25,
                    8.47
                  ],
                  [
                    2.48,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.39,
                    0
                  ],
                  [
                    -0.31,
                    -0.18
                  ],
                  [
                    -0.18,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0.2,
                    -0.34
                  ],
                  [
                    0.32,
                    -0.18
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.29,
                    0
                  ],
                  [
                    0.21,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.13,
                    -0.11
                  ],
                  [
                    -0.14,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.27,
                    0
                  ],
                  [
                    -0.21,
                    0.14
                  ],
                  [
                    -0.12,
                    0.26
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0.25,
                    0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0
                  ],
                  [
                    0.18,
                    -0.09
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.18
                  ],
                  [
                    -0.24,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 201,
        ty: 3,
        parent: 192,
        ks: {
          p: {
            a: 0,
            k: [
              4.838,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 204,
        ty: 4,
        parent: 203,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.5,
                    8.6
                  ],
                  [
                    2.5,
                    8.6
                  ],
                  [
                    1.3,
                    8.4
                  ],
                  [
                    0.4,
                    7.7
                  ],
                  [
                    0.4,
                    7.7
                  ],
                  [
                    0.8,
                    7.2
                  ],
                  [
                    1.6,
                    7.8
                  ],
                  [
                    2.5,
                    8
                  ],
                  [
                    2.5,
                    8
                  ],
                  [
                    3.4,
                    7.7
                  ],
                  [
                    3.7,
                    7
                  ],
                  [
                    3.7,
                    7
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    3.2,
                    6.2
                  ],
                  [
                    2.7,
                    5.9
                  ],
                  [
                    2.7,
                    5.9
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.3,
                    5.3
                  ],
                  [
                    0.9,
                    4.8
                  ],
                  [
                    0.7,
                    4
                  ],
                  [
                    0.7,
                    4
                  ],
                  [
                    0.9,
                    3.2
                  ],
                  [
                    1.6,
                    2.7
                  ],
                  [
                    2.5,
                    2.5
                  ],
                  [
                    2.5,
                    2.5
                  ],
                  [
                    3.5,
                    2.7
                  ],
                  [
                    4.3,
                    3.2
                  ],
                  [
                    4.3,
                    3.2
                  ],
                  [
                    3.9,
                    3.7
                  ],
                  [
                    3.3,
                    3.3
                  ],
                  [
                    2.5,
                    3.1
                  ],
                  [
                    2.5,
                    3.1
                  ],
                  [
                    1.7,
                    3.4
                  ],
                  [
                    1.4,
                    4
                  ],
                  [
                    1.4,
                    4
                  ],
                  [
                    1.6,
                    4.5
                  ],
                  [
                    2,
                    4.8
                  ],
                  [
                    2.4,
                    5
                  ],
                  [
                    2.4,
                    5
                  ],
                  [
                    3.3,
                    5.3
                  ],
                  [
                    3.9,
                    5.7
                  ],
                  [
                    4.3,
                    6.2
                  ],
                  [
                    4.5,
                    6.9
                  ],
                  [
                    4.5,
                    6.9
                  ],
                  [
                    4.2,
                    7.8
                  ],
                  [
                    3.5,
                    8.4
                  ],
                  [
                    2.5,
                    8.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 203,
        ty: 3,
        parent: 192,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 192,
        ty: 3,
        parent: 191,
        ks: {
          p: {
            a: 0,
            k: [
              18.709,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 207,
        ty: 4,
        parent: 206,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    8.6
                  ],
                  [
                    2.1,
                    8.6
                  ],
                  [
                    1.1,
                    8.2
                  ],
                  [
                    0.9,
                    7.2
                  ],
                  [
                    0.9,
                    7.2
                  ],
                  [
                    0.9,
                    4.7
                  ],
                  [
                    0.2,
                    4.7
                  ],
                  [
                    0.2,
                    4.2
                  ],
                  [
                    0.9,
                    4.1
                  ],
                  [
                    1,
                    2.9
                  ],
                  [
                    1.6,
                    2.9
                  ],
                  [
                    1.6,
                    4.1
                  ],
                  [
                    2.8,
                    4.1
                  ],
                  [
                    2.8,
                    4.7
                  ],
                  [
                    1.6,
                    4.7
                  ],
                  [
                    1.6,
                    7.2
                  ],
                  [
                    1.8,
                    7.8
                  ],
                  [
                    2.3,
                    8
                  ],
                  [
                    2.3,
                    8
                  ],
                  [
                    2.6,
                    8
                  ],
                  [
                    2.8,
                    7.9
                  ],
                  [
                    2.8,
                    7.9
                  ],
                  [
                    2.9,
                    8.5
                  ],
                  [
                    2.6,
                    8.6
                  ],
                  [
                    2.1,
                    8.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 206,
        ty: 3,
        parent: 205,
        ks: {
          p: {
            a: 0,
            k: [
              13.835,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 209,
        ty: 4,
        parent: 208,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.28,
                    0.12
                  ],
                  [
                    0.21,
                    0.17
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.1
                  ],
                  [
                    -0.26,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.15,
                    0.14
                  ],
                  [
                    0,
                    0.19
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.15,
                    0.07
                  ],
                  [
                    0.16,
                    0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.13,
                    0.16
                  ],
                  [
                    0,
                    0.25
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.27,
                    0.24
                  ],
                  [
                    -0.48,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.24,
                    -0.1
                  ],
                  [
                    -0.17,
                    -0.14
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.16,
                    0.07
                  ],
                  [
                    0.19,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.13,
                    -0.13
                  ],
                  [
                    0,
                    -0.17
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.09,
                    -0.09
                  ],
                  [
                    -0.15,
                    -0.06
                  ],
                  [
                    -0.16,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.1
                  ],
                  [
                    -0.14,
                    -0.17
                  ],
                  [
                    0,
                    -0.28
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.12,
                    -0.2
                  ],
                  [
                    0.24,
                    -0.12
                  ],
                  [
                    0.35,
                    0
                  ]
                ],
                v: [
                  [
                    1.9,
                    8.62
                  ],
                  [
                    1.9,
                    8.62
                  ],
                  [
                    1,
                    8.45
                  ],
                  [
                    0.25,
                    8.01
                  ],
                  [
                    0.25,
                    8.01
                  ],
                  [
                    0.63,
                    7.52
                  ],
                  [
                    1.22,
                    7.89
                  ],
                  [
                    1.92,
                    8.04
                  ],
                  [
                    1.92,
                    8.04
                  ],
                  [
                    2.58,
                    7.84
                  ],
                  [
                    2.79,
                    7.35
                  ],
                  [
                    2.79,
                    7.35
                  ],
                  [
                    2.64,
                    6.97
                  ],
                  [
                    2.26,
                    6.71
                  ],
                  [
                    1.79,
                    6.52
                  ],
                  [
                    1.79,
                    6.52
                  ],
                  [
                    1.18,
                    6.25
                  ],
                  [
                    0.69,
                    5.86
                  ],
                  [
                    0.5,
                    5.25
                  ],
                  [
                    0.5,
                    5.25
                  ],
                  [
                    0.9,
                    4.36
                  ],
                  [
                    2.02,
                    4
                  ],
                  [
                    2.02,
                    4
                  ],
                  [
                    2.78,
                    4.14
                  ],
                  [
                    3.39,
                    4.5
                  ],
                  [
                    3.39,
                    4.5
                  ],
                  [
                    3.03,
                    4.97
                  ],
                  [
                    2.56,
                    4.69
                  ],
                  [
                    2.02,
                    4.58
                  ],
                  [
                    2.02,
                    4.58
                  ],
                  [
                    1.41,
                    4.77
                  ],
                  [
                    1.22,
                    5.21
                  ],
                  [
                    1.22,
                    5.21
                  ],
                  [
                    1.35,
                    5.55
                  ],
                  [
                    1.7,
                    5.78
                  ],
                  [
                    2.17,
                    5.97
                  ],
                  [
                    2.17,
                    5.97
                  ],
                  [
                    2.79,
                    6.24
                  ],
                  [
                    3.31,
                    6.64
                  ],
                  [
                    3.51,
                    7.31
                  ],
                  [
                    3.51,
                    7.31
                  ],
                  [
                    3.32,
                    7.96
                  ],
                  [
                    2.78,
                    8.44
                  ],
                  [
                    1.9,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    0
                  ],
                  [
                    -0.28,
                    -0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.19,
                    0.15
                  ],
                  [
                    0.21,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.29,
                    0
                  ],
                  [
                    0.15,
                    -0.14
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.15
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.15,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.08
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.13,
                    -0.16
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.36
                  ],
                  [
                    0.27,
                    -0.24
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.27,
                    0
                  ],
                  [
                    0.24,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.15,
                    -0.11
                  ],
                  [
                    -0.16,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.28,
                    0
                  ],
                  [
                    -0.13,
                    0.13
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.14
                  ],
                  [
                    0.09,
                    0.09
                  ],
                  [
                    0.15,
                    0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0.08
                  ],
                  [
                    0.21,
                    0.1
                  ],
                  [
                    0.14,
                    0.17
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.24
                  ],
                  [
                    -0.12,
                    0.2
                  ],
                  [
                    -0.24,
                    0.12
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 208,
        ty: 3,
        parent: 205,
        ks: {
          p: {
            a: 0,
            k: [
              10.038,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 211,
        ty: 4,
        parent: 210,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.31,
                    0.18
                  ],
                  [
                    0.19,
                    0.34
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.34
                  ],
                  [
                    -0.31,
                    0.18
                  ],
                  [
                    -0.36,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    -0.18
                  ],
                  [
                    -0.19,
                    -0.34
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.19,
                    -0.34
                  ],
                  [
                    0.31,
                    -0.18
                  ],
                  [
                    0.36,
                    0
                  ]
                ],
                v: [
                  [
                    2.46,
                    8.62
                  ],
                  [
                    2.46,
                    8.62
                  ],
                  [
                    1.46,
                    8.35
                  ],
                  [
                    0.7,
                    7.56
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.7,
                    5.06
                  ],
                  [
                    1.46,
                    4.27
                  ],
                  [
                    2.46,
                    4
                  ],
                  [
                    2.46,
                    4
                  ],
                  [
                    3.46,
                    4.27
                  ],
                  [
                    4.21,
                    5.06
                  ],
                  [
                    4.5,
                    6.32
                  ],
                  [
                    4.5,
                    6.32
                  ],
                  [
                    4.21,
                    7.56
                  ],
                  [
                    3.46,
                    8.35
                  ],
                  [
                    2.46,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.36,
                    0
                  ],
                  [
                    -0.31,
                    -0.18
                  ],
                  [
                    -0.19,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0.19,
                    -0.34
                  ],
                  [
                    0.31,
                    -0.18
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.36,
                    0
                  ],
                  [
                    0.31,
                    0.18
                  ],
                  [
                    0.19,
                    0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    -0.19,
                    0.34
                  ],
                  [
                    -0.31,
                    0.18
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.23,
                    0.31
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.23,
                    0.31
                  ],
                  [
                    0.38,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.31
                  ],
                  [
                    0,
                    -0.51
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.24,
                    -0.31
                  ],
                  [
                    -0.37,
                    0
                  ]
                ],
                v: [
                  [
                    2.46,
                    8.01
                  ],
                  [
                    2.46,
                    8.01
                  ],
                  [
                    3.38,
                    7.54
                  ],
                  [
                    3.73,
                    6.32
                  ],
                  [
                    3.73,
                    6.32
                  ],
                  [
                    3.38,
                    5.09
                  ],
                  [
                    2.46,
                    4.61
                  ],
                  [
                    2.46,
                    4.61
                  ],
                  [
                    1.54,
                    5.09
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.54,
                    7.54
                  ],
                  [
                    2.46,
                    8.01
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.38,
                    0
                  ],
                  [
                    0.23,
                    -0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.51
                  ],
                  [
                    -0.23,
                    -0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.37,
                    0
                  ],
                  [
                    -0.24,
                    0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0.24,
                    0.31
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 210,
        ty: 3,
        parent: 205,
        ks: {
          p: {
            a: 0,
            k: [
              5.128,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 213,
        ty: 4,
        parent: 212,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.5
                  ],
                  [
                    0.8,
                    8.5
                  ],
                  [
                    0.8,
                    2.6
                  ],
                  [
                    2.5,
                    2.6
                  ],
                  [
                    3.7,
                    2.7
                  ],
                  [
                    4.5,
                    3.3
                  ],
                  [
                    4.7,
                    4.3
                  ],
                  [
                    4.7,
                    4.3
                  ],
                  [
                    4.1,
                    5.7
                  ],
                  [
                    2.5,
                    6.2
                  ],
                  [
                    2.5,
                    6.2
                  ],
                  [
                    1.6,
                    6.2
                  ],
                  [
                    1.6,
                    8.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.6,
                    3.2
                  ],
                  [
                    1.6,
                    5.5
                  ],
                  [
                    2.5,
                    5.5
                  ],
                  [
                    3.6,
                    5.2
                  ],
                  [
                    4,
                    4.3
                  ],
                  [
                    4,
                    4.3
                  ],
                  [
                    3.6,
                    3.4
                  ],
                  [
                    2.4,
                    3.2
                  ],
                  [
                    2.4,
                    3.2
                  ],
                  [
                    1.6,
                    3.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 212,
        ty: 3,
        parent: 205,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 205,
        ty: 3,
        parent: 191,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 191,
        ty: 3,
        parent: 190,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 190,
        ty: 3,
        parent: 90,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 90,
        ty: 3,
        parent: 89,
        ks: {
          p: {
            a: 0,
            k: [
              186.97,
              2.915
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 219,
        ty: 0,
        parent: 215,
        ks: {},
        w: 27,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "217"
      },
      {
        ind: 215,
        ty: 3,
        parent: 214,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 214,
        ty: 3,
        parent: 89,
        ks: {
          p: {
            a: 0,
            k: [
              150.193,
              10.204
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 225,
        ty: 4,
        parent: 224,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    13.2
                  ],
                  [
                    1.2,
                    13.2
                  ],
                  [
                    1.2,
                    3.2
                  ],
                  [
                    2.3,
                    3.2
                  ],
                  [
                    2.3,
                    10
                  ],
                  [
                    2.3,
                    10
                  ],
                  [
                    5.3,
                    6.4
                  ],
                  [
                    6.5,
                    6.4
                  ],
                  [
                    4.2,
                    9.1
                  ],
                  [
                    6.9,
                    13.2
                  ],
                  [
                    5.6,
                    13.2
                  ],
                  [
                    3.6,
                    9.9
                  ],
                  [
                    2.3,
                    11.4
                  ],
                  [
                    2.3,
                    13.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 224,
        ty: 3,
        parent: 223,
        ks: {
          p: {
            a: 0,
            k: [
              50.577,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 227,
        ty: 4,
        parent: 226,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.8,
                    13.4
                  ],
                  [
                    3.8,
                    13.4
                  ],
                  [
                    2.3,
                    13
                  ],
                  [
                    1.1,
                    11.8
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    1.1,
                    7.9
                  ],
                  [
                    2.3,
                    6.6
                  ],
                  [
                    3.8,
                    6.2
                  ],
                  [
                    3.8,
                    6.2
                  ],
                  [
                    5.4,
                    6.6
                  ],
                  [
                    6.6,
                    7.9
                  ],
                  [
                    7,
                    9.8
                  ],
                  [
                    7,
                    9.8
                  ],
                  [
                    6.6,
                    11.8
                  ],
                  [
                    5.4,
                    13
                  ],
                  [
                    3.8,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.5
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    -0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.8,
                    12.5
                  ],
                  [
                    3.8,
                    12.5
                  ],
                  [
                    5.3,
                    11.7
                  ],
                  [
                    5.8,
                    9.8
                  ],
                  [
                    5.8,
                    9.8
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    3.8,
                    7.2
                  ],
                  [
                    3.8,
                    7.2
                  ],
                  [
                    2.4,
                    7.9
                  ],
                  [
                    1.8,
                    9.8
                  ],
                  [
                    1.8,
                    9.8
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    3.8,
                    12.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 226,
        ty: 3,
        parent: 223,
        ks: {
          p: {
            a: 0,
            k: [
              42.934,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 229,
        ty: 4,
        parent: 228,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.8,
                    13.4
                  ],
                  [
                    3.8,
                    13.4
                  ],
                  [
                    2.3,
                    13
                  ],
                  [
                    1.1,
                    11.8
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    1.1,
                    7.9
                  ],
                  [
                    2.3,
                    6.6
                  ],
                  [
                    3.8,
                    6.2
                  ],
                  [
                    3.8,
                    6.2
                  ],
                  [
                    5.4,
                    6.6
                  ],
                  [
                    6.6,
                    7.9
                  ],
                  [
                    7,
                    9.8
                  ],
                  [
                    7,
                    9.8
                  ],
                  [
                    6.6,
                    11.8
                  ],
                  [
                    5.4,
                    13
                  ],
                  [
                    3.8,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.5
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    -0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.8,
                    12.5
                  ],
                  [
                    3.8,
                    12.5
                  ],
                  [
                    5.3,
                    11.7
                  ],
                  [
                    5.8,
                    9.8
                  ],
                  [
                    5.8,
                    9.8
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    3.8,
                    7.2
                  ],
                  [
                    3.8,
                    7.2
                  ],
                  [
                    2.4,
                    7.9
                  ],
                  [
                    1.8,
                    9.8
                  ],
                  [
                    1.8,
                    9.8
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    3.8,
                    12.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 228,
        ty: 3,
        parent: 223,
        ks: {
          p: {
            a: 0,
            k: [
              35.292,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 231,
        ty: 4,
        parent: 230,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    -1.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.6
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    4.2,
                    13.4
                  ],
                  [
                    4.2,
                    13.4
                  ],
                  [
                    3.2,
                    13.2
                  ],
                  [
                    2.2,
                    12.5
                  ],
                  [
                    2.2,
                    12.5
                  ],
                  [
                    2.2,
                    12.5
                  ],
                  [
                    2.1,
                    13.2
                  ],
                  [
                    1.2,
                    13.2
                  ],
                  [
                    1.2,
                    3.2
                  ],
                  [
                    2.3,
                    3.2
                  ],
                  [
                    2.3,
                    5.9
                  ],
                  [
                    2.3,
                    7.2
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    4.4,
                    6.2
                  ],
                  [
                    4.4,
                    6.2
                  ],
                  [
                    6.5,
                    7.2
                  ],
                  [
                    7.2,
                    9.7
                  ],
                  [
                    7.2,
                    9.7
                  ],
                  [
                    6.7,
                    11.7
                  ],
                  [
                    5.6,
                    13
                  ],
                  [
                    4.2,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.3,
                    0.6
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.5
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    0
                  ]
                ],
                v: [
                  [
                    4,
                    12.4
                  ],
                  [
                    4,
                    12.4
                  ],
                  [
                    5.4,
                    11.7
                  ],
                  [
                    6,
                    9.7
                  ],
                  [
                    6,
                    9.7
                  ],
                  [
                    5.5,
                    7.9
                  ],
                  [
                    4.1,
                    7.2
                  ],
                  [
                    4.1,
                    7.2
                  ],
                  [
                    3.3,
                    7.4
                  ],
                  [
                    2.3,
                    8.1
                  ],
                  [
                    2.3,
                    8.1
                  ],
                  [
                    2.3,
                    11.7
                  ],
                  [
                    3.2,
                    12.3
                  ],
                  [
                    4,
                    12.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 230,
        ty: 3,
        parent: 223,
        ks: {
          p: {
            a: 0,
            k: [
              27.495,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 233,
        ty: 4,
        parent: 232,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.9,
                    13.4
                  ],
                  [
                    3.9,
                    13.4
                  ],
                  [
                    2.3,
                    13
                  ],
                  [
                    1.1,
                    11.7
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    1.1,
                    7.9
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    3.7,
                    6.2
                  ],
                  [
                    3.7,
                    6.2
                  ],
                  [
                    5.7,
                    7.1
                  ],
                  [
                    6.5,
                    9.4
                  ],
                  [
                    6.5,
                    9.4
                  ],
                  [
                    6.5,
                    9.8
                  ],
                  [
                    6.4,
                    10.1
                  ],
                  [
                    6.4,
                    10.1
                  ],
                  [
                    1.8,
                    10.1
                  ],
                  [
                    2.5,
                    11.8
                  ],
                  [
                    4.1,
                    12.5
                  ],
                  [
                    4.1,
                    12.5
                  ],
                  [
                    5,
                    12.3
                  ],
                  [
                    5.8,
                    11.9
                  ],
                  [
                    5.8,
                    11.9
                  ],
                  [
                    6.2,
                    12.7
                  ],
                  [
                    5.2,
                    13.2
                  ],
                  [
                    3.9,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.1,
                    -0.7
                  ]
                ],
                v: [
                  [
                    1.8,
                    9.3
                  ],
                  [
                    1.8,
                    9.3
                  ],
                  [
                    5.4,
                    9.3
                  ],
                  [
                    5,
                    7.7
                  ],
                  [
                    3.8,
                    7.1
                  ],
                  [
                    3.8,
                    7.1
                  ],
                  [
                    2.5,
                    7.7
                  ],
                  [
                    1.8,
                    9.3
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 232,
        ty: 3,
        parent: 223,
        ks: {
          p: {
            a: 0,
            k: [
              20.501,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 235,
        ty: 4,
        parent: 234,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.9,
                    13.4
                  ],
                  [
                    3.9,
                    13.4
                  ],
                  [
                    2.2,
                    13
                  ],
                  [
                    1.1,
                    11.8
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    1.1,
                    7.9
                  ],
                  [
                    2.3,
                    6.6
                  ],
                  [
                    3.9,
                    6.2
                  ],
                  [
                    3.9,
                    6.2
                  ],
                  [
                    5.1,
                    6.5
                  ],
                  [
                    6,
                    7
                  ],
                  [
                    6,
                    7
                  ],
                  [
                    5.4,
                    7.8
                  ],
                  [
                    4.7,
                    7.3
                  ],
                  [
                    4,
                    7.2
                  ],
                  [
                    4,
                    7.2
                  ],
                  [
                    2.9,
                    7.5
                  ],
                  [
                    2.1,
                    8.4
                  ],
                  [
                    1.8,
                    9.8
                  ],
                  [
                    1.8,
                    9.8
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    4,
                    12.5
                  ],
                  [
                    4,
                    12.5
                  ],
                  [
                    4.9,
                    12.2
                  ],
                  [
                    5.6,
                    11.8
                  ],
                  [
                    5.6,
                    11.8
                  ],
                  [
                    6.1,
                    12.5
                  ],
                  [
                    5.1,
                    13.2
                  ],
                  [
                    3.9,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 234,
        ty: 3,
        parent: 223,
        ks: {
          p: {
            a: 0,
            k: [
              14.072,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 237,
        ty: 4,
        parent: 236,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0.4
                  ],
                  [
                    -1.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    13.4
                  ],
                  [
                    2.7,
                    13.4
                  ],
                  [
                    1.3,
                    12.9
                  ],
                  [
                    0.7,
                    11.5
                  ],
                  [
                    0.7,
                    11.5
                  ],
                  [
                    1.7,
                    9.7
                  ],
                  [
                    4.9,
                    8.9
                  ],
                  [
                    4.9,
                    8.9
                  ],
                  [
                    4.8,
                    8.1
                  ],
                  [
                    4.4,
                    7.4
                  ],
                  [
                    3.5,
                    7.2
                  ],
                  [
                    3.5,
                    7.2
                  ],
                  [
                    2.4,
                    7.4
                  ],
                  [
                    1.5,
                    7.9
                  ],
                  [
                    1.5,
                    7.9
                  ],
                  [
                    1,
                    7.1
                  ],
                  [
                    2.2,
                    6.5
                  ],
                  [
                    3.7,
                    6.2
                  ],
                  [
                    3.7,
                    6.2
                  ],
                  [
                    5.5,
                    7
                  ],
                  [
                    6.1,
                    9
                  ],
                  [
                    6.1,
                    9
                  ],
                  [
                    6.1,
                    13.2
                  ],
                  [
                    5.1,
                    13.2
                  ],
                  [
                    5.1,
                    12.4
                  ],
                  [
                    5,
                    12.4
                  ],
                  [
                    4,
                    13.1
                  ],
                  [
                    2.7,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.7,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.1,
                    12.5
                  ],
                  [
                    3.1,
                    12.5
                  ],
                  [
                    4,
                    12.2
                  ],
                  [
                    4.9,
                    11.6
                  ],
                  [
                    4.9,
                    11.6
                  ],
                  [
                    4.9,
                    9.7
                  ],
                  [
                    2.5,
                    10.3
                  ],
                  [
                    1.9,
                    11.4
                  ],
                  [
                    1.9,
                    11.4
                  ],
                  [
                    2.2,
                    12.2
                  ],
                  [
                    3.1,
                    12.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.1,
                    0.1
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 236,
        ty: 3,
        parent: 223,
        ks: {
          p: {
            a: 0,
            k: [
              6.965,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 239,
        ty: 4,
        parent: 238,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    13.2
                  ],
                  [
                    1.3,
                    13.2
                  ],
                  [
                    1.3,
                    4
                  ],
                  [
                    6.6,
                    4
                  ],
                  [
                    6.6,
                    5
                  ],
                  [
                    2.4,
                    5
                  ],
                  [
                    2.4,
                    8.1
                  ],
                  [
                    6,
                    8.1
                  ],
                  [
                    6,
                    9.1
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2.4,
                    13.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 238,
        ty: 3,
        parent: 223,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 223,
        ty: 3,
        parent: 222,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 222,
        ty: 3,
        parent: 221,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 221,
        ty: 3,
        parent: 220,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              14.988
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 244,
        ty: 0,
        parent: 240,
        ks: {},
        w: 81,
        h: 15,
        ip: 0,
        op: 565,
        st: 0,
        refId: "242"
      },
      {
        ind: 240,
        ty: 3,
        parent: 220,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 220,
        ty: 3,
        parent: 89,
        ks: {
          p: {
            a: 0,
            k: [
              27.646,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 89,
        ty: 3,
        parent: 23,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 23,
        ty: 3,
        parent: 22,
        ks: {
          p: {
            a: 0,
            k: [
              10.58,
              102.27
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 253,
        ty: 4,
        parent: 252,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    1,
                    3.2
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    2,
                    3.2
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2,
                    4.2
                  ],
                  [
                    1.5,
                    4.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 252,
        ty: 3,
        parent: 251,
        ks: {
          p: {
            a: 0,
            k: [
              23.569,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 255,
        ty: 4,
        parent: 254,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    2.8
                  ],
                  [
                    2,
                    2.8
                  ],
                  [
                    2,
                    5.2
                  ],
                  [
                    2,
                    6.4
                  ],
                  [
                    2.9,
                    5.7
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    5.4,
                    6
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    4.8,
                    7.9
                  ],
                  [
                    4.5,
                    6.7
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    2.8,
                    6.6
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 254,
        ty: 3,
        parent: 251,
        ks: {
          p: {
            a: 0,
            k: [
              16.856,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 257,
        ty: 4,
        parent: 256,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    11.7
                  ],
                  [
                    2.1,
                    11.7
                  ],
                  [
                    1.3,
                    11.4
                  ],
                  [
                    1,
                    10.4
                  ],
                  [
                    1,
                    10.4
                  ],
                  [
                    1,
                    2.8
                  ],
                  [
                    2,
                    2.8
                  ],
                  [
                    2,
                    10.5
                  ],
                  [
                    2.1,
                    10.8
                  ],
                  [
                    2.3,
                    10.9
                  ],
                  [
                    2.3,
                    10.9
                  ],
                  [
                    2.4,
                    10.9
                  ],
                  [
                    2.5,
                    10.9
                  ],
                  [
                    2.5,
                    10.9
                  ],
                  [
                    2.7,
                    11.6
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.1,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 256,
        ty: 3,
        parent: 251,
        ks: {
          p: {
            a: 0,
            k: [
              13.71,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 259,
        ty: 4,
        parent: 258,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.2
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.6,
                    8.6
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    1.6,
                    8.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.4,
                    11.1
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.6
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.1
                  ],
                  [
                    1.6,
                    8.1
                  ],
                  [
                    4.8,
                    8.1
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.6,
                    8.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 258,
        ty: 3,
        parent: 251,
        ks: {
          p: {
            a: 0,
            k: [
              7.589,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 261,
        ty: 4,
        parent: 260,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    -0.7
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.7
                  ],
                  [
                    1.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    3.5
                  ],
                  [
                    3.1,
                    3.5
                  ],
                  [
                    6,
                    4.5
                  ],
                  [
                    7,
                    7.5
                  ],
                  [
                    7,
                    7.5
                  ],
                  [
                    6,
                    10.5
                  ],
                  [
                    3.2,
                    11.6
                  ],
                  [
                    3.2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1.3,
                    0
                  ],
                  [
                    0.7,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    -0.6,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.6
                  ],
                  [
                    0,
                    1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.5
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    4.3
                  ],
                  [
                    2.1,
                    10.7
                  ],
                  [
                    3.1,
                    10.7
                  ],
                  [
                    5.2,
                    9.9
                  ],
                  [
                    5.9,
                    7.5
                  ],
                  [
                    5.9,
                    7.5
                  ],
                  [
                    5.2,
                    5.2
                  ],
                  [
                    3.1,
                    4.3
                  ],
                  [
                    3.1,
                    4.3
                  ],
                  [
                    2.1,
                    4.3
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0.5,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    -0.5,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 260,
        ty: 3,
        parent: 251,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 251,
        ty: 3,
        parent: 250,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 250,
        ty: 3,
        parent: 249,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 249,
        ty: 3,
        parent: 248,
        ks: {
          p: {
            a: 0,
            k: [
              21.159,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 271,
        ty: 0,
        parent: 262,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "269"
      },
      {
        ind: 262,
        ty: 3,
        parent: 248,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 248,
        ty: 3,
        parent: 247,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              19.527
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 277,
        ty: 4,
        parent: 276,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.9,
                    11.7
                  ],
                  [
                    2.9,
                    11.7
                  ],
                  [
                    1.6,
                    11.2
                  ],
                  [
                    1.2,
                    9.7
                  ],
                  [
                    1.2,
                    9.7
                  ],
                  [
                    1.2,
                    6.4
                  ],
                  [
                    0.3,
                    6.4
                  ],
                  [
                    0.3,
                    5.7
                  ],
                  [
                    1.2,
                    5.6
                  ],
                  [
                    1.4,
                    3.9
                  ],
                  [
                    2.2,
                    3.9
                  ],
                  [
                    2.2,
                    5.6
                  ],
                  [
                    3.8,
                    5.6
                  ],
                  [
                    3.8,
                    6.4
                  ],
                  [
                    2.2,
                    6.4
                  ],
                  [
                    2.2,
                    9.7
                  ],
                  [
                    2.4,
                    10.6
                  ],
                  [
                    3.1,
                    10.9
                  ],
                  [
                    3.1,
                    10.9
                  ],
                  [
                    3.5,
                    10.9
                  ],
                  [
                    3.8,
                    10.7
                  ],
                  [
                    3.8,
                    10.7
                  ],
                  [
                    4,
                    11.5
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2.9,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 276,
        ty: 3,
        parent: 275,
        ks: {
          p: {
            a: 0,
            k: [
              40.5,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 279,
        ty: 4,
        parent: 278,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    2.6,
                    11.7
                  ],
                  [
                    2.6,
                    11.7
                  ],
                  [
                    1.4,
                    11.5
                  ],
                  [
                    0.3,
                    10.9
                  ],
                  [
                    0.3,
                    10.9
                  ],
                  [
                    0.9,
                    10.2
                  ],
                  [
                    1.7,
                    10.7
                  ],
                  [
                    2.6,
                    10.9
                  ],
                  [
                    2.6,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    3.8,
                    10
                  ],
                  [
                    3.8,
                    10
                  ],
                  [
                    3.6,
                    9.5
                  ],
                  [
                    3.1,
                    9.1
                  ],
                  [
                    2.4,
                    8.9
                  ],
                  [
                    2.4,
                    8.9
                  ],
                  [
                    1.6,
                    8.5
                  ],
                  [
                    0.9,
                    8
                  ],
                  [
                    0.7,
                    7.1
                  ],
                  [
                    0.7,
                    7.1
                  ],
                  [
                    1.2,
                    5.9
                  ],
                  [
                    2.8,
                    5.4
                  ],
                  [
                    2.8,
                    5.4
                  ],
                  [
                    3.8,
                    5.6
                  ],
                  [
                    4.6,
                    6.1
                  ],
                  [
                    4.6,
                    6.1
                  ],
                  [
                    4.1,
                    6.8
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    2.8,
                    6.2
                  ],
                  [
                    2.8,
                    6.2
                  ],
                  [
                    1.9,
                    6.5
                  ],
                  [
                    1.7,
                    7.1
                  ],
                  [
                    1.7,
                    7.1
                  ],
                  [
                    1.8,
                    7.6
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.9,
                    8.1
                  ],
                  [
                    2.9,
                    8.1
                  ],
                  [
                    3.8,
                    8.5
                  ],
                  [
                    4.5,
                    9
                  ],
                  [
                    4.8,
                    9.9
                  ],
                  [
                    4.8,
                    9.9
                  ],
                  [
                    4.5,
                    10.8
                  ],
                  [
                    3.8,
                    11.5
                  ],
                  [
                    2.6,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 278,
        ty: 3,
        parent: 275,
        ks: {
          p: {
            a: 0,
            k: [
              35.329,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 281,
        ty: 4,
        parent: 280,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    1,
                    3.2
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    2,
                    3.2
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2,
                    4.2
                  ],
                  [
                    1.5,
                    4.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 280,
        ty: 3,
        parent: 275,
        ks: {
          p: {
            a: 0,
            k: [
              32.294,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 283,
        ty: 4,
        parent: 282,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.9,
                    11.7
                  ],
                  [
                    2.9,
                    11.7
                  ],
                  [
                    1.6,
                    11.2
                  ],
                  [
                    1.2,
                    9.7
                  ],
                  [
                    1.2,
                    9.7
                  ],
                  [
                    1.2,
                    6.4
                  ],
                  [
                    0.3,
                    6.4
                  ],
                  [
                    0.3,
                    5.7
                  ],
                  [
                    1.2,
                    5.6
                  ],
                  [
                    1.4,
                    3.9
                  ],
                  [
                    2.2,
                    3.9
                  ],
                  [
                    2.2,
                    5.6
                  ],
                  [
                    3.8,
                    5.6
                  ],
                  [
                    3.8,
                    6.4
                  ],
                  [
                    2.2,
                    6.4
                  ],
                  [
                    2.2,
                    9.7
                  ],
                  [
                    2.4,
                    10.6
                  ],
                  [
                    3.1,
                    10.9
                  ],
                  [
                    3.1,
                    10.9
                  ],
                  [
                    3.5,
                    10.9
                  ],
                  [
                    3.8,
                    10.7
                  ],
                  [
                    3.8,
                    10.7
                  ],
                  [
                    4,
                    11.5
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2.9,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 282,
        ty: 3,
        parent: 275,
        ks: {
          p: {
            a: 0,
            k: [
              28.123,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 285,
        ty: 4,
        parent: 284,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.5
                  ],
                  [
                    2,
                    6.5
                  ],
                  [
                    2.9,
                    5.7
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    5.4,
                    6
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    4.8,
                    7.9
                  ],
                  [
                    4.5,
                    6.7
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    2.8,
                    6.6
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 284,
        ty: 3,
        parent: 275,
        ks: {
          p: {
            a: 0,
            k: [
              21.373,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 287,
        ty: 4,
        parent: 286,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.2
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.6,
                    8.6
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    1.6,
                    8.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.4,
                    11.1
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.6
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.1
                  ],
                  [
                    1.6,
                    8.1
                  ],
                  [
                    4.8,
                    8.1
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.6,
                    8.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 286,
        ty: 3,
        parent: 275,
        ks: {
          p: {
            a: 0,
            k: [
              15.252,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 289,
        ty: 4,
        parent: 288,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    1,
                    3.2
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    2,
                    3.2
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2,
                    4.2
                  ],
                  [
                    1.5,
                    4.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 288,
        ty: 3,
        parent: 275,
        ks: {
          p: {
            a: 0,
            k: [
              12.217,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 291,
        ty: 4,
        parent: 290,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    4.5,
                    5.7
                  ],
                  [
                    5.2,
                    6.1
                  ],
                  [
                    5.2,
                    6.1
                  ],
                  [
                    4.7,
                    6.8
                  ],
                  [
                    4.1,
                    6.4
                  ],
                  [
                    3.5,
                    6.3
                  ],
                  [
                    3.5,
                    6.3
                  ],
                  [
                    2.5,
                    6.6
                  ],
                  [
                    1.9,
                    7.4
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    2.1,
                    10.3
                  ],
                  [
                    3.5,
                    10.9
                  ],
                  [
                    3.5,
                    10.9
                  ],
                  [
                    4.2,
                    10.7
                  ],
                  [
                    4.9,
                    10.3
                  ],
                  [
                    4.9,
                    10.3
                  ],
                  [
                    5.3,
                    11
                  ],
                  [
                    4.4,
                    11.5
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 290,
        ty: 3,
        parent: 275,
        ks: {
          p: {
            a: 0,
            k: [
              6.59,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 293,
        ty: 4,
        parent: 292,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    1.1,
                    9.8
                  ],
                  [
                    2.2,
                    10.6
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    4.6,
                    10.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    4.9,
                    8.8
                  ],
                  [
                    4.4,
                    8.4
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    2.6,
                    7.6
                  ],
                  [
                    1.8,
                    7.2
                  ],
                  [
                    1.2,
                    6.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    1.2,
                    4.4
                  ],
                  [
                    2.1,
                    3.6
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    4.8,
                    3.6
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.3,
                    5
                  ],
                  [
                    4.5,
                    4.4
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    2.4,
                    4.6
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2.2,
                    6.1
                  ],
                  [
                    2.7,
                    6.5
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    4.4,
                    7.3
                  ],
                  [
                    5.3,
                    7.7
                  ],
                  [
                    5.9,
                    8.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    5.8,
                    10.6
                  ],
                  [
                    4.8,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 292,
        ty: 3,
        parent: 275,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 275,
        ty: 3,
        parent: 274,
        ks: {
          p: {
            a: 0,
            k: [
              62.601,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 296,
        ty: 4,
        parent: 295,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -1.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.3
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.5,
                    8.5
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.2,
                    7.1
                  ],
                  [
                    3.8,
                    6.5
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    2.1,
                    6.5
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    0.9,
                    6.2
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    11.6
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    3.5,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    10.9
                  ],
                  [
                    2.7,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    8.5
                  ],
                  [
                    2.2,
                    9
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.9,
                    10.7
                  ],
                  [
                    2.7,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 295,
        ty: 3,
        parent: 294,
        ks: {
          p: {
            a: 0,
            k: [
              17.979,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 298,
        ty: 4,
        parent: 297,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.9,
                    11.7
                  ],
                  [
                    2.9,
                    11.7
                  ],
                  [
                    1.6,
                    11.2
                  ],
                  [
                    1.2,
                    9.7
                  ],
                  [
                    1.2,
                    9.7
                  ],
                  [
                    1.2,
                    6.4
                  ],
                  [
                    0.3,
                    6.4
                  ],
                  [
                    0.3,
                    5.7
                  ],
                  [
                    1.2,
                    5.6
                  ],
                  [
                    1.4,
                    3.9
                  ],
                  [
                    2.2,
                    3.9
                  ],
                  [
                    2.2,
                    5.6
                  ],
                  [
                    3.8,
                    5.6
                  ],
                  [
                    3.8,
                    6.4
                  ],
                  [
                    2.2,
                    6.4
                  ],
                  [
                    2.2,
                    9.7
                  ],
                  [
                    2.4,
                    10.6
                  ],
                  [
                    3.1,
                    10.9
                  ],
                  [
                    3.1,
                    10.9
                  ],
                  [
                    3.5,
                    10.9
                  ],
                  [
                    3.8,
                    10.7
                  ],
                  [
                    3.8,
                    10.7
                  ],
                  [
                    4,
                    11.5
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2.9,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 297,
        ty: 3,
        parent: 294,
        ks: {
          p: {
            a: 0,
            k: [
              13.808,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 300,
        ty: 4,
        parent: 299,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -1.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.3
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.5,
                    8.5
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.2,
                    7.1
                  ],
                  [
                    3.8,
                    6.5
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    2.1,
                    6.5
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    0.9,
                    6.2
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    11.6
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    3.5,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    10.9
                  ],
                  [
                    2.7,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    8.5
                  ],
                  [
                    2.2,
                    9
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.9,
                    10.7
                  ],
                  [
                    2.7,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 299,
        ty: 3,
        parent: 294,
        ks: {
          p: {
            a: 0,
            k: [
              7.589,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 302,
        ty: 4,
        parent: 301,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    -0.7
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.7
                  ],
                  [
                    1.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    3.5
                  ],
                  [
                    3.1,
                    3.5
                  ],
                  [
                    6,
                    4.5
                  ],
                  [
                    7,
                    7.5
                  ],
                  [
                    7,
                    7.5
                  ],
                  [
                    6,
                    10.5
                  ],
                  [
                    3.2,
                    11.6
                  ],
                  [
                    3.2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1.3,
                    0
                  ],
                  [
                    0.7,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    -0.6,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.6
                  ],
                  [
                    0,
                    1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.5
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    4.3
                  ],
                  [
                    2.1,
                    10.7
                  ],
                  [
                    3.1,
                    10.7
                  ],
                  [
                    5.2,
                    9.9
                  ],
                  [
                    5.9,
                    7.5
                  ],
                  [
                    5.9,
                    7.5
                  ],
                  [
                    5.2,
                    5.2
                  ],
                  [
                    3.1,
                    4.3
                  ],
                  [
                    3.1,
                    4.3
                  ],
                  [
                    2.1,
                    4.3
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0.5,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    -0.5,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 301,
        ty: 3,
        parent: 294,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 294,
        ty: 3,
        parent: 274,
        ks: {
          p: {
            a: 0,
            k: [
              35.934,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 305,
        ty: 4,
        parent: 304,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.7
                  ],
                  [
                    2,
                    6.7
                  ],
                  [
                    2.7,
                    5.8
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.1,
                    6.5
                  ],
                  [
                    3.9,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    2.7,
                    6.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 304,
        ty: 3,
        parent: 303,
        ks: {
          p: {
            a: 0,
            k: [
              29.184,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 307,
        ty: 4,
        parent: 306,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    11.7
                  ],
                  [
                    3.3,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.8
                  ],
                  [
                    5.7,
                    6.9
                  ],
                  [
                    6.1,
                    8.6
                  ],
                  [
                    6.1,
                    8.6
                  ],
                  [
                    5.7,
                    10.3
                  ],
                  [
                    4.7,
                    11.4
                  ],
                  [
                    3.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    10.9
                  ],
                  [
                    3.3,
                    10.9
                  ],
                  [
                    4.6,
                    10.3
                  ],
                  [
                    5.1,
                    8.6
                  ],
                  [
                    5.1,
                    8.6
                  ],
                  [
                    4.6,
                    6.9
                  ],
                  [
                    3.3,
                    6.3
                  ],
                  [
                    3.3,
                    6.3
                  ],
                  [
                    2.1,
                    6.9
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    2.1,
                    10.3
                  ],
                  [
                    3.3,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 306,
        ty: 3,
        parent: 303,
        ks: {
          p: {
            a: 0,
            k: [
              22.496,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 309,
        ty: 4,
        parent: 308,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    1,
                    3.2
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    2,
                    3.2
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2,
                    4.2
                  ],
                  [
                    1.5,
                    4.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 308,
        ty: 3,
        parent: 303,
        ks: {
          p: {
            a: 0,
            k: [
              19.46,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 311,
        ty: 4,
        parent: 310,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.5
                  ],
                  [
                    2,
                    6.5
                  ],
                  [
                    2.9,
                    5.7
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    5.4,
                    6
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    4.8,
                    7.9
                  ],
                  [
                    4.5,
                    6.7
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    2.8,
                    6.6
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 310,
        ty: 3,
        parent: 303,
        ks: {
          p: {
            a: 0,
            k: [
              12.71,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 313,
        ty: 4,
        parent: 312,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.2
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.6,
                    8.6
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    1.6,
                    8.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.4,
                    11.1
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.6
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.1
                  ],
                  [
                    1.6,
                    8.1
                  ],
                  [
                    4.8,
                    8.1
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.6,
                    8.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 312,
        ty: 3,
        parent: 303,
        ks: {
          p: {
            a: 0,
            k: [
              6.59,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 315,
        ty: 4,
        parent: 314,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    1.1,
                    9.8
                  ],
                  [
                    2.2,
                    10.6
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    4.6,
                    10.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    4.9,
                    8.8
                  ],
                  [
                    4.4,
                    8.4
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    2.6,
                    7.6
                  ],
                  [
                    1.8,
                    7.2
                  ],
                  [
                    1.2,
                    6.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    1.2,
                    4.4
                  ],
                  [
                    2.1,
                    3.6
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    4.8,
                    3.6
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.3,
                    5
                  ],
                  [
                    4.5,
                    4.4
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    2.4,
                    4.6
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2.2,
                    6.1
                  ],
                  [
                    2.7,
                    6.5
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    4.4,
                    7.3
                  ],
                  [
                    5.3,
                    7.7
                  ],
                  [
                    5.9,
                    8.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    5.8,
                    10.6
                  ],
                  [
                    4.8,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 314,
        ty: 3,
        parent: 303,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 303,
        ty: 3,
        parent: 274,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 274,
        ty: 3,
        parent: 273,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.8
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 273,
        ty: 3,
        parent: 272,
        ks: {
          p: {
            a: 0,
            k: [
              21.159,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 325,
        ty: 0,
        parent: 316,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "323"
      },
      {
        ind: 316,
        ty: 3,
        parent: 272,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 272,
        ty: 3,
        parent: 247,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 247,
        ty: 3,
        parent: 246,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              36.053
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 331,
        ty: 4,
        parent: 330,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0.5
                  ],
                  [
                    -1.6,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    -1.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.9
                  ],
                  [
                    3,
                    19.9
                  ],
                  [
                    1.4,
                    19.3
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    1.8,
                    15.7
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5,
                    13.7
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    2.8,
                    13.5
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1,
                    12.8
                  ],
                  [
                    2.5,
                    12.1
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    6.4,
                    12.6
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    19.7
                  ],
                  [
                    5.6,
                    19.7
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    4.3,
                    19.6
                  ],
                  [
                    3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.7,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.6,
                    18.5
                  ],
                  [
                    3.6,
                    18.5
                  ],
                  [
                    4.5,
                    18.3
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    15.9
                  ],
                  [
                    3.1,
                    16.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.8,
                    18.3
                  ],
                  [
                    3.6,
                    18.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 330,
        ty: 3,
        parent: 329,
        ks: {
          p: {
            a: 0,
            k: [
              33.449,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 333,
        ty: 4,
        parent: 332,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.9,
                    19.9
                  ],
                  [
                    3.9,
                    19.9
                  ],
                  [
                    2,
                    19.2
                  ],
                  [
                    1.4,
                    17.1
                  ],
                  [
                    1.4,
                    17.1
                  ],
                  [
                    1.4,
                    13.4
                  ],
                  [
                    0.3,
                    13.4
                  ],
                  [
                    0.3,
                    12
                  ],
                  [
                    1.5,
                    12
                  ],
                  [
                    1.7,
                    9.8
                  ],
                  [
                    3.3,
                    9.8
                  ],
                  [
                    3.3,
                    12
                  ],
                  [
                    5.3,
                    12
                  ],
                  [
                    5.3,
                    13.4
                  ],
                  [
                    3.3,
                    13.4
                  ],
                  [
                    3.3,
                    17.1
                  ],
                  [
                    4.4,
                    18.5
                  ],
                  [
                    4.4,
                    18.5
                  ],
                  [
                    4.8,
                    18.4
                  ],
                  [
                    5.2,
                    18.3
                  ],
                  [
                    5.2,
                    18.3
                  ],
                  [
                    5.5,
                    19.7
                  ],
                  [
                    4.8,
                    19.9
                  ],
                  [
                    3.9,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.9,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 332,
        ty: 3,
        parent: 329,
        ks: {
          p: {
            a: 0,
            k: [
              27.723,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 335,
        ty: 4,
        parent: 334,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    -1.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.6
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    22.8
                  ],
                  [
                    1.2,
                    22.8
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    2.7,
                    12
                  ],
                  [
                    2.8,
                    12.8
                  ],
                  [
                    2.9,
                    12.8
                  ],
                  [
                    4,
                    12.1
                  ],
                  [
                    5.2,
                    11.8
                  ],
                  [
                    5.2,
                    11.8
                  ],
                  [
                    7.5,
                    12.8
                  ],
                  [
                    8.3,
                    15.7
                  ],
                  [
                    8.3,
                    15.7
                  ],
                  [
                    7.8,
                    18
                  ],
                  [
                    6.6,
                    19.4
                  ],
                  [
                    4.9,
                    19.9
                  ],
                  [
                    4.9,
                    19.9
                  ],
                  [
                    3.9,
                    19.7
                  ],
                  [
                    2.9,
                    19.1
                  ],
                  [
                    2.9,
                    19.1
                  ],
                  [
                    3,
                    20.4
                  ],
                  [
                    3,
                    22.8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.9
                  ],
                  [
                    -0.3,
                    0.6
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    0,
                    0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    0
                  ]
                ],
                v: [
                  [
                    4.6,
                    18.4
                  ],
                  [
                    4.6,
                    18.4
                  ],
                  [
                    5.9,
                    17.7
                  ],
                  [
                    6.4,
                    15.7
                  ],
                  [
                    6.4,
                    15.7
                  ],
                  [
                    6,
                    13.9
                  ],
                  [
                    4.7,
                    13.3
                  ],
                  [
                    4.7,
                    13.3
                  ],
                  [
                    3,
                    14.1
                  ],
                  [
                    3,
                    14.1
                  ],
                  [
                    3,
                    17.8
                  ],
                  [
                    3.8,
                    18.3
                  ],
                  [
                    4.6,
                    18.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 334,
        ty: 3,
        parent: 329,
        ks: {
          p: {
            a: 0,
            k: [
              18.778,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 337,
        ty: 4,
        parent: 336,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    19.9
                  ],
                  [
                    3.5,
                    19.9
                  ],
                  [
                    1.7,
                    19.1
                  ],
                  [
                    1.1,
                    16.8
                  ],
                  [
                    1.1,
                    16.8
                  ],
                  [
                    1.1,
                    12
                  ],
                  [
                    2.9,
                    12
                  ],
                  [
                    2.9,
                    16.6
                  ],
                  [
                    3.2,
                    18
                  ],
                  [
                    4.1,
                    18.4
                  ],
                  [
                    4.1,
                    18.4
                  ],
                  [
                    5,
                    18.1
                  ],
                  [
                    5.8,
                    17.3
                  ],
                  [
                    5.8,
                    17.3
                  ],
                  [
                    5.8,
                    12
                  ],
                  [
                    7.7,
                    12
                  ],
                  [
                    7.7,
                    19.7
                  ],
                  [
                    6.2,
                    19.7
                  ],
                  [
                    6,
                    18.6
                  ],
                  [
                    6,
                    18.6
                  ],
                  [
                    4.9,
                    19.6
                  ],
                  [
                    3.5,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 336,
        ty: 3,
        parent: 329,
        ks: {
          p: {
            a: 0,
            k: [
              9.96,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 339,
        ty: 4,
        parent: 338,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0.4
                  ],
                  [
                    0.4,
                    0.8
                  ],
                  [
                    0,
                    1.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.8
                  ],
                  [
                    -0.7,
                    0.4
                  ],
                  [
                    -0.9,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.7
                  ],
                  [
                    0,
                    -1.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    -1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.2
                  ],
                  [
                    0.7,
                    0
                  ]
                ],
                v: [
                  [
                    5.7,
                    19.9
                  ],
                  [
                    5.7,
                    19.9
                  ],
                  [
                    3.2,
                    19.3
                  ],
                  [
                    1.4,
                    17.5
                  ],
                  [
                    0.8,
                    14.6
                  ],
                  [
                    0.8,
                    14.6
                  ],
                  [
                    1.4,
                    11.7
                  ],
                  [
                    3.2,
                    9.8
                  ],
                  [
                    5.7,
                    9.2
                  ],
                  [
                    5.7,
                    9.2
                  ],
                  [
                    7.6,
                    9.6
                  ],
                  [
                    8.8,
                    10.5
                  ],
                  [
                    8.8,
                    10.5
                  ],
                  [
                    7.8,
                    11.7
                  ],
                  [
                    7,
                    11
                  ],
                  [
                    5.7,
                    10.8
                  ],
                  [
                    5.7,
                    10.8
                  ],
                  [
                    3.5,
                    11.8
                  ],
                  [
                    2.7,
                    14.5
                  ],
                  [
                    2.7,
                    14.5
                  ],
                  [
                    3.5,
                    17.3
                  ],
                  [
                    5.8,
                    18.3
                  ],
                  [
                    5.8,
                    18.3
                  ],
                  [
                    6.7,
                    18.2
                  ],
                  [
                    7.3,
                    17.9
                  ],
                  [
                    7.3,
                    17.9
                  ],
                  [
                    7.3,
                    15.6
                  ],
                  [
                    5.4,
                    15.6
                  ],
                  [
                    5.4,
                    14.1
                  ],
                  [
                    9,
                    14.1
                  ],
                  [
                    9,
                    18.7
                  ],
                  [
                    7.6,
                    19.6
                  ],
                  [
                    5.7,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.9,
                    0
                  ],
                  [
                    -0.7,
                    -0.4
                  ],
                  [
                    -0.4,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -1.1
                  ],
                  [
                    0.4,
                    -0.8
                  ],
                  [
                    0.7,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.9,
                    0
                  ],
                  [
                    -0.6,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    1.2
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.6,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 338,
        ty: 3,
        parent: 329,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 329,
        ty: 3,
        parent: 328,
        ks: {
          p: {
            a: 0,
            k: [
              52.148,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 342,
        ty: 4,
        parent: 341,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    5,
                    19.7
                  ],
                  [
                    2.9,
                    19.7
                  ],
                  [
                    0.2,
                    12
                  ],
                  [
                    2,
                    12
                  ],
                  [
                    3.3,
                    16
                  ],
                  [
                    3.6,
                    17.2
                  ],
                  [
                    3.9,
                    18.4
                  ],
                  [
                    3.9,
                    18.4
                  ],
                  [
                    4,
                    18.4
                  ],
                  [
                    4.3,
                    17.2
                  ],
                  [
                    4.7,
                    16
                  ],
                  [
                    4.7,
                    16
                  ],
                  [
                    5.9,
                    12
                  ],
                  [
                    7.7,
                    12
                  ],
                  [
                    5,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 341,
        ty: 3,
        parent: 340,
        ks: {
          p: {
            a: 0,
            k: [
              41.125,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 344,
        ty: 4,
        parent: 343,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    2.7,
                    12
                  ],
                  [
                    2.8,
                    13.3
                  ],
                  [
                    2.9,
                    13.3
                  ],
                  [
                    3.9,
                    12.2
                  ],
                  [
                    5.1,
                    11.8
                  ],
                  [
                    5.1,
                    11.8
                  ],
                  [
                    6,
                    11.9
                  ],
                  [
                    6,
                    11.9
                  ],
                  [
                    5.6,
                    13.5
                  ],
                  [
                    5.3,
                    13.4
                  ],
                  [
                    4.8,
                    13.4
                  ],
                  [
                    4.8,
                    13.4
                  ],
                  [
                    3.9,
                    13.7
                  ],
                  [
                    3,
                    15
                  ],
                  [
                    3,
                    15
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 343,
        ty: 3,
        parent: 340,
        ks: {
          p: {
            a: 0,
            k: [
              35.209,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 346,
        ty: 4,
        parent: 345,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0.3
                  ],
                  [
                    0.3,
                    0.6
                  ],
                  [
                    0,
                    0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.6
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.6
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.6
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0.7,
                    0
                  ]
                ],
                v: [
                  [
                    4.3,
                    19.9
                  ],
                  [
                    4.3,
                    19.9
                  ],
                  [
                    2.5,
                    19.5
                  ],
                  [
                    1.2,
                    18.1
                  ],
                  [
                    0.7,
                    15.9
                  ],
                  [
                    0.7,
                    15.9
                  ],
                  [
                    1.2,
                    13.6
                  ],
                  [
                    2.5,
                    12.2
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    6.2,
                    12.2
                  ],
                  [
                    7.5,
                    13.6
                  ],
                  [
                    8.1,
                    15.9
                  ],
                  [
                    8.1,
                    15.9
                  ],
                  [
                    7.5,
                    18.1
                  ],
                  [
                    6.2,
                    19.5
                  ],
                  [
                    4.3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.6,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0.3,
                    -0.6
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.6,
                    0.3
                  ],
                  [
                    0.3,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.9
                  ],
                  [
                    -0.3,
                    0.6
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    -0.6,
                    0
                  ]
                ],
                v: [
                  [
                    4.3,
                    18.4
                  ],
                  [
                    4.3,
                    18.4
                  ],
                  [
                    5.7,
                    17.7
                  ],
                  [
                    6.2,
                    15.9
                  ],
                  [
                    6.2,
                    15.9
                  ],
                  [
                    5.7,
                    14
                  ],
                  [
                    4.3,
                    13.3
                  ],
                  [
                    4.3,
                    13.3
                  ],
                  [
                    3,
                    14
                  ],
                  [
                    2.5,
                    15.9
                  ],
                  [
                    2.5,
                    15.9
                  ],
                  [
                    3,
                    17.7
                  ],
                  [
                    4.3,
                    18.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 345,
        ty: 3,
        parent: 340,
        ks: {
          p: {
            a: 0,
            k: [
              26.502,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 348,
        ty: 4,
        parent: 347,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0.3
                  ],
                  [
                    0.3,
                    0.6
                  ],
                  [
                    0,
                    0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.6
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.6
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.6
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0.7,
                    0
                  ]
                ],
                v: [
                  [
                    4.3,
                    19.9
                  ],
                  [
                    4.3,
                    19.9
                  ],
                  [
                    2.5,
                    19.5
                  ],
                  [
                    1.2,
                    18.1
                  ],
                  [
                    0.7,
                    15.9
                  ],
                  [
                    0.7,
                    15.9
                  ],
                  [
                    1.2,
                    13.6
                  ],
                  [
                    2.5,
                    12.2
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    6.2,
                    12.2
                  ],
                  [
                    7.5,
                    13.6
                  ],
                  [
                    8.1,
                    15.9
                  ],
                  [
                    8.1,
                    15.9
                  ],
                  [
                    7.5,
                    18.1
                  ],
                  [
                    6.2,
                    19.5
                  ],
                  [
                    4.3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.6,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0.3,
                    -0.6
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.6,
                    0.3
                  ],
                  [
                    0.3,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.9
                  ],
                  [
                    -0.3,
                    0.6
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    -0.6,
                    0
                  ]
                ],
                v: [
                  [
                    4.3,
                    18.4
                  ],
                  [
                    4.3,
                    18.4
                  ],
                  [
                    5.7,
                    17.7
                  ],
                  [
                    6.2,
                    15.9
                  ],
                  [
                    6.2,
                    15.9
                  ],
                  [
                    5.7,
                    14
                  ],
                  [
                    4.3,
                    13.3
                  ],
                  [
                    4.3,
                    13.3
                  ],
                  [
                    3,
                    14
                  ],
                  [
                    2.5,
                    15.9
                  ],
                  [
                    2.5,
                    15.9
                  ],
                  [
                    3,
                    17.7
                  ],
                  [
                    4.3,
                    18.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 347,
        ty: 3,
        parent: 340,
        ks: {
          p: {
            a: 0,
            k: [
              17.795,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 350,
        ty: 4,
        parent: 349,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    -1.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.6
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    22.8
                  ],
                  [
                    1.2,
                    22.8
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    2.7,
                    12
                  ],
                  [
                    2.8,
                    12.8
                  ],
                  [
                    2.9,
                    12.8
                  ],
                  [
                    4,
                    12.1
                  ],
                  [
                    5.2,
                    11.8
                  ],
                  [
                    5.2,
                    11.8
                  ],
                  [
                    7.5,
                    12.8
                  ],
                  [
                    8.3,
                    15.7
                  ],
                  [
                    8.3,
                    15.7
                  ],
                  [
                    7.8,
                    18
                  ],
                  [
                    6.6,
                    19.4
                  ],
                  [
                    4.9,
                    19.9
                  ],
                  [
                    4.9,
                    19.9
                  ],
                  [
                    3.9,
                    19.7
                  ],
                  [
                    2.9,
                    19.1
                  ],
                  [
                    2.9,
                    19.1
                  ],
                  [
                    3,
                    20.4
                  ],
                  [
                    3,
                    22.8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.9
                  ],
                  [
                    -0.3,
                    0.6
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    0,
                    0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    0
                  ]
                ],
                v: [
                  [
                    4.6,
                    18.4
                  ],
                  [
                    4.6,
                    18.4
                  ],
                  [
                    5.9,
                    17.7
                  ],
                  [
                    6.4,
                    15.7
                  ],
                  [
                    6.4,
                    15.7
                  ],
                  [
                    6,
                    13.9
                  ],
                  [
                    4.7,
                    13.3
                  ],
                  [
                    4.7,
                    13.3
                  ],
                  [
                    3,
                    14.1
                  ],
                  [
                    3,
                    14.1
                  ],
                  [
                    3,
                    17.8
                  ],
                  [
                    3.8,
                    18.3
                  ],
                  [
                    4.6,
                    18.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 349,
        ty: 3,
        parent: 340,
        ks: {
          p: {
            a: 0,
            k: [
              8.85,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 352,
        ty: 4,
        parent: 351,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.6
                  ],
                  [
                    0.1,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.6
                  ],
                  [
                    0.2,
                    -0.6
                  ]
                ],
                v: [
                  [
                    3.4,
                    14.2
                  ],
                  [
                    3.4,
                    14.2
                  ],
                  [
                    3.1,
                    15.5
                  ],
                  [
                    5.7,
                    15.5
                  ],
                  [
                    5.4,
                    14.2
                  ],
                  [
                    4.9,
                    12.5
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    3.9,
                    12.5
                  ],
                  [
                    3.4,
                    14.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.6
                  ],
                  [
                    -0.2,
                    0.6
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.8,
                    19.7
                  ],
                  [
                    0,
                    19.7
                  ],
                  [
                    3.3,
                    9.4
                  ],
                  [
                    5.5,
                    9.4
                  ],
                  [
                    8.9,
                    19.7
                  ],
                  [
                    7,
                    19.7
                  ],
                  [
                    6.1,
                    16.9
                  ],
                  [
                    2.7,
                    16.9
                  ],
                  [
                    1.8,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 351,
        ty: 3,
        parent: 340,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 340,
        ty: 3,
        parent: 328,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 328,
        ty: 3,
        parent: 327,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.394
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 327,
        ty: 3,
        parent: 326,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 326,
        ty: 3,
        parent: 246,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 246,
        ty: 3,
        parent: 245,
        ks: {
          p: {
            a: 0,
            k: [
              91.69,
              3.002
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 363,
        ty: 0,
        parent: 354,
        ks: {
          a: {
            a: 0,
            k: [
              54.666,
              55.543
            ]
          },
          p: {
            a: 0,
            k: [
              54.666,
              55.543
            ]
          }
        },
        w: 21.159,
        h: 21.159,
        ip: 0,
        op: 565,
        st: 0,
        refId: "361"
      },
      {
        ind: 354,
        ty: 3,
        parent: 353,
        ks: {
          p: {
            a: 0,
            k: [
              54.666,
              55.543
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 366,
        ty: 4,
        td: 1,
        parent: 364,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                38.792,
                38.792
              ]
            },
            r: {
              a: 0,
              k: 60
            },
            s: {
              a: 0,
              k: [
                77.584,
                77.584
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 365,
        ty: 4,
        tt: 1,
        parent: 364,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                p: {
                  a: 0,
                  k: [
                    38.792,
                    38.792
                  ]
                },
                r: {
                  a: 0,
                  k: 0
                },
                s: {
                  a: 0,
                  k: [
                    81.992,
                    81.992
                  ]
                }
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0,
                    0,
                    0,
                    0
                  ]
                },
                o: {
                  a: 0,
                  k: 0
                }
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          },
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                p: {
                  a: 0,
                  k: [
                    38.792,
                    38.792
                  ]
                },
                r: {
                  a: 0,
                  k: 60
                },
                s: {
                  a: 0,
                  k: [
                    77.584,
                    77.584
                  ]
                }
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.427,
                    0.184,
                    0.604
                  ]
                },
                lj: 1,
                ml: 10,
                o: {
                  a: 0,
                  k: 100
                },
                w: {
                  a: 0,
                  k: 4.408
                }
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      },
      {
        ind: 382,
        ty: 4,
        td: 1,
        parent: 364,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                38.792,
                38.792
              ]
            },
            r: {
              a: 0,
              k: 60
            },
            s: {
              a: 0,
              k: [
                77.584,
                77.584
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 381,
        ty: 0,
        tt: 1,
        parent: 364,
        ks: {},
        w: 71,
        h: 71,
        ip: 0,
        op: 565,
        st: 0,
        refId: "379"
      },
      {
        ind: 364,
        ty: 3,
        parent: 353,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 353,
        ty: 3,
        parent: 245,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 245,
        ty: 3,
        parent: 22,
        ks: {
          p: {
            a: 0,
            k: [
              10.58,
              10.58
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 383,
        ty: 4,
        parent: 22,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                148.115,
                91.315
              ]
            },
            r: {
              a: 0,
              k: 7
            },
            s: {
              a: 0,
              k: [
                296.23,
                182.63
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                1,
                1
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 22,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "388",
    layers: [
      {
        ind: 386,
        ty: 0,
        ks: {
          a: {
            a: 0,
            k: [
              1,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              143.629,
              142.629
            ]
          }
        },
        w: 298,
        h: 183,
        ip: 0,
        op: 565,
        st: 0,
        refId: "384"
      },
      {
        ind: 387,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                291.745,
                233.944
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                583.489,
                467.888
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      }
    ]
  },
  {
    id: "455",
    layers: [
      {
        ind: 454,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                7,
                4.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                14,
                9
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            -0.09
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            -0.02
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.06,
                            0.03
                          ],
                          [
                            0.05,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            0.02
                          ],
                          [
                            -0.07,
                            0
                          ],
                          [
                            -0.06,
                            -0.03
                          ],
                          [
                            -0.05,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.13
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.04
                          ],
                          [
                            -0.06,
                            0.03
                          ],
                          [
                            -0.06,
                            0
                          ],
                          [
                            -0.06,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.05
                          ],
                          [
                            0.06,
                            -0.03
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.06,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            0.09,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            10.09,
                            0.81
                          ],
                          [
                            10.09,
                            3.46
                          ],
                          [
                            9.94,
                            3.81
                          ],
                          [
                            9.59,
                            3.95
                          ],
                          [
                            9.24,
                            3.81
                          ],
                          [
                            9.09,
                            3.46
                          ],
                          [
                            9.09,
                            2.01
                          ],
                          [
                            5.97,
                            5.13
                          ],
                          [
                            5.81,
                            5.24
                          ],
                          [
                            5.62,
                            5.28
                          ],
                          [
                            5.43,
                            5.24
                          ],
                          [
                            5.27,
                            5.13
                          ],
                          [
                            3.97,
                            3.83
                          ],
                          [
                            1.34,
                            6.45
                          ],
                          [
                            0.99,
                            6.6
                          ],
                          [
                            0.64,
                            6.45
                          ],
                          [
                            0.5,
                            6.1
                          ],
                          [
                            0.64,
                            5.75
                          ],
                          [
                            3.62,
                            2.77
                          ],
                          [
                            3.78,
                            2.67
                          ],
                          [
                            3.97,
                            2.63
                          ],
                          [
                            4.16,
                            2.67
                          ],
                          [
                            4.32,
                            2.77
                          ],
                          [
                            5.62,
                            4.08
                          ],
                          [
                            8.39,
                            1.31
                          ],
                          [
                            6.95,
                            1.31
                          ],
                          [
                            6.59,
                            1.16
                          ],
                          [
                            6.45,
                            0.81
                          ],
                          [
                            6.59,
                            0.46
                          ],
                          [
                            6.95,
                            0.32
                          ],
                          [
                            9.59,
                            0.32
                          ],
                          [
                            9.94,
                            0.46
                          ],
                          [
                            10.09,
                            0.81
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.52,
                        0.32,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "458",
    layers: [
      {
        ind: 457,
        ty: 0,
        parent: 453,
        ks: {},
        w: 14,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "455"
      },
      {
        ind: 453,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              2
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "469",
    layers: [
      {
        ind: 468,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3,
                6
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                6,
                12
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            0,
                            0.2
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.47,
                            0.44
                          ],
                          [
                            0.26,
                            0.25
                          ],
                          [
                            0,
                            0.82
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.97,
                            0
                          ],
                          [
                            0,
                            -1.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0,
                            -0.2
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.43,
                            -0.41
                          ],
                          [
                            -0.3,
                            -0.3
                          ],
                          [
                            0,
                            -0.66
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.96,
                            0
                          ],
                          [
                            0,
                            1.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0.2
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.63
                          ],
                          [
                            -0.4,
                            -0.38
                          ],
                          [
                            -0.33,
                            -0.31
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.1
                          ],
                          [
                            0.96,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.2
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.52
                          ],
                          [
                            0.18,
                            0.17
                          ],
                          [
                            0.54,
                            0.53
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.17
                          ],
                          [
                            -0.98,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.59,
                            6.99
                          ],
                          [
                            1.89,
                            7.3
                          ],
                          [
                            2.18,
                            6.99
                          ],
                          [
                            2.18,
                            6.2
                          ],
                          [
                            1.58,
                            4.89
                          ],
                          [
                            0.72,
                            4.08
                          ],
                          [
                            0,
                            2.52
                          ],
                          [
                            0,
                            1.51
                          ],
                          [
                            1.89,
                            0
                          ],
                          [
                            3.76,
                            1.5
                          ],
                          [
                            3.76,
                            2.8
                          ],
                          [
                            2.18,
                            2.8
                          ],
                          [
                            2.18,
                            1.54
                          ],
                          [
                            1.89,
                            1.24
                          ],
                          [
                            1.59,
                            1.54
                          ],
                          [
                            1.59,
                            2.15
                          ],
                          [
                            2.19,
                            3.31
                          ],
                          [
                            3.06,
                            4.16
                          ],
                          [
                            3.79,
                            5.83
                          ],
                          [
                            3.79,
                            6.95
                          ],
                          [
                            1.89,
                            8.53
                          ],
                          [
                            0,
                            7.01
                          ],
                          [
                            0,
                            5.4
                          ],
                          [
                            1.59,
                            5.4
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "474",
    layers: [
      {
        ind: 473,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3,
                6
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                6,
                12
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0,
                            0.2
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            0,
                            -0.2
                          ]
                        ],
                        o: [
                          [
                            0,
                            0.2
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.2
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            2.56,
                            5.05
                          ],
                          [
                            2.27,
                            5.36
                          ],
                          [
                            1.97,
                            5.05
                          ],
                          [
                            1.97,
                            1.68
                          ],
                          [
                            2.27,
                            1.37
                          ],
                          [
                            2.56,
                            1.68
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0,
                            0.2
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.98,
                            0
                          ],
                          [
                            0,
                            1.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.53,
                            0
                          ],
                          [
                            0,
                            -0.73
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.55,
                            0
                          ],
                          [
                            -0.09,
                            0.14
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0.2
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.04
                          ],
                          [
                            0.98,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.15
                          ],
                          [
                            -0.51,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.76
                          ],
                          [
                            0.52,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            2.56,
                            7.4
                          ],
                          [
                            2.27,
                            7.71
                          ],
                          [
                            1.97,
                            7.4
                          ],
                          [
                            1.97,
                            6.86
                          ],
                          [
                            0.55,
                            6.86
                          ],
                          [
                            0.55,
                            7.23
                          ],
                          [
                            2.26,
                            8.74
                          ],
                          [
                            3.98,
                            7.23
                          ],
                          [
                            3.98,
                            0.23
                          ],
                          [
                            2.58,
                            0.23
                          ],
                          [
                            2.56,
                            0.7
                          ],
                          [
                            2.52,
                            0.7
                          ],
                          [
                            1.59,
                            0.15
                          ],
                          [
                            0.55,
                            1.27
                          ],
                          [
                            0.55,
                            5.26
                          ],
                          [
                            1.6,
                            6.47
                          ],
                          [
                            2.52,
                            5.98
                          ],
                          [
                            2.56,
                            5.98
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "479",
    layers: [
      {
        ind: 478,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                6,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -0.2
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.48,
                                0
                              ],
                              [
                                0,
                                -0.71
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.14,
                                0
                              ]
                            ],
                            o: [
                              [
                                -0.16,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.14,
                                -0.18
                              ],
                              [
                                0.55,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -0.16
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                2.3,
                                1.37
                              ],
                              [
                                2,
                                1.67
                              ],
                              [
                                2,
                                6.91
                              ],
                              [
                                0.58,
                                6.91
                              ],
                              [
                                0.58,
                                0.23
                              ],
                              [
                                1.97,
                                0.23
                              ],
                              [
                                2,
                                0.7
                              ],
                              [
                                2.03,
                                0.7
                              ],
                              [
                                2.98,
                                0.15
                              ],
                              [
                                4.01,
                                1.3
                              ],
                              [
                                4.01,
                                3.81
                              ],
                              [
                                2.59,
                                3.81
                              ],
                              [
                                2.59,
                                1.63
                              ],
                              [
                                2.29,
                                1.37
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0,
                            0.2,
                            0.4,
                            1
                          ]
                        },
                        r: 2,
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "484",
    layers: [
      {
        ind: 483,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                6,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0
                          ],
                          [
                            0,
                            0.2
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.88,
                            0
                          ],
                          [
                            0,
                            1.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.9,
                            0
                          ],
                          [
                            0,
                            -1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0.2
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.01
                          ],
                          [
                            -0.9,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.01
                          ],
                          [
                            0.92,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.98,
                            5.59
                          ],
                          [
                            2.28,
                            5.9
                          ],
                          [
                            2.57,
                            5.59
                          ],
                          [
                            2.57,
                            4.27
                          ],
                          [
                            3.99,
                            4.27
                          ],
                          [
                            3.99,
                            5.49
                          ],
                          [
                            2.27,
                            6.99
                          ],
                          [
                            0.57,
                            5.49
                          ],
                          [
                            0.57,
                            1.66
                          ],
                          [
                            2.27,
                            0.15
                          ],
                          [
                            3.99,
                            1.66
                          ],
                          [
                            3.99,
                            3.82
                          ],
                          [
                            1.98,
                            3.82
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0,
                            -0.2
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.2
                          ],
                          [
                            -0.15,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            2.57,
                            2.8
                          ],
                          [
                            2.57,
                            1.55
                          ],
                          [
                            2.28,
                            1.25
                          ],
                          [
                            1.98,
                            1.55
                          ],
                          [
                            1.98,
                            2.8
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "489",
    layers: [
      {
        ind: 488,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                6,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.2
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.47,
                            0
                          ],
                          [
                            0,
                            -0.71
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.14,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.15,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            -0.18
                          ],
                          [
                            0.55,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            2.25,
                            1.37
                          ],
                          [
                            1.95,
                            1.67
                          ],
                          [
                            1.95,
                            6.91
                          ],
                          [
                            0.53,
                            6.91
                          ],
                          [
                            0.53,
                            0.23
                          ],
                          [
                            1.92,
                            0.23
                          ],
                          [
                            1.95,
                            0.7
                          ],
                          [
                            1.98,
                            0.7
                          ],
                          [
                            2.93,
                            0.15
                          ],
                          [
                            3.96,
                            1.3
                          ],
                          [
                            3.96,
                            3.81
                          ],
                          [
                            2.54,
                            3.81
                          ],
                          [
                            2.54,
                            1.63
                          ],
                          [
                            2.24,
                            1.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "494",
    layers: [
      {
        ind: 493,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                6,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            0,
                            0.2
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.89,
                            0
                          ],
                          [
                            0,
                            1.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.9,
                            0
                          ],
                          [
                            0,
                            -1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0.2
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            1.01
                          ],
                          [
                            -0.89,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.01
                          ],
                          [
                            0.92,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.93,
                            5.59
                          ],
                          [
                            2.23,
                            5.9
                          ],
                          [
                            2.52,
                            5.59
                          ],
                          [
                            2.52,
                            4.27
                          ],
                          [
                            3.93,
                            4.27
                          ],
                          [
                            3.93,
                            5.49
                          ],
                          [
                            2.22,
                            6.99
                          ],
                          [
                            0.51,
                            5.49
                          ],
                          [
                            0.51,
                            1.66
                          ],
                          [
                            2.22,
                            0.15
                          ],
                          [
                            3.93,
                            1.66
                          ],
                          [
                            3.93,
                            3.82
                          ],
                          [
                            1.93,
                            3.82
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0,
                            -0.2
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.2
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            2.52,
                            2.8
                          ],
                          [
                            2.52,
                            1.55
                          ],
                          [
                            2.23,
                            1.25
                          ],
                          [
                            1.93,
                            1.55
                          ],
                          [
                            1.93,
                            2.8
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "499",
    layers: [
      {
        ind: 498,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3,
                6
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                6,
                12
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.52,
                            0
                          ],
                          [
                            0,
                            0.78
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.57,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.47,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.18
                          ],
                          [
                            0.6,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.75
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            2.84,
                            1.65
                          ],
                          [
                            1.94,
                            2.2
                          ],
                          [
                            1.91,
                            2.2
                          ],
                          [
                            1.91,
                            0.03
                          ],
                          [
                            0.49,
                            0.03
                          ],
                          [
                            0.49,
                            8.41
                          ],
                          [
                            1.89,
                            8.41
                          ],
                          [
                            1.91,
                            7.95
                          ],
                          [
                            1.94,
                            7.95
                          ],
                          [
                            2.83,
                            8.49
                          ],
                          [
                            3.92,
                            7.2
                          ],
                          [
                            3.92,
                            2.87
                          ],
                          [
                            2.84,
                            1.65
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0,
                            0.2
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            0,
                            -0.2
                          ]
                        ],
                        o: [
                          [
                            0,
                            0.2
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.2
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            2.5,
                            6.98
                          ],
                          [
                            2.2,
                            7.28
                          ],
                          [
                            1.91,
                            6.98
                          ],
                          [
                            1.91,
                            3.18
                          ],
                          [
                            2.2,
                            2.87
                          ],
                          [
                            2.5,
                            3.18
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "504",
    layers: [
      {
        ind: 503,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                4.5,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                9,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.51,
                                0
                              ],
                              [
                                -0.07,
                                -0.24
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.54,
                                0
                              ],
                              [
                                0,
                                -0.91
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.16,
                                0
                              ],
                              [
                                0,
                                -0.2
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.16,
                                0
                              ],
                              [
                                0,
                                -0.2
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.11,
                                -0.2
                              ],
                              [
                                0.53,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.11,
                                -0.24
                              ],
                              [
                                0.54,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -0.2
                              ],
                              [
                                -0.16,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -0.2
                              ],
                              [
                                -0.16,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                2.13,
                                6.91
                              ],
                              [
                                0.71,
                                6.91
                              ],
                              [
                                0.71,
                                0.23
                              ],
                              [
                                2.11,
                                0.23
                              ],
                              [
                                2.13,
                                0.7
                              ],
                              [
                                2.15,
                                0.7
                              ],
                              [
                                3.11,
                                0.15
                              ],
                              [
                                4.05,
                                0.8
                              ],
                              [
                                4.07,
                                0.8
                              ],
                              [
                                5.08,
                                0.15
                              ],
                              [
                                6.14,
                                1.43
                              ],
                              [
                                6.14,
                                6.91
                              ],
                              [
                                4.73,
                                6.91
                              ],
                              [
                                4.73,
                                1.67
                              ],
                              [
                                4.43,
                                1.36
                              ],
                              [
                                4.14,
                                1.67
                              ],
                              [
                                4.14,
                                6.91
                              ],
                              [
                                2.71,
                                6.91
                              ],
                              [
                                2.71,
                                1.67
                              ],
                              [
                                2.41,
                                1.37
                              ],
                              [
                                2.13,
                                1.67
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0,
                            0.2,
                            0.4,
                            1
                          ]
                        },
                        r: 2,
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "509",
    layers: [
      {
        ind: 508,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                6,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0.16,
                                0
                              ],
                              [
                                0,
                                0.2
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.55,
                                0
                              ],
                              [
                                -0.08,
                                0.14
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            o: [
                              [
                                0,
                                0.2
                              ],
                              [
                                -0.16,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.74
                              ],
                              [
                                0.55,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                2.7,
                                5.47
                              ],
                              [
                                2.4,
                                5.78
                              ],
                              [
                                2.11,
                                5.47
                              ],
                              [
                                2.11,
                                0.23
                              ],
                              [
                                0.69,
                                0.23
                              ],
                              [
                                0.69,
                                5.8
                              ],
                              [
                                1.75,
                                7
                              ],
                              [
                                2.68,
                                6.45
                              ],
                              [
                                2.71,
                                6.45
                              ],
                              [
                                2.74,
                                6.91
                              ],
                              [
                                4.11,
                                6.91
                              ],
                              [
                                4.11,
                                0.23
                              ],
                              [
                                2.7,
                                0.23
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0,
                            0.2,
                            0.4,
                            1
                          ]
                        },
                        r: 2,
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "514",
    layers: [
      {
        ind: 513,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3,
                6
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                6,
                12
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            0,
                            -0.2
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.45,
                            0
                          ],
                          [
                            0.09,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            -0.2
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.9
                          ],
                          [
                            -0.5,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.82,
                            3.24
                          ],
                          [
                            2.12,
                            2.93
                          ],
                          [
                            2.41,
                            3.24
                          ],
                          [
                            2.41,
                            8.41
                          ],
                          [
                            3.83,
                            8.41
                          ],
                          [
                            3.83,
                            2.87
                          ],
                          [
                            2.8,
                            1.65
                          ],
                          [
                            1.85,
                            2.2
                          ],
                          [
                            1.83,
                            2.2
                          ],
                          [
                            1.83,
                            0.03
                          ],
                          [
                            0.41,
                            0.03
                          ],
                          [
                            0.41,
                            8.41
                          ],
                          [
                            1.82,
                            8.41
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "519",
    layers: [
      {
        ind: 518,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                6,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0,
                            -0.2
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            0,
                            0.2
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.94,
                            0
                          ],
                          [
                            0,
                            1.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.9,
                            0
                          ],
                          [
                            0,
                            -0.99
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            -0.2
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.2
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.99
                          ],
                          [
                            -0.9,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1
                          ],
                          [
                            0.92,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            2.39,
                            1.55
                          ],
                          [
                            2.1,
                            1.25
                          ],
                          [
                            1.81,
                            1.55
                          ],
                          [
                            1.81,
                            5.59
                          ],
                          [
                            2.1,
                            5.9
                          ],
                          [
                            2.39,
                            5.59
                          ],
                          [
                            2.39,
                            4.27
                          ],
                          [
                            3.81,
                            4.27
                          ],
                          [
                            3.81,
                            5.49
                          ],
                          [
                            2.1,
                            6.99
                          ],
                          [
                            0.39,
                            5.49
                          ],
                          [
                            0.39,
                            1.66
                          ],
                          [
                            2.1,
                            0.15
                          ],
                          [
                            3.81,
                            1.66
                          ],
                          [
                            3.81,
                            2.75
                          ],
                          [
                            2.39,
                            2.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "524",
    layers: [
      {
        ind: 523,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                1.5,
                6
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                3,
                12
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.43,
                            0.03
                          ],
                          [
                            1.84,
                            0.03
                          ],
                          [
                            1.84,
                            8.41
                          ],
                          [
                            0.43,
                            8.41
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "527",
    layers: [
      {
        ind: 471,
        ty: 0,
        parent: 467,
        ks: {},
        w: 6,
        h: 12,
        ip: 0,
        op: 565,
        st: 0,
        refId: "469"
      },
      {
        ind: 467,
        ty: 3,
        parent: 466,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 476,
        ty: 0,
        parent: 472,
        ks: {},
        w: 6,
        h: 12,
        ip: 0,
        op: 565,
        st: 0,
        refId: "474"
      },
      {
        ind: 472,
        ty: 3,
        parent: 466,
        ks: {
          p: {
            a: 0,
            k: [
              45,
              2
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 481,
        ty: 0,
        parent: 477,
        ks: {},
        w: 6,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "479"
      },
      {
        ind: 477,
        ty: 3,
        parent: 466,
        ks: {
          p: {
            a: 0,
            k: [
              55,
              2
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 486,
        ty: 0,
        parent: 482,
        ks: {},
        w: 6,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "484"
      },
      {
        ind: 482,
        ty: 3,
        parent: 466,
        ks: {
          p: {
            a: 0,
            k: [
              50,
              2
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 491,
        ty: 0,
        parent: 487,
        ks: {},
        w: 6,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "489"
      },
      {
        ind: 487,
        ty: 3,
        parent: 466,
        ks: {
          p: {
            a: 0,
            k: [
              40,
              2
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 496,
        ty: 0,
        parent: 492,
        ks: {},
        w: 6,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "494"
      },
      {
        ind: 492,
        ty: 3,
        parent: 466,
        ks: {
          p: {
            a: 0,
            k: [
              35,
              2
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 501,
        ty: 0,
        parent: 497,
        ks: {},
        w: 6,
        h: 12,
        ip: 0,
        op: 565,
        st: 0,
        refId: "499"
      },
      {
        ind: 497,
        ty: 3,
        parent: 466,
        ks: {
          p: {
            a: 0,
            k: [
              30,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 506,
        ty: 0,
        parent: 502,
        ks: {},
        w: 9,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "504"
      },
      {
        ind: 502,
        ty: 3,
        parent: 466,
        ks: {
          p: {
            a: 0,
            k: [
              22,
              2
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 511,
        ty: 0,
        parent: 507,
        ks: {},
        w: 6,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "509"
      },
      {
        ind: 507,
        ty: 3,
        parent: 466,
        ks: {
          p: {
            a: 0,
            k: [
              17,
              2
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 516,
        ty: 0,
        parent: 512,
        ks: {},
        w: 6,
        h: 12,
        ip: 0,
        op: 565,
        st: 0,
        refId: "514"
      },
      {
        ind: 512,
        ty: 3,
        parent: 466,
        ks: {
          p: {
            a: 0,
            k: [
              10,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 521,
        ty: 0,
        parent: 517,
        ks: {},
        w: 6,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "519"
      },
      {
        ind: 517,
        ty: 3,
        parent: 466,
        ks: {
          p: {
            a: 0,
            k: [
              5,
              2
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 526,
        ty: 0,
        parent: 522,
        ks: {},
        w: 3,
        h: 12,
        ip: 0,
        op: 565,
        st: 0,
        refId: "524"
      },
      {
        ind: 522,
        ty: 3,
        parent: 466,
        ks: {
          p: {
            a: 0,
            k: [
              15,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 466,
        ty: 3,
        parent: 465,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 465,
        ty: 3,
        parent: 464,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 464,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0.037,
              0.046
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "557",
    layers: [
      {
        ind: 556,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                13.5,
                6.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                27,
                13
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.12,
                                0
                              ],
                              [
                                0.09,
                                0.09
                              ],
                              [
                                0,
                                0.12
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.09,
                                0.09
                              ],
                              [
                                0,
                                0.12
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.12
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.02,
                                -0.06
                              ],
                              [
                                0,
                                -0.06
                              ],
                              [
                                0.02,
                                -0.05
                              ],
                              [
                                0.04,
                                -0.04
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                -0.12
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                -0.12
                              ],
                              [
                                0.09,
                                -0.09
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                -0.12
                              ],
                              [
                                0.09,
                                -0.09
                              ],
                              [
                                0.12,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                0.04
                              ],
                              [
                                0.02,
                                0.05
                              ],
                              [
                                0,
                                0.06
                              ],
                              [
                                -0.02,
                                0.06
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                19.51,
                                4.9
                              ],
                              [
                                15.39,
                                9.03
                              ],
                              [
                                15.07,
                                9.16
                              ],
                              [
                                14.74,
                                9.03
                              ],
                              [
                                14.61,
                                8.7
                              ],
                              [
                                14.74,
                                8.38
                              ],
                              [
                                18.09,
                                5.04
                              ],
                              [
                                0.46,
                                5.04
                              ],
                              [
                                0.13,
                                4.9
                              ],
                              [
                                0,
                                4.58
                              ],
                              [
                                0.13,
                                4.26
                              ],
                              [
                                0.46,
                                4.12
                              ],
                              [
                                18.09,
                                4.12
                              ],
                              [
                                14.74,
                                0.78
                              ],
                              [
                                14.61,
                                0.46
                              ],
                              [
                                14.74,
                                0.13
                              ],
                              [
                                15.07,
                                0
                              ],
                              [
                                15.39,
                                0.13
                              ],
                              [
                                19.51,
                                4.26
                              ],
                              [
                                19.61,
                                4.41
                              ],
                              [
                                19.65,
                                4.58
                              ],
                              [
                                19.61,
                                4.75
                              ],
                              [
                                19.51,
                                4.9
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0.57,
                            0.63,
                            0.72,
                            1
                          ]
                        },
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "590",
    layers: [
      {
        ind: 589,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                40.5,
                7.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                81,
                15
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.34,
                            -0.11
                          ],
                          [
                            -0.19,
                            -0.27
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            0.41,
                            -0.31
                          ],
                          [
                            0.67,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.46,
                            0
                          ],
                          [
                            0.34,
                            0.11
                          ],
                          [
                            0.19,
                            0.26
                          ],
                          [
                            0,
                            0.63
                          ],
                          [
                            -0.41,
                            0.31
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.83,
                            9
                          ],
                          [
                            0.83,
                            2.93
                          ],
                          [
                            2.56,
                            2.93
                          ],
                          [
                            3.76,
                            3.09
                          ],
                          [
                            4.55,
                            3.66
                          ],
                          [
                            4.84,
                            4.71
                          ],
                          [
                            4.22,
                            6.13
                          ],
                          [
                            2.6,
                            6.59
                          ],
                          [
                            1.6,
                            6.59
                          ],
                          [
                            1.6,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.25,
                            0.2
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            0.27,
                            0.16
                          ],
                          [
                            0.53,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0.53,
                            0
                          ],
                          [
                            0.26,
                            -0.2
                          ],
                          [
                            0,
                            -0.44
                          ],
                          [
                            -0.26,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.6,
                            5.96
                          ],
                          [
                            2.51,
                            5.96
                          ],
                          [
                            3.68,
                            5.67
                          ],
                          [
                            4.07,
                            4.71
                          ],
                          [
                            3.66,
                            3.81
                          ],
                          [
                            2.47,
                            3.55
                          ],
                          [
                            1.6,
                            3.55
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.16
                          ],
                          [
                            -0.25,
                            0
                          ],
                          [
                            -0.14,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0.01
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.15,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.29
                          ],
                          [
                            0.22,
                            -0.17
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.06,
                            -0.01
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            6,
                            9
                          ],
                          [
                            6,
                            4.5
                          ],
                          [
                            6.63,
                            4.5
                          ],
                          [
                            6.7,
                            5.32
                          ],
                          [
                            6.72,
                            5.32
                          ],
                          [
                            7.29,
                            4.64
                          ],
                          [
                            8,
                            4.39
                          ],
                          [
                            8.48,
                            4.48
                          ],
                          [
                            8.34,
                            5.15
                          ],
                          [
                            8.13,
                            5.09
                          ],
                          [
                            7.9,
                            5.07
                          ],
                          [
                            7.3,
                            5.3
                          ],
                          [
                            6.76,
                            6.11
                          ],
                          [
                            6.76,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.33,
                            0.19
                          ],
                          [
                            0.19,
                            0.35
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.19,
                            0.35
                          ],
                          [
                            -0.31,
                            0.19
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.31,
                            -0.38
                          ],
                          [
                            0,
                            -0.64
                          ],
                          [
                            0,
                            -0.08
                          ],
                          [
                            0.01,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.26,
                            -0.29
                          ],
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.18,
                            0.06
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.09
                          ],
                          [
                            0.31,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.4,
                            0
                          ],
                          [
                            -0.32,
                            -0.19
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.31,
                            -0.19
                          ],
                          [
                            0.57,
                            0
                          ],
                          [
                            0.32,
                            0.38
                          ],
                          [
                            0,
                            0.08
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.47
                          ],
                          [
                            0.27,
                            0.29
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.13
                          ],
                          [
                            -0.24,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            10.95,
                            9.11
                          ],
                          [
                            9.85,
                            8.83
                          ],
                          [
                            9.07,
                            8.02
                          ],
                          [
                            8.79,
                            6.76
                          ],
                          [
                            9.07,
                            5.49
                          ],
                          [
                            9.84,
                            4.68
                          ],
                          [
                            10.8,
                            4.39
                          ],
                          [
                            12.13,
                            4.96
                          ],
                          [
                            12.6,
                            6.5
                          ],
                          [
                            12.59,
                            6.74
                          ],
                          [
                            12.57,
                            6.94
                          ],
                          [
                            9.54,
                            6.94
                          ],
                          [
                            9.98,
                            8.07
                          ],
                          [
                            11.04,
                            8.5
                          ],
                          [
                            11.63,
                            8.41
                          ],
                          [
                            12.16,
                            8.15
                          ],
                          [
                            12.43,
                            8.65
                          ],
                          [
                            11.77,
                            8.97
                          ],
                          [
                            10.95,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.23
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.25,
                            -0.25
                          ],
                          [
                            0.05,
                            -0.45
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.46
                          ],
                          [
                            -0.19,
                            -0.24
                          ],
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            0.24
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.53,
                            6.39
                          ],
                          [
                            11.93,
                            6.39
                          ],
                          [
                            11.64,
                            5.35
                          ],
                          [
                            10.82,
                            4.99
                          ],
                          [
                            9.97,
                            5.36
                          ],
                          [
                            9.53,
                            6.39
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.36,
                            0.16
                          ],
                          [
                            0.27,
                            0.27
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.29,
                            -0.14
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.22,
                            0.18
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            0.09,
                            0.12
                          ],
                          [
                            0.16,
                            0.09
                          ],
                          [
                            0.19,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            0.13
                          ],
                          [
                            0.13,
                            0.2
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            -0.16,
                            0.24
                          ],
                          [
                            -0.29,
                            0.14
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.31,
                            -0.14
                          ],
                          [
                            -0.21,
                            -0.22
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0.1
                          ],
                          [
                            0.29,
                            0
                          ],
                          [
                            0.21,
                            -0.16
                          ],
                          [
                            0,
                            -0.27
                          ],
                          [
                            -0.1,
                            -0.13
                          ],
                          [
                            -0.16,
                            -0.08
                          ],
                          [
                            -0.16,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            -0.14
                          ],
                          [
                            -0.11,
                            -0.2
                          ],
                          [
                            0,
                            -0.3
                          ],
                          [
                            0.17,
                            -0.27
                          ],
                          [
                            0.31,
                            -0.15
                          ],
                          [
                            0.43,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.36,
                            -0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            0.23
                          ],
                          [
                            0.3,
                            0.14
                          ],
                          [
                            0.4,
                            0
                          ],
                          [
                            0.22,
                            -0.19
                          ],
                          [
                            0,
                            -0.21
                          ],
                          [
                            -0.09,
                            -0.12
                          ],
                          [
                            -0.14,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            -0.08
                          ],
                          [
                            -0.18,
                            -0.13
                          ],
                          [
                            -0.12,
                            -0.2
                          ],
                          [
                            0,
                            -0.31
                          ],
                          [
                            0.16,
                            -0.25
                          ],
                          [
                            0.29,
                            -0.14
                          ],
                          [
                            0.37,
                            0
                          ],
                          [
                            0.31,
                            0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            -0.18
                          ],
                          [
                            -0.22,
                            -0.11
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0.19
                          ],
                          [
                            0.11,
                            0.12
                          ],
                          [
                            0.15,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0.1
                          ],
                          [
                            0.19,
                            0.14
                          ],
                          [
                            0.11,
                            0.2
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            -0.17,
                            0.26
                          ],
                          [
                            -0.31,
                            0.16
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.32,
                            9.11
                          ],
                          [
                            16.14,
                            8.87
                          ],
                          [
                            15.2,
                            8.21
                          ],
                          [
                            15.66,
                            7.68
                          ],
                          [
                            16.42,
                            8.23
                          ],
                          [
                            17.34,
                            8.43
                          ],
                          [
                            18.27,
                            8.17
                          ],
                          [
                            18.6,
                            7.45
                          ],
                          [
                            18.46,
                            6.95
                          ],
                          [
                            18.1,
                            6.63
                          ],
                          [
                            17.59,
                            6.37
                          ],
                          [
                            16.72,
                            5.99
                          ],
                          [
                            16.15,
                            5.68
                          ],
                          [
                            15.68,
                            5.18
                          ],
                          [
                            15.49,
                            4.43
                          ],
                          [
                            15.73,
                            3.6
                          ],
                          [
                            16.42,
                            3.03
                          ],
                          [
                            17.4,
                            2.82
                          ],
                          [
                            18.41,
                            3.03
                          ],
                          [
                            19.2,
                            3.57
                          ],
                          [
                            18.78,
                            4.07
                          ],
                          [
                            18.16,
                            3.65
                          ],
                          [
                            17.4,
                            3.49
                          ],
                          [
                            16.57,
                            3.73
                          ],
                          [
                            16.27,
                            4.38
                          ],
                          [
                            16.42,
                            4.86
                          ],
                          [
                            16.81,
                            5.17
                          ],
                          [
                            17.28,
                            5.39
                          ],
                          [
                            18.14,
                            5.76
                          ],
                          [
                            18.77,
                            6.12
                          ],
                          [
                            19.22,
                            6.63
                          ],
                          [
                            19.39,
                            7.38
                          ],
                          [
                            19.14,
                            8.26
                          ],
                          [
                            18.43,
                            8.88
                          ],
                          [
                            17.32,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.32,
                            0.19
                          ],
                          [
                            0.18,
                            0.35
                          ],
                          [
                            0,
                            0.5
                          ],
                          [
                            -0.2,
                            0.35
                          ],
                          [
                            -0.32,
                            0.18
                          ],
                          [
                            -0.38,
                            0
                          ],
                          [
                            -0.21,
                            -0.11
                          ],
                          [
                            -0.16,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.07
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.13,
                            -0.27
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            -0.25,
                            -0.32
                          ],
                          [
                            -0.41,
                            0
                          ],
                          [
                            -0.18,
                            0.09
                          ],
                          [
                            -0.14,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.11
                          ],
                          [
                            0.27,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.39,
                            0
                          ],
                          [
                            -0.32,
                            -0.18
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.5
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.34,
                            -0.18
                          ],
                          [
                            0.3,
                            0
                          ],
                          [
                            0.21,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            -0.12
                          ],
                          [
                            -0.14,
                            -0.07
                          ],
                          [
                            -0.27,
                            0
                          ],
                          [
                            -0.21,
                            0.14
                          ],
                          [
                            -0.12,
                            0.26
                          ],
                          [
                            0,
                            0.52
                          ],
                          [
                            0.26,
                            0.32
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0.18,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.18
                          ],
                          [
                            -0.25,
                            0.1
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            22.29,
                            9.11
                          ],
                          [
                            21.21,
                            8.83
                          ],
                          [
                            20.46,
                            8.03
                          ],
                          [
                            20.18,
                            6.76
                          ],
                          [
                            20.48,
                            5.47
                          ],
                          [
                            21.27,
                            4.67
                          ],
                          [
                            22.34,
                            4.39
                          ],
                          [
                            23.11,
                            4.55
                          ],
                          [
                            23.66,
                            4.92
                          ],
                          [
                            23.27,
                            5.42
                          ],
                          [
                            22.86,
                            5.13
                          ],
                          [
                            22.37,
                            5.02
                          ],
                          [
                            21.64,
                            5.24
                          ],
                          [
                            21.14,
                            5.85
                          ],
                          [
                            20.96,
                            6.76
                          ],
                          [
                            21.34,
                            8.01
                          ],
                          [
                            22.36,
                            8.48
                          ],
                          [
                            22.94,
                            8.35
                          ],
                          [
                            23.41,
                            8.03
                          ],
                          [
                            23.74,
                            8.54
                          ],
                          [
                            23.07,
                            8.96
                          ],
                          [
                            22.29,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.22
                          ],
                          [
                            0,
                            0.4
                          ],
                          [
                            -0.44,
                            0.26
                          ],
                          [
                            -0.96,
                            0.11
                          ],
                          [
                            0.05,
                            0.18
                          ],
                          [
                            0.14,
                            0.1
                          ],
                          [
                            0.25,
                            0
                          ],
                          [
                            0.23,
                            -0.1
                          ],
                          [
                            0.18,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.3,
                            0.12
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.25,
                            -0.34
                          ],
                          [
                            0,
                            -0.56
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.13
                          ],
                          [
                            0.29,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.37,
                            0
                          ],
                          [
                            -0.25,
                            -0.23
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.45,
                            -0.27
                          ],
                          [
                            0,
                            -0.19
                          ],
                          [
                            -0.05,
                            -0.17
                          ],
                          [
                            -0.13,
                            -0.11
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.23,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            -0.14
                          ],
                          [
                            0.31,
                            -0.13
                          ],
                          [
                            0.55,
                            0
                          ],
                          [
                            0.25,
                            0.33
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            0.17
                          ],
                          [
                            -0.25,
                            0.13
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.68,
                            9.11
                          ],
                          [
                            24.73,
                            8.78
                          ],
                          [
                            24.37,
                            7.83
                          ],
                          [
                            25.02,
                            6.7
                          ],
                          [
                            27.13,
                            6.15
                          ],
                          [
                            27.04,
                            5.6
                          ],
                          [
                            26.76,
                            5.19
                          ],
                          [
                            26.2,
                            5.02
                          ],
                          [
                            25.47,
                            5.17
                          ],
                          [
                            24.86,
                            5.5
                          ],
                          [
                            24.56,
                            4.97
                          ],
                          [
                            25.33,
                            4.59
                          ],
                          [
                            26.33,
                            4.39
                          ],
                          [
                            27.52,
                            4.9
                          ],
                          [
                            27.89,
                            6.24
                          ],
                          [
                            27.89,
                            9
                          ],
                          [
                            27.26,
                            9
                          ],
                          [
                            27.2,
                            8.46
                          ],
                          [
                            27.17,
                            8.46
                          ],
                          [
                            26.48,
                            8.92
                          ],
                          [
                            25.68,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.11
                          ],
                          [
                            -0.21,
                            0.19
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.3,
                            -0.19
                          ],
                          [
                            0,
                            -0.29
                          ],
                          [
                            -0.15,
                            -0.12
                          ],
                          [
                            -0.22,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.21,
                            0
                          ],
                          [
                            0.19,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.75,
                            0.09
                          ],
                          [
                            -0.3,
                            0.18
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.9,
                            8.5
                          ],
                          [
                            26.51,
                            8.34
                          ],
                          [
                            27.13,
                            7.9
                          ],
                          [
                            27.13,
                            6.65
                          ],
                          [
                            25.55,
                            7.07
                          ],
                          [
                            25.11,
                            7.78
                          ],
                          [
                            25.34,
                            8.33
                          ],
                          [
                            25.9,
                            8.5
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0.17
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.05
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            -0.01
                          ],
                          [
                            0.11,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.12,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.12
                          ],
                          [
                            0.04,
                            0.05
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0.03,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.03
                          ],
                          [
                            -0.07,
                            0.01
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            30.11,
                            9.11
                          ],
                          [
                            29.49,
                            8.85
                          ],
                          [
                            29.31,
                            8.09
                          ],
                          [
                            29.31,
                            2.41
                          ],
                          [
                            30.07,
                            2.41
                          ],
                          [
                            30.07,
                            8.15
                          ],
                          [
                            30.13,
                            8.41
                          ],
                          [
                            30.28,
                            8.48
                          ],
                          [
                            30.34,
                            8.48
                          ],
                          [
                            30.45,
                            8.46
                          ],
                          [
                            30.55,
                            9.04
                          ],
                          [
                            30.37,
                            9.09
                          ],
                          [
                            30.11,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.33,
                            0.19
                          ],
                          [
                            0.19,
                            0.35
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.19,
                            0.35
                          ],
                          [
                            -0.31,
                            0.19
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.31,
                            -0.38
                          ],
                          [
                            0,
                            -0.64
                          ],
                          [
                            0,
                            -0.08
                          ],
                          [
                            0.01,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.27,
                            -0.29
                          ],
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.18,
                            0.06
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.09
                          ],
                          [
                            0.31,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.4,
                            0
                          ],
                          [
                            -0.33,
                            -0.19
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.31,
                            -0.19
                          ],
                          [
                            0.57,
                            0
                          ],
                          [
                            0.32,
                            0.38
                          ],
                          [
                            0,
                            0.08
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.47
                          ],
                          [
                            0.27,
                            0.29
                          ],
                          [
                            0.22,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.13
                          ],
                          [
                            -0.24,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            33.49,
                            9.11
                          ],
                          [
                            32.4,
                            8.83
                          ],
                          [
                            31.62,
                            8.02
                          ],
                          [
                            31.34,
                            6.76
                          ],
                          [
                            31.62,
                            5.49
                          ],
                          [
                            32.38,
                            4.68
                          ],
                          [
                            33.35,
                            4.39
                          ],
                          [
                            34.68,
                            4.96
                          ],
                          [
                            35.15,
                            6.5
                          ],
                          [
                            35.14,
                            6.74
                          ],
                          [
                            35.12,
                            6.94
                          ],
                          [
                            32.09,
                            6.94
                          ],
                          [
                            32.53,
                            8.07
                          ],
                          [
                            33.58,
                            8.5
                          ],
                          [
                            34.18,
                            8.41
                          ],
                          [
                            34.7,
                            8.15
                          ],
                          [
                            34.97,
                            8.65
                          ],
                          [
                            34.32,
                            8.97
                          ],
                          [
                            33.49,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.23
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.25,
                            -0.25
                          ],
                          [
                            0.05,
                            -0.45
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.46
                          ],
                          [
                            -0.19,
                            -0.24
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.25,
                            0.24
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            32.07,
                            6.39
                          ],
                          [
                            34.48,
                            6.39
                          ],
                          [
                            34.19,
                            5.35
                          ],
                          [
                            33.37,
                            4.99
                          ],
                          [
                            32.52,
                            5.36
                          ],
                          [
                            32.07,
                            6.39
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.16
                          ],
                          [
                            -0.25,
                            0
                          ],
                          [
                            -0.14,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0.01
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.15,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.29
                          ],
                          [
                            0.22,
                            -0.17
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.06,
                            -0.01
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            36.26,
                            9
                          ],
                          [
                            36.26,
                            4.5
                          ],
                          [
                            36.89,
                            4.5
                          ],
                          [
                            36.95,
                            5.32
                          ],
                          [
                            36.98,
                            5.32
                          ],
                          [
                            37.55,
                            4.64
                          ],
                          [
                            38.26,
                            4.39
                          ],
                          [
                            38.74,
                            4.48
                          ],
                          [
                            38.59,
                            5.15
                          ],
                          [
                            38.39,
                            5.09
                          ],
                          [
                            38.16,
                            5.07
                          ],
                          [
                            37.55,
                            5.3
                          ],
                          [
                            37.02,
                            6.11
                          ],
                          [
                            37.02,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.49,
                        0.55,
                        0.65,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "616",
    layers: [
      {
        ind: 615,
        ty: 2,
        parent: 614,
        ks: {
          s: {
            a: 0,
            k: [
              157.14,
              162.5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "0"
      },
      {
        ind: 614,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "619",
    layers: [
      {
        ind: 618,
        ty: 0,
        parent: 613,
        ks: {},
        w: 11,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "616"
      },
      {
        ind: 613,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "670",
    layers: [
      {
        ind: 669,
        ty: 2,
        parent: 668,
        ks: {
          s: {
            a: 0,
            k: [
              162.5,
              160
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "1"
      },
      {
        ind: 668,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "673",
    layers: [
      {
        ind: 672,
        ty: 0,
        parent: 667,
        ks: {},
        w: 13,
        h: 12,
        ip: 0,
        op: 565,
        st: 0,
        refId: "670"
      },
      {
        ind: 667,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "721",
    layers: [
      {
        ind: 720,
        ty: 2,
        parent: 719,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        refId: "4"
      },
      {
        ind: 719,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "724",
    layers: [
      {
        ind: 723,
        ty: 0,
        parent: 718,
        ks: {},
        w: 19,
        h: 21.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "721"
      },
      {
        ind: 718,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "735",
    layers: [
      {
        ind: 734,
        ty: 2,
        parent: 733,
        ks: {
          s: {
            a: 0,
            k: [
              166.3,
              166.3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "5"
      },
      {
        ind: 733,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "738",
    layers: [
      {
        ind: 737,
        ty: 0,
        parent: 732,
        ks: {},
        w: 76.5,
        h: 76.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "735"
      },
      {
        ind: 732,
        ty: 3,
        parent: 731,
        ks: {
          p: {
            a: 0,
            k: [
              -7,
              -4
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 731,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              7,
              5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "742",
    layers: [
      {
        ind: 741,
        ty: 4,
        td: 1,
        parent: 730,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                31.739,
                31.739
              ]
            },
            r: {
              a: 0,
              k: 31
            },
            s: {
              a: 0,
              k: [
                63.478,
                63.478
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 740,
        ty: 0,
        tt: 1,
        parent: 730,
        ks: {
          a: {
            a: 0,
            k: [
              7,
              5
            ]
          }
        },
        w: 84,
        h: 82,
        ip: 0,
        op: 565,
        st: 0,
        refId: "738"
      },
      {
        ind: 730,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              7.053,
              7.053
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "747",
    layers: [
      {
        ind: 401,
        ty: 4,
        parent: 400,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 400,
        ty: 3,
        parent: 399,
        ks: {
          p: {
            a: 0,
            k: [
              28.394,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 403,
        ty: 4,
        parent: 402,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 402,
        ty: 3,
        parent: 399,
        ks: {
          p: {
            a: 0,
            k: [
              22.138,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 405,
        ty: 4,
        parent: 404,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ],
                  [
                    1.2,
                    11.3
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    10.1
                  ],
                  [
                    2.4,
                    10.5
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.7,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    3,
                    11.6
                  ],
                  [
                    2.7,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 404,
        ty: 3,
        parent: 399,
        ks: {
          p: {
            a: 0,
            k: [
              18.794,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 407,
        ty: 4,
        parent: 406,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 406,
        ty: 3,
        parent: 399,
        ks: {
          p: {
            a: 0,
            k: [
              12.426,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 409,
        ty: 4,
        parent: 408,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.9,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.8
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    4.6,
                    5.6
                  ],
                  [
                    5.3,
                    6.1
                  ],
                  [
                    5.3,
                    6.1
                  ],
                  [
                    4.6,
                    7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    2.4,
                    7.1
                  ],
                  [
                    2,
                    8.6
                  ],
                  [
                    2,
                    8.6
                  ],
                  [
                    2.4,
                    10
                  ],
                  [
                    3.6,
                    10.6
                  ],
                  [
                    3.6,
                    10.6
                  ],
                  [
                    4.3,
                    10.4
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    5.4,
                    11
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 408,
        ty: 3,
        parent: 399,
        ks: {
          p: {
            a: 0,
            k: [
              6.725,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 411,
        ty: 4,
        parent: 410,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    1.3,
                    9.6
                  ],
                  [
                    2.3,
                    10.2
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    4.5,
                    10.2
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.5,
                    8.7
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    2.5,
                    7.8
                  ],
                  [
                    1.7,
                    7.3
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    1.2,
                    4.5
                  ],
                  [
                    2.1,
                    3.7
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    4.9,
                    3.6
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    5.3,
                    5.3
                  ],
                  [
                    4.5,
                    4.8
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.5,
                    6.1
                  ],
                  [
                    2.9,
                    6.4
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    4.7,
                    7.2
                  ],
                  [
                    5.8,
                    8
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    5.9,
                    10.5
                  ],
                  [
                    4.9,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 410,
        ty: 3,
        parent: 399,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 399,
        ty: 3,
        parent: 398,
        ks: {
          p: {
            a: 0,
            k: [
              122.02,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 414,
        ty: 4,
        parent: 413,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 413,
        ty: 3,
        parent: 412,
        ks: {
          p: {
            a: 0,
            k: [
              20.548,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 416,
        ty: 4,
        parent: 415,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 415,
        ty: 3,
        parent: 412,
        ks: {
          p: {
            a: 0,
            k: [
              14.292,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 418,
        ty: 4,
        parent: 417,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.6,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.3,
                    6.7
                  ],
                  [
                    0.3,
                    5.6
                  ],
                  [
                    1.1,
                    5.5
                  ],
                  [
                    1.1,
                    4.9
                  ],
                  [
                    1.6,
                    3.3
                  ],
                  [
                    3.2,
                    2.7
                  ],
                  [
                    3.2,
                    2.7
                  ],
                  [
                    3.8,
                    2.8
                  ],
                  [
                    4.3,
                    2.9
                  ],
                  [
                    4.3,
                    2.9
                  ],
                  [
                    4,
                    4
                  ],
                  [
                    3.3,
                    3.8
                  ],
                  [
                    3.3,
                    3.8
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.6,
                    5.5
                  ],
                  [
                    3.8,
                    5.5
                  ],
                  [
                    3.8,
                    6.7
                  ],
                  [
                    2.6,
                    6.7
                  ],
                  [
                    2.6,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    6.9,
                    11.7
                  ],
                  [
                    6.9,
                    11.7
                  ],
                  [
                    5.5,
                    11.1
                  ],
                  [
                    5,
                    9.5
                  ],
                  [
                    5,
                    9.5
                  ],
                  [
                    5,
                    6.7
                  ],
                  [
                    4.2,
                    6.7
                  ],
                  [
                    4.2,
                    5.6
                  ],
                  [
                    5.1,
                    5.5
                  ],
                  [
                    5.3,
                    3.9
                  ],
                  [
                    6.5,
                    3.9
                  ],
                  [
                    6.5,
                    5.5
                  ],
                  [
                    8,
                    5.5
                  ],
                  [
                    8,
                    6.7
                  ],
                  [
                    6.5,
                    6.7
                  ],
                  [
                    6.5,
                    9.5
                  ],
                  [
                    7.3,
                    10.6
                  ],
                  [
                    7.3,
                    10.6
                  ],
                  [
                    7.6,
                    10.6
                  ],
                  [
                    7.9,
                    10.5
                  ],
                  [
                    7.9,
                    10.5
                  ],
                  [
                    8.2,
                    11.5
                  ],
                  [
                    7.6,
                    11.7
                  ],
                  [
                    6.9,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 417,
        ty: 3,
        parent: 412,
        ks: {
          p: {
            a: 0,
            k: [
              6.367,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 420,
        ty: 4,
        parent: 419,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 419,
        ty: 3,
        parent: 412,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 412,
        ty: 3,
        parent: 398,
        ks: {
          p: {
            a: 0,
            k: [
              94.401,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 423,
        ty: 4,
        parent: 422,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 422,
        ty: 3,
        parent: 421,
        ks: {
          p: {
            a: 0,
            k: [
              17.856,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 425,
        ty: 4,
        parent: 424,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    6.1,
                    5.5
                  ],
                  [
                    4.1,
                    8
                  ],
                  [
                    6.3,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    3.2,
                    9
                  ],
                  [
                    2.3,
                    10
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 424,
        ty: 3,
        parent: 421,
        ks: {
          p: {
            a: 0,
            k: [
              11.414,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 427,
        ty: 4,
        parent: 426,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.3,
                    5.5
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    1.6,
                    4.5
                  ],
                  [
                    1.6,
                    4.5
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.8,
                    3.7
                  ],
                  [
                    0.8,
                    3.7
                  ],
                  [
                    1,
                    3.1
                  ],
                  [
                    1.6,
                    2.8
                  ],
                  [
                    1.6,
                    2.8
                  ],
                  [
                    2.2,
                    3.1
                  ],
                  [
                    2.5,
                    3.7
                  ],
                  [
                    2.5,
                    3.7
                  ],
                  [
                    2.2,
                    4.2
                  ],
                  [
                    1.6,
                    4.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 426,
        ty: 3,
        parent: 421,
        ks: {
          p: {
            a: 0,
            k: [
              8.181,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 429,
        ty: 4,
        parent: 428,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.5,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    3.5
                  ],
                  [
                    2.5,
                    3.5
                  ],
                  [
                    2.5,
                    6.8
                  ],
                  [
                    5.7,
                    6.8
                  ],
                  [
                    5.7,
                    3.5
                  ],
                  [
                    7.2,
                    3.5
                  ],
                  [
                    7.2,
                    11.6
                  ],
                  [
                    5.7,
                    11.6
                  ],
                  [
                    5.7,
                    8
                  ],
                  [
                    2.5,
                    8
                  ],
                  [
                    2.5,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 428,
        ty: 3,
        parent: 421,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 421,
        ty: 3,
        parent: 398,
        ks: {
          p: {
            a: 0,
            k: [
              67.821,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 432,
        ty: 4,
        parent: 431,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.7,
                    0
                  ]
                ],
                v: [
                  [
                    1.3,
                    14.1
                  ],
                  [
                    1.3,
                    14.1
                  ],
                  [
                    0.9,
                    14
                  ],
                  [
                    0.5,
                    14
                  ],
                  [
                    0.5,
                    14
                  ],
                  [
                    0.8,
                    12.8
                  ],
                  [
                    1,
                    12.9
                  ],
                  [
                    1.2,
                    12.9
                  ],
                  [
                    1.2,
                    12.9
                  ],
                  [
                    2,
                    12.6
                  ],
                  [
                    2.4,
                    11.9
                  ],
                  [
                    2.4,
                    11.9
                  ],
                  [
                    2.5,
                    11.5
                  ],
                  [
                    0.1,
                    5.5
                  ],
                  [
                    1.6,
                    5.5
                  ],
                  [
                    2.6,
                    8.5
                  ],
                  [
                    2.9,
                    9.3
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.4,
                    9.3
                  ],
                  [
                    3.7,
                    8.5
                  ],
                  [
                    3.7,
                    8.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    6,
                    5.5
                  ],
                  [
                    3.8,
                    11.9
                  ],
                  [
                    2.8,
                    13.5
                  ],
                  [
                    1.3,
                    14.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.7
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 431,
        ty: 3,
        parent: 430,
        ks: {
          p: {
            a: 0,
            k: [
              27.407,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 434,
        ty: 4,
        parent: 433,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 433,
        ty: 3,
        parent: 430,
        ks: {
          p: {
            a: 0,
            k: [
              22.804,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 436,
        ty: 4,
        parent: 435,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 435,
        ty: 3,
        parent: 430,
        ks: {
          p: {
            a: 0,
            k: [
              16.437,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 438,
        ty: 4,
        parent: 437,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ],
                  [
                    1.2,
                    11.3
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    10.1
                  ],
                  [
                    2.4,
                    10.5
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.7,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    3,
                    11.6
                  ],
                  [
                    2.7,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 437,
        ty: 3,
        parent: 430,
        ks: {
          p: {
            a: 0,
            k: [
              13.093,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 440,
        ty: 4,
        parent: 439,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 439,
        ty: 3,
        parent: 430,
        ks: {
          p: {
            a: 0,
            k: [
              6.725,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 442,
        ty: 4,
        parent: 441,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    1.3,
                    9.6
                  ],
                  [
                    2.3,
                    10.2
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    4.5,
                    10.2
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.5,
                    8.7
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    2.5,
                    7.8
                  ],
                  [
                    1.7,
                    7.3
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    1.2,
                    4.5
                  ],
                  [
                    2.1,
                    3.7
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    4.9,
                    3.6
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    5.3,
                    5.3
                  ],
                  [
                    4.5,
                    4.8
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.5,
                    6.1
                  ],
                  [
                    2.9,
                    6.4
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    4.7,
                    7.2
                  ],
                  [
                    5.8,
                    8
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    5.9,
                    10.5
                  ],
                  [
                    4.9,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 441,
        ty: 3,
        parent: 430,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 430,
        ty: 3,
        parent: 398,
        ks: {
          p: {
            a: 0,
            k: [
              31.837,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 445,
        ty: 4,
        parent: 444,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    8.5
                  ],
                  [
                    2.3,
                    8.5
                  ],
                  [
                    0.9,
                    7.8
                  ],
                  [
                    0.4,
                    5.9
                  ],
                  [
                    0.4,
                    5.9
                  ],
                  [
                    0.9,
                    4
                  ],
                  [
                    2.3,
                    3.4
                  ],
                  [
                    2.3,
                    3.4
                  ],
                  [
                    3.7,
                    4
                  ],
                  [
                    4.2,
                    5.9
                  ],
                  [
                    4.2,
                    5.9
                  ],
                  [
                    3.7,
                    7.8
                  ],
                  [
                    2.3,
                    8.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    7.7
                  ],
                  [
                    2.3,
                    7.7
                  ],
                  [
                    2.9,
                    7.2
                  ],
                  [
                    3.2,
                    5.9
                  ],
                  [
                    3.2,
                    5.9
                  ],
                  [
                    2.9,
                    4.6
                  ],
                  [
                    2.3,
                    4.2
                  ],
                  [
                    2.3,
                    4.2
                  ],
                  [
                    1.7,
                    4.6
                  ],
                  [
                    1.4,
                    5.9
                  ],
                  [
                    1.4,
                    5.9
                  ],
                  [
                    1.7,
                    7.2
                  ],
                  [
                    2.3,
                    7.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2.6,
                    11.7
                  ],
                  [
                    7,
                    3.4
                  ],
                  [
                    7.8,
                    3.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    8.1,
                    11.7
                  ],
                  [
                    8.1,
                    11.7
                  ],
                  [
                    6.7,
                    11.1
                  ],
                  [
                    6.2,
                    9.2
                  ],
                  [
                    6.2,
                    9.2
                  ],
                  [
                    6.7,
                    7.3
                  ],
                  [
                    8.1,
                    6.6
                  ],
                  [
                    8.1,
                    6.6
                  ],
                  [
                    9.5,
                    7.3
                  ],
                  [
                    10,
                    9.2
                  ],
                  [
                    10,
                    9.2
                  ],
                  [
                    9.5,
                    11.1
                  ],
                  [
                    8.1,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    8.1,
                    10.9
                  ],
                  [
                    8.1,
                    10.9
                  ],
                  [
                    8.7,
                    10.5
                  ],
                  [
                    9,
                    9.2
                  ],
                  [
                    9,
                    9.2
                  ],
                  [
                    8.7,
                    7.9
                  ],
                  [
                    8.1,
                    7.5
                  ],
                  [
                    8.1,
                    7.5
                  ],
                  [
                    7.4,
                    7.9
                  ],
                  [
                    7.2,
                    9.2
                  ],
                  [
                    7.2,
                    9.2
                  ],
                  [
                    7.4,
                    10.5
                  ],
                  [
                    8.1,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 444,
        ty: 3,
        parent: 443,
        ks: {
          p: {
            a: 0,
            k: [
              18.991,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 447,
        ty: 4,
        parent: 446,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.7
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.7
                  ],
                  [
                    0.8,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    11.7
                  ],
                  [
                    3.2,
                    11.7
                  ],
                  [
                    1.2,
                    10.7
                  ],
                  [
                    0.5,
                    7.6
                  ],
                  [
                    0.5,
                    7.6
                  ],
                  [
                    1.2,
                    4.6
                  ],
                  [
                    3.2,
                    3.6
                  ],
                  [
                    3.2,
                    3.6
                  ],
                  [
                    5.1,
                    4.6
                  ],
                  [
                    5.8,
                    7.6
                  ],
                  [
                    5.8,
                    7.6
                  ],
                  [
                    5.1,
                    10.7
                  ],
                  [
                    3.2,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0.5,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    -0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    10.6
                  ],
                  [
                    3.2,
                    10.6
                  ],
                  [
                    3.8,
                    10.3
                  ],
                  [
                    4.3,
                    9.4
                  ],
                  [
                    4.5,
                    7.6
                  ],
                  [
                    4.5,
                    7.6
                  ],
                  [
                    4.3,
                    5.9
                  ],
                  [
                    3.8,
                    5
                  ],
                  [
                    3.2,
                    4.7
                  ],
                  [
                    3.2,
                    4.7
                  ],
                  [
                    2.5,
                    5
                  ],
                  [
                    2,
                    5.9
                  ],
                  [
                    1.9,
                    7.6
                  ],
                  [
                    1.9,
                    7.6
                  ],
                  [
                    2,
                    9.4
                  ],
                  [
                    2.5,
                    10.3
                  ],
                  [
                    3.2,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 446,
        ty: 3,
        parent: 443,
        ks: {
          p: {
            a: 0,
            k: [
              12.661,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 449,
        ty: 4,
        parent: 448,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.7
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.7
                  ],
                  [
                    0.8,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    11.7
                  ],
                  [
                    3.2,
                    11.7
                  ],
                  [
                    1.2,
                    10.7
                  ],
                  [
                    0.5,
                    7.6
                  ],
                  [
                    0.5,
                    7.6
                  ],
                  [
                    1.2,
                    4.6
                  ],
                  [
                    3.2,
                    3.6
                  ],
                  [
                    3.2,
                    3.6
                  ],
                  [
                    5.1,
                    4.6
                  ],
                  [
                    5.8,
                    7.6
                  ],
                  [
                    5.8,
                    7.6
                  ],
                  [
                    5.1,
                    10.7
                  ],
                  [
                    3.2,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0.5,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    -0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    10.6
                  ],
                  [
                    3.2,
                    10.6
                  ],
                  [
                    3.8,
                    10.3
                  ],
                  [
                    4.3,
                    9.4
                  ],
                  [
                    4.5,
                    7.6
                  ],
                  [
                    4.5,
                    7.6
                  ],
                  [
                    4.3,
                    5.9
                  ],
                  [
                    3.8,
                    5
                  ],
                  [
                    3.2,
                    4.7
                  ],
                  [
                    3.2,
                    4.7
                  ],
                  [
                    2.5,
                    5
                  ],
                  [
                    2,
                    5.9
                  ],
                  [
                    1.9,
                    7.6
                  ],
                  [
                    1.9,
                    7.6
                  ],
                  [
                    2,
                    9.4
                  ],
                  [
                    2.5,
                    10.3
                  ],
                  [
                    3.2,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 448,
        ty: 3,
        parent: 443,
        ks: {
          p: {
            a: 0,
            k: [
              6.33,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 451,
        ty: 4,
        parent: 450,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    11.7
                  ],
                  [
                    3,
                    11.7
                  ],
                  [
                    1.4,
                    11.4
                  ],
                  [
                    0.3,
                    10.6
                  ],
                  [
                    0.3,
                    10.6
                  ],
                  [
                    1,
                    9.7
                  ],
                  [
                    1.8,
                    10.3
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.9,
                    10.2
                  ],
                  [
                    4.3,
                    9.1
                  ],
                  [
                    4.3,
                    9.1
                  ],
                  [
                    3.9,
                    8
                  ],
                  [
                    2.9,
                    7.6
                  ],
                  [
                    2.9,
                    7.6
                  ],
                  [
                    2.2,
                    7.7
                  ],
                  [
                    1.6,
                    8
                  ],
                  [
                    1.6,
                    8
                  ],
                  [
                    0.9,
                    7.6
                  ],
                  [
                    1.2,
                    3.7
                  ],
                  [
                    5.4,
                    3.7
                  ],
                  [
                    5.4,
                    4.9
                  ],
                  [
                    2.4,
                    4.9
                  ],
                  [
                    2.2,
                    6.8
                  ],
                  [
                    2.7,
                    6.6
                  ],
                  [
                    3.3,
                    6.6
                  ],
                  [
                    3.3,
                    6.6
                  ],
                  [
                    4.5,
                    6.8
                  ],
                  [
                    5.4,
                    7.6
                  ],
                  [
                    5.7,
                    9
                  ],
                  [
                    5.7,
                    9
                  ],
                  [
                    5.4,
                    10.5
                  ],
                  [
                    4.3,
                    11.4
                  ],
                  [
                    3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 450,
        ty: 3,
        parent: 443,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 443,
        ty: 3,
        parent: 398,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 398,
        ty: 3,
        parent: 397,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 397,
        ty: 3,
        parent: 396,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 396,
        ty: 3,
        parent: 395,
        ks: {
          p: {
            a: 0,
            k: [
              22.167,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 460,
        ty: 0,
        parent: 452,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "458"
      },
      {
        ind: 452,
        ty: 3,
        parent: 395,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 395,
        ty: 3,
        parent: 394,
        ks: {
          p: {
            a: 0,
            k: [
              48.952,
              3.527
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 394,
        ty: 3,
        parent: 393,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              46.727
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 529,
        ty: 0,
        parent: 463,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              13.015
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              13.015
            ]
          }
        },
        w: 60.455,
        h: 13.731,
        ip: 0,
        op: 565,
        st: 0,
        refId: "527"
      },
      {
        ind: 463,
        ty: 3,
        parent: 462,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              13.015
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 534,
        ty: 4,
        parent: 533,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.22,
                    0.16
                  ],
                  [
                    -0.25,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.14,
                    -0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.06,
                    0.01
                  ],
                  [
                    0.09,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.15
                  ],
                  [
                    0.15,
                    -0.37
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.49,
                    8.51
                  ],
                  [
                    0.74,
                    8.51
                  ],
                  [
                    0.74,
                    4.11
                  ],
                  [
                    1.36,
                    4.11
                  ],
                  [
                    1.42,
                    4.9
                  ],
                  [
                    1.45,
                    4.9
                  ],
                  [
                    2,
                    4.24
                  ],
                  [
                    2.7,
                    4
                  ],
                  [
                    2.7,
                    4
                  ],
                  [
                    3.17,
                    4.09
                  ],
                  [
                    3.17,
                    4.09
                  ],
                  [
                    3.03,
                    4.74
                  ],
                  [
                    2.83,
                    4.69
                  ],
                  [
                    2.6,
                    4.67
                  ],
                  [
                    2.6,
                    4.67
                  ],
                  [
                    2.02,
                    4.9
                  ],
                  [
                    1.49,
                    5.68
                  ],
                  [
                    1.49,
                    5.68
                  ],
                  [
                    1.49,
                    8.51
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.15,
                    -0.28
                  ],
                  [
                    0.22,
                    -0.16
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.18,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.07,
                    -0.02
                  ],
                  [
                    -0.06,
                    -0.01
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0
                  ],
                  [
                    -0.2,
                    0.15
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 533,
        ty: 3,
        parent: 532,
        ks: {
          p: {
            a: 0,
            k: [
              20.34,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 536,
        ty: 4,
        parent: 535,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.32,
                    0.18
                  ],
                  [
                    0.19,
                    0.34
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.34
                  ],
                  [
                    -0.3,
                    0.19
                  ],
                  [
                    -0.33,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    -0.37
                  ],
                  [
                    0,
                    -0.63
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.08
                  ],
                  [
                    0.01,
                    -0.05
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.26,
                    -0.28
                  ],
                  [
                    -0.42,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.18,
                    0.06
                  ],
                  [
                    -0.16,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.09
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.53,
                    8.62
                  ],
                  [
                    2.53,
                    8.62
                  ],
                  [
                    1.46,
                    8.35
                  ],
                  [
                    0.7,
                    7.55
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.7,
                    5.08
                  ],
                  [
                    1.44,
                    4.28
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    3.7,
                    4.56
                  ],
                  [
                    4.15,
                    6.07
                  ],
                  [
                    4.15,
                    6.07
                  ],
                  [
                    4.15,
                    6.3
                  ],
                  [
                    4.13,
                    6.49
                  ],
                  [
                    4.13,
                    6.49
                  ],
                  [
                    1.15,
                    6.49
                  ],
                  [
                    1.59,
                    7.61
                  ],
                  [
                    2.62,
                    8.02
                  ],
                  [
                    2.62,
                    8.02
                  ],
                  [
                    3.21,
                    7.93
                  ],
                  [
                    3.72,
                    7.68
                  ],
                  [
                    3.72,
                    7.68
                  ],
                  [
                    3.98,
                    8.17
                  ],
                  [
                    3.34,
                    8.49
                  ],
                  [
                    2.53,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.39,
                    0
                  ],
                  [
                    -0.32,
                    -0.18
                  ],
                  [
                    -0.19,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.48
                  ],
                  [
                    0.19,
                    -0.34
                  ],
                  [
                    0.3,
                    -0.19
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.56,
                    0
                  ],
                  [
                    0.31,
                    0.37
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.08
                  ],
                  [
                    0,
                    0.08
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.03,
                    0.47
                  ],
                  [
                    0.26,
                    0.28
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0
                  ],
                  [
                    0.18,
                    -0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.12
                  ],
                  [
                    -0.24,
                    0.09
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.19,
                    0.23
                  ],
                  [
                    0.34,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.24
                  ],
                  [
                    0.05,
                    -0.44
                  ]
                ],
                v: [
                  [
                    1.14,
                    5.96
                  ],
                  [
                    1.14,
                    5.96
                  ],
                  [
                    3.5,
                    5.96
                  ],
                  [
                    3.21,
                    4.94
                  ],
                  [
                    2.41,
                    4.59
                  ],
                  [
                    2.41,
                    4.59
                  ],
                  [
                    1.58,
                    4.95
                  ],
                  [
                    1.14,
                    5.96
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.45
                  ],
                  [
                    -0.19,
                    -0.23
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    0
                  ],
                  [
                    -0.24,
                    0.24
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 535,
        ty: 3,
        parent: 532,
        ks: {
          p: {
            a: 0,
            k: [
              15.846,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 538,
        ty: 4,
        parent: 537,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    8.6
                  ],
                  [
                    1.5,
                    8.6
                  ],
                  [
                    0.9,
                    8.4
                  ],
                  [
                    0.7,
                    7.6
                  ],
                  [
                    0.7,
                    7.6
                  ],
                  [
                    0.7,
                    2.1
                  ],
                  [
                    1.5,
                    2.1
                  ],
                  [
                    1.5,
                    7.7
                  ],
                  [
                    1.6,
                    7.9
                  ],
                  [
                    1.7,
                    8
                  ],
                  [
                    1.7,
                    8
                  ],
                  [
                    1.8,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    2,
                    8.5
                  ],
                  [
                    1.8,
                    8.6
                  ],
                  [
                    1.5,
                    8.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 537,
        ty: 3,
        parent: 532,
        ks: {
          p: {
            a: 0,
            k: [
              13.536,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 540,
        ty: 4,
        parent: 539,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    0.22
                  ],
                  [
                    0,
                    0.39
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.43,
                    0.26
                  ],
                  [
                    -0.94,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.05,
                    0.17
                  ],
                  [
                    0.13,
                    0.11
                  ],
                  [
                    0.24,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.22,
                    -0.1
                  ],
                  [
                    0.18,
                    -0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.12
                  ],
                  [
                    -0.35,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.24,
                    -0.33
                  ],
                  [
                    0,
                    -0.55
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.13
                  ],
                  [
                    0.28,
                    0
                  ]
                ],
                v: [
                  [
                    1.76,
                    8.62
                  ],
                  [
                    1.76,
                    8.62
                  ],
                  [
                    0.84,
                    8.29
                  ],
                  [
                    0.47,
                    7.37
                  ],
                  [
                    0.47,
                    7.37
                  ],
                  [
                    1.12,
                    6.26
                  ],
                  [
                    3.17,
                    5.72
                  ],
                  [
                    3.17,
                    5.72
                  ],
                  [
                    3.1,
                    5.19
                  ],
                  [
                    2.82,
                    4.77
                  ],
                  [
                    2.27,
                    4.61
                  ],
                  [
                    2.27,
                    4.61
                  ],
                  [
                    1.55,
                    4.76
                  ],
                  [
                    0.95,
                    5.09
                  ],
                  [
                    0.95,
                    5.09
                  ],
                  [
                    0.66,
                    4.57
                  ],
                  [
                    1.42,
                    4.18
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    3.56,
                    4.49
                  ],
                  [
                    3.93,
                    5.81
                  ],
                  [
                    3.93,
                    5.81
                  ],
                  [
                    3.93,
                    8.51
                  ],
                  [
                    3.31,
                    8.51
                  ],
                  [
                    3.25,
                    7.99
                  ],
                  [
                    3.22,
                    7.99
                  ],
                  [
                    2.54,
                    8.43
                  ],
                  [
                    1.76,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.37,
                    0
                  ],
                  [
                    -0.24,
                    -0.22
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.48
                  ],
                  [
                    0.43,
                    -0.26
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.19
                  ],
                  [
                    -0.05,
                    -0.17
                  ],
                  [
                    -0.13,
                    -0.11
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.25,
                    0
                  ],
                  [
                    -0.22,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    -0.13
                  ],
                  [
                    0.3,
                    -0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.54,
                    0
                  ],
                  [
                    0.24,
                    0.33
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    0.17
                  ],
                  [
                    -0.24,
                    0.13
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.1
                  ],
                  [
                    -0.21,
                    0.19
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.29,
                    -0.18
                  ],
                  [
                    0,
                    -0.28
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.15,
                    -0.11
                  ],
                  [
                    -0.22,
                    0
                  ]
                ],
                v: [
                  [
                    1.98,
                    8.02
                  ],
                  [
                    1.98,
                    8.02
                  ],
                  [
                    2.58,
                    7.87
                  ],
                  [
                    3.17,
                    7.43
                  ],
                  [
                    3.17,
                    7.43
                  ],
                  [
                    3.17,
                    6.21
                  ],
                  [
                    1.64,
                    6.62
                  ],
                  [
                    1.2,
                    7.32
                  ],
                  [
                    1.2,
                    7.32
                  ],
                  [
                    1.42,
                    7.86
                  ],
                  [
                    1.98,
                    8.02
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0
                  ],
                  [
                    0.19,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.73,
                    0.09
                  ],
                  [
                    -0.29,
                    0.18
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.25
                  ],
                  [
                    0.15,
                    0.11
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 539,
        ty: 3,
        parent: 532,
        ks: {
          p: {
            a: 0,
            k: [
              8.969,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 542,
        ty: 4,
        parent: 541,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.31,
                    0.18
                  ],
                  [
                    0.18,
                    0.34
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.34
                  ],
                  [
                    -0.32,
                    0.18
                  ],
                  [
                    -0.37,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.1
                  ],
                  [
                    -0.15,
                    -0.14
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.14,
                    0.07
                  ],
                  [
                    0.18,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    -0.14
                  ],
                  [
                    0.12,
                    -0.26
                  ],
                  [
                    0,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.25,
                    -0.31
                  ],
                  [
                    -0.41,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.18,
                    0.09
                  ],
                  [
                    -0.13,
                    0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.1
                  ],
                  [
                    0.27,
                    0
                  ]
                ],
                v: [
                  [
                    2.48,
                    8.62
                  ],
                  [
                    2.48,
                    8.62
                  ],
                  [
                    1.43,
                    8.35
                  ],
                  [
                    0.69,
                    7.56
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.71,
                    5.06
                  ],
                  [
                    1.49,
                    4.27
                  ],
                  [
                    2.54,
                    4
                  ],
                  [
                    2.54,
                    4
                  ],
                  [
                    3.29,
                    4.15
                  ],
                  [
                    3.83,
                    4.51
                  ],
                  [
                    3.83,
                    4.51
                  ],
                  [
                    3.45,
                    5
                  ],
                  [
                    3.04,
                    4.72
                  ],
                  [
                    2.57,
                    4.61
                  ],
                  [
                    2.57,
                    4.61
                  ],
                  [
                    1.85,
                    4.83
                  ],
                  [
                    1.36,
                    5.43
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.56,
                    7.54
                  ],
                  [
                    2.55,
                    8.01
                  ],
                  [
                    2.55,
                    8.01
                  ],
                  [
                    3.12,
                    7.87
                  ],
                  [
                    3.58,
                    7.56
                  ],
                  [
                    3.58,
                    7.56
                  ],
                  [
                    3.91,
                    8.06
                  ],
                  [
                    3.25,
                    8.47
                  ],
                  [
                    2.48,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.39,
                    0
                  ],
                  [
                    -0.31,
                    -0.18
                  ],
                  [
                    -0.18,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0.2,
                    -0.34
                  ],
                  [
                    0.32,
                    -0.18
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.29,
                    0
                  ],
                  [
                    0.21,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.13,
                    -0.11
                  ],
                  [
                    -0.14,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.27,
                    0
                  ],
                  [
                    -0.21,
                    0.14
                  ],
                  [
                    -0.12,
                    0.26
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0.25,
                    0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0
                  ],
                  [
                    0.18,
                    -0.09
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.18
                  ],
                  [
                    -0.24,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 541,
        ty: 3,
        parent: 532,
        ks: {
          p: {
            a: 0,
            k: [
              4.838,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 544,
        ty: 4,
        parent: 543,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.5,
                    8.6
                  ],
                  [
                    2.5,
                    8.6
                  ],
                  [
                    1.3,
                    8.4
                  ],
                  [
                    0.4,
                    7.7
                  ],
                  [
                    0.4,
                    7.7
                  ],
                  [
                    0.8,
                    7.2
                  ],
                  [
                    1.6,
                    7.8
                  ],
                  [
                    2.5,
                    8
                  ],
                  [
                    2.5,
                    8
                  ],
                  [
                    3.4,
                    7.7
                  ],
                  [
                    3.7,
                    7
                  ],
                  [
                    3.7,
                    7
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    3.2,
                    6.2
                  ],
                  [
                    2.7,
                    5.9
                  ],
                  [
                    2.7,
                    5.9
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.3,
                    5.3
                  ],
                  [
                    0.9,
                    4.8
                  ],
                  [
                    0.7,
                    4
                  ],
                  [
                    0.7,
                    4
                  ],
                  [
                    0.9,
                    3.2
                  ],
                  [
                    1.6,
                    2.7
                  ],
                  [
                    2.5,
                    2.5
                  ],
                  [
                    2.5,
                    2.5
                  ],
                  [
                    3.5,
                    2.7
                  ],
                  [
                    4.3,
                    3.2
                  ],
                  [
                    4.3,
                    3.2
                  ],
                  [
                    3.9,
                    3.7
                  ],
                  [
                    3.3,
                    3.3
                  ],
                  [
                    2.5,
                    3.1
                  ],
                  [
                    2.5,
                    3.1
                  ],
                  [
                    1.7,
                    3.4
                  ],
                  [
                    1.4,
                    4
                  ],
                  [
                    1.4,
                    4
                  ],
                  [
                    1.6,
                    4.5
                  ],
                  [
                    2,
                    4.8
                  ],
                  [
                    2.4,
                    5
                  ],
                  [
                    2.4,
                    5
                  ],
                  [
                    3.3,
                    5.3
                  ],
                  [
                    3.9,
                    5.7
                  ],
                  [
                    4.3,
                    6.2
                  ],
                  [
                    4.5,
                    6.9
                  ],
                  [
                    4.5,
                    6.9
                  ],
                  [
                    4.2,
                    7.8
                  ],
                  [
                    3.5,
                    8.4
                  ],
                  [
                    2.5,
                    8.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 543,
        ty: 3,
        parent: 532,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 532,
        ty: 3,
        parent: 531,
        ks: {
          p: {
            a: 0,
            k: [
              18.709,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 547,
        ty: 4,
        parent: 546,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    8.6
                  ],
                  [
                    2.1,
                    8.6
                  ],
                  [
                    1.1,
                    8.2
                  ],
                  [
                    0.9,
                    7.2
                  ],
                  [
                    0.9,
                    7.2
                  ],
                  [
                    0.9,
                    4.7
                  ],
                  [
                    0.2,
                    4.7
                  ],
                  [
                    0.2,
                    4.2
                  ],
                  [
                    0.9,
                    4.1
                  ],
                  [
                    1,
                    2.9
                  ],
                  [
                    1.6,
                    2.9
                  ],
                  [
                    1.6,
                    4.1
                  ],
                  [
                    2.8,
                    4.1
                  ],
                  [
                    2.8,
                    4.7
                  ],
                  [
                    1.6,
                    4.7
                  ],
                  [
                    1.6,
                    7.2
                  ],
                  [
                    1.8,
                    7.8
                  ],
                  [
                    2.3,
                    8
                  ],
                  [
                    2.3,
                    8
                  ],
                  [
                    2.6,
                    8
                  ],
                  [
                    2.8,
                    7.9
                  ],
                  [
                    2.8,
                    7.9
                  ],
                  [
                    2.9,
                    8.5
                  ],
                  [
                    2.6,
                    8.6
                  ],
                  [
                    2.1,
                    8.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 546,
        ty: 3,
        parent: 545,
        ks: {
          p: {
            a: 0,
            k: [
              13.835,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 549,
        ty: 4,
        parent: 548,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.28,
                    0.12
                  ],
                  [
                    0.21,
                    0.17
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.1
                  ],
                  [
                    -0.26,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.15,
                    0.14
                  ],
                  [
                    0,
                    0.19
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.15,
                    0.07
                  ],
                  [
                    0.16,
                    0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.13,
                    0.16
                  ],
                  [
                    0,
                    0.25
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.27,
                    0.24
                  ],
                  [
                    -0.48,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.24,
                    -0.1
                  ],
                  [
                    -0.17,
                    -0.14
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.16,
                    0.07
                  ],
                  [
                    0.19,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.13,
                    -0.13
                  ],
                  [
                    0,
                    -0.17
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.09,
                    -0.09
                  ],
                  [
                    -0.15,
                    -0.06
                  ],
                  [
                    -0.16,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.1
                  ],
                  [
                    -0.14,
                    -0.17
                  ],
                  [
                    0,
                    -0.28
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.12,
                    -0.2
                  ],
                  [
                    0.24,
                    -0.12
                  ],
                  [
                    0.35,
                    0
                  ]
                ],
                v: [
                  [
                    1.9,
                    8.62
                  ],
                  [
                    1.9,
                    8.62
                  ],
                  [
                    1,
                    8.45
                  ],
                  [
                    0.25,
                    8.01
                  ],
                  [
                    0.25,
                    8.01
                  ],
                  [
                    0.63,
                    7.52
                  ],
                  [
                    1.22,
                    7.89
                  ],
                  [
                    1.92,
                    8.04
                  ],
                  [
                    1.92,
                    8.04
                  ],
                  [
                    2.58,
                    7.84
                  ],
                  [
                    2.79,
                    7.35
                  ],
                  [
                    2.79,
                    7.35
                  ],
                  [
                    2.64,
                    6.97
                  ],
                  [
                    2.26,
                    6.71
                  ],
                  [
                    1.79,
                    6.52
                  ],
                  [
                    1.79,
                    6.52
                  ],
                  [
                    1.18,
                    6.25
                  ],
                  [
                    0.69,
                    5.86
                  ],
                  [
                    0.5,
                    5.25
                  ],
                  [
                    0.5,
                    5.25
                  ],
                  [
                    0.9,
                    4.36
                  ],
                  [
                    2.02,
                    4
                  ],
                  [
                    2.02,
                    4
                  ],
                  [
                    2.78,
                    4.14
                  ],
                  [
                    3.39,
                    4.5
                  ],
                  [
                    3.39,
                    4.5
                  ],
                  [
                    3.03,
                    4.97
                  ],
                  [
                    2.56,
                    4.69
                  ],
                  [
                    2.02,
                    4.58
                  ],
                  [
                    2.02,
                    4.58
                  ],
                  [
                    1.41,
                    4.77
                  ],
                  [
                    1.22,
                    5.21
                  ],
                  [
                    1.22,
                    5.21
                  ],
                  [
                    1.35,
                    5.55
                  ],
                  [
                    1.7,
                    5.78
                  ],
                  [
                    2.17,
                    5.97
                  ],
                  [
                    2.17,
                    5.97
                  ],
                  [
                    2.79,
                    6.24
                  ],
                  [
                    3.31,
                    6.64
                  ],
                  [
                    3.51,
                    7.31
                  ],
                  [
                    3.51,
                    7.31
                  ],
                  [
                    3.32,
                    7.96
                  ],
                  [
                    2.78,
                    8.44
                  ],
                  [
                    1.9,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    0
                  ],
                  [
                    -0.28,
                    -0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.19,
                    0.15
                  ],
                  [
                    0.21,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.29,
                    0
                  ],
                  [
                    0.15,
                    -0.14
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.15
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.15,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.08
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.13,
                    -0.16
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.36
                  ],
                  [
                    0.27,
                    -0.24
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.27,
                    0
                  ],
                  [
                    0.24,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.15,
                    -0.11
                  ],
                  [
                    -0.16,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.28,
                    0
                  ],
                  [
                    -0.13,
                    0.13
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.14
                  ],
                  [
                    0.09,
                    0.09
                  ],
                  [
                    0.15,
                    0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0.08
                  ],
                  [
                    0.21,
                    0.1
                  ],
                  [
                    0.14,
                    0.17
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.24
                  ],
                  [
                    -0.12,
                    0.2
                  ],
                  [
                    -0.24,
                    0.12
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 548,
        ty: 3,
        parent: 545,
        ks: {
          p: {
            a: 0,
            k: [
              10.038,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 551,
        ty: 4,
        parent: 550,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.31,
                    0.18
                  ],
                  [
                    0.19,
                    0.34
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.34
                  ],
                  [
                    -0.31,
                    0.18
                  ],
                  [
                    -0.36,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    -0.18
                  ],
                  [
                    -0.19,
                    -0.34
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.19,
                    -0.34
                  ],
                  [
                    0.31,
                    -0.18
                  ],
                  [
                    0.36,
                    0
                  ]
                ],
                v: [
                  [
                    2.46,
                    8.62
                  ],
                  [
                    2.46,
                    8.62
                  ],
                  [
                    1.46,
                    8.35
                  ],
                  [
                    0.7,
                    7.56
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.7,
                    5.06
                  ],
                  [
                    1.46,
                    4.27
                  ],
                  [
                    2.46,
                    4
                  ],
                  [
                    2.46,
                    4
                  ],
                  [
                    3.46,
                    4.27
                  ],
                  [
                    4.21,
                    5.06
                  ],
                  [
                    4.5,
                    6.32
                  ],
                  [
                    4.5,
                    6.32
                  ],
                  [
                    4.21,
                    7.56
                  ],
                  [
                    3.46,
                    8.35
                  ],
                  [
                    2.46,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.36,
                    0
                  ],
                  [
                    -0.31,
                    -0.18
                  ],
                  [
                    -0.19,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0.19,
                    -0.34
                  ],
                  [
                    0.31,
                    -0.18
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.36,
                    0
                  ],
                  [
                    0.31,
                    0.18
                  ],
                  [
                    0.19,
                    0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    -0.19,
                    0.34
                  ],
                  [
                    -0.31,
                    0.18
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.23,
                    0.31
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.23,
                    0.31
                  ],
                  [
                    0.38,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.31
                  ],
                  [
                    0,
                    -0.51
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.24,
                    -0.31
                  ],
                  [
                    -0.37,
                    0
                  ]
                ],
                v: [
                  [
                    2.46,
                    8.01
                  ],
                  [
                    2.46,
                    8.01
                  ],
                  [
                    3.38,
                    7.54
                  ],
                  [
                    3.73,
                    6.32
                  ],
                  [
                    3.73,
                    6.32
                  ],
                  [
                    3.38,
                    5.09
                  ],
                  [
                    2.46,
                    4.61
                  ],
                  [
                    2.46,
                    4.61
                  ],
                  [
                    1.54,
                    5.09
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.54,
                    7.54
                  ],
                  [
                    2.46,
                    8.01
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.38,
                    0
                  ],
                  [
                    0.23,
                    -0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.51
                  ],
                  [
                    -0.23,
                    -0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.37,
                    0
                  ],
                  [
                    -0.24,
                    0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0.24,
                    0.31
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 550,
        ty: 3,
        parent: 545,
        ks: {
          p: {
            a: 0,
            k: [
              5.128,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 553,
        ty: 4,
        parent: 552,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.5
                  ],
                  [
                    0.8,
                    8.5
                  ],
                  [
                    0.8,
                    2.6
                  ],
                  [
                    2.5,
                    2.6
                  ],
                  [
                    3.7,
                    2.7
                  ],
                  [
                    4.5,
                    3.3
                  ],
                  [
                    4.7,
                    4.3
                  ],
                  [
                    4.7,
                    4.3
                  ],
                  [
                    4.1,
                    5.7
                  ],
                  [
                    2.5,
                    6.2
                  ],
                  [
                    2.5,
                    6.2
                  ],
                  [
                    1.6,
                    6.2
                  ],
                  [
                    1.6,
                    8.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.6,
                    3.2
                  ],
                  [
                    1.6,
                    5.5
                  ],
                  [
                    2.5,
                    5.5
                  ],
                  [
                    3.6,
                    5.2
                  ],
                  [
                    4,
                    4.3
                  ],
                  [
                    4,
                    4.3
                  ],
                  [
                    3.6,
                    3.4
                  ],
                  [
                    2.4,
                    3.2
                  ],
                  [
                    2.4,
                    3.2
                  ],
                  [
                    1.6,
                    3.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 552,
        ty: 3,
        parent: 545,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 545,
        ty: 3,
        parent: 531,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 531,
        ty: 3,
        parent: 530,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 530,
        ty: 3,
        parent: 462,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 462,
        ty: 3,
        parent: 461,
        ks: {
          p: {
            a: 0,
            k: [
              186.97,
              2.937
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 559,
        ty: 0,
        parent: 555,
        ks: {},
        w: 27,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "557"
      },
      {
        ind: 555,
        ty: 3,
        parent: 554,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 554,
        ty: 3,
        parent: 461,
        ks: {
          p: {
            a: 0,
            k: [
              150.193,
              10.204
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 565,
        ty: 4,
        parent: 564,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    13.2
                  ],
                  [
                    1.2,
                    13.2
                  ],
                  [
                    1.2,
                    6.4
                  ],
                  [
                    2.1,
                    6.4
                  ],
                  [
                    2.2,
                    7.6
                  ],
                  [
                    2.3,
                    7.6
                  ],
                  [
                    3.1,
                    6.6
                  ],
                  [
                    4.2,
                    6.2
                  ],
                  [
                    4.2,
                    6.2
                  ],
                  [
                    4.9,
                    6.4
                  ],
                  [
                    4.9,
                    6.4
                  ],
                  [
                    4.7,
                    7.4
                  ],
                  [
                    4.4,
                    7.3
                  ],
                  [
                    4,
                    7.3
                  ],
                  [
                    4,
                    7.3
                  ],
                  [
                    3.1,
                    7.6
                  ],
                  [
                    2.3,
                    8.8
                  ],
                  [
                    2.3,
                    8.8
                  ],
                  [
                    2.3,
                    13.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 564,
        ty: 3,
        parent: 563,
        ks: {
          p: {
            a: 0,
            k: [
              78.368,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 567,
        ty: 4,
        parent: 566,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.9,
                    13.4
                  ],
                  [
                    3.9,
                    13.4
                  ],
                  [
                    2.3,
                    13
                  ],
                  [
                    1.1,
                    11.7
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    1.1,
                    7.9
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    3.7,
                    6.2
                  ],
                  [
                    3.7,
                    6.2
                  ],
                  [
                    5.7,
                    7.1
                  ],
                  [
                    6.5,
                    9.4
                  ],
                  [
                    6.5,
                    9.4
                  ],
                  [
                    6.5,
                    9.8
                  ],
                  [
                    6.4,
                    10.1
                  ],
                  [
                    6.4,
                    10.1
                  ],
                  [
                    1.8,
                    10.1
                  ],
                  [
                    2.5,
                    11.8
                  ],
                  [
                    4.1,
                    12.5
                  ],
                  [
                    4.1,
                    12.5
                  ],
                  [
                    5,
                    12.3
                  ],
                  [
                    5.8,
                    11.9
                  ],
                  [
                    5.8,
                    11.9
                  ],
                  [
                    6.2,
                    12.7
                  ],
                  [
                    5.2,
                    13.2
                  ],
                  [
                    3.9,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.1,
                    -0.7
                  ]
                ],
                v: [
                  [
                    1.8,
                    9.3
                  ],
                  [
                    1.8,
                    9.3
                  ],
                  [
                    5.4,
                    9.3
                  ],
                  [
                    5,
                    7.7
                  ],
                  [
                    3.8,
                    7.1
                  ],
                  [
                    3.8,
                    7.1
                  ],
                  [
                    2.5,
                    7.7
                  ],
                  [
                    1.8,
                    9.3
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 566,
        ty: 3,
        parent: 563,
        ks: {
          p: {
            a: 0,
            k: [
              71.374,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 569,
        ty: 4,
        parent: 568,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0.7,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    16.4
                  ],
                  [
                    3.5,
                    16.4
                  ],
                  [
                    1.4,
                    15.9
                  ],
                  [
                    0.6,
                    14.6
                  ],
                  [
                    0.6,
                    14.6
                  ],
                  [
                    0.9,
                    13.7
                  ],
                  [
                    1.6,
                    13
                  ],
                  [
                    1.6,
                    13
                  ],
                  [
                    1.6,
                    12.9
                  ],
                  [
                    1.2,
                    12.5
                  ],
                  [
                    1,
                    11.8
                  ],
                  [
                    1,
                    11.8
                  ],
                  [
                    1.3,
                    11.1
                  ],
                  [
                    1.8,
                    10.6
                  ],
                  [
                    1.8,
                    10.6
                  ],
                  [
                    1.8,
                    10.5
                  ],
                  [
                    1.2,
                    9.7
                  ],
                  [
                    0.9,
                    8.7
                  ],
                  [
                    0.9,
                    8.7
                  ],
                  [
                    1.2,
                    7.4
                  ],
                  [
                    2.2,
                    6.5
                  ],
                  [
                    3.5,
                    6.2
                  ],
                  [
                    3.5,
                    6.2
                  ],
                  [
                    4,
                    6.3
                  ],
                  [
                    4.4,
                    6.4
                  ],
                  [
                    4.4,
                    6.4
                  ],
                  [
                    6.8,
                    6.4
                  ],
                  [
                    6.8,
                    7.3
                  ],
                  [
                    5.4,
                    7.3
                  ],
                  [
                    5.8,
                    7.9
                  ],
                  [
                    6,
                    8.7
                  ],
                  [
                    6,
                    8.7
                  ],
                  [
                    5.6,
                    10
                  ],
                  [
                    4.7,
                    10.8
                  ],
                  [
                    3.5,
                    11.1
                  ],
                  [
                    3.5,
                    11.1
                  ],
                  [
                    2.4,
                    10.8
                  ],
                  [
                    2.4,
                    10.8
                  ],
                  [
                    2.1,
                    11.2
                  ],
                  [
                    2,
                    11.6
                  ],
                  [
                    2,
                    11.6
                  ],
                  [
                    2.3,
                    12.2
                  ],
                  [
                    3.2,
                    12.4
                  ],
                  [
                    3.2,
                    12.4
                  ],
                  [
                    4.5,
                    12.4
                  ],
                  [
                    6.3,
                    12.8
                  ],
                  [
                    6.9,
                    14
                  ],
                  [
                    6.9,
                    14
                  ],
                  [
                    6.5,
                    15.2
                  ],
                  [
                    5.3,
                    16.1
                  ],
                  [
                    3.5,
                    16.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    10.3
                  ],
                  [
                    3.5,
                    10.3
                  ],
                  [
                    4.5,
                    9.9
                  ],
                  [
                    4.9,
                    8.7
                  ],
                  [
                    4.9,
                    8.7
                  ],
                  [
                    4.5,
                    7.5
                  ],
                  [
                    3.5,
                    7.1
                  ],
                  [
                    3.5,
                    7.1
                  ],
                  [
                    2.4,
                    7.5
                  ],
                  [
                    2,
                    8.7
                  ],
                  [
                    2,
                    8.7
                  ],
                  [
                    2.4,
                    9.9
                  ],
                  [
                    3.5,
                    10.3
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.6,
                    15.6
                  ],
                  [
                    3.6,
                    15.6
                  ],
                  [
                    5.2,
                    15.2
                  ],
                  [
                    5.8,
                    14.2
                  ],
                  [
                    5.8,
                    14.2
                  ],
                  [
                    5.5,
                    13.5
                  ],
                  [
                    4.4,
                    13.4
                  ],
                  [
                    4.4,
                    13.4
                  ],
                  [
                    3.2,
                    13.4
                  ],
                  [
                    2.8,
                    13.3
                  ],
                  [
                    2.4,
                    13.2
                  ],
                  [
                    2.4,
                    13.2
                  ],
                  [
                    1.8,
                    13.8
                  ],
                  [
                    1.7,
                    14.4
                  ],
                  [
                    1.7,
                    14.4
                  ],
                  [
                    2.2,
                    15.3
                  ],
                  [
                    3.6,
                    15.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 568,
        ty: 3,
        parent: 563,
        ks: {
          p: {
            a: 0,
            k: [
              64.268,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 571,
        ty: 4,
        parent: 570,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    13.2
                  ],
                  [
                    1.2,
                    13.2
                  ],
                  [
                    1.2,
                    6.4
                  ],
                  [
                    2.1,
                    6.4
                  ],
                  [
                    2.2,
                    7.6
                  ],
                  [
                    2.3,
                    7.6
                  ],
                  [
                    3.1,
                    6.6
                  ],
                  [
                    4.2,
                    6.2
                  ],
                  [
                    4.2,
                    6.2
                  ],
                  [
                    4.9,
                    6.4
                  ],
                  [
                    4.9,
                    6.4
                  ],
                  [
                    4.7,
                    7.4
                  ],
                  [
                    4.4,
                    7.3
                  ],
                  [
                    4,
                    7.3
                  ],
                  [
                    4,
                    7.3
                  ],
                  [
                    3.1,
                    7.6
                  ],
                  [
                    2.3,
                    8.8
                  ],
                  [
                    2.3,
                    8.8
                  ],
                  [
                    2.3,
                    13.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 570,
        ty: 3,
        parent: 563,
        ks: {
          p: {
            a: 0,
            k: [
              59.375,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 573,
        ty: 4,
        parent: 572,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.9,
                    13.4
                  ],
                  [
                    3.9,
                    13.4
                  ],
                  [
                    2.3,
                    13
                  ],
                  [
                    1.1,
                    11.7
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    1.1,
                    7.9
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    3.7,
                    6.2
                  ],
                  [
                    3.7,
                    6.2
                  ],
                  [
                    5.7,
                    7.1
                  ],
                  [
                    6.5,
                    9.4
                  ],
                  [
                    6.5,
                    9.4
                  ],
                  [
                    6.5,
                    9.8
                  ],
                  [
                    6.4,
                    10.1
                  ],
                  [
                    6.4,
                    10.1
                  ],
                  [
                    1.8,
                    10.1
                  ],
                  [
                    2.5,
                    11.8
                  ],
                  [
                    4.1,
                    12.5
                  ],
                  [
                    4.1,
                    12.5
                  ],
                  [
                    5,
                    12.3
                  ],
                  [
                    5.8,
                    11.9
                  ],
                  [
                    5.8,
                    11.9
                  ],
                  [
                    6.2,
                    12.7
                  ],
                  [
                    5.2,
                    13.2
                  ],
                  [
                    3.9,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.1,
                    -0.7
                  ]
                ],
                v: [
                  [
                    1.8,
                    9.3
                  ],
                  [
                    1.8,
                    9.3
                  ],
                  [
                    5.4,
                    9.3
                  ],
                  [
                    5,
                    7.7
                  ],
                  [
                    3.8,
                    7.1
                  ],
                  [
                    3.8,
                    7.1
                  ],
                  [
                    2.5,
                    7.7
                  ],
                  [
                    1.8,
                    9.3
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 572,
        ty: 3,
        parent: 563,
        ks: {
          p: {
            a: 0,
            k: [
              52.381,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 575,
        ty: 4,
        parent: 574,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    -1.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.6
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    4.2,
                    13.4
                  ],
                  [
                    4.2,
                    13.4
                  ],
                  [
                    3.2,
                    13.2
                  ],
                  [
                    2.2,
                    12.5
                  ],
                  [
                    2.2,
                    12.5
                  ],
                  [
                    2.2,
                    12.5
                  ],
                  [
                    2.1,
                    13.2
                  ],
                  [
                    1.2,
                    13.2
                  ],
                  [
                    1.2,
                    3.2
                  ],
                  [
                    2.3,
                    3.2
                  ],
                  [
                    2.3,
                    5.9
                  ],
                  [
                    2.3,
                    7.2
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    4.4,
                    6.2
                  ],
                  [
                    4.4,
                    6.2
                  ],
                  [
                    6.5,
                    7.2
                  ],
                  [
                    7.2,
                    9.7
                  ],
                  [
                    7.2,
                    9.7
                  ],
                  [
                    6.7,
                    11.7
                  ],
                  [
                    5.6,
                    13
                  ],
                  [
                    4.2,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.3,
                    0.6
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.5
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    0
                  ]
                ],
                v: [
                  [
                    4,
                    12.4
                  ],
                  [
                    4,
                    12.4
                  ],
                  [
                    5.4,
                    11.7
                  ],
                  [
                    6,
                    9.7
                  ],
                  [
                    6,
                    9.7
                  ],
                  [
                    5.5,
                    7.9
                  ],
                  [
                    4.1,
                    7.2
                  ],
                  [
                    4.1,
                    7.2
                  ],
                  [
                    3.3,
                    7.4
                  ],
                  [
                    2.3,
                    8.1
                  ],
                  [
                    2.3,
                    8.1
                  ],
                  [
                    2.3,
                    11.7
                  ],
                  [
                    3.2,
                    12.3
                  ],
                  [
                    4,
                    12.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 574,
        ty: 3,
        parent: 563,
        ks: {
          p: {
            a: 0,
            k: [
              44.584,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 577,
        ty: 4,
        parent: 576,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    13.2
                  ],
                  [
                    1.2,
                    13.2
                  ],
                  [
                    1.2,
                    6.4
                  ],
                  [
                    2.1,
                    6.4
                  ],
                  [
                    2.2,
                    7.4
                  ],
                  [
                    2.3,
                    7.4
                  ],
                  [
                    3.2,
                    6.5
                  ],
                  [
                    4.4,
                    6.2
                  ],
                  [
                    4.4,
                    6.2
                  ],
                  [
                    5.6,
                    6.6
                  ],
                  [
                    6.3,
                    7.5
                  ],
                  [
                    6.3,
                    7.5
                  ],
                  [
                    7.4,
                    6.6
                  ],
                  [
                    8.5,
                    6.2
                  ],
                  [
                    8.5,
                    6.2
                  ],
                  [
                    10.1,
                    6.9
                  ],
                  [
                    10.6,
                    8.9
                  ],
                  [
                    10.6,
                    8.9
                  ],
                  [
                    10.6,
                    13.2
                  ],
                  [
                    9.5,
                    13.2
                  ],
                  [
                    9.5,
                    9.1
                  ],
                  [
                    9.2,
                    7.7
                  ],
                  [
                    8.2,
                    7.2
                  ],
                  [
                    8.2,
                    7.2
                  ],
                  [
                    6.5,
                    8.3
                  ],
                  [
                    6.5,
                    8.3
                  ],
                  [
                    6.5,
                    13.2
                  ],
                  [
                    5.3,
                    13.2
                  ],
                  [
                    5.3,
                    9.1
                  ],
                  [
                    5,
                    7.7
                  ],
                  [
                    4,
                    7.2
                  ],
                  [
                    4,
                    7.2
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    2.3,
                    13.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 576,
        ty: 3,
        parent: 563,
        ks: {
          p: {
            a: 0,
            k: [
              32.895,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 579,
        ty: 4,
        parent: 578,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    13.4
                  ],
                  [
                    3.2,
                    13.4
                  ],
                  [
                    1.6,
                    12.7
                  ],
                  [
                    1.1,
                    10.7
                  ],
                  [
                    1.1,
                    10.7
                  ],
                  [
                    1.1,
                    6.4
                  ],
                  [
                    2.2,
                    6.4
                  ],
                  [
                    2.2,
                    10.6
                  ],
                  [
                    2.5,
                    12
                  ],
                  [
                    3.5,
                    12.4
                  ],
                  [
                    3.5,
                    12.4
                  ],
                  [
                    4.5,
                    12.1
                  ],
                  [
                    5.4,
                    11.3
                  ],
                  [
                    5.4,
                    11.3
                  ],
                  [
                    5.4,
                    6.4
                  ],
                  [
                    6.5,
                    6.4
                  ],
                  [
                    6.5,
                    13.2
                  ],
                  [
                    5.6,
                    13.2
                  ],
                  [
                    5.5,
                    12.2
                  ],
                  [
                    5.4,
                    12.2
                  ],
                  [
                    4.4,
                    13.1
                  ],
                  [
                    3.2,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 578,
        ty: 3,
        parent: 563,
        ks: {
          p: {
            a: 0,
            k: [
              25.225,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 581,
        ty: 4,
        parent: 580,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    13.4
                  ],
                  [
                    2.4,
                    13.4
                  ],
                  [
                    1.4,
                    13
                  ],
                  [
                    1.2,
                    11.9
                  ],
                  [
                    1.2,
                    11.9
                  ],
                  [
                    1.2,
                    3.2
                  ],
                  [
                    2.3,
                    3.2
                  ],
                  [
                    2.3,
                    11.9
                  ],
                  [
                    2.4,
                    12.3
                  ],
                  [
                    2.6,
                    12.5
                  ],
                  [
                    2.6,
                    12.5
                  ],
                  [
                    2.7,
                    12.4
                  ],
                  [
                    2.9,
                    12.4
                  ],
                  [
                    2.9,
                    12.4
                  ],
                  [
                    3,
                    13.3
                  ],
                  [
                    2.8,
                    13.4
                  ],
                  [
                    2.4,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 580,
        ty: 3,
        parent: 563,
        ks: {
          p: {
            a: 0,
            k: [
              21.629,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 583,
        ty: 4,
        parent: 582,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    13.2
                  ],
                  [
                    1.2,
                    13.2
                  ],
                  [
                    1.2,
                    3.2
                  ],
                  [
                    2.3,
                    3.2
                  ],
                  [
                    2.3,
                    5.9
                  ],
                  [
                    2.3,
                    7.3
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    4.6,
                    6.2
                  ],
                  [
                    4.6,
                    6.2
                  ],
                  [
                    6.1,
                    6.9
                  ],
                  [
                    6.6,
                    8.9
                  ],
                  [
                    6.6,
                    8.9
                  ],
                  [
                    6.6,
                    13.2
                  ],
                  [
                    5.5,
                    13.2
                  ],
                  [
                    5.5,
                    9.1
                  ],
                  [
                    5.2,
                    7.7
                  ],
                  [
                    4.2,
                    7.2
                  ],
                  [
                    4.2,
                    7.2
                  ],
                  [
                    3.3,
                    7.5
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    2.3,
                    13.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 582,
        ty: 3,
        parent: 563,
        ks: {
          p: {
            a: 0,
            k: [
              13.959,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 585,
        ty: 4,
        parent: 584,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.9,
                    13.4
                  ],
                  [
                    3.9,
                    13.4
                  ],
                  [
                    2.2,
                    13
                  ],
                  [
                    1.1,
                    11.8
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    1.1,
                    7.9
                  ],
                  [
                    2.3,
                    6.6
                  ],
                  [
                    3.9,
                    6.2
                  ],
                  [
                    3.9,
                    6.2
                  ],
                  [
                    5.1,
                    6.5
                  ],
                  [
                    6,
                    7
                  ],
                  [
                    6,
                    7
                  ],
                  [
                    5.4,
                    7.8
                  ],
                  [
                    4.7,
                    7.3
                  ],
                  [
                    4,
                    7.2
                  ],
                  [
                    4,
                    7.2
                  ],
                  [
                    2.9,
                    7.5
                  ],
                  [
                    2.1,
                    8.4
                  ],
                  [
                    1.8,
                    9.8
                  ],
                  [
                    1.8,
                    9.8
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    4,
                    12.5
                  ],
                  [
                    4,
                    12.5
                  ],
                  [
                    4.9,
                    12.2
                  ],
                  [
                    5.6,
                    11.8
                  ],
                  [
                    5.6,
                    11.8
                  ],
                  [
                    6.1,
                    12.5
                  ],
                  [
                    5.1,
                    13.2
                  ],
                  [
                    3.9,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 584,
        ty: 3,
        parent: 563,
        ks: {
          p: {
            a: 0,
            k: [
              7.529,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 587,
        ty: 4,
        parent: 586,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.8,
                    13.4
                  ],
                  [
                    3.8,
                    13.4
                  ],
                  [
                    2,
                    13
                  ],
                  [
                    0.6,
                    12
                  ],
                  [
                    0.6,
                    12
                  ],
                  [
                    1.3,
                    11.2
                  ],
                  [
                    2.5,
                    12.1
                  ],
                  [
                    3.9,
                    12.4
                  ],
                  [
                    3.9,
                    12.4
                  ],
                  [
                    5.3,
                    12
                  ],
                  [
                    5.8,
                    10.9
                  ],
                  [
                    5.8,
                    10.9
                  ],
                  [
                    5.6,
                    10.1
                  ],
                  [
                    5,
                    9.6
                  ],
                  [
                    4.2,
                    9.2
                  ],
                  [
                    4.2,
                    9.2
                  ],
                  [
                    2.9,
                    8.7
                  ],
                  [
                    2.1,
                    8.2
                  ],
                  [
                    1.3,
                    7.4
                  ],
                  [
                    1,
                    6.3
                  ],
                  [
                    1,
                    6.3
                  ],
                  [
                    1.4,
                    5
                  ],
                  [
                    2.5,
                    4.1
                  ],
                  [
                    3.9,
                    3.8
                  ],
                  [
                    3.9,
                    3.8
                  ],
                  [
                    5.5,
                    4.1
                  ],
                  [
                    6.7,
                    5
                  ],
                  [
                    6.7,
                    5
                  ],
                  [
                    6.1,
                    5.7
                  ],
                  [
                    5.1,
                    5.1
                  ],
                  [
                    3.9,
                    4.9
                  ],
                  [
                    3.9,
                    4.9
                  ],
                  [
                    2.7,
                    5.2
                  ],
                  [
                    2.2,
                    6.2
                  ],
                  [
                    2.2,
                    6.2
                  ],
                  [
                    2.5,
                    6.9
                  ],
                  [
                    3,
                    7.4
                  ],
                  [
                    3.8,
                    7.7
                  ],
                  [
                    3.8,
                    7.7
                  ],
                  [
                    5.1,
                    8.3
                  ],
                  [
                    6,
                    8.8
                  ],
                  [
                    6.7,
                    9.6
                  ],
                  [
                    7,
                    10.8
                  ],
                  [
                    7,
                    10.8
                  ],
                  [
                    6.6,
                    12.1
                  ],
                  [
                    5.5,
                    13.1
                  ],
                  [
                    3.8,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.6,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 586,
        ty: 3,
        parent: 563,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 563,
        ty: 3,
        parent: 562,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 562,
        ty: 3,
        parent: 561,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 561,
        ty: 3,
        parent: 560,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              14.988
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 592,
        ty: 0,
        parent: 588,
        ks: {},
        w: 81,
        h: 15,
        ip: 0,
        op: 565,
        st: 0,
        refId: "590"
      },
      {
        ind: 588,
        ty: 3,
        parent: 560,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 560,
        ty: 3,
        parent: 461,
        ks: {
          p: {
            a: 0,
            k: [
              27.646,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 461,
        ty: 3,
        parent: 393,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 393,
        ty: 3,
        parent: 392,
        ks: {
          p: {
            a: 0,
            k: [
              10.58,
              102.27
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 601,
        ty: 4,
        parent: 600,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    1,
                    3.2
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    2,
                    3.2
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2,
                    4.2
                  ],
                  [
                    1.5,
                    4.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 600,
        ty: 3,
        parent: 599,
        ks: {
          p: {
            a: 0,
            k: [
              38.957,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 603,
        ty: 4,
        parent: 602,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -1.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.3
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.5,
                    8.5
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.2,
                    7.1
                  ],
                  [
                    3.8,
                    6.5
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    2.1,
                    6.5
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    0.9,
                    6.2
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    11.6
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    3.5,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    10.9
                  ],
                  [
                    2.7,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    8.5
                  ],
                  [
                    2.2,
                    9
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.9,
                    10.7
                  ],
                  [
                    2.7,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 602,
        ty: 3,
        parent: 599,
        ks: {
          p: {
            a: 0,
            k: [
              32.738,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 605,
        ty: 4,
        parent: 604,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.6
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.7,
                    11.7
                  ],
                  [
                    3.7,
                    11.7
                  ],
                  [
                    2.8,
                    11.5
                  ],
                  [
                    2,
                    11
                  ],
                  [
                    2,
                    11
                  ],
                  [
                    1.9,
                    11
                  ],
                  [
                    1.8,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    2.8
                  ],
                  [
                    2,
                    2.8
                  ],
                  [
                    2,
                    5.2
                  ],
                  [
                    2,
                    6.3
                  ],
                  [
                    2.9,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    5.7,
                    6.3
                  ],
                  [
                    6.3,
                    8.5
                  ],
                  [
                    6.3,
                    8.5
                  ],
                  [
                    5.9,
                    10.2
                  ],
                  [
                    4.9,
                    11.4
                  ],
                  [
                    3.7,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    -0.2,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    10.9
                  ],
                  [
                    3.5,
                    10.9
                  ],
                  [
                    4.7,
                    10.2
                  ],
                  [
                    5.2,
                    8.5
                  ],
                  [
                    5.2,
                    8.5
                  ],
                  [
                    4.8,
                    6.9
                  ],
                  [
                    3.6,
                    6.3
                  ],
                  [
                    3.6,
                    6.3
                  ],
                  [
                    2.9,
                    6.5
                  ],
                  [
                    2,
                    7.1
                  ],
                  [
                    2,
                    7.1
                  ],
                  [
                    2,
                    10.3
                  ],
                  [
                    2.8,
                    10.7
                  ],
                  [
                    3.5,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 604,
        ty: 3,
        parent: 599,
        ks: {
          p: {
            a: 0,
            k: [
              25.914,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 607,
        ty: 4,
        parent: 606,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.5
                  ],
                  [
                    2,
                    6.5
                  ],
                  [
                    2.8,
                    5.7
                  ],
                  [
                    3.8,
                    5.4
                  ],
                  [
                    3.8,
                    5.4
                  ],
                  [
                    4.9,
                    5.7
                  ],
                  [
                    5.5,
                    6.6
                  ],
                  [
                    5.5,
                    6.6
                  ],
                  [
                    6.4,
                    5.8
                  ],
                  [
                    7.5,
                    5.4
                  ],
                  [
                    7.5,
                    5.4
                  ],
                  [
                    8.8,
                    6
                  ],
                  [
                    9.3,
                    7.8
                  ],
                  [
                    9.3,
                    7.8
                  ],
                  [
                    9.3,
                    11.6
                  ],
                  [
                    8.3,
                    11.6
                  ],
                  [
                    8.3,
                    7.9
                  ],
                  [
                    8,
                    6.7
                  ],
                  [
                    7.2,
                    6.3
                  ],
                  [
                    7.2,
                    6.3
                  ],
                  [
                    5.7,
                    7.2
                  ],
                  [
                    5.7,
                    7.2
                  ],
                  [
                    5.7,
                    11.6
                  ],
                  [
                    4.7,
                    11.6
                  ],
                  [
                    4.7,
                    7.9
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    3.5,
                    6.3
                  ],
                  [
                    3.5,
                    6.3
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 606,
        ty: 3,
        parent: 599,
        ks: {
          p: {
            a: 0,
            k: [
              15.684,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 609,
        ty: 4,
        parent: 608,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    11.7
                  ],
                  [
                    2.8,
                    11.7
                  ],
                  [
                    1.4,
                    11.1
                  ],
                  [
                    0.9,
                    9.4
                  ],
                  [
                    0.9,
                    9.4
                  ],
                  [
                    0.9,
                    5.6
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    2,
                    9.3
                  ],
                  [
                    2.2,
                    10.5
                  ],
                  [
                    3.1,
                    10.9
                  ],
                  [
                    3.1,
                    10.9
                  ],
                  [
                    3.9,
                    10.6
                  ],
                  [
                    4.7,
                    9.8
                  ],
                  [
                    4.7,
                    9.8
                  ],
                  [
                    4.7,
                    5.6
                  ],
                  [
                    5.7,
                    5.6
                  ],
                  [
                    5.7,
                    11.6
                  ],
                  [
                    4.9,
                    11.6
                  ],
                  [
                    4.8,
                    10.6
                  ],
                  [
                    4.7,
                    10.6
                  ],
                  [
                    3.9,
                    11.4
                  ],
                  [
                    2.8,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 608,
        ty: 3,
        parent: 599,
        ks: {
          p: {
            a: 0,
            k: [
              8.971,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 611,
        ty: 4,
        parent: 610,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    3.5
                  ],
                  [
                    2.3,
                    3.5
                  ],
                  [
                    3.9,
                    7.8
                  ],
                  [
                    4.2,
                    8.7
                  ],
                  [
                    4.5,
                    9.5
                  ],
                  [
                    4.5,
                    9.5
                  ],
                  [
                    4.5,
                    9.5
                  ],
                  [
                    4.8,
                    8.7
                  ],
                  [
                    5.1,
                    7.8
                  ],
                  [
                    5.1,
                    7.8
                  ],
                  [
                    6.6,
                    3.5
                  ],
                  [
                    7.9,
                    3.5
                  ],
                  [
                    7.9,
                    11.6
                  ],
                  [
                    6.9,
                    11.6
                  ],
                  [
                    6.9,
                    7.1
                  ],
                  [
                    6.9,
                    5.9
                  ],
                  [
                    7,
                    4.7
                  ],
                  [
                    7,
                    4.7
                  ],
                  [
                    7,
                    4.7
                  ],
                  [
                    6.3,
                    6.6
                  ],
                  [
                    4.8,
                    10.8
                  ],
                  [
                    4.1,
                    10.8
                  ],
                  [
                    2.6,
                    6.6
                  ],
                  [
                    2,
                    4.7
                  ],
                  [
                    1.9,
                    4.7
                  ],
                  [
                    2,
                    5.9
                  ],
                  [
                    2,
                    7.1
                  ],
                  [
                    2,
                    7.1
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 610,
        ty: 3,
        parent: 599,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 599,
        ty: 3,
        parent: 598,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 598,
        ty: 3,
        parent: 597,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 597,
        ty: 3,
        parent: 596,
        ks: {
          p: {
            a: 0,
            k: [
              21.159,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 621,
        ty: 0,
        parent: 612,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "619"
      },
      {
        ind: 612,
        ty: 3,
        parent: 596,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 596,
        ty: 3,
        parent: 595,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              19.527
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 627,
        ty: 4,
        parent: 626,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.9,
                    11.7
                  ],
                  [
                    2.9,
                    11.7
                  ],
                  [
                    1.6,
                    11.2
                  ],
                  [
                    1.2,
                    9.7
                  ],
                  [
                    1.2,
                    9.7
                  ],
                  [
                    1.2,
                    6.4
                  ],
                  [
                    0.3,
                    6.4
                  ],
                  [
                    0.3,
                    5.7
                  ],
                  [
                    1.2,
                    5.6
                  ],
                  [
                    1.4,
                    3.9
                  ],
                  [
                    2.2,
                    3.9
                  ],
                  [
                    2.2,
                    5.6
                  ],
                  [
                    3.8,
                    5.6
                  ],
                  [
                    3.8,
                    6.4
                  ],
                  [
                    2.2,
                    6.4
                  ],
                  [
                    2.2,
                    9.7
                  ],
                  [
                    2.4,
                    10.6
                  ],
                  [
                    3.1,
                    10.9
                  ],
                  [
                    3.1,
                    10.9
                  ],
                  [
                    3.5,
                    10.9
                  ],
                  [
                    3.8,
                    10.7
                  ],
                  [
                    3.8,
                    10.7
                  ],
                  [
                    4,
                    11.5
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2.9,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 626,
        ty: 3,
        parent: 625,
        ks: {
          p: {
            a: 0,
            k: [
              40.5,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 629,
        ty: 4,
        parent: 628,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    2.6,
                    11.7
                  ],
                  [
                    2.6,
                    11.7
                  ],
                  [
                    1.4,
                    11.5
                  ],
                  [
                    0.3,
                    10.9
                  ],
                  [
                    0.3,
                    10.9
                  ],
                  [
                    0.9,
                    10.2
                  ],
                  [
                    1.7,
                    10.7
                  ],
                  [
                    2.6,
                    10.9
                  ],
                  [
                    2.6,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    3.8,
                    10
                  ],
                  [
                    3.8,
                    10
                  ],
                  [
                    3.6,
                    9.5
                  ],
                  [
                    3.1,
                    9.1
                  ],
                  [
                    2.4,
                    8.9
                  ],
                  [
                    2.4,
                    8.9
                  ],
                  [
                    1.6,
                    8.5
                  ],
                  [
                    0.9,
                    8
                  ],
                  [
                    0.7,
                    7.1
                  ],
                  [
                    0.7,
                    7.1
                  ],
                  [
                    1.2,
                    5.9
                  ],
                  [
                    2.8,
                    5.4
                  ],
                  [
                    2.8,
                    5.4
                  ],
                  [
                    3.8,
                    5.6
                  ],
                  [
                    4.6,
                    6.1
                  ],
                  [
                    4.6,
                    6.1
                  ],
                  [
                    4.1,
                    6.8
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    2.8,
                    6.2
                  ],
                  [
                    2.8,
                    6.2
                  ],
                  [
                    1.9,
                    6.5
                  ],
                  [
                    1.7,
                    7.1
                  ],
                  [
                    1.7,
                    7.1
                  ],
                  [
                    1.8,
                    7.6
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.9,
                    8.1
                  ],
                  [
                    2.9,
                    8.1
                  ],
                  [
                    3.8,
                    8.5
                  ],
                  [
                    4.5,
                    9
                  ],
                  [
                    4.8,
                    9.9
                  ],
                  [
                    4.8,
                    9.9
                  ],
                  [
                    4.5,
                    10.8
                  ],
                  [
                    3.8,
                    11.5
                  ],
                  [
                    2.6,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 628,
        ty: 3,
        parent: 625,
        ks: {
          p: {
            a: 0,
            k: [
              35.329,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 631,
        ty: 4,
        parent: 630,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    1,
                    3.2
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    2,
                    3.2
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2,
                    4.2
                  ],
                  [
                    1.5,
                    4.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 630,
        ty: 3,
        parent: 625,
        ks: {
          p: {
            a: 0,
            k: [
              32.294,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 633,
        ty: 4,
        parent: 632,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.9,
                    11.7
                  ],
                  [
                    2.9,
                    11.7
                  ],
                  [
                    1.6,
                    11.2
                  ],
                  [
                    1.2,
                    9.7
                  ],
                  [
                    1.2,
                    9.7
                  ],
                  [
                    1.2,
                    6.4
                  ],
                  [
                    0.3,
                    6.4
                  ],
                  [
                    0.3,
                    5.7
                  ],
                  [
                    1.2,
                    5.6
                  ],
                  [
                    1.4,
                    3.9
                  ],
                  [
                    2.2,
                    3.9
                  ],
                  [
                    2.2,
                    5.6
                  ],
                  [
                    3.8,
                    5.6
                  ],
                  [
                    3.8,
                    6.4
                  ],
                  [
                    2.2,
                    6.4
                  ],
                  [
                    2.2,
                    9.7
                  ],
                  [
                    2.4,
                    10.6
                  ],
                  [
                    3.1,
                    10.9
                  ],
                  [
                    3.1,
                    10.9
                  ],
                  [
                    3.5,
                    10.9
                  ],
                  [
                    3.8,
                    10.7
                  ],
                  [
                    3.8,
                    10.7
                  ],
                  [
                    4,
                    11.5
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2.9,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 632,
        ty: 3,
        parent: 625,
        ks: {
          p: {
            a: 0,
            k: [
              28.123,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 635,
        ty: 4,
        parent: 634,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.5
                  ],
                  [
                    2,
                    6.5
                  ],
                  [
                    2.9,
                    5.7
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    5.4,
                    6
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    4.8,
                    7.9
                  ],
                  [
                    4.5,
                    6.7
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    2.8,
                    6.6
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 634,
        ty: 3,
        parent: 625,
        ks: {
          p: {
            a: 0,
            k: [
              21.373,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 637,
        ty: 4,
        parent: 636,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.2
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.6,
                    8.6
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    1.6,
                    8.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.4,
                    11.1
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.6
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.1
                  ],
                  [
                    1.6,
                    8.1
                  ],
                  [
                    4.8,
                    8.1
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.6,
                    8.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 636,
        ty: 3,
        parent: 625,
        ks: {
          p: {
            a: 0,
            k: [
              15.252,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 639,
        ty: 4,
        parent: 638,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    1,
                    3.2
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    2,
                    3.2
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2,
                    4.2
                  ],
                  [
                    1.5,
                    4.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 638,
        ty: 3,
        parent: 625,
        ks: {
          p: {
            a: 0,
            k: [
              12.217,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 641,
        ty: 4,
        parent: 640,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    4.5,
                    5.7
                  ],
                  [
                    5.2,
                    6.1
                  ],
                  [
                    5.2,
                    6.1
                  ],
                  [
                    4.7,
                    6.8
                  ],
                  [
                    4.1,
                    6.4
                  ],
                  [
                    3.5,
                    6.3
                  ],
                  [
                    3.5,
                    6.3
                  ],
                  [
                    2.5,
                    6.6
                  ],
                  [
                    1.9,
                    7.4
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    2.1,
                    10.3
                  ],
                  [
                    3.5,
                    10.9
                  ],
                  [
                    3.5,
                    10.9
                  ],
                  [
                    4.2,
                    10.7
                  ],
                  [
                    4.9,
                    10.3
                  ],
                  [
                    4.9,
                    10.3
                  ],
                  [
                    5.3,
                    11
                  ],
                  [
                    4.4,
                    11.5
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 640,
        ty: 3,
        parent: 625,
        ks: {
          p: {
            a: 0,
            k: [
              6.59,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 643,
        ty: 4,
        parent: 642,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    1.1,
                    9.8
                  ],
                  [
                    2.2,
                    10.6
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    4.6,
                    10.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    4.9,
                    8.8
                  ],
                  [
                    4.4,
                    8.4
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    2.6,
                    7.6
                  ],
                  [
                    1.8,
                    7.2
                  ],
                  [
                    1.2,
                    6.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    1.2,
                    4.4
                  ],
                  [
                    2.1,
                    3.6
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    4.8,
                    3.6
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.3,
                    5
                  ],
                  [
                    4.5,
                    4.4
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    2.4,
                    4.6
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2.2,
                    6.1
                  ],
                  [
                    2.7,
                    6.5
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    4.4,
                    7.3
                  ],
                  [
                    5.3,
                    7.7
                  ],
                  [
                    5.9,
                    8.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    5.8,
                    10.6
                  ],
                  [
                    4.8,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 642,
        ty: 3,
        parent: 625,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 625,
        ty: 3,
        parent: 624,
        ks: {
          p: {
            a: 0,
            k: [
              69.647,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 646,
        ty: 4,
        parent: 645,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -1.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.3
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.5,
                    8.5
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.2,
                    7.1
                  ],
                  [
                    3.8,
                    6.5
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    2.1,
                    6.5
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    0.9,
                    6.2
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    11.6
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    3.5,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    10.9
                  ],
                  [
                    2.7,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    8.5
                  ],
                  [
                    2.2,
                    9
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.9,
                    10.7
                  ],
                  [
                    2.7,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 645,
        ty: 3,
        parent: 644,
        ks: {
          p: {
            a: 0,
            k: [
              17.979,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 648,
        ty: 4,
        parent: 647,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.9,
                    11.7
                  ],
                  [
                    2.9,
                    11.7
                  ],
                  [
                    1.6,
                    11.2
                  ],
                  [
                    1.2,
                    9.7
                  ],
                  [
                    1.2,
                    9.7
                  ],
                  [
                    1.2,
                    6.4
                  ],
                  [
                    0.3,
                    6.4
                  ],
                  [
                    0.3,
                    5.7
                  ],
                  [
                    1.2,
                    5.6
                  ],
                  [
                    1.4,
                    3.9
                  ],
                  [
                    2.2,
                    3.9
                  ],
                  [
                    2.2,
                    5.6
                  ],
                  [
                    3.8,
                    5.6
                  ],
                  [
                    3.8,
                    6.4
                  ],
                  [
                    2.2,
                    6.4
                  ],
                  [
                    2.2,
                    9.7
                  ],
                  [
                    2.4,
                    10.6
                  ],
                  [
                    3.1,
                    10.9
                  ],
                  [
                    3.1,
                    10.9
                  ],
                  [
                    3.5,
                    10.9
                  ],
                  [
                    3.8,
                    10.7
                  ],
                  [
                    3.8,
                    10.7
                  ],
                  [
                    4,
                    11.5
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2.9,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 647,
        ty: 3,
        parent: 644,
        ks: {
          p: {
            a: 0,
            k: [
              13.808,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 650,
        ty: 4,
        parent: 649,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -1.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.3
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.5,
                    8.5
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.2,
                    7.1
                  ],
                  [
                    3.8,
                    6.5
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    2.1,
                    6.5
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    0.9,
                    6.2
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    11.6
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    3.5,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    10.9
                  ],
                  [
                    2.7,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    8.5
                  ],
                  [
                    2.2,
                    9
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.9,
                    10.7
                  ],
                  [
                    2.7,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 649,
        ty: 3,
        parent: 644,
        ks: {
          p: {
            a: 0,
            k: [
              7.589,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 652,
        ty: 4,
        parent: 651,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    -0.7
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.7
                  ],
                  [
                    1.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    3.5
                  ],
                  [
                    3.1,
                    3.5
                  ],
                  [
                    6,
                    4.5
                  ],
                  [
                    7,
                    7.5
                  ],
                  [
                    7,
                    7.5
                  ],
                  [
                    6,
                    10.5
                  ],
                  [
                    3.2,
                    11.6
                  ],
                  [
                    3.2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1.3,
                    0
                  ],
                  [
                    0.7,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    -0.6,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.6
                  ],
                  [
                    0,
                    1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.5
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    4.3
                  ],
                  [
                    2.1,
                    10.7
                  ],
                  [
                    3.1,
                    10.7
                  ],
                  [
                    5.2,
                    9.9
                  ],
                  [
                    5.9,
                    7.5
                  ],
                  [
                    5.9,
                    7.5
                  ],
                  [
                    5.2,
                    5.2
                  ],
                  [
                    3.1,
                    4.3
                  ],
                  [
                    3.1,
                    4.3
                  ],
                  [
                    2.1,
                    4.3
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0.5,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    -0.5,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 651,
        ty: 3,
        parent: 644,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 644,
        ty: 3,
        parent: 624,
        ks: {
          p: {
            a: 0,
            k: [
              42.98,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 655,
        ty: 4,
        parent: 654,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.5
                  ],
                  [
                    2,
                    6.5
                  ],
                  [
                    2.9,
                    5.7
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    5.4,
                    6
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    4.8,
                    7.9
                  ],
                  [
                    4.5,
                    6.7
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    2.8,
                    6.6
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 654,
        ty: 3,
        parent: 653,
        ks: {
          p: {
            a: 0,
            k: [
              33.762,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 657,
        ty: 4,
        parent: 656,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    1,
                    3.2
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    2,
                    3.2
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2,
                    4.2
                  ],
                  [
                    1.5,
                    4.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 656,
        ty: 3,
        parent: 653,
        ks: {
          p: {
            a: 0,
            k: [
              30.727,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 659,
        ty: 4,
        parent: 658,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -1.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.3
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.5,
                    8.5
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.2,
                    7.1
                  ],
                  [
                    3.8,
                    6.5
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    2.1,
                    6.5
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    0.9,
                    6.2
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    11.6
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    3.5,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    10.9
                  ],
                  [
                    2.7,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    8.5
                  ],
                  [
                    2.2,
                    9
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.9,
                    10.7
                  ],
                  [
                    2.7,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 658,
        ty: 3,
        parent: 653,
        ks: {
          p: {
            a: 0,
            k: [
              24.507,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 661,
        ty: 4,
        parent: 660,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.5
                  ],
                  [
                    2,
                    6.5
                  ],
                  [
                    2.8,
                    5.7
                  ],
                  [
                    3.8,
                    5.4
                  ],
                  [
                    3.8,
                    5.4
                  ],
                  [
                    4.9,
                    5.7
                  ],
                  [
                    5.5,
                    6.6
                  ],
                  [
                    5.5,
                    6.6
                  ],
                  [
                    6.4,
                    5.8
                  ],
                  [
                    7.5,
                    5.4
                  ],
                  [
                    7.5,
                    5.4
                  ],
                  [
                    8.8,
                    6
                  ],
                  [
                    9.3,
                    7.8
                  ],
                  [
                    9.3,
                    7.8
                  ],
                  [
                    9.3,
                    11.6
                  ],
                  [
                    8.3,
                    11.6
                  ],
                  [
                    8.3,
                    7.9
                  ],
                  [
                    8,
                    6.7
                  ],
                  [
                    7.2,
                    6.3
                  ],
                  [
                    7.2,
                    6.3
                  ],
                  [
                    5.7,
                    7.2
                  ],
                  [
                    5.7,
                    7.2
                  ],
                  [
                    5.7,
                    11.6
                  ],
                  [
                    4.7,
                    11.6
                  ],
                  [
                    4.7,
                    7.9
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    3.5,
                    6.3
                  ],
                  [
                    3.5,
                    6.3
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 660,
        ty: 3,
        parent: 653,
        ks: {
          p: {
            a: 0,
            k: [
              14.277,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 663,
        ty: 4,
        parent: 662,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    11.7
                  ],
                  [
                    3.3,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.8
                  ],
                  [
                    5.7,
                    6.9
                  ],
                  [
                    6.1,
                    8.6
                  ],
                  [
                    6.1,
                    8.6
                  ],
                  [
                    5.7,
                    10.3
                  ],
                  [
                    4.7,
                    11.4
                  ],
                  [
                    3.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    10.9
                  ],
                  [
                    3.3,
                    10.9
                  ],
                  [
                    4.6,
                    10.3
                  ],
                  [
                    5.1,
                    8.6
                  ],
                  [
                    5.1,
                    8.6
                  ],
                  [
                    4.6,
                    6.9
                  ],
                  [
                    3.3,
                    6.3
                  ],
                  [
                    3.3,
                    6.3
                  ],
                  [
                    2.1,
                    6.9
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    2.1,
                    10.3
                  ],
                  [
                    3.3,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 662,
        ty: 3,
        parent: 653,
        ks: {
          p: {
            a: 0,
            k: [
              7.589,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 665,
        ty: 4,
        parent: 664,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    -0.7
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.7
                  ],
                  [
                    1.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    3.5
                  ],
                  [
                    3.1,
                    3.5
                  ],
                  [
                    6,
                    4.5
                  ],
                  [
                    7,
                    7.5
                  ],
                  [
                    7,
                    7.5
                  ],
                  [
                    6,
                    10.5
                  ],
                  [
                    3.2,
                    11.6
                  ],
                  [
                    3.2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1.3,
                    0
                  ],
                  [
                    0.7,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    -0.6,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.6
                  ],
                  [
                    0,
                    1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.5
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    4.3
                  ],
                  [
                    2.1,
                    10.7
                  ],
                  [
                    3.1,
                    10.7
                  ],
                  [
                    5.2,
                    9.9
                  ],
                  [
                    5.9,
                    7.5
                  ],
                  [
                    5.9,
                    7.5
                  ],
                  [
                    5.2,
                    5.2
                  ],
                  [
                    3.1,
                    4.3
                  ],
                  [
                    3.1,
                    4.3
                  ],
                  [
                    2.1,
                    4.3
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0.5,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    -0.5,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 664,
        ty: 3,
        parent: 653,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 653,
        ty: 3,
        parent: 624,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 624,
        ty: 3,
        parent: 623,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.8
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 623,
        ty: 3,
        parent: 622,
        ks: {
          p: {
            a: 0,
            k: [
              21.159,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 675,
        ty: 0,
        parent: 666,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "673"
      },
      {
        ind: 666,
        ty: 3,
        parent: 622,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 622,
        ty: 3,
        parent: 595,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 595,
        ty: 3,
        parent: 594,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              36.053
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 681,
        ty: 4,
        parent: 680,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    2.7,
                    12
                  ],
                  [
                    2.8,
                    13
                  ],
                  [
                    2.9,
                    13
                  ],
                  [
                    4,
                    12.1
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    7.2,
                    12.6
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    19.7
                  ],
                  [
                    6,
                    19.7
                  ],
                  [
                    6,
                    15.1
                  ],
                  [
                    5.7,
                    13.7
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    3.9,
                    13.6
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 680,
        ty: 3,
        parent: 679,
        ks: {
          p: {
            a: 0,
            k: [
              45.344,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 683,
        ty: 4,
        parent: 682,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    3,
                    12
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    10.6
                  ],
                  [
                    2.1,
                    10.6
                  ],
                  [
                    1.3,
                    10.3
                  ],
                  [
                    1,
                    9.5
                  ],
                  [
                    1,
                    9.5
                  ],
                  [
                    1.3,
                    8.8
                  ],
                  [
                    2.1,
                    8.5
                  ],
                  [
                    2.1,
                    8.5
                  ],
                  [
                    2.9,
                    8.8
                  ],
                  [
                    3.2,
                    9.5
                  ],
                  [
                    3.2,
                    9.5
                  ],
                  [
                    2.9,
                    10.3
                  ],
                  [
                    2.1,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 682,
        ty: 3,
        parent: 679,
        ks: {
          p: {
            a: 0,
            k: [
              41.188,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 685,
        ty: 4,
        parent: 684,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0.5
                  ],
                  [
                    -1.6,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    -1.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.9
                  ],
                  [
                    3,
                    19.9
                  ],
                  [
                    1.4,
                    19.3
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    1.8,
                    15.7
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5,
                    13.7
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    2.8,
                    13.5
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1,
                    12.8
                  ],
                  [
                    2.5,
                    12.1
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    6.4,
                    12.6
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    19.7
                  ],
                  [
                    5.6,
                    19.7
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    4.3,
                    19.6
                  ],
                  [
                    3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.7,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.6,
                    18.5
                  ],
                  [
                    3.6,
                    18.5
                  ],
                  [
                    4.5,
                    18.3
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    15.9
                  ],
                  [
                    3.1,
                    16.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.8,
                    18.3
                  ],
                  [
                    3.6,
                    18.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 684,
        ty: 3,
        parent: 679,
        ks: {
          p: {
            a: 0,
            k: [
              33.005,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 687,
        ty: 4,
        parent: 686,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.4
                  ],
                  [
                    -0.9,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.4,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.5
                  ],
                  [
                    1,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    19.9
                  ],
                  [
                    3.3,
                    19.9
                  ],
                  [
                    1.7,
                    19.6
                  ],
                  [
                    0.4,
                    18.9
                  ],
                  [
                    0.4,
                    18.9
                  ],
                  [
                    1.2,
                    17.7
                  ],
                  [
                    2.3,
                    18.3
                  ],
                  [
                    3.4,
                    18.6
                  ],
                  [
                    3.4,
                    18.6
                  ],
                  [
                    4.3,
                    18.3
                  ],
                  [
                    4.6,
                    17.6
                  ],
                  [
                    4.6,
                    17.6
                  ],
                  [
                    4.4,
                    17.1
                  ],
                  [
                    3.8,
                    16.7
                  ],
                  [
                    3,
                    16.4
                  ],
                  [
                    3,
                    16.4
                  ],
                  [
                    2,
                    15.9
                  ],
                  [
                    1.1,
                    15.2
                  ],
                  [
                    0.8,
                    14.1
                  ],
                  [
                    0.8,
                    14.1
                  ],
                  [
                    1.6,
                    12.4
                  ],
                  [
                    3.6,
                    11.8
                  ],
                  [
                    3.6,
                    11.8
                  ],
                  [
                    5.1,
                    12.1
                  ],
                  [
                    6.3,
                    12.7
                  ],
                  [
                    6.3,
                    12.7
                  ],
                  [
                    5.4,
                    13.8
                  ],
                  [
                    4.6,
                    13.3
                  ],
                  [
                    3.7,
                    13.1
                  ],
                  [
                    3.7,
                    13.1
                  ],
                  [
                    2.8,
                    13.4
                  ],
                  [
                    2.5,
                    14
                  ],
                  [
                    2.5,
                    14
                  ],
                  [
                    3,
                    14.7
                  ],
                  [
                    4.1,
                    15.2
                  ],
                  [
                    4.1,
                    15.2
                  ],
                  [
                    5.2,
                    15.6
                  ],
                  [
                    6,
                    16.4
                  ],
                  [
                    6.4,
                    17.5
                  ],
                  [
                    6.4,
                    17.5
                  ],
                  [
                    5.6,
                    19.2
                  ],
                  [
                    3.3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.5,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    -0.5,
                    0.5
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 686,
        ty: 3,
        parent: 679,
        ks: {
          p: {
            a: 0,
            k: [
              26.169,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 689,
        ty: 4,
        parent: 688,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.4
                  ],
                  [
                    -0.9,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.4,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.5
                  ],
                  [
                    1,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    19.9
                  ],
                  [
                    3.3,
                    19.9
                  ],
                  [
                    1.7,
                    19.6
                  ],
                  [
                    0.4,
                    18.9
                  ],
                  [
                    0.4,
                    18.9
                  ],
                  [
                    1.2,
                    17.7
                  ],
                  [
                    2.3,
                    18.3
                  ],
                  [
                    3.4,
                    18.6
                  ],
                  [
                    3.4,
                    18.6
                  ],
                  [
                    4.3,
                    18.3
                  ],
                  [
                    4.6,
                    17.6
                  ],
                  [
                    4.6,
                    17.6
                  ],
                  [
                    4.4,
                    17.1
                  ],
                  [
                    3.8,
                    16.7
                  ],
                  [
                    3,
                    16.4
                  ],
                  [
                    3,
                    16.4
                  ],
                  [
                    2,
                    15.9
                  ],
                  [
                    1.1,
                    15.2
                  ],
                  [
                    0.8,
                    14.1
                  ],
                  [
                    0.8,
                    14.1
                  ],
                  [
                    1.6,
                    12.4
                  ],
                  [
                    3.6,
                    11.8
                  ],
                  [
                    3.6,
                    11.8
                  ],
                  [
                    5.1,
                    12.1
                  ],
                  [
                    6.3,
                    12.7
                  ],
                  [
                    6.3,
                    12.7
                  ],
                  [
                    5.4,
                    13.8
                  ],
                  [
                    4.6,
                    13.3
                  ],
                  [
                    3.7,
                    13.1
                  ],
                  [
                    3.7,
                    13.1
                  ],
                  [
                    2.8,
                    13.4
                  ],
                  [
                    2.5,
                    14
                  ],
                  [
                    2.5,
                    14
                  ],
                  [
                    3,
                    14.7
                  ],
                  [
                    4.1,
                    15.2
                  ],
                  [
                    4.1,
                    15.2
                  ],
                  [
                    5.2,
                    15.6
                  ],
                  [
                    6,
                    16.4
                  ],
                  [
                    6.4,
                    17.5
                  ],
                  [
                    6.4,
                    17.5
                  ],
                  [
                    5.6,
                    19.2
                  ],
                  [
                    3.3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.5,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    -0.5,
                    0.5
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 688,
        ty: 3,
        parent: 679,
        ks: {
          p: {
            a: 0,
            k: [
              19.333,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 691,
        ty: 4,
        parent: 690,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    19.9
                  ],
                  [
                    3.5,
                    19.9
                  ],
                  [
                    1.7,
                    19.1
                  ],
                  [
                    1.1,
                    16.8
                  ],
                  [
                    1.1,
                    16.8
                  ],
                  [
                    1.1,
                    12
                  ],
                  [
                    2.9,
                    12
                  ],
                  [
                    2.9,
                    16.6
                  ],
                  [
                    3.2,
                    18
                  ],
                  [
                    4.1,
                    18.4
                  ],
                  [
                    4.1,
                    18.4
                  ],
                  [
                    5,
                    18.1
                  ],
                  [
                    5.8,
                    17.3
                  ],
                  [
                    5.8,
                    17.3
                  ],
                  [
                    5.8,
                    12
                  ],
                  [
                    7.7,
                    12
                  ],
                  [
                    7.7,
                    19.7
                  ],
                  [
                    6.2,
                    19.7
                  ],
                  [
                    6,
                    18.6
                  ],
                  [
                    6,
                    18.6
                  ],
                  [
                    4.9,
                    19.6
                  ],
                  [
                    3.5,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 690,
        ty: 3,
        parent: 679,
        ks: {
          p: {
            a: 0,
            k: [
              10.515,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 693,
        ty: 4,
        parent: 692,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    19.7
                  ],
                  [
                    1.3,
                    19.7
                  ],
                  [
                    1.3,
                    9.4
                  ],
                  [
                    3.2,
                    9.4
                  ],
                  [
                    3.2,
                    13.5
                  ],
                  [
                    7.4,
                    13.5
                  ],
                  [
                    7.4,
                    9.4
                  ],
                  [
                    9.2,
                    9.4
                  ],
                  [
                    9.2,
                    19.7
                  ],
                  [
                    7.4,
                    19.7
                  ],
                  [
                    7.4,
                    15.1
                  ],
                  [
                    3.2,
                    15.1
                  ],
                  [
                    3.2,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 692,
        ty: 3,
        parent: 679,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 679,
        ty: 3,
        parent: 678,
        ks: {
          p: {
            a: 0,
            k: [
              87.706,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 696,
        ty: 4,
        parent: 695,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    -1.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.6
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    4.9,
                    19.9
                  ],
                  [
                    4.9,
                    19.9
                  ],
                  [
                    2.8,
                    18.9
                  ],
                  [
                    2.8,
                    18.9
                  ],
                  [
                    2.8,
                    18.9
                  ],
                  [
                    2.6,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    8.5
                  ],
                  [
                    3,
                    8.5
                  ],
                  [
                    3,
                    11.4
                  ],
                  [
                    2.9,
                    12.7
                  ],
                  [
                    4,
                    12
                  ],
                  [
                    5.2,
                    11.8
                  ],
                  [
                    5.2,
                    11.8
                  ],
                  [
                    7.5,
                    12.8
                  ],
                  [
                    8.3,
                    15.7
                  ],
                  [
                    8.3,
                    15.7
                  ],
                  [
                    7.8,
                    18
                  ],
                  [
                    6.6,
                    19.4
                  ],
                  [
                    4.9,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.9
                  ],
                  [
                    -0.3,
                    0.6
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    0,
                    0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    0
                  ]
                ],
                v: [
                  [
                    4.6,
                    18.4
                  ],
                  [
                    4.6,
                    18.4
                  ],
                  [
                    5.9,
                    17.7
                  ],
                  [
                    6.4,
                    15.7
                  ],
                  [
                    6.4,
                    15.7
                  ],
                  [
                    6,
                    13.9
                  ],
                  [
                    4.7,
                    13.3
                  ],
                  [
                    4.7,
                    13.3
                  ],
                  [
                    3,
                    14.1
                  ],
                  [
                    3,
                    14.1
                  ],
                  [
                    3,
                    17.8
                  ],
                  [
                    3.8,
                    18.3
                  ],
                  [
                    4.6,
                    18.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 695,
        ty: 3,
        parent: 694,
        ks: {
          p: {
            a: 0,
            k: [
              38.952,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 698,
        ty: 4,
        parent: 697,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    3,
                    12
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    10.6
                  ],
                  [
                    2.1,
                    10.6
                  ],
                  [
                    1.3,
                    10.3
                  ],
                  [
                    1,
                    9.5
                  ],
                  [
                    1,
                    9.5
                  ],
                  [
                    1.3,
                    8.8
                  ],
                  [
                    2.1,
                    8.5
                  ],
                  [
                    2.1,
                    8.5
                  ],
                  [
                    2.9,
                    8.8
                  ],
                  [
                    3.2,
                    9.5
                  ],
                  [
                    3.2,
                    9.5
                  ],
                  [
                    2.9,
                    10.3
                  ],
                  [
                    2.1,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 697,
        ty: 3,
        parent: 694,
        ks: {
          p: {
            a: 0,
            k: [
              34.797,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 700,
        ty: 4,
        parent: 699,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    19.9
                  ],
                  [
                    3.5,
                    19.9
                  ],
                  [
                    1.7,
                    19.1
                  ],
                  [
                    1.1,
                    16.8
                  ],
                  [
                    1.1,
                    16.8
                  ],
                  [
                    1.1,
                    12
                  ],
                  [
                    2.9,
                    12
                  ],
                  [
                    2.9,
                    16.6
                  ],
                  [
                    3.2,
                    18
                  ],
                  [
                    4.1,
                    18.4
                  ],
                  [
                    4.1,
                    18.4
                  ],
                  [
                    5,
                    18.1
                  ],
                  [
                    5.8,
                    17.3
                  ],
                  [
                    5.8,
                    17.3
                  ],
                  [
                    5.8,
                    12
                  ],
                  [
                    7.7,
                    12
                  ],
                  [
                    7.7,
                    19.7
                  ],
                  [
                    6.2,
                    19.7
                  ],
                  [
                    6,
                    18.6
                  ],
                  [
                    6,
                    18.6
                  ],
                  [
                    4.9,
                    19.6
                  ],
                  [
                    3.5,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 699,
        ty: 3,
        parent: 694,
        ks: {
          p: {
            a: 0,
            k: [
              25.979,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 702,
        ty: 4,
        parent: 701,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0.7
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.6
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    7.8,
                    22.8
                  ],
                  [
                    6,
                    22.8
                  ],
                  [
                    6,
                    20.3
                  ],
                  [
                    6,
                    19
                  ],
                  [
                    5,
                    19.7
                  ],
                  [
                    3.9,
                    19.9
                  ],
                  [
                    3.9,
                    19.9
                  ],
                  [
                    1.6,
                    18.9
                  ],
                  [
                    0.7,
                    15.9
                  ],
                  [
                    0.7,
                    15.9
                  ],
                  [
                    1.2,
                    13.7
                  ],
                  [
                    2.4,
                    12.3
                  ],
                  [
                    4,
                    11.8
                  ],
                  [
                    4,
                    11.8
                  ],
                  [
                    5.1,
                    12
                  ],
                  [
                    6.1,
                    12.7
                  ],
                  [
                    6.1,
                    12.7
                  ],
                  [
                    6.2,
                    12.7
                  ],
                  [
                    6.3,
                    12
                  ],
                  [
                    7.8,
                    12
                  ],
                  [
                    7.8,
                    22.8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0
                  ],
                  [
                    -0.6,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.3,
                    -0.6
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ]
                ],
                v: [
                  [
                    4.3,
                    18.4
                  ],
                  [
                    4.3,
                    18.4
                  ],
                  [
                    6,
                    17.6
                  ],
                  [
                    6,
                    17.6
                  ],
                  [
                    6,
                    13.9
                  ],
                  [
                    5.2,
                    13.4
                  ],
                  [
                    4.4,
                    13.3
                  ],
                  [
                    4.4,
                    13.3
                  ],
                  [
                    3.1,
                    13.9
                  ],
                  [
                    2.6,
                    15.8
                  ],
                  [
                    2.6,
                    15.8
                  ],
                  [
                    3,
                    17.8
                  ],
                  [
                    4.3,
                    18.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 701,
        ty: 3,
        parent: 694,
        ks: {
          p: {
            a: 0,
            k: [
              17.034,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 704,
        ty: 4,
        parent: 703,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0.5
                  ],
                  [
                    -1.6,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    -1.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.9
                  ],
                  [
                    3,
                    19.9
                  ],
                  [
                    1.4,
                    19.3
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    1.8,
                    15.7
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5,
                    13.7
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    2.8,
                    13.5
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1,
                    12.8
                  ],
                  [
                    2.5,
                    12.1
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    6.4,
                    12.6
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    19.7
                  ],
                  [
                    5.6,
                    19.7
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    4.3,
                    19.6
                  ],
                  [
                    3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.7,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.6,
                    18.5
                  ],
                  [
                    3.6,
                    18.5
                  ],
                  [
                    4.5,
                    18.3
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    15.9
                  ],
                  [
                    3.1,
                    16.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.8,
                    18.3
                  ],
                  [
                    3.6,
                    18.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 703,
        ty: 3,
        parent: 694,
        ks: {
          p: {
            a: 0,
            k: [
              8.85,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 706,
        ty: 4,
        parent: 705,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.6
                  ],
                  [
                    0.1,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.6
                  ],
                  [
                    0.2,
                    -0.6
                  ]
                ],
                v: [
                  [
                    3.4,
                    14.2
                  ],
                  [
                    3.4,
                    14.2
                  ],
                  [
                    3.1,
                    15.5
                  ],
                  [
                    5.7,
                    15.5
                  ],
                  [
                    5.4,
                    14.2
                  ],
                  [
                    4.9,
                    12.5
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    3.9,
                    12.5
                  ],
                  [
                    3.4,
                    14.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.6
                  ],
                  [
                    -0.2,
                    0.6
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.8,
                    19.7
                  ],
                  [
                    0,
                    19.7
                  ],
                  [
                    3.3,
                    9.4
                  ],
                  [
                    5.5,
                    9.4
                  ],
                  [
                    8.9,
                    19.7
                  ],
                  [
                    7,
                    19.7
                  ],
                  [
                    6.1,
                    16.9
                  ],
                  [
                    2.7,
                    16.9
                  ],
                  [
                    1.8,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 705,
        ty: 3,
        parent: 694,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 694,
        ty: 3,
        parent: 678,
        ks: {
          p: {
            a: 0,
            k: [
              36.652,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 709,
        ty: 4,
        parent: 708,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0.7
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.6
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.9,
                    19.9
                  ],
                  [
                    3.9,
                    19.9
                  ],
                  [
                    1.6,
                    18.9
                  ],
                  [
                    0.7,
                    15.9
                  ],
                  [
                    0.7,
                    15.9
                  ],
                  [
                    1.2,
                    13.7
                  ],
                  [
                    2.4,
                    12.3
                  ],
                  [
                    4,
                    11.8
                  ],
                  [
                    4,
                    11.8
                  ],
                  [
                    5.1,
                    12
                  ],
                  [
                    6,
                    12.6
                  ],
                  [
                    6,
                    12.6
                  ],
                  [
                    6,
                    11.4
                  ],
                  [
                    6,
                    8.5
                  ],
                  [
                    7.8,
                    8.5
                  ],
                  [
                    7.8,
                    19.7
                  ],
                  [
                    6.3,
                    19.7
                  ],
                  [
                    6.2,
                    18.9
                  ],
                  [
                    6.1,
                    18.9
                  ],
                  [
                    5.1,
                    19.6
                  ],
                  [
                    3.9,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0
                  ],
                  [
                    -0.6,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.3,
                    -0.6
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ]
                ],
                v: [
                  [
                    4.3,
                    18.4
                  ],
                  [
                    4.3,
                    18.4
                  ],
                  [
                    6,
                    17.6
                  ],
                  [
                    6,
                    17.6
                  ],
                  [
                    6,
                    13.9
                  ],
                  [
                    5.2,
                    13.4
                  ],
                  [
                    4.4,
                    13.3
                  ],
                  [
                    4.4,
                    13.3
                  ],
                  [
                    3.1,
                    13.9
                  ],
                  [
                    2.6,
                    15.8
                  ],
                  [
                    2.6,
                    15.8
                  ],
                  [
                    3,
                    17.8
                  ],
                  [
                    4.3,
                    18.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 708,
        ty: 3,
        parent: 707,
        ks: {
          p: {
            a: 0,
            k: [
              24.535,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 711,
        ty: 4,
        parent: 710,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0.3
                  ],
                  [
                    0.3,
                    0.6
                  ],
                  [
                    0,
                    0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.6
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.6
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    4.5,
                    19.9
                  ],
                  [
                    4.5,
                    19.9
                  ],
                  [
                    2.5,
                    19.5
                  ],
                  [
                    1.2,
                    18.1
                  ],
                  [
                    0.7,
                    15.9
                  ],
                  [
                    0.7,
                    15.9
                  ],
                  [
                    1.2,
                    13.7
                  ],
                  [
                    2.5,
                    12.3
                  ],
                  [
                    4.2,
                    11.8
                  ],
                  [
                    4.2,
                    11.8
                  ],
                  [
                    6,
                    12.2
                  ],
                  [
                    7.1,
                    13.5
                  ],
                  [
                    7.5,
                    15.5
                  ],
                  [
                    7.5,
                    15.5
                  ],
                  [
                    7.4,
                    16.4
                  ],
                  [
                    7.4,
                    16.4
                  ],
                  [
                    2.4,
                    16.4
                  ],
                  [
                    3.2,
                    18
                  ],
                  [
                    4.7,
                    18.5
                  ],
                  [
                    4.7,
                    18.5
                  ],
                  [
                    5.7,
                    18.4
                  ],
                  [
                    6.5,
                    18
                  ],
                  [
                    6.5,
                    18
                  ],
                  [
                    7.2,
                    19.1
                  ],
                  [
                    5.9,
                    19.7
                  ],
                  [
                    4.5,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.6,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.3,
                    -0.6
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.2,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.7
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.6
                  ]
                ],
                v: [
                  [
                    2.4,
                    15.1
                  ],
                  [
                    2.4,
                    15.1
                  ],
                  [
                    5.9,
                    15.1
                  ],
                  [
                    5.5,
                    13.7
                  ],
                  [
                    4.3,
                    13.2
                  ],
                  [
                    4.3,
                    13.2
                  ],
                  [
                    3.1,
                    13.7
                  ],
                  [
                    2.4,
                    15.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 710,
        ty: 3,
        parent: 707,
        ks: {
          p: {
            a: 0,
            k: [
              16.494,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 713,
        ty: 4,
        parent: 712,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.5
                  ],
                  [
                    0.8,
                    0
                  ]
                ],
                v: [
                  [
                    1.7,
                    23
                  ],
                  [
                    1.7,
                    23
                  ],
                  [
                    1.1,
                    22.9
                  ],
                  [
                    0.7,
                    22.8
                  ],
                  [
                    0.7,
                    22.8
                  ],
                  [
                    1,
                    21.4
                  ],
                  [
                    1.3,
                    21.4
                  ],
                  [
                    1.6,
                    21.5
                  ],
                  [
                    1.6,
                    21.5
                  ],
                  [
                    2.5,
                    21.1
                  ],
                  [
                    3.1,
                    20.1
                  ],
                  [
                    3.1,
                    20.1
                  ],
                  [
                    3.3,
                    19.7
                  ],
                  [
                    0.2,
                    12
                  ],
                  [
                    2,
                    12
                  ],
                  [
                    3.4,
                    15.8
                  ],
                  [
                    3.7,
                    16.9
                  ],
                  [
                    4.1,
                    18
                  ],
                  [
                    4.1,
                    18
                  ],
                  [
                    4.1,
                    18
                  ],
                  [
                    4.4,
                    16.9
                  ],
                  [
                    4.7,
                    15.8
                  ],
                  [
                    4.7,
                    15.8
                  ],
                  [
                    5.9,
                    12
                  ],
                  [
                    7.7,
                    12
                  ],
                  [
                    4.8,
                    20.1
                  ],
                  [
                    3.6,
                    22.2
                  ],
                  [
                    1.7,
                    23
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.9
                  ],
                  [
                    -0.5,
                    0.5
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 712,
        ty: 3,
        parent: 707,
        ks: {
          p: {
            a: 0,
            k: [
              8.644,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 715,
        ty: 4,
        parent: 714,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0.3
                  ],
                  [
                    0.5,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    -0.2
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0.8,
                    0
                  ]
                ],
                v: [
                  [
                    4.3,
                    19.9
                  ],
                  [
                    4.3,
                    19.9
                  ],
                  [
                    2.3,
                    19.5
                  ],
                  [
                    0.6,
                    18.4
                  ],
                  [
                    0.6,
                    18.4
                  ],
                  [
                    1.7,
                    17.2
                  ],
                  [
                    3,
                    18
                  ],
                  [
                    4.4,
                    18.3
                  ],
                  [
                    4.4,
                    18.3
                  ],
                  [
                    5.7,
                    18
                  ],
                  [
                    6.2,
                    17
                  ],
                  [
                    6.2,
                    17
                  ],
                  [
                    5.7,
                    16.1
                  ],
                  [
                    4.6,
                    15.5
                  ],
                  [
                    4.6,
                    15.5
                  ],
                  [
                    3.2,
                    14.9
                  ],
                  [
                    2.2,
                    14.3
                  ],
                  [
                    1.4,
                    13.4
                  ],
                  [
                    1.1,
                    12.1
                  ],
                  [
                    1.1,
                    12.1
                  ],
                  [
                    1.5,
                    10.6
                  ],
                  [
                    2.8,
                    9.6
                  ],
                  [
                    4.6,
                    9.2
                  ],
                  [
                    4.6,
                    9.2
                  ],
                  [
                    6.3,
                    9.5
                  ],
                  [
                    7.7,
                    10.5
                  ],
                  [
                    7.7,
                    10.5
                  ],
                  [
                    6.8,
                    11.7
                  ],
                  [
                    5.8,
                    11
                  ],
                  [
                    4.6,
                    10.8
                  ],
                  [
                    4.6,
                    10.8
                  ],
                  [
                    3.4,
                    11.1
                  ],
                  [
                    2.9,
                    12
                  ],
                  [
                    2.9,
                    12
                  ],
                  [
                    3.2,
                    12.7
                  ],
                  [
                    3.8,
                    13.1
                  ],
                  [
                    4.6,
                    13.5
                  ],
                  [
                    4.6,
                    13.5
                  ],
                  [
                    6,
                    14.1
                  ],
                  [
                    7.5,
                    15.1
                  ],
                  [
                    8.1,
                    16.9
                  ],
                  [
                    8.1,
                    16.9
                  ],
                  [
                    7.6,
                    18.4
                  ],
                  [
                    6.4,
                    19.5
                  ],
                  [
                    4.3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.7,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.6,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0.3
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 714,
        ty: 3,
        parent: 707,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 707,
        ty: 3,
        parent: 678,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 678,
        ty: 3,
        parent: 677,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.394
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 677,
        ty: 3,
        parent: 676,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 676,
        ty: 3,
        parent: 594,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 594,
        ty: 3,
        parent: 593,
        ks: {
          p: {
            a: 0,
            k: [
              91.69,
              3.002
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 726,
        ty: 0,
        parent: 717,
        ks: {
          a: {
            a: 0,
            k: [
              54.666,
              55.542
            ]
          },
          p: {
            a: 0,
            k: [
              54.666,
              55.542
            ]
          }
        },
        w: 21.159,
        h: 21.159,
        ip: 0,
        op: 565,
        st: 0,
        refId: "724"
      },
      {
        ind: 717,
        ty: 3,
        parent: 716,
        ks: {
          p: {
            a: 0,
            k: [
              54.666,
              55.542
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 729,
        ty: 4,
        td: 1,
        parent: 727,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                38.792,
                38.792
              ]
            },
            r: {
              a: 0,
              k: 60
            },
            s: {
              a: 0,
              k: [
                77.584,
                77.584
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 728,
        ty: 4,
        tt: 1,
        parent: 727,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                p: {
                  a: 0,
                  k: [
                    38.792,
                    38.792
                  ]
                },
                r: {
                  a: 0,
                  k: 0
                },
                s: {
                  a: 0,
                  k: [
                    81.992,
                    81.992
                  ]
                }
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0,
                    0,
                    0,
                    0
                  ]
                },
                o: {
                  a: 0,
                  k: 0
                }
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          },
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                p: {
                  a: 0,
                  k: [
                    38.792,
                    38.792
                  ]
                },
                r: {
                  a: 0,
                  k: 60
                },
                s: {
                  a: 0,
                  k: [
                    77.584,
                    77.584
                  ]
                }
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.427,
                    0.184,
                    0.604
                  ]
                },
                lj: 1,
                ml: 10,
                o: {
                  a: 0,
                  k: 100
                },
                w: {
                  a: 0,
                  k: 4.408
                }
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      },
      {
        ind: 745,
        ty: 4,
        td: 1,
        parent: 727,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                38.792,
                38.792
              ]
            },
            r: {
              a: 0,
              k: 60
            },
            s: {
              a: 0,
              k: [
                77.584,
                77.584
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 744,
        ty: 0,
        tt: 1,
        parent: 727,
        ks: {},
        w: 71,
        h: 71,
        ip: 0,
        op: 565,
        st: 0,
        refId: "742"
      },
      {
        ind: 727,
        ty: 3,
        parent: 716,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 716,
        ty: 3,
        parent: 593,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 593,
        ty: 3,
        parent: 392,
        ks: {
          p: {
            a: 0,
            k: [
              10.58,
              10.579
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 746,
        ty: 4,
        parent: 392,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                148.115,
                91.315
              ]
            },
            r: {
              a: 0,
              k: 7
            },
            s: {
              a: 0,
              k: [
                296.23,
                182.63
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                1,
                1
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 392,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "751",
    layers: [
      {
        ind: 749,
        ty: 0,
        ks: {
          a: {
            a: 0,
            k: [
              1,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              143.629,
              142.629
            ]
          }
        },
        w: 298,
        h: 183,
        ip: 0,
        op: 565,
        st: 0,
        refId: "747"
      },
      {
        ind: 750,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                291.745,
                233.944
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                583.489,
                467.888
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      }
    ]
  },
  {
    id: "818",
    layers: [
      {
        ind: 817,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                7,
                4.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                14,
                9
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            -0.09
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            -0.02
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.06,
                            0.02
                          ],
                          [
                            0.05,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            0.03
                          ],
                          [
                            -0.07,
                            0
                          ],
                          [
                            -0.06,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.13
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.05
                          ],
                          [
                            -0.06,
                            0.02
                          ],
                          [
                            -0.06,
                            0
                          ],
                          [
                            -0.06,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.05
                          ],
                          [
                            0.06,
                            -0.02
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.06,
                            0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            0.09,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            10.09,
                            0.82
                          ],
                          [
                            10.09,
                            3.46
                          ],
                          [
                            9.94,
                            3.81
                          ],
                          [
                            9.59,
                            3.96
                          ],
                          [
                            9.24,
                            3.81
                          ],
                          [
                            9.09,
                            3.46
                          ],
                          [
                            9.09,
                            2.01
                          ],
                          [
                            5.97,
                            5.13
                          ],
                          [
                            5.81,
                            5.24
                          ],
                          [
                            5.62,
                            5.28
                          ],
                          [
                            5.43,
                            5.24
                          ],
                          [
                            5.27,
                            5.13
                          ],
                          [
                            3.97,
                            3.83
                          ],
                          [
                            1.34,
                            6.46
                          ],
                          [
                            0.99,
                            6.6
                          ],
                          [
                            0.64,
                            6.46
                          ],
                          [
                            0.5,
                            6.11
                          ],
                          [
                            0.64,
                            5.75
                          ],
                          [
                            3.62,
                            2.78
                          ],
                          [
                            3.78,
                            2.67
                          ],
                          [
                            3.97,
                            2.63
                          ],
                          [
                            4.16,
                            2.67
                          ],
                          [
                            4.32,
                            2.78
                          ],
                          [
                            5.62,
                            4.08
                          ],
                          [
                            8.39,
                            1.31
                          ],
                          [
                            6.95,
                            1.31
                          ],
                          [
                            6.59,
                            1.16
                          ],
                          [
                            6.45,
                            0.82
                          ],
                          [
                            6.59,
                            0.46
                          ],
                          [
                            6.95,
                            0.32
                          ],
                          [
                            9.59,
                            0.32
                          ],
                          [
                            9.94,
                            0.46
                          ],
                          [
                            10.09,
                            0.82
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.52,
                        0.32,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "821",
    layers: [
      {
        ind: 820,
        ty: 0,
        parent: 816,
        ks: {},
        w: 14,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "818"
      },
      {
        ind: 816,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              2
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "829",
    layers: [
      {
        ind: 828,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                6,
                7
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                12,
                14
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.08,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.27,
                            -0.04
                          ],
                          [
                            -0.18,
                            -0.05
                          ],
                          [
                            -0.12,
                            -0.06
                          ],
                          [
                            0.47,
                            0.53
                          ],
                          [
                            1.18,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.24
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.01,
                            -0.04
                          ],
                          [
                            -0.03,
                            -0.03
                          ],
                          [
                            -0.04,
                            -0.02
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.02,
                            -0.1
                          ],
                          [
                            0.08,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.32,
                            0
                          ],
                          [
                            0.18,
                            0.03
                          ],
                          [
                            0.14,
                            0.05
                          ],
                          [
                            0.13,
                            -0.86
                          ],
                          [
                            -0.51,
                            -0.59
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.01,
                            0.04
                          ],
                          [
                            0.01,
                            0.04
                          ],
                          [
                            0.03,
                            0.04
                          ],
                          [
                            0.04,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            3.54,
                            3.32
                          ],
                          [
                            3.68,
                            3.06
                          ],
                          [
                            3.96,
                            2.96
                          ],
                          [
                            6.66,
                            2.96
                          ],
                          [
                            7.55,
                            3.02
                          ],
                          [
                            8.09,
                            3.15
                          ],
                          [
                            8.46,
                            3.31
                          ],
                          [
                            8,
                            1.33
                          ],
                          [
                            5.38,
                            0.5
                          ],
                          [
                            1.93,
                            0.5
                          ],
                          [
                            1.45,
                            0.91
                          ],
                          [
                            0.02,
                            9.99
                          ],
                          [
                            0.02,
                            10.12
                          ],
                          [
                            0.08,
                            10.23
                          ],
                          [
                            0.18,
                            10.31
                          ],
                          [
                            0.3,
                            10.34
                          ],
                          [
                            2.43,
                            10.34
                          ],
                          [
                            2.96,
                            6.95
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.15,
                        0.23,
                        0.5,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "834",
    layers: [
      {
        ind: 833,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                4.5,
                3.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                9,
                7
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0.15,
                                0.02
                              ],
                              [
                                0.3,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.08,
                                -0.07
                              ],
                              [
                                0.02,
                                -0.1
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.09,
                                0.07
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.45,
                                2.33
                              ],
                              [
                                -0.01,
                                0.07
                              ],
                              [
                                0.13,
                                0.04
                              ],
                              [
                                0.04,
                                0.01
                              ]
                            ],
                            o: [
                              [
                                -0.14,
                                -0.04
                              ],
                              [
                                -0.29,
                                -0.05
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.1,
                                0
                              ],
                              [
                                -0.08,
                                0.07
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.02,
                                -0.12
                              ],
                              [
                                0.09,
                                -0.08
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                1.98,
                                0
                              ],
                              [
                                0.01,
                                -0.07
                              ],
                              [
                                -0.12,
                                -0.06
                              ],
                              [
                                -0.03,
                                -0.01
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                5.74,
                                0.87
                              ],
                              [
                                5.3,
                                0.77
                              ],
                              [
                                4.41,
                                0.7
                              ],
                              [
                                1.71,
                                0.7
                              ],
                              [
                                1.43,
                                0.81
                              ],
                              [
                                1.29,
                                1.07
                              ],
                              [
                                0.71,
                                4.7
                              ],
                              [
                                0.7,
                                4.81
                              ],
                              [
                                0.86,
                                4.51
                              ],
                              [
                                1.18,
                                4.39
                              ],
                              [
                                2.19,
                                4.39
                              ],
                              [
                                6.18,
                                1.26
                              ],
                              [
                                6.21,
                                1.05
                              ],
                              [
                                5.84,
                                0.9
                              ],
                              [
                                5.74,
                                0.87
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0.13,
                            0.18,
                            0.4,
                            1
                          ]
                        },
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "839",
    layers: [
      {
        ind: 838,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                5,
                6
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                10,
                12
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            -0.07
                          ],
                          [
                            1.98,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.24
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.01,
                            -0.04
                          ],
                          [
                            -0.02,
                            -0.03
                          ],
                          [
                            -0.04,
                            -0.02
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.03,
                            0.21
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.39,
                            2.04
                          ],
                          [
                            0.44,
                            0.5
                          ],
                          [
                            0.18,
                            0.1
                          ]
                        ],
                        o: [
                          [
                            -0.01,
                            0.07
                          ],
                          [
                            -0.45,
                            2.33
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.01,
                            0.04
                          ],
                          [
                            0.01,
                            0.04
                          ],
                          [
                            0.02,
                            0.03
                          ],
                          [
                            0.03,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            -0.21
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.73,
                            0
                          ],
                          [
                            0.17,
                            -0.85
                          ],
                          [
                            -0.14,
                            -0.15
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            6.21,
                            0.3
                          ],
                          [
                            6.18,
                            0.51
                          ],
                          [
                            2.19,
                            3.64
                          ],
                          [
                            1.18,
                            3.64
                          ],
                          [
                            0.7,
                            4.06
                          ],
                          [
                            0.18,
                            7.34
                          ],
                          [
                            0.04,
                            8.26
                          ],
                          [
                            0.04,
                            8.38
                          ],
                          [
                            0.09,
                            8.47
                          ],
                          [
                            0.18,
                            8.54
                          ],
                          [
                            0.29,
                            8.56
                          ],
                          [
                            2.08,
                            8.56
                          ],
                          [
                            2.5,
                            8.2
                          ],
                          [
                            2.52,
                            8.11
                          ],
                          [
                            2.86,
                            5.97
                          ],
                          [
                            2.88,
                            5.85
                          ],
                          [
                            3.31,
                            5.49
                          ],
                          [
                            3.57,
                            5.49
                          ],
                          [
                            7.06,
                            2.75
                          ],
                          [
                            6.7,
                            0.68
                          ],
                          [
                            6.21,
                            0.3
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.09,
                        0.61,
                        0.84,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "844",
    layers: [
      {
        ind: 843,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                6.5,
                7
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                13,
                14
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            0.02
                          ],
                          [
                            -0.03,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.41,
                            -0.47
                          ],
                          [
                            -0.06,
                            -0.25
                          ],
                          [
                            0.06,
                            -0.39
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.11,
                            -0.12
                          ],
                          [
                            -0.04,
                            -0.28
                          ],
                          [
                            0.07,
                            -0.39
                          ],
                          [
                            0.19,
                            -0.32
                          ],
                          [
                            0.27,
                            -0.2
                          ],
                          [
                            0.34,
                            -0.09
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.14,
                            -0.12
                          ],
                          [
                            0.03,
                            -0.19
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            -0.01
                          ],
                          [
                            0.02,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.03
                          ],
                          [
                            0.02,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.14,
                            0
                          ],
                          [
                            0.2,
                            0.22
                          ],
                          [
                            0.06,
                            0.27
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.07
                          ],
                          [
                            0.16,
                            0.19
                          ],
                          [
                            0.05,
                            0.29
                          ],
                          [
                            -0.09,
                            0.45
                          ],
                          [
                            -0.17,
                            0.29
                          ],
                          [
                            -0.25,
                            0.18
                          ],
                          [
                            -0.33,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.15,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.03
                          ],
                          [
                            -0.01,
                            0.01
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            2.68,
                            10.44
                          ],
                          [
                            2.87,
                            9.22
                          ],
                          [
                            2.44,
                            9.21
                          ],
                          [
                            0.4,
                            9.21
                          ],
                          [
                            1.82,
                            0.22
                          ],
                          [
                            1.86,
                            0.15
                          ],
                          [
                            1.93,
                            0.12
                          ],
                          [
                            5.38,
                            0.12
                          ],
                          [
                            7.71,
                            0.83
                          ],
                          [
                            8.09,
                            1.53
                          ],
                          [
                            8.09,
                            2.5
                          ],
                          [
                            8.09,
                            2.53
                          ],
                          [
                            8.09,
                            2.78
                          ],
                          [
                            8.28,
                            2.89
                          ],
                          [
                            8.67,
                            3.18
                          ],
                          [
                            8.99,
                            3.89
                          ],
                          [
                            8.95,
                            4.93
                          ],
                          [
                            8.52,
                            6.09
                          ],
                          [
                            7.85,
                            6.83
                          ],
                          [
                            6.95,
                            7.23
                          ],
                          [
                            5.82,
                            7.36
                          ],
                          [
                            5.56,
                            7.36
                          ],
                          [
                            5.04,
                            7.56
                          ],
                          [
                            4.76,
                            8.04
                          ],
                          [
                            4.74,
                            8.15
                          ],
                          [
                            4.4,
                            10.3
                          ],
                          [
                            4.39,
                            10.38
                          ],
                          [
                            4.36,
                            10.43
                          ],
                          [
                            4.33,
                            10.44
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.15,
                        0.23,
                        0.5,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "849",
    layers: [
      {
        ind: 848,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                10,
                5.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                20,
                11
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            -0.05
                          ],
                          [
                            0.02,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.01,
                            -0.03
                          ],
                          [
                            -0.02,
                            -0.02
                          ],
                          [
                            -0.03,
                            -0.01
                          ],
                          [
                            -0.03,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.04
                          ],
                          [
                            -0.01,
                            0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            0.05
                          ],
                          [
                            -0.08,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.25,
                            1.59
                          ],
                          [
                            0.33,
                            0.38
                          ],
                          [
                            0.84,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.08,
                            0
                          ],
                          [
                            -0.06,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.01,
                            0.03
                          ],
                          [
                            0.01,
                            0.03
                          ],
                          [
                            0.02,
                            0.02
                          ],
                          [
                            0.03,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0
                          ],
                          [
                            0.05,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            -0.08
                          ],
                          [
                            0.07,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.66,
                            0
                          ],
                          [
                            0.11,
                            -0.69
                          ],
                          [
                            -0.36,
                            -0.42
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            4.1,
                            0.72
                          ],
                          [
                            1.59,
                            0.72
                          ],
                          [
                            1.36,
                            0.8
                          ],
                          [
                            1.24,
                            1.02
                          ],
                          [
                            0.23,
                            7.45
                          ],
                          [
                            0.23,
                            7.54
                          ],
                          [
                            0.28,
                            7.62
                          ],
                          [
                            0.35,
                            7.67
                          ],
                          [
                            0.43,
                            7.69
                          ],
                          [
                            1.72,
                            7.69
                          ],
                          [
                            1.88,
                            7.63
                          ],
                          [
                            1.96,
                            7.48
                          ],
                          [
                            2.25,
                            5.66
                          ],
                          [
                            2.37,
                            5.45
                          ],
                          [
                            2.59,
                            5.36
                          ],
                          [
                            3.39,
                            5.36
                          ],
                          [
                            6.24,
                            2.98
                          ],
                          [
                            5.92,
                            1.36
                          ],
                          [
                            4.1,
                            0.72
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.67,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.03
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            -0.26
                          ],
                          [
                            0.05,
                            -0.32
                          ]
                        ],
                        o: [
                          [
                            -0.14,
                            0.9
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            -0.05
                          ],
                          [
                            0.04,
                            -0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.45,
                            0
                          ],
                          [
                            0.13,
                            0.16
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            4.39,
                            3.07
                          ],
                          [
                            2.89,
                            3.97
                          ],
                          [
                            2.52,
                            3.97
                          ],
                          [
                            2.79,
                            2.29
                          ],
                          [
                            2.86,
                            2.16
                          ],
                          [
                            2.99,
                            2.11
                          ],
                          [
                            3.16,
                            2.11
                          ],
                          [
                            4.27,
                            2.37
                          ],
                          [
                            4.39,
                            3.07
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.03
                          ],
                          [
                            0.01,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.58,
                            0
                          ],
                          [
                            0.22,
                            -1.41
                          ],
                          [
                            -0.4,
                            -0.47
                          ],
                          [
                            -0.62,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.01,
                            -0.03
                          ],
                          [
                            -0.02,
                            -0.02
                          ],
                          [
                            -0.03,
                            -0.01
                          ],
                          [
                            -0.03,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            0.05
                          ],
                          [
                            -0.02,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            0.03
                          ],
                          [
                            0.02,
                            0.02
                          ],
                          [
                            0.03,
                            0.01
                          ],
                          [
                            0.03,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.04,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.26,
                            -0.38
                          ],
                          [
                            -1.32,
                            0
                          ],
                          [
                            -0.11,
                            0.7
                          ],
                          [
                            0.36,
                            0.43
                          ],
                          [
                            1.07,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.01,
                            0.03
                          ],
                          [
                            0.01,
                            0.03
                          ],
                          [
                            0.02,
                            0.02
                          ],
                          [
                            0.03,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.08,
                            0
                          ],
                          [
                            0.07,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.03
                          ],
                          [
                            -0.01,
                            -0.03
                          ],
                          [
                            -0.02,
                            -0.02
                          ],
                          [
                            -0.03,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            11.59,
                            3.04
                          ],
                          [
                            10.39,
                            3.04
                          ],
                          [
                            10.26,
                            3.09
                          ],
                          [
                            10.19,
                            3.22
                          ],
                          [
                            10.13,
                            3.55
                          ],
                          [
                            10.05,
                            3.43
                          ],
                          [
                            8.63,
                            2.93
                          ],
                          [
                            5.95,
                            5.34
                          ],
                          [
                            6.4,
                            7.19
                          ],
                          [
                            7.91,
                            7.8
                          ],
                          [
                            9.57,
                            7.11
                          ],
                          [
                            9.52,
                            7.45
                          ],
                          [
                            9.52,
                            7.54
                          ],
                          [
                            9.57,
                            7.61
                          ],
                          [
                            9.64,
                            7.67
                          ],
                          [
                            9.73,
                            7.69
                          ],
                          [
                            10.81,
                            7.69
                          ],
                          [
                            11.03,
                            7.61
                          ],
                          [
                            11.15,
                            7.39
                          ],
                          [
                            11.8,
                            3.28
                          ],
                          [
                            11.79,
                            3.2
                          ],
                          [
                            11.75,
                            3.11
                          ],
                          [
                            11.68,
                            3.06
                          ],
                          [
                            11.59,
                            3.04
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.7,
                            0
                          ],
                          [
                            0.18,
                            0.21
                          ],
                          [
                            -0.06,
                            0.33
                          ],
                          [
                            -0.68,
                            0
                          ],
                          [
                            -0.18,
                            -0.21
                          ],
                          [
                            0.05,
                            -0.33
                          ]
                        ],
                        o: [
                          [
                            -0.11,
                            0.69
                          ],
                          [
                            -0.35,
                            0
                          ],
                          [
                            -0.18,
                            -0.21
                          ],
                          [
                            0.11,
                            -0.68
                          ],
                          [
                            0.34,
                            0
                          ],
                          [
                            0.18,
                            0.21
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.92,
                            5.38
                          ],
                          [
                            8.56,
                            6.53
                          ],
                          [
                            7.76,
                            6.2
                          ],
                          [
                            7.57,
                            5.36
                          ],
                          [
                            8.91,
                            4.2
                          ],
                          [
                            9.71,
                            4.53
                          ],
                          [
                            9.92,
                            5.38
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.01,
                            -0.03
                          ],
                          [
                            -0.02,
                            -0.02
                          ],
                          [
                            -0.03,
                            -0.01
                          ],
                          [
                            -0.03,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.03,
                            0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            0.03
                          ],
                          [
                            0.02,
                            0.02
                          ],
                          [
                            0.03,
                            0.01
                          ],
                          [
                            0.03,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.04
                          ],
                          [
                            0.01,
                            -0.05
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.03
                          ],
                          [
                            0.01,
                            0.03
                          ],
                          [
                            0.02,
                            0.02
                          ],
                          [
                            0.03,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.03
                          ],
                          [
                            -0.01,
                            -0.03
                          ],
                          [
                            -0.02,
                            -0.02
                          ],
                          [
                            -0.03,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.04,
                            0.03
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            13.01,
                            0.9
                          ],
                          [
                            11.98,
                            7.45
                          ],
                          [
                            11.98,
                            7.54
                          ],
                          [
                            12.03,
                            7.62
                          ],
                          [
                            12.1,
                            7.67
                          ],
                          [
                            12.19,
                            7.69
                          ],
                          [
                            13.22,
                            7.69
                          ],
                          [
                            13.57,
                            7.39
                          ],
                          [
                            14.58,
                            0.96
                          ],
                          [
                            14.57,
                            0.88
                          ],
                          [
                            14.53,
                            0.79
                          ],
                          [
                            14.46,
                            0.74
                          ],
                          [
                            14.38,
                            0.72
                          ],
                          [
                            13.21,
                            0.72
                          ],
                          [
                            13.08,
                            0.77
                          ],
                          [
                            13.01,
                            0.9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.09,
                        0.61,
                        0.84,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "854",
    layers: [
      {
        ind: 853,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                12.5,
                6.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                25,
                13
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            -0.05
                          ],
                          [
                            0.02,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.01,
                            -0.03
                          ],
                          [
                            -0.02,
                            -0.02
                          ],
                          [
                            -0.03,
                            -0.01
                          ],
                          [
                            -0.03,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            0.05
                          ],
                          [
                            -0.01,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            0.05
                          ],
                          [
                            -0.08,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.25,
                            1.59
                          ],
                          [
                            0.33,
                            0.38
                          ],
                          [
                            0.84,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.08,
                            0
                          ],
                          [
                            -0.06,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.01,
                            0.03
                          ],
                          [
                            0.01,
                            0.03
                          ],
                          [
                            0.02,
                            0.02
                          ],
                          [
                            0.03,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.08,
                            0
                          ],
                          [
                            0.06,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            -0.08
                          ],
                          [
                            0.06,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.65,
                            0
                          ],
                          [
                            0.11,
                            -0.69
                          ],
                          [
                            -0.36,
                            -0.42
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            4.21,
                            0.72
                          ],
                          [
                            1.7,
                            0.72
                          ],
                          [
                            1.47,
                            0.8
                          ],
                          [
                            1.36,
                            1.02
                          ],
                          [
                            0.34,
                            7.45
                          ],
                          [
                            0.35,
                            7.54
                          ],
                          [
                            0.39,
                            7.61
                          ],
                          [
                            0.46,
                            7.67
                          ],
                          [
                            0.55,
                            7.69
                          ],
                          [
                            1.75,
                            7.69
                          ],
                          [
                            1.97,
                            7.61
                          ],
                          [
                            2.09,
                            7.39
                          ],
                          [
                            2.36,
                            5.66
                          ],
                          [
                            2.48,
                            5.45
                          ],
                          [
                            2.71,
                            5.36
                          ],
                          [
                            3.5,
                            5.36
                          ],
                          [
                            6.36,
                            2.98
                          ],
                          [
                            6.04,
                            1.36
                          ],
                          [
                            4.21,
                            0.72
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.66,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.03
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            -0.26
                          ],
                          [
                            0.05,
                            -0.32
                          ]
                        ],
                        o: [
                          [
                            -0.14,
                            0.9
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            -0.05
                          ],
                          [
                            0.04,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.45,
                            0
                          ],
                          [
                            0.13,
                            0.15
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            4.5,
                            3.07
                          ],
                          [
                            3.01,
                            3.97
                          ],
                          [
                            2.63,
                            3.97
                          ],
                          [
                            2.89,
                            2.29
                          ],
                          [
                            2.96,
                            2.16
                          ],
                          [
                            3.1,
                            2.11
                          ],
                          [
                            3.28,
                            2.11
                          ],
                          [
                            4.38,
                            2.37
                          ],
                          [
                            4.5,
                            3.07
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.03
                          ],
                          [
                            0.01,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.58,
                            0
                          ],
                          [
                            0.22,
                            -1.41
                          ],
                          [
                            -0.4,
                            -0.47
                          ],
                          [
                            -0.62,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.01,
                            -0.03
                          ],
                          [
                            -0.02,
                            -0.02
                          ],
                          [
                            -0.03,
                            -0.01
                          ],
                          [
                            -0.03,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            0.05
                          ],
                          [
                            -0.01,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            0.03
                          ],
                          [
                            0.02,
                            0.02
                          ],
                          [
                            0.03,
                            0.02
                          ],
                          [
                            0.03,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.04,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.26,
                            -0.38
                          ],
                          [
                            -1.33,
                            0
                          ],
                          [
                            -0.12,
                            0.7
                          ],
                          [
                            0.37,
                            0.43
                          ],
                          [
                            1.07,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.03
                          ],
                          [
                            0.01,
                            0.03
                          ],
                          [
                            0.02,
                            0.02
                          ],
                          [
                            0.03,
                            0.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.08,
                            0
                          ],
                          [
                            0.06,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            -0.03
                          ],
                          [
                            -0.01,
                            -0.03
                          ],
                          [
                            -0.02,
                            -0.02
                          ],
                          [
                            -0.03,
                            -0.01
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            11.71,
                            3.04
                          ],
                          [
                            10.5,
                            3.04
                          ],
                          [
                            10.37,
                            3.09
                          ],
                          [
                            10.3,
                            3.22
                          ],
                          [
                            10.25,
                            3.55
                          ],
                          [
                            10.16,
                            3.43
                          ],
                          [
                            8.74,
                            2.93
                          ],
                          [
                            6.06,
                            5.34
                          ],
                          [
                            6.51,
                            7.19
                          ],
                          [
                            8.02,
                            7.8
                          ],
                          [
                            9.68,
                            7.11
                          ],
                          [
                            9.63,
                            7.45
                          ],
                          [
                            9.64,
                            7.54
                          ],
                          [
                            9.68,
                            7.61
                          ],
                          [
                            9.75,
                            7.67
                          ],
                          [
                            9.84,
                            7.69
                          ],
                          [
                            10.92,
                            7.69
                          ],
                          [
                            11.14,
                            7.61
                          ],
                          [
                            11.26,
                            7.39
                          ],
                          [
                            11.91,
                            3.28
                          ],
                          [
                            11.91,
                            3.19
                          ],
                          [
                            11.86,
                            3.11
                          ],
                          [
                            11.79,
                            3.06
                          ],
                          [
                            11.71,
                            3.04
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.7,
                            0
                          ],
                          [
                            0.18,
                            0.21
                          ],
                          [
                            -0.06,
                            0.33
                          ],
                          [
                            -0.68,
                            0
                          ],
                          [
                            -0.18,
                            -0.21
                          ],
                          [
                            0.05,
                            -0.33
                          ]
                        ],
                        o: [
                          [
                            -0.11,
                            0.69
                          ],
                          [
                            -0.35,
                            0
                          ],
                          [
                            -0.18,
                            -0.21
                          ],
                          [
                            0.11,
                            -0.68
                          ],
                          [
                            0.34,
                            0
                          ],
                          [
                            0.18,
                            0.22
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            10.03,
                            5.38
                          ],
                          [
                            8.68,
                            6.53
                          ],
                          [
                            7.87,
                            6.2
                          ],
                          [
                            7.68,
                            5.36
                          ],
                          [
                            9.03,
                            4.2
                          ],
                          [
                            9.83,
                            4.53
                          ],
                          [
                            10.03,
                            5.38
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.03
                          ],
                          [
                            0.04,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0.05
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            -0.01
                          ],
                          [
                            0.02,
                            -0.03
                          ],
                          [
                            0.01,
                            -0.03
                          ],
                          [
                            -0.01,
                            -0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.04
                          ],
                          [
                            -0.02,
                            -0.03
                          ],
                          [
                            -0.04,
                            -0.02
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.03
                          ],
                          [
                            -0.04,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.04
                          ],
                          [
                            0.02,
                            0.04
                          ],
                          [
                            0.03,
                            0.02
                          ],
                          [
                            0.04,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.05,
                            0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            -0.07
                          ],
                          [
                            -0.06,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.03,
                            0
                          ],
                          [
                            -0.03,
                            0.02
                          ],
                          [
                            -0.02,
                            0.03
                          ],
                          [
                            0,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            0.03
                          ],
                          [
                            0,
                            0.04
                          ],
                          [
                            0.02,
                            0.04
                          ],
                          [
                            0.03,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0
                          ],
                          [
                            0.05,
                            -0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            -0.03
                          ],
                          [
                            0,
                            -0.04
                          ],
                          [
                            -0.02,
                            -0.03
                          ],
                          [
                            -0.03,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            18.1,
                            3.04
                          ],
                          [
                            16.89,
                            3.04
                          ],
                          [
                            16.73,
                            3.08
                          ],
                          [
                            16.61,
                            3.2
                          ],
                          [
                            14.94,
                            5.64
                          ],
                          [
                            14.24,
                            3.29
                          ],
                          [
                            14.11,
                            3.11
                          ],
                          [
                            13.9,
                            3.04
                          ],
                          [
                            12.71,
                            3.04
                          ],
                          [
                            12.62,
                            3.06
                          ],
                          [
                            12.55,
                            3.13
                          ],
                          [
                            12.51,
                            3.22
                          ],
                          [
                            12.52,
                            3.32
                          ],
                          [
                            13.85,
                            7.22
                          ],
                          [
                            12.6,
                            8.98
                          ],
                          [
                            12.56,
                            9.09
                          ],
                          [
                            12.58,
                            9.2
                          ],
                          [
                            12.66,
                            9.28
                          ],
                          [
                            12.77,
                            9.31
                          ],
                          [
                            13.97,
                            9.31
                          ],
                          [
                            14.14,
                            9.27
                          ],
                          [
                            14.26,
                            9.16
                          ],
                          [
                            18.27,
                            3.37
                          ],
                          [
                            18.31,
                            3.26
                          ],
                          [
                            18.29,
                            3.15
                          ],
                          [
                            18.21,
                            3.07
                          ],
                          [
                            18.1,
                            3.04
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.15,
                        0.23,
                        0.5,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "857",
    layers: [
      {
        ind: 831,
        ty: 0,
        parent: 827,
        ks: {},
        w: 12,
        h: 14,
        ip: 0,
        op: 565,
        st: 0,
        refId: "829"
      },
      {
        ind: 827,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 836,
        ty: 0,
        parent: 832,
        ks: {},
        w: 9,
        h: 7,
        ip: 0,
        op: 565,
        st: 0,
        refId: "834"
      },
      {
        ind: 832,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              3,
              3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 841,
        ty: 0,
        parent: 837,
        ks: {},
        w: 10,
        h: 12,
        ip: 0,
        op: 565,
        st: 0,
        refId: "839"
      },
      {
        ind: 837,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              3,
              4
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 846,
        ty: 0,
        parent: 842,
        ks: {},
        w: 13,
        h: 14,
        ip: 0,
        op: 565,
        st: 0,
        refId: "844"
      },
      {
        ind: 842,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 851,
        ty: 0,
        parent: 847,
        ks: {},
        w: 20,
        h: 11,
        ip: 0,
        op: 565,
        st: 0,
        refId: "849"
      },
      {
        ind: 847,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              41,
              3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 856,
        ty: 0,
        parent: 852,
        ks: {},
        w: 25,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "854"
      },
      {
        ind: 852,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              17,
              3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "887",
    layers: [
      {
        ind: 886,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                13.5,
                6.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                27,
                13
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.12,
                                0
                              ],
                              [
                                0.09,
                                0.09
                              ],
                              [
                                0,
                                0.12
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.09,
                                0.09
                              ],
                              [
                                0,
                                0.12
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.12
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.02,
                                -0.06
                              ],
                              [
                                0,
                                -0.06
                              ],
                              [
                                0.02,
                                -0.05
                              ],
                              [
                                0.04,
                                -0.04
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                -0.12
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                -0.12
                              ],
                              [
                                0.09,
                                -0.09
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                -0.12
                              ],
                              [
                                0.09,
                                -0.09
                              ],
                              [
                                0.12,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                0.04
                              ],
                              [
                                0.02,
                                0.05
                              ],
                              [
                                0,
                                0.06
                              ],
                              [
                                -0.02,
                                0.06
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                19.51,
                                4.9
                              ],
                              [
                                15.39,
                                9.03
                              ],
                              [
                                15.07,
                                9.16
                              ],
                              [
                                14.74,
                                9.03
                              ],
                              [
                                14.61,
                                8.7
                              ],
                              [
                                14.74,
                                8.38
                              ],
                              [
                                18.09,
                                5.04
                              ],
                              [
                                0.46,
                                5.04
                              ],
                              [
                                0.13,
                                4.9
                              ],
                              [
                                0,
                                4.58
                              ],
                              [
                                0.13,
                                4.26
                              ],
                              [
                                0.46,
                                4.12
                              ],
                              [
                                18.09,
                                4.12
                              ],
                              [
                                14.74,
                                0.78
                              ],
                              [
                                14.61,
                                0.46
                              ],
                              [
                                14.74,
                                0.13
                              ],
                              [
                                15.07,
                                0
                              ],
                              [
                                15.39,
                                0.13
                              ],
                              [
                                19.51,
                                4.26
                              ],
                              [
                                19.61,
                                4.41
                              ],
                              [
                                19.65,
                                4.58
                              ],
                              [
                                19.61,
                                4.75
                              ],
                              [
                                19.51,
                                4.9
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0.57,
                            0.63,
                            0.72,
                            1
                          ]
                        },
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "926",
    layers: [
      {
        ind: 925,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                40.5,
                7.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                81,
                15
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.34,
                            -0.11
                          ],
                          [
                            -0.19,
                            -0.27
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            0.41,
                            -0.31
                          ],
                          [
                            0.67,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.46,
                            0
                          ],
                          [
                            0.34,
                            0.11
                          ],
                          [
                            0.19,
                            0.26
                          ],
                          [
                            0,
                            0.63
                          ],
                          [
                            -0.41,
                            0.31
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.83,
                            9
                          ],
                          [
                            0.83,
                            2.93
                          ],
                          [
                            2.56,
                            2.93
                          ],
                          [
                            3.76,
                            3.09
                          ],
                          [
                            4.55,
                            3.66
                          ],
                          [
                            4.84,
                            4.71
                          ],
                          [
                            4.22,
                            6.13
                          ],
                          [
                            2.6,
                            6.59
                          ],
                          [
                            1.6,
                            6.59
                          ],
                          [
                            1.6,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.25,
                            0.2
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            0.27,
                            0.16
                          ],
                          [
                            0.53,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0.53,
                            0
                          ],
                          [
                            0.26,
                            -0.2
                          ],
                          [
                            0,
                            -0.44
                          ],
                          [
                            -0.26,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.6,
                            5.96
                          ],
                          [
                            2.51,
                            5.96
                          ],
                          [
                            3.68,
                            5.67
                          ],
                          [
                            4.07,
                            4.71
                          ],
                          [
                            3.66,
                            3.81
                          ],
                          [
                            2.47,
                            3.55
                          ],
                          [
                            1.6,
                            3.55
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.16
                          ],
                          [
                            -0.25,
                            0
                          ],
                          [
                            -0.14,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0.01
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.15,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.29
                          ],
                          [
                            0.22,
                            -0.17
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.06,
                            -0.01
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            6,
                            9
                          ],
                          [
                            6,
                            4.5
                          ],
                          [
                            6.63,
                            4.5
                          ],
                          [
                            6.7,
                            5.32
                          ],
                          [
                            6.72,
                            5.32
                          ],
                          [
                            7.29,
                            4.64
                          ],
                          [
                            8,
                            4.39
                          ],
                          [
                            8.48,
                            4.48
                          ],
                          [
                            8.34,
                            5.15
                          ],
                          [
                            8.13,
                            5.09
                          ],
                          [
                            7.9,
                            5.07
                          ],
                          [
                            7.3,
                            5.3
                          ],
                          [
                            6.76,
                            6.11
                          ],
                          [
                            6.76,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.33,
                            0.19
                          ],
                          [
                            0.19,
                            0.35
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.19,
                            0.35
                          ],
                          [
                            -0.31,
                            0.19
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.31,
                            -0.38
                          ],
                          [
                            0,
                            -0.64
                          ],
                          [
                            0,
                            -0.08
                          ],
                          [
                            0.01,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.26,
                            -0.29
                          ],
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.18,
                            0.06
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.09
                          ],
                          [
                            0.31,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.4,
                            0
                          ],
                          [
                            -0.32,
                            -0.19
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.31,
                            -0.19
                          ],
                          [
                            0.57,
                            0
                          ],
                          [
                            0.32,
                            0.38
                          ],
                          [
                            0,
                            0.08
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.47
                          ],
                          [
                            0.27,
                            0.29
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.13
                          ],
                          [
                            -0.24,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            10.95,
                            9.11
                          ],
                          [
                            9.85,
                            8.83
                          ],
                          [
                            9.07,
                            8.02
                          ],
                          [
                            8.79,
                            6.76
                          ],
                          [
                            9.07,
                            5.49
                          ],
                          [
                            9.84,
                            4.68
                          ],
                          [
                            10.8,
                            4.39
                          ],
                          [
                            12.13,
                            4.96
                          ],
                          [
                            12.6,
                            6.5
                          ],
                          [
                            12.59,
                            6.74
                          ],
                          [
                            12.57,
                            6.94
                          ],
                          [
                            9.54,
                            6.94
                          ],
                          [
                            9.98,
                            8.07
                          ],
                          [
                            11.04,
                            8.5
                          ],
                          [
                            11.63,
                            8.41
                          ],
                          [
                            12.16,
                            8.15
                          ],
                          [
                            12.43,
                            8.65
                          ],
                          [
                            11.77,
                            8.97
                          ],
                          [
                            10.95,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.23
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.25,
                            -0.25
                          ],
                          [
                            0.05,
                            -0.45
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.46
                          ],
                          [
                            -0.19,
                            -0.24
                          ],
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            0.24
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.53,
                            6.39
                          ],
                          [
                            11.93,
                            6.39
                          ],
                          [
                            11.64,
                            5.35
                          ],
                          [
                            10.82,
                            4.99
                          ],
                          [
                            9.97,
                            5.36
                          ],
                          [
                            9.53,
                            6.39
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.36,
                            0.16
                          ],
                          [
                            0.27,
                            0.27
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.29,
                            -0.14
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.22,
                            0.18
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            0.09,
                            0.12
                          ],
                          [
                            0.16,
                            0.09
                          ],
                          [
                            0.19,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            0.13
                          ],
                          [
                            0.13,
                            0.2
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            -0.16,
                            0.24
                          ],
                          [
                            -0.29,
                            0.14
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.31,
                            -0.14
                          ],
                          [
                            -0.21,
                            -0.22
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0.1
                          ],
                          [
                            0.29,
                            0
                          ],
                          [
                            0.21,
                            -0.16
                          ],
                          [
                            0,
                            -0.27
                          ],
                          [
                            -0.1,
                            -0.13
                          ],
                          [
                            -0.16,
                            -0.08
                          ],
                          [
                            -0.16,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            -0.14
                          ],
                          [
                            -0.11,
                            -0.2
                          ],
                          [
                            0,
                            -0.3
                          ],
                          [
                            0.17,
                            -0.27
                          ],
                          [
                            0.31,
                            -0.15
                          ],
                          [
                            0.43,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.36,
                            -0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            0.23
                          ],
                          [
                            0.3,
                            0.14
                          ],
                          [
                            0.4,
                            0
                          ],
                          [
                            0.22,
                            -0.19
                          ],
                          [
                            0,
                            -0.21
                          ],
                          [
                            -0.09,
                            -0.12
                          ],
                          [
                            -0.14,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            -0.08
                          ],
                          [
                            -0.18,
                            -0.13
                          ],
                          [
                            -0.12,
                            -0.2
                          ],
                          [
                            0,
                            -0.31
                          ],
                          [
                            0.16,
                            -0.25
                          ],
                          [
                            0.29,
                            -0.14
                          ],
                          [
                            0.37,
                            0
                          ],
                          [
                            0.31,
                            0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            -0.18
                          ],
                          [
                            -0.22,
                            -0.11
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0.19
                          ],
                          [
                            0.11,
                            0.12
                          ],
                          [
                            0.15,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0.1
                          ],
                          [
                            0.19,
                            0.14
                          ],
                          [
                            0.11,
                            0.2
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            -0.17,
                            0.26
                          ],
                          [
                            -0.31,
                            0.16
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.32,
                            9.11
                          ],
                          [
                            16.14,
                            8.87
                          ],
                          [
                            15.2,
                            8.21
                          ],
                          [
                            15.66,
                            7.68
                          ],
                          [
                            16.42,
                            8.23
                          ],
                          [
                            17.34,
                            8.43
                          ],
                          [
                            18.27,
                            8.17
                          ],
                          [
                            18.6,
                            7.45
                          ],
                          [
                            18.46,
                            6.95
                          ],
                          [
                            18.1,
                            6.63
                          ],
                          [
                            17.59,
                            6.37
                          ],
                          [
                            16.72,
                            5.99
                          ],
                          [
                            16.15,
                            5.68
                          ],
                          [
                            15.68,
                            5.18
                          ],
                          [
                            15.49,
                            4.43
                          ],
                          [
                            15.73,
                            3.6
                          ],
                          [
                            16.42,
                            3.03
                          ],
                          [
                            17.4,
                            2.82
                          ],
                          [
                            18.41,
                            3.03
                          ],
                          [
                            19.2,
                            3.57
                          ],
                          [
                            18.78,
                            4.07
                          ],
                          [
                            18.16,
                            3.65
                          ],
                          [
                            17.4,
                            3.49
                          ],
                          [
                            16.57,
                            3.73
                          ],
                          [
                            16.27,
                            4.38
                          ],
                          [
                            16.42,
                            4.86
                          ],
                          [
                            16.81,
                            5.17
                          ],
                          [
                            17.28,
                            5.39
                          ],
                          [
                            18.14,
                            5.76
                          ],
                          [
                            18.77,
                            6.12
                          ],
                          [
                            19.22,
                            6.63
                          ],
                          [
                            19.39,
                            7.38
                          ],
                          [
                            19.14,
                            8.26
                          ],
                          [
                            18.43,
                            8.88
                          ],
                          [
                            17.32,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.32,
                            0.19
                          ],
                          [
                            0.18,
                            0.35
                          ],
                          [
                            0,
                            0.5
                          ],
                          [
                            -0.2,
                            0.35
                          ],
                          [
                            -0.32,
                            0.18
                          ],
                          [
                            -0.38,
                            0
                          ],
                          [
                            -0.21,
                            -0.11
                          ],
                          [
                            -0.16,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.07
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.13,
                            -0.27
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            -0.25,
                            -0.32
                          ],
                          [
                            -0.41,
                            0
                          ],
                          [
                            -0.18,
                            0.09
                          ],
                          [
                            -0.14,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.11
                          ],
                          [
                            0.27,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.39,
                            0
                          ],
                          [
                            -0.32,
                            -0.18
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.5
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.34,
                            -0.18
                          ],
                          [
                            0.3,
                            0
                          ],
                          [
                            0.21,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            -0.12
                          ],
                          [
                            -0.14,
                            -0.07
                          ],
                          [
                            -0.27,
                            0
                          ],
                          [
                            -0.21,
                            0.14
                          ],
                          [
                            -0.12,
                            0.26
                          ],
                          [
                            0,
                            0.52
                          ],
                          [
                            0.26,
                            0.32
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0.18,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.18
                          ],
                          [
                            -0.25,
                            0.1
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            22.29,
                            9.11
                          ],
                          [
                            21.21,
                            8.83
                          ],
                          [
                            20.46,
                            8.03
                          ],
                          [
                            20.18,
                            6.76
                          ],
                          [
                            20.48,
                            5.47
                          ],
                          [
                            21.27,
                            4.67
                          ],
                          [
                            22.34,
                            4.39
                          ],
                          [
                            23.11,
                            4.55
                          ],
                          [
                            23.66,
                            4.92
                          ],
                          [
                            23.27,
                            5.42
                          ],
                          [
                            22.86,
                            5.13
                          ],
                          [
                            22.37,
                            5.02
                          ],
                          [
                            21.64,
                            5.24
                          ],
                          [
                            21.14,
                            5.85
                          ],
                          [
                            20.96,
                            6.76
                          ],
                          [
                            21.34,
                            8.01
                          ],
                          [
                            22.36,
                            8.48
                          ],
                          [
                            22.94,
                            8.35
                          ],
                          [
                            23.41,
                            8.03
                          ],
                          [
                            23.74,
                            8.54
                          ],
                          [
                            23.07,
                            8.96
                          ],
                          [
                            22.29,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.22
                          ],
                          [
                            0,
                            0.4
                          ],
                          [
                            -0.44,
                            0.26
                          ],
                          [
                            -0.96,
                            0.11
                          ],
                          [
                            0.05,
                            0.18
                          ],
                          [
                            0.14,
                            0.1
                          ],
                          [
                            0.25,
                            0
                          ],
                          [
                            0.23,
                            -0.1
                          ],
                          [
                            0.18,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.3,
                            0.12
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.25,
                            -0.34
                          ],
                          [
                            0,
                            -0.56
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.13
                          ],
                          [
                            0.29,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.37,
                            0
                          ],
                          [
                            -0.25,
                            -0.23
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.45,
                            -0.27
                          ],
                          [
                            0,
                            -0.19
                          ],
                          [
                            -0.05,
                            -0.17
                          ],
                          [
                            -0.13,
                            -0.11
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.23,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            -0.14
                          ],
                          [
                            0.31,
                            -0.13
                          ],
                          [
                            0.55,
                            0
                          ],
                          [
                            0.25,
                            0.33
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            0.17
                          ],
                          [
                            -0.25,
                            0.13
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.68,
                            9.11
                          ],
                          [
                            24.73,
                            8.78
                          ],
                          [
                            24.37,
                            7.83
                          ],
                          [
                            25.02,
                            6.7
                          ],
                          [
                            27.13,
                            6.15
                          ],
                          [
                            27.04,
                            5.6
                          ],
                          [
                            26.76,
                            5.19
                          ],
                          [
                            26.2,
                            5.02
                          ],
                          [
                            25.47,
                            5.17
                          ],
                          [
                            24.86,
                            5.5
                          ],
                          [
                            24.56,
                            4.97
                          ],
                          [
                            25.33,
                            4.59
                          ],
                          [
                            26.33,
                            4.39
                          ],
                          [
                            27.52,
                            4.9
                          ],
                          [
                            27.89,
                            6.24
                          ],
                          [
                            27.89,
                            9
                          ],
                          [
                            27.26,
                            9
                          ],
                          [
                            27.2,
                            8.46
                          ],
                          [
                            27.17,
                            8.46
                          ],
                          [
                            26.48,
                            8.92
                          ],
                          [
                            25.68,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.11
                          ],
                          [
                            -0.21,
                            0.19
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.3,
                            -0.19
                          ],
                          [
                            0,
                            -0.29
                          ],
                          [
                            -0.15,
                            -0.12
                          ],
                          [
                            -0.22,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.21,
                            0
                          ],
                          [
                            0.19,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.75,
                            0.09
                          ],
                          [
                            -0.3,
                            0.18
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.9,
                            8.5
                          ],
                          [
                            26.51,
                            8.34
                          ],
                          [
                            27.13,
                            7.9
                          ],
                          [
                            27.13,
                            6.65
                          ],
                          [
                            25.55,
                            7.07
                          ],
                          [
                            25.11,
                            7.78
                          ],
                          [
                            25.34,
                            8.33
                          ],
                          [
                            25.9,
                            8.5
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0.17
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.05
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            -0.01
                          ],
                          [
                            0.11,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.12,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.12
                          ],
                          [
                            0.04,
                            0.05
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0.03,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.03
                          ],
                          [
                            -0.07,
                            0.01
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            30.11,
                            9.11
                          ],
                          [
                            29.49,
                            8.85
                          ],
                          [
                            29.31,
                            8.09
                          ],
                          [
                            29.31,
                            2.41
                          ],
                          [
                            30.07,
                            2.41
                          ],
                          [
                            30.07,
                            8.15
                          ],
                          [
                            30.13,
                            8.41
                          ],
                          [
                            30.28,
                            8.48
                          ],
                          [
                            30.34,
                            8.48
                          ],
                          [
                            30.45,
                            8.46
                          ],
                          [
                            30.55,
                            9.04
                          ],
                          [
                            30.37,
                            9.09
                          ],
                          [
                            30.11,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.33,
                            0.19
                          ],
                          [
                            0.19,
                            0.35
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.19,
                            0.35
                          ],
                          [
                            -0.31,
                            0.19
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.31,
                            -0.38
                          ],
                          [
                            0,
                            -0.64
                          ],
                          [
                            0,
                            -0.08
                          ],
                          [
                            0.01,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.27,
                            -0.29
                          ],
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.18,
                            0.06
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.09
                          ],
                          [
                            0.31,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.4,
                            0
                          ],
                          [
                            -0.33,
                            -0.19
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.31,
                            -0.19
                          ],
                          [
                            0.57,
                            0
                          ],
                          [
                            0.32,
                            0.38
                          ],
                          [
                            0,
                            0.08
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.47
                          ],
                          [
                            0.27,
                            0.29
                          ],
                          [
                            0.22,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.13
                          ],
                          [
                            -0.24,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            33.49,
                            9.11
                          ],
                          [
                            32.4,
                            8.83
                          ],
                          [
                            31.62,
                            8.02
                          ],
                          [
                            31.34,
                            6.76
                          ],
                          [
                            31.62,
                            5.49
                          ],
                          [
                            32.38,
                            4.68
                          ],
                          [
                            33.35,
                            4.39
                          ],
                          [
                            34.68,
                            4.96
                          ],
                          [
                            35.15,
                            6.5
                          ],
                          [
                            35.14,
                            6.74
                          ],
                          [
                            35.12,
                            6.94
                          ],
                          [
                            32.09,
                            6.94
                          ],
                          [
                            32.53,
                            8.07
                          ],
                          [
                            33.58,
                            8.5
                          ],
                          [
                            34.18,
                            8.41
                          ],
                          [
                            34.7,
                            8.15
                          ],
                          [
                            34.97,
                            8.65
                          ],
                          [
                            34.32,
                            8.97
                          ],
                          [
                            33.49,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.23
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.25,
                            -0.25
                          ],
                          [
                            0.05,
                            -0.45
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.46
                          ],
                          [
                            -0.19,
                            -0.24
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.25,
                            0.24
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            32.07,
                            6.39
                          ],
                          [
                            34.48,
                            6.39
                          ],
                          [
                            34.19,
                            5.35
                          ],
                          [
                            33.37,
                            4.99
                          ],
                          [
                            32.52,
                            5.36
                          ],
                          [
                            32.07,
                            6.39
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.16
                          ],
                          [
                            -0.25,
                            0
                          ],
                          [
                            -0.14,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0.01
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.15,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.29
                          ],
                          [
                            0.22,
                            -0.17
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.06,
                            -0.01
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            36.26,
                            9
                          ],
                          [
                            36.26,
                            4.5
                          ],
                          [
                            36.89,
                            4.5
                          ],
                          [
                            36.95,
                            5.32
                          ],
                          [
                            36.98,
                            5.32
                          ],
                          [
                            37.55,
                            4.64
                          ],
                          [
                            38.26,
                            4.39
                          ],
                          [
                            38.74,
                            4.48
                          ],
                          [
                            38.59,
                            5.15
                          ],
                          [
                            38.39,
                            5.09
                          ],
                          [
                            38.16,
                            5.07
                          ],
                          [
                            37.55,
                            5.3
                          ],
                          [
                            37.02,
                            6.11
                          ],
                          [
                            37.02,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.49,
                        0.55,
                        0.65,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "958",
    layers: [
      {
        ind: 957,
        ty: 2,
        parent: 956,
        ks: {
          s: {
            a: 0,
            k: [
              157.14,
              162.5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "0"
      },
      {
        ind: 956,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "961",
    layers: [
      {
        ind: 960,
        ty: 0,
        parent: 955,
        ks: {},
        w: 11,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "958"
      },
      {
        ind: 955,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "980",
    layers: [
      {
        ind: 979,
        ty: 2,
        parent: 978,
        ks: {
          s: {
            a: 0,
            k: [
              162.5,
              160
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "1"
      },
      {
        ind: 978,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "983",
    layers: [
      {
        ind: 982,
        ty: 0,
        parent: 977,
        ks: {},
        w: 13,
        h: 12,
        ip: 0,
        op: 565,
        st: 0,
        refId: "980"
      },
      {
        ind: 977,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1016",
    layers: [
      {
        ind: 1015,
        ty: 2,
        parent: 1014,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        refId: "6"
      },
      {
        ind: 1014,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1019",
    layers: [
      {
        ind: 1018,
        ty: 0,
        parent: 1013,
        ks: {},
        w: 19,
        h: 21.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1016"
      },
      {
        ind: 1013,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1030",
    layers: [
      {
        ind: 1029,
        ty: 2,
        parent: 1028,
        ks: {
          s: {
            a: 0,
            k: [
              165.22,
              165.22
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "7"
      },
      {
        ind: 1028,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1033",
    layers: [
      {
        ind: 1032,
        ty: 0,
        parent: 1027,
        ks: {},
        w: 76,
        h: 76,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1030"
      },
      {
        ind: 1027,
        ty: 3,
        parent: 1026,
        ks: {
          p: {
            a: 0,
            k: [
              -7,
              -4
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1026,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              7,
              4
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1037",
    layers: [
      {
        ind: 1036,
        ty: 4,
        td: 1,
        parent: 1025,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                31.739,
                31.739
              ]
            },
            r: {
              a: 0,
              k: 31
            },
            s: {
              a: 0,
              k: [
                63.478,
                63.478
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1035,
        ty: 0,
        tt: 1,
        parent: 1025,
        ks: {
          a: {
            a: 0,
            k: [
              7,
              4
            ]
          }
        },
        w: 83,
        h: 80,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1033"
      },
      {
        ind: 1025,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              7.053,
              7.053
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1042",
    layers: [
      {
        ind: 764,
        ty: 4,
        parent: 763,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 763,
        ty: 3,
        parent: 762,
        ks: {
          p: {
            a: 0,
            k: [
              28.394,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 766,
        ty: 4,
        parent: 765,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 765,
        ty: 3,
        parent: 762,
        ks: {
          p: {
            a: 0,
            k: [
              22.138,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 768,
        ty: 4,
        parent: 767,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ],
                  [
                    1.2,
                    11.3
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    10.1
                  ],
                  [
                    2.4,
                    10.5
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.7,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    3,
                    11.6
                  ],
                  [
                    2.7,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 767,
        ty: 3,
        parent: 762,
        ks: {
          p: {
            a: 0,
            k: [
              18.794,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 770,
        ty: 4,
        parent: 769,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 769,
        ty: 3,
        parent: 762,
        ks: {
          p: {
            a: 0,
            k: [
              12.426,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 772,
        ty: 4,
        parent: 771,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.9,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.8
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    4.6,
                    5.6
                  ],
                  [
                    5.3,
                    6.1
                  ],
                  [
                    5.3,
                    6.1
                  ],
                  [
                    4.6,
                    7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    2.4,
                    7.1
                  ],
                  [
                    2,
                    8.6
                  ],
                  [
                    2,
                    8.6
                  ],
                  [
                    2.4,
                    10
                  ],
                  [
                    3.6,
                    10.6
                  ],
                  [
                    3.6,
                    10.6
                  ],
                  [
                    4.3,
                    10.4
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    5.4,
                    11
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 771,
        ty: 3,
        parent: 762,
        ks: {
          p: {
            a: 0,
            k: [
              6.725,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 774,
        ty: 4,
        parent: 773,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    1.3,
                    9.6
                  ],
                  [
                    2.3,
                    10.2
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    4.5,
                    10.2
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.5,
                    8.7
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    2.5,
                    7.8
                  ],
                  [
                    1.7,
                    7.3
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    1.2,
                    4.5
                  ],
                  [
                    2.1,
                    3.7
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    4.9,
                    3.6
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    5.3,
                    5.3
                  ],
                  [
                    4.5,
                    4.8
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.5,
                    6.1
                  ],
                  [
                    2.9,
                    6.4
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    4.7,
                    7.2
                  ],
                  [
                    5.8,
                    8
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    5.9,
                    10.5
                  ],
                  [
                    4.9,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 773,
        ty: 3,
        parent: 762,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 762,
        ty: 3,
        parent: 761,
        ks: {
          p: {
            a: 0,
            k: [
              122.02,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 777,
        ty: 4,
        parent: 776,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 776,
        ty: 3,
        parent: 775,
        ks: {
          p: {
            a: 0,
            k: [
              20.548,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 779,
        ty: 4,
        parent: 778,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 778,
        ty: 3,
        parent: 775,
        ks: {
          p: {
            a: 0,
            k: [
              14.292,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 781,
        ty: 4,
        parent: 780,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.6,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.3,
                    6.7
                  ],
                  [
                    0.3,
                    5.6
                  ],
                  [
                    1.1,
                    5.5
                  ],
                  [
                    1.1,
                    4.9
                  ],
                  [
                    1.6,
                    3.3
                  ],
                  [
                    3.2,
                    2.7
                  ],
                  [
                    3.2,
                    2.7
                  ],
                  [
                    3.8,
                    2.8
                  ],
                  [
                    4.3,
                    2.9
                  ],
                  [
                    4.3,
                    2.9
                  ],
                  [
                    4,
                    4
                  ],
                  [
                    3.3,
                    3.8
                  ],
                  [
                    3.3,
                    3.8
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.6,
                    5.5
                  ],
                  [
                    3.8,
                    5.5
                  ],
                  [
                    3.8,
                    6.7
                  ],
                  [
                    2.6,
                    6.7
                  ],
                  [
                    2.6,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    6.9,
                    11.7
                  ],
                  [
                    6.9,
                    11.7
                  ],
                  [
                    5.5,
                    11.1
                  ],
                  [
                    5,
                    9.5
                  ],
                  [
                    5,
                    9.5
                  ],
                  [
                    5,
                    6.7
                  ],
                  [
                    4.2,
                    6.7
                  ],
                  [
                    4.2,
                    5.6
                  ],
                  [
                    5.1,
                    5.5
                  ],
                  [
                    5.3,
                    3.9
                  ],
                  [
                    6.5,
                    3.9
                  ],
                  [
                    6.5,
                    5.5
                  ],
                  [
                    8,
                    5.5
                  ],
                  [
                    8,
                    6.7
                  ],
                  [
                    6.5,
                    6.7
                  ],
                  [
                    6.5,
                    9.5
                  ],
                  [
                    7.3,
                    10.6
                  ],
                  [
                    7.3,
                    10.6
                  ],
                  [
                    7.6,
                    10.6
                  ],
                  [
                    7.9,
                    10.5
                  ],
                  [
                    7.9,
                    10.5
                  ],
                  [
                    8.2,
                    11.5
                  ],
                  [
                    7.6,
                    11.7
                  ],
                  [
                    6.9,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 780,
        ty: 3,
        parent: 775,
        ks: {
          p: {
            a: 0,
            k: [
              6.367,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 783,
        ty: 4,
        parent: 782,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 782,
        ty: 3,
        parent: 775,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 775,
        ty: 3,
        parent: 761,
        ks: {
          p: {
            a: 0,
            k: [
              94.401,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 786,
        ty: 4,
        parent: 785,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 785,
        ty: 3,
        parent: 784,
        ks: {
          p: {
            a: 0,
            k: [
              17.856,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 788,
        ty: 4,
        parent: 787,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    6.1,
                    5.5
                  ],
                  [
                    4.1,
                    8
                  ],
                  [
                    6.3,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    3.2,
                    9
                  ],
                  [
                    2.3,
                    10
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 787,
        ty: 3,
        parent: 784,
        ks: {
          p: {
            a: 0,
            k: [
              11.414,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 790,
        ty: 4,
        parent: 789,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.3,
                    5.5
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    1.6,
                    4.5
                  ],
                  [
                    1.6,
                    4.5
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.8,
                    3.7
                  ],
                  [
                    0.8,
                    3.7
                  ],
                  [
                    1,
                    3.1
                  ],
                  [
                    1.6,
                    2.8
                  ],
                  [
                    1.6,
                    2.8
                  ],
                  [
                    2.2,
                    3.1
                  ],
                  [
                    2.5,
                    3.7
                  ],
                  [
                    2.5,
                    3.7
                  ],
                  [
                    2.2,
                    4.2
                  ],
                  [
                    1.6,
                    4.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 789,
        ty: 3,
        parent: 784,
        ks: {
          p: {
            a: 0,
            k: [
              8.181,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 792,
        ty: 4,
        parent: 791,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.5,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    3.5
                  ],
                  [
                    2.5,
                    3.5
                  ],
                  [
                    2.5,
                    6.8
                  ],
                  [
                    5.7,
                    6.8
                  ],
                  [
                    5.7,
                    3.5
                  ],
                  [
                    7.2,
                    3.5
                  ],
                  [
                    7.2,
                    11.6
                  ],
                  [
                    5.7,
                    11.6
                  ],
                  [
                    5.7,
                    8
                  ],
                  [
                    2.5,
                    8
                  ],
                  [
                    2.5,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 791,
        ty: 3,
        parent: 784,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 784,
        ty: 3,
        parent: 761,
        ks: {
          p: {
            a: 0,
            k: [
              67.821,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 795,
        ty: 4,
        parent: 794,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.7,
                    0
                  ]
                ],
                v: [
                  [
                    1.3,
                    14.1
                  ],
                  [
                    1.3,
                    14.1
                  ],
                  [
                    0.9,
                    14
                  ],
                  [
                    0.5,
                    14
                  ],
                  [
                    0.5,
                    14
                  ],
                  [
                    0.8,
                    12.8
                  ],
                  [
                    1,
                    12.9
                  ],
                  [
                    1.2,
                    12.9
                  ],
                  [
                    1.2,
                    12.9
                  ],
                  [
                    2,
                    12.6
                  ],
                  [
                    2.4,
                    11.9
                  ],
                  [
                    2.4,
                    11.9
                  ],
                  [
                    2.5,
                    11.5
                  ],
                  [
                    0.1,
                    5.5
                  ],
                  [
                    1.6,
                    5.5
                  ],
                  [
                    2.6,
                    8.5
                  ],
                  [
                    2.9,
                    9.3
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.4,
                    9.3
                  ],
                  [
                    3.7,
                    8.5
                  ],
                  [
                    3.7,
                    8.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    6,
                    5.5
                  ],
                  [
                    3.8,
                    11.9
                  ],
                  [
                    2.8,
                    13.5
                  ],
                  [
                    1.3,
                    14.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.7
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 794,
        ty: 3,
        parent: 793,
        ks: {
          p: {
            a: 0,
            k: [
              27.407,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 797,
        ty: 4,
        parent: 796,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 796,
        ty: 3,
        parent: 793,
        ks: {
          p: {
            a: 0,
            k: [
              22.804,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 799,
        ty: 4,
        parent: 798,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 798,
        ty: 3,
        parent: 793,
        ks: {
          p: {
            a: 0,
            k: [
              16.437,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 801,
        ty: 4,
        parent: 800,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ],
                  [
                    1.2,
                    11.3
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    10.1
                  ],
                  [
                    2.4,
                    10.5
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.7,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    3,
                    11.6
                  ],
                  [
                    2.7,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 800,
        ty: 3,
        parent: 793,
        ks: {
          p: {
            a: 0,
            k: [
              13.093,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 803,
        ty: 4,
        parent: 802,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 802,
        ty: 3,
        parent: 793,
        ks: {
          p: {
            a: 0,
            k: [
              6.725,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 805,
        ty: 4,
        parent: 804,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    1.3,
                    9.6
                  ],
                  [
                    2.3,
                    10.2
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    4.5,
                    10.2
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.5,
                    8.7
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    2.5,
                    7.8
                  ],
                  [
                    1.7,
                    7.3
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    1.2,
                    4.5
                  ],
                  [
                    2.1,
                    3.7
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    4.9,
                    3.6
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    5.3,
                    5.3
                  ],
                  [
                    4.5,
                    4.8
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.5,
                    6.1
                  ],
                  [
                    2.9,
                    6.4
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    4.7,
                    7.2
                  ],
                  [
                    5.8,
                    8
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    5.9,
                    10.5
                  ],
                  [
                    4.9,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 804,
        ty: 3,
        parent: 793,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 793,
        ty: 3,
        parent: 761,
        ks: {
          p: {
            a: 0,
            k: [
              31.837,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 808,
        ty: 4,
        parent: 807,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    8.5
                  ],
                  [
                    2.3,
                    8.5
                  ],
                  [
                    0.9,
                    7.8
                  ],
                  [
                    0.4,
                    5.9
                  ],
                  [
                    0.4,
                    5.9
                  ],
                  [
                    0.9,
                    4
                  ],
                  [
                    2.3,
                    3.4
                  ],
                  [
                    2.3,
                    3.4
                  ],
                  [
                    3.7,
                    4
                  ],
                  [
                    4.2,
                    5.9
                  ],
                  [
                    4.2,
                    5.9
                  ],
                  [
                    3.7,
                    7.8
                  ],
                  [
                    2.3,
                    8.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    7.7
                  ],
                  [
                    2.3,
                    7.7
                  ],
                  [
                    2.9,
                    7.2
                  ],
                  [
                    3.2,
                    5.9
                  ],
                  [
                    3.2,
                    5.9
                  ],
                  [
                    2.9,
                    4.6
                  ],
                  [
                    2.3,
                    4.2
                  ],
                  [
                    2.3,
                    4.2
                  ],
                  [
                    1.7,
                    4.6
                  ],
                  [
                    1.4,
                    5.9
                  ],
                  [
                    1.4,
                    5.9
                  ],
                  [
                    1.7,
                    7.2
                  ],
                  [
                    2.3,
                    7.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2.6,
                    11.7
                  ],
                  [
                    7,
                    3.4
                  ],
                  [
                    7.8,
                    3.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    8.1,
                    11.7
                  ],
                  [
                    8.1,
                    11.7
                  ],
                  [
                    6.7,
                    11.1
                  ],
                  [
                    6.2,
                    9.2
                  ],
                  [
                    6.2,
                    9.2
                  ],
                  [
                    6.7,
                    7.3
                  ],
                  [
                    8.1,
                    6.6
                  ],
                  [
                    8.1,
                    6.6
                  ],
                  [
                    9.5,
                    7.3
                  ],
                  [
                    10,
                    9.2
                  ],
                  [
                    10,
                    9.2
                  ],
                  [
                    9.5,
                    11.1
                  ],
                  [
                    8.1,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    8.1,
                    10.9
                  ],
                  [
                    8.1,
                    10.9
                  ],
                  [
                    8.7,
                    10.5
                  ],
                  [
                    9,
                    9.2
                  ],
                  [
                    9,
                    9.2
                  ],
                  [
                    8.7,
                    7.9
                  ],
                  [
                    8.1,
                    7.5
                  ],
                  [
                    8.1,
                    7.5
                  ],
                  [
                    7.4,
                    7.9
                  ],
                  [
                    7.2,
                    9.2
                  ],
                  [
                    7.2,
                    9.2
                  ],
                  [
                    7.4,
                    10.5
                  ],
                  [
                    8.1,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 807,
        ty: 3,
        parent: 806,
        ks: {
          p: {
            a: 0,
            k: [
              18.991,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 810,
        ty: 4,
        parent: 809,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    11.7
                  ],
                  [
                    3,
                    11.7
                  ],
                  [
                    1.4,
                    11.4
                  ],
                  [
                    0.3,
                    10.6
                  ],
                  [
                    0.3,
                    10.6
                  ],
                  [
                    1,
                    9.7
                  ],
                  [
                    1.8,
                    10.3
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.9,
                    10.2
                  ],
                  [
                    4.3,
                    9.1
                  ],
                  [
                    4.3,
                    9.1
                  ],
                  [
                    3.9,
                    8
                  ],
                  [
                    2.9,
                    7.6
                  ],
                  [
                    2.9,
                    7.6
                  ],
                  [
                    2.2,
                    7.7
                  ],
                  [
                    1.6,
                    8
                  ],
                  [
                    1.6,
                    8
                  ],
                  [
                    0.9,
                    7.6
                  ],
                  [
                    1.2,
                    3.7
                  ],
                  [
                    5.4,
                    3.7
                  ],
                  [
                    5.4,
                    4.9
                  ],
                  [
                    2.4,
                    4.9
                  ],
                  [
                    2.2,
                    6.8
                  ],
                  [
                    2.7,
                    6.6
                  ],
                  [
                    3.3,
                    6.6
                  ],
                  [
                    3.3,
                    6.6
                  ],
                  [
                    4.5,
                    6.8
                  ],
                  [
                    5.4,
                    7.6
                  ],
                  [
                    5.7,
                    9
                  ],
                  [
                    5.7,
                    9
                  ],
                  [
                    5.4,
                    10.5
                  ],
                  [
                    4.3,
                    11.4
                  ],
                  [
                    3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 809,
        ty: 3,
        parent: 806,
        ks: {
          p: {
            a: 0,
            k: [
              12.661,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 812,
        ty: 4,
        parent: 811,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    5.6,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    10.4
                  ],
                  [
                    2.7,
                    10.4
                  ],
                  [
                    2.7,
                    5.3
                  ],
                  [
                    1.2,
                    5.3
                  ],
                  [
                    1.2,
                    4.4
                  ],
                  [
                    2.2,
                    4.1
                  ],
                  [
                    3,
                    3.7
                  ],
                  [
                    3,
                    3.7
                  ],
                  [
                    4.1,
                    3.7
                  ],
                  [
                    4.1,
                    10.4
                  ],
                  [
                    5.6,
                    10.4
                  ],
                  [
                    5.6,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 811,
        ty: 3,
        parent: 806,
        ks: {
          p: {
            a: 0,
            k: [
              6.33,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 814,
        ty: 4,
        parent: 813,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.1,
                    6.3
                  ],
                  [
                    1.6,
                    8.5
                  ],
                  [
                    3.7,
                    8.5
                  ],
                  [
                    3.7,
                    6.7
                  ],
                  [
                    3.7,
                    5.9
                  ],
                  [
                    3.8,
                    5.1
                  ],
                  [
                    3.8,
                    5.1
                  ],
                  [
                    3.7,
                    5.1
                  ],
                  [
                    3.4,
                    5.7
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    5,
                    11.6
                  ],
                  [
                    3.7,
                    11.6
                  ],
                  [
                    3.7,
                    9.6
                  ],
                  [
                    0.2,
                    9.6
                  ],
                  [
                    0.2,
                    8.6
                  ],
                  [
                    3.3,
                    3.7
                  ],
                  [
                    5,
                    3.7
                  ],
                  [
                    5,
                    8.5
                  ],
                  [
                    6,
                    8.5
                  ],
                  [
                    6,
                    9.6
                  ],
                  [
                    5,
                    9.6
                  ],
                  [
                    5,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 813,
        ty: 3,
        parent: 806,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 806,
        ty: 3,
        parent: 761,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 761,
        ty: 3,
        parent: 760,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 760,
        ty: 3,
        parent: 759,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 759,
        ty: 3,
        parent: 758,
        ks: {
          p: {
            a: 0,
            k: [
              22.167,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 823,
        ty: 0,
        parent: 815,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "821"
      },
      {
        ind: 815,
        ty: 3,
        parent: 758,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 758,
        ty: 3,
        parent: 757,
        ks: {
          p: {
            a: 0,
            k: [
              48.952,
              3.527
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 757,
        ty: 3,
        parent: 756,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              46.727
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 859,
        ty: 0,
        parent: 826,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              13.015
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              13.015
            ]
          }
        },
        w: 60.455,
        h: 16.081,
        ip: 0,
        op: 565,
        st: 0,
        refId: "857"
      },
      {
        ind: 826,
        ty: 3,
        parent: 825,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              13.015
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 864,
        ty: 4,
        parent: 863,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.22,
                    0.16
                  ],
                  [
                    -0.25,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.14,
                    -0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.06,
                    0.01
                  ],
                  [
                    0.09,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.15
                  ],
                  [
                    0.15,
                    -0.37
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.49,
                    8.51
                  ],
                  [
                    0.74,
                    8.51
                  ],
                  [
                    0.74,
                    4.11
                  ],
                  [
                    1.36,
                    4.11
                  ],
                  [
                    1.42,
                    4.9
                  ],
                  [
                    1.45,
                    4.9
                  ],
                  [
                    2,
                    4.24
                  ],
                  [
                    2.7,
                    4
                  ],
                  [
                    2.7,
                    4
                  ],
                  [
                    3.17,
                    4.09
                  ],
                  [
                    3.17,
                    4.09
                  ],
                  [
                    3.03,
                    4.74
                  ],
                  [
                    2.83,
                    4.69
                  ],
                  [
                    2.6,
                    4.67
                  ],
                  [
                    2.6,
                    4.67
                  ],
                  [
                    2.02,
                    4.9
                  ],
                  [
                    1.49,
                    5.68
                  ],
                  [
                    1.49,
                    5.68
                  ],
                  [
                    1.49,
                    8.51
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.15,
                    -0.28
                  ],
                  [
                    0.22,
                    -0.16
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.18,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.07,
                    -0.02
                  ],
                  [
                    -0.06,
                    -0.01
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0
                  ],
                  [
                    -0.2,
                    0.15
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 863,
        ty: 3,
        parent: 862,
        ks: {
          p: {
            a: 0,
            k: [
              20.34,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 866,
        ty: 4,
        parent: 865,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.32,
                    0.18
                  ],
                  [
                    0.19,
                    0.34
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.34
                  ],
                  [
                    -0.3,
                    0.19
                  ],
                  [
                    -0.33,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    -0.37
                  ],
                  [
                    0,
                    -0.63
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.08
                  ],
                  [
                    0.01,
                    -0.05
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.26,
                    -0.28
                  ],
                  [
                    -0.42,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.18,
                    0.06
                  ],
                  [
                    -0.16,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.09
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.53,
                    8.62
                  ],
                  [
                    2.53,
                    8.62
                  ],
                  [
                    1.46,
                    8.35
                  ],
                  [
                    0.7,
                    7.55
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.7,
                    5.08
                  ],
                  [
                    1.44,
                    4.28
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    3.7,
                    4.56
                  ],
                  [
                    4.15,
                    6.07
                  ],
                  [
                    4.15,
                    6.07
                  ],
                  [
                    4.15,
                    6.3
                  ],
                  [
                    4.13,
                    6.49
                  ],
                  [
                    4.13,
                    6.49
                  ],
                  [
                    1.15,
                    6.49
                  ],
                  [
                    1.59,
                    7.61
                  ],
                  [
                    2.62,
                    8.02
                  ],
                  [
                    2.62,
                    8.02
                  ],
                  [
                    3.21,
                    7.93
                  ],
                  [
                    3.72,
                    7.68
                  ],
                  [
                    3.72,
                    7.68
                  ],
                  [
                    3.98,
                    8.17
                  ],
                  [
                    3.34,
                    8.49
                  ],
                  [
                    2.53,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.39,
                    0
                  ],
                  [
                    -0.32,
                    -0.18
                  ],
                  [
                    -0.19,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.48
                  ],
                  [
                    0.19,
                    -0.34
                  ],
                  [
                    0.3,
                    -0.19
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.56,
                    0
                  ],
                  [
                    0.31,
                    0.37
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.08
                  ],
                  [
                    0,
                    0.08
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.03,
                    0.47
                  ],
                  [
                    0.26,
                    0.28
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0
                  ],
                  [
                    0.18,
                    -0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.12
                  ],
                  [
                    -0.24,
                    0.09
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.19,
                    0.23
                  ],
                  [
                    0.34,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.24
                  ],
                  [
                    0.05,
                    -0.44
                  ]
                ],
                v: [
                  [
                    1.14,
                    5.96
                  ],
                  [
                    1.14,
                    5.96
                  ],
                  [
                    3.5,
                    5.96
                  ],
                  [
                    3.21,
                    4.94
                  ],
                  [
                    2.41,
                    4.59
                  ],
                  [
                    2.41,
                    4.59
                  ],
                  [
                    1.58,
                    4.95
                  ],
                  [
                    1.14,
                    5.96
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.45
                  ],
                  [
                    -0.19,
                    -0.23
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    0
                  ],
                  [
                    -0.24,
                    0.24
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 865,
        ty: 3,
        parent: 862,
        ks: {
          p: {
            a: 0,
            k: [
              15.846,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 868,
        ty: 4,
        parent: 867,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    8.6
                  ],
                  [
                    1.5,
                    8.6
                  ],
                  [
                    0.9,
                    8.4
                  ],
                  [
                    0.7,
                    7.6
                  ],
                  [
                    0.7,
                    7.6
                  ],
                  [
                    0.7,
                    2.1
                  ],
                  [
                    1.5,
                    2.1
                  ],
                  [
                    1.5,
                    7.7
                  ],
                  [
                    1.6,
                    7.9
                  ],
                  [
                    1.7,
                    8
                  ],
                  [
                    1.7,
                    8
                  ],
                  [
                    1.8,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    2,
                    8.5
                  ],
                  [
                    1.8,
                    8.6
                  ],
                  [
                    1.5,
                    8.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 867,
        ty: 3,
        parent: 862,
        ks: {
          p: {
            a: 0,
            k: [
              13.536,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 870,
        ty: 4,
        parent: 869,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    0.22
                  ],
                  [
                    0,
                    0.39
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.43,
                    0.26
                  ],
                  [
                    -0.94,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.05,
                    0.17
                  ],
                  [
                    0.13,
                    0.11
                  ],
                  [
                    0.24,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.22,
                    -0.1
                  ],
                  [
                    0.18,
                    -0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.12
                  ],
                  [
                    -0.35,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.24,
                    -0.33
                  ],
                  [
                    0,
                    -0.55
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.13
                  ],
                  [
                    0.28,
                    0
                  ]
                ],
                v: [
                  [
                    1.76,
                    8.62
                  ],
                  [
                    1.76,
                    8.62
                  ],
                  [
                    0.84,
                    8.29
                  ],
                  [
                    0.47,
                    7.37
                  ],
                  [
                    0.47,
                    7.37
                  ],
                  [
                    1.12,
                    6.26
                  ],
                  [
                    3.17,
                    5.72
                  ],
                  [
                    3.17,
                    5.72
                  ],
                  [
                    3.1,
                    5.19
                  ],
                  [
                    2.82,
                    4.77
                  ],
                  [
                    2.27,
                    4.61
                  ],
                  [
                    2.27,
                    4.61
                  ],
                  [
                    1.55,
                    4.76
                  ],
                  [
                    0.95,
                    5.09
                  ],
                  [
                    0.95,
                    5.09
                  ],
                  [
                    0.66,
                    4.57
                  ],
                  [
                    1.42,
                    4.18
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    3.56,
                    4.49
                  ],
                  [
                    3.93,
                    5.81
                  ],
                  [
                    3.93,
                    5.81
                  ],
                  [
                    3.93,
                    8.51
                  ],
                  [
                    3.31,
                    8.51
                  ],
                  [
                    3.25,
                    7.99
                  ],
                  [
                    3.22,
                    7.99
                  ],
                  [
                    2.54,
                    8.43
                  ],
                  [
                    1.76,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.37,
                    0
                  ],
                  [
                    -0.24,
                    -0.22
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.48
                  ],
                  [
                    0.43,
                    -0.26
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.19
                  ],
                  [
                    -0.05,
                    -0.17
                  ],
                  [
                    -0.13,
                    -0.11
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.25,
                    0
                  ],
                  [
                    -0.22,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    -0.13
                  ],
                  [
                    0.3,
                    -0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.54,
                    0
                  ],
                  [
                    0.24,
                    0.33
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    0.17
                  ],
                  [
                    -0.24,
                    0.13
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.1
                  ],
                  [
                    -0.21,
                    0.19
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.29,
                    -0.18
                  ],
                  [
                    0,
                    -0.28
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.15,
                    -0.11
                  ],
                  [
                    -0.22,
                    0
                  ]
                ],
                v: [
                  [
                    1.98,
                    8.02
                  ],
                  [
                    1.98,
                    8.02
                  ],
                  [
                    2.58,
                    7.87
                  ],
                  [
                    3.17,
                    7.43
                  ],
                  [
                    3.17,
                    7.43
                  ],
                  [
                    3.17,
                    6.21
                  ],
                  [
                    1.64,
                    6.62
                  ],
                  [
                    1.2,
                    7.32
                  ],
                  [
                    1.2,
                    7.32
                  ],
                  [
                    1.42,
                    7.86
                  ],
                  [
                    1.98,
                    8.02
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0
                  ],
                  [
                    0.19,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.73,
                    0.09
                  ],
                  [
                    -0.29,
                    0.18
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.25
                  ],
                  [
                    0.15,
                    0.11
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 869,
        ty: 3,
        parent: 862,
        ks: {
          p: {
            a: 0,
            k: [
              8.969,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 872,
        ty: 4,
        parent: 871,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.31,
                    0.18
                  ],
                  [
                    0.18,
                    0.34
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.34
                  ],
                  [
                    -0.32,
                    0.18
                  ],
                  [
                    -0.37,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.1
                  ],
                  [
                    -0.15,
                    -0.14
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.14,
                    0.07
                  ],
                  [
                    0.18,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    -0.14
                  ],
                  [
                    0.12,
                    -0.26
                  ],
                  [
                    0,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.25,
                    -0.31
                  ],
                  [
                    -0.41,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.18,
                    0.09
                  ],
                  [
                    -0.13,
                    0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.1
                  ],
                  [
                    0.27,
                    0
                  ]
                ],
                v: [
                  [
                    2.48,
                    8.62
                  ],
                  [
                    2.48,
                    8.62
                  ],
                  [
                    1.43,
                    8.35
                  ],
                  [
                    0.69,
                    7.56
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.71,
                    5.06
                  ],
                  [
                    1.49,
                    4.27
                  ],
                  [
                    2.54,
                    4
                  ],
                  [
                    2.54,
                    4
                  ],
                  [
                    3.29,
                    4.15
                  ],
                  [
                    3.83,
                    4.51
                  ],
                  [
                    3.83,
                    4.51
                  ],
                  [
                    3.45,
                    5
                  ],
                  [
                    3.04,
                    4.72
                  ],
                  [
                    2.57,
                    4.61
                  ],
                  [
                    2.57,
                    4.61
                  ],
                  [
                    1.85,
                    4.83
                  ],
                  [
                    1.36,
                    5.43
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.56,
                    7.54
                  ],
                  [
                    2.55,
                    8.01
                  ],
                  [
                    2.55,
                    8.01
                  ],
                  [
                    3.12,
                    7.87
                  ],
                  [
                    3.58,
                    7.56
                  ],
                  [
                    3.58,
                    7.56
                  ],
                  [
                    3.91,
                    8.06
                  ],
                  [
                    3.25,
                    8.47
                  ],
                  [
                    2.48,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.39,
                    0
                  ],
                  [
                    -0.31,
                    -0.18
                  ],
                  [
                    -0.18,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0.2,
                    -0.34
                  ],
                  [
                    0.32,
                    -0.18
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.29,
                    0
                  ],
                  [
                    0.21,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.13,
                    -0.11
                  ],
                  [
                    -0.14,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.27,
                    0
                  ],
                  [
                    -0.21,
                    0.14
                  ],
                  [
                    -0.12,
                    0.26
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0.25,
                    0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0
                  ],
                  [
                    0.18,
                    -0.09
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.18
                  ],
                  [
                    -0.24,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 871,
        ty: 3,
        parent: 862,
        ks: {
          p: {
            a: 0,
            k: [
              4.838,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 874,
        ty: 4,
        parent: 873,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.5,
                    8.6
                  ],
                  [
                    2.5,
                    8.6
                  ],
                  [
                    1.3,
                    8.4
                  ],
                  [
                    0.4,
                    7.7
                  ],
                  [
                    0.4,
                    7.7
                  ],
                  [
                    0.8,
                    7.2
                  ],
                  [
                    1.6,
                    7.8
                  ],
                  [
                    2.5,
                    8
                  ],
                  [
                    2.5,
                    8
                  ],
                  [
                    3.4,
                    7.7
                  ],
                  [
                    3.7,
                    7
                  ],
                  [
                    3.7,
                    7
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    3.2,
                    6.2
                  ],
                  [
                    2.7,
                    5.9
                  ],
                  [
                    2.7,
                    5.9
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.3,
                    5.3
                  ],
                  [
                    0.9,
                    4.8
                  ],
                  [
                    0.7,
                    4
                  ],
                  [
                    0.7,
                    4
                  ],
                  [
                    0.9,
                    3.2
                  ],
                  [
                    1.6,
                    2.7
                  ],
                  [
                    2.5,
                    2.5
                  ],
                  [
                    2.5,
                    2.5
                  ],
                  [
                    3.5,
                    2.7
                  ],
                  [
                    4.3,
                    3.2
                  ],
                  [
                    4.3,
                    3.2
                  ],
                  [
                    3.9,
                    3.7
                  ],
                  [
                    3.3,
                    3.3
                  ],
                  [
                    2.5,
                    3.1
                  ],
                  [
                    2.5,
                    3.1
                  ],
                  [
                    1.7,
                    3.4
                  ],
                  [
                    1.4,
                    4
                  ],
                  [
                    1.4,
                    4
                  ],
                  [
                    1.6,
                    4.5
                  ],
                  [
                    2,
                    4.8
                  ],
                  [
                    2.4,
                    5
                  ],
                  [
                    2.4,
                    5
                  ],
                  [
                    3.3,
                    5.3
                  ],
                  [
                    3.9,
                    5.7
                  ],
                  [
                    4.3,
                    6.2
                  ],
                  [
                    4.5,
                    6.9
                  ],
                  [
                    4.5,
                    6.9
                  ],
                  [
                    4.2,
                    7.8
                  ],
                  [
                    3.5,
                    8.4
                  ],
                  [
                    2.5,
                    8.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 873,
        ty: 3,
        parent: 862,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 862,
        ty: 3,
        parent: 861,
        ks: {
          p: {
            a: 0,
            k: [
              18.709,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 877,
        ty: 4,
        parent: 876,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    8.6
                  ],
                  [
                    2.1,
                    8.6
                  ],
                  [
                    1.1,
                    8.2
                  ],
                  [
                    0.9,
                    7.2
                  ],
                  [
                    0.9,
                    7.2
                  ],
                  [
                    0.9,
                    4.7
                  ],
                  [
                    0.2,
                    4.7
                  ],
                  [
                    0.2,
                    4.2
                  ],
                  [
                    0.9,
                    4.1
                  ],
                  [
                    1,
                    2.9
                  ],
                  [
                    1.6,
                    2.9
                  ],
                  [
                    1.6,
                    4.1
                  ],
                  [
                    2.8,
                    4.1
                  ],
                  [
                    2.8,
                    4.7
                  ],
                  [
                    1.6,
                    4.7
                  ],
                  [
                    1.6,
                    7.2
                  ],
                  [
                    1.8,
                    7.8
                  ],
                  [
                    2.3,
                    8
                  ],
                  [
                    2.3,
                    8
                  ],
                  [
                    2.6,
                    8
                  ],
                  [
                    2.8,
                    7.9
                  ],
                  [
                    2.8,
                    7.9
                  ],
                  [
                    2.9,
                    8.5
                  ],
                  [
                    2.6,
                    8.6
                  ],
                  [
                    2.1,
                    8.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 876,
        ty: 3,
        parent: 875,
        ks: {
          p: {
            a: 0,
            k: [
              13.835,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 879,
        ty: 4,
        parent: 878,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.28,
                    0.12
                  ],
                  [
                    0.21,
                    0.17
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.1
                  ],
                  [
                    -0.26,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.15,
                    0.14
                  ],
                  [
                    0,
                    0.19
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.15,
                    0.07
                  ],
                  [
                    0.16,
                    0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.13,
                    0.16
                  ],
                  [
                    0,
                    0.25
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.27,
                    0.24
                  ],
                  [
                    -0.48,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.24,
                    -0.1
                  ],
                  [
                    -0.17,
                    -0.14
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.16,
                    0.07
                  ],
                  [
                    0.19,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.13,
                    -0.13
                  ],
                  [
                    0,
                    -0.17
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.09,
                    -0.09
                  ],
                  [
                    -0.15,
                    -0.06
                  ],
                  [
                    -0.16,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.1
                  ],
                  [
                    -0.14,
                    -0.17
                  ],
                  [
                    0,
                    -0.28
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.12,
                    -0.2
                  ],
                  [
                    0.24,
                    -0.12
                  ],
                  [
                    0.35,
                    0
                  ]
                ],
                v: [
                  [
                    1.9,
                    8.62
                  ],
                  [
                    1.9,
                    8.62
                  ],
                  [
                    1,
                    8.45
                  ],
                  [
                    0.25,
                    8.01
                  ],
                  [
                    0.25,
                    8.01
                  ],
                  [
                    0.63,
                    7.52
                  ],
                  [
                    1.22,
                    7.89
                  ],
                  [
                    1.92,
                    8.04
                  ],
                  [
                    1.92,
                    8.04
                  ],
                  [
                    2.58,
                    7.84
                  ],
                  [
                    2.79,
                    7.35
                  ],
                  [
                    2.79,
                    7.35
                  ],
                  [
                    2.64,
                    6.97
                  ],
                  [
                    2.26,
                    6.71
                  ],
                  [
                    1.79,
                    6.52
                  ],
                  [
                    1.79,
                    6.52
                  ],
                  [
                    1.18,
                    6.25
                  ],
                  [
                    0.69,
                    5.86
                  ],
                  [
                    0.5,
                    5.25
                  ],
                  [
                    0.5,
                    5.25
                  ],
                  [
                    0.9,
                    4.36
                  ],
                  [
                    2.02,
                    4
                  ],
                  [
                    2.02,
                    4
                  ],
                  [
                    2.78,
                    4.14
                  ],
                  [
                    3.39,
                    4.5
                  ],
                  [
                    3.39,
                    4.5
                  ],
                  [
                    3.03,
                    4.97
                  ],
                  [
                    2.56,
                    4.69
                  ],
                  [
                    2.02,
                    4.58
                  ],
                  [
                    2.02,
                    4.58
                  ],
                  [
                    1.41,
                    4.77
                  ],
                  [
                    1.22,
                    5.21
                  ],
                  [
                    1.22,
                    5.21
                  ],
                  [
                    1.35,
                    5.55
                  ],
                  [
                    1.7,
                    5.78
                  ],
                  [
                    2.17,
                    5.97
                  ],
                  [
                    2.17,
                    5.97
                  ],
                  [
                    2.79,
                    6.24
                  ],
                  [
                    3.31,
                    6.64
                  ],
                  [
                    3.51,
                    7.31
                  ],
                  [
                    3.51,
                    7.31
                  ],
                  [
                    3.32,
                    7.96
                  ],
                  [
                    2.78,
                    8.44
                  ],
                  [
                    1.9,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    0
                  ],
                  [
                    -0.28,
                    -0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.19,
                    0.15
                  ],
                  [
                    0.21,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.29,
                    0
                  ],
                  [
                    0.15,
                    -0.14
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.15
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.15,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.08
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.13,
                    -0.16
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.36
                  ],
                  [
                    0.27,
                    -0.24
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.27,
                    0
                  ],
                  [
                    0.24,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.15,
                    -0.11
                  ],
                  [
                    -0.16,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.28,
                    0
                  ],
                  [
                    -0.13,
                    0.13
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.14
                  ],
                  [
                    0.09,
                    0.09
                  ],
                  [
                    0.15,
                    0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0.08
                  ],
                  [
                    0.21,
                    0.1
                  ],
                  [
                    0.14,
                    0.17
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.24
                  ],
                  [
                    -0.12,
                    0.2
                  ],
                  [
                    -0.24,
                    0.12
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 878,
        ty: 3,
        parent: 875,
        ks: {
          p: {
            a: 0,
            k: [
              10.038,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 881,
        ty: 4,
        parent: 880,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.31,
                    0.18
                  ],
                  [
                    0.19,
                    0.34
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.34
                  ],
                  [
                    -0.31,
                    0.18
                  ],
                  [
                    -0.36,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    -0.18
                  ],
                  [
                    -0.19,
                    -0.34
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.19,
                    -0.34
                  ],
                  [
                    0.31,
                    -0.18
                  ],
                  [
                    0.36,
                    0
                  ]
                ],
                v: [
                  [
                    2.46,
                    8.62
                  ],
                  [
                    2.46,
                    8.62
                  ],
                  [
                    1.46,
                    8.35
                  ],
                  [
                    0.7,
                    7.56
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.7,
                    5.06
                  ],
                  [
                    1.46,
                    4.27
                  ],
                  [
                    2.46,
                    4
                  ],
                  [
                    2.46,
                    4
                  ],
                  [
                    3.46,
                    4.27
                  ],
                  [
                    4.21,
                    5.06
                  ],
                  [
                    4.5,
                    6.32
                  ],
                  [
                    4.5,
                    6.32
                  ],
                  [
                    4.21,
                    7.56
                  ],
                  [
                    3.46,
                    8.35
                  ],
                  [
                    2.46,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.36,
                    0
                  ],
                  [
                    -0.31,
                    -0.18
                  ],
                  [
                    -0.19,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0.19,
                    -0.34
                  ],
                  [
                    0.31,
                    -0.18
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.36,
                    0
                  ],
                  [
                    0.31,
                    0.18
                  ],
                  [
                    0.19,
                    0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    -0.19,
                    0.34
                  ],
                  [
                    -0.31,
                    0.18
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.23,
                    0.31
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.23,
                    0.31
                  ],
                  [
                    0.38,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.31
                  ],
                  [
                    0,
                    -0.51
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.24,
                    -0.31
                  ],
                  [
                    -0.37,
                    0
                  ]
                ],
                v: [
                  [
                    2.46,
                    8.01
                  ],
                  [
                    2.46,
                    8.01
                  ],
                  [
                    3.38,
                    7.54
                  ],
                  [
                    3.73,
                    6.32
                  ],
                  [
                    3.73,
                    6.32
                  ],
                  [
                    3.38,
                    5.09
                  ],
                  [
                    2.46,
                    4.61
                  ],
                  [
                    2.46,
                    4.61
                  ],
                  [
                    1.54,
                    5.09
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.54,
                    7.54
                  ],
                  [
                    2.46,
                    8.01
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.38,
                    0
                  ],
                  [
                    0.23,
                    -0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.51
                  ],
                  [
                    -0.23,
                    -0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.37,
                    0
                  ],
                  [
                    -0.24,
                    0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0.24,
                    0.31
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 880,
        ty: 3,
        parent: 875,
        ks: {
          p: {
            a: 0,
            k: [
              5.128,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 883,
        ty: 4,
        parent: 882,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.5
                  ],
                  [
                    0.8,
                    8.5
                  ],
                  [
                    0.8,
                    2.6
                  ],
                  [
                    2.5,
                    2.6
                  ],
                  [
                    3.7,
                    2.7
                  ],
                  [
                    4.5,
                    3.3
                  ],
                  [
                    4.7,
                    4.3
                  ],
                  [
                    4.7,
                    4.3
                  ],
                  [
                    4.1,
                    5.7
                  ],
                  [
                    2.5,
                    6.2
                  ],
                  [
                    2.5,
                    6.2
                  ],
                  [
                    1.6,
                    6.2
                  ],
                  [
                    1.6,
                    8.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.6,
                    3.2
                  ],
                  [
                    1.6,
                    5.5
                  ],
                  [
                    2.5,
                    5.5
                  ],
                  [
                    3.6,
                    5.2
                  ],
                  [
                    4,
                    4.3
                  ],
                  [
                    4,
                    4.3
                  ],
                  [
                    3.6,
                    3.4
                  ],
                  [
                    2.4,
                    3.2
                  ],
                  [
                    2.4,
                    3.2
                  ],
                  [
                    1.6,
                    3.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 882,
        ty: 3,
        parent: 875,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 875,
        ty: 3,
        parent: 861,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 861,
        ty: 3,
        parent: 860,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 860,
        ty: 3,
        parent: 825,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 825,
        ty: 3,
        parent: 824,
        ks: {
          p: {
            a: 0,
            k: [
              186.97,
              1.762
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 889,
        ty: 0,
        parent: 885,
        ks: {},
        w: 27,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "887"
      },
      {
        ind: 885,
        ty: 3,
        parent: 884,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 884,
        ty: 3,
        parent: 824,
        ks: {
          p: {
            a: 0,
            k: [
              150.193,
              10.204
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 895,
        ty: 4,
        parent: 894,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    13.2
                  ],
                  [
                    1.2,
                    13.2
                  ],
                  [
                    1.2,
                    6.4
                  ],
                  [
                    2.1,
                    6.4
                  ],
                  [
                    2.2,
                    7.4
                  ],
                  [
                    2.3,
                    7.4
                  ],
                  [
                    3.2,
                    6.5
                  ],
                  [
                    4.4,
                    6.2
                  ],
                  [
                    4.4,
                    6.2
                  ],
                  [
                    5.6,
                    6.6
                  ],
                  [
                    6.3,
                    7.5
                  ],
                  [
                    6.3,
                    7.5
                  ],
                  [
                    7.4,
                    6.6
                  ],
                  [
                    8.5,
                    6.2
                  ],
                  [
                    8.5,
                    6.2
                  ],
                  [
                    10.1,
                    6.9
                  ],
                  [
                    10.6,
                    8.9
                  ],
                  [
                    10.6,
                    8.9
                  ],
                  [
                    10.6,
                    13.2
                  ],
                  [
                    9.5,
                    13.2
                  ],
                  [
                    9.5,
                    9.1
                  ],
                  [
                    9.2,
                    7.7
                  ],
                  [
                    8.2,
                    7.2
                  ],
                  [
                    8.2,
                    7.2
                  ],
                  [
                    6.5,
                    8.3
                  ],
                  [
                    6.5,
                    8.3
                  ],
                  [
                    6.5,
                    13.2
                  ],
                  [
                    5.3,
                    13.2
                  ],
                  [
                    5.3,
                    9.1
                  ],
                  [
                    5,
                    7.7
                  ],
                  [
                    4,
                    7.2
                  ],
                  [
                    4,
                    7.2
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    2.3,
                    13.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 894,
        ty: 3,
        parent: 893,
        ks: {
          p: {
            a: 0,
            k: [
              31.781,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 897,
        ty: 4,
        parent: 896,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.9,
                    13.4
                  ],
                  [
                    3.9,
                    13.4
                  ],
                  [
                    2.3,
                    13
                  ],
                  [
                    1.1,
                    11.7
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    1.1,
                    7.9
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    3.7,
                    6.2
                  ],
                  [
                    3.7,
                    6.2
                  ],
                  [
                    5.7,
                    7.1
                  ],
                  [
                    6.5,
                    9.4
                  ],
                  [
                    6.5,
                    9.4
                  ],
                  [
                    6.5,
                    9.8
                  ],
                  [
                    6.4,
                    10.1
                  ],
                  [
                    6.4,
                    10.1
                  ],
                  [
                    1.8,
                    10.1
                  ],
                  [
                    2.5,
                    11.8
                  ],
                  [
                    4.1,
                    12.5
                  ],
                  [
                    4.1,
                    12.5
                  ],
                  [
                    5,
                    12.3
                  ],
                  [
                    5.8,
                    11.9
                  ],
                  [
                    5.8,
                    11.9
                  ],
                  [
                    6.2,
                    12.7
                  ],
                  [
                    5.2,
                    13.2
                  ],
                  [
                    3.9,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.1,
                    -0.7
                  ]
                ],
                v: [
                  [
                    1.8,
                    9.3
                  ],
                  [
                    1.8,
                    9.3
                  ],
                  [
                    5.4,
                    9.3
                  ],
                  [
                    5,
                    7.7
                  ],
                  [
                    3.8,
                    7.1
                  ],
                  [
                    3.8,
                    7.1
                  ],
                  [
                    2.5,
                    7.7
                  ],
                  [
                    1.8,
                    9.3
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 896,
        ty: 3,
        parent: 893,
        ks: {
          p: {
            a: 0,
            k: [
              24.788,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 899,
        ty: 4,
        parent: 898,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    13.4
                  ],
                  [
                    3.3,
                    13.4
                  ],
                  [
                    1.8,
                    12.8
                  ],
                  [
                    1.4,
                    11.1
                  ],
                  [
                    1.4,
                    11.1
                  ],
                  [
                    1.4,
                    7.3
                  ],
                  [
                    0.3,
                    7.3
                  ],
                  [
                    0.3,
                    6.5
                  ],
                  [
                    1.4,
                    6.4
                  ],
                  [
                    1.6,
                    4.5
                  ],
                  [
                    2.5,
                    4.5
                  ],
                  [
                    2.5,
                    6.4
                  ],
                  [
                    4.4,
                    6.4
                  ],
                  [
                    4.4,
                    7.3
                  ],
                  [
                    2.5,
                    7.3
                  ],
                  [
                    2.5,
                    11.1
                  ],
                  [
                    2.8,
                    12.1
                  ],
                  [
                    3.6,
                    12.5
                  ],
                  [
                    3.6,
                    12.5
                  ],
                  [
                    4,
                    12.4
                  ],
                  [
                    4.4,
                    12.3
                  ],
                  [
                    4.4,
                    12.3
                  ],
                  [
                    4.6,
                    13.2
                  ],
                  [
                    4,
                    13.3
                  ],
                  [
                    3.3,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 898,
        ty: 3,
        parent: 893,
        ks: {
          p: {
            a: 0,
            k: [
              20.022,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 901,
        ty: 4,
        parent: 900,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    2.9,
                    13.4
                  ],
                  [
                    2.9,
                    13.4
                  ],
                  [
                    1.6,
                    13.1
                  ],
                  [
                    0.4,
                    12.5
                  ],
                  [
                    0.4,
                    12.5
                  ],
                  [
                    1,
                    11.7
                  ],
                  [
                    1.9,
                    12.3
                  ],
                  [
                    3,
                    12.5
                  ],
                  [
                    3,
                    12.5
                  ],
                  [
                    4,
                    12.2
                  ],
                  [
                    4.3,
                    11.4
                  ],
                  [
                    4.3,
                    11.4
                  ],
                  [
                    4.1,
                    10.8
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    2.8,
                    10.1
                  ],
                  [
                    2.8,
                    10.1
                  ],
                  [
                    1.8,
                    9.7
                  ],
                  [
                    1.1,
                    9.1
                  ],
                  [
                    0.8,
                    8.2
                  ],
                  [
                    0.8,
                    8.2
                  ],
                  [
                    1.4,
                    6.8
                  ],
                  [
                    3.1,
                    6.2
                  ],
                  [
                    3.1,
                    6.2
                  ],
                  [
                    4.3,
                    6.4
                  ],
                  [
                    5.3,
                    7
                  ],
                  [
                    5.3,
                    7
                  ],
                  [
                    4.7,
                    7.7
                  ],
                  [
                    4,
                    7.3
                  ],
                  [
                    3.1,
                    7.1
                  ],
                  [
                    3.1,
                    7.1
                  ],
                  [
                    2.2,
                    7.4
                  ],
                  [
                    1.9,
                    8.1
                  ],
                  [
                    1.9,
                    8.1
                  ],
                  [
                    2.1,
                    8.6
                  ],
                  [
                    2.7,
                    9
                  ],
                  [
                    3.4,
                    9.3
                  ],
                  [
                    3.4,
                    9.3
                  ],
                  [
                    4.3,
                    9.7
                  ],
                  [
                    5.1,
                    10.3
                  ],
                  [
                    5.5,
                    11.4
                  ],
                  [
                    5.5,
                    11.4
                  ],
                  [
                    5.2,
                    12.4
                  ],
                  [
                    4.3,
                    13.1
                  ],
                  [
                    2.9,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 900,
        ty: 3,
        parent: 893,
        ks: {
          p: {
            a: 0,
            k: [
              14.114,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 903,
        ty: 4,
        parent: 902,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    1.3,
                    16.2
                  ],
                  [
                    1.3,
                    16.2
                  ],
                  [
                    0.8,
                    16.1
                  ],
                  [
                    0.5,
                    16.1
                  ],
                  [
                    0.5,
                    16.1
                  ],
                  [
                    0.7,
                    15.1
                  ],
                  [
                    0.9,
                    15.2
                  ],
                  [
                    1.2,
                    15.2
                  ],
                  [
                    1.2,
                    15.2
                  ],
                  [
                    2.2,
                    14.8
                  ],
                  [
                    2.8,
                    13.8
                  ],
                  [
                    2.8,
                    13.8
                  ],
                  [
                    2.9,
                    13.3
                  ],
                  [
                    0.2,
                    6.4
                  ],
                  [
                    1.4,
                    6.4
                  ],
                  [
                    2.8,
                    10.2
                  ],
                  [
                    3.1,
                    11.1
                  ],
                  [
                    3.4,
                    12.1
                  ],
                  [
                    3.4,
                    12.1
                  ],
                  [
                    3.5,
                    12.1
                  ],
                  [
                    3.8,
                    11.1
                  ],
                  [
                    4.1,
                    10.2
                  ],
                  [
                    4.1,
                    10.2
                  ],
                  [
                    5.3,
                    6.4
                  ],
                  [
                    6.4,
                    6.4
                  ],
                  [
                    3.8,
                    13.8
                  ],
                  [
                    3.3,
                    15
                  ],
                  [
                    2.4,
                    15.9
                  ],
                  [
                    1.3,
                    16.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.5
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 902,
        ty: 3,
        parent: 893,
        ks: {
          p: {
            a: 0,
            k: [
              7.529,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 905,
        ty: 4,
        parent: 904,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.8,
                    13.4
                  ],
                  [
                    3.8,
                    13.4
                  ],
                  [
                    2,
                    13
                  ],
                  [
                    0.6,
                    12
                  ],
                  [
                    0.6,
                    12
                  ],
                  [
                    1.3,
                    11.2
                  ],
                  [
                    2.5,
                    12.1
                  ],
                  [
                    3.9,
                    12.4
                  ],
                  [
                    3.9,
                    12.4
                  ],
                  [
                    5.3,
                    12
                  ],
                  [
                    5.8,
                    10.9
                  ],
                  [
                    5.8,
                    10.9
                  ],
                  [
                    5.6,
                    10.1
                  ],
                  [
                    5,
                    9.6
                  ],
                  [
                    4.2,
                    9.2
                  ],
                  [
                    4.2,
                    9.2
                  ],
                  [
                    2.9,
                    8.7
                  ],
                  [
                    2.1,
                    8.2
                  ],
                  [
                    1.3,
                    7.4
                  ],
                  [
                    1,
                    6.3
                  ],
                  [
                    1,
                    6.3
                  ],
                  [
                    1.4,
                    5
                  ],
                  [
                    2.5,
                    4.1
                  ],
                  [
                    3.9,
                    3.8
                  ],
                  [
                    3.9,
                    3.8
                  ],
                  [
                    5.5,
                    4.1
                  ],
                  [
                    6.7,
                    5
                  ],
                  [
                    6.7,
                    5
                  ],
                  [
                    6.1,
                    5.7
                  ],
                  [
                    5.1,
                    5.1
                  ],
                  [
                    3.9,
                    4.9
                  ],
                  [
                    3.9,
                    4.9
                  ],
                  [
                    2.7,
                    5.2
                  ],
                  [
                    2.2,
                    6.2
                  ],
                  [
                    2.2,
                    6.2
                  ],
                  [
                    2.5,
                    6.9
                  ],
                  [
                    3,
                    7.4
                  ],
                  [
                    3.8,
                    7.7
                  ],
                  [
                    3.8,
                    7.7
                  ],
                  [
                    5.1,
                    8.3
                  ],
                  [
                    6,
                    8.8
                  ],
                  [
                    6.7,
                    9.6
                  ],
                  [
                    7,
                    10.8
                  ],
                  [
                    7,
                    10.8
                  ],
                  [
                    6.6,
                    12.1
                  ],
                  [
                    5.5,
                    13.1
                  ],
                  [
                    3.8,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.6,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 904,
        ty: 3,
        parent: 893,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 893,
        ty: 3,
        parent: 892,
        ks: {
          p: {
            a: 0,
            k: [
              62.322,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 908,
        ty: 4,
        parent: 907,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0.4
                  ],
                  [
                    -1.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    13.4
                  ],
                  [
                    2.7,
                    13.4
                  ],
                  [
                    1.3,
                    12.9
                  ],
                  [
                    0.7,
                    11.5
                  ],
                  [
                    0.7,
                    11.5
                  ],
                  [
                    1.7,
                    9.7
                  ],
                  [
                    4.9,
                    8.9
                  ],
                  [
                    4.9,
                    8.9
                  ],
                  [
                    4.8,
                    8.1
                  ],
                  [
                    4.4,
                    7.4
                  ],
                  [
                    3.5,
                    7.2
                  ],
                  [
                    3.5,
                    7.2
                  ],
                  [
                    2.4,
                    7.4
                  ],
                  [
                    1.5,
                    7.9
                  ],
                  [
                    1.5,
                    7.9
                  ],
                  [
                    1,
                    7.1
                  ],
                  [
                    2.2,
                    6.5
                  ],
                  [
                    3.7,
                    6.2
                  ],
                  [
                    3.7,
                    6.2
                  ],
                  [
                    5.5,
                    7
                  ],
                  [
                    6.1,
                    9
                  ],
                  [
                    6.1,
                    9
                  ],
                  [
                    6.1,
                    13.2
                  ],
                  [
                    5.1,
                    13.2
                  ],
                  [
                    5.1,
                    12.4
                  ],
                  [
                    5,
                    12.4
                  ],
                  [
                    4,
                    13.1
                  ],
                  [
                    2.7,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.7,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.1,
                    12.5
                  ],
                  [
                    3.1,
                    12.5
                  ],
                  [
                    4,
                    12.2
                  ],
                  [
                    4.9,
                    11.6
                  ],
                  [
                    4.9,
                    11.6
                  ],
                  [
                    4.9,
                    9.7
                  ],
                  [
                    2.5,
                    10.3
                  ],
                  [
                    1.9,
                    11.4
                  ],
                  [
                    1.9,
                    11.4
                  ],
                  [
                    2.2,
                    12.2
                  ],
                  [
                    3.1,
                    12.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.1,
                    0.1
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 907,
        ty: 3,
        parent: 906,
        ks: {
          p: {
            a: 0,
            k: [
              28.538,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 910,
        ty: 4,
        parent: 909,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    13.2
                  ],
                  [
                    1.2,
                    13.2
                  ],
                  [
                    1.2,
                    6.4
                  ],
                  [
                    2.3,
                    6.4
                  ],
                  [
                    2.3,
                    13.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    1.7,
                    5
                  ],
                  [
                    1.7,
                    5
                  ],
                  [
                    1.2,
                    4.8
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    1.2,
                    3.7
                  ],
                  [
                    1.7,
                    3.5
                  ],
                  [
                    1.7,
                    3.5
                  ],
                  [
                    2.3,
                    3.7
                  ],
                  [
                    2.5,
                    4.2
                  ],
                  [
                    2.5,
                    4.2
                  ],
                  [
                    2.3,
                    4.8
                  ],
                  [
                    1.7,
                    5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 909,
        ty: 3,
        parent: 906,
        ks: {
          p: {
            a: 0,
            k: [
              25.07,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 912,
        ty: 4,
        parent: 911,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    1.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    13.4
                  ],
                  [
                    3.5,
                    13.4
                  ],
                  [
                    1.4,
                    12.5
                  ],
                  [
                    0.7,
                    9.8
                  ],
                  [
                    0.7,
                    9.8
                  ],
                  [
                    1.1,
                    7.9
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    3.6,
                    6.2
                  ],
                  [
                    3.6,
                    6.2
                  ],
                  [
                    4.7,
                    6.4
                  ],
                  [
                    5.6,
                    7
                  ],
                  [
                    5.6,
                    7
                  ],
                  [
                    5.5,
                    5.8
                  ],
                  [
                    5.5,
                    3.2
                  ],
                  [
                    6.7,
                    3.2
                  ],
                  [
                    6.7,
                    13.2
                  ],
                  [
                    5.7,
                    13.2
                  ],
                  [
                    5.6,
                    12.4
                  ],
                  [
                    5.6,
                    12.4
                  ],
                  [
                    4.6,
                    13.1
                  ],
                  [
                    3.5,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.9,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    -0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.8,
                    12.4
                  ],
                  [
                    3.8,
                    12.4
                  ],
                  [
                    5.5,
                    11.5
                  ],
                  [
                    5.5,
                    11.5
                  ],
                  [
                    5.5,
                    7.9
                  ],
                  [
                    4.7,
                    7.4
                  ],
                  [
                    3.8,
                    7.2
                  ],
                  [
                    3.8,
                    7.2
                  ],
                  [
                    2.8,
                    7.5
                  ],
                  [
                    2.1,
                    8.4
                  ],
                  [
                    1.9,
                    9.8
                  ],
                  [
                    1.9,
                    9.8
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    3.8,
                    12.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 911,
        ty: 3,
        parent: 906,
        ks: {
          p: {
            a: 0,
            k: [
              17.244,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 914,
        ty: 4,
        parent: 913,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.9,
                    13.4
                  ],
                  [
                    3.9,
                    13.4
                  ],
                  [
                    2.3,
                    13
                  ],
                  [
                    1.1,
                    11.7
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    1.1,
                    7.9
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    3.7,
                    6.2
                  ],
                  [
                    3.7,
                    6.2
                  ],
                  [
                    5.7,
                    7.1
                  ],
                  [
                    6.5,
                    9.4
                  ],
                  [
                    6.5,
                    9.4
                  ],
                  [
                    6.5,
                    9.8
                  ],
                  [
                    6.4,
                    10.1
                  ],
                  [
                    6.4,
                    10.1
                  ],
                  [
                    1.8,
                    10.1
                  ],
                  [
                    2.5,
                    11.8
                  ],
                  [
                    4.1,
                    12.5
                  ],
                  [
                    4.1,
                    12.5
                  ],
                  [
                    5,
                    12.3
                  ],
                  [
                    5.8,
                    11.9
                  ],
                  [
                    5.8,
                    11.9
                  ],
                  [
                    6.2,
                    12.7
                  ],
                  [
                    5.2,
                    13.2
                  ],
                  [
                    3.9,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.1,
                    -0.7
                  ]
                ],
                v: [
                  [
                    1.8,
                    9.3
                  ],
                  [
                    1.8,
                    9.3
                  ],
                  [
                    5.4,
                    9.3
                  ],
                  [
                    5,
                    7.7
                  ],
                  [
                    3.8,
                    7.1
                  ],
                  [
                    3.8,
                    7.1
                  ],
                  [
                    2.5,
                    7.7
                  ],
                  [
                    1.8,
                    9.3
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 913,
        ty: 3,
        parent: 906,
        ks: {
          p: {
            a: 0,
            k: [
              10.251,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 916,
        ty: 4,
        parent: 915,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    13.2
                  ],
                  [
                    1.3,
                    13.2
                  ],
                  [
                    1.3,
                    4
                  ],
                  [
                    2.7,
                    4
                  ],
                  [
                    4.5,
                    8.9
                  ],
                  [
                    4.8,
                    9.9
                  ],
                  [
                    5.1,
                    10.9
                  ],
                  [
                    5.1,
                    10.9
                  ],
                  [
                    5.2,
                    10.9
                  ],
                  [
                    5.5,
                    9.9
                  ],
                  [
                    5.8,
                    8.9
                  ],
                  [
                    5.8,
                    8.9
                  ],
                  [
                    7.6,
                    4
                  ],
                  [
                    9,
                    4
                  ],
                  [
                    9,
                    13.2
                  ],
                  [
                    7.9,
                    13.2
                  ],
                  [
                    7.9,
                    8.2
                  ],
                  [
                    7.9,
                    6.8
                  ],
                  [
                    8,
                    5.4
                  ],
                  [
                    8,
                    5.4
                  ],
                  [
                    8,
                    5.4
                  ],
                  [
                    7.3,
                    7.5
                  ],
                  [
                    5.5,
                    12.3
                  ],
                  [
                    4.7,
                    12.3
                  ],
                  [
                    3,
                    7.5
                  ],
                  [
                    2.2,
                    5.4
                  ],
                  [
                    2.2,
                    5.4
                  ],
                  [
                    2.3,
                    6.8
                  ],
                  [
                    2.3,
                    8.2
                  ],
                  [
                    2.3,
                    8.2
                  ],
                  [
                    2.3,
                    13.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 915,
        ty: 3,
        parent: 906,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 906,
        ty: 3,
        parent: 892,
        ks: {
          p: {
            a: 0,
            k: [
              23.857,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 919,
        ty: 4,
        parent: 918,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0.7,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    16.4
                  ],
                  [
                    3.5,
                    16.4
                  ],
                  [
                    1.4,
                    15.9
                  ],
                  [
                    0.6,
                    14.6
                  ],
                  [
                    0.6,
                    14.6
                  ],
                  [
                    0.9,
                    13.7
                  ],
                  [
                    1.6,
                    13
                  ],
                  [
                    1.6,
                    13
                  ],
                  [
                    1.6,
                    12.9
                  ],
                  [
                    1.2,
                    12.5
                  ],
                  [
                    1,
                    11.8
                  ],
                  [
                    1,
                    11.8
                  ],
                  [
                    1.3,
                    11.1
                  ],
                  [
                    1.8,
                    10.6
                  ],
                  [
                    1.8,
                    10.6
                  ],
                  [
                    1.8,
                    10.5
                  ],
                  [
                    1.2,
                    9.7
                  ],
                  [
                    0.9,
                    8.7
                  ],
                  [
                    0.9,
                    8.7
                  ],
                  [
                    1.2,
                    7.4
                  ],
                  [
                    2.2,
                    6.5
                  ],
                  [
                    3.5,
                    6.2
                  ],
                  [
                    3.5,
                    6.2
                  ],
                  [
                    4,
                    6.3
                  ],
                  [
                    4.4,
                    6.4
                  ],
                  [
                    4.4,
                    6.4
                  ],
                  [
                    6.8,
                    6.4
                  ],
                  [
                    6.8,
                    7.3
                  ],
                  [
                    5.4,
                    7.3
                  ],
                  [
                    5.8,
                    7.9
                  ],
                  [
                    6,
                    8.7
                  ],
                  [
                    6,
                    8.7
                  ],
                  [
                    5.6,
                    10
                  ],
                  [
                    4.7,
                    10.8
                  ],
                  [
                    3.5,
                    11.1
                  ],
                  [
                    3.5,
                    11.1
                  ],
                  [
                    2.4,
                    10.8
                  ],
                  [
                    2.4,
                    10.8
                  ],
                  [
                    2.1,
                    11.2
                  ],
                  [
                    2,
                    11.6
                  ],
                  [
                    2,
                    11.6
                  ],
                  [
                    2.3,
                    12.2
                  ],
                  [
                    3.2,
                    12.4
                  ],
                  [
                    3.2,
                    12.4
                  ],
                  [
                    4.5,
                    12.4
                  ],
                  [
                    6.3,
                    12.8
                  ],
                  [
                    6.9,
                    14
                  ],
                  [
                    6.9,
                    14
                  ],
                  [
                    6.5,
                    15.2
                  ],
                  [
                    5.3,
                    16.1
                  ],
                  [
                    3.5,
                    16.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    10.3
                  ],
                  [
                    3.5,
                    10.3
                  ],
                  [
                    4.5,
                    9.9
                  ],
                  [
                    4.9,
                    8.7
                  ],
                  [
                    4.9,
                    8.7
                  ],
                  [
                    4.5,
                    7.5
                  ],
                  [
                    3.5,
                    7.1
                  ],
                  [
                    3.5,
                    7.1
                  ],
                  [
                    2.4,
                    7.5
                  ],
                  [
                    2,
                    8.7
                  ],
                  [
                    2,
                    8.7
                  ],
                  [
                    2.4,
                    9.9
                  ],
                  [
                    3.5,
                    10.3
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.6,
                    15.6
                  ],
                  [
                    3.6,
                    15.6
                  ],
                  [
                    5.2,
                    15.2
                  ],
                  [
                    5.8,
                    14.2
                  ],
                  [
                    5.8,
                    14.2
                  ],
                  [
                    5.5,
                    13.5
                  ],
                  [
                    4.4,
                    13.4
                  ],
                  [
                    4.4,
                    13.4
                  ],
                  [
                    3.2,
                    13.4
                  ],
                  [
                    2.8,
                    13.3
                  ],
                  [
                    2.4,
                    13.2
                  ],
                  [
                    2.4,
                    13.2
                  ],
                  [
                    1.8,
                    13.8
                  ],
                  [
                    1.7,
                    14.4
                  ],
                  [
                    1.7,
                    14.4
                  ],
                  [
                    2.2,
                    15.3
                  ],
                  [
                    3.6,
                    15.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 918,
        ty: 3,
        parent: 917,
        ks: {
          p: {
            a: 0,
            k: [
              13.931,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 921,
        ty: 4,
        parent: 920,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    2.9,
                    13.4
                  ],
                  [
                    2.9,
                    13.4
                  ],
                  [
                    1.6,
                    13.1
                  ],
                  [
                    0.4,
                    12.5
                  ],
                  [
                    0.4,
                    12.5
                  ],
                  [
                    1,
                    11.7
                  ],
                  [
                    1.9,
                    12.3
                  ],
                  [
                    3,
                    12.5
                  ],
                  [
                    3,
                    12.5
                  ],
                  [
                    4,
                    12.2
                  ],
                  [
                    4.3,
                    11.4
                  ],
                  [
                    4.3,
                    11.4
                  ],
                  [
                    4.1,
                    10.8
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    2.8,
                    10.1
                  ],
                  [
                    2.8,
                    10.1
                  ],
                  [
                    1.8,
                    9.7
                  ],
                  [
                    1.1,
                    9.1
                  ],
                  [
                    0.8,
                    8.2
                  ],
                  [
                    0.8,
                    8.2
                  ],
                  [
                    1.4,
                    6.8
                  ],
                  [
                    3.1,
                    6.2
                  ],
                  [
                    3.1,
                    6.2
                  ],
                  [
                    4.3,
                    6.4
                  ],
                  [
                    5.3,
                    7
                  ],
                  [
                    5.3,
                    7
                  ],
                  [
                    4.7,
                    7.7
                  ],
                  [
                    4,
                    7.3
                  ],
                  [
                    3.1,
                    7.1
                  ],
                  [
                    3.1,
                    7.1
                  ],
                  [
                    2.2,
                    7.4
                  ],
                  [
                    1.9,
                    8.1
                  ],
                  [
                    1.9,
                    8.1
                  ],
                  [
                    2.1,
                    8.6
                  ],
                  [
                    2.7,
                    9
                  ],
                  [
                    3.4,
                    9.3
                  ],
                  [
                    3.4,
                    9.3
                  ],
                  [
                    4.3,
                    9.7
                  ],
                  [
                    5.1,
                    10.3
                  ],
                  [
                    5.5,
                    11.4
                  ],
                  [
                    5.5,
                    11.4
                  ],
                  [
                    5.2,
                    12.4
                  ],
                  [
                    4.3,
                    13.1
                  ],
                  [
                    2.9,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 920,
        ty: 3,
        parent: 917,
        ks: {
          p: {
            a: 0,
            k: [
              8.023,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 923,
        ty: 4,
        parent: 922,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.6,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    13.2
                  ],
                  [
                    1.3,
                    13.2
                  ],
                  [
                    1.3,
                    4
                  ],
                  [
                    4.2,
                    4
                  ],
                  [
                    5.8,
                    4.2
                  ],
                  [
                    7,
                    5.1
                  ],
                  [
                    7.4,
                    6.6
                  ],
                  [
                    7.4,
                    6.6
                  ],
                  [
                    6.8,
                    8.3
                  ],
                  [
                    5.3,
                    9.2
                  ],
                  [
                    5.3,
                    9.2
                  ],
                  [
                    7.7,
                    13.2
                  ],
                  [
                    6.3,
                    13.2
                  ],
                  [
                    4.1,
                    9.3
                  ],
                  [
                    2.4,
                    9.3
                  ],
                  [
                    2.4,
                    13.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    4.9
                  ],
                  [
                    2.4,
                    8.4
                  ],
                  [
                    4,
                    8.4
                  ],
                  [
                    5.7,
                    7.9
                  ],
                  [
                    6.2,
                    6.6
                  ],
                  [
                    6.2,
                    6.6
                  ],
                  [
                    5.7,
                    5.3
                  ],
                  [
                    4,
                    4.9
                  ],
                  [
                    4,
                    4.9
                  ],
                  [
                    2.4,
                    4.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 922,
        ty: 3,
        parent: 917,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 917,
        ty: 3,
        parent: 892,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 892,
        ty: 3,
        parent: 891,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 891,
        ty: 3,
        parent: 890,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              14.988
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 928,
        ty: 0,
        parent: 924,
        ks: {},
        w: 81,
        h: 15,
        ip: 0,
        op: 565,
        st: 0,
        refId: "926"
      },
      {
        ind: 924,
        ty: 3,
        parent: 890,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 890,
        ty: 3,
        parent: 824,
        ks: {
          p: {
            a: 0,
            k: [
              27.646,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 824,
        ty: 3,
        parent: 756,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 756,
        ty: 3,
        parent: 755,
        ks: {
          p: {
            a: 0,
            k: [
              10.58,
              102.27
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 937,
        ty: 4,
        parent: 936,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.5
                  ],
                  [
                    0,
                    1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.1,
                    11.7
                  ],
                  [
                    3.1,
                    11.7
                  ],
                  [
                    1.3,
                    10.9
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    1.9,
                    5.8
                  ],
                  [
                    3.2,
                    5.4
                  ],
                  [
                    3.2,
                    5.4
                  ],
                  [
                    4.1,
                    5.6
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    4.8,
                    5.1
                  ],
                  [
                    4.8,
                    2.8
                  ],
                  [
                    5.8,
                    2.8
                  ],
                  [
                    5.8,
                    11.6
                  ],
                  [
                    5,
                    11.6
                  ],
                  [
                    4.9,
                    10.9
                  ],
                  [
                    4.9,
                    10.9
                  ],
                  [
                    4.1,
                    11.5
                  ],
                  [
                    3.1,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.5,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    10.9
                  ],
                  [
                    3.3,
                    10.9
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    4.8,
                    6.9
                  ],
                  [
                    4.1,
                    6.4
                  ],
                  [
                    3.4,
                    6.3
                  ],
                  [
                    3.4,
                    6.3
                  ],
                  [
                    2.5,
                    6.6
                  ],
                  [
                    1.9,
                    7.4
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    2.1,
                    10.3
                  ],
                  [
                    3.3,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 936,
        ty: 3,
        parent: 935,
        ks: {
          p: {
            a: 0,
            k: [
              45.744,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 939,
        ty: 4,
        parent: 938,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -1.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.3
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.5,
                    8.5
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.2,
                    7.1
                  ],
                  [
                    3.8,
                    6.5
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    2.1,
                    6.5
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    0.9,
                    6.2
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    11.6
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    3.5,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    10.9
                  ],
                  [
                    2.7,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    8.5
                  ],
                  [
                    2.2,
                    9
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.9,
                    10.7
                  ],
                  [
                    2.7,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 938,
        ty: 3,
        parent: 935,
        ks: {
          p: {
            a: 0,
            k: [
              39.525,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 941,
        ty: 4,
        parent: 940,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.6
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.7,
                    11.7
                  ],
                  [
                    3.7,
                    11.7
                  ],
                  [
                    2.8,
                    11.5
                  ],
                  [
                    2,
                    11
                  ],
                  [
                    2,
                    11
                  ],
                  [
                    1.9,
                    11
                  ],
                  [
                    1.8,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    2.8
                  ],
                  [
                    2,
                    2.8
                  ],
                  [
                    2,
                    5.2
                  ],
                  [
                    2,
                    6.3
                  ],
                  [
                    2.9,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    5.7,
                    6.3
                  ],
                  [
                    6.3,
                    8.5
                  ],
                  [
                    6.3,
                    8.5
                  ],
                  [
                    5.9,
                    10.2
                  ],
                  [
                    4.9,
                    11.4
                  ],
                  [
                    3.7,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    -0.2,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    10.9
                  ],
                  [
                    3.5,
                    10.9
                  ],
                  [
                    4.7,
                    10.2
                  ],
                  [
                    5.2,
                    8.5
                  ],
                  [
                    5.2,
                    8.5
                  ],
                  [
                    4.8,
                    6.9
                  ],
                  [
                    3.6,
                    6.3
                  ],
                  [
                    3.6,
                    6.3
                  ],
                  [
                    2.9,
                    6.5
                  ],
                  [
                    2,
                    7.1
                  ],
                  [
                    2,
                    7.1
                  ],
                  [
                    2,
                    10.3
                  ],
                  [
                    2.8,
                    10.7
                  ],
                  [
                    3.5,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 940,
        ty: 3,
        parent: 935,
        ks: {
          p: {
            a: 0,
            k: [
              32.701,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 943,
        ty: 4,
        parent: 942,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -1.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.3
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.5,
                    8.5
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.2,
                    7.1
                  ],
                  [
                    3.8,
                    6.5
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    2.1,
                    6.5
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    0.9,
                    6.2
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    11.6
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    3.5,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    10.9
                  ],
                  [
                    2.7,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    8.5
                  ],
                  [
                    2.2,
                    9
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.9,
                    10.7
                  ],
                  [
                    2.7,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 942,
        ty: 3,
        parent: 935,
        ks: {
          p: {
            a: 0,
            k: [
              26.482,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 945,
        ty: 4,
        parent: 944,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.5
                  ],
                  [
                    0,
                    1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.1,
                    11.7
                  ],
                  [
                    3.1,
                    11.7
                  ],
                  [
                    1.3,
                    10.9
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    1.9,
                    5.8
                  ],
                  [
                    3.2,
                    5.4
                  ],
                  [
                    3.2,
                    5.4
                  ],
                  [
                    4.1,
                    5.6
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    4.8,
                    5.1
                  ],
                  [
                    4.8,
                    2.8
                  ],
                  [
                    5.8,
                    2.8
                  ],
                  [
                    5.8,
                    11.6
                  ],
                  [
                    5,
                    11.6
                  ],
                  [
                    4.9,
                    10.9
                  ],
                  [
                    4.9,
                    10.9
                  ],
                  [
                    4.1,
                    11.5
                  ],
                  [
                    3.1,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.5,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    10.9
                  ],
                  [
                    3.3,
                    10.9
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    4.8,
                    6.9
                  ],
                  [
                    4.1,
                    6.4
                  ],
                  [
                    3.4,
                    6.3
                  ],
                  [
                    3.4,
                    6.3
                  ],
                  [
                    2.5,
                    6.6
                  ],
                  [
                    1.9,
                    7.4
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    2.1,
                    10.3
                  ],
                  [
                    3.3,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 944,
        ty: 3,
        parent: 935,
        ks: {
          p: {
            a: 0,
            k: [
              19.633,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 947,
        ty: 4,
        parent: 946,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    1,
                    3.2
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    2,
                    3.2
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2,
                    4.2
                  ],
                  [
                    1.5,
                    4.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 946,
        ty: 3,
        parent: 935,
        ks: {
          p: {
            a: 0,
            k: [
              16.597,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 949,
        ty: 4,
        parent: 948,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.7
                  ],
                  [
                    2,
                    6.7
                  ],
                  [
                    2.7,
                    5.8
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.1,
                    6.5
                  ],
                  [
                    3.9,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    2.7,
                    6.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 948,
        ty: 3,
        parent: 935,
        ks: {
          p: {
            a: 0,
            k: [
              12.315,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 951,
        ty: 4,
        parent: 950,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -1.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.3
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.5,
                    8.5
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.2,
                    7.1
                  ],
                  [
                    3.8,
                    6.5
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    2.1,
                    6.5
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    0.9,
                    6.2
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    11.6
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    3.5,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    10.9
                  ],
                  [
                    2.7,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    8.5
                  ],
                  [
                    2.2,
                    9
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.9,
                    10.7
                  ],
                  [
                    2.7,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 950,
        ty: 3,
        parent: 935,
        ks: {
          p: {
            a: 0,
            k: [
              6.096,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 953,
        ty: 4,
        parent: 952,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    3.5
                  ],
                  [
                    5.8,
                    3.5
                  ],
                  [
                    5.8,
                    4.4
                  ],
                  [
                    2.1,
                    4.4
                  ],
                  [
                    2.1,
                    7.1
                  ],
                  [
                    5.2,
                    7.1
                  ],
                  [
                    5.2,
                    8
                  ],
                  [
                    2.1,
                    8
                  ],
                  [
                    2.1,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 952,
        ty: 3,
        parent: 935,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 935,
        ty: 3,
        parent: 934,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 934,
        ty: 3,
        parent: 933,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 933,
        ty: 3,
        parent: 932,
        ks: {
          p: {
            a: 0,
            k: [
              21.159,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 963,
        ty: 0,
        parent: 954,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "961"
      },
      {
        ind: 954,
        ty: 3,
        parent: 932,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 932,
        ty: 3,
        parent: 931,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              19.527
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 969,
        ty: 4,
        parent: 968,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0.1
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    2.9,
                    11.7
                  ],
                  [
                    2.9,
                    11.7
                  ],
                  [
                    1.3,
                    11.4
                  ],
                  [
                    0.3,
                    10.6
                  ],
                  [
                    0.3,
                    10.6
                  ],
                  [
                    0.8,
                    10
                  ],
                  [
                    1.7,
                    10.6
                  ],
                  [
                    2.9,
                    10.9
                  ],
                  [
                    2.9,
                    10.9
                  ],
                  [
                    4,
                    10.5
                  ],
                  [
                    4.5,
                    9.5
                  ],
                  [
                    4.5,
                    9.5
                  ],
                  [
                    4.2,
                    8.6
                  ],
                  [
                    3.4,
                    8.1
                  ],
                  [
                    2,
                    7.9
                  ],
                  [
                    2,
                    7.9
                  ],
                  [
                    2,
                    7.1
                  ],
                  [
                    3.3,
                    6.9
                  ],
                  [
                    4,
                    6.4
                  ],
                  [
                    4.2,
                    5.6
                  ],
                  [
                    4.2,
                    5.6
                  ],
                  [
                    3.8,
                    4.7
                  ],
                  [
                    2.8,
                    4.4
                  ],
                  [
                    2.8,
                    4.4
                  ],
                  [
                    1.9,
                    4.6
                  ],
                  [
                    1.2,
                    5.2
                  ],
                  [
                    1.2,
                    5.2
                  ],
                  [
                    0.6,
                    4.6
                  ],
                  [
                    1.6,
                    3.8
                  ],
                  [
                    2.9,
                    3.6
                  ],
                  [
                    2.9,
                    3.6
                  ],
                  [
                    4.6,
                    4.1
                  ],
                  [
                    5.2,
                    5.6
                  ],
                  [
                    5.2,
                    5.6
                  ],
                  [
                    4.8,
                    6.7
                  ],
                  [
                    3.8,
                    7.4
                  ],
                  [
                    3.8,
                    7.4
                  ],
                  [
                    3.8,
                    7.5
                  ],
                  [
                    5,
                    8.2
                  ],
                  [
                    5.5,
                    9.5
                  ],
                  [
                    5.5,
                    9.5
                  ],
                  [
                    5.2,
                    10.7
                  ],
                  [
                    4.2,
                    11.5
                  ],
                  [
                    2.9,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.4,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.1
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 968,
        ty: 3,
        parent: 967,
        ks: {
          p: {
            a: 0,
            k: [
              16.93,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 971,
        ty: 4,
        parent: 970,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.34,
                    8.88
                  ],
                  [
                    0.51,
                    8.88
                  ],
                  [
                    0.51,
                    8.11
                  ],
                  [
                    3.34,
                    8.11
                  ],
                  [
                    3.34,
                    8.88
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 970,
        ty: 3,
        parent: 967,
        ks: {
          p: {
            a: 0,
            k: [
              13.093,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 973,
        ty: 4,
        parent: 972,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    5.9,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    3.5
                  ],
                  [
                    5.8,
                    3.5
                  ],
                  [
                    5.8,
                    4.4
                  ],
                  [
                    2.1,
                    4.4
                  ],
                  [
                    2.1,
                    6.9
                  ],
                  [
                    5.2,
                    6.9
                  ],
                  [
                    5.2,
                    7.8
                  ],
                  [
                    2.1,
                    7.8
                  ],
                  [
                    2.1,
                    10.7
                  ],
                  [
                    5.9,
                    10.7
                  ],
                  [
                    5.9,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 972,
        ty: 3,
        parent: 967,
        ks: {
          p: {
            a: 0,
            k: [
              6.59,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 975,
        ty: 4,
        parent: 974,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    1.1,
                    9.8
                  ],
                  [
                    2.2,
                    10.6
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    4.6,
                    10.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    4.9,
                    8.8
                  ],
                  [
                    4.4,
                    8.4
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    2.6,
                    7.6
                  ],
                  [
                    1.8,
                    7.2
                  ],
                  [
                    1.2,
                    6.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    1.2,
                    4.4
                  ],
                  [
                    2.1,
                    3.6
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    4.8,
                    3.6
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.3,
                    5
                  ],
                  [
                    4.5,
                    4.4
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    2.4,
                    4.6
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2.2,
                    6.1
                  ],
                  [
                    2.7,
                    6.5
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    4.4,
                    7.3
                  ],
                  [
                    5.3,
                    7.7
                  ],
                  [
                    5.9,
                    8.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    5.8,
                    10.6
                  ],
                  [
                    4.8,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 974,
        ty: 3,
        parent: 967,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 967,
        ty: 3,
        parent: 966,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 966,
        ty: 3,
        parent: 965,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.8
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 965,
        ty: 3,
        parent: 964,
        ks: {
          p: {
            a: 0,
            k: [
              21.159,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 985,
        ty: 0,
        parent: 976,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "983"
      },
      {
        ind: 976,
        ty: 3,
        parent: 964,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 964,
        ty: 3,
        parent: 931,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 931,
        ty: 3,
        parent: 930,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              36.053
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 991,
        ty: 4,
        parent: 990,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    2.7,
                    12
                  ],
                  [
                    2.8,
                    13.3
                  ],
                  [
                    2.9,
                    13.3
                  ],
                  [
                    3.9,
                    12.2
                  ],
                  [
                    5.1,
                    11.8
                  ],
                  [
                    5.1,
                    11.8
                  ],
                  [
                    6,
                    11.9
                  ],
                  [
                    6,
                    11.9
                  ],
                  [
                    5.6,
                    13.5
                  ],
                  [
                    5.3,
                    13.4
                  ],
                  [
                    4.8,
                    13.4
                  ],
                  [
                    4.8,
                    13.4
                  ],
                  [
                    3.9,
                    13.7
                  ],
                  [
                    3,
                    15
                  ],
                  [
                    3,
                    15
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 990,
        ty: 3,
        parent: 989,
        ks: {
          p: {
            a: 0,
            k: [
              39.84,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 993,
        ty: 4,
        parent: 992,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0.5
                  ],
                  [
                    -1.6,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    -1.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.9
                  ],
                  [
                    3,
                    19.9
                  ],
                  [
                    1.4,
                    19.3
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    1.8,
                    15.7
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5,
                    13.7
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    2.8,
                    13.5
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1,
                    12.8
                  ],
                  [
                    2.5,
                    12.1
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    6.4,
                    12.6
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    19.7
                  ],
                  [
                    5.6,
                    19.7
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    4.3,
                    19.6
                  ],
                  [
                    3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.7,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.6,
                    18.5
                  ],
                  [
                    3.6,
                    18.5
                  ],
                  [
                    4.5,
                    18.3
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    15.9
                  ],
                  [
                    3.1,
                    16.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.8,
                    18.3
                  ],
                  [
                    3.6,
                    18.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 992,
        ty: 3,
        parent: 989,
        ks: {
          p: {
            a: 0,
            k: [
              31.657,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 995,
        ty: 4,
        parent: 994,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    2.7,
                    12
                  ],
                  [
                    2.8,
                    13
                  ],
                  [
                    2.9,
                    13
                  ],
                  [
                    3.9,
                    12.1
                  ],
                  [
                    5.2,
                    11.8
                  ],
                  [
                    5.2,
                    11.8
                  ],
                  [
                    6.6,
                    12.1
                  ],
                  [
                    7.4,
                    13.2
                  ],
                  [
                    7.4,
                    13.2
                  ],
                  [
                    8.6,
                    12.2
                  ],
                  [
                    9.9,
                    11.8
                  ],
                  [
                    9.9,
                    11.8
                  ],
                  [
                    11.7,
                    12.6
                  ],
                  [
                    12.3,
                    14.9
                  ],
                  [
                    12.3,
                    14.9
                  ],
                  [
                    12.3,
                    19.7
                  ],
                  [
                    10.5,
                    19.7
                  ],
                  [
                    10.5,
                    15.1
                  ],
                  [
                    10.2,
                    13.7
                  ],
                  [
                    9.3,
                    13.3
                  ],
                  [
                    9.3,
                    13.3
                  ],
                  [
                    7.6,
                    14.3
                  ],
                  [
                    7.6,
                    14.3
                  ],
                  [
                    7.6,
                    19.7
                  ],
                  [
                    5.8,
                    19.7
                  ],
                  [
                    5.8,
                    15.1
                  ],
                  [
                    5.5,
                    13.7
                  ],
                  [
                    4.6,
                    13.3
                  ],
                  [
                    4.6,
                    13.3
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 994,
        ty: 3,
        parent: 989,
        ks: {
          p: {
            a: 0,
            k: [
              18.287,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 997,
        ty: 4,
        parent: 996,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    19.9
                  ],
                  [
                    3.5,
                    19.9
                  ],
                  [
                    1.7,
                    19.1
                  ],
                  [
                    1.1,
                    16.8
                  ],
                  [
                    1.1,
                    16.8
                  ],
                  [
                    1.1,
                    12
                  ],
                  [
                    2.9,
                    12
                  ],
                  [
                    2.9,
                    16.6
                  ],
                  [
                    3.2,
                    18
                  ],
                  [
                    4.1,
                    18.4
                  ],
                  [
                    4.1,
                    18.4
                  ],
                  [
                    5,
                    18.1
                  ],
                  [
                    5.8,
                    17.3
                  ],
                  [
                    5.8,
                    17.3
                  ],
                  [
                    5.8,
                    12
                  ],
                  [
                    7.7,
                    12
                  ],
                  [
                    7.7,
                    19.7
                  ],
                  [
                    6.2,
                    19.7
                  ],
                  [
                    6,
                    18.6
                  ],
                  [
                    6,
                    18.6
                  ],
                  [
                    4.9,
                    19.6
                  ],
                  [
                    3.5,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 996,
        ty: 3,
        parent: 989,
        ks: {
          p: {
            a: 0,
            k: [
              9.468,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 999,
        ty: 4,
        parent: 998,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    19.7
                  ],
                  [
                    1.3,
                    19.7
                  ],
                  [
                    1.3,
                    9.4
                  ],
                  [
                    3.2,
                    9.4
                  ],
                  [
                    3.2,
                    14.1
                  ],
                  [
                    3.2,
                    14.1
                  ],
                  [
                    6.9,
                    9.4
                  ],
                  [
                    9,
                    9.4
                  ],
                  [
                    5.8,
                    13.4
                  ],
                  [
                    9.5,
                    19.7
                  ],
                  [
                    7.5,
                    19.7
                  ],
                  [
                    4.6,
                    14.9
                  ],
                  [
                    3.2,
                    16.7
                  ],
                  [
                    3.2,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 998,
        ty: 3,
        parent: 989,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 989,
        ty: 3,
        parent: 988,
        ks: {
          p: {
            a: 0,
            k: [
              43.472,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1002,
        ty: 4,
        parent: 1001,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    2.7,
                    12
                  ],
                  [
                    2.8,
                    13
                  ],
                  [
                    2.9,
                    13
                  ],
                  [
                    4,
                    12.1
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    7.2,
                    12.6
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    19.7
                  ],
                  [
                    6,
                    19.7
                  ],
                  [
                    6,
                    15.1
                  ],
                  [
                    5.7,
                    13.7
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    3.9,
                    13.6
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1001,
        ty: 3,
        parent: 1e3,
        ks: {
          p: {
            a: 0,
            k: [
              31.419,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1004,
        ty: 4,
        parent: 1003,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    19.9
                  ],
                  [
                    3.5,
                    19.9
                  ],
                  [
                    1.7,
                    19.1
                  ],
                  [
                    1.1,
                    16.8
                  ],
                  [
                    1.1,
                    16.8
                  ],
                  [
                    1.1,
                    12
                  ],
                  [
                    2.9,
                    12
                  ],
                  [
                    2.9,
                    16.6
                  ],
                  [
                    3.2,
                    18
                  ],
                  [
                    4.1,
                    18.4
                  ],
                  [
                    4.1,
                    18.4
                  ],
                  [
                    5,
                    18.1
                  ],
                  [
                    5.8,
                    17.3
                  ],
                  [
                    5.8,
                    17.3
                  ],
                  [
                    5.8,
                    12
                  ],
                  [
                    7.7,
                    12
                  ],
                  [
                    7.7,
                    19.7
                  ],
                  [
                    6.2,
                    19.7
                  ],
                  [
                    6,
                    18.6
                  ],
                  [
                    6,
                    18.6
                  ],
                  [
                    4.9,
                    19.6
                  ],
                  [
                    3.5,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1003,
        ty: 3,
        parent: 1e3,
        ks: {
          p: {
            a: 0,
            k: [
              22.6,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1006,
        ty: 4,
        parent: 1005,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    2.7,
                    12
                  ],
                  [
                    2.8,
                    13.3
                  ],
                  [
                    2.9,
                    13.3
                  ],
                  [
                    3.9,
                    12.2
                  ],
                  [
                    5.1,
                    11.8
                  ],
                  [
                    5.1,
                    11.8
                  ],
                  [
                    6,
                    11.9
                  ],
                  [
                    6,
                    11.9
                  ],
                  [
                    5.6,
                    13.5
                  ],
                  [
                    5.3,
                    13.4
                  ],
                  [
                    4.8,
                    13.4
                  ],
                  [
                    4.8,
                    13.4
                  ],
                  [
                    3.9,
                    13.7
                  ],
                  [
                    3,
                    15
                  ],
                  [
                    3,
                    15
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1005,
        ty: 3,
        parent: 1e3,
        ks: {
          p: {
            a: 0,
            k: [
              16.685,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1008,
        ty: 4,
        parent: 1007,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0.5
                  ],
                  [
                    -1.6,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    -1.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.9
                  ],
                  [
                    3,
                    19.9
                  ],
                  [
                    1.4,
                    19.3
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    1.8,
                    15.7
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5,
                    13.7
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    2.8,
                    13.5
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1,
                    12.8
                  ],
                  [
                    2.5,
                    12.1
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    6.4,
                    12.6
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    19.7
                  ],
                  [
                    5.6,
                    19.7
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    4.3,
                    19.6
                  ],
                  [
                    3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.7,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.6,
                    18.5
                  ],
                  [
                    3.6,
                    18.5
                  ],
                  [
                    4.5,
                    18.3
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    15.9
                  ],
                  [
                    3.1,
                    16.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.8,
                    18.3
                  ],
                  [
                    3.6,
                    18.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1007,
        ty: 3,
        parent: 1e3,
        ks: {
          p: {
            a: 0,
            k: [
              8.501,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1010,
        ty: 4,
        parent: 1009,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.5
                  ],
                  [
                    -0.2,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    5.3,
                    19.7
                  ],
                  [
                    3.2,
                    19.7
                  ],
                  [
                    -0.1,
                    9.4
                  ],
                  [
                    1.9,
                    9.4
                  ],
                  [
                    3.3,
                    14.6
                  ],
                  [
                    3.8,
                    16.3
                  ],
                  [
                    4.3,
                    18
                  ],
                  [
                    4.3,
                    18
                  ],
                  [
                    4.3,
                    18
                  ],
                  [
                    4.8,
                    16.3
                  ],
                  [
                    5.2,
                    14.6
                  ],
                  [
                    5.2,
                    14.6
                  ],
                  [
                    6.7,
                    9.4
                  ],
                  [
                    8.6,
                    9.4
                  ],
                  [
                    5.3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.6
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.6
                  ],
                  [
                    0.1,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1009,
        ty: 3,
        parent: 1e3,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1e3,
        ty: 3,
        parent: 988,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 988,
        ty: 3,
        parent: 987,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.394
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 987,
        ty: 3,
        parent: 986,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 986,
        ty: 3,
        parent: 930,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 930,
        ty: 3,
        parent: 929,
        ks: {
          p: {
            a: 0,
            k: [
              91.69,
              3.002
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1021,
        ty: 0,
        parent: 1012,
        ks: {
          a: {
            a: 0,
            k: [
              54.666,
              55.543
            ]
          },
          p: {
            a: 0,
            k: [
              54.666,
              55.543
            ]
          }
        },
        w: 21.159,
        h: 21.159,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1019"
      },
      {
        ind: 1012,
        ty: 3,
        parent: 1011,
        ks: {
          p: {
            a: 0,
            k: [
              54.666,
              55.543
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1024,
        ty: 4,
        td: 1,
        parent: 1022,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                38.792,
                38.792
              ]
            },
            r: {
              a: 0,
              k: 60
            },
            s: {
              a: 0,
              k: [
                77.584,
                77.584
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1023,
        ty: 4,
        tt: 1,
        parent: 1022,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                p: {
                  a: 0,
                  k: [
                    38.792,
                    38.792
                  ]
                },
                r: {
                  a: 0,
                  k: 0
                },
                s: {
                  a: 0,
                  k: [
                    81.992,
                    81.992
                  ]
                }
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0,
                    0,
                    0,
                    0
                  ]
                },
                o: {
                  a: 0,
                  k: 0
                }
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          },
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                p: {
                  a: 0,
                  k: [
                    38.792,
                    38.792
                  ]
                },
                r: {
                  a: 0,
                  k: 60
                },
                s: {
                  a: 0,
                  k: [
                    77.584,
                    77.584
                  ]
                }
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.427,
                    0.184,
                    0.604
                  ]
                },
                lj: 1,
                ml: 10,
                o: {
                  a: 0,
                  k: 100
                },
                w: {
                  a: 0,
                  k: 4.408
                }
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      },
      {
        ind: 1040,
        ty: 4,
        td: 1,
        parent: 1022,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                38.792,
                38.792
              ]
            },
            r: {
              a: 0,
              k: 60
            },
            s: {
              a: 0,
              k: [
                77.584,
                77.584
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1039,
        ty: 0,
        tt: 1,
        parent: 1022,
        ks: {},
        w: 71,
        h: 71,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1037"
      },
      {
        ind: 1022,
        ty: 3,
        parent: 1011,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1011,
        ty: 3,
        parent: 929,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 929,
        ty: 3,
        parent: 755,
        ks: {
          p: {
            a: 0,
            k: [
              10.58,
              10.58
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1041,
        ty: 4,
        parent: 755,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                148.115,
                91.315
              ]
            },
            r: {
              a: 0,
              k: 7
            },
            s: {
              a: 0,
              k: [
                296.23,
                182.63
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                1,
                1
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 755,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1046",
    layers: [
      {
        ind: 1044,
        ty: 0,
        ks: {
          a: {
            a: 0,
            k: [
              1,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              143.629,
              142.629
            ]
          }
        },
        w: 298,
        h: 183,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1042"
      },
      {
        ind: 1045,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                291.745,
                233.944
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                583.489,
                467.888
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      }
    ]
  },
  {
    id: "1113",
    layers: [
      {
        ind: 1112,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                7,
                4.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                14,
                9
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            -0.09
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            -0.03
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.06,
                            0.02
                          ],
                          [
                            0.05,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            0.03
                          ],
                          [
                            -0.07,
                            0
                          ],
                          [
                            -0.06,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.13
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.05
                          ],
                          [
                            -0.06,
                            0.02
                          ],
                          [
                            -0.06,
                            0
                          ],
                          [
                            -0.06,
                            -0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.05
                          ],
                          [
                            0.06,
                            -0.02
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.06,
                            0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            0.09,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            10.09,
                            0.81
                          ],
                          [
                            10.09,
                            3.46
                          ],
                          [
                            9.94,
                            3.81
                          ],
                          [
                            9.59,
                            3.95
                          ],
                          [
                            9.24,
                            3.81
                          ],
                          [
                            9.09,
                            3.46
                          ],
                          [
                            9.09,
                            2.01
                          ],
                          [
                            5.97,
                            5.13
                          ],
                          [
                            5.81,
                            5.24
                          ],
                          [
                            5.62,
                            5.28
                          ],
                          [
                            5.43,
                            5.24
                          ],
                          [
                            5.27,
                            5.13
                          ],
                          [
                            3.97,
                            3.83
                          ],
                          [
                            1.34,
                            6.45
                          ],
                          [
                            0.99,
                            6.6
                          ],
                          [
                            0.64,
                            6.45
                          ],
                          [
                            0.5,
                            6.1
                          ],
                          [
                            0.64,
                            5.75
                          ],
                          [
                            3.62,
                            2.78
                          ],
                          [
                            3.78,
                            2.67
                          ],
                          [
                            3.97,
                            2.63
                          ],
                          [
                            4.16,
                            2.67
                          ],
                          [
                            4.32,
                            2.78
                          ],
                          [
                            5.62,
                            4.08
                          ],
                          [
                            8.39,
                            1.31
                          ],
                          [
                            6.95,
                            1.31
                          ],
                          [
                            6.59,
                            1.16
                          ],
                          [
                            6.45,
                            0.81
                          ],
                          [
                            6.59,
                            0.46
                          ],
                          [
                            6.95,
                            0.32
                          ],
                          [
                            9.59,
                            0.32
                          ],
                          [
                            9.94,
                            0.46
                          ],
                          [
                            10.09,
                            0.81
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.52,
                        0.32,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1116",
    layers: [
      {
        ind: 1115,
        ty: 0,
        parent: 1111,
        ks: {},
        w: 14,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1113"
      },
      {
        ind: 1111,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              2
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1125",
    layers: [
      {
        ind: 1124,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                12,
                3
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                24,
                6
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.29,
                            -0.2
                          ],
                          [
                            5.07,
                            0
                          ],
                          [
                            4.36,
                            3.96
                          ],
                          [
                            -0.09,
                            0.13
                          ],
                          [
                            -0.22,
                            -0.12
                          ],
                          [
                            -5.39,
                            0
                          ],
                          [
                            -3.84,
                            1.64
                          ],
                          [
                            -0.16,
                            -0.21
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.88,
                            1.57
                          ],
                          [
                            17.77,
                            2
                          ],
                          [
                            9.68,
                            4.41
                          ],
                          [
                            0.09,
                            0.71
                          ],
                          [
                            0.03,
                            0.45
                          ],
                          [
                            0.34,
                            0.46
                          ],
                          [
                            9.83,
                            3.02
                          ],
                          [
                            17.42,
                            1.52
                          ],
                          [
                            17.88,
                            1.57
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.95,
                        0.59,
                        0.11,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1130",
    layers: [
      {
        ind: 1129,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3,
                2.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                6,
                5
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                -0.12,
                                -0.04
                              ],
                              [
                                -0.16,
                                0.15
                              ],
                              [
                                -0.03,
                                1.9
                              ],
                              [
                                0.1,
                                0.07
                              ],
                              [
                                1.35,
                                -0.1
                              ],
                              [
                                0.64,
                                -0.57
                              ],
                              [
                                0,
                                -0.06
                              ],
                              [
                                -0.36,
                                0.06
                              ],
                              [
                                -0.7,
                                -0.09
                              ],
                              [
                                -0.1,
                                -0.12
                              ],
                              [
                                0.09,
                                -0.45
                              ],
                              [
                                0.38,
                                -0.71
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                2.37,
                                3.4
                              ],
                              [
                                2.39,
                                3.6
                              ],
                              [
                                2.69,
                                3.5
                              ],
                              [
                                3.91,
                                0.55
                              ],
                              [
                                3.82,
                                0.25
                              ],
                              [
                                2.1,
                                0.02
                              ],
                              [
                                0.29,
                                0.67
                              ],
                              [
                                0.23,
                                0.78
                              ],
                              [
                                0.57,
                                0.86
                              ],
                              [
                                2.44,
                                0.78
                              ],
                              [
                                2.9,
                                0.95
                              ],
                              [
                                2.98,
                                1.54
                              ],
                              [
                                2.37,
                                3.4
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0.95,
                            0.59,
                            0.11,
                            1
                          ]
                        },
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1135",
    layers: [
      {
        ind: 1134,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                25,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                50,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                -0.04
                              ],
                              [
                                0.06,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                0.04
                              ],
                              [
                                0,
                                0.06
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.04,
                                0.04
                              ],
                              [
                                -0.06,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.04,
                                -0.04
                              ],
                              [
                                0,
                                -0.06
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.11,
                                0
                              ],
                              [
                                -0.45,
                                -1.22
                              ],
                              [
                                -1.14,
                                0
                              ],
                              [
                                0,
                                -1.75
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                -0.04
                              ],
                              [
                                0.05,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                0.04
                              ],
                              [
                                0,
                                0.06
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                -0.04
                              ],
                              [
                                0.06,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                0.04
                              ],
                              [
                                0,
                                0.06
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.81,
                                0
                              ],
                              [
                                -0.03,
                                -1.25
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.06
                              ],
                              [
                                -0.04,
                                0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.06,
                                0
                              ],
                              [
                                -0.04,
                                -0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -0.06
                              ],
                              [
                                0.04,
                                -0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.06,
                                0
                              ],
                              [
                                0.04,
                                0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.06
                              ],
                              [
                                -0.04,
                                0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.06,
                                0
                              ],
                              [
                                -0.04,
                                -0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.03,
                                -0.89
                              ],
                              [
                                -0.9,
                                0.02
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.06
                              ],
                              [
                                -0.04,
                                0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.06,
                                0
                              ],
                              [
                                -0.04,
                                -0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                7.9,
                                2.84
                              ],
                              [
                                7.9,
                                6.43
                              ],
                              [
                                7.84,
                                6.59
                              ],
                              [
                                7.68,
                                6.65
                              ],
                              [
                                6.55,
                                6.65
                              ],
                              [
                                6.39,
                                6.59
                              ],
                              [
                                6.33,
                                6.43
                              ],
                              [
                                6.33,
                                0.59
                              ],
                              [
                                6.39,
                                0.44
                              ],
                              [
                                6.55,
                                0.38
                              ],
                              [
                                7.6,
                                0.38
                              ],
                              [
                                7.75,
                                0.44
                              ],
                              [
                                7.82,
                                0.59
                              ],
                              [
                                7.82,
                                1.42
                              ],
                              [
                                9.3,
                                0.25
                              ],
                              [
                                10.85,
                                1.33
                              ],
                              [
                                12.36,
                                0.25
                              ],
                              [
                                14.05,
                                1.89
                              ],
                              [
                                14.06,
                                2.86
                              ],
                              [
                                14.06,
                                6.44
                              ],
                              [
                                14,
                                6.6
                              ],
                              [
                                13.84,
                                6.66
                              ],
                              [
                                12.71,
                                6.66
                              ],
                              [
                                12.55,
                                6.6
                              ],
                              [
                                12.49,
                                6.44
                              ],
                              [
                                12.48,
                                2.53
                              ],
                              [
                                11.8,
                                1.71
                              ],
                              [
                                10.98,
                                2.86
                              ],
                              [
                                10.98,
                                6.44
                              ],
                              [
                                10.91,
                                6.6
                              ],
                              [
                                10.76,
                                6.66
                              ],
                              [
                                9.63,
                                6.66
                              ],
                              [
                                9.47,
                                6.6
                              ],
                              [
                                9.41,
                                6.44
                              ],
                              [
                                9.41,
                                2.62
                              ],
                              [
                                8.67,
                                1.7
                              ],
                              [
                                7.9,
                                2.84
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                -0.04
                              ],
                              [
                                0.06,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                0.04
                              ],
                              [
                                0,
                                0.06
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.81,
                                0
                              ],
                              [
                                0,
                                -1.44
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                -0.04
                              ],
                              [
                                0.06,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                0.04
                              ],
                              [
                                0,
                                0.06
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.04,
                                0.04
                              ],
                              [
                                -0.06,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.04,
                                -0.04
                              ],
                              [
                                0,
                                -0.06
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.11,
                                0
                              ],
                              [
                                -0.4,
                                -1.25
                              ],
                              [
                                0,
                                -1.27
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.06
                              ],
                              [
                                -0.04,
                                0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.06,
                                0
                              ],
                              [
                                -0.04,
                                -0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.06
                              ],
                              [
                                -0.04,
                                0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.06,
                                0
                              ],
                              [
                                -0.04,
                                -0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -0.06
                              ],
                              [
                                0.04,
                                -0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.05,
                                0
                              ],
                              [
                                0.04,
                                0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                37.09,
                                2.83
                              ],
                              [
                                37.09,
                                6.42
                              ],
                              [
                                37.03,
                                6.57
                              ],
                              [
                                36.87,
                                6.64
                              ],
                              [
                                35.7,
                                6.66
                              ],
                              [
                                35.54,
                                6.6
                              ],
                              [
                                35.48,
                                6.44
                              ],
                              [
                                35.48,
                                2.62
                              ],
                              [
                                34.73,
                                1.7
                              ],
                              [
                                33.96,
                                3.1
                              ],
                              [
                                33.96,
                                6.43
                              ],
                              [
                                33.9,
                                6.59
                              ],
                              [
                                33.75,
                                6.65
                              ],
                              [
                                32.61,
                                6.65
                              ],
                              [
                                32.46,
                                6.59
                              ],
                              [
                                32.39,
                                6.43
                              ],
                              [
                                32.39,
                                0.59
                              ],
                              [
                                32.46,
                                0.44
                              ],
                              [
                                32.61,
                                0.38
                              ],
                              [
                                33.66,
                                0.38
                              ],
                              [
                                33.82,
                                0.44
                              ],
                              [
                                33.88,
                                0.59
                              ],
                              [
                                33.88,
                                1.42
                              ],
                              [
                                35.37,
                                0.25
                              ],
                              [
                                36.96,
                                1.31
                              ],
                              [
                                37.09,
                                2.83
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -2.05
                              ],
                              [
                                -1.71,
                                0
                              ],
                              [
                                0,
                                1.81
                              ],
                              [
                                1.45,
                                0
                              ]
                            ],
                            o: [
                              [
                                -1.45,
                                0
                              ],
                              [
                                0,
                                1.81
                              ],
                              [
                                1.62,
                                0
                              ],
                              [
                                0,
                                -2.02
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                28.91,
                                0.22
                              ],
                              [
                                26.29,
                                3.5
                              ],
                              [
                                28.91,
                                6.77
                              ],
                              [
                                31.54,
                                3.5
                              ],
                              [
                                28.91,
                                0.22
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.09,
                                0
                              ],
                              [
                                0.12,
                                0.81
                              ],
                              [
                                0,
                                0.77
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.09,
                                0
                              ],
                              [
                                -0.14,
                                -0.82
                              ],
                              [
                                0,
                                -0.77
                              ]
                            ],
                            o: [
                              [
                                0,
                                0.77
                              ],
                              [
                                -0.14,
                                0.82
                              ],
                              [
                                -0.09,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -0.77
                              ],
                              [
                                0.12,
                                -0.81
                              ],
                              [
                                0.09,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                29.83,
                                3.57
                              ],
                              [
                                29.73,
                                4.75
                              ],
                              [
                                28.91,
                                5.57
                              ],
                              [
                                28.1,
                                4.75
                              ],
                              [
                                28,
                                3.57
                              ],
                              [
                                28,
                                3.44
                              ],
                              [
                                28.1,
                                2.25
                              ],
                              [
                                28.91,
                                1.44
                              ],
                              [
                                29.73,
                                2.25
                              ],
                              [
                                29.83,
                                3.44
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                0.04
                              ],
                              [
                                0.06,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                -0.04
                              ],
                              [
                                0,
                                -0.06
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.04,
                                -0.04
                              ],
                              [
                                -0.06,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -0.15
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.39,
                                0.2
                              ],
                              [
                                -1.18,
                                0
                              ],
                              [
                                -0.78,
                                -0.48
                              ],
                              [
                                0,
                                0.32
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.31,
                                0.14
                              ],
                              [
                                1.18,
                                -0.08
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -0.06
                              ],
                              [
                                -0.04,
                                -0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.06,
                                0
                              ],
                              [
                                -0.04,
                                0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.06
                              ],
                              [
                                0.04,
                                0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                25.64,
                                1.41
                              ],
                              [
                                25.64,
                                0.57
                              ],
                              [
                                25.57,
                                0.42
                              ],
                              [
                                25.41,
                                0.35
                              ],
                              [
                                21.67,
                                0.35
                              ],
                              [
                                21.52,
                                0.42
                              ],
                              [
                                21.45,
                                0.57
                              ],
                              [
                                21.45,
                                1.4
                              ],
                              [
                                21.52,
                                1.56
                              ],
                              [
                                21.67,
                                1.62
                              ],
                              [
                                23.63,
                                1.62
                              ],
                              [
                                21.31,
                                4.97
                              ],
                              [
                                21.23,
                                5.26
                              ],
                              [
                                21.23,
                                6.28
                              ],
                              [
                                21.61,
                                6.43
                              ],
                              [
                                23.49,
                                6
                              ],
                              [
                                25.44,
                                6.46
                              ],
                              [
                                25.76,
                                6.29
                              ],
                              [
                                25.76,
                                5.4
                              ],
                              [
                                25.48,
                                5.02
                              ],
                              [
                                23.41,
                                4.61
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.06,
                                0.21
                              ],
                              [
                                -0.76,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                -0.11,
                                -0.2
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.05,
                                -2.15
                              ],
                              [
                                -2.12,
                                0
                              ],
                              [
                                -0.09,
                                0.33
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.83,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.66,
                                0.05
                              ],
                              [
                                -1.02,
                                0.58
                              ],
                              [
                                0,
                                1.88
                              ],
                              [
                                1.14,
                                0
                              ],
                              [
                                0.2,
                                0.36
                              ],
                              [
                                0.18,
                                0.2
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.19,
                                -0.14
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                5.45,
                                5.61
                              ],
                              [
                                5.1,
                                5.07
                              ],
                              [
                                5,
                                4.64
                              ],
                              [
                                5,
                                2.15
                              ],
                              [
                                2.66,
                                0.18
                              ],
                              [
                                0.23,
                                1.84
                              ],
                              [
                                0.39,
                                2.17
                              ],
                              [
                                1.43,
                                2.28
                              ],
                              [
                                1.67,
                                2.11
                              ],
                              [
                                2.57,
                                1.39
                              ],
                              [
                                3.39,
                                2.1
                              ],
                              [
                                3.39,
                                2.7
                              ],
                              [
                                0.97,
                                3.21
                              ],
                              [
                                0.01,
                                4.95
                              ],
                              [
                                1.8,
                                6.74
                              ],
                              [
                                3.62,
                                5.9
                              ],
                              [
                                4.19,
                                6.6
                              ],
                              [
                                4.57,
                                6.63
                              ],
                              [
                                5.41,
                                5.91
                              ],
                              [
                                5.45,
                                5.61
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                -0.09,
                                0.52
                              ],
                              [
                                -1.13,
                                -0.01
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.45,
                                0
                              ]
                            ],
                            o: [
                              [
                                -0.54,
                                0
                              ],
                              [
                                0.09,
                                -0.53
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                1.4
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                2.36,
                                5.58
                              ],
                              [
                                1.71,
                                4.52
                              ],
                              [
                                3.39,
                                3.6
                              ],
                              [
                                3.39,
                                3.91
                              ],
                              [
                                2.36,
                                5.58
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.07,
                                0.21
                              ],
                              [
                                -0.77,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                -0.11,
                                -0.2
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.05,
                                -2.15
                              ],
                              [
                                -2.12,
                                0
                              ],
                              [
                                -0.09,
                                0.33
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.83,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -1.66,
                                0.05
                              ],
                              [
                                -1.02,
                                0.58
                              ],
                              [
                                0,
                                1.88
                              ],
                              [
                                1.14,
                                0
                              ],
                              [
                                0.2,
                                0.36
                              ],
                              [
                                0.19,
                                0.2
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.18,
                                -0.14
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                20.5,
                                5.61
                              ],
                              [
                                20.15,
                                5.07
                              ],
                              [
                                20.04,
                                4.64
                              ],
                              [
                                20.04,
                                2.15
                              ],
                              [
                                17.71,
                                0.18
                              ],
                              [
                                15.27,
                                1.84
                              ],
                              [
                                15.45,
                                2.17
                              ],
                              [
                                16.48,
                                2.28
                              ],
                              [
                                16.72,
                                2.11
                              ],
                              [
                                17.62,
                                1.39
                              ],
                              [
                                18.44,
                                2.1
                              ],
                              [
                                18.44,
                                2.7
                              ],
                              [
                                16.02,
                                3.21
                              ],
                              [
                                15.06,
                                4.95
                              ],
                              [
                                16.85,
                                6.74
                              ],
                              [
                                18.67,
                                5.9
                              ],
                              [
                                19.24,
                                6.6
                              ],
                              [
                                19.62,
                                6.63
                              ],
                              [
                                20.46,
                                5.91
                              ],
                              [
                                20.5,
                                5.61
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                -0.09,
                                0.52
                              ],
                              [
                                -1.13,
                                -0.01
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.45,
                                0
                              ]
                            ],
                            o: [
                              [
                                -0.54,
                                0
                              ],
                              [
                                0.09,
                                -0.53
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                1.4
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                17.41,
                                5.58
                              ],
                              [
                                16.75,
                                4.52
                              ],
                              [
                                18.44,
                                3.6
                              ],
                              [
                                18.44,
                                3.91
                              ],
                              [
                                17.41,
                                5.58
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0,
                            0,
                            0,
                            1
                          ]
                        },
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1138",
    layers: [
      {
        ind: 1127,
        ty: 0,
        parent: 1123,
        ks: {},
        w: 24,
        h: 6,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1125"
      },
      {
        ind: 1123,
        ty: 3,
        parent: 1122,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1132,
        ty: 0,
        parent: 1128,
        ks: {},
        w: 6,
        h: 5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1130"
      },
      {
        ind: 1128,
        ty: 3,
        parent: 1122,
        ks: {
          p: {
            a: 0,
            k: [
              21,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1122,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              7.985,
              9.228
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1137,
        ty: 0,
        parent: 1133,
        ks: {},
        w: 50,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1135"
      },
      {
        ind: 1133,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1168",
    layers: [
      {
        ind: 1167,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                13.5,
                6.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                27,
                13
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.12,
                                0
                              ],
                              [
                                0.09,
                                0.09
                              ],
                              [
                                0,
                                0.12
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.09,
                                0.09
                              ],
                              [
                                0,
                                0.12
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.12
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.02,
                                -0.06
                              ],
                              [
                                0,
                                -0.06
                              ],
                              [
                                0.02,
                                -0.05
                              ],
                              [
                                0.04,
                                -0.04
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                -0.12
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                -0.12
                              ],
                              [
                                0.09,
                                -0.09
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                -0.12
                              ],
                              [
                                0.09,
                                -0.09
                              ],
                              [
                                0.12,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                0.04
                              ],
                              [
                                0.02,
                                0.05
                              ],
                              [
                                0,
                                0.06
                              ],
                              [
                                -0.02,
                                0.06
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                19.51,
                                4.9
                              ],
                              [
                                15.39,
                                9.03
                              ],
                              [
                                15.07,
                                9.16
                              ],
                              [
                                14.74,
                                9.03
                              ],
                              [
                                14.61,
                                8.7
                              ],
                              [
                                14.74,
                                8.38
                              ],
                              [
                                18.09,
                                5.04
                              ],
                              [
                                0.46,
                                5.04
                              ],
                              [
                                0.13,
                                4.9
                              ],
                              [
                                0,
                                4.58
                              ],
                              [
                                0.13,
                                4.26
                              ],
                              [
                                0.46,
                                4.12
                              ],
                              [
                                18.09,
                                4.12
                              ],
                              [
                                14.74,
                                0.78
                              ],
                              [
                                14.61,
                                0.46
                              ],
                              [
                                14.74,
                                0.13
                              ],
                              [
                                15.07,
                                0
                              ],
                              [
                                15.39,
                                0.13
                              ],
                              [
                                19.51,
                                4.26
                              ],
                              [
                                19.61,
                                4.41
                              ],
                              [
                                19.65,
                                4.58
                              ],
                              [
                                19.61,
                                4.75
                              ],
                              [
                                19.51,
                                4.9
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0.57,
                            0.63,
                            0.72,
                            1
                          ]
                        },
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1174",
    layers: [
      {
        ind: 1173,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                56,
                9.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                112,
                19
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.08,
                            -0.25
                          ],
                          [
                            -0.09,
                            -0.24
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0.24
                          ],
                          [
                            -0.09,
                            0.24
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.03,
                            0.38
                          ],
                          [
                            -0.02,
                            0.3
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            -0.38
                          ],
                          [
                            0,
                            -0.31
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.08,
                            0.24
                          ],
                          [
                            0.09,
                            0.24
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            -0.24
                          ],
                          [
                            0.07,
                            -0.25
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.31
                          ],
                          [
                            0.03,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            0.3
                          ],
                          [
                            0.03,
                            0.38
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.95,
                            11.24
                          ],
                          [
                            0.95,
                            4.3
                          ],
                          [
                            2.01,
                            4.3
                          ],
                          [
                            3.34,
                            8
                          ],
                          [
                            3.59,
                            8.73
                          ],
                          [
                            3.84,
                            9.45
                          ],
                          [
                            3.88,
                            9.45
                          ],
                          [
                            4.12,
                            8.73
                          ],
                          [
                            4.36,
                            8
                          ],
                          [
                            5.67,
                            4.3
                          ],
                          [
                            6.74,
                            4.3
                          ],
                          [
                            6.74,
                            11.24
                          ],
                          [
                            5.91,
                            11.24
                          ],
                          [
                            5.91,
                            7.42
                          ],
                          [
                            5.96,
                            6.39
                          ],
                          [
                            6.03,
                            5.37
                          ],
                          [
                            5.99,
                            5.37
                          ],
                          [
                            5.44,
                            6.95
                          ],
                          [
                            4.13,
                            10.54
                          ],
                          [
                            3.54,
                            10.54
                          ],
                          [
                            2.23,
                            6.95
                          ],
                          [
                            1.68,
                            5.37
                          ],
                          [
                            1.64,
                            5.37
                          ],
                          [
                            1.7,
                            6.39
                          ],
                          [
                            1.75,
                            7.42
                          ],
                          [
                            1.75,
                            11.24
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.29,
                            0.25
                          ],
                          [
                            0,
                            0.46
                          ],
                          [
                            -0.5,
                            0.3
                          ],
                          [
                            -1.09,
                            0.12
                          ],
                          [
                            0.07,
                            0.2
                          ],
                          [
                            0.16,
                            0.12
                          ],
                          [
                            0.28,
                            0
                          ],
                          [
                            0.26,
                            -0.11
                          ],
                          [
                            0.21,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.34,
                            0.14
                          ],
                          [
                            -0.41,
                            0
                          ],
                          [
                            -0.28,
                            -0.39
                          ],
                          [
                            0,
                            -0.64
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.29,
                            -0.15
                          ],
                          [
                            0.32,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.28,
                            -0.26
                          ],
                          [
                            0,
                            -0.56
                          ],
                          [
                            0.51,
                            -0.3
                          ],
                          [
                            0,
                            -0.21
                          ],
                          [
                            -0.05,
                            -0.2
                          ],
                          [
                            -0.15,
                            -0.13
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.26,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.24,
                            -0.16
                          ],
                          [
                            0.36,
                            -0.15
                          ],
                          [
                            0.63,
                            0
                          ],
                          [
                            0.28,
                            0.38
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.24,
                            0.2
                          ],
                          [
                            -0.28,
                            0.15
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.74,
                            11.37
                          ],
                          [
                            8.66,
                            10.99
                          ],
                          [
                            8.24,
                            9.91
                          ],
                          [
                            8.99,
                            8.62
                          ],
                          [
                            11.39,
                            7.98
                          ],
                          [
                            11.29,
                            7.36
                          ],
                          [
                            10.98,
                            6.88
                          ],
                          [
                            10.33,
                            6.69
                          ],
                          [
                            9.5,
                            6.86
                          ],
                          [
                            8.8,
                            7.24
                          ],
                          [
                            8.46,
                            6.64
                          ],
                          [
                            9.34,
                            6.2
                          ],
                          [
                            10.48,
                            5.97
                          ],
                          [
                            11.84,
                            6.55
                          ],
                          [
                            12.27,
                            8.09
                          ],
                          [
                            12.27,
                            11.24
                          ],
                          [
                            11.55,
                            11.24
                          ],
                          [
                            11.47,
                            10.63
                          ],
                          [
                            11.44,
                            10.63
                          ],
                          [
                            10.65,
                            11.14
                          ],
                          [
                            9.74,
                            11.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.12
                          ],
                          [
                            -0.25,
                            0.22
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.35,
                            -0.21
                          ],
                          [
                            0,
                            -0.33
                          ],
                          [
                            -0.18,
                            -0.14
                          ],
                          [
                            -0.25,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.25,
                            0
                          ],
                          [
                            0.22,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.86,
                            0.11
                          ],
                          [
                            -0.34,
                            0.21
                          ],
                          [
                            0,
                            0.29
                          ],
                          [
                            0.18,
                            0.13
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.99,
                            10.67
                          ],
                          [
                            10.69,
                            10.49
                          ],
                          [
                            11.39,
                            9.98
                          ],
                          [
                            11.39,
                            8.55
                          ],
                          [
                            9.59,
                            9.03
                          ],
                          [
                            9.08,
                            9.84
                          ],
                          [
                            9.35,
                            10.48
                          ],
                          [
                            9.99,
                            10.67
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.33,
                            0.13
                          ],
                          [
                            0.25,
                            0.2
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.24,
                            -0.12
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.17,
                            0.16
                          ],
                          [
                            0,
                            0.22
                          ],
                          [
                            0.12,
                            0.12
                          ],
                          [
                            0.18,
                            0.08
                          ],
                          [
                            0.19,
                            0.07
                          ],
                          [
                            0.23,
                            0.11
                          ],
                          [
                            0.15,
                            0.18
                          ],
                          [
                            0,
                            0.29
                          ],
                          [
                            -0.31,
                            0.28
                          ],
                          [
                            -0.56,
                            0
                          ],
                          [
                            -0.27,
                            -0.11
                          ],
                          [
                            -0.2,
                            -0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            0.08
                          ],
                          [
                            0.22,
                            0
                          ],
                          [
                            0.16,
                            -0.15
                          ],
                          [
                            0,
                            -0.2
                          ],
                          [
                            -0.11,
                            -0.11
                          ],
                          [
                            -0.17,
                            -0.07
                          ],
                          [
                            -0.19,
                            -0.08
                          ],
                          [
                            -0.24,
                            -0.12
                          ],
                          [
                            -0.15,
                            -0.2
                          ],
                          [
                            0,
                            -0.32
                          ],
                          [
                            0.15,
                            -0.23
                          ],
                          [
                            0.29,
                            -0.14
                          ],
                          [
                            0.41,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.37,
                            0
                          ],
                          [
                            -0.33,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0.18
                          ],
                          [
                            0.24,
                            0.11
                          ],
                          [
                            0.34,
                            0
                          ],
                          [
                            0.17,
                            -0.16
                          ],
                          [
                            0,
                            -0.18
                          ],
                          [
                            -0.11,
                            -0.12
                          ],
                          [
                            -0.18,
                            -0.08
                          ],
                          [
                            -0.24,
                            -0.09
                          ],
                          [
                            -0.23,
                            -0.12
                          ],
                          [
                            -0.15,
                            -0.19
                          ],
                          [
                            0,
                            -0.42
                          ],
                          [
                            0.32,
                            -0.28
                          ],
                          [
                            0.32,
                            0
                          ],
                          [
                            0.27,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            -0.14
                          ],
                          [
                            -0.19,
                            -0.09
                          ],
                          [
                            -0.33,
                            0
                          ],
                          [
                            -0.15,
                            0.15
                          ],
                          [
                            0,
                            0.16
                          ],
                          [
                            0.11,
                            0.1
                          ],
                          [
                            0.17,
                            0.07
                          ],
                          [
                            0.25,
                            0.09
                          ],
                          [
                            0.24,
                            0.11
                          ],
                          [
                            0.16,
                            0.19
                          ],
                          [
                            0,
                            0.28
                          ],
                          [
                            -0.14,
                            0.23
                          ],
                          [
                            -0.27,
                            0.14
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            15.23,
                            11.37
                          ],
                          [
                            14.18,
                            11.17
                          ],
                          [
                            13.31,
                            10.66
                          ],
                          [
                            13.75,
                            10.08
                          ],
                          [
                            14.45,
                            10.52
                          ],
                          [
                            15.26,
                            10.69
                          ],
                          [
                            16.02,
                            10.46
                          ],
                          [
                            16.28,
                            9.89
                          ],
                          [
                            16.1,
                            9.44
                          ],
                          [
                            15.65,
                            9.14
                          ],
                          [
                            15.1,
                            8.91
                          ],
                          [
                            14.39,
                            8.61
                          ],
                          [
                            13.82,
                            8.15
                          ],
                          [
                            13.6,
                            7.43
                          ],
                          [
                            14.07,
                            6.39
                          ],
                          [
                            15.38,
                            5.97
                          ],
                          [
                            16.27,
                            6.14
                          ],
                          [
                            16.97,
                            6.55
                          ],
                          [
                            16.55,
                            7.11
                          ],
                          [
                            16,
                            6.78
                          ],
                          [
                            15.38,
                            6.65
                          ],
                          [
                            14.66,
                            6.87
                          ],
                          [
                            14.43,
                            7.39
                          ],
                          [
                            14.59,
                            7.79
                          ],
                          [
                            15.01,
                            8.05
                          ],
                          [
                            15.55,
                            8.28
                          ],
                          [
                            16.28,
                            8.6
                          ],
                          [
                            16.87,
                            9.06
                          ],
                          [
                            17.11,
                            9.83
                          ],
                          [
                            16.89,
                            10.59
                          ],
                          [
                            16.25,
                            11.16
                          ],
                          [
                            15.23,
                            11.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.22,
                            0.32
                          ],
                          [
                            0,
                            0.51
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.11,
                            -0.18
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.11,
                            0.03
                          ],
                          [
                            -0.08,
                            0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.17,
                            -0.04
                          ],
                          [
                            0.16,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.55,
                            0
                          ],
                          [
                            -0.21,
                            -0.32
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            0.12,
                            0.17
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.11,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            0.05
                          ],
                          [
                            -0.16,
                            0.04
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            19.73,
                            11.37
                          ],
                          [
                            18.58,
                            10.89
                          ],
                          [
                            18.26,
                            9.65
                          ],
                          [
                            18.26,
                            6.81
                          ],
                          [
                            17.5,
                            6.81
                          ],
                          [
                            17.5,
                            6.15
                          ],
                          [
                            18.3,
                            6.1
                          ],
                          [
                            18.41,
                            4.66
                          ],
                          [
                            19.14,
                            4.66
                          ],
                          [
                            19.14,
                            6.1
                          ],
                          [
                            20.52,
                            6.1
                          ],
                          [
                            20.52,
                            6.81
                          ],
                          [
                            19.14,
                            6.81
                          ],
                          [
                            19.14,
                            9.66
                          ],
                          [
                            19.3,
                            10.41
                          ],
                          [
                            19.93,
                            10.66
                          ],
                          [
                            20.23,
                            10.62
                          ],
                          [
                            20.51,
                            10.52
                          ],
                          [
                            20.68,
                            11.18
                          ],
                          [
                            20.21,
                            11.3
                          ],
                          [
                            19.73,
                            11.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.38,
                            0.21
                          ],
                          [
                            0.22,
                            0.4
                          ],
                          [
                            0,
                            0.56
                          ],
                          [
                            -0.22,
                            0.4
                          ],
                          [
                            -0.35,
                            0.22
                          ],
                          [
                            -0.39,
                            0
                          ],
                          [
                            -0.36,
                            -0.44
                          ],
                          [
                            0,
                            -0.73
                          ],
                          [
                            0.01,
                            -0.09
                          ],
                          [
                            0.01,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.3,
                            -0.32
                          ],
                          [
                            -0.49,
                            0
                          ],
                          [
                            -0.2,
                            0.07
                          ],
                          [
                            -0.19,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.28,
                            -0.11
                          ],
                          [
                            0.35,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.46,
                            0
                          ],
                          [
                            -0.37,
                            -0.22
                          ],
                          [
                            -0.22,
                            -0.4
                          ],
                          [
                            0,
                            -0.56
                          ],
                          [
                            0.23,
                            -0.4
                          ],
                          [
                            0.35,
                            -0.22
                          ],
                          [
                            0.66,
                            0
                          ],
                          [
                            0.36,
                            0.44
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            0,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            0.54
                          ],
                          [
                            0.31,
                            0.32
                          ],
                          [
                            0.25,
                            0
                          ],
                          [
                            0.21,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.14
                          ],
                          [
                            -0.27,
                            0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            23.63,
                            11.37
                          ],
                          [
                            22.38,
                            11.05
                          ],
                          [
                            21.49,
                            10.12
                          ],
                          [
                            21.16,
                            8.68
                          ],
                          [
                            21.49,
                            7.23
                          ],
                          [
                            22.36,
                            6.3
                          ],
                          [
                            23.46,
                            5.97
                          ],
                          [
                            24.98,
                            6.63
                          ],
                          [
                            25.52,
                            8.38
                          ],
                          [
                            25.51,
                            8.66
                          ],
                          [
                            25.49,
                            8.88
                          ],
                          [
                            22.02,
                            8.88
                          ],
                          [
                            22.52,
                            10.18
                          ],
                          [
                            23.73,
                            10.67
                          ],
                          [
                            24.41,
                            10.56
                          ],
                          [
                            25.01,
                            10.27
                          ],
                          [
                            25.32,
                            10.84
                          ],
                          [
                            24.57,
                            11.21
                          ],
                          [
                            23.63,
                            11.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0.27
                          ],
                          [
                            0.4,
                            0
                          ],
                          [
                            0.29,
                            -0.28
                          ],
                          [
                            0.05,
                            -0.51
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.52
                          ],
                          [
                            -0.22,
                            -0.28
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.29,
                            0.28
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            22.01,
                            8.26
                          ],
                          [
                            24.76,
                            8.26
                          ],
                          [
                            24.42,
                            7.07
                          ],
                          [
                            23.49,
                            6.66
                          ],
                          [
                            22.52,
                            7.08
                          ],
                          [
                            22.01,
                            8.26
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.25,
                            0.19
                          ],
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.16,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.01
                          ],
                          [
                            0.11,
                            0
                          ],
                          [
                            0.24,
                            -0.18
                          ],
                          [
                            0.18,
                            -0.44
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            -0.32
                          ],
                          [
                            0.25,
                            -0.19
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.03
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.22,
                            0
                          ],
                          [
                            -0.23,
                            0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            26.79,
                            11.24
                          ],
                          [
                            26.79,
                            6.1
                          ],
                          [
                            27.51,
                            6.1
                          ],
                          [
                            27.58,
                            7.03
                          ],
                          [
                            27.61,
                            7.03
                          ],
                          [
                            28.26,
                            6.26
                          ],
                          [
                            29.07,
                            5.97
                          ],
                          [
                            29.63,
                            6.08
                          ],
                          [
                            29.46,
                            6.84
                          ],
                          [
                            29.22,
                            6.78
                          ],
                          [
                            28.96,
                            6.75
                          ],
                          [
                            28.27,
                            7.02
                          ],
                          [
                            27.66,
                            7.94
                          ],
                          [
                            27.66,
                            11.24
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.37,
                            0.21
                          ],
                          [
                            0.21,
                            0.4
                          ],
                          [
                            0,
                            0.57
                          ],
                          [
                            -0.23,
                            0.4
                          ],
                          [
                            -0.37,
                            0.21
                          ],
                          [
                            -0.44,
                            0
                          ],
                          [
                            -0.24,
                            -0.12
                          ],
                          [
                            -0.18,
                            -0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.17,
                            0.08
                          ],
                          [
                            0.2,
                            0
                          ],
                          [
                            0.25,
                            -0.17
                          ],
                          [
                            0.14,
                            -0.3
                          ],
                          [
                            0,
                            -0.39
                          ],
                          [
                            -0.29,
                            -0.37
                          ],
                          [
                            -0.47,
                            0
                          ],
                          [
                            -0.2,
                            0.1
                          ],
                          [
                            -0.15,
                            0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.28,
                            -0.12
                          ],
                          [
                            0.31,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.45,
                            0
                          ],
                          [
                            -0.36,
                            -0.21
                          ],
                          [
                            -0.21,
                            -0.4
                          ],
                          [
                            0,
                            -0.58
                          ],
                          [
                            0.23,
                            -0.4
                          ],
                          [
                            0.38,
                            -0.21
                          ],
                          [
                            0.34,
                            0
                          ],
                          [
                            0.25,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            -0.14
                          ],
                          [
                            -0.16,
                            -0.09
                          ],
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.24,
                            0.16
                          ],
                          [
                            -0.14,
                            0.3
                          ],
                          [
                            0,
                            0.59
                          ],
                          [
                            0.3,
                            0.36
                          ],
                          [
                            0.24,
                            0
                          ],
                          [
                            0.21,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.23,
                            0.21
                          ],
                          [
                            -0.28,
                            0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            32.39,
                            11.37
                          ],
                          [
                            31.16,
                            11.05
                          ],
                          [
                            30.29,
                            10.13
                          ],
                          [
                            29.97,
                            8.68
                          ],
                          [
                            30.31,
                            7.21
                          ],
                          [
                            31.22,
                            6.29
                          ],
                          [
                            32.45,
                            5.97
                          ],
                          [
                            33.32,
                            6.15
                          ],
                          [
                            33.95,
                            6.57
                          ],
                          [
                            33.51,
                            7.15
                          ],
                          [
                            33.03,
                            6.82
                          ],
                          [
                            32.48,
                            6.69
                          ],
                          [
                            31.64,
                            6.95
                          ],
                          [
                            31.07,
                            7.64
                          ],
                          [
                            30.87,
                            8.68
                          ],
                          [
                            31.3,
                            10.11
                          ],
                          [
                            32.46,
                            10.65
                          ],
                          [
                            33.13,
                            10.5
                          ],
                          [
                            33.66,
                            10.13
                          ],
                          [
                            34.05,
                            10.71
                          ],
                          [
                            33.27,
                            11.2
                          ],
                          [
                            32.39,
                            11.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.29,
                            0.25
                          ],
                          [
                            0,
                            0.46
                          ],
                          [
                            -0.5,
                            0.3
                          ],
                          [
                            -1.09,
                            0.12
                          ],
                          [
                            0.06,
                            0.2
                          ],
                          [
                            0.15,
                            0.12
                          ],
                          [
                            0.29,
                            0
                          ],
                          [
                            0.26,
                            -0.11
                          ],
                          [
                            0.2,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.35,
                            0.14
                          ],
                          [
                            -0.41,
                            0
                          ],
                          [
                            -0.29,
                            -0.39
                          ],
                          [
                            0,
                            -0.64
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.29,
                            -0.15
                          ],
                          [
                            0.32,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.28,
                            -0.26
                          ],
                          [
                            0,
                            -0.56
                          ],
                          [
                            0.51,
                            -0.3
                          ],
                          [
                            0,
                            -0.21
                          ],
                          [
                            -0.06,
                            -0.2
                          ],
                          [
                            -0.15,
                            -0.13
                          ],
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.26,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.24,
                            -0.16
                          ],
                          [
                            0.35,
                            -0.15
                          ],
                          [
                            0.63,
                            0
                          ],
                          [
                            0.28,
                            0.38
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.24,
                            0.2
                          ],
                          [
                            -0.29,
                            0.15
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            36.26,
                            11.37
                          ],
                          [
                            35.18,
                            10.99
                          ],
                          [
                            34.76,
                            9.91
                          ],
                          [
                            35.51,
                            8.62
                          ],
                          [
                            37.91,
                            7.98
                          ],
                          [
                            37.82,
                            7.36
                          ],
                          [
                            37.5,
                            6.88
                          ],
                          [
                            36.85,
                            6.69
                          ],
                          [
                            36.02,
                            6.86
                          ],
                          [
                            35.32,
                            7.24
                          ],
                          [
                            34.98,
                            6.64
                          ],
                          [
                            35.86,
                            6.2
                          ],
                          [
                            37,
                            5.97
                          ],
                          [
                            38.37,
                            6.55
                          ],
                          [
                            38.79,
                            8.09
                          ],
                          [
                            38.79,
                            11.24
                          ],
                          [
                            38.07,
                            11.24
                          ],
                          [
                            38,
                            10.63
                          ],
                          [
                            37.96,
                            10.63
                          ],
                          [
                            37.17,
                            11.14
                          ],
                          [
                            36.26,
                            11.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.12
                          ],
                          [
                            -0.25,
                            0.22
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.34,
                            -0.21
                          ],
                          [
                            0,
                            -0.33
                          ],
                          [
                            -0.18,
                            -0.14
                          ],
                          [
                            -0.25,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.25,
                            0
                          ],
                          [
                            0.22,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.85,
                            0.11
                          ],
                          [
                            -0.34,
                            0.21
                          ],
                          [
                            0,
                            0.29
                          ],
                          [
                            0.18,
                            0.13
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            36.52,
                            10.67
                          ],
                          [
                            37.21,
                            10.49
                          ],
                          [
                            37.91,
                            9.98
                          ],
                          [
                            37.91,
                            8.55
                          ],
                          [
                            36.11,
                            9.03
                          ],
                          [
                            35.61,
                            9.84
                          ],
                          [
                            35.87,
                            10.48
                          ],
                          [
                            36.52,
                            10.67
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.25,
                            0.19
                          ],
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.16,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.01
                          ],
                          [
                            0.11,
                            0
                          ],
                          [
                            0.24,
                            -0.18
                          ],
                          [
                            0.18,
                            -0.44
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            -0.32
                          ],
                          [
                            0.25,
                            -0.19
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.03
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.22,
                            0
                          ],
                          [
                            -0.23,
                            0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            40.41,
                            11.24
                          ],
                          [
                            40.41,
                            6.1
                          ],
                          [
                            41.13,
                            6.1
                          ],
                          [
                            41.2,
                            7.03
                          ],
                          [
                            41.23,
                            7.03
                          ],
                          [
                            41.88,
                            6.26
                          ],
                          [
                            42.69,
                            5.97
                          ],
                          [
                            43.24,
                            6.08
                          ],
                          [
                            43.07,
                            6.84
                          ],
                          [
                            42.84,
                            6.78
                          ],
                          [
                            42.57,
                            6.75
                          ],
                          [
                            41.89,
                            7.02
                          ],
                          [
                            41.27,
                            7.94
                          ],
                          [
                            41.27,
                            11.24
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.39,
                            0.47
                          ],
                          [
                            0,
                            0.86
                          ],
                          [
                            -0.2,
                            0.4
                          ],
                          [
                            -0.34,
                            0.22
                          ],
                          [
                            -0.39,
                            0
                          ],
                          [
                            -0.22,
                            -0.11
                          ],
                          [
                            -0.23,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.27,
                            -0.15
                          ],
                          [
                            0.3,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.64,
                            0
                          ],
                          [
                            -0.39,
                            -0.47
                          ],
                          [
                            0,
                            -0.55
                          ],
                          [
                            0.21,
                            -0.41
                          ],
                          [
                            0.34,
                            -0.22
                          ],
                          [
                            0.3,
                            0
                          ],
                          [
                            0.22,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.2
                          ],
                          [
                            -0.27,
                            0.14
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            45.73,
                            11.37
                          ],
                          [
                            44.18,
                            10.67
                          ],
                          [
                            43.6,
                            8.68
                          ],
                          [
                            43.91,
                            7.24
                          ],
                          [
                            44.73,
                            6.3
                          ],
                          [
                            45.83,
                            5.97
                          ],
                          [
                            46.61,
                            6.13
                          ],
                          [
                            47.27,
                            6.57
                          ],
                          [
                            47.23,
                            5.69
                          ],
                          [
                            47.23,
                            3.71
                          ],
                          [
                            48.11,
                            3.71
                          ],
                          [
                            48.11,
                            11.24
                          ],
                          [
                            47.39,
                            11.24
                          ],
                          [
                            47.31,
                            10.64
                          ],
                          [
                            47.28,
                            10.64
                          ],
                          [
                            46.59,
                            11.16
                          ],
                          [
                            45.73,
                            11.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.43,
                            0.47
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            0.08
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0.23,
                            -0.17
                          ],
                          [
                            0.13,
                            -0.3
                          ],
                          [
                            0,
                            -0.4
                          ],
                          [
                            -0.25,
                            -0.36
                          ],
                          [
                            -0.45,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.45,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            -0.2
                          ],
                          [
                            -0.2,
                            -0.08
                          ],
                          [
                            -0.27,
                            0
                          ],
                          [
                            -0.22,
                            0.16
                          ],
                          [
                            -0.14,
                            0.29
                          ],
                          [
                            0,
                            0.61
                          ],
                          [
                            0.25,
                            0.34
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            45.92,
                            10.64
                          ],
                          [
                            47.23,
                            9.93
                          ],
                          [
                            47.23,
                            7.24
                          ],
                          [
                            46.59,
                            6.83
                          ],
                          [
                            45.98,
                            6.7
                          ],
                          [
                            45.23,
                            6.96
                          ],
                          [
                            44.7,
                            7.64
                          ],
                          [
                            44.5,
                            8.67
                          ],
                          [
                            44.87,
                            10.12
                          ],
                          [
                            45.92,
                            10.64
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.17,
                        0.28,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1179",
    layers: [
      {
        ind: 1178,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                40.5,
                7.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                81,
                15
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.34,
                            -0.11
                          ],
                          [
                            -0.19,
                            -0.27
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            0.41,
                            -0.31
                          ],
                          [
                            0.67,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.46,
                            0
                          ],
                          [
                            0.34,
                            0.11
                          ],
                          [
                            0.19,
                            0.26
                          ],
                          [
                            0,
                            0.63
                          ],
                          [
                            -0.41,
                            0.31
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.83,
                            9
                          ],
                          [
                            0.83,
                            2.93
                          ],
                          [
                            2.56,
                            2.93
                          ],
                          [
                            3.76,
                            3.09
                          ],
                          [
                            4.55,
                            3.66
                          ],
                          [
                            4.84,
                            4.71
                          ],
                          [
                            4.22,
                            6.13
                          ],
                          [
                            2.6,
                            6.59
                          ],
                          [
                            1.6,
                            6.59
                          ],
                          [
                            1.6,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.25,
                            0.2
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            0.27,
                            0.16
                          ],
                          [
                            0.53,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0.53,
                            0
                          ],
                          [
                            0.26,
                            -0.2
                          ],
                          [
                            0,
                            -0.44
                          ],
                          [
                            -0.26,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.6,
                            5.96
                          ],
                          [
                            2.51,
                            5.96
                          ],
                          [
                            3.68,
                            5.67
                          ],
                          [
                            4.07,
                            4.71
                          ],
                          [
                            3.66,
                            3.81
                          ],
                          [
                            2.47,
                            3.55
                          ],
                          [
                            1.6,
                            3.55
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.16
                          ],
                          [
                            -0.25,
                            0
                          ],
                          [
                            -0.14,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0.01
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.15,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.29
                          ],
                          [
                            0.22,
                            -0.17
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.06,
                            -0.01
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            6,
                            9
                          ],
                          [
                            6,
                            4.5
                          ],
                          [
                            6.63,
                            4.5
                          ],
                          [
                            6.7,
                            5.32
                          ],
                          [
                            6.72,
                            5.32
                          ],
                          [
                            7.29,
                            4.64
                          ],
                          [
                            8,
                            4.39
                          ],
                          [
                            8.48,
                            4.48
                          ],
                          [
                            8.34,
                            5.15
                          ],
                          [
                            8.13,
                            5.09
                          ],
                          [
                            7.9,
                            5.07
                          ],
                          [
                            7.3,
                            5.3
                          ],
                          [
                            6.76,
                            6.11
                          ],
                          [
                            6.76,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.33,
                            0.19
                          ],
                          [
                            0.19,
                            0.35
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.19,
                            0.35
                          ],
                          [
                            -0.31,
                            0.19
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.31,
                            -0.38
                          ],
                          [
                            0,
                            -0.64
                          ],
                          [
                            0,
                            -0.08
                          ],
                          [
                            0.01,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.26,
                            -0.29
                          ],
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.18,
                            0.06
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.09
                          ],
                          [
                            0.31,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.4,
                            0
                          ],
                          [
                            -0.32,
                            -0.19
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.31,
                            -0.19
                          ],
                          [
                            0.57,
                            0
                          ],
                          [
                            0.32,
                            0.38
                          ],
                          [
                            0,
                            0.08
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.47
                          ],
                          [
                            0.27,
                            0.29
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.13
                          ],
                          [
                            -0.24,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            10.95,
                            9.11
                          ],
                          [
                            9.85,
                            8.83
                          ],
                          [
                            9.07,
                            8.02
                          ],
                          [
                            8.79,
                            6.76
                          ],
                          [
                            9.07,
                            5.49
                          ],
                          [
                            9.84,
                            4.68
                          ],
                          [
                            10.8,
                            4.39
                          ],
                          [
                            12.13,
                            4.96
                          ],
                          [
                            12.6,
                            6.5
                          ],
                          [
                            12.59,
                            6.74
                          ],
                          [
                            12.57,
                            6.94
                          ],
                          [
                            9.54,
                            6.94
                          ],
                          [
                            9.98,
                            8.07
                          ],
                          [
                            11.04,
                            8.5
                          ],
                          [
                            11.63,
                            8.41
                          ],
                          [
                            12.16,
                            8.15
                          ],
                          [
                            12.43,
                            8.65
                          ],
                          [
                            11.77,
                            8.97
                          ],
                          [
                            10.95,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.23
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.25,
                            -0.25
                          ],
                          [
                            0.05,
                            -0.45
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.46
                          ],
                          [
                            -0.19,
                            -0.24
                          ],
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            0.24
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.53,
                            6.39
                          ],
                          [
                            11.93,
                            6.39
                          ],
                          [
                            11.64,
                            5.35
                          ],
                          [
                            10.82,
                            4.99
                          ],
                          [
                            9.97,
                            5.36
                          ],
                          [
                            9.53,
                            6.39
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.36,
                            0.16
                          ],
                          [
                            0.27,
                            0.27
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.29,
                            -0.14
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.22,
                            0.18
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            0.09,
                            0.12
                          ],
                          [
                            0.16,
                            0.09
                          ],
                          [
                            0.19,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            0.13
                          ],
                          [
                            0.13,
                            0.2
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            -0.16,
                            0.24
                          ],
                          [
                            -0.29,
                            0.14
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.31,
                            -0.14
                          ],
                          [
                            -0.21,
                            -0.22
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0.1
                          ],
                          [
                            0.29,
                            0
                          ],
                          [
                            0.21,
                            -0.16
                          ],
                          [
                            0,
                            -0.27
                          ],
                          [
                            -0.1,
                            -0.13
                          ],
                          [
                            -0.16,
                            -0.08
                          ],
                          [
                            -0.16,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            -0.14
                          ],
                          [
                            -0.11,
                            -0.2
                          ],
                          [
                            0,
                            -0.3
                          ],
                          [
                            0.17,
                            -0.27
                          ],
                          [
                            0.31,
                            -0.15
                          ],
                          [
                            0.43,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.36,
                            -0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            0.23
                          ],
                          [
                            0.3,
                            0.14
                          ],
                          [
                            0.4,
                            0
                          ],
                          [
                            0.22,
                            -0.19
                          ],
                          [
                            0,
                            -0.21
                          ],
                          [
                            -0.09,
                            -0.12
                          ],
                          [
                            -0.14,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            -0.08
                          ],
                          [
                            -0.18,
                            -0.13
                          ],
                          [
                            -0.12,
                            -0.2
                          ],
                          [
                            0,
                            -0.31
                          ],
                          [
                            0.16,
                            -0.25
                          ],
                          [
                            0.29,
                            -0.14
                          ],
                          [
                            0.37,
                            0
                          ],
                          [
                            0.31,
                            0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            -0.18
                          ],
                          [
                            -0.22,
                            -0.11
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0.19
                          ],
                          [
                            0.11,
                            0.12
                          ],
                          [
                            0.15,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0.1
                          ],
                          [
                            0.19,
                            0.14
                          ],
                          [
                            0.11,
                            0.2
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            -0.17,
                            0.26
                          ],
                          [
                            -0.31,
                            0.16
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.32,
                            9.11
                          ],
                          [
                            16.14,
                            8.87
                          ],
                          [
                            15.2,
                            8.21
                          ],
                          [
                            15.66,
                            7.68
                          ],
                          [
                            16.42,
                            8.23
                          ],
                          [
                            17.34,
                            8.43
                          ],
                          [
                            18.27,
                            8.17
                          ],
                          [
                            18.6,
                            7.45
                          ],
                          [
                            18.46,
                            6.95
                          ],
                          [
                            18.1,
                            6.63
                          ],
                          [
                            17.59,
                            6.37
                          ],
                          [
                            16.72,
                            5.99
                          ],
                          [
                            16.15,
                            5.68
                          ],
                          [
                            15.68,
                            5.18
                          ],
                          [
                            15.49,
                            4.43
                          ],
                          [
                            15.73,
                            3.6
                          ],
                          [
                            16.42,
                            3.03
                          ],
                          [
                            17.4,
                            2.82
                          ],
                          [
                            18.41,
                            3.03
                          ],
                          [
                            19.2,
                            3.57
                          ],
                          [
                            18.78,
                            4.07
                          ],
                          [
                            18.16,
                            3.65
                          ],
                          [
                            17.4,
                            3.49
                          ],
                          [
                            16.57,
                            3.73
                          ],
                          [
                            16.27,
                            4.38
                          ],
                          [
                            16.42,
                            4.86
                          ],
                          [
                            16.81,
                            5.17
                          ],
                          [
                            17.28,
                            5.39
                          ],
                          [
                            18.14,
                            5.76
                          ],
                          [
                            18.77,
                            6.12
                          ],
                          [
                            19.22,
                            6.63
                          ],
                          [
                            19.39,
                            7.38
                          ],
                          [
                            19.14,
                            8.26
                          ],
                          [
                            18.43,
                            8.88
                          ],
                          [
                            17.32,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.32,
                            0.19
                          ],
                          [
                            0.18,
                            0.35
                          ],
                          [
                            0,
                            0.5
                          ],
                          [
                            -0.2,
                            0.35
                          ],
                          [
                            -0.32,
                            0.18
                          ],
                          [
                            -0.38,
                            0
                          ],
                          [
                            -0.21,
                            -0.11
                          ],
                          [
                            -0.16,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.07
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.13,
                            -0.27
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            -0.25,
                            -0.32
                          ],
                          [
                            -0.41,
                            0
                          ],
                          [
                            -0.18,
                            0.09
                          ],
                          [
                            -0.14,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.11
                          ],
                          [
                            0.27,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.39,
                            0
                          ],
                          [
                            -0.32,
                            -0.18
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.5
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.34,
                            -0.18
                          ],
                          [
                            0.3,
                            0
                          ],
                          [
                            0.21,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            -0.12
                          ],
                          [
                            -0.14,
                            -0.07
                          ],
                          [
                            -0.27,
                            0
                          ],
                          [
                            -0.21,
                            0.14
                          ],
                          [
                            -0.12,
                            0.26
                          ],
                          [
                            0,
                            0.52
                          ],
                          [
                            0.26,
                            0.32
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0.18,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.18
                          ],
                          [
                            -0.25,
                            0.1
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            22.29,
                            9.11
                          ],
                          [
                            21.21,
                            8.83
                          ],
                          [
                            20.46,
                            8.03
                          ],
                          [
                            20.18,
                            6.76
                          ],
                          [
                            20.48,
                            5.47
                          ],
                          [
                            21.27,
                            4.67
                          ],
                          [
                            22.34,
                            4.39
                          ],
                          [
                            23.11,
                            4.55
                          ],
                          [
                            23.66,
                            4.92
                          ],
                          [
                            23.27,
                            5.42
                          ],
                          [
                            22.86,
                            5.13
                          ],
                          [
                            22.37,
                            5.02
                          ],
                          [
                            21.64,
                            5.24
                          ],
                          [
                            21.14,
                            5.85
                          ],
                          [
                            20.96,
                            6.76
                          ],
                          [
                            21.34,
                            8.01
                          ],
                          [
                            22.36,
                            8.48
                          ],
                          [
                            22.94,
                            8.35
                          ],
                          [
                            23.41,
                            8.03
                          ],
                          [
                            23.74,
                            8.54
                          ],
                          [
                            23.07,
                            8.96
                          ],
                          [
                            22.29,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.22
                          ],
                          [
                            0,
                            0.4
                          ],
                          [
                            -0.44,
                            0.26
                          ],
                          [
                            -0.96,
                            0.11
                          ],
                          [
                            0.05,
                            0.18
                          ],
                          [
                            0.14,
                            0.1
                          ],
                          [
                            0.25,
                            0
                          ],
                          [
                            0.23,
                            -0.1
                          ],
                          [
                            0.18,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.3,
                            0.12
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.25,
                            -0.34
                          ],
                          [
                            0,
                            -0.56
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.13
                          ],
                          [
                            0.29,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.37,
                            0
                          ],
                          [
                            -0.25,
                            -0.23
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.45,
                            -0.27
                          ],
                          [
                            0,
                            -0.19
                          ],
                          [
                            -0.05,
                            -0.17
                          ],
                          [
                            -0.13,
                            -0.11
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.23,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            -0.14
                          ],
                          [
                            0.31,
                            -0.13
                          ],
                          [
                            0.55,
                            0
                          ],
                          [
                            0.25,
                            0.33
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            0.17
                          ],
                          [
                            -0.25,
                            0.13
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.68,
                            9.11
                          ],
                          [
                            24.73,
                            8.78
                          ],
                          [
                            24.37,
                            7.83
                          ],
                          [
                            25.02,
                            6.7
                          ],
                          [
                            27.13,
                            6.15
                          ],
                          [
                            27.04,
                            5.6
                          ],
                          [
                            26.76,
                            5.19
                          ],
                          [
                            26.2,
                            5.02
                          ],
                          [
                            25.47,
                            5.17
                          ],
                          [
                            24.86,
                            5.5
                          ],
                          [
                            24.56,
                            4.97
                          ],
                          [
                            25.33,
                            4.59
                          ],
                          [
                            26.33,
                            4.39
                          ],
                          [
                            27.52,
                            4.9
                          ],
                          [
                            27.89,
                            6.24
                          ],
                          [
                            27.89,
                            9
                          ],
                          [
                            27.26,
                            9
                          ],
                          [
                            27.2,
                            8.46
                          ],
                          [
                            27.17,
                            8.46
                          ],
                          [
                            26.48,
                            8.92
                          ],
                          [
                            25.68,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.11
                          ],
                          [
                            -0.21,
                            0.19
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.3,
                            -0.19
                          ],
                          [
                            0,
                            -0.29
                          ],
                          [
                            -0.15,
                            -0.12
                          ],
                          [
                            -0.22,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.21,
                            0
                          ],
                          [
                            0.19,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.75,
                            0.09
                          ],
                          [
                            -0.3,
                            0.18
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.9,
                            8.5
                          ],
                          [
                            26.51,
                            8.34
                          ],
                          [
                            27.13,
                            7.9
                          ],
                          [
                            27.13,
                            6.65
                          ],
                          [
                            25.55,
                            7.07
                          ],
                          [
                            25.11,
                            7.78
                          ],
                          [
                            25.34,
                            8.33
                          ],
                          [
                            25.9,
                            8.5
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0.17
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.05
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            -0.01
                          ],
                          [
                            0.11,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.12,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.12
                          ],
                          [
                            0.04,
                            0.05
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0.03,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.03
                          ],
                          [
                            -0.07,
                            0.01
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            30.11,
                            9.11
                          ],
                          [
                            29.49,
                            8.85
                          ],
                          [
                            29.31,
                            8.09
                          ],
                          [
                            29.31,
                            2.41
                          ],
                          [
                            30.07,
                            2.41
                          ],
                          [
                            30.07,
                            8.15
                          ],
                          [
                            30.13,
                            8.41
                          ],
                          [
                            30.28,
                            8.48
                          ],
                          [
                            30.34,
                            8.48
                          ],
                          [
                            30.45,
                            8.46
                          ],
                          [
                            30.55,
                            9.04
                          ],
                          [
                            30.37,
                            9.09
                          ],
                          [
                            30.11,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.33,
                            0.19
                          ],
                          [
                            0.19,
                            0.35
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.19,
                            0.35
                          ],
                          [
                            -0.31,
                            0.19
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.31,
                            -0.38
                          ],
                          [
                            0,
                            -0.64
                          ],
                          [
                            0,
                            -0.08
                          ],
                          [
                            0.01,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.27,
                            -0.29
                          ],
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.18,
                            0.06
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.09
                          ],
                          [
                            0.31,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.4,
                            0
                          ],
                          [
                            -0.33,
                            -0.19
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.31,
                            -0.19
                          ],
                          [
                            0.57,
                            0
                          ],
                          [
                            0.32,
                            0.38
                          ],
                          [
                            0,
                            0.08
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.47
                          ],
                          [
                            0.27,
                            0.29
                          ],
                          [
                            0.22,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.13
                          ],
                          [
                            -0.24,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            33.49,
                            9.11
                          ],
                          [
                            32.4,
                            8.83
                          ],
                          [
                            31.62,
                            8.02
                          ],
                          [
                            31.34,
                            6.76
                          ],
                          [
                            31.62,
                            5.49
                          ],
                          [
                            32.38,
                            4.68
                          ],
                          [
                            33.35,
                            4.39
                          ],
                          [
                            34.68,
                            4.96
                          ],
                          [
                            35.15,
                            6.5
                          ],
                          [
                            35.14,
                            6.74
                          ],
                          [
                            35.12,
                            6.94
                          ],
                          [
                            32.09,
                            6.94
                          ],
                          [
                            32.53,
                            8.07
                          ],
                          [
                            33.58,
                            8.5
                          ],
                          [
                            34.18,
                            8.41
                          ],
                          [
                            34.7,
                            8.15
                          ],
                          [
                            34.97,
                            8.65
                          ],
                          [
                            34.32,
                            8.97
                          ],
                          [
                            33.49,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.23
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.25,
                            -0.25
                          ],
                          [
                            0.05,
                            -0.45
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.46
                          ],
                          [
                            -0.19,
                            -0.24
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.25,
                            0.24
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            32.07,
                            6.39
                          ],
                          [
                            34.48,
                            6.39
                          ],
                          [
                            34.19,
                            5.35
                          ],
                          [
                            33.37,
                            4.99
                          ],
                          [
                            32.52,
                            5.36
                          ],
                          [
                            32.07,
                            6.39
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.16
                          ],
                          [
                            -0.25,
                            0
                          ],
                          [
                            -0.14,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0.01
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.15,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.29
                          ],
                          [
                            0.22,
                            -0.17
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.06,
                            -0.01
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            36.26,
                            9
                          ],
                          [
                            36.26,
                            4.5
                          ],
                          [
                            36.89,
                            4.5
                          ],
                          [
                            36.95,
                            5.32
                          ],
                          [
                            36.98,
                            5.32
                          ],
                          [
                            37.55,
                            4.64
                          ],
                          [
                            38.26,
                            4.39
                          ],
                          [
                            38.74,
                            4.48
                          ],
                          [
                            38.59,
                            5.15
                          ],
                          [
                            38.39,
                            5.09
                          ],
                          [
                            38.16,
                            5.07
                          ],
                          [
                            37.55,
                            5.3
                          ],
                          [
                            37.02,
                            6.11
                          ],
                          [
                            37.02,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.49,
                        0.55,
                        0.65,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1203",
    layers: [
      {
        ind: 1202,
        ty: 2,
        parent: 1201,
        ks: {
          s: {
            a: 0,
            k: [
              157.14,
              162.5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "0"
      },
      {
        ind: 1201,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1206",
    layers: [
      {
        ind: 1205,
        ty: 0,
        parent: 1200,
        ks: {},
        w: 11,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1203"
      },
      {
        ind: 1200,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1226",
    layers: [
      {
        ind: 1225,
        ty: 2,
        parent: 1224,
        ks: {
          s: {
            a: 0,
            k: [
              162.5,
              160
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "1"
      },
      {
        ind: 1224,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1229",
    layers: [
      {
        ind: 1228,
        ty: 0,
        parent: 1223,
        ks: {},
        w: 13,
        h: 12,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1226"
      },
      {
        ind: 1223,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1260",
    layers: [
      {
        ind: 1259,
        ty: 2,
        parent: 1258,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        refId: "4"
      },
      {
        ind: 1258,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1263",
    layers: [
      {
        ind: 1262,
        ty: 0,
        parent: 1257,
        ks: {},
        w: 19,
        h: 21.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1260"
      },
      {
        ind: 1257,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1274",
    layers: [
      {
        ind: 1273,
        ty: 2,
        parent: 1272,
        ks: {
          s: {
            a: 0,
            k: [
              165.22,
              165.22
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "8"
      },
      {
        ind: 1272,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1277",
    layers: [
      {
        ind: 1276,
        ty: 0,
        parent: 1271,
        ks: {},
        w: 76,
        h: 76,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1274"
      },
      {
        ind: 1271,
        ty: 3,
        parent: 1270,
        ks: {
          p: {
            a: 0,
            k: [
              -7,
              -4
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1270,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              7,
              5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1281",
    layers: [
      {
        ind: 1280,
        ty: 4,
        td: 1,
        parent: 1269,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                31.739,
                31.739
              ]
            },
            r: {
              a: 0,
              k: 31
            },
            s: {
              a: 0,
              k: [
                63.478,
                63.478
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1279,
        ty: 0,
        tt: 1,
        parent: 1269,
        ks: {
          a: {
            a: 0,
            k: [
              7,
              5
            ]
          }
        },
        w: 83,
        h: 81,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1277"
      },
      {
        ind: 1269,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              7.053,
              7.053
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1286",
    layers: [
      {
        ind: 1059,
        ty: 4,
        parent: 1058,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1058,
        ty: 3,
        parent: 1057,
        ks: {
          p: {
            a: 0,
            k: [
              28.394,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1061,
        ty: 4,
        parent: 1060,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1060,
        ty: 3,
        parent: 1057,
        ks: {
          p: {
            a: 0,
            k: [
              22.138,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1063,
        ty: 4,
        parent: 1062,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ],
                  [
                    1.2,
                    11.3
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    10.1
                  ],
                  [
                    2.4,
                    10.5
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.7,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    3,
                    11.6
                  ],
                  [
                    2.7,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1062,
        ty: 3,
        parent: 1057,
        ks: {
          p: {
            a: 0,
            k: [
              18.794,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1065,
        ty: 4,
        parent: 1064,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1064,
        ty: 3,
        parent: 1057,
        ks: {
          p: {
            a: 0,
            k: [
              12.426,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1067,
        ty: 4,
        parent: 1066,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.9,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.8
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    4.6,
                    5.6
                  ],
                  [
                    5.3,
                    6.1
                  ],
                  [
                    5.3,
                    6.1
                  ],
                  [
                    4.6,
                    7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    2.4,
                    7.1
                  ],
                  [
                    2,
                    8.6
                  ],
                  [
                    2,
                    8.6
                  ],
                  [
                    2.4,
                    10
                  ],
                  [
                    3.6,
                    10.6
                  ],
                  [
                    3.6,
                    10.6
                  ],
                  [
                    4.3,
                    10.4
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    5.4,
                    11
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1066,
        ty: 3,
        parent: 1057,
        ks: {
          p: {
            a: 0,
            k: [
              6.725,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1069,
        ty: 4,
        parent: 1068,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    1.3,
                    9.6
                  ],
                  [
                    2.3,
                    10.2
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    4.5,
                    10.2
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.5,
                    8.7
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    2.5,
                    7.8
                  ],
                  [
                    1.7,
                    7.3
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    1.2,
                    4.5
                  ],
                  [
                    2.1,
                    3.7
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    4.9,
                    3.6
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    5.3,
                    5.3
                  ],
                  [
                    4.5,
                    4.8
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.5,
                    6.1
                  ],
                  [
                    2.9,
                    6.4
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    4.7,
                    7.2
                  ],
                  [
                    5.8,
                    8
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    5.9,
                    10.5
                  ],
                  [
                    4.9,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1068,
        ty: 3,
        parent: 1057,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1057,
        ty: 3,
        parent: 1056,
        ks: {
          p: {
            a: 0,
            k: [
              122.02,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1072,
        ty: 4,
        parent: 1071,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1071,
        ty: 3,
        parent: 1070,
        ks: {
          p: {
            a: 0,
            k: [
              20.548,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1074,
        ty: 4,
        parent: 1073,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1073,
        ty: 3,
        parent: 1070,
        ks: {
          p: {
            a: 0,
            k: [
              14.292,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1076,
        ty: 4,
        parent: 1075,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.6,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.3,
                    6.7
                  ],
                  [
                    0.3,
                    5.6
                  ],
                  [
                    1.1,
                    5.5
                  ],
                  [
                    1.1,
                    4.9
                  ],
                  [
                    1.6,
                    3.3
                  ],
                  [
                    3.2,
                    2.7
                  ],
                  [
                    3.2,
                    2.7
                  ],
                  [
                    3.8,
                    2.8
                  ],
                  [
                    4.3,
                    2.9
                  ],
                  [
                    4.3,
                    2.9
                  ],
                  [
                    4,
                    4
                  ],
                  [
                    3.3,
                    3.8
                  ],
                  [
                    3.3,
                    3.8
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.6,
                    5.5
                  ],
                  [
                    3.8,
                    5.5
                  ],
                  [
                    3.8,
                    6.7
                  ],
                  [
                    2.6,
                    6.7
                  ],
                  [
                    2.6,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    6.9,
                    11.7
                  ],
                  [
                    6.9,
                    11.7
                  ],
                  [
                    5.5,
                    11.1
                  ],
                  [
                    5,
                    9.5
                  ],
                  [
                    5,
                    9.5
                  ],
                  [
                    5,
                    6.7
                  ],
                  [
                    4.2,
                    6.7
                  ],
                  [
                    4.2,
                    5.6
                  ],
                  [
                    5.1,
                    5.5
                  ],
                  [
                    5.3,
                    3.9
                  ],
                  [
                    6.5,
                    3.9
                  ],
                  [
                    6.5,
                    5.5
                  ],
                  [
                    8,
                    5.5
                  ],
                  [
                    8,
                    6.7
                  ],
                  [
                    6.5,
                    6.7
                  ],
                  [
                    6.5,
                    9.5
                  ],
                  [
                    7.3,
                    10.6
                  ],
                  [
                    7.3,
                    10.6
                  ],
                  [
                    7.6,
                    10.6
                  ],
                  [
                    7.9,
                    10.5
                  ],
                  [
                    7.9,
                    10.5
                  ],
                  [
                    8.2,
                    11.5
                  ],
                  [
                    7.6,
                    11.7
                  ],
                  [
                    6.9,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1075,
        ty: 3,
        parent: 1070,
        ks: {
          p: {
            a: 0,
            k: [
              6.367,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1078,
        ty: 4,
        parent: 1077,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1077,
        ty: 3,
        parent: 1070,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1070,
        ty: 3,
        parent: 1056,
        ks: {
          p: {
            a: 0,
            k: [
              94.401,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1081,
        ty: 4,
        parent: 1080,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1080,
        ty: 3,
        parent: 1079,
        ks: {
          p: {
            a: 0,
            k: [
              17.856,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1083,
        ty: 4,
        parent: 1082,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    6.1,
                    5.5
                  ],
                  [
                    4.1,
                    8
                  ],
                  [
                    6.3,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    3.2,
                    9
                  ],
                  [
                    2.3,
                    10
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1082,
        ty: 3,
        parent: 1079,
        ks: {
          p: {
            a: 0,
            k: [
              11.414,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1085,
        ty: 4,
        parent: 1084,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.3,
                    5.5
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    1.6,
                    4.5
                  ],
                  [
                    1.6,
                    4.5
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.8,
                    3.7
                  ],
                  [
                    0.8,
                    3.7
                  ],
                  [
                    1,
                    3.1
                  ],
                  [
                    1.6,
                    2.8
                  ],
                  [
                    1.6,
                    2.8
                  ],
                  [
                    2.2,
                    3.1
                  ],
                  [
                    2.5,
                    3.7
                  ],
                  [
                    2.5,
                    3.7
                  ],
                  [
                    2.2,
                    4.2
                  ],
                  [
                    1.6,
                    4.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1084,
        ty: 3,
        parent: 1079,
        ks: {
          p: {
            a: 0,
            k: [
              8.181,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1087,
        ty: 4,
        parent: 1086,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.5,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    3.5
                  ],
                  [
                    2.5,
                    3.5
                  ],
                  [
                    2.5,
                    6.8
                  ],
                  [
                    5.7,
                    6.8
                  ],
                  [
                    5.7,
                    3.5
                  ],
                  [
                    7.2,
                    3.5
                  ],
                  [
                    7.2,
                    11.6
                  ],
                  [
                    5.7,
                    11.6
                  ],
                  [
                    5.7,
                    8
                  ],
                  [
                    2.5,
                    8
                  ],
                  [
                    2.5,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1086,
        ty: 3,
        parent: 1079,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1079,
        ty: 3,
        parent: 1056,
        ks: {
          p: {
            a: 0,
            k: [
              67.821,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1090,
        ty: 4,
        parent: 1089,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.7,
                    0
                  ]
                ],
                v: [
                  [
                    1.3,
                    14.1
                  ],
                  [
                    1.3,
                    14.1
                  ],
                  [
                    0.9,
                    14
                  ],
                  [
                    0.5,
                    14
                  ],
                  [
                    0.5,
                    14
                  ],
                  [
                    0.8,
                    12.8
                  ],
                  [
                    1,
                    12.9
                  ],
                  [
                    1.2,
                    12.9
                  ],
                  [
                    1.2,
                    12.9
                  ],
                  [
                    2,
                    12.6
                  ],
                  [
                    2.4,
                    11.9
                  ],
                  [
                    2.4,
                    11.9
                  ],
                  [
                    2.5,
                    11.5
                  ],
                  [
                    0.1,
                    5.5
                  ],
                  [
                    1.6,
                    5.5
                  ],
                  [
                    2.6,
                    8.5
                  ],
                  [
                    2.9,
                    9.3
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.4,
                    9.3
                  ],
                  [
                    3.7,
                    8.5
                  ],
                  [
                    3.7,
                    8.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    6,
                    5.5
                  ],
                  [
                    3.8,
                    11.9
                  ],
                  [
                    2.8,
                    13.5
                  ],
                  [
                    1.3,
                    14.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.7
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1089,
        ty: 3,
        parent: 1088,
        ks: {
          p: {
            a: 0,
            k: [
              27.407,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1092,
        ty: 4,
        parent: 1091,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1091,
        ty: 3,
        parent: 1088,
        ks: {
          p: {
            a: 0,
            k: [
              22.804,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1094,
        ty: 4,
        parent: 1093,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1093,
        ty: 3,
        parent: 1088,
        ks: {
          p: {
            a: 0,
            k: [
              16.437,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1096,
        ty: 4,
        parent: 1095,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ],
                  [
                    1.2,
                    11.3
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    10.1
                  ],
                  [
                    2.4,
                    10.5
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.7,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    3,
                    11.6
                  ],
                  [
                    2.7,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1095,
        ty: 3,
        parent: 1088,
        ks: {
          p: {
            a: 0,
            k: [
              13.093,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1098,
        ty: 4,
        parent: 1097,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1097,
        ty: 3,
        parent: 1088,
        ks: {
          p: {
            a: 0,
            k: [
              6.725,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1100,
        ty: 4,
        parent: 1099,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    1.3,
                    9.6
                  ],
                  [
                    2.3,
                    10.2
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    4.5,
                    10.2
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.5,
                    8.7
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    2.5,
                    7.8
                  ],
                  [
                    1.7,
                    7.3
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    1.2,
                    4.5
                  ],
                  [
                    2.1,
                    3.7
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    4.9,
                    3.6
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    5.3,
                    5.3
                  ],
                  [
                    4.5,
                    4.8
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.5,
                    6.1
                  ],
                  [
                    2.9,
                    6.4
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    4.7,
                    7.2
                  ],
                  [
                    5.8,
                    8
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    5.9,
                    10.5
                  ],
                  [
                    4.9,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1099,
        ty: 3,
        parent: 1088,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1088,
        ty: 3,
        parent: 1056,
        ks: {
          p: {
            a: 0,
            k: [
              31.837,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1103,
        ty: 4,
        parent: 1102,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    8.5
                  ],
                  [
                    2.3,
                    8.5
                  ],
                  [
                    0.9,
                    7.8
                  ],
                  [
                    0.4,
                    5.9
                  ],
                  [
                    0.4,
                    5.9
                  ],
                  [
                    0.9,
                    4
                  ],
                  [
                    2.3,
                    3.4
                  ],
                  [
                    2.3,
                    3.4
                  ],
                  [
                    3.7,
                    4
                  ],
                  [
                    4.2,
                    5.9
                  ],
                  [
                    4.2,
                    5.9
                  ],
                  [
                    3.7,
                    7.8
                  ],
                  [
                    2.3,
                    8.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    7.7
                  ],
                  [
                    2.3,
                    7.7
                  ],
                  [
                    2.9,
                    7.2
                  ],
                  [
                    3.2,
                    5.9
                  ],
                  [
                    3.2,
                    5.9
                  ],
                  [
                    2.9,
                    4.6
                  ],
                  [
                    2.3,
                    4.2
                  ],
                  [
                    2.3,
                    4.2
                  ],
                  [
                    1.7,
                    4.6
                  ],
                  [
                    1.4,
                    5.9
                  ],
                  [
                    1.4,
                    5.9
                  ],
                  [
                    1.7,
                    7.2
                  ],
                  [
                    2.3,
                    7.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2.6,
                    11.7
                  ],
                  [
                    7,
                    3.4
                  ],
                  [
                    7.8,
                    3.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    8.1,
                    11.7
                  ],
                  [
                    8.1,
                    11.7
                  ],
                  [
                    6.7,
                    11.1
                  ],
                  [
                    6.2,
                    9.2
                  ],
                  [
                    6.2,
                    9.2
                  ],
                  [
                    6.7,
                    7.3
                  ],
                  [
                    8.1,
                    6.6
                  ],
                  [
                    8.1,
                    6.6
                  ],
                  [
                    9.5,
                    7.3
                  ],
                  [
                    10,
                    9.2
                  ],
                  [
                    10,
                    9.2
                  ],
                  [
                    9.5,
                    11.1
                  ],
                  [
                    8.1,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    8.1,
                    10.9
                  ],
                  [
                    8.1,
                    10.9
                  ],
                  [
                    8.7,
                    10.5
                  ],
                  [
                    9,
                    9.2
                  ],
                  [
                    9,
                    9.2
                  ],
                  [
                    8.7,
                    7.9
                  ],
                  [
                    8.1,
                    7.5
                  ],
                  [
                    8.1,
                    7.5
                  ],
                  [
                    7.4,
                    7.9
                  ],
                  [
                    7.2,
                    9.2
                  ],
                  [
                    7.2,
                    9.2
                  ],
                  [
                    7.4,
                    10.5
                  ],
                  [
                    8.1,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1102,
        ty: 3,
        parent: 1101,
        ks: {
          p: {
            a: 0,
            k: [
              18.991,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1105,
        ty: 4,
        parent: 1104,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.7
                  ],
                  [
                    -0.3,
                    0.7
                  ],
                  [
                    -0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0.1,
                    -0.6
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.6
                  ],
                  [
                    2.1,
                    11.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    3,
                    7
                  ],
                  [
                    4.3,
                    4.9
                  ],
                  [
                    4.3,
                    4.9
                  ],
                  [
                    0.5,
                    4.9
                  ],
                  [
                    0.5,
                    3.7
                  ],
                  [
                    5.8,
                    3.7
                  ],
                  [
                    5.8,
                    4.6
                  ],
                  [
                    4.7,
                    6.2
                  ],
                  [
                    4,
                    7.8
                  ],
                  [
                    3.7,
                    9.5
                  ],
                  [
                    3.5,
                    11.6
                  ],
                  [
                    3.5,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0.1,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.6
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.2,
                    0.5
                  ],
                  [
                    -0.1,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1104,
        ty: 3,
        parent: 1101,
        ks: {
          p: {
            a: 0,
            k: [
              12.661,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1107,
        ty: 4,
        parent: 1106,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.1,
                    6.3
                  ],
                  [
                    1.6,
                    8.5
                  ],
                  [
                    3.7,
                    8.5
                  ],
                  [
                    3.7,
                    6.7
                  ],
                  [
                    3.7,
                    5.9
                  ],
                  [
                    3.8,
                    5.1
                  ],
                  [
                    3.8,
                    5.1
                  ],
                  [
                    3.7,
                    5.1
                  ],
                  [
                    3.4,
                    5.7
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    5,
                    11.6
                  ],
                  [
                    3.7,
                    11.6
                  ],
                  [
                    3.7,
                    9.6
                  ],
                  [
                    0.2,
                    9.6
                  ],
                  [
                    0.2,
                    8.6
                  ],
                  [
                    3.3,
                    3.7
                  ],
                  [
                    5,
                    3.7
                  ],
                  [
                    5,
                    8.5
                  ],
                  [
                    6,
                    8.5
                  ],
                  [
                    6,
                    9.6
                  ],
                  [
                    5,
                    9.6
                  ],
                  [
                    5,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1106,
        ty: 3,
        parent: 1101,
        ks: {
          p: {
            a: 0,
            k: [
              6.33,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1109,
        ty: 4,
        parent: 1108,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.6
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    5.8,
                    11.6
                  ],
                  [
                    0.5,
                    11.6
                  ],
                  [
                    0.5,
                    10.8
                  ],
                  [
                    2.4,
                    8.9
                  ],
                  [
                    3.6,
                    7.3
                  ],
                  [
                    4,
                    6.1
                  ],
                  [
                    4,
                    6.1
                  ],
                  [
                    3.7,
                    5.1
                  ],
                  [
                    2.7,
                    4.7
                  ],
                  [
                    2.7,
                    4.7
                  ],
                  [
                    1.9,
                    5
                  ],
                  [
                    1.2,
                    5.6
                  ],
                  [
                    1.2,
                    5.6
                  ],
                  [
                    0.4,
                    4.8
                  ],
                  [
                    1.5,
                    3.9
                  ],
                  [
                    2.9,
                    3.6
                  ],
                  [
                    2.9,
                    3.6
                  ],
                  [
                    4.7,
                    4.2
                  ],
                  [
                    5.4,
                    6
                  ],
                  [
                    5.4,
                    6
                  ],
                  [
                    5,
                    7.4
                  ],
                  [
                    4,
                    8.9
                  ],
                  [
                    2.5,
                    10.5
                  ],
                  [
                    2.5,
                    10.5
                  ],
                  [
                    3.2,
                    10.4
                  ],
                  [
                    3.9,
                    10.4
                  ],
                  [
                    3.9,
                    10.4
                  ],
                  [
                    5.8,
                    10.4
                  ],
                  [
                    5.8,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    -0.7
                  ],
                  [
                    0.5,
                    -0.6
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1108,
        ty: 3,
        parent: 1101,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1101,
        ty: 3,
        parent: 1056,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1056,
        ty: 3,
        parent: 1055,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1055,
        ty: 3,
        parent: 1054,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1054,
        ty: 3,
        parent: 1053,
        ks: {
          p: {
            a: 0,
            k: [
              22.167,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1118,
        ty: 0,
        parent: 1110,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1116"
      },
      {
        ind: 1110,
        ty: 3,
        parent: 1053,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1053,
        ty: 3,
        parent: 1052,
        ks: {
          p: {
            a: 0,
            k: [
              48.952,
              3.527
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1052,
        ty: 3,
        parent: 1051,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              46.727
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1140,
        ty: 0,
        parent: 1121,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              13.015
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              13.015
            ]
          }
        },
        w: 51.387,
        h: 15.457,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1138"
      },
      {
        ind: 1121,
        ty: 3,
        parent: 1120,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              13.015
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1145,
        ty: 4,
        parent: 1144,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.22,
                    0.16
                  ],
                  [
                    -0.25,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.14,
                    -0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.06,
                    0.01
                  ],
                  [
                    0.09,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.15
                  ],
                  [
                    0.15,
                    -0.37
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.49,
                    8.51
                  ],
                  [
                    0.74,
                    8.51
                  ],
                  [
                    0.74,
                    4.11
                  ],
                  [
                    1.36,
                    4.11
                  ],
                  [
                    1.42,
                    4.9
                  ],
                  [
                    1.45,
                    4.9
                  ],
                  [
                    2,
                    4.24
                  ],
                  [
                    2.7,
                    4
                  ],
                  [
                    2.7,
                    4
                  ],
                  [
                    3.17,
                    4.09
                  ],
                  [
                    3.17,
                    4.09
                  ],
                  [
                    3.03,
                    4.74
                  ],
                  [
                    2.83,
                    4.69
                  ],
                  [
                    2.6,
                    4.67
                  ],
                  [
                    2.6,
                    4.67
                  ],
                  [
                    2.02,
                    4.9
                  ],
                  [
                    1.49,
                    5.68
                  ],
                  [
                    1.49,
                    5.68
                  ],
                  [
                    1.49,
                    8.51
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.15,
                    -0.28
                  ],
                  [
                    0.22,
                    -0.16
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.18,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.07,
                    -0.02
                  ],
                  [
                    -0.06,
                    -0.01
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0
                  ],
                  [
                    -0.2,
                    0.15
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1144,
        ty: 3,
        parent: 1143,
        ks: {
          p: {
            a: 0,
            k: [
              20.34,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1147,
        ty: 4,
        parent: 1146,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.32,
                    0.18
                  ],
                  [
                    0.19,
                    0.34
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.34
                  ],
                  [
                    -0.3,
                    0.19
                  ],
                  [
                    -0.33,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    -0.37
                  ],
                  [
                    0,
                    -0.63
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.08
                  ],
                  [
                    0.01,
                    -0.05
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.26,
                    -0.28
                  ],
                  [
                    -0.42,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.18,
                    0.06
                  ],
                  [
                    -0.16,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.09
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.53,
                    8.62
                  ],
                  [
                    2.53,
                    8.62
                  ],
                  [
                    1.46,
                    8.35
                  ],
                  [
                    0.7,
                    7.55
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.7,
                    5.08
                  ],
                  [
                    1.44,
                    4.28
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    3.7,
                    4.56
                  ],
                  [
                    4.15,
                    6.07
                  ],
                  [
                    4.15,
                    6.07
                  ],
                  [
                    4.15,
                    6.3
                  ],
                  [
                    4.13,
                    6.49
                  ],
                  [
                    4.13,
                    6.49
                  ],
                  [
                    1.15,
                    6.49
                  ],
                  [
                    1.59,
                    7.61
                  ],
                  [
                    2.62,
                    8.02
                  ],
                  [
                    2.62,
                    8.02
                  ],
                  [
                    3.21,
                    7.93
                  ],
                  [
                    3.72,
                    7.68
                  ],
                  [
                    3.72,
                    7.68
                  ],
                  [
                    3.98,
                    8.17
                  ],
                  [
                    3.34,
                    8.49
                  ],
                  [
                    2.53,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.39,
                    0
                  ],
                  [
                    -0.32,
                    -0.18
                  ],
                  [
                    -0.19,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.48
                  ],
                  [
                    0.19,
                    -0.34
                  ],
                  [
                    0.3,
                    -0.19
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.56,
                    0
                  ],
                  [
                    0.31,
                    0.37
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.08
                  ],
                  [
                    0,
                    0.08
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.03,
                    0.47
                  ],
                  [
                    0.26,
                    0.28
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0
                  ],
                  [
                    0.18,
                    -0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.12
                  ],
                  [
                    -0.24,
                    0.09
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.19,
                    0.23
                  ],
                  [
                    0.34,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.24
                  ],
                  [
                    0.05,
                    -0.44
                  ]
                ],
                v: [
                  [
                    1.14,
                    5.96
                  ],
                  [
                    1.14,
                    5.96
                  ],
                  [
                    3.5,
                    5.96
                  ],
                  [
                    3.21,
                    4.94
                  ],
                  [
                    2.41,
                    4.59
                  ],
                  [
                    2.41,
                    4.59
                  ],
                  [
                    1.58,
                    4.95
                  ],
                  [
                    1.14,
                    5.96
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.45
                  ],
                  [
                    -0.19,
                    -0.23
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    0
                  ],
                  [
                    -0.24,
                    0.24
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1146,
        ty: 3,
        parent: 1143,
        ks: {
          p: {
            a: 0,
            k: [
              15.846,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1149,
        ty: 4,
        parent: 1148,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    8.6
                  ],
                  [
                    1.5,
                    8.6
                  ],
                  [
                    0.9,
                    8.4
                  ],
                  [
                    0.7,
                    7.6
                  ],
                  [
                    0.7,
                    7.6
                  ],
                  [
                    0.7,
                    2.1
                  ],
                  [
                    1.5,
                    2.1
                  ],
                  [
                    1.5,
                    7.7
                  ],
                  [
                    1.6,
                    7.9
                  ],
                  [
                    1.7,
                    8
                  ],
                  [
                    1.7,
                    8
                  ],
                  [
                    1.8,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    2,
                    8.5
                  ],
                  [
                    1.8,
                    8.6
                  ],
                  [
                    1.5,
                    8.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1148,
        ty: 3,
        parent: 1143,
        ks: {
          p: {
            a: 0,
            k: [
              13.536,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1151,
        ty: 4,
        parent: 1150,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    0.22
                  ],
                  [
                    0,
                    0.39
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.43,
                    0.26
                  ],
                  [
                    -0.94,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.05,
                    0.17
                  ],
                  [
                    0.13,
                    0.11
                  ],
                  [
                    0.24,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.22,
                    -0.1
                  ],
                  [
                    0.18,
                    -0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.12
                  ],
                  [
                    -0.35,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.24,
                    -0.33
                  ],
                  [
                    0,
                    -0.55
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.13
                  ],
                  [
                    0.28,
                    0
                  ]
                ],
                v: [
                  [
                    1.76,
                    8.62
                  ],
                  [
                    1.76,
                    8.62
                  ],
                  [
                    0.84,
                    8.29
                  ],
                  [
                    0.47,
                    7.37
                  ],
                  [
                    0.47,
                    7.37
                  ],
                  [
                    1.12,
                    6.26
                  ],
                  [
                    3.17,
                    5.72
                  ],
                  [
                    3.17,
                    5.72
                  ],
                  [
                    3.1,
                    5.19
                  ],
                  [
                    2.82,
                    4.77
                  ],
                  [
                    2.27,
                    4.61
                  ],
                  [
                    2.27,
                    4.61
                  ],
                  [
                    1.55,
                    4.76
                  ],
                  [
                    0.95,
                    5.09
                  ],
                  [
                    0.95,
                    5.09
                  ],
                  [
                    0.66,
                    4.57
                  ],
                  [
                    1.42,
                    4.18
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    3.56,
                    4.49
                  ],
                  [
                    3.93,
                    5.81
                  ],
                  [
                    3.93,
                    5.81
                  ],
                  [
                    3.93,
                    8.51
                  ],
                  [
                    3.31,
                    8.51
                  ],
                  [
                    3.25,
                    7.99
                  ],
                  [
                    3.22,
                    7.99
                  ],
                  [
                    2.54,
                    8.43
                  ],
                  [
                    1.76,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.37,
                    0
                  ],
                  [
                    -0.24,
                    -0.22
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.48
                  ],
                  [
                    0.43,
                    -0.26
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.19
                  ],
                  [
                    -0.05,
                    -0.17
                  ],
                  [
                    -0.13,
                    -0.11
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.25,
                    0
                  ],
                  [
                    -0.22,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    -0.13
                  ],
                  [
                    0.3,
                    -0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.54,
                    0
                  ],
                  [
                    0.24,
                    0.33
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    0.17
                  ],
                  [
                    -0.24,
                    0.13
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.1
                  ],
                  [
                    -0.21,
                    0.19
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.29,
                    -0.18
                  ],
                  [
                    0,
                    -0.28
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.15,
                    -0.11
                  ],
                  [
                    -0.22,
                    0
                  ]
                ],
                v: [
                  [
                    1.98,
                    8.02
                  ],
                  [
                    1.98,
                    8.02
                  ],
                  [
                    2.58,
                    7.87
                  ],
                  [
                    3.17,
                    7.43
                  ],
                  [
                    3.17,
                    7.43
                  ],
                  [
                    3.17,
                    6.21
                  ],
                  [
                    1.64,
                    6.62
                  ],
                  [
                    1.2,
                    7.32
                  ],
                  [
                    1.2,
                    7.32
                  ],
                  [
                    1.42,
                    7.86
                  ],
                  [
                    1.98,
                    8.02
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0
                  ],
                  [
                    0.19,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.73,
                    0.09
                  ],
                  [
                    -0.29,
                    0.18
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.25
                  ],
                  [
                    0.15,
                    0.11
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1150,
        ty: 3,
        parent: 1143,
        ks: {
          p: {
            a: 0,
            k: [
              8.969,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1153,
        ty: 4,
        parent: 1152,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.31,
                    0.18
                  ],
                  [
                    0.18,
                    0.34
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.34
                  ],
                  [
                    -0.32,
                    0.18
                  ],
                  [
                    -0.37,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.1
                  ],
                  [
                    -0.15,
                    -0.14
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.14,
                    0.07
                  ],
                  [
                    0.18,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    -0.14
                  ],
                  [
                    0.12,
                    -0.26
                  ],
                  [
                    0,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.25,
                    -0.31
                  ],
                  [
                    -0.41,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.18,
                    0.09
                  ],
                  [
                    -0.13,
                    0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.1
                  ],
                  [
                    0.27,
                    0
                  ]
                ],
                v: [
                  [
                    2.48,
                    8.62
                  ],
                  [
                    2.48,
                    8.62
                  ],
                  [
                    1.43,
                    8.35
                  ],
                  [
                    0.69,
                    7.56
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.71,
                    5.06
                  ],
                  [
                    1.49,
                    4.27
                  ],
                  [
                    2.54,
                    4
                  ],
                  [
                    2.54,
                    4
                  ],
                  [
                    3.29,
                    4.15
                  ],
                  [
                    3.83,
                    4.51
                  ],
                  [
                    3.83,
                    4.51
                  ],
                  [
                    3.45,
                    5
                  ],
                  [
                    3.04,
                    4.72
                  ],
                  [
                    2.57,
                    4.61
                  ],
                  [
                    2.57,
                    4.61
                  ],
                  [
                    1.85,
                    4.83
                  ],
                  [
                    1.36,
                    5.43
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.56,
                    7.54
                  ],
                  [
                    2.55,
                    8.01
                  ],
                  [
                    2.55,
                    8.01
                  ],
                  [
                    3.12,
                    7.87
                  ],
                  [
                    3.58,
                    7.56
                  ],
                  [
                    3.58,
                    7.56
                  ],
                  [
                    3.91,
                    8.06
                  ],
                  [
                    3.25,
                    8.47
                  ],
                  [
                    2.48,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.39,
                    0
                  ],
                  [
                    -0.31,
                    -0.18
                  ],
                  [
                    -0.18,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0.2,
                    -0.34
                  ],
                  [
                    0.32,
                    -0.18
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.29,
                    0
                  ],
                  [
                    0.21,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.13,
                    -0.11
                  ],
                  [
                    -0.14,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.27,
                    0
                  ],
                  [
                    -0.21,
                    0.14
                  ],
                  [
                    -0.12,
                    0.26
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0.25,
                    0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0
                  ],
                  [
                    0.18,
                    -0.09
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.18
                  ],
                  [
                    -0.24,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1152,
        ty: 3,
        parent: 1143,
        ks: {
          p: {
            a: 0,
            k: [
              4.838,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1155,
        ty: 4,
        parent: 1154,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.5,
                    8.6
                  ],
                  [
                    2.5,
                    8.6
                  ],
                  [
                    1.3,
                    8.4
                  ],
                  [
                    0.4,
                    7.7
                  ],
                  [
                    0.4,
                    7.7
                  ],
                  [
                    0.8,
                    7.2
                  ],
                  [
                    1.6,
                    7.8
                  ],
                  [
                    2.5,
                    8
                  ],
                  [
                    2.5,
                    8
                  ],
                  [
                    3.4,
                    7.7
                  ],
                  [
                    3.7,
                    7
                  ],
                  [
                    3.7,
                    7
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    3.2,
                    6.2
                  ],
                  [
                    2.7,
                    5.9
                  ],
                  [
                    2.7,
                    5.9
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.3,
                    5.3
                  ],
                  [
                    0.9,
                    4.8
                  ],
                  [
                    0.7,
                    4
                  ],
                  [
                    0.7,
                    4
                  ],
                  [
                    0.9,
                    3.2
                  ],
                  [
                    1.6,
                    2.7
                  ],
                  [
                    2.5,
                    2.5
                  ],
                  [
                    2.5,
                    2.5
                  ],
                  [
                    3.5,
                    2.7
                  ],
                  [
                    4.3,
                    3.2
                  ],
                  [
                    4.3,
                    3.2
                  ],
                  [
                    3.9,
                    3.7
                  ],
                  [
                    3.3,
                    3.3
                  ],
                  [
                    2.5,
                    3.1
                  ],
                  [
                    2.5,
                    3.1
                  ],
                  [
                    1.7,
                    3.4
                  ],
                  [
                    1.4,
                    4
                  ],
                  [
                    1.4,
                    4
                  ],
                  [
                    1.6,
                    4.5
                  ],
                  [
                    2,
                    4.8
                  ],
                  [
                    2.4,
                    5
                  ],
                  [
                    2.4,
                    5
                  ],
                  [
                    3.3,
                    5.3
                  ],
                  [
                    3.9,
                    5.7
                  ],
                  [
                    4.3,
                    6.2
                  ],
                  [
                    4.5,
                    6.9
                  ],
                  [
                    4.5,
                    6.9
                  ],
                  [
                    4.2,
                    7.8
                  ],
                  [
                    3.5,
                    8.4
                  ],
                  [
                    2.5,
                    8.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1154,
        ty: 3,
        parent: 1143,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1143,
        ty: 3,
        parent: 1142,
        ks: {
          p: {
            a: 0,
            k: [
              18.709,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1158,
        ty: 4,
        parent: 1157,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    8.6
                  ],
                  [
                    2.1,
                    8.6
                  ],
                  [
                    1.1,
                    8.2
                  ],
                  [
                    0.9,
                    7.2
                  ],
                  [
                    0.9,
                    7.2
                  ],
                  [
                    0.9,
                    4.7
                  ],
                  [
                    0.2,
                    4.7
                  ],
                  [
                    0.2,
                    4.2
                  ],
                  [
                    0.9,
                    4.1
                  ],
                  [
                    1,
                    2.9
                  ],
                  [
                    1.6,
                    2.9
                  ],
                  [
                    1.6,
                    4.1
                  ],
                  [
                    2.8,
                    4.1
                  ],
                  [
                    2.8,
                    4.7
                  ],
                  [
                    1.6,
                    4.7
                  ],
                  [
                    1.6,
                    7.2
                  ],
                  [
                    1.8,
                    7.8
                  ],
                  [
                    2.3,
                    8
                  ],
                  [
                    2.3,
                    8
                  ],
                  [
                    2.6,
                    8
                  ],
                  [
                    2.8,
                    7.9
                  ],
                  [
                    2.8,
                    7.9
                  ],
                  [
                    2.9,
                    8.5
                  ],
                  [
                    2.6,
                    8.6
                  ],
                  [
                    2.1,
                    8.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1157,
        ty: 3,
        parent: 1156,
        ks: {
          p: {
            a: 0,
            k: [
              13.835,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1160,
        ty: 4,
        parent: 1159,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.28,
                    0.12
                  ],
                  [
                    0.21,
                    0.17
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.1
                  ],
                  [
                    -0.26,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.15,
                    0.14
                  ],
                  [
                    0,
                    0.19
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.15,
                    0.07
                  ],
                  [
                    0.16,
                    0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.13,
                    0.16
                  ],
                  [
                    0,
                    0.25
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.27,
                    0.24
                  ],
                  [
                    -0.48,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.24,
                    -0.1
                  ],
                  [
                    -0.17,
                    -0.14
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.16,
                    0.07
                  ],
                  [
                    0.19,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.13,
                    -0.13
                  ],
                  [
                    0,
                    -0.17
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.09,
                    -0.09
                  ],
                  [
                    -0.15,
                    -0.06
                  ],
                  [
                    -0.16,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.1
                  ],
                  [
                    -0.14,
                    -0.17
                  ],
                  [
                    0,
                    -0.28
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.12,
                    -0.2
                  ],
                  [
                    0.24,
                    -0.12
                  ],
                  [
                    0.35,
                    0
                  ]
                ],
                v: [
                  [
                    1.9,
                    8.62
                  ],
                  [
                    1.9,
                    8.62
                  ],
                  [
                    1,
                    8.45
                  ],
                  [
                    0.25,
                    8.01
                  ],
                  [
                    0.25,
                    8.01
                  ],
                  [
                    0.63,
                    7.52
                  ],
                  [
                    1.22,
                    7.89
                  ],
                  [
                    1.92,
                    8.04
                  ],
                  [
                    1.92,
                    8.04
                  ],
                  [
                    2.58,
                    7.84
                  ],
                  [
                    2.79,
                    7.35
                  ],
                  [
                    2.79,
                    7.35
                  ],
                  [
                    2.64,
                    6.97
                  ],
                  [
                    2.26,
                    6.71
                  ],
                  [
                    1.79,
                    6.52
                  ],
                  [
                    1.79,
                    6.52
                  ],
                  [
                    1.18,
                    6.25
                  ],
                  [
                    0.69,
                    5.86
                  ],
                  [
                    0.5,
                    5.25
                  ],
                  [
                    0.5,
                    5.25
                  ],
                  [
                    0.9,
                    4.36
                  ],
                  [
                    2.02,
                    4
                  ],
                  [
                    2.02,
                    4
                  ],
                  [
                    2.78,
                    4.14
                  ],
                  [
                    3.39,
                    4.5
                  ],
                  [
                    3.39,
                    4.5
                  ],
                  [
                    3.03,
                    4.97
                  ],
                  [
                    2.56,
                    4.69
                  ],
                  [
                    2.02,
                    4.58
                  ],
                  [
                    2.02,
                    4.58
                  ],
                  [
                    1.41,
                    4.77
                  ],
                  [
                    1.22,
                    5.21
                  ],
                  [
                    1.22,
                    5.21
                  ],
                  [
                    1.35,
                    5.55
                  ],
                  [
                    1.7,
                    5.78
                  ],
                  [
                    2.17,
                    5.97
                  ],
                  [
                    2.17,
                    5.97
                  ],
                  [
                    2.79,
                    6.24
                  ],
                  [
                    3.31,
                    6.64
                  ],
                  [
                    3.51,
                    7.31
                  ],
                  [
                    3.51,
                    7.31
                  ],
                  [
                    3.32,
                    7.96
                  ],
                  [
                    2.78,
                    8.44
                  ],
                  [
                    1.9,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    0
                  ],
                  [
                    -0.28,
                    -0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.19,
                    0.15
                  ],
                  [
                    0.21,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.29,
                    0
                  ],
                  [
                    0.15,
                    -0.14
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.15
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.15,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.08
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.13,
                    -0.16
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.36
                  ],
                  [
                    0.27,
                    -0.24
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.27,
                    0
                  ],
                  [
                    0.24,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.15,
                    -0.11
                  ],
                  [
                    -0.16,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.28,
                    0
                  ],
                  [
                    -0.13,
                    0.13
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.14
                  ],
                  [
                    0.09,
                    0.09
                  ],
                  [
                    0.15,
                    0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0.08
                  ],
                  [
                    0.21,
                    0.1
                  ],
                  [
                    0.14,
                    0.17
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.24
                  ],
                  [
                    -0.12,
                    0.2
                  ],
                  [
                    -0.24,
                    0.12
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1159,
        ty: 3,
        parent: 1156,
        ks: {
          p: {
            a: 0,
            k: [
              10.038,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1162,
        ty: 4,
        parent: 1161,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.31,
                    0.18
                  ],
                  [
                    0.19,
                    0.34
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.34
                  ],
                  [
                    -0.31,
                    0.18
                  ],
                  [
                    -0.36,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    -0.18
                  ],
                  [
                    -0.19,
                    -0.34
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.19,
                    -0.34
                  ],
                  [
                    0.31,
                    -0.18
                  ],
                  [
                    0.36,
                    0
                  ]
                ],
                v: [
                  [
                    2.46,
                    8.62
                  ],
                  [
                    2.46,
                    8.62
                  ],
                  [
                    1.46,
                    8.35
                  ],
                  [
                    0.7,
                    7.56
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.7,
                    5.06
                  ],
                  [
                    1.46,
                    4.27
                  ],
                  [
                    2.46,
                    4
                  ],
                  [
                    2.46,
                    4
                  ],
                  [
                    3.46,
                    4.27
                  ],
                  [
                    4.21,
                    5.06
                  ],
                  [
                    4.5,
                    6.32
                  ],
                  [
                    4.5,
                    6.32
                  ],
                  [
                    4.21,
                    7.56
                  ],
                  [
                    3.46,
                    8.35
                  ],
                  [
                    2.46,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.36,
                    0
                  ],
                  [
                    -0.31,
                    -0.18
                  ],
                  [
                    -0.19,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0.19,
                    -0.34
                  ],
                  [
                    0.31,
                    -0.18
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.36,
                    0
                  ],
                  [
                    0.31,
                    0.18
                  ],
                  [
                    0.19,
                    0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    -0.19,
                    0.34
                  ],
                  [
                    -0.31,
                    0.18
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.23,
                    0.31
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.23,
                    0.31
                  ],
                  [
                    0.38,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.31
                  ],
                  [
                    0,
                    -0.51
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.24,
                    -0.31
                  ],
                  [
                    -0.37,
                    0
                  ]
                ],
                v: [
                  [
                    2.46,
                    8.01
                  ],
                  [
                    2.46,
                    8.01
                  ],
                  [
                    3.38,
                    7.54
                  ],
                  [
                    3.73,
                    6.32
                  ],
                  [
                    3.73,
                    6.32
                  ],
                  [
                    3.38,
                    5.09
                  ],
                  [
                    2.46,
                    4.61
                  ],
                  [
                    2.46,
                    4.61
                  ],
                  [
                    1.54,
                    5.09
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.54,
                    7.54
                  ],
                  [
                    2.46,
                    8.01
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.38,
                    0
                  ],
                  [
                    0.23,
                    -0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.51
                  ],
                  [
                    -0.23,
                    -0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.37,
                    0
                  ],
                  [
                    -0.24,
                    0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0.24,
                    0.31
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1161,
        ty: 3,
        parent: 1156,
        ks: {
          p: {
            a: 0,
            k: [
              5.128,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1164,
        ty: 4,
        parent: 1163,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.5
                  ],
                  [
                    0.8,
                    8.5
                  ],
                  [
                    0.8,
                    2.6
                  ],
                  [
                    2.5,
                    2.6
                  ],
                  [
                    3.7,
                    2.7
                  ],
                  [
                    4.5,
                    3.3
                  ],
                  [
                    4.7,
                    4.3
                  ],
                  [
                    4.7,
                    4.3
                  ],
                  [
                    4.1,
                    5.7
                  ],
                  [
                    2.5,
                    6.2
                  ],
                  [
                    2.5,
                    6.2
                  ],
                  [
                    1.6,
                    6.2
                  ],
                  [
                    1.6,
                    8.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.6,
                    3.2
                  ],
                  [
                    1.6,
                    5.5
                  ],
                  [
                    2.5,
                    5.5
                  ],
                  [
                    3.6,
                    5.2
                  ],
                  [
                    4,
                    4.3
                  ],
                  [
                    4,
                    4.3
                  ],
                  [
                    3.6,
                    3.4
                  ],
                  [
                    2.4,
                    3.2
                  ],
                  [
                    2.4,
                    3.2
                  ],
                  [
                    1.6,
                    3.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1163,
        ty: 3,
        parent: 1156,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1156,
        ty: 3,
        parent: 1142,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1142,
        ty: 3,
        parent: 1141,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1141,
        ty: 3,
        parent: 1120,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1120,
        ty: 3,
        parent: 1119,
        ks: {
          p: {
            a: 0,
            k: [
              191.504,
              2.074
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1170,
        ty: 0,
        parent: 1166,
        ks: {},
        w: 27,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1168"
      },
      {
        ind: 1166,
        ty: 3,
        parent: 1165,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1165,
        ty: 3,
        parent: 1119,
        ks: {
          p: {
            a: 0,
            k: [
              154.727,
              10.204
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1176,
        ty: 0,
        parent: 1172,
        ks: {},
        w: 112,
        h: 19,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1174"
      },
      {
        ind: 1172,
        ty: 3,
        parent: 1171,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              14
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1181,
        ty: 0,
        parent: 1177,
        ks: {},
        w: 81,
        h: 15,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1179"
      },
      {
        ind: 1177,
        ty: 3,
        parent: 1171,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1171,
        ty: 3,
        parent: 1119,
        ks: {
          p: {
            a: 0,
            k: [
              32.18,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1119,
        ty: 3,
        parent: 1051,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1051,
        ty: 3,
        parent: 1050,
        ks: {
          p: {
            a: 0,
            k: [
              10.58,
              102.27
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1190,
        ty: 4,
        parent: 1189,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.7
                  ],
                  [
                    2,
                    6.7
                  ],
                  [
                    2.7,
                    5.8
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.1,
                    6.5
                  ],
                  [
                    3.9,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    2.7,
                    6.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1189,
        ty: 3,
        parent: 1188,
        ks: {
          p: {
            a: 0,
            k: [
              25.248,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1192,
        ty: 4,
        parent: 1191,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -1.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.3
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.5,
                    8.5
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.2,
                    7.1
                  ],
                  [
                    3.8,
                    6.5
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    2.1,
                    6.5
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    0.9,
                    6.2
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    11.6
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    3.5,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    10.9
                  ],
                  [
                    2.7,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    8.5
                  ],
                  [
                    2.2,
                    9
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.9,
                    10.7
                  ],
                  [
                    2.7,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1191,
        ty: 3,
        parent: 1188,
        ks: {
          p: {
            a: 0,
            k: [
              19.028,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1194,
        ty: 4,
        parent: 1193,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    14.4
                  ],
                  [
                    3,
                    14.4
                  ],
                  [
                    1.2,
                    13.9
                  ],
                  [
                    0.6,
                    12.7
                  ],
                  [
                    0.6,
                    12.7
                  ],
                  [
                    0.8,
                    12
                  ],
                  [
                    1.4,
                    11.4
                  ],
                  [
                    1.4,
                    11.4
                  ],
                  [
                    1.4,
                    11.3
                  ],
                  [
                    1.1,
                    10.9
                  ],
                  [
                    0.9,
                    10.4
                  ],
                  [
                    0.9,
                    10.4
                  ],
                  [
                    1.1,
                    9.7
                  ],
                  [
                    1.6,
                    9.2
                  ],
                  [
                    1.6,
                    9.2
                  ],
                  [
                    1.6,
                    9.2
                  ],
                  [
                    1,
                    8.5
                  ],
                  [
                    0.8,
                    7.6
                  ],
                  [
                    0.8,
                    7.6
                  ],
                  [
                    1.1,
                    6.4
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3,
                    5.4
                  ],
                  [
                    3,
                    5.4
                  ],
                  [
                    3.5,
                    5.5
                  ],
                  [
                    3.9,
                    5.6
                  ],
                  [
                    3.9,
                    5.6
                  ],
                  [
                    6,
                    5.6
                  ],
                  [
                    6,
                    6.4
                  ],
                  [
                    4.7,
                    6.4
                  ],
                  [
                    5.1,
                    6.9
                  ],
                  [
                    5.2,
                    7.6
                  ],
                  [
                    5.2,
                    7.6
                  ],
                  [
                    4.9,
                    8.7
                  ],
                  [
                    4.1,
                    9.4
                  ],
                  [
                    3,
                    9.7
                  ],
                  [
                    3,
                    9.7
                  ],
                  [
                    2.1,
                    9.5
                  ],
                  [
                    2.1,
                    9.5
                  ],
                  [
                    1.9,
                    9.8
                  ],
                  [
                    1.8,
                    10.2
                  ],
                  [
                    1.8,
                    10.2
                  ],
                  [
                    2,
                    10.7
                  ],
                  [
                    2.8,
                    10.8
                  ],
                  [
                    2.8,
                    10.8
                  ],
                  [
                    4,
                    10.8
                  ],
                  [
                    5.5,
                    11.2
                  ],
                  [
                    6.1,
                    12.3
                  ],
                  [
                    6.1,
                    12.3
                  ],
                  [
                    5.7,
                    13.3
                  ],
                  [
                    4.7,
                    14.1
                  ],
                  [
                    3,
                    14.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    9
                  ],
                  [
                    3,
                    9
                  ],
                  [
                    3.9,
                    8.6
                  ],
                  [
                    4.3,
                    7.6
                  ],
                  [
                    4.3,
                    7.6
                  ],
                  [
                    3.9,
                    6.6
                  ],
                  [
                    3,
                    6.2
                  ],
                  [
                    3,
                    6.2
                  ],
                  [
                    2.1,
                    6.6
                  ],
                  [
                    1.8,
                    7.6
                  ],
                  [
                    1.8,
                    7.6
                  ],
                  [
                    2.1,
                    8.6
                  ],
                  [
                    3,
                    9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    13.6
                  ],
                  [
                    3.2,
                    13.6
                  ],
                  [
                    4.6,
                    13.3
                  ],
                  [
                    5.1,
                    12.4
                  ],
                  [
                    5.1,
                    12.4
                  ],
                  [
                    4.8,
                    11.8
                  ],
                  [
                    3.9,
                    11.7
                  ],
                  [
                    3.9,
                    11.7
                  ],
                  [
                    2.8,
                    11.7
                  ],
                  [
                    2.5,
                    11.7
                  ],
                  [
                    2.1,
                    11.6
                  ],
                  [
                    2.1,
                    11.6
                  ],
                  [
                    1.6,
                    12.1
                  ],
                  [
                    1.4,
                    12.6
                  ],
                  [
                    1.4,
                    12.6
                  ],
                  [
                    1.9,
                    13.4
                  ],
                  [
                    3.2,
                    13.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1193,
        ty: 3,
        parent: 1188,
        ks: {
          p: {
            a: 0,
            k: [
              12.809,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1196,
        ty: 4,
        parent: 1195,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -1.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.3
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.5,
                    8.5
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.2,
                    7.1
                  ],
                  [
                    3.8,
                    6.5
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    2.1,
                    6.5
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    0.9,
                    6.2
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    11.6
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    3.5,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    10.9
                  ],
                  [
                    2.7,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    8.5
                  ],
                  [
                    2.2,
                    9
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.9,
                    10.7
                  ],
                  [
                    2.7,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1195,
        ty: 3,
        parent: 1188,
        ks: {
          p: {
            a: 0,
            k: [
              6.59,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1198,
        ty: 4,
        parent: 1197,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    1.1,
                    9.8
                  ],
                  [
                    2.2,
                    10.6
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    4.6,
                    10.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    4.9,
                    8.8
                  ],
                  [
                    4.4,
                    8.4
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    2.6,
                    7.6
                  ],
                  [
                    1.8,
                    7.2
                  ],
                  [
                    1.2,
                    6.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    1.2,
                    4.4
                  ],
                  [
                    2.1,
                    3.6
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    4.8,
                    3.6
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.3,
                    5
                  ],
                  [
                    4.5,
                    4.4
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    2.4,
                    4.6
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2.2,
                    6.1
                  ],
                  [
                    2.7,
                    6.5
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    4.4,
                    7.3
                  ],
                  [
                    5.3,
                    7.7
                  ],
                  [
                    5.9,
                    8.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    5.8,
                    10.6
                  ],
                  [
                    4.8,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1197,
        ty: 3,
        parent: 1188,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1188,
        ty: 3,
        parent: 1187,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1187,
        ty: 3,
        parent: 1186,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1186,
        ty: 3,
        parent: 1185,
        ks: {
          p: {
            a: 0,
            k: [
              21.159,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1208,
        ty: 0,
        parent: 1199,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1206"
      },
      {
        ind: 1199,
        ty: 3,
        parent: 1185,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1185,
        ty: 3,
        parent: 1184,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              19.527
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1214,
        ty: 4,
        parent: 1213,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.6
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.6
                  ],
                  [
                    0.6,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    5.6,
                    11.6
                  ],
                  [
                    0.5,
                    11.6
                  ],
                  [
                    0.5,
                    11
                  ],
                  [
                    2.5,
                    8.9
                  ],
                  [
                    3.8,
                    7.3
                  ],
                  [
                    4.2,
                    5.9
                  ],
                  [
                    4.2,
                    5.9
                  ],
                  [
                    3.8,
                    4.8
                  ],
                  [
                    2.7,
                    4.4
                  ],
                  [
                    2.7,
                    4.4
                  ],
                  [
                    1.8,
                    4.7
                  ],
                  [
                    1,
                    5.3
                  ],
                  [
                    1,
                    5.3
                  ],
                  [
                    0.4,
                    4.8
                  ],
                  [
                    1.5,
                    3.9
                  ],
                  [
                    2.8,
                    3.6
                  ],
                  [
                    2.8,
                    3.6
                  ],
                  [
                    4.6,
                    4.2
                  ],
                  [
                    5.2,
                    5.9
                  ],
                  [
                    5.2,
                    5.9
                  ],
                  [
                    4.8,
                    7.4
                  ],
                  [
                    3.6,
                    9
                  ],
                  [
                    2,
                    10.8
                  ],
                  [
                    2,
                    10.8
                  ],
                  [
                    2.6,
                    10.7
                  ],
                  [
                    3.3,
                    10.7
                  ],
                  [
                    3.3,
                    10.7
                  ],
                  [
                    5.6,
                    10.7
                  ],
                  [
                    5.6,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    -0.8
                  ],
                  [
                    0.6,
                    -0.6
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1213,
        ty: 3,
        parent: 1212,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1212,
        ty: 3,
        parent: 1211,
        ks: {
          p: {
            a: 0,
            k: [
              23.15,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1217,
        ty: 4,
        parent: 1216,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    5.9,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    3.5
                  ],
                  [
                    5.8,
                    3.5
                  ],
                  [
                    5.8,
                    4.4
                  ],
                  [
                    2.1,
                    4.4
                  ],
                  [
                    2.1,
                    6.9
                  ],
                  [
                    5.2,
                    6.9
                  ],
                  [
                    5.2,
                    7.8
                  ],
                  [
                    2.1,
                    7.8
                  ],
                  [
                    2.1,
                    10.7
                  ],
                  [
                    5.9,
                    10.7
                  ],
                  [
                    5.9,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1216,
        ty: 3,
        parent: 1215,
        ks: {
          p: {
            a: 0,
            k: [
              14.179,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1219,
        ty: 4,
        parent: 1218,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    -0.7
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.7
                  ],
                  [
                    1.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    3.5
                  ],
                  [
                    3.1,
                    3.5
                  ],
                  [
                    6,
                    4.5
                  ],
                  [
                    7,
                    7.5
                  ],
                  [
                    7,
                    7.5
                  ],
                  [
                    6,
                    10.5
                  ],
                  [
                    3.2,
                    11.6
                  ],
                  [
                    3.2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1.3,
                    0
                  ],
                  [
                    0.7,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    -0.6,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.6
                  ],
                  [
                    0,
                    1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.5
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    4.3
                  ],
                  [
                    2.1,
                    10.7
                  ],
                  [
                    3.1,
                    10.7
                  ],
                  [
                    5.2,
                    9.9
                  ],
                  [
                    5.9,
                    7.5
                  ],
                  [
                    5.9,
                    7.5
                  ],
                  [
                    5.2,
                    5.2
                  ],
                  [
                    3.1,
                    4.3
                  ],
                  [
                    3.1,
                    4.3
                  ],
                  [
                    2.1,
                    4.3
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0.5,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    -0.5,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1218,
        ty: 3,
        parent: 1215,
        ks: {
          p: {
            a: 0,
            k: [
              6.59,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1221,
        ty: 4,
        parent: 1220,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    1.1,
                    9.8
                  ],
                  [
                    2.2,
                    10.6
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    4.6,
                    10.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    4.9,
                    8.8
                  ],
                  [
                    4.4,
                    8.4
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    2.6,
                    7.6
                  ],
                  [
                    1.8,
                    7.2
                  ],
                  [
                    1.2,
                    6.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    1.2,
                    4.4
                  ],
                  [
                    2.1,
                    3.6
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    4.8,
                    3.6
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.3,
                    5
                  ],
                  [
                    4.5,
                    4.4
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    2.4,
                    4.6
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2.2,
                    6.1
                  ],
                  [
                    2.7,
                    6.5
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    4.4,
                    7.3
                  ],
                  [
                    5.3,
                    7.7
                  ],
                  [
                    5.9,
                    8.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    5.8,
                    10.6
                  ],
                  [
                    4.8,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1220,
        ty: 3,
        parent: 1215,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1215,
        ty: 3,
        parent: 1211,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1211,
        ty: 3,
        parent: 1210,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.8
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1210,
        ty: 3,
        parent: 1209,
        ks: {
          p: {
            a: 0,
            k: [
              21.159,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1231,
        ty: 0,
        parent: 1222,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1229"
      },
      {
        ind: 1222,
        ty: 3,
        parent: 1209,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1209,
        ty: 3,
        parent: 1184,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1184,
        ty: 3,
        parent: 1183,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              36.053
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1237,
        ty: 4,
        parent: 1236,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    3,
                    12
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    10.6
                  ],
                  [
                    2.1,
                    10.6
                  ],
                  [
                    1.3,
                    10.3
                  ],
                  [
                    1,
                    9.5
                  ],
                  [
                    1,
                    9.5
                  ],
                  [
                    1.3,
                    8.8
                  ],
                  [
                    2.1,
                    8.5
                  ],
                  [
                    2.1,
                    8.5
                  ],
                  [
                    2.9,
                    8.8
                  ],
                  [
                    3.2,
                    9.5
                  ],
                  [
                    3.2,
                    9.5
                  ],
                  [
                    2.9,
                    10.3
                  ],
                  [
                    2.1,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1236,
        ty: 3,
        parent: 1235,
        ks: {
          p: {
            a: 0,
            k: [
              17.573,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1239,
        ty: 4,
        parent: 1238,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0.5
                  ],
                  [
                    -1.6,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    -1.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.9
                  ],
                  [
                    3,
                    19.9
                  ],
                  [
                    1.4,
                    19.3
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    1.8,
                    15.7
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5,
                    13.7
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    2.8,
                    13.5
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1,
                    12.8
                  ],
                  [
                    2.5,
                    12.1
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    6.4,
                    12.6
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    19.7
                  ],
                  [
                    5.6,
                    19.7
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    4.3,
                    19.6
                  ],
                  [
                    3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.7,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.6,
                    18.5
                  ],
                  [
                    3.6,
                    18.5
                  ],
                  [
                    4.5,
                    18.3
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    15.9
                  ],
                  [
                    3.1,
                    16.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.8,
                    18.3
                  ],
                  [
                    3.6,
                    18.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1238,
        ty: 3,
        parent: 1235,
        ks: {
          p: {
            a: 0,
            k: [
              9.389,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1241,
        ty: 4,
        parent: 1240,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.5
                  ],
                  [
                    0.6,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    19.7
                  ],
                  [
                    1.3,
                    19.7
                  ],
                  [
                    1.3,
                    9.4
                  ],
                  [
                    4.8,
                    9.4
                  ],
                  [
                    6.8,
                    9.7
                  ],
                  [
                    8.1,
                    10.6
                  ],
                  [
                    8.6,
                    12.4
                  ],
                  [
                    8.6,
                    12.4
                  ],
                  [
                    8.1,
                    14.4
                  ],
                  [
                    6.6,
                    15.4
                  ],
                  [
                    6.6,
                    15.4
                  ],
                  [
                    9,
                    19.7
                  ],
                  [
                    7,
                    19.7
                  ],
                  [
                    4.7,
                    15.7
                  ],
                  [
                    3.2,
                    15.7
                  ],
                  [
                    3.2,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.6,
                    0.2
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    10.8
                  ],
                  [
                    3.2,
                    14.2
                  ],
                  [
                    4.6,
                    14.2
                  ],
                  [
                    6.3,
                    13.8
                  ],
                  [
                    6.8,
                    12.4
                  ],
                  [
                    6.8,
                    12.4
                  ],
                  [
                    6.3,
                    11.2
                  ],
                  [
                    4.6,
                    10.8
                  ],
                  [
                    4.6,
                    10.8
                  ],
                  [
                    3.2,
                    10.8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1240,
        ty: 3,
        parent: 1235,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1235,
        ty: 3,
        parent: 1234,
        ks: {
          p: {
            a: 0,
            k: [
              49.642,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1244,
        ty: 4,
        parent: 1243,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    8.5
                  ],
                  [
                    3,
                    8.5
                  ],
                  [
                    3,
                    11.4
                  ],
                  [
                    2.9,
                    12.9
                  ],
                  [
                    4,
                    12.1
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    7.2,
                    12.6
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    19.7
                  ],
                  [
                    6,
                    19.7
                  ],
                  [
                    6,
                    15.1
                  ],
                  [
                    5.7,
                    13.7
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    3.9,
                    13.6
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1243,
        ty: 3,
        parent: 1242,
        ks: {
          p: {
            a: 0,
            k: [
              37.62,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1246,
        ty: 4,
        parent: 1245,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.4
                  ],
                  [
                    -0.9,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.4,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.5
                  ],
                  [
                    1,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    19.9
                  ],
                  [
                    3.3,
                    19.9
                  ],
                  [
                    1.7,
                    19.6
                  ],
                  [
                    0.4,
                    18.9
                  ],
                  [
                    0.4,
                    18.9
                  ],
                  [
                    1.2,
                    17.7
                  ],
                  [
                    2.3,
                    18.3
                  ],
                  [
                    3.4,
                    18.6
                  ],
                  [
                    3.4,
                    18.6
                  ],
                  [
                    4.3,
                    18.3
                  ],
                  [
                    4.6,
                    17.6
                  ],
                  [
                    4.6,
                    17.6
                  ],
                  [
                    4.4,
                    17.1
                  ],
                  [
                    3.8,
                    16.7
                  ],
                  [
                    3,
                    16.4
                  ],
                  [
                    3,
                    16.4
                  ],
                  [
                    2,
                    15.9
                  ],
                  [
                    1.1,
                    15.2
                  ],
                  [
                    0.8,
                    14.1
                  ],
                  [
                    0.8,
                    14.1
                  ],
                  [
                    1.6,
                    12.4
                  ],
                  [
                    3.6,
                    11.8
                  ],
                  [
                    3.6,
                    11.8
                  ],
                  [
                    5.1,
                    12.1
                  ],
                  [
                    6.3,
                    12.7
                  ],
                  [
                    6.3,
                    12.7
                  ],
                  [
                    5.4,
                    13.8
                  ],
                  [
                    4.6,
                    13.3
                  ],
                  [
                    3.7,
                    13.1
                  ],
                  [
                    3.7,
                    13.1
                  ],
                  [
                    2.8,
                    13.4
                  ],
                  [
                    2.5,
                    14
                  ],
                  [
                    2.5,
                    14
                  ],
                  [
                    3,
                    14.7
                  ],
                  [
                    4.1,
                    15.2
                  ],
                  [
                    4.1,
                    15.2
                  ],
                  [
                    5.2,
                    15.6
                  ],
                  [
                    6,
                    16.4
                  ],
                  [
                    6.4,
                    17.5
                  ],
                  [
                    6.4,
                    17.5
                  ],
                  [
                    5.6,
                    19.2
                  ],
                  [
                    3.3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.5,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    -0.5,
                    0.5
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1245,
        ty: 3,
        parent: 1242,
        ks: {
          p: {
            a: 0,
            k: [
              30.784,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1248,
        ty: 4,
        parent: 1247,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    3,
                    12
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    10.6
                  ],
                  [
                    2.1,
                    10.6
                  ],
                  [
                    1.3,
                    10.3
                  ],
                  [
                    1,
                    9.5
                  ],
                  [
                    1,
                    9.5
                  ],
                  [
                    1.3,
                    8.8
                  ],
                  [
                    2.1,
                    8.5
                  ],
                  [
                    2.1,
                    8.5
                  ],
                  [
                    2.9,
                    8.8
                  ],
                  [
                    3.2,
                    9.5
                  ],
                  [
                    3.2,
                    9.5
                  ],
                  [
                    2.9,
                    10.3
                  ],
                  [
                    2.1,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1247,
        ty: 3,
        parent: 1242,
        ks: {
          p: {
            a: 0,
            k: [
              26.629,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1250,
        ty: 4,
        parent: 1249,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    8.5
                  ],
                  [
                    3,
                    8.5
                  ],
                  [
                    3,
                    11.4
                  ],
                  [
                    2.9,
                    12.9
                  ],
                  [
                    4,
                    12.1
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    7.2,
                    12.6
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    19.7
                  ],
                  [
                    6,
                    19.7
                  ],
                  [
                    6,
                    15.1
                  ],
                  [
                    5.7,
                    13.7
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    3.9,
                    13.6
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1249,
        ty: 3,
        parent: 1242,
        ks: {
          p: {
            a: 0,
            k: [
              17.779,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1252,
        ty: 4,
        parent: 1251,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    -1.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.6
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    4.9,
                    19.9
                  ],
                  [
                    4.9,
                    19.9
                  ],
                  [
                    2.8,
                    18.9
                  ],
                  [
                    2.8,
                    18.9
                  ],
                  [
                    2.8,
                    18.9
                  ],
                  [
                    2.6,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    8.5
                  ],
                  [
                    3,
                    8.5
                  ],
                  [
                    3,
                    11.4
                  ],
                  [
                    2.9,
                    12.7
                  ],
                  [
                    4,
                    12
                  ],
                  [
                    5.2,
                    11.8
                  ],
                  [
                    5.2,
                    11.8
                  ],
                  [
                    7.5,
                    12.8
                  ],
                  [
                    8.3,
                    15.7
                  ],
                  [
                    8.3,
                    15.7
                  ],
                  [
                    7.8,
                    18
                  ],
                  [
                    6.6,
                    19.4
                  ],
                  [
                    4.9,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.9
                  ],
                  [
                    -0.3,
                    0.6
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    0,
                    0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    0
                  ]
                ],
                v: [
                  [
                    4.6,
                    18.4
                  ],
                  [
                    4.6,
                    18.4
                  ],
                  [
                    5.9,
                    17.7
                  ],
                  [
                    6.4,
                    15.7
                  ],
                  [
                    6.4,
                    15.7
                  ],
                  [
                    6,
                    13.9
                  ],
                  [
                    4.7,
                    13.3
                  ],
                  [
                    4.7,
                    13.3
                  ],
                  [
                    3,
                    14.1
                  ],
                  [
                    3,
                    14.1
                  ],
                  [
                    3,
                    17.8
                  ],
                  [
                    3.8,
                    18.3
                  ],
                  [
                    4.6,
                    18.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1251,
        ty: 3,
        parent: 1242,
        ks: {
          p: {
            a: 0,
            k: [
              8.85,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1254,
        ty: 4,
        parent: 1253,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.6
                  ],
                  [
                    0.1,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.6
                  ],
                  [
                    0.2,
                    -0.6
                  ]
                ],
                v: [
                  [
                    3.4,
                    14.2
                  ],
                  [
                    3.4,
                    14.2
                  ],
                  [
                    3.1,
                    15.5
                  ],
                  [
                    5.7,
                    15.5
                  ],
                  [
                    5.4,
                    14.2
                  ],
                  [
                    4.9,
                    12.5
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    3.9,
                    12.5
                  ],
                  [
                    3.4,
                    14.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.6
                  ],
                  [
                    -0.2,
                    0.6
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.8,
                    19.7
                  ],
                  [
                    0,
                    19.7
                  ],
                  [
                    3.3,
                    9.4
                  ],
                  [
                    5.5,
                    9.4
                  ],
                  [
                    8.9,
                    19.7
                  ],
                  [
                    7,
                    19.7
                  ],
                  [
                    6.1,
                    16.9
                  ],
                  [
                    2.7,
                    16.9
                  ],
                  [
                    1.8,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1253,
        ty: 3,
        parent: 1242,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1242,
        ty: 3,
        parent: 1234,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1234,
        ty: 3,
        parent: 1233,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.394
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1233,
        ty: 3,
        parent: 1232,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1232,
        ty: 3,
        parent: 1183,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1183,
        ty: 3,
        parent: 1182,
        ks: {
          p: {
            a: 0,
            k: [
              91.69,
              3.002
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1265,
        ty: 0,
        parent: 1256,
        ks: {
          a: {
            a: 0,
            k: [
              54.666,
              55.543
            ]
          },
          p: {
            a: 0,
            k: [
              54.666,
              55.543
            ]
          }
        },
        w: 21.159,
        h: 21.159,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1263"
      },
      {
        ind: 1256,
        ty: 3,
        parent: 1255,
        ks: {
          p: {
            a: 0,
            k: [
              54.666,
              55.543
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1268,
        ty: 4,
        td: 1,
        parent: 1266,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                38.792,
                38.792
              ]
            },
            r: {
              a: 0,
              k: 60
            },
            s: {
              a: 0,
              k: [
                77.584,
                77.584
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1267,
        ty: 4,
        tt: 1,
        parent: 1266,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                p: {
                  a: 0,
                  k: [
                    38.792,
                    38.792
                  ]
                },
                r: {
                  a: 0,
                  k: 0
                },
                s: {
                  a: 0,
                  k: [
                    81.992,
                    81.992
                  ]
                }
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0,
                    0,
                    0,
                    0
                  ]
                },
                o: {
                  a: 0,
                  k: 0
                }
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          },
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                p: {
                  a: 0,
                  k: [
                    38.792,
                    38.792
                  ]
                },
                r: {
                  a: 0,
                  k: 60
                },
                s: {
                  a: 0,
                  k: [
                    77.584,
                    77.584
                  ]
                }
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.427,
                    0.184,
                    0.604
                  ]
                },
                lj: 1,
                ml: 10,
                o: {
                  a: 0,
                  k: 100
                },
                w: {
                  a: 0,
                  k: 4.408
                }
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      },
      {
        ind: 1284,
        ty: 4,
        td: 1,
        parent: 1266,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                38.792,
                38.792
              ]
            },
            r: {
              a: 0,
              k: 60
            },
            s: {
              a: 0,
              k: [
                77.584,
                77.584
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1283,
        ty: 0,
        tt: 1,
        parent: 1266,
        ks: {},
        w: 71,
        h: 71,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1281"
      },
      {
        ind: 1266,
        ty: 3,
        parent: 1255,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1255,
        ty: 3,
        parent: 1182,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1182,
        ty: 3,
        parent: 1050,
        ks: {
          p: {
            a: 0,
            k: [
              10.58,
              10.58
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1285,
        ty: 4,
        parent: 1050,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                148.115,
                91.315
              ]
            },
            r: {
              a: 0,
              k: 7
            },
            s: {
              a: 0,
              k: [
                296.23,
                182.63
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                1,
                1
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1050,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1290",
    layers: [
      {
        ind: 1288,
        ty: 0,
        ks: {
          a: {
            a: 0,
            k: [
              1,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              143.629,
              142.629
            ]
          }
        },
        w: 298,
        h: 183,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1286"
      },
      {
        ind: 1289,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                291.745,
                233.944
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                583.489,
                467.888
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      }
    ]
  },
  {
    id: "1356",
    layers: [
      {
        ind: 1355,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                7,
                4.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                14,
                9
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            -0.09
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            -0.03
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.06,
                            0.02
                          ],
                          [
                            0.05,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            0.02
                          ],
                          [
                            -0.07,
                            0
                          ],
                          [
                            -0.06,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.13
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.05
                          ],
                          [
                            -0.06,
                            0.02
                          ],
                          [
                            -0.06,
                            0
                          ],
                          [
                            -0.06,
                            -0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.05
                          ],
                          [
                            0.06,
                            -0.02
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.06,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            0.09,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            10.09,
                            0.81
                          ],
                          [
                            10.09,
                            3.46
                          ],
                          [
                            9.94,
                            3.81
                          ],
                          [
                            9.59,
                            3.95
                          ],
                          [
                            9.24,
                            3.81
                          ],
                          [
                            9.09,
                            3.46
                          ],
                          [
                            9.09,
                            2.01
                          ],
                          [
                            5.97,
                            5.13
                          ],
                          [
                            5.81,
                            5.24
                          ],
                          [
                            5.62,
                            5.28
                          ],
                          [
                            5.43,
                            5.24
                          ],
                          [
                            5.27,
                            5.13
                          ],
                          [
                            3.97,
                            3.83
                          ],
                          [
                            1.34,
                            6.45
                          ],
                          [
                            0.99,
                            6.6
                          ],
                          [
                            0.64,
                            6.45
                          ],
                          [
                            0.5,
                            6.1
                          ],
                          [
                            0.64,
                            5.75
                          ],
                          [
                            3.62,
                            2.78
                          ],
                          [
                            3.78,
                            2.67
                          ],
                          [
                            3.97,
                            2.63
                          ],
                          [
                            4.16,
                            2.67
                          ],
                          [
                            4.32,
                            2.78
                          ],
                          [
                            5.62,
                            4.08
                          ],
                          [
                            8.39,
                            1.31
                          ],
                          [
                            6.95,
                            1.31
                          ],
                          [
                            6.59,
                            1.16
                          ],
                          [
                            6.45,
                            0.81
                          ],
                          [
                            6.59,
                            0.46
                          ],
                          [
                            6.95,
                            0.32
                          ],
                          [
                            9.59,
                            0.32
                          ],
                          [
                            9.94,
                            0.46
                          ],
                          [
                            10.09,
                            0.81
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.52,
                        0.32,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1359",
    layers: [
      {
        ind: 1358,
        ty: 0,
        parent: 1354,
        ks: {},
        w: 14,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1356"
      },
      {
        ind: 1354,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              2
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1367",
    layers: [
      {
        ind: 1366,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3.5,
                3.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                7,
                7
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.59,
                            0.58
                          ],
                          [
                            5.19,
                            0.58
                          ],
                          [
                            5.19,
                            5.18
                          ],
                          [
                            0.59,
                            5.18
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        1,
                        0.73,
                        0,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1372",
    layers: [
      {
        ind: 1371,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3.5,
                3.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                7,
                7
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                0,
                                0.58
                              ],
                              [
                                4.6,
                                0.58
                              ],
                              [
                                4.6,
                                5.18
                              ],
                              [
                                0,
                                5.18
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0,
                            0.64,
                            0.94,
                            1
                          ]
                        },
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1377",
    layers: [
      {
        ind: 1376,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3.5,
                3.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                7,
                7
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                0.59,
                                0
                              ],
                              [
                                5.19,
                                0
                              ],
                              [
                                5.19,
                                4.6
                              ],
                              [
                                0.59,
                                4.6
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0.5,
                            0.73,
                            0,
                            1
                          ]
                        },
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1382",
    layers: [
      {
        ind: 1381,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3.5,
                3.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                7,
                7
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0,
                            0
                          ],
                          [
                            4.6,
                            0
                          ],
                          [
                            4.6,
                            4.6
                          ],
                          [
                            0,
                            4.6
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.95,
                        0.31,
                        0.13,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1387",
    layers: [
      {
        ind: 1386,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                22.5,
                4.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                45,
                9
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.14,
                            0.31
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            0.31
                          ],
                          [
                            0.01,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            -0.23
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            -0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.22
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            0.22
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            0.43
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            4.01,
                            4.08
                          ],
                          [
                            3.73,
                            4.84
                          ],
                          [
                            3.71,
                            4.84
                          ],
                          [
                            3.45,
                            4.09
                          ],
                          [
                            2,
                            0.45
                          ],
                          [
                            0.58,
                            0.45
                          ],
                          [
                            0.58,
                            6.25
                          ],
                          [
                            1.52,
                            6.25
                          ],
                          [
                            1.52,
                            2.67
                          ],
                          [
                            1.51,
                            1.88
                          ],
                          [
                            1.48,
                            1.51
                          ],
                          [
                            1.51,
                            1.51
                          ],
                          [
                            1.64,
                            2
                          ],
                          [
                            3.38,
                            6.24
                          ],
                          [
                            4.04,
                            6.24
                          ],
                          [
                            5.77,
                            1.97
                          ],
                          [
                            5.88,
                            1.51
                          ],
                          [
                            5.91,
                            1.51
                          ],
                          [
                            5.86,
                            2.55
                          ],
                          [
                            5.86,
                            6.23
                          ],
                          [
                            6.86,
                            6.23
                          ],
                          [
                            6.86,
                            0.44
                          ],
                          [
                            5.49,
                            0.44
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.8,
                            2.07
                          ],
                          [
                            8.78,
                            2.07
                          ],
                          [
                            8.78,
                            6.23
                          ],
                          [
                            7.8,
                            6.23
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            -0.11
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            -0.11,
                            -0.11
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            -0.11,
                            0.1
                          ],
                          [
                            0,
                            0.16
                          ],
                          [
                            0.11,
                            0.11
                          ],
                          [
                            0.17,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.16,
                            0
                          ],
                          [
                            -0.11,
                            0.11
                          ],
                          [
                            0,
                            0.16
                          ],
                          [
                            0.11,
                            0.11
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.11,
                            -0.11
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            -0.1,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            8.3,
                            0.32
                          ],
                          [
                            7.89,
                            0.48
                          ],
                          [
                            7.71,
                            0.89
                          ],
                          [
                            7.89,
                            1.29
                          ],
                          [
                            8.3,
                            1.44
                          ],
                          [
                            8.71,
                            1.29
                          ],
                          [
                            8.89,
                            0.89
                          ],
                          [
                            8.71,
                            0.48
                          ],
                          [
                            8.3,
                            0.32
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0.34,
                            -0.2
                          ],
                          [
                            0.17,
                            -0.34
                          ],
                          [
                            0,
                            -0.46
                          ],
                          [
                            -0.17,
                            -0.32
                          ],
                          [
                            -0.32,
                            -0.17
                          ],
                          [
                            -0.4,
                            0
                          ],
                          [
                            -0.32,
                            0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.17,
                            -0.05
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0.21,
                            0.25
                          ],
                          [
                            0,
                            0.41
                          ],
                          [
                            -0.23,
                            0.25
                          ],
                          [
                            -0.37,
                            0
                          ],
                          [
                            -0.29,
                            -0.21
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.04
                          ]
                        ],
                        o: [
                          [
                            -0.18,
                            -0.04
                          ],
                          [
                            -0.45,
                            0
                          ],
                          [
                            -0.34,
                            0.2
                          ],
                          [
                            -0.18,
                            0.35
                          ],
                          [
                            0,
                            0.4
                          ],
                          [
                            0.17,
                            0.31
                          ],
                          [
                            0.31,
                            0.17
                          ],
                          [
                            0.47,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            0.11
                          ],
                          [
                            -0.17,
                            0.06
                          ],
                          [
                            -0.39,
                            0
                          ],
                          [
                            -0.23,
                            -0.24
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0.23,
                            -0.25
                          ],
                          [
                            0.32,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            12.24,
                            2.04
                          ],
                          [
                            11.7,
                            1.98
                          ],
                          [
                            10.51,
                            2.27
                          ],
                          [
                            9.73,
                            3.07
                          ],
                          [
                            9.46,
                            4.27
                          ],
                          [
                            9.72,
                            5.35
                          ],
                          [
                            10.45,
                            6.09
                          ],
                          [
                            11.53,
                            6.35
                          ],
                          [
                            12.71,
                            6.07
                          ],
                          [
                            12.71,
                            6.07
                          ],
                          [
                            12.71,
                            5.17
                          ],
                          [
                            12.68,
                            5.2
                          ],
                          [
                            12.2,
                            5.45
                          ],
                          [
                            11.74,
                            5.54
                          ],
                          [
                            10.82,
                            5.17
                          ],
                          [
                            10.48,
                            4.19
                          ],
                          [
                            10.83,
                            3.18
                          ],
                          [
                            11.75,
                            2.8
                          ],
                          [
                            12.68,
                            3.12
                          ],
                          [
                            12.71,
                            3.15
                          ],
                          [
                            12.71,
                            2.19
                          ],
                          [
                            12.71,
                            2.19
                          ],
                          [
                            12.24,
                            2.04
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            -0.16
                          ],
                          [
                            0.1,
                            -0.23
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.21
                          ],
                          [
                            -0.25,
                            0
                          ],
                          [
                            -0.11,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.17,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.16,
                            0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.36
                          ],
                          [
                            0.16,
                            -0.23
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.11,
                            0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            15.46,
                            2
                          ],
                          [
                            14.8,
                            2.24
                          ],
                          [
                            14.43,
                            2.8
                          ],
                          [
                            14.42,
                            2.8
                          ],
                          [
                            14.42,
                            2.07
                          ],
                          [
                            13.44,
                            2.07
                          ],
                          [
                            13.44,
                            6.23
                          ],
                          [
                            14.42,
                            6.23
                          ],
                          [
                            14.42,
                            4.11
                          ],
                          [
                            14.66,
                            3.23
                          ],
                          [
                            15.29,
                            2.89
                          ],
                          [
                            15.58,
                            2.93
                          ],
                          [
                            15.82,
                            3.03
                          ],
                          [
                            15.85,
                            3.05
                          ],
                          [
                            15.85,
                            2.08
                          ],
                          [
                            15.83,
                            2.07
                          ],
                          [
                            15.46,
                            2
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.38,
                            -0.39
                          ],
                          [
                            0,
                            -0.69
                          ],
                          [
                            -0.37,
                            -0.38
                          ],
                          [
                            -0.64,
                            0
                          ],
                          [
                            -0.38,
                            0.4
                          ],
                          [
                            0,
                            0.67
                          ],
                          [
                            0.37,
                            0.38
                          ],
                          [
                            0.64,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.68,
                            0
                          ],
                          [
                            -0.39,
                            0.4
                          ],
                          [
                            0,
                            0.65
                          ],
                          [
                            0.38,
                            0.38
                          ],
                          [
                            0.67,
                            0
                          ],
                          [
                            0.39,
                            -0.41
                          ],
                          [
                            0,
                            -0.66
                          ],
                          [
                            -0.35,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            18.12,
                            1.98
                          ],
                          [
                            16.51,
                            2.58
                          ],
                          [
                            15.93,
                            4.22
                          ],
                          [
                            16.5,
                            5.77
                          ],
                          [
                            18.02,
                            6.34
                          ],
                          [
                            19.61,
                            5.74
                          ],
                          [
                            20.18,
                            4.12
                          ],
                          [
                            19.64,
                            2.55
                          ],
                          [
                            18.12,
                            1.98
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.36,
                            0
                          ],
                          [
                            0.2,
                            0.25
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            -0.2,
                            0.24
                          ],
                          [
                            -0.35,
                            0
                          ],
                          [
                            -0.2,
                            -0.23
                          ],
                          [
                            0,
                            -0.44
                          ],
                          [
                            0.19,
                            -0.23
                          ]
                        ],
                        o: [
                          [
                            -0.18,
                            0.23
                          ],
                          [
                            -0.35,
                            0
                          ],
                          [
                            -0.2,
                            -0.23
                          ],
                          [
                            0,
                            -0.44
                          ],
                          [
                            0.2,
                            -0.24
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.2,
                            0.23
                          ],
                          [
                            -0.02,
                            0.45
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            18.9,
                            5.18
                          ],
                          [
                            18.08,
                            5.53
                          ],
                          [
                            17.24,
                            5.17
                          ],
                          [
                            16.94,
                            4.17
                          ],
                          [
                            17.24,
                            3.15
                          ],
                          [
                            18.07,
                            2.79
                          ],
                          [
                            18.89,
                            3.13
                          ],
                          [
                            19.19,
                            4.14
                          ],
                          [
                            18.9,
                            5.18
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0.08
                          ],
                          [
                            0,
                            0.14
                          ],
                          [
                            -0.11,
                            0.08
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.17,
                            -0.05
                          ],
                          [
                            -0.12,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.04
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.3,
                            -0.25
                          ],
                          [
                            0,
                            -0.37
                          ],
                          [
                            -0.07,
                            -0.14
                          ],
                          [
                            -0.14,
                            -0.11
                          ],
                          [
                            -0.27,
                            -0.11
                          ],
                          [
                            -0.11,
                            -0.06
                          ],
                          [
                            -0.05,
                            -0.05
                          ],
                          [
                            0,
                            -0.1
                          ],
                          [
                            0.43,
                            0
                          ],
                          [
                            0.2,
                            0.07
                          ],
                          [
                            0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            -0.05
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            -0.29,
                            0.25
                          ],
                          [
                            0,
                            0.4
                          ],
                          [
                            0.16,
                            0.19
                          ],
                          [
                            0.39,
                            0.15
                          ]
                        ],
                        o: [
                          [
                            -0.31,
                            -0.13
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.11
                          ],
                          [
                            0.11,
                            -0.07
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.16,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.11,
                            -0.05
                          ],
                          [
                            -0.18,
                            -0.03
                          ],
                          [
                            -0.46,
                            0
                          ],
                          [
                            -0.3,
                            0.23
                          ],
                          [
                            0,
                            0.2
                          ],
                          [
                            0.07,
                            0.14
                          ],
                          [
                            0.14,
                            0.11
                          ],
                          [
                            0.23,
                            0.1
                          ],
                          [
                            0.11,
                            0.06
                          ],
                          [
                            0.04,
                            0.06
                          ],
                          [
                            0,
                            0.28
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            -0.2,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.14,
                            0.07
                          ],
                          [
                            0.21,
                            0.04
                          ],
                          [
                            0.5,
                            0
                          ],
                          [
                            0.3,
                            -0.24
                          ],
                          [
                            0,
                            -0.28
                          ],
                          [
                            -0.22,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            22.36,
                            3.8
                          ],
                          [
                            21.77,
                            3.49
                          ],
                          [
                            21.66,
                            3.18
                          ],
                          [
                            21.81,
                            2.88
                          ],
                          [
                            22.24,
                            2.76
                          ],
                          [
                            22.75,
                            2.84
                          ],
                          [
                            23.18,
                            3.04
                          ],
                          [
                            23.22,
                            3.07
                          ],
                          [
                            23.22,
                            2.16
                          ],
                          [
                            23.2,
                            2.15
                          ],
                          [
                            22.75,
                            2.02
                          ],
                          [
                            22.27,
                            1.98
                          ],
                          [
                            21.13,
                            2.34
                          ],
                          [
                            20.68,
                            3.25
                          ],
                          [
                            20.78,
                            3.76
                          ],
                          [
                            21.08,
                            4.15
                          ],
                          [
                            21.68,
                            4.49
                          ],
                          [
                            22.18,
                            4.72
                          ],
                          [
                            22.41,
                            4.9
                          ],
                          [
                            22.47,
                            5.14
                          ],
                          [
                            21.83,
                            5.55
                          ],
                          [
                            21.29,
                            5.45
                          ],
                          [
                            20.74,
                            5.17
                          ],
                          [
                            20.7,
                            5.14
                          ],
                          [
                            20.7,
                            6.1
                          ],
                          [
                            20.73,
                            6.11
                          ],
                          [
                            21.25,
                            6.27
                          ],
                          [
                            21.81,
                            6.34
                          ],
                          [
                            23.02,
                            5.98
                          ],
                          [
                            23.48,
                            5.03
                          ],
                          [
                            23.24,
                            4.32
                          ],
                          [
                            22.36,
                            3.8
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.38,
                            -0.39
                          ],
                          [
                            0,
                            -0.69
                          ],
                          [
                            -0.37,
                            -0.38
                          ],
                          [
                            -0.64,
                            0
                          ],
                          [
                            -0.38,
                            0.4
                          ],
                          [
                            0,
                            0.67
                          ],
                          [
                            0.37,
                            0.38
                          ],
                          [
                            0.65,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.68,
                            0
                          ],
                          [
                            -0.38,
                            0.4
                          ],
                          [
                            0,
                            0.65
                          ],
                          [
                            0.38,
                            0.38
                          ],
                          [
                            0.67,
                            0
                          ],
                          [
                            0.39,
                            -0.41
                          ],
                          [
                            0,
                            -0.66
                          ],
                          [
                            -0.36,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            26.05,
                            1.98
                          ],
                          [
                            24.44,
                            2.58
                          ],
                          [
                            23.86,
                            4.22
                          ],
                          [
                            24.43,
                            5.77
                          ],
                          [
                            25.96,
                            6.34
                          ],
                          [
                            27.54,
                            5.74
                          ],
                          [
                            28.12,
                            4.12
                          ],
                          [
                            27.57,
                            2.55
                          ],
                          [
                            26.05,
                            1.98
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.2,
                            0.25
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            -0.2,
                            0.24
                          ],
                          [
                            -0.35,
                            0
                          ],
                          [
                            -0.19,
                            -0.23
                          ],
                          [
                            0,
                            -0.44
                          ],
                          [
                            0.19,
                            -0.23
                          ]
                        ],
                        o: [
                          [
                            -0.18,
                            0.23
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.2,
                            -0.23
                          ],
                          [
                            0,
                            -0.44
                          ],
                          [
                            0.2,
                            -0.24
                          ],
                          [
                            0.34,
                            0
                          ],
                          [
                            0.2,
                            0.23
                          ],
                          [
                            0,
                            0.45
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            26.83,
                            5.18
                          ],
                          [
                            26.01,
                            5.53
                          ],
                          [
                            25.17,
                            5.17
                          ],
                          [
                            24.87,
                            4.17
                          ],
                          [
                            25.17,
                            3.15
                          ],
                          [
                            26,
                            2.79
                          ],
                          [
                            26.81,
                            3.13
                          ],
                          [
                            27.11,
                            4.14
                          ],
                          [
                            26.83,
                            5.18
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.11,
                            0.12
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.16,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0
                          ],
                          [
                            0.23,
                            -0.11
                          ],
                          [
                            0.13,
                            -0.23
                          ],
                          [
                            0,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.82,
                            0
                          ],
                          [
                            -0.14,
                            0.02
                          ],
                          [
                            -0.06,
                            0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            -0.02
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0.1,
                            0.11
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.24
                          ],
                          [
                            0.11,
                            -0.12
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            -0.04
                          ],
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.23,
                            0.13
                          ],
                          [
                            -0.13,
                            0.22
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.88
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0.14,
                            -0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            0.04
                          ],
                          [
                            -0.07,
                            0.02
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.09,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            33.34,
                            2.88
                          ],
                          [
                            33.34,
                            2.07
                          ],
                          [
                            32.36,
                            2.07
                          ],
                          [
                            32.36,
                            0.84
                          ],
                          [
                            32.32,
                            0.85
                          ],
                          [
                            31.39,
                            1.13
                          ],
                          [
                            31.37,
                            1.13
                          ],
                          [
                            31.37,
                            2.07
                          ],
                          [
                            29.9,
                            2.07
                          ],
                          [
                            29.9,
                            1.55
                          ],
                          [
                            30.07,
                            1
                          ],
                          [
                            30.52,
                            0.82
                          ],
                          [
                            30.96,
                            0.92
                          ],
                          [
                            31,
                            0.94
                          ],
                          [
                            31,
                            0.09
                          ],
                          [
                            30.97,
                            0.08
                          ],
                          [
                            30.43,
                            0.01
                          ],
                          [
                            29.64,
                            0.19
                          ],
                          [
                            29.11,
                            0.72
                          ],
                          [
                            28.92,
                            1.5
                          ],
                          [
                            28.92,
                            2.07
                          ],
                          [
                            28.23,
                            2.07
                          ],
                          [
                            28.23,
                            2.87
                          ],
                          [
                            28.92,
                            2.87
                          ],
                          [
                            28.92,
                            6.23
                          ],
                          [
                            29.9,
                            6.23
                          ],
                          [
                            29.9,
                            2.88
                          ],
                          [
                            31.37,
                            2.88
                          ],
                          [
                            31.37,
                            5.02
                          ],
                          [
                            32.61,
                            6.34
                          ],
                          [
                            33.02,
                            6.29
                          ],
                          [
                            33.33,
                            6.2
                          ],
                          [
                            33.34,
                            6.19
                          ],
                          [
                            33.34,
                            5.38
                          ],
                          [
                            33.3,
                            5.41
                          ],
                          [
                            33.1,
                            5.5
                          ],
                          [
                            32.9,
                            5.54
                          ],
                          [
                            32.48,
                            5.38
                          ],
                          [
                            32.34,
                            4.84
                          ],
                          [
                            32.34,
                            2.88
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.45,
                        0.45,
                        0.45,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1390",
    layers: [
      {
        ind: 1369,
        ty: 0,
        parent: 1365,
        ks: {},
        w: 7,
        h: 7,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1367"
      },
      {
        ind: 1365,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              6,
              6
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1374,
        ty: 0,
        parent: 1370,
        ks: {},
        w: 7,
        h: 7,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1372"
      },
      {
        ind: 1370,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              6
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1379,
        ty: 0,
        parent: 1375,
        ks: {},
        w: 7,
        h: 7,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1377"
      },
      {
        ind: 1375,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              6,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1384,
        ty: 0,
        parent: 1380,
        ks: {},
        w: 7,
        h: 7,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1382"
      },
      {
        ind: 1380,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1389,
        ty: 0,
        parent: 1385,
        ks: {},
        w: 45,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1387"
      },
      {
        ind: 1385,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              16,
              2
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1420",
    layers: [
      {
        ind: 1419,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                12,
                6.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                24,
                13
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.12
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.12
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.12
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            -0.06
                          ],
                          [
                            0,
                            -0.06
                          ],
                          [
                            0.02,
                            -0.05
                          ],
                          [
                            0.04,
                            -0.04
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.12
                          ],
                          [
                            0.09,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.12
                          ],
                          [
                            0.09,
                            -0.09
                          ],
                          [
                            0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            0.04
                          ],
                          [
                            0.02,
                            0.05
                          ],
                          [
                            0,
                            0.06
                          ],
                          [
                            -0.02,
                            0.06
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.25,
                            4.9
                          ],
                          [
                            13.13,
                            9.03
                          ],
                          [
                            12.8,
                            9.16
                          ],
                          [
                            12.48,
                            9.03
                          ],
                          [
                            12.34,
                            8.7
                          ],
                          [
                            12.48,
                            8.38
                          ],
                          [
                            15.82,
                            5.04
                          ],
                          [
                            0.46,
                            5.04
                          ],
                          [
                            0.13,
                            4.9
                          ],
                          [
                            0,
                            4.58
                          ],
                          [
                            0.13,
                            4.26
                          ],
                          [
                            0.46,
                            4.12
                          ],
                          [
                            15.82,
                            4.12
                          ],
                          [
                            12.48,
                            0.78
                          ],
                          [
                            12.34,
                            0.46
                          ],
                          [
                            12.48,
                            0.13
                          ],
                          [
                            12.8,
                            0
                          ],
                          [
                            13.13,
                            0.13
                          ],
                          [
                            17.25,
                            4.26
                          ],
                          [
                            17.35,
                            4.41
                          ],
                          [
                            17.38,
                            4.58
                          ],
                          [
                            17.35,
                            4.75
                          ],
                          [
                            17.25,
                            4.9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.57,
                        0.63,
                        0.72,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1426",
    layers: [
      {
        ind: 1425,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                56,
                9.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                112,
                19
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            0.38
                          ],
                          [
                            0.11,
                            0.4
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            -0.39
                          ],
                          [
                            0.13,
                            -0.39
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.12,
                            -0.39
                          ],
                          [
                            -0.11,
                            -0.39
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.11,
                            0.4
                          ],
                          [
                            -0.11,
                            0.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            2.15,
                            7.36
                          ],
                          [
                            1.82,
                            8.42
                          ],
                          [
                            3.9,
                            8.42
                          ],
                          [
                            3.57,
                            7.36
                          ],
                          [
                            3.21,
                            6.2
                          ],
                          [
                            2.88,
                            5.02
                          ],
                          [
                            2.84,
                            5.02
                          ],
                          [
                            2.51,
                            6.2
                          ],
                          [
                            2.15,
                            7.36
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.03,
                            11.24
                          ],
                          [
                            2.38,
                            4.3
                          ],
                          [
                            3.38,
                            4.3
                          ],
                          [
                            5.72,
                            11.24
                          ],
                          [
                            4.78,
                            11.24
                          ],
                          [
                            4.13,
                            9.13
                          ],
                          [
                            1.6,
                            9.13
                          ],
                          [
                            0.93,
                            11.24
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.39,
                            0.47
                          ],
                          [
                            0,
                            0.86
                          ],
                          [
                            -0.2,
                            0.4
                          ],
                          [
                            -0.34,
                            0.22
                          ],
                          [
                            -0.39,
                            0
                          ],
                          [
                            -0.22,
                            -0.11
                          ],
                          [
                            -0.22,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.27,
                            -0.15
                          ],
                          [
                            0.3,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.64,
                            0
                          ],
                          [
                            -0.39,
                            -0.47
                          ],
                          [
                            0,
                            -0.55
                          ],
                          [
                            0.21,
                            -0.41
                          ],
                          [
                            0.35,
                            -0.22
                          ],
                          [
                            0.3,
                            0
                          ],
                          [
                            0.22,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.2
                          ],
                          [
                            -0.27,
                            0.14
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            8.38,
                            11.37
                          ],
                          [
                            6.83,
                            10.67
                          ],
                          [
                            6.25,
                            8.68
                          ],
                          [
                            6.56,
                            7.24
                          ],
                          [
                            7.38,
                            6.3
                          ],
                          [
                            8.48,
                            5.97
                          ],
                          [
                            9.26,
                            6.13
                          ],
                          [
                            9.92,
                            6.57
                          ],
                          [
                            9.88,
                            5.69
                          ],
                          [
                            9.88,
                            3.71
                          ],
                          [
                            10.76,
                            3.71
                          ],
                          [
                            10.76,
                            11.24
                          ],
                          [
                            10.04,
                            11.24
                          ],
                          [
                            9.96,
                            10.64
                          ],
                          [
                            9.93,
                            10.64
                          ],
                          [
                            9.23,
                            11.16
                          ],
                          [
                            8.38,
                            11.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.42,
                            0.47
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.08
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0.22,
                            -0.17
                          ],
                          [
                            0.13,
                            -0.3
                          ],
                          [
                            0,
                            -0.4
                          ],
                          [
                            -0.25,
                            -0.36
                          ],
                          [
                            -0.45,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.45,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            -0.2
                          ],
                          [
                            -0.2,
                            -0.08
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.22,
                            0.16
                          ],
                          [
                            -0.13,
                            0.29
                          ],
                          [
                            0,
                            0.61
                          ],
                          [
                            0.25,
                            0.34
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            8.57,
                            10.64
                          ],
                          [
                            9.88,
                            9.93
                          ],
                          [
                            9.88,
                            7.24
                          ],
                          [
                            9.25,
                            6.83
                          ],
                          [
                            8.63,
                            6.7
                          ],
                          [
                            7.88,
                            6.96
                          ],
                          [
                            7.35,
                            7.64
                          ],
                          [
                            7.15,
                            8.67
                          ],
                          [
                            7.52,
                            10.12
                          ],
                          [
                            8.57,
                            10.64
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.37,
                            0.21
                          ],
                          [
                            0.23,
                            0.4
                          ],
                          [
                            0,
                            0.57
                          ],
                          [
                            -0.22,
                            0.4
                          ],
                          [
                            -0.36,
                            0.21
                          ],
                          [
                            -0.41,
                            0
                          ],
                          [
                            -0.36,
                            -0.21
                          ],
                          [
                            -0.22,
                            -0.4
                          ],
                          [
                            0,
                            -0.58
                          ],
                          [
                            0.23,
                            -0.4
                          ],
                          [
                            0.36,
                            -0.21
                          ],
                          [
                            0.43,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.41,
                            0
                          ],
                          [
                            -0.36,
                            -0.21
                          ],
                          [
                            -0.22,
                            -0.4
                          ],
                          [
                            0,
                            -0.58
                          ],
                          [
                            0.23,
                            -0.4
                          ],
                          [
                            0.37,
                            -0.21
                          ],
                          [
                            0.43,
                            0
                          ],
                          [
                            0.36,
                            0.21
                          ],
                          [
                            0.23,
                            0.4
                          ],
                          [
                            0,
                            0.57
                          ],
                          [
                            -0.22,
                            0.4
                          ],
                          [
                            -0.36,
                            0.21
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            14.49,
                            11.37
                          ],
                          [
                            13.32,
                            11.05
                          ],
                          [
                            12.44,
                            10.13
                          ],
                          [
                            12.11,
                            8.68
                          ],
                          [
                            12.44,
                            7.21
                          ],
                          [
                            13.32,
                            6.29
                          ],
                          [
                            14.49,
                            5.97
                          ],
                          [
                            15.66,
                            6.29
                          ],
                          [
                            16.53,
                            7.21
                          ],
                          [
                            16.87,
                            8.68
                          ],
                          [
                            16.53,
                            10.13
                          ],
                          [
                            15.66,
                            11.05
                          ],
                          [
                            14.49,
                            11.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.27,
                            0.36
                          ],
                          [
                            0,
                            0.59
                          ],
                          [
                            0.27,
                            0.37
                          ],
                          [
                            0.45,
                            0
                          ],
                          [
                            0.27,
                            -0.37
                          ],
                          [
                            0,
                            -0.59
                          ],
                          [
                            -0.27,
                            -0.37
                          ],
                          [
                            -0.43,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.45,
                            0
                          ],
                          [
                            0.27,
                            -0.37
                          ],
                          [
                            0,
                            -0.59
                          ],
                          [
                            -0.27,
                            -0.37
                          ],
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.27,
                            0.37
                          ],
                          [
                            0,
                            0.59
                          ],
                          [
                            0.27,
                            0.36
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            14.49,
                            10.65
                          ],
                          [
                            15.56,
                            10.11
                          ],
                          [
                            15.97,
                            8.68
                          ],
                          [
                            15.56,
                            7.24
                          ],
                          [
                            14.49,
                            6.69
                          ],
                          [
                            13.42,
                            7.24
                          ],
                          [
                            13.01,
                            8.68
                          ],
                          [
                            13.42,
                            10.11
                          ],
                          [
                            14.49,
                            10.65
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.26,
                            0.11
                          ],
                          [
                            0.23,
                            0.21
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.27,
                            0.13
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.35,
                            -0.47
                          ],
                          [
                            0,
                            -0.8
                          ],
                          [
                            0.21,
                            -0.41
                          ],
                          [
                            0.34,
                            -0.22
                          ],
                          [
                            0.39,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.25,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            -0.2
                          ],
                          [
                            0.28,
                            -0.14
                          ],
                          [
                            0.67,
                            0
                          ],
                          [
                            0.34,
                            0.47
                          ],
                          [
                            0,
                            0.59
                          ],
                          [
                            -0.2,
                            0.42
                          ],
                          [
                            -0.33,
                            0.22
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            20.5,
                            11.37
                          ],
                          [
                            19.75,
                            11.2
                          ],
                          [
                            19.03,
                            10.71
                          ],
                          [
                            19,
                            10.71
                          ],
                          [
                            18.92,
                            11.24
                          ],
                          [
                            18.23,
                            11.24
                          ],
                          [
                            18.23,
                            3.71
                          ],
                          [
                            19.09,
                            3.71
                          ],
                          [
                            19.09,
                            5.76
                          ],
                          [
                            19.07,
                            6.69
                          ],
                          [
                            19.83,
                            6.18
                          ],
                          [
                            20.68,
                            5.97
                          ],
                          [
                            22.2,
                            6.68
                          ],
                          [
                            22.72,
                            8.59
                          ],
                          [
                            22.4,
                            10.09
                          ],
                          [
                            21.59,
                            11.04
                          ],
                          [
                            20.5,
                            11.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.27,
                            0.36
                          ],
                          [
                            0,
                            0.63
                          ],
                          [
                            0.21,
                            0.35
                          ],
                          [
                            0.48,
                            0
                          ],
                          [
                            0.23,
                            -0.12
                          ],
                          [
                            0.25,
                            -0.23
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            -0.08
                          ],
                          [
                            -0.17,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.42,
                            0
                          ],
                          [
                            0.28,
                            -0.37
                          ],
                          [
                            0,
                            -0.57
                          ],
                          [
                            -0.2,
                            -0.35
                          ],
                          [
                            -0.22,
                            0
                          ],
                          [
                            -0.23,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.22,
                            0.2
                          ],
                          [
                            0.23,
                            0.08
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            20.35,
                            10.64
                          ],
                          [
                            21.4,
                            10.1
                          ],
                          [
                            21.82,
                            8.6
                          ],
                          [
                            21.5,
                            7.23
                          ],
                          [
                            20.47,
                            6.7
                          ],
                          [
                            19.8,
                            6.88
                          ],
                          [
                            19.09,
                            7.4
                          ],
                          [
                            19.09,
                            10.1
                          ],
                          [
                            19.76,
                            10.52
                          ],
                          [
                            20.35,
                            10.64
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.37,
                            0.21
                          ],
                          [
                            0.22,
                            0.4
                          ],
                          [
                            0,
                            0.56
                          ],
                          [
                            -0.22,
                            0.4
                          ],
                          [
                            -0.35,
                            0.22
                          ],
                          [
                            -0.39,
                            0
                          ],
                          [
                            -0.35,
                            -0.44
                          ],
                          [
                            0,
                            -0.73
                          ],
                          [
                            0.01,
                            -0.09
                          ],
                          [
                            0.01,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.3,
                            -0.32
                          ],
                          [
                            -0.49,
                            0
                          ],
                          [
                            -0.21,
                            0.07
                          ],
                          [
                            -0.19,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.28,
                            -0.11
                          ],
                          [
                            0.35,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.46,
                            0
                          ],
                          [
                            -0.37,
                            -0.22
                          ],
                          [
                            -0.22,
                            -0.4
                          ],
                          [
                            0,
                            -0.56
                          ],
                          [
                            0.23,
                            -0.4
                          ],
                          [
                            0.35,
                            -0.22
                          ],
                          [
                            0.66,
                            0
                          ],
                          [
                            0.36,
                            0.44
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            0,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            0.54
                          ],
                          [
                            0.31,
                            0.32
                          ],
                          [
                            0.25,
                            0
                          ],
                          [
                            0.21,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.14
                          ],
                          [
                            -0.27,
                            0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            26.16,
                            11.37
                          ],
                          [
                            24.91,
                            11.05
                          ],
                          [
                            24.02,
                            10.12
                          ],
                          [
                            23.69,
                            8.68
                          ],
                          [
                            24.02,
                            7.23
                          ],
                          [
                            24.89,
                            6.3
                          ],
                          [
                            26,
                            5.97
                          ],
                          [
                            27.51,
                            6.63
                          ],
                          [
                            28.05,
                            8.38
                          ],
                          [
                            28.04,
                            8.66
                          ],
                          [
                            28.02,
                            8.88
                          ],
                          [
                            24.55,
                            8.88
                          ],
                          [
                            25.05,
                            10.18
                          ],
                          [
                            26.26,
                            10.67
                          ],
                          [
                            26.94,
                            10.56
                          ],
                          [
                            27.54,
                            10.27
                          ],
                          [
                            27.85,
                            10.84
                          ],
                          [
                            27.1,
                            11.21
                          ],
                          [
                            26.16,
                            11.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0.27
                          ],
                          [
                            0.4,
                            0
                          ],
                          [
                            0.29,
                            -0.28
                          ],
                          [
                            0.05,
                            -0.51
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.52
                          ],
                          [
                            -0.22,
                            -0.28
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.28,
                            0.28
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            24.54,
                            8.26
                          ],
                          [
                            27.29,
                            8.26
                          ],
                          [
                            26.95,
                            7.07
                          ],
                          [
                            26.02,
                            6.66
                          ],
                          [
                            25.05,
                            7.08
                          ],
                          [
                            24.54,
                            8.26
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.17,
                        0.28,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1431",
    layers: [
      {
        ind: 1430,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                40.5,
                7.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                81,
                15
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.34,
                            -0.11
                          ],
                          [
                            -0.19,
                            -0.27
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            0.41,
                            -0.31
                          ],
                          [
                            0.67,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.46,
                            0
                          ],
                          [
                            0.34,
                            0.11
                          ],
                          [
                            0.19,
                            0.26
                          ],
                          [
                            0,
                            0.63
                          ],
                          [
                            -0.41,
                            0.31
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.83,
                            9
                          ],
                          [
                            0.83,
                            2.93
                          ],
                          [
                            2.56,
                            2.93
                          ],
                          [
                            3.76,
                            3.09
                          ],
                          [
                            4.55,
                            3.66
                          ],
                          [
                            4.84,
                            4.71
                          ],
                          [
                            4.22,
                            6.13
                          ],
                          [
                            2.6,
                            6.59
                          ],
                          [
                            1.6,
                            6.59
                          ],
                          [
                            1.6,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.25,
                            0.2
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            0.27,
                            0.16
                          ],
                          [
                            0.53,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0.53,
                            0
                          ],
                          [
                            0.26,
                            -0.2
                          ],
                          [
                            0,
                            -0.44
                          ],
                          [
                            -0.26,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.6,
                            5.96
                          ],
                          [
                            2.51,
                            5.96
                          ],
                          [
                            3.68,
                            5.67
                          ],
                          [
                            4.07,
                            4.71
                          ],
                          [
                            3.66,
                            3.81
                          ],
                          [
                            2.47,
                            3.55
                          ],
                          [
                            1.6,
                            3.55
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.16
                          ],
                          [
                            -0.25,
                            0
                          ],
                          [
                            -0.14,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0.01
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.15,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.29
                          ],
                          [
                            0.22,
                            -0.17
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.06,
                            -0.01
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            6,
                            9
                          ],
                          [
                            6,
                            4.5
                          ],
                          [
                            6.63,
                            4.5
                          ],
                          [
                            6.7,
                            5.32
                          ],
                          [
                            6.72,
                            5.32
                          ],
                          [
                            7.29,
                            4.64
                          ],
                          [
                            8,
                            4.39
                          ],
                          [
                            8.48,
                            4.48
                          ],
                          [
                            8.34,
                            5.15
                          ],
                          [
                            8.13,
                            5.09
                          ],
                          [
                            7.9,
                            5.07
                          ],
                          [
                            7.3,
                            5.3
                          ],
                          [
                            6.76,
                            6.11
                          ],
                          [
                            6.76,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.33,
                            0.19
                          ],
                          [
                            0.19,
                            0.35
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.19,
                            0.35
                          ],
                          [
                            -0.31,
                            0.19
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.31,
                            -0.38
                          ],
                          [
                            0,
                            -0.64
                          ],
                          [
                            0,
                            -0.08
                          ],
                          [
                            0.01,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.26,
                            -0.29
                          ],
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.18,
                            0.06
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.09
                          ],
                          [
                            0.31,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.4,
                            0
                          ],
                          [
                            -0.32,
                            -0.19
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.31,
                            -0.19
                          ],
                          [
                            0.57,
                            0
                          ],
                          [
                            0.32,
                            0.38
                          ],
                          [
                            0,
                            0.08
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.47
                          ],
                          [
                            0.27,
                            0.29
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.13
                          ],
                          [
                            -0.24,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            10.95,
                            9.11
                          ],
                          [
                            9.85,
                            8.83
                          ],
                          [
                            9.07,
                            8.02
                          ],
                          [
                            8.79,
                            6.76
                          ],
                          [
                            9.07,
                            5.49
                          ],
                          [
                            9.84,
                            4.68
                          ],
                          [
                            10.8,
                            4.39
                          ],
                          [
                            12.13,
                            4.96
                          ],
                          [
                            12.6,
                            6.5
                          ],
                          [
                            12.59,
                            6.74
                          ],
                          [
                            12.57,
                            6.94
                          ],
                          [
                            9.54,
                            6.94
                          ],
                          [
                            9.98,
                            8.07
                          ],
                          [
                            11.04,
                            8.5
                          ],
                          [
                            11.63,
                            8.41
                          ],
                          [
                            12.16,
                            8.15
                          ],
                          [
                            12.43,
                            8.65
                          ],
                          [
                            11.77,
                            8.97
                          ],
                          [
                            10.95,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.23
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.25,
                            -0.25
                          ],
                          [
                            0.05,
                            -0.45
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.46
                          ],
                          [
                            -0.19,
                            -0.24
                          ],
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            0.24
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.53,
                            6.39
                          ],
                          [
                            11.93,
                            6.39
                          ],
                          [
                            11.64,
                            5.35
                          ],
                          [
                            10.82,
                            4.99
                          ],
                          [
                            9.97,
                            5.36
                          ],
                          [
                            9.53,
                            6.39
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.36,
                            0.16
                          ],
                          [
                            0.27,
                            0.27
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.29,
                            -0.14
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.22,
                            0.18
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            0.09,
                            0.12
                          ],
                          [
                            0.16,
                            0.09
                          ],
                          [
                            0.19,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            0.13
                          ],
                          [
                            0.13,
                            0.2
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            -0.16,
                            0.24
                          ],
                          [
                            -0.29,
                            0.14
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.31,
                            -0.14
                          ],
                          [
                            -0.21,
                            -0.22
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0.1
                          ],
                          [
                            0.29,
                            0
                          ],
                          [
                            0.21,
                            -0.16
                          ],
                          [
                            0,
                            -0.27
                          ],
                          [
                            -0.1,
                            -0.13
                          ],
                          [
                            -0.16,
                            -0.08
                          ],
                          [
                            -0.16,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            -0.14
                          ],
                          [
                            -0.11,
                            -0.2
                          ],
                          [
                            0,
                            -0.3
                          ],
                          [
                            0.17,
                            -0.27
                          ],
                          [
                            0.31,
                            -0.15
                          ],
                          [
                            0.43,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.36,
                            -0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            0.23
                          ],
                          [
                            0.3,
                            0.14
                          ],
                          [
                            0.4,
                            0
                          ],
                          [
                            0.22,
                            -0.19
                          ],
                          [
                            0,
                            -0.21
                          ],
                          [
                            -0.09,
                            -0.12
                          ],
                          [
                            -0.14,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            -0.08
                          ],
                          [
                            -0.18,
                            -0.13
                          ],
                          [
                            -0.12,
                            -0.2
                          ],
                          [
                            0,
                            -0.31
                          ],
                          [
                            0.16,
                            -0.25
                          ],
                          [
                            0.29,
                            -0.14
                          ],
                          [
                            0.37,
                            0
                          ],
                          [
                            0.31,
                            0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            -0.18
                          ],
                          [
                            -0.22,
                            -0.11
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0.19
                          ],
                          [
                            0.11,
                            0.12
                          ],
                          [
                            0.15,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0.1
                          ],
                          [
                            0.19,
                            0.14
                          ],
                          [
                            0.11,
                            0.2
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            -0.17,
                            0.26
                          ],
                          [
                            -0.31,
                            0.16
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.32,
                            9.11
                          ],
                          [
                            16.14,
                            8.87
                          ],
                          [
                            15.2,
                            8.21
                          ],
                          [
                            15.66,
                            7.68
                          ],
                          [
                            16.42,
                            8.23
                          ],
                          [
                            17.34,
                            8.43
                          ],
                          [
                            18.27,
                            8.17
                          ],
                          [
                            18.6,
                            7.45
                          ],
                          [
                            18.46,
                            6.95
                          ],
                          [
                            18.1,
                            6.63
                          ],
                          [
                            17.59,
                            6.37
                          ],
                          [
                            16.72,
                            5.99
                          ],
                          [
                            16.15,
                            5.68
                          ],
                          [
                            15.68,
                            5.18
                          ],
                          [
                            15.49,
                            4.43
                          ],
                          [
                            15.73,
                            3.6
                          ],
                          [
                            16.42,
                            3.03
                          ],
                          [
                            17.4,
                            2.82
                          ],
                          [
                            18.41,
                            3.03
                          ],
                          [
                            19.2,
                            3.57
                          ],
                          [
                            18.78,
                            4.07
                          ],
                          [
                            18.16,
                            3.65
                          ],
                          [
                            17.4,
                            3.49
                          ],
                          [
                            16.57,
                            3.73
                          ],
                          [
                            16.27,
                            4.38
                          ],
                          [
                            16.42,
                            4.86
                          ],
                          [
                            16.81,
                            5.17
                          ],
                          [
                            17.28,
                            5.39
                          ],
                          [
                            18.14,
                            5.76
                          ],
                          [
                            18.77,
                            6.12
                          ],
                          [
                            19.22,
                            6.63
                          ],
                          [
                            19.39,
                            7.38
                          ],
                          [
                            19.14,
                            8.26
                          ],
                          [
                            18.43,
                            8.88
                          ],
                          [
                            17.32,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.32,
                            0.19
                          ],
                          [
                            0.18,
                            0.35
                          ],
                          [
                            0,
                            0.5
                          ],
                          [
                            -0.2,
                            0.35
                          ],
                          [
                            -0.32,
                            0.18
                          ],
                          [
                            -0.38,
                            0
                          ],
                          [
                            -0.21,
                            -0.11
                          ],
                          [
                            -0.16,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.07
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.13,
                            -0.27
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            -0.25,
                            -0.32
                          ],
                          [
                            -0.41,
                            0
                          ],
                          [
                            -0.18,
                            0.09
                          ],
                          [
                            -0.14,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.11
                          ],
                          [
                            0.27,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.39,
                            0
                          ],
                          [
                            -0.32,
                            -0.18
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.5
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.34,
                            -0.18
                          ],
                          [
                            0.3,
                            0
                          ],
                          [
                            0.21,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            -0.12
                          ],
                          [
                            -0.14,
                            -0.07
                          ],
                          [
                            -0.27,
                            0
                          ],
                          [
                            -0.21,
                            0.14
                          ],
                          [
                            -0.12,
                            0.26
                          ],
                          [
                            0,
                            0.52
                          ],
                          [
                            0.26,
                            0.32
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0.18,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.18
                          ],
                          [
                            -0.25,
                            0.1
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            22.29,
                            9.11
                          ],
                          [
                            21.21,
                            8.83
                          ],
                          [
                            20.46,
                            8.03
                          ],
                          [
                            20.18,
                            6.76
                          ],
                          [
                            20.48,
                            5.47
                          ],
                          [
                            21.27,
                            4.67
                          ],
                          [
                            22.34,
                            4.39
                          ],
                          [
                            23.11,
                            4.55
                          ],
                          [
                            23.66,
                            4.92
                          ],
                          [
                            23.27,
                            5.42
                          ],
                          [
                            22.86,
                            5.13
                          ],
                          [
                            22.37,
                            5.02
                          ],
                          [
                            21.64,
                            5.24
                          ],
                          [
                            21.14,
                            5.85
                          ],
                          [
                            20.96,
                            6.76
                          ],
                          [
                            21.34,
                            8.01
                          ],
                          [
                            22.36,
                            8.48
                          ],
                          [
                            22.94,
                            8.35
                          ],
                          [
                            23.41,
                            8.03
                          ],
                          [
                            23.74,
                            8.54
                          ],
                          [
                            23.07,
                            8.96
                          ],
                          [
                            22.29,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.22
                          ],
                          [
                            0,
                            0.4
                          ],
                          [
                            -0.44,
                            0.26
                          ],
                          [
                            -0.96,
                            0.11
                          ],
                          [
                            0.05,
                            0.18
                          ],
                          [
                            0.14,
                            0.1
                          ],
                          [
                            0.25,
                            0
                          ],
                          [
                            0.23,
                            -0.1
                          ],
                          [
                            0.18,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.3,
                            0.12
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.25,
                            -0.34
                          ],
                          [
                            0,
                            -0.56
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.13
                          ],
                          [
                            0.29,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.37,
                            0
                          ],
                          [
                            -0.25,
                            -0.23
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.45,
                            -0.27
                          ],
                          [
                            0,
                            -0.19
                          ],
                          [
                            -0.05,
                            -0.17
                          ],
                          [
                            -0.13,
                            -0.11
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.23,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            -0.14
                          ],
                          [
                            0.31,
                            -0.13
                          ],
                          [
                            0.55,
                            0
                          ],
                          [
                            0.25,
                            0.33
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            0.17
                          ],
                          [
                            -0.25,
                            0.13
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.68,
                            9.11
                          ],
                          [
                            24.73,
                            8.78
                          ],
                          [
                            24.37,
                            7.83
                          ],
                          [
                            25.02,
                            6.7
                          ],
                          [
                            27.13,
                            6.15
                          ],
                          [
                            27.04,
                            5.6
                          ],
                          [
                            26.76,
                            5.19
                          ],
                          [
                            26.2,
                            5.02
                          ],
                          [
                            25.47,
                            5.17
                          ],
                          [
                            24.86,
                            5.5
                          ],
                          [
                            24.56,
                            4.97
                          ],
                          [
                            25.33,
                            4.59
                          ],
                          [
                            26.33,
                            4.39
                          ],
                          [
                            27.52,
                            4.9
                          ],
                          [
                            27.89,
                            6.24
                          ],
                          [
                            27.89,
                            9
                          ],
                          [
                            27.26,
                            9
                          ],
                          [
                            27.2,
                            8.46
                          ],
                          [
                            27.17,
                            8.46
                          ],
                          [
                            26.48,
                            8.92
                          ],
                          [
                            25.68,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.11
                          ],
                          [
                            -0.21,
                            0.19
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.3,
                            -0.19
                          ],
                          [
                            0,
                            -0.29
                          ],
                          [
                            -0.15,
                            -0.12
                          ],
                          [
                            -0.22,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.21,
                            0
                          ],
                          [
                            0.19,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.75,
                            0.09
                          ],
                          [
                            -0.3,
                            0.18
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.9,
                            8.5
                          ],
                          [
                            26.51,
                            8.34
                          ],
                          [
                            27.13,
                            7.9
                          ],
                          [
                            27.13,
                            6.65
                          ],
                          [
                            25.55,
                            7.07
                          ],
                          [
                            25.11,
                            7.78
                          ],
                          [
                            25.34,
                            8.33
                          ],
                          [
                            25.9,
                            8.5
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0.17
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.05
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            -0.01
                          ],
                          [
                            0.11,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.12,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.12
                          ],
                          [
                            0.04,
                            0.05
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0.03,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.03
                          ],
                          [
                            -0.07,
                            0.01
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            30.11,
                            9.11
                          ],
                          [
                            29.49,
                            8.85
                          ],
                          [
                            29.31,
                            8.09
                          ],
                          [
                            29.31,
                            2.41
                          ],
                          [
                            30.07,
                            2.41
                          ],
                          [
                            30.07,
                            8.15
                          ],
                          [
                            30.13,
                            8.41
                          ],
                          [
                            30.28,
                            8.48
                          ],
                          [
                            30.34,
                            8.48
                          ],
                          [
                            30.45,
                            8.46
                          ],
                          [
                            30.55,
                            9.04
                          ],
                          [
                            30.37,
                            9.09
                          ],
                          [
                            30.11,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.33,
                            0.19
                          ],
                          [
                            0.19,
                            0.35
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.19,
                            0.35
                          ],
                          [
                            -0.31,
                            0.19
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.31,
                            -0.38
                          ],
                          [
                            0,
                            -0.64
                          ],
                          [
                            0,
                            -0.08
                          ],
                          [
                            0.01,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.27,
                            -0.29
                          ],
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.18,
                            0.06
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.09
                          ],
                          [
                            0.31,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.4,
                            0
                          ],
                          [
                            -0.33,
                            -0.19
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.31,
                            -0.19
                          ],
                          [
                            0.57,
                            0
                          ],
                          [
                            0.32,
                            0.38
                          ],
                          [
                            0,
                            0.08
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.47
                          ],
                          [
                            0.27,
                            0.29
                          ],
                          [
                            0.22,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.13
                          ],
                          [
                            -0.24,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            33.49,
                            9.11
                          ],
                          [
                            32.4,
                            8.83
                          ],
                          [
                            31.62,
                            8.02
                          ],
                          [
                            31.34,
                            6.76
                          ],
                          [
                            31.62,
                            5.49
                          ],
                          [
                            32.38,
                            4.68
                          ],
                          [
                            33.35,
                            4.39
                          ],
                          [
                            34.68,
                            4.96
                          ],
                          [
                            35.15,
                            6.5
                          ],
                          [
                            35.14,
                            6.74
                          ],
                          [
                            35.12,
                            6.94
                          ],
                          [
                            32.09,
                            6.94
                          ],
                          [
                            32.53,
                            8.07
                          ],
                          [
                            33.58,
                            8.5
                          ],
                          [
                            34.18,
                            8.41
                          ],
                          [
                            34.7,
                            8.15
                          ],
                          [
                            34.97,
                            8.65
                          ],
                          [
                            34.32,
                            8.97
                          ],
                          [
                            33.49,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.23
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.25,
                            -0.25
                          ],
                          [
                            0.05,
                            -0.45
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.46
                          ],
                          [
                            -0.19,
                            -0.24
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.25,
                            0.24
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            32.07,
                            6.39
                          ],
                          [
                            34.48,
                            6.39
                          ],
                          [
                            34.19,
                            5.35
                          ],
                          [
                            33.37,
                            4.99
                          ],
                          [
                            32.52,
                            5.36
                          ],
                          [
                            32.07,
                            6.39
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.16
                          ],
                          [
                            -0.25,
                            0
                          ],
                          [
                            -0.14,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0.01
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.15,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.29
                          ],
                          [
                            0.22,
                            -0.17
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.06,
                            -0.01
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            36.26,
                            9
                          ],
                          [
                            36.26,
                            4.5
                          ],
                          [
                            36.89,
                            4.5
                          ],
                          [
                            36.95,
                            5.32
                          ],
                          [
                            36.98,
                            5.32
                          ],
                          [
                            37.55,
                            4.64
                          ],
                          [
                            38.26,
                            4.39
                          ],
                          [
                            38.74,
                            4.48
                          ],
                          [
                            38.59,
                            5.15
                          ],
                          [
                            38.39,
                            5.09
                          ],
                          [
                            38.16,
                            5.07
                          ],
                          [
                            37.55,
                            5.3
                          ],
                          [
                            37.02,
                            6.11
                          ],
                          [
                            37.02,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.49,
                        0.55,
                        0.65,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1455",
    layers: [
      {
        ind: 1454,
        ty: 2,
        parent: 1453,
        ks: {
          s: {
            a: 0,
            k: [
              157.14,
              162.5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "0"
      },
      {
        ind: 1453,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1458",
    layers: [
      {
        ind: 1457,
        ty: 0,
        parent: 1452,
        ks: {},
        w: 11,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1455"
      },
      {
        ind: 1452,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1500",
    layers: [
      {
        ind: 1499,
        ty: 2,
        parent: 1498,
        ks: {
          s: {
            a: 0,
            k: [
              162.5,
              160
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "1"
      },
      {
        ind: 1498,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1503",
    layers: [
      {
        ind: 1502,
        ty: 0,
        parent: 1497,
        ks: {},
        w: 13,
        h: 12,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1500"
      },
      {
        ind: 1497,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1538",
    layers: [
      {
        ind: 1537,
        ty: 2,
        parent: 1536,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        refId: "4"
      },
      {
        ind: 1536,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1541",
    layers: [
      {
        ind: 1540,
        ty: 0,
        parent: 1535,
        ks: {},
        w: 19,
        h: 21.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1538"
      },
      {
        ind: 1535,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1552",
    layers: [
      {
        ind: 1551,
        ty: 2,
        parent: 1550,
        ks: {
          s: {
            a: 0,
            k: [
              165.22,
              166.3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "9"
      },
      {
        ind: 1550,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1555",
    layers: [
      {
        ind: 1554,
        ty: 0,
        parent: 1549,
        ks: {},
        w: 76,
        h: 76.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1552"
      },
      {
        ind: 1549,
        ty: 3,
        parent: 1548,
        ks: {
          p: {
            a: 0,
            k: [
              -7,
              -5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1548,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              8,
              5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1559",
    layers: [
      {
        ind: 1558,
        ty: 4,
        td: 1,
        parent: 1547,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                31.739,
                31.739
              ]
            },
            r: {
              a: 0,
              k: 31
            },
            s: {
              a: 0,
              k: [
                63.478,
                63.478
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1557,
        ty: 0,
        tt: 1,
        parent: 1547,
        ks: {
          a: {
            a: 0,
            k: [
              8,
              5
            ]
          }
        },
        w: 84,
        h: 82,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1555"
      },
      {
        ind: 1547,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              7.053,
              7.053
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1564",
    layers: [
      {
        ind: 1302,
        ty: 4,
        parent: 1301,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1301,
        ty: 3,
        parent: 1300,
        ks: {
          p: {
            a: 0,
            k: [
              28.394,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1304,
        ty: 4,
        parent: 1303,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1303,
        ty: 3,
        parent: 1300,
        ks: {
          p: {
            a: 0,
            k: [
              22.138,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1306,
        ty: 4,
        parent: 1305,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ],
                  [
                    1.2,
                    11.3
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    10.1
                  ],
                  [
                    2.4,
                    10.5
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.7,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    3,
                    11.6
                  ],
                  [
                    2.7,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1305,
        ty: 3,
        parent: 1300,
        ks: {
          p: {
            a: 0,
            k: [
              18.794,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1308,
        ty: 4,
        parent: 1307,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1307,
        ty: 3,
        parent: 1300,
        ks: {
          p: {
            a: 0,
            k: [
              12.426,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1310,
        ty: 4,
        parent: 1309,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.9,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.8
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    4.6,
                    5.6
                  ],
                  [
                    5.3,
                    6.1
                  ],
                  [
                    5.3,
                    6.1
                  ],
                  [
                    4.6,
                    7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    2.4,
                    7.1
                  ],
                  [
                    2,
                    8.6
                  ],
                  [
                    2,
                    8.6
                  ],
                  [
                    2.4,
                    10
                  ],
                  [
                    3.6,
                    10.6
                  ],
                  [
                    3.6,
                    10.6
                  ],
                  [
                    4.3,
                    10.4
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    5.4,
                    11
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1309,
        ty: 3,
        parent: 1300,
        ks: {
          p: {
            a: 0,
            k: [
              6.725,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1312,
        ty: 4,
        parent: 1311,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    1.3,
                    9.6
                  ],
                  [
                    2.3,
                    10.2
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    4.5,
                    10.2
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.5,
                    8.7
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    2.5,
                    7.8
                  ],
                  [
                    1.7,
                    7.3
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    1.2,
                    4.5
                  ],
                  [
                    2.1,
                    3.7
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    4.9,
                    3.6
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    5.3,
                    5.3
                  ],
                  [
                    4.5,
                    4.8
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.5,
                    6.1
                  ],
                  [
                    2.9,
                    6.4
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    4.7,
                    7.2
                  ],
                  [
                    5.8,
                    8
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    5.9,
                    10.5
                  ],
                  [
                    4.9,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1311,
        ty: 3,
        parent: 1300,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1300,
        ty: 3,
        parent: 1299,
        ks: {
          p: {
            a: 0,
            k: [
              122.02,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1315,
        ty: 4,
        parent: 1314,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1314,
        ty: 3,
        parent: 1313,
        ks: {
          p: {
            a: 0,
            k: [
              20.548,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1317,
        ty: 4,
        parent: 1316,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1316,
        ty: 3,
        parent: 1313,
        ks: {
          p: {
            a: 0,
            k: [
              14.292,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1319,
        ty: 4,
        parent: 1318,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.6,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.3,
                    6.7
                  ],
                  [
                    0.3,
                    5.6
                  ],
                  [
                    1.1,
                    5.5
                  ],
                  [
                    1.1,
                    4.9
                  ],
                  [
                    1.6,
                    3.3
                  ],
                  [
                    3.2,
                    2.7
                  ],
                  [
                    3.2,
                    2.7
                  ],
                  [
                    3.8,
                    2.8
                  ],
                  [
                    4.3,
                    2.9
                  ],
                  [
                    4.3,
                    2.9
                  ],
                  [
                    4,
                    4
                  ],
                  [
                    3.3,
                    3.8
                  ],
                  [
                    3.3,
                    3.8
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.6,
                    5.5
                  ],
                  [
                    3.8,
                    5.5
                  ],
                  [
                    3.8,
                    6.7
                  ],
                  [
                    2.6,
                    6.7
                  ],
                  [
                    2.6,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    6.9,
                    11.7
                  ],
                  [
                    6.9,
                    11.7
                  ],
                  [
                    5.5,
                    11.1
                  ],
                  [
                    5,
                    9.5
                  ],
                  [
                    5,
                    9.5
                  ],
                  [
                    5,
                    6.7
                  ],
                  [
                    4.2,
                    6.7
                  ],
                  [
                    4.2,
                    5.6
                  ],
                  [
                    5.1,
                    5.5
                  ],
                  [
                    5.3,
                    3.9
                  ],
                  [
                    6.5,
                    3.9
                  ],
                  [
                    6.5,
                    5.5
                  ],
                  [
                    8,
                    5.5
                  ],
                  [
                    8,
                    6.7
                  ],
                  [
                    6.5,
                    6.7
                  ],
                  [
                    6.5,
                    9.5
                  ],
                  [
                    7.3,
                    10.6
                  ],
                  [
                    7.3,
                    10.6
                  ],
                  [
                    7.6,
                    10.6
                  ],
                  [
                    7.9,
                    10.5
                  ],
                  [
                    7.9,
                    10.5
                  ],
                  [
                    8.2,
                    11.5
                  ],
                  [
                    7.6,
                    11.7
                  ],
                  [
                    6.9,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1318,
        ty: 3,
        parent: 1313,
        ks: {
          p: {
            a: 0,
            k: [
              6.367,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1321,
        ty: 4,
        parent: 1320,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1320,
        ty: 3,
        parent: 1313,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1313,
        ty: 3,
        parent: 1299,
        ks: {
          p: {
            a: 0,
            k: [
              94.401,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1324,
        ty: 4,
        parent: 1323,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1323,
        ty: 3,
        parent: 1322,
        ks: {
          p: {
            a: 0,
            k: [
              17.856,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1326,
        ty: 4,
        parent: 1325,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    6.1,
                    5.5
                  ],
                  [
                    4.1,
                    8
                  ],
                  [
                    6.3,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    3.2,
                    9
                  ],
                  [
                    2.3,
                    10
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1325,
        ty: 3,
        parent: 1322,
        ks: {
          p: {
            a: 0,
            k: [
              11.414,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1328,
        ty: 4,
        parent: 1327,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.3,
                    5.5
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    1.6,
                    4.5
                  ],
                  [
                    1.6,
                    4.5
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.8,
                    3.7
                  ],
                  [
                    0.8,
                    3.7
                  ],
                  [
                    1,
                    3.1
                  ],
                  [
                    1.6,
                    2.8
                  ],
                  [
                    1.6,
                    2.8
                  ],
                  [
                    2.2,
                    3.1
                  ],
                  [
                    2.5,
                    3.7
                  ],
                  [
                    2.5,
                    3.7
                  ],
                  [
                    2.2,
                    4.2
                  ],
                  [
                    1.6,
                    4.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1327,
        ty: 3,
        parent: 1322,
        ks: {
          p: {
            a: 0,
            k: [
              8.181,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1330,
        ty: 4,
        parent: 1329,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.5,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    3.5
                  ],
                  [
                    2.5,
                    3.5
                  ],
                  [
                    2.5,
                    6.8
                  ],
                  [
                    5.7,
                    6.8
                  ],
                  [
                    5.7,
                    3.5
                  ],
                  [
                    7.2,
                    3.5
                  ],
                  [
                    7.2,
                    11.6
                  ],
                  [
                    5.7,
                    11.6
                  ],
                  [
                    5.7,
                    8
                  ],
                  [
                    2.5,
                    8
                  ],
                  [
                    2.5,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1329,
        ty: 3,
        parent: 1322,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1322,
        ty: 3,
        parent: 1299,
        ks: {
          p: {
            a: 0,
            k: [
              67.821,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1333,
        ty: 4,
        parent: 1332,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.7,
                    0
                  ]
                ],
                v: [
                  [
                    1.3,
                    14.1
                  ],
                  [
                    1.3,
                    14.1
                  ],
                  [
                    0.9,
                    14
                  ],
                  [
                    0.5,
                    14
                  ],
                  [
                    0.5,
                    14
                  ],
                  [
                    0.8,
                    12.8
                  ],
                  [
                    1,
                    12.9
                  ],
                  [
                    1.2,
                    12.9
                  ],
                  [
                    1.2,
                    12.9
                  ],
                  [
                    2,
                    12.6
                  ],
                  [
                    2.4,
                    11.9
                  ],
                  [
                    2.4,
                    11.9
                  ],
                  [
                    2.5,
                    11.5
                  ],
                  [
                    0.1,
                    5.5
                  ],
                  [
                    1.6,
                    5.5
                  ],
                  [
                    2.6,
                    8.5
                  ],
                  [
                    2.9,
                    9.3
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.4,
                    9.3
                  ],
                  [
                    3.7,
                    8.5
                  ],
                  [
                    3.7,
                    8.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    6,
                    5.5
                  ],
                  [
                    3.8,
                    11.9
                  ],
                  [
                    2.8,
                    13.5
                  ],
                  [
                    1.3,
                    14.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.7
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1332,
        ty: 3,
        parent: 1331,
        ks: {
          p: {
            a: 0,
            k: [
              27.407,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1335,
        ty: 4,
        parent: 1334,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1334,
        ty: 3,
        parent: 1331,
        ks: {
          p: {
            a: 0,
            k: [
              22.804,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1337,
        ty: 4,
        parent: 1336,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1336,
        ty: 3,
        parent: 1331,
        ks: {
          p: {
            a: 0,
            k: [
              16.437,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1339,
        ty: 4,
        parent: 1338,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ],
                  [
                    1.2,
                    11.3
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    10.1
                  ],
                  [
                    2.4,
                    10.5
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.7,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    3,
                    11.6
                  ],
                  [
                    2.7,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1338,
        ty: 3,
        parent: 1331,
        ks: {
          p: {
            a: 0,
            k: [
              13.093,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1341,
        ty: 4,
        parent: 1340,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1340,
        ty: 3,
        parent: 1331,
        ks: {
          p: {
            a: 0,
            k: [
              6.725,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1343,
        ty: 4,
        parent: 1342,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    1.3,
                    9.6
                  ],
                  [
                    2.3,
                    10.2
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    4.5,
                    10.2
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.5,
                    8.7
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    2.5,
                    7.8
                  ],
                  [
                    1.7,
                    7.3
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    1.2,
                    4.5
                  ],
                  [
                    2.1,
                    3.7
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    4.9,
                    3.6
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    5.3,
                    5.3
                  ],
                  [
                    4.5,
                    4.8
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.5,
                    6.1
                  ],
                  [
                    2.9,
                    6.4
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    4.7,
                    7.2
                  ],
                  [
                    5.8,
                    8
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    5.9,
                    10.5
                  ],
                  [
                    4.9,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1342,
        ty: 3,
        parent: 1331,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1331,
        ty: 3,
        parent: 1299,
        ks: {
          p: {
            a: 0,
            k: [
              31.837,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1346,
        ty: 4,
        parent: 1345,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    8.5
                  ],
                  [
                    2.3,
                    8.5
                  ],
                  [
                    0.9,
                    7.8
                  ],
                  [
                    0.4,
                    5.9
                  ],
                  [
                    0.4,
                    5.9
                  ],
                  [
                    0.9,
                    4
                  ],
                  [
                    2.3,
                    3.4
                  ],
                  [
                    2.3,
                    3.4
                  ],
                  [
                    3.7,
                    4
                  ],
                  [
                    4.2,
                    5.9
                  ],
                  [
                    4.2,
                    5.9
                  ],
                  [
                    3.7,
                    7.8
                  ],
                  [
                    2.3,
                    8.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    7.7
                  ],
                  [
                    2.3,
                    7.7
                  ],
                  [
                    2.9,
                    7.2
                  ],
                  [
                    3.2,
                    5.9
                  ],
                  [
                    3.2,
                    5.9
                  ],
                  [
                    2.9,
                    4.6
                  ],
                  [
                    2.3,
                    4.2
                  ],
                  [
                    2.3,
                    4.2
                  ],
                  [
                    1.7,
                    4.6
                  ],
                  [
                    1.4,
                    5.9
                  ],
                  [
                    1.4,
                    5.9
                  ],
                  [
                    1.7,
                    7.2
                  ],
                  [
                    2.3,
                    7.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2.6,
                    11.7
                  ],
                  [
                    7,
                    3.4
                  ],
                  [
                    7.8,
                    3.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    8.1,
                    11.7
                  ],
                  [
                    8.1,
                    11.7
                  ],
                  [
                    6.7,
                    11.1
                  ],
                  [
                    6.2,
                    9.2
                  ],
                  [
                    6.2,
                    9.2
                  ],
                  [
                    6.7,
                    7.3
                  ],
                  [
                    8.1,
                    6.6
                  ],
                  [
                    8.1,
                    6.6
                  ],
                  [
                    9.5,
                    7.3
                  ],
                  [
                    10,
                    9.2
                  ],
                  [
                    10,
                    9.2
                  ],
                  [
                    9.5,
                    11.1
                  ],
                  [
                    8.1,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    8.1,
                    10.9
                  ],
                  [
                    8.1,
                    10.9
                  ],
                  [
                    8.7,
                    10.5
                  ],
                  [
                    9,
                    9.2
                  ],
                  [
                    9,
                    9.2
                  ],
                  [
                    8.7,
                    7.9
                  ],
                  [
                    8.1,
                    7.5
                  ],
                  [
                    8.1,
                    7.5
                  ],
                  [
                    7.4,
                    7.9
                  ],
                  [
                    7.2,
                    9.2
                  ],
                  [
                    7.2,
                    9.2
                  ],
                  [
                    7.4,
                    10.5
                  ],
                  [
                    8.1,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1345,
        ty: 3,
        parent: 1344,
        ks: {
          p: {
            a: 0,
            k: [
              18.991,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1348,
        ty: 4,
        parent: 1347,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.7
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.7
                  ],
                  [
                    0.8,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    11.7
                  ],
                  [
                    3.2,
                    11.7
                  ],
                  [
                    1.2,
                    10.7
                  ],
                  [
                    0.5,
                    7.6
                  ],
                  [
                    0.5,
                    7.6
                  ],
                  [
                    1.2,
                    4.6
                  ],
                  [
                    3.2,
                    3.6
                  ],
                  [
                    3.2,
                    3.6
                  ],
                  [
                    5.1,
                    4.6
                  ],
                  [
                    5.8,
                    7.6
                  ],
                  [
                    5.8,
                    7.6
                  ],
                  [
                    5.1,
                    10.7
                  ],
                  [
                    3.2,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0.5,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    -0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    10.6
                  ],
                  [
                    3.2,
                    10.6
                  ],
                  [
                    3.8,
                    10.3
                  ],
                  [
                    4.3,
                    9.4
                  ],
                  [
                    4.5,
                    7.6
                  ],
                  [
                    4.5,
                    7.6
                  ],
                  [
                    4.3,
                    5.9
                  ],
                  [
                    3.8,
                    5
                  ],
                  [
                    3.2,
                    4.7
                  ],
                  [
                    3.2,
                    4.7
                  ],
                  [
                    2.5,
                    5
                  ],
                  [
                    2,
                    5.9
                  ],
                  [
                    1.9,
                    7.6
                  ],
                  [
                    1.9,
                    7.6
                  ],
                  [
                    2,
                    9.4
                  ],
                  [
                    2.5,
                    10.3
                  ],
                  [
                    3.2,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1347,
        ty: 3,
        parent: 1344,
        ks: {
          p: {
            a: 0,
            k: [
              12.661,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1350,
        ty: 4,
        parent: 1349,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.7
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.7
                  ],
                  [
                    0.8,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    11.7
                  ],
                  [
                    3.2,
                    11.7
                  ],
                  [
                    1.2,
                    10.7
                  ],
                  [
                    0.5,
                    7.6
                  ],
                  [
                    0.5,
                    7.6
                  ],
                  [
                    1.2,
                    4.6
                  ],
                  [
                    3.2,
                    3.6
                  ],
                  [
                    3.2,
                    3.6
                  ],
                  [
                    5.1,
                    4.6
                  ],
                  [
                    5.8,
                    7.6
                  ],
                  [
                    5.8,
                    7.6
                  ],
                  [
                    5.1,
                    10.7
                  ],
                  [
                    3.2,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0.5,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    -0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    10.6
                  ],
                  [
                    3.2,
                    10.6
                  ],
                  [
                    3.8,
                    10.3
                  ],
                  [
                    4.3,
                    9.4
                  ],
                  [
                    4.5,
                    7.6
                  ],
                  [
                    4.5,
                    7.6
                  ],
                  [
                    4.3,
                    5.9
                  ],
                  [
                    3.8,
                    5
                  ],
                  [
                    3.2,
                    4.7
                  ],
                  [
                    3.2,
                    4.7
                  ],
                  [
                    2.5,
                    5
                  ],
                  [
                    2,
                    5.9
                  ],
                  [
                    1.9,
                    7.6
                  ],
                  [
                    1.9,
                    7.6
                  ],
                  [
                    2,
                    9.4
                  ],
                  [
                    2.5,
                    10.3
                  ],
                  [
                    3.2,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1349,
        ty: 3,
        parent: 1344,
        ks: {
          p: {
            a: 0,
            k: [
              6.33,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1352,
        ty: 4,
        parent: 1351,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    5.6,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    10.4
                  ],
                  [
                    2.7,
                    10.4
                  ],
                  [
                    2.7,
                    5.3
                  ],
                  [
                    1.2,
                    5.3
                  ],
                  [
                    1.2,
                    4.4
                  ],
                  [
                    2.2,
                    4.1
                  ],
                  [
                    3,
                    3.7
                  ],
                  [
                    3,
                    3.7
                  ],
                  [
                    4.1,
                    3.7
                  ],
                  [
                    4.1,
                    10.4
                  ],
                  [
                    5.6,
                    10.4
                  ],
                  [
                    5.6,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1351,
        ty: 3,
        parent: 1344,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1344,
        ty: 3,
        parent: 1299,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1299,
        ty: 3,
        parent: 1298,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1298,
        ty: 3,
        parent: 1297,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1297,
        ty: 3,
        parent: 1296,
        ks: {
          p: {
            a: 0,
            k: [
              22.167,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1361,
        ty: 0,
        parent: 1353,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1359"
      },
      {
        ind: 1353,
        ty: 3,
        parent: 1296,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1296,
        ty: 3,
        parent: 1295,
        ks: {
          p: {
            a: 0,
            k: [
              48.952,
              3.527
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1295,
        ty: 3,
        parent: 1294,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              46.727
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1392,
        ty: 0,
        parent: 1364,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              13.015
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              13.015
            ]
          }
        },
        w: 60.455,
        h: 12.913,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1390"
      },
      {
        ind: 1364,
        ty: 3,
        parent: 1363,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              13.015
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1397,
        ty: 4,
        parent: 1396,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.22,
                    0.16
                  ],
                  [
                    -0.25,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.14,
                    -0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.06,
                    0.01
                  ],
                  [
                    0.09,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.15
                  ],
                  [
                    0.15,
                    -0.37
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.49,
                    8.51
                  ],
                  [
                    0.74,
                    8.51
                  ],
                  [
                    0.74,
                    4.11
                  ],
                  [
                    1.36,
                    4.11
                  ],
                  [
                    1.42,
                    4.9
                  ],
                  [
                    1.45,
                    4.9
                  ],
                  [
                    2,
                    4.24
                  ],
                  [
                    2.7,
                    4
                  ],
                  [
                    2.7,
                    4
                  ],
                  [
                    3.17,
                    4.09
                  ],
                  [
                    3.17,
                    4.09
                  ],
                  [
                    3.03,
                    4.74
                  ],
                  [
                    2.83,
                    4.69
                  ],
                  [
                    2.6,
                    4.67
                  ],
                  [
                    2.6,
                    4.67
                  ],
                  [
                    2.02,
                    4.9
                  ],
                  [
                    1.49,
                    5.68
                  ],
                  [
                    1.49,
                    5.68
                  ],
                  [
                    1.49,
                    8.51
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.15,
                    -0.28
                  ],
                  [
                    0.22,
                    -0.16
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.18,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.07,
                    -0.02
                  ],
                  [
                    -0.06,
                    -0.01
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0
                  ],
                  [
                    -0.2,
                    0.15
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1396,
        ty: 3,
        parent: 1395,
        ks: {
          p: {
            a: 0,
            k: [
              20.34,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1399,
        ty: 4,
        parent: 1398,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.32,
                    0.18
                  ],
                  [
                    0.19,
                    0.34
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.34
                  ],
                  [
                    -0.3,
                    0.19
                  ],
                  [
                    -0.33,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    -0.37
                  ],
                  [
                    0,
                    -0.63
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.08
                  ],
                  [
                    0.01,
                    -0.05
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.26,
                    -0.28
                  ],
                  [
                    -0.42,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.18,
                    0.06
                  ],
                  [
                    -0.16,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.09
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.53,
                    8.62
                  ],
                  [
                    2.53,
                    8.62
                  ],
                  [
                    1.46,
                    8.35
                  ],
                  [
                    0.7,
                    7.55
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.7,
                    5.08
                  ],
                  [
                    1.44,
                    4.28
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    3.7,
                    4.56
                  ],
                  [
                    4.15,
                    6.07
                  ],
                  [
                    4.15,
                    6.07
                  ],
                  [
                    4.15,
                    6.3
                  ],
                  [
                    4.13,
                    6.49
                  ],
                  [
                    4.13,
                    6.49
                  ],
                  [
                    1.15,
                    6.49
                  ],
                  [
                    1.59,
                    7.61
                  ],
                  [
                    2.62,
                    8.02
                  ],
                  [
                    2.62,
                    8.02
                  ],
                  [
                    3.21,
                    7.93
                  ],
                  [
                    3.72,
                    7.68
                  ],
                  [
                    3.72,
                    7.68
                  ],
                  [
                    3.98,
                    8.17
                  ],
                  [
                    3.34,
                    8.49
                  ],
                  [
                    2.53,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.39,
                    0
                  ],
                  [
                    -0.32,
                    -0.18
                  ],
                  [
                    -0.19,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.48
                  ],
                  [
                    0.19,
                    -0.34
                  ],
                  [
                    0.3,
                    -0.19
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.56,
                    0
                  ],
                  [
                    0.31,
                    0.37
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.08
                  ],
                  [
                    0,
                    0.08
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.03,
                    0.47
                  ],
                  [
                    0.26,
                    0.28
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0
                  ],
                  [
                    0.18,
                    -0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.12
                  ],
                  [
                    -0.24,
                    0.09
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.19,
                    0.23
                  ],
                  [
                    0.34,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.24
                  ],
                  [
                    0.05,
                    -0.44
                  ]
                ],
                v: [
                  [
                    1.14,
                    5.96
                  ],
                  [
                    1.14,
                    5.96
                  ],
                  [
                    3.5,
                    5.96
                  ],
                  [
                    3.21,
                    4.94
                  ],
                  [
                    2.41,
                    4.59
                  ],
                  [
                    2.41,
                    4.59
                  ],
                  [
                    1.58,
                    4.95
                  ],
                  [
                    1.14,
                    5.96
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.45
                  ],
                  [
                    -0.19,
                    -0.23
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    0
                  ],
                  [
                    -0.24,
                    0.24
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1398,
        ty: 3,
        parent: 1395,
        ks: {
          p: {
            a: 0,
            k: [
              15.846,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1401,
        ty: 4,
        parent: 1400,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    8.6
                  ],
                  [
                    1.5,
                    8.6
                  ],
                  [
                    0.9,
                    8.4
                  ],
                  [
                    0.7,
                    7.6
                  ],
                  [
                    0.7,
                    7.6
                  ],
                  [
                    0.7,
                    2.1
                  ],
                  [
                    1.5,
                    2.1
                  ],
                  [
                    1.5,
                    7.7
                  ],
                  [
                    1.6,
                    7.9
                  ],
                  [
                    1.7,
                    8
                  ],
                  [
                    1.7,
                    8
                  ],
                  [
                    1.8,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    2,
                    8.5
                  ],
                  [
                    1.8,
                    8.6
                  ],
                  [
                    1.5,
                    8.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1400,
        ty: 3,
        parent: 1395,
        ks: {
          p: {
            a: 0,
            k: [
              13.536,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1403,
        ty: 4,
        parent: 1402,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    0.22
                  ],
                  [
                    0,
                    0.39
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.43,
                    0.26
                  ],
                  [
                    -0.94,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.05,
                    0.17
                  ],
                  [
                    0.13,
                    0.11
                  ],
                  [
                    0.24,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.22,
                    -0.1
                  ],
                  [
                    0.18,
                    -0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.12
                  ],
                  [
                    -0.35,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.24,
                    -0.33
                  ],
                  [
                    0,
                    -0.55
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.13
                  ],
                  [
                    0.28,
                    0
                  ]
                ],
                v: [
                  [
                    1.76,
                    8.62
                  ],
                  [
                    1.76,
                    8.62
                  ],
                  [
                    0.84,
                    8.29
                  ],
                  [
                    0.47,
                    7.37
                  ],
                  [
                    0.47,
                    7.37
                  ],
                  [
                    1.12,
                    6.26
                  ],
                  [
                    3.17,
                    5.72
                  ],
                  [
                    3.17,
                    5.72
                  ],
                  [
                    3.1,
                    5.19
                  ],
                  [
                    2.82,
                    4.77
                  ],
                  [
                    2.27,
                    4.61
                  ],
                  [
                    2.27,
                    4.61
                  ],
                  [
                    1.55,
                    4.76
                  ],
                  [
                    0.95,
                    5.09
                  ],
                  [
                    0.95,
                    5.09
                  ],
                  [
                    0.66,
                    4.57
                  ],
                  [
                    1.42,
                    4.18
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    3.56,
                    4.49
                  ],
                  [
                    3.93,
                    5.81
                  ],
                  [
                    3.93,
                    5.81
                  ],
                  [
                    3.93,
                    8.51
                  ],
                  [
                    3.31,
                    8.51
                  ],
                  [
                    3.25,
                    7.99
                  ],
                  [
                    3.22,
                    7.99
                  ],
                  [
                    2.54,
                    8.43
                  ],
                  [
                    1.76,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.37,
                    0
                  ],
                  [
                    -0.24,
                    -0.22
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.48
                  ],
                  [
                    0.43,
                    -0.26
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.19
                  ],
                  [
                    -0.05,
                    -0.17
                  ],
                  [
                    -0.13,
                    -0.11
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.25,
                    0
                  ],
                  [
                    -0.22,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    -0.13
                  ],
                  [
                    0.3,
                    -0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.54,
                    0
                  ],
                  [
                    0.24,
                    0.33
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    0.17
                  ],
                  [
                    -0.24,
                    0.13
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.1
                  ],
                  [
                    -0.21,
                    0.19
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.29,
                    -0.18
                  ],
                  [
                    0,
                    -0.28
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.15,
                    -0.11
                  ],
                  [
                    -0.22,
                    0
                  ]
                ],
                v: [
                  [
                    1.98,
                    8.02
                  ],
                  [
                    1.98,
                    8.02
                  ],
                  [
                    2.58,
                    7.87
                  ],
                  [
                    3.17,
                    7.43
                  ],
                  [
                    3.17,
                    7.43
                  ],
                  [
                    3.17,
                    6.21
                  ],
                  [
                    1.64,
                    6.62
                  ],
                  [
                    1.2,
                    7.32
                  ],
                  [
                    1.2,
                    7.32
                  ],
                  [
                    1.42,
                    7.86
                  ],
                  [
                    1.98,
                    8.02
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0
                  ],
                  [
                    0.19,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.73,
                    0.09
                  ],
                  [
                    -0.29,
                    0.18
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.25
                  ],
                  [
                    0.15,
                    0.11
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1402,
        ty: 3,
        parent: 1395,
        ks: {
          p: {
            a: 0,
            k: [
              8.969,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1405,
        ty: 4,
        parent: 1404,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.31,
                    0.18
                  ],
                  [
                    0.18,
                    0.34
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.34
                  ],
                  [
                    -0.32,
                    0.18
                  ],
                  [
                    -0.37,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.1
                  ],
                  [
                    -0.15,
                    -0.14
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.14,
                    0.07
                  ],
                  [
                    0.18,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    -0.14
                  ],
                  [
                    0.12,
                    -0.26
                  ],
                  [
                    0,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.25,
                    -0.31
                  ],
                  [
                    -0.41,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.18,
                    0.09
                  ],
                  [
                    -0.13,
                    0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.1
                  ],
                  [
                    0.27,
                    0
                  ]
                ],
                v: [
                  [
                    2.48,
                    8.62
                  ],
                  [
                    2.48,
                    8.62
                  ],
                  [
                    1.43,
                    8.35
                  ],
                  [
                    0.69,
                    7.56
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.71,
                    5.06
                  ],
                  [
                    1.49,
                    4.27
                  ],
                  [
                    2.54,
                    4
                  ],
                  [
                    2.54,
                    4
                  ],
                  [
                    3.29,
                    4.15
                  ],
                  [
                    3.83,
                    4.51
                  ],
                  [
                    3.83,
                    4.51
                  ],
                  [
                    3.45,
                    5
                  ],
                  [
                    3.04,
                    4.72
                  ],
                  [
                    2.57,
                    4.61
                  ],
                  [
                    2.57,
                    4.61
                  ],
                  [
                    1.85,
                    4.83
                  ],
                  [
                    1.36,
                    5.43
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.56,
                    7.54
                  ],
                  [
                    2.55,
                    8.01
                  ],
                  [
                    2.55,
                    8.01
                  ],
                  [
                    3.12,
                    7.87
                  ],
                  [
                    3.58,
                    7.56
                  ],
                  [
                    3.58,
                    7.56
                  ],
                  [
                    3.91,
                    8.06
                  ],
                  [
                    3.25,
                    8.47
                  ],
                  [
                    2.48,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.39,
                    0
                  ],
                  [
                    -0.31,
                    -0.18
                  ],
                  [
                    -0.18,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0.2,
                    -0.34
                  ],
                  [
                    0.32,
                    -0.18
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.29,
                    0
                  ],
                  [
                    0.21,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.13,
                    -0.11
                  ],
                  [
                    -0.14,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.27,
                    0
                  ],
                  [
                    -0.21,
                    0.14
                  ],
                  [
                    -0.12,
                    0.26
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0.25,
                    0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0
                  ],
                  [
                    0.18,
                    -0.09
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.18
                  ],
                  [
                    -0.24,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1404,
        ty: 3,
        parent: 1395,
        ks: {
          p: {
            a: 0,
            k: [
              4.838,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1407,
        ty: 4,
        parent: 1406,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.5,
                    8.6
                  ],
                  [
                    2.5,
                    8.6
                  ],
                  [
                    1.3,
                    8.4
                  ],
                  [
                    0.4,
                    7.7
                  ],
                  [
                    0.4,
                    7.7
                  ],
                  [
                    0.8,
                    7.2
                  ],
                  [
                    1.6,
                    7.8
                  ],
                  [
                    2.5,
                    8
                  ],
                  [
                    2.5,
                    8
                  ],
                  [
                    3.4,
                    7.7
                  ],
                  [
                    3.7,
                    7
                  ],
                  [
                    3.7,
                    7
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    3.2,
                    6.2
                  ],
                  [
                    2.7,
                    5.9
                  ],
                  [
                    2.7,
                    5.9
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.3,
                    5.3
                  ],
                  [
                    0.9,
                    4.8
                  ],
                  [
                    0.7,
                    4
                  ],
                  [
                    0.7,
                    4
                  ],
                  [
                    0.9,
                    3.2
                  ],
                  [
                    1.6,
                    2.7
                  ],
                  [
                    2.5,
                    2.5
                  ],
                  [
                    2.5,
                    2.5
                  ],
                  [
                    3.5,
                    2.7
                  ],
                  [
                    4.3,
                    3.2
                  ],
                  [
                    4.3,
                    3.2
                  ],
                  [
                    3.9,
                    3.7
                  ],
                  [
                    3.3,
                    3.3
                  ],
                  [
                    2.5,
                    3.1
                  ],
                  [
                    2.5,
                    3.1
                  ],
                  [
                    1.7,
                    3.4
                  ],
                  [
                    1.4,
                    4
                  ],
                  [
                    1.4,
                    4
                  ],
                  [
                    1.6,
                    4.5
                  ],
                  [
                    2,
                    4.8
                  ],
                  [
                    2.4,
                    5
                  ],
                  [
                    2.4,
                    5
                  ],
                  [
                    3.3,
                    5.3
                  ],
                  [
                    3.9,
                    5.7
                  ],
                  [
                    4.3,
                    6.2
                  ],
                  [
                    4.5,
                    6.9
                  ],
                  [
                    4.5,
                    6.9
                  ],
                  [
                    4.2,
                    7.8
                  ],
                  [
                    3.5,
                    8.4
                  ],
                  [
                    2.5,
                    8.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1406,
        ty: 3,
        parent: 1395,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1395,
        ty: 3,
        parent: 1394,
        ks: {
          p: {
            a: 0,
            k: [
              18.709,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1410,
        ty: 4,
        parent: 1409,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    8.6
                  ],
                  [
                    2.1,
                    8.6
                  ],
                  [
                    1.1,
                    8.2
                  ],
                  [
                    0.9,
                    7.2
                  ],
                  [
                    0.9,
                    7.2
                  ],
                  [
                    0.9,
                    4.7
                  ],
                  [
                    0.2,
                    4.7
                  ],
                  [
                    0.2,
                    4.2
                  ],
                  [
                    0.9,
                    4.1
                  ],
                  [
                    1,
                    2.9
                  ],
                  [
                    1.6,
                    2.9
                  ],
                  [
                    1.6,
                    4.1
                  ],
                  [
                    2.8,
                    4.1
                  ],
                  [
                    2.8,
                    4.7
                  ],
                  [
                    1.6,
                    4.7
                  ],
                  [
                    1.6,
                    7.2
                  ],
                  [
                    1.8,
                    7.8
                  ],
                  [
                    2.3,
                    8
                  ],
                  [
                    2.3,
                    8
                  ],
                  [
                    2.6,
                    8
                  ],
                  [
                    2.8,
                    7.9
                  ],
                  [
                    2.8,
                    7.9
                  ],
                  [
                    2.9,
                    8.5
                  ],
                  [
                    2.6,
                    8.6
                  ],
                  [
                    2.1,
                    8.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1409,
        ty: 3,
        parent: 1408,
        ks: {
          p: {
            a: 0,
            k: [
              13.835,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1412,
        ty: 4,
        parent: 1411,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.28,
                    0.12
                  ],
                  [
                    0.21,
                    0.17
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.1
                  ],
                  [
                    -0.26,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.15,
                    0.14
                  ],
                  [
                    0,
                    0.19
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.15,
                    0.07
                  ],
                  [
                    0.16,
                    0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.13,
                    0.16
                  ],
                  [
                    0,
                    0.25
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.27,
                    0.24
                  ],
                  [
                    -0.48,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.24,
                    -0.1
                  ],
                  [
                    -0.17,
                    -0.14
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.16,
                    0.07
                  ],
                  [
                    0.19,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.13,
                    -0.13
                  ],
                  [
                    0,
                    -0.17
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.09,
                    -0.09
                  ],
                  [
                    -0.15,
                    -0.06
                  ],
                  [
                    -0.16,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.1
                  ],
                  [
                    -0.14,
                    -0.17
                  ],
                  [
                    0,
                    -0.28
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.12,
                    -0.2
                  ],
                  [
                    0.24,
                    -0.12
                  ],
                  [
                    0.35,
                    0
                  ]
                ],
                v: [
                  [
                    1.9,
                    8.62
                  ],
                  [
                    1.9,
                    8.62
                  ],
                  [
                    1,
                    8.45
                  ],
                  [
                    0.25,
                    8.01
                  ],
                  [
                    0.25,
                    8.01
                  ],
                  [
                    0.63,
                    7.52
                  ],
                  [
                    1.22,
                    7.89
                  ],
                  [
                    1.92,
                    8.04
                  ],
                  [
                    1.92,
                    8.04
                  ],
                  [
                    2.58,
                    7.84
                  ],
                  [
                    2.79,
                    7.35
                  ],
                  [
                    2.79,
                    7.35
                  ],
                  [
                    2.64,
                    6.97
                  ],
                  [
                    2.26,
                    6.71
                  ],
                  [
                    1.79,
                    6.52
                  ],
                  [
                    1.79,
                    6.52
                  ],
                  [
                    1.18,
                    6.25
                  ],
                  [
                    0.69,
                    5.86
                  ],
                  [
                    0.5,
                    5.25
                  ],
                  [
                    0.5,
                    5.25
                  ],
                  [
                    0.9,
                    4.36
                  ],
                  [
                    2.02,
                    4
                  ],
                  [
                    2.02,
                    4
                  ],
                  [
                    2.78,
                    4.14
                  ],
                  [
                    3.39,
                    4.5
                  ],
                  [
                    3.39,
                    4.5
                  ],
                  [
                    3.03,
                    4.97
                  ],
                  [
                    2.56,
                    4.69
                  ],
                  [
                    2.02,
                    4.58
                  ],
                  [
                    2.02,
                    4.58
                  ],
                  [
                    1.41,
                    4.77
                  ],
                  [
                    1.22,
                    5.21
                  ],
                  [
                    1.22,
                    5.21
                  ],
                  [
                    1.35,
                    5.55
                  ],
                  [
                    1.7,
                    5.78
                  ],
                  [
                    2.17,
                    5.97
                  ],
                  [
                    2.17,
                    5.97
                  ],
                  [
                    2.79,
                    6.24
                  ],
                  [
                    3.31,
                    6.64
                  ],
                  [
                    3.51,
                    7.31
                  ],
                  [
                    3.51,
                    7.31
                  ],
                  [
                    3.32,
                    7.96
                  ],
                  [
                    2.78,
                    8.44
                  ],
                  [
                    1.9,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    0
                  ],
                  [
                    -0.28,
                    -0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.19,
                    0.15
                  ],
                  [
                    0.21,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.29,
                    0
                  ],
                  [
                    0.15,
                    -0.14
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.15
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.15,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.08
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.13,
                    -0.16
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.36
                  ],
                  [
                    0.27,
                    -0.24
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.27,
                    0
                  ],
                  [
                    0.24,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.15,
                    -0.11
                  ],
                  [
                    -0.16,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.28,
                    0
                  ],
                  [
                    -0.13,
                    0.13
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.14
                  ],
                  [
                    0.09,
                    0.09
                  ],
                  [
                    0.15,
                    0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0.08
                  ],
                  [
                    0.21,
                    0.1
                  ],
                  [
                    0.14,
                    0.17
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.24
                  ],
                  [
                    -0.12,
                    0.2
                  ],
                  [
                    -0.24,
                    0.12
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1411,
        ty: 3,
        parent: 1408,
        ks: {
          p: {
            a: 0,
            k: [
              10.038,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1414,
        ty: 4,
        parent: 1413,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.31,
                    0.18
                  ],
                  [
                    0.19,
                    0.34
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.34
                  ],
                  [
                    -0.31,
                    0.18
                  ],
                  [
                    -0.36,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    -0.18
                  ],
                  [
                    -0.19,
                    -0.34
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.19,
                    -0.34
                  ],
                  [
                    0.31,
                    -0.18
                  ],
                  [
                    0.36,
                    0
                  ]
                ],
                v: [
                  [
                    2.46,
                    8.62
                  ],
                  [
                    2.46,
                    8.62
                  ],
                  [
                    1.46,
                    8.35
                  ],
                  [
                    0.7,
                    7.56
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.7,
                    5.06
                  ],
                  [
                    1.46,
                    4.27
                  ],
                  [
                    2.46,
                    4
                  ],
                  [
                    2.46,
                    4
                  ],
                  [
                    3.46,
                    4.27
                  ],
                  [
                    4.21,
                    5.06
                  ],
                  [
                    4.5,
                    6.32
                  ],
                  [
                    4.5,
                    6.32
                  ],
                  [
                    4.21,
                    7.56
                  ],
                  [
                    3.46,
                    8.35
                  ],
                  [
                    2.46,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.36,
                    0
                  ],
                  [
                    -0.31,
                    -0.18
                  ],
                  [
                    -0.19,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0.19,
                    -0.34
                  ],
                  [
                    0.31,
                    -0.18
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.36,
                    0
                  ],
                  [
                    0.31,
                    0.18
                  ],
                  [
                    0.19,
                    0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    -0.19,
                    0.34
                  ],
                  [
                    -0.31,
                    0.18
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.23,
                    0.31
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.23,
                    0.31
                  ],
                  [
                    0.38,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.31
                  ],
                  [
                    0,
                    -0.51
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.24,
                    -0.31
                  ],
                  [
                    -0.37,
                    0
                  ]
                ],
                v: [
                  [
                    2.46,
                    8.01
                  ],
                  [
                    2.46,
                    8.01
                  ],
                  [
                    3.38,
                    7.54
                  ],
                  [
                    3.73,
                    6.32
                  ],
                  [
                    3.73,
                    6.32
                  ],
                  [
                    3.38,
                    5.09
                  ],
                  [
                    2.46,
                    4.61
                  ],
                  [
                    2.46,
                    4.61
                  ],
                  [
                    1.54,
                    5.09
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.54,
                    7.54
                  ],
                  [
                    2.46,
                    8.01
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.38,
                    0
                  ],
                  [
                    0.23,
                    -0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.51
                  ],
                  [
                    -0.23,
                    -0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.37,
                    0
                  ],
                  [
                    -0.24,
                    0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0.24,
                    0.31
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1413,
        ty: 3,
        parent: 1408,
        ks: {
          p: {
            a: 0,
            k: [
              5.128,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1416,
        ty: 4,
        parent: 1415,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.5
                  ],
                  [
                    0.8,
                    8.5
                  ],
                  [
                    0.8,
                    2.6
                  ],
                  [
                    2.5,
                    2.6
                  ],
                  [
                    3.7,
                    2.7
                  ],
                  [
                    4.5,
                    3.3
                  ],
                  [
                    4.7,
                    4.3
                  ],
                  [
                    4.7,
                    4.3
                  ],
                  [
                    4.1,
                    5.7
                  ],
                  [
                    2.5,
                    6.2
                  ],
                  [
                    2.5,
                    6.2
                  ],
                  [
                    1.6,
                    6.2
                  ],
                  [
                    1.6,
                    8.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.6,
                    3.2
                  ],
                  [
                    1.6,
                    5.5
                  ],
                  [
                    2.5,
                    5.5
                  ],
                  [
                    3.6,
                    5.2
                  ],
                  [
                    4,
                    4.3
                  ],
                  [
                    4,
                    4.3
                  ],
                  [
                    3.6,
                    3.4
                  ],
                  [
                    2.4,
                    3.2
                  ],
                  [
                    2.4,
                    3.2
                  ],
                  [
                    1.6,
                    3.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1415,
        ty: 3,
        parent: 1408,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1408,
        ty: 3,
        parent: 1394,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1394,
        ty: 3,
        parent: 1393,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1393,
        ty: 3,
        parent: 1363,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1363,
        ty: 3,
        parent: 1362,
        ks: {
          p: {
            a: 0,
            k: [
              185.459,
              3.346
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1422,
        ty: 0,
        parent: 1418,
        ks: {},
        w: 24,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1420"
      },
      {
        ind: 1418,
        ty: 3,
        parent: 1417,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1417,
        ty: 3,
        parent: 1362,
        ks: {
          p: {
            a: 0,
            k: [
              151.705,
              10.204
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1428,
        ty: 0,
        parent: 1424,
        ks: {},
        w: 112,
        h: 19,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1426"
      },
      {
        ind: 1424,
        ty: 3,
        parent: 1423,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              14
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1433,
        ty: 0,
        parent: 1429,
        ks: {},
        w: 81,
        h: 15,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1431"
      },
      {
        ind: 1429,
        ty: 3,
        parent: 1423,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1423,
        ty: 3,
        parent: 1362,
        ks: {
          p: {
            a: 0,
            k: [
              29.157,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1362,
        ty: 3,
        parent: 1294,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1294,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              10.58,
              102.27
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1442,
        ty: 4,
        parent: 1441,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -1.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.3
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.5,
                    8.5
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.2,
                    7.1
                  ],
                  [
                    3.8,
                    6.5
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    2.1,
                    6.5
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    0.9,
                    6.2
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    11.6
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    3.5,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    10.9
                  ],
                  [
                    2.7,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    8.5
                  ],
                  [
                    2.2,
                    9
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.9,
                    10.7
                  ],
                  [
                    2.7,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1441,
        ty: 3,
        parent: 1440,
        ks: {
          p: {
            a: 0,
            k: [
              19.88,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1444,
        ty: 4,
        parent: 1443,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    1,
                    3.2
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    2,
                    3.2
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2,
                    4.2
                  ],
                  [
                    1.5,
                    4.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1443,
        ty: 3,
        parent: 1440,
        ks: {
          p: {
            a: 0,
            k: [
              16.844,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1446,
        ty: 4,
        parent: 1445,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.5
                  ],
                  [
                    0,
                    1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.1,
                    11.7
                  ],
                  [
                    3.1,
                    11.7
                  ],
                  [
                    1.3,
                    10.9
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    1.9,
                    5.8
                  ],
                  [
                    3.2,
                    5.4
                  ],
                  [
                    3.2,
                    5.4
                  ],
                  [
                    4.1,
                    5.6
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    4.8,
                    5.1
                  ],
                  [
                    4.8,
                    2.8
                  ],
                  [
                    5.8,
                    2.8
                  ],
                  [
                    5.8,
                    11.6
                  ],
                  [
                    5,
                    11.6
                  ],
                  [
                    4.9,
                    10.9
                  ],
                  [
                    4.9,
                    10.9
                  ],
                  [
                    4.1,
                    11.5
                  ],
                  [
                    3.1,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.5,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    10.9
                  ],
                  [
                    3.3,
                    10.9
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    4.8,
                    6.9
                  ],
                  [
                    4.1,
                    6.4
                  ],
                  [
                    3.4,
                    6.3
                  ],
                  [
                    3.4,
                    6.3
                  ],
                  [
                    2.5,
                    6.6
                  ],
                  [
                    1.9,
                    7.4
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    2.1,
                    10.3
                  ],
                  [
                    3.3,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1445,
        ty: 3,
        parent: 1440,
        ks: {
          p: {
            a: 0,
            k: [
              9.995,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1448,
        ty: 4,
        parent: 1447,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.5
                  ],
                  [
                    2,
                    6.5
                  ],
                  [
                    2.9,
                    5.7
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    5.4,
                    6
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    4.8,
                    7.9
                  ],
                  [
                    4.5,
                    6.7
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    2.8,
                    6.6
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1447,
        ty: 3,
        parent: 1440,
        ks: {
          p: {
            a: 0,
            k: [
              3.245,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1450,
        ty: 4,
        parent: 1449,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    3.5
                  ],
                  [
                    2.1,
                    3.5
                  ],
                  [
                    2.1,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1449,
        ty: 3,
        parent: 1440,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1440,
        ty: 3,
        parent: 1439,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1439,
        ty: 3,
        parent: 1438,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1438,
        ty: 3,
        parent: 1437,
        ks: {
          p: {
            a: 0,
            k: [
              21.159,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1460,
        ty: 0,
        parent: 1451,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1458"
      },
      {
        ind: 1451,
        ty: 3,
        parent: 1437,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1437,
        ty: 3,
        parent: 1436,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              19.527
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1466,
        ty: 4,
        parent: 1465,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.7
                  ],
                  [
                    2,
                    6.7
                  ],
                  [
                    2.7,
                    5.8
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.1,
                    6.5
                  ],
                  [
                    3.9,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    2.7,
                    6.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1465,
        ty: 3,
        parent: 1464,
        ks: {
          p: {
            a: 0,
            k: [
              41.499,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1468,
        ty: 4,
        parent: 1467,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.2
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.6,
                    8.6
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    1.6,
                    8.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.4,
                    11.1
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.6
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.1
                  ],
                  [
                    1.6,
                    8.1
                  ],
                  [
                    4.8,
                    8.1
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.6,
                    8.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1467,
        ty: 3,
        parent: 1464,
        ks: {
          p: {
            a: 0,
            k: [
              35.379,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1470,
        ty: 4,
        parent: 1469,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.2
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.6,
                    8.6
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    1.6,
                    8.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.4,
                    11.1
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.6
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.1
                  ],
                  [
                    1.6,
                    8.1
                  ],
                  [
                    4.8,
                    8.1
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.6,
                    8.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1469,
        ty: 3,
        parent: 1464,
        ks: {
          p: {
            a: 0,
            k: [
              29.258,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1472,
        ty: 4,
        parent: 1471,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.5
                  ],
                  [
                    2,
                    6.5
                  ],
                  [
                    2.9,
                    5.7
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    5.4,
                    6
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    4.8,
                    7.9
                  ],
                  [
                    4.5,
                    6.7
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    2.8,
                    6.6
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1471,
        ty: 3,
        parent: 1464,
        ks: {
          p: {
            a: 0,
            k: [
              22.508,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1474,
        ty: 4,
        parent: 1473,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    1,
                    3.2
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    2,
                    3.2
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2,
                    4.2
                  ],
                  [
                    1.5,
                    4.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1473,
        ty: 3,
        parent: 1464,
        ks: {
          p: {
            a: 0,
            k: [
              19.472,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1476,
        ty: 4,
        parent: 1475,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    14.4
                  ],
                  [
                    3,
                    14.4
                  ],
                  [
                    1.2,
                    13.9
                  ],
                  [
                    0.6,
                    12.7
                  ],
                  [
                    0.6,
                    12.7
                  ],
                  [
                    0.8,
                    12
                  ],
                  [
                    1.4,
                    11.4
                  ],
                  [
                    1.4,
                    11.4
                  ],
                  [
                    1.4,
                    11.3
                  ],
                  [
                    1.1,
                    10.9
                  ],
                  [
                    0.9,
                    10.4
                  ],
                  [
                    0.9,
                    10.4
                  ],
                  [
                    1.1,
                    9.7
                  ],
                  [
                    1.6,
                    9.2
                  ],
                  [
                    1.6,
                    9.2
                  ],
                  [
                    1.6,
                    9.2
                  ],
                  [
                    1,
                    8.5
                  ],
                  [
                    0.8,
                    7.6
                  ],
                  [
                    0.8,
                    7.6
                  ],
                  [
                    1.1,
                    6.4
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3,
                    5.4
                  ],
                  [
                    3,
                    5.4
                  ],
                  [
                    3.5,
                    5.5
                  ],
                  [
                    3.9,
                    5.6
                  ],
                  [
                    3.9,
                    5.6
                  ],
                  [
                    6,
                    5.6
                  ],
                  [
                    6,
                    6.4
                  ],
                  [
                    4.7,
                    6.4
                  ],
                  [
                    5.1,
                    6.9
                  ],
                  [
                    5.2,
                    7.6
                  ],
                  [
                    5.2,
                    7.6
                  ],
                  [
                    4.9,
                    8.7
                  ],
                  [
                    4.1,
                    9.4
                  ],
                  [
                    3,
                    9.7
                  ],
                  [
                    3,
                    9.7
                  ],
                  [
                    2.1,
                    9.5
                  ],
                  [
                    2.1,
                    9.5
                  ],
                  [
                    1.9,
                    9.8
                  ],
                  [
                    1.8,
                    10.2
                  ],
                  [
                    1.8,
                    10.2
                  ],
                  [
                    2,
                    10.7
                  ],
                  [
                    2.8,
                    10.8
                  ],
                  [
                    2.8,
                    10.8
                  ],
                  [
                    4,
                    10.8
                  ],
                  [
                    5.5,
                    11.2
                  ],
                  [
                    6.1,
                    12.3
                  ],
                  [
                    6.1,
                    12.3
                  ],
                  [
                    5.7,
                    13.3
                  ],
                  [
                    4.7,
                    14.1
                  ],
                  [
                    3,
                    14.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    9
                  ],
                  [
                    3,
                    9
                  ],
                  [
                    3.9,
                    8.6
                  ],
                  [
                    4.3,
                    7.6
                  ],
                  [
                    4.3,
                    7.6
                  ],
                  [
                    3.9,
                    6.6
                  ],
                  [
                    3,
                    6.2
                  ],
                  [
                    3,
                    6.2
                  ],
                  [
                    2.1,
                    6.6
                  ],
                  [
                    1.8,
                    7.6
                  ],
                  [
                    1.8,
                    7.6
                  ],
                  [
                    2.1,
                    8.6
                  ],
                  [
                    3,
                    9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    13.6
                  ],
                  [
                    3.2,
                    13.6
                  ],
                  [
                    4.6,
                    13.3
                  ],
                  [
                    5.1,
                    12.4
                  ],
                  [
                    5.1,
                    12.4
                  ],
                  [
                    4.8,
                    11.8
                  ],
                  [
                    3.9,
                    11.7
                  ],
                  [
                    3.9,
                    11.7
                  ],
                  [
                    2.8,
                    11.7
                  ],
                  [
                    2.5,
                    11.7
                  ],
                  [
                    2.1,
                    11.6
                  ],
                  [
                    2.1,
                    11.6
                  ],
                  [
                    1.6,
                    12.1
                  ],
                  [
                    1.4,
                    12.6
                  ],
                  [
                    1.4,
                    12.6
                  ],
                  [
                    1.9,
                    13.4
                  ],
                  [
                    3.2,
                    13.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1475,
        ty: 3,
        parent: 1464,
        ks: {
          p: {
            a: 0,
            k: [
              13.253,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1478,
        ty: 4,
        parent: 1477,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.5
                  ],
                  [
                    2,
                    6.5
                  ],
                  [
                    2.9,
                    5.7
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    5.4,
                    6
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    4.8,
                    7.9
                  ],
                  [
                    4.5,
                    6.7
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    2.8,
                    6.6
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1477,
        ty: 3,
        parent: 1464,
        ks: {
          p: {
            a: 0,
            k: [
              6.503,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1480,
        ty: 4,
        parent: 1479,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    5.9,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    3.5
                  ],
                  [
                    5.8,
                    3.5
                  ],
                  [
                    5.8,
                    4.4
                  ],
                  [
                    2.1,
                    4.4
                  ],
                  [
                    2.1,
                    6.9
                  ],
                  [
                    5.2,
                    6.9
                  ],
                  [
                    5.2,
                    7.8
                  ],
                  [
                    2.1,
                    7.8
                  ],
                  [
                    2.1,
                    10.7
                  ],
                  [
                    5.9,
                    10.7
                  ],
                  [
                    5.9,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1479,
        ty: 3,
        parent: 1464,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1464,
        ty: 3,
        parent: 1463,
        ks: {
          p: {
            a: 0,
            k: [
              48.56,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1483,
        ty: 4,
        parent: 1482,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.2
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.6,
                    8.6
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    1.6,
                    8.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.4,
                    11.1
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.6
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.1
                  ],
                  [
                    1.6,
                    8.1
                  ],
                  [
                    4.8,
                    8.1
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.6,
                    8.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1482,
        ty: 3,
        parent: 1481,
        ks: {
          p: {
            a: 0,
            k: [
              39.971,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1485,
        ty: 4,
        parent: 1484,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.7
                  ],
                  [
                    2,
                    6.7
                  ],
                  [
                    2.7,
                    5.8
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.1,
                    6.5
                  ],
                  [
                    3.9,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    2.7,
                    6.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1484,
        ty: 3,
        parent: 1481,
        ks: {
          p: {
            a: 0,
            k: [
              35.689,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1487,
        ty: 4,
        parent: 1486,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -1.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.3
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.5,
                    8.5
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.2,
                    7.1
                  ],
                  [
                    3.8,
                    6.5
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    2.1,
                    6.5
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    0.9,
                    6.2
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    11.6
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    3.5,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    10.9
                  ],
                  [
                    2.7,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    8.5
                  ],
                  [
                    2.2,
                    9
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.9,
                    10.7
                  ],
                  [
                    2.7,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1486,
        ty: 3,
        parent: 1481,
        ks: {
          p: {
            a: 0,
            k: [
              29.47,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1489,
        ty: 4,
        parent: 1488,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.1,
                    11.6
                  ],
                  [
                    2,
                    11.6
                  ],
                  [
                    0.3,
                    5.6
                  ],
                  [
                    1.3,
                    5.6
                  ],
                  [
                    2.2,
                    9.1
                  ],
                  [
                    2.4,
                    9.9
                  ],
                  [
                    2.6,
                    10.7
                  ],
                  [
                    2.6,
                    10.7
                  ],
                  [
                    2.6,
                    10.7
                  ],
                  [
                    2.8,
                    9.9
                  ],
                  [
                    3,
                    9.1
                  ],
                  [
                    3,
                    9.1
                  ],
                  [
                    4,
                    5.6
                  ],
                  [
                    4.9,
                    5.6
                  ],
                  [
                    5.9,
                    9.1
                  ],
                  [
                    6.1,
                    9.9
                  ],
                  [
                    6.3,
                    10.7
                  ],
                  [
                    6.3,
                    10.7
                  ],
                  [
                    6.4,
                    10.7
                  ],
                  [
                    6.5,
                    9.9
                  ],
                  [
                    6.7,
                    9.1
                  ],
                  [
                    6.7,
                    9.1
                  ],
                  [
                    7.6,
                    5.6
                  ],
                  [
                    8.6,
                    5.6
                  ],
                  [
                    7,
                    11.6
                  ],
                  [
                    5.7,
                    11.6
                  ],
                  [
                    4.9,
                    8.4
                  ],
                  [
                    4.7,
                    7.5
                  ],
                  [
                    4.5,
                    6.6
                  ],
                  [
                    4.5,
                    6.6
                  ],
                  [
                    4.4,
                    6.6
                  ],
                  [
                    4.2,
                    7.5
                  ],
                  [
                    4,
                    8.4
                  ],
                  [
                    4,
                    8.4
                  ],
                  [
                    3.1,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1488,
        ty: 3,
        parent: 1481,
        ks: {
          p: {
            a: 0,
            k: [
              20.61,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1491,
        ty: 4,
        parent: 1490,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.2,
                    11.6
                  ],
                  [
                    1.2,
                    11.6
                  ],
                  [
                    1.2,
                    6.4
                  ],
                  [
                    0.4,
                    6.4
                  ],
                  [
                    0.4,
                    5.7
                  ],
                  [
                    1.2,
                    5.6
                  ],
                  [
                    1.2,
                    4.6
                  ],
                  [
                    1.6,
                    3.2
                  ],
                  [
                    2.9,
                    2.7
                  ],
                  [
                    2.9,
                    2.7
                  ],
                  [
                    3.5,
                    2.7
                  ],
                  [
                    3.9,
                    2.8
                  ],
                  [
                    3.9,
                    2.8
                  ],
                  [
                    3.7,
                    3.6
                  ],
                  [
                    3,
                    3.5
                  ],
                  [
                    3,
                    3.5
                  ],
                  [
                    2.2,
                    4.6
                  ],
                  [
                    2.2,
                    4.6
                  ],
                  [
                    2.2,
                    5.6
                  ],
                  [
                    3.5,
                    5.6
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    2.2,
                    6.4
                  ],
                  [
                    2.2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    6.5,
                    11.7
                  ],
                  [
                    6.5,
                    11.7
                  ],
                  [
                    5.2,
                    11.2
                  ],
                  [
                    4.8,
                    9.7
                  ],
                  [
                    4.8,
                    9.7
                  ],
                  [
                    4.8,
                    6.4
                  ],
                  [
                    3.9,
                    6.4
                  ],
                  [
                    3.9,
                    5.7
                  ],
                  [
                    4.8,
                    5.6
                  ],
                  [
                    5,
                    3.9
                  ],
                  [
                    5.8,
                    3.9
                  ],
                  [
                    5.8,
                    5.6
                  ],
                  [
                    7.4,
                    5.6
                  ],
                  [
                    7.4,
                    6.4
                  ],
                  [
                    5.8,
                    6.4
                  ],
                  [
                    5.8,
                    9.7
                  ],
                  [
                    6,
                    10.6
                  ],
                  [
                    6.7,
                    10.9
                  ],
                  [
                    6.7,
                    10.9
                  ],
                  [
                    7.1,
                    10.9
                  ],
                  [
                    7.4,
                    10.7
                  ],
                  [
                    7.4,
                    10.7
                  ],
                  [
                    7.6,
                    11.5
                  ],
                  [
                    7.1,
                    11.7
                  ],
                  [
                    6.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1490,
        ty: 3,
        parent: 1481,
        ks: {
          p: {
            a: 0,
            k: [
              13.278,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1493,
        ty: 4,
        parent: 1492,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    11.7
                  ],
                  [
                    3.3,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.8
                  ],
                  [
                    5.7,
                    6.9
                  ],
                  [
                    6.1,
                    8.6
                  ],
                  [
                    6.1,
                    8.6
                  ],
                  [
                    5.7,
                    10.3
                  ],
                  [
                    4.7,
                    11.4
                  ],
                  [
                    3.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    10.9
                  ],
                  [
                    3.3,
                    10.9
                  ],
                  [
                    4.6,
                    10.3
                  ],
                  [
                    5.1,
                    8.6
                  ],
                  [
                    5.1,
                    8.6
                  ],
                  [
                    4.6,
                    6.9
                  ],
                  [
                    3.3,
                    6.3
                  ],
                  [
                    3.3,
                    6.3
                  ],
                  [
                    2.1,
                    6.9
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    2.1,
                    10.3
                  ],
                  [
                    3.3,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1492,
        ty: 3,
        parent: 1481,
        ks: {
          p: {
            a: 0,
            k: [
              6.59,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1495,
        ty: 4,
        parent: 1494,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    1.1,
                    9.8
                  ],
                  [
                    2.2,
                    10.6
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    4.6,
                    10.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    4.9,
                    8.8
                  ],
                  [
                    4.4,
                    8.4
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    2.6,
                    7.6
                  ],
                  [
                    1.8,
                    7.2
                  ],
                  [
                    1.2,
                    6.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    1.2,
                    4.4
                  ],
                  [
                    2.1,
                    3.6
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    4.8,
                    3.6
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.3,
                    5
                  ],
                  [
                    4.5,
                    4.4
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    2.4,
                    4.6
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2.2,
                    6.1
                  ],
                  [
                    2.7,
                    6.5
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    4.4,
                    7.3
                  ],
                  [
                    5.3,
                    7.7
                  ],
                  [
                    5.9,
                    8.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    5.8,
                    10.6
                  ],
                  [
                    4.8,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1494,
        ty: 3,
        parent: 1481,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1481,
        ty: 3,
        parent: 1463,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1463,
        ty: 3,
        parent: 1462,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.8
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1462,
        ty: 3,
        parent: 1461,
        ks: {
          p: {
            a: 0,
            k: [
              21.159,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1505,
        ty: 0,
        parent: 1496,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1503"
      },
      {
        ind: 1496,
        ty: 3,
        parent: 1461,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1461,
        ty: 3,
        parent: 1436,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1436,
        ty: 3,
        parent: 1435,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              36.053
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1511,
        ty: 4,
        parent: 1510,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    8.5
                  ],
                  [
                    3,
                    8.5
                  ],
                  [
                    3,
                    11.4
                  ],
                  [
                    2.9,
                    12.9
                  ],
                  [
                    4,
                    12.1
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    7.2,
                    12.6
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    19.7
                  ],
                  [
                    6,
                    19.7
                  ],
                  [
                    6,
                    15.1
                  ],
                  [
                    5.7,
                    13.7
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    3.9,
                    13.6
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1510,
        ty: 3,
        parent: 1509,
        ks: {
          p: {
            a: 0,
            k: [
              29.928,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1513,
        ty: 4,
        parent: 1512,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.1
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0.6,
                    -0.2
                  ],
                  [
                    0.8,
                    0
                  ]
                ],
                v: [
                  [
                    3.9,
                    23.2
                  ],
                  [
                    3.9,
                    23.2
                  ],
                  [
                    2.2,
                    23
                  ],
                  [
                    1.1,
                    22.3
                  ],
                  [
                    0.6,
                    21.2
                  ],
                  [
                    0.6,
                    21.2
                  ],
                  [
                    1.7,
                    19.5
                  ],
                  [
                    1.7,
                    19.5
                  ],
                  [
                    1.7,
                    19.4
                  ],
                  [
                    1.2,
                    18.9
                  ],
                  [
                    1,
                    18.1
                  ],
                  [
                    1,
                    18.1
                  ],
                  [
                    1.3,
                    17.3
                  ],
                  [
                    1.9,
                    16.7
                  ],
                  [
                    1.9,
                    16.7
                  ],
                  [
                    1.9,
                    16.6
                  ],
                  [
                    1.2,
                    15.8
                  ],
                  [
                    0.9,
                    14.6
                  ],
                  [
                    0.9,
                    14.6
                  ],
                  [
                    1.3,
                    13
                  ],
                  [
                    2.5,
                    12.1
                  ],
                  [
                    4,
                    11.8
                  ],
                  [
                    4,
                    11.8
                  ],
                  [
                    4.6,
                    11.8
                  ],
                  [
                    5.1,
                    12
                  ],
                  [
                    5.1,
                    12
                  ],
                  [
                    7.9,
                    12
                  ],
                  [
                    7.9,
                    13.3
                  ],
                  [
                    6.5,
                    13.3
                  ],
                  [
                    6.8,
                    13.9
                  ],
                  [
                    6.9,
                    14.6
                  ],
                  [
                    6.9,
                    14.6
                  ],
                  [
                    6.5,
                    16.1
                  ],
                  [
                    5.5,
                    17
                  ],
                  [
                    4,
                    17.3
                  ],
                  [
                    4,
                    17.3
                  ],
                  [
                    3.4,
                    17.2
                  ],
                  [
                    2.9,
                    17.1
                  ],
                  [
                    2.9,
                    17.1
                  ],
                  [
                    2.6,
                    17.4
                  ],
                  [
                    2.5,
                    17.8
                  ],
                  [
                    2.5,
                    17.8
                  ],
                  [
                    2.8,
                    18.3
                  ],
                  [
                    3.8,
                    18.5
                  ],
                  [
                    3.8,
                    18.5
                  ],
                  [
                    5.2,
                    18.5
                  ],
                  [
                    7.3,
                    19
                  ],
                  [
                    8,
                    20.4
                  ],
                  [
                    8,
                    20.4
                  ],
                  [
                    7.5,
                    21.8
                  ],
                  [
                    6.1,
                    22.8
                  ],
                  [
                    3.9,
                    23.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.6,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.4,
                    0
                  ]
                ],
                v: [
                  [
                    4,
                    16.1
                  ],
                  [
                    4,
                    16.1
                  ],
                  [
                    4.9,
                    15.7
                  ],
                  [
                    5.3,
                    14.6
                  ],
                  [
                    5.3,
                    14.6
                  ],
                  [
                    4.9,
                    13.4
                  ],
                  [
                    4,
                    13
                  ],
                  [
                    4,
                    13
                  ],
                  [
                    3,
                    13.4
                  ],
                  [
                    2.6,
                    14.6
                  ],
                  [
                    2.6,
                    14.6
                  ],
                  [
                    3,
                    15.7
                  ],
                  [
                    4,
                    16.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.6,
                    0
                  ]
                ],
                v: [
                  [
                    4.2,
                    22
                  ],
                  [
                    4.2,
                    22
                  ],
                  [
                    5.7,
                    21.6
                  ],
                  [
                    6.3,
                    20.7
                  ],
                  [
                    6.3,
                    20.7
                  ],
                  [
                    5.9,
                    20.1
                  ],
                  [
                    4.9,
                    20
                  ],
                  [
                    4.9,
                    20
                  ],
                  [
                    3.8,
                    20
                  ],
                  [
                    2.8,
                    19.9
                  ],
                  [
                    2.8,
                    19.9
                  ],
                  [
                    2.2,
                    20.9
                  ],
                  [
                    2.2,
                    20.9
                  ],
                  [
                    2.7,
                    21.7
                  ],
                  [
                    4.2,
                    22
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1512,
        ty: 3,
        parent: 1509,
        ks: {
          p: {
            a: 0,
            k: [
              21.681,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1515,
        ty: 4,
        parent: 1514,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    2.7,
                    12
                  ],
                  [
                    2.8,
                    13
                  ],
                  [
                    2.9,
                    13
                  ],
                  [
                    4,
                    12.1
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    7.2,
                    12.6
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    19.7
                  ],
                  [
                    6,
                    19.7
                  ],
                  [
                    6,
                    15.1
                  ],
                  [
                    5.7,
                    13.7
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    3.9,
                    13.6
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1514,
        ty: 3,
        parent: 1509,
        ks: {
          p: {
            a: 0,
            k: [
              12.799,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1517,
        ty: 4,
        parent: 1516,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    3,
                    12
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    10.6
                  ],
                  [
                    2.1,
                    10.6
                  ],
                  [
                    1.3,
                    10.3
                  ],
                  [
                    1,
                    9.5
                  ],
                  [
                    1,
                    9.5
                  ],
                  [
                    1.3,
                    8.8
                  ],
                  [
                    2.1,
                    8.5
                  ],
                  [
                    2.1,
                    8.5
                  ],
                  [
                    2.9,
                    8.8
                  ],
                  [
                    3.2,
                    9.5
                  ],
                  [
                    3.2,
                    9.5
                  ],
                  [
                    2.9,
                    10.3
                  ],
                  [
                    2.1,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1516,
        ty: 3,
        parent: 1509,
        ks: {
          p: {
            a: 0,
            k: [
              8.644,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1519,
        ty: 4,
        parent: 1518,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0.3
                  ],
                  [
                    0.5,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    -0.2
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0.8,
                    0
                  ]
                ],
                v: [
                  [
                    4.3,
                    19.9
                  ],
                  [
                    4.3,
                    19.9
                  ],
                  [
                    2.3,
                    19.5
                  ],
                  [
                    0.6,
                    18.4
                  ],
                  [
                    0.6,
                    18.4
                  ],
                  [
                    1.7,
                    17.2
                  ],
                  [
                    3,
                    18
                  ],
                  [
                    4.4,
                    18.3
                  ],
                  [
                    4.4,
                    18.3
                  ],
                  [
                    5.7,
                    18
                  ],
                  [
                    6.2,
                    17
                  ],
                  [
                    6.2,
                    17
                  ],
                  [
                    5.7,
                    16.1
                  ],
                  [
                    4.6,
                    15.5
                  ],
                  [
                    4.6,
                    15.5
                  ],
                  [
                    3.2,
                    14.9
                  ],
                  [
                    2.2,
                    14.3
                  ],
                  [
                    1.4,
                    13.4
                  ],
                  [
                    1.1,
                    12.1
                  ],
                  [
                    1.1,
                    12.1
                  ],
                  [
                    1.5,
                    10.6
                  ],
                  [
                    2.8,
                    9.6
                  ],
                  [
                    4.6,
                    9.2
                  ],
                  [
                    4.6,
                    9.2
                  ],
                  [
                    6.3,
                    9.5
                  ],
                  [
                    7.7,
                    10.5
                  ],
                  [
                    7.7,
                    10.5
                  ],
                  [
                    6.8,
                    11.7
                  ],
                  [
                    5.8,
                    11
                  ],
                  [
                    4.6,
                    10.8
                  ],
                  [
                    4.6,
                    10.8
                  ],
                  [
                    3.4,
                    11.1
                  ],
                  [
                    2.9,
                    12
                  ],
                  [
                    2.9,
                    12
                  ],
                  [
                    3.2,
                    12.7
                  ],
                  [
                    3.8,
                    13.1
                  ],
                  [
                    4.6,
                    13.5
                  ],
                  [
                    4.6,
                    13.5
                  ],
                  [
                    6,
                    14.1
                  ],
                  [
                    7.5,
                    15.1
                  ],
                  [
                    8.1,
                    16.9
                  ],
                  [
                    8.1,
                    16.9
                  ],
                  [
                    7.6,
                    18.4
                  ],
                  [
                    6.4,
                    19.5
                  ],
                  [
                    4.3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.7,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.6,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0.3
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1518,
        ty: 3,
        parent: 1509,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1509,
        ty: 3,
        parent: 1508,
        ks: {
          p: {
            a: 0,
            k: [
              48.912,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1522,
        ty: 4,
        parent: 1521,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    8.5
                  ],
                  [
                    3,
                    8.5
                  ],
                  [
                    3,
                    11.4
                  ],
                  [
                    2.9,
                    12.9
                  ],
                  [
                    4,
                    12.1
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    7.2,
                    12.6
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    19.7
                  ],
                  [
                    6,
                    19.7
                  ],
                  [
                    6,
                    15.1
                  ],
                  [
                    5.7,
                    13.7
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    3.9,
                    13.6
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1521,
        ty: 3,
        parent: 1520,
        ks: {
          p: {
            a: 0,
            k: [
              36.89,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1524,
        ty: 4,
        parent: 1523,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.4
                  ],
                  [
                    -0.9,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.4,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.5
                  ],
                  [
                    1,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    19.9
                  ],
                  [
                    3.3,
                    19.9
                  ],
                  [
                    1.7,
                    19.6
                  ],
                  [
                    0.4,
                    18.9
                  ],
                  [
                    0.4,
                    18.9
                  ],
                  [
                    1.2,
                    17.7
                  ],
                  [
                    2.3,
                    18.3
                  ],
                  [
                    3.4,
                    18.6
                  ],
                  [
                    3.4,
                    18.6
                  ],
                  [
                    4.3,
                    18.3
                  ],
                  [
                    4.6,
                    17.6
                  ],
                  [
                    4.6,
                    17.6
                  ],
                  [
                    4.4,
                    17.1
                  ],
                  [
                    3.8,
                    16.7
                  ],
                  [
                    3,
                    16.4
                  ],
                  [
                    3,
                    16.4
                  ],
                  [
                    2,
                    15.9
                  ],
                  [
                    1.1,
                    15.2
                  ],
                  [
                    0.8,
                    14.1
                  ],
                  [
                    0.8,
                    14.1
                  ],
                  [
                    1.6,
                    12.4
                  ],
                  [
                    3.6,
                    11.8
                  ],
                  [
                    3.6,
                    11.8
                  ],
                  [
                    5.1,
                    12.1
                  ],
                  [
                    6.3,
                    12.7
                  ],
                  [
                    6.3,
                    12.7
                  ],
                  [
                    5.4,
                    13.8
                  ],
                  [
                    4.6,
                    13.3
                  ],
                  [
                    3.7,
                    13.1
                  ],
                  [
                    3.7,
                    13.1
                  ],
                  [
                    2.8,
                    13.4
                  ],
                  [
                    2.5,
                    14
                  ],
                  [
                    2.5,
                    14
                  ],
                  [
                    3,
                    14.7
                  ],
                  [
                    4.1,
                    15.2
                  ],
                  [
                    4.1,
                    15.2
                  ],
                  [
                    5.2,
                    15.6
                  ],
                  [
                    6,
                    16.4
                  ],
                  [
                    6.4,
                    17.5
                  ],
                  [
                    6.4,
                    17.5
                  ],
                  [
                    5.6,
                    19.2
                  ],
                  [
                    3.3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.5,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    -0.5,
                    0.5
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1523,
        ty: 3,
        parent: 1520,
        ks: {
          p: {
            a: 0,
            k: [
              30.055,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1526,
        ty: 4,
        parent: 1525,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    19.9
                  ],
                  [
                    3.5,
                    19.9
                  ],
                  [
                    1.7,
                    19.1
                  ],
                  [
                    1.1,
                    16.8
                  ],
                  [
                    1.1,
                    16.8
                  ],
                  [
                    1.1,
                    12
                  ],
                  [
                    2.9,
                    12
                  ],
                  [
                    2.9,
                    16.6
                  ],
                  [
                    3.2,
                    18
                  ],
                  [
                    4.1,
                    18.4
                  ],
                  [
                    4.1,
                    18.4
                  ],
                  [
                    5,
                    18.1
                  ],
                  [
                    5.8,
                    17.3
                  ],
                  [
                    5.8,
                    17.3
                  ],
                  [
                    5.8,
                    12
                  ],
                  [
                    7.7,
                    12
                  ],
                  [
                    7.7,
                    19.7
                  ],
                  [
                    6.2,
                    19.7
                  ],
                  [
                    6,
                    18.6
                  ],
                  [
                    6,
                    18.6
                  ],
                  [
                    4.9,
                    19.6
                  ],
                  [
                    3.5,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1525,
        ty: 3,
        parent: 1520,
        ks: {
          p: {
            a: 0,
            k: [
              21.237,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1528,
        ty: 4,
        parent: 1527,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.5
                  ],
                  [
                    0.8,
                    0
                  ]
                ],
                v: [
                  [
                    1.7,
                    23
                  ],
                  [
                    1.7,
                    23
                  ],
                  [
                    1.1,
                    22.9
                  ],
                  [
                    0.7,
                    22.8
                  ],
                  [
                    0.7,
                    22.8
                  ],
                  [
                    1,
                    21.4
                  ],
                  [
                    1.3,
                    21.4
                  ],
                  [
                    1.6,
                    21.5
                  ],
                  [
                    1.6,
                    21.5
                  ],
                  [
                    2.5,
                    21.1
                  ],
                  [
                    3.1,
                    20.1
                  ],
                  [
                    3.1,
                    20.1
                  ],
                  [
                    3.3,
                    19.7
                  ],
                  [
                    0.2,
                    12
                  ],
                  [
                    2,
                    12
                  ],
                  [
                    3.4,
                    15.8
                  ],
                  [
                    3.7,
                    16.9
                  ],
                  [
                    4.1,
                    18
                  ],
                  [
                    4.1,
                    18
                  ],
                  [
                    4.1,
                    18
                  ],
                  [
                    4.4,
                    16.9
                  ],
                  [
                    4.7,
                    15.8
                  ],
                  [
                    4.7,
                    15.8
                  ],
                  [
                    5.9,
                    12
                  ],
                  [
                    7.7,
                    12
                  ],
                  [
                    4.8,
                    20.1
                  ],
                  [
                    3.6,
                    22.2
                  ],
                  [
                    1.7,
                    23
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.9
                  ],
                  [
                    -0.5,
                    0.5
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1527,
        ty: 3,
        parent: 1520,
        ks: {
          p: {
            a: 0,
            k: [
              13.386,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1530,
        ty: 4,
        parent: 1529,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    3,
                    12
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    10.6
                  ],
                  [
                    2.1,
                    10.6
                  ],
                  [
                    1.3,
                    10.3
                  ],
                  [
                    1,
                    9.5
                  ],
                  [
                    1,
                    9.5
                  ],
                  [
                    1.3,
                    8.8
                  ],
                  [
                    2.1,
                    8.5
                  ],
                  [
                    2.1,
                    8.5
                  ],
                  [
                    2.9,
                    8.8
                  ],
                  [
                    3.2,
                    9.5
                  ],
                  [
                    3.2,
                    9.5
                  ],
                  [
                    2.9,
                    10.3
                  ],
                  [
                    2.1,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1529,
        ty: 3,
        parent: 1520,
        ks: {
          p: {
            a: 0,
            k: [
              9.231,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1532,
        ty: 4,
        parent: 1531,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.6,
                    -0.2
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    19.7
                  ],
                  [
                    1.3,
                    19.7
                  ],
                  [
                    1.3,
                    9.4
                  ],
                  [
                    4.6,
                    9.4
                  ],
                  [
                    6.6,
                    9.7
                  ],
                  [
                    8.1,
                    10.7
                  ],
                  [
                    8.6,
                    12.6
                  ],
                  [
                    8.6,
                    12.6
                  ],
                  [
                    8.1,
                    14.5
                  ],
                  [
                    6.7,
                    15.6
                  ],
                  [
                    4.6,
                    15.9
                  ],
                  [
                    4.6,
                    15.9
                  ],
                  [
                    3.2,
                    15.9
                  ],
                  [
                    3.2,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.6,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.6,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    10.8
                  ],
                  [
                    3.2,
                    14.5
                  ],
                  [
                    4.5,
                    14.5
                  ],
                  [
                    6.8,
                    12.6
                  ],
                  [
                    6.8,
                    12.6
                  ],
                  [
                    6.2,
                    11.2
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    3.2,
                    10.8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1531,
        ty: 3,
        parent: 1520,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1520,
        ty: 3,
        parent: 1508,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1508,
        ty: 3,
        parent: 1507,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.394
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1507,
        ty: 3,
        parent: 1506,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1506,
        ty: 3,
        parent: 1435,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1435,
        ty: 3,
        parent: 1434,
        ks: {
          p: {
            a: 0,
            k: [
              91.69,
              3.002
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1543,
        ty: 0,
        parent: 1534,
        ks: {
          a: {
            a: 0,
            k: [
              54.666,
              55.542
            ]
          },
          p: {
            a: 0,
            k: [
              54.666,
              55.542
            ]
          }
        },
        w: 21.159,
        h: 21.159,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1541"
      },
      {
        ind: 1534,
        ty: 3,
        parent: 1533,
        ks: {
          p: {
            a: 0,
            k: [
              54.666,
              55.542
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1546,
        ty: 4,
        td: 1,
        parent: 1544,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                38.792,
                38.792
              ]
            },
            r: {
              a: 0,
              k: 60
            },
            s: {
              a: 0,
              k: [
                77.584,
                77.584
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1545,
        ty: 4,
        tt: 1,
        parent: 1544,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                p: {
                  a: 0,
                  k: [
                    38.792,
                    38.792
                  ]
                },
                r: {
                  a: 0,
                  k: 0
                },
                s: {
                  a: 0,
                  k: [
                    81.992,
                    81.992
                  ]
                }
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0,
                    0,
                    0,
                    0
                  ]
                },
                o: {
                  a: 0,
                  k: 0
                }
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          },
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                p: {
                  a: 0,
                  k: [
                    38.792,
                    38.792
                  ]
                },
                r: {
                  a: 0,
                  k: 60
                },
                s: {
                  a: 0,
                  k: [
                    77.584,
                    77.584
                  ]
                }
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.427,
                    0.184,
                    0.604
                  ]
                },
                lj: 1,
                ml: 10,
                o: {
                  a: 0,
                  k: 100
                },
                w: {
                  a: 0,
                  k: 4.408
                }
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      },
      {
        ind: 1562,
        ty: 4,
        td: 1,
        parent: 1544,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                38.792,
                38.792
              ]
            },
            r: {
              a: 0,
              k: 60
            },
            s: {
              a: 0,
              k: [
                77.584,
                77.584
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1561,
        ty: 0,
        tt: 1,
        parent: 1544,
        ks: {},
        w: 71,
        h: 71,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1559"
      },
      {
        ind: 1544,
        ty: 3,
        parent: 1533,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1533,
        ty: 3,
        parent: 1434,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1434,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              10.58,
              10.58
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1563,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                148.115,
                91.315
              ]
            },
            r: {
              a: 0,
              k: 7
            },
            s: {
              a: 0,
              k: [
                296.23,
                182.63
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                1,
                1
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      }
    ]
  },
  {
    id: "1568",
    layers: [
      {
        ind: 1566,
        ty: 0,
        ks: {
          p: {
            a: 0,
            k: [
              142.629,
              142.629
            ]
          }
        },
        w: 297,
        h: 183,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1564"
      },
      {
        ind: 1567,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                290.745,
                233.944
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                581.489,
                467.888
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      }
    ]
  },
  {
    id: "1634",
    layers: [
      {
        ind: 1633,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                7,
                4.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                14,
                9
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.09,
                                -0.09
                              ],
                              [
                                0.13,
                                0
                              ],
                              [
                                0.09,
                                0.09
                              ],
                              [
                                0,
                                0.13
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.06,
                                -0.02
                              ],
                              [
                                0.06,
                                0
                              ],
                              [
                                0.06,
                                0.02
                              ],
                              [
                                0.05,
                                0.05
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.13,
                                0
                              ],
                              [
                                0.09,
                                0.09
                              ],
                              [
                                0,
                                0.13
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.06,
                                0.02
                              ],
                              [
                                -0.06,
                                0
                              ],
                              [
                                -0.06,
                                -0.03
                              ],
                              [
                                -0.05,
                                -0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.09,
                                0.09
                              ],
                              [
                                0,
                                0.13
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                -0.13,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                -0.13
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.13
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.04,
                                0.05
                              ],
                              [
                                -0.06,
                                0.02
                              ],
                              [
                                -0.06,
                                0
                              ],
                              [
                                -0.06,
                                -0.02
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                -0.13,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                -0.12
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                -0.04
                              ],
                              [
                                0.06,
                                -0.03
                              ],
                              [
                                0.07,
                                0
                              ],
                              [
                                0.06,
                                0.02
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.13,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                -0.13
                              ],
                              [
                                0.09,
                                -0.09
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.13,
                                0
                              ],
                              [
                                0.09,
                                0.09
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                9.8,
                                0.75
                              ],
                              [
                                9.8,
                                3.32
                              ],
                              [
                                9.66,
                                3.66
                              ],
                              [
                                9.32,
                                3.8
                              ],
                              [
                                8.98,
                                3.66
                              ],
                              [
                                8.84,
                                3.32
                              ],
                              [
                                8.84,
                                1.91
                              ],
                              [
                                5.8,
                                4.95
                              ],
                              [
                                5.65,
                                5.05
                              ],
                              [
                                5.46,
                                5.09
                              ],
                              [
                                5.28,
                                5.05
                              ],
                              [
                                5.12,
                                4.95
                              ],
                              [
                                3.86,
                                3.68
                              ],
                              [
                                1.3,
                                6.23
                              ],
                              [
                                0.96,
                                6.38
                              ],
                              [
                                0.62,
                                6.23
                              ],
                              [
                                0.48,
                                5.89
                              ],
                              [
                                0.62,
                                5.55
                              ],
                              [
                                3.52,
                                2.66
                              ],
                              [
                                3.67,
                                2.55
                              ],
                              [
                                3.86,
                                2.52
                              ],
                              [
                                4.04,
                                2.55
                              ],
                              [
                                4.2,
                                2.66
                              ],
                              [
                                5.46,
                                3.93
                              ],
                              [
                                8.16,
                                1.23
                              ],
                              [
                                6.75,
                                1.23
                              ],
                              [
                                6.41,
                                1.09
                              ],
                              [
                                6.27,
                                0.75
                              ],
                              [
                                6.41,
                                0.41
                              ],
                              [
                                6.75,
                                0.27
                              ],
                              [
                                9.32,
                                0.27
                              ],
                              [
                                9.66,
                                0.41
                              ],
                              [
                                9.8,
                                0.75
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0.1,
                            0.52,
                            0.32,
                            1
                          ]
                        },
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1637",
    layers: [
      {
        ind: 1636,
        ty: 0,
        parent: 1632,
        ks: {},
        w: 14,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1634"
      },
      {
        ind: 1632,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              2
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1645",
    layers: [
      {
        ind: 1644,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                1,
                1
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                2,
                2
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.02
                              ],
                              [
                                0.04,
                                0
                              ],
                              [
                                0.01,
                                0
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                0
                              ],
                              [
                                0,
                                -0.03
                              ],
                              [
                                -0.01,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                0.58,
                                0.66
                              ],
                              [
                                0.61,
                                0.66
                              ],
                              [
                                0.68,
                                0.62
                              ],
                              [
                                0.62,
                                0.57
                              ],
                              [
                                0.58,
                                0.57
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.07,
                                0
                              ],
                              [
                                -0.02,
                                -0.02
                              ],
                              [
                                0,
                                -0.04
                              ],
                              [
                                0.05,
                                -0.01
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.01,
                                -0.05
                              ],
                              [
                                0,
                                -0.01
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.03
                              ],
                              [
                                0.04,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.02,
                                0
                              ],
                              [
                                0.07,
                                0
                              ],
                              [
                                0.02,
                                0.01
                              ],
                              [
                                0,
                                0.03
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                0.01
                              ],
                              [
                                0.01,
                                0.05
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.01,
                                -0.01
                              ],
                              [
                                -0.01,
                                -0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                0.58,
                                0.85
                              ],
                              [
                                0.48,
                                0.85
                              ],
                              [
                                0.48,
                                0.51
                              ],
                              [
                                0.63,
                                0.5
                              ],
                              [
                                0.76,
                                0.53
                              ],
                              [
                                0.8,
                                0.6
                              ],
                              [
                                0.72,
                                0.68
                              ],
                              [
                                0.72,
                                0.68
                              ],
                              [
                                0.79,
                                0.77
                              ],
                              [
                                0.81,
                                0.85
                              ],
                              [
                                0.69,
                                0.85
                              ],
                              [
                                0.67,
                                0.78
                              ],
                              [
                                0.61,
                                0.73
                              ],
                              [
                                0.58,
                                0.73
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -0.15
                              ],
                              [
                                -0.15,
                                0
                              ],
                              [
                                0,
                                0.15
                              ],
                              [
                                0.15,
                                0
                              ]
                            ],
                            o: [
                              [
                                -0.15,
                                0
                              ],
                              [
                                0,
                                0.15
                              ],
                              [
                                0.15,
                                0
                              ],
                              [
                                0,
                                -0.15
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                0.62,
                                0.4
                              ],
                              [
                                0.36,
                                0.68
                              ],
                              [
                                0.63,
                                0.95
                              ],
                              [
                                0.89,
                                0.68
                              ],
                              [
                                0.63,
                                0.4
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !1,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -0.2
                              ],
                              [
                                0.21,
                                0
                              ],
                              [
                                0,
                                0.2
                              ],
                              [
                                -0.21,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            o: [
                              [
                                0.21,
                                0
                              ],
                              [
                                0,
                                0.2
                              ],
                              [
                                -0.21,
                                0
                              ],
                              [
                                0,
                                -0.2
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                0.63,
                                0.31
                              ],
                              [
                                1,
                                0.68
                              ],
                              [
                                0.63,
                                1.04
                              ],
                              [
                                0.25,
                                0.68
                              ],
                              [
                                0.63,
                                0.31
                              ],
                              [
                                0.63,
                                0.31
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0.99,
                            0.73,
                            0.19,
                            1
                          ]
                        },
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1650",
    layers: [
      {
        ind: 1649,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                34,
                7
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                68,
                14
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.12
                          ],
                          [
                            0.64,
                            0
                          ],
                          [
                            0,
                            0.64
                          ],
                          [
                            -1.23,
                            -0.01
                          ]
                        ],
                        o: [
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.15,
                            0.5
                          ],
                          [
                            -0.54,
                            0
                          ],
                          [
                            0,
                            -0.98
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            38.51,
                            7.44
                          ],
                          [
                            38.46,
                            7.83
                          ],
                          [
                            37.15,
                            8.75
                          ],
                          [
                            36.19,
                            7.8
                          ],
                          [
                            38.51,
                            6.55
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !1,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            2.34,
                            0
                          ],
                          [
                            0.52,
                            -0.3
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.72,
                            0
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.83
                          ],
                          [
                            -1.45,
                            0
                          ],
                          [
                            -0.45,
                            0.57
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.63,
                            0.48
                          ],
                          [
                            0,
                            0.66
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            -1.62
                          ],
                          [
                            -1.21,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.48,
                            -0.3
                          ],
                          [
                            1.19,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.59,
                            0
                          ],
                          [
                            0,
                            1.12
                          ],
                          [
                            0.89,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.08,
                            -0.52
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            40.45,
                            5.72
                          ],
                          [
                            37.41,
                            2.67
                          ],
                          [
                            34.72,
                            3.31
                          ],
                          [
                            35.11,
                            4.61
                          ],
                          [
                            37.06,
                            4.07
                          ],
                          [
                            38.45,
                            5.17
                          ],
                          [
                            38.45,
                            5.27
                          ],
                          [
                            34.21,
                            8
                          ],
                          [
                            36.5,
                            10.17
                          ],
                          [
                            38.59,
                            9.24
                          ],
                          [
                            38.63,
                            9.24
                          ],
                          [
                            40.56,
                            10
                          ],
                          [
                            40.45,
                            8.28
                          ],
                          [
                            40.45,
                            5.72
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.27,
                            -1.13
                          ],
                          [
                            -1.64,
                            0.33
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            1.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            -1.07
                          ],
                          [
                            -0.22,
                            -1.03
                          ],
                          [
                            -1.61,
                            0.35
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -1.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            1.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -1.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.24,
                            1.21
                          ],
                          [
                            0.2,
                            1.01
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0.32,
                            1.32
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.27,
                            -1.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            1.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.22,
                            1.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.23,
                            1.2
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            -1.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.27,
                            1.25
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            -1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.01,
                            0.45
                          ],
                          [
                            1.98,
                            8.53
                          ],
                          [
                            4.5,
                            10
                          ],
                          [
                            5.57,
                            5.7
                          ],
                          [
                            6.19,
                            2.77
                          ],
                          [
                            6.21,
                            2.77
                          ],
                          [
                            6.73,
                            5.7
                          ],
                          [
                            7.38,
                            8.68
                          ],
                          [
                            9.83,
                            10
                          ],
                          [
                            12.35,
                            0.45
                          ],
                          [
                            10.31,
                            0.45
                          ],
                          [
                            9.45,
                            4.58
                          ],
                          [
                            8.85,
                            7.82
                          ],
                          [
                            8.82,
                            7.82
                          ],
                          [
                            8.25,
                            4.66
                          ],
                          [
                            7.35,
                            0.45
                          ],
                          [
                            5.23,
                            0.45
                          ],
                          [
                            4.27,
                            4.55
                          ],
                          [
                            3.58,
                            7.87
                          ],
                          [
                            3.55,
                            7.87
                          ],
                          [
                            2.93,
                            4.4
                          ],
                          [
                            2.16,
                            0.45
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.12
                          ],
                          [
                            0.64,
                            0
                          ],
                          [
                            0,
                            0.64
                          ],
                          [
                            -1.24,
                            -0.01
                          ]
                        ],
                        o: [
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.15,
                            0.5
                          ],
                          [
                            -0.54,
                            0
                          ],
                          [
                            0,
                            -0.98
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            16.2,
                            7.44
                          ],
                          [
                            16.15,
                            7.83
                          ],
                          [
                            14.84,
                            8.75
                          ],
                          [
                            13.88,
                            7.8
                          ],
                          [
                            16.2,
                            6.55
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            2.35,
                            0
                          ],
                          [
                            0.52,
                            -0.3
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.72,
                            0
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.83
                          ],
                          [
                            -1.45,
                            0
                          ],
                          [
                            -0.45,
                            0.57
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.64,
                            0.48
                          ],
                          [
                            0,
                            0.66
                          ]
                        ],
                        o: [
                          [
                            0,
                            -1.62
                          ],
                          [
                            -1.2,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.48,
                            -0.3
                          ],
                          [
                            1.19,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2.6,
                            0
                          ],
                          [
                            0,
                            1.12
                          ],
                          [
                            0.89,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.52
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            18.14,
                            5.72
                          ],
                          [
                            15.1,
                            2.67
                          ],
                          [
                            12.41,
                            3.31
                          ],
                          [
                            12.8,
                            4.61
                          ],
                          [
                            14.75,
                            4.07
                          ],
                          [
                            16.14,
                            5.17
                          ],
                          [
                            16.14,
                            5.27
                          ],
                          [
                            11.9,
                            8
                          ],
                          [
                            14.19,
                            10.17
                          ],
                          [
                            16.28,
                            9.24
                          ],
                          [
                            16.32,
                            9.24
                          ],
                          [
                            18.25,
                            10
                          ],
                          [
                            18.14,
                            8.28
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            21.37,
                            7.98
                          ],
                          [
                            21.37,
                            0.45
                          ],
                          [
                            19.43,
                            0.45
                          ],
                          [
                            19.43,
                            10
                          ],
                          [
                            21.37,
                            10
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.39,
                            -0.41
                          ],
                          [
                            -0.67,
                            0
                          ],
                          [
                            -0.27,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.31,
                            0
                          ],
                          [
                            0,
                            0.88
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.97
                          ],
                          [
                            0.34,
                            0.36
                          ],
                          [
                            0.57,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.05
                          ],
                          [
                            -0.66,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            46.75,
                            0.45
                          ],
                          [
                            46.75,
                            7.5
                          ],
                          [
                            47.32,
                            9.57
                          ],
                          [
                            48.9,
                            10.17
                          ],
                          [
                            50.3,
                            9.96
                          ],
                          [
                            50.28,
                            8.45
                          ],
                          [
                            49.54,
                            8.53
                          ],
                          [
                            48.66,
                            7.23
                          ],
                          [
                            48.66,
                            4.54
                          ],
                          [
                            50.35,
                            4.54
                          ],
                          [
                            50.35,
                            2.71
                          ],
                          [
                            48.66,
                            2.71
                          ],
                          [
                            48.66,
                            0.45
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.03,
                            0.16
                          ],
                          [
                            -0.85,
                            0
                          ],
                          [
                            -0.18,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            0
                          ],
                          [
                            0.36,
                            -1.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.2
                          ],
                          [
                            0.15,
                            -0.77
                          ],
                          [
                            0.23,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            -0.03
                          ],
                          [
                            -0.75,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            41.74,
                            2.83
                          ],
                          [
                            41.74,
                            10
                          ],
                          [
                            43.74,
                            10
                          ],
                          [
                            43.74,
                            6.33
                          ],
                          [
                            43.79,
                            5.8
                          ],
                          [
                            45.37,
                            4.54
                          ],
                          [
                            45.94,
                            4.59
                          ],
                          [
                            45.94,
                            2.71
                          ],
                          [
                            45.5,
                            2.67
                          ],
                          [
                            43.55,
                            4.18
                          ],
                          [
                            43.5,
                            4.18
                          ],
                          [
                            43.5,
                            2.83
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !1,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0.18
                          ],
                          [
                            -0.63,
                            0
                          ],
                          [
                            0,
                            -0.96
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.17
                          ],
                          [
                            -0.59,
                            0
                          ],
                          [
                            0,
                            -1.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.28,
                            0
                          ],
                          [
                            0.41,
                            -0.25
                          ],
                          [
                            0.26,
                            -0.39
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.95,
                            0
                          ],
                          [
                            0.33,
                            -0.52
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.2
                          ],
                          [
                            0.16,
                            -0.43
                          ],
                          [
                            0.79,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.19
                          ],
                          [
                            0.16,
                            -0.48
                          ],
                          [
                            0.8,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -2.23
                          ],
                          [
                            -0.57,
                            0
                          ],
                          [
                            -0.34,
                            0.21
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.31,
                            -0.77
                          ],
                          [
                            -1.21,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            22.73,
                            2.83
                          ],
                          [
                            22.73,
                            10
                          ],
                          [
                            24.68,
                            10
                          ],
                          [
                            24.68,
                            5.8
                          ],
                          [
                            24.77,
                            5.21
                          ],
                          [
                            25.96,
                            4.29
                          ],
                          [
                            27.11,
                            5.91
                          ],
                          [
                            27.11,
                            10
                          ],
                          [
                            29.06,
                            10
                          ],
                          [
                            29.06,
                            5.75
                          ],
                          [
                            29.14,
                            5.16
                          ],
                          [
                            30.31,
                            4.29
                          ],
                          [
                            31.49,
                            6.07
                          ],
                          [
                            31.49,
                            10
                          ],
                          [
                            33.44,
                            10
                          ],
                          [
                            33.44,
                            5.78
                          ],
                          [
                            31.03,
                            2.67
                          ],
                          [
                            29.61,
                            3.06
                          ],
                          [
                            28.71,
                            3.95
                          ],
                          [
                            28.68,
                            3.95
                          ],
                          [
                            26.7,
                            2.67
                          ],
                          [
                            24.61,
                            3.8
                          ],
                          [
                            24.58,
                            3.8
                          ],
                          [
                            24.58,
                            2.83
                          ],
                          [
                            22.73,
                            2.83
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.46,
                        0.81,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1655",
    layers: [
      {
        ind: 1654,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                10,
                11
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                20,
                22
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.26
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.63,
                            0
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.39,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.39,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            -0.63,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            0.26
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.58,
                            5.54
                          ],
                          [
                            8.32,
                            5.08
                          ],
                          [
                            8.71,
                            0.78
                          ],
                          [
                            7.58,
                            0
                          ],
                          [
                            6.46,
                            0.78
                          ],
                          [
                            6.84,
                            5.08
                          ],
                          [
                            7.58,
                            5.54
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.31,
                            -0.54
                          ],
                          [
                            -0.37,
                            -0.21
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.34
                          ]
                        ],
                        o: [
                          [
                            0.19,
                            -0.34
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.37,
                            -0.21
                          ],
                          [
                            -0.32,
                            0.54
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.24,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            5.25,
                            6.89
                          ],
                          [
                            5.23,
                            6.01
                          ],
                          [
                            1.69,
                            3.53
                          ],
                          [
                            0.46,
                            4.11
                          ],
                          [
                            0.56,
                            5.48
                          ],
                          [
                            4.48,
                            7.3
                          ],
                          [
                            5.25,
                            6.88
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.25,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.31,
                            0.54
                          ],
                          [
                            0.37,
                            -0.21
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            -0.33
                          ]
                        ],
                        o: [
                          [
                            0.19,
                            0.34
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.37,
                            -0.21
                          ],
                          [
                            -0.31,
                            -0.54
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.17
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.91,
                            6.88
                          ],
                          [
                            10.68,
                            7.3
                          ],
                          [
                            14.6,
                            5.48
                          ],
                          [
                            14.71,
                            4.12
                          ],
                          [
                            13.47,
                            3.53
                          ],
                          [
                            9.93,
                            6.01
                          ],
                          [
                            9.91,
                            6.89
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.26
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.63,
                            0
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.39,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.39,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            -0.63,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.26
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.58,
                            10.92
                          ],
                          [
                            8.32,
                            11.38
                          ],
                          [
                            8.71,
                            15.68
                          ],
                          [
                            7.58,
                            16.46
                          ],
                          [
                            6.46,
                            15.68
                          ],
                          [
                            6.84,
                            11.38
                          ],
                          [
                            7.58,
                            10.92
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !1,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.25,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.31,
                            -0.54
                          ],
                          [
                            0.37,
                            0.21
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.33
                          ]
                        ],
                        o: [
                          [
                            0.19,
                            -0.33
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.37,
                            0.21
                          ],
                          [
                            -0.31,
                            0.54
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            -0.17
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.91,
                            9.57
                          ],
                          [
                            10.68,
                            9.16
                          ],
                          [
                            14.6,
                            10.98
                          ],
                          [
                            14.71,
                            12.34
                          ],
                          [
                            13.47,
                            12.93
                          ],
                          [
                            9.93,
                            10.45
                          ],
                          [
                            9.91,
                            9.57
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !1,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            -0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.31,
                            0.54
                          ],
                          [
                            -0.37,
                            0.21
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            -0.33
                          ]
                        ],
                        o: [
                          [
                            0.19,
                            0.33
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.37,
                            0.21
                          ],
                          [
                            -0.32,
                            -0.54
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.24,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            5.25,
                            9.57
                          ],
                          [
                            5.23,
                            10.45
                          ],
                          [
                            1.69,
                            12.93
                          ],
                          [
                            0.46,
                            12.34
                          ],
                          [
                            0.56,
                            10.98
                          ],
                          [
                            4.48,
                            9.16
                          ],
                          [
                            5.25,
                            9.57
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.99,
                        0.73,
                        0.19,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1658",
    layers: [
      {
        ind: 1647,
        ty: 0,
        parent: 1643,
        ks: {},
        w: 2,
        h: 2,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1645"
      },
      {
        ind: 1643,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              91,
              16
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1652,
        ty: 0,
        parent: 1648,
        ks: {},
        w: 68,
        h: 14,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1650"
      },
      {
        ind: 1648,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              4
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1657,
        ty: 0,
        parent: 1653,
        ks: {},
        w: 20,
        h: 22,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1655"
      },
      {
        ind: 1653,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              71,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1688",
    layers: [
      {
        ind: 1687,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                16,
                8.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                32,
                17
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.17,
                            0
                          ],
                          [
                            0.12,
                            0.12
                          ],
                          [
                            0,
                            0.16
                          ],
                          [
                            -0.12,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            0.12
                          ],
                          [
                            0,
                            0.16
                          ],
                          [
                            -0.12,
                            0.12
                          ],
                          [
                            -0.17,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.16
                          ],
                          [
                            -0.12,
                            0.12
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            -0.12,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.03,
                            -0.08
                          ],
                          [
                            0,
                            -0.08
                          ],
                          [
                            0.03,
                            -0.07
                          ],
                          [
                            0.06,
                            -0.06
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.12,
                            0.12
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            -0.12,
                            -0.12
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0
                          ],
                          [
                            -0.12,
                            -0.12
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            0.12,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.12,
                            -0.12
                          ],
                          [
                            0,
                            -0.17
                          ],
                          [
                            0.12,
                            -0.12
                          ],
                          [
                            0.17,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0.06
                          ],
                          [
                            0.03,
                            0.07
                          ],
                          [
                            0,
                            0.08
                          ],
                          [
                            -0.03,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            23.47,
                            6.68
                          ],
                          [
                            17.86,
                            12.29
                          ],
                          [
                            17.42,
                            12.47
                          ],
                          [
                            16.98,
                            12.29
                          ],
                          [
                            16.8,
                            11.84
                          ],
                          [
                            16.98,
                            11.4
                          ],
                          [
                            21.53,
                            6.86
                          ],
                          [
                            0.63,
                            6.86
                          ],
                          [
                            0.18,
                            6.68
                          ],
                          [
                            0,
                            6.23
                          ],
                          [
                            0.18,
                            5.79
                          ],
                          [
                            0.63,
                            5.61
                          ],
                          [
                            21.53,
                            5.61
                          ],
                          [
                            16.98,
                            1.07
                          ],
                          [
                            16.8,
                            0.63
                          ],
                          [
                            16.98,
                            0.18
                          ],
                          [
                            17.42,
                            0
                          ],
                          [
                            17.86,
                            0.18
                          ],
                          [
                            23.47,
                            5.79
                          ],
                          [
                            23.61,
                            6
                          ],
                          [
                            23.66,
                            6.23
                          ],
                          [
                            23.61,
                            6.47
                          ],
                          [
                            23.47,
                            6.68
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.57,
                        0.63,
                        0.72,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1694",
    layers: [
      {
        ind: 1693,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                56,
                9.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                112,
                19
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.37
                          ],
                          [
                            -0.06,
                            -0.37
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            0.38
                          ],
                          [
                            -0.07,
                            0.37
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.08,
                            -0.38
                          ],
                          [
                            -0.08,
                            -0.37
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            0.38
                          ],
                          [
                            -0.07,
                            0.37
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0.25
                          ],
                          [
                            0.05,
                            0.27
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            -0.26
                          ],
                          [
                            0.05,
                            -0.27
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0.38
                          ],
                          [
                            0.07,
                            0.38
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.08,
                            -0.37
                          ],
                          [
                            0.09,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0.37
                          ],
                          [
                            0.09,
                            0.38
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            -0.37
                          ],
                          [
                            0.06,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            -0.27
                          ],
                          [
                            -0.05,
                            -0.26
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.27
                          ],
                          [
                            -0.07,
                            0.25
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.71,
                            11.24
                          ],
                          [
                            0.24,
                            4.3
                          ],
                          [
                            1.15,
                            4.3
                          ],
                          [
                            1.88,
                            8.08
                          ],
                          [
                            2.09,
                            9.2
                          ],
                          [
                            2.29,
                            10.32
                          ],
                          [
                            2.33,
                            10.32
                          ],
                          [
                            2.57,
                            9.2
                          ],
                          [
                            2.81,
                            8.08
                          ],
                          [
                            3.78,
                            4.3
                          ],
                          [
                            4.58,
                            4.3
                          ],
                          [
                            5.54,
                            8.08
                          ],
                          [
                            5.8,
                            9.2
                          ],
                          [
                            6.05,
                            10.32
                          ],
                          [
                            6.09,
                            10.32
                          ],
                          [
                            6.29,
                            9.2
                          ],
                          [
                            6.48,
                            8.08
                          ],
                          [
                            7.21,
                            4.3
                          ],
                          [
                            8.06,
                            4.3
                          ],
                          [
                            6.62,
                            11.24
                          ],
                          [
                            5.57,
                            11.24
                          ],
                          [
                            4.52,
                            7.06
                          ],
                          [
                            4.34,
                            6.28
                          ],
                          [
                            4.18,
                            5.48
                          ],
                          [
                            4.14,
                            5.48
                          ],
                          [
                            3.97,
                            6.28
                          ],
                          [
                            3.79,
                            7.06
                          ],
                          [
                            2.76,
                            11.24
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.18,
                            11.24
                          ],
                          [
                            9.18,
                            6.1
                          ],
                          [
                            10.05,
                            6.1
                          ],
                          [
                            10.05,
                            11.24
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            0.1
                          ],
                          [
                            0,
                            0.18
                          ],
                          [
                            -0.11,
                            0.11
                          ],
                          [
                            -0.17,
                            0
                          ],
                          [
                            -0.11,
                            -0.11
                          ],
                          [
                            0,
                            -0.17
                          ],
                          [
                            0.11,
                            -0.11
                          ],
                          [
                            0.17,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.17,
                            0
                          ],
                          [
                            -0.11,
                            -0.11
                          ],
                          [
                            0,
                            -0.17
                          ],
                          [
                            0.11,
                            -0.11
                          ],
                          [
                            0.17,
                            0
                          ],
                          [
                            0.11,
                            0.11
                          ],
                          [
                            0,
                            0.18
                          ],
                          [
                            -0.11,
                            0.1
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.63,
                            5.04
                          ],
                          [
                            9.21,
                            4.89
                          ],
                          [
                            9.05,
                            4.47
                          ],
                          [
                            9.21,
                            4.06
                          ],
                          [
                            9.63,
                            3.9
                          ],
                          [
                            10.04,
                            4.06
                          ],
                          [
                            10.21,
                            4.47
                          ],
                          [
                            10.04,
                            4.89
                          ],
                          [
                            9.63,
                            5.04
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.27,
                            0.14
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.34,
                            -0.48
                          ],
                          [
                            0,
                            -0.8
                          ],
                          [
                            0.21,
                            -0.41
                          ],
                          [
                            0.34,
                            -0.22
                          ],
                          [
                            0.39,
                            0
                          ],
                          [
                            0.24,
                            0.11
                          ],
                          [
                            0.24,
                            0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            -0.2
                          ],
                          [
                            0.28,
                            -0.14
                          ],
                          [
                            0.66,
                            0
                          ],
                          [
                            0.35,
                            0.47
                          ],
                          [
                            0,
                            0.58
                          ],
                          [
                            -0.21,
                            0.42
                          ],
                          [
                            -0.33,
                            0.22
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.23,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            11.79,
                            13.41
                          ],
                          [
                            11.79,
                            6.1
                          ],
                          [
                            12.51,
                            6.1
                          ],
                          [
                            12.58,
                            6.69
                          ],
                          [
                            12.61,
                            6.69
                          ],
                          [
                            13.38,
                            6.18
                          ],
                          [
                            14.25,
                            5.97
                          ],
                          [
                            15.77,
                            6.69
                          ],
                          [
                            16.29,
                            8.6
                          ],
                          [
                            15.97,
                            10.09
                          ],
                          [
                            15.15,
                            11.04
                          ],
                          [
                            14.06,
                            11.37
                          ],
                          [
                            13.34,
                            11.21
                          ],
                          [
                            12.63,
                            10.78
                          ],
                          [
                            12.66,
                            11.68
                          ],
                          [
                            12.66,
                            13.41
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.27,
                            0.36
                          ],
                          [
                            0,
                            0.63
                          ],
                          [
                            0.21,
                            0.35
                          ],
                          [
                            0.49,
                            0
                          ],
                          [
                            0.23,
                            -0.12
                          ],
                          [
                            0.25,
                            -0.23
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            -0.08
                          ],
                          [
                            -0.17,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.42,
                            0
                          ],
                          [
                            0.28,
                            -0.37
                          ],
                          [
                            0,
                            -0.57
                          ],
                          [
                            -0.2,
                            -0.35
                          ],
                          [
                            -0.22,
                            0
                          ],
                          [
                            -0.22,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0.2
                          ],
                          [
                            0.22,
                            0.08
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            13.91,
                            10.64
                          ],
                          [
                            14.96,
                            10.1
                          ],
                          [
                            15.39,
                            8.6
                          ],
                          [
                            15.07,
                            7.23
                          ],
                          [
                            14.03,
                            6.7
                          ],
                          [
                            13.36,
                            6.88
                          ],
                          [
                            12.66,
                            7.4
                          ],
                          [
                            12.66,
                            10.1
                          ],
                          [
                            13.33,
                            10.52
                          ],
                          [
                            13.91,
                            10.64
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.25,
                            0.19
                          ],
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.16,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.01
                          ],
                          [
                            0.11,
                            0
                          ],
                          [
                            0.24,
                            -0.18
                          ],
                          [
                            0.18,
                            -0.44
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            -0.32
                          ],
                          [
                            0.25,
                            -0.19
                          ],
                          [
                            0.2,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.03
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.22,
                            0
                          ],
                          [
                            -0.23,
                            0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.66,
                            11.24
                          ],
                          [
                            17.66,
                            6.1
                          ],
                          [
                            18.38,
                            6.1
                          ],
                          [
                            18.45,
                            7.03
                          ],
                          [
                            18.48,
                            7.03
                          ],
                          [
                            19.13,
                            6.26
                          ],
                          [
                            19.94,
                            5.97
                          ],
                          [
                            20.49,
                            6.08
                          ],
                          [
                            20.32,
                            6.84
                          ],
                          [
                            20.09,
                            6.78
                          ],
                          [
                            19.82,
                            6.75
                          ],
                          [
                            19.14,
                            7.02
                          ],
                          [
                            18.52,
                            7.94
                          ],
                          [
                            18.52,
                            11.24
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.37,
                            0.21
                          ],
                          [
                            0.23,
                            0.4
                          ],
                          [
                            0,
                            0.57
                          ],
                          [
                            -0.22,
                            0.4
                          ],
                          [
                            -0.36,
                            0.21
                          ],
                          [
                            -0.41,
                            0
                          ],
                          [
                            -0.36,
                            -0.21
                          ],
                          [
                            -0.22,
                            -0.4
                          ],
                          [
                            0,
                            -0.58
                          ],
                          [
                            0.23,
                            -0.4
                          ],
                          [
                            0.36,
                            -0.21
                          ],
                          [
                            0.43,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.41,
                            0
                          ],
                          [
                            -0.36,
                            -0.21
                          ],
                          [
                            -0.22,
                            -0.4
                          ],
                          [
                            0,
                            -0.58
                          ],
                          [
                            0.23,
                            -0.4
                          ],
                          [
                            0.37,
                            -0.21
                          ],
                          [
                            0.43,
                            0
                          ],
                          [
                            0.36,
                            0.21
                          ],
                          [
                            0.23,
                            0.4
                          ],
                          [
                            0,
                            0.57
                          ],
                          [
                            -0.22,
                            0.4
                          ],
                          [
                            -0.36,
                            0.21
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            23.22,
                            11.37
                          ],
                          [
                            22.05,
                            11.05
                          ],
                          [
                            21.17,
                            10.13
                          ],
                          [
                            20.84,
                            8.68
                          ],
                          [
                            21.17,
                            7.21
                          ],
                          [
                            22.05,
                            6.29
                          ],
                          [
                            23.22,
                            5.97
                          ],
                          [
                            24.39,
                            6.29
                          ],
                          [
                            25.26,
                            7.21
                          ],
                          [
                            25.6,
                            8.68
                          ],
                          [
                            25.26,
                            10.13
                          ],
                          [
                            24.39,
                            11.05
                          ],
                          [
                            23.22,
                            11.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.27,
                            0.36
                          ],
                          [
                            0,
                            0.59
                          ],
                          [
                            0.27,
                            0.37
                          ],
                          [
                            0.45,
                            0
                          ],
                          [
                            0.27,
                            -0.37
                          ],
                          [
                            0,
                            -0.59
                          ],
                          [
                            -0.28,
                            -0.37
                          ],
                          [
                            -0.44,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.45,
                            0
                          ],
                          [
                            0.27,
                            -0.37
                          ],
                          [
                            0,
                            -0.59
                          ],
                          [
                            -0.27,
                            -0.37
                          ],
                          [
                            -0.44,
                            0
                          ],
                          [
                            -0.28,
                            0.37
                          ],
                          [
                            0,
                            0.59
                          ],
                          [
                            0.27,
                            0.36
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            23.22,
                            10.65
                          ],
                          [
                            24.29,
                            10.11
                          ],
                          [
                            24.7,
                            8.68
                          ],
                          [
                            24.29,
                            7.24
                          ],
                          [
                            23.22,
                            6.69
                          ],
                          [
                            22.15,
                            7.24
                          ],
                          [
                            21.74,
                            8.68
                          ],
                          [
                            22.15,
                            10.11
                          ],
                          [
                            23.22,
                            10.65
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            29.16,
                            11.24
                          ],
                          [
                            29.16,
                            4.3
                          ],
                          [
                            30.04,
                            4.3
                          ],
                          [
                            30.04,
                            10.49
                          ],
                          [
                            33.07,
                            10.49
                          ],
                          [
                            33.07,
                            11.24
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            34.22,
                            11.24
                          ],
                          [
                            34.22,
                            6.1
                          ],
                          [
                            35.09,
                            6.1
                          ],
                          [
                            35.09,
                            11.24
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            0.1
                          ],
                          [
                            0,
                            0.18
                          ],
                          [
                            -0.11,
                            0.11
                          ],
                          [
                            -0.17,
                            0
                          ],
                          [
                            -0.11,
                            -0.11
                          ],
                          [
                            0,
                            -0.17
                          ],
                          [
                            0.11,
                            -0.11
                          ],
                          [
                            0.17,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.17,
                            0
                          ],
                          [
                            -0.11,
                            -0.11
                          ],
                          [
                            0,
                            -0.17
                          ],
                          [
                            0.11,
                            -0.11
                          ],
                          [
                            0.17,
                            0
                          ],
                          [
                            0.11,
                            0.11
                          ],
                          [
                            0,
                            0.18
                          ],
                          [
                            -0.11,
                            0.1
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            34.66,
                            5.04
                          ],
                          [
                            34.24,
                            4.89
                          ],
                          [
                            34.08,
                            4.47
                          ],
                          [
                            34.24,
                            4.06
                          ],
                          [
                            34.66,
                            3.9
                          ],
                          [
                            35.07,
                            4.06
                          ],
                          [
                            35.25,
                            4.47
                          ],
                          [
                            35.07,
                            4.89
                          ],
                          [
                            34.66,
                            5.04
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.27,
                            0.16
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.22,
                            -0.18
                          ],
                          [
                            -0.11,
                            -0.31
                          ],
                          [
                            -0.27,
                            0.18
                          ],
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            -0.35
                          ],
                          [
                            0,
                            -0.65
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0.22
                          ],
                          [
                            0.32,
                            0
                          ],
                          [
                            0.48,
                            -0.53
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0.22
                          ],
                          [
                            0.33,
                            0
                          ],
                          [
                            0.48,
                            -0.53
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.22,
                            -0.25
                          ],
                          [
                            0.27,
                            -0.17
                          ],
                          [
                            0.39,
                            0
                          ],
                          [
                            0.23,
                            0.17
                          ],
                          [
                            0.27,
                            -0.29
                          ],
                          [
                            0.28,
                            -0.18
                          ],
                          [
                            0.53,
                            0
                          ],
                          [
                            0.26,
                            0.34
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.48
                          ],
                          [
                            -0.16,
                            -0.22
                          ],
                          [
                            -0.38,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.48
                          ],
                          [
                            -0.16,
                            -0.22
                          ],
                          [
                            -0.38,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            36.82,
                            11.24
                          ],
                          [
                            36.82,
                            6.1
                          ],
                          [
                            37.54,
                            6.1
                          ],
                          [
                            37.62,
                            6.84
                          ],
                          [
                            37.65,
                            6.84
                          ],
                          [
                            38.39,
                            6.23
                          ],
                          [
                            39.25,
                            5.97
                          ],
                          [
                            40.16,
                            6.24
                          ],
                          [
                            40.66,
                            6.96
                          ],
                          [
                            41.48,
                            6.25
                          ],
                          [
                            42.36,
                            5.97
                          ],
                          [
                            43.53,
                            6.49
                          ],
                          [
                            43.92,
                            7.98
                          ],
                          [
                            43.92,
                            11.24
                          ],
                          [
                            43.05,
                            11.24
                          ],
                          [
                            43.05,
                            8.1
                          ],
                          [
                            42.82,
                            7.05
                          ],
                          [
                            42.1,
                            6.72
                          ],
                          [
                            40.81,
                            7.52
                          ],
                          [
                            40.81,
                            11.24
                          ],
                          [
                            39.94,
                            11.24
                          ],
                          [
                            39.94,
                            8.1
                          ],
                          [
                            39.71,
                            7.05
                          ],
                          [
                            38.98,
                            6.72
                          ],
                          [
                            37.69,
                            7.52
                          ],
                          [
                            37.69,
                            11.24
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            45.59,
                            11.24
                          ],
                          [
                            45.59,
                            6.1
                          ],
                          [
                            46.46,
                            6.1
                          ],
                          [
                            46.46,
                            11.24
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            0.1
                          ],
                          [
                            0,
                            0.18
                          ],
                          [
                            -0.11,
                            0.11
                          ],
                          [
                            -0.17,
                            0
                          ],
                          [
                            -0.11,
                            -0.11
                          ],
                          [
                            0,
                            -0.17
                          ],
                          [
                            0.11,
                            -0.11
                          ],
                          [
                            0.17,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.17,
                            0
                          ],
                          [
                            -0.11,
                            -0.11
                          ],
                          [
                            0,
                            -0.17
                          ],
                          [
                            0.11,
                            -0.11
                          ],
                          [
                            0.17,
                            0
                          ],
                          [
                            0.11,
                            0.11
                          ],
                          [
                            0,
                            0.18
                          ],
                          [
                            -0.11,
                            0.1
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            46.04,
                            5.04
                          ],
                          [
                            45.61,
                            4.89
                          ],
                          [
                            45.46,
                            4.47
                          ],
                          [
                            45.61,
                            4.06
                          ],
                          [
                            46.04,
                            3.9
                          ],
                          [
                            46.45,
                            4.06
                          ],
                          [
                            46.62,
                            4.47
                          ],
                          [
                            46.45,
                            4.89
                          ],
                          [
                            46.04,
                            5.04
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.22,
                            0.32
                          ],
                          [
                            0,
                            0.51
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.11,
                            -0.18
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.11,
                            0.03
                          ],
                          [
                            -0.08,
                            0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.17,
                            -0.04
                          ],
                          [
                            0.16,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.55,
                            0
                          ],
                          [
                            -0.21,
                            -0.32
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            0.12,
                            0.17
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.11,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            0.05
                          ],
                          [
                            -0.16,
                            0.04
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            49.82,
                            11.37
                          ],
                          [
                            48.66,
                            10.89
                          ],
                          [
                            48.34,
                            9.65
                          ],
                          [
                            48.34,
                            6.81
                          ],
                          [
                            47.58,
                            6.81
                          ],
                          [
                            47.58,
                            6.15
                          ],
                          [
                            48.39,
                            6.1
                          ],
                          [
                            48.49,
                            4.66
                          ],
                          [
                            49.22,
                            4.66
                          ],
                          [
                            49.22,
                            6.1
                          ],
                          [
                            50.61,
                            6.1
                          ],
                          [
                            50.61,
                            6.81
                          ],
                          [
                            49.22,
                            6.81
                          ],
                          [
                            49.22,
                            9.66
                          ],
                          [
                            49.39,
                            10.41
                          ],
                          [
                            50.02,
                            10.66
                          ],
                          [
                            50.31,
                            10.62
                          ],
                          [
                            50.6,
                            10.52
                          ],
                          [
                            50.77,
                            11.18
                          ],
                          [
                            50.3,
                            11.3
                          ],
                          [
                            49.82,
                            11.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.37,
                            0.21
                          ],
                          [
                            0.22,
                            0.4
                          ],
                          [
                            0,
                            0.56
                          ],
                          [
                            -0.22,
                            0.4
                          ],
                          [
                            -0.35,
                            0.22
                          ],
                          [
                            -0.39,
                            0
                          ],
                          [
                            -0.36,
                            -0.44
                          ],
                          [
                            0,
                            -0.73
                          ],
                          [
                            0.01,
                            -0.09
                          ],
                          [
                            0.01,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.3,
                            -0.32
                          ],
                          [
                            -0.49,
                            0
                          ],
                          [
                            -0.21,
                            0.07
                          ],
                          [
                            -0.19,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.28,
                            -0.11
                          ],
                          [
                            0.35,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.46,
                            0
                          ],
                          [
                            -0.37,
                            -0.22
                          ],
                          [
                            -0.22,
                            -0.4
                          ],
                          [
                            0,
                            -0.56
                          ],
                          [
                            0.23,
                            -0.4
                          ],
                          [
                            0.35,
                            -0.22
                          ],
                          [
                            0.66,
                            0
                          ],
                          [
                            0.36,
                            0.44
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            0,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            0.54
                          ],
                          [
                            0.31,
                            0.32
                          ],
                          [
                            0.25,
                            0
                          ],
                          [
                            0.21,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.14
                          ],
                          [
                            -0.27,
                            0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            53.71,
                            11.37
                          ],
                          [
                            52.46,
                            11.05
                          ],
                          [
                            51.57,
                            10.12
                          ],
                          [
                            51.25,
                            8.68
                          ],
                          [
                            51.57,
                            7.23
                          ],
                          [
                            52.44,
                            6.3
                          ],
                          [
                            53.55,
                            5.97
                          ],
                          [
                            55.07,
                            6.63
                          ],
                          [
                            55.61,
                            8.38
                          ],
                          [
                            55.59,
                            8.66
                          ],
                          [
                            55.57,
                            8.88
                          ],
                          [
                            52.1,
                            8.88
                          ],
                          [
                            52.61,
                            10.18
                          ],
                          [
                            53.82,
                            10.67
                          ],
                          [
                            54.5,
                            10.56
                          ],
                          [
                            55.1,
                            10.27
                          ],
                          [
                            55.4,
                            10.84
                          ],
                          [
                            54.65,
                            11.21
                          ],
                          [
                            53.71,
                            11.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0.27
                          ],
                          [
                            0.4,
                            0
                          ],
                          [
                            0.29,
                            -0.28
                          ],
                          [
                            0.05,
                            -0.51
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.52
                          ],
                          [
                            -0.22,
                            -0.28
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.29,
                            0.28
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            52.09,
                            8.26
                          ],
                          [
                            54.84,
                            8.26
                          ],
                          [
                            54.5,
                            7.07
                          ],
                          [
                            53.57,
                            6.66
                          ],
                          [
                            52.6,
                            7.08
                          ],
                          [
                            52.09,
                            8.26
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.39,
                            0.47
                          ],
                          [
                            0,
                            0.86
                          ],
                          [
                            -0.2,
                            0.4
                          ],
                          [
                            -0.34,
                            0.22
                          ],
                          [
                            -0.39,
                            0
                          ],
                          [
                            -0.22,
                            -0.11
                          ],
                          [
                            -0.23,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.27,
                            -0.15
                          ],
                          [
                            0.3,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.64,
                            0
                          ],
                          [
                            -0.39,
                            -0.47
                          ],
                          [
                            0,
                            -0.55
                          ],
                          [
                            0.21,
                            -0.41
                          ],
                          [
                            0.35,
                            -0.22
                          ],
                          [
                            0.3,
                            0
                          ],
                          [
                            0.22,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.2
                          ],
                          [
                            -0.27,
                            0.14
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            58.63,
                            11.37
                          ],
                          [
                            57.09,
                            10.67
                          ],
                          [
                            56.5,
                            8.68
                          ],
                          [
                            56.81,
                            7.24
                          ],
                          [
                            57.64,
                            6.3
                          ],
                          [
                            58.74,
                            5.97
                          ],
                          [
                            59.51,
                            6.13
                          ],
                          [
                            60.18,
                            6.57
                          ],
                          [
                            60.13,
                            5.69
                          ],
                          [
                            60.13,
                            3.71
                          ],
                          [
                            61.01,
                            3.71
                          ],
                          [
                            61.01,
                            11.24
                          ],
                          [
                            60.29,
                            11.24
                          ],
                          [
                            60.22,
                            10.64
                          ],
                          [
                            60.19,
                            10.64
                          ],
                          [
                            59.49,
                            11.16
                          ],
                          [
                            58.63,
                            11.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.42,
                            0.47
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.08
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0.23,
                            -0.17
                          ],
                          [
                            0.13,
                            -0.3
                          ],
                          [
                            0,
                            -0.4
                          ],
                          [
                            -0.25,
                            -0.36
                          ],
                          [
                            -0.45,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.45,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            -0.2
                          ],
                          [
                            -0.2,
                            -0.08
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.22,
                            0.16
                          ],
                          [
                            -0.13,
                            0.29
                          ],
                          [
                            0,
                            0.61
                          ],
                          [
                            0.25,
                            0.34
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            58.82,
                            10.64
                          ],
                          [
                            60.13,
                            9.93
                          ],
                          [
                            60.13,
                            7.24
                          ],
                          [
                            59.5,
                            6.83
                          ],
                          [
                            58.89,
                            6.7
                          ],
                          [
                            58.13,
                            6.96
                          ],
                          [
                            57.61,
                            7.64
                          ],
                          [
                            57.41,
                            8.67
                          ],
                          [
                            57.77,
                            10.12
                          ],
                          [
                            58.82,
                            10.64
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.17,
                        0.28,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1699",
    layers: [
      {
        ind: 1698,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                40.5,
                7.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                81,
                15
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.34,
                            -0.11
                          ],
                          [
                            -0.19,
                            -0.27
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            0.41,
                            -0.31
                          ],
                          [
                            0.67,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.46,
                            0
                          ],
                          [
                            0.34,
                            0.11
                          ],
                          [
                            0.19,
                            0.26
                          ],
                          [
                            0,
                            0.63
                          ],
                          [
                            -0.41,
                            0.31
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.83,
                            9
                          ],
                          [
                            0.83,
                            2.93
                          ],
                          [
                            2.56,
                            2.93
                          ],
                          [
                            3.76,
                            3.09
                          ],
                          [
                            4.55,
                            3.66
                          ],
                          [
                            4.84,
                            4.71
                          ],
                          [
                            4.22,
                            6.13
                          ],
                          [
                            2.6,
                            6.59
                          ],
                          [
                            1.6,
                            6.59
                          ],
                          [
                            1.6,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.25,
                            0.2
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            0.27,
                            0.16
                          ],
                          [
                            0.53,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0.53,
                            0
                          ],
                          [
                            0.26,
                            -0.2
                          ],
                          [
                            0,
                            -0.44
                          ],
                          [
                            -0.26,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.6,
                            5.96
                          ],
                          [
                            2.51,
                            5.96
                          ],
                          [
                            3.68,
                            5.67
                          ],
                          [
                            4.07,
                            4.71
                          ],
                          [
                            3.66,
                            3.81
                          ],
                          [
                            2.47,
                            3.55
                          ],
                          [
                            1.6,
                            3.55
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.16
                          ],
                          [
                            -0.25,
                            0
                          ],
                          [
                            -0.14,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0.01
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.15,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.29
                          ],
                          [
                            0.22,
                            -0.17
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.06,
                            -0.01
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            6,
                            9
                          ],
                          [
                            6,
                            4.5
                          ],
                          [
                            6.63,
                            4.5
                          ],
                          [
                            6.7,
                            5.32
                          ],
                          [
                            6.72,
                            5.32
                          ],
                          [
                            7.29,
                            4.64
                          ],
                          [
                            8,
                            4.39
                          ],
                          [
                            8.48,
                            4.48
                          ],
                          [
                            8.34,
                            5.15
                          ],
                          [
                            8.13,
                            5.09
                          ],
                          [
                            7.9,
                            5.07
                          ],
                          [
                            7.3,
                            5.3
                          ],
                          [
                            6.76,
                            6.11
                          ],
                          [
                            6.76,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.33,
                            0.19
                          ],
                          [
                            0.19,
                            0.35
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.19,
                            0.35
                          ],
                          [
                            -0.31,
                            0.19
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.31,
                            -0.38
                          ],
                          [
                            0,
                            -0.64
                          ],
                          [
                            0,
                            -0.08
                          ],
                          [
                            0.01,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.26,
                            -0.29
                          ],
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.18,
                            0.06
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.09
                          ],
                          [
                            0.31,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.4,
                            0
                          ],
                          [
                            -0.32,
                            -0.19
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.31,
                            -0.19
                          ],
                          [
                            0.57,
                            0
                          ],
                          [
                            0.32,
                            0.38
                          ],
                          [
                            0,
                            0.08
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.47
                          ],
                          [
                            0.27,
                            0.29
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.13
                          ],
                          [
                            -0.24,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            10.95,
                            9.11
                          ],
                          [
                            9.85,
                            8.83
                          ],
                          [
                            9.07,
                            8.02
                          ],
                          [
                            8.79,
                            6.76
                          ],
                          [
                            9.07,
                            5.49
                          ],
                          [
                            9.84,
                            4.68
                          ],
                          [
                            10.8,
                            4.39
                          ],
                          [
                            12.13,
                            4.96
                          ],
                          [
                            12.6,
                            6.5
                          ],
                          [
                            12.59,
                            6.74
                          ],
                          [
                            12.57,
                            6.94
                          ],
                          [
                            9.54,
                            6.94
                          ],
                          [
                            9.98,
                            8.07
                          ],
                          [
                            11.04,
                            8.5
                          ],
                          [
                            11.63,
                            8.41
                          ],
                          [
                            12.16,
                            8.15
                          ],
                          [
                            12.43,
                            8.65
                          ],
                          [
                            11.77,
                            8.97
                          ],
                          [
                            10.95,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.23
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.25,
                            -0.25
                          ],
                          [
                            0.05,
                            -0.45
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.46
                          ],
                          [
                            -0.19,
                            -0.24
                          ],
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            0.24
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.53,
                            6.39
                          ],
                          [
                            11.93,
                            6.39
                          ],
                          [
                            11.64,
                            5.35
                          ],
                          [
                            10.82,
                            4.99
                          ],
                          [
                            9.97,
                            5.36
                          ],
                          [
                            9.53,
                            6.39
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.36,
                            0.16
                          ],
                          [
                            0.27,
                            0.27
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.29,
                            -0.14
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.22,
                            0.18
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            0.09,
                            0.12
                          ],
                          [
                            0.16,
                            0.09
                          ],
                          [
                            0.19,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            0.13
                          ],
                          [
                            0.13,
                            0.2
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            -0.16,
                            0.24
                          ],
                          [
                            -0.29,
                            0.14
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.31,
                            -0.14
                          ],
                          [
                            -0.21,
                            -0.22
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0.1
                          ],
                          [
                            0.29,
                            0
                          ],
                          [
                            0.21,
                            -0.16
                          ],
                          [
                            0,
                            -0.27
                          ],
                          [
                            -0.1,
                            -0.13
                          ],
                          [
                            -0.16,
                            -0.08
                          ],
                          [
                            -0.16,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            -0.14
                          ],
                          [
                            -0.11,
                            -0.2
                          ],
                          [
                            0,
                            -0.3
                          ],
                          [
                            0.17,
                            -0.27
                          ],
                          [
                            0.31,
                            -0.15
                          ],
                          [
                            0.43,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.36,
                            -0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            0.23
                          ],
                          [
                            0.3,
                            0.14
                          ],
                          [
                            0.4,
                            0
                          ],
                          [
                            0.22,
                            -0.19
                          ],
                          [
                            0,
                            -0.21
                          ],
                          [
                            -0.09,
                            -0.12
                          ],
                          [
                            -0.14,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            -0.08
                          ],
                          [
                            -0.18,
                            -0.13
                          ],
                          [
                            -0.12,
                            -0.2
                          ],
                          [
                            0,
                            -0.31
                          ],
                          [
                            0.16,
                            -0.25
                          ],
                          [
                            0.29,
                            -0.14
                          ],
                          [
                            0.37,
                            0
                          ],
                          [
                            0.31,
                            0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            -0.18
                          ],
                          [
                            -0.22,
                            -0.11
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0.19
                          ],
                          [
                            0.11,
                            0.12
                          ],
                          [
                            0.15,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0.1
                          ],
                          [
                            0.19,
                            0.14
                          ],
                          [
                            0.11,
                            0.2
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            -0.17,
                            0.26
                          ],
                          [
                            -0.31,
                            0.16
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.32,
                            9.11
                          ],
                          [
                            16.14,
                            8.87
                          ],
                          [
                            15.2,
                            8.21
                          ],
                          [
                            15.66,
                            7.68
                          ],
                          [
                            16.42,
                            8.23
                          ],
                          [
                            17.34,
                            8.43
                          ],
                          [
                            18.27,
                            8.17
                          ],
                          [
                            18.6,
                            7.45
                          ],
                          [
                            18.46,
                            6.95
                          ],
                          [
                            18.1,
                            6.63
                          ],
                          [
                            17.59,
                            6.37
                          ],
                          [
                            16.72,
                            5.99
                          ],
                          [
                            16.15,
                            5.68
                          ],
                          [
                            15.68,
                            5.18
                          ],
                          [
                            15.49,
                            4.43
                          ],
                          [
                            15.73,
                            3.6
                          ],
                          [
                            16.42,
                            3.03
                          ],
                          [
                            17.4,
                            2.82
                          ],
                          [
                            18.41,
                            3.03
                          ],
                          [
                            19.2,
                            3.57
                          ],
                          [
                            18.78,
                            4.07
                          ],
                          [
                            18.16,
                            3.65
                          ],
                          [
                            17.4,
                            3.49
                          ],
                          [
                            16.57,
                            3.73
                          ],
                          [
                            16.27,
                            4.38
                          ],
                          [
                            16.42,
                            4.86
                          ],
                          [
                            16.81,
                            5.17
                          ],
                          [
                            17.28,
                            5.39
                          ],
                          [
                            18.14,
                            5.76
                          ],
                          [
                            18.77,
                            6.12
                          ],
                          [
                            19.22,
                            6.63
                          ],
                          [
                            19.39,
                            7.38
                          ],
                          [
                            19.14,
                            8.26
                          ],
                          [
                            18.43,
                            8.88
                          ],
                          [
                            17.32,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.32,
                            0.19
                          ],
                          [
                            0.18,
                            0.35
                          ],
                          [
                            0,
                            0.5
                          ],
                          [
                            -0.2,
                            0.35
                          ],
                          [
                            -0.32,
                            0.18
                          ],
                          [
                            -0.38,
                            0
                          ],
                          [
                            -0.21,
                            -0.11
                          ],
                          [
                            -0.16,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.07
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.13,
                            -0.27
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            -0.25,
                            -0.32
                          ],
                          [
                            -0.41,
                            0
                          ],
                          [
                            -0.18,
                            0.09
                          ],
                          [
                            -0.14,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.11
                          ],
                          [
                            0.27,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.39,
                            0
                          ],
                          [
                            -0.32,
                            -0.18
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.5
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.34,
                            -0.18
                          ],
                          [
                            0.3,
                            0
                          ],
                          [
                            0.21,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            -0.12
                          ],
                          [
                            -0.14,
                            -0.07
                          ],
                          [
                            -0.27,
                            0
                          ],
                          [
                            -0.21,
                            0.14
                          ],
                          [
                            -0.12,
                            0.26
                          ],
                          [
                            0,
                            0.52
                          ],
                          [
                            0.26,
                            0.32
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0.18,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.18
                          ],
                          [
                            -0.25,
                            0.1
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            22.29,
                            9.11
                          ],
                          [
                            21.21,
                            8.83
                          ],
                          [
                            20.46,
                            8.03
                          ],
                          [
                            20.18,
                            6.76
                          ],
                          [
                            20.48,
                            5.47
                          ],
                          [
                            21.27,
                            4.67
                          ],
                          [
                            22.34,
                            4.39
                          ],
                          [
                            23.11,
                            4.55
                          ],
                          [
                            23.66,
                            4.92
                          ],
                          [
                            23.27,
                            5.42
                          ],
                          [
                            22.86,
                            5.13
                          ],
                          [
                            22.37,
                            5.02
                          ],
                          [
                            21.64,
                            5.24
                          ],
                          [
                            21.14,
                            5.85
                          ],
                          [
                            20.96,
                            6.76
                          ],
                          [
                            21.34,
                            8.01
                          ],
                          [
                            22.36,
                            8.48
                          ],
                          [
                            22.94,
                            8.35
                          ],
                          [
                            23.41,
                            8.03
                          ],
                          [
                            23.74,
                            8.54
                          ],
                          [
                            23.07,
                            8.96
                          ],
                          [
                            22.29,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.22
                          ],
                          [
                            0,
                            0.4
                          ],
                          [
                            -0.44,
                            0.26
                          ],
                          [
                            -0.96,
                            0.11
                          ],
                          [
                            0.05,
                            0.18
                          ],
                          [
                            0.14,
                            0.1
                          ],
                          [
                            0.25,
                            0
                          ],
                          [
                            0.23,
                            -0.1
                          ],
                          [
                            0.18,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.3,
                            0.12
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.25,
                            -0.34
                          ],
                          [
                            0,
                            -0.56
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.13
                          ],
                          [
                            0.29,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.37,
                            0
                          ],
                          [
                            -0.25,
                            -0.23
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.45,
                            -0.27
                          ],
                          [
                            0,
                            -0.19
                          ],
                          [
                            -0.05,
                            -0.17
                          ],
                          [
                            -0.13,
                            -0.11
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.23,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            -0.14
                          ],
                          [
                            0.31,
                            -0.13
                          ],
                          [
                            0.55,
                            0
                          ],
                          [
                            0.25,
                            0.33
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            0.17
                          ],
                          [
                            -0.25,
                            0.13
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.68,
                            9.11
                          ],
                          [
                            24.73,
                            8.78
                          ],
                          [
                            24.37,
                            7.83
                          ],
                          [
                            25.02,
                            6.7
                          ],
                          [
                            27.13,
                            6.15
                          ],
                          [
                            27.04,
                            5.6
                          ],
                          [
                            26.76,
                            5.19
                          ],
                          [
                            26.2,
                            5.02
                          ],
                          [
                            25.47,
                            5.17
                          ],
                          [
                            24.86,
                            5.5
                          ],
                          [
                            24.56,
                            4.97
                          ],
                          [
                            25.33,
                            4.59
                          ],
                          [
                            26.33,
                            4.39
                          ],
                          [
                            27.52,
                            4.9
                          ],
                          [
                            27.89,
                            6.24
                          ],
                          [
                            27.89,
                            9
                          ],
                          [
                            27.26,
                            9
                          ],
                          [
                            27.2,
                            8.46
                          ],
                          [
                            27.17,
                            8.46
                          ],
                          [
                            26.48,
                            8.92
                          ],
                          [
                            25.68,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.11
                          ],
                          [
                            -0.21,
                            0.19
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.3,
                            -0.19
                          ],
                          [
                            0,
                            -0.29
                          ],
                          [
                            -0.15,
                            -0.12
                          ],
                          [
                            -0.22,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.21,
                            0
                          ],
                          [
                            0.19,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.75,
                            0.09
                          ],
                          [
                            -0.3,
                            0.18
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.9,
                            8.5
                          ],
                          [
                            26.51,
                            8.34
                          ],
                          [
                            27.13,
                            7.9
                          ],
                          [
                            27.13,
                            6.65
                          ],
                          [
                            25.55,
                            7.07
                          ],
                          [
                            25.11,
                            7.78
                          ],
                          [
                            25.34,
                            8.33
                          ],
                          [
                            25.9,
                            8.5
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0.17
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.05
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            -0.01
                          ],
                          [
                            0.11,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.12,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.12
                          ],
                          [
                            0.04,
                            0.05
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0.03,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.03
                          ],
                          [
                            -0.07,
                            0.01
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            30.11,
                            9.11
                          ],
                          [
                            29.49,
                            8.85
                          ],
                          [
                            29.31,
                            8.09
                          ],
                          [
                            29.31,
                            2.41
                          ],
                          [
                            30.07,
                            2.41
                          ],
                          [
                            30.07,
                            8.15
                          ],
                          [
                            30.13,
                            8.41
                          ],
                          [
                            30.28,
                            8.48
                          ],
                          [
                            30.34,
                            8.48
                          ],
                          [
                            30.45,
                            8.46
                          ],
                          [
                            30.55,
                            9.04
                          ],
                          [
                            30.37,
                            9.09
                          ],
                          [
                            30.11,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.33,
                            0.19
                          ],
                          [
                            0.19,
                            0.35
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.19,
                            0.35
                          ],
                          [
                            -0.31,
                            0.19
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.31,
                            -0.38
                          ],
                          [
                            0,
                            -0.64
                          ],
                          [
                            0,
                            -0.08
                          ],
                          [
                            0.01,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.27,
                            -0.29
                          ],
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.18,
                            0.06
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.09
                          ],
                          [
                            0.31,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.4,
                            0
                          ],
                          [
                            -0.33,
                            -0.19
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.31,
                            -0.19
                          ],
                          [
                            0.57,
                            0
                          ],
                          [
                            0.32,
                            0.38
                          ],
                          [
                            0,
                            0.08
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.47
                          ],
                          [
                            0.27,
                            0.29
                          ],
                          [
                            0.22,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.13
                          ],
                          [
                            -0.24,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            33.49,
                            9.11
                          ],
                          [
                            32.4,
                            8.83
                          ],
                          [
                            31.62,
                            8.02
                          ],
                          [
                            31.34,
                            6.76
                          ],
                          [
                            31.62,
                            5.49
                          ],
                          [
                            32.38,
                            4.68
                          ],
                          [
                            33.35,
                            4.39
                          ],
                          [
                            34.68,
                            4.96
                          ],
                          [
                            35.15,
                            6.5
                          ],
                          [
                            35.14,
                            6.74
                          ],
                          [
                            35.12,
                            6.94
                          ],
                          [
                            32.09,
                            6.94
                          ],
                          [
                            32.53,
                            8.07
                          ],
                          [
                            33.58,
                            8.5
                          ],
                          [
                            34.18,
                            8.41
                          ],
                          [
                            34.7,
                            8.15
                          ],
                          [
                            34.97,
                            8.65
                          ],
                          [
                            34.32,
                            8.97
                          ],
                          [
                            33.49,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.23
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.25,
                            -0.25
                          ],
                          [
                            0.05,
                            -0.45
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.46
                          ],
                          [
                            -0.19,
                            -0.24
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.25,
                            0.24
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            32.07,
                            6.39
                          ],
                          [
                            34.48,
                            6.39
                          ],
                          [
                            34.19,
                            5.35
                          ],
                          [
                            33.37,
                            4.99
                          ],
                          [
                            32.52,
                            5.36
                          ],
                          [
                            32.07,
                            6.39
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.16
                          ],
                          [
                            -0.25,
                            0
                          ],
                          [
                            -0.14,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0.01
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.15,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.29
                          ],
                          [
                            0.22,
                            -0.17
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.06,
                            -0.01
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            36.26,
                            9
                          ],
                          [
                            36.26,
                            4.5
                          ],
                          [
                            36.89,
                            4.5
                          ],
                          [
                            36.95,
                            5.32
                          ],
                          [
                            36.98,
                            5.32
                          ],
                          [
                            37.55,
                            4.64
                          ],
                          [
                            38.26,
                            4.39
                          ],
                          [
                            38.74,
                            4.48
                          ],
                          [
                            38.59,
                            5.15
                          ],
                          [
                            38.39,
                            5.09
                          ],
                          [
                            38.16,
                            5.07
                          ],
                          [
                            37.55,
                            5.3
                          ],
                          [
                            37.02,
                            6.11
                          ],
                          [
                            37.02,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.49,
                        0.55,
                        0.65,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1727",
    layers: [
      {
        ind: 1726,
        ty: 2,
        parent: 1725,
        ks: {
          s: {
            a: 0,
            k: [
              157.14,
              162.5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "0"
      },
      {
        ind: 1725,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1730",
    layers: [
      {
        ind: 1729,
        ty: 0,
        parent: 1724,
        ks: {},
        w: 11,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1727"
      },
      {
        ind: 1724,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1775",
    layers: [
      {
        ind: 1774,
        ty: 2,
        parent: 1773,
        ks: {
          s: {
            a: 0,
            k: [
              162.5,
              160
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "1"
      },
      {
        ind: 1773,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1778",
    layers: [
      {
        ind: 1777,
        ty: 0,
        parent: 1772,
        ks: {},
        w: 13,
        h: 12,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1775"
      },
      {
        ind: 1772,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1817",
    layers: [
      {
        ind: 1816,
        ty: 2,
        parent: 1815,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        refId: "10"
      },
      {
        ind: 1815,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1820",
    layers: [
      {
        ind: 1819,
        ty: 0,
        parent: 1814,
        ks: {},
        w: 19,
        h: 21.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1817"
      },
      {
        ind: 1814,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1831",
    layers: [
      {
        ind: 1830,
        ty: 2,
        parent: 1829,
        ks: {
          s: {
            a: 0,
            k: [
              165.91,
              166.67
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "11"
      },
      {
        ind: 1829,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1834",
    layers: [
      {
        ind: 1833,
        ty: 0,
        parent: 1828,
        ks: {},
        w: 73,
        h: 72.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1831"
      },
      {
        ind: 1828,
        ty: 3,
        parent: 1827,
        ks: {
          p: {
            a: 0,
            k: [
              -8,
              -2
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1827,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              9,
              3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1838",
    layers: [
      {
        ind: 1837,
        ty: 4,
        td: 1,
        parent: 1826,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                31.739,
                31.739
              ]
            },
            r: {
              a: 0,
              k: 31
            },
            s: {
              a: 0,
              k: [
                63.478,
                63.478
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1836,
        ty: 0,
        tt: 1,
        parent: 1826,
        ks: {
          a: {
            a: 0,
            k: [
              9,
              3
            ]
          }
        },
        w: 82,
        h: 76,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1834"
      },
      {
        ind: 1826,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              7.053,
              7.053
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1843",
    layers: [
      {
        ind: 1580,
        ty: 4,
        parent: 1579,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1579,
        ty: 3,
        parent: 1578,
        ks: {
          p: {
            a: 0,
            k: [
              28.394,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1582,
        ty: 4,
        parent: 1581,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1581,
        ty: 3,
        parent: 1578,
        ks: {
          p: {
            a: 0,
            k: [
              22.138,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1584,
        ty: 4,
        parent: 1583,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ],
                  [
                    1.2,
                    11.3
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    10.1
                  ],
                  [
                    2.4,
                    10.5
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.7,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    3,
                    11.6
                  ],
                  [
                    2.7,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1583,
        ty: 3,
        parent: 1578,
        ks: {
          p: {
            a: 0,
            k: [
              18.794,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1586,
        ty: 4,
        parent: 1585,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1585,
        ty: 3,
        parent: 1578,
        ks: {
          p: {
            a: 0,
            k: [
              12.426,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1588,
        ty: 4,
        parent: 1587,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.9,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.8
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    4.6,
                    5.6
                  ],
                  [
                    5.3,
                    6.1
                  ],
                  [
                    5.3,
                    6.1
                  ],
                  [
                    4.6,
                    7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    2.4,
                    7.1
                  ],
                  [
                    2,
                    8.6
                  ],
                  [
                    2,
                    8.6
                  ],
                  [
                    2.4,
                    10
                  ],
                  [
                    3.6,
                    10.6
                  ],
                  [
                    3.6,
                    10.6
                  ],
                  [
                    4.3,
                    10.4
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    5.4,
                    11
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1587,
        ty: 3,
        parent: 1578,
        ks: {
          p: {
            a: 0,
            k: [
              6.725,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1590,
        ty: 4,
        parent: 1589,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    1.3,
                    9.6
                  ],
                  [
                    2.3,
                    10.2
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    4.5,
                    10.2
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.5,
                    8.7
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    2.5,
                    7.8
                  ],
                  [
                    1.7,
                    7.3
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    1.2,
                    4.5
                  ],
                  [
                    2.1,
                    3.7
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    4.9,
                    3.6
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    5.3,
                    5.3
                  ],
                  [
                    4.5,
                    4.8
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.5,
                    6.1
                  ],
                  [
                    2.9,
                    6.4
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    4.7,
                    7.2
                  ],
                  [
                    5.8,
                    8
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    5.9,
                    10.5
                  ],
                  [
                    4.9,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1589,
        ty: 3,
        parent: 1578,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1578,
        ty: 3,
        parent: 1577,
        ks: {
          p: {
            a: 0,
            k: [
              122.02,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1593,
        ty: 4,
        parent: 1592,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1592,
        ty: 3,
        parent: 1591,
        ks: {
          p: {
            a: 0,
            k: [
              20.548,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1595,
        ty: 4,
        parent: 1594,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1594,
        ty: 3,
        parent: 1591,
        ks: {
          p: {
            a: 0,
            k: [
              14.292,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1597,
        ty: 4,
        parent: 1596,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.6,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.3,
                    6.7
                  ],
                  [
                    0.3,
                    5.6
                  ],
                  [
                    1.1,
                    5.5
                  ],
                  [
                    1.1,
                    4.9
                  ],
                  [
                    1.6,
                    3.3
                  ],
                  [
                    3.2,
                    2.7
                  ],
                  [
                    3.2,
                    2.7
                  ],
                  [
                    3.8,
                    2.8
                  ],
                  [
                    4.3,
                    2.9
                  ],
                  [
                    4.3,
                    2.9
                  ],
                  [
                    4,
                    4
                  ],
                  [
                    3.3,
                    3.8
                  ],
                  [
                    3.3,
                    3.8
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.6,
                    5.5
                  ],
                  [
                    3.8,
                    5.5
                  ],
                  [
                    3.8,
                    6.7
                  ],
                  [
                    2.6,
                    6.7
                  ],
                  [
                    2.6,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    6.9,
                    11.7
                  ],
                  [
                    6.9,
                    11.7
                  ],
                  [
                    5.5,
                    11.1
                  ],
                  [
                    5,
                    9.5
                  ],
                  [
                    5,
                    9.5
                  ],
                  [
                    5,
                    6.7
                  ],
                  [
                    4.2,
                    6.7
                  ],
                  [
                    4.2,
                    5.6
                  ],
                  [
                    5.1,
                    5.5
                  ],
                  [
                    5.3,
                    3.9
                  ],
                  [
                    6.5,
                    3.9
                  ],
                  [
                    6.5,
                    5.5
                  ],
                  [
                    8,
                    5.5
                  ],
                  [
                    8,
                    6.7
                  ],
                  [
                    6.5,
                    6.7
                  ],
                  [
                    6.5,
                    9.5
                  ],
                  [
                    7.3,
                    10.6
                  ],
                  [
                    7.3,
                    10.6
                  ],
                  [
                    7.6,
                    10.6
                  ],
                  [
                    7.9,
                    10.5
                  ],
                  [
                    7.9,
                    10.5
                  ],
                  [
                    8.2,
                    11.5
                  ],
                  [
                    7.6,
                    11.7
                  ],
                  [
                    6.9,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1596,
        ty: 3,
        parent: 1591,
        ks: {
          p: {
            a: 0,
            k: [
              6.367,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1599,
        ty: 4,
        parent: 1598,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1598,
        ty: 3,
        parent: 1591,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1591,
        ty: 3,
        parent: 1577,
        ks: {
          p: {
            a: 0,
            k: [
              94.401,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1602,
        ty: 4,
        parent: 1601,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1601,
        ty: 3,
        parent: 1600,
        ks: {
          p: {
            a: 0,
            k: [
              17.856,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1604,
        ty: 4,
        parent: 1603,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    6.1,
                    5.5
                  ],
                  [
                    4.1,
                    8
                  ],
                  [
                    6.3,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    3.2,
                    9
                  ],
                  [
                    2.3,
                    10
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1603,
        ty: 3,
        parent: 1600,
        ks: {
          p: {
            a: 0,
            k: [
              11.414,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1606,
        ty: 4,
        parent: 1605,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.3,
                    5.5
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    1.6,
                    4.5
                  ],
                  [
                    1.6,
                    4.5
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.8,
                    3.7
                  ],
                  [
                    0.8,
                    3.7
                  ],
                  [
                    1,
                    3.1
                  ],
                  [
                    1.6,
                    2.8
                  ],
                  [
                    1.6,
                    2.8
                  ],
                  [
                    2.2,
                    3.1
                  ],
                  [
                    2.5,
                    3.7
                  ],
                  [
                    2.5,
                    3.7
                  ],
                  [
                    2.2,
                    4.2
                  ],
                  [
                    1.6,
                    4.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1605,
        ty: 3,
        parent: 1600,
        ks: {
          p: {
            a: 0,
            k: [
              8.181,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1608,
        ty: 4,
        parent: 1607,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.5,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    3.5
                  ],
                  [
                    2.5,
                    3.5
                  ],
                  [
                    2.5,
                    6.8
                  ],
                  [
                    5.7,
                    6.8
                  ],
                  [
                    5.7,
                    3.5
                  ],
                  [
                    7.2,
                    3.5
                  ],
                  [
                    7.2,
                    11.6
                  ],
                  [
                    5.7,
                    11.6
                  ],
                  [
                    5.7,
                    8
                  ],
                  [
                    2.5,
                    8
                  ],
                  [
                    2.5,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1607,
        ty: 3,
        parent: 1600,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1600,
        ty: 3,
        parent: 1577,
        ks: {
          p: {
            a: 0,
            k: [
              67.821,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1611,
        ty: 4,
        parent: 1610,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.7,
                    0
                  ]
                ],
                v: [
                  [
                    1.3,
                    14.1
                  ],
                  [
                    1.3,
                    14.1
                  ],
                  [
                    0.9,
                    14
                  ],
                  [
                    0.5,
                    14
                  ],
                  [
                    0.5,
                    14
                  ],
                  [
                    0.8,
                    12.8
                  ],
                  [
                    1,
                    12.9
                  ],
                  [
                    1.2,
                    12.9
                  ],
                  [
                    1.2,
                    12.9
                  ],
                  [
                    2,
                    12.6
                  ],
                  [
                    2.4,
                    11.9
                  ],
                  [
                    2.4,
                    11.9
                  ],
                  [
                    2.5,
                    11.5
                  ],
                  [
                    0.1,
                    5.5
                  ],
                  [
                    1.6,
                    5.5
                  ],
                  [
                    2.6,
                    8.5
                  ],
                  [
                    2.9,
                    9.3
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.4,
                    9.3
                  ],
                  [
                    3.7,
                    8.5
                  ],
                  [
                    3.7,
                    8.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    6,
                    5.5
                  ],
                  [
                    3.8,
                    11.9
                  ],
                  [
                    2.8,
                    13.5
                  ],
                  [
                    1.3,
                    14.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.7
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1610,
        ty: 3,
        parent: 1609,
        ks: {
          p: {
            a: 0,
            k: [
              27.407,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1613,
        ty: 4,
        parent: 1612,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1612,
        ty: 3,
        parent: 1609,
        ks: {
          p: {
            a: 0,
            k: [
              22.804,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1615,
        ty: 4,
        parent: 1614,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1614,
        ty: 3,
        parent: 1609,
        ks: {
          p: {
            a: 0,
            k: [
              16.437,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1617,
        ty: 4,
        parent: 1616,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ],
                  [
                    1.2,
                    11.3
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    10.1
                  ],
                  [
                    2.4,
                    10.5
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.7,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    3,
                    11.6
                  ],
                  [
                    2.7,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1616,
        ty: 3,
        parent: 1609,
        ks: {
          p: {
            a: 0,
            k: [
              13.093,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1619,
        ty: 4,
        parent: 1618,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1618,
        ty: 3,
        parent: 1609,
        ks: {
          p: {
            a: 0,
            k: [
              6.725,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1621,
        ty: 4,
        parent: 1620,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    1.3,
                    9.6
                  ],
                  [
                    2.3,
                    10.2
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    4.5,
                    10.2
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.5,
                    8.7
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    2.5,
                    7.8
                  ],
                  [
                    1.7,
                    7.3
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    1.2,
                    4.5
                  ],
                  [
                    2.1,
                    3.7
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    4.9,
                    3.6
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    5.3,
                    5.3
                  ],
                  [
                    4.5,
                    4.8
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.5,
                    6.1
                  ],
                  [
                    2.9,
                    6.4
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    4.7,
                    7.2
                  ],
                  [
                    5.8,
                    8
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    5.9,
                    10.5
                  ],
                  [
                    4.9,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1620,
        ty: 3,
        parent: 1609,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1609,
        ty: 3,
        parent: 1577,
        ks: {
          p: {
            a: 0,
            k: [
              31.837,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1624,
        ty: 4,
        parent: 1623,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    8.5
                  ],
                  [
                    2.3,
                    8.5
                  ],
                  [
                    0.9,
                    7.8
                  ],
                  [
                    0.4,
                    5.9
                  ],
                  [
                    0.4,
                    5.9
                  ],
                  [
                    0.9,
                    4
                  ],
                  [
                    2.3,
                    3.4
                  ],
                  [
                    2.3,
                    3.4
                  ],
                  [
                    3.7,
                    4
                  ],
                  [
                    4.2,
                    5.9
                  ],
                  [
                    4.2,
                    5.9
                  ],
                  [
                    3.7,
                    7.8
                  ],
                  [
                    2.3,
                    8.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    7.7
                  ],
                  [
                    2.3,
                    7.7
                  ],
                  [
                    2.9,
                    7.2
                  ],
                  [
                    3.2,
                    5.9
                  ],
                  [
                    3.2,
                    5.9
                  ],
                  [
                    2.9,
                    4.6
                  ],
                  [
                    2.3,
                    4.2
                  ],
                  [
                    2.3,
                    4.2
                  ],
                  [
                    1.7,
                    4.6
                  ],
                  [
                    1.4,
                    5.9
                  ],
                  [
                    1.4,
                    5.9
                  ],
                  [
                    1.7,
                    7.2
                  ],
                  [
                    2.3,
                    7.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2.6,
                    11.7
                  ],
                  [
                    7,
                    3.4
                  ],
                  [
                    7.8,
                    3.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    8.1,
                    11.7
                  ],
                  [
                    8.1,
                    11.7
                  ],
                  [
                    6.7,
                    11.1
                  ],
                  [
                    6.2,
                    9.2
                  ],
                  [
                    6.2,
                    9.2
                  ],
                  [
                    6.7,
                    7.3
                  ],
                  [
                    8.1,
                    6.6
                  ],
                  [
                    8.1,
                    6.6
                  ],
                  [
                    9.5,
                    7.3
                  ],
                  [
                    10,
                    9.2
                  ],
                  [
                    10,
                    9.2
                  ],
                  [
                    9.5,
                    11.1
                  ],
                  [
                    8.1,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    8.1,
                    10.9
                  ],
                  [
                    8.1,
                    10.9
                  ],
                  [
                    8.7,
                    10.5
                  ],
                  [
                    9,
                    9.2
                  ],
                  [
                    9,
                    9.2
                  ],
                  [
                    8.7,
                    7.9
                  ],
                  [
                    8.1,
                    7.5
                  ],
                  [
                    8.1,
                    7.5
                  ],
                  [
                    7.4,
                    7.9
                  ],
                  [
                    7.2,
                    9.2
                  ],
                  [
                    7.2,
                    9.2
                  ],
                  [
                    7.4,
                    10.5
                  ],
                  [
                    8.1,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1623,
        ty: 3,
        parent: 1622,
        ks: {
          p: {
            a: 0,
            k: [
              18.991,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1626,
        ty: 4,
        parent: 1625,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.7
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.7
                  ],
                  [
                    0.8,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    11.7
                  ],
                  [
                    3.2,
                    11.7
                  ],
                  [
                    1.2,
                    10.7
                  ],
                  [
                    0.5,
                    7.6
                  ],
                  [
                    0.5,
                    7.6
                  ],
                  [
                    1.2,
                    4.6
                  ],
                  [
                    3.2,
                    3.6
                  ],
                  [
                    3.2,
                    3.6
                  ],
                  [
                    5.1,
                    4.6
                  ],
                  [
                    5.8,
                    7.6
                  ],
                  [
                    5.8,
                    7.6
                  ],
                  [
                    5.1,
                    10.7
                  ],
                  [
                    3.2,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0.5,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    -0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    10.6
                  ],
                  [
                    3.2,
                    10.6
                  ],
                  [
                    3.8,
                    10.3
                  ],
                  [
                    4.3,
                    9.4
                  ],
                  [
                    4.5,
                    7.6
                  ],
                  [
                    4.5,
                    7.6
                  ],
                  [
                    4.3,
                    5.9
                  ],
                  [
                    3.8,
                    5
                  ],
                  [
                    3.2,
                    4.7
                  ],
                  [
                    3.2,
                    4.7
                  ],
                  [
                    2.5,
                    5
                  ],
                  [
                    2,
                    5.9
                  ],
                  [
                    1.9,
                    7.6
                  ],
                  [
                    1.9,
                    7.6
                  ],
                  [
                    2,
                    9.4
                  ],
                  [
                    2.5,
                    10.3
                  ],
                  [
                    3.2,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1625,
        ty: 3,
        parent: 1622,
        ks: {
          p: {
            a: 0,
            k: [
              12.661,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1628,
        ty: 4,
        parent: 1627,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.7
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.7
                  ],
                  [
                    0.8,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    11.7
                  ],
                  [
                    3.2,
                    11.7
                  ],
                  [
                    1.2,
                    10.7
                  ],
                  [
                    0.5,
                    7.6
                  ],
                  [
                    0.5,
                    7.6
                  ],
                  [
                    1.2,
                    4.6
                  ],
                  [
                    3.2,
                    3.6
                  ],
                  [
                    3.2,
                    3.6
                  ],
                  [
                    5.1,
                    4.6
                  ],
                  [
                    5.8,
                    7.6
                  ],
                  [
                    5.8,
                    7.6
                  ],
                  [
                    5.1,
                    10.7
                  ],
                  [
                    3.2,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0.5,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    -0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    10.6
                  ],
                  [
                    3.2,
                    10.6
                  ],
                  [
                    3.8,
                    10.3
                  ],
                  [
                    4.3,
                    9.4
                  ],
                  [
                    4.5,
                    7.6
                  ],
                  [
                    4.5,
                    7.6
                  ],
                  [
                    4.3,
                    5.9
                  ],
                  [
                    3.8,
                    5
                  ],
                  [
                    3.2,
                    4.7
                  ],
                  [
                    3.2,
                    4.7
                  ],
                  [
                    2.5,
                    5
                  ],
                  [
                    2,
                    5.9
                  ],
                  [
                    1.9,
                    7.6
                  ],
                  [
                    1.9,
                    7.6
                  ],
                  [
                    2,
                    9.4
                  ],
                  [
                    2.5,
                    10.3
                  ],
                  [
                    3.2,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1627,
        ty: 3,
        parent: 1622,
        ks: {
          p: {
            a: 0,
            k: [
              6.33,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1630,
        ty: 4,
        parent: 1629,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    11.7
                  ],
                  [
                    3,
                    11.7
                  ],
                  [
                    1.4,
                    11.4
                  ],
                  [
                    0.3,
                    10.6
                  ],
                  [
                    0.3,
                    10.6
                  ],
                  [
                    1,
                    9.7
                  ],
                  [
                    1.8,
                    10.3
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.9,
                    10.3
                  ],
                  [
                    4.3,
                    9.4
                  ],
                  [
                    4.3,
                    9.4
                  ],
                  [
                    4.1,
                    8.7
                  ],
                  [
                    3.4,
                    8.2
                  ],
                  [
                    2,
                    8.1
                  ],
                  [
                    2,
                    8.1
                  ],
                  [
                    2,
                    7
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    4,
                    5.8
                  ],
                  [
                    4,
                    5.8
                  ],
                  [
                    3.7,
                    5
                  ],
                  [
                    2.9,
                    4.7
                  ],
                  [
                    2.9,
                    4.7
                  ],
                  [
                    2,
                    4.9
                  ],
                  [
                    1.3,
                    5.5
                  ],
                  [
                    1.3,
                    5.5
                  ],
                  [
                    0.6,
                    4.6
                  ],
                  [
                    1.6,
                    3.9
                  ],
                  [
                    2.9,
                    3.6
                  ],
                  [
                    2.9,
                    3.6
                  ],
                  [
                    4.8,
                    4.1
                  ],
                  [
                    5.5,
                    5.7
                  ],
                  [
                    5.5,
                    5.7
                  ],
                  [
                    5.1,
                    6.8
                  ],
                  [
                    4.1,
                    7.5
                  ],
                  [
                    4.1,
                    7.5
                  ],
                  [
                    4.1,
                    7.5
                  ],
                  [
                    5.2,
                    8.2
                  ],
                  [
                    5.7,
                    9.5
                  ],
                  [
                    5.7,
                    9.5
                  ],
                  [
                    5.3,
                    10.7
                  ],
                  [
                    4.3,
                    11.5
                  ],
                  [
                    3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.5,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.1
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1629,
        ty: 3,
        parent: 1622,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1622,
        ty: 3,
        parent: 1577,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1577,
        ty: 3,
        parent: 1576,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1576,
        ty: 3,
        parent: 1575,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1575,
        ty: 3,
        parent: 1574,
        ks: {
          p: {
            a: 0,
            k: [
              19.2,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1639,
        ty: 0,
        parent: 1631,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              1.143
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              1.143
            ]
          }
        },
        w: 13.714,
        h: 13.714,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1637"
      },
      {
        ind: 1631,
        ty: 3,
        parent: 1574,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1.143
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1574,
        ty: 3,
        parent: 1573,
        ks: {
          p: {
            a: 0,
            k: [
              50.435,
              3.527
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1573,
        ty: 3,
        parent: 1572,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              54.792
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1660,
        ty: 0,
        parent: 1642,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              18.743
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              18.743
            ]
          }
        },
        w: 92.353,
        h: 21.943,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1658"
      },
      {
        ind: 1642,
        ty: 3,
        parent: 1641,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              18.743
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1665,
        ty: 4,
        parent: 1664,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.7
                  ],
                  [
                    2,
                    6.7
                  ],
                  [
                    2.7,
                    5.8
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.1,
                    6.5
                  ],
                  [
                    3.9,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    2.7,
                    6.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1664,
        ty: 3,
        parent: 1663,
        ks: {
          p: {
            a: 0,
            k: [
              27.703,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1667,
        ty: 4,
        parent: 1666,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.2
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.6,
                    8.6
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    1.6,
                    8.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.4,
                    11.1
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.6
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.1
                  ],
                  [
                    1.6,
                    8.1
                  ],
                  [
                    4.8,
                    8.1
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.6,
                    8.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1666,
        ty: 3,
        parent: 1663,
        ks: {
          p: {
            a: 0,
            k: [
              21.583,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1669,
        ty: 4,
        parent: 1668,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    11.7
                  ],
                  [
                    2.1,
                    11.7
                  ],
                  [
                    1.3,
                    11.4
                  ],
                  [
                    1,
                    10.4
                  ],
                  [
                    1,
                    10.4
                  ],
                  [
                    1,
                    2.8
                  ],
                  [
                    2,
                    2.8
                  ],
                  [
                    2,
                    10.5
                  ],
                  [
                    2.1,
                    10.8
                  ],
                  [
                    2.3,
                    10.9
                  ],
                  [
                    2.3,
                    10.9
                  ],
                  [
                    2.4,
                    10.9
                  ],
                  [
                    2.5,
                    10.9
                  ],
                  [
                    2.5,
                    10.9
                  ],
                  [
                    2.7,
                    11.6
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.1,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1668,
        ty: 3,
        parent: 1663,
        ks: {
          p: {
            a: 0,
            k: [
              18.436,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1671,
        ty: 4,
        parent: 1670,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -1.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.3
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.5,
                    8.5
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.2,
                    7.1
                  ],
                  [
                    3.8,
                    6.5
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    2.1,
                    6.5
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    0.9,
                    6.2
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    11.6
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    3.5,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    10.9
                  ],
                  [
                    2.7,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    8.5
                  ],
                  [
                    2.2,
                    9
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.9,
                    10.7
                  ],
                  [
                    2.7,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1670,
        ty: 3,
        parent: 1663,
        ks: {
          p: {
            a: 0,
            k: [
              12.217,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1673,
        ty: 4,
        parent: 1672,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    4.5,
                    5.7
                  ],
                  [
                    5.2,
                    6.1
                  ],
                  [
                    5.2,
                    6.1
                  ],
                  [
                    4.7,
                    6.8
                  ],
                  [
                    4.1,
                    6.4
                  ],
                  [
                    3.5,
                    6.3
                  ],
                  [
                    3.5,
                    6.3
                  ],
                  [
                    2.5,
                    6.6
                  ],
                  [
                    1.9,
                    7.4
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    2.1,
                    10.3
                  ],
                  [
                    3.5,
                    10.9
                  ],
                  [
                    3.5,
                    10.9
                  ],
                  [
                    4.2,
                    10.7
                  ],
                  [
                    4.9,
                    10.3
                  ],
                  [
                    4.9,
                    10.3
                  ],
                  [
                    5.3,
                    11
                  ],
                  [
                    4.4,
                    11.5
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1672,
        ty: 3,
        parent: 1663,
        ks: {
          p: {
            a: 0,
            k: [
              6.59,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1675,
        ty: 4,
        parent: 1674,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    1.1,
                    9.8
                  ],
                  [
                    2.2,
                    10.6
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    4.6,
                    10.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    4.9,
                    8.8
                  ],
                  [
                    4.4,
                    8.4
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    2.6,
                    7.6
                  ],
                  [
                    1.8,
                    7.2
                  ],
                  [
                    1.2,
                    6.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    1.2,
                    4.4
                  ],
                  [
                    2.1,
                    3.6
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    4.8,
                    3.6
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.3,
                    5
                  ],
                  [
                    4.5,
                    4.4
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    2.4,
                    4.6
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2.2,
                    6.1
                  ],
                  [
                    2.7,
                    6.5
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    4.4,
                    7.3
                  ],
                  [
                    5.3,
                    7.7
                  ],
                  [
                    5.9,
                    8.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    5.8,
                    10.6
                  ],
                  [
                    4.8,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1674,
        ty: 3,
        parent: 1663,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1663,
        ty: 3,
        parent: 1662,
        ks: {
          p: {
            a: 0,
            k: [
              25.482,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1678,
        ty: 4,
        parent: 1677,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.9,
                    11.7
                  ],
                  [
                    2.9,
                    11.7
                  ],
                  [
                    1.6,
                    11.2
                  ],
                  [
                    1.2,
                    9.7
                  ],
                  [
                    1.2,
                    9.7
                  ],
                  [
                    1.2,
                    6.4
                  ],
                  [
                    0.3,
                    6.4
                  ],
                  [
                    0.3,
                    5.7
                  ],
                  [
                    1.2,
                    5.6
                  ],
                  [
                    1.4,
                    3.9
                  ],
                  [
                    2.2,
                    3.9
                  ],
                  [
                    2.2,
                    5.6
                  ],
                  [
                    3.8,
                    5.6
                  ],
                  [
                    3.8,
                    6.4
                  ],
                  [
                    2.2,
                    6.4
                  ],
                  [
                    2.2,
                    9.7
                  ],
                  [
                    2.4,
                    10.6
                  ],
                  [
                    3.1,
                    10.9
                  ],
                  [
                    3.1,
                    10.9
                  ],
                  [
                    3.5,
                    10.9
                  ],
                  [
                    3.8,
                    10.7
                  ],
                  [
                    3.8,
                    10.7
                  ],
                  [
                    4,
                    11.5
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2.9,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1677,
        ty: 3,
        parent: 1676,
        ks: {
          p: {
            a: 0,
            k: [
              18.843,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1680,
        ty: 4,
        parent: 1679,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    2.6,
                    11.7
                  ],
                  [
                    2.6,
                    11.7
                  ],
                  [
                    1.4,
                    11.5
                  ],
                  [
                    0.3,
                    10.9
                  ],
                  [
                    0.3,
                    10.9
                  ],
                  [
                    0.9,
                    10.2
                  ],
                  [
                    1.7,
                    10.7
                  ],
                  [
                    2.6,
                    10.9
                  ],
                  [
                    2.6,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    3.8,
                    10
                  ],
                  [
                    3.8,
                    10
                  ],
                  [
                    3.6,
                    9.5
                  ],
                  [
                    3.1,
                    9.1
                  ],
                  [
                    2.4,
                    8.9
                  ],
                  [
                    2.4,
                    8.9
                  ],
                  [
                    1.6,
                    8.5
                  ],
                  [
                    0.9,
                    8
                  ],
                  [
                    0.7,
                    7.1
                  ],
                  [
                    0.7,
                    7.1
                  ],
                  [
                    1.2,
                    5.9
                  ],
                  [
                    2.8,
                    5.4
                  ],
                  [
                    2.8,
                    5.4
                  ],
                  [
                    3.8,
                    5.6
                  ],
                  [
                    4.6,
                    6.1
                  ],
                  [
                    4.6,
                    6.1
                  ],
                  [
                    4.1,
                    6.8
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    2.8,
                    6.2
                  ],
                  [
                    2.8,
                    6.2
                  ],
                  [
                    1.9,
                    6.5
                  ],
                  [
                    1.7,
                    7.1
                  ],
                  [
                    1.7,
                    7.1
                  ],
                  [
                    1.8,
                    7.6
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.9,
                    8.1
                  ],
                  [
                    2.9,
                    8.1
                  ],
                  [
                    3.8,
                    8.5
                  ],
                  [
                    4.5,
                    9
                  ],
                  [
                    4.8,
                    9.9
                  ],
                  [
                    4.8,
                    9.9
                  ],
                  [
                    4.5,
                    10.8
                  ],
                  [
                    3.8,
                    11.5
                  ],
                  [
                    2.6,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1679,
        ty: 3,
        parent: 1676,
        ks: {
          p: {
            a: 0,
            k: [
              13.673,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1682,
        ty: 4,
        parent: 1681,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    11.7
                  ],
                  [
                    3.3,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.8
                  ],
                  [
                    5.7,
                    6.9
                  ],
                  [
                    6.1,
                    8.6
                  ],
                  [
                    6.1,
                    8.6
                  ],
                  [
                    5.7,
                    10.3
                  ],
                  [
                    4.7,
                    11.4
                  ],
                  [
                    3.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    10.9
                  ],
                  [
                    3.3,
                    10.9
                  ],
                  [
                    4.6,
                    10.3
                  ],
                  [
                    5.1,
                    8.6
                  ],
                  [
                    5.1,
                    8.6
                  ],
                  [
                    4.6,
                    6.9
                  ],
                  [
                    3.3,
                    6.3
                  ],
                  [
                    3.3,
                    6.3
                  ],
                  [
                    2.1,
                    6.9
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    2.1,
                    10.3
                  ],
                  [
                    3.3,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1681,
        ty: 3,
        parent: 1676,
        ks: {
          p: {
            a: 0,
            k: [
              6.984,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1684,
        ty: 4,
        parent: 1683,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    3.5
                  ],
                  [
                    3.4,
                    3.5
                  ],
                  [
                    5,
                    3.7
                  ],
                  [
                    6.1,
                    4.5
                  ],
                  [
                    6.5,
                    5.9
                  ],
                  [
                    6.5,
                    5.9
                  ],
                  [
                    5.6,
                    7.8
                  ],
                  [
                    3.5,
                    8.4
                  ],
                  [
                    3.5,
                    8.4
                  ],
                  [
                    2.1,
                    8.4
                  ],
                  [
                    2.1,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.5,
                    0.1
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    4.3
                  ],
                  [
                    2.1,
                    7.5
                  ],
                  [
                    3.3,
                    7.5
                  ],
                  [
                    4.9,
                    7.1
                  ],
                  [
                    5.4,
                    5.9
                  ],
                  [
                    5.4,
                    5.9
                  ],
                  [
                    4.9,
                    4.7
                  ],
                  [
                    3.3,
                    4.3
                  ],
                  [
                    3.3,
                    4.3
                  ],
                  [
                    2.1,
                    4.3
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1683,
        ty: 3,
        parent: 1676,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1676,
        ty: 3,
        parent: 1662,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1662,
        ty: 3,
        parent: 1661,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1661,
        ty: 3,
        parent: 1641,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1641,
        ty: 3,
        parent: 1640,
        ks: {
          p: {
            a: 0,
            k: [
              173.694,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1690,
        ty: 0,
        parent: 1686,
        ks: {},
        w: 32,
        h: 17,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1688"
      },
      {
        ind: 1686,
        ty: 3,
        parent: 1685,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1685,
        ty: 3,
        parent: 1640,
        ks: {
          p: {
            a: 0,
            k: [
              131.572,
              12.031
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1696,
        ty: 0,
        parent: 1692,
        ks: {},
        w: 112,
        h: 19,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1694"
      },
      {
        ind: 1692,
        ty: 3,
        parent: 1691,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              14
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1701,
        ty: 0,
        parent: 1697,
        ks: {},
        w: 81,
        h: 15,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1699"
      },
      {
        ind: 1697,
        ty: 3,
        parent: 1691,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1691,
        ty: 3,
        parent: 1640,
        ks: {
          p: {
            a: 0,
            k: [
              9.024,
              4.033
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1640,
        ty: 3,
        parent: 1572,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1572,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              10.58,
              97.78
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1710,
        ty: 4,
        parent: 1709,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.5
                  ],
                  [
                    2,
                    6.5
                  ],
                  [
                    2.9,
                    5.7
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    5.4,
                    6
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    4.8,
                    7.9
                  ],
                  [
                    4.5,
                    6.7
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    2.8,
                    6.6
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1709,
        ty: 3,
        parent: 1708,
        ks: {
          p: {
            a: 0,
            k: [
              37.736,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1712,
        ty: 4,
        parent: 1711,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    11.7
                  ],
                  [
                    3.3,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.8
                  ],
                  [
                    5.7,
                    6.9
                  ],
                  [
                    6.1,
                    8.6
                  ],
                  [
                    6.1,
                    8.6
                  ],
                  [
                    5.7,
                    10.3
                  ],
                  [
                    4.7,
                    11.4
                  ],
                  [
                    3.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    10.9
                  ],
                  [
                    3.3,
                    10.9
                  ],
                  [
                    4.6,
                    10.3
                  ],
                  [
                    5.1,
                    8.6
                  ],
                  [
                    5.1,
                    8.6
                  ],
                  [
                    4.6,
                    6.9
                  ],
                  [
                    3.3,
                    6.3
                  ],
                  [
                    3.3,
                    6.3
                  ],
                  [
                    2.1,
                    6.9
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    2.1,
                    10.3
                  ],
                  [
                    3.3,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1711,
        ty: 3,
        parent: 1708,
        ks: {
          p: {
            a: 0,
            k: [
              31.047,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1714,
        ty: 4,
        parent: 1713,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -1.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.3
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.5,
                    8.5
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.2,
                    7.1
                  ],
                  [
                    3.8,
                    6.5
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    2.1,
                    6.5
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    0.9,
                    6.2
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    11.6
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    3.5,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    10.9
                  ],
                  [
                    2.7,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    8.5
                  ],
                  [
                    2.2,
                    9
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.9,
                    10.7
                  ],
                  [
                    2.7,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1713,
        ty: 3,
        parent: 1708,
        ks: {
          p: {
            a: 0,
            k: [
              24.828,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1716,
        ty: 4,
        parent: 1715,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    14.4
                  ],
                  [
                    3,
                    14.4
                  ],
                  [
                    1.2,
                    13.9
                  ],
                  [
                    0.6,
                    12.7
                  ],
                  [
                    0.6,
                    12.7
                  ],
                  [
                    0.8,
                    12
                  ],
                  [
                    1.4,
                    11.4
                  ],
                  [
                    1.4,
                    11.4
                  ],
                  [
                    1.4,
                    11.3
                  ],
                  [
                    1.1,
                    10.9
                  ],
                  [
                    0.9,
                    10.4
                  ],
                  [
                    0.9,
                    10.4
                  ],
                  [
                    1.1,
                    9.7
                  ],
                  [
                    1.6,
                    9.2
                  ],
                  [
                    1.6,
                    9.2
                  ],
                  [
                    1.6,
                    9.2
                  ],
                  [
                    1,
                    8.5
                  ],
                  [
                    0.8,
                    7.6
                  ],
                  [
                    0.8,
                    7.6
                  ],
                  [
                    1.1,
                    6.4
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3,
                    5.4
                  ],
                  [
                    3,
                    5.4
                  ],
                  [
                    3.5,
                    5.5
                  ],
                  [
                    3.9,
                    5.6
                  ],
                  [
                    3.9,
                    5.6
                  ],
                  [
                    6,
                    5.6
                  ],
                  [
                    6,
                    6.4
                  ],
                  [
                    4.7,
                    6.4
                  ],
                  [
                    5.1,
                    6.9
                  ],
                  [
                    5.2,
                    7.6
                  ],
                  [
                    5.2,
                    7.6
                  ],
                  [
                    4.9,
                    8.7
                  ],
                  [
                    4.1,
                    9.4
                  ],
                  [
                    3,
                    9.7
                  ],
                  [
                    3,
                    9.7
                  ],
                  [
                    2.1,
                    9.5
                  ],
                  [
                    2.1,
                    9.5
                  ],
                  [
                    1.9,
                    9.8
                  ],
                  [
                    1.8,
                    10.2
                  ],
                  [
                    1.8,
                    10.2
                  ],
                  [
                    2,
                    10.7
                  ],
                  [
                    2.8,
                    10.8
                  ],
                  [
                    2.8,
                    10.8
                  ],
                  [
                    4,
                    10.8
                  ],
                  [
                    5.5,
                    11.2
                  ],
                  [
                    6.1,
                    12.3
                  ],
                  [
                    6.1,
                    12.3
                  ],
                  [
                    5.7,
                    13.3
                  ],
                  [
                    4.7,
                    14.1
                  ],
                  [
                    3,
                    14.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    9
                  ],
                  [
                    3,
                    9
                  ],
                  [
                    3.9,
                    8.6
                  ],
                  [
                    4.3,
                    7.6
                  ],
                  [
                    4.3,
                    7.6
                  ],
                  [
                    3.9,
                    6.6
                  ],
                  [
                    3,
                    6.2
                  ],
                  [
                    3,
                    6.2
                  ],
                  [
                    2.1,
                    6.6
                  ],
                  [
                    1.8,
                    7.6
                  ],
                  [
                    1.8,
                    7.6
                  ],
                  [
                    2.1,
                    8.6
                  ],
                  [
                    3,
                    9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    13.6
                  ],
                  [
                    3.2,
                    13.6
                  ],
                  [
                    4.6,
                    13.3
                  ],
                  [
                    5.1,
                    12.4
                  ],
                  [
                    5.1,
                    12.4
                  ],
                  [
                    4.8,
                    11.8
                  ],
                  [
                    3.9,
                    11.7
                  ],
                  [
                    3.9,
                    11.7
                  ],
                  [
                    2.8,
                    11.7
                  ],
                  [
                    2.5,
                    11.7
                  ],
                  [
                    2.1,
                    11.6
                  ],
                  [
                    2.1,
                    11.6
                  ],
                  [
                    1.6,
                    12.1
                  ],
                  [
                    1.4,
                    12.6
                  ],
                  [
                    1.4,
                    12.6
                  ],
                  [
                    1.9,
                    13.4
                  ],
                  [
                    3.2,
                    13.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1715,
        ty: 3,
        parent: 1708,
        ks: {
          p: {
            a: 0,
            k: [
              18.609,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1718,
        ty: 4,
        parent: 1717,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.7
                  ],
                  [
                    2,
                    6.7
                  ],
                  [
                    2.7,
                    5.8
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.1,
                    6.5
                  ],
                  [
                    3.9,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    2.7,
                    6.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1717,
        ty: 3,
        parent: 1708,
        ks: {
          p: {
            a: 0,
            k: [
              14.327,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1720,
        ty: 4,
        parent: 1719,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    11.7
                  ],
                  [
                    2.8,
                    11.7
                  ],
                  [
                    1.4,
                    11.1
                  ],
                  [
                    0.9,
                    9.4
                  ],
                  [
                    0.9,
                    9.4
                  ],
                  [
                    0.9,
                    5.6
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    2,
                    9.3
                  ],
                  [
                    2.2,
                    10.5
                  ],
                  [
                    3.1,
                    10.9
                  ],
                  [
                    3.1,
                    10.9
                  ],
                  [
                    3.9,
                    10.6
                  ],
                  [
                    4.7,
                    9.8
                  ],
                  [
                    4.7,
                    9.8
                  ],
                  [
                    4.7,
                    5.6
                  ],
                  [
                    5.7,
                    5.6
                  ],
                  [
                    5.7,
                    11.6
                  ],
                  [
                    4.9,
                    11.6
                  ],
                  [
                    4.8,
                    10.6
                  ],
                  [
                    4.7,
                    10.6
                  ],
                  [
                    3.9,
                    11.4
                  ],
                  [
                    2.8,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1719,
        ty: 3,
        parent: 1708,
        ks: {
          p: {
            a: 0,
            k: [
              7.614,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1722,
        ty: 4,
        parent: 1721,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0.3
                  ],
                  [
                    0.3,
                    0.6
                  ],
                  [
                    0,
                    0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.6
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    -0.9,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    4.3,
                    11.7
                  ],
                  [
                    4.3,
                    11.7
                  ],
                  [
                    2.4,
                    11.2
                  ],
                  [
                    1.1,
                    9.8
                  ],
                  [
                    0.6,
                    7.5
                  ],
                  [
                    0.6,
                    7.5
                  ],
                  [
                    1.1,
                    5.3
                  ],
                  [
                    2.4,
                    3.8
                  ],
                  [
                    4.4,
                    3.3
                  ],
                  [
                    4.4,
                    3.3
                  ],
                  [
                    5.8,
                    3.7
                  ],
                  [
                    6.7,
                    4.3
                  ],
                  [
                    6.7,
                    4.3
                  ],
                  [
                    6.1,
                    5
                  ],
                  [
                    5.4,
                    4.5
                  ],
                  [
                    4.4,
                    4.2
                  ],
                  [
                    4.4,
                    4.2
                  ],
                  [
                    3,
                    4.6
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    1.7,
                    7.5
                  ],
                  [
                    1.7,
                    7.5
                  ],
                  [
                    2.4,
                    9.9
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    5.2,
                    10.7
                  ],
                  [
                    5.9,
                    10.4
                  ],
                  [
                    5.9,
                    10.4
                  ],
                  [
                    5.9,
                    8.2
                  ],
                  [
                    4.1,
                    8.2
                  ],
                  [
                    4.1,
                    7.4
                  ],
                  [
                    6.8,
                    7.4
                  ],
                  [
                    6.8,
                    10.8
                  ],
                  [
                    5.8,
                    11.5
                  ],
                  [
                    4.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.6,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0.3,
                    -0.6
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.2,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    1
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1721,
        ty: 3,
        parent: 1708,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1708,
        ty: 3,
        parent: 1707,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1707,
        ty: 3,
        parent: 1706,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1706,
        ty: 3,
        parent: 1705,
        ks: {
          p: {
            a: 0,
            k: [
              21.159,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1732,
        ty: 0,
        parent: 1723,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1730"
      },
      {
        ind: 1723,
        ty: 3,
        parent: 1705,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1705,
        ty: 3,
        parent: 1704,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              19.527
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1738,
        ty: 4,
        parent: 1737,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0.1
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    2.9,
                    11.7
                  ],
                  [
                    2.9,
                    11.7
                  ],
                  [
                    1.3,
                    11.4
                  ],
                  [
                    0.3,
                    10.6
                  ],
                  [
                    0.3,
                    10.6
                  ],
                  [
                    0.8,
                    10
                  ],
                  [
                    1.7,
                    10.6
                  ],
                  [
                    2.9,
                    10.9
                  ],
                  [
                    2.9,
                    10.9
                  ],
                  [
                    4,
                    10.5
                  ],
                  [
                    4.5,
                    9.5
                  ],
                  [
                    4.5,
                    9.5
                  ],
                  [
                    4.2,
                    8.6
                  ],
                  [
                    3.4,
                    8.1
                  ],
                  [
                    2,
                    7.9
                  ],
                  [
                    2,
                    7.9
                  ],
                  [
                    2,
                    7.1
                  ],
                  [
                    3.3,
                    6.9
                  ],
                  [
                    4,
                    6.4
                  ],
                  [
                    4.2,
                    5.6
                  ],
                  [
                    4.2,
                    5.6
                  ],
                  [
                    3.8,
                    4.7
                  ],
                  [
                    2.8,
                    4.4
                  ],
                  [
                    2.8,
                    4.4
                  ],
                  [
                    1.9,
                    4.6
                  ],
                  [
                    1.2,
                    5.2
                  ],
                  [
                    1.2,
                    5.2
                  ],
                  [
                    0.6,
                    4.6
                  ],
                  [
                    1.6,
                    3.8
                  ],
                  [
                    2.9,
                    3.6
                  ],
                  [
                    2.9,
                    3.6
                  ],
                  [
                    4.6,
                    4.1
                  ],
                  [
                    5.2,
                    5.6
                  ],
                  [
                    5.2,
                    5.6
                  ],
                  [
                    4.8,
                    6.7
                  ],
                  [
                    3.8,
                    7.4
                  ],
                  [
                    3.8,
                    7.4
                  ],
                  [
                    3.8,
                    7.5
                  ],
                  [
                    5,
                    8.2
                  ],
                  [
                    5.5,
                    9.5
                  ],
                  [
                    5.5,
                    9.5
                  ],
                  [
                    5.2,
                    10.7
                  ],
                  [
                    4.2,
                    11.5
                  ],
                  [
                    2.9,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.4,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.1
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1737,
        ty: 3,
        parent: 1736,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1736,
        ty: 3,
        parent: 1735,
        ks: {
          p: {
            a: 0,
            k: [
              96.809,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1741,
        ty: 4,
        parent: 1740,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.7
                  ],
                  [
                    2,
                    6.7
                  ],
                  [
                    2.7,
                    5.8
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.1,
                    6.5
                  ],
                  [
                    3.9,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    2.7,
                    6.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1740,
        ty: 3,
        parent: 1739,
        ks: {
          p: {
            a: 0,
            k: [
              41.499,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1743,
        ty: 4,
        parent: 1742,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.2
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.6,
                    8.6
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    1.6,
                    8.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.4,
                    11.1
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.6
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.1
                  ],
                  [
                    1.6,
                    8.1
                  ],
                  [
                    4.8,
                    8.1
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.6,
                    8.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1742,
        ty: 3,
        parent: 1739,
        ks: {
          p: {
            a: 0,
            k: [
              35.379,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1745,
        ty: 4,
        parent: 1744,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.2
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.6,
                    8.6
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    1.6,
                    8.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.4,
                    11.1
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.6
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.1
                  ],
                  [
                    1.6,
                    8.1
                  ],
                  [
                    4.8,
                    8.1
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.6,
                    8.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1744,
        ty: 3,
        parent: 1739,
        ks: {
          p: {
            a: 0,
            k: [
              29.258,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1747,
        ty: 4,
        parent: 1746,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.5
                  ],
                  [
                    2,
                    6.5
                  ],
                  [
                    2.9,
                    5.7
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    5.4,
                    6
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    4.8,
                    7.9
                  ],
                  [
                    4.5,
                    6.7
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    2.8,
                    6.6
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1746,
        ty: 3,
        parent: 1739,
        ks: {
          p: {
            a: 0,
            k: [
              22.508,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1749,
        ty: 4,
        parent: 1748,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    1,
                    3.2
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    2,
                    3.2
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2,
                    4.2
                  ],
                  [
                    1.5,
                    4.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1748,
        ty: 3,
        parent: 1739,
        ks: {
          p: {
            a: 0,
            k: [
              19.472,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1751,
        ty: 4,
        parent: 1750,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    14.4
                  ],
                  [
                    3,
                    14.4
                  ],
                  [
                    1.2,
                    13.9
                  ],
                  [
                    0.6,
                    12.7
                  ],
                  [
                    0.6,
                    12.7
                  ],
                  [
                    0.8,
                    12
                  ],
                  [
                    1.4,
                    11.4
                  ],
                  [
                    1.4,
                    11.4
                  ],
                  [
                    1.4,
                    11.3
                  ],
                  [
                    1.1,
                    10.9
                  ],
                  [
                    0.9,
                    10.4
                  ],
                  [
                    0.9,
                    10.4
                  ],
                  [
                    1.1,
                    9.7
                  ],
                  [
                    1.6,
                    9.2
                  ],
                  [
                    1.6,
                    9.2
                  ],
                  [
                    1.6,
                    9.2
                  ],
                  [
                    1,
                    8.5
                  ],
                  [
                    0.8,
                    7.6
                  ],
                  [
                    0.8,
                    7.6
                  ],
                  [
                    1.1,
                    6.4
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3,
                    5.4
                  ],
                  [
                    3,
                    5.4
                  ],
                  [
                    3.5,
                    5.5
                  ],
                  [
                    3.9,
                    5.6
                  ],
                  [
                    3.9,
                    5.6
                  ],
                  [
                    6,
                    5.6
                  ],
                  [
                    6,
                    6.4
                  ],
                  [
                    4.7,
                    6.4
                  ],
                  [
                    5.1,
                    6.9
                  ],
                  [
                    5.2,
                    7.6
                  ],
                  [
                    5.2,
                    7.6
                  ],
                  [
                    4.9,
                    8.7
                  ],
                  [
                    4.1,
                    9.4
                  ],
                  [
                    3,
                    9.7
                  ],
                  [
                    3,
                    9.7
                  ],
                  [
                    2.1,
                    9.5
                  ],
                  [
                    2.1,
                    9.5
                  ],
                  [
                    1.9,
                    9.8
                  ],
                  [
                    1.8,
                    10.2
                  ],
                  [
                    1.8,
                    10.2
                  ],
                  [
                    2,
                    10.7
                  ],
                  [
                    2.8,
                    10.8
                  ],
                  [
                    2.8,
                    10.8
                  ],
                  [
                    4,
                    10.8
                  ],
                  [
                    5.5,
                    11.2
                  ],
                  [
                    6.1,
                    12.3
                  ],
                  [
                    6.1,
                    12.3
                  ],
                  [
                    5.7,
                    13.3
                  ],
                  [
                    4.7,
                    14.1
                  ],
                  [
                    3,
                    14.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    9
                  ],
                  [
                    3,
                    9
                  ],
                  [
                    3.9,
                    8.6
                  ],
                  [
                    4.3,
                    7.6
                  ],
                  [
                    4.3,
                    7.6
                  ],
                  [
                    3.9,
                    6.6
                  ],
                  [
                    3,
                    6.2
                  ],
                  [
                    3,
                    6.2
                  ],
                  [
                    2.1,
                    6.6
                  ],
                  [
                    1.8,
                    7.6
                  ],
                  [
                    1.8,
                    7.6
                  ],
                  [
                    2.1,
                    8.6
                  ],
                  [
                    3,
                    9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    13.6
                  ],
                  [
                    3.2,
                    13.6
                  ],
                  [
                    4.6,
                    13.3
                  ],
                  [
                    5.1,
                    12.4
                  ],
                  [
                    5.1,
                    12.4
                  ],
                  [
                    4.8,
                    11.8
                  ],
                  [
                    3.9,
                    11.7
                  ],
                  [
                    3.9,
                    11.7
                  ],
                  [
                    2.8,
                    11.7
                  ],
                  [
                    2.5,
                    11.7
                  ],
                  [
                    2.1,
                    11.6
                  ],
                  [
                    2.1,
                    11.6
                  ],
                  [
                    1.6,
                    12.1
                  ],
                  [
                    1.4,
                    12.6
                  ],
                  [
                    1.4,
                    12.6
                  ],
                  [
                    1.9,
                    13.4
                  ],
                  [
                    3.2,
                    13.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1750,
        ty: 3,
        parent: 1739,
        ks: {
          p: {
            a: 0,
            k: [
              13.253,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1753,
        ty: 4,
        parent: 1752,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.5
                  ],
                  [
                    2,
                    6.5
                  ],
                  [
                    2.9,
                    5.7
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    5.4,
                    6
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    4.8,
                    7.9
                  ],
                  [
                    4.5,
                    6.7
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    2.8,
                    6.6
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1752,
        ty: 3,
        parent: 1739,
        ks: {
          p: {
            a: 0,
            k: [
              6.503,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1755,
        ty: 4,
        parent: 1754,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    5.9,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    3.5
                  ],
                  [
                    5.8,
                    3.5
                  ],
                  [
                    5.8,
                    4.4
                  ],
                  [
                    2.1,
                    4.4
                  ],
                  [
                    2.1,
                    6.9
                  ],
                  [
                    5.2,
                    6.9
                  ],
                  [
                    5.2,
                    7.8
                  ],
                  [
                    2.1,
                    7.8
                  ],
                  [
                    2.1,
                    10.7
                  ],
                  [
                    5.9,
                    10.7
                  ],
                  [
                    5.9,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1754,
        ty: 3,
        parent: 1739,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1739,
        ty: 3,
        parent: 1735,
        ks: {
          p: {
            a: 0,
            k: [
              48.56,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1758,
        ty: 4,
        parent: 1757,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.2
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.6,
                    8.6
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    1.6,
                    8.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.4,
                    11.1
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.6
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.1
                  ],
                  [
                    1.6,
                    8.1
                  ],
                  [
                    4.8,
                    8.1
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.6,
                    8.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1757,
        ty: 3,
        parent: 1756,
        ks: {
          p: {
            a: 0,
            k: [
              39.971,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1760,
        ty: 4,
        parent: 1759,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.7
                  ],
                  [
                    2,
                    6.7
                  ],
                  [
                    2.7,
                    5.8
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.1,
                    6.5
                  ],
                  [
                    3.9,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    2.7,
                    6.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1759,
        ty: 3,
        parent: 1756,
        ks: {
          p: {
            a: 0,
            k: [
              35.689,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1762,
        ty: 4,
        parent: 1761,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -1.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.3
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.5,
                    8.5
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.2,
                    7.1
                  ],
                  [
                    3.8,
                    6.5
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    2.1,
                    6.5
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    0.9,
                    6.2
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    11.6
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    3.5,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    10.9
                  ],
                  [
                    2.7,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    8.5
                  ],
                  [
                    2.2,
                    9
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.9,
                    10.7
                  ],
                  [
                    2.7,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1761,
        ty: 3,
        parent: 1756,
        ks: {
          p: {
            a: 0,
            k: [
              29.47,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1764,
        ty: 4,
        parent: 1763,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.1,
                    11.6
                  ],
                  [
                    2,
                    11.6
                  ],
                  [
                    0.3,
                    5.6
                  ],
                  [
                    1.3,
                    5.6
                  ],
                  [
                    2.2,
                    9.1
                  ],
                  [
                    2.4,
                    9.9
                  ],
                  [
                    2.6,
                    10.7
                  ],
                  [
                    2.6,
                    10.7
                  ],
                  [
                    2.6,
                    10.7
                  ],
                  [
                    2.8,
                    9.9
                  ],
                  [
                    3,
                    9.1
                  ],
                  [
                    3,
                    9.1
                  ],
                  [
                    4,
                    5.6
                  ],
                  [
                    4.9,
                    5.6
                  ],
                  [
                    5.9,
                    9.1
                  ],
                  [
                    6.1,
                    9.9
                  ],
                  [
                    6.3,
                    10.7
                  ],
                  [
                    6.3,
                    10.7
                  ],
                  [
                    6.4,
                    10.7
                  ],
                  [
                    6.5,
                    9.9
                  ],
                  [
                    6.7,
                    9.1
                  ],
                  [
                    6.7,
                    9.1
                  ],
                  [
                    7.6,
                    5.6
                  ],
                  [
                    8.6,
                    5.6
                  ],
                  [
                    7,
                    11.6
                  ],
                  [
                    5.7,
                    11.6
                  ],
                  [
                    4.9,
                    8.4
                  ],
                  [
                    4.7,
                    7.5
                  ],
                  [
                    4.5,
                    6.6
                  ],
                  [
                    4.5,
                    6.6
                  ],
                  [
                    4.4,
                    6.6
                  ],
                  [
                    4.2,
                    7.5
                  ],
                  [
                    4,
                    8.4
                  ],
                  [
                    4,
                    8.4
                  ],
                  [
                    3.1,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1763,
        ty: 3,
        parent: 1756,
        ks: {
          p: {
            a: 0,
            k: [
              20.61,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1766,
        ty: 4,
        parent: 1765,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.2,
                    11.6
                  ],
                  [
                    1.2,
                    11.6
                  ],
                  [
                    1.2,
                    6.4
                  ],
                  [
                    0.4,
                    6.4
                  ],
                  [
                    0.4,
                    5.7
                  ],
                  [
                    1.2,
                    5.6
                  ],
                  [
                    1.2,
                    4.6
                  ],
                  [
                    1.6,
                    3.2
                  ],
                  [
                    2.9,
                    2.7
                  ],
                  [
                    2.9,
                    2.7
                  ],
                  [
                    3.5,
                    2.7
                  ],
                  [
                    3.9,
                    2.8
                  ],
                  [
                    3.9,
                    2.8
                  ],
                  [
                    3.7,
                    3.6
                  ],
                  [
                    3,
                    3.5
                  ],
                  [
                    3,
                    3.5
                  ],
                  [
                    2.2,
                    4.6
                  ],
                  [
                    2.2,
                    4.6
                  ],
                  [
                    2.2,
                    5.6
                  ],
                  [
                    3.5,
                    5.6
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    2.2,
                    6.4
                  ],
                  [
                    2.2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    6.5,
                    11.7
                  ],
                  [
                    6.5,
                    11.7
                  ],
                  [
                    5.2,
                    11.2
                  ],
                  [
                    4.8,
                    9.7
                  ],
                  [
                    4.8,
                    9.7
                  ],
                  [
                    4.8,
                    6.4
                  ],
                  [
                    3.9,
                    6.4
                  ],
                  [
                    3.9,
                    5.7
                  ],
                  [
                    4.8,
                    5.6
                  ],
                  [
                    5,
                    3.9
                  ],
                  [
                    5.8,
                    3.9
                  ],
                  [
                    5.8,
                    5.6
                  ],
                  [
                    7.4,
                    5.6
                  ],
                  [
                    7.4,
                    6.4
                  ],
                  [
                    5.8,
                    6.4
                  ],
                  [
                    5.8,
                    9.7
                  ],
                  [
                    6,
                    10.6
                  ],
                  [
                    6.7,
                    10.9
                  ],
                  [
                    6.7,
                    10.9
                  ],
                  [
                    7.1,
                    10.9
                  ],
                  [
                    7.4,
                    10.7
                  ],
                  [
                    7.4,
                    10.7
                  ],
                  [
                    7.6,
                    11.5
                  ],
                  [
                    7.1,
                    11.7
                  ],
                  [
                    6.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1765,
        ty: 3,
        parent: 1756,
        ks: {
          p: {
            a: 0,
            k: [
              13.278,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1768,
        ty: 4,
        parent: 1767,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    11.7
                  ],
                  [
                    3.3,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.8
                  ],
                  [
                    5.7,
                    6.9
                  ],
                  [
                    6.1,
                    8.6
                  ],
                  [
                    6.1,
                    8.6
                  ],
                  [
                    5.7,
                    10.3
                  ],
                  [
                    4.7,
                    11.4
                  ],
                  [
                    3.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    10.9
                  ],
                  [
                    3.3,
                    10.9
                  ],
                  [
                    4.6,
                    10.3
                  ],
                  [
                    5.1,
                    8.6
                  ],
                  [
                    5.1,
                    8.6
                  ],
                  [
                    4.6,
                    6.9
                  ],
                  [
                    3.3,
                    6.3
                  ],
                  [
                    3.3,
                    6.3
                  ],
                  [
                    2.1,
                    6.9
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    2.1,
                    10.3
                  ],
                  [
                    3.3,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1767,
        ty: 3,
        parent: 1756,
        ks: {
          p: {
            a: 0,
            k: [
              6.59,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1770,
        ty: 4,
        parent: 1769,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    1.1,
                    9.8
                  ],
                  [
                    2.2,
                    10.6
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    4.6,
                    10.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    4.9,
                    8.8
                  ],
                  [
                    4.4,
                    8.4
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    2.6,
                    7.6
                  ],
                  [
                    1.8,
                    7.2
                  ],
                  [
                    1.2,
                    6.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    1.2,
                    4.4
                  ],
                  [
                    2.1,
                    3.6
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    4.8,
                    3.6
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.3,
                    5
                  ],
                  [
                    4.5,
                    4.4
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    2.4,
                    4.6
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2.2,
                    6.1
                  ],
                  [
                    2.7,
                    6.5
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    4.4,
                    7.3
                  ],
                  [
                    5.3,
                    7.7
                  ],
                  [
                    5.9,
                    8.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    5.8,
                    10.6
                  ],
                  [
                    4.8,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1769,
        ty: 3,
        parent: 1756,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1756,
        ty: 3,
        parent: 1735,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1735,
        ty: 3,
        parent: 1734,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.8
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1734,
        ty: 3,
        parent: 1733,
        ks: {
          p: {
            a: 0,
            k: [
              21.159,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1780,
        ty: 0,
        parent: 1771,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1778"
      },
      {
        ind: 1771,
        ty: 3,
        parent: 1733,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1733,
        ty: 3,
        parent: 1704,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1704,
        ty: 3,
        parent: 1703,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              36.053
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1786,
        ty: 4,
        parent: 1785,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0.5
                  ],
                  [
                    -1.6,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    -1.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.9
                  ],
                  [
                    3,
                    19.9
                  ],
                  [
                    1.4,
                    19.3
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    1.8,
                    15.7
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5,
                    13.7
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    2.8,
                    13.5
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1,
                    12.8
                  ],
                  [
                    2.5,
                    12.1
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    6.4,
                    12.6
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    19.7
                  ],
                  [
                    5.6,
                    19.7
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    4.3,
                    19.6
                  ],
                  [
                    3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.7,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.6,
                    18.5
                  ],
                  [
                    3.6,
                    18.5
                  ],
                  [
                    4.5,
                    18.3
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    15.9
                  ],
                  [
                    3.1,
                    16.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.8,
                    18.3
                  ],
                  [
                    3.6,
                    18.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1785,
        ty: 3,
        parent: 1784,
        ks: {
          p: {
            a: 0,
            k: [
              23.917,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1788,
        ty: 4,
        parent: 1787,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    2.7,
                    12
                  ],
                  [
                    2.8,
                    13.3
                  ],
                  [
                    2.9,
                    13.3
                  ],
                  [
                    3.9,
                    12.2
                  ],
                  [
                    5.1,
                    11.8
                  ],
                  [
                    5.1,
                    11.8
                  ],
                  [
                    6,
                    11.9
                  ],
                  [
                    6,
                    11.9
                  ],
                  [
                    5.6,
                    13.5
                  ],
                  [
                    5.3,
                    13.4
                  ],
                  [
                    4.8,
                    13.4
                  ],
                  [
                    4.8,
                    13.4
                  ],
                  [
                    3.9,
                    13.7
                  ],
                  [
                    3,
                    15
                  ],
                  [
                    3,
                    15
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1787,
        ty: 3,
        parent: 1784,
        ks: {
          p: {
            a: 0,
            k: [
              18.001,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1790,
        ty: 4,
        parent: 1789,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0.3
                  ],
                  [
                    0.3,
                    0.6
                  ],
                  [
                    0,
                    0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.6
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.6
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    4.5,
                    19.9
                  ],
                  [
                    4.5,
                    19.9
                  ],
                  [
                    2.5,
                    19.5
                  ],
                  [
                    1.2,
                    18.1
                  ],
                  [
                    0.7,
                    15.9
                  ],
                  [
                    0.7,
                    15.9
                  ],
                  [
                    1.2,
                    13.7
                  ],
                  [
                    2.5,
                    12.3
                  ],
                  [
                    4.2,
                    11.8
                  ],
                  [
                    4.2,
                    11.8
                  ],
                  [
                    6,
                    12.2
                  ],
                  [
                    7.1,
                    13.5
                  ],
                  [
                    7.5,
                    15.5
                  ],
                  [
                    7.5,
                    15.5
                  ],
                  [
                    7.4,
                    16.4
                  ],
                  [
                    7.4,
                    16.4
                  ],
                  [
                    2.4,
                    16.4
                  ],
                  [
                    3.2,
                    18
                  ],
                  [
                    4.7,
                    18.5
                  ],
                  [
                    4.7,
                    18.5
                  ],
                  [
                    5.7,
                    18.4
                  ],
                  [
                    6.5,
                    18
                  ],
                  [
                    6.5,
                    18
                  ],
                  [
                    7.2,
                    19.1
                  ],
                  [
                    5.9,
                    19.7
                  ],
                  [
                    4.5,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.6,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.3,
                    -0.6
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.2,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.7
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.6
                  ]
                ],
                v: [
                  [
                    2.4,
                    15.1
                  ],
                  [
                    2.4,
                    15.1
                  ],
                  [
                    5.9,
                    15.1
                  ],
                  [
                    5.5,
                    13.7
                  ],
                  [
                    4.3,
                    13.2
                  ],
                  [
                    4.3,
                    13.2
                  ],
                  [
                    3.1,
                    13.7
                  ],
                  [
                    2.4,
                    15.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1789,
        ty: 3,
        parent: 1784,
        ks: {
          p: {
            a: 0,
            k: [
              9.96,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1792,
        ty: 4,
        parent: 1791,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0.4
                  ],
                  [
                    0.4,
                    0.8
                  ],
                  [
                    0,
                    1.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.8
                  ],
                  [
                    -0.7,
                    0.4
                  ],
                  [
                    -0.9,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.7
                  ],
                  [
                    0,
                    -1.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    -1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.2
                  ],
                  [
                    0.7,
                    0
                  ]
                ],
                v: [
                  [
                    5.7,
                    19.9
                  ],
                  [
                    5.7,
                    19.9
                  ],
                  [
                    3.2,
                    19.3
                  ],
                  [
                    1.4,
                    17.5
                  ],
                  [
                    0.8,
                    14.6
                  ],
                  [
                    0.8,
                    14.6
                  ],
                  [
                    1.4,
                    11.7
                  ],
                  [
                    3.2,
                    9.8
                  ],
                  [
                    5.7,
                    9.2
                  ],
                  [
                    5.7,
                    9.2
                  ],
                  [
                    7.6,
                    9.6
                  ],
                  [
                    8.8,
                    10.5
                  ],
                  [
                    8.8,
                    10.5
                  ],
                  [
                    7.8,
                    11.7
                  ],
                  [
                    7,
                    11
                  ],
                  [
                    5.7,
                    10.8
                  ],
                  [
                    5.7,
                    10.8
                  ],
                  [
                    3.5,
                    11.8
                  ],
                  [
                    2.7,
                    14.5
                  ],
                  [
                    2.7,
                    14.5
                  ],
                  [
                    3.5,
                    17.3
                  ],
                  [
                    5.8,
                    18.3
                  ],
                  [
                    5.8,
                    18.3
                  ],
                  [
                    6.7,
                    18.2
                  ],
                  [
                    7.3,
                    17.9
                  ],
                  [
                    7.3,
                    17.9
                  ],
                  [
                    7.3,
                    15.6
                  ],
                  [
                    5.4,
                    15.6
                  ],
                  [
                    5.4,
                    14.1
                  ],
                  [
                    9,
                    14.1
                  ],
                  [
                    9,
                    18.7
                  ],
                  [
                    7.6,
                    19.6
                  ],
                  [
                    5.7,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.9,
                    0
                  ],
                  [
                    -0.7,
                    -0.4
                  ],
                  [
                    -0.4,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -1.1
                  ],
                  [
                    0.4,
                    -0.8
                  ],
                  [
                    0.7,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.9,
                    0
                  ],
                  [
                    -0.6,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    1.2
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.6,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1791,
        ty: 3,
        parent: 1784,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1784,
        ty: 3,
        parent: 1783,
        ks: {
          p: {
            a: 0,
            k: [
              79.998,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1795,
        ty: 4,
        parent: 1794,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    19.9
                  ],
                  [
                    3.5,
                    19.9
                  ],
                  [
                    1.7,
                    19.1
                  ],
                  [
                    1.1,
                    16.8
                  ],
                  [
                    1.1,
                    16.8
                  ],
                  [
                    1.1,
                    12
                  ],
                  [
                    2.9,
                    12
                  ],
                  [
                    2.9,
                    16.6
                  ],
                  [
                    3.2,
                    18
                  ],
                  [
                    4.1,
                    18.4
                  ],
                  [
                    4.1,
                    18.4
                  ],
                  [
                    5,
                    18.1
                  ],
                  [
                    5.8,
                    17.3
                  ],
                  [
                    5.8,
                    17.3
                  ],
                  [
                    5.8,
                    12
                  ],
                  [
                    7.7,
                    12
                  ],
                  [
                    7.7,
                    19.7
                  ],
                  [
                    6.2,
                    19.7
                  ],
                  [
                    6,
                    18.6
                  ],
                  [
                    6,
                    18.6
                  ],
                  [
                    4.9,
                    19.6
                  ],
                  [
                    3.5,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1794,
        ty: 3,
        parent: 1793,
        ks: {
          p: {
            a: 0,
            k: [
              68.008,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1797,
        ty: 4,
        parent: 1796,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    8.5
                  ],
                  [
                    3,
                    8.5
                  ],
                  [
                    3,
                    11.4
                  ],
                  [
                    2.9,
                    12.9
                  ],
                  [
                    4,
                    12.1
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    7.2,
                    12.6
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    19.7
                  ],
                  [
                    6,
                    19.7
                  ],
                  [
                    6,
                    15.1
                  ],
                  [
                    5.7,
                    13.7
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    3.9,
                    13.6
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1796,
        ty: 3,
        parent: 1793,
        ks: {
          p: {
            a: 0,
            k: [
              59.158,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1799,
        ty: 4,
        parent: 1798,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.4
                  ],
                  [
                    -0.9,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.4,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.5
                  ],
                  [
                    1,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    19.9
                  ],
                  [
                    3.3,
                    19.9
                  ],
                  [
                    1.7,
                    19.6
                  ],
                  [
                    0.4,
                    18.9
                  ],
                  [
                    0.4,
                    18.9
                  ],
                  [
                    1.2,
                    17.7
                  ],
                  [
                    2.3,
                    18.3
                  ],
                  [
                    3.4,
                    18.6
                  ],
                  [
                    3.4,
                    18.6
                  ],
                  [
                    4.3,
                    18.3
                  ],
                  [
                    4.6,
                    17.6
                  ],
                  [
                    4.6,
                    17.6
                  ],
                  [
                    4.4,
                    17.1
                  ],
                  [
                    3.8,
                    16.7
                  ],
                  [
                    3,
                    16.4
                  ],
                  [
                    3,
                    16.4
                  ],
                  [
                    2,
                    15.9
                  ],
                  [
                    1.1,
                    15.2
                  ],
                  [
                    0.8,
                    14.1
                  ],
                  [
                    0.8,
                    14.1
                  ],
                  [
                    1.6,
                    12.4
                  ],
                  [
                    3.6,
                    11.8
                  ],
                  [
                    3.6,
                    11.8
                  ],
                  [
                    5.1,
                    12.1
                  ],
                  [
                    6.3,
                    12.7
                  ],
                  [
                    6.3,
                    12.7
                  ],
                  [
                    5.4,
                    13.8
                  ],
                  [
                    4.6,
                    13.3
                  ],
                  [
                    3.7,
                    13.1
                  ],
                  [
                    3.7,
                    13.1
                  ],
                  [
                    2.8,
                    13.4
                  ],
                  [
                    2.5,
                    14
                  ],
                  [
                    2.5,
                    14
                  ],
                  [
                    3,
                    14.7
                  ],
                  [
                    4.1,
                    15.2
                  ],
                  [
                    4.1,
                    15.2
                  ],
                  [
                    5.2,
                    15.6
                  ],
                  [
                    6,
                    16.4
                  ],
                  [
                    6.4,
                    17.5
                  ],
                  [
                    6.4,
                    17.5
                  ],
                  [
                    5.6,
                    19.2
                  ],
                  [
                    3.3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.5,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    -0.5,
                    0.5
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1798,
        ty: 3,
        parent: 1793,
        ks: {
          p: {
            a: 0,
            k: [
              52.322,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1801,
        ty: 4,
        parent: 1800,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    2.7,
                    12
                  ],
                  [
                    2.8,
                    13
                  ],
                  [
                    2.9,
                    13
                  ],
                  [
                    4,
                    12.1
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    7.2,
                    12.6
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    19.7
                  ],
                  [
                    6,
                    19.7
                  ],
                  [
                    6,
                    15.1
                  ],
                  [
                    5.7,
                    13.7
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    3.9,
                    13.6
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1800,
        ty: 3,
        parent: 1793,
        ks: {
          p: {
            a: 0,
            k: [
              43.44,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1803,
        ty: 4,
        parent: 1802,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0.5
                  ],
                  [
                    -1.6,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    -1.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.9
                  ],
                  [
                    3,
                    19.9
                  ],
                  [
                    1.4,
                    19.3
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    1.8,
                    15.7
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5,
                    13.7
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    2.8,
                    13.5
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1,
                    12.8
                  ],
                  [
                    2.5,
                    12.1
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    6.4,
                    12.6
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    19.7
                  ],
                  [
                    5.6,
                    19.7
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    4.3,
                    19.6
                  ],
                  [
                    3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.7,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.6,
                    18.5
                  ],
                  [
                    3.6,
                    18.5
                  ],
                  [
                    4.5,
                    18.3
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    15.9
                  ],
                  [
                    3.1,
                    16.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.8,
                    18.3
                  ],
                  [
                    3.6,
                    18.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1802,
        ty: 3,
        parent: 1793,
        ks: {
          p: {
            a: 0,
            k: [
              35.257,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1805,
        ty: 4,
        parent: 1804,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    8.5
                  ],
                  [
                    3,
                    8.5
                  ],
                  [
                    3,
                    11.4
                  ],
                  [
                    2.9,
                    12.9
                  ],
                  [
                    4,
                    12.1
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    7.2,
                    12.6
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    19.7
                  ],
                  [
                    6,
                    19.7
                  ],
                  [
                    6,
                    15.1
                  ],
                  [
                    5.7,
                    13.7
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    3.9,
                    13.6
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1804,
        ty: 3,
        parent: 1793,
        ks: {
          p: {
            a: 0,
            k: [
              26.407,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1807,
        ty: 4,
        parent: 1806,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0.7
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.6
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.9,
                    19.9
                  ],
                  [
                    3.9,
                    19.9
                  ],
                  [
                    1.6,
                    18.9
                  ],
                  [
                    0.7,
                    15.9
                  ],
                  [
                    0.7,
                    15.9
                  ],
                  [
                    1.2,
                    13.7
                  ],
                  [
                    2.4,
                    12.3
                  ],
                  [
                    4,
                    11.8
                  ],
                  [
                    4,
                    11.8
                  ],
                  [
                    5.1,
                    12
                  ],
                  [
                    6,
                    12.6
                  ],
                  [
                    6,
                    12.6
                  ],
                  [
                    6,
                    11.4
                  ],
                  [
                    6,
                    8.5
                  ],
                  [
                    7.8,
                    8.5
                  ],
                  [
                    7.8,
                    19.7
                  ],
                  [
                    6.3,
                    19.7
                  ],
                  [
                    6.2,
                    18.9
                  ],
                  [
                    6.1,
                    18.9
                  ],
                  [
                    5.1,
                    19.6
                  ],
                  [
                    3.9,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0
                  ],
                  [
                    -0.6,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.3,
                    -0.6
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ]
                ],
                v: [
                  [
                    4.3,
                    18.4
                  ],
                  [
                    4.3,
                    18.4
                  ],
                  [
                    6,
                    17.6
                  ],
                  [
                    6,
                    17.6
                  ],
                  [
                    6,
                    13.9
                  ],
                  [
                    5.2,
                    13.4
                  ],
                  [
                    4.4,
                    13.3
                  ],
                  [
                    4.4,
                    13.3
                  ],
                  [
                    3.1,
                    13.9
                  ],
                  [
                    2.6,
                    15.8
                  ],
                  [
                    2.6,
                    15.8
                  ],
                  [
                    3,
                    17.8
                  ],
                  [
                    4.3,
                    18.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1806,
        ty: 3,
        parent: 1793,
        ks: {
          p: {
            a: 0,
            k: [
              17.462,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1809,
        ty: 4,
        parent: 1808,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    19.9
                  ],
                  [
                    3.5,
                    19.9
                  ],
                  [
                    1.7,
                    19.1
                  ],
                  [
                    1.1,
                    16.8
                  ],
                  [
                    1.1,
                    16.8
                  ],
                  [
                    1.1,
                    12
                  ],
                  [
                    2.9,
                    12
                  ],
                  [
                    2.9,
                    16.6
                  ],
                  [
                    3.2,
                    18
                  ],
                  [
                    4.1,
                    18.4
                  ],
                  [
                    4.1,
                    18.4
                  ],
                  [
                    5,
                    18.1
                  ],
                  [
                    5.8,
                    17.3
                  ],
                  [
                    5.8,
                    17.3
                  ],
                  [
                    5.8,
                    12
                  ],
                  [
                    7.7,
                    12
                  ],
                  [
                    7.7,
                    19.7
                  ],
                  [
                    6.2,
                    19.7
                  ],
                  [
                    6,
                    18.6
                  ],
                  [
                    6,
                    18.6
                  ],
                  [
                    4.9,
                    19.6
                  ],
                  [
                    3.5,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1808,
        ty: 3,
        parent: 1793,
        ks: {
          p: {
            a: 0,
            k: [
              8.644,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1811,
        ty: 4,
        parent: 1810,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0.3
                  ],
                  [
                    0.5,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    -0.2
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0.8,
                    0
                  ]
                ],
                v: [
                  [
                    4.3,
                    19.9
                  ],
                  [
                    4.3,
                    19.9
                  ],
                  [
                    2.3,
                    19.5
                  ],
                  [
                    0.6,
                    18.4
                  ],
                  [
                    0.6,
                    18.4
                  ],
                  [
                    1.7,
                    17.2
                  ],
                  [
                    3,
                    18
                  ],
                  [
                    4.4,
                    18.3
                  ],
                  [
                    4.4,
                    18.3
                  ],
                  [
                    5.7,
                    18
                  ],
                  [
                    6.2,
                    17
                  ],
                  [
                    6.2,
                    17
                  ],
                  [
                    5.7,
                    16.1
                  ],
                  [
                    4.6,
                    15.5
                  ],
                  [
                    4.6,
                    15.5
                  ],
                  [
                    3.2,
                    14.9
                  ],
                  [
                    2.2,
                    14.3
                  ],
                  [
                    1.4,
                    13.4
                  ],
                  [
                    1.1,
                    12.1
                  ],
                  [
                    1.1,
                    12.1
                  ],
                  [
                    1.5,
                    10.6
                  ],
                  [
                    2.8,
                    9.6
                  ],
                  [
                    4.6,
                    9.2
                  ],
                  [
                    4.6,
                    9.2
                  ],
                  [
                    6.3,
                    9.5
                  ],
                  [
                    7.7,
                    10.5
                  ],
                  [
                    7.7,
                    10.5
                  ],
                  [
                    6.8,
                    11.7
                  ],
                  [
                    5.8,
                    11
                  ],
                  [
                    4.6,
                    10.8
                  ],
                  [
                    4.6,
                    10.8
                  ],
                  [
                    3.4,
                    11.1
                  ],
                  [
                    2.9,
                    12
                  ],
                  [
                    2.9,
                    12
                  ],
                  [
                    3.2,
                    12.7
                  ],
                  [
                    3.8,
                    13.1
                  ],
                  [
                    4.6,
                    13.5
                  ],
                  [
                    4.6,
                    13.5
                  ],
                  [
                    6,
                    14.1
                  ],
                  [
                    7.5,
                    15.1
                  ],
                  [
                    8.1,
                    16.9
                  ],
                  [
                    8.1,
                    16.9
                  ],
                  [
                    7.6,
                    18.4
                  ],
                  [
                    6.4,
                    19.5
                  ],
                  [
                    4.3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.7,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.6,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0.3
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1810,
        ty: 3,
        parent: 1793,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1793,
        ty: 3,
        parent: 1783,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1783,
        ty: 3,
        parent: 1782,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.394
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1782,
        ty: 3,
        parent: 1781,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1781,
        ty: 3,
        parent: 1703,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1703,
        ty: 3,
        parent: 1702,
        ks: {
          p: {
            a: 0,
            k: [
              91.69,
              3.002
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1822,
        ty: 0,
        parent: 1813,
        ks: {
          a: {
            a: 0,
            k: [
              54.666,
              55.544
            ]
          },
          p: {
            a: 0,
            k: [
              54.666,
              55.544
            ]
          }
        },
        w: 21.159,
        h: 21.159,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1820"
      },
      {
        ind: 1813,
        ty: 3,
        parent: 1812,
        ks: {
          p: {
            a: 0,
            k: [
              54.666,
              55.544
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1825,
        ty: 4,
        td: 1,
        parent: 1823,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                38.792,
                38.792
              ]
            },
            r: {
              a: 0,
              k: 60
            },
            s: {
              a: 0,
              k: [
                77.584,
                77.584
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1824,
        ty: 4,
        tt: 1,
        parent: 1823,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                p: {
                  a: 0,
                  k: [
                    38.792,
                    38.792
                  ]
                },
                r: {
                  a: 0,
                  k: 0
                },
                s: {
                  a: 0,
                  k: [
                    81.992,
                    81.992
                  ]
                }
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0,
                    0,
                    0,
                    0
                  ]
                },
                o: {
                  a: 0,
                  k: 0
                }
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          },
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                p: {
                  a: 0,
                  k: [
                    38.792,
                    38.792
                  ]
                },
                r: {
                  a: 0,
                  k: 60
                },
                s: {
                  a: 0,
                  k: [
                    77.584,
                    77.584
                  ]
                }
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.427,
                    0.184,
                    0.604
                  ]
                },
                lj: 1,
                ml: 10,
                o: {
                  a: 0,
                  k: 100
                },
                w: {
                  a: 0,
                  k: 4.408
                }
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      },
      {
        ind: 1841,
        ty: 4,
        td: 1,
        parent: 1823,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                38.792,
                38.792
              ]
            },
            r: {
              a: 0,
              k: 60
            },
            s: {
              a: 0,
              k: [
                77.584,
                77.584
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1840,
        ty: 0,
        tt: 1,
        parent: 1823,
        ks: {},
        w: 71,
        h: 71,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1838"
      },
      {
        ind: 1823,
        ty: 3,
        parent: 1812,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1812,
        ty: 3,
        parent: 1702,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1702,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              10.58,
              6.09
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1842,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                148.115,
                90.858
              ]
            },
            r: {
              a: 0,
              k: 7
            },
            s: {
              a: 0,
              k: [
                296.23,
                181.715
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                1,
                1
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      }
    ]
  },
  {
    id: "1847",
    layers: [
      {
        ind: 1845,
        ty: 0,
        ks: {
          p: {
            a: 0,
            k: [
              142.629,
              142.629
            ]
          }
        },
        w: 297,
        h: 182,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1843"
      },
      {
        ind: 1846,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                290.745,
                233.487
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                581.489,
                466.974
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      }
    ]
  },
  {
    id: "1914",
    layers: [
      {
        ind: 1913,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                7,
                4.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                14,
                9
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            -0.09
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            -0.02
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.06,
                            0.03
                          ],
                          [
                            0.05,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            0.02
                          ],
                          [
                            -0.07,
                            0
                          ],
                          [
                            -0.06,
                            -0.03
                          ],
                          [
                            -0.05,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.13
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.04
                          ],
                          [
                            -0.06,
                            0.03
                          ],
                          [
                            -0.06,
                            0
                          ],
                          [
                            -0.06,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.05
                          ],
                          [
                            0.06,
                            -0.03
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.06,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            0.09,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            10.09,
                            0.81
                          ],
                          [
                            10.09,
                            3.46
                          ],
                          [
                            9.94,
                            3.81
                          ],
                          [
                            9.59,
                            3.95
                          ],
                          [
                            9.24,
                            3.81
                          ],
                          [
                            9.09,
                            3.46
                          ],
                          [
                            9.09,
                            2.01
                          ],
                          [
                            5.97,
                            5.13
                          ],
                          [
                            5.81,
                            5.24
                          ],
                          [
                            5.62,
                            5.28
                          ],
                          [
                            5.43,
                            5.24
                          ],
                          [
                            5.27,
                            5.13
                          ],
                          [
                            3.97,
                            3.83
                          ],
                          [
                            1.34,
                            6.45
                          ],
                          [
                            0.99,
                            6.6
                          ],
                          [
                            0.64,
                            6.45
                          ],
                          [
                            0.5,
                            6.1
                          ],
                          [
                            0.64,
                            5.75
                          ],
                          [
                            3.62,
                            2.77
                          ],
                          [
                            3.78,
                            2.67
                          ],
                          [
                            3.97,
                            2.63
                          ],
                          [
                            4.16,
                            2.67
                          ],
                          [
                            4.32,
                            2.77
                          ],
                          [
                            5.62,
                            4.08
                          ],
                          [
                            8.39,
                            1.31
                          ],
                          [
                            6.95,
                            1.31
                          ],
                          [
                            6.59,
                            1.16
                          ],
                          [
                            6.45,
                            0.81
                          ],
                          [
                            6.59,
                            0.46
                          ],
                          [
                            6.95,
                            0.32
                          ],
                          [
                            9.59,
                            0.32
                          ],
                          [
                            9.94,
                            0.46
                          ],
                          [
                            10.09,
                            0.81
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.52,
                        0.32,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1917",
    layers: [
      {
        ind: 1916,
        ty: 0,
        parent: 1912,
        ks: {},
        w: 14,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1914"
      },
      {
        ind: 1912,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              2
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1925",
    layers: [
      {
        ind: 1924,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3.5,
                3.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                7,
                7
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.59,
                            0.58
                          ],
                          [
                            5.19,
                            0.58
                          ],
                          [
                            5.19,
                            5.18
                          ],
                          [
                            0.59,
                            5.18
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        1,
                        0.73,
                        0,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1930",
    layers: [
      {
        ind: 1929,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3.5,
                3.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                7,
                7
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                0,
                                0.58
                              ],
                              [
                                4.61,
                                0.58
                              ],
                              [
                                4.61,
                                5.18
                              ],
                              [
                                0,
                                5.18
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0,
                            0.64,
                            0.94,
                            1
                          ]
                        },
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1935",
    layers: [
      {
        ind: 1934,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3.5,
                3.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                7,
                7
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                0.59,
                                0
                              ],
                              [
                                5.19,
                                0
                              ],
                              [
                                5.19,
                                4.6
                              ],
                              [
                                0.59,
                                4.6
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0.5,
                            0.73,
                            0,
                            1
                          ]
                        },
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1940",
    layers: [
      {
        ind: 1939,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3.5,
                3.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                7,
                7
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0,
                            0
                          ],
                          [
                            4.61,
                            0
                          ],
                          [
                            4.61,
                            4.6
                          ],
                          [
                            0,
                            4.6
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.95,
                        0.31,
                        0.13,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1945",
    layers: [
      {
        ind: 1944,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                22.5,
                4.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                45,
                9
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.14,
                            0.32
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            0.32
                          ],
                          [
                            0.01,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            -0.23
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.23
                          ],
                          [
                            -0.01,
                            -0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            0.23
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            0.43
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            4.01,
                            4.07
                          ],
                          [
                            3.74,
                            4.84
                          ],
                          [
                            3.71,
                            4.84
                          ],
                          [
                            3.45,
                            4.09
                          ],
                          [
                            2,
                            0.45
                          ],
                          [
                            0.58,
                            0.45
                          ],
                          [
                            0.58,
                            6.25
                          ],
                          [
                            1.52,
                            6.25
                          ],
                          [
                            1.52,
                            2.67
                          ],
                          [
                            1.52,
                            1.88
                          ],
                          [
                            1.48,
                            1.51
                          ],
                          [
                            1.51,
                            1.51
                          ],
                          [
                            1.64,
                            2
                          ],
                          [
                            3.38,
                            6.24
                          ],
                          [
                            4.04,
                            6.24
                          ],
                          [
                            5.77,
                            1.96
                          ],
                          [
                            5.88,
                            1.51
                          ],
                          [
                            5.91,
                            1.51
                          ],
                          [
                            5.86,
                            2.55
                          ],
                          [
                            5.86,
                            6.23
                          ],
                          [
                            6.86,
                            6.23
                          ],
                          [
                            6.86,
                            0.43
                          ],
                          [
                            5.49,
                            0.43
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.8,
                            2.07
                          ],
                          [
                            8.78,
                            2.07
                          ],
                          [
                            8.78,
                            6.23
                          ],
                          [
                            7.8,
                            6.23
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            -0.11
                          ],
                          [
                            0,
                            -0.17
                          ],
                          [
                            -0.11,
                            -0.11
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            -0.11,
                            0.1
                          ],
                          [
                            0,
                            0.16
                          ],
                          [
                            0.11,
                            0.11
                          ],
                          [
                            0.17,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.16,
                            0
                          ],
                          [
                            -0.11,
                            0.11
                          ],
                          [
                            0,
                            0.16
                          ],
                          [
                            0.11,
                            0.1
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.11,
                            -0.11
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            -0.1,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            8.3,
                            0.32
                          ],
                          [
                            7.89,
                            0.48
                          ],
                          [
                            7.71,
                            0.89
                          ],
                          [
                            7.89,
                            1.29
                          ],
                          [
                            8.3,
                            1.44
                          ],
                          [
                            8.71,
                            1.29
                          ],
                          [
                            8.89,
                            0.89
                          ],
                          [
                            8.71,
                            0.48
                          ],
                          [
                            8.3,
                            0.32
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0.34,
                            -0.2
                          ],
                          [
                            0.17,
                            -0.34
                          ],
                          [
                            0,
                            -0.46
                          ],
                          [
                            -0.17,
                            -0.32
                          ],
                          [
                            -0.32,
                            -0.18
                          ],
                          [
                            -0.41,
                            0
                          ],
                          [
                            -0.31,
                            0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.05
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0.22,
                            0.25
                          ],
                          [
                            0,
                            0.41
                          ],
                          [
                            -0.23,
                            0.25
                          ],
                          [
                            -0.37,
                            0
                          ],
                          [
                            -0.29,
                            -0.21
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.04
                          ]
                        ],
                        o: [
                          [
                            -0.18,
                            -0.04
                          ],
                          [
                            -0.45,
                            0
                          ],
                          [
                            -0.34,
                            0.2
                          ],
                          [
                            -0.18,
                            0.34
                          ],
                          [
                            0,
                            0.4
                          ],
                          [
                            0.18,
                            0.32
                          ],
                          [
                            0.3,
                            0.17
                          ],
                          [
                            0.46,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            0.11
                          ],
                          [
                            -0.18,
                            0.06
                          ],
                          [
                            -0.39,
                            0
                          ],
                          [
                            -0.23,
                            -0.24
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0.23,
                            -0.25
                          ],
                          [
                            0.32,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.12,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            12.24,
                            2.04
                          ],
                          [
                            11.7,
                            1.97
                          ],
                          [
                            10.51,
                            2.27
                          ],
                          [
                            9.73,
                            3.07
                          ],
                          [
                            9.46,
                            4.27
                          ],
                          [
                            9.72,
                            5.34
                          ],
                          [
                            10.46,
                            6.09
                          ],
                          [
                            11.53,
                            6.35
                          ],
                          [
                            12.71,
                            6.07
                          ],
                          [
                            12.71,
                            6.07
                          ],
                          [
                            12.71,
                            5.16
                          ],
                          [
                            12.68,
                            5.2
                          ],
                          [
                            12.21,
                            5.44
                          ],
                          [
                            11.74,
                            5.53
                          ],
                          [
                            10.82,
                            5.17
                          ],
                          [
                            10.48,
                            4.19
                          ],
                          [
                            10.83,
                            3.18
                          ],
                          [
                            11.75,
                            2.8
                          ],
                          [
                            12.68,
                            3.11
                          ],
                          [
                            12.71,
                            3.14
                          ],
                          [
                            12.71,
                            2.19
                          ],
                          [
                            12.71,
                            2.18
                          ],
                          [
                            12.24,
                            2.04
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.16
                          ],
                          [
                            0.1,
                            -0.23
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.22
                          ],
                          [
                            -0.25,
                            0
                          ],
                          [
                            -0.11,
                            -0.01
                          ],
                          [
                            -0.05,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.17,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.36
                          ],
                          [
                            0.16,
                            -0.22
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.11,
                            0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            15.46,
                            2
                          ],
                          [
                            14.8,
                            2.24
                          ],
                          [
                            14.43,
                            2.8
                          ],
                          [
                            14.42,
                            2.8
                          ],
                          [
                            14.42,
                            2.07
                          ],
                          [
                            13.45,
                            2.07
                          ],
                          [
                            13.45,
                            6.23
                          ],
                          [
                            14.42,
                            6.23
                          ],
                          [
                            14.42,
                            4.11
                          ],
                          [
                            14.66,
                            3.23
                          ],
                          [
                            15.29,
                            2.89
                          ],
                          [
                            15.58,
                            2.93
                          ],
                          [
                            15.82,
                            3.02
                          ],
                          [
                            15.86,
                            3.05
                          ],
                          [
                            15.86,
                            2.08
                          ],
                          [
                            15.83,
                            2.07
                          ],
                          [
                            15.46,
                            2
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.38,
                            -0.4
                          ],
                          [
                            0,
                            -0.69
                          ],
                          [
                            -0.37,
                            -0.38
                          ],
                          [
                            -0.64,
                            0
                          ],
                          [
                            -0.38,
                            0.41
                          ],
                          [
                            0,
                            0.67
                          ],
                          [
                            0.37,
                            0.38
                          ],
                          [
                            0.64,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.68,
                            0
                          ],
                          [
                            -0.39,
                            0.4
                          ],
                          [
                            0,
                            0.64
                          ],
                          [
                            0.38,
                            0.38
                          ],
                          [
                            0.67,
                            0
                          ],
                          [
                            0.39,
                            -0.41
                          ],
                          [
                            0,
                            -0.66
                          ],
                          [
                            -0.35,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            18.12,
                            1.98
                          ],
                          [
                            16.51,
                            2.58
                          ],
                          [
                            15.93,
                            4.22
                          ],
                          [
                            16.5,
                            5.77
                          ],
                          [
                            18.02,
                            6.34
                          ],
                          [
                            19.61,
                            5.73
                          ],
                          [
                            20.19,
                            4.12
                          ],
                          [
                            19.64,
                            2.55
                          ],
                          [
                            18.12,
                            1.98
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.36,
                            0
                          ],
                          [
                            0.2,
                            0.25
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            -0.2,
                            0.24
                          ],
                          [
                            -0.35,
                            0
                          ],
                          [
                            -0.2,
                            -0.23
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            0.19,
                            -0.23
                          ]
                        ],
                        o: [
                          [
                            -0.18,
                            0.23
                          ],
                          [
                            -0.35,
                            0
                          ],
                          [
                            -0.2,
                            -0.23
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            0.2,
                            -0.24
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.2,
                            0.23
                          ],
                          [
                            -0.02,
                            0.45
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            18.9,
                            5.18
                          ],
                          [
                            18.08,
                            5.52
                          ],
                          [
                            17.24,
                            5.16
                          ],
                          [
                            16.94,
                            4.17
                          ],
                          [
                            17.24,
                            3.14
                          ],
                          [
                            18.07,
                            2.79
                          ],
                          [
                            18.89,
                            3.13
                          ],
                          [
                            19.19,
                            4.14
                          ],
                          [
                            18.9,
                            5.18
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0.08
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.11,
                            0.07
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.16,
                            -0.04
                          ],
                          [
                            -0.12,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.04
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.3,
                            -0.25
                          ],
                          [
                            0,
                            -0.37
                          ],
                          [
                            -0.07,
                            -0.14
                          ],
                          [
                            -0.13,
                            -0.11
                          ],
                          [
                            -0.27,
                            -0.11
                          ],
                          [
                            -0.11,
                            -0.06
                          ],
                          [
                            -0.05,
                            -0.05
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0.43,
                            0
                          ],
                          [
                            0.2,
                            0.07
                          ],
                          [
                            0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            -0.05
                          ],
                          [
                            -0.17,
                            0
                          ],
                          [
                            -0.29,
                            0.25
                          ],
                          [
                            0,
                            0.39
                          ],
                          [
                            0.16,
                            0.19
                          ],
                          [
                            0.39,
                            0.15
                          ]
                        ],
                        o: [
                          [
                            -0.31,
                            -0.12
                          ],
                          [
                            -0.07,
                            -0.08
                          ],
                          [
                            0,
                            -0.11
                          ],
                          [
                            0.11,
                            -0.07
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.16,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.11,
                            -0.05
                          ],
                          [
                            -0.18,
                            -0.03
                          ],
                          [
                            -0.46,
                            0
                          ],
                          [
                            -0.3,
                            0.23
                          ],
                          [
                            0,
                            0.2
                          ],
                          [
                            0.07,
                            0.14
                          ],
                          [
                            0.14,
                            0.11
                          ],
                          [
                            0.23,
                            0.1
                          ],
                          [
                            0.11,
                            0.06
                          ],
                          [
                            0.04,
                            0.06
                          ],
                          [
                            0,
                            0.28
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            -0.2,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.14,
                            0.07
                          ],
                          [
                            0.21,
                            0.04
                          ],
                          [
                            0.5,
                            0
                          ],
                          [
                            0.3,
                            -0.24
                          ],
                          [
                            0,
                            -0.28
                          ],
                          [
                            -0.22,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            22.36,
                            3.8
                          ],
                          [
                            21.77,
                            3.49
                          ],
                          [
                            21.66,
                            3.18
                          ],
                          [
                            21.82,
                            2.88
                          ],
                          [
                            22.24,
                            2.76
                          ],
                          [
                            22.75,
                            2.84
                          ],
                          [
                            23.18,
                            3.04
                          ],
                          [
                            23.22,
                            3.07
                          ],
                          [
                            23.22,
                            2.15
                          ],
                          [
                            23.2,
                            2.15
                          ],
                          [
                            22.75,
                            2.02
                          ],
                          [
                            22.27,
                            1.97
                          ],
                          [
                            21.13,
                            2.34
                          ],
                          [
                            20.68,
                            3.25
                          ],
                          [
                            20.78,
                            3.76
                          ],
                          [
                            21.08,
                            4.15
                          ],
                          [
                            21.68,
                            4.49
                          ],
                          [
                            22.18,
                            4.72
                          ],
                          [
                            22.41,
                            4.9
                          ],
                          [
                            22.47,
                            5.13
                          ],
                          [
                            21.83,
                            5.55
                          ],
                          [
                            21.29,
                            5.45
                          ],
                          [
                            20.74,
                            5.17
                          ],
                          [
                            20.7,
                            5.14
                          ],
                          [
                            20.7,
                            6.1
                          ],
                          [
                            20.73,
                            6.1
                          ],
                          [
                            21.25,
                            6.27
                          ],
                          [
                            21.82,
                            6.34
                          ],
                          [
                            23.02,
                            5.98
                          ],
                          [
                            23.48,
                            5.03
                          ],
                          [
                            23.24,
                            4.32
                          ],
                          [
                            22.36,
                            3.8
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.38,
                            -0.4
                          ],
                          [
                            0,
                            -0.69
                          ],
                          [
                            -0.37,
                            -0.38
                          ],
                          [
                            -0.64,
                            0
                          ],
                          [
                            -0.38,
                            0.41
                          ],
                          [
                            0,
                            0.67
                          ],
                          [
                            0.37,
                            0.38
                          ],
                          [
                            0.64,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.68,
                            0
                          ],
                          [
                            -0.38,
                            0.4
                          ],
                          [
                            0,
                            0.64
                          ],
                          [
                            0.38,
                            0.38
                          ],
                          [
                            0.67,
                            0
                          ],
                          [
                            0.39,
                            -0.41
                          ],
                          [
                            0,
                            -0.66
                          ],
                          [
                            -0.36,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            26.06,
                            1.98
                          ],
                          [
                            24.44,
                            2.58
                          ],
                          [
                            23.86,
                            4.22
                          ],
                          [
                            24.43,
                            5.77
                          ],
                          [
                            25.96,
                            6.34
                          ],
                          [
                            27.54,
                            5.73
                          ],
                          [
                            28.12,
                            4.12
                          ],
                          [
                            27.57,
                            2.55
                          ],
                          [
                            26.06,
                            1.98
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.2,
                            0.25
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            -0.2,
                            0.24
                          ],
                          [
                            -0.35,
                            0
                          ],
                          [
                            -0.2,
                            -0.23
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            0.19,
                            -0.23
                          ]
                        ],
                        o: [
                          [
                            -0.18,
                            0.23
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.2,
                            -0.23
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            0.2,
                            -0.24
                          ],
                          [
                            0.34,
                            0
                          ],
                          [
                            0.2,
                            0.23
                          ],
                          [
                            0,
                            0.45
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            26.83,
                            5.18
                          ],
                          [
                            26.01,
                            5.52
                          ],
                          [
                            25.17,
                            5.16
                          ],
                          [
                            24.87,
                            4.17
                          ],
                          [
                            25.17,
                            3.14
                          ],
                          [
                            26,
                            2.79
                          ],
                          [
                            26.82,
                            3.13
                          ],
                          [
                            27.12,
                            4.14
                          ],
                          [
                            26.83,
                            5.18
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.11,
                            0.12
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.16,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0
                          ],
                          [
                            0.23,
                            -0.11
                          ],
                          [
                            0.13,
                            -0.23
                          ],
                          [
                            0,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.82,
                            0
                          ],
                          [
                            -0.13,
                            0.02
                          ],
                          [
                            -0.06,
                            0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            -0.02
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0.1,
                            0.11
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.24
                          ],
                          [
                            0.11,
                            -0.12
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            -0.05
                          ],
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.23,
                            0.13
                          ],
                          [
                            -0.13,
                            0.23
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.88
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0.14,
                            -0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            0.04
                          ],
                          [
                            -0.07,
                            0.02
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.09,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            33.34,
                            2.88
                          ],
                          [
                            33.34,
                            2.07
                          ],
                          [
                            32.36,
                            2.07
                          ],
                          [
                            32.36,
                            0.84
                          ],
                          [
                            32.32,
                            0.85
                          ],
                          [
                            31.39,
                            1.13
                          ],
                          [
                            31.37,
                            1.13
                          ],
                          [
                            31.37,
                            2.07
                          ],
                          [
                            29.9,
                            2.07
                          ],
                          [
                            29.9,
                            1.55
                          ],
                          [
                            30.07,
                            1
                          ],
                          [
                            30.52,
                            0.82
                          ],
                          [
                            30.96,
                            0.91
                          ],
                          [
                            31,
                            0.94
                          ],
                          [
                            31,
                            0.09
                          ],
                          [
                            30.97,
                            0.08
                          ],
                          [
                            30.43,
                            0.01
                          ],
                          [
                            29.64,
                            0.19
                          ],
                          [
                            29.11,
                            0.72
                          ],
                          [
                            28.92,
                            1.49
                          ],
                          [
                            28.92,
                            2.07
                          ],
                          [
                            28.23,
                            2.07
                          ],
                          [
                            28.23,
                            2.87
                          ],
                          [
                            28.92,
                            2.87
                          ],
                          [
                            28.92,
                            6.23
                          ],
                          [
                            29.9,
                            6.23
                          ],
                          [
                            29.9,
                            2.88
                          ],
                          [
                            31.37,
                            2.88
                          ],
                          [
                            31.37,
                            5.02
                          ],
                          [
                            32.61,
                            6.34
                          ],
                          [
                            33.02,
                            6.29
                          ],
                          [
                            33.33,
                            6.19
                          ],
                          [
                            33.34,
                            6.19
                          ],
                          [
                            33.34,
                            5.38
                          ],
                          [
                            33.3,
                            5.41
                          ],
                          [
                            33.1,
                            5.5
                          ],
                          [
                            32.9,
                            5.53
                          ],
                          [
                            32.48,
                            5.38
                          ],
                          [
                            32.34,
                            4.84
                          ],
                          [
                            32.34,
                            2.88
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.45,
                        0.45,
                        0.45,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1948",
    layers: [
      {
        ind: 1927,
        ty: 0,
        parent: 1923,
        ks: {},
        w: 7,
        h: 7,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1925"
      },
      {
        ind: 1923,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              6,
              6
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1932,
        ty: 0,
        parent: 1928,
        ks: {},
        w: 7,
        h: 7,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1930"
      },
      {
        ind: 1928,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              6
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1937,
        ty: 0,
        parent: 1933,
        ks: {},
        w: 7,
        h: 7,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1935"
      },
      {
        ind: 1933,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              6,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1942,
        ty: 0,
        parent: 1938,
        ks: {},
        w: 7,
        h: 7,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1940"
      },
      {
        ind: 1938,
        ty: 3,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1947,
        ty: 0,
        parent: 1943,
        ks: {},
        w: 45,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1945"
      },
      {
        ind: 1943,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              16,
              2
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1978",
    layers: [
      {
        ind: 1977,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                13.5,
                6.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                27,
                13
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.12,
                                0
                              ],
                              [
                                0.09,
                                0.09
                              ],
                              [
                                0,
                                0.12
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.09,
                                0.09
                              ],
                              [
                                0,
                                0.12
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.12
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.02,
                                -0.06
                              ],
                              [
                                0,
                                -0.06
                              ],
                              [
                                0.02,
                                -0.05
                              ],
                              [
                                0.04,
                                -0.04
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                -0.09,
                                0.09
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                -0.12
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                -0.12
                              ],
                              [
                                0.09,
                                -0.09
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.09,
                                -0.09
                              ],
                              [
                                0,
                                -0.12
                              ],
                              [
                                0.09,
                                -0.09
                              ],
                              [
                                0.12,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.04,
                                0.04
                              ],
                              [
                                0.02,
                                0.05
                              ],
                              [
                                0,
                                0.06
                              ],
                              [
                                -0.02,
                                0.06
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                19.51,
                                4.9
                              ],
                              [
                                15.39,
                                9.03
                              ],
                              [
                                15.07,
                                9.16
                              ],
                              [
                                14.74,
                                9.03
                              ],
                              [
                                14.61,
                                8.7
                              ],
                              [
                                14.74,
                                8.38
                              ],
                              [
                                18.09,
                                5.04
                              ],
                              [
                                0.46,
                                5.04
                              ],
                              [
                                0.13,
                                4.9
                              ],
                              [
                                0,
                                4.58
                              ],
                              [
                                0.13,
                                4.26
                              ],
                              [
                                0.46,
                                4.12
                              ],
                              [
                                18.09,
                                4.12
                              ],
                              [
                                14.74,
                                0.78
                              ],
                              [
                                14.61,
                                0.46
                              ],
                              [
                                14.74,
                                0.13
                              ],
                              [
                                15.07,
                                0
                              ],
                              [
                                15.39,
                                0.13
                              ],
                              [
                                19.51,
                                4.26
                              ],
                              [
                                19.61,
                                4.41
                              ],
                              [
                                19.65,
                                4.58
                              ],
                              [
                                19.61,
                                4.75
                              ],
                              [
                                19.51,
                                4.9
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0.57,
                            0.63,
                            0.72,
                            1
                          ]
                        },
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1999",
    layers: [
      {
        ind: 1998,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                40.5,
                7.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                81,
                15
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.34,
                            -0.11
                          ],
                          [
                            -0.19,
                            -0.27
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            0.41,
                            -0.31
                          ],
                          [
                            0.67,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.46,
                            0
                          ],
                          [
                            0.34,
                            0.11
                          ],
                          [
                            0.19,
                            0.26
                          ],
                          [
                            0,
                            0.63
                          ],
                          [
                            -0.41,
                            0.31
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.83,
                            9
                          ],
                          [
                            0.83,
                            2.93
                          ],
                          [
                            2.56,
                            2.93
                          ],
                          [
                            3.76,
                            3.09
                          ],
                          [
                            4.55,
                            3.66
                          ],
                          [
                            4.84,
                            4.71
                          ],
                          [
                            4.22,
                            6.13
                          ],
                          [
                            2.6,
                            6.59
                          ],
                          [
                            1.6,
                            6.59
                          ],
                          [
                            1.6,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.25,
                            0.2
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            0.27,
                            0.16
                          ],
                          [
                            0.53,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0.53,
                            0
                          ],
                          [
                            0.26,
                            -0.2
                          ],
                          [
                            0,
                            -0.44
                          ],
                          [
                            -0.26,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.6,
                            5.96
                          ],
                          [
                            2.51,
                            5.96
                          ],
                          [
                            3.68,
                            5.67
                          ],
                          [
                            4.07,
                            4.71
                          ],
                          [
                            3.66,
                            3.81
                          ],
                          [
                            2.47,
                            3.55
                          ],
                          [
                            1.6,
                            3.55
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.16
                          ],
                          [
                            -0.25,
                            0
                          ],
                          [
                            -0.14,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0.01
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.15,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.29
                          ],
                          [
                            0.22,
                            -0.17
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.06,
                            -0.01
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            6,
                            9
                          ],
                          [
                            6,
                            4.5
                          ],
                          [
                            6.63,
                            4.5
                          ],
                          [
                            6.7,
                            5.32
                          ],
                          [
                            6.72,
                            5.32
                          ],
                          [
                            7.29,
                            4.64
                          ],
                          [
                            8,
                            4.39
                          ],
                          [
                            8.48,
                            4.48
                          ],
                          [
                            8.34,
                            5.15
                          ],
                          [
                            8.13,
                            5.09
                          ],
                          [
                            7.9,
                            5.07
                          ],
                          [
                            7.3,
                            5.3
                          ],
                          [
                            6.76,
                            6.11
                          ],
                          [
                            6.76,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.33,
                            0.19
                          ],
                          [
                            0.19,
                            0.35
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.19,
                            0.35
                          ],
                          [
                            -0.31,
                            0.19
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.31,
                            -0.38
                          ],
                          [
                            0,
                            -0.64
                          ],
                          [
                            0,
                            -0.08
                          ],
                          [
                            0.01,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.26,
                            -0.29
                          ],
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.18,
                            0.06
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.09
                          ],
                          [
                            0.31,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.4,
                            0
                          ],
                          [
                            -0.32,
                            -0.19
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.31,
                            -0.19
                          ],
                          [
                            0.57,
                            0
                          ],
                          [
                            0.32,
                            0.38
                          ],
                          [
                            0,
                            0.08
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.47
                          ],
                          [
                            0.27,
                            0.29
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.13
                          ],
                          [
                            -0.24,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            10.95,
                            9.11
                          ],
                          [
                            9.85,
                            8.83
                          ],
                          [
                            9.07,
                            8.02
                          ],
                          [
                            8.79,
                            6.76
                          ],
                          [
                            9.07,
                            5.49
                          ],
                          [
                            9.84,
                            4.68
                          ],
                          [
                            10.8,
                            4.39
                          ],
                          [
                            12.13,
                            4.96
                          ],
                          [
                            12.6,
                            6.5
                          ],
                          [
                            12.59,
                            6.74
                          ],
                          [
                            12.57,
                            6.94
                          ],
                          [
                            9.54,
                            6.94
                          ],
                          [
                            9.98,
                            8.07
                          ],
                          [
                            11.04,
                            8.5
                          ],
                          [
                            11.63,
                            8.41
                          ],
                          [
                            12.16,
                            8.15
                          ],
                          [
                            12.43,
                            8.65
                          ],
                          [
                            11.77,
                            8.97
                          ],
                          [
                            10.95,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.23
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.25,
                            -0.25
                          ],
                          [
                            0.05,
                            -0.45
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.46
                          ],
                          [
                            -0.19,
                            -0.24
                          ],
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            0.24
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.53,
                            6.39
                          ],
                          [
                            11.93,
                            6.39
                          ],
                          [
                            11.64,
                            5.35
                          ],
                          [
                            10.82,
                            4.99
                          ],
                          [
                            9.97,
                            5.36
                          ],
                          [
                            9.53,
                            6.39
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.36,
                            0.16
                          ],
                          [
                            0.27,
                            0.27
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.29,
                            -0.14
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.22,
                            0.18
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            0.09,
                            0.12
                          ],
                          [
                            0.16,
                            0.09
                          ],
                          [
                            0.19,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            0.13
                          ],
                          [
                            0.13,
                            0.2
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            -0.16,
                            0.24
                          ],
                          [
                            -0.29,
                            0.14
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.31,
                            -0.14
                          ],
                          [
                            -0.21,
                            -0.22
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0.1
                          ],
                          [
                            0.29,
                            0
                          ],
                          [
                            0.21,
                            -0.16
                          ],
                          [
                            0,
                            -0.27
                          ],
                          [
                            -0.1,
                            -0.13
                          ],
                          [
                            -0.16,
                            -0.08
                          ],
                          [
                            -0.16,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            -0.14
                          ],
                          [
                            -0.11,
                            -0.2
                          ],
                          [
                            0,
                            -0.3
                          ],
                          [
                            0.17,
                            -0.27
                          ],
                          [
                            0.31,
                            -0.15
                          ],
                          [
                            0.43,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.36,
                            -0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            0.23
                          ],
                          [
                            0.3,
                            0.14
                          ],
                          [
                            0.4,
                            0
                          ],
                          [
                            0.22,
                            -0.19
                          ],
                          [
                            0,
                            -0.21
                          ],
                          [
                            -0.09,
                            -0.12
                          ],
                          [
                            -0.14,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            -0.08
                          ],
                          [
                            -0.18,
                            -0.13
                          ],
                          [
                            -0.12,
                            -0.2
                          ],
                          [
                            0,
                            -0.31
                          ],
                          [
                            0.16,
                            -0.25
                          ],
                          [
                            0.29,
                            -0.14
                          ],
                          [
                            0.37,
                            0
                          ],
                          [
                            0.31,
                            0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            -0.18
                          ],
                          [
                            -0.22,
                            -0.11
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0.19
                          ],
                          [
                            0.11,
                            0.12
                          ],
                          [
                            0.15,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            0.1
                          ],
                          [
                            0.19,
                            0.14
                          ],
                          [
                            0.11,
                            0.2
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            -0.17,
                            0.26
                          ],
                          [
                            -0.31,
                            0.16
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.32,
                            9.11
                          ],
                          [
                            16.14,
                            8.87
                          ],
                          [
                            15.2,
                            8.21
                          ],
                          [
                            15.66,
                            7.68
                          ],
                          [
                            16.42,
                            8.23
                          ],
                          [
                            17.34,
                            8.43
                          ],
                          [
                            18.27,
                            8.17
                          ],
                          [
                            18.6,
                            7.45
                          ],
                          [
                            18.46,
                            6.95
                          ],
                          [
                            18.1,
                            6.63
                          ],
                          [
                            17.59,
                            6.37
                          ],
                          [
                            16.72,
                            5.99
                          ],
                          [
                            16.15,
                            5.68
                          ],
                          [
                            15.68,
                            5.18
                          ],
                          [
                            15.49,
                            4.43
                          ],
                          [
                            15.73,
                            3.6
                          ],
                          [
                            16.42,
                            3.03
                          ],
                          [
                            17.4,
                            2.82
                          ],
                          [
                            18.41,
                            3.03
                          ],
                          [
                            19.2,
                            3.57
                          ],
                          [
                            18.78,
                            4.07
                          ],
                          [
                            18.16,
                            3.65
                          ],
                          [
                            17.4,
                            3.49
                          ],
                          [
                            16.57,
                            3.73
                          ],
                          [
                            16.27,
                            4.38
                          ],
                          [
                            16.42,
                            4.86
                          ],
                          [
                            16.81,
                            5.17
                          ],
                          [
                            17.28,
                            5.39
                          ],
                          [
                            18.14,
                            5.76
                          ],
                          [
                            18.77,
                            6.12
                          ],
                          [
                            19.22,
                            6.63
                          ],
                          [
                            19.39,
                            7.38
                          ],
                          [
                            19.14,
                            8.26
                          ],
                          [
                            18.43,
                            8.88
                          ],
                          [
                            17.32,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.32,
                            0.19
                          ],
                          [
                            0.18,
                            0.35
                          ],
                          [
                            0,
                            0.5
                          ],
                          [
                            -0.2,
                            0.35
                          ],
                          [
                            -0.32,
                            0.18
                          ],
                          [
                            -0.38,
                            0
                          ],
                          [
                            -0.21,
                            -0.11
                          ],
                          [
                            -0.16,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.07
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.13,
                            -0.27
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            -0.25,
                            -0.32
                          ],
                          [
                            -0.41,
                            0
                          ],
                          [
                            -0.18,
                            0.09
                          ],
                          [
                            -0.14,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.11
                          ],
                          [
                            0.27,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.39,
                            0
                          ],
                          [
                            -0.32,
                            -0.18
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.5
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.34,
                            -0.18
                          ],
                          [
                            0.3,
                            0
                          ],
                          [
                            0.21,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            -0.12
                          ],
                          [
                            -0.14,
                            -0.07
                          ],
                          [
                            -0.27,
                            0
                          ],
                          [
                            -0.21,
                            0.14
                          ],
                          [
                            -0.12,
                            0.26
                          ],
                          [
                            0,
                            0.52
                          ],
                          [
                            0.26,
                            0.32
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0.18,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.18
                          ],
                          [
                            -0.25,
                            0.1
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            22.29,
                            9.11
                          ],
                          [
                            21.21,
                            8.83
                          ],
                          [
                            20.46,
                            8.03
                          ],
                          [
                            20.18,
                            6.76
                          ],
                          [
                            20.48,
                            5.47
                          ],
                          [
                            21.27,
                            4.67
                          ],
                          [
                            22.34,
                            4.39
                          ],
                          [
                            23.11,
                            4.55
                          ],
                          [
                            23.66,
                            4.92
                          ],
                          [
                            23.27,
                            5.42
                          ],
                          [
                            22.86,
                            5.13
                          ],
                          [
                            22.37,
                            5.02
                          ],
                          [
                            21.64,
                            5.24
                          ],
                          [
                            21.14,
                            5.85
                          ],
                          [
                            20.96,
                            6.76
                          ],
                          [
                            21.34,
                            8.01
                          ],
                          [
                            22.36,
                            8.48
                          ],
                          [
                            22.94,
                            8.35
                          ],
                          [
                            23.41,
                            8.03
                          ],
                          [
                            23.74,
                            8.54
                          ],
                          [
                            23.07,
                            8.96
                          ],
                          [
                            22.29,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.22
                          ],
                          [
                            0,
                            0.4
                          ],
                          [
                            -0.44,
                            0.26
                          ],
                          [
                            -0.96,
                            0.11
                          ],
                          [
                            0.05,
                            0.18
                          ],
                          [
                            0.14,
                            0.1
                          ],
                          [
                            0.25,
                            0
                          ],
                          [
                            0.23,
                            -0.1
                          ],
                          [
                            0.18,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.3,
                            0.12
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.25,
                            -0.34
                          ],
                          [
                            0,
                            -0.56
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.13
                          ],
                          [
                            0.29,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.37,
                            0
                          ],
                          [
                            -0.25,
                            -0.23
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.45,
                            -0.27
                          ],
                          [
                            0,
                            -0.19
                          ],
                          [
                            -0.05,
                            -0.17
                          ],
                          [
                            -0.13,
                            -0.11
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.23,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            -0.14
                          ],
                          [
                            0.31,
                            -0.13
                          ],
                          [
                            0.55,
                            0
                          ],
                          [
                            0.25,
                            0.33
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            0.17
                          ],
                          [
                            -0.25,
                            0.13
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.68,
                            9.11
                          ],
                          [
                            24.73,
                            8.78
                          ],
                          [
                            24.37,
                            7.83
                          ],
                          [
                            25.02,
                            6.7
                          ],
                          [
                            27.13,
                            6.15
                          ],
                          [
                            27.04,
                            5.6
                          ],
                          [
                            26.76,
                            5.19
                          ],
                          [
                            26.2,
                            5.02
                          ],
                          [
                            25.47,
                            5.17
                          ],
                          [
                            24.86,
                            5.5
                          ],
                          [
                            24.56,
                            4.97
                          ],
                          [
                            25.33,
                            4.59
                          ],
                          [
                            26.33,
                            4.39
                          ],
                          [
                            27.52,
                            4.9
                          ],
                          [
                            27.89,
                            6.24
                          ],
                          [
                            27.89,
                            9
                          ],
                          [
                            27.26,
                            9
                          ],
                          [
                            27.2,
                            8.46
                          ],
                          [
                            27.17,
                            8.46
                          ],
                          [
                            26.48,
                            8.92
                          ],
                          [
                            25.68,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.11
                          ],
                          [
                            -0.21,
                            0.19
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.3,
                            -0.19
                          ],
                          [
                            0,
                            -0.29
                          ],
                          [
                            -0.15,
                            -0.12
                          ],
                          [
                            -0.22,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.21,
                            0
                          ],
                          [
                            0.19,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.75,
                            0.09
                          ],
                          [
                            -0.3,
                            0.18
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.9,
                            8.5
                          ],
                          [
                            26.51,
                            8.34
                          ],
                          [
                            27.13,
                            7.9
                          ],
                          [
                            27.13,
                            6.65
                          ],
                          [
                            25.55,
                            7.07
                          ],
                          [
                            25.11,
                            7.78
                          ],
                          [
                            25.34,
                            8.33
                          ],
                          [
                            25.9,
                            8.5
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0.17
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.05
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            -0.01
                          ],
                          [
                            0.11,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.12,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.12
                          ],
                          [
                            0.04,
                            0.05
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0.03,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.03
                          ],
                          [
                            -0.07,
                            0.01
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            30.11,
                            9.11
                          ],
                          [
                            29.49,
                            8.85
                          ],
                          [
                            29.31,
                            8.09
                          ],
                          [
                            29.31,
                            2.41
                          ],
                          [
                            30.07,
                            2.41
                          ],
                          [
                            30.07,
                            8.15
                          ],
                          [
                            30.13,
                            8.41
                          ],
                          [
                            30.28,
                            8.48
                          ],
                          [
                            30.34,
                            8.48
                          ],
                          [
                            30.45,
                            8.46
                          ],
                          [
                            30.55,
                            9.04
                          ],
                          [
                            30.37,
                            9.09
                          ],
                          [
                            30.11,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.33,
                            0.19
                          ],
                          [
                            0.19,
                            0.35
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.19,
                            0.35
                          ],
                          [
                            -0.31,
                            0.19
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.31,
                            -0.38
                          ],
                          [
                            0,
                            -0.64
                          ],
                          [
                            0,
                            -0.08
                          ],
                          [
                            0.01,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.27,
                            -0.29
                          ],
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.18,
                            0.06
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            -0.09
                          ],
                          [
                            0.31,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.4,
                            0
                          ],
                          [
                            -0.33,
                            -0.19
                          ],
                          [
                            -0.19,
                            -0.35
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0.2,
                            -0.35
                          ],
                          [
                            0.31,
                            -0.19
                          ],
                          [
                            0.57,
                            0
                          ],
                          [
                            0.32,
                            0.38
                          ],
                          [
                            0,
                            0.08
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.47
                          ],
                          [
                            0.27,
                            0.29
                          ],
                          [
                            0.22,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.13
                          ],
                          [
                            -0.24,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            33.49,
                            9.11
                          ],
                          [
                            32.4,
                            8.83
                          ],
                          [
                            31.62,
                            8.02
                          ],
                          [
                            31.34,
                            6.76
                          ],
                          [
                            31.62,
                            5.49
                          ],
                          [
                            32.38,
                            4.68
                          ],
                          [
                            33.35,
                            4.39
                          ],
                          [
                            34.68,
                            4.96
                          ],
                          [
                            35.15,
                            6.5
                          ],
                          [
                            35.14,
                            6.74
                          ],
                          [
                            35.12,
                            6.94
                          ],
                          [
                            32.09,
                            6.94
                          ],
                          [
                            32.53,
                            8.07
                          ],
                          [
                            33.58,
                            8.5
                          ],
                          [
                            34.18,
                            8.41
                          ],
                          [
                            34.7,
                            8.15
                          ],
                          [
                            34.97,
                            8.65
                          ],
                          [
                            34.32,
                            8.97
                          ],
                          [
                            33.49,
                            9.11
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.23
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.25,
                            -0.25
                          ],
                          [
                            0.05,
                            -0.45
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.46
                          ],
                          [
                            -0.19,
                            -0.24
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.25,
                            0.24
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            32.07,
                            6.39
                          ],
                          [
                            34.48,
                            6.39
                          ],
                          [
                            34.19,
                            5.35
                          ],
                          [
                            33.37,
                            4.99
                          ],
                          [
                            32.52,
                            5.36
                          ],
                          [
                            32.07,
                            6.39
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            0.16
                          ],
                          [
                            -0.25,
                            0
                          ],
                          [
                            -0.14,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0.01
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.15,
                            -0.38
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.29
                          ],
                          [
                            0.22,
                            -0.17
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.06,
                            -0.01
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.2,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            36.26,
                            9
                          ],
                          [
                            36.26,
                            4.5
                          ],
                          [
                            36.89,
                            4.5
                          ],
                          [
                            36.95,
                            5.32
                          ],
                          [
                            36.98,
                            5.32
                          ],
                          [
                            37.55,
                            4.64
                          ],
                          [
                            38.26,
                            4.39
                          ],
                          [
                            38.74,
                            4.48
                          ],
                          [
                            38.59,
                            5.15
                          ],
                          [
                            38.39,
                            5.09
                          ],
                          [
                            38.16,
                            5.07
                          ],
                          [
                            37.55,
                            5.3
                          ],
                          [
                            37.02,
                            6.11
                          ],
                          [
                            37.02,
                            9
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.49,
                        0.55,
                        0.65,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "2031",
    layers: [
      {
        ind: 2030,
        ty: 2,
        parent: 2029,
        ks: {
          s: {
            a: 0,
            k: [
              157.14,
              162.5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "0"
      },
      {
        ind: 2029,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "2034",
    layers: [
      {
        ind: 2033,
        ty: 0,
        parent: 2028,
        ks: {},
        w: 11,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "2031"
      },
      {
        ind: 2028,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "2089",
    layers: [
      {
        ind: 2088,
        ty: 2,
        parent: 2087,
        ks: {
          s: {
            a: 0,
            k: [
              162.5,
              160
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "1"
      },
      {
        ind: 2087,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "2092",
    layers: [
      {
        ind: 2091,
        ty: 0,
        parent: 2086,
        ks: {},
        w: 13,
        h: 12,
        ip: 0,
        op: 565,
        st: 0,
        refId: "2089"
      },
      {
        ind: 2086,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "2129",
    layers: [
      {
        ind: 2128,
        ty: 2,
        parent: 2127,
        ks: {
          s: {
            a: 0,
            k: [
              200,
              195.45
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "12"
      },
      {
        ind: 2127,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "2132",
    layers: [
      {
        ind: 2131,
        ty: 0,
        parent: 2126,
        ks: {},
        w: 19,
        h: 21.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "2129"
      },
      {
        ind: 2126,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "2143",
    layers: [
      {
        ind: 2142,
        ty: 2,
        parent: 2141,
        ks: {
          s: {
            a: 0,
            k: [
              198.7,
              198.7
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "13"
      },
      {
        ind: 2141,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "2146",
    layers: [
      {
        ind: 2145,
        ty: 0,
        parent: 2140,
        ks: {},
        w: 76.5,
        h: 76.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "2143"
      },
      {
        ind: 2140,
        ty: 3,
        parent: 2139,
        ks: {
          p: {
            a: 0,
            k: [
              -6,
              -5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2139,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              7,
              5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "2150",
    layers: [
      {
        ind: 2149,
        ty: 4,
        td: 1,
        parent: 2138,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                31.739,
                31.739
              ]
            },
            r: {
              a: 0,
              k: 31
            },
            s: {
              a: 0,
              k: [
                63.478,
                63.478
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2148,
        ty: 0,
        tt: 1,
        parent: 2138,
        ks: {
          a: {
            a: 0,
            k: [
              7,
              5
            ]
          }
        },
        w: 84,
        h: 82,
        ip: 0,
        op: 565,
        st: 0,
        refId: "2146"
      },
      {
        ind: 2138,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              7.053,
              7.053
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "2155",
    layers: [
      {
        ind: 1860,
        ty: 4,
        parent: 1859,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1859,
        ty: 3,
        parent: 1858,
        ks: {
          p: {
            a: 0,
            k: [
              28.394,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1862,
        ty: 4,
        parent: 1861,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1861,
        ty: 3,
        parent: 1858,
        ks: {
          p: {
            a: 0,
            k: [
              22.138,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1864,
        ty: 4,
        parent: 1863,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ],
                  [
                    1.2,
                    11.3
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    10.1
                  ],
                  [
                    2.4,
                    10.5
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.7,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    3,
                    11.6
                  ],
                  [
                    2.7,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1863,
        ty: 3,
        parent: 1858,
        ks: {
          p: {
            a: 0,
            k: [
              18.794,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1866,
        ty: 4,
        parent: 1865,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1865,
        ty: 3,
        parent: 1858,
        ks: {
          p: {
            a: 0,
            k: [
              12.426,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1868,
        ty: 4,
        parent: 1867,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.9,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.8
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    3.5,
                    5.4
                  ],
                  [
                    4.6,
                    5.6
                  ],
                  [
                    5.3,
                    6.1
                  ],
                  [
                    5.3,
                    6.1
                  ],
                  [
                    4.6,
                    7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    2.4,
                    7.1
                  ],
                  [
                    2,
                    8.6
                  ],
                  [
                    2,
                    8.6
                  ],
                  [
                    2.4,
                    10
                  ],
                  [
                    3.6,
                    10.6
                  ],
                  [
                    3.6,
                    10.6
                  ],
                  [
                    4.3,
                    10.4
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    4.8,
                    10.1
                  ],
                  [
                    5.4,
                    11
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1867,
        ty: 3,
        parent: 1858,
        ks: {
          p: {
            a: 0,
            k: [
              6.725,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1870,
        ty: 4,
        parent: 1869,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    1.3,
                    9.6
                  ],
                  [
                    2.3,
                    10.2
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    4.5,
                    10.2
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.5,
                    8.7
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    2.5,
                    7.8
                  ],
                  [
                    1.7,
                    7.3
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    1.2,
                    4.5
                  ],
                  [
                    2.1,
                    3.7
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    4.9,
                    3.6
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    5.3,
                    5.3
                  ],
                  [
                    4.5,
                    4.8
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.5,
                    6.1
                  ],
                  [
                    2.9,
                    6.4
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    4.7,
                    7.2
                  ],
                  [
                    5.8,
                    8
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    5.9,
                    10.5
                  ],
                  [
                    4.9,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1869,
        ty: 3,
        parent: 1858,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1858,
        ty: 3,
        parent: 1857,
        ks: {
          p: {
            a: 0,
            k: [
              122.02,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1873,
        ty: 4,
        parent: 1872,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1872,
        ty: 3,
        parent: 1871,
        ks: {
          p: {
            a: 0,
            k: [
              20.548,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1875,
        ty: 4,
        parent: 1874,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1874,
        ty: 3,
        parent: 1871,
        ks: {
          p: {
            a: 0,
            k: [
              14.292,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1877,
        ty: 4,
        parent: 1876,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.6,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.3,
                    6.7
                  ],
                  [
                    0.3,
                    5.6
                  ],
                  [
                    1.1,
                    5.5
                  ],
                  [
                    1.1,
                    4.9
                  ],
                  [
                    1.6,
                    3.3
                  ],
                  [
                    3.2,
                    2.7
                  ],
                  [
                    3.2,
                    2.7
                  ],
                  [
                    3.8,
                    2.8
                  ],
                  [
                    4.3,
                    2.9
                  ],
                  [
                    4.3,
                    2.9
                  ],
                  [
                    4,
                    4
                  ],
                  [
                    3.3,
                    3.8
                  ],
                  [
                    3.3,
                    3.8
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.6,
                    5.5
                  ],
                  [
                    3.8,
                    5.5
                  ],
                  [
                    3.8,
                    6.7
                  ],
                  [
                    2.6,
                    6.7
                  ],
                  [
                    2.6,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    6.9,
                    11.7
                  ],
                  [
                    6.9,
                    11.7
                  ],
                  [
                    5.5,
                    11.1
                  ],
                  [
                    5,
                    9.5
                  ],
                  [
                    5,
                    9.5
                  ],
                  [
                    5,
                    6.7
                  ],
                  [
                    4.2,
                    6.7
                  ],
                  [
                    4.2,
                    5.6
                  ],
                  [
                    5.1,
                    5.5
                  ],
                  [
                    5.3,
                    3.9
                  ],
                  [
                    6.5,
                    3.9
                  ],
                  [
                    6.5,
                    5.5
                  ],
                  [
                    8,
                    5.5
                  ],
                  [
                    8,
                    6.7
                  ],
                  [
                    6.5,
                    6.7
                  ],
                  [
                    6.5,
                    9.5
                  ],
                  [
                    7.3,
                    10.6
                  ],
                  [
                    7.3,
                    10.6
                  ],
                  [
                    7.6,
                    10.6
                  ],
                  [
                    7.9,
                    10.5
                  ],
                  [
                    7.9,
                    10.5
                  ],
                  [
                    8.2,
                    11.5
                  ],
                  [
                    7.6,
                    11.7
                  ],
                  [
                    6.9,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1876,
        ty: 3,
        parent: 1871,
        ks: {
          p: {
            a: 0,
            k: [
              6.367,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1879,
        ty: 4,
        parent: 1878,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1878,
        ty: 3,
        parent: 1871,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1871,
        ty: 3,
        parent: 1857,
        ks: {
          p: {
            a: 0,
            k: [
              94.401,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1882,
        ty: 4,
        parent: 1881,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.5,
                    11.7
                  ],
                  [
                    3.5,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    0.9,
                    10.3
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.5,
                    8.6
                  ],
                  [
                    0.9,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.7
                  ],
                  [
                    5.5,
                    6.8
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.8,
                    8.3
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    5.7,
                    8.9
                  ],
                  [
                    1.9,
                    8.9
                  ],
                  [
                    2.5,
                    10.2
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    3.7,
                    10.6
                  ],
                  [
                    4.4,
                    10.5
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.1,
                    10.2
                  ],
                  [
                    5.6,
                    11.1
                  ],
                  [
                    4.6,
                    11.6
                  ],
                  [
                    3.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.2,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.5
                  ]
                ],
                v: [
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    4.6,
                    8
                  ],
                  [
                    4.3,
                    6.9
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    3.3,
                    6.5
                  ],
                  [
                    2.4,
                    6.9
                  ],
                  [
                    1.9,
                    8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1881,
        ty: 3,
        parent: 1880,
        ks: {
          p: {
            a: 0,
            k: [
              17.856,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1884,
        ty: 4,
        parent: 1883,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    2.3,
                    8.3
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    6.1,
                    5.5
                  ],
                  [
                    4.1,
                    8
                  ],
                  [
                    6.3,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    3.2,
                    9
                  ],
                  [
                    2.3,
                    10
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1883,
        ty: 3,
        parent: 1880,
        ks: {
          p: {
            a: 0,
            k: [
              11.414,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1886,
        ty: 4,
        parent: 1885,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.3,
                    5.5
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    1.6,
                    4.5
                  ],
                  [
                    1.6,
                    4.5
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.8,
                    3.7
                  ],
                  [
                    0.8,
                    3.7
                  ],
                  [
                    1,
                    3.1
                  ],
                  [
                    1.6,
                    2.8
                  ],
                  [
                    1.6,
                    2.8
                  ],
                  [
                    2.2,
                    3.1
                  ],
                  [
                    2.5,
                    3.7
                  ],
                  [
                    2.5,
                    3.7
                  ],
                  [
                    2.2,
                    4.2
                  ],
                  [
                    1.6,
                    4.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1885,
        ty: 3,
        parent: 1880,
        ks: {
          p: {
            a: 0,
            k: [
              8.181,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1888,
        ty: 4,
        parent: 1887,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.5,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    3.5
                  ],
                  [
                    2.5,
                    3.5
                  ],
                  [
                    2.5,
                    6.8
                  ],
                  [
                    5.7,
                    6.8
                  ],
                  [
                    5.7,
                    3.5
                  ],
                  [
                    7.2,
                    3.5
                  ],
                  [
                    7.2,
                    11.6
                  ],
                  [
                    5.7,
                    11.6
                  ],
                  [
                    5.7,
                    8
                  ],
                  [
                    2.5,
                    8
                  ],
                  [
                    2.5,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1887,
        ty: 3,
        parent: 1880,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1880,
        ty: 3,
        parent: 1857,
        ks: {
          p: {
            a: 0,
            k: [
              67.821,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1891,
        ty: 4,
        parent: 1890,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.7,
                    0
                  ]
                ],
                v: [
                  [
                    1.3,
                    14.1
                  ],
                  [
                    1.3,
                    14.1
                  ],
                  [
                    0.9,
                    14
                  ],
                  [
                    0.5,
                    14
                  ],
                  [
                    0.5,
                    14
                  ],
                  [
                    0.8,
                    12.8
                  ],
                  [
                    1,
                    12.9
                  ],
                  [
                    1.2,
                    12.9
                  ],
                  [
                    1.2,
                    12.9
                  ],
                  [
                    2,
                    12.6
                  ],
                  [
                    2.4,
                    11.9
                  ],
                  [
                    2.4,
                    11.9
                  ],
                  [
                    2.5,
                    11.5
                  ],
                  [
                    0.1,
                    5.5
                  ],
                  [
                    1.6,
                    5.5
                  ],
                  [
                    2.6,
                    8.5
                  ],
                  [
                    2.9,
                    9.3
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.2,
                    10.2
                  ],
                  [
                    3.4,
                    9.3
                  ],
                  [
                    3.7,
                    8.5
                  ],
                  [
                    3.7,
                    8.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    6,
                    5.5
                  ],
                  [
                    3.8,
                    11.9
                  ],
                  [
                    2.8,
                    13.5
                  ],
                  [
                    1.3,
                    14.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.7
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1890,
        ty: 3,
        parent: 1889,
        ks: {
          p: {
            a: 0,
            k: [
              27.407,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1893,
        ty: 4,
        parent: 1892,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    2.1,
                    5.5
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    2.2,
                    6.6
                  ],
                  [
                    3,
                    5.7
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    3.9,
                    5.4
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.6,
                    5.5
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    4.1,
                    6.7
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3.8,
                    6.6
                  ],
                  [
                    3,
                    6.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    7.9
                  ],
                  [
                    2.3,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1892,
        ty: 3,
        parent: 1889,
        ks: {
          p: {
            a: 0,
            k: [
              22.804,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1895,
        ty: 4,
        parent: 1894,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1894,
        ty: 3,
        parent: 1889,
        ks: {
          p: {
            a: 0,
            k: [
              16.437,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1897,
        ty: 4,
        parent: 1896,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ],
                  [
                    1.2,
                    11.3
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    10
                  ],
                  [
                    0.9,
                    2.9
                  ],
                  [
                    2.3,
                    2.9
                  ],
                  [
                    2.3,
                    10.1
                  ],
                  [
                    2.4,
                    10.5
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.6,
                    10.6
                  ],
                  [
                    2.7,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    2.9,
                    10.6
                  ],
                  [
                    3,
                    11.6
                  ],
                  [
                    2.7,
                    11.7
                  ],
                  [
                    2.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1896,
        ty: 3,
        parent: 1889,
        ks: {
          p: {
            a: 0,
            k: [
              13.093,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1899,
        ty: 4,
        parent: 1898,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.4
                  ],
                  [
                    -1.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.2
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.4,
                    8.4
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    4.1,
                    7.7
                  ],
                  [
                    3.9,
                    6.9
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    3,
                    6.5
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    1.3,
                    7.1
                  ],
                  [
                    0.8,
                    6.2
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.1
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    8
                  ],
                  [
                    5.6,
                    11.6
                  ],
                  [
                    4.4,
                    11.6
                  ],
                  [
                    4.3,
                    10.9
                  ],
                  [
                    4.2,
                    10.9
                  ],
                  [
                    3.4,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.8,
                    10.6
                  ],
                  [
                    2.8,
                    10.6
                  ],
                  [
                    3.5,
                    10.4
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    10
                  ],
                  [
                    4.1,
                    8.6
                  ],
                  [
                    2.4,
                    9.1
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2,
                    9.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    2.8,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1898,
        ty: 3,
        parent: 1889,
        ks: {
          p: {
            a: 0,
            k: [
              6.725,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1901,
        ty: 4,
        parent: 1900,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    0.5,
                    10.6
                  ],
                  [
                    1.3,
                    9.6
                  ],
                  [
                    2.3,
                    10.2
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    4.5,
                    10.2
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.8,
                    9.5
                  ],
                  [
                    4.5,
                    8.7
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    3.6,
                    8.3
                  ],
                  [
                    2.5,
                    7.8
                  ],
                  [
                    1.7,
                    7.3
                  ],
                  [
                    1.1,
                    6.7
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    0.8,
                    5.6
                  ],
                  [
                    1.2,
                    4.5
                  ],
                  [
                    2.1,
                    3.7
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    3.5,
                    3.4
                  ],
                  [
                    4.9,
                    3.6
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    6,
                    4.4
                  ],
                  [
                    5.3,
                    5.3
                  ],
                  [
                    4.5,
                    4.8
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    3.5,
                    4.6
                  ],
                  [
                    2.6,
                    4.9
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.3,
                    5.6
                  ],
                  [
                    2.5,
                    6.1
                  ],
                  [
                    2.9,
                    6.4
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    3.6,
                    6.7
                  ],
                  [
                    4.7,
                    7.2
                  ],
                  [
                    5.8,
                    8
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    6.3,
                    9.3
                  ],
                  [
                    5.9,
                    10.5
                  ],
                  [
                    4.9,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1900,
        ty: 3,
        parent: 1889,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1889,
        ty: 3,
        parent: 1857,
        ks: {
          p: {
            a: 0,
            k: [
              31.837,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1904,
        ty: 4,
        parent: 1903,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    8.5
                  ],
                  [
                    2.3,
                    8.5
                  ],
                  [
                    0.9,
                    7.8
                  ],
                  [
                    0.4,
                    5.9
                  ],
                  [
                    0.4,
                    5.9
                  ],
                  [
                    0.9,
                    4
                  ],
                  [
                    2.3,
                    3.4
                  ],
                  [
                    2.3,
                    3.4
                  ],
                  [
                    3.7,
                    4
                  ],
                  [
                    4.2,
                    5.9
                  ],
                  [
                    4.2,
                    5.9
                  ],
                  [
                    3.7,
                    7.8
                  ],
                  [
                    2.3,
                    8.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    7.7
                  ],
                  [
                    2.3,
                    7.7
                  ],
                  [
                    2.9,
                    7.2
                  ],
                  [
                    3.2,
                    5.9
                  ],
                  [
                    3.2,
                    5.9
                  ],
                  [
                    2.9,
                    4.6
                  ],
                  [
                    2.3,
                    4.2
                  ],
                  [
                    2.3,
                    4.2
                  ],
                  [
                    1.7,
                    4.6
                  ],
                  [
                    1.4,
                    5.9
                  ],
                  [
                    1.4,
                    5.9
                  ],
                  [
                    1.7,
                    7.2
                  ],
                  [
                    2.3,
                    7.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2.6,
                    11.7
                  ],
                  [
                    7,
                    3.4
                  ],
                  [
                    7.8,
                    3.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    8.1,
                    11.7
                  ],
                  [
                    8.1,
                    11.7
                  ],
                  [
                    6.7,
                    11.1
                  ],
                  [
                    6.2,
                    9.2
                  ],
                  [
                    6.2,
                    9.2
                  ],
                  [
                    6.7,
                    7.3
                  ],
                  [
                    8.1,
                    6.6
                  ],
                  [
                    8.1,
                    6.6
                  ],
                  [
                    9.5,
                    7.3
                  ],
                  [
                    10,
                    9.2
                  ],
                  [
                    10,
                    9.2
                  ],
                  [
                    9.5,
                    11.1
                  ],
                  [
                    8.1,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    8.1,
                    10.9
                  ],
                  [
                    8.1,
                    10.9
                  ],
                  [
                    8.7,
                    10.5
                  ],
                  [
                    9,
                    9.2
                  ],
                  [
                    9,
                    9.2
                  ],
                  [
                    8.7,
                    7.9
                  ],
                  [
                    8.1,
                    7.5
                  ],
                  [
                    8.1,
                    7.5
                  ],
                  [
                    7.4,
                    7.9
                  ],
                  [
                    7.2,
                    9.2
                  ],
                  [
                    7.2,
                    9.2
                  ],
                  [
                    7.4,
                    10.5
                  ],
                  [
                    8.1,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1903,
        ty: 3,
        parent: 1902,
        ks: {
          p: {
            a: 0,
            k: [
              18.991,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1906,
        ty: 4,
        parent: 1905,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.7
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.7
                  ],
                  [
                    0.8,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    11.7
                  ],
                  [
                    3.2,
                    11.7
                  ],
                  [
                    1.2,
                    10.7
                  ],
                  [
                    0.5,
                    7.6
                  ],
                  [
                    0.5,
                    7.6
                  ],
                  [
                    1.2,
                    4.6
                  ],
                  [
                    3.2,
                    3.6
                  ],
                  [
                    3.2,
                    3.6
                  ],
                  [
                    5.1,
                    4.6
                  ],
                  [
                    5.8,
                    7.6
                  ],
                  [
                    5.8,
                    7.6
                  ],
                  [
                    5.1,
                    10.7
                  ],
                  [
                    3.2,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0.5,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    -0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    10.6
                  ],
                  [
                    3.2,
                    10.6
                  ],
                  [
                    3.8,
                    10.3
                  ],
                  [
                    4.3,
                    9.4
                  ],
                  [
                    4.5,
                    7.6
                  ],
                  [
                    4.5,
                    7.6
                  ],
                  [
                    4.3,
                    5.9
                  ],
                  [
                    3.8,
                    5
                  ],
                  [
                    3.2,
                    4.7
                  ],
                  [
                    3.2,
                    4.7
                  ],
                  [
                    2.5,
                    5
                  ],
                  [
                    2,
                    5.9
                  ],
                  [
                    1.9,
                    7.6
                  ],
                  [
                    1.9,
                    7.6
                  ],
                  [
                    2,
                    9.4
                  ],
                  [
                    2.5,
                    10.3
                  ],
                  [
                    3.2,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1905,
        ty: 3,
        parent: 1902,
        ks: {
          p: {
            a: 0,
            k: [
              12.661,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1908,
        ty: 4,
        parent: 1907,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.7
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.7
                  ],
                  [
                    0.8,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    11.7
                  ],
                  [
                    3.2,
                    11.7
                  ],
                  [
                    1.2,
                    10.7
                  ],
                  [
                    0.5,
                    7.6
                  ],
                  [
                    0.5,
                    7.6
                  ],
                  [
                    1.2,
                    4.6
                  ],
                  [
                    3.2,
                    3.6
                  ],
                  [
                    3.2,
                    3.6
                  ],
                  [
                    5.1,
                    4.6
                  ],
                  [
                    5.8,
                    7.6
                  ],
                  [
                    5.8,
                    7.6
                  ],
                  [
                    5.1,
                    10.7
                  ],
                  [
                    3.2,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.8,
                    0
                  ],
                  [
                    -0.5,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -1.3
                  ],
                  [
                    0.5,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    -0.5,
                    0.7
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    10.6
                  ],
                  [
                    3.2,
                    10.6
                  ],
                  [
                    3.8,
                    10.3
                  ],
                  [
                    4.3,
                    9.4
                  ],
                  [
                    4.5,
                    7.6
                  ],
                  [
                    4.5,
                    7.6
                  ],
                  [
                    4.3,
                    5.9
                  ],
                  [
                    3.8,
                    5
                  ],
                  [
                    3.2,
                    4.7
                  ],
                  [
                    3.2,
                    4.7
                  ],
                  [
                    2.5,
                    5
                  ],
                  [
                    2,
                    5.9
                  ],
                  [
                    1.9,
                    7.6
                  ],
                  [
                    1.9,
                    7.6
                  ],
                  [
                    2,
                    9.4
                  ],
                  [
                    2.5,
                    10.3
                  ],
                  [
                    3.2,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1907,
        ty: 3,
        parent: 1902,
        ks: {
          p: {
            a: 0,
            k: [
              6.33,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1910,
        ty: 4,
        parent: 1909,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    5.6,
                    11.6
                  ],
                  [
                    0.9,
                    11.6
                  ],
                  [
                    0.9,
                    10.4
                  ],
                  [
                    2.7,
                    10.4
                  ],
                  [
                    2.7,
                    5.3
                  ],
                  [
                    1.2,
                    5.3
                  ],
                  [
                    1.2,
                    4.4
                  ],
                  [
                    2.2,
                    4.1
                  ],
                  [
                    3,
                    3.7
                  ],
                  [
                    3,
                    3.7
                  ],
                  [
                    4.1,
                    3.7
                  ],
                  [
                    4.1,
                    10.4
                  ],
                  [
                    5.6,
                    10.4
                  ],
                  [
                    5.6,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.518,
                0.322
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1909,
        ty: 3,
        parent: 1902,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1902,
        ty: 3,
        parent: 1857,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1857,
        ty: 3,
        parent: 1856,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1856,
        ty: 3,
        parent: 1855,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1855,
        ty: 3,
        parent: 1854,
        ks: {
          p: {
            a: 0,
            k: [
              22.167,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1919,
        ty: 0,
        parent: 1911,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1917"
      },
      {
        ind: 1911,
        ty: 3,
        parent: 1854,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1854,
        ty: 3,
        parent: 1853,
        ks: {
          p: {
            a: 0,
            k: [
              48.952,
              3.527
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1853,
        ty: 3,
        parent: 1852,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              46.727
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1950,
        ty: 0,
        parent: 1922,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              13.015
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              13.015
            ]
          }
        },
        w: 60.455,
        h: 12.913,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1948"
      },
      {
        ind: 1922,
        ty: 3,
        parent: 1921,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              13.015
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1955,
        ty: 4,
        parent: 1954,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.22,
                    0.16
                  ],
                  [
                    -0.25,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.14,
                    -0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.06,
                    0.01
                  ],
                  [
                    0.09,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.15
                  ],
                  [
                    0.15,
                    -0.37
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.49,
                    8.51
                  ],
                  [
                    0.74,
                    8.51
                  ],
                  [
                    0.74,
                    4.11
                  ],
                  [
                    1.36,
                    4.11
                  ],
                  [
                    1.42,
                    4.9
                  ],
                  [
                    1.45,
                    4.9
                  ],
                  [
                    2,
                    4.24
                  ],
                  [
                    2.7,
                    4
                  ],
                  [
                    2.7,
                    4
                  ],
                  [
                    3.17,
                    4.09
                  ],
                  [
                    3.17,
                    4.09
                  ],
                  [
                    3.03,
                    4.74
                  ],
                  [
                    2.83,
                    4.69
                  ],
                  [
                    2.6,
                    4.67
                  ],
                  [
                    2.6,
                    4.67
                  ],
                  [
                    2.02,
                    4.9
                  ],
                  [
                    1.49,
                    5.68
                  ],
                  [
                    1.49,
                    5.68
                  ],
                  [
                    1.49,
                    8.51
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.15,
                    -0.28
                  ],
                  [
                    0.22,
                    -0.16
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.18,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.07,
                    -0.02
                  ],
                  [
                    -0.06,
                    -0.01
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0
                  ],
                  [
                    -0.2,
                    0.15
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1954,
        ty: 3,
        parent: 1953,
        ks: {
          p: {
            a: 0,
            k: [
              20.34,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1957,
        ty: 4,
        parent: 1956,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.32,
                    0.18
                  ],
                  [
                    0.19,
                    0.34
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.34
                  ],
                  [
                    -0.3,
                    0.19
                  ],
                  [
                    -0.33,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    -0.37
                  ],
                  [
                    0,
                    -0.63
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.08
                  ],
                  [
                    0.01,
                    -0.05
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.26,
                    -0.28
                  ],
                  [
                    -0.42,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.18,
                    0.06
                  ],
                  [
                    -0.16,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.09
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.53,
                    8.62
                  ],
                  [
                    2.53,
                    8.62
                  ],
                  [
                    1.46,
                    8.35
                  ],
                  [
                    0.7,
                    7.55
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.7,
                    5.08
                  ],
                  [
                    1.44,
                    4.28
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    3.7,
                    4.56
                  ],
                  [
                    4.15,
                    6.07
                  ],
                  [
                    4.15,
                    6.07
                  ],
                  [
                    4.15,
                    6.3
                  ],
                  [
                    4.13,
                    6.49
                  ],
                  [
                    4.13,
                    6.49
                  ],
                  [
                    1.15,
                    6.49
                  ],
                  [
                    1.59,
                    7.61
                  ],
                  [
                    2.62,
                    8.02
                  ],
                  [
                    2.62,
                    8.02
                  ],
                  [
                    3.21,
                    7.93
                  ],
                  [
                    3.72,
                    7.68
                  ],
                  [
                    3.72,
                    7.68
                  ],
                  [
                    3.98,
                    8.17
                  ],
                  [
                    3.34,
                    8.49
                  ],
                  [
                    2.53,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.39,
                    0
                  ],
                  [
                    -0.32,
                    -0.18
                  ],
                  [
                    -0.19,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.48
                  ],
                  [
                    0.19,
                    -0.34
                  ],
                  [
                    0.3,
                    -0.19
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.56,
                    0
                  ],
                  [
                    0.31,
                    0.37
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.08
                  ],
                  [
                    0,
                    0.08
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.03,
                    0.47
                  ],
                  [
                    0.26,
                    0.28
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0
                  ],
                  [
                    0.18,
                    -0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.12
                  ],
                  [
                    -0.24,
                    0.09
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.19,
                    0.23
                  ],
                  [
                    0.34,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.24
                  ],
                  [
                    0.05,
                    -0.44
                  ]
                ],
                v: [
                  [
                    1.14,
                    5.96
                  ],
                  [
                    1.14,
                    5.96
                  ],
                  [
                    3.5,
                    5.96
                  ],
                  [
                    3.21,
                    4.94
                  ],
                  [
                    2.41,
                    4.59
                  ],
                  [
                    2.41,
                    4.59
                  ],
                  [
                    1.58,
                    4.95
                  ],
                  [
                    1.14,
                    5.96
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.45
                  ],
                  [
                    -0.19,
                    -0.23
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    0
                  ],
                  [
                    -0.24,
                    0.24
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1956,
        ty: 3,
        parent: 1953,
        ks: {
          p: {
            a: 0,
            k: [
              15.846,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1959,
        ty: 4,
        parent: 1958,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    8.6
                  ],
                  [
                    1.5,
                    8.6
                  ],
                  [
                    0.9,
                    8.4
                  ],
                  [
                    0.7,
                    7.6
                  ],
                  [
                    0.7,
                    7.6
                  ],
                  [
                    0.7,
                    2.1
                  ],
                  [
                    1.5,
                    2.1
                  ],
                  [
                    1.5,
                    7.7
                  ],
                  [
                    1.6,
                    7.9
                  ],
                  [
                    1.7,
                    8
                  ],
                  [
                    1.7,
                    8
                  ],
                  [
                    1.8,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    1.9,
                    8
                  ],
                  [
                    2,
                    8.5
                  ],
                  [
                    1.8,
                    8.6
                  ],
                  [
                    1.5,
                    8.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1958,
        ty: 3,
        parent: 1953,
        ks: {
          p: {
            a: 0,
            k: [
              13.536,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1961,
        ty: 4,
        parent: 1960,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    0.22
                  ],
                  [
                    0,
                    0.39
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.43,
                    0.26
                  ],
                  [
                    -0.94,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.05,
                    0.17
                  ],
                  [
                    0.13,
                    0.11
                  ],
                  [
                    0.24,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.22,
                    -0.1
                  ],
                  [
                    0.18,
                    -0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.12
                  ],
                  [
                    -0.35,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.24,
                    -0.33
                  ],
                  [
                    0,
                    -0.55
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.13
                  ],
                  [
                    0.28,
                    0
                  ]
                ],
                v: [
                  [
                    1.76,
                    8.62
                  ],
                  [
                    1.76,
                    8.62
                  ],
                  [
                    0.84,
                    8.29
                  ],
                  [
                    0.47,
                    7.37
                  ],
                  [
                    0.47,
                    7.37
                  ],
                  [
                    1.12,
                    6.26
                  ],
                  [
                    3.17,
                    5.72
                  ],
                  [
                    3.17,
                    5.72
                  ],
                  [
                    3.1,
                    5.19
                  ],
                  [
                    2.82,
                    4.77
                  ],
                  [
                    2.27,
                    4.61
                  ],
                  [
                    2.27,
                    4.61
                  ],
                  [
                    1.55,
                    4.76
                  ],
                  [
                    0.95,
                    5.09
                  ],
                  [
                    0.95,
                    5.09
                  ],
                  [
                    0.66,
                    4.57
                  ],
                  [
                    1.42,
                    4.18
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    2.39,
                    4
                  ],
                  [
                    3.56,
                    4.49
                  ],
                  [
                    3.93,
                    5.81
                  ],
                  [
                    3.93,
                    5.81
                  ],
                  [
                    3.93,
                    8.51
                  ],
                  [
                    3.31,
                    8.51
                  ],
                  [
                    3.25,
                    7.99
                  ],
                  [
                    3.22,
                    7.99
                  ],
                  [
                    2.54,
                    8.43
                  ],
                  [
                    1.76,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.37,
                    0
                  ],
                  [
                    -0.24,
                    -0.22
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.48
                  ],
                  [
                    0.43,
                    -0.26
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.19
                  ],
                  [
                    -0.05,
                    -0.17
                  ],
                  [
                    -0.13,
                    -0.11
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.25,
                    0
                  ],
                  [
                    -0.22,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    -0.13
                  ],
                  [
                    0.3,
                    -0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.54,
                    0
                  ],
                  [
                    0.24,
                    0.33
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    0.17
                  ],
                  [
                    -0.24,
                    0.13
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.1
                  ],
                  [
                    -0.21,
                    0.19
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.29,
                    -0.18
                  ],
                  [
                    0,
                    -0.28
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.15,
                    -0.11
                  ],
                  [
                    -0.22,
                    0
                  ]
                ],
                v: [
                  [
                    1.98,
                    8.02
                  ],
                  [
                    1.98,
                    8.02
                  ],
                  [
                    2.58,
                    7.87
                  ],
                  [
                    3.17,
                    7.43
                  ],
                  [
                    3.17,
                    7.43
                  ],
                  [
                    3.17,
                    6.21
                  ],
                  [
                    1.64,
                    6.62
                  ],
                  [
                    1.2,
                    7.32
                  ],
                  [
                    1.2,
                    7.32
                  ],
                  [
                    1.42,
                    7.86
                  ],
                  [
                    1.98,
                    8.02
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0
                  ],
                  [
                    0.19,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.73,
                    0.09
                  ],
                  [
                    -0.29,
                    0.18
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.25
                  ],
                  [
                    0.15,
                    0.11
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1960,
        ty: 3,
        parent: 1953,
        ks: {
          p: {
            a: 0,
            k: [
              8.969,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1963,
        ty: 4,
        parent: 1962,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.31,
                    0.18
                  ],
                  [
                    0.18,
                    0.34
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.34
                  ],
                  [
                    -0.32,
                    0.18
                  ],
                  [
                    -0.37,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.1
                  ],
                  [
                    -0.15,
                    -0.14
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.14,
                    0.07
                  ],
                  [
                    0.18,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    -0.14
                  ],
                  [
                    0.12,
                    -0.26
                  ],
                  [
                    0,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.25,
                    -0.31
                  ],
                  [
                    -0.41,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.18,
                    0.09
                  ],
                  [
                    -0.13,
                    0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.1
                  ],
                  [
                    0.27,
                    0
                  ]
                ],
                v: [
                  [
                    2.48,
                    8.62
                  ],
                  [
                    2.48,
                    8.62
                  ],
                  [
                    1.43,
                    8.35
                  ],
                  [
                    0.69,
                    7.56
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.71,
                    5.06
                  ],
                  [
                    1.49,
                    4.27
                  ],
                  [
                    2.54,
                    4
                  ],
                  [
                    2.54,
                    4
                  ],
                  [
                    3.29,
                    4.15
                  ],
                  [
                    3.83,
                    4.51
                  ],
                  [
                    3.83,
                    4.51
                  ],
                  [
                    3.45,
                    5
                  ],
                  [
                    3.04,
                    4.72
                  ],
                  [
                    2.57,
                    4.61
                  ],
                  [
                    2.57,
                    4.61
                  ],
                  [
                    1.85,
                    4.83
                  ],
                  [
                    1.36,
                    5.43
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.56,
                    7.54
                  ],
                  [
                    2.55,
                    8.01
                  ],
                  [
                    2.55,
                    8.01
                  ],
                  [
                    3.12,
                    7.87
                  ],
                  [
                    3.58,
                    7.56
                  ],
                  [
                    3.58,
                    7.56
                  ],
                  [
                    3.91,
                    8.06
                  ],
                  [
                    3.25,
                    8.47
                  ],
                  [
                    2.48,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.39,
                    0
                  ],
                  [
                    -0.31,
                    -0.18
                  ],
                  [
                    -0.18,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0.2,
                    -0.34
                  ],
                  [
                    0.32,
                    -0.18
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.29,
                    0
                  ],
                  [
                    0.21,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.13,
                    -0.11
                  ],
                  [
                    -0.14,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.27,
                    0
                  ],
                  [
                    -0.21,
                    0.14
                  ],
                  [
                    -0.12,
                    0.26
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0.25,
                    0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0
                  ],
                  [
                    0.18,
                    -0.09
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.18
                  ],
                  [
                    -0.24,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1962,
        ty: 3,
        parent: 1953,
        ks: {
          p: {
            a: 0,
            k: [
              4.838,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1965,
        ty: 4,
        parent: 1964,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.5,
                    8.6
                  ],
                  [
                    2.5,
                    8.6
                  ],
                  [
                    1.3,
                    8.4
                  ],
                  [
                    0.4,
                    7.7
                  ],
                  [
                    0.4,
                    7.7
                  ],
                  [
                    0.8,
                    7.2
                  ],
                  [
                    1.6,
                    7.8
                  ],
                  [
                    2.5,
                    8
                  ],
                  [
                    2.5,
                    8
                  ],
                  [
                    3.4,
                    7.7
                  ],
                  [
                    3.7,
                    7
                  ],
                  [
                    3.7,
                    7
                  ],
                  [
                    3.6,
                    6.5
                  ],
                  [
                    3.2,
                    6.2
                  ],
                  [
                    2.7,
                    5.9
                  ],
                  [
                    2.7,
                    5.9
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.3,
                    5.3
                  ],
                  [
                    0.9,
                    4.8
                  ],
                  [
                    0.7,
                    4
                  ],
                  [
                    0.7,
                    4
                  ],
                  [
                    0.9,
                    3.2
                  ],
                  [
                    1.6,
                    2.7
                  ],
                  [
                    2.5,
                    2.5
                  ],
                  [
                    2.5,
                    2.5
                  ],
                  [
                    3.5,
                    2.7
                  ],
                  [
                    4.3,
                    3.2
                  ],
                  [
                    4.3,
                    3.2
                  ],
                  [
                    3.9,
                    3.7
                  ],
                  [
                    3.3,
                    3.3
                  ],
                  [
                    2.5,
                    3.1
                  ],
                  [
                    2.5,
                    3.1
                  ],
                  [
                    1.7,
                    3.4
                  ],
                  [
                    1.4,
                    4
                  ],
                  [
                    1.4,
                    4
                  ],
                  [
                    1.6,
                    4.5
                  ],
                  [
                    2,
                    4.8
                  ],
                  [
                    2.4,
                    5
                  ],
                  [
                    2.4,
                    5
                  ],
                  [
                    3.3,
                    5.3
                  ],
                  [
                    3.9,
                    5.7
                  ],
                  [
                    4.3,
                    6.2
                  ],
                  [
                    4.5,
                    6.9
                  ],
                  [
                    4.5,
                    6.9
                  ],
                  [
                    4.2,
                    7.8
                  ],
                  [
                    3.5,
                    8.4
                  ],
                  [
                    2.5,
                    8.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1964,
        ty: 3,
        parent: 1953,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1953,
        ty: 3,
        parent: 1952,
        ks: {
          p: {
            a: 0,
            k: [
              18.709,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1968,
        ty: 4,
        parent: 1967,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    8.6
                  ],
                  [
                    2.1,
                    8.6
                  ],
                  [
                    1.1,
                    8.2
                  ],
                  [
                    0.9,
                    7.2
                  ],
                  [
                    0.9,
                    7.2
                  ],
                  [
                    0.9,
                    4.7
                  ],
                  [
                    0.2,
                    4.7
                  ],
                  [
                    0.2,
                    4.2
                  ],
                  [
                    0.9,
                    4.1
                  ],
                  [
                    1,
                    2.9
                  ],
                  [
                    1.6,
                    2.9
                  ],
                  [
                    1.6,
                    4.1
                  ],
                  [
                    2.8,
                    4.1
                  ],
                  [
                    2.8,
                    4.7
                  ],
                  [
                    1.6,
                    4.7
                  ],
                  [
                    1.6,
                    7.2
                  ],
                  [
                    1.8,
                    7.8
                  ],
                  [
                    2.3,
                    8
                  ],
                  [
                    2.3,
                    8
                  ],
                  [
                    2.6,
                    8
                  ],
                  [
                    2.8,
                    7.9
                  ],
                  [
                    2.8,
                    7.9
                  ],
                  [
                    2.9,
                    8.5
                  ],
                  [
                    2.6,
                    8.6
                  ],
                  [
                    2.1,
                    8.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1967,
        ty: 3,
        parent: 1966,
        ks: {
          p: {
            a: 0,
            k: [
              13.835,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1970,
        ty: 4,
        parent: 1969,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.28,
                    0.12
                  ],
                  [
                    0.21,
                    0.17
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.1
                  ],
                  [
                    -0.26,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.15,
                    0.14
                  ],
                  [
                    0,
                    0.19
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.15,
                    0.07
                  ],
                  [
                    0.16,
                    0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.13,
                    0.16
                  ],
                  [
                    0,
                    0.25
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.27,
                    0.24
                  ],
                  [
                    -0.48,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.24,
                    -0.1
                  ],
                  [
                    -0.17,
                    -0.14
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.16,
                    0.07
                  ],
                  [
                    0.19,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.13,
                    -0.13
                  ],
                  [
                    0,
                    -0.17
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.09,
                    -0.09
                  ],
                  [
                    -0.15,
                    -0.06
                  ],
                  [
                    -0.16,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.1
                  ],
                  [
                    -0.14,
                    -0.17
                  ],
                  [
                    0,
                    -0.28
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.12,
                    -0.2
                  ],
                  [
                    0.24,
                    -0.12
                  ],
                  [
                    0.35,
                    0
                  ]
                ],
                v: [
                  [
                    1.9,
                    8.62
                  ],
                  [
                    1.9,
                    8.62
                  ],
                  [
                    1,
                    8.45
                  ],
                  [
                    0.25,
                    8.01
                  ],
                  [
                    0.25,
                    8.01
                  ],
                  [
                    0.63,
                    7.52
                  ],
                  [
                    1.22,
                    7.89
                  ],
                  [
                    1.92,
                    8.04
                  ],
                  [
                    1.92,
                    8.04
                  ],
                  [
                    2.58,
                    7.84
                  ],
                  [
                    2.79,
                    7.35
                  ],
                  [
                    2.79,
                    7.35
                  ],
                  [
                    2.64,
                    6.97
                  ],
                  [
                    2.26,
                    6.71
                  ],
                  [
                    1.79,
                    6.52
                  ],
                  [
                    1.79,
                    6.52
                  ],
                  [
                    1.18,
                    6.25
                  ],
                  [
                    0.69,
                    5.86
                  ],
                  [
                    0.5,
                    5.25
                  ],
                  [
                    0.5,
                    5.25
                  ],
                  [
                    0.9,
                    4.36
                  ],
                  [
                    2.02,
                    4
                  ],
                  [
                    2.02,
                    4
                  ],
                  [
                    2.78,
                    4.14
                  ],
                  [
                    3.39,
                    4.5
                  ],
                  [
                    3.39,
                    4.5
                  ],
                  [
                    3.03,
                    4.97
                  ],
                  [
                    2.56,
                    4.69
                  ],
                  [
                    2.02,
                    4.58
                  ],
                  [
                    2.02,
                    4.58
                  ],
                  [
                    1.41,
                    4.77
                  ],
                  [
                    1.22,
                    5.21
                  ],
                  [
                    1.22,
                    5.21
                  ],
                  [
                    1.35,
                    5.55
                  ],
                  [
                    1.7,
                    5.78
                  ],
                  [
                    2.17,
                    5.97
                  ],
                  [
                    2.17,
                    5.97
                  ],
                  [
                    2.79,
                    6.24
                  ],
                  [
                    3.31,
                    6.64
                  ],
                  [
                    3.51,
                    7.31
                  ],
                  [
                    3.51,
                    7.31
                  ],
                  [
                    3.32,
                    7.96
                  ],
                  [
                    2.78,
                    8.44
                  ],
                  [
                    1.9,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    0
                  ],
                  [
                    -0.28,
                    -0.12
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.19,
                    0.15
                  ],
                  [
                    0.21,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.29,
                    0
                  ],
                  [
                    0.15,
                    -0.14
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.15
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.15,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.21,
                    -0.08
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.13,
                    -0.16
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.36
                  ],
                  [
                    0.27,
                    -0.24
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.27,
                    0
                  ],
                  [
                    0.24,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.15,
                    -0.11
                  ],
                  [
                    -0.16,
                    -0.07
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.28,
                    0
                  ],
                  [
                    -0.13,
                    0.13
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.14
                  ],
                  [
                    0.09,
                    0.09
                  ],
                  [
                    0.15,
                    0.06
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.21,
                    0.08
                  ],
                  [
                    0.21,
                    0.1
                  ],
                  [
                    0.14,
                    0.17
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.24
                  ],
                  [
                    -0.12,
                    0.2
                  ],
                  [
                    -0.24,
                    0.12
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1969,
        ty: 3,
        parent: 1966,
        ks: {
          p: {
            a: 0,
            k: [
              10.038,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1972,
        ty: 4,
        parent: 1971,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.31,
                    0.18
                  ],
                  [
                    0.19,
                    0.34
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.19,
                    0.34
                  ],
                  [
                    -0.31,
                    0.18
                  ],
                  [
                    -0.36,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.31,
                    -0.18
                  ],
                  [
                    -0.19,
                    -0.34
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.19,
                    -0.34
                  ],
                  [
                    0.31,
                    -0.18
                  ],
                  [
                    0.36,
                    0
                  ]
                ],
                v: [
                  [
                    2.46,
                    8.62
                  ],
                  [
                    2.46,
                    8.62
                  ],
                  [
                    1.46,
                    8.35
                  ],
                  [
                    0.7,
                    7.56
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.42,
                    6.32
                  ],
                  [
                    0.7,
                    5.06
                  ],
                  [
                    1.46,
                    4.27
                  ],
                  [
                    2.46,
                    4
                  ],
                  [
                    2.46,
                    4
                  ],
                  [
                    3.46,
                    4.27
                  ],
                  [
                    4.21,
                    5.06
                  ],
                  [
                    4.5,
                    6.32
                  ],
                  [
                    4.5,
                    6.32
                  ],
                  [
                    4.21,
                    7.56
                  ],
                  [
                    3.46,
                    8.35
                  ],
                  [
                    2.46,
                    8.62
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.36,
                    0
                  ],
                  [
                    -0.31,
                    -0.18
                  ],
                  [
                    -0.19,
                    -0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0.19,
                    -0.34
                  ],
                  [
                    0.31,
                    -0.18
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.36,
                    0
                  ],
                  [
                    0.31,
                    0.18
                  ],
                  [
                    0.19,
                    0.34
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.48
                  ],
                  [
                    -0.19,
                    0.34
                  ],
                  [
                    -0.31,
                    0.18
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.23,
                    0.31
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.23,
                    0.31
                  ],
                  [
                    0.38,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.24,
                    -0.31
                  ],
                  [
                    0,
                    -0.51
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.24,
                    -0.31
                  ],
                  [
                    -0.37,
                    0
                  ]
                ],
                v: [
                  [
                    2.46,
                    8.01
                  ],
                  [
                    2.46,
                    8.01
                  ],
                  [
                    3.38,
                    7.54
                  ],
                  [
                    3.73,
                    6.32
                  ],
                  [
                    3.73,
                    6.32
                  ],
                  [
                    3.38,
                    5.09
                  ],
                  [
                    2.46,
                    4.61
                  ],
                  [
                    2.46,
                    4.61
                  ],
                  [
                    1.54,
                    5.09
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.19,
                    6.32
                  ],
                  [
                    1.54,
                    7.54
                  ],
                  [
                    2.46,
                    8.01
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.38,
                    0
                  ],
                  [
                    0.23,
                    -0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.51
                  ],
                  [
                    -0.23,
                    -0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.37,
                    0
                  ],
                  [
                    -0.24,
                    0.31
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0.24,
                    0.31
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1971,
        ty: 3,
        parent: 1966,
        ks: {
          p: {
            a: 0,
            k: [
              5.128,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1974,
        ty: 4,
        parent: 1973,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.5
                  ],
                  [
                    0.8,
                    8.5
                  ],
                  [
                    0.8,
                    2.6
                  ],
                  [
                    2.5,
                    2.6
                  ],
                  [
                    3.7,
                    2.7
                  ],
                  [
                    4.5,
                    3.3
                  ],
                  [
                    4.7,
                    4.3
                  ],
                  [
                    4.7,
                    4.3
                  ],
                  [
                    4.1,
                    5.7
                  ],
                  [
                    2.5,
                    6.2
                  ],
                  [
                    2.5,
                    6.2
                  ],
                  [
                    1.6,
                    6.2
                  ],
                  [
                    1.6,
                    8.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    1.6,
                    3.2
                  ],
                  [
                    1.6,
                    5.5
                  ],
                  [
                    2.5,
                    5.5
                  ],
                  [
                    3.6,
                    5.2
                  ],
                  [
                    4,
                    4.3
                  ],
                  [
                    4,
                    4.3
                  ],
                  [
                    3.6,
                    3.4
                  ],
                  [
                    2.4,
                    3.2
                  ],
                  [
                    2.4,
                    3.2
                  ],
                  [
                    1.6,
                    3.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.486,
                0.553,
                0.647
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1973,
        ty: 3,
        parent: 1966,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1966,
        ty: 3,
        parent: 1952,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1952,
        ty: 3,
        parent: 1951,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1951,
        ty: 3,
        parent: 1921,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1921,
        ty: 3,
        parent: 1920,
        ks: {
          p: {
            a: 0,
            k: [
              186.97,
              3.346
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1980,
        ty: 0,
        parent: 1976,
        ks: {},
        w: 27,
        h: 13,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1978"
      },
      {
        ind: 1976,
        ty: 3,
        parent: 1975,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1975,
        ty: 3,
        parent: 1920,
        ks: {
          p: {
            a: 0,
            k: [
              150.193,
              10.204
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1986,
        ty: 4,
        parent: 1985,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.9,
                    13.4
                  ],
                  [
                    3.9,
                    13.4
                  ],
                  [
                    2.3,
                    13
                  ],
                  [
                    1.1,
                    11.7
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    0.6,
                    9.8
                  ],
                  [
                    1.1,
                    7.9
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    3.7,
                    6.2
                  ],
                  [
                    3.7,
                    6.2
                  ],
                  [
                    5.7,
                    7.1
                  ],
                  [
                    6.5,
                    9.4
                  ],
                  [
                    6.5,
                    9.4
                  ],
                  [
                    6.5,
                    9.8
                  ],
                  [
                    6.4,
                    10.1
                  ],
                  [
                    6.4,
                    10.1
                  ],
                  [
                    1.8,
                    10.1
                  ],
                  [
                    2.5,
                    11.8
                  ],
                  [
                    4.1,
                    12.5
                  ],
                  [
                    4.1,
                    12.5
                  ],
                  [
                    5,
                    12.3
                  ],
                  [
                    5.8,
                    11.9
                  ],
                  [
                    5.8,
                    11.9
                  ],
                  [
                    6.2,
                    12.7
                  ],
                  [
                    5.2,
                    13.2
                  ],
                  [
                    3.9,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.9,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.1,
                    -0.7
                  ]
                ],
                v: [
                  [
                    1.8,
                    9.3
                  ],
                  [
                    1.8,
                    9.3
                  ],
                  [
                    5.4,
                    9.3
                  ],
                  [
                    5,
                    7.7
                  ],
                  [
                    3.8,
                    7.1
                  ],
                  [
                    3.8,
                    7.1
                  ],
                  [
                    2.5,
                    7.7
                  ],
                  [
                    1.8,
                    9.3
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1985,
        ty: 3,
        parent: 1984,
        ks: {
          p: {
            a: 0,
            k: [
              40.594,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1988,
        ty: 4,
        parent: 1987,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    13.2
                  ],
                  [
                    1.2,
                    13.2
                  ],
                  [
                    1.2,
                    6.4
                  ],
                  [
                    2.1,
                    6.4
                  ],
                  [
                    2.2,
                    7.6
                  ],
                  [
                    2.3,
                    7.6
                  ],
                  [
                    3.1,
                    6.6
                  ],
                  [
                    4.2,
                    6.2
                  ],
                  [
                    4.2,
                    6.2
                  ],
                  [
                    4.9,
                    6.4
                  ],
                  [
                    4.9,
                    6.4
                  ],
                  [
                    4.7,
                    7.4
                  ],
                  [
                    4.4,
                    7.3
                  ],
                  [
                    4,
                    7.3
                  ],
                  [
                    4,
                    7.3
                  ],
                  [
                    3.1,
                    7.6
                  ],
                  [
                    2.3,
                    8.8
                  ],
                  [
                    2.3,
                    8.8
                  ],
                  [
                    2.3,
                    13.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1987,
        ty: 3,
        parent: 1984,
        ks: {
          p: {
            a: 0,
            k: [
              35.701,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1990,
        ty: 4,
        parent: 1989,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0.4
                  ],
                  [
                    -1.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    13.4
                  ],
                  [
                    2.7,
                    13.4
                  ],
                  [
                    1.3,
                    12.9
                  ],
                  [
                    0.7,
                    11.5
                  ],
                  [
                    0.7,
                    11.5
                  ],
                  [
                    1.7,
                    9.7
                  ],
                  [
                    4.9,
                    8.9
                  ],
                  [
                    4.9,
                    8.9
                  ],
                  [
                    4.8,
                    8.1
                  ],
                  [
                    4.4,
                    7.4
                  ],
                  [
                    3.5,
                    7.2
                  ],
                  [
                    3.5,
                    7.2
                  ],
                  [
                    2.4,
                    7.4
                  ],
                  [
                    1.5,
                    7.9
                  ],
                  [
                    1.5,
                    7.9
                  ],
                  [
                    1,
                    7.1
                  ],
                  [
                    2.2,
                    6.5
                  ],
                  [
                    3.7,
                    6.2
                  ],
                  [
                    3.7,
                    6.2
                  ],
                  [
                    5.5,
                    7
                  ],
                  [
                    6.1,
                    9
                  ],
                  [
                    6.1,
                    9
                  ],
                  [
                    6.1,
                    13.2
                  ],
                  [
                    5.1,
                    13.2
                  ],
                  [
                    5.1,
                    12.4
                  ],
                  [
                    5,
                    12.4
                  ],
                  [
                    4,
                    13.1
                  ],
                  [
                    2.7,
                    13.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.7,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.1,
                    12.5
                  ],
                  [
                    3.1,
                    12.5
                  ],
                  [
                    4,
                    12.2
                  ],
                  [
                    4.9,
                    11.6
                  ],
                  [
                    4.9,
                    11.6
                  ],
                  [
                    4.9,
                    9.7
                  ],
                  [
                    2.5,
                    10.3
                  ],
                  [
                    1.9,
                    11.4
                  ],
                  [
                    1.9,
                    11.4
                  ],
                  [
                    2.2,
                    12.2
                  ],
                  [
                    3.1,
                    12.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.1,
                    0.1
                  ],
                  [
                    -0.5,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1989,
        ty: 3,
        parent: 1984,
        ks: {
          p: {
            a: 0,
            k: [
              28.595,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1992,
        ty: 4,
        parent: 1991,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.5
                  ],
                  [
                    -0.1,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.5
                  ],
                  [
                    -0.1,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.5
                  ],
                  [
                    -0.1,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.5
                  ],
                  [
                    -0.1,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.7,
                    13.2
                  ],
                  [
                    2.3,
                    13.2
                  ],
                  [
                    0.3,
                    4
                  ],
                  [
                    1.5,
                    4
                  ],
                  [
                    2.5,
                    9
                  ],
                  [
                    2.8,
                    10.5
                  ],
                  [
                    3,
                    12
                  ],
                  [
                    3,
                    12
                  ],
                  [
                    3.1,
                    12
                  ],
                  [
                    3.4,
                    10.5
                  ],
                  [
                    3.8,
                    9
                  ],
                  [
                    3.8,
                    9
                  ],
                  [
                    5,
                    4
                  ],
                  [
                    6.1,
                    4
                  ],
                  [
                    7.4,
                    9
                  ],
                  [
                    7.7,
                    10.5
                  ],
                  [
                    8.1,
                    12
                  ],
                  [
                    8.1,
                    12
                  ],
                  [
                    8.1,
                    12
                  ],
                  [
                    8.4,
                    10.5
                  ],
                  [
                    8.6,
                    9
                  ],
                  [
                    8.6,
                    9
                  ],
                  [
                    9.6,
                    4
                  ],
                  [
                    10.7,
                    4
                  ],
                  [
                    8.8,
                    13.2
                  ],
                  [
                    7.4,
                    13.2
                  ],
                  [
                    6,
                    7.7
                  ],
                  [
                    5.8,
                    6.6
                  ],
                  [
                    5.6,
                    5.6
                  ],
                  [
                    5.6,
                    5.6
                  ],
                  [
                    5.5,
                    5.6
                  ],
                  [
                    5.3,
                    6.6
                  ],
                  [
                    5.1,
                    7.7
                  ],
                  [
                    5.1,
                    7.7
                  ],
                  [
                    3.7,
                    13.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.5
                  ],
                  [
                    0.1,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.5
                  ],
                  [
                    0.1,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.4
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.4
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1991,
        ty: 3,
        parent: 1984,
        ks: {
          p: {
            a: 0,
            k: [
              17.512,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1994,
        ty: 4,
        parent: 1993,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.3,
                    13.2
                  ],
                  [
                    1.3,
                    13.2
                  ],
                  [
                    1.3,
                    4
                  ],
                  [
                    2.7,
                    4
                  ],
                  [
                    4.5,
                    8.9
                  ],
                  [
                    4.8,
                    9.9
                  ],
                  [
                    5.1,
                    10.9
                  ],
                  [
                    5.1,
                    10.9
                  ],
                  [
                    5.2,
                    10.9
                  ],
                  [
                    5.5,
                    9.9
                  ],
                  [
                    5.8,
                    8.9
                  ],
                  [
                    5.8,
                    8.9
                  ],
                  [
                    7.6,
                    4
                  ],
                  [
                    9,
                    4
                  ],
                  [
                    9,
                    13.2
                  ],
                  [
                    7.9,
                    13.2
                  ],
                  [
                    7.9,
                    8.2
                  ],
                  [
                    7.9,
                    6.8
                  ],
                  [
                    8,
                    5.4
                  ],
                  [
                    8,
                    5.4
                  ],
                  [
                    8,
                    5.4
                  ],
                  [
                    7.3,
                    7.5
                  ],
                  [
                    5.5,
                    12.3
                  ],
                  [
                    4.7,
                    12.3
                  ],
                  [
                    3,
                    7.5
                  ],
                  [
                    2.2,
                    5.4
                  ],
                  [
                    2.2,
                    5.4
                  ],
                  [
                    2.3,
                    6.8
                  ],
                  [
                    2.3,
                    8.2
                  ],
                  [
                    2.3,
                    8.2
                  ],
                  [
                    2.3,
                    13.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1993,
        ty: 3,
        parent: 1984,
        ks: {
          p: {
            a: 0,
            k: [
              7.261,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1996,
        ty: 4,
        parent: 1995,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.5
                  ],
                  [
                    -0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.5
                  ],
                  [
                    -0.2,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    4.3,
                    13.2
                  ],
                  [
                    3,
                    13.2
                  ],
                  [
                    0,
                    4
                  ],
                  [
                    1.3,
                    4
                  ],
                  [
                    2.7,
                    9
                  ],
                  [
                    3.2,
                    10.5
                  ],
                  [
                    3.6,
                    12
                  ],
                  [
                    3.6,
                    12
                  ],
                  [
                    3.7,
                    12
                  ],
                  [
                    4.1,
                    10.5
                  ],
                  [
                    4.6,
                    9
                  ],
                  [
                    4.6,
                    9
                  ],
                  [
                    6.1,
                    4
                  ],
                  [
                    7.3,
                    4
                  ],
                  [
                    4.3,
                    13.2
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.5
                  ],
                  [
                    0.1,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0.1,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1995,
        ty: 3,
        parent: 1984,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1984,
        ty: 3,
        parent: 1983,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1983,
        ty: 3,
        parent: 1982,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1982,
        ty: 3,
        parent: 1981,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              14.988
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2001,
        ty: 0,
        parent: 1997,
        ks: {},
        w: 81,
        h: 15,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1999"
      },
      {
        ind: 1997,
        ty: 3,
        parent: 1981,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1981,
        ty: 3,
        parent: 1920,
        ks: {
          p: {
            a: 0,
            k: [
              27.646,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1920,
        ty: 3,
        parent: 1852,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1852,
        ty: 3,
        parent: 1851,
        ks: {
          p: {
            a: 0,
            k: [
              10.58,
              102.27
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2010,
        ty: 4,
        parent: 2009,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.2
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.6,
                    8.6
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    1.6,
                    8.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.4,
                    11.1
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.6
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.1
                  ],
                  [
                    1.6,
                    8.1
                  ],
                  [
                    4.8,
                    8.1
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.6,
                    8.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2009,
        ty: 3,
        parent: 2008,
        ks: {
          p: {
            a: 0,
            k: [
              46.781,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2012,
        ty: 4,
        parent: 2011,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.7
                  ],
                  [
                    2,
                    6.7
                  ],
                  [
                    2.7,
                    5.8
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.1,
                    6.5
                  ],
                  [
                    3.9,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    2.7,
                    6.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2011,
        ty: 3,
        parent: 2008,
        ks: {
          p: {
            a: 0,
            k: [
              42.499,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2014,
        ty: 4,
        parent: 2013,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    11.7
                  ],
                  [
                    3.3,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.8
                  ],
                  [
                    5.7,
                    6.9
                  ],
                  [
                    6.1,
                    8.6
                  ],
                  [
                    6.1,
                    8.6
                  ],
                  [
                    5.7,
                    10.3
                  ],
                  [
                    4.7,
                    11.4
                  ],
                  [
                    3.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    10.9
                  ],
                  [
                    3.3,
                    10.9
                  ],
                  [
                    4.6,
                    10.3
                  ],
                  [
                    5.1,
                    8.6
                  ],
                  [
                    5.1,
                    8.6
                  ],
                  [
                    4.6,
                    6.9
                  ],
                  [
                    3.3,
                    6.3
                  ],
                  [
                    3.3,
                    6.3
                  ],
                  [
                    2.1,
                    6.9
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    2.1,
                    10.3
                  ],
                  [
                    3.3,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2013,
        ty: 3,
        parent: 2008,
        ks: {
          p: {
            a: 0,
            k: [
              35.811,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2016,
        ty: 4,
        parent: 2015,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    11.7
                  ],
                  [
                    2.1,
                    11.7
                  ],
                  [
                    1.3,
                    11.4
                  ],
                  [
                    1,
                    10.4
                  ],
                  [
                    1,
                    10.4
                  ],
                  [
                    1,
                    2.8
                  ],
                  [
                    2,
                    2.8
                  ],
                  [
                    2,
                    10.5
                  ],
                  [
                    2.1,
                    10.8
                  ],
                  [
                    2.3,
                    10.9
                  ],
                  [
                    2.3,
                    10.9
                  ],
                  [
                    2.4,
                    10.9
                  ],
                  [
                    2.5,
                    10.9
                  ],
                  [
                    2.5,
                    10.9
                  ],
                  [
                    2.7,
                    11.6
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.1,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2015,
        ty: 3,
        parent: 2008,
        ks: {
          p: {
            a: 0,
            k: [
              32.664,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2018,
        ty: 4,
        parent: 2017,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -1.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.3
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.5,
                    8.5
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.2,
                    7.1
                  ],
                  [
                    3.8,
                    6.5
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    2.1,
                    6.5
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    0.9,
                    6.2
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    11.6
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    3.5,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    10.9
                  ],
                  [
                    2.7,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    8.5
                  ],
                  [
                    2.2,
                    9
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.9,
                    10.7
                  ],
                  [
                    2.7,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2017,
        ty: 3,
        parent: 2008,
        ks: {
          p: {
            a: 0,
            k: [
              26.445,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2020,
        ty: 4,
        parent: 2019,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    14.4
                  ],
                  [
                    3,
                    14.4
                  ],
                  [
                    1.2,
                    13.9
                  ],
                  [
                    0.6,
                    12.7
                  ],
                  [
                    0.6,
                    12.7
                  ],
                  [
                    0.8,
                    12
                  ],
                  [
                    1.4,
                    11.4
                  ],
                  [
                    1.4,
                    11.4
                  ],
                  [
                    1.4,
                    11.3
                  ],
                  [
                    1.1,
                    10.9
                  ],
                  [
                    0.9,
                    10.4
                  ],
                  [
                    0.9,
                    10.4
                  ],
                  [
                    1.1,
                    9.7
                  ],
                  [
                    1.6,
                    9.2
                  ],
                  [
                    1.6,
                    9.2
                  ],
                  [
                    1.6,
                    9.2
                  ],
                  [
                    1,
                    8.5
                  ],
                  [
                    0.8,
                    7.6
                  ],
                  [
                    0.8,
                    7.6
                  ],
                  [
                    1.1,
                    6.4
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3,
                    5.4
                  ],
                  [
                    3,
                    5.4
                  ],
                  [
                    3.5,
                    5.5
                  ],
                  [
                    3.9,
                    5.6
                  ],
                  [
                    3.9,
                    5.6
                  ],
                  [
                    6,
                    5.6
                  ],
                  [
                    6,
                    6.4
                  ],
                  [
                    4.7,
                    6.4
                  ],
                  [
                    5.1,
                    6.9
                  ],
                  [
                    5.2,
                    7.6
                  ],
                  [
                    5.2,
                    7.6
                  ],
                  [
                    4.9,
                    8.7
                  ],
                  [
                    4.1,
                    9.4
                  ],
                  [
                    3,
                    9.7
                  ],
                  [
                    3,
                    9.7
                  ],
                  [
                    2.1,
                    9.5
                  ],
                  [
                    2.1,
                    9.5
                  ],
                  [
                    1.9,
                    9.8
                  ],
                  [
                    1.8,
                    10.2
                  ],
                  [
                    1.8,
                    10.2
                  ],
                  [
                    2,
                    10.7
                  ],
                  [
                    2.8,
                    10.8
                  ],
                  [
                    2.8,
                    10.8
                  ],
                  [
                    4,
                    10.8
                  ],
                  [
                    5.5,
                    11.2
                  ],
                  [
                    6.1,
                    12.3
                  ],
                  [
                    6.1,
                    12.3
                  ],
                  [
                    5.7,
                    13.3
                  ],
                  [
                    4.7,
                    14.1
                  ],
                  [
                    3,
                    14.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    9
                  ],
                  [
                    3,
                    9
                  ],
                  [
                    3.9,
                    8.6
                  ],
                  [
                    4.3,
                    7.6
                  ],
                  [
                    4.3,
                    7.6
                  ],
                  [
                    3.9,
                    6.6
                  ],
                  [
                    3,
                    6.2
                  ],
                  [
                    3,
                    6.2
                  ],
                  [
                    2.1,
                    6.6
                  ],
                  [
                    1.8,
                    7.6
                  ],
                  [
                    1.8,
                    7.6
                  ],
                  [
                    2.1,
                    8.6
                  ],
                  [
                    3,
                    9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    13.6
                  ],
                  [
                    3.2,
                    13.6
                  ],
                  [
                    4.6,
                    13.3
                  ],
                  [
                    5.1,
                    12.4
                  ],
                  [
                    5.1,
                    12.4
                  ],
                  [
                    4.8,
                    11.8
                  ],
                  [
                    3.9,
                    11.7
                  ],
                  [
                    3.9,
                    11.7
                  ],
                  [
                    2.8,
                    11.7
                  ],
                  [
                    2.5,
                    11.7
                  ],
                  [
                    2.1,
                    11.6
                  ],
                  [
                    2.1,
                    11.6
                  ],
                  [
                    1.6,
                    12.1
                  ],
                  [
                    1.4,
                    12.6
                  ],
                  [
                    1.4,
                    12.6
                  ],
                  [
                    1.9,
                    13.4
                  ],
                  [
                    3.2,
                    13.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2019,
        ty: 3,
        parent: 2008,
        ks: {
          p: {
            a: 0,
            k: [
              20.225,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2022,
        ty: 4,
        parent: 2021,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.5
                  ],
                  [
                    2,
                    6.5
                  ],
                  [
                    2.9,
                    5.7
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    5.4,
                    6
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    4.8,
                    7.9
                  ],
                  [
                    4.5,
                    6.7
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    2.8,
                    6.6
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2021,
        ty: 3,
        parent: 2008,
        ks: {
          p: {
            a: 0,
            k: [
              13.475,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2024,
        ty: 4,
        parent: 2023,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -1.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.3
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.5,
                    8.5
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.2,
                    7.1
                  ],
                  [
                    3.8,
                    6.5
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    2.1,
                    6.5
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    0.9,
                    6.2
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    11.6
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    3.5,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    10.9
                  ],
                  [
                    2.7,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    8.5
                  ],
                  [
                    2.2,
                    9
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.9,
                    10.7
                  ],
                  [
                    2.7,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2023,
        ty: 3,
        parent: 2008,
        ks: {
          p: {
            a: 0,
            k: [
              7.256,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2026,
        ty: 4,
        parent: 2025,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.7,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    3.5
                  ],
                  [
                    3.5,
                    3.5
                  ],
                  [
                    5,
                    3.7
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    6.3,
                    5.5
                  ],
                  [
                    6.3,
                    5.5
                  ],
                  [
                    6,
                    6.6
                  ],
                  [
                    5.1,
                    7.2
                  ],
                  [
                    5.1,
                    7.2
                  ],
                  [
                    5.1,
                    7.3
                  ],
                  [
                    6.3,
                    7.9
                  ],
                  [
                    6.8,
                    9.2
                  ],
                  [
                    6.8,
                    9.2
                  ],
                  [
                    6.4,
                    10.5
                  ],
                  [
                    5.3,
                    11.3
                  ],
                  [
                    3.7,
                    11.6
                  ],
                  [
                    3.7,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.4,
                    0.1
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.1
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    4.3
                  ],
                  [
                    2.1,
                    6.9
                  ],
                  [
                    3.3,
                    6.9
                  ],
                  [
                    4.8,
                    6.6
                  ],
                  [
                    5.3,
                    5.6
                  ],
                  [
                    5.3,
                    5.6
                  ],
                  [
                    4.8,
                    4.6
                  ],
                  [
                    3.4,
                    4.3
                  ],
                  [
                    3.4,
                    4.3
                  ],
                  [
                    2.1,
                    4.3
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    7.7
                  ],
                  [
                    2.1,
                    10.8
                  ],
                  [
                    3.5,
                    10.8
                  ],
                  [
                    5.2,
                    10.4
                  ],
                  [
                    5.8,
                    9.2
                  ],
                  [
                    5.8,
                    9.2
                  ],
                  [
                    5.2,
                    8.1
                  ],
                  [
                    3.5,
                    7.7
                  ],
                  [
                    3.5,
                    7.7
                  ],
                  [
                    2.1,
                    7.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2025,
        ty: 3,
        parent: 2008,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2008,
        ty: 3,
        parent: 2007,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2007,
        ty: 3,
        parent: 2006,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2006,
        ty: 3,
        parent: 2005,
        ks: {
          p: {
            a: 0,
            k: [
              21.159,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2036,
        ty: 0,
        parent: 2027,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "2034"
      },
      {
        ind: 2027,
        ty: 3,
        parent: 2005,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2005,
        ty: 3,
        parent: 2004,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              19.527
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2042,
        ty: 4,
        parent: 2041,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.7
                  ],
                  [
                    2,
                    6.7
                  ],
                  [
                    2.7,
                    5.8
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.1,
                    6.5
                  ],
                  [
                    3.9,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    2.7,
                    6.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2041,
        ty: 3,
        parent: 2040,
        ks: {
          p: {
            a: 0,
            k: [
              41.499,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2044,
        ty: 4,
        parent: 2043,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.2
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.6,
                    8.6
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    1.6,
                    8.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.4,
                    11.1
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.6
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.1
                  ],
                  [
                    1.6,
                    8.1
                  ],
                  [
                    4.8,
                    8.1
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.6,
                    8.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2043,
        ty: 3,
        parent: 2040,
        ks: {
          p: {
            a: 0,
            k: [
              35.379,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2046,
        ty: 4,
        parent: 2045,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.2
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.6,
                    8.6
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    1.6,
                    8.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.4,
                    11.1
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.6
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.1
                  ],
                  [
                    1.6,
                    8.1
                  ],
                  [
                    4.8,
                    8.1
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.6,
                    8.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2045,
        ty: 3,
        parent: 2040,
        ks: {
          p: {
            a: 0,
            k: [
              29.258,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2048,
        ty: 4,
        parent: 2047,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.5
                  ],
                  [
                    2,
                    6.5
                  ],
                  [
                    2.9,
                    5.7
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    5.4,
                    6
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    4.8,
                    7.9
                  ],
                  [
                    4.5,
                    6.7
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    2.8,
                    6.6
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2047,
        ty: 3,
        parent: 2040,
        ks: {
          p: {
            a: 0,
            k: [
              22.508,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2050,
        ty: 4,
        parent: 2049,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    1,
                    3.2
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    2,
                    3.2
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2,
                    4.2
                  ],
                  [
                    1.5,
                    4.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2049,
        ty: 3,
        parent: 2040,
        ks: {
          p: {
            a: 0,
            k: [
              19.472,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2052,
        ty: 4,
        parent: 2051,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    14.4
                  ],
                  [
                    3,
                    14.4
                  ],
                  [
                    1.2,
                    13.9
                  ],
                  [
                    0.6,
                    12.7
                  ],
                  [
                    0.6,
                    12.7
                  ],
                  [
                    0.8,
                    12
                  ],
                  [
                    1.4,
                    11.4
                  ],
                  [
                    1.4,
                    11.4
                  ],
                  [
                    1.4,
                    11.3
                  ],
                  [
                    1.1,
                    10.9
                  ],
                  [
                    0.9,
                    10.4
                  ],
                  [
                    0.9,
                    10.4
                  ],
                  [
                    1.1,
                    9.7
                  ],
                  [
                    1.6,
                    9.2
                  ],
                  [
                    1.6,
                    9.2
                  ],
                  [
                    1.6,
                    9.2
                  ],
                  [
                    1,
                    8.5
                  ],
                  [
                    0.8,
                    7.6
                  ],
                  [
                    0.8,
                    7.6
                  ],
                  [
                    1.1,
                    6.4
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3,
                    5.4
                  ],
                  [
                    3,
                    5.4
                  ],
                  [
                    3.5,
                    5.5
                  ],
                  [
                    3.9,
                    5.6
                  ],
                  [
                    3.9,
                    5.6
                  ],
                  [
                    6,
                    5.6
                  ],
                  [
                    6,
                    6.4
                  ],
                  [
                    4.7,
                    6.4
                  ],
                  [
                    5.1,
                    6.9
                  ],
                  [
                    5.2,
                    7.6
                  ],
                  [
                    5.2,
                    7.6
                  ],
                  [
                    4.9,
                    8.7
                  ],
                  [
                    4.1,
                    9.4
                  ],
                  [
                    3,
                    9.7
                  ],
                  [
                    3,
                    9.7
                  ],
                  [
                    2.1,
                    9.5
                  ],
                  [
                    2.1,
                    9.5
                  ],
                  [
                    1.9,
                    9.8
                  ],
                  [
                    1.8,
                    10.2
                  ],
                  [
                    1.8,
                    10.2
                  ],
                  [
                    2,
                    10.7
                  ],
                  [
                    2.8,
                    10.8
                  ],
                  [
                    2.8,
                    10.8
                  ],
                  [
                    4,
                    10.8
                  ],
                  [
                    5.5,
                    11.2
                  ],
                  [
                    6.1,
                    12.3
                  ],
                  [
                    6.1,
                    12.3
                  ],
                  [
                    5.7,
                    13.3
                  ],
                  [
                    4.7,
                    14.1
                  ],
                  [
                    3,
                    14.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    9
                  ],
                  [
                    3,
                    9
                  ],
                  [
                    3.9,
                    8.6
                  ],
                  [
                    4.3,
                    7.6
                  ],
                  [
                    4.3,
                    7.6
                  ],
                  [
                    3.9,
                    6.6
                  ],
                  [
                    3,
                    6.2
                  ],
                  [
                    3,
                    6.2
                  ],
                  [
                    2.1,
                    6.6
                  ],
                  [
                    1.8,
                    7.6
                  ],
                  [
                    1.8,
                    7.6
                  ],
                  [
                    2.1,
                    8.6
                  ],
                  [
                    3,
                    9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    13.6
                  ],
                  [
                    3.2,
                    13.6
                  ],
                  [
                    4.6,
                    13.3
                  ],
                  [
                    5.1,
                    12.4
                  ],
                  [
                    5.1,
                    12.4
                  ],
                  [
                    4.8,
                    11.8
                  ],
                  [
                    3.9,
                    11.7
                  ],
                  [
                    3.9,
                    11.7
                  ],
                  [
                    2.8,
                    11.7
                  ],
                  [
                    2.5,
                    11.7
                  ],
                  [
                    2.1,
                    11.6
                  ],
                  [
                    2.1,
                    11.6
                  ],
                  [
                    1.6,
                    12.1
                  ],
                  [
                    1.4,
                    12.6
                  ],
                  [
                    1.4,
                    12.6
                  ],
                  [
                    1.9,
                    13.4
                  ],
                  [
                    3.2,
                    13.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2051,
        ty: 3,
        parent: 2040,
        ks: {
          p: {
            a: 0,
            k: [
              13.253,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2054,
        ty: 4,
        parent: 2053,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.5
                  ],
                  [
                    2,
                    6.5
                  ],
                  [
                    2.9,
                    5.7
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    5.4,
                    6
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    4.8,
                    7.9
                  ],
                  [
                    4.5,
                    6.7
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    2.8,
                    6.6
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2053,
        ty: 3,
        parent: 2040,
        ks: {
          p: {
            a: 0,
            k: [
              6.503,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2056,
        ty: 4,
        parent: 2055,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    5.9,
                    11.6
                  ],
                  [
                    1.1,
                    11.6
                  ],
                  [
                    1.1,
                    3.5
                  ],
                  [
                    5.8,
                    3.5
                  ],
                  [
                    5.8,
                    4.4
                  ],
                  [
                    2.1,
                    4.4
                  ],
                  [
                    2.1,
                    6.9
                  ],
                  [
                    5.2,
                    6.9
                  ],
                  [
                    5.2,
                    7.8
                  ],
                  [
                    2.1,
                    7.8
                  ],
                  [
                    2.1,
                    10.7
                  ],
                  [
                    5.9,
                    10.7
                  ],
                  [
                    5.9,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2055,
        ty: 3,
        parent: 2040,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2040,
        ty: 3,
        parent: 2039,
        ks: {
          p: {
            a: 0,
            k: [
              84.494,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2059,
        ty: 4,
        parent: 2058,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.2
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.6,
                    8.6
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    1.6,
                    8.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.4,
                    11.1
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.6
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.1
                  ],
                  [
                    1.6,
                    8.1
                  ],
                  [
                    4.8,
                    8.1
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.6,
                    8.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2058,
        ty: 3,
        parent: 2057,
        ks: {
          p: {
            a: 0,
            k: [
              39.971,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2061,
        ty: 4,
        parent: 2060,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.7
                  ],
                  [
                    2,
                    6.7
                  ],
                  [
                    2.7,
                    5.8
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.1,
                    6.5
                  ],
                  [
                    3.9,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    2.7,
                    6.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2060,
        ty: 3,
        parent: 2057,
        ks: {
          p: {
            a: 0,
            k: [
              35.689,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2063,
        ty: 4,
        parent: 2062,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -1.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    2.4,
                    11.7
                  ],
                  [
                    2.4,
                    11.7
                  ],
                  [
                    1.1,
                    11.3
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    0.6,
                    10
                  ],
                  [
                    1.5,
                    8.5
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.3,
                    7.8
                  ],
                  [
                    4.2,
                    7.1
                  ],
                  [
                    3.8,
                    6.5
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    3.1,
                    6.3
                  ],
                  [
                    2.1,
                    6.5
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    1.3,
                    6.9
                  ],
                  [
                    0.9,
                    6.2
                  ],
                  [
                    1.9,
                    5.7
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.9,
                    6.1
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    7.9
                  ],
                  [
                    5.3,
                    11.6
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    4.4,
                    10.9
                  ],
                  [
                    3.5,
                    11.5
                  ],
                  [
                    2.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.7,
                    10.9
                  ],
                  [
                    2.7,
                    10.9
                  ],
                  [
                    3.5,
                    10.7
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    10.1
                  ],
                  [
                    4.3,
                    8.5
                  ],
                  [
                    2.2,
                    9
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.6,
                    10
                  ],
                  [
                    1.9,
                    10.7
                  ],
                  [
                    2.7,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2062,
        ty: 3,
        parent: 2057,
        ks: {
          p: {
            a: 0,
            k: [
              29.47,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2065,
        ty: 4,
        parent: 2064,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.1,
                    11.6
                  ],
                  [
                    2,
                    11.6
                  ],
                  [
                    0.3,
                    5.6
                  ],
                  [
                    1.3,
                    5.6
                  ],
                  [
                    2.2,
                    9.1
                  ],
                  [
                    2.4,
                    9.9
                  ],
                  [
                    2.6,
                    10.7
                  ],
                  [
                    2.6,
                    10.7
                  ],
                  [
                    2.6,
                    10.7
                  ],
                  [
                    2.8,
                    9.9
                  ],
                  [
                    3,
                    9.1
                  ],
                  [
                    3,
                    9.1
                  ],
                  [
                    4,
                    5.6
                  ],
                  [
                    4.9,
                    5.6
                  ],
                  [
                    5.9,
                    9.1
                  ],
                  [
                    6.1,
                    9.9
                  ],
                  [
                    6.3,
                    10.7
                  ],
                  [
                    6.3,
                    10.7
                  ],
                  [
                    6.4,
                    10.7
                  ],
                  [
                    6.5,
                    9.9
                  ],
                  [
                    6.7,
                    9.1
                  ],
                  [
                    6.7,
                    9.1
                  ],
                  [
                    7.6,
                    5.6
                  ],
                  [
                    8.6,
                    5.6
                  ],
                  [
                    7,
                    11.6
                  ],
                  [
                    5.7,
                    11.6
                  ],
                  [
                    4.9,
                    8.4
                  ],
                  [
                    4.7,
                    7.5
                  ],
                  [
                    4.5,
                    6.6
                  ],
                  [
                    4.5,
                    6.6
                  ],
                  [
                    4.4,
                    6.6
                  ],
                  [
                    4.2,
                    7.5
                  ],
                  [
                    4,
                    8.4
                  ],
                  [
                    4,
                    8.4
                  ],
                  [
                    3.1,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    -0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2064,
        ty: 3,
        parent: 2057,
        ks: {
          p: {
            a: 0,
            k: [
              20.61,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2067,
        ty: 4,
        parent: 2066,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2.2,
                    11.6
                  ],
                  [
                    1.2,
                    11.6
                  ],
                  [
                    1.2,
                    6.4
                  ],
                  [
                    0.4,
                    6.4
                  ],
                  [
                    0.4,
                    5.7
                  ],
                  [
                    1.2,
                    5.6
                  ],
                  [
                    1.2,
                    4.6
                  ],
                  [
                    1.6,
                    3.2
                  ],
                  [
                    2.9,
                    2.7
                  ],
                  [
                    2.9,
                    2.7
                  ],
                  [
                    3.5,
                    2.7
                  ],
                  [
                    3.9,
                    2.8
                  ],
                  [
                    3.9,
                    2.8
                  ],
                  [
                    3.7,
                    3.6
                  ],
                  [
                    3,
                    3.5
                  ],
                  [
                    3,
                    3.5
                  ],
                  [
                    2.2,
                    4.6
                  ],
                  [
                    2.2,
                    4.6
                  ],
                  [
                    2.2,
                    5.6
                  ],
                  [
                    3.5,
                    5.6
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    2.2,
                    6.4
                  ],
                  [
                    2.2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    6.5,
                    11.7
                  ],
                  [
                    6.5,
                    11.7
                  ],
                  [
                    5.2,
                    11.2
                  ],
                  [
                    4.8,
                    9.7
                  ],
                  [
                    4.8,
                    9.7
                  ],
                  [
                    4.8,
                    6.4
                  ],
                  [
                    3.9,
                    6.4
                  ],
                  [
                    3.9,
                    5.7
                  ],
                  [
                    4.8,
                    5.6
                  ],
                  [
                    5,
                    3.9
                  ],
                  [
                    5.8,
                    3.9
                  ],
                  [
                    5.8,
                    5.6
                  ],
                  [
                    7.4,
                    5.6
                  ],
                  [
                    7.4,
                    6.4
                  ],
                  [
                    5.8,
                    6.4
                  ],
                  [
                    5.8,
                    9.7
                  ],
                  [
                    6,
                    10.6
                  ],
                  [
                    6.7,
                    10.9
                  ],
                  [
                    6.7,
                    10.9
                  ],
                  [
                    7.1,
                    10.9
                  ],
                  [
                    7.4,
                    10.7
                  ],
                  [
                    7.4,
                    10.7
                  ],
                  [
                    7.6,
                    11.5
                  ],
                  [
                    7.1,
                    11.7
                  ],
                  [
                    6.5,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2066,
        ty: 3,
        parent: 2057,
        ks: {
          p: {
            a: 0,
            k: [
              13.278,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2069,
        ty: 4,
        parent: 2068,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    11.7
                  ],
                  [
                    3.3,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.8
                  ],
                  [
                    5.7,
                    6.9
                  ],
                  [
                    6.1,
                    8.6
                  ],
                  [
                    6.1,
                    8.6
                  ],
                  [
                    5.7,
                    10.3
                  ],
                  [
                    4.7,
                    11.4
                  ],
                  [
                    3.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    10.9
                  ],
                  [
                    3.3,
                    10.9
                  ],
                  [
                    4.6,
                    10.3
                  ],
                  [
                    5.1,
                    8.6
                  ],
                  [
                    5.1,
                    8.6
                  ],
                  [
                    4.6,
                    6.9
                  ],
                  [
                    3.3,
                    6.3
                  ],
                  [
                    3.3,
                    6.3
                  ],
                  [
                    2.1,
                    6.9
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    2.1,
                    10.3
                  ],
                  [
                    3.3,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2068,
        ty: 3,
        parent: 2057,
        ks: {
          p: {
            a: 0,
            k: [
              6.59,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2071,
        ty: 4,
        parent: 2070,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    1.1,
                    9.8
                  ],
                  [
                    2.2,
                    10.6
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    4.6,
                    10.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    4.9,
                    8.8
                  ],
                  [
                    4.4,
                    8.4
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    2.6,
                    7.6
                  ],
                  [
                    1.8,
                    7.2
                  ],
                  [
                    1.2,
                    6.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    1.2,
                    4.4
                  ],
                  [
                    2.1,
                    3.6
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    4.8,
                    3.6
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.3,
                    5
                  ],
                  [
                    4.5,
                    4.4
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    2.4,
                    4.6
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2.2,
                    6.1
                  ],
                  [
                    2.7,
                    6.5
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    4.4,
                    7.3
                  ],
                  [
                    5.3,
                    7.7
                  ],
                  [
                    5.9,
                    8.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    5.8,
                    10.6
                  ],
                  [
                    4.8,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2070,
        ty: 3,
        parent: 2057,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2057,
        ty: 3,
        parent: 2039,
        ks: {
          p: {
            a: 0,
            k: [
              35.934,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2074,
        ty: 4,
        parent: 2073,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.2,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.7
                  ],
                  [
                    2,
                    6.7
                  ],
                  [
                    2.7,
                    5.8
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    3.7,
                    5.4
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.3,
                    5.6
                  ],
                  [
                    4.1,
                    6.5
                  ],
                  [
                    3.9,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    3.5,
                    6.4
                  ],
                  [
                    2.7,
                    6.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    7.7
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2073,
        ty: 3,
        parent: 2072,
        ks: {
          p: {
            a: 0,
            k: [
              29.184,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2076,
        ty: 4,
        parent: 2075,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    11.7
                  ],
                  [
                    3.3,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    4.7,
                    5.8
                  ],
                  [
                    5.7,
                    6.9
                  ],
                  [
                    6.1,
                    8.6
                  ],
                  [
                    6.1,
                    8.6
                  ],
                  [
                    5.7,
                    10.3
                  ],
                  [
                    4.7,
                    11.4
                  ],
                  [
                    3.3,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    -0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3.3,
                    10.9
                  ],
                  [
                    3.3,
                    10.9
                  ],
                  [
                    4.6,
                    10.3
                  ],
                  [
                    5.1,
                    8.6
                  ],
                  [
                    5.1,
                    8.6
                  ],
                  [
                    4.6,
                    6.9
                  ],
                  [
                    3.3,
                    6.3
                  ],
                  [
                    3.3,
                    6.3
                  ],
                  [
                    2.1,
                    6.9
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    1.6,
                    8.6
                  ],
                  [
                    2.1,
                    10.3
                  ],
                  [
                    3.3,
                    10.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2075,
        ty: 3,
        parent: 2072,
        ks: {
          p: {
            a: 0,
            k: [
              22.496,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2078,
        ty: 4,
        parent: 2077,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    2,
                    5.6
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1.5,
                    4.4
                  ],
                  [
                    1,
                    4.2
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    0.9,
                    3.7
                  ],
                  [
                    1,
                    3.2
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    1.5,
                    3
                  ],
                  [
                    2,
                    3.2
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2.2,
                    3.7
                  ],
                  [
                    2,
                    4.2
                  ],
                  [
                    1.5,
                    4.4
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.2
                  ],
                  [
                    0.1,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    -0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2077,
        ty: 3,
        parent: 2072,
        ks: {
          p: {
            a: 0,
            k: [
              19.46,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2080,
        ty: 4,
        parent: 2079,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    2,
                    11.6
                  ],
                  [
                    1,
                    11.6
                  ],
                  [
                    1,
                    5.6
                  ],
                  [
                    1.9,
                    5.6
                  ],
                  [
                    1.9,
                    6.5
                  ],
                  [
                    2,
                    6.5
                  ],
                  [
                    2.9,
                    5.7
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    4,
                    5.4
                  ],
                  [
                    5.4,
                    6
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    7.8
                  ],
                  [
                    5.8,
                    11.6
                  ],
                  [
                    4.8,
                    11.6
                  ],
                  [
                    4.8,
                    7.9
                  ],
                  [
                    4.5,
                    6.7
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    3.7,
                    6.3
                  ],
                  [
                    2.8,
                    6.6
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    7.2
                  ],
                  [
                    2,
                    11.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2079,
        ty: 3,
        parent: 2072,
        ks: {
          p: {
            a: 0,
            k: [
              12.71,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2082,
        ty: 4,
        parent: 2081,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.3
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.4,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    2,
                    11.4
                  ],
                  [
                    1,
                    10.3
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    0.6,
                    8.6
                  ],
                  [
                    1,
                    6.9
                  ],
                  [
                    2,
                    5.8
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    3.3,
                    5.4
                  ],
                  [
                    5,
                    6.2
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.7,
                    8.3
                  ],
                  [
                    5.6,
                    8.6
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    5.6,
                    8.8
                  ],
                  [
                    1.6,
                    8.8
                  ],
                  [
                    2.2,
                    10.4
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    3.6,
                    10.9
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.1,
                    10.5
                  ],
                  [
                    5.4,
                    11.1
                  ],
                  [
                    4.5,
                    11.6
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.6
                  ]
                ],
                v: [
                  [
                    1.6,
                    8.1
                  ],
                  [
                    1.6,
                    8.1
                  ],
                  [
                    4.8,
                    8.1
                  ],
                  [
                    4.4,
                    6.7
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    3.3,
                    6.2
                  ],
                  [
                    2.2,
                    6.7
                  ],
                  [
                    1.6,
                    8.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2081,
        ty: 3,
        parent: 2072,
        ks: {
          p: {
            a: 0,
            k: [
              6.59,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2084,
        ty: 4,
        parent: 2083,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0.2
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.1,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    3.4,
                    11.7
                  ],
                  [
                    3.4,
                    11.7
                  ],
                  [
                    1.8,
                    11.4
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    0.5,
                    10.5
                  ],
                  [
                    1.1,
                    9.8
                  ],
                  [
                    2.2,
                    10.6
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    3.4,
                    10.8
                  ],
                  [
                    4.6,
                    10.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    5.1,
                    9.5
                  ],
                  [
                    4.9,
                    8.8
                  ],
                  [
                    4.4,
                    8.4
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    3.7,
                    8.1
                  ],
                  [
                    2.6,
                    7.6
                  ],
                  [
                    1.8,
                    7.2
                  ],
                  [
                    1.2,
                    6.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    0.9,
                    5.5
                  ],
                  [
                    1.2,
                    4.4
                  ],
                  [
                    2.1,
                    3.6
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    3.5,
                    3.3
                  ],
                  [
                    4.8,
                    3.6
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.9,
                    4.3
                  ],
                  [
                    5.3,
                    5
                  ],
                  [
                    4.5,
                    4.4
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    3.5,
                    4.2
                  ],
                  [
                    2.4,
                    4.6
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2,
                    5.4
                  ],
                  [
                    2.2,
                    6.1
                  ],
                  [
                    2.7,
                    6.5
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    3.3,
                    6.8
                  ],
                  [
                    4.4,
                    7.3
                  ],
                  [
                    5.3,
                    7.7
                  ],
                  [
                    5.9,
                    8.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    6.1,
                    9.4
                  ],
                  [
                    5.8,
                    10.6
                  ],
                  [
                    4.8,
                    11.4
                  ],
                  [
                    3.4,
                    11.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    -0.1,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0.2,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.1,
                    0.2
                  ],
                  [
                    0.2,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.1
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0.1,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    -0.2,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.38,
                0.451,
                0.557
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2083,
        ty: 3,
        parent: 2072,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2072,
        ty: 3,
        parent: 2039,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2039,
        ty: 3,
        parent: 2038,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.8
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2038,
        ty: 3,
        parent: 2037,
        ks: {
          p: {
            a: 0,
            k: [
              21.159,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2094,
        ty: 0,
        parent: 2085,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              0.947
            ]
          },
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        w: 14.106,
        h: 14.106,
        ip: 0,
        op: 565,
        st: 0,
        refId: "2092"
      },
      {
        ind: 2085,
        ty: 3,
        parent: 2037,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.947
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2037,
        ty: 3,
        parent: 2004,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2004,
        ty: 3,
        parent: 2003,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              36.053
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2100,
        ty: 4,
        parent: 2099,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    -0.1
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.2,
                    0
                  ]
                ],
                v: [
                  [
                    2.9,
                    19.9
                  ],
                  [
                    2.9,
                    19.9
                  ],
                  [
                    1.6,
                    19.4
                  ],
                  [
                    1.2,
                    17.7
                  ],
                  [
                    1.2,
                    17.7
                  ],
                  [
                    1.2,
                    8.5
                  ],
                  [
                    3,
                    8.5
                  ],
                  [
                    3,
                    17.8
                  ],
                  [
                    3.1,
                    18.3
                  ],
                  [
                    3.4,
                    18.4
                  ],
                  [
                    3.4,
                    18.4
                  ],
                  [
                    3.5,
                    18.4
                  ],
                  [
                    3.7,
                    18.4
                  ],
                  [
                    3.7,
                    18.4
                  ],
                  [
                    3.9,
                    19.8
                  ],
                  [
                    3.5,
                    19.9
                  ],
                  [
                    2.9,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.2
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2099,
        ty: 3,
        parent: 2098,
        ks: {
          p: {
            a: 0,
            k: [
              31.181,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2102,
        ty: 4,
        parent: 2101,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0.3
                  ],
                  [
                    0.3,
                    0.6
                  ],
                  [
                    0,
                    0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.6
                  ],
                  [
                    -0.6,
                    0.3
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.3
                  ],
                  [
                    -0.2,
                    -0.6
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    4.5,
                    19.9
                  ],
                  [
                    4.5,
                    19.9
                  ],
                  [
                    2.5,
                    19.5
                  ],
                  [
                    1.2,
                    18.1
                  ],
                  [
                    0.7,
                    15.9
                  ],
                  [
                    0.7,
                    15.9
                  ],
                  [
                    1.2,
                    13.7
                  ],
                  [
                    2.5,
                    12.3
                  ],
                  [
                    4.2,
                    11.8
                  ],
                  [
                    4.2,
                    11.8
                  ],
                  [
                    6,
                    12.2
                  ],
                  [
                    7.1,
                    13.5
                  ],
                  [
                    7.5,
                    15.5
                  ],
                  [
                    7.5,
                    15.5
                  ],
                  [
                    7.4,
                    16.4
                  ],
                  [
                    7.4,
                    16.4
                  ],
                  [
                    2.4,
                    16.4
                  ],
                  [
                    3.2,
                    18
                  ],
                  [
                    4.7,
                    18.5
                  ],
                  [
                    4.7,
                    18.5
                  ],
                  [
                    5.7,
                    18.4
                  ],
                  [
                    6.5,
                    18
                  ],
                  [
                    6.5,
                    18
                  ],
                  [
                    7.2,
                    19.1
                  ],
                  [
                    5.9,
                    19.7
                  ],
                  [
                    4.5,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.6,
                    -0.3
                  ],
                  [
                    -0.3,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.3,
                    -0.6
                  ],
                  [
                    0.6,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.5,
                    0.3
                  ],
                  [
                    0.2,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0.7
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.1,
                    -0.6
                  ]
                ],
                v: [
                  [
                    2.4,
                    15.1
                  ],
                  [
                    2.4,
                    15.1
                  ],
                  [
                    5.9,
                    15.1
                  ],
                  [
                    5.5,
                    13.7
                  ],
                  [
                    4.3,
                    13.2
                  ],
                  [
                    4.3,
                    13.2
                  ],
                  [
                    3.1,
                    13.7
                  ],
                  [
                    2.4,
                    15.1
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2101,
        ty: 3,
        parent: 2098,
        ks: {
          p: {
            a: 0,
            k: [
              23.14,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2104,
        ty: 4,
        parent: 2103,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.1
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.9,
                    19.9
                  ],
                  [
                    3.9,
                    19.9
                  ],
                  [
                    2,
                    19.2
                  ],
                  [
                    1.4,
                    17.1
                  ],
                  [
                    1.4,
                    17.1
                  ],
                  [
                    1.4,
                    13.4
                  ],
                  [
                    0.3,
                    13.4
                  ],
                  [
                    0.3,
                    12
                  ],
                  [
                    1.5,
                    12
                  ],
                  [
                    1.7,
                    9.8
                  ],
                  [
                    3.3,
                    9.8
                  ],
                  [
                    3.3,
                    12
                  ],
                  [
                    5.3,
                    12
                  ],
                  [
                    5.3,
                    13.4
                  ],
                  [
                    3.3,
                    13.4
                  ],
                  [
                    3.3,
                    17.1
                  ],
                  [
                    4.4,
                    18.5
                  ],
                  [
                    4.4,
                    18.5
                  ],
                  [
                    4.8,
                    18.4
                  ],
                  [
                    5.2,
                    18.3
                  ],
                  [
                    5.2,
                    18.3
                  ],
                  [
                    5.5,
                    19.7
                  ],
                  [
                    4.8,
                    19.9
                  ],
                  [
                    3.9,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.9,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.9
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.1
                  ],
                  [
                    -0.3,
                    0.1
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2103,
        ty: 3,
        parent: 2098,
        ks: {
          p: {
            a: 0,
            k: [
              17.414,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2106,
        ty: 4,
        parent: 2105,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0.5
                  ],
                  [
                    -1.6,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    -1.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.9
                  ],
                  [
                    3,
                    19.9
                  ],
                  [
                    1.4,
                    19.3
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    1.8,
                    15.7
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5,
                    13.7
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    2.8,
                    13.5
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1,
                    12.8
                  ],
                  [
                    2.5,
                    12.1
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    6.4,
                    12.6
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    19.7
                  ],
                  [
                    5.6,
                    19.7
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    4.3,
                    19.6
                  ],
                  [
                    3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.7,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.6,
                    18.5
                  ],
                  [
                    3.6,
                    18.5
                  ],
                  [
                    4.5,
                    18.3
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    15.9
                  ],
                  [
                    3.1,
                    16.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.8,
                    18.3
                  ],
                  [
                    3.6,
                    18.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2105,
        ty: 3,
        parent: 2098,
        ks: {
          p: {
            a: 0,
            k: [
              9.231,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2108,
        ty: 4,
        parent: 2107,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.5
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.5
                  ],
                  [
                    0.6,
                    -0.2
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    19.7
                  ],
                  [
                    1.3,
                    19.7
                  ],
                  [
                    1.3,
                    9.4
                  ],
                  [
                    4.6,
                    9.4
                  ],
                  [
                    6.6,
                    9.7
                  ],
                  [
                    8.1,
                    10.7
                  ],
                  [
                    8.6,
                    12.6
                  ],
                  [
                    8.6,
                    12.6
                  ],
                  [
                    8.1,
                    14.5
                  ],
                  [
                    6.7,
                    15.6
                  ],
                  [
                    4.6,
                    15.9
                  ],
                  [
                    4.6,
                    15.9
                  ],
                  [
                    3.2,
                    15.9
                  ],
                  [
                    3.2,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.6,
                    0.2
                  ],
                  [
                    0.3,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.3,
                    0.5
                  ],
                  [
                    -0.6,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    1.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    10.8
                  ],
                  [
                    3.2,
                    14.5
                  ],
                  [
                    4.5,
                    14.5
                  ],
                  [
                    6.8,
                    12.6
                  ],
                  [
                    6.8,
                    12.6
                  ],
                  [
                    6.2,
                    11.2
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    4.4,
                    10.8
                  ],
                  [
                    3.2,
                    10.8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.7
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2107,
        ty: 3,
        parent: 2098,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2098,
        ty: 3,
        parent: 2097,
        ks: {
          p: {
            a: 0,
            k: [
              59.507,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2111,
        ty: 4,
        parent: 2110,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    3,
                    12
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    10.6
                  ],
                  [
                    2.1,
                    10.6
                  ],
                  [
                    1.3,
                    10.3
                  ],
                  [
                    1,
                    9.5
                  ],
                  [
                    1,
                    9.5
                  ],
                  [
                    1.3,
                    8.8
                  ],
                  [
                    2.1,
                    8.5
                  ],
                  [
                    2.1,
                    8.5
                  ],
                  [
                    2.9,
                    8.8
                  ],
                  [
                    3.2,
                    9.5
                  ],
                  [
                    3.2,
                    9.5
                  ],
                  [
                    2.9,
                    10.3
                  ],
                  [
                    2.1,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2110,
        ty: 3,
        parent: 2109,
        ks: {
          p: {
            a: 0,
            k: [
              52.179,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2113,
        ty: 4,
        parent: 2112,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    2.7,
                    12
                  ],
                  [
                    2.8,
                    13
                  ],
                  [
                    2.9,
                    13
                  ],
                  [
                    4,
                    12.1
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    5.4,
                    11.8
                  ],
                  [
                    7.2,
                    12.6
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    14.9
                  ],
                  [
                    7.8,
                    19.7
                  ],
                  [
                    6,
                    19.7
                  ],
                  [
                    6,
                    15.1
                  ],
                  [
                    5.7,
                    13.7
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    4.8,
                    13.3
                  ],
                  [
                    3.9,
                    13.6
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2112,
        ty: 3,
        parent: 2109,
        ks: {
          p: {
            a: 0,
            k: [
              43.298,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2115,
        ty: 4,
        parent: 2114,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0.5
                  ],
                  [
                    -1.6,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    -1.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.9
                  ],
                  [
                    3,
                    19.9
                  ],
                  [
                    1.4,
                    19.3
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    1.8,
                    15.7
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5,
                    13.7
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    2.8,
                    13.5
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1,
                    12.8
                  ],
                  [
                    2.5,
                    12.1
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    6.4,
                    12.6
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    19.7
                  ],
                  [
                    5.6,
                    19.7
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    4.3,
                    19.6
                  ],
                  [
                    3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.7,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.6,
                    18.5
                  ],
                  [
                    3.6,
                    18.5
                  ],
                  [
                    4.5,
                    18.3
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    15.9
                  ],
                  [
                    3.1,
                    16.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.8,
                    18.3
                  ],
                  [
                    3.6,
                    18.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2114,
        ty: 3,
        parent: 2109,
        ks: {
          p: {
            a: 0,
            k: [
              35.114,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2117,
        ty: 4,
        parent: 2116,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    -0.2
                  ],
                  [
                    -0.2,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    -0.5
                  ],
                  [
                    0,
                    -1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.4,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    -0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.7
                  ],
                  [
                    1.2,
                    19.7
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    2.7,
                    12
                  ],
                  [
                    2.8,
                    13
                  ],
                  [
                    2.9,
                    13
                  ],
                  [
                    3.9,
                    12.1
                  ],
                  [
                    5.2,
                    11.8
                  ],
                  [
                    5.2,
                    11.8
                  ],
                  [
                    6.6,
                    12.1
                  ],
                  [
                    7.4,
                    13.2
                  ],
                  [
                    7.4,
                    13.2
                  ],
                  [
                    8.6,
                    12.2
                  ],
                  [
                    9.9,
                    11.8
                  ],
                  [
                    9.9,
                    11.8
                  ],
                  [
                    11.7,
                    12.6
                  ],
                  [
                    12.3,
                    14.9
                  ],
                  [
                    12.3,
                    14.9
                  ],
                  [
                    12.3,
                    19.7
                  ],
                  [
                    10.5,
                    19.7
                  ],
                  [
                    10.5,
                    15.1
                  ],
                  [
                    10.2,
                    13.7
                  ],
                  [
                    9.3,
                    13.3
                  ],
                  [
                    9.3,
                    13.3
                  ],
                  [
                    7.6,
                    14.3
                  ],
                  [
                    7.6,
                    14.3
                  ],
                  [
                    7.6,
                    19.7
                  ],
                  [
                    5.8,
                    19.7
                  ],
                  [
                    5.8,
                    15.1
                  ],
                  [
                    5.5,
                    13.7
                  ],
                  [
                    4.6,
                    13.3
                  ],
                  [
                    4.6,
                    13.3
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    14.3
                  ],
                  [
                    3,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    -0.3
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.6,
                    0
                  ],
                  [
                    0.3,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.8,
                    0
                  ],
                  [
                    0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2116,
        ty: 3,
        parent: 2109,
        ks: {
          p: {
            a: 0,
            k: [
              21.744,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2119,
        ty: 4,
        parent: 2118,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0
                  ],
                  [
                    0.1,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    -0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.1,
                    0.2
                  ],
                  [
                    0,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.4
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.6,
                    0
                  ]
                ],
                v: [
                  [
                    0.5,
                    23
                  ],
                  [
                    0.5,
                    23
                  ],
                  [
                    -0.2,
                    23
                  ],
                  [
                    -0.7,
                    22.8
                  ],
                  [
                    -0.7,
                    22.8
                  ],
                  [
                    -0.4,
                    21.4
                  ],
                  [
                    -0.1,
                    21.5
                  ],
                  [
                    0.3,
                    21.6
                  ],
                  [
                    0.3,
                    21.6
                  ],
                  [
                    1,
                    21.2
                  ],
                  [
                    1.2,
                    20.2
                  ],
                  [
                    1.2,
                    20.2
                  ],
                  [
                    1.2,
                    12
                  ],
                  [
                    3,
                    12
                  ],
                  [
                    3,
                    20.1
                  ],
                  [
                    2.8,
                    21.6
                  ],
                  [
                    2,
                    22.6
                  ],
                  [
                    0.5,
                    23
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0.1,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.1,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    -0.2,
                    0.4
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0.3,
                    0
                  ]
                ],
                v: [
                  [
                    2.1,
                    10.6
                  ],
                  [
                    2.1,
                    10.6
                  ],
                  [
                    1.3,
                    10.3
                  ],
                  [
                    1,
                    9.5
                  ],
                  [
                    1,
                    9.5
                  ],
                  [
                    1.3,
                    8.8
                  ],
                  [
                    2.1,
                    8.5
                  ],
                  [
                    2.1,
                    8.5
                  ],
                  [
                    2.9,
                    8.8
                  ],
                  [
                    3.2,
                    9.5
                  ],
                  [
                    3.2,
                    9.5
                  ],
                  [
                    2.9,
                    10.3
                  ],
                  [
                    2.1,
                    10.6
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.3
                  ],
                  [
                    0.2,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    -0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2118,
        ty: 3,
        parent: 2109,
        ks: {
          p: {
            a: 0,
            k: [
              17.573,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2121,
        ty: 4,
        parent: 2120,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.4
                  ],
                  [
                    0,
                    0.7
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0.5
                  ],
                  [
                    -1.6,
                    0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.2,
                    0.3
                  ],
                  [
                    0.5,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.1
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    0.2
                  ],
                  [
                    -0.6,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.5,
                    -0.6
                  ],
                  [
                    0,
                    -1.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.2
                  ],
                  [
                    0.5,
                    0
                  ]
                ],
                v: [
                  [
                    3,
                    19.9
                  ],
                  [
                    3,
                    19.9
                  ],
                  [
                    1.4,
                    19.3
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    0.7,
                    17.7
                  ],
                  [
                    1.8,
                    15.7
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5.3,
                    14.8
                  ],
                  [
                    5,
                    13.7
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    3.9,
                    13.2
                  ],
                  [
                    2.8,
                    13.5
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1.7,
                    14
                  ],
                  [
                    1,
                    12.8
                  ],
                  [
                    2.5,
                    12.1
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    4.3,
                    11.8
                  ],
                  [
                    6.4,
                    12.6
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    15.1
                  ],
                  [
                    7.2,
                    19.7
                  ],
                  [
                    5.6,
                    19.7
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    5.5,
                    18.9
                  ],
                  [
                    4.3,
                    19.6
                  ],
                  [
                    3,
                    19.9
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    -0.7,
                    0
                  ],
                  [
                    -0.4,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0.7,
                    -0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    -0.2,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0
                  ],
                  [
                    -0.4,
                    0.1
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0.5,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    1,
                    0
                  ],
                  [
                    0.5,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    -0.4,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.3,
                    0.2
                  ],
                  [
                    -0.3,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    -0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.2,
                    -0.2
                  ],
                  [
                    -0.3,
                    0
                  ]
                ],
                v: [
                  [
                    3.6,
                    18.5
                  ],
                  [
                    3.6,
                    18.5
                  ],
                  [
                    4.5,
                    18.3
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    17.7
                  ],
                  [
                    5.3,
                    15.9
                  ],
                  [
                    3.1,
                    16.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.5,
                    17.5
                  ],
                  [
                    2.8,
                    18.3
                  ],
                  [
                    3.6,
                    18.5
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0.3,
                    0
                  ],
                  [
                    0.3,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -1.1,
                    0.1
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.3
                  ],
                  [
                    0.2,
                    0.2
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2120,
        ty: 3,
        parent: 2109,
        ks: {
          p: {
            a: 0,
            k: [
              9.389,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2123,
        ty: 4,
        parent: 2122,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.6,
                    -0.2
                  ],
                  [
                    -0.3,
                    -0.4
                  ],
                  [
                    0,
                    -0.8
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    -0.5
                  ],
                  [
                    0.6,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    19.7
                  ],
                  [
                    1.3,
                    19.7
                  ],
                  [
                    1.3,
                    9.4
                  ],
                  [
                    4.8,
                    9.4
                  ],
                  [
                    6.8,
                    9.7
                  ],
                  [
                    8.1,
                    10.6
                  ],
                  [
                    8.6,
                    12.4
                  ],
                  [
                    8.6,
                    12.4
                  ],
                  [
                    8.1,
                    14.4
                  ],
                  [
                    6.6,
                    15.4
                  ],
                  [
                    6.6,
                    15.4
                  ],
                  [
                    9,
                    19.7
                  ],
                  [
                    7,
                    19.7
                  ],
                  [
                    4.7,
                    15.7
                  ],
                  [
                    3.2,
                    15.7
                  ],
                  [
                    3.2,
                    19.7
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.6,
                    0.2
                  ],
                  [
                    0.3,
                    0.4
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0.8
                  ],
                  [
                    -0.4,
                    0.5
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "sh",
            ks: {
              a: 0,
              k: {
                c: !0,
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.4,
                    0.3
                  ],
                  [
                    0,
                    0.6
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.4,
                    0.2
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    3.2,
                    10.8
                  ],
                  [
                    3.2,
                    14.2
                  ],
                  [
                    4.6,
                    14.2
                  ],
                  [
                    6.3,
                    13.8
                  ],
                  [
                    6.8,
                    12.4
                  ],
                  [
                    6.8,
                    12.4
                  ],
                  [
                    6.3,
                    11.2
                  ],
                  [
                    4.6,
                    10.8
                  ],
                  [
                    4.6,
                    10.8
                  ],
                  [
                    3.2,
                    10.8
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.7,
                    0
                  ],
                  [
                    0.4,
                    -0.3
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -0.6
                  ],
                  [
                    -0.4,
                    -0.2
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ]
              }
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.102,
                0.173,
                0.278
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2122,
        ty: 3,
        parent: 2109,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2109,
        ty: 3,
        parent: 2097,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2097,
        ty: 3,
        parent: 2096,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0.394
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2096,
        ty: 3,
        parent: 2095,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2095,
        ty: 3,
        parent: 2003,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2003,
        ty: 3,
        parent: 2002,
        ks: {
          p: {
            a: 0,
            k: [
              91.69,
              3.002
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2134,
        ty: 0,
        parent: 2125,
        ks: {
          a: {
            a: 0,
            k: [
              54.666,
              55.543
            ]
          },
          p: {
            a: 0,
            k: [
              54.666,
              55.543
            ]
          }
        },
        w: 21.159,
        h: 21.159,
        ip: 0,
        op: 565,
        st: 0,
        refId: "2132"
      },
      {
        ind: 2125,
        ty: 3,
        parent: 2124,
        ks: {
          p: {
            a: 0,
            k: [
              54.666,
              55.543
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2137,
        ty: 4,
        td: 1,
        parent: 2135,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                38.792,
                38.792
              ]
            },
            r: {
              a: 0,
              k: 60
            },
            s: {
              a: 0,
              k: [
                77.584,
                77.584
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2136,
        ty: 4,
        tt: 1,
        parent: 2135,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                p: {
                  a: 0,
                  k: [
                    38.792,
                    38.792
                  ]
                },
                r: {
                  a: 0,
                  k: 0
                },
                s: {
                  a: 0,
                  k: [
                    81.992,
                    81.992
                  ]
                }
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0,
                    0,
                    0,
                    0
                  ]
                },
                o: {
                  a: 0,
                  k: 0
                }
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          },
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                p: {
                  a: 0,
                  k: [
                    38.792,
                    38.792
                  ]
                },
                r: {
                  a: 0,
                  k: 60
                },
                s: {
                  a: 0,
                  k: [
                    77.584,
                    77.584
                  ]
                }
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.427,
                    0.184,
                    0.604
                  ]
                },
                lj: 1,
                ml: 10,
                o: {
                  a: 0,
                  k: 100
                },
                w: {
                  a: 0,
                  k: 4.408
                }
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      },
      {
        ind: 2153,
        ty: 4,
        td: 1,
        parent: 2135,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                38.792,
                38.792
              ]
            },
            r: {
              a: 0,
              k: 60
            },
            s: {
              a: 0,
              k: [
                77.584,
                77.584
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2152,
        ty: 0,
        tt: 1,
        parent: 2135,
        ks: {},
        w: 71,
        h: 71,
        ip: 0,
        op: 565,
        st: 0,
        refId: "2150"
      },
      {
        ind: 2135,
        ty: 3,
        parent: 2124,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2124,
        ty: 3,
        parent: 2002,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2002,
        ty: 3,
        parent: 1851,
        ks: {
          p: {
            a: 0,
            k: [
              10.58,
              10.58
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2154,
        ty: 4,
        parent: 1851,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                148.115,
                91.315
              ]
            },
            r: {
              a: 0,
              k: 7
            },
            s: {
              a: 0,
              k: [
                296.23,
                182.63
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                1,
                1
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1851,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "2159",
    layers: [
      {
        ind: 2157,
        ty: 0,
        ks: {
          a: {
            a: 0,
            k: [
              1,
              0
            ]
          },
          p: {
            a: 0,
            k: [
              143.629,
              142.629
            ]
          }
        },
        w: 298,
        h: 183,
        ip: 0,
        op: 565,
        st: 0,
        refId: "2155"
      },
      {
        ind: 2158,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                291.745,
                233.944
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                583.489,
                467.888
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      }
    ]
  }
], Q = 60, B = 576, C = 0, S = [
  {
    ind: 18,
    ty: 4,
    parent: 17,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            208,
            66.5
          ]
        },
        r: {
          a: 0,
          k: 0
        },
        s: {
          a: 0,
          k: [
            416,
            133
          ]
        }
      },
      {
        ty: "gf",
        e: {
          a: 0,
          k: [
            208,
            0
          ]
        },
        g: {
          p: 2,
          k: {
            a: 0,
            k: [
              0,
              0.149,
              0.212,
              0.494,
              1,
              0.149,
              0.212,
              0.494,
              0,
              1,
              1,
              0
            ]
          }
        },
        t: 1,
        o: {
          a: 0,
          k: 100
        },
        s: {
          a: 0,
          k: [
            208,
            133
          ]
        }
      }
    ]
  },
  {
    ind: 17,
    ty: 3,
    parent: 16,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          443
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 20,
    ty: 4,
    parent: 19,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            208,
            66.5
          ]
        },
        r: {
          a: 0,
          k: 0
        },
        s: {
          a: 0,
          k: [
            416,
            133
          ]
        }
      },
      {
        ty: "gf",
        e: {
          a: 0,
          k: [
            208,
            133
          ]
        },
        g: {
          p: 2,
          k: {
            a: 0,
            k: [
              0,
              0.278,
              0.204,
              0.541,
              1,
              0.278,
              0.204,
              0.541,
              0,
              1,
              1,
              0
            ]
          }
        },
        t: 1,
        o: {
          a: 0,
          k: 100
        },
        s: {
          a: 0,
          k: [
            208,
            0
          ]
        }
      }
    ]
  },
  {
    ind: 19,
    ty: 3,
    parent: 16,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 16,
    ty: 3,
    parent: 15,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 390,
    ty: 0,
    parent: 21,
    ks: {
      p: {
        a: 0,
        k: [
          -143.629,
          -142.629
        ]
      }
    },
    ef: [
      {
        ty: 25,
        ef: [
          {
            ty: 2,
            nm: "S",
            v: {
              a: 0,
              k: [
                0.02,
                0.082,
                0.141
              ]
            }
          },
          {
            ty: 0,
            nm: "O",
            v: {
              a: 0,
              k: 128
            }
          },
          {
            ty: 1,
            nm: "D",
            v: {
              a: 0,
              k: 0
            }
          },
          {
            ty: 0,
            nm: "D",
            v: {
              a: 0,
              k: 0
            }
          },
          {
            ty: 0,
            nm: "S",
            v: {
              a: 0,
              k: 142.63
            }
          }
        ]
      }
    ],
    w: 583.489,
    h: 467.888,
    ip: 0,
    op: 565,
    st: 0,
    refId: "388"
  },
  {
    ind: 21,
    ty: 3,
    parent: 15,
    ks: {
      p: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              60,
              1388.863
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 144,
            s: [
              60,
              1150.863
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 288,
            s: [
              60,
              912.863
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 432,
            s: [
              60,
              674.863
            ],
            i: {
              x: [
                1,
                0.265
              ],
              y: [
                1,
                0.931
              ]
            },
            o: {
              x: [
                0,
                0.84
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              60,
              437.82
            ],
            h: 1
          }
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 753,
    ty: 0,
    parent: 391,
    ks: {
      p: {
        a: 0,
        k: [
          -143.629,
          -142.629
        ]
      }
    },
    ef: [
      {
        ty: 25,
        ef: [
          {
            ty: 2,
            nm: "S",
            v: {
              a: 0,
              k: [
                0.02,
                0.082,
                0.141
              ]
            }
          },
          {
            ty: 0,
            nm: "O",
            v: {
              a: 0,
              k: 128
            }
          },
          {
            ty: 1,
            nm: "D",
            v: {
              a: 0,
              k: 0
            }
          },
          {
            ty: 0,
            nm: "D",
            v: {
              a: 0,
              k: 0
            }
          },
          {
            ty: 0,
            nm: "S",
            v: {
              a: 1,
              k: [
                {
                  t: 0,
                  s: [
                    142.63
                  ],
                  h: 1
                },
                {
                  t: 432,
                  s: [
                    142.63
                  ],
                  i: {
                    x: 0.876,
                    y: 0.447
                  },
                  o: {
                    x: 0.64,
                    y: 0
                  }
                },
                {
                  t: 498,
                  s: [
                    134.03
                  ],
                  i: {
                    x: 0.098,
                    y: 0.944
                  },
                  o: {
                    x: 0.183,
                    y: 0.466
                  }
                },
                {
                  t: 564,
                  s: [
                    118.94
                  ],
                  h: 1
                }
              ]
            }
          }
        ]
      }
    ],
    w: 583.489,
    h: 467.888,
    ip: 0,
    op: 565,
    st: 0,
    refId: "751"
  },
  {
    ind: 391,
    ty: 3,
    parent: 15,
    ks: {
      a: {
        a: 0,
        k: [
          148.115,
          91.315
        ]
      },
      p: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              208.115,
              1241.548
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 144,
            s: [
              208.115,
              1003.548
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 288,
            s: [
              208.115,
              765.548
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 432,
            s: [
              208.115,
              527.548
            ],
            i: {
              x: [
                1,
                0.265
              ],
              y: [
                1,
                0.931
              ]
            },
            o: {
              x: [
                0,
                0.84
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              208.115,
              290.505
            ],
            h: 1
          }
        ]
      },
      s: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              100,
              100
            ],
            i: {
              x: [
                1,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 432,
            s: [
              100,
              100
            ],
            i: {
              x: [
                0.265,
                0.265
              ],
              y: [
                0.931,
                0.931
              ]
            },
            o: {
              x: [
                0.84,
                0.84
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              119.92,
              119.92
            ],
            h: 1
          }
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1048,
    ty: 0,
    parent: 754,
    ks: {
      p: {
        a: 0,
        k: [
          -143.629,
          -142.629
        ]
      }
    },
    ef: [
      {
        ty: 25,
        ef: [
          {
            ty: 2,
            nm: "S",
            v: {
              a: 0,
              k: [
                0.02,
                0.082,
                0.141
              ]
            }
          },
          {
            ty: 0,
            nm: "O",
            v: {
              a: 0,
              k: 128
            }
          },
          {
            ty: 1,
            nm: "D",
            v: {
              a: 0,
              k: 0
            }
          },
          {
            ty: 0,
            nm: "D",
            v: {
              a: 0,
              k: 0
            }
          },
          {
            ty: 0,
            nm: "S",
            v: {
              a: 1,
              k: [
                {
                  t: 0,
                  s: [
                    142.63
                  ],
                  h: 1
                },
                {
                  t: 288,
                  s: [
                    142.63
                  ],
                  i: {
                    x: 0.899,
                    y: 0.543
                  },
                  o: {
                    x: 0.792,
                    y: 0
                  }
                },
                {
                  t: 360,
                  s: [
                    129.66
                  ],
                  i: {
                    x: 0.196,
                    y: 1
                  },
                  o: {
                    x: 0.1,
                    y: 0.543
                  }
                },
                {
                  t: 432,
                  s: [
                    118.86
                  ],
                  i: {
                    x: 0.886,
                    y: 0.426
                  },
                  o: {
                    x: 0.667,
                    y: 0
                  }
                },
                {
                  t: 498,
                  s: [
                    125.57
                  ],
                  i: {
                    x: 0.122,
                    y: 0.931
                  },
                  o: {
                    x: 0.178,
                    y: 0.353
                  }
                },
                {
                  t: 564,
                  s: [
                    142.51
                  ],
                  h: 1
                }
              ]
            }
          }
        ]
      }
    ],
    w: 583.489,
    h: 467.888,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1046"
  },
  {
    ind: 754,
    ty: 3,
    parent: 15,
    ks: {
      a: {
        a: 0,
        k: [
          148.115,
          91.315
        ]
      },
      p: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              208.115,
              1002.919
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 144,
            s: [
              208.115,
              764.919
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 288,
            s: [
              208.115,
              526.919
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 432,
            s: [
              208.115,
              288.919
            ],
            i: {
              x: [
                1,
                0.265
              ],
              y: [
                1,
                0.931
              ]
            },
            o: {
              x: [
                0,
                0.84
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              208.115,
              51.876
            ],
            h: 1
          }
        ]
      },
      s: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              100,
              100
            ],
            i: {
              x: [
                1,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 288,
            s: [
              100,
              100
            ],
            i: {
              x: [
                0.2,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 432,
            s: [
              120,
              120
            ],
            i: {
              x: [
                0.265,
                0.265
              ],
              y: [
                0.931,
                0.931
              ]
            },
            o: {
              x: [
                0.84,
                0.84
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              100.08,
              100.08
            ],
            h: 1
          }
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1292,
    ty: 0,
    parent: 1049,
    ks: {
      p: {
        a: 0,
        k: [
          -143.629,
          -142.629
        ]
      }
    },
    ef: [
      {
        ty: 25,
        ef: [
          {
            ty: 2,
            nm: "S",
            v: {
              a: 0,
              k: [
                0.02,
                0.082,
                0.141
              ]
            }
          },
          {
            ty: 0,
            nm: "O",
            v: {
              a: 0,
              k: 128
            }
          },
          {
            ty: 1,
            nm: "D",
            v: {
              a: 0,
              k: 0
            }
          },
          {
            ty: 0,
            nm: "D",
            v: {
              a: 0,
              k: 0
            }
          },
          {
            ty: 0,
            nm: "S",
            v: {
              a: 1,
              k: [
                {
                  t: 0,
                  s: [
                    142.63
                  ],
                  h: 1
                },
                {
                  t: 144,
                  s: [
                    142.63
                  ],
                  i: {
                    x: 0.899,
                    y: 0.543
                  },
                  o: {
                    x: 0.792,
                    y: 0
                  }
                },
                {
                  t: 216,
                  s: [
                    129.66
                  ],
                  i: {
                    x: 0.196,
                    y: 1
                  },
                  o: {
                    x: 0.1,
                    y: 0.543
                  }
                },
                {
                  t: 288,
                  s: [
                    118.86
                  ],
                  i: {
                    x: 0.9,
                    y: 0.456
                  },
                  o: {
                    x: 0.804,
                    y: 0
                  }
                },
                {
                  t: 360,
                  s: [
                    129.66
                  ],
                  i: {
                    x: 0.208,
                    y: 1
                  },
                  o: {
                    x: 0.101,
                    y: 0.458
                  }
                },
                {
                  t: 432,
                  s: [
                    142.63
                  ],
                  h: 1
                },
                {
                  t: 564,
                  s: [
                    142.63
                  ],
                  h: 1
                }
              ]
            }
          }
        ]
      }
    ],
    w: 583.489,
    h: 467.888,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1290"
  },
  {
    ind: 1049,
    ty: 3,
    parent: 15,
    ks: {
      a: {
        a: 0,
        k: [
          148.115,
          91.315
        ]
      },
      p: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              208.115,
              764.289
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 144,
            s: [
              208.115,
              526.289
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 288,
            s: [
              208.115,
              288.289
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 432,
            s: [
              208.115,
              50.289
            ],
            i: {
              x: [
                1,
                0.265
              ],
              y: [
                1,
                0.931
              ]
            },
            o: {
              x: [
                0,
                0.84
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              208.115,
              -186.754
            ],
            h: 1
          }
        ]
      },
      s: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              100,
              100
            ],
            i: {
              x: [
                1,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 144,
            s: [
              100,
              100
            ],
            i: {
              x: [
                0.2,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 288,
            s: [
              120,
              120
            ],
            i: {
              x: [
                0.2,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 432,
            s: [
              100,
              100
            ],
            i: {
              x: [
                1,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              100,
              100
            ],
            h: 1
          }
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1570,
    ty: 0,
    parent: 1293,
    ks: {
      p: {
        a: 0,
        k: [
          -142.629,
          -142.629
        ]
      }
    },
    ef: [
      {
        ty: 25,
        ef: [
          {
            ty: 2,
            nm: "S",
            v: {
              a: 0,
              k: [
                0.02,
                0.082,
                0.141
              ]
            }
          },
          {
            ty: 0,
            nm: "O",
            v: {
              a: 0,
              k: 128
            }
          },
          {
            ty: 1,
            nm: "D",
            v: {
              a: 0,
              k: 0
            }
          },
          {
            ty: 0,
            nm: "D",
            v: {
              a: 0,
              k: 0
            }
          },
          {
            ty: 0,
            nm: "S",
            v: {
              a: 1,
              k: [
                {
                  t: 0,
                  s: [
                    142.63
                  ],
                  i: {
                    x: 0.899,
                    y: 0.543
                  },
                  o: {
                    x: 0.792,
                    y: 0
                  }
                },
                {
                  t: 72,
                  s: [
                    129.66
                  ],
                  i: {
                    x: 0.196,
                    y: 1
                  },
                  o: {
                    x: 0.1,
                    y: 0.543
                  }
                },
                {
                  t: 144,
                  s: [
                    118.86
                  ],
                  i: {
                    x: 0.9,
                    y: 0.456
                  },
                  o: {
                    x: 0.804,
                    y: 0
                  }
                },
                {
                  t: 216,
                  s: [
                    129.66
                  ],
                  i: {
                    x: 0.208,
                    y: 1
                  },
                  o: {
                    x: 0.101,
                    y: 0.458
                  }
                },
                {
                  t: 288,
                  s: [
                    142.63
                  ],
                  h: 1
                },
                {
                  t: 564,
                  s: [
                    142.63
                  ],
                  h: 1
                }
              ]
            }
          }
        ]
      }
    ],
    w: 581.489,
    h: 467.888,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1568"
  },
  {
    ind: 1293,
    ty: 3,
    parent: 15,
    ks: {
      a: {
        a: 0,
        k: [
          148.115,
          91.315
        ]
      },
      p: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              208.115,
              525.659
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 144,
            s: [
              208.115,
              287.659
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 288,
            s: [
              208.115,
              49.659
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 432,
            s: [
              208.115,
              -188.341
            ],
            i: {
              x: [
                1,
                0.265
              ],
              y: [
                1,
                0.931
              ]
            },
            o: {
              x: [
                0,
                0.84
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              208.115,
              -425.384
            ],
            h: 1
          }
        ]
      },
      s: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              100,
              100
            ],
            i: {
              x: [
                0.2,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 144,
            s: [
              120,
              120
            ],
            i: {
              x: [
                0.2,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 288,
            s: [
              100,
              100
            ],
            i: {
              x: [
                1,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              100,
              100
            ],
            h: 1
          }
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1849,
    ty: 0,
    parent: 1571,
    ks: {
      p: {
        a: 0,
        k: [
          -142.629,
          -142.629
        ]
      }
    },
    ef: [
      {
        ty: 25,
        ef: [
          {
            ty: 2,
            nm: "S",
            v: {
              a: 0,
              k: [
                0.02,
                0.082,
                0.141
              ]
            }
          },
          {
            ty: 0,
            nm: "O",
            v: {
              a: 0,
              k: 128
            }
          },
          {
            ty: 1,
            nm: "D",
            v: {
              a: 0,
              k: 0
            }
          },
          {
            ty: 0,
            nm: "D",
            v: {
              a: 0,
              k: 0
            }
          },
          {
            ty: 0,
            nm: "S",
            v: {
              a: 1,
              k: [
                {
                  t: 0,
                  s: [
                    118.86
                  ],
                  i: {
                    x: 0.9,
                    y: 0.456
                  },
                  o: {
                    x: 0.804,
                    y: 0
                  }
                },
                {
                  t: 72,
                  s: [
                    129.66
                  ],
                  i: {
                    x: 0.208,
                    y: 1
                  },
                  o: {
                    x: 0.101,
                    y: 0.458
                  }
                },
                {
                  t: 144,
                  s: [
                    142.63
                  ],
                  h: 1
                },
                {
                  t: 564,
                  s: [
                    142.63
                  ],
                  h: 1
                }
              ]
            }
          }
        ]
      }
    ],
    w: 581.489,
    h: 466.974,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1847"
  },
  {
    ind: 1571,
    ty: 3,
    parent: 15,
    ks: {
      a: {
        a: 0,
        k: [
          148.115,
          90.858
        ]
      },
      p: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              208.115,
              287.487
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 144,
            s: [
              208.115,
              49.487
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 288,
            s: [
              208.115,
              -188.513
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 432,
            s: [
              208.115,
              -426.513
            ],
            i: {
              x: [
                1,
                0.265
              ],
              y: [
                1,
                0.931
              ]
            },
            o: {
              x: [
                0,
                0.84
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              208.115,
              -663.556
            ],
            h: 1
          }
        ]
      },
      s: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              120,
              120
            ],
            i: {
              x: [
                0.2,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 144,
            s: [
              100,
              100
            ],
            i: {
              x: [
                1,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              100,
              100
            ],
            h: 1
          }
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2161,
    ty: 0,
    parent: 1850,
    ks: {
      p: {
        a: 0,
        k: [
          -143.629,
          -142.629
        ]
      }
    },
    ef: [
      {
        ty: 25,
        ef: [
          {
            ty: 2,
            nm: "S",
            v: {
              a: 0,
              k: [
                0.02,
                0.082,
                0.141
              ]
            }
          },
          {
            ty: 0,
            nm: "O",
            v: {
              a: 0,
              k: 128
            }
          },
          {
            ty: 1,
            nm: "D",
            v: {
              a: 0,
              k: 0
            }
          },
          {
            ty: 0,
            nm: "D",
            v: {
              a: 0,
              k: 0
            }
          },
          {
            ty: 0,
            nm: "S",
            v: {
              a: 0,
              k: 142.63
            }
          }
        ]
      }
    ],
    w: 583.489,
    h: 467.888,
    ip: 0,
    op: 565,
    st: 0,
    refId: "2159"
  },
  {
    ind: 1850,
    ty: 3,
    parent: 15,
    ks: {
      p: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              60,
              -42
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 144,
            s: [
              60,
              -280
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 288,
            s: [
              60,
              -518
            ],
            i: {
              x: [
                1,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 432,
            s: [
              60,
              -756
            ],
            i: {
              x: [
                1,
                0.265
              ],
              y: [
                1,
                0.931
              ]
            },
            o: {
              x: [
                0,
                0.84
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              60,
              -993.043
            ],
            h: 1
          }
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 15,
    ty: 3,
    parent: 14,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2162,
    ty: 4,
    parent: 14,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            208,
            288
          ]
        },
        r: {
          a: 0,
          k: 0
        },
        s: {
          a: 0,
          k: [
            416,
            576
          ]
        }
      },
      {
        ty: "gf",
        e: {
          a: 0,
          k: [
            464.85,
            -271.086
          ]
        },
        g: {
          p: 2,
          k: {
            a: 0,
            k: [
              0,
              0,
              0.2,
              0.4,
              1,
              0.569,
              0.243,
              0.808
            ]
          }
        },
        t: 1,
        o: {
          a: 0,
          k: 100
        },
        s: {
          a: 0,
          k: [
            -48.85,
            530.286
          ]
        }
      }
    ]
  },
  {
    ind: 14,
    ty: 3,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  }
], J = {
  g: "https://jitter.video"
}, b = 564, D = "5.7.4", U = 416, P = {
  assets: m,
  fr: Q,
  h: B,
  ip: C,
  layers: S,
  meta: J,
  op: b,
  v: D,
  w: U
}, R = [
  {
    h: 11,
    id: "0",
    p: "data:image/webp;base64,UklGRuAAAABXRUJQVlA4WAoAAAAQAAAACQAACgAAQUxQSG8AAAAAAAAAH1BWNgUAAAAGis53Y62+IgABmE0AAQMAH/UfM8sDK9TmZgAxfFhWAJ4oCbgZAKlcWwCgNge9EgCqLsoJJ7vNWQBOegB1kwoAAAE95goAAGbGAACDtAcAAAAANcuojgUAAAAAAABUzQYAAAAAVlA4IEoAAADwAQCdASoKAAsAAUAmJQBOgCL2w98MfKAA/XVRvV5zxF9fPJR0VrWOdSNn9MVBdAGnmfKeDPQvvF3YXOvCivnOFFRkPNuRVsHAAA==",
    w: 10,
    e: 1
  },
  {
    h: 10,
    id: "1",
    p: "data:image/webp;base64,UklGRpYAAABXRUJQVlA4WAoAAAAQAAAACgAACQAAQUxQSEIAAAABYBPbdpSXvc9XEAHxE6Ck3HFARwkSMtRoAEN0CKDaFUTEBABAXLfIARgKNdHkSbnjvNyTApd9ll91f6iuBjsvlyNWUDggLgAAAFABAJ0BKgsACgABQCYlAE6ALqAA/ueRGl0uN2gvOLz7t9+ec3gUUAghFY3G6AA=",
    w: 11,
    e: 1
  },
  {
    h: 17,
    id: "2",
    p: "data:image/webp;base64,UklGRloBAABXRUJQVlA4WAoAAAAQAAAADgAAEAAAQUxQSHoAAAABcFpt27K8/49LdKlEmkvlfAmpbEB1BmARMsndBpEJNJEf5P3eGSJiAogNXF9hEjouQF1gWwFI6ixdAIjqyvj3aXJga0qphIVCd47tWs4QD0eQFx+yBg1EXZMs4VgslmWmDuJLfzcvafsA3mHSjwHkSHgCaiSN75oGB1ZQOCC6AAAAUAQAnQEqDwARAD5tKpJFpCKhmAQAQAbEsYBOmUAUYfxU/PgnfHs7qZ0+4AD+8mGxsctnY9w3dX/3tYi8QP6f/pupqvmgVHbA4+f/itpAfHEII/P0if0x/OzRuyHH+QLu2zo/Bt650kzaXgtA3aEfYvSThXX+yEcIlkVo0dsn9dSeO181zRQrOTyBUghcz7lZFCp+vPMpdMDcBtxalJYGNvclNOsjscblXtluPM1YQsh+1V+C/ezYAAAA",
    w: 15,
    e: 1
  },
  {
    h: 59,
    id: "3",
    p: "data:image/webp;base64,UklGRiwDAABXRUJQVlA4WAoAAAAQAAAAOgAAOgAAQUxQSDIAAAABL6CmbSM4ura9I3Hzz+wiItLxF1DQRpJy6AdeASkg/3pWwCcR/Z+AaFDdD+r/kb6gBlZQOCDUAgAA8A0AnQEqOwA7AD5tLJFFpCKhmAsGfEAGxLGAX7Qg5xJjO3CxYcr53K5QVpDTvJO+AS9zWdELJ1uutLHu8kKQJNeHTe40Fy1InoD/xF/kJ/JiicSsre9x8LHmZYBUvn/OFnsCwOCx8GceQbGVknCsM2690tRFNzGAAP79KnFBtIix70AU+iS/FjzAjYvWWwWdyYZnzy0KToucBvdf/NyCKrcIdOlAQf3hMMJOs6cyk7KOyddGPLsF9UCEhrU6Dtp69uo+qQW3bmCjfLGBkbmbMCdoWuocVY5PLjBZumH/M993RBeVhZsdJSA3MgIGrigJIzHnwwrwZjPiAHBLbmVLc5pneCYygod+PqWa+j48M6p5ZUt1kVTsPIdOGtEasXObpEor1rxx8fwya8gyFn7mf0+h7AZyXwS0cptogiTY4v9Gax0b8ffuMxQb8gUxu856kowow+x7P+I+MVeZzS7nVU4OIXjiBaMU13iOPGMwuKeDDWULiBd8jk/6FkNXjoGC1JZSFQS6NO2sk66pkRDt0rKxg1nD57bl2vUOWjcjsKttzQZiqe9Df9X/+DukP0ahVHO5N+XR5PWVcmt2O5mOPf/U/Xda6+OInMqp/Pb1onXOy6SOeiUQB0XcBaqOXv+W5aXOc7qh5s/BlaO0WAuJHC8e4kOG6LxCNj39qBBgfotpJdtepURMbXvdcLNEygP2MbcV9e1Z+a+rp0NDouMV7O1ZggVbtT+18sqnTZl9/Izrf/puP/tx7uEGHEbaM/X1+rr1ua0ikyVrIAQ/MFWfrQMH4558oF1G2LR7Mg4ewL3xWmAiNFT1cIza/42OX+MlD+S2Af/Nk5fXcnCL9p6JwGQtyyHqHzdDl01/O3cyv1NOhflJETo10aoj8BVUfJRoOCys4xUegU3lzVMp/8nvjHuAvvMb4wm9JwvCE2kgdN5zOzeAhlSB6C1HtkKLXO2bzrgAAA==",
    w: 59,
    e: 1
  },
  {
    h: 18,
    id: "4",
    p: "data:image/webp;base64,UklGRlgBAABXRUJQVlA4WAoAAAAQAAAADwAAEQAAQUxQSIkAAAABgGJt27Loxd01sQdvzgpsF2Snc4hsABpJmzXaX/FKlMSh6cwz8v0vW4iICSChuvHqqYibAxDgZAHAynCdAByJeQCApZxyiv9dl8vlUhKpWuBeglQCvxPHh+XdBxP1inf2UHQhSZJ0F9ycJFYJrkmS9QPAq0rysX9NYuYADNScInCxEtfQ7ntJDABWUDggqAAAALADAJ0BKhAAEgA+bSqRRaQioZgEAEAGxKAJ0Bim62u57RMDkGBgAP7x4PvnRX2djvNz1f3pXrkC238u83cxyzxSf/unP0CLUcjthru4dmag6jr9FScKRv5lZVdrhfm009G/HUCu4dmfnWU4rV1CnfMJl0tl/TOhz1bzHHvdI8t0wCyiU3ure4mUzoqJlvmCko67hfowym/ti+y681ArhMF/BuayPXAAAA==",
    w: 16,
    e: 1
  },
  {
    h: 64,
    id: "5",
    p: "data:image/webp;base64,UklGRo4EAABXRUJQVlA4WAoAAAAQAAAAPgAAPwAAQUxQSC8AAAABR6CojRQ4ugt8bywgk4iINXu/mYWCBiIgXxE6mgam+gWwRfR/ArJg2YPjP+uBHQBWUDggOAQAAJATAJ0BKj8AQAA+aSyQRaQioZj6rthABoSgDBD+NTnAi7bHD2+nPJabBvL9eRfhfDHxxex0BmJSegOlZPH+q8UEzToV1CukW2la3zJxen4yhX8tNE+5qCYP2T5hiePIkd3NEG2eq4GaU8qqedUrafvxuGteatnTFEUf8y9El289ndaM0YytqxGI/UQvS5bmUj1leV4Nx7tu9VWhqbrJEJKU0wWrAAD+/10NYsm/hjztRclQXpdTo2c6wpMIdExPOsrvrE2Fre0aUgd64Fnpoql8dD33oq7NHfXBxDIhUq6jbl5VlV0HVw2wk8sa7BGM/vO7KYtFFORHtSFQc//ZywqZk6/2ur5FTTBeBWJA1PDfhXEwO+iAz811YPu4QDTa10/ib51redKapRJRofDGV7w2rJFRxLkaHtiX//In/8y4P/wa/7/hr/qcf9uEaAbDDY8yzwgE8Jeufw4GhqD+VbWk6txhsDSNi6TkSHaruAQG+LtNzsdFF6VM7+6babyohMwG99rYUzjeOUQCUfrVxf78c9DfnhCkNt21BKQgeI/6o0W9ytwD8x5F2AAgYnZpEOi9kX7GHKOFbljJ6zRB4o/ZAbNB1vYudjdDk0AvGOKHerrRiQokAguQJZlfo5QSNDRJ04OmcjM0lK3uK/jsyGPYDLLEI8GA2MDSKJpdz4SDL9py+c47gtMmYmFuP1LtxqjRfJ/UoLlu4nu2G6k8Huh5p6hfHEW389yA8+Xd2Yu8ZrIhU2w9aP5FV2Ri8X3hUKhrTXsNVcoY5D1/ZJ//bxjpTra0u3nuhJub6HP9YMK7kgsOUO9K/3vw6BB93xT5SIMju6Q/htOoyI0IpPlWnza4g5E1ewb/7X8G1RM2pdf86lN0snxvZekGLfYMI53S9YOmGGk/PRbizSRaGQpfG5eSz8jey/S8cFP1lHdgE8wpfMho7BV9aq7IIF9GBaSmFWGAjD5dMJdCgPmkPnzRby0gafmwSir1mTzH8TnflKTWTE3Z8u957tyrBHUnHUaE/KC3MzLGGjeAv80/dk6/r79pJeKJKVVrwOa2gXd5aTF8RAz0y+jvae4ipBpLx+/czirP2OZzj4wFB3nb1oV4SSf7xwC3DOXsjX0cE0TmZp6C/vZUdV32htw/u1OMat+8SYDv37gA44mYkFqr4UMKuK61Wsp8JpOx0FXkZIiMxCpSbVRWrL7X0xYp2EmBUxBwwcUXeMOk9iu1LjS/mZKqujsy9uzPe0iaJ7F3Di56LJuxhxf4eF/0tTZ9FWLplaEWOC0I60dOr8n2MBfvm2mWTAWLBPROmRjfA/Uz4Vv9HhDtU1+5iR0LAaGENx9mV2HsBqXpzYBZiAAdLg1Yzs5CZgnEHrwvqsYuAe6m+PgKkjFiVVayc9kuOpPJBETdu96A3cgsOAPq4yqWxu5LfR/XdpgXzot7x+AAAA==",
    w: 63,
    e: 1
  },
  {
    h: 18,
    id: "6",
    p: "data:image/webp;base64,UklGRlgBAABXRUJQVlA4WAoAAAAQAAAADwAAEQAAQUxQSIkAAAABgGJt27Loxd01sQdvzgpsF2Snc4gsACJJmzXaX/FKlMSh6cwz8v0vW4iICSChuvHqqoibAxDgZAHAynCdAByJeQCApZxyiv89l8vlUhKpWuBeglQCvxPHh+XdBxP1inf2UHQhSZJ0F9ycJFYJrkmS9QPAq0rysX9NYuYADNScInCxEtfQ7ntJDABWUDggqAAAALADAJ0BKhAAEgA+bSqRRaQioZgEAEAGxKAJ0Bim62u57RMDkGBgAP7x4PvnRX2djvNz1f3pXrkC238u83cxyzxSf/unP0CLUcjthru4dmag6jr9FScKRv5lZVdrhfm009G/HUCu4dmfnWU4rV1CnfMJl0tl/TOhz1bzHHvdI8t0wCyiU3ure4mUzoqJlvmCko67hfowym/ti+y681ArhMF/BuayPXAAAA==",
    w: 16,
    e: 1
  },
  {
    h: 63,
    id: "7",
    p: "data:image/webp;base64,UklGRjgFAABXRUJQVlA4WAoAAAAQAAAAPgAAPgAAQUxQSC0AAAABL6Agkg06+x4S/DMoo4CIiB27dyhIwITZMYhYSeyfZwGEiP5PQE+Ye+H6zwAAVlA4IOQEAADQEwCdASo/AD8APm0sk0akIqGhKhmcWIANiUAWo19oq/2Z5Xeb5L/dcjXu41FO2d/OXGwU0uLQxie4VzY29iikV3f2QzI4uYy51eFf5YehKhq5iNxzveJlqt7VxVZq7/2Fkac/ILOBQZ0dDae2RpW9CcO9FWYpFjTlTbsHloYQ+75e0/rfDwQLGk09VL2WewZ1qAWet0wbXFrNRizwdhH/Gbpz9Ehr0AD9egyVufKwN48CDFyVRyr8OJnjfiF+HjUrBEf88H5JQ6Ubwl/HeVUvkn5QlxQ8FaH7eXpojF9k7r5EJu+wmOKlIQLDNXdAxa/Sfyvw3Hs6fERdLl8fcgFFWX2bbMUFVy7vvUr7N8s8rUAyTnEjfNEuWMWR8Qol3Z1KfV4ODwS04l7iwxTMLtIesb/N1xAJt9bPdfGExp/2wX0vs3IF8dg2Tr2TsSlX4ks0jKiCZcbfhz4r9jhLEJjTXbDex+UQ8h3GdkAf9XAIjASLHxYMq3r+BPizeDYIgAvcfqhaj/UGG4cnoGglBvF8Cfl15PSTkcffzvqkVgCzVZMtNTPvZyh1LABJAJVwnfRlra8Qg//kBK/kyjR4ad0QWNo31gmo2oKsYl4qzBGatLXgIx8UK8vWXBtTVn2nAKp9oRCVg1t/lzhHZFXRQe3fEzR94RvB2tQ61D3LFxwRzakKIooFN40eHT1GaNVuDHiBB4WZKtPadUoP/R1174/JAxPyM5MPIqJq239RasLQr+VZ0VmJzILumLfwM0yWw5YBEw6ZOntHZ90J9vrhcB/Fp41RFH+Rnu4bpLNwbnuHnEtHA4OPpd4SWqPbTQKo5BREB9WtfCZuemDK3BpJdXc7KHOtAPgLAopyrjI4XiaaGB/TcvOb0p94EWogWQHj4UYHplreClvEo5741kjXfr0qXlFn0+i4gT1/nXFDo9Gkmu8pqedcZisaCiE/XFGGbYb4dX4m0x3kO7NiYzXMYK8MGmZDD6hI7XLUCIKghLDzgmaitEKOR99l2eTMC9uwZCroyZv4FQ36/HT6o2Y8NMP6eZ+D8nH3EeoEL1ZyhCCiv9tt8zq3E9M8V3vdOyR6R2YFo4hFPFmjuoJ3AjVDb441RaehHnsafzYtM+9sUCe9rFC1IzbasHjLSlgQFKDpdzq9zPDBDVL/mI/6KkWRw7HFFlGVSEXJBEgOIcnTqI7azxXXg1Wx3mN5V/lS0q+/AUvDYqzjVr8JAwzCMCwzV8dAIOJNp7gxllA6vUxqkdkNPT/mjR0Y1EDjaQA6UaJ0RizYLxFgnsunN47/rHGvuQ/5ct6Q7Z9uCVT5cbTJhjj0Sho4isf8XYfzrH7ACX9A9iwr0naXB/dUDdhje8LK0ZGzH6r2tXDSKor5Sje7RTKh56uJVyo9aQrGRtPzfmh8T5h1JUzrzRV7rjf5V6/6j0arM4FoHjPuPqxTaGUXV3wIM5LdvG5WHdjpjfTIPQmeHL6riBj1A21sFPmtA9H/j9FAnf7cCV0yPdVjJyNPknVi2r+vXbo8nue8b+YzbVebIAaXO6RrWCfabVvqWUPHGe2VC1b9zLyYCnHh4qQLEwbq670wUPCT5PkkDPZho6cmxu4rW35XeeRm+RT+069V8QvRJt0a30BEMR6EyTfKFeXGJrF/gPqHFILbgT/fVzuYe53QqjQA",
    w: 63,
    e: 1
  },
  {
    h: 18,
    id: "8",
    p: "data:image/webp;base64,UklGRloBAABXRUJQVlA4WAoAAAAQAAAADwAAEQAAQUxQSIkAAAABgGJt27Loxd1d9+DNWYHtguzVIxuARqJpJvFXRuvEGeq4PyPf/7KFiJgAEqq7HzMVccsAopwSAFgZrlsAN8S8BoCdnHKL/1OXy+VSEqmG4B5jVAd/ksGJjcsT9uoD785DqaUkSdKr4D5AYpXgIUeyfgD4aJF8+l+PmGUACzWnBhytxDWM514SAwBWUDggqgAAALADAJ0BKhAAEgA+bSqSRaQioZgEAEAGxKAJ0BiqC2u57RMDkGBgAP7x4PvnRX2djvN0WX3r8zS2hX5v3ol+yeD0On/7CIGexbsYl1F49H9ySZhz7Up7OZbh/OjrRanAsNBdB+OoFd2rb/AVTrVJhQkN7l00mwfplflQR+9w42iFKWZACqM8g0djioACscZl81I1zLGPUkn6ElHw4rYxQBn9pq+skQPh3gAA",
    w: 16,
    e: 1
  },
  {
    h: 60,
    id: "9",
    p: "data:image/webp;base64,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",
    w: 60,
    e: 1
  },
  {
    h: 18,
    id: "10",
    p: "data:image/webp;base64,UklGRloBAABXRUJQVlA4WAoAAAAQAAAADwAAEQAAQUxQSIkAAAABgGJt27Loxd1d9+DNWYHtguwLsMYCIJLo1kj8Fa8TZ6jj/ox8/8sWImICSKjufoxVxC0DiHJKAGBluG4B3BDzDABrOeUc/ycul8ulJFL1wL3EqA7+KIMrG8crNuot785DqZUkSdKr4D5AYpXgIUeyfgD4aJF8+t+QmGUAMzWnBlzsxDUMpl4SAwBWUDggqgAAALADAJ0BKhAAEgA+bSqSRaQioZgEAEAGxKAJ0BiqC2u57RMDkGBgAP7x4PvnRX2djvN0WX3r8zS2hX5v3ol+yeD0On/7CIGexbsYl1F49H9ySZhz7Up7OZbh/OjrRanAsNBdB+OoFd2rb/AVTrVJhQkN7l00mwfplflQR+9w42iFKWZACqM8g0djioACscZl81I1zLGPUkn6ElHw4rYxQBn9pq+skQPh3gAA",
    w: 16,
    e: 1
  },
  {
    h: 63,
    id: "11",
    p: "data:image/webp;base64,UklGRsQDAABXRUJQVlA4WAoAAAAQAAAAPwAAPgAAQUxQSCYAAAABHyAQIPynWRBjIyKCE2raNoJIthyrw/iNAXBLRP8noI/K9H+lKFZQOCB4AwAAUBAAnQEqQAA/AD5tNJNIJCKhoSYVWnCADYljAL58F7962xpb0vbbZKb6h+A+V7wa0501Hy1Wir9TNj/tLrXrIV8/SOffjROkiFHj4JBtx5t+/4ULrXNkuJIL1x8VGlzCwWnaQmxSj5VqEK09tOs2GnzIWK/lHJLBXCv9mH7siJN20CIKhHc0h7WgAAD+/un8gTv9PFd+jGC//b29d5pjFyVRDCFqzTxC811ZUi/kxBvZlZkDctFp3TNfE73xAOG82P0EmF8VycRgh5n+/qK7/auzOQr78bTT1c3YQ9GgWNqrV/WWruftZiKQFEzMq/qt0M5PbsUObbmiwMe/YogmbfDRbHGBScWLWmx+/wgKvK5j7iEiXwb7kh+3Xg+MBjOviHhm5zSq+0z59wflpO27F2tZWC+Ux0iMZ4ZQMAshG2EJdyfiKSKLPu/w3hClN0PZ58WvxTdTGgMc7lMrp+6CZPy4d6vN53mGvDiH22MLzqbIvqGnXVfLRHpGfRrXvBXeQZ1xEVpsCkWBI6eK1ZOFt7BdwFy+6bCOQy9jXl3MgVyg18VqPtqYngSkqAcblX2GEZfSb2EEUgI6HjbAt2sK+SS0klFSTIw9sD6SUg7Gjqyij/LwHngsgg5aE3cfy95WwysGKtkvoQHUKJk5DjcN8a5F7A4YPXgGfXQyp1sIPkLY8m6UsF8vpdyZgAWUdQPRJdZj0ULUGkDD11Mg/YNu0h9pZy+ZgdvpEiKN/mn7ctJV9d0Jr5t5PTRKs6pbFh0STvouDhzt1O4rriI1tZsByTFL6KphyoAEcrw0guQ2EPzJ4jz26/Bmjtc5u7MzT9HrDVBgjse1EGz0Kw2570yIrrut2JB2LeCysCxnQQ7izjtXYrvWr4s36VE5ahDhxRo/MMaNCYB5rD0aLPILjgpNY0EnX0bFf+SB+2EInnDQfbTVRtq+dfj2ibT/O2pdW73SOjbp+zKYyCDy4fvVr3h6/Qi9GwzFjqZzCWeOXoPYwo+FruPEyia2xHNSicGue3oRz4mC6XE1THTleMAxpdbDOEwAitRszXEOzjB6RYaT9UQ7FioMvTslPCQoVVD2J1+qGgArAq7Eb/4tPn7u8bs+w4I1m68kcuYsA1vcFlz8pYonV8ZF1aaJryMVMbit4mH1/38HFwVTpzEuuno+mMPwkNUROFE52AAA",
    w: 64,
    e: 1
  },
  {
    h: 18,
    id: "12",
    p: "data:image/webp;base64,UklGRlgBAABXRUJQVlA4WAoAAAAQAAAADwAAEQAAQUxQSIkAAAABgGJt27Loxd01sQdvzgpsF2Snc4gsACJJmzXaX/FKlMSh6cwz8v0vW4iICSChuvHqqoibAxDgZAHAynCdAByJeQCApZxyiv89l8vlUhKpWuBeglQCvxPHh+XdBxP1inf2UHQhSZJ0F9ycJFYJrkmS9QPAq0rysX9NYuYADNScInCxEtfQ7ntJDABWUDggqAAAALADAJ0BKhAAEgA+bSqSRaQioZgEAEAGxKAJ0Bim62u57RMDkGBgAP7x4PvnRX2djvNz1f3pXrkC238u83cxyzxSf/unP0CLUcjthru4dmag6jr9FScKRv5lZVdrhfm009G/HUCu4dmfnWU4rV1CnfMJl0tl/TK/Kgj97gSty3vxJrLTYyXDrTQNMzFRMt8wUld6lwEB1Ap4+L7LrzUCuEwX7/4ihGqAAA==",
    w: 16,
    e: 1
  },
  {
    h: 63,
    id: "13",
    p: "data:image/webp;base64,UklGRtQDAABXRUJQVlA4WAoAAAAQAAAAPwAAPgAAQUxQSCwAAAABJ6CobRuo16/8SVXjNBoREd/coKBtG6YqpA7B488rACZF9H8C+miL/r9SNFZQOCCCAwAAUBAAnQEqQAA/AD5tMJJGpCMhoS4SS4iADYlkAL/jjhEGoQkXtr+eA9If/D30/ec5mF+O4j247NyXSy4NNUzn6AvR6ZvVExBjVG7qj+9eCSmKuI91t35XK7cRv+trNqyXPlou+PbLV9QBM1MLMWpjtKMlUppasxmZTGFTYmIhj7b/+YIWB6BbLZbiAAD+/gwGD4yMy+wlFTz/Gz6e+8vXOrtnwmoI9md/0fmakRhPriv4Gg4QTWg73X2jW1VF5nQubYyIgtOfas90yL6J6zLfmAYyvOWeWObviAkA/2lJPbDgbEV9xGBxJYRBbamC3XkhdmFF8VMxTg7fGum1Rb/1O2fuBc+V9itTnPnkehoZHdjZvo9cKSdnN3mnvmAKp0D9PeWUQhPJvhNlSzTPrMlWBrt1PJ3HK5Xr7+ZkA0GHzcm9wCIzwaNq6musUeDHSLGnAsBnKfsAADV68B8XxP+C9j8Sdnk7MaZZsCOHah+Qo2BNRkBb89xGgRn68cCJaz0I2Ii0/2BZqfEX5rwatyKuD+fOO40/rGgFoWBtKznsLrvg8IE0Jk1Z7ALyYrKqzaApydFzAsAIWwgw6KKgekv3aRLO6QIxhv5SYwCjuXBaVNPDo6NQJxTomiOhYsWjd99+yw1z/ybXEeGvAaWipORarYAy17UCdAD8/mnlGTaGmYiCAeQgD1zcfl93mNVJcNHnMYico28Ap1cAlmzCsavaY9ArYAdyCh9qd+kJ6FY+BDaXrUPuT0IWMp5SYq3tAHIa9Vwyr392+hxYdwBZEwhrBQgvEdMHZka5tqWeu0GVoaWTf8C8nZ9JUOEHNjZU5V2dG2v6qX7MF/AviHU4dxYx2JQgbSHd8ZhsOl3y7GJL4MbT2oPfaZYaCYJYpX8nOlX/wl+PsAiomjZ61Cd4P50K8luFXmq0qXGMtnUI1DRtHVIF2hN3Hd9SOM81aGb4pwlcG3yQHk7tQvvzMpb00YBT14TT2MfdAMNb3Gc0wtzy2EmrFh3nO2OU8258ZMomtuUjxH7ckfXbQs5unvrlvhxhTvqRF/cP9enraXJl3WV9ihGpqr4BRffTSDnczx6f+h4hWMkS6JxYO5FzV0y5BpnJjq1e9OcFcWtyBVkMXiIV9djG8k6XJLoMmajEcMcDG3TfDWCbokYMLLU3KBqSUtRplqZs4/7v0x/z9WBG2jLFfCAAAA==",
    w: 64,
    e: 1
  },
  {
    h: 59,
    id: "14",
    p: "data:image/webp;base64,UklGRvQEAABXRUJQVlA4WAoAAAAQAAAAOgAAOgAAQUxQSCEAAAABFyAWTK5Z5K+ZRkTEApkGhImjOUEJ4Ino/wQ4vYjxVgAAVlA4IKwEAAAwFgCdASo7ADsAPmkokUWkIqGYDAb8QAaEtgBXJ8Ahu+G81mzdzXmbzZxvtt1zw3ow85nqWd5ltCbOzwx8eHqn2oykQeO9x/lOAa5P/W++g1L1V41HyMfVPsF9JDyZlS5D0inzwhcLe9/Te2C/YVa3BmMK+9yBDiIVGqNFHinZbYGASwzn8MKE8locNulGahXoNp4f8B4sEWYT8R1d1hncSXZ+oFflABIl7eR6ACY++gf0Hqz1eGHaegAA/vZ7gllbLlNRli5pjXK+kw0dkr5v4sg9Fbd41A8ZkyaqGC+O5QjH//7eWHJLa+toP+tfLiHzv/LYIncR82s3ZpwIlFQoCtNCFoHZn/8xvhMd+aSJm6Ix+xAQvbPpUZcydIE4SHGhmRdEB5BAreAtz145c7fNXb2PBb6cw05RKo/b8xtBaC72B7cw3N5qOcfCvRiHEgilrECgSJWBKGlfDq8De9hpSmMvNSnqwisPnBSWX1rCT+8Wa/gcuY1vty6gp6LW98lF4CABUiBY5giJ482RDsZVX6UvTiqINn/LLLP6ySnSQPYfW0gE8+29ZZ7epwI/9oBQz9jeGIF1jmdAPzQFftjabrd+Ppz4KnC0Fgy7F7Ntj5CmNdmasf3yMQbGKq1DKPSSvlqEvheYmlV34RLDhu4Ni/LsLYtWwqdo1YYhMtpUiiO/O6bFEYZ3aLRtllL1lSMDMZGoOjF2dCXkYTaeFuMIoZPaWl/MbwgH4hL5jTFmiwhiu7fXGLxuheHXV6ulgf/Qmcne/MDYEYUsYatijwB7mULMLj/w5qpK+uugeNKnLN8mmjyj04Y7hxuKD7uw0oELefE/ynDKXnIPpE6oZ1UNDB/LStzbuMCWlZd2IzceGRil9qv57bkkP6rZKNKbO3c1lXfk5Q7Q5b4/dG7HPUSZ+e0RuVK2cU1sn2IRgvDu59nGVKiKBw7MuhjirW9J/bRTUrfEvMDAmBKNMWPU6MfB6r0kh1b7+dkgSoP7Bj/5+vgDms3zOW8V0nlDyJvDkjjMxfKoSVkUIMUTtTO8yj9q98SwS77+W82w+I+QsEdBH5fpsKGpiWWpD/nhk5E4lbRtZFXxf/H7P3hWZjAwtSLsEdRxem5J5qHzXIIRPJ7F2xD/Jg6JzYlYRpICx+k3+7b6dAlRI2aIqWHm36j+m59PsZppZo8v+Lvoo/5DNnm77p/MHBZvx6EfjluwRRMHopophhcSDVolJYNsI4Wj5CnWu98KlwILamhcfqRg3yTUL/5SOqdnxkoeIOKzuTgZdriouuZLuBlCv7bzMhgbZTPDbzPuNeM2Ss2Zx23kcJBgnsv1MslWal10RrtsOnaXO8JM0OEpLRKCP1dsgzkPmzPWkCy0j941wsWdCoIU3JEkhOMvNryr2/EVeuSeuTGGyEh0n0dz/I5uirXdxpaM84X5qMLzc5qIUcB/+spHEEvvNlWjFkTt/Q1vDpON7Wj+RG/w+uHGqZSvJjnVYd4J6SD2+UxA5X/2gVMlTvMycyagJkY3aZCx4q4OA/ZLNtxuWJsDK2I6Z8F3nG3/z+h0bOIfJx8s+kbQB8O/LAt0MV34LfV+80OJbdk8p6AAAA==",
    w: 59,
    e: 1
  },
  {
    id: "78",
    layers: [
      {
        ind: 77,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                5.5,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                11,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.02
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0.05,
                            0.02
                          ],
                          [
                            0.04,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.02
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.04,
                            -0.02
                          ],
                          [
                            -0.04,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.04
                          ],
                          [
                            -0.05,
                            0.02
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.04
                          ],
                          [
                            0.04,
                            -0.02
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0.05,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.75,
                            1.03
                          ],
                          [
                            7.75,
                            3.06
                          ],
                          [
                            7.64,
                            3.33
                          ],
                          [
                            7.37,
                            3.44
                          ],
                          [
                            7.1,
                            3.33
                          ],
                          [
                            6.99,
                            3.06
                          ],
                          [
                            6.99,
                            1.95
                          ],
                          [
                            4.59,
                            4.34
                          ],
                          [
                            4.47,
                            4.43
                          ],
                          [
                            4.32,
                            4.46
                          ],
                          [
                            4.18,
                            4.43
                          ],
                          [
                            4.05,
                            4.34
                          ],
                          [
                            3.05,
                            3.34
                          ],
                          [
                            1.04,
                            5.36
                          ],
                          [
                            0.77,
                            5.47
                          ],
                          [
                            0.5,
                            5.36
                          ],
                          [
                            0.38,
                            5.09
                          ],
                          [
                            0.5,
                            4.82
                          ],
                          [
                            2.78,
                            2.54
                          ],
                          [
                            2.91,
                            2.45
                          ],
                          [
                            3.05,
                            2.42
                          ],
                          [
                            3.2,
                            2.45
                          ],
                          [
                            3.32,
                            2.54
                          ],
                          [
                            4.32,
                            3.54
                          ],
                          [
                            6.45,
                            1.41
                          ],
                          [
                            5.34,
                            1.41
                          ],
                          [
                            5.07,
                            1.3
                          ],
                          [
                            4.96,
                            1.03
                          ],
                          [
                            5.07,
                            0.76
                          ],
                          [
                            5.34,
                            0.64
                          ],
                          [
                            7.37,
                            0.64
                          ],
                          [
                            7.64,
                            0.76
                          ],
                          [
                            7.75,
                            1.03
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.52,
                        0.32,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "81",
    layers: [
      {
        ind: 80,
        ty: 0,
        parent: 76,
        ks: {},
        w: 11,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "78"
      },
      {
        ind: 76,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "104",
    layers: [
      {
        ind: 103,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                4,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                8,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0,
                            0
                          ],
                          [
                            5.8,
                            0
                          ],
                          [
                            5.8,
                            7.49
                          ],
                          [
                            0,
                            7.49
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        1,
                        1,
                        1,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "107",
    layers: [
      {
        ind: 106,
        ty: 0,
        parent: 102,
        ks: {},
        w: 8,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "104"
      },
      {
        ind: 102,
        ty: 3,
        parent: 101,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 101,
        ty: 3,
        ks: {
          a: {
            a: 0,
            k: [
              3.865,
              4.992
            ]
          },
          p: {
            a: 0,
            k: [
              3.865,
              4.992
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "95",
    layers: [
      {
        ind: 94,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3.5,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                7,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            1.16,
                            0
                          ],
                          [
                            0.09,
                            -1.14
                          ]
                        ],
                        o: [
                          [
                            -0.07,
                            -1.04
                          ],
                          [
                            -1,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            4.52,
                            3.05
                          ],
                          [
                            2.71,
                            1.05
                          ],
                          [
                            0.86,
                            3.05
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.36,
                            0
                          ],
                          [
                            0,
                            -1.52
                          ],
                          [
                            0.01,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.99,
                            0
                          ],
                          [
                            -0.41,
                            0.45
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.96,
                            0
                          ],
                          [
                            0,
                            1.61
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.5
                          ],
                          [
                            1.41,
                            0
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            1.28
                          ],
                          [
                            0.78,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.52,
                            0.57
                          ],
                          [
                            -1.32,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.35,
                            3.31
                          ],
                          [
                            0.35,
                            3.29
                          ],
                          [
                            2.73,
                            0.6
                          ],
                          [
                            5.05,
                            3.3
                          ],
                          [
                            5.04,
                            3.5
                          ],
                          [
                            0.86,
                            3.5
                          ],
                          [
                            2.84,
                            5.53
                          ],
                          [
                            4.56,
                            4.72
                          ],
                          [
                            4.9,
                            5.02
                          ],
                          [
                            2.82,
                            6
                          ],
                          [
                            0.35,
                            3.31
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0,
                        0,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "98",
    layers: [
      {
        ind: 97,
        ty: 0,
        parent: 93,
        ks: {},
        w: 7,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "95"
      },
      {
        ind: 93,
        ty: 3,
        ks: {
          a: {
            a: 0,
            k: [
              3.5,
              4
            ]
          },
          p: {
            a: 0,
            k: [
              4.5,
              6
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "123",
    layers: [
      {
        ind: 122,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                4,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                8,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0,
                            0
                          ],
                          [
                            5.8,
                            0
                          ],
                          [
                            5.8,
                            7.49
                          ],
                          [
                            0,
                            7.49
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        1,
                        1,
                        1,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "126",
    layers: [
      {
        ind: 125,
        ty: 0,
        parent: 121,
        ks: {},
        w: 8,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "123"
      },
      {
        ind: 121,
        ty: 3,
        parent: 120,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 120,
        ty: 3,
        ks: {
          a: {
            a: 0,
            k: [
              3.865,
              4.992
            ]
          },
          p: {
            a: 0,
            k: [
              3.865,
              4.992
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "114",
    layers: [
      {
        ind: 113,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                0.5,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                1,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0,
                            7.38
                          ],
                          [
                            0.48,
                            7.38
                          ],
                          [
                            0.48,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0,
                        0,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "117",
    layers: [
      {
        ind: 116,
        ty: 0,
        parent: 112,
        ks: {},
        w: 1,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "114"
      },
      {
        ind: 112,
        ty: 3,
        parent: 111,
        ks: {
          a: {
            a: 0,
            k: [
              0.5,
              5
            ]
          },
          p: {
            a: 0,
            k: [
              0.5,
              5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 111,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "131",
    layers: [
      {
        ind: 130,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2.5,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                5,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.58,
                            0
                          ],
                          [
                            -0.29,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.32,
                            0
                          ],
                          [
                            0,
                            0.96
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.72
                          ],
                          [
                            0.25,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.26,
                            0.12
                          ],
                          [
                            -0.78,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.87,
                            5.71
                          ],
                          [
                            0.87,
                            2.39
                          ],
                          [
                            0.14,
                            2.39
                          ],
                          [
                            0.14,
                            1.95
                          ],
                          [
                            0.87,
                            1.95
                          ],
                          [
                            0.87,
                            0.33
                          ],
                          [
                            1.36,
                            0.33
                          ],
                          [
                            1.36,
                            1.95
                          ],
                          [
                            3.12,
                            1.95
                          ],
                          [
                            3.12,
                            2.39
                          ],
                          [
                            1.36,
                            2.39
                          ],
                          [
                            1.36,
                            5.66
                          ],
                          [
                            2.36,
                            6.64
                          ],
                          [
                            3.1,
                            6.46
                          ],
                          [
                            3.1,
                            6.92
                          ],
                          [
                            2.28,
                            7.09
                          ],
                          [
                            0.87,
                            5.71
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0,
                        0,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "147",
    layers: [
      {
        ind: 146,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                8,
                5.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                16,
                11
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0,
                            0
                          ],
                          [
                            11.45,
                            0
                          ],
                          [
                            11.45,
                            7.74
                          ],
                          [
                            0,
                            7.74
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        1,
                        1,
                        1,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "150",
    layers: [
      {
        ind: 149,
        ty: 0,
        parent: 145,
        ks: {},
        w: 16,
        h: 11,
        ip: 0,
        op: 565,
        st: 0,
        refId: "147"
      },
      {
        ind: 145,
        ty: 3,
        parent: 144,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 144,
        ty: 3,
        ks: {
          a: {
            a: 0,
            k: [
              7.629,
              5.16
            ]
          },
          p: {
            a: 0,
            k: [
              7.629,
              5.16
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "138",
    layers: [
      {
        ind: 137,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                4,
                5.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                8,
                11
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.71,
                            0
                          ],
                          [
                            -0.01,
                            0.5
                          ],
                          [
                            0.76,
                            0.22
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.68
                          ],
                          [
                            -1.44,
                            0
                          ],
                          [
                            0,
                            -1.45
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.63,
                            0
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            -0.73,
                            -0.21
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            -0.72
                          ],
                          [
                            1.33,
                            0
                          ],
                          [
                            0,
                            1.36
                          ]
                        ],
                        o: [
                          [
                            0.02,
                            0.48
                          ],
                          [
                            0.64,
                            0
                          ],
                          [
                            0.01,
                            -0.34
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.65,
                            -0.52
                          ],
                          [
                            0,
                            -1.35
                          ],
                          [
                            1.45,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.5
                          ],
                          [
                            -0.55,
                            0
                          ],
                          [
                            0,
                            0.2
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.82,
                            0.52
                          ],
                          [
                            -0.02,
                            1.5
                          ],
                          [
                            -1.63,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.62,
                            5.42
                          ],
                          [
                            2.74,
                            6.33
                          ],
                          [
                            3.84,
                            5.53
                          ],
                          [
                            2.94,
                            4.68
                          ],
                          [
                            2.03,
                            4.43
                          ],
                          [
                            0.09,
                            2.26
                          ],
                          [
                            2.68,
                            0
                          ],
                          [
                            5.21,
                            2.31
                          ],
                          [
                            3.62,
                            2.31
                          ],
                          [
                            2.65,
                            1.46
                          ],
                          [
                            1.68,
                            2.21
                          ],
                          [
                            2.49,
                            2.98
                          ],
                          [
                            3.38,
                            3.27
                          ],
                          [
                            5.44,
                            5.54
                          ],
                          [
                            2.74,
                            7.75
                          ],
                          [
                            0.02,
                            5.42
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0,
                        0,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "141",
    layers: [
      {
        ind: 140,
        ty: 0,
        parent: 136,
        ks: {},
        w: 8,
        h: 11,
        ip: 0,
        op: 565,
        st: 0,
        refId: "138"
      },
      {
        ind: 136,
        ty: 3,
        ks: {
          a: {
            a: 0,
            k: [
              4,
              5.5
            ]
          },
          p: {
            a: 0,
            k: [
              12,
              5.5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "165",
    layers: [
      {
        ind: 164,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                8,
                5.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                16,
                11
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0,
                            0
                          ],
                          [
                            11.45,
                            0
                          ],
                          [
                            11.45,
                            7.74
                          ],
                          [
                            0,
                            7.74
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        1,
                        1,
                        1,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "168",
    layers: [
      {
        ind: 167,
        ty: 0,
        parent: 163,
        ks: {},
        w: 16,
        h: 11,
        ip: 0,
        op: 565,
        st: 0,
        refId: "165"
      },
      {
        ind: 163,
        ty: 3,
        parent: 162,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 162,
        ty: 3,
        ks: {
          a: {
            a: 0,
            k: [
              7.629,
              5.16
            ]
          },
          p: {
            a: 0,
            k: [
              7.629,
              5.16
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "156",
    layers: [
      {
        ind: 155,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                4,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                8,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.77
                          ],
                          [
                            0.62,
                            0
                          ],
                          [
                            0,
                            -0.73
                          ],
                          [
                            -0.63,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.62,
                            0
                          ],
                          [
                            0,
                            -0.77
                          ],
                          [
                            -0.63,
                            0
                          ],
                          [
                            0,
                            0.73
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            2.84,
                            4.04
                          ],
                          [
                            4.07,
                            2.82
                          ],
                          [
                            2.84,
                            1.61
                          ],
                          [
                            1.57,
                            2.82
                          ],
                          [
                            2.84,
                            4.04
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.39,
                            0
                          ],
                          [
                            0,
                            1.64
                          ],
                          [
                            -1.29,
                            0
                          ],
                          [
                            -0.39,
                            -0.57
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.32,
                            0.49
                          ],
                          [
                            -1.29,
                            0
                          ],
                          [
                            0,
                            -1.64
                          ],
                          [
                            0.33,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            4.07,
                            4.8
                          ],
                          [
                            2.59,
                            5.48
                          ],
                          [
                            0,
                            2.82
                          ],
                          [
                            2.59,
                            0.16
                          ],
                          [
                            4.07,
                            0.84
                          ],
                          [
                            4.07,
                            0.27
                          ],
                          [
                            5.57,
                            0.27
                          ],
                          [
                            5.57,
                            5.38
                          ],
                          [
                            4.07,
                            5.38
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0,
                        0,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "159",
    layers: [
      {
        ind: 158,
        ty: 0,
        parent: 154,
        ks: {},
        w: 8,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "156"
      },
      {
        ind: 154,
        ty: 3,
        ks: {
          a: {
            a: 0,
            k: [
              4,
              4
            ]
          },
          p: {
            a: 0,
            k: [
              4,
              7
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "173",
    layers: [
      {
        ind: 172,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                4,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                8,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.78
                          ],
                          [
                            0.63,
                            0
                          ],
                          [
                            0,
                            -0.75
                          ],
                          [
                            -0.64,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.63,
                            0
                          ],
                          [
                            0,
                            -0.78
                          ],
                          [
                            -0.64,
                            0
                          ],
                          [
                            0,
                            0.75
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            3.18,
                            4.13
                          ],
                          [
                            4.44,
                            2.89
                          ],
                          [
                            3.18,
                            1.66
                          ],
                          [
                            1.89,
                            2.89
                          ],
                          [
                            3.18,
                            4.13
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.4,
                            0
                          ],
                          [
                            0,
                            1.67
                          ],
                          [
                            -1.32,
                            0
                          ],
                          [
                            -0.4,
                            -0.58
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.33,
                            0.5
                          ],
                          [
                            -1.32,
                            0
                          ],
                          [
                            0,
                            -1.67
                          ],
                          [
                            0.33,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            4.44,
                            4.91
                          ],
                          [
                            2.93,
                            5.6
                          ],
                          [
                            0.29,
                            2.89
                          ],
                          [
                            2.93,
                            0.19
                          ],
                          [
                            4.44,
                            0.88
                          ],
                          [
                            4.44,
                            0.3
                          ],
                          [
                            5.97,
                            0.3
                          ],
                          [
                            5.97,
                            5.5
                          ],
                          [
                            4.44,
                            5.5
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0,
                        0,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "178",
    layers: [
      {
        ind: 177,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                5,
                5.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                10,
                11
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                1.38,
                                0
                              ],
                              [
                                0,
                                2.15
                              ],
                              [
                                -2.18,
                                0
                              ],
                              [
                                -0.66,
                                -0.98
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.79,
                                0
                              ],
                              [
                                0,
                                -1.33
                              ],
                              [
                                -1.27,
                                0
                              ],
                              [
                                -0.41,
                                0.62
                              ]
                            ],
                            o: [
                              [
                                -0.66,
                                1.01
                              ],
                              [
                                -2.18,
                                0
                              ],
                              [
                                0,
                                -2.18
                              ],
                              [
                                1.36,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.41,
                                -0.6
                              ],
                              [
                                -1.27,
                                0
                              ],
                              [
                                0,
                                1.32
                              ],
                              [
                                0.8,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                7.04,
                                6.17
                              ],
                              [
                                3.83,
                                7.85
                              ],
                              [
                                0,
                                3.93
                              ],
                              [
                                3.83,
                                0
                              ],
                              [
                                7,
                                1.62
                              ],
                              [
                                5.68,
                                2.53
                              ],
                              [
                                3.83,
                                1.53
                              ],
                              [
                                1.63,
                                3.93
                              ],
                              [
                                3.83,
                                6.32
                              ],
                              [
                                5.73,
                                5.26
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0,
                            0,
                            0,
                            1
                          ]
                        },
                        r: 2,
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "181",
    layers: [
      {
        ind: 109,
        ty: 0,
        td: 1,
        parent: 92,
        ks: {},
        w: 8,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "107"
      },
      {
        ind: 100,
        ty: 0,
        tt: 1,
        parent: 92,
        ks: {},
        w: 8,
        h: 11,
        ip: 0,
        op: 565,
        st: 0,
        refId: "98"
      },
      {
        ind: 92,
        ty: 3,
        parent: 91,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 128,
        ty: 0,
        td: 1,
        parent: 110,
        ks: {},
        w: 8,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "126"
      },
      {
        ind: 119,
        ty: 0,
        tt: 1,
        parent: 110,
        ks: {
          a: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        w: 2,
        h: 11,
        ip: 0,
        op: 565,
        st: 0,
        refId: "117"
      },
      {
        ind: 110,
        ty: 3,
        parent: 91,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 91,
        ty: 3,
        parent: 90,
        ks: {
          p: {
            a: 0,
            k: [
              38.281,
              0.469
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 133,
        ty: 0,
        parent: 129,
        ks: {},
        w: 5,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "131"
      },
      {
        ind: 129,
        ty: 3,
        parent: 90,
        ks: {
          p: {
            a: 0,
            k: [
              33,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 152,
        ty: 0,
        td: 1,
        parent: 135,
        ks: {},
        w: 16,
        h: 11,
        ip: 0,
        op: 565,
        st: 0,
        refId: "150"
      },
      {
        ind: 143,
        ty: 0,
        tt: 1,
        parent: 135,
        ks: {},
        w: 17,
        h: 12,
        ip: 0,
        op: 565,
        st: 0,
        refId: "141"
      },
      {
        ind: 135,
        ty: 3,
        parent: 134,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 170,
        ty: 0,
        td: 1,
        parent: 153,
        ks: {},
        w: 16,
        h: 11,
        ip: 0,
        op: 565,
        st: 0,
        refId: "168"
      },
      {
        ind: 161,
        ty: 0,
        tt: 1,
        parent: 153,
        ks: {},
        w: 9,
        h: 11,
        ip: 0,
        op: 565,
        st: 0,
        refId: "159"
      },
      {
        ind: 153,
        ty: 3,
        parent: 134,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 134,
        ty: 3,
        parent: 90,
        ks: {
          p: {
            a: 0,
            k: [
              17.803,
              0.12
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 175,
        ty: 0,
        parent: 171,
        ks: {},
        w: 8,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "173"
      },
      {
        ind: 171,
        ty: 3,
        parent: 90,
        ks: {
          p: {
            a: 0,
            k: [
              9,
              3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 180,
        ty: 0,
        parent: 176,
        ks: {},
        w: 10,
        h: 11,
        ip: 0,
        op: 565,
        st: 0,
        refId: "178"
      },
      {
        ind: 176,
        ty: 3,
        parent: 90,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 90,
        ty: 3,
        parent: 89,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 89,
        ty: 3,
        parent: 88,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 88,
        ty: 3,
        parent: 87,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 87,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              6e-3,
              7e-3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "211",
    layers: [
      {
        ind: 210,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                10.5,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                21,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.06,
                            0.07
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            -0.04
                          ],
                          [
                            0,
                            -0.05
                          ],
                          [
                            0.02,
                            -0.04
                          ],
                          [
                            0.03,
                            -0.03
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            -0.07,
                            -0.06
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0.06,
                            -0.07
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.03
                          ],
                          [
                            0.02,
                            0.04
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            -0.02,
                            0.04
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            14.99,
                            3.77
                          ],
                          [
                            11.82,
                            6.93
                          ],
                          [
                            11.57,
                            7.04
                          ],
                          [
                            11.33,
                            6.93
                          ],
                          [
                            11.22,
                            6.68
                          ],
                          [
                            11.33,
                            6.44
                          ],
                          [
                            13.89,
                            3.87
                          ],
                          [
                            0.35,
                            3.87
                          ],
                          [
                            0.1,
                            3.77
                          ],
                          [
                            0,
                            3.52
                          ],
                          [
                            0.1,
                            3.27
                          ],
                          [
                            0.35,
                            3.17
                          ],
                          [
                            13.89,
                            3.17
                          ],
                          [
                            11.33,
                            0.6
                          ],
                          [
                            11.22,
                            0.35
                          ],
                          [
                            11.33,
                            0.1
                          ],
                          [
                            11.57,
                            0
                          ],
                          [
                            11.82,
                            0.1
                          ],
                          [
                            14.99,
                            3.27
                          ],
                          [
                            15.07,
                            3.38
                          ],
                          [
                            15.09,
                            3.52
                          ],
                          [
                            15.07,
                            3.65
                          ],
                          [
                            14.99,
                            3.77
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.57,
                        0.63,
                        0.72,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "236",
    layers: [
      {
        ind: 235,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                31,
                6
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                62,
                12
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.26,
                            -0.08
                          ],
                          [
                            -0.15,
                            -0.21
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            0.32,
                            -0.24
                          ],
                          [
                            0.51,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.26,
                            0.09
                          ],
                          [
                            0.14,
                            0.2
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.32,
                            0.23
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.64,
                            6.75
                          ],
                          [
                            0.64,
                            2.09
                          ],
                          [
                            1.97,
                            2.09
                          ],
                          [
                            2.89,
                            2.21
                          ],
                          [
                            3.5,
                            2.65
                          ],
                          [
                            3.72,
                            3.46
                          ],
                          [
                            3.24,
                            4.55
                          ],
                          [
                            2,
                            4.9
                          ],
                          [
                            1.23,
                            4.9
                          ],
                          [
                            1.23,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.15
                          ],
                          [
                            0,
                            0.33
                          ],
                          [
                            0.21,
                            0.13
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0.2,
                            -0.16
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            -0.2,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.23,
                            4.42
                          ],
                          [
                            1.93,
                            4.42
                          ],
                          [
                            2.83,
                            4.19
                          ],
                          [
                            3.13,
                            3.46
                          ],
                          [
                            2.82,
                            2.76
                          ],
                          [
                            1.9,
                            2.56
                          ],
                          [
                            1.23,
                            2.56
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0.13
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.11,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.01
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0.12,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            -0.21
                          ],
                          [
                            0.17,
                            -0.13
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.01
                          ],
                          [
                            -0.15,
                            0
                          ],
                          [
                            -0.16,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            4.61,
                            6.75
                          ],
                          [
                            4.61,
                            3.29
                          ],
                          [
                            5.09,
                            3.29
                          ],
                          [
                            5.14,
                            3.92
                          ],
                          [
                            5.16,
                            3.92
                          ],
                          [
                            5.6,
                            3.4
                          ],
                          [
                            6.15,
                            3.21
                          ],
                          [
                            6.52,
                            3.28
                          ],
                          [
                            6.4,
                            3.79
                          ],
                          [
                            6.25,
                            3.75
                          ],
                          [
                            6.07,
                            3.73
                          ],
                          [
                            5.61,
                            3.91
                          ],
                          [
                            5.2,
                            4.53
                          ],
                          [
                            5.2,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.24,
                            0.14
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.24,
                            -0.29
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0,
                            -0.06
                          ],
                          [
                            0.01,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            -0.22
                          ],
                          [
                            -0.33,
                            0
                          ],
                          [
                            -0.14,
                            0.05
                          ],
                          [
                            -0.13,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0.23,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.15,
                            -0.27
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.15,
                            -0.27
                          ],
                          [
                            0.24,
                            -0.15
                          ],
                          [
                            0.44,
                            0
                          ],
                          [
                            0.24,
                            0.29
                          ],
                          [
                            0,
                            0.06
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            0.36
                          ],
                          [
                            0.21,
                            0.22
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0.09
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            8.41,
                            6.84
                          ],
                          [
                            7.57,
                            6.62
                          ],
                          [
                            6.97,
                            6
                          ],
                          [
                            6.75,
                            5.03
                          ],
                          [
                            6.97,
                            4.05
                          ],
                          [
                            7.55,
                            3.43
                          ],
                          [
                            8.3,
                            3.21
                          ],
                          [
                            9.32,
                            3.65
                          ],
                          [
                            9.68,
                            4.83
                          ],
                          [
                            9.68,
                            5.02
                          ],
                          [
                            9.66,
                            5.16
                          ],
                          [
                            7.33,
                            5.16
                          ],
                          [
                            7.67,
                            6.04
                          ],
                          [
                            8.48,
                            6.37
                          ],
                          [
                            8.93,
                            6.29
                          ],
                          [
                            9.34,
                            6.1
                          ],
                          [
                            9.55,
                            6.48
                          ],
                          [
                            9.04,
                            6.73
                          ],
                          [
                            8.41,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.18
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.2,
                            -0.19
                          ],
                          [
                            0.04,
                            -0.34
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.35
                          ],
                          [
                            -0.15,
                            -0.19
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.19,
                            0.18
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.32,
                            4.75
                          ],
                          [
                            9.17,
                            4.75
                          ],
                          [
                            8.94,
                            3.95
                          ],
                          [
                            8.32,
                            3.67
                          ],
                          [
                            7.66,
                            3.96
                          ],
                          [
                            7.32,
                            4.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.28,
                            0.12
                          ],
                          [
                            0.2,
                            0.21
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            -0.11
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.17,
                            0.14
                          ],
                          [
                            0,
                            0.23
                          ],
                          [
                            0.07,
                            0.09
                          ],
                          [
                            0.12,
                            0.07
                          ],
                          [
                            0.15,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.1
                          ],
                          [
                            0.1,
                            0.16
                          ],
                          [
                            0,
                            0.23
                          ],
                          [
                            -0.12,
                            0.18
                          ],
                          [
                            -0.22,
                            0.1
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.23,
                            -0.11
                          ],
                          [
                            -0.16,
                            -0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.07
                          ],
                          [
                            0.22,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0,
                            -0.21
                          ],
                          [
                            -0.07,
                            -0.1
                          ],
                          [
                            -0.12,
                            -0.06
                          ],
                          [
                            -0.12,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            -0.11
                          ],
                          [
                            -0.09,
                            -0.16
                          ],
                          [
                            0,
                            -0.23
                          ],
                          [
                            0.13,
                            -0.2
                          ],
                          [
                            0.24,
                            -0.12
                          ],
                          [
                            0.33,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.28,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0.18
                          ],
                          [
                            0.23,
                            0.11
                          ],
                          [
                            0.31,
                            0
                          ],
                          [
                            0.17,
                            -0.14
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            -0.07,
                            -0.09
                          ],
                          [
                            -0.11,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            -0.06
                          ],
                          [
                            -0.14,
                            -0.1
                          ],
                          [
                            -0.09,
                            -0.16
                          ],
                          [
                            0,
                            -0.24
                          ],
                          [
                            0.13,
                            -0.19
                          ],
                          [
                            0.22,
                            -0.11
                          ],
                          [
                            0.28,
                            0
                          ],
                          [
                            0.24,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            -0.14
                          ],
                          [
                            -0.17,
                            -0.08
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.16,
                            0.13
                          ],
                          [
                            0,
                            0.14
                          ],
                          [
                            0.08,
                            0.09
                          ],
                          [
                            0.12,
                            0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.07
                          ],
                          [
                            0.15,
                            0.1
                          ],
                          [
                            0.08,
                            0.15
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            -0.13,
                            0.2
                          ],
                          [
                            -0.24,
                            0.12
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            13.31,
                            6.84
                          ],
                          [
                            12.4,
                            6.65
                          ],
                          [
                            11.68,
                            6.14
                          ],
                          [
                            12.03,
                            5.73
                          ],
                          [
                            12.61,
                            6.16
                          ],
                          [
                            13.32,
                            6.32
                          ],
                          [
                            14.04,
                            6.11
                          ],
                          [
                            14.29,
                            5.55
                          ],
                          [
                            14.18,
                            5.17
                          ],
                          [
                            13.91,
                            4.93
                          ],
                          [
                            13.52,
                            4.73
                          ],
                          [
                            12.85,
                            4.44
                          ],
                          [
                            12.41,
                            4.2
                          ],
                          [
                            12.04,
                            3.81
                          ],
                          [
                            11.9,
                            3.24
                          ],
                          [
                            12.09,
                            2.61
                          ],
                          [
                            12.61,
                            2.16
                          ],
                          [
                            13.37,
                            2
                          ],
                          [
                            14.14,
                            2.16
                          ],
                          [
                            14.75,
                            2.57
                          ],
                          [
                            14.43,
                            2.96
                          ],
                          [
                            13.95,
                            2.64
                          ],
                          [
                            13.37,
                            2.52
                          ],
                          [
                            12.73,
                            2.7
                          ],
                          [
                            12.5,
                            3.2
                          ],
                          [
                            12.61,
                            3.57
                          ],
                          [
                            12.91,
                            3.8
                          ],
                          [
                            13.27,
                            3.98
                          ],
                          [
                            13.94,
                            4.26
                          ],
                          [
                            14.42,
                            4.54
                          ],
                          [
                            14.77,
                            4.93
                          ],
                          [
                            14.89,
                            5.5
                          ],
                          [
                            14.7,
                            6.18
                          ],
                          [
                            14.16,
                            6.66
                          ],
                          [
                            13.31,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.25,
                            0.14
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.16,
                            -0.08
                          ],
                          [
                            -0.12,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            0.06
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0.17,
                            -0.11
                          ],
                          [
                            0.09,
                            -0.2
                          ],
                          [
                            0,
                            -0.27
                          ],
                          [
                            -0.2,
                            -0.25
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.14,
                            0.07
                          ],
                          [
                            -0.11,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.08
                          ],
                          [
                            0.21,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.14,
                            -0.27
                          ],
                          [
                            0,
                            -0.39
                          ],
                          [
                            0.16,
                            -0.27
                          ],
                          [
                            0.26,
                            -0.14
                          ],
                          [
                            0.23,
                            0
                          ],
                          [
                            0.16,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.1,
                            -0.09
                          ],
                          [
                            -0.11,
                            -0.06
                          ],
                          [
                            -0.21,
                            0
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            -0.09,
                            0.2
                          ],
                          [
                            0,
                            0.39
                          ],
                          [
                            0.2,
                            0.24
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.14
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.13,
                            6.84
                          ],
                          [
                            16.3,
                            6.62
                          ],
                          [
                            15.71,
                            6
                          ],
                          [
                            15.5,
                            5.03
                          ],
                          [
                            15.73,
                            4.04
                          ],
                          [
                            16.34,
                            3.42
                          ],
                          [
                            17.17,
                            3.21
                          ],
                          [
                            17.75,
                            3.33
                          ],
                          [
                            18.18,
                            3.61
                          ],
                          [
                            17.88,
                            4
                          ],
                          [
                            17.56,
                            3.78
                          ],
                          [
                            17.19,
                            3.69
                          ],
                          [
                            16.63,
                            3.86
                          ],
                          [
                            16.24,
                            4.33
                          ],
                          [
                            16.11,
                            5.03
                          ],
                          [
                            16.4,
                            5.99
                          ],
                          [
                            17.17,
                            6.35
                          ],
                          [
                            17.62,
                            6.25
                          ],
                          [
                            17.98,
                            6
                          ],
                          [
                            18.24,
                            6.39
                          ],
                          [
                            17.72,
                            6.72
                          ],
                          [
                            17.13,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.17
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            -0.34,
                            0.2
                          ],
                          [
                            -0.73,
                            0.08
                          ],
                          [
                            0.04,
                            0.13
                          ],
                          [
                            0.11,
                            0.08
                          ],
                          [
                            0.19,
                            0
                          ],
                          [
                            0.17,
                            -0.07
                          ],
                          [
                            0.14,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.23,
                            0.09
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.19,
                            -0.26
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            -0.1
                          ],
                          [
                            0.22,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.19,
                            -0.18
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.34,
                            -0.2
                          ],
                          [
                            0,
                            -0.14
                          ],
                          [
                            -0.04,
                            -0.13
                          ],
                          [
                            -0.1,
                            -0.09
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.18,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.11
                          ],
                          [
                            0.24,
                            -0.1
                          ],
                          [
                            0.42,
                            0
                          ],
                          [
                            0.19,
                            0.26
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.13
                          ],
                          [
                            -0.19,
                            0.1
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            19.73,
                            6.84
                          ],
                          [
                            19,
                            6.58
                          ],
                          [
                            18.72,
                            5.86
                          ],
                          [
                            19.22,
                            4.98
                          ],
                          [
                            20.84,
                            4.56
                          ],
                          [
                            20.77,
                            4.14
                          ],
                          [
                            20.56,
                            3.82
                          ],
                          [
                            20.13,
                            3.69
                          ],
                          [
                            19.57,
                            3.8
                          ],
                          [
                            19.09,
                            4.06
                          ],
                          [
                            18.87,
                            3.66
                          ],
                          [
                            19.46,
                            3.36
                          ],
                          [
                            20.23,
                            3.21
                          ],
                          [
                            21.14,
                            3.6
                          ],
                          [
                            21.43,
                            4.63
                          ],
                          [
                            21.43,
                            6.75
                          ],
                          [
                            20.95,
                            6.75
                          ],
                          [
                            20.89,
                            6.34
                          ],
                          [
                            20.88,
                            6.34
                          ],
                          [
                            20.34,
                            6.69
                          ],
                          [
                            19.73,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            0.08
                          ],
                          [
                            -0.16,
                            0.15
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            -0.14
                          ],
                          [
                            0,
                            -0.22
                          ],
                          [
                            -0.12,
                            -0.09
                          ],
                          [
                            -0.17,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.17,
                            0
                          ],
                          [
                            0.15,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.57,
                            0.07
                          ],
                          [
                            -0.23,
                            0.14
                          ],
                          [
                            0,
                            0.19
                          ],
                          [
                            0.12,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            19.9,
                            6.37
                          ],
                          [
                            20.37,
                            6.25
                          ],
                          [
                            20.84,
                            5.9
                          ],
                          [
                            20.84,
                            4.95
                          ],
                          [
                            19.63,
                            5.26
                          ],
                          [
                            19.29,
                            5.81
                          ],
                          [
                            19.46,
                            6.24
                          ],
                          [
                            19.9,
                            6.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0.13
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.04
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            -0.04,
                            0.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.01
                          ],
                          [
                            0.08,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.21,
                            0
                          ],
                          [
                            -0.09,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            0.03,
                            0.04
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.02
                          ],
                          [
                            -0.05,
                            0.01
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            23.13,
                            6.84
                          ],
                          [
                            22.66,
                            6.64
                          ],
                          [
                            22.52,
                            6.05
                          ],
                          [
                            22.52,
                            1.69
                          ],
                          [
                            23.1,
                            1.69
                          ],
                          [
                            23.1,
                            6.1
                          ],
                          [
                            23.15,
                            6.29
                          ],
                          [
                            23.26,
                            6.35
                          ],
                          [
                            23.31,
                            6.35
                          ],
                          [
                            23.39,
                            6.34
                          ],
                          [
                            23.47,
                            6.78
                          ],
                          [
                            23.33,
                            6.82
                          ],
                          [
                            23.13,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.24,
                            0.14
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.24,
                            -0.29
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0,
                            -0.06
                          ],
                          [
                            0.01,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            -0.22
                          ],
                          [
                            -0.33,
                            0
                          ],
                          [
                            -0.14,
                            0.05
                          ],
                          [
                            -0.13,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0.23,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.15,
                            -0.27
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.15,
                            -0.27
                          ],
                          [
                            0.24,
                            -0.15
                          ],
                          [
                            0.44,
                            0
                          ],
                          [
                            0.24,
                            0.29
                          ],
                          [
                            0,
                            0.06
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            0.36
                          ],
                          [
                            0.21,
                            0.22
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0.09
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.73,
                            6.84
                          ],
                          [
                            24.89,
                            6.62
                          ],
                          [
                            24.29,
                            6
                          ],
                          [
                            24.07,
                            5.03
                          ],
                          [
                            24.29,
                            4.05
                          ],
                          [
                            24.88,
                            3.43
                          ],
                          [
                            25.62,
                            3.21
                          ],
                          [
                            26.64,
                            3.65
                          ],
                          [
                            27,
                            4.83
                          ],
                          [
                            27,
                            5.02
                          ],
                          [
                            26.98,
                            5.16
                          ],
                          [
                            24.65,
                            5.16
                          ],
                          [
                            24.99,
                            6.04
                          ],
                          [
                            25.8,
                            6.37
                          ],
                          [
                            26.25,
                            6.29
                          ],
                          [
                            26.66,
                            6.1
                          ],
                          [
                            26.87,
                            6.48
                          ],
                          [
                            26.36,
                            6.73
                          ],
                          [
                            25.73,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.18
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.2,
                            -0.19
                          ],
                          [
                            0.04,
                            -0.34
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.35
                          ],
                          [
                            -0.14,
                            -0.19
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.19,
                            0.18
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            24.64,
                            4.75
                          ],
                          [
                            26.49,
                            4.75
                          ],
                          [
                            26.26,
                            3.95
                          ],
                          [
                            25.64,
                            3.67
                          ],
                          [
                            24.98,
                            3.96
                          ],
                          [
                            24.64,
                            4.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0.13
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.11,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.01
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0.12,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            -0.21
                          ],
                          [
                            0.17,
                            -0.13
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.01
                          ],
                          [
                            -0.14,
                            0
                          ],
                          [
                            -0.16,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            27.86,
                            6.75
                          ],
                          [
                            27.86,
                            3.29
                          ],
                          [
                            28.34,
                            3.29
                          ],
                          [
                            28.39,
                            3.92
                          ],
                          [
                            28.41,
                            3.92
                          ],
                          [
                            28.84,
                            3.4
                          ],
                          [
                            29.39,
                            3.21
                          ],
                          [
                            29.76,
                            3.28
                          ],
                          [
                            29.65,
                            3.79
                          ],
                          [
                            29.49,
                            3.75
                          ],
                          [
                            29.31,
                            3.73
                          ],
                          [
                            28.85,
                            3.91
                          ],
                          [
                            28.44,
                            4.53
                          ],
                          [
                            28.44,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.49,
                        0.55,
                        0.65,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "260",
    layers: [
      {
        ind: 259,
        ty: 2,
        parent: 258,
        ks: {
          s: {
            a: 0,
            k: [
              170,
              181.82
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "0"
      },
      {
        ind: 258,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "263",
    layers: [
      {
        ind: 262,
        ty: 0,
        parent: 257,
        ks: {},
        w: 8.5,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "260"
      },
      {
        ind: 257,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "314",
    layers: [
      {
        ind: 313,
        ty: 2,
        parent: 312,
        ks: {
          s: {
            a: 0,
            k: [
              181.82,
              180
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "1"
      },
      {
        ind: 312,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "317",
    layers: [
      {
        ind: 316,
        ty: 0,
        parent: 311,
        ks: {},
        w: 10,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "314"
      },
      {
        ind: 311,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "352",
    layers: [
      {
        ind: 351,
        ty: 2,
        parent: 350,
        ks: {
          s: {
            a: 0,
            k: [
              193.33,
              194.12
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "2"
      },
      {
        ind: 350,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "355",
    layers: [
      {
        ind: 354,
        ty: 0,
        parent: 349,
        ks: {},
        w: 14.5,
        h: 16.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "352"
      },
      {
        ind: 349,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "366",
    layers: [
      {
        ind: 365,
        ty: 2,
        parent: 364,
        ks: {
          s: {
            a: 0,
            k: [
              198.31,
              198.31
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "3"
      },
      {
        ind: 364,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "369",
    layers: [
      {
        ind: 368,
        ty: 0,
        parent: 363,
        ks: {},
        w: 58.5,
        h: 58.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "366"
      },
      {
        ind: 363,
        ty: 3,
        parent: 362,
        ks: {
          p: {
            a: 0,
            k: [
              -5,
              -3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 362,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              5,
              4
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "373",
    layers: [
      {
        ind: 372,
        ty: 4,
        td: 1,
        parent: 361,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                24.383,
                24.383
              ]
            },
            r: {
              a: 0,
              k: 24
            },
            s: {
              a: 0,
              k: [
                48.766,
                48.766
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 371,
        ty: 0,
        tt: 1,
        parent: 361,
        ks: {
          a: {
            a: 0,
            k: [
              5,
              4
            ]
          }
        },
        w: 64,
        h: 63,
        ip: 0,
        op: 565,
        st: 0,
        refId: "369"
      },
      {
        ind: 361,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              5.418,
              5.418
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "442",
    layers: [
      {
        ind: 441,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                5.5,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                11,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.02
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0.05,
                            0.02
                          ],
                          [
                            0.04,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.02
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            -0.04,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.04
                          ],
                          [
                            -0.05,
                            0.02
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.04
                          ],
                          [
                            0.05,
                            -0.02
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0.04,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.75,
                            1.03
                          ],
                          [
                            7.75,
                            3.06
                          ],
                          [
                            7.64,
                            3.33
                          ],
                          [
                            7.37,
                            3.44
                          ],
                          [
                            7.1,
                            3.33
                          ],
                          [
                            6.98,
                            3.06
                          ],
                          [
                            6.98,
                            1.95
                          ],
                          [
                            4.59,
                            4.34
                          ],
                          [
                            4.46,
                            4.43
                          ],
                          [
                            4.32,
                            4.46
                          ],
                          [
                            4.17,
                            4.43
                          ],
                          [
                            4.05,
                            4.34
                          ],
                          [
                            3.05,
                            3.34
                          ],
                          [
                            1.03,
                            5.36
                          ],
                          [
                            0.76,
                            5.47
                          ],
                          [
                            0.49,
                            5.36
                          ],
                          [
                            0.38,
                            5.09
                          ],
                          [
                            0.49,
                            4.82
                          ],
                          [
                            2.78,
                            2.54
                          ],
                          [
                            2.9,
                            2.45
                          ],
                          [
                            3.05,
                            2.42
                          ],
                          [
                            3.2,
                            2.45
                          ],
                          [
                            3.32,
                            2.54
                          ],
                          [
                            4.32,
                            3.54
                          ],
                          [
                            6.45,
                            1.41
                          ],
                          [
                            5.33,
                            1.41
                          ],
                          [
                            5.06,
                            1.3
                          ],
                          [
                            4.95,
                            1.03
                          ],
                          [
                            5.06,
                            0.76
                          ],
                          [
                            5.33,
                            0.64
                          ],
                          [
                            7.37,
                            0.64
                          ],
                          [
                            7.64,
                            0.76
                          ],
                          [
                            7.75,
                            1.03
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.52,
                        0.32,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "445",
    layers: [
      {
        ind: 444,
        ty: 0,
        parent: 440,
        ks: {},
        w: 11,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "442"
      },
      {
        ind: 440,
        ty: 3,
        parent: 439,
        ks: {
          s: {
            a: 0,
            k: [
              107.41,
              107.14
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 439,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1.071
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "454",
    layers: [
      {
        ind: 453,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2.5,
                2.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                5,
                5
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.16,
                            0.16
                          ],
                          [
                            3.69,
                            0.16
                          ],
                          [
                            3.69,
                            3.69
                          ],
                          [
                            0.16,
                            3.69
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        1,
                        0.73,
                        0,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "460",
    layers: [
      {
        ind: 459,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2.5,
                2.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                5,
                5
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0,
                            0.16
                          ],
                          [
                            3.54,
                            0.16
                          ],
                          [
                            3.54,
                            3.69
                          ],
                          [
                            0,
                            3.69
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.64,
                        0.94,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "466",
    layers: [
      {
        ind: 465,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2.5,
                2.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                5,
                5
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.16,
                            0
                          ],
                          [
                            3.69,
                            0
                          ],
                          [
                            3.69,
                            3.54
                          ],
                          [
                            0.16,
                            3.54
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.5,
                        0.73,
                        0,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "472",
    layers: [
      {
        ind: 471,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2.5,
                2.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                5,
                5
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0,
                            0
                          ],
                          [
                            3.54,
                            0
                          ],
                          [
                            3.54,
                            3.54
                          ],
                          [
                            0,
                            3.54
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.95,
                        0.31,
                        0.13,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "478",
    layers: [
      {
        ind: 477,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                17.5,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                35,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            0.24
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            0.24
                          ],
                          [
                            0.01,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.03,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.03,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.17
                          ],
                          [
                            0,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            0.33
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            3.3,
                            3.54
                          ],
                          [
                            3.09,
                            4.12
                          ],
                          [
                            3.07,
                            4.12
                          ],
                          [
                            2.87,
                            3.55
                          ],
                          [
                            1.76,
                            0.75
                          ],
                          [
                            0.67,
                            0.75
                          ],
                          [
                            0.67,
                            5.21
                          ],
                          [
                            1.39,
                            5.21
                          ],
                          [
                            1.39,
                            2.45
                          ],
                          [
                            1.38,
                            1.84
                          ],
                          [
                            1.36,
                            1.56
                          ],
                          [
                            1.38,
                            1.56
                          ],
                          [
                            1.48,
                            1.94
                          ],
                          [
                            2.82,
                            5.2
                          ],
                          [
                            3.33,
                            5.2
                          ],
                          [
                            4.65,
                            1.91
                          ],
                          [
                            4.74,
                            1.56
                          ],
                          [
                            4.76,
                            1.56
                          ],
                          [
                            4.72,
                            2.36
                          ],
                          [
                            4.72,
                            5.19
                          ],
                          [
                            5.49,
                            5.19
                          ],
                          [
                            5.49,
                            0.73
                          ],
                          [
                            4.44,
                            0.73
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            6.21,
                            1.99
                          ],
                          [
                            6.96,
                            1.99
                          ],
                          [
                            6.96,
                            5.19
                          ],
                          [
                            6.21,
                            5.19
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            -0.08
                          ],
                          [
                            0,
                            -0.12
                          ],
                          [
                            -0.09,
                            -0.08
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.08,
                            0.07
                          ],
                          [
                            0,
                            0.12
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0.13,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            0.08
                          ],
                          [
                            0,
                            0.12
                          ],
                          [
                            0.09,
                            0.08
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            -0.08
                          ],
                          [
                            0,
                            -0.12
                          ],
                          [
                            -0.07,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            6.6,
                            0.64
                          ],
                          [
                            6.28,
                            0.77
                          ],
                          [
                            6.15,
                            1.08
                          ],
                          [
                            6.28,
                            1.39
                          ],
                          [
                            6.6,
                            1.51
                          ],
                          [
                            6.91,
                            1.39
                          ],
                          [
                            7.05,
                            1.08
                          ],
                          [
                            6.91,
                            0.77
                          ],
                          [
                            6.6,
                            0.64
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0.26,
                            -0.15
                          ],
                          [
                            0.13,
                            -0.26
                          ],
                          [
                            0,
                            -0.35
                          ],
                          [
                            -0.13,
                            -0.25
                          ],
                          [
                            -0.25,
                            -0.13
                          ],
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.24,
                            0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            -0.04
                          ],
                          [
                            0.11,
                            0
                          ],
                          [
                            0.17,
                            0.19
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            -0.18,
                            0.19
                          ],
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.23,
                            -0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.03
                          ]
                        ],
                        o: [
                          [
                            -0.14,
                            -0.03
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.26,
                            0.15
                          ],
                          [
                            -0.14,
                            0.27
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            0.13,
                            0.24
                          ],
                          [
                            0.23,
                            0.13
                          ],
                          [
                            0.36,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.11,
                            0.08
                          ],
                          [
                            -0.13,
                            0.05
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.17,
                            -0.18
                          ],
                          [
                            0,
                            -0.33
                          ],
                          [
                            0.18,
                            -0.19
                          ],
                          [
                            0.24,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.1,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.63,
                            1.96
                          ],
                          [
                            9.2,
                            1.92
                          ],
                          [
                            8.29,
                            2.14
                          ],
                          [
                            7.69,
                            2.76
                          ],
                          [
                            7.48,
                            3.68
                          ],
                          [
                            7.69,
                            4.51
                          ],
                          [
                            8.25,
                            5.08
                          ],
                          [
                            9.08,
                            5.28
                          ],
                          [
                            9.98,
                            5.07
                          ],
                          [
                            9.99,
                            5.06
                          ],
                          [
                            9.99,
                            4.37
                          ],
                          [
                            9.96,
                            4.39
                          ],
                          [
                            9.6,
                            4.58
                          ],
                          [
                            9.24,
                            4.65
                          ],
                          [
                            8.54,
                            4.38
                          ],
                          [
                            8.28,
                            3.62
                          ],
                          [
                            8.54,
                            2.84
                          ],
                          [
                            9.25,
                            2.55
                          ],
                          [
                            9.96,
                            2.8
                          ],
                          [
                            9.99,
                            2.82
                          ],
                          [
                            9.99,
                            2.09
                          ],
                          [
                            9.98,
                            2.08
                          ],
                          [
                            9.63,
                            1.96
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            -0.12
                          ],
                          [
                            0.07,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.12,
                            0.17
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.09,
                            -0.01
                          ],
                          [
                            -0.04,
                            -0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.18,
                            0
                          ],
                          [
                            -0.13,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.27
                          ],
                          [
                            0.13,
                            -0.18
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.08,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            12.1,
                            1.94
                          ],
                          [
                            11.59,
                            2.12
                          ],
                          [
                            11.3,
                            2.55
                          ],
                          [
                            11.3,
                            2.55
                          ],
                          [
                            11.3,
                            1.99
                          ],
                          [
                            10.55,
                            1.99
                          ],
                          [
                            10.55,
                            5.19
                          ],
                          [
                            11.3,
                            5.19
                          ],
                          [
                            11.3,
                            3.55
                          ],
                          [
                            11.48,
                            2.88
                          ],
                          [
                            11.96,
                            2.62
                          ],
                          [
                            12.19,
                            2.65
                          ],
                          [
                            12.37,
                            2.73
                          ],
                          [
                            12.4,
                            2.75
                          ],
                          [
                            12.4,
                            2
                          ],
                          [
                            12.38,
                            1.99
                          ],
                          [
                            12.1,
                            1.94
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.29,
                            -0.31
                          ],
                          [
                            0,
                            -0.53
                          ],
                          [
                            -0.29,
                            -0.29
                          ],
                          [
                            -0.49,
                            0
                          ],
                          [
                            -0.29,
                            0.31
                          ],
                          [
                            0,
                            0.52
                          ],
                          [
                            0.29,
                            0.29
                          ],
                          [
                            0.5,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.52,
                            0
                          ],
                          [
                            -0.3,
                            0.3
                          ],
                          [
                            0,
                            0.5
                          ],
                          [
                            0.29,
                            0.29
                          ],
                          [
                            0.51,
                            0
                          ],
                          [
                            0.3,
                            -0.31
                          ],
                          [
                            0,
                            -0.51
                          ],
                          [
                            -0.27,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            14.14,
                            1.93
                          ],
                          [
                            12.9,
                            2.39
                          ],
                          [
                            12.46,
                            3.64
                          ],
                          [
                            12.89,
                            4.84
                          ],
                          [
                            14.07,
                            5.27
                          ],
                          [
                            15.28,
                            4.81
                          ],
                          [
                            15.73,
                            3.57
                          ],
                          [
                            15.3,
                            2.36
                          ],
                          [
                            14.14,
                            1.93
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.16,
                            0.19
                          ],
                          [
                            0,
                            0.33
                          ],
                          [
                            -0.15,
                            0.19
                          ],
                          [
                            -0.27,
                            0
                          ],
                          [
                            -0.15,
                            -0.18
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            0.14,
                            -0.18
                          ]
                        ],
                        o: [
                          [
                            -0.14,
                            0.18
                          ],
                          [
                            -0.27,
                            0
                          ],
                          [
                            -0.15,
                            -0.18
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            0.16,
                            -0.18
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.15,
                            0.18
                          ],
                          [
                            -0.01,
                            0.34
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            14.74,
                            4.38
                          ],
                          [
                            14.11,
                            4.65
                          ],
                          [
                            13.46,
                            4.37
                          ],
                          [
                            13.23,
                            3.6
                          ],
                          [
                            13.46,
                            2.82
                          ],
                          [
                            14.11,
                            2.54
                          ],
                          [
                            14.73,
                            2.81
                          ],
                          [
                            14.96,
                            3.59
                          ],
                          [
                            14.74,
                            4.38
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.11
                          ],
                          [
                            -0.09,
                            0.06
                          ],
                          [
                            -0.14,
                            0
                          ],
                          [
                            -0.13,
                            -0.04
                          ],
                          [
                            -0.09,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.14,
                            0.03
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.23,
                            -0.19
                          ],
                          [
                            0,
                            -0.28
                          ],
                          [
                            -0.05,
                            -0.11
                          ],
                          [
                            -0.11,
                            -0.09
                          ],
                          [
                            -0.21,
                            -0.09
                          ],
                          [
                            -0.08,
                            -0.05
                          ],
                          [
                            -0.04,
                            -0.04
                          ],
                          [
                            0,
                            -0.07
                          ],
                          [
                            0.33,
                            0
                          ],
                          [
                            0.16,
                            0.05
                          ],
                          [
                            0.12,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            -0.04
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.22,
                            0.19
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            0.13,
                            0.14
                          ],
                          [
                            0.3,
                            0.11
                          ]
                        ],
                        o: [
                          [
                            -0.23,
                            -0.1
                          ],
                          [
                            -0.06,
                            -0.05
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0.09,
                            -0.05
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.13,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.04
                          ],
                          [
                            -0.14,
                            -0.02
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.23,
                            0.18
                          ],
                          [
                            0,
                            0.15
                          ],
                          [
                            0.05,
                            0.11
                          ],
                          [
                            0.1,
                            0.08
                          ],
                          [
                            0.17,
                            0.07
                          ],
                          [
                            0.08,
                            0.04
                          ],
                          [
                            0.03,
                            0.05
                          ],
                          [
                            0,
                            0.21
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.16,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            0.05
                          ],
                          [
                            0.16,
                            0.03
                          ],
                          [
                            0.39,
                            0
                          ],
                          [
                            0.23,
                            -0.18
                          ],
                          [
                            0,
                            -0.21
                          ],
                          [
                            -0.17,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.4,
                            3.32
                          ],
                          [
                            16.95,
                            3.08
                          ],
                          [
                            16.86,
                            2.84
                          ],
                          [
                            16.98,
                            2.61
                          ],
                          [
                            17.31,
                            2.52
                          ],
                          [
                            17.7,
                            2.58
                          ],
                          [
                            18.03,
                            2.74
                          ],
                          [
                            18.06,
                            2.76
                          ],
                          [
                            18.06,
                            2.06
                          ],
                          [
                            18.04,
                            2.05
                          ],
                          [
                            17.7,
                            1.95
                          ],
                          [
                            17.33,
                            1.92
                          ],
                          [
                            16.45,
                            2.2
                          ],
                          [
                            16.11,
                            2.9
                          ],
                          [
                            16.18,
                            3.29
                          ],
                          [
                            16.41,
                            3.59
                          ],
                          [
                            16.88,
                            3.85
                          ],
                          [
                            17.26,
                            4.03
                          ],
                          [
                            17.43,
                            4.17
                          ],
                          [
                            17.48,
                            4.35
                          ],
                          [
                            16.99,
                            4.66
                          ],
                          [
                            16.57,
                            4.59
                          ],
                          [
                            16.15,
                            4.38
                          ],
                          [
                            16.13,
                            4.35
                          ],
                          [
                            16.13,
                            5.09
                          ],
                          [
                            16.14,
                            5.09
                          ],
                          [
                            16.55,
                            5.22
                          ],
                          [
                            16.98,
                            5.27
                          ],
                          [
                            17.91,
                            4.99
                          ],
                          [
                            18.26,
                            4.27
                          ],
                          [
                            18.07,
                            3.72
                          ],
                          [
                            17.4,
                            3.32
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.3,
                            -0.31
                          ],
                          [
                            0,
                            -0.53
                          ],
                          [
                            -0.29,
                            -0.29
                          ],
                          [
                            -0.49,
                            0
                          ],
                          [
                            -0.29,
                            0.31
                          ],
                          [
                            0,
                            0.52
                          ],
                          [
                            0.28,
                            0.29
                          ],
                          [
                            0.5,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.53,
                            0
                          ],
                          [
                            -0.29,
                            0.3
                          ],
                          [
                            0,
                            0.5
                          ],
                          [
                            0.29,
                            0.29
                          ],
                          [
                            0.51,
                            0
                          ],
                          [
                            0.3,
                            -0.31
                          ],
                          [
                            0,
                            -0.51
                          ],
                          [
                            -0.27,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            20.24,
                            1.93
                          ],
                          [
                            19,
                            2.39
                          ],
                          [
                            18.55,
                            3.64
                          ],
                          [
                            18.99,
                            4.84
                          ],
                          [
                            20.16,
                            5.27
                          ],
                          [
                            21.38,
                            4.81
                          ],
                          [
                            21.82,
                            3.57
                          ],
                          [
                            21.4,
                            2.36
                          ],
                          [
                            20.24,
                            1.93
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.15,
                            0.19
                          ],
                          [
                            0,
                            0.33
                          ],
                          [
                            -0.15,
                            0.19
                          ],
                          [
                            -0.27,
                            0
                          ],
                          [
                            -0.15,
                            -0.18
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            0.14,
                            -0.18
                          ]
                        ],
                        o: [
                          [
                            -0.14,
                            0.18
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.16,
                            -0.18
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            0.15,
                            -0.18
                          ],
                          [
                            0.26,
                            0
                          ],
                          [
                            0.15,
                            0.18
                          ],
                          [
                            0,
                            0.34
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            20.83,
                            4.38
                          ],
                          [
                            20.2,
                            4.65
                          ],
                          [
                            19.56,
                            4.37
                          ],
                          [
                            19.33,
                            3.6
                          ],
                          [
                            19.56,
                            2.82
                          ],
                          [
                            20.2,
                            2.54
                          ],
                          [
                            20.82,
                            2.81
                          ],
                          [
                            21.05,
                            3.59
                          ],
                          [
                            20.83,
                            4.38
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.08,
                            0.09
                          ],
                          [
                            -0.15,
                            0
                          ],
                          [
                            -0.12,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0.18,
                            -0.09
                          ],
                          [
                            0.1,
                            -0.18
                          ],
                          [
                            0,
                            -0.23
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.64,
                            0
                          ],
                          [
                            -0.11,
                            0.02
                          ],
                          [
                            -0.05,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            -0.02
                          ],
                          [
                            0.04,
                            0
                          ],
                          [
                            0.07,
                            0.09
                          ],
                          [
                            0,
                            0.2
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.18
                          ],
                          [
                            0.08,
                            -0.09
                          ],
                          [
                            0.11,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.11,
                            -0.04
                          ],
                          [
                            -0.22,
                            0
                          ],
                          [
                            -0.18,
                            0.1
                          ],
                          [
                            -0.1,
                            0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.68
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.11,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.03
                          ],
                          [
                            -0.06,
                            0.02
                          ],
                          [
                            -0.15,
                            0
                          ],
                          [
                            -0.07,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.83,
                            2.61
                          ],
                          [
                            25.83,
                            1.99
                          ],
                          [
                            25.08,
                            1.99
                          ],
                          [
                            25.08,
                            1.05
                          ],
                          [
                            25.05,
                            1.05
                          ],
                          [
                            24.34,
                            1.27
                          ],
                          [
                            24.32,
                            1.27
                          ],
                          [
                            24.32,
                            1.99
                          ],
                          [
                            23.19,
                            1.99
                          ],
                          [
                            23.19,
                            1.59
                          ],
                          [
                            23.32,
                            1.17
                          ],
                          [
                            23.67,
                            1.03
                          ],
                          [
                            24,
                            1.11
                          ],
                          [
                            24.03,
                            1.12
                          ],
                          [
                            24.03,
                            0.47
                          ],
                          [
                            24.02,
                            0.46
                          ],
                          [
                            23.59,
                            0.41
                          ],
                          [
                            23,
                            0.55
                          ],
                          [
                            22.59,
                            0.96
                          ],
                          [
                            22.43,
                            1.55
                          ],
                          [
                            22.43,
                            1.99
                          ],
                          [
                            21.91,
                            1.99
                          ],
                          [
                            21.91,
                            2.61
                          ],
                          [
                            22.43,
                            2.61
                          ],
                          [
                            22.43,
                            5.19
                          ],
                          [
                            23.19,
                            5.19
                          ],
                          [
                            23.19,
                            2.61
                          ],
                          [
                            24.32,
                            2.61
                          ],
                          [
                            24.32,
                            4.25
                          ],
                          [
                            25.27,
                            5.27
                          ],
                          [
                            25.59,
                            5.23
                          ],
                          [
                            25.83,
                            5.16
                          ],
                          [
                            25.83,
                            5.15
                          ],
                          [
                            25.83,
                            4.54
                          ],
                          [
                            25.8,
                            4.56
                          ],
                          [
                            25.65,
                            4.63
                          ],
                          [
                            25.5,
                            4.65
                          ],
                          [
                            25.17,
                            4.53
                          ],
                          [
                            25.07,
                            4.12
                          ],
                          [
                            25.07,
                            2.61
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.45,
                        0.45,
                        0.45,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "481",
    layers: [
      {
        ind: 456,
        ty: 0,
        parent: 452,
        ks: {},
        w: 5,
        h: 5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "454"
      },
      {
        ind: 452,
        ty: 3,
        parent: 451,
        ks: {
          s: {
            a: 0,
            k: [
              107.41,
              107.14
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 451,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              5.37,
              5.357
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 462,
        ty: 0,
        parent: 458,
        ks: {},
        w: 5,
        h: 5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "460"
      },
      {
        ind: 458,
        ty: 3,
        parent: 457,
        ks: {
          s: {
            a: 0,
            k: [
              107.41,
              107.14
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 457,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              5.357
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 468,
        ty: 0,
        parent: 464,
        ks: {},
        w: 5,
        h: 5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "466"
      },
      {
        ind: 464,
        ty: 3,
        parent: 463,
        ks: {
          s: {
            a: 0,
            k: [
              107.41,
              107.14
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 463,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              5.37,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 474,
        ty: 0,
        parent: 470,
        ks: {},
        w: 5,
        h: 5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "472"
      },
      {
        ind: 470,
        ty: 3,
        parent: 469,
        ks: {
          s: {
            a: 0,
            k: [
              107.41,
              107.14
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 469,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 480,
        ty: 0,
        parent: 476,
        ks: {},
        w: 35,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "478"
      },
      {
        ind: 476,
        ty: 3,
        parent: 475,
        ks: {
          s: {
            a: 0,
            k: [
              107.41,
              107.14
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 475,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              12.889,
              1.071
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "512",
    layers: [
      {
        ind: 511,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                10.5,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                21,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.06,
                            0.07
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            -0.04
                          ],
                          [
                            0,
                            -0.05
                          ],
                          [
                            0.02,
                            -0.04
                          ],
                          [
                            0.03,
                            -0.03
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            -0.07,
                            -0.06
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0.06,
                            -0.07
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.03
                          ],
                          [
                            0.02,
                            0.04
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            -0.02,
                            0.04
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            14.99,
                            3.77
                          ],
                          [
                            11.82,
                            6.93
                          ],
                          [
                            11.57,
                            7.04
                          ],
                          [
                            11.33,
                            6.93
                          ],
                          [
                            11.22,
                            6.68
                          ],
                          [
                            11.33,
                            6.44
                          ],
                          [
                            13.89,
                            3.87
                          ],
                          [
                            0.35,
                            3.87
                          ],
                          [
                            0.1,
                            3.77
                          ],
                          [
                            0,
                            3.52
                          ],
                          [
                            0.1,
                            3.27
                          ],
                          [
                            0.35,
                            3.17
                          ],
                          [
                            13.89,
                            3.17
                          ],
                          [
                            11.33,
                            0.6
                          ],
                          [
                            11.22,
                            0.35
                          ],
                          [
                            11.33,
                            0.1
                          ],
                          [
                            11.57,
                            0
                          ],
                          [
                            11.82,
                            0.1
                          ],
                          [
                            14.99,
                            3.27
                          ],
                          [
                            15.07,
                            3.38
                          ],
                          [
                            15.09,
                            3.52
                          ],
                          [
                            15.07,
                            3.65
                          ],
                          [
                            14.99,
                            3.77
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.57,
                        0.63,
                        0.72,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "534",
    layers: [
      {
        ind: 533,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                31,
                6
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                62,
                12
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.26,
                            -0.08
                          ],
                          [
                            -0.15,
                            -0.21
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            0.32,
                            -0.24
                          ],
                          [
                            0.51,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.26,
                            0.09
                          ],
                          [
                            0.14,
                            0.2
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.32,
                            0.23
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.64,
                            6.75
                          ],
                          [
                            0.64,
                            2.09
                          ],
                          [
                            1.97,
                            2.09
                          ],
                          [
                            2.89,
                            2.21
                          ],
                          [
                            3.5,
                            2.65
                          ],
                          [
                            3.72,
                            3.46
                          ],
                          [
                            3.24,
                            4.55
                          ],
                          [
                            2,
                            4.9
                          ],
                          [
                            1.23,
                            4.9
                          ],
                          [
                            1.23,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.15
                          ],
                          [
                            0,
                            0.33
                          ],
                          [
                            0.21,
                            0.13
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0.2,
                            -0.16
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            -0.2,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.23,
                            4.42
                          ],
                          [
                            1.93,
                            4.42
                          ],
                          [
                            2.83,
                            4.19
                          ],
                          [
                            3.13,
                            3.46
                          ],
                          [
                            2.82,
                            2.76
                          ],
                          [
                            1.9,
                            2.56
                          ],
                          [
                            1.23,
                            2.56
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0.13
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.11,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.01
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0.12,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            -0.21
                          ],
                          [
                            0.17,
                            -0.13
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.01
                          ],
                          [
                            -0.15,
                            0
                          ],
                          [
                            -0.16,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            4.61,
                            6.75
                          ],
                          [
                            4.61,
                            3.29
                          ],
                          [
                            5.09,
                            3.29
                          ],
                          [
                            5.14,
                            3.92
                          ],
                          [
                            5.16,
                            3.92
                          ],
                          [
                            5.6,
                            3.4
                          ],
                          [
                            6.15,
                            3.21
                          ],
                          [
                            6.52,
                            3.28
                          ],
                          [
                            6.4,
                            3.79
                          ],
                          [
                            6.25,
                            3.75
                          ],
                          [
                            6.07,
                            3.73
                          ],
                          [
                            5.61,
                            3.91
                          ],
                          [
                            5.2,
                            4.53
                          ],
                          [
                            5.2,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.24,
                            0.14
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.24,
                            -0.29
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0,
                            -0.06
                          ],
                          [
                            0.01,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            -0.22
                          ],
                          [
                            -0.33,
                            0
                          ],
                          [
                            -0.14,
                            0.05
                          ],
                          [
                            -0.13,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0.23,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.15,
                            -0.27
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.15,
                            -0.27
                          ],
                          [
                            0.24,
                            -0.15
                          ],
                          [
                            0.44,
                            0
                          ],
                          [
                            0.24,
                            0.29
                          ],
                          [
                            0,
                            0.06
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            0.36
                          ],
                          [
                            0.21,
                            0.22
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0.09
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            8.41,
                            6.84
                          ],
                          [
                            7.57,
                            6.62
                          ],
                          [
                            6.97,
                            6
                          ],
                          [
                            6.75,
                            5.03
                          ],
                          [
                            6.97,
                            4.05
                          ],
                          [
                            7.55,
                            3.43
                          ],
                          [
                            8.3,
                            3.21
                          ],
                          [
                            9.32,
                            3.65
                          ],
                          [
                            9.68,
                            4.83
                          ],
                          [
                            9.68,
                            5.02
                          ],
                          [
                            9.66,
                            5.16
                          ],
                          [
                            7.33,
                            5.16
                          ],
                          [
                            7.67,
                            6.04
                          ],
                          [
                            8.48,
                            6.37
                          ],
                          [
                            8.93,
                            6.29
                          ],
                          [
                            9.34,
                            6.1
                          ],
                          [
                            9.55,
                            6.48
                          ],
                          [
                            9.04,
                            6.73
                          ],
                          [
                            8.41,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.18
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.2,
                            -0.19
                          ],
                          [
                            0.04,
                            -0.34
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.35
                          ],
                          [
                            -0.15,
                            -0.19
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.19,
                            0.18
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.32,
                            4.75
                          ],
                          [
                            9.17,
                            4.75
                          ],
                          [
                            8.94,
                            3.95
                          ],
                          [
                            8.32,
                            3.67
                          ],
                          [
                            7.66,
                            3.96
                          ],
                          [
                            7.32,
                            4.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.28,
                            0.12
                          ],
                          [
                            0.2,
                            0.21
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            -0.11
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.17,
                            0.14
                          ],
                          [
                            0,
                            0.23
                          ],
                          [
                            0.07,
                            0.09
                          ],
                          [
                            0.12,
                            0.07
                          ],
                          [
                            0.15,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.1
                          ],
                          [
                            0.1,
                            0.16
                          ],
                          [
                            0,
                            0.23
                          ],
                          [
                            -0.12,
                            0.18
                          ],
                          [
                            -0.22,
                            0.1
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.23,
                            -0.11
                          ],
                          [
                            -0.16,
                            -0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.07
                          ],
                          [
                            0.22,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0,
                            -0.21
                          ],
                          [
                            -0.07,
                            -0.1
                          ],
                          [
                            -0.12,
                            -0.06
                          ],
                          [
                            -0.12,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            -0.11
                          ],
                          [
                            -0.09,
                            -0.16
                          ],
                          [
                            0,
                            -0.23
                          ],
                          [
                            0.13,
                            -0.2
                          ],
                          [
                            0.24,
                            -0.12
                          ],
                          [
                            0.33,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.28,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0.18
                          ],
                          [
                            0.23,
                            0.11
                          ],
                          [
                            0.31,
                            0
                          ],
                          [
                            0.17,
                            -0.14
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            -0.07,
                            -0.09
                          ],
                          [
                            -0.11,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            -0.06
                          ],
                          [
                            -0.14,
                            -0.1
                          ],
                          [
                            -0.09,
                            -0.16
                          ],
                          [
                            0,
                            -0.24
                          ],
                          [
                            0.13,
                            -0.19
                          ],
                          [
                            0.22,
                            -0.11
                          ],
                          [
                            0.28,
                            0
                          ],
                          [
                            0.24,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            -0.14
                          ],
                          [
                            -0.17,
                            -0.08
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.16,
                            0.13
                          ],
                          [
                            0,
                            0.14
                          ],
                          [
                            0.08,
                            0.09
                          ],
                          [
                            0.12,
                            0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.07
                          ],
                          [
                            0.15,
                            0.1
                          ],
                          [
                            0.08,
                            0.15
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            -0.13,
                            0.2
                          ],
                          [
                            -0.24,
                            0.12
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            13.31,
                            6.84
                          ],
                          [
                            12.4,
                            6.65
                          ],
                          [
                            11.68,
                            6.14
                          ],
                          [
                            12.03,
                            5.73
                          ],
                          [
                            12.61,
                            6.16
                          ],
                          [
                            13.32,
                            6.32
                          ],
                          [
                            14.04,
                            6.11
                          ],
                          [
                            14.29,
                            5.55
                          ],
                          [
                            14.18,
                            5.17
                          ],
                          [
                            13.91,
                            4.93
                          ],
                          [
                            13.52,
                            4.73
                          ],
                          [
                            12.85,
                            4.44
                          ],
                          [
                            12.41,
                            4.2
                          ],
                          [
                            12.04,
                            3.81
                          ],
                          [
                            11.9,
                            3.24
                          ],
                          [
                            12.09,
                            2.61
                          ],
                          [
                            12.61,
                            2.16
                          ],
                          [
                            13.37,
                            2
                          ],
                          [
                            14.14,
                            2.16
                          ],
                          [
                            14.75,
                            2.57
                          ],
                          [
                            14.43,
                            2.96
                          ],
                          [
                            13.95,
                            2.64
                          ],
                          [
                            13.37,
                            2.52
                          ],
                          [
                            12.73,
                            2.7
                          ],
                          [
                            12.5,
                            3.2
                          ],
                          [
                            12.61,
                            3.57
                          ],
                          [
                            12.91,
                            3.8
                          ],
                          [
                            13.27,
                            3.98
                          ],
                          [
                            13.94,
                            4.26
                          ],
                          [
                            14.42,
                            4.54
                          ],
                          [
                            14.77,
                            4.93
                          ],
                          [
                            14.89,
                            5.5
                          ],
                          [
                            14.7,
                            6.18
                          ],
                          [
                            14.16,
                            6.66
                          ],
                          [
                            13.31,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.25,
                            0.14
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.16,
                            -0.08
                          ],
                          [
                            -0.12,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            0.06
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0.17,
                            -0.11
                          ],
                          [
                            0.09,
                            -0.2
                          ],
                          [
                            0,
                            -0.27
                          ],
                          [
                            -0.2,
                            -0.25
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.14,
                            0.07
                          ],
                          [
                            -0.11,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.08
                          ],
                          [
                            0.21,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.14,
                            -0.27
                          ],
                          [
                            0,
                            -0.39
                          ],
                          [
                            0.16,
                            -0.27
                          ],
                          [
                            0.26,
                            -0.14
                          ],
                          [
                            0.23,
                            0
                          ],
                          [
                            0.16,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.1,
                            -0.09
                          ],
                          [
                            -0.11,
                            -0.06
                          ],
                          [
                            -0.21,
                            0
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            -0.09,
                            0.2
                          ],
                          [
                            0,
                            0.39
                          ],
                          [
                            0.2,
                            0.24
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.14
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.13,
                            6.84
                          ],
                          [
                            16.3,
                            6.62
                          ],
                          [
                            15.71,
                            6
                          ],
                          [
                            15.5,
                            5.03
                          ],
                          [
                            15.73,
                            4.04
                          ],
                          [
                            16.34,
                            3.42
                          ],
                          [
                            17.17,
                            3.21
                          ],
                          [
                            17.75,
                            3.33
                          ],
                          [
                            18.18,
                            3.61
                          ],
                          [
                            17.88,
                            4
                          ],
                          [
                            17.56,
                            3.78
                          ],
                          [
                            17.19,
                            3.69
                          ],
                          [
                            16.63,
                            3.86
                          ],
                          [
                            16.24,
                            4.33
                          ],
                          [
                            16.11,
                            5.03
                          ],
                          [
                            16.4,
                            5.99
                          ],
                          [
                            17.17,
                            6.35
                          ],
                          [
                            17.62,
                            6.25
                          ],
                          [
                            17.98,
                            6
                          ],
                          [
                            18.24,
                            6.39
                          ],
                          [
                            17.72,
                            6.72
                          ],
                          [
                            17.13,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.17
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            -0.34,
                            0.2
                          ],
                          [
                            -0.73,
                            0.08
                          ],
                          [
                            0.04,
                            0.13
                          ],
                          [
                            0.11,
                            0.08
                          ],
                          [
                            0.19,
                            0
                          ],
                          [
                            0.17,
                            -0.07
                          ],
                          [
                            0.14,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.23,
                            0.09
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.19,
                            -0.26
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            -0.1
                          ],
                          [
                            0.22,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.19,
                            -0.18
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.34,
                            -0.2
                          ],
                          [
                            0,
                            -0.14
                          ],
                          [
                            -0.04,
                            -0.13
                          ],
                          [
                            -0.1,
                            -0.09
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.18,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.11
                          ],
                          [
                            0.24,
                            -0.1
                          ],
                          [
                            0.42,
                            0
                          ],
                          [
                            0.19,
                            0.26
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.13
                          ],
                          [
                            -0.19,
                            0.1
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            19.73,
                            6.84
                          ],
                          [
                            19,
                            6.58
                          ],
                          [
                            18.72,
                            5.86
                          ],
                          [
                            19.22,
                            4.98
                          ],
                          [
                            20.84,
                            4.56
                          ],
                          [
                            20.77,
                            4.14
                          ],
                          [
                            20.56,
                            3.82
                          ],
                          [
                            20.13,
                            3.69
                          ],
                          [
                            19.57,
                            3.8
                          ],
                          [
                            19.09,
                            4.06
                          ],
                          [
                            18.87,
                            3.66
                          ],
                          [
                            19.46,
                            3.36
                          ],
                          [
                            20.23,
                            3.21
                          ],
                          [
                            21.14,
                            3.6
                          ],
                          [
                            21.43,
                            4.63
                          ],
                          [
                            21.43,
                            6.75
                          ],
                          [
                            20.95,
                            6.75
                          ],
                          [
                            20.89,
                            6.34
                          ],
                          [
                            20.88,
                            6.34
                          ],
                          [
                            20.34,
                            6.69
                          ],
                          [
                            19.73,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            0.08
                          ],
                          [
                            -0.16,
                            0.15
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            -0.14
                          ],
                          [
                            0,
                            -0.22
                          ],
                          [
                            -0.12,
                            -0.09
                          ],
                          [
                            -0.17,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.17,
                            0
                          ],
                          [
                            0.15,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.57,
                            0.07
                          ],
                          [
                            -0.23,
                            0.14
                          ],
                          [
                            0,
                            0.19
                          ],
                          [
                            0.12,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            19.9,
                            6.37
                          ],
                          [
                            20.37,
                            6.25
                          ],
                          [
                            20.84,
                            5.9
                          ],
                          [
                            20.84,
                            4.95
                          ],
                          [
                            19.63,
                            5.26
                          ],
                          [
                            19.29,
                            5.81
                          ],
                          [
                            19.46,
                            6.24
                          ],
                          [
                            19.9,
                            6.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0.13
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.04
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            -0.04,
                            0.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.01
                          ],
                          [
                            0.08,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.21,
                            0
                          ],
                          [
                            -0.09,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            0.03,
                            0.04
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.02
                          ],
                          [
                            -0.05,
                            0.01
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            23.13,
                            6.84
                          ],
                          [
                            22.66,
                            6.64
                          ],
                          [
                            22.52,
                            6.05
                          ],
                          [
                            22.52,
                            1.69
                          ],
                          [
                            23.1,
                            1.69
                          ],
                          [
                            23.1,
                            6.1
                          ],
                          [
                            23.15,
                            6.29
                          ],
                          [
                            23.26,
                            6.35
                          ],
                          [
                            23.31,
                            6.35
                          ],
                          [
                            23.39,
                            6.34
                          ],
                          [
                            23.47,
                            6.78
                          ],
                          [
                            23.33,
                            6.82
                          ],
                          [
                            23.13,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.24,
                            0.14
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.24,
                            -0.29
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0,
                            -0.06
                          ],
                          [
                            0.01,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            -0.22
                          ],
                          [
                            -0.33,
                            0
                          ],
                          [
                            -0.14,
                            0.05
                          ],
                          [
                            -0.13,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0.23,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.15,
                            -0.27
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.15,
                            -0.27
                          ],
                          [
                            0.24,
                            -0.15
                          ],
                          [
                            0.44,
                            0
                          ],
                          [
                            0.24,
                            0.29
                          ],
                          [
                            0,
                            0.06
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            0.36
                          ],
                          [
                            0.21,
                            0.22
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0.09
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.73,
                            6.84
                          ],
                          [
                            24.89,
                            6.62
                          ],
                          [
                            24.29,
                            6
                          ],
                          [
                            24.07,
                            5.03
                          ],
                          [
                            24.29,
                            4.05
                          ],
                          [
                            24.88,
                            3.43
                          ],
                          [
                            25.62,
                            3.21
                          ],
                          [
                            26.64,
                            3.65
                          ],
                          [
                            27,
                            4.83
                          ],
                          [
                            27,
                            5.02
                          ],
                          [
                            26.98,
                            5.16
                          ],
                          [
                            24.65,
                            5.16
                          ],
                          [
                            24.99,
                            6.04
                          ],
                          [
                            25.8,
                            6.37
                          ],
                          [
                            26.25,
                            6.29
                          ],
                          [
                            26.66,
                            6.1
                          ],
                          [
                            26.87,
                            6.48
                          ],
                          [
                            26.36,
                            6.73
                          ],
                          [
                            25.73,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.18
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.2,
                            -0.19
                          ],
                          [
                            0.04,
                            -0.34
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.35
                          ],
                          [
                            -0.14,
                            -0.19
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.19,
                            0.18
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            24.64,
                            4.75
                          ],
                          [
                            26.49,
                            4.75
                          ],
                          [
                            26.26,
                            3.95
                          ],
                          [
                            25.64,
                            3.67
                          ],
                          [
                            24.98,
                            3.96
                          ],
                          [
                            24.64,
                            4.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0.13
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.11,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.01
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0.12,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            -0.21
                          ],
                          [
                            0.17,
                            -0.13
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.01
                          ],
                          [
                            -0.14,
                            0
                          ],
                          [
                            -0.16,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            27.86,
                            6.75
                          ],
                          [
                            27.86,
                            3.29
                          ],
                          [
                            28.34,
                            3.29
                          ],
                          [
                            28.39,
                            3.92
                          ],
                          [
                            28.41,
                            3.92
                          ],
                          [
                            28.84,
                            3.4
                          ],
                          [
                            29.39,
                            3.21
                          ],
                          [
                            29.76,
                            3.28
                          ],
                          [
                            29.65,
                            3.79
                          ],
                          [
                            29.49,
                            3.75
                          ],
                          [
                            29.31,
                            3.73
                          ],
                          [
                            28.85,
                            3.91
                          ],
                          [
                            28.44,
                            4.53
                          ],
                          [
                            28.44,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.49,
                        0.55,
                        0.65,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "566",
    layers: [
      {
        ind: 565,
        ty: 2,
        parent: 564,
        ks: {
          s: {
            a: 0,
            k: [
              170,
              181.82
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "0"
      },
      {
        ind: 564,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              -0.013
            ]
          },
          s: {
            a: 0,
            k: [
              53.7,
              53.7
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "569",
    layers: [
      {
        ind: 568,
        ty: 0,
        parent: 563,
        ks: {},
        w: 9.13,
        h: 10.714,
        ip: 0,
        op: 565,
        st: 0,
        refId: "566"
      },
      {
        ind: 563,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1.074,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "624",
    layers: [
      {
        ind: 623,
        ty: 2,
        parent: 622,
        ks: {
          s: {
            a: 0,
            k: [
              181.82,
              180
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "1"
      },
      {
        ind: 622,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              -0.012
            ]
          },
          s: {
            a: 0,
            k: [
              53.7,
              53.7
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "627",
    layers: [
      {
        ind: 626,
        ty: 0,
        parent: 621,
        ks: {},
        w: 10.741,
        h: 9.643,
        ip: 0,
        op: 565,
        st: 0,
        refId: "624"
      },
      {
        ind: 621,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1.071
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "664",
    layers: [
      {
        ind: 663,
        ty: 2,
        parent: 662,
        ks: {
          s: {
            a: 0,
            k: [
              181.25,
              183.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "4"
      },
      {
        ind: 662,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              -0.022
            ]
          },
          s: {
            a: 0,
            k: [
              53.7,
              53.7
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "667",
    layers: [
      {
        ind: 666,
        ty: 0,
        parent: 661,
        ks: {},
        w: 15.574,
        h: 17.678,
        ip: 0,
        op: 565,
        st: 0,
        refId: "664"
      },
      {
        ind: 661,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1.074,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "678",
    layers: [
      {
        ind: 677,
        ty: 2,
        parent: 676,
        ks: {
          s: {
            a: 0,
            k: [
              185.71,
              184.38
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "5"
      },
      {
        ind: 676,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              -0.078
            ]
          },
          s: {
            a: 0,
            k: [
              53.7,
              53.7
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "681",
    layers: [
      {
        ind: 680,
        ty: 0,
        parent: 675,
        ks: {},
        w: 62.832,
        h: 63.214,
        ip: 0,
        op: 565,
        st: 0,
        refId: "678"
      },
      {
        ind: 675,
        ty: 3,
        parent: 674,
        ks: {
          p: {
            a: 0,
            k: [
              -4.296,
              -4.286
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 674,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              5,
              5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "685",
    layers: [
      {
        ind: 684,
        ty: 4,
        td: 1,
        parent: 673,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                26.189,
                26.124
              ]
            },
            r: {
              a: 0,
              k: 24
            },
            s: {
              a: 0,
              k: [
                52.377,
                52.249
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 683,
        ty: 0,
        tt: 1,
        parent: 673,
        ks: {
          a: {
            a: 0,
            k: [
              5,
              5
            ]
          }
        },
        w: 68,
        h: 69,
        ip: 0,
        op: 565,
        st: 0,
        refId: "681"
      },
      {
        ind: 673,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              5.82,
              5.805
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "753",
    layers: [
      {
        ind: 752,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                5.5,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                11,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.02
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0.05,
                            0.02
                          ],
                          [
                            0.04,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.02
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            -0.04,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.04
                          ],
                          [
                            -0.05,
                            0.02
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.04
                          ],
                          [
                            0.05,
                            -0.02
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0.05,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.75,
                            1.03
                          ],
                          [
                            7.75,
                            3.06
                          ],
                          [
                            7.64,
                            3.33
                          ],
                          [
                            7.37,
                            3.44
                          ],
                          [
                            7.1,
                            3.33
                          ],
                          [
                            6.98,
                            3.06
                          ],
                          [
                            6.98,
                            1.95
                          ],
                          [
                            4.59,
                            4.34
                          ],
                          [
                            4.46,
                            4.43
                          ],
                          [
                            4.32,
                            4.46
                          ],
                          [
                            4.17,
                            4.43
                          ],
                          [
                            4.05,
                            4.34
                          ],
                          [
                            3.05,
                            3.34
                          ],
                          [
                            1.03,
                            5.36
                          ],
                          [
                            0.76,
                            5.47
                          ],
                          [
                            0.49,
                            5.36
                          ],
                          [
                            0.38,
                            5.09
                          ],
                          [
                            0.49,
                            4.82
                          ],
                          [
                            2.78,
                            2.54
                          ],
                          [
                            2.9,
                            2.45
                          ],
                          [
                            3.05,
                            2.42
                          ],
                          [
                            3.2,
                            2.45
                          ],
                          [
                            3.32,
                            2.54
                          ],
                          [
                            4.32,
                            3.54
                          ],
                          [
                            6.45,
                            1.41
                          ],
                          [
                            5.34,
                            1.41
                          ],
                          [
                            5.07,
                            1.3
                          ],
                          [
                            4.95,
                            1.03
                          ],
                          [
                            5.07,
                            0.76
                          ],
                          [
                            5.34,
                            0.64
                          ],
                          [
                            7.37,
                            0.64
                          ],
                          [
                            7.64,
                            0.76
                          ],
                          [
                            7.75,
                            1.03
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.52,
                        0.32,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "756",
    layers: [
      {
        ind: 755,
        ty: 0,
        parent: 751,
        ks: {},
        w: 11,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "753"
      },
      {
        ind: 751,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "767",
    layers: [
      {
        ind: 766,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2,
                4.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                4,
                9
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            0.15
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.36,
                            0.34
                          ],
                          [
                            0.2,
                            0.19
                          ],
                          [
                            0,
                            0.63
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.75,
                            0
                          ],
                          [
                            0,
                            -0.84
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            0
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.33,
                            -0.32
                          ],
                          [
                            -0.23,
                            -0.23
                          ],
                          [
                            0,
                            -0.51
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.74,
                            0
                          ],
                          [
                            0,
                            0.86
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0.15
                          ],
                          [
                            0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            -0.31,
                            -0.29
                          ],
                          [
                            -0.25,
                            -0.24
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.85
                          ],
                          [
                            0.74,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.15
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.4
                          ],
                          [
                            0.13,
                            0.13
                          ],
                          [
                            0.41,
                            0.41
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.9
                          ],
                          [
                            -0.75,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.23,
                            5.37
                          ],
                          [
                            1.45,
                            5.61
                          ],
                          [
                            1.68,
                            5.37
                          ],
                          [
                            1.68,
                            4.76
                          ],
                          [
                            1.21,
                            3.76
                          ],
                          [
                            0.55,
                            3.13
                          ],
                          [
                            0,
                            1.93
                          ],
                          [
                            0,
                            1.16
                          ],
                          [
                            1.45,
                            0
                          ],
                          [
                            2.89,
                            1.16
                          ],
                          [
                            2.89,
                            2.15
                          ],
                          [
                            1.68,
                            2.15
                          ],
                          [
                            1.68,
                            1.19
                          ],
                          [
                            1.45,
                            0.95
                          ],
                          [
                            1.23,
                            1.19
                          ],
                          [
                            1.23,
                            1.65
                          ],
                          [
                            1.68,
                            2.55
                          ],
                          [
                            2.36,
                            3.2
                          ],
                          [
                            2.91,
                            4.48
                          ],
                          [
                            2.91,
                            5.34
                          ],
                          [
                            1.45,
                            6.55
                          ],
                          [
                            0,
                            5.38
                          ],
                          [
                            0,
                            4.15
                          ],
                          [
                            1.23,
                            4.15
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "772",
    layers: [
      {
        ind: 771,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                4,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            0
                          ],
                          [
                            0,
                            0.15
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            -0.15
                          ]
                        ],
                        o: [
                          [
                            0,
                            0.15
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.64,
                            4.29
                          ],
                          [
                            1.42,
                            4.52
                          ],
                          [
                            1.19,
                            4.29
                          ],
                          [
                            1.19,
                            1.69
                          ],
                          [
                            1.42,
                            1.46
                          ],
                          [
                            1.64,
                            1.69
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            0
                          ],
                          [
                            0,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.76,
                            0
                          ],
                          [
                            0,
                            0.8
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0,
                            -0.56
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.07,
                            0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0.15
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.8
                          ],
                          [
                            0.75,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            -0.12
                          ],
                          [
                            -0.39,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.59
                          ],
                          [
                            0.4,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.64,
                            6.09
                          ],
                          [
                            1.42,
                            6.32
                          ],
                          [
                            1.19,
                            6.09
                          ],
                          [
                            1.19,
                            5.67
                          ],
                          [
                            0.11,
                            5.67
                          ],
                          [
                            0.11,
                            5.96
                          ],
                          [
                            1.41,
                            7.12
                          ],
                          [
                            2.73,
                            5.96
                          ],
                          [
                            2.73,
                            0.58
                          ],
                          [
                            1.66,
                            0.58
                          ],
                          [
                            1.64,
                            0.94
                          ],
                          [
                            1.62,
                            0.94
                          ],
                          [
                            0.9,
                            0.52
                          ],
                          [
                            0.11,
                            1.38
                          ],
                          [
                            0.11,
                            4.45
                          ],
                          [
                            0.91,
                            5.38
                          ],
                          [
                            1.61,
                            5
                          ],
                          [
                            1.64,
                            5
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "777",
    layers: [
      {
        ind: 776,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2.5,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                5,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            0,
                            -0.54
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            -0.14
                          ],
                          [
                            0.42,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.95,
                            1.45
                          ],
                          [
                            1.73,
                            1.69
                          ],
                          [
                            1.73,
                            5.71
                          ],
                          [
                            0.64,
                            5.71
                          ],
                          [
                            0.64,
                            0.58
                          ],
                          [
                            1.7,
                            0.58
                          ],
                          [
                            1.73,
                            0.94
                          ],
                          [
                            1.75,
                            0.94
                          ],
                          [
                            2.48,
                            0.52
                          ],
                          [
                            3.27,
                            1.4
                          ],
                          [
                            3.27,
                            3.33
                          ],
                          [
                            2.18,
                            3.33
                          ],
                          [
                            2.18,
                            1.66
                          ],
                          [
                            1.95,
                            1.45
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "782",
    layers: [
      {
        ind: 781,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                4,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            0.15
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.68,
                            0
                          ],
                          [
                            0,
                            0.77
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.69,
                            0
                          ],
                          [
                            0,
                            -0.76
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0.16
                          ],
                          [
                            0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.77
                          ],
                          [
                            -0.69,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.77
                          ],
                          [
                            0.71,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.08,
                            4.7
                          ],
                          [
                            1.31,
                            4.94
                          ],
                          [
                            1.54,
                            4.7
                          ],
                          [
                            1.54,
                            3.68
                          ],
                          [
                            2.63,
                            3.68
                          ],
                          [
                            2.63,
                            4.62
                          ],
                          [
                            1.3,
                            5.78
                          ],
                          [
                            -0.01,
                            4.62
                          ],
                          [
                            -0.01,
                            1.68
                          ],
                          [
                            1.3,
                            0.52
                          ],
                          [
                            2.63,
                            1.68
                          ],
                          [
                            2.63,
                            3.34
                          ],
                          [
                            1.08,
                            3.34
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            0
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.15
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.54,
                            2.55
                          ],
                          [
                            1.54,
                            1.6
                          ],
                          [
                            1.31,
                            1.36
                          ],
                          [
                            1.08,
                            1.6
                          ],
                          [
                            1.08,
                            2.55
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "787",
    layers: [
      {
        ind: 786,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                4,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            0,
                            -0.54
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            -0.14
                          ],
                          [
                            0.42,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.52,
                            1.45
                          ],
                          [
                            1.3,
                            1.69
                          ],
                          [
                            1.3,
                            5.71
                          ],
                          [
                            0.21,
                            5.71
                          ],
                          [
                            0.21,
                            0.58
                          ],
                          [
                            1.27,
                            0.58
                          ],
                          [
                            1.29,
                            0.94
                          ],
                          [
                            1.32,
                            0.94
                          ],
                          [
                            2.05,
                            0.52
                          ],
                          [
                            2.84,
                            1.4
                          ],
                          [
                            2.84,
                            3.33
                          ],
                          [
                            1.75,
                            3.33
                          ],
                          [
                            1.75,
                            1.66
                          ],
                          [
                            1.52,
                            1.45
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "792",
    layers: [
      {
        ind: 791,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                4,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            0.15
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.68,
                            0
                          ],
                          [
                            0,
                            0.78
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.69,
                            0
                          ],
                          [
                            0,
                            -0.76
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0.15
                          ],
                          [
                            0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.78
                          ],
                          [
                            -0.69,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.77
                          ],
                          [
                            0.71,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.4,
                            4.7
                          ],
                          [
                            1.63,
                            4.94
                          ],
                          [
                            1.85,
                            4.7
                          ],
                          [
                            1.85,
                            3.68
                          ],
                          [
                            2.94,
                            3.68
                          ],
                          [
                            2.94,
                            4.62
                          ],
                          [
                            1.62,
                            5.78
                          ],
                          [
                            0.31,
                            4.62
                          ],
                          [
                            0.31,
                            1.68
                          ],
                          [
                            1.62,
                            0.52
                          ],
                          [
                            2.94,
                            1.68
                          ],
                          [
                            2.94,
                            3.34
                          ],
                          [
                            1.4,
                            3.34
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            0
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.15
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.85,
                            2.55
                          ],
                          [
                            1.85,
                            1.6
                          ],
                          [
                            1.63,
                            1.36
                          ],
                          [
                            1.4,
                            1.6
                          ],
                          [
                            1.4,
                            2.55
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "797",
    layers: [
      {
        ind: 796,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2.5,
                4.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                5,
                9
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.4,
                            0
                          ],
                          [
                            0,
                            0.6
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.43,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.37,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.14
                          ],
                          [
                            0.46,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.58
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            2.22,
                            1.27
                          ],
                          [
                            1.52,
                            1.69
                          ],
                          [
                            1.5,
                            1.69
                          ],
                          [
                            1.5,
                            0.02
                          ],
                          [
                            0.41,
                            0.02
                          ],
                          [
                            0.41,
                            6.46
                          ],
                          [
                            1.49,
                            6.46
                          ],
                          [
                            1.5,
                            6.11
                          ],
                          [
                            1.52,
                            6.11
                          ],
                          [
                            2.21,
                            6.52
                          ],
                          [
                            3.04,
                            5.53
                          ],
                          [
                            3.04,
                            2.2
                          ],
                          [
                            2.22,
                            1.27
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            0
                          ],
                          [
                            0,
                            0.15
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            -0.15
                          ]
                        ],
                        o: [
                          [
                            0,
                            0.15
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.95,
                            5.36
                          ],
                          [
                            1.73,
                            5.59
                          ],
                          [
                            1.5,
                            5.36
                          ],
                          [
                            1.5,
                            2.44
                          ],
                          [
                            1.73,
                            2.2
                          ],
                          [
                            1.95,
                            2.44
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "802",
    layers: [
      {
        ind: 801,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3.5,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                7,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.39,
                            0
                          ],
                          [
                            -0.05,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.41,
                            0
                          ],
                          [
                            0,
                            -0.7
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            0
                          ],
                          [
                            0,
                            -0.15
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            0
                          ],
                          [
                            0,
                            -0.15
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.08,
                            -0.16
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.08,
                            -0.19
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.56,
                            5.71
                          ],
                          [
                            0.47,
                            5.71
                          ],
                          [
                            0.47,
                            0.58
                          ],
                          [
                            1.55,
                            0.58
                          ],
                          [
                            1.56,
                            0.94
                          ],
                          [
                            1.58,
                            0.94
                          ],
                          [
                            2.31,
                            0.52
                          ],
                          [
                            3.04,
                            1.02
                          ],
                          [
                            3.05,
                            1.02
                          ],
                          [
                            3.83,
                            0.52
                          ],
                          [
                            4.64,
                            1.5
                          ],
                          [
                            4.64,
                            5.71
                          ],
                          [
                            3.56,
                            5.71
                          ],
                          [
                            3.56,
                            1.69
                          ],
                          [
                            3.33,
                            1.45
                          ],
                          [
                            3.11,
                            1.69
                          ],
                          [
                            3.11,
                            5.71
                          ],
                          [
                            2.01,
                            5.71
                          ],
                          [
                            2.01,
                            1.69
                          ],
                          [
                            1.78,
                            1.45
                          ],
                          [
                            1.56,
                            1.69
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "807",
    layers: [
      {
        ind: 806,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2.5,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                5,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            0
                          ],
                          [
                            0,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.42,
                            0
                          ],
                          [
                            -0.07,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0.15
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.57
                          ],
                          [
                            0.43,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            2.12,
                            4.61
                          ],
                          [
                            1.89,
                            4.84
                          ],
                          [
                            1.66,
                            4.61
                          ],
                          [
                            1.66,
                            0.58
                          ],
                          [
                            0.57,
                            0.58
                          ],
                          [
                            0.57,
                            4.86
                          ],
                          [
                            1.39,
                            5.78
                          ],
                          [
                            2.11,
                            5.36
                          ],
                          [
                            2.13,
                            5.36
                          ],
                          [
                            2.15,
                            5.71
                          ],
                          [
                            3.2,
                            5.71
                          ],
                          [
                            3.2,
                            0.58
                          ],
                          [
                            2.12,
                            0.58
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "812",
    layers: [
      {
        ind: 811,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2,
                4.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                4,
                9
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            -0.15
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.34,
                            0
                          ],
                          [
                            0.07,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            -0.16
                          ],
                          [
                            0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.7
                          ],
                          [
                            -0.39,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.16,
                            2.49
                          ],
                          [
                            1.39,
                            2.25
                          ],
                          [
                            1.62,
                            2.49
                          ],
                          [
                            1.62,
                            6.46
                          ],
                          [
                            2.71,
                            6.46
                          ],
                          [
                            2.71,
                            2.2
                          ],
                          [
                            1.91,
                            1.27
                          ],
                          [
                            1.18,
                            1.69
                          ],
                          [
                            1.17,
                            1.69
                          ],
                          [
                            1.17,
                            0.02
                          ],
                          [
                            0.08,
                            0.02
                          ],
                          [
                            0.08,
                            6.46
                          ],
                          [
                            1.16,
                            6.46
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "817",
    layers: [
      {
        ind: 816,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                4,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            0
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            0.15
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.72,
                            0
                          ],
                          [
                            0,
                            0.77
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.69,
                            0
                          ],
                          [
                            0,
                            -0.76
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            -0.15
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.15
                          ],
                          [
                            0.12,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.76
                          ],
                          [
                            -0.69,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.77
                          ],
                          [
                            0.71,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.72,
                            1.6
                          ],
                          [
                            1.5,
                            1.36
                          ],
                          [
                            1.27,
                            1.6
                          ],
                          [
                            1.27,
                            4.7
                          ],
                          [
                            1.5,
                            4.93
                          ],
                          [
                            1.72,
                            4.7
                          ],
                          [
                            1.72,
                            3.68
                          ],
                          [
                            2.81,
                            3.68
                          ],
                          [
                            2.81,
                            4.62
                          ],
                          [
                            1.49,
                            5.77
                          ],
                          [
                            0.18,
                            4.62
                          ],
                          [
                            0.18,
                            1.68
                          ],
                          [
                            1.49,
                            0.52
                          ],
                          [
                            2.81,
                            1.68
                          ],
                          [
                            2.81,
                            2.52
                          ],
                          [
                            1.72,
                            2.52
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.2,
                        0.4,
                        1
                      ]
                    },
                    r: 2,
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "822",
    layers: [
      {
        ind: 821,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                1.5,
                4.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                3,
                9
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                0.72,
                                0.02
                              ],
                              [
                                1.81,
                                0.02
                              ],
                              [
                                1.81,
                                6.46
                              ],
                              [
                                0.72,
                                6.46
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0,
                            0.2,
                            0.4,
                            1
                          ]
                        },
                        r: 2,
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "825",
    layers: [
      {
        ind: 769,
        ty: 0,
        parent: 765,
        ks: {},
        w: 4,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "767"
      },
      {
        ind: 765,
        ty: 3,
        parent: 764,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 774,
        ty: 0,
        parent: 770,
        ks: {},
        w: 4,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "772"
      },
      {
        ind: 770,
        ty: 3,
        parent: 764,
        ks: {
          p: {
            a: 0,
            k: [
              35,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 779,
        ty: 0,
        parent: 775,
        ks: {},
        w: 5,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "777"
      },
      {
        ind: 775,
        ty: 3,
        parent: 764,
        ks: {
          p: {
            a: 0,
            k: [
              42,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 784,
        ty: 0,
        parent: 780,
        ks: {},
        w: 4,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "782"
      },
      {
        ind: 780,
        ty: 3,
        parent: 764,
        ks: {
          p: {
            a: 0,
            k: [
              39,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 789,
        ty: 0,
        parent: 785,
        ks: {},
        w: 4,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "787"
      },
      {
        ind: 785,
        ty: 3,
        parent: 764,
        ks: {
          p: {
            a: 0,
            k: [
              31,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 794,
        ty: 0,
        parent: 790,
        ks: {},
        w: 4,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "792"
      },
      {
        ind: 790,
        ty: 3,
        parent: 764,
        ks: {
          p: {
            a: 0,
            k: [
              27,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 799,
        ty: 0,
        parent: 795,
        ks: {},
        w: 5,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "797"
      },
      {
        ind: 795,
        ty: 3,
        parent: 764,
        ks: {
          p: {
            a: 0,
            k: [
              23,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 804,
        ty: 0,
        parent: 800,
        ks: {},
        w: 7,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "802"
      },
      {
        ind: 800,
        ty: 3,
        parent: 764,
        ks: {
          p: {
            a: 0,
            k: [
              17,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 809,
        ty: 0,
        parent: 805,
        ks: {},
        w: 5,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "807"
      },
      {
        ind: 805,
        ty: 3,
        parent: 764,
        ks: {
          p: {
            a: 0,
            k: [
              13,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 814,
        ty: 0,
        parent: 810,
        ks: {},
        w: 4,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "812"
      },
      {
        ind: 810,
        ty: 3,
        parent: 764,
        ks: {
          p: {
            a: 0,
            k: [
              8,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 819,
        ty: 0,
        parent: 815,
        ks: {},
        w: 4,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "817"
      },
      {
        ind: 815,
        ty: 3,
        parent: 764,
        ks: {
          p: {
            a: 0,
            k: [
              4,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 824,
        ty: 0,
        parent: 820,
        ks: {},
        w: 3,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "822"
      },
      {
        ind: 820,
        ty: 3,
        parent: 764,
        ks: {
          p: {
            a: 0,
            k: [
              11,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 764,
        ty: 3,
        parent: 763,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 763,
        ty: 3,
        parent: 762,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 762,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0.026,
              0.033
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "855",
    layers: [
      {
        ind: 854,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                10.5,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                21,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.06,
                            0.07
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            -0.04
                          ],
                          [
                            0,
                            -0.05
                          ],
                          [
                            0.02,
                            -0.04
                          ],
                          [
                            0.03,
                            -0.03
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            -0.07,
                            -0.06
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0.06,
                            -0.07
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.03
                          ],
                          [
                            0.02,
                            0.04
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            -0.02,
                            0.04
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            14.99,
                            3.77
                          ],
                          [
                            11.82,
                            6.93
                          ],
                          [
                            11.57,
                            7.04
                          ],
                          [
                            11.33,
                            6.93
                          ],
                          [
                            11.22,
                            6.68
                          ],
                          [
                            11.33,
                            6.44
                          ],
                          [
                            13.89,
                            3.87
                          ],
                          [
                            0.35,
                            3.87
                          ],
                          [
                            0.1,
                            3.77
                          ],
                          [
                            0,
                            3.52
                          ],
                          [
                            0.1,
                            3.27
                          ],
                          [
                            0.35,
                            3.17
                          ],
                          [
                            13.89,
                            3.17
                          ],
                          [
                            11.33,
                            0.6
                          ],
                          [
                            11.22,
                            0.35
                          ],
                          [
                            11.33,
                            0.1
                          ],
                          [
                            11.57,
                            0
                          ],
                          [
                            11.82,
                            0.1
                          ],
                          [
                            14.99,
                            3.27
                          ],
                          [
                            15.07,
                            3.38
                          ],
                          [
                            15.09,
                            3.52
                          ],
                          [
                            15.07,
                            3.65
                          ],
                          [
                            14.99,
                            3.77
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.57,
                        0.63,
                        0.72,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "888",
    layers: [
      {
        ind: 887,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                31,
                6
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                62,
                12
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.26,
                            -0.08
                          ],
                          [
                            -0.15,
                            -0.21
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            0.32,
                            -0.24
                          ],
                          [
                            0.51,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.26,
                            0.09
                          ],
                          [
                            0.14,
                            0.2
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.32,
                            0.23
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.64,
                            6.75
                          ],
                          [
                            0.64,
                            2.09
                          ],
                          [
                            1.97,
                            2.09
                          ],
                          [
                            2.89,
                            2.21
                          ],
                          [
                            3.5,
                            2.65
                          ],
                          [
                            3.72,
                            3.46
                          ],
                          [
                            3.24,
                            4.55
                          ],
                          [
                            2,
                            4.9
                          ],
                          [
                            1.23,
                            4.9
                          ],
                          [
                            1.23,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.15
                          ],
                          [
                            0,
                            0.33
                          ],
                          [
                            0.21,
                            0.13
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0.2,
                            -0.16
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            -0.2,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.23,
                            4.42
                          ],
                          [
                            1.93,
                            4.42
                          ],
                          [
                            2.83,
                            4.19
                          ],
                          [
                            3.13,
                            3.46
                          ],
                          [
                            2.82,
                            2.76
                          ],
                          [
                            1.9,
                            2.56
                          ],
                          [
                            1.23,
                            2.56
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0.13
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.11,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.01
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0.12,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            -0.21
                          ],
                          [
                            0.17,
                            -0.13
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.01
                          ],
                          [
                            -0.15,
                            0
                          ],
                          [
                            -0.16,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            4.61,
                            6.75
                          ],
                          [
                            4.61,
                            3.29
                          ],
                          [
                            5.09,
                            3.29
                          ],
                          [
                            5.14,
                            3.92
                          ],
                          [
                            5.16,
                            3.92
                          ],
                          [
                            5.6,
                            3.4
                          ],
                          [
                            6.15,
                            3.21
                          ],
                          [
                            6.52,
                            3.28
                          ],
                          [
                            6.4,
                            3.79
                          ],
                          [
                            6.25,
                            3.75
                          ],
                          [
                            6.07,
                            3.73
                          ],
                          [
                            5.61,
                            3.91
                          ],
                          [
                            5.2,
                            4.53
                          ],
                          [
                            5.2,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.24,
                            0.14
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.24,
                            -0.29
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0,
                            -0.06
                          ],
                          [
                            0.01,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            -0.22
                          ],
                          [
                            -0.33,
                            0
                          ],
                          [
                            -0.14,
                            0.05
                          ],
                          [
                            -0.13,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0.23,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.15,
                            -0.27
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.15,
                            -0.27
                          ],
                          [
                            0.24,
                            -0.15
                          ],
                          [
                            0.44,
                            0
                          ],
                          [
                            0.24,
                            0.29
                          ],
                          [
                            0,
                            0.06
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            0.36
                          ],
                          [
                            0.21,
                            0.22
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0.09
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            8.41,
                            6.84
                          ],
                          [
                            7.57,
                            6.62
                          ],
                          [
                            6.97,
                            6
                          ],
                          [
                            6.75,
                            5.03
                          ],
                          [
                            6.97,
                            4.05
                          ],
                          [
                            7.55,
                            3.43
                          ],
                          [
                            8.3,
                            3.21
                          ],
                          [
                            9.32,
                            3.65
                          ],
                          [
                            9.68,
                            4.83
                          ],
                          [
                            9.68,
                            5.02
                          ],
                          [
                            9.66,
                            5.16
                          ],
                          [
                            7.33,
                            5.16
                          ],
                          [
                            7.67,
                            6.04
                          ],
                          [
                            8.48,
                            6.37
                          ],
                          [
                            8.93,
                            6.29
                          ],
                          [
                            9.34,
                            6.1
                          ],
                          [
                            9.55,
                            6.48
                          ],
                          [
                            9.04,
                            6.73
                          ],
                          [
                            8.41,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.18
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.2,
                            -0.19
                          ],
                          [
                            0.04,
                            -0.34
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.35
                          ],
                          [
                            -0.15,
                            -0.19
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.19,
                            0.18
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.32,
                            4.75
                          ],
                          [
                            9.17,
                            4.75
                          ],
                          [
                            8.94,
                            3.95
                          ],
                          [
                            8.32,
                            3.67
                          ],
                          [
                            7.66,
                            3.96
                          ],
                          [
                            7.32,
                            4.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.28,
                            0.12
                          ],
                          [
                            0.2,
                            0.21
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            -0.11
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.17,
                            0.14
                          ],
                          [
                            0,
                            0.23
                          ],
                          [
                            0.07,
                            0.09
                          ],
                          [
                            0.12,
                            0.07
                          ],
                          [
                            0.15,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.1
                          ],
                          [
                            0.1,
                            0.16
                          ],
                          [
                            0,
                            0.23
                          ],
                          [
                            -0.12,
                            0.18
                          ],
                          [
                            -0.22,
                            0.1
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.23,
                            -0.11
                          ],
                          [
                            -0.16,
                            -0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.07
                          ],
                          [
                            0.22,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0,
                            -0.21
                          ],
                          [
                            -0.07,
                            -0.1
                          ],
                          [
                            -0.12,
                            -0.06
                          ],
                          [
                            -0.12,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            -0.11
                          ],
                          [
                            -0.09,
                            -0.16
                          ],
                          [
                            0,
                            -0.23
                          ],
                          [
                            0.13,
                            -0.2
                          ],
                          [
                            0.24,
                            -0.12
                          ],
                          [
                            0.33,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.28,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0.18
                          ],
                          [
                            0.23,
                            0.11
                          ],
                          [
                            0.31,
                            0
                          ],
                          [
                            0.17,
                            -0.14
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            -0.07,
                            -0.09
                          ],
                          [
                            -0.11,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            -0.06
                          ],
                          [
                            -0.14,
                            -0.1
                          ],
                          [
                            -0.09,
                            -0.16
                          ],
                          [
                            0,
                            -0.24
                          ],
                          [
                            0.13,
                            -0.19
                          ],
                          [
                            0.22,
                            -0.11
                          ],
                          [
                            0.28,
                            0
                          ],
                          [
                            0.24,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            -0.14
                          ],
                          [
                            -0.17,
                            -0.08
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.16,
                            0.13
                          ],
                          [
                            0,
                            0.14
                          ],
                          [
                            0.08,
                            0.09
                          ],
                          [
                            0.12,
                            0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.07
                          ],
                          [
                            0.15,
                            0.1
                          ],
                          [
                            0.08,
                            0.15
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            -0.13,
                            0.2
                          ],
                          [
                            -0.24,
                            0.12
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            13.31,
                            6.84
                          ],
                          [
                            12.4,
                            6.65
                          ],
                          [
                            11.68,
                            6.14
                          ],
                          [
                            12.03,
                            5.73
                          ],
                          [
                            12.61,
                            6.16
                          ],
                          [
                            13.32,
                            6.32
                          ],
                          [
                            14.04,
                            6.11
                          ],
                          [
                            14.29,
                            5.55
                          ],
                          [
                            14.18,
                            5.17
                          ],
                          [
                            13.91,
                            4.93
                          ],
                          [
                            13.52,
                            4.73
                          ],
                          [
                            12.85,
                            4.44
                          ],
                          [
                            12.41,
                            4.2
                          ],
                          [
                            12.04,
                            3.81
                          ],
                          [
                            11.9,
                            3.24
                          ],
                          [
                            12.09,
                            2.61
                          ],
                          [
                            12.61,
                            2.16
                          ],
                          [
                            13.37,
                            2
                          ],
                          [
                            14.14,
                            2.16
                          ],
                          [
                            14.75,
                            2.57
                          ],
                          [
                            14.43,
                            2.96
                          ],
                          [
                            13.95,
                            2.64
                          ],
                          [
                            13.37,
                            2.52
                          ],
                          [
                            12.73,
                            2.7
                          ],
                          [
                            12.5,
                            3.2
                          ],
                          [
                            12.61,
                            3.57
                          ],
                          [
                            12.91,
                            3.8
                          ],
                          [
                            13.27,
                            3.98
                          ],
                          [
                            13.94,
                            4.26
                          ],
                          [
                            14.42,
                            4.54
                          ],
                          [
                            14.77,
                            4.93
                          ],
                          [
                            14.89,
                            5.5
                          ],
                          [
                            14.7,
                            6.18
                          ],
                          [
                            14.16,
                            6.66
                          ],
                          [
                            13.31,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.25,
                            0.14
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.16,
                            -0.08
                          ],
                          [
                            -0.12,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            0.06
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0.17,
                            -0.11
                          ],
                          [
                            0.09,
                            -0.2
                          ],
                          [
                            0,
                            -0.27
                          ],
                          [
                            -0.2,
                            -0.25
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.14,
                            0.07
                          ],
                          [
                            -0.11,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.08
                          ],
                          [
                            0.21,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.14,
                            -0.27
                          ],
                          [
                            0,
                            -0.39
                          ],
                          [
                            0.16,
                            -0.27
                          ],
                          [
                            0.26,
                            -0.14
                          ],
                          [
                            0.23,
                            0
                          ],
                          [
                            0.16,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.1,
                            -0.09
                          ],
                          [
                            -0.11,
                            -0.06
                          ],
                          [
                            -0.21,
                            0
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            -0.09,
                            0.2
                          ],
                          [
                            0,
                            0.39
                          ],
                          [
                            0.2,
                            0.24
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.14
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.13,
                            6.84
                          ],
                          [
                            16.3,
                            6.62
                          ],
                          [
                            15.71,
                            6
                          ],
                          [
                            15.5,
                            5.03
                          ],
                          [
                            15.73,
                            4.04
                          ],
                          [
                            16.34,
                            3.42
                          ],
                          [
                            17.17,
                            3.21
                          ],
                          [
                            17.75,
                            3.33
                          ],
                          [
                            18.18,
                            3.61
                          ],
                          [
                            17.88,
                            4
                          ],
                          [
                            17.56,
                            3.78
                          ],
                          [
                            17.19,
                            3.69
                          ],
                          [
                            16.63,
                            3.86
                          ],
                          [
                            16.24,
                            4.33
                          ],
                          [
                            16.11,
                            5.03
                          ],
                          [
                            16.4,
                            5.99
                          ],
                          [
                            17.17,
                            6.35
                          ],
                          [
                            17.62,
                            6.25
                          ],
                          [
                            17.98,
                            6
                          ],
                          [
                            18.24,
                            6.39
                          ],
                          [
                            17.72,
                            6.72
                          ],
                          [
                            17.13,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.17
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            -0.34,
                            0.2
                          ],
                          [
                            -0.73,
                            0.08
                          ],
                          [
                            0.04,
                            0.13
                          ],
                          [
                            0.11,
                            0.08
                          ],
                          [
                            0.19,
                            0
                          ],
                          [
                            0.17,
                            -0.07
                          ],
                          [
                            0.14,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.23,
                            0.09
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.19,
                            -0.26
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            -0.1
                          ],
                          [
                            0.22,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.19,
                            -0.18
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.34,
                            -0.2
                          ],
                          [
                            0,
                            -0.14
                          ],
                          [
                            -0.04,
                            -0.13
                          ],
                          [
                            -0.1,
                            -0.09
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.18,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.11
                          ],
                          [
                            0.24,
                            -0.1
                          ],
                          [
                            0.42,
                            0
                          ],
                          [
                            0.19,
                            0.26
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.13
                          ],
                          [
                            -0.19,
                            0.1
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            19.73,
                            6.84
                          ],
                          [
                            19,
                            6.58
                          ],
                          [
                            18.72,
                            5.86
                          ],
                          [
                            19.22,
                            4.98
                          ],
                          [
                            20.84,
                            4.56
                          ],
                          [
                            20.77,
                            4.14
                          ],
                          [
                            20.56,
                            3.82
                          ],
                          [
                            20.13,
                            3.69
                          ],
                          [
                            19.57,
                            3.8
                          ],
                          [
                            19.09,
                            4.06
                          ],
                          [
                            18.87,
                            3.66
                          ],
                          [
                            19.46,
                            3.36
                          ],
                          [
                            20.23,
                            3.21
                          ],
                          [
                            21.14,
                            3.6
                          ],
                          [
                            21.43,
                            4.63
                          ],
                          [
                            21.43,
                            6.75
                          ],
                          [
                            20.95,
                            6.75
                          ],
                          [
                            20.89,
                            6.34
                          ],
                          [
                            20.88,
                            6.34
                          ],
                          [
                            20.34,
                            6.69
                          ],
                          [
                            19.73,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            0.08
                          ],
                          [
                            -0.16,
                            0.15
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            -0.14
                          ],
                          [
                            0,
                            -0.22
                          ],
                          [
                            -0.12,
                            -0.09
                          ],
                          [
                            -0.17,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.17,
                            0
                          ],
                          [
                            0.15,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.57,
                            0.07
                          ],
                          [
                            -0.23,
                            0.14
                          ],
                          [
                            0,
                            0.19
                          ],
                          [
                            0.12,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            19.9,
                            6.37
                          ],
                          [
                            20.37,
                            6.25
                          ],
                          [
                            20.84,
                            5.9
                          ],
                          [
                            20.84,
                            4.95
                          ],
                          [
                            19.63,
                            5.26
                          ],
                          [
                            19.29,
                            5.81
                          ],
                          [
                            19.46,
                            6.24
                          ],
                          [
                            19.9,
                            6.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0.13
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.04
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            -0.04,
                            0.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.01
                          ],
                          [
                            0.08,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.21,
                            0
                          ],
                          [
                            -0.09,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            0.03,
                            0.04
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.02
                          ],
                          [
                            -0.05,
                            0.01
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            23.13,
                            6.84
                          ],
                          [
                            22.66,
                            6.64
                          ],
                          [
                            22.52,
                            6.05
                          ],
                          [
                            22.52,
                            1.69
                          ],
                          [
                            23.1,
                            1.69
                          ],
                          [
                            23.1,
                            6.1
                          ],
                          [
                            23.15,
                            6.29
                          ],
                          [
                            23.26,
                            6.35
                          ],
                          [
                            23.31,
                            6.35
                          ],
                          [
                            23.39,
                            6.34
                          ],
                          [
                            23.47,
                            6.78
                          ],
                          [
                            23.33,
                            6.82
                          ],
                          [
                            23.13,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.24,
                            0.14
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.24,
                            -0.29
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0,
                            -0.06
                          ],
                          [
                            0.01,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            -0.22
                          ],
                          [
                            -0.33,
                            0
                          ],
                          [
                            -0.14,
                            0.05
                          ],
                          [
                            -0.13,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0.23,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.15,
                            -0.27
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.15,
                            -0.27
                          ],
                          [
                            0.24,
                            -0.15
                          ],
                          [
                            0.44,
                            0
                          ],
                          [
                            0.24,
                            0.29
                          ],
                          [
                            0,
                            0.06
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            0.36
                          ],
                          [
                            0.21,
                            0.22
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0.09
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.73,
                            6.84
                          ],
                          [
                            24.89,
                            6.62
                          ],
                          [
                            24.29,
                            6
                          ],
                          [
                            24.07,
                            5.03
                          ],
                          [
                            24.29,
                            4.05
                          ],
                          [
                            24.88,
                            3.43
                          ],
                          [
                            25.62,
                            3.21
                          ],
                          [
                            26.64,
                            3.65
                          ],
                          [
                            27,
                            4.83
                          ],
                          [
                            27,
                            5.02
                          ],
                          [
                            26.98,
                            5.16
                          ],
                          [
                            24.65,
                            5.16
                          ],
                          [
                            24.99,
                            6.04
                          ],
                          [
                            25.8,
                            6.37
                          ],
                          [
                            26.25,
                            6.29
                          ],
                          [
                            26.66,
                            6.1
                          ],
                          [
                            26.87,
                            6.48
                          ],
                          [
                            26.36,
                            6.73
                          ],
                          [
                            25.73,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.18
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.2,
                            -0.19
                          ],
                          [
                            0.04,
                            -0.34
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.35
                          ],
                          [
                            -0.14,
                            -0.19
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.19,
                            0.18
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            24.64,
                            4.75
                          ],
                          [
                            26.49,
                            4.75
                          ],
                          [
                            26.26,
                            3.95
                          ],
                          [
                            25.64,
                            3.67
                          ],
                          [
                            24.98,
                            3.96
                          ],
                          [
                            24.64,
                            4.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0.13
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.11,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.01
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0.12,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            -0.21
                          ],
                          [
                            0.17,
                            -0.13
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.01
                          ],
                          [
                            -0.14,
                            0
                          ],
                          [
                            -0.16,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            27.86,
                            6.75
                          ],
                          [
                            27.86,
                            3.29
                          ],
                          [
                            28.34,
                            3.29
                          ],
                          [
                            28.39,
                            3.92
                          ],
                          [
                            28.41,
                            3.92
                          ],
                          [
                            28.84,
                            3.4
                          ],
                          [
                            29.39,
                            3.21
                          ],
                          [
                            29.76,
                            3.28
                          ],
                          [
                            29.65,
                            3.79
                          ],
                          [
                            29.49,
                            3.75
                          ],
                          [
                            29.31,
                            3.73
                          ],
                          [
                            28.85,
                            3.91
                          ],
                          [
                            28.44,
                            4.53
                          ],
                          [
                            28.44,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.49,
                        0.55,
                        0.65,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "914",
    layers: [
      {
        ind: 913,
        ty: 2,
        parent: 912,
        ks: {
          s: {
            a: 0,
            k: [
              170,
              181.82
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "0"
      },
      {
        ind: 912,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "917",
    layers: [
      {
        ind: 916,
        ty: 0,
        parent: 911,
        ks: {},
        w: 8.5,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "914"
      },
      {
        ind: 911,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "968",
    layers: [
      {
        ind: 967,
        ty: 2,
        parent: 966,
        ks: {
          s: {
            a: 0,
            k: [
              181.82,
              180
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "1"
      },
      {
        ind: 966,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "971",
    layers: [
      {
        ind: 970,
        ty: 0,
        parent: 965,
        ks: {},
        w: 10,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "968"
      },
      {
        ind: 965,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1019",
    layers: [
      {
        ind: 1018,
        ty: 2,
        parent: 1017,
        ks: {
          s: {
            a: 0,
            k: [
              181.25,
              183.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "6"
      },
      {
        ind: 1017,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1022",
    layers: [
      {
        ind: 1021,
        ty: 0,
        parent: 1016,
        ks: {},
        w: 14.5,
        h: 16.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1019"
      },
      {
        ind: 1016,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1033",
    layers: [
      {
        ind: 1032,
        ty: 2,
        parent: 1031,
        ks: {
          s: {
            a: 0,
            k: [
              185.71,
              185.71
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "7"
      },
      {
        ind: 1031,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1036",
    layers: [
      {
        ind: 1035,
        ty: 0,
        parent: 1030,
        ks: {},
        w: 58.5,
        h: 58.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1033"
      },
      {
        ind: 1030,
        ty: 3,
        parent: 1029,
        ks: {
          p: {
            a: 0,
            k: [
              -5,
              -3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1029,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              5,
              4
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1040",
    layers: [
      {
        ind: 1039,
        ty: 4,
        td: 1,
        parent: 1028,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                24.383,
                24.383
              ]
            },
            r: {
              a: 0,
              k: 24
            },
            s: {
              a: 0,
              k: [
                48.766,
                48.766
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1038,
        ty: 0,
        tt: 1,
        parent: 1028,
        ks: {
          a: {
            a: 0,
            k: [
              5,
              4
            ]
          }
        },
        w: 64,
        h: 63,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1036"
      },
      {
        ind: 1028,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              5.418,
              5.418
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1108",
    layers: [
      {
        ind: 1107,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                5.5,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                11,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.02
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0.04,
                            0.02
                          ],
                          [
                            0.04,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.02
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            -0.03,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.03,
                            0.04
                          ],
                          [
                            -0.05,
                            0.02
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.04
                          ],
                          [
                            0.04,
                            -0.02
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0.04,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.53,
                            0.98
                          ],
                          [
                            7.53,
                            2.95
                          ],
                          [
                            7.42,
                            3.21
                          ],
                          [
                            7.16,
                            3.32
                          ],
                          [
                            6.9,
                            3.21
                          ],
                          [
                            6.79,
                            2.95
                          ],
                          [
                            6.79,
                            1.88
                          ],
                          [
                            4.46,
                            4.2
                          ],
                          [
                            4.34,
                            4.29
                          ],
                          [
                            4.2,
                            4.31
                          ],
                          [
                            4.05,
                            4.29
                          ],
                          [
                            3.93,
                            4.2
                          ],
                          [
                            2.96,
                            3.23
                          ],
                          [
                            1,
                            5.19
                          ],
                          [
                            0.74,
                            5.3
                          ],
                          [
                            0.48,
                            5.19
                          ],
                          [
                            0.37,
                            4.93
                          ],
                          [
                            0.48,
                            4.67
                          ],
                          [
                            2.7,
                            2.45
                          ],
                          [
                            2.82,
                            2.36
                          ],
                          [
                            2.96,
                            2.34
                          ],
                          [
                            3.11,
                            2.36
                          ],
                          [
                            3.22,
                            2.45
                          ],
                          [
                            4.2,
                            3.42
                          ],
                          [
                            6.27,
                            1.35
                          ],
                          [
                            5.18,
                            1.35
                          ],
                          [
                            4.92,
                            1.24
                          ],
                          [
                            4.81,
                            0.98
                          ],
                          [
                            4.92,
                            0.71
                          ],
                          [
                            5.18,
                            0.61
                          ],
                          [
                            7.16,
                            0.61
                          ],
                          [
                            7.42,
                            0.71
                          ],
                          [
                            7.53,
                            0.98
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.52,
                        0.32,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1111",
    layers: [
      {
        ind: 1110,
        ty: 0,
        parent: 1106,
        ks: {},
        w: 11,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1108"
      },
      {
        ind: 1106,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1119",
    layers: [
      {
        ind: 1118,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                1,
                1
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                2,
                2
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.02
                              ],
                              [
                                0.03,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                0.03,
                                0
                              ],
                              [
                                0,
                                -0.02
                              ],
                              [
                                -0.01,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                0.38,
                                0.72
                              ],
                              [
                                0.4,
                                0.72
                              ],
                              [
                                0.45,
                                0.69
                              ],
                              [
                                0.41,
                                0.66
                              ],
                              [
                                0.38,
                                0.66
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.05,
                                0
                              ],
                              [
                                -0.02,
                                -0.01
                              ],
                              [
                                0,
                                -0.03
                              ],
                              [
                                0.04,
                                -0.01
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.01,
                                -0.04
                              ],
                              [
                                0,
                                -0.01
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.02
                              ],
                              [
                                0.03,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.02,
                                0
                              ],
                              [
                                0.06,
                                0
                              ],
                              [
                                0.02,
                                0.01
                              ],
                              [
                                0,
                                0.03
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.03,
                                0.01
                              ],
                              [
                                0.01,
                                0.04
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.01,
                                -0.01
                              ],
                              [
                                -0.01,
                                -0.03
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                0.38,
                                0.87
                              ],
                              [
                                0.3,
                                0.87
                              ],
                              [
                                0.3,
                                0.61
                              ],
                              [
                                0.41,
                                0.6
                              ],
                              [
                                0.52,
                                0.62
                              ],
                              [
                                0.55,
                                0.68
                              ],
                              [
                                0.48,
                                0.74
                              ],
                              [
                                0.48,
                                0.74
                              ],
                              [
                                0.54,
                                0.81
                              ],
                              [
                                0.55,
                                0.87
                              ],
                              [
                                0.46,
                                0.87
                              ],
                              [
                                0.45,
                                0.82
                              ],
                              [
                                0.4,
                                0.78
                              ],
                              [
                                0.38,
                                0.78
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -0.12
                              ],
                              [
                                -0.12,
                                0
                              ],
                              [
                                0,
                                0.12
                              ],
                              [
                                0.12,
                                0
                              ]
                            ],
                            o: [
                              [
                                -0.11,
                                0
                              ],
                              [
                                0,
                                0.12
                              ],
                              [
                                0.12,
                                0
                              ],
                              [
                                0,
                                -0.12
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                0.41,
                                0.53
                              ],
                              [
                                0.21,
                                0.74
                              ],
                              [
                                0.41,
                                0.95
                              ],
                              [
                                0.62,
                                0.74
                              ],
                              [
                                0.41,
                                0.53
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !1,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                -0.16
                              ],
                              [
                                0.16,
                                0
                              ],
                              [
                                0,
                                0.16
                              ],
                              [
                                -0.16,
                                0
                              ]
                            ],
                            o: [
                              [
                                0.16,
                                0
                              ],
                              [
                                0,
                                0.16
                              ],
                              [
                                -0.16,
                                0
                              ],
                              [
                                0,
                                -0.16
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                0.42,
                                0.46
                              ],
                              [
                                0.7,
                                0.74
                              ],
                              [
                                0.41,
                                1.02
                              ],
                              [
                                0.13,
                                0.74
                              ],
                              [
                                0.41,
                                0.46
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0.99,
                            0.73,
                            0.19,
                            1
                          ]
                        },
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1124",
    layers: [
      {
        ind: 1123,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                26,
                5.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                52,
                11
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            -0.09
                          ],
                          [
                            0.49,
                            0
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.95,
                            -0.01
                          ]
                        ],
                        o: [
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.12,
                            0.38
                          ],
                          [
                            -0.41,
                            0
                          ],
                          [
                            0,
                            -0.76
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            29.58,
                            5.77
                          ],
                          [
                            29.55,
                            6.07
                          ],
                          [
                            28.54,
                            6.77
                          ],
                          [
                            27.8,
                            6.05
                          ],
                          [
                            29.58,
                            5.09
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !1,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            1.8,
                            0
                          ],
                          [
                            0.4,
                            -0.23
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.55,
                            0
                          ],
                          [
                            0,
                            -0.33
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.41
                          ],
                          [
                            -1.12,
                            0
                          ],
                          [
                            -0.34,
                            0.44
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.26,
                            0.36
                          ],
                          [
                            0,
                            0.51
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            -1.25
                          ],
                          [
                            -0.93,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.37,
                            -0.23
                          ],
                          [
                            0.91,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.99,
                            0
                          ],
                          [
                            0,
                            0.86
                          ],
                          [
                            0.69,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.4
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            31.07,
                            4.45
                          ],
                          [
                            28.73,
                            2.11
                          ],
                          [
                            26.68,
                            2.6
                          ],
                          [
                            26.97,
                            3.6
                          ],
                          [
                            28.47,
                            3.18
                          ],
                          [
                            29.54,
                            4.03
                          ],
                          [
                            29.54,
                            4.11
                          ],
                          [
                            26.28,
                            6.2
                          ],
                          [
                            28.04,
                            7.86
                          ],
                          [
                            29.64,
                            7.15
                          ],
                          [
                            29.68,
                            7.15
                          ],
                          [
                            31.16,
                            7.74
                          ],
                          [
                            31.07,
                            6.41
                          ],
                          [
                            31.07,
                            4.45
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            -0.87
                          ],
                          [
                            -1.26,
                            0.25
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            0.84
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            -0.82
                          ],
                          [
                            -0.17,
                            -0.79
                          ],
                          [
                            -1.24,
                            0.27
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            -0.84
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.9
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            -0.82
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.93
                          ],
                          [
                            0.15,
                            0.78
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0.24,
                            1.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            -0.82
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0.84
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.17,
                            0.79
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            0.93
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.11,
                            -0.84
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            0.96
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            -0.77
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.01,
                            0.4
                          ],
                          [
                            1.52,
                            6.61
                          ],
                          [
                            3.46,
                            7.74
                          ],
                          [
                            4.27,
                            4.43
                          ],
                          [
                            4.75,
                            2.19
                          ],
                          [
                            4.77,
                            2.19
                          ],
                          [
                            5.17,
                            4.43
                          ],
                          [
                            5.67,
                            6.73
                          ],
                          [
                            7.55,
                            7.74
                          ],
                          [
                            9.49,
                            0.4
                          ],
                          [
                            7.92,
                            0.4
                          ],
                          [
                            7.26,
                            3.57
                          ],
                          [
                            6.8,
                            6.07
                          ],
                          [
                            6.77,
                            6.07
                          ],
                          [
                            6.34,
                            3.64
                          ],
                          [
                            5.65,
                            0.4
                          ],
                          [
                            4.02,
                            0.4
                          ],
                          [
                            3.28,
                            3.55
                          ],
                          [
                            2.75,
                            6.1
                          ],
                          [
                            2.73,
                            6.1
                          ],
                          [
                            2.25,
                            3.43
                          ],
                          [
                            1.66,
                            0.4
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            -0.09
                          ],
                          [
                            0.5,
                            0
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.95,
                            -0.01
                          ]
                        ],
                        o: [
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.12,
                            0.38
                          ],
                          [
                            -0.41,
                            0
                          ],
                          [
                            0,
                            -0.76
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            12.45,
                            5.77
                          ],
                          [
                            12.41,
                            6.07
                          ],
                          [
                            11.4,
                            6.77
                          ],
                          [
                            10.66,
                            6.05
                          ],
                          [
                            12.45,
                            5.09
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            1.8,
                            0
                          ],
                          [
                            0.4,
                            -0.23
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.55,
                            0
                          ],
                          [
                            0,
                            -0.33
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.41
                          ],
                          [
                            -1.12,
                            0
                          ],
                          [
                            -0.34,
                            0.44
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.26,
                            0.36
                          ],
                          [
                            0,
                            0.51
                          ]
                        ],
                        o: [
                          [
                            0,
                            -1.25
                          ],
                          [
                            -0.93,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.36,
                            -0.23
                          ],
                          [
                            0.92,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -2,
                            0
                          ],
                          [
                            0,
                            0.86
                          ],
                          [
                            0.68,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.4
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            13.93,
                            4.45
                          ],
                          [
                            11.6,
                            2.11
                          ],
                          [
                            9.54,
                            2.6
                          ],
                          [
                            9.83,
                            3.6
                          ],
                          [
                            11.33,
                            3.18
                          ],
                          [
                            12.4,
                            4.03
                          ],
                          [
                            12.4,
                            4.11
                          ],
                          [
                            9.14,
                            6.2
                          ],
                          [
                            10.9,
                            7.86
                          ],
                          [
                            12.5,
                            7.15
                          ],
                          [
                            12.54,
                            7.15
                          ],
                          [
                            14.02,
                            7.74
                          ],
                          [
                            13.93,
                            6.41
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            16.42,
                            6.18
                          ],
                          [
                            16.42,
                            0.4
                          ],
                          [
                            14.93,
                            0.4
                          ],
                          [
                            14.93,
                            7.74
                          ],
                          [
                            16.42,
                            7.74
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.3,
                            -0.32
                          ],
                          [
                            -0.52,
                            0
                          ],
                          [
                            -0.2,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.24,
                            0
                          ],
                          [
                            0,
                            0.67
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.75
                          ],
                          [
                            0.27,
                            0.28
                          ],
                          [
                            0.44,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0.04
                          ],
                          [
                            -0.51,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            35.91,
                            0.4
                          ],
                          [
                            35.91,
                            5.82
                          ],
                          [
                            36.35,
                            7.41
                          ],
                          [
                            37.57,
                            7.87
                          ],
                          [
                            38.64,
                            7.71
                          ],
                          [
                            38.63,
                            6.54
                          ],
                          [
                            38.06,
                            6.61
                          ],
                          [
                            37.38,
                            5.61
                          ],
                          [
                            37.38,
                            3.54
                          ],
                          [
                            38.68,
                            3.54
                          ],
                          [
                            38.68,
                            2.14
                          ],
                          [
                            37.38,
                            2.14
                          ],
                          [
                            37.38,
                            0.4
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            0.12
                          ],
                          [
                            -0.65,
                            0
                          ],
                          [
                            -0.14,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0.27,
                            -0.79
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.15
                          ],
                          [
                            0.11,
                            -0.59
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.11,
                            -0.02
                          ],
                          [
                            -0.57,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            32.07,
                            2.23
                          ],
                          [
                            32.07,
                            7.74
                          ],
                          [
                            33.6,
                            7.74
                          ],
                          [
                            33.6,
                            4.92
                          ],
                          [
                            33.64,
                            4.51
                          ],
                          [
                            34.85,
                            3.54
                          ],
                          [
                            35.29,
                            3.58
                          ],
                          [
                            35.29,
                            2.14
                          ],
                          [
                            34.96,
                            2.11
                          ],
                          [
                            33.46,
                            3.27
                          ],
                          [
                            33.41,
                            3.27
                          ],
                          [
                            33.41,
                            2.23
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !1,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.14
                          ],
                          [
                            -0.48,
                            0
                          ],
                          [
                            0,
                            -0.73
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.13
                          ],
                          [
                            -0.45,
                            0
                          ],
                          [
                            0,
                            -0.87
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.98,
                            0
                          ],
                          [
                            0.31,
                            -0.19
                          ],
                          [
                            0.21,
                            -0.3
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.73,
                            0
                          ],
                          [
                            0.25,
                            -0.4
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.15
                          ],
                          [
                            0.12,
                            -0.33
                          ],
                          [
                            0.6,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.14
                          ],
                          [
                            0.12,
                            -0.37
                          ],
                          [
                            0.61,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.71
                          ],
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.26,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.24,
                            -0.59
                          ],
                          [
                            -0.93,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.46,
                            2.23
                          ],
                          [
                            17.46,
                            7.74
                          ],
                          [
                            18.96,
                            7.74
                          ],
                          [
                            18.96,
                            4.51
                          ],
                          [
                            19.03,
                            4.06
                          ],
                          [
                            19.94,
                            3.35
                          ],
                          [
                            20.83,
                            4.6
                          ],
                          [
                            20.83,
                            7.74
                          ],
                          [
                            22.32,
                            7.74
                          ],
                          [
                            22.32,
                            4.47
                          ],
                          [
                            22.39,
                            4.02
                          ],
                          [
                            23.29,
                            3.35
                          ],
                          [
                            24.19,
                            4.72
                          ],
                          [
                            24.19,
                            7.74
                          ],
                          [
                            25.69,
                            7.74
                          ],
                          [
                            25.69,
                            4.49
                          ],
                          [
                            23.84,
                            2.11
                          ],
                          [
                            22.75,
                            2.4
                          ],
                          [
                            22.05,
                            3.09
                          ],
                          [
                            22.03,
                            3.09
                          ],
                          [
                            20.51,
                            2.11
                          ],
                          [
                            18.91,
                            2.98
                          ],
                          [
                            18.88,
                            2.98
                          ],
                          [
                            18.88,
                            2.23
                          ],
                          [
                            17.46,
                            2.23
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.46,
                        0.81,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1129",
    layers: [
      {
        ind: 1128,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                8,
                8.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                16,
                17
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.2
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.48,
                            0
                          ],
                          [
                            0,
                            -0.33
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.29,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.3,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.33
                          ],
                          [
                            -0.48,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.2
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            6.23,
                            4.26
                          ],
                          [
                            6.8,
                            3.9
                          ],
                          [
                            7.1,
                            0.6
                          ],
                          [
                            6.23,
                            0
                          ],
                          [
                            5.37,
                            0.6
                          ],
                          [
                            5.66,
                            3.9
                          ],
                          [
                            6.23,
                            4.26
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.24,
                            -0.42
                          ],
                          [
                            -0.28,
                            -0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0.25
                          ]
                        ],
                        o: [
                          [
                            0.15,
                            -0.25
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.28,
                            -0.16
                          ],
                          [
                            -0.24,
                            0.42
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            4.44,
                            5.29
                          ],
                          [
                            4.42,
                            4.62
                          ],
                          [
                            1.7,
                            2.71
                          ],
                          [
                            0.76,
                            3.16
                          ],
                          [
                            0.84,
                            4.21
                          ],
                          [
                            3.85,
                            5.61
                          ],
                          [
                            4.45,
                            5.29
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.24,
                            0.42
                          ],
                          [
                            0.29,
                            -0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            -0.25
                          ]
                        ],
                        o: [
                          [
                            0.15,
                            0.25
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.29,
                            -0.16
                          ],
                          [
                            -0.24,
                            -0.41
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.13
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            8.02,
                            5.29
                          ],
                          [
                            8.61,
                            5.61
                          ],
                          [
                            11.62,
                            4.21
                          ],
                          [
                            11.71,
                            3.16
                          ],
                          [
                            10.76,
                            2.71
                          ],
                          [
                            8.04,
                            4.62
                          ],
                          [
                            8.02,
                            5.29
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.2
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.48,
                            0
                          ],
                          [
                            0,
                            0.33
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.29,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.3,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.33
                          ],
                          [
                            -0.48,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            -0.2
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            6.23,
                            8.39
                          ],
                          [
                            6.8,
                            8.74
                          ],
                          [
                            7.1,
                            12.05
                          ],
                          [
                            6.23,
                            12.64
                          ],
                          [
                            5.37,
                            12.05
                          ],
                          [
                            5.66,
                            8.74
                          ],
                          [
                            6.23,
                            8.39
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !1,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.24,
                            -0.42
                          ],
                          [
                            0.29,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            0.25
                          ]
                        ],
                        o: [
                          [
                            0.15,
                            -0.26
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.29,
                            0.16
                          ],
                          [
                            -0.24,
                            0.41
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            8.02,
                            7.36
                          ],
                          [
                            8.61,
                            7.04
                          ],
                          [
                            11.62,
                            8.44
                          ],
                          [
                            11.71,
                            9.48
                          ],
                          [
                            10.76,
                            9.93
                          ],
                          [
                            8.04,
                            8.03
                          ],
                          [
                            8.02,
                            7.36
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !1,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.24,
                            0.41
                          ],
                          [
                            -0.28,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            -0.26
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.15,
                            0.25
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.28,
                            0.16
                          ],
                          [
                            -0.24,
                            -0.42
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            4.44,
                            7.36
                          ],
                          [
                            4.42,
                            8.03
                          ],
                          [
                            1.7,
                            9.93
                          ],
                          [
                            0.76,
                            9.48
                          ],
                          [
                            0.84,
                            8.44
                          ],
                          [
                            3.85,
                            7.04
                          ],
                          [
                            4.45,
                            7.36
                          ],
                          [
                            4.44,
                            7.36
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.99,
                        0.73,
                        0.19,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1132",
    layers: [
      {
        ind: 1121,
        ty: 0,
        parent: 1117,
        ks: {},
        w: 2,
        h: 2,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1119"
      },
      {
        ind: 1117,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              70,
              12
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1126,
        ty: 0,
        parent: 1122,
        ks: {},
        w: 52,
        h: 11,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1124"
      },
      {
        ind: 1122,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1131,
        ty: 0,
        parent: 1127,
        ks: {},
        w: 16,
        h: 17,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1129"
      },
      {
        ind: 1127,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              54,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1162",
    layers: [
      {
        ind: 1161,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                12.5,
                6.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                25,
                13
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            -0.06
                          ],
                          [
                            0,
                            -0.06
                          ],
                          [
                            0.02,
                            -0.06
                          ],
                          [
                            0.04,
                            -0.05
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            0.09
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.12
                          ],
                          [
                            0.09,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            0.09,
                            -0.09
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            0.05
                          ],
                          [
                            0.02,
                            0.06
                          ],
                          [
                            0,
                            0.06
                          ],
                          [
                            -0.02,
                            0.06
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            18.04,
                            5.13
                          ],
                          [
                            13.72,
                            9.44
                          ],
                          [
                            13.39,
                            9.58
                          ],
                          [
                            13.05,
                            9.44
                          ],
                          [
                            12.91,
                            9.1
                          ],
                          [
                            13.05,
                            8.76
                          ],
                          [
                            16.54,
                            5.27
                          ],
                          [
                            0.48,
                            5.27
                          ],
                          [
                            0.14,
                            5.13
                          ],
                          [
                            0,
                            4.79
                          ],
                          [
                            0.14,
                            4.45
                          ],
                          [
                            0.48,
                            4.31
                          ],
                          [
                            16.54,
                            4.31
                          ],
                          [
                            13.05,
                            0.82
                          ],
                          [
                            12.91,
                            0.48
                          ],
                          [
                            13.05,
                            0.14
                          ],
                          [
                            13.39,
                            0
                          ],
                          [
                            13.72,
                            0.14
                          ],
                          [
                            18.04,
                            4.45
                          ],
                          [
                            18.14,
                            4.61
                          ],
                          [
                            18.18,
                            4.79
                          ],
                          [
                            18.14,
                            4.97
                          ],
                          [
                            18.04,
                            5.13
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.57,
                        0.63,
                        0.72,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1168",
    layers: [
      {
        ind: 1167,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                43.5,
                7.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                87,
                15
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            -0.29
                          ],
                          [
                            -0.05,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0.29
                          ],
                          [
                            -0.06,
                            0.28
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            -0.29
                          ],
                          [
                            -0.07,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.29
                          ],
                          [
                            -0.05,
                            0.28
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            0.2
                          ],
                          [
                            0.04,
                            0.21
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.2
                          ],
                          [
                            0.04,
                            -0.21
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.29
                          ],
                          [
                            0.05,
                            0.29
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            -0.29
                          ],
                          [
                            0.06,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.28
                          ],
                          [
                            0.07,
                            0.29
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.29
                          ],
                          [
                            0.05,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            -0.21
                          ],
                          [
                            -0.04,
                            -0.2
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.21
                          ],
                          [
                            -0.05,
                            0.2
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.32,
                            8.64
                          ],
                          [
                            0.19,
                            3.3
                          ],
                          [
                            0.89,
                            3.3
                          ],
                          [
                            1.45,
                            6.21
                          ],
                          [
                            1.6,
                            7.07
                          ],
                          [
                            1.75,
                            7.93
                          ],
                          [
                            1.79,
                            7.93
                          ],
                          [
                            1.98,
                            7.07
                          ],
                          [
                            2.16,
                            6.21
                          ],
                          [
                            2.9,
                            3.3
                          ],
                          [
                            3.52,
                            3.3
                          ],
                          [
                            4.26,
                            6.21
                          ],
                          [
                            4.45,
                            7.07
                          ],
                          [
                            4.65,
                            7.93
                          ],
                          [
                            4.68,
                            7.93
                          ],
                          [
                            4.83,
                            7.07
                          ],
                          [
                            4.98,
                            6.21
                          ],
                          [
                            5.54,
                            3.3
                          ],
                          [
                            6.19,
                            3.3
                          ],
                          [
                            5.09,
                            8.64
                          ],
                          [
                            4.27,
                            8.64
                          ],
                          [
                            3.47,
                            5.43
                          ],
                          [
                            3.33,
                            4.82
                          ],
                          [
                            3.21,
                            4.21
                          ],
                          [
                            3.18,
                            4.21
                          ],
                          [
                            3.05,
                            4.82
                          ],
                          [
                            2.91,
                            5.43
                          ],
                          [
                            2.12,
                            8.64
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.05,
                            8.64
                          ],
                          [
                            7.05,
                            4.69
                          ],
                          [
                            7.72,
                            4.69
                          ],
                          [
                            7.72,
                            8.64
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0.08
                          ],
                          [
                            0,
                            0.14
                          ],
                          [
                            -0.08,
                            0.08
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.08,
                            -0.08
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            0.09,
                            -0.08
                          ],
                          [
                            0.13,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.08,
                            -0.08
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            0.09,
                            -0.08
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.08
                          ],
                          [
                            0,
                            0.14
                          ],
                          [
                            -0.08,
                            0.08
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.4,
                            3.87
                          ],
                          [
                            7.07,
                            3.76
                          ],
                          [
                            6.95,
                            3.43
                          ],
                          [
                            7.07,
                            3.12
                          ],
                          [
                            7.4,
                            3
                          ],
                          [
                            7.71,
                            3.12
                          ],
                          [
                            7.84,
                            3.43
                          ],
                          [
                            7.71,
                            3.76
                          ],
                          [
                            7.4,
                            3.87
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            0.11
                          ],
                          [
                            -0.23,
                            0
                          ],
                          [
                            -0.27,
                            -0.37
                          ],
                          [
                            0,
                            -0.61
                          ],
                          [
                            0.16,
                            -0.32
                          ],
                          [
                            0.26,
                            -0.17
                          ],
                          [
                            0.3,
                            0
                          ],
                          [
                            0.18,
                            0.08
                          ],
                          [
                            0.18,
                            0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            -0.15
                          ],
                          [
                            0.22,
                            -0.11
                          ],
                          [
                            0.51,
                            0
                          ],
                          [
                            0.27,
                            0.36
                          ],
                          [
                            0,
                            0.44
                          ],
                          [
                            -0.16,
                            0.32
                          ],
                          [
                            -0.25,
                            0.17
                          ],
                          [
                            -0.18,
                            0
                          ],
                          [
                            -0.18,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.05,
                            10.3
                          ],
                          [
                            9.05,
                            4.69
                          ],
                          [
                            9.61,
                            4.69
                          ],
                          [
                            9.66,
                            5.14
                          ],
                          [
                            9.69,
                            5.14
                          ],
                          [
                            10.27,
                            4.75
                          ],
                          [
                            10.95,
                            4.59
                          ],
                          [
                            12.11,
                            5.14
                          ],
                          [
                            12.51,
                            6.61
                          ],
                          [
                            12.27,
                            7.75
                          ],
                          [
                            11.64,
                            8.48
                          ],
                          [
                            10.8,
                            8.73
                          ],
                          [
                            10.25,
                            8.61
                          ],
                          [
                            9.71,
                            8.28
                          ],
                          [
                            9.72,
                            8.97
                          ],
                          [
                            9.72,
                            10.3
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            0.28
                          ],
                          [
                            0,
                            0.48
                          ],
                          [
                            0.16,
                            0.27
                          ],
                          [
                            0.38,
                            0
                          ],
                          [
                            0.18,
                            -0.09
                          ],
                          [
                            0.2,
                            -0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            -0.06
                          ],
                          [
                            -0.13,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.32,
                            0
                          ],
                          [
                            0.21,
                            -0.28
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            -0.16,
                            -0.27
                          ],
                          [
                            -0.17,
                            0
                          ],
                          [
                            -0.17,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.15
                          ],
                          [
                            0.17,
                            0.06
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            10.69,
                            8.17
                          ],
                          [
                            11.5,
                            7.76
                          ],
                          [
                            11.82,
                            6.61
                          ],
                          [
                            11.57,
                            5.55
                          ],
                          [
                            10.78,
                            5.15
                          ],
                          [
                            10.27,
                            5.29
                          ],
                          [
                            9.72,
                            5.68
                          ],
                          [
                            9.72,
                            7.76
                          ],
                          [
                            10.24,
                            8.08
                          ],
                          [
                            10.69,
                            8.17
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.14
                          ],
                          [
                            -0.22,
                            0
                          ],
                          [
                            -0.12,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.01
                          ],
                          [
                            0.08,
                            0
                          ],
                          [
                            0.18,
                            -0.14
                          ],
                          [
                            0.14,
                            -0.34
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            -0.25
                          ],
                          [
                            0.2,
                            -0.15
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.01
                          ],
                          [
                            -0.17,
                            0
                          ],
                          [
                            -0.18,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            13.56,
                            8.64
                          ],
                          [
                            13.56,
                            4.69
                          ],
                          [
                            14.12,
                            4.69
                          ],
                          [
                            14.18,
                            5.4
                          ],
                          [
                            14.2,
                            5.4
                          ],
                          [
                            14.7,
                            4.81
                          ],
                          [
                            15.32,
                            4.59
                          ],
                          [
                            15.74,
                            4.67
                          ],
                          [
                            15.61,
                            5.25
                          ],
                          [
                            15.43,
                            5.21
                          ],
                          [
                            15.23,
                            5.19
                          ],
                          [
                            14.7,
                            5.39
                          ],
                          [
                            14.23,
                            6.1
                          ],
                          [
                            14.23,
                            8.64
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.28,
                            0.16
                          ],
                          [
                            0.17,
                            0.31
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            -0.17,
                            0.31
                          ],
                          [
                            -0.28,
                            0.16
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.28,
                            -0.16
                          ],
                          [
                            -0.17,
                            -0.31
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            0.18,
                            -0.31
                          ],
                          [
                            0.27,
                            -0.16
                          ],
                          [
                            0.32,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.28,
                            -0.16
                          ],
                          [
                            -0.17,
                            -0.31
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            0.17,
                            -0.31
                          ],
                          [
                            0.28,
                            -0.16
                          ],
                          [
                            0.32,
                            0
                          ],
                          [
                            0.27,
                            0.16
                          ],
                          [
                            0.18,
                            0.31
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            -0.17,
                            0.31
                          ],
                          [
                            -0.28,
                            0.16
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.84,
                            8.73
                          ],
                          [
                            16.94,
                            8.49
                          ],
                          [
                            16.26,
                            7.78
                          ],
                          [
                            16.01,
                            6.67
                          ],
                          [
                            16.26,
                            5.54
                          ],
                          [
                            16.94,
                            4.83
                          ],
                          [
                            17.84,
                            4.59
                          ],
                          [
                            18.74,
                            4.83
                          ],
                          [
                            19.41,
                            5.54
                          ],
                          [
                            19.67,
                            6.67
                          ],
                          [
                            19.41,
                            7.78
                          ],
                          [
                            18.74,
                            8.49
                          ],
                          [
                            17.84,
                            8.73
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            0.28
                          ],
                          [
                            0,
                            0.45
                          ],
                          [
                            0.21,
                            0.28
                          ],
                          [
                            0.34,
                            0
                          ],
                          [
                            0.21,
                            -0.28
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            -0.21,
                            -0.28
                          ],
                          [
                            -0.34,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.34,
                            0
                          ],
                          [
                            0.21,
                            -0.28
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            -0.21,
                            -0.28
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.21,
                            0.28
                          ],
                          [
                            0,
                            0.45
                          ],
                          [
                            0.21,
                            0.28
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.84,
                            8.18
                          ],
                          [
                            18.66,
                            7.77
                          ],
                          [
                            18.98,
                            6.67
                          ],
                          [
                            18.66,
                            5.56
                          ],
                          [
                            17.84,
                            5.14
                          ],
                          [
                            17.02,
                            5.56
                          ],
                          [
                            16.7,
                            6.67
                          ],
                          [
                            17.02,
                            7.77
                          ],
                          [
                            17.84,
                            8.18
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            22.4,
                            8.64
                          ],
                          [
                            22.4,
                            3.3
                          ],
                          [
                            23.07,
                            3.3
                          ],
                          [
                            23.07,
                            8.06
                          ],
                          [
                            25.41,
                            8.06
                          ],
                          [
                            25.41,
                            8.64
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            26.29,
                            8.64
                          ],
                          [
                            26.29,
                            4.69
                          ],
                          [
                            26.95,
                            4.69
                          ],
                          [
                            26.95,
                            8.64
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0.08
                          ],
                          [
                            0,
                            0.14
                          ],
                          [
                            -0.08,
                            0.08
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.08,
                            -0.08
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            0.09,
                            -0.08
                          ],
                          [
                            0.13,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.08,
                            -0.08
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            0.09,
                            -0.08
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.08
                          ],
                          [
                            0,
                            0.14
                          ],
                          [
                            -0.08,
                            0.08
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            26.63,
                            3.87
                          ],
                          [
                            26.3,
                            3.76
                          ],
                          [
                            26.18,
                            3.43
                          ],
                          [
                            26.3,
                            3.12
                          ],
                          [
                            26.63,
                            3
                          ],
                          [
                            26.95,
                            3.12
                          ],
                          [
                            27.07,
                            3.43
                          ],
                          [
                            26.95,
                            3.76
                          ],
                          [
                            26.63,
                            3.87
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            0.13
                          ],
                          [
                            -0.23,
                            0
                          ],
                          [
                            -0.17,
                            -0.14
                          ],
                          [
                            -0.08,
                            -0.24
                          ],
                          [
                            -0.21,
                            0.14
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.2,
                            -0.26
                          ],
                          [
                            0,
                            -0.5
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            0.17
                          ],
                          [
                            0.25,
                            0
                          ],
                          [
                            0.37,
                            -0.41
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            0.17
                          ],
                          [
                            0.25,
                            0
                          ],
                          [
                            0.37,
                            -0.41
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.17,
                            -0.19
                          ],
                          [
                            0.2,
                            -0.13
                          ],
                          [
                            0.3,
                            0
                          ],
                          [
                            0.18,
                            0.13
                          ],
                          [
                            0.21,
                            -0.22
                          ],
                          [
                            0.21,
                            -0.14
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0.2,
                            0.26
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.37
                          ],
                          [
                            -0.12,
                            -0.17
                          ],
                          [
                            -0.29,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.37
                          ],
                          [
                            -0.12,
                            -0.17
                          ],
                          [
                            -0.29,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            28.29,
                            8.64
                          ],
                          [
                            28.29,
                            4.69
                          ],
                          [
                            28.84,
                            4.69
                          ],
                          [
                            28.9,
                            5.25
                          ],
                          [
                            28.92,
                            5.25
                          ],
                          [
                            29.49,
                            4.78
                          ],
                          [
                            30.15,
                            4.59
                          ],
                          [
                            30.86,
                            4.79
                          ],
                          [
                            31.24,
                            5.34
                          ],
                          [
                            31.86,
                            4.8
                          ],
                          [
                            32.54,
                            4.59
                          ],
                          [
                            33.44,
                            4.98
                          ],
                          [
                            33.74,
                            6.13
                          ],
                          [
                            33.74,
                            8.64
                          ],
                          [
                            33.07,
                            8.64
                          ],
                          [
                            33.07,
                            6.22
                          ],
                          [
                            32.89,
                            5.42
                          ],
                          [
                            32.34,
                            5.16
                          ],
                          [
                            31.35,
                            5.77
                          ],
                          [
                            31.35,
                            8.64
                          ],
                          [
                            30.68,
                            8.64
                          ],
                          [
                            30.68,
                            6.22
                          ],
                          [
                            30.51,
                            5.42
                          ],
                          [
                            29.95,
                            5.16
                          ],
                          [
                            28.95,
                            5.77
                          ],
                          [
                            28.95,
                            8.64
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            35.03,
                            8.64
                          ],
                          [
                            35.03,
                            4.69
                          ],
                          [
                            35.69,
                            4.69
                          ],
                          [
                            35.69,
                            8.64
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0.08
                          ],
                          [
                            0,
                            0.14
                          ],
                          [
                            -0.08,
                            0.08
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.08,
                            -0.08
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            0.09,
                            -0.08
                          ],
                          [
                            0.13,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.08,
                            -0.08
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            0.09,
                            -0.08
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            0.08
                          ],
                          [
                            0,
                            0.14
                          ],
                          [
                            -0.08,
                            0.08
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            35.37,
                            3.87
                          ],
                          [
                            35.04,
                            3.76
                          ],
                          [
                            34.92,
                            3.43
                          ],
                          [
                            35.04,
                            3.12
                          ],
                          [
                            35.37,
                            3
                          ],
                          [
                            35.68,
                            3.12
                          ],
                          [
                            35.82,
                            3.43
                          ],
                          [
                            35.68,
                            3.76
                          ],
                          [
                            35.37,
                            3.87
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.17,
                            0.24
                          ],
                          [
                            0,
                            0.39
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.13
                          ],
                          [
                            -0.23,
                            0
                          ],
                          [
                            -0.08,
                            0.02
                          ],
                          [
                            -0.07,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            -0.03
                          ],
                          [
                            0.13,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.42,
                            0
                          ],
                          [
                            -0.16,
                            -0.24
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.24
                          ],
                          [
                            0.09,
                            0.13
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.08,
                            -0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.11,
                            0.04
                          ],
                          [
                            -0.12,
                            0.04
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            38.27,
                            8.73
                          ],
                          [
                            37.38,
                            8.37
                          ],
                          [
                            37.14,
                            7.42
                          ],
                          [
                            37.14,
                            5.23
                          ],
                          [
                            36.55,
                            5.23
                          ],
                          [
                            36.55,
                            4.73
                          ],
                          [
                            37.17,
                            4.69
                          ],
                          [
                            37.25,
                            3.58
                          ],
                          [
                            37.82,
                            3.58
                          ],
                          [
                            37.82,
                            4.69
                          ],
                          [
                            38.88,
                            4.69
                          ],
                          [
                            38.88,
                            5.23
                          ],
                          [
                            37.82,
                            5.23
                          ],
                          [
                            37.82,
                            7.43
                          ],
                          [
                            37.95,
                            7.99
                          ],
                          [
                            38.43,
                            8.19
                          ],
                          [
                            38.65,
                            8.16
                          ],
                          [
                            38.87,
                            8.08
                          ],
                          [
                            39,
                            8.59
                          ],
                          [
                            38.64,
                            8.68
                          ],
                          [
                            38.27,
                            8.73
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.29,
                            0.16
                          ],
                          [
                            0.17,
                            0.31
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            -0.17,
                            0.31
                          ],
                          [
                            -0.27,
                            0.17
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.27,
                            -0.34
                          ],
                          [
                            0,
                            -0.56
                          ],
                          [
                            0,
                            -0.07
                          ],
                          [
                            0.01,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.23,
                            -0.25
                          ],
                          [
                            -0.38,
                            0
                          ],
                          [
                            -0.16,
                            0.05
                          ],
                          [
                            -0.15,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.22,
                            -0.08
                          ],
                          [
                            0.27,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.35,
                            0
                          ],
                          [
                            -0.29,
                            -0.17
                          ],
                          [
                            -0.17,
                            -0.31
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0.17,
                            -0.31
                          ],
                          [
                            0.27,
                            -0.17
                          ],
                          [
                            0.5,
                            0
                          ],
                          [
                            0.27,
                            0.34
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.42
                          ],
                          [
                            0.24,
                            0.25
                          ],
                          [
                            0.19,
                            0
                          ],
                          [
                            0.16,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0.11
                          ],
                          [
                            -0.21,
                            0.08
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            41.26,
                            8.73
                          ],
                          [
                            40.3,
                            8.49
                          ],
                          [
                            39.62,
                            7.77
                          ],
                          [
                            39.37,
                            6.67
                          ],
                          [
                            39.62,
                            5.55
                          ],
                          [
                            40.29,
                            4.84
                          ],
                          [
                            41.14,
                            4.59
                          ],
                          [
                            42.3,
                            5.09
                          ],
                          [
                            42.72,
                            6.44
                          ],
                          [
                            42.71,
                            6.65
                          ],
                          [
                            42.69,
                            6.82
                          ],
                          [
                            40.03,
                            6.82
                          ],
                          [
                            40.42,
                            7.82
                          ],
                          [
                            41.34,
                            8.2
                          ],
                          [
                            41.86,
                            8.12
                          ],
                          [
                            42.33,
                            7.89
                          ],
                          [
                            42.56,
                            8.33
                          ],
                          [
                            41.98,
                            8.61
                          ],
                          [
                            41.26,
                            8.73
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.21
                          ],
                          [
                            0.31,
                            0
                          ],
                          [
                            0.22,
                            -0.21
                          ],
                          [
                            0.04,
                            -0.39
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.4
                          ],
                          [
                            -0.17,
                            -0.21
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.22,
                            0.21
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            40.02,
                            6.34
                          ],
                          [
                            42.13,
                            6.34
                          ],
                          [
                            41.87,
                            5.43
                          ],
                          [
                            41.16,
                            5.12
                          ],
                          [
                            40.41,
                            5.44
                          ],
                          [
                            40.02,
                            6.34
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.3,
                            0.36
                          ],
                          [
                            0,
                            0.66
                          ],
                          [
                            -0.16,
                            0.31
                          ],
                          [
                            -0.26,
                            0.17
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.17,
                            -0.08
                          ],
                          [
                            -0.18,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            -0.11
                          ],
                          [
                            0.23,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.49,
                            0
                          ],
                          [
                            -0.3,
                            -0.36
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0.16,
                            -0.31
                          ],
                          [
                            0.27,
                            -0.17
                          ],
                          [
                            0.23,
                            0
                          ],
                          [
                            0.17,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0.15
                          ],
                          [
                            -0.2,
                            0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            45.04,
                            8.73
                          ],
                          [
                            43.86,
                            8.2
                          ],
                          [
                            43.41,
                            6.67
                          ],
                          [
                            43.64,
                            5.56
                          ],
                          [
                            44.28,
                            4.84
                          ],
                          [
                            45.13,
                            4.59
                          ],
                          [
                            45.72,
                            4.71
                          ],
                          [
                            46.23,
                            5.04
                          ],
                          [
                            46.2,
                            4.37
                          ],
                          [
                            46.2,
                            2.85
                          ],
                          [
                            46.87,
                            2.85
                          ],
                          [
                            46.87,
                            8.64
                          ],
                          [
                            46.32,
                            8.64
                          ],
                          [
                            46.26,
                            8.17
                          ],
                          [
                            46.24,
                            8.17
                          ],
                          [
                            45.7,
                            8.57
                          ],
                          [
                            45.04,
                            8.73
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.32,
                            0.36
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0.06
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.18,
                            -0.13
                          ],
                          [
                            0.1,
                            -0.23
                          ],
                          [
                            0,
                            -0.3
                          ],
                          [
                            -0.19,
                            -0.27
                          ],
                          [
                            -0.34,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.35,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            -0.15
                          ],
                          [
                            -0.15,
                            -0.07
                          ],
                          [
                            -0.21,
                            0
                          ],
                          [
                            -0.17,
                            0.13
                          ],
                          [
                            -0.1,
                            0.22
                          ],
                          [
                            0,
                            0.47
                          ],
                          [
                            0.19,
                            0.27
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            45.19,
                            8.17
                          ],
                          [
                            46.2,
                            7.63
                          ],
                          [
                            46.2,
                            5.56
                          ],
                          [
                            45.71,
                            5.25
                          ],
                          [
                            45.24,
                            5.15
                          ],
                          [
                            44.66,
                            5.34
                          ],
                          [
                            44.25,
                            5.87
                          ],
                          [
                            44.1,
                            6.66
                          ],
                          [
                            44.38,
                            7.77
                          ],
                          [
                            45.19,
                            8.17
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.17,
                        0.28,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1173",
    layers: [
      {
        ind: 1172,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                31,
                6
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                62,
                12
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.26,
                            -0.08
                          ],
                          [
                            -0.15,
                            -0.21
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            0.32,
                            -0.24
                          ],
                          [
                            0.51,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.26,
                            0.09
                          ],
                          [
                            0.14,
                            0.2
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.32,
                            0.23
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.64,
                            6.75
                          ],
                          [
                            0.64,
                            2.09
                          ],
                          [
                            1.97,
                            2.09
                          ],
                          [
                            2.89,
                            2.21
                          ],
                          [
                            3.5,
                            2.65
                          ],
                          [
                            3.72,
                            3.46
                          ],
                          [
                            3.24,
                            4.55
                          ],
                          [
                            2,
                            4.9
                          ],
                          [
                            1.23,
                            4.9
                          ],
                          [
                            1.23,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.15
                          ],
                          [
                            0,
                            0.33
                          ],
                          [
                            0.21,
                            0.13
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0.2,
                            -0.16
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            -0.2,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.23,
                            4.42
                          ],
                          [
                            1.93,
                            4.42
                          ],
                          [
                            2.83,
                            4.19
                          ],
                          [
                            3.13,
                            3.46
                          ],
                          [
                            2.82,
                            2.76
                          ],
                          [
                            1.9,
                            2.56
                          ],
                          [
                            1.23,
                            2.56
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0.13
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.11,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.01
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0.12,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            -0.21
                          ],
                          [
                            0.17,
                            -0.13
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.01
                          ],
                          [
                            -0.15,
                            0
                          ],
                          [
                            -0.16,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            4.61,
                            6.75
                          ],
                          [
                            4.61,
                            3.29
                          ],
                          [
                            5.09,
                            3.29
                          ],
                          [
                            5.14,
                            3.92
                          ],
                          [
                            5.16,
                            3.92
                          ],
                          [
                            5.6,
                            3.4
                          ],
                          [
                            6.15,
                            3.21
                          ],
                          [
                            6.52,
                            3.28
                          ],
                          [
                            6.4,
                            3.79
                          ],
                          [
                            6.25,
                            3.75
                          ],
                          [
                            6.07,
                            3.73
                          ],
                          [
                            5.61,
                            3.91
                          ],
                          [
                            5.2,
                            4.53
                          ],
                          [
                            5.2,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.24,
                            0.14
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.24,
                            -0.29
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0,
                            -0.06
                          ],
                          [
                            0.01,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            -0.22
                          ],
                          [
                            -0.33,
                            0
                          ],
                          [
                            -0.14,
                            0.05
                          ],
                          [
                            -0.13,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0.23,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.15,
                            -0.27
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.15,
                            -0.27
                          ],
                          [
                            0.24,
                            -0.15
                          ],
                          [
                            0.44,
                            0
                          ],
                          [
                            0.24,
                            0.29
                          ],
                          [
                            0,
                            0.06
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            0.36
                          ],
                          [
                            0.21,
                            0.22
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0.09
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            8.41,
                            6.84
                          ],
                          [
                            7.57,
                            6.62
                          ],
                          [
                            6.97,
                            6
                          ],
                          [
                            6.75,
                            5.03
                          ],
                          [
                            6.97,
                            4.05
                          ],
                          [
                            7.55,
                            3.43
                          ],
                          [
                            8.3,
                            3.21
                          ],
                          [
                            9.32,
                            3.65
                          ],
                          [
                            9.68,
                            4.83
                          ],
                          [
                            9.68,
                            5.02
                          ],
                          [
                            9.66,
                            5.16
                          ],
                          [
                            7.33,
                            5.16
                          ],
                          [
                            7.67,
                            6.04
                          ],
                          [
                            8.48,
                            6.37
                          ],
                          [
                            8.93,
                            6.29
                          ],
                          [
                            9.34,
                            6.1
                          ],
                          [
                            9.55,
                            6.48
                          ],
                          [
                            9.04,
                            6.73
                          ],
                          [
                            8.41,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.18
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.2,
                            -0.19
                          ],
                          [
                            0.04,
                            -0.34
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.35
                          ],
                          [
                            -0.15,
                            -0.19
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.19,
                            0.18
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.32,
                            4.75
                          ],
                          [
                            9.17,
                            4.75
                          ],
                          [
                            8.94,
                            3.95
                          ],
                          [
                            8.32,
                            3.67
                          ],
                          [
                            7.66,
                            3.96
                          ],
                          [
                            7.32,
                            4.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.28,
                            0.12
                          ],
                          [
                            0.2,
                            0.21
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            -0.11
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.17,
                            0.14
                          ],
                          [
                            0,
                            0.23
                          ],
                          [
                            0.07,
                            0.09
                          ],
                          [
                            0.12,
                            0.07
                          ],
                          [
                            0.15,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.1
                          ],
                          [
                            0.1,
                            0.16
                          ],
                          [
                            0,
                            0.23
                          ],
                          [
                            -0.12,
                            0.18
                          ],
                          [
                            -0.22,
                            0.1
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.23,
                            -0.11
                          ],
                          [
                            -0.16,
                            -0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.07
                          ],
                          [
                            0.22,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0,
                            -0.21
                          ],
                          [
                            -0.07,
                            -0.1
                          ],
                          [
                            -0.12,
                            -0.06
                          ],
                          [
                            -0.12,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            -0.11
                          ],
                          [
                            -0.09,
                            -0.16
                          ],
                          [
                            0,
                            -0.23
                          ],
                          [
                            0.13,
                            -0.2
                          ],
                          [
                            0.24,
                            -0.12
                          ],
                          [
                            0.33,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.28,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0.18
                          ],
                          [
                            0.23,
                            0.11
                          ],
                          [
                            0.31,
                            0
                          ],
                          [
                            0.17,
                            -0.14
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            -0.07,
                            -0.09
                          ],
                          [
                            -0.11,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            -0.06
                          ],
                          [
                            -0.14,
                            -0.1
                          ],
                          [
                            -0.09,
                            -0.16
                          ],
                          [
                            0,
                            -0.24
                          ],
                          [
                            0.13,
                            -0.19
                          ],
                          [
                            0.22,
                            -0.11
                          ],
                          [
                            0.28,
                            0
                          ],
                          [
                            0.24,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            -0.14
                          ],
                          [
                            -0.17,
                            -0.08
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.16,
                            0.13
                          ],
                          [
                            0,
                            0.14
                          ],
                          [
                            0.08,
                            0.09
                          ],
                          [
                            0.12,
                            0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.07
                          ],
                          [
                            0.15,
                            0.1
                          ],
                          [
                            0.08,
                            0.15
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            -0.13,
                            0.2
                          ],
                          [
                            -0.24,
                            0.12
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            13.31,
                            6.84
                          ],
                          [
                            12.4,
                            6.65
                          ],
                          [
                            11.68,
                            6.14
                          ],
                          [
                            12.03,
                            5.73
                          ],
                          [
                            12.61,
                            6.16
                          ],
                          [
                            13.32,
                            6.32
                          ],
                          [
                            14.04,
                            6.11
                          ],
                          [
                            14.29,
                            5.55
                          ],
                          [
                            14.18,
                            5.17
                          ],
                          [
                            13.91,
                            4.93
                          ],
                          [
                            13.52,
                            4.73
                          ],
                          [
                            12.85,
                            4.44
                          ],
                          [
                            12.41,
                            4.2
                          ],
                          [
                            12.04,
                            3.81
                          ],
                          [
                            11.9,
                            3.24
                          ],
                          [
                            12.09,
                            2.61
                          ],
                          [
                            12.61,
                            2.16
                          ],
                          [
                            13.37,
                            2
                          ],
                          [
                            14.14,
                            2.16
                          ],
                          [
                            14.75,
                            2.57
                          ],
                          [
                            14.43,
                            2.96
                          ],
                          [
                            13.95,
                            2.64
                          ],
                          [
                            13.37,
                            2.52
                          ],
                          [
                            12.73,
                            2.7
                          ],
                          [
                            12.5,
                            3.2
                          ],
                          [
                            12.61,
                            3.57
                          ],
                          [
                            12.91,
                            3.8
                          ],
                          [
                            13.27,
                            3.98
                          ],
                          [
                            13.94,
                            4.26
                          ],
                          [
                            14.42,
                            4.54
                          ],
                          [
                            14.77,
                            4.93
                          ],
                          [
                            14.89,
                            5.5
                          ],
                          [
                            14.7,
                            6.18
                          ],
                          [
                            14.16,
                            6.66
                          ],
                          [
                            13.31,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.25,
                            0.14
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.16,
                            -0.08
                          ],
                          [
                            -0.12,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            0.06
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0.17,
                            -0.11
                          ],
                          [
                            0.09,
                            -0.2
                          ],
                          [
                            0,
                            -0.27
                          ],
                          [
                            -0.2,
                            -0.25
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.14,
                            0.07
                          ],
                          [
                            -0.11,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.08
                          ],
                          [
                            0.21,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.14,
                            -0.27
                          ],
                          [
                            0,
                            -0.39
                          ],
                          [
                            0.16,
                            -0.27
                          ],
                          [
                            0.26,
                            -0.14
                          ],
                          [
                            0.23,
                            0
                          ],
                          [
                            0.16,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.1,
                            -0.09
                          ],
                          [
                            -0.11,
                            -0.06
                          ],
                          [
                            -0.21,
                            0
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            -0.09,
                            0.2
                          ],
                          [
                            0,
                            0.39
                          ],
                          [
                            0.2,
                            0.24
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.14
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.13,
                            6.84
                          ],
                          [
                            16.3,
                            6.62
                          ],
                          [
                            15.71,
                            6
                          ],
                          [
                            15.5,
                            5.03
                          ],
                          [
                            15.73,
                            4.04
                          ],
                          [
                            16.34,
                            3.42
                          ],
                          [
                            17.17,
                            3.21
                          ],
                          [
                            17.75,
                            3.33
                          ],
                          [
                            18.18,
                            3.61
                          ],
                          [
                            17.88,
                            4
                          ],
                          [
                            17.56,
                            3.78
                          ],
                          [
                            17.19,
                            3.69
                          ],
                          [
                            16.63,
                            3.86
                          ],
                          [
                            16.24,
                            4.33
                          ],
                          [
                            16.11,
                            5.03
                          ],
                          [
                            16.4,
                            5.99
                          ],
                          [
                            17.17,
                            6.35
                          ],
                          [
                            17.62,
                            6.25
                          ],
                          [
                            17.98,
                            6
                          ],
                          [
                            18.24,
                            6.39
                          ],
                          [
                            17.72,
                            6.72
                          ],
                          [
                            17.13,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.17
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            -0.34,
                            0.2
                          ],
                          [
                            -0.73,
                            0.08
                          ],
                          [
                            0.04,
                            0.13
                          ],
                          [
                            0.11,
                            0.08
                          ],
                          [
                            0.19,
                            0
                          ],
                          [
                            0.17,
                            -0.07
                          ],
                          [
                            0.14,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.23,
                            0.09
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.19,
                            -0.26
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            -0.1
                          ],
                          [
                            0.22,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.19,
                            -0.18
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.34,
                            -0.2
                          ],
                          [
                            0,
                            -0.14
                          ],
                          [
                            -0.04,
                            -0.13
                          ],
                          [
                            -0.1,
                            -0.09
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.18,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.11
                          ],
                          [
                            0.24,
                            -0.1
                          ],
                          [
                            0.42,
                            0
                          ],
                          [
                            0.19,
                            0.26
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.13
                          ],
                          [
                            -0.19,
                            0.1
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            19.73,
                            6.84
                          ],
                          [
                            19,
                            6.58
                          ],
                          [
                            18.72,
                            5.86
                          ],
                          [
                            19.22,
                            4.98
                          ],
                          [
                            20.84,
                            4.56
                          ],
                          [
                            20.77,
                            4.14
                          ],
                          [
                            20.56,
                            3.82
                          ],
                          [
                            20.13,
                            3.69
                          ],
                          [
                            19.57,
                            3.8
                          ],
                          [
                            19.09,
                            4.06
                          ],
                          [
                            18.87,
                            3.66
                          ],
                          [
                            19.46,
                            3.36
                          ],
                          [
                            20.23,
                            3.21
                          ],
                          [
                            21.14,
                            3.6
                          ],
                          [
                            21.43,
                            4.63
                          ],
                          [
                            21.43,
                            6.75
                          ],
                          [
                            20.95,
                            6.75
                          ],
                          [
                            20.89,
                            6.34
                          ],
                          [
                            20.88,
                            6.34
                          ],
                          [
                            20.34,
                            6.69
                          ],
                          [
                            19.73,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            0.08
                          ],
                          [
                            -0.16,
                            0.15
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            -0.14
                          ],
                          [
                            0,
                            -0.22
                          ],
                          [
                            -0.12,
                            -0.09
                          ],
                          [
                            -0.17,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.17,
                            0
                          ],
                          [
                            0.15,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.57,
                            0.07
                          ],
                          [
                            -0.23,
                            0.14
                          ],
                          [
                            0,
                            0.19
                          ],
                          [
                            0.12,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            19.9,
                            6.37
                          ],
                          [
                            20.37,
                            6.25
                          ],
                          [
                            20.84,
                            5.9
                          ],
                          [
                            20.84,
                            4.95
                          ],
                          [
                            19.63,
                            5.26
                          ],
                          [
                            19.29,
                            5.81
                          ],
                          [
                            19.46,
                            6.24
                          ],
                          [
                            19.9,
                            6.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0.13
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.04
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            -0.04,
                            0.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.01
                          ],
                          [
                            0.08,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.21,
                            0
                          ],
                          [
                            -0.09,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            0.03,
                            0.04
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.02
                          ],
                          [
                            -0.05,
                            0.01
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            23.13,
                            6.84
                          ],
                          [
                            22.66,
                            6.64
                          ],
                          [
                            22.52,
                            6.05
                          ],
                          [
                            22.52,
                            1.69
                          ],
                          [
                            23.1,
                            1.69
                          ],
                          [
                            23.1,
                            6.1
                          ],
                          [
                            23.15,
                            6.29
                          ],
                          [
                            23.26,
                            6.35
                          ],
                          [
                            23.31,
                            6.35
                          ],
                          [
                            23.39,
                            6.34
                          ],
                          [
                            23.47,
                            6.78
                          ],
                          [
                            23.33,
                            6.82
                          ],
                          [
                            23.13,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.24,
                            0.14
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.24,
                            -0.29
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0,
                            -0.06
                          ],
                          [
                            0.01,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            -0.22
                          ],
                          [
                            -0.33,
                            0
                          ],
                          [
                            -0.14,
                            0.05
                          ],
                          [
                            -0.13,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0.23,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.15,
                            -0.27
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.15,
                            -0.27
                          ],
                          [
                            0.24,
                            -0.15
                          ],
                          [
                            0.44,
                            0
                          ],
                          [
                            0.24,
                            0.29
                          ],
                          [
                            0,
                            0.06
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            0.36
                          ],
                          [
                            0.21,
                            0.22
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0.09
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.73,
                            6.84
                          ],
                          [
                            24.89,
                            6.62
                          ],
                          [
                            24.29,
                            6
                          ],
                          [
                            24.07,
                            5.03
                          ],
                          [
                            24.29,
                            4.05
                          ],
                          [
                            24.88,
                            3.43
                          ],
                          [
                            25.62,
                            3.21
                          ],
                          [
                            26.64,
                            3.65
                          ],
                          [
                            27,
                            4.83
                          ],
                          [
                            27,
                            5.02
                          ],
                          [
                            26.98,
                            5.16
                          ],
                          [
                            24.65,
                            5.16
                          ],
                          [
                            24.99,
                            6.04
                          ],
                          [
                            25.8,
                            6.37
                          ],
                          [
                            26.25,
                            6.29
                          ],
                          [
                            26.66,
                            6.1
                          ],
                          [
                            26.87,
                            6.48
                          ],
                          [
                            26.36,
                            6.73
                          ],
                          [
                            25.73,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.18
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.2,
                            -0.19
                          ],
                          [
                            0.04,
                            -0.34
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.35
                          ],
                          [
                            -0.14,
                            -0.19
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.19,
                            0.18
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            24.64,
                            4.75
                          ],
                          [
                            26.49,
                            4.75
                          ],
                          [
                            26.26,
                            3.95
                          ],
                          [
                            25.64,
                            3.67
                          ],
                          [
                            24.98,
                            3.96
                          ],
                          [
                            24.64,
                            4.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0.13
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.11,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.01
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0.12,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            -0.21
                          ],
                          [
                            0.17,
                            -0.13
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.01
                          ],
                          [
                            -0.14,
                            0
                          ],
                          [
                            -0.16,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            27.86,
                            6.75
                          ],
                          [
                            27.86,
                            3.29
                          ],
                          [
                            28.34,
                            3.29
                          ],
                          [
                            28.39,
                            3.92
                          ],
                          [
                            28.41,
                            3.92
                          ],
                          [
                            28.84,
                            3.4
                          ],
                          [
                            29.39,
                            3.21
                          ],
                          [
                            29.76,
                            3.28
                          ],
                          [
                            29.65,
                            3.79
                          ],
                          [
                            29.49,
                            3.75
                          ],
                          [
                            29.31,
                            3.73
                          ],
                          [
                            28.85,
                            3.91
                          ],
                          [
                            28.44,
                            4.53
                          ],
                          [
                            28.44,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.49,
                        0.55,
                        0.65,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1201",
    layers: [
      {
        ind: 1200,
        ty: 2,
        parent: 1199,
        ks: {
          s: {
            a: 0,
            k: [
              170,
              181.82
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "0"
      },
      {
        ind: 1199,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1204",
    layers: [
      {
        ind: 1203,
        ty: 0,
        parent: 1198,
        ks: {},
        w: 8.5,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1201"
      },
      {
        ind: 1198,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1249",
    layers: [
      {
        ind: 1248,
        ty: 2,
        parent: 1247,
        ks: {
          s: {
            a: 0,
            k: [
              181.82,
              180
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "1"
      },
      {
        ind: 1247,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1252",
    layers: [
      {
        ind: 1251,
        ty: 0,
        parent: 1246,
        ks: {},
        w: 10,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1249"
      },
      {
        ind: 1246,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1291",
    layers: [
      {
        ind: 1290,
        ty: 2,
        parent: 1289,
        ks: {
          s: {
            a: 0,
            k: [
              181.25,
              183.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "8"
      },
      {
        ind: 1289,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1294",
    layers: [
      {
        ind: 1293,
        ty: 0,
        parent: 1288,
        ks: {},
        w: 14.5,
        h: 16.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1291"
      },
      {
        ind: 1288,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1305",
    layers: [
      {
        ind: 1304,
        ty: 2,
        parent: 1303,
        ks: {
          s: {
            a: 0,
            k: [
              186.67,
              186.67
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "9"
      },
      {
        ind: 1303,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1308",
    layers: [
      {
        ind: 1307,
        ty: 0,
        parent: 1302,
        ks: {},
        w: 56,
        h: 56,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1305"
      },
      {
        ind: 1302,
        ty: 3,
        parent: 1301,
        ks: {
          p: {
            a: 0,
            k: [
              -6,
              -2
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1301,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              6,
              3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1312",
    layers: [
      {
        ind: 1311,
        ty: 4,
        td: 1,
        parent: 1300,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                24.383,
                24.383
              ]
            },
            r: {
              a: 0,
              k: 24
            },
            s: {
              a: 0,
              k: [
                48.766,
                48.766
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1310,
        ty: 0,
        tt: 1,
        parent: 1300,
        ks: {
          a: {
            a: 0,
            k: [
              6,
              3
            ]
          }
        },
        w: 62,
        h: 59,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1308"
      },
      {
        ind: 1300,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              5.418,
              5.418
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1380",
    layers: [
      {
        ind: 1379,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                5.5,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                11,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.02
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0.04,
                            0.02
                          ],
                          [
                            0.04,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.02
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            -0.04,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.04
                          ],
                          [
                            -0.05,
                            0.02
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.04
                          ],
                          [
                            0.05,
                            -0.02
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0.05,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.75,
                            1.03
                          ],
                          [
                            7.75,
                            3.06
                          ],
                          [
                            7.63,
                            3.33
                          ],
                          [
                            7.36,
                            3.44
                          ],
                          [
                            7.09,
                            3.33
                          ],
                          [
                            6.98,
                            3.06
                          ],
                          [
                            6.98,
                            1.95
                          ],
                          [
                            4.59,
                            4.35
                          ],
                          [
                            4.46,
                            4.43
                          ],
                          [
                            4.32,
                            4.46
                          ],
                          [
                            4.17,
                            4.43
                          ],
                          [
                            4.05,
                            4.35
                          ],
                          [
                            3.05,
                            3.34
                          ],
                          [
                            1.03,
                            5.36
                          ],
                          [
                            0.76,
                            5.47
                          ],
                          [
                            0.49,
                            5.36
                          ],
                          [
                            0.38,
                            5.09
                          ],
                          [
                            0.49,
                            4.82
                          ],
                          [
                            2.78,
                            2.54
                          ],
                          [
                            2.9,
                            2.45
                          ],
                          [
                            3.05,
                            2.42
                          ],
                          [
                            3.19,
                            2.45
                          ],
                          [
                            3.32,
                            2.54
                          ],
                          [
                            4.32,
                            3.54
                          ],
                          [
                            6.45,
                            1.41
                          ],
                          [
                            5.33,
                            1.41
                          ],
                          [
                            5.06,
                            1.3
                          ],
                          [
                            4.95,
                            1.03
                          ],
                          [
                            5.06,
                            0.76
                          ],
                          [
                            5.33,
                            0.64
                          ],
                          [
                            7.36,
                            0.64
                          ],
                          [
                            7.63,
                            0.76
                          ],
                          [
                            7.75,
                            1.03
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.52,
                        0.32,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1383",
    layers: [
      {
        ind: 1382,
        ty: 0,
        parent: 1378,
        ks: {},
        w: 11,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1380"
      },
      {
        ind: 1378,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1391",
    layers: [
      {
        ind: 1390,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                4.5,
                5.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                9,
                11
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                -0.06,
                                0.05
                              ],
                              [
                                -0.08,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.21,
                                -0.03
                              ],
                              [
                                -0.13,
                                -0.05
                              ],
                              [
                                -0.09,
                                -0.05
                              ],
                              [
                                0.36,
                                0.41
                              ],
                              [
                                0.91,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.03,
                                -0.18
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.01,
                                -0.03
                              ],
                              [
                                -0.02,
                                -0.02
                              ],
                              [
                                -0.03,
                                -0.01
                              ],
                              [
                                -0.03,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            o: [
                              [
                                0.01,
                                -0.08
                              ],
                              [
                                0.06,
                                -0.05
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0.24,
                                0
                              ],
                              [
                                0.14,
                                0.02
                              ],
                              [
                                0.11,
                                0.03
                              ],
                              [
                                0.1,
                                -0.66
                              ],
                              [
                                -0.39,
                                -0.45
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                -0.18,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0.03
                              ],
                              [
                                0.01,
                                0.03
                              ],
                              [
                                0.02,
                                0.03
                              ],
                              [
                                0.03,
                                0.02
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                2.71,
                                2.55
                              ],
                              [
                                2.82,
                                2.35
                              ],
                              [
                                3.04,
                                2.27
                              ],
                              [
                                5.11,
                                2.27
                              ],
                              [
                                5.8,
                                2.32
                              ],
                              [
                                6.21,
                                2.42
                              ],
                              [
                                6.5,
                                2.54
                              ],
                              [
                                6.14,
                                1.02
                              ],
                              [
                                4.13,
                                0.38
                              ],
                              [
                                1.48,
                                0.38
                              ],
                              [
                                1.11,
                                0.7
                              ],
                              [
                                0.01,
                                7.68
                              ],
                              [
                                0.02,
                                7.77
                              ],
                              [
                                0.06,
                                7.86
                              ],
                              [
                                0.14,
                                7.92
                              ],
                              [
                                0.23,
                                7.94
                              ],
                              [
                                1.86,
                                7.94
                              ],
                              [
                                2.27,
                                5.34
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0.15,
                            0.23,
                            0.5,
                            1
                          ]
                        },
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1396",
    layers: [
      {
        ind: 1395,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                3,
                2.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                6,
                5
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            0.02
                          ],
                          [
                            0.23,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            -0.05
                          ],
                          [
                            0.01,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0.06
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.35,
                            1.79
                          ],
                          [
                            -0.01,
                            0.05
                          ],
                          [
                            0.1,
                            0.03
                          ],
                          [
                            0.03,
                            0.01
                          ]
                        ],
                        o: [
                          [
                            -0.11,
                            -0.03
                          ],
                          [
                            -0.23,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.08,
                            0
                          ],
                          [
                            -0.06,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            -0.09
                          ],
                          [
                            0.07,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.52,
                            0
                          ],
                          [
                            0.01,
                            -0.05
                          ],
                          [
                            -0.09,
                            -0.05
                          ],
                          [
                            -0.02,
                            -0.01
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            3.88,
                            0.14
                          ],
                          [
                            3.55,
                            0.07
                          ],
                          [
                            2.86,
                            0.02
                          ],
                          [
                            0.79,
                            0.02
                          ],
                          [
                            0.57,
                            0.1
                          ],
                          [
                            0.46,
                            0.3
                          ],
                          [
                            0.02,
                            3.09
                          ],
                          [
                            0.01,
                            3.17
                          ],
                          [
                            0.14,
                            2.95
                          ],
                          [
                            0.38,
                            2.85
                          ],
                          [
                            1.16,
                            2.85
                          ],
                          [
                            4.22,
                            0.45
                          ],
                          [
                            4.25,
                            0.29
                          ],
                          [
                            3.96,
                            0.17
                          ],
                          [
                            3.88,
                            0.14
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.13,
                        0.18,
                        0.4,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1401",
    layers: [
      {
        ind: 1400,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                4,
                4.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                8,
                9
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            -0.05
                          ],
                          [
                            1.52,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.01,
                            -0.03
                          ],
                          [
                            -0.02,
                            -0.02
                          ],
                          [
                            -0.03,
                            -0.01
                          ],
                          [
                            -0.03,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.03,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.31,
                            1.57
                          ],
                          [
                            0.34,
                            0.38
                          ],
                          [
                            0.14,
                            0.07
                          ]
                        ],
                        o: [
                          [
                            -0.01,
                            0.05
                          ],
                          [
                            -0.35,
                            1.79
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.03
                          ],
                          [
                            0.01,
                            0.03
                          ],
                          [
                            0.02,
                            0.02
                          ],
                          [
                            0.03,
                            0.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            -0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.33,
                            0
                          ],
                          [
                            0.13,
                            -0.65
                          ],
                          [
                            -0.11,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            5,
                            0.29
                          ],
                          [
                            4.97,
                            0.45
                          ],
                          [
                            1.91,
                            2.85
                          ],
                          [
                            1.13,
                            2.85
                          ],
                          [
                            0.76,
                            3.17
                          ],
                          [
                            0.36,
                            5.69
                          ],
                          [
                            0.25,
                            6.4
                          ],
                          [
                            0.25,
                            6.49
                          ],
                          [
                            0.3,
                            6.56
                          ],
                          [
                            0.36,
                            6.61
                          ],
                          [
                            0.45,
                            6.63
                          ],
                          [
                            1.82,
                            6.63
                          ],
                          [
                            2.15,
                            6.36
                          ],
                          [
                            2.16,
                            6.29
                          ],
                          [
                            2.42,
                            4.64
                          ],
                          [
                            2.44,
                            4.55
                          ],
                          [
                            2.77,
                            4.27
                          ],
                          [
                            2.97,
                            4.27
                          ],
                          [
                            5.65,
                            2.16
                          ],
                          [
                            5.38,
                            0.58
                          ],
                          [
                            5,
                            0.29
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.09,
                        0.61,
                        0.84,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1406",
    layers: [
      {
        ind: 1405,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                5,
                6
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                10,
                12
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            0.01
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.32,
                            -0.36
                          ],
                          [
                            -0.05,
                            -0.2
                          ],
                          [
                            0.05,
                            -0.3
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            -0.04,
                            -0.22
                          ],
                          [
                            0.06,
                            -0.3
                          ],
                          [
                            0.15,
                            -0.25
                          ],
                          [
                            0.21,
                            -0.15
                          ],
                          [
                            0.26,
                            -0.07
                          ],
                          [
                            0.32,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            -0.1
                          ],
                          [
                            0.02,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            -0.01
                          ],
                          [
                            0.01,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.02
                          ],
                          [
                            0.02,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.88,
                            0
                          ],
                          [
                            0.15,
                            0.17
                          ],
                          [
                            0.05,
                            0.2
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            0.06
                          ],
                          [
                            0.13,
                            0.14
                          ],
                          [
                            0.04,
                            0.22
                          ],
                          [
                            -0.07,
                            0.35
                          ],
                          [
                            -0.13,
                            0.22
                          ],
                          [
                            -0.2,
                            0.14
                          ],
                          [
                            -0.25,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0
                          ],
                          [
                            -0.11,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.02
                          ],
                          [
                            -0.01,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            2.05,
                            8.59
                          ],
                          [
                            2.2,
                            7.66
                          ],
                          [
                            1.87,
                            7.65
                          ],
                          [
                            0.3,
                            7.65
                          ],
                          [
                            1.39,
                            0.75
                          ],
                          [
                            1.42,
                            0.69
                          ],
                          [
                            1.48,
                            0.67
                          ],
                          [
                            4.13,
                            0.67
                          ],
                          [
                            5.92,
                            1.21
                          ],
                          [
                            6.21,
                            1.75
                          ],
                          [
                            6.21,
                            2.5
                          ],
                          [
                            6.21,
                            2.52
                          ],
                          [
                            6.21,
                            2.71
                          ],
                          [
                            6.36,
                            2.79
                          ],
                          [
                            6.66,
                            3.02
                          ],
                          [
                            6.9,
                            3.57
                          ],
                          [
                            6.87,
                            4.36
                          ],
                          [
                            6.54,
                            5.26
                          ],
                          [
                            6.03,
                            5.82
                          ],
                          [
                            5.34,
                            6.13
                          ],
                          [
                            4.47,
                            6.23
                          ],
                          [
                            4.27,
                            6.23
                          ],
                          [
                            3.86,
                            6.38
                          ],
                          [
                            3.65,
                            6.75
                          ],
                          [
                            3.64,
                            6.84
                          ],
                          [
                            3.38,
                            8.49
                          ],
                          [
                            3.36,
                            8.55
                          ],
                          [
                            3.35,
                            8.59
                          ],
                          [
                            3.32,
                            8.59
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.15,
                        0.23,
                        0.5,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1411",
    layers: [
      {
        ind: 1410,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                8,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                16,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.04
                          ],
                          [
                            0.01,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.01,
                            -0.02
                          ],
                          [
                            -0.02,
                            -0.02
                          ],
                          [
                            -0.02,
                            -0.01
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.03
                          ],
                          [
                            -0.01,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.04
                          ],
                          [
                            -0.06,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            1.21
                          ],
                          [
                            0.25,
                            0.29
                          ],
                          [
                            0.64,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            0
                          ],
                          [
                            -0.05,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.02
                          ],
                          [
                            0,
                            0.02
                          ],
                          [
                            0.02,
                            0.02
                          ],
                          [
                            0.02,
                            0.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0.03,
                            -0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            -0.07
                          ],
                          [
                            0.05,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.27,
                            0
                          ],
                          [
                            0.09,
                            -0.53
                          ],
                          [
                            -0.27,
                            -0.32
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            3.52,
                            0.03
                          ],
                          [
                            1.59,
                            0.03
                          ],
                          [
                            1.41,
                            0.1
                          ],
                          [
                            1.32,
                            0.26
                          ],
                          [
                            0.55,
                            5.2
                          ],
                          [
                            0.55,
                            5.27
                          ],
                          [
                            0.58,
                            5.33
                          ],
                          [
                            0.64,
                            5.37
                          ],
                          [
                            0.7,
                            5.39
                          ],
                          [
                            1.69,
                            5.39
                          ],
                          [
                            1.82,
                            5.34
                          ],
                          [
                            1.88,
                            5.23
                          ],
                          [
                            2.1,
                            3.83
                          ],
                          [
                            2.19,
                            3.66
                          ],
                          [
                            2.36,
                            3.6
                          ],
                          [
                            2.97,
                            3.6
                          ],
                          [
                            5.17,
                            1.77
                          ],
                          [
                            4.92,
                            0.52
                          ],
                          [
                            3.52,
                            0.03
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.51,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.03,
                            0.02
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            -0.2
                          ],
                          [
                            0.04,
                            -0.24
                          ]
                        ],
                        o: [
                          [
                            -0.11,
                            0.69
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            -0.04
                          ],
                          [
                            0.03,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.1,
                            0.12
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            3.74,
                            1.84
                          ],
                          [
                            2.59,
                            2.53
                          ],
                          [
                            2.3,
                            2.53
                          ],
                          [
                            2.51,
                            1.24
                          ],
                          [
                            2.56,
                            1.14
                          ],
                          [
                            2.67,
                            1.1
                          ],
                          [
                            2.8,
                            1.1
                          ],
                          [
                            3.64,
                            1.3
                          ],
                          [
                            3.74,
                            1.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            -0.03
                          ],
                          [
                            0.01,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.45,
                            0
                          ],
                          [
                            0.17,
                            -1.09
                          ],
                          [
                            -0.31,
                            -0.36
                          ],
                          [
                            -0.48,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.01,
                            -0.02
                          ],
                          [
                            -0.02,
                            -0.02
                          ],
                          [
                            -0.02,
                            -0.01
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.04
                          ],
                          [
                            -0.01,
                            0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            0.02
                          ],
                          [
                            0.02,
                            0.02
                          ],
                          [
                            0.02,
                            0.01
                          ],
                          [
                            0.02,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            -0.03,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            -0.29
                          ],
                          [
                            -1.02,
                            0
                          ],
                          [
                            -0.09,
                            0.54
                          ],
                          [
                            0.28,
                            0.33
                          ],
                          [
                            0.82,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.02
                          ],
                          [
                            0,
                            0.02
                          ],
                          [
                            0.02,
                            0.02
                          ],
                          [
                            0.02,
                            0.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0
                          ],
                          [
                            0.05,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.02
                          ],
                          [
                            0,
                            -0.02
                          ],
                          [
                            -0.02,
                            -0.02
                          ],
                          [
                            -0.02,
                            -0.01
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.28,
                            1.82
                          ],
                          [
                            8.36,
                            1.82
                          ],
                          [
                            8.25,
                            1.86
                          ],
                          [
                            8.2,
                            1.95
                          ],
                          [
                            8.16,
                            2.21
                          ],
                          [
                            8.09,
                            2.12
                          ],
                          [
                            7,
                            1.73
                          ],
                          [
                            4.94,
                            3.59
                          ],
                          [
                            5.29,
                            5
                          ],
                          [
                            6.45,
                            5.47
                          ],
                          [
                            7.72,
                            4.94
                          ],
                          [
                            7.68,
                            5.2
                          ],
                          [
                            7.69,
                            5.27
                          ],
                          [
                            7.72,
                            5.33
                          ],
                          [
                            7.77,
                            5.37
                          ],
                          [
                            7.84,
                            5.39
                          ],
                          [
                            8.67,
                            5.39
                          ],
                          [
                            8.84,
                            5.32
                          ],
                          [
                            8.94,
                            5.16
                          ],
                          [
                            9.43,
                            2
                          ],
                          [
                            9.43,
                            1.93
                          ],
                          [
                            9.4,
                            1.87
                          ],
                          [
                            9.34,
                            1.83
                          ],
                          [
                            9.28,
                            1.82
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.53,
                            0
                          ],
                          [
                            0.14,
                            0.16
                          ],
                          [
                            -0.04,
                            0.26
                          ],
                          [
                            -0.53,
                            0
                          ],
                          [
                            -0.14,
                            -0.16
                          ],
                          [
                            0.04,
                            -0.25
                          ]
                        ],
                        o: [
                          [
                            -0.09,
                            0.53
                          ],
                          [
                            -0.27,
                            0
                          ],
                          [
                            -0.14,
                            -0.16
                          ],
                          [
                            0.09,
                            -0.52
                          ],
                          [
                            0.26,
                            0
                          ],
                          [
                            0.14,
                            0.17
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.99,
                            3.61
                          ],
                          [
                            6.95,
                            4.49
                          ],
                          [
                            6.33,
                            4.24
                          ],
                          [
                            6.18,
                            3.59
                          ],
                          [
                            7.22,
                            2.71
                          ],
                          [
                            7.83,
                            2.96
                          ],
                          [
                            7.99,
                            3.61
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.01,
                            -0.02
                          ],
                          [
                            -0.02,
                            -0.02
                          ],
                          [
                            -0.02,
                            -0.01
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            0.02
                          ],
                          [
                            0.02,
                            0.02
                          ],
                          [
                            0.02,
                            0.01
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            -0.02
                          ],
                          [
                            0.01,
                            -0.04
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.02
                          ],
                          [
                            0,
                            0.02
                          ],
                          [
                            0.02,
                            0.02
                          ],
                          [
                            0.02,
                            0.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.02
                          ],
                          [
                            -0.01,
                            -0.02
                          ],
                          [
                            -0.02,
                            -0.02
                          ],
                          [
                            -0.02,
                            -0.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            -0.03,
                            0.03
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            10.36,
                            0.17
                          ],
                          [
                            9.57,
                            5.2
                          ],
                          [
                            9.58,
                            5.27
                          ],
                          [
                            9.61,
                            5.33
                          ],
                          [
                            9.66,
                            5.37
                          ],
                          [
                            9.73,
                            5.39
                          ],
                          [
                            10.53,
                            5.39
                          ],
                          [
                            10.79,
                            5.16
                          ],
                          [
                            11.57,
                            0.22
                          ],
                          [
                            11.57,
                            0.15
                          ],
                          [
                            11.54,
                            0.09
                          ],
                          [
                            11.48,
                            0.05
                          ],
                          [
                            11.41,
                            0.03
                          ],
                          [
                            10.52,
                            0.03
                          ],
                          [
                            10.42,
                            0.07
                          ],
                          [
                            10.36,
                            0.17
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.09,
                        0.61,
                        0.84,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1416",
    layers: [
      {
        ind: 1415,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                9.5,
                4.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                19,
                9
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.04
                          ],
                          [
                            0.01,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.02
                          ],
                          [
                            -0.01,
                            -0.02
                          ],
                          [
                            -0.02,
                            -0.01
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.04
                          ],
                          [
                            -0.01,
                            0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.04
                          ],
                          [
                            -0.06,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.19,
                            1.21
                          ],
                          [
                            0.25,
                            0.29
                          ],
                          [
                            0.64,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            0
                          ],
                          [
                            -0.05,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.02
                          ],
                          [
                            0.01,
                            0.02
                          ],
                          [
                            0.02,
                            0.02
                          ],
                          [
                            0.02,
                            0.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.05,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            -0.07
                          ],
                          [
                            0.05,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            1.27,
                            0
                          ],
                          [
                            0.09,
                            -0.54
                          ],
                          [
                            -0.27,
                            -0.32
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            3.28,
                            0.03
                          ],
                          [
                            1.35,
                            0.03
                          ],
                          [
                            1.18,
                            0.1
                          ],
                          [
                            1.09,
                            0.26
                          ],
                          [
                            0.3,
                            5.2
                          ],
                          [
                            0.31,
                            5.27
                          ],
                          [
                            0.34,
                            5.33
                          ],
                          [
                            0.4,
                            5.37
                          ],
                          [
                            0.46,
                            5.39
                          ],
                          [
                            1.38,
                            5.39
                          ],
                          [
                            1.56,
                            5.32
                          ],
                          [
                            1.65,
                            5.16
                          ],
                          [
                            1.86,
                            3.83
                          ],
                          [
                            1.95,
                            3.66
                          ],
                          [
                            2.12,
                            3.6
                          ],
                          [
                            2.73,
                            3.6
                          ],
                          [
                            4.93,
                            1.77
                          ],
                          [
                            4.68,
                            0.52
                          ],
                          [
                            3.28,
                            0.03
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.51,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.03,
                            0.02
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            -0.2
                          ],
                          [
                            0.04,
                            -0.24
                          ]
                        ],
                        o: [
                          [
                            -0.1,
                            0.69
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            -0.04
                          ],
                          [
                            0.03,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.1,
                            0.12
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            3.5,
                            1.84
                          ],
                          [
                            2.36,
                            2.53
                          ],
                          [
                            2.06,
                            2.53
                          ],
                          [
                            2.27,
                            1.24
                          ],
                          [
                            2.32,
                            1.14
                          ],
                          [
                            2.43,
                            1.1
                          ],
                          [
                            2.56,
                            1.1
                          ],
                          [
                            3.41,
                            1.3
                          ],
                          [
                            3.5,
                            1.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            -0.03
                          ],
                          [
                            0.01,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.45,
                            0
                          ],
                          [
                            0.17,
                            -1.09
                          ],
                          [
                            -0.31,
                            -0.36
                          ],
                          [
                            -0.48,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.01,
                            -0.02
                          ],
                          [
                            -0.02,
                            -0.02
                          ],
                          [
                            -0.02,
                            -0.01
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.04
                          ],
                          [
                            -0.01,
                            0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.02
                          ],
                          [
                            0.02,
                            0.02
                          ],
                          [
                            0.02,
                            0.01
                          ],
                          [
                            0.02,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            -0.03,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            -0.29
                          ],
                          [
                            -1.02,
                            0
                          ],
                          [
                            -0.09,
                            0.54
                          ],
                          [
                            0.28,
                            0.33
                          ],
                          [
                            0.82,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.02
                          ],
                          [
                            0,
                            0.02
                          ],
                          [
                            0.02,
                            0.02
                          ],
                          [
                            0.02,
                            0.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            0
                          ],
                          [
                            0.05,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.02
                          ],
                          [
                            -0.01,
                            -0.02
                          ],
                          [
                            -0.02,
                            -0.02
                          ],
                          [
                            -0.02,
                            -0.01
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.04,
                            1.82
                          ],
                          [
                            8.11,
                            1.82
                          ],
                          [
                            8.01,
                            1.86
                          ],
                          [
                            7.95,
                            1.95
                          ],
                          [
                            7.91,
                            2.21
                          ],
                          [
                            7.85,
                            2.12
                          ],
                          [
                            6.76,
                            1.73
                          ],
                          [
                            4.7,
                            3.59
                          ],
                          [
                            5.04,
                            5
                          ],
                          [
                            6.2,
                            5.47
                          ],
                          [
                            7.48,
                            4.94
                          ],
                          [
                            7.44,
                            5.2
                          ],
                          [
                            7.45,
                            5.27
                          ],
                          [
                            7.48,
                            5.33
                          ],
                          [
                            7.53,
                            5.37
                          ],
                          [
                            7.6,
                            5.39
                          ],
                          [
                            8.43,
                            5.39
                          ],
                          [
                            8.61,
                            5.32
                          ],
                          [
                            8.7,
                            5.16
                          ],
                          [
                            9.2,
                            2
                          ],
                          [
                            9.19,
                            1.93
                          ],
                          [
                            9.16,
                            1.87
                          ],
                          [
                            9.1,
                            1.83
                          ],
                          [
                            9.04,
                            1.82
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.54,
                            0
                          ],
                          [
                            0.14,
                            0.16
                          ],
                          [
                            -0.04,
                            0.26
                          ],
                          [
                            -0.52,
                            0
                          ],
                          [
                            -0.14,
                            -0.16
                          ],
                          [
                            0.04,
                            -0.25
                          ]
                        ],
                        o: [
                          [
                            -0.09,
                            0.53
                          ],
                          [
                            -0.27,
                            0
                          ],
                          [
                            -0.14,
                            -0.16
                          ],
                          [
                            0.08,
                            -0.52
                          ],
                          [
                            0.26,
                            0
                          ],
                          [
                            0.14,
                            0.17
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.75,
                            3.61
                          ],
                          [
                            6.71,
                            4.49
                          ],
                          [
                            6.09,
                            4.24
                          ],
                          [
                            5.95,
                            3.59
                          ],
                          [
                            6.98,
                            2.71
                          ],
                          [
                            7.59,
                            2.96
                          ],
                          [
                            7.75,
                            3.61
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.02
                          ],
                          [
                            0.02,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.04
                          ],
                          [
                            0.06,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            -0.01
                          ],
                          [
                            0.02,
                            -0.02
                          ],
                          [
                            0,
                            -0.03
                          ],
                          [
                            -0.01,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.03
                          ],
                          [
                            -0.01,
                            -0.03
                          ],
                          [
                            -0.03,
                            -0.02
                          ],
                          [
                            -0.03,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.02
                          ],
                          [
                            -0.02,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.03
                          ],
                          [
                            0.01,
                            0.02
                          ],
                          [
                            0.03,
                            0.02
                          ],
                          [
                            0.03,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            -0.04,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            -0.06
                          ],
                          [
                            -0.05,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.03,
                            0
                          ],
                          [
                            -0.02,
                            0.01
                          ],
                          [
                            -0.02,
                            0.02
                          ],
                          [
                            0,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            0.03
                          ],
                          [
                            0,
                            0.03
                          ],
                          [
                            0.02,
                            0.03
                          ],
                          [
                            0.02,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            0
                          ],
                          [
                            0.04,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            -0.02
                          ],
                          [
                            0,
                            -0.03
                          ],
                          [
                            -0.02,
                            -0.03
                          ],
                          [
                            -0.02,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            13.95,
                            1.82
                          ],
                          [
                            13.02,
                            1.82
                          ],
                          [
                            12.9,
                            1.85
                          ],
                          [
                            12.8,
                            1.93
                          ],
                          [
                            11.52,
                            3.82
                          ],
                          [
                            10.98,
                            2.01
                          ],
                          [
                            10.88,
                            1.87
                          ],
                          [
                            10.72,
                            1.82
                          ],
                          [
                            9.81,
                            1.82
                          ],
                          [
                            9.74,
                            1.83
                          ],
                          [
                            9.68,
                            1.88
                          ],
                          [
                            9.65,
                            1.95
                          ],
                          [
                            9.66,
                            2.03
                          ],
                          [
                            10.68,
                            5.02
                          ],
                          [
                            9.72,
                            6.38
                          ],
                          [
                            9.69,
                            6.46
                          ],
                          [
                            9.71,
                            6.55
                          ],
                          [
                            9.77,
                            6.61
                          ],
                          [
                            9.85,
                            6.63
                          ],
                          [
                            10.78,
                            6.63
                          ],
                          [
                            10.9,
                            6.6
                          ],
                          [
                            11,
                            6.52
                          ],
                          [
                            14.08,
                            2.07
                          ],
                          [
                            14.11,
                            1.98
                          ],
                          [
                            14.09,
                            1.9
                          ],
                          [
                            14.03,
                            1.84
                          ],
                          [
                            13.95,
                            1.82
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.15,
                        0.23,
                        0.5,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1419",
    layers: [
      {
        ind: 1393,
        ty: 0,
        parent: 1389,
        ks: {},
        w: 9,
        h: 11,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1391"
      },
      {
        ind: 1389,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1398,
        ty: 0,
        parent: 1394,
        ks: {},
        w: 6,
        h: 5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1396"
      },
      {
        ind: 1394,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              3,
              3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1403,
        ty: 0,
        parent: 1399,
        ks: {},
        w: 8,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1401"
      },
      {
        ind: 1399,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              2,
              3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1408,
        ty: 0,
        parent: 1404,
        ks: {},
        w: 10,
        h: 12,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1406"
      },
      {
        ind: 1404,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1413,
        ty: 0,
        parent: 1409,
        ks: {},
        w: 16,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1411"
      },
      {
        ind: 1409,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              31,
              3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1418,
        ty: 0,
        parent: 1414,
        ks: {},
        w: 19,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1416"
      },
      {
        ind: 1414,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              13,
              3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1449",
    layers: [
      {
        ind: 1448,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                10.5,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                21,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.06,
                            0.07
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            -0.04
                          ],
                          [
                            0,
                            -0.05
                          ],
                          [
                            0.02,
                            -0.04
                          ],
                          [
                            0.03,
                            -0.03
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            -0.07,
                            -0.06
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0.06,
                            -0.07
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.03
                          ],
                          [
                            0.02,
                            0.04
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            -0.02,
                            0.04
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            14.99,
                            3.77
                          ],
                          [
                            11.82,
                            6.93
                          ],
                          [
                            11.57,
                            7.04
                          ],
                          [
                            11.33,
                            6.93
                          ],
                          [
                            11.22,
                            6.68
                          ],
                          [
                            11.33,
                            6.44
                          ],
                          [
                            13.89,
                            3.87
                          ],
                          [
                            0.35,
                            3.87
                          ],
                          [
                            0.1,
                            3.77
                          ],
                          [
                            0,
                            3.52
                          ],
                          [
                            0.1,
                            3.27
                          ],
                          [
                            0.35,
                            3.17
                          ],
                          [
                            13.89,
                            3.17
                          ],
                          [
                            11.33,
                            0.6
                          ],
                          [
                            11.22,
                            0.35
                          ],
                          [
                            11.33,
                            0.1
                          ],
                          [
                            11.57,
                            0
                          ],
                          [
                            11.82,
                            0.1
                          ],
                          [
                            14.99,
                            3.27
                          ],
                          [
                            15.07,
                            3.38
                          ],
                          [
                            15.09,
                            3.52
                          ],
                          [
                            15.07,
                            3.65
                          ],
                          [
                            14.99,
                            3.77
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.57,
                        0.63,
                        0.72,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1488",
    layers: [
      {
        ind: 1487,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                31,
                6
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                62,
                12
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.26,
                            -0.08
                          ],
                          [
                            -0.15,
                            -0.21
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            0.32,
                            -0.24
                          ],
                          [
                            0.51,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.26,
                            0.09
                          ],
                          [
                            0.14,
                            0.2
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.32,
                            0.23
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.64,
                            6.75
                          ],
                          [
                            0.64,
                            2.09
                          ],
                          [
                            1.97,
                            2.09
                          ],
                          [
                            2.89,
                            2.21
                          ],
                          [
                            3.5,
                            2.65
                          ],
                          [
                            3.72,
                            3.46
                          ],
                          [
                            3.24,
                            4.55
                          ],
                          [
                            2,
                            4.9
                          ],
                          [
                            1.23,
                            4.9
                          ],
                          [
                            1.23,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.15
                          ],
                          [
                            0,
                            0.33
                          ],
                          [
                            0.21,
                            0.13
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0.2,
                            -0.16
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            -0.2,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.23,
                            4.42
                          ],
                          [
                            1.93,
                            4.42
                          ],
                          [
                            2.83,
                            4.19
                          ],
                          [
                            3.13,
                            3.46
                          ],
                          [
                            2.82,
                            2.76
                          ],
                          [
                            1.9,
                            2.56
                          ],
                          [
                            1.23,
                            2.56
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0.13
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.11,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.01
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0.12,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            -0.21
                          ],
                          [
                            0.17,
                            -0.13
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.01
                          ],
                          [
                            -0.15,
                            0
                          ],
                          [
                            -0.16,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            4.61,
                            6.75
                          ],
                          [
                            4.61,
                            3.29
                          ],
                          [
                            5.09,
                            3.29
                          ],
                          [
                            5.14,
                            3.92
                          ],
                          [
                            5.16,
                            3.92
                          ],
                          [
                            5.6,
                            3.4
                          ],
                          [
                            6.15,
                            3.21
                          ],
                          [
                            6.52,
                            3.28
                          ],
                          [
                            6.4,
                            3.79
                          ],
                          [
                            6.25,
                            3.75
                          ],
                          [
                            6.07,
                            3.73
                          ],
                          [
                            5.61,
                            3.91
                          ],
                          [
                            5.2,
                            4.53
                          ],
                          [
                            5.2,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.24,
                            0.14
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.24,
                            -0.29
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0,
                            -0.06
                          ],
                          [
                            0.01,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            -0.22
                          ],
                          [
                            -0.33,
                            0
                          ],
                          [
                            -0.14,
                            0.05
                          ],
                          [
                            -0.13,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0.23,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.15,
                            -0.27
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.15,
                            -0.27
                          ],
                          [
                            0.24,
                            -0.15
                          ],
                          [
                            0.44,
                            0
                          ],
                          [
                            0.24,
                            0.29
                          ],
                          [
                            0,
                            0.06
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            0.36
                          ],
                          [
                            0.21,
                            0.22
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0.09
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            8.41,
                            6.84
                          ],
                          [
                            7.57,
                            6.62
                          ],
                          [
                            6.97,
                            6
                          ],
                          [
                            6.75,
                            5.03
                          ],
                          [
                            6.97,
                            4.05
                          ],
                          [
                            7.55,
                            3.43
                          ],
                          [
                            8.3,
                            3.21
                          ],
                          [
                            9.32,
                            3.65
                          ],
                          [
                            9.68,
                            4.83
                          ],
                          [
                            9.68,
                            5.02
                          ],
                          [
                            9.66,
                            5.16
                          ],
                          [
                            7.33,
                            5.16
                          ],
                          [
                            7.67,
                            6.04
                          ],
                          [
                            8.48,
                            6.37
                          ],
                          [
                            8.93,
                            6.29
                          ],
                          [
                            9.34,
                            6.1
                          ],
                          [
                            9.55,
                            6.48
                          ],
                          [
                            9.04,
                            6.73
                          ],
                          [
                            8.41,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.18
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.2,
                            -0.19
                          ],
                          [
                            0.04,
                            -0.34
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.35
                          ],
                          [
                            -0.15,
                            -0.19
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.19,
                            0.18
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.32,
                            4.75
                          ],
                          [
                            9.17,
                            4.75
                          ],
                          [
                            8.94,
                            3.95
                          ],
                          [
                            8.32,
                            3.67
                          ],
                          [
                            7.66,
                            3.96
                          ],
                          [
                            7.32,
                            4.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.28,
                            0.12
                          ],
                          [
                            0.2,
                            0.21
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            -0.11
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.17,
                            0.14
                          ],
                          [
                            0,
                            0.23
                          ],
                          [
                            0.07,
                            0.09
                          ],
                          [
                            0.12,
                            0.07
                          ],
                          [
                            0.15,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.1
                          ],
                          [
                            0.1,
                            0.16
                          ],
                          [
                            0,
                            0.23
                          ],
                          [
                            -0.12,
                            0.18
                          ],
                          [
                            -0.22,
                            0.1
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.23,
                            -0.11
                          ],
                          [
                            -0.16,
                            -0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.07
                          ],
                          [
                            0.22,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0,
                            -0.21
                          ],
                          [
                            -0.07,
                            -0.1
                          ],
                          [
                            -0.12,
                            -0.06
                          ],
                          [
                            -0.12,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            -0.11
                          ],
                          [
                            -0.09,
                            -0.16
                          ],
                          [
                            0,
                            -0.23
                          ],
                          [
                            0.13,
                            -0.2
                          ],
                          [
                            0.24,
                            -0.12
                          ],
                          [
                            0.33,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.28,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0.18
                          ],
                          [
                            0.23,
                            0.11
                          ],
                          [
                            0.31,
                            0
                          ],
                          [
                            0.17,
                            -0.14
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            -0.07,
                            -0.09
                          ],
                          [
                            -0.11,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            -0.06
                          ],
                          [
                            -0.14,
                            -0.1
                          ],
                          [
                            -0.09,
                            -0.16
                          ],
                          [
                            0,
                            -0.24
                          ],
                          [
                            0.13,
                            -0.19
                          ],
                          [
                            0.22,
                            -0.11
                          ],
                          [
                            0.28,
                            0
                          ],
                          [
                            0.24,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            -0.14
                          ],
                          [
                            -0.17,
                            -0.08
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.16,
                            0.13
                          ],
                          [
                            0,
                            0.14
                          ],
                          [
                            0.08,
                            0.09
                          ],
                          [
                            0.12,
                            0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.07
                          ],
                          [
                            0.15,
                            0.1
                          ],
                          [
                            0.08,
                            0.15
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            -0.13,
                            0.2
                          ],
                          [
                            -0.24,
                            0.12
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            13.31,
                            6.84
                          ],
                          [
                            12.4,
                            6.65
                          ],
                          [
                            11.68,
                            6.14
                          ],
                          [
                            12.03,
                            5.73
                          ],
                          [
                            12.61,
                            6.16
                          ],
                          [
                            13.32,
                            6.32
                          ],
                          [
                            14.04,
                            6.11
                          ],
                          [
                            14.29,
                            5.55
                          ],
                          [
                            14.18,
                            5.17
                          ],
                          [
                            13.91,
                            4.93
                          ],
                          [
                            13.52,
                            4.73
                          ],
                          [
                            12.85,
                            4.44
                          ],
                          [
                            12.41,
                            4.2
                          ],
                          [
                            12.04,
                            3.81
                          ],
                          [
                            11.9,
                            3.24
                          ],
                          [
                            12.09,
                            2.61
                          ],
                          [
                            12.61,
                            2.16
                          ],
                          [
                            13.37,
                            2
                          ],
                          [
                            14.14,
                            2.16
                          ],
                          [
                            14.75,
                            2.57
                          ],
                          [
                            14.43,
                            2.96
                          ],
                          [
                            13.95,
                            2.64
                          ],
                          [
                            13.37,
                            2.52
                          ],
                          [
                            12.73,
                            2.7
                          ],
                          [
                            12.5,
                            3.2
                          ],
                          [
                            12.61,
                            3.57
                          ],
                          [
                            12.91,
                            3.8
                          ],
                          [
                            13.27,
                            3.98
                          ],
                          [
                            13.94,
                            4.26
                          ],
                          [
                            14.42,
                            4.54
                          ],
                          [
                            14.77,
                            4.93
                          ],
                          [
                            14.89,
                            5.5
                          ],
                          [
                            14.7,
                            6.18
                          ],
                          [
                            14.16,
                            6.66
                          ],
                          [
                            13.31,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.25,
                            0.14
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.16,
                            -0.08
                          ],
                          [
                            -0.12,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            0.06
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0.17,
                            -0.11
                          ],
                          [
                            0.09,
                            -0.2
                          ],
                          [
                            0,
                            -0.27
                          ],
                          [
                            -0.2,
                            -0.25
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.14,
                            0.07
                          ],
                          [
                            -0.11,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.08
                          ],
                          [
                            0.21,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.14,
                            -0.27
                          ],
                          [
                            0,
                            -0.39
                          ],
                          [
                            0.16,
                            -0.27
                          ],
                          [
                            0.26,
                            -0.14
                          ],
                          [
                            0.23,
                            0
                          ],
                          [
                            0.16,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.1,
                            -0.09
                          ],
                          [
                            -0.11,
                            -0.06
                          ],
                          [
                            -0.21,
                            0
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            -0.09,
                            0.2
                          ],
                          [
                            0,
                            0.39
                          ],
                          [
                            0.2,
                            0.24
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.14
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.13,
                            6.84
                          ],
                          [
                            16.3,
                            6.62
                          ],
                          [
                            15.71,
                            6
                          ],
                          [
                            15.5,
                            5.03
                          ],
                          [
                            15.73,
                            4.04
                          ],
                          [
                            16.34,
                            3.42
                          ],
                          [
                            17.17,
                            3.21
                          ],
                          [
                            17.75,
                            3.33
                          ],
                          [
                            18.18,
                            3.61
                          ],
                          [
                            17.88,
                            4
                          ],
                          [
                            17.56,
                            3.78
                          ],
                          [
                            17.19,
                            3.69
                          ],
                          [
                            16.63,
                            3.86
                          ],
                          [
                            16.24,
                            4.33
                          ],
                          [
                            16.11,
                            5.03
                          ],
                          [
                            16.4,
                            5.99
                          ],
                          [
                            17.17,
                            6.35
                          ],
                          [
                            17.62,
                            6.25
                          ],
                          [
                            17.98,
                            6
                          ],
                          [
                            18.24,
                            6.39
                          ],
                          [
                            17.72,
                            6.72
                          ],
                          [
                            17.13,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.17
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            -0.34,
                            0.2
                          ],
                          [
                            -0.73,
                            0.08
                          ],
                          [
                            0.04,
                            0.13
                          ],
                          [
                            0.11,
                            0.08
                          ],
                          [
                            0.19,
                            0
                          ],
                          [
                            0.17,
                            -0.07
                          ],
                          [
                            0.14,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.23,
                            0.09
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.19,
                            -0.26
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            -0.1
                          ],
                          [
                            0.22,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.19,
                            -0.18
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.34,
                            -0.2
                          ],
                          [
                            0,
                            -0.14
                          ],
                          [
                            -0.04,
                            -0.13
                          ],
                          [
                            -0.1,
                            -0.09
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.18,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.11
                          ],
                          [
                            0.24,
                            -0.1
                          ],
                          [
                            0.42,
                            0
                          ],
                          [
                            0.19,
                            0.26
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.13
                          ],
                          [
                            -0.19,
                            0.1
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            19.73,
                            6.84
                          ],
                          [
                            19,
                            6.58
                          ],
                          [
                            18.72,
                            5.86
                          ],
                          [
                            19.22,
                            4.98
                          ],
                          [
                            20.84,
                            4.56
                          ],
                          [
                            20.77,
                            4.14
                          ],
                          [
                            20.56,
                            3.82
                          ],
                          [
                            20.13,
                            3.69
                          ],
                          [
                            19.57,
                            3.8
                          ],
                          [
                            19.09,
                            4.06
                          ],
                          [
                            18.87,
                            3.66
                          ],
                          [
                            19.46,
                            3.36
                          ],
                          [
                            20.23,
                            3.21
                          ],
                          [
                            21.14,
                            3.6
                          ],
                          [
                            21.43,
                            4.63
                          ],
                          [
                            21.43,
                            6.75
                          ],
                          [
                            20.95,
                            6.75
                          ],
                          [
                            20.89,
                            6.34
                          ],
                          [
                            20.88,
                            6.34
                          ],
                          [
                            20.34,
                            6.69
                          ],
                          [
                            19.73,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            0.08
                          ],
                          [
                            -0.16,
                            0.15
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            -0.14
                          ],
                          [
                            0,
                            -0.22
                          ],
                          [
                            -0.12,
                            -0.09
                          ],
                          [
                            -0.17,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.17,
                            0
                          ],
                          [
                            0.15,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.57,
                            0.07
                          ],
                          [
                            -0.23,
                            0.14
                          ],
                          [
                            0,
                            0.19
                          ],
                          [
                            0.12,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            19.9,
                            6.37
                          ],
                          [
                            20.37,
                            6.25
                          ],
                          [
                            20.84,
                            5.9
                          ],
                          [
                            20.84,
                            4.95
                          ],
                          [
                            19.63,
                            5.26
                          ],
                          [
                            19.29,
                            5.81
                          ],
                          [
                            19.46,
                            6.24
                          ],
                          [
                            19.9,
                            6.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0.13
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.04
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            -0.04,
                            0.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.01
                          ],
                          [
                            0.08,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.21,
                            0
                          ],
                          [
                            -0.09,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            0.03,
                            0.04
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.02
                          ],
                          [
                            -0.05,
                            0.01
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            23.13,
                            6.84
                          ],
                          [
                            22.66,
                            6.64
                          ],
                          [
                            22.52,
                            6.05
                          ],
                          [
                            22.52,
                            1.69
                          ],
                          [
                            23.1,
                            1.69
                          ],
                          [
                            23.1,
                            6.1
                          ],
                          [
                            23.15,
                            6.29
                          ],
                          [
                            23.26,
                            6.35
                          ],
                          [
                            23.31,
                            6.35
                          ],
                          [
                            23.39,
                            6.34
                          ],
                          [
                            23.47,
                            6.78
                          ],
                          [
                            23.33,
                            6.82
                          ],
                          [
                            23.13,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.24,
                            0.14
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.24,
                            -0.29
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0,
                            -0.06
                          ],
                          [
                            0.01,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            -0.22
                          ],
                          [
                            -0.33,
                            0
                          ],
                          [
                            -0.14,
                            0.05
                          ],
                          [
                            -0.13,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0.23,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.15,
                            -0.27
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.15,
                            -0.27
                          ],
                          [
                            0.24,
                            -0.15
                          ],
                          [
                            0.44,
                            0
                          ],
                          [
                            0.24,
                            0.29
                          ],
                          [
                            0,
                            0.06
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            0.36
                          ],
                          [
                            0.21,
                            0.22
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0.09
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.73,
                            6.84
                          ],
                          [
                            24.89,
                            6.62
                          ],
                          [
                            24.29,
                            6
                          ],
                          [
                            24.07,
                            5.03
                          ],
                          [
                            24.29,
                            4.05
                          ],
                          [
                            24.88,
                            3.43
                          ],
                          [
                            25.62,
                            3.21
                          ],
                          [
                            26.64,
                            3.65
                          ],
                          [
                            27,
                            4.83
                          ],
                          [
                            27,
                            5.02
                          ],
                          [
                            26.98,
                            5.16
                          ],
                          [
                            24.65,
                            5.16
                          ],
                          [
                            24.99,
                            6.04
                          ],
                          [
                            25.8,
                            6.37
                          ],
                          [
                            26.25,
                            6.29
                          ],
                          [
                            26.66,
                            6.1
                          ],
                          [
                            26.87,
                            6.48
                          ],
                          [
                            26.36,
                            6.73
                          ],
                          [
                            25.73,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.18
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.2,
                            -0.19
                          ],
                          [
                            0.04,
                            -0.34
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.35
                          ],
                          [
                            -0.14,
                            -0.19
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.19,
                            0.18
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            24.64,
                            4.75
                          ],
                          [
                            26.49,
                            4.75
                          ],
                          [
                            26.26,
                            3.95
                          ],
                          [
                            25.64,
                            3.67
                          ],
                          [
                            24.98,
                            3.96
                          ],
                          [
                            24.64,
                            4.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0.13
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.11,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.01
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0.12,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            -0.21
                          ],
                          [
                            0.17,
                            -0.13
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.01
                          ],
                          [
                            -0.14,
                            0
                          ],
                          [
                            -0.16,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            27.86,
                            6.75
                          ],
                          [
                            27.86,
                            3.29
                          ],
                          [
                            28.34,
                            3.29
                          ],
                          [
                            28.39,
                            3.92
                          ],
                          [
                            28.41,
                            3.92
                          ],
                          [
                            28.84,
                            3.4
                          ],
                          [
                            29.39,
                            3.21
                          ],
                          [
                            29.76,
                            3.28
                          ],
                          [
                            29.65,
                            3.79
                          ],
                          [
                            29.49,
                            3.75
                          ],
                          [
                            29.31,
                            3.73
                          ],
                          [
                            28.85,
                            3.91
                          ],
                          [
                            28.44,
                            4.53
                          ],
                          [
                            28.44,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.49,
                        0.55,
                        0.65,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1520",
    layers: [
      {
        ind: 1519,
        ty: 2,
        parent: 1518,
        ks: {
          s: {
            a: 0,
            k: [
              170,
              181.82
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "0"
      },
      {
        ind: 1518,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1523",
    layers: [
      {
        ind: 1522,
        ty: 0,
        parent: 1517,
        ks: {},
        w: 8.5,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1520"
      },
      {
        ind: 1517,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1542",
    layers: [
      {
        ind: 1541,
        ty: 2,
        parent: 1540,
        ks: {
          s: {
            a: 0,
            k: [
              181.82,
              180
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "1"
      },
      {
        ind: 1540,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1545",
    layers: [
      {
        ind: 1544,
        ty: 0,
        parent: 1539,
        ks: {},
        w: 10,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1542"
      },
      {
        ind: 1539,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1578",
    layers: [
      {
        ind: 1577,
        ty: 2,
        parent: 1576,
        ks: {
          s: {
            a: 0,
            k: [
              181.25,
              183.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "10"
      },
      {
        ind: 1576,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1581",
    layers: [
      {
        ind: 1580,
        ty: 0,
        parent: 1575,
        ks: {},
        w: 14.5,
        h: 16.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1578"
      },
      {
        ind: 1575,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1592",
    layers: [
      {
        ind: 1591,
        ty: 2,
        parent: 1590,
        ks: {
          s: {
            a: 0,
            k: [
              184.38,
              185.71
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "11"
      },
      {
        ind: 1590,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1595",
    layers: [
      {
        ind: 1594,
        ty: 0,
        parent: 1589,
        ks: {},
        w: 59,
        h: 58.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1592"
      },
      {
        ind: 1589,
        ty: 3,
        parent: 1588,
        ks: {
          p: {
            a: 0,
            k: [
              -6,
              -3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1588,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              7,
              4
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1599",
    layers: [
      {
        ind: 1598,
        ty: 4,
        td: 1,
        parent: 1587,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                24.383,
                24.383
              ]
            },
            r: {
              a: 0,
              k: 24
            },
            s: {
              a: 0,
              k: [
                48.766,
                48.766
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1597,
        ty: 0,
        tt: 1,
        parent: 1587,
        ks: {
          a: {
            a: 0,
            k: [
              7,
              4
            ]
          }
        },
        w: 66,
        h: 63,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1595"
      },
      {
        ind: 1587,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              5.418,
              5.418
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1667",
    layers: [
      {
        ind: 1666,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                5.5,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                11,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.02
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0.05,
                            0.02
                          ],
                          [
                            0.04,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.02
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            -0.04,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.04
                          ],
                          [
                            -0.05,
                            0.02
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.04
                          ],
                          [
                            0.05,
                            -0.02
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0.05,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.75,
                            1.03
                          ],
                          [
                            7.75,
                            3.06
                          ],
                          [
                            7.64,
                            3.33
                          ],
                          [
                            7.37,
                            3.44
                          ],
                          [
                            7.1,
                            3.33
                          ],
                          [
                            6.98,
                            3.06
                          ],
                          [
                            6.98,
                            1.95
                          ],
                          [
                            4.59,
                            4.34
                          ],
                          [
                            4.46,
                            4.43
                          ],
                          [
                            4.32,
                            4.46
                          ],
                          [
                            4.17,
                            4.43
                          ],
                          [
                            4.05,
                            4.34
                          ],
                          [
                            3.05,
                            3.34
                          ],
                          [
                            1.03,
                            5.36
                          ],
                          [
                            0.76,
                            5.47
                          ],
                          [
                            0.49,
                            5.36
                          ],
                          [
                            0.38,
                            5.09
                          ],
                          [
                            0.49,
                            4.82
                          ],
                          [
                            2.78,
                            2.54
                          ],
                          [
                            2.9,
                            2.45
                          ],
                          [
                            3.05,
                            2.42
                          ],
                          [
                            3.2,
                            2.45
                          ],
                          [
                            3.32,
                            2.54
                          ],
                          [
                            4.32,
                            3.54
                          ],
                          [
                            6.45,
                            1.41
                          ],
                          [
                            5.34,
                            1.41
                          ],
                          [
                            5.07,
                            1.3
                          ],
                          [
                            4.95,
                            1.03
                          ],
                          [
                            5.07,
                            0.76
                          ],
                          [
                            5.34,
                            0.64
                          ],
                          [
                            7.37,
                            0.64
                          ],
                          [
                            7.64,
                            0.76
                          ],
                          [
                            7.75,
                            1.03
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.52,
                        0.32,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1670",
    layers: [
      {
        ind: 1669,
        ty: 0,
        parent: 1665,
        ks: {},
        w: 11,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1667"
      },
      {
        ind: 1665,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1679",
    layers: [
      {
        ind: 1678,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                9.5,
                2.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                19,
                5
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "sh",
                        ks: {
                          a: 0,
                          k: {
                            c: !0,
                            i: [
                              [
                                0,
                                0
                              ],
                              [
                                0.21,
                                -0.15
                              ],
                              [
                                3.9,
                                0
                              ],
                              [
                                3.35,
                                3.05
                              ],
                              [
                                -0.07,
                                0.1
                              ],
                              [
                                -0.17,
                                -0.09
                              ],
                              [
                                -4.14,
                                0
                              ],
                              [
                                -2.95,
                                1.26
                              ],
                              [
                                -0.12,
                                -0.17
                              ]
                            ],
                            o: [
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ],
                              [
                                0,
                                0
                              ]
                            ],
                            v: [
                              [
                                13.74,
                                1.21
                              ],
                              [
                                13.66,
                                1.54
                              ],
                              [
                                7.43,
                                3.39
                              ],
                              [
                                0.07,
                                0.54
                              ],
                              [
                                0.02,
                                0.34
                              ],
                              [
                                0.26,
                                0.35
                              ],
                              [
                                7.55,
                                2.32
                              ],
                              [
                                13.38,
                                1.17
                              ],
                              [
                                13.74,
                                1.21
                              ]
                            ]
                          }
                        }
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0.95,
                            0.59,
                            0.11,
                            1
                          ]
                        },
                        o: {
                          a: 0,
                          k: 100
                        }
                      },
                      {
                        ty: "tr",
                        o: {
                          a: 0,
                          k: 100
                        }
                      }
                    ]
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1684",
    layers: [
      {
        ind: 1683,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2.5,
                2
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                5,
                4
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.03
                          ],
                          [
                            -0.12,
                            0.12
                          ],
                          [
                            -0.02,
                            1.46
                          ],
                          [
                            0.07,
                            0.05
                          ],
                          [
                            1.03,
                            -0.08
                          ],
                          [
                            0.49,
                            -0.44
                          ],
                          [
                            0,
                            -0.05
                          ],
                          [
                            -0.27,
                            0.04
                          ],
                          [
                            -0.54,
                            -0.07
                          ],
                          [
                            -0.08,
                            -0.1
                          ],
                          [
                            0.07,
                            -0.35
                          ],
                          [
                            0.29,
                            -0.54
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.92,
                            2.61
                          ],
                          [
                            1.93,
                            2.77
                          ],
                          [
                            2.16,
                            2.69
                          ],
                          [
                            3.1,
                            0.43
                          ],
                          [
                            3.04,
                            0.19
                          ],
                          [
                            1.71,
                            0.02
                          ],
                          [
                            0.32,
                            0.51
                          ],
                          [
                            0.27,
                            0.6
                          ],
                          [
                            0.54,
                            0.66
                          ],
                          [
                            1.97,
                            0.6
                          ],
                          [
                            2.33,
                            0.73
                          ],
                          [
                            2.39,
                            1.18
                          ],
                          [
                            1.92,
                            2.61
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.95,
                        0.59,
                        0.11,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1689",
    layers: [
      {
        ind: 1688,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                19.5,
                3.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                39,
                7
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            -0.03
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.03
                          ],
                          [
                            0,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.03,
                            0.03
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.03,
                            -0.03
                          ],
                          [
                            0,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.86,
                            0
                          ],
                          [
                            -0.34,
                            -0.94
                          ],
                          [
                            -0.87,
                            0
                          ],
                          [
                            0,
                            -1.34
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            -0.04
                          ],
                          [
                            0.04,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.03
                          ],
                          [
                            0,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.04
                          ],
                          [
                            0.04,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.03
                          ],
                          [
                            0,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.62,
                            0
                          ],
                          [
                            -0.02,
                            -0.96
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.04
                          ],
                          [
                            -0.03,
                            0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.03,
                            -0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.04
                          ],
                          [
                            0.03,
                            -0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            0
                          ],
                          [
                            0.03,
                            0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.04
                          ],
                          [
                            -0.04,
                            0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            -0.03,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            -0.68
                          ],
                          [
                            -0.7,
                            0.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.04
                          ],
                          [
                            -0.03,
                            0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            -0.03,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            6.64,
                            2.18
                          ],
                          [
                            6.64,
                            4.94
                          ],
                          [
                            6.6,
                            5.06
                          ],
                          [
                            6.48,
                            5.11
                          ],
                          [
                            5.61,
                            5.11
                          ],
                          [
                            5.49,
                            5.06
                          ],
                          [
                            5.44,
                            4.94
                          ],
                          [
                            5.44,
                            0.46
                          ],
                          [
                            5.49,
                            0.34
                          ],
                          [
                            5.61,
                            0.29
                          ],
                          [
                            6.41,
                            0.29
                          ],
                          [
                            6.53,
                            0.34
                          ],
                          [
                            6.58,
                            0.46
                          ],
                          [
                            6.58,
                            1.09
                          ],
                          [
                            7.72,
                            0.19
                          ],
                          [
                            8.91,
                            1.02
                          ],
                          [
                            10.07,
                            0.19
                          ],
                          [
                            11.37,
                            1.45
                          ],
                          [
                            11.38,
                            2.2
                          ],
                          [
                            11.38,
                            4.95
                          ],
                          [
                            11.33,
                            5.07
                          ],
                          [
                            11.21,
                            5.12
                          ],
                          [
                            10.34,
                            5.12
                          ],
                          [
                            10.22,
                            5.07
                          ],
                          [
                            10.17,
                            4.95
                          ],
                          [
                            10.16,
                            1.94
                          ],
                          [
                            9.64,
                            1.31
                          ],
                          [
                            9.01,
                            2.2
                          ],
                          [
                            9.01,
                            4.95
                          ],
                          [
                            8.96,
                            5.07
                          ],
                          [
                            8.84,
                            5.12
                          ],
                          [
                            7.97,
                            5.12
                          ],
                          [
                            7.86,
                            5.07
                          ],
                          [
                            7.8,
                            4.95
                          ],
                          [
                            7.8,
                            2.01
                          ],
                          [
                            7.24,
                            1.3
                          ],
                          [
                            6.64,
                            2.18
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            -0.03
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.04
                          ],
                          [
                            0,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.62,
                            0
                          ],
                          [
                            0,
                            -1.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            -0.03
                          ],
                          [
                            0.04,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            0.03
                          ],
                          [
                            0,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.03,
                            0.03
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.03
                          ],
                          [
                            0,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.85,
                            0
                          ],
                          [
                            -0.31,
                            -0.96
                          ],
                          [
                            0,
                            -0.97
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.04
                          ],
                          [
                            -0.03,
                            0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.03,
                            -0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.04
                          ],
                          [
                            -0.03,
                            0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            -0.03,
                            -0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.04
                          ],
                          [
                            0.04,
                            -0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            0
                          ],
                          [
                            0.03,
                            0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            29.07,
                            2.18
                          ],
                          [
                            29.07,
                            4.93
                          ],
                          [
                            29.02,
                            5.05
                          ],
                          [
                            28.9,
                            5.1
                          ],
                          [
                            28,
                            5.12
                          ],
                          [
                            27.88,
                            5.07
                          ],
                          [
                            27.83,
                            4.95
                          ],
                          [
                            27.83,
                            2.01
                          ],
                          [
                            27.26,
                            1.3
                          ],
                          [
                            26.67,
                            2.38
                          ],
                          [
                            26.67,
                            4.94
                          ],
                          [
                            26.62,
                            5.06
                          ],
                          [
                            26.5,
                            5.11
                          ],
                          [
                            25.63,
                            5.11
                          ],
                          [
                            25.51,
                            5.06
                          ],
                          [
                            25.46,
                            4.94
                          ],
                          [
                            25.46,
                            0.46
                          ],
                          [
                            25.51,
                            0.34
                          ],
                          [
                            25.63,
                            0.29
                          ],
                          [
                            26.44,
                            0.29
                          ],
                          [
                            26.56,
                            0.34
                          ],
                          [
                            26.61,
                            0.46
                          ],
                          [
                            26.61,
                            1.09
                          ],
                          [
                            27.75,
                            0.19
                          ],
                          [
                            28.97,
                            1.01
                          ],
                          [
                            29.07,
                            2.18
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -1.58
                          ],
                          [
                            -1.32,
                            0
                          ],
                          [
                            0,
                            1.39
                          ],
                          [
                            1.11,
                            0
                          ]
                        ],
                        o: [
                          [
                            -1.11,
                            0
                          ],
                          [
                            0,
                            1.39
                          ],
                          [
                            1.25,
                            0
                          ],
                          [
                            0,
                            -1.55
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            22.79,
                            0.17
                          ],
                          [
                            20.78,
                            2.68
                          ],
                          [
                            22.79,
                            5.2
                          ],
                          [
                            24.8,
                            2.68
                          ],
                          [
                            22.79,
                            0.17
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.1,
                            0.62
                          ],
                          [
                            0,
                            0.59
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0
                          ],
                          [
                            -0.11,
                            -0.62
                          ],
                          [
                            0,
                            -0.59
                          ]
                        ],
                        o: [
                          [
                            0,
                            0.59
                          ],
                          [
                            -0.11,
                            0.63
                          ],
                          [
                            -0.07,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.59
                          ],
                          [
                            0.1,
                            -0.62
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            23.49,
                            2.74
                          ],
                          [
                            23.42,
                            3.65
                          ],
                          [
                            22.79,
                            4.28
                          ],
                          [
                            22.16,
                            3.65
                          ],
                          [
                            22.09,
                            2.74
                          ],
                          [
                            22.09,
                            2.64
                          ],
                          [
                            22.16,
                            1.73
                          ],
                          [
                            22.79,
                            1.11
                          ],
                          [
                            23.42,
                            1.73
                          ],
                          [
                            23.49,
                            2.64
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.03
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            -0.03
                          ],
                          [
                            0,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.03
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.3,
                            0.16
                          ],
                          [
                            -0.91,
                            0
                          ],
                          [
                            -0.6,
                            -0.37
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.24,
                            0.11
                          ],
                          [
                            0.9,
                            -0.06
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.04
                          ],
                          [
                            -0.03,
                            -0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            -0.04,
                            0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.04
                          ],
                          [
                            0.03,
                            0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            20.27,
                            1.08
                          ],
                          [
                            20.27,
                            0.44
                          ],
                          [
                            20.22,
                            0.32
                          ],
                          [
                            20.1,
                            0.27
                          ],
                          [
                            17.23,
                            0.27
                          ],
                          [
                            17.11,
                            0.32
                          ],
                          [
                            17.06,
                            0.44
                          ],
                          [
                            17.06,
                            1.08
                          ],
                          [
                            17.11,
                            1.2
                          ],
                          [
                            17.23,
                            1.25
                          ],
                          [
                            18.73,
                            1.25
                          ],
                          [
                            16.95,
                            3.82
                          ],
                          [
                            16.88,
                            4.04
                          ],
                          [
                            16.88,
                            4.82
                          ],
                          [
                            17.18,
                            4.94
                          ],
                          [
                            18.63,
                            4.61
                          ],
                          [
                            20.12,
                            4.96
                          ],
                          [
                            20.37,
                            4.83
                          ],
                          [
                            20.37,
                            4.15
                          ],
                          [
                            20.15,
                            3.86
                          ],
                          [
                            18.56,
                            3.54
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.16
                          ],
                          [
                            -0.59,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.15
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -1.65
                          ],
                          [
                            -1.63,
                            0
                          ],
                          [
                            -0.07,
                            0.25
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.64,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.27,
                            0.04
                          ],
                          [
                            -0.79,
                            0.45
                          ],
                          [
                            0,
                            1.44
                          ],
                          [
                            0.88,
                            0
                          ],
                          [
                            0.16,
                            0.27
                          ],
                          [
                            0.14,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.14,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            4.77,
                            4.31
                          ],
                          [
                            4.5,
                            3.89
                          ],
                          [
                            4.41,
                            3.56
                          ],
                          [
                            4.41,
                            1.65
                          ],
                          [
                            2.62,
                            0.14
                          ],
                          [
                            0.75,
                            1.41
                          ],
                          [
                            0.88,
                            1.67
                          ],
                          [
                            1.68,
                            1.75
                          ],
                          [
                            1.86,
                            1.62
                          ],
                          [
                            2.55,
                            1.07
                          ],
                          [
                            3.18,
                            1.61
                          ],
                          [
                            3.18,
                            2.07
                          ],
                          [
                            1.32,
                            2.47
                          ],
                          [
                            0.59,
                            3.8
                          ],
                          [
                            1.96,
                            5.18
                          ],
                          [
                            3.36,
                            4.54
                          ],
                          [
                            3.8,
                            5.07
                          ],
                          [
                            4.09,
                            5.09
                          ],
                          [
                            4.73,
                            4.54
                          ],
                          [
                            4.77,
                            4.31
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0.41
                          ],
                          [
                            -0.87,
                            -0.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.34,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.41,
                            0
                          ],
                          [
                            0.07,
                            -0.4
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            1.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            2.39,
                            4.29
                          ],
                          [
                            1.89,
                            3.47
                          ],
                          [
                            3.18,
                            2.76
                          ],
                          [
                            3.18,
                            3.01
                          ],
                          [
                            2.39,
                            4.29
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.16
                          ],
                          [
                            -0.59,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.15
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -1.65
                          ],
                          [
                            -1.62,
                            0
                          ],
                          [
                            -0.07,
                            0.25
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.64,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -1.27,
                            0.04
                          ],
                          [
                            -0.79,
                            0.45
                          ],
                          [
                            0,
                            1.44
                          ],
                          [
                            0.88,
                            0
                          ],
                          [
                            0.16,
                            0.27
                          ],
                          [
                            0.14,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.14,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            16.33,
                            4.31
                          ],
                          [
                            16.06,
                            3.89
                          ],
                          [
                            15.98,
                            3.56
                          ],
                          [
                            15.98,
                            1.65
                          ],
                          [
                            14.18,
                            0.14
                          ],
                          [
                            12.31,
                            1.41
                          ],
                          [
                            12.44,
                            1.67
                          ],
                          [
                            13.24,
                            1.75
                          ],
                          [
                            13.42,
                            1.62
                          ],
                          [
                            14.11,
                            1.07
                          ],
                          [
                            14.75,
                            1.61
                          ],
                          [
                            14.75,
                            2.07
                          ],
                          [
                            12.88,
                            2.47
                          ],
                          [
                            12.14,
                            3.8
                          ],
                          [
                            13.52,
                            5.18
                          ],
                          [
                            14.92,
                            4.54
                          ],
                          [
                            15.36,
                            5.07
                          ],
                          [
                            15.65,
                            5.09
                          ],
                          [
                            16.29,
                            4.54
                          ],
                          [
                            16.33,
                            4.31
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0.41
                          ],
                          [
                            -0.87,
                            -0.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.34,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.41,
                            0
                          ],
                          [
                            0.07,
                            -0.4
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            1.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            13.95,
                            4.29
                          ],
                          [
                            13.45,
                            3.47
                          ],
                          [
                            14.75,
                            2.76
                          ],
                          [
                            14.75,
                            3.01
                          ],
                          [
                            13.95,
                            4.29
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0,
                        0,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1692",
    layers: [
      {
        ind: 1681,
        ty: 0,
        parent: 1677,
        ks: {},
        w: 19,
        h: 5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1679"
      },
      {
        ind: 1677,
        ty: 3,
        parent: 1676,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1686,
        ty: 0,
        parent: 1682,
        ks: {},
        w: 5,
        h: 4,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1684"
      },
      {
        ind: 1682,
        ty: 3,
        parent: 1676,
        ks: {
          p: {
            a: 0,
            k: [
              16,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1676,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              6.133,
              7.089
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1691,
        ty: 0,
        parent: 1687,
        ks: {},
        w: 39,
        h: 7,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1689"
      },
      {
        ind: 1687,
        ty: 3,
        ks: {},
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1722",
    layers: [
      {
        ind: 1721,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                10.5,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                21,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.06,
                            0.07
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            -0.04
                          ],
                          [
                            0,
                            -0.05
                          ],
                          [
                            0.02,
                            -0.04
                          ],
                          [
                            0.03,
                            -0.03
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            -0.07,
                            -0.06
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0.06,
                            -0.07
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.03
                          ],
                          [
                            0.02,
                            0.04
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            -0.02,
                            0.04
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            14.99,
                            3.77
                          ],
                          [
                            11.82,
                            6.93
                          ],
                          [
                            11.57,
                            7.04
                          ],
                          [
                            11.33,
                            6.93
                          ],
                          [
                            11.22,
                            6.68
                          ],
                          [
                            11.33,
                            6.44
                          ],
                          [
                            13.89,
                            3.87
                          ],
                          [
                            0.35,
                            3.87
                          ],
                          [
                            0.1,
                            3.77
                          ],
                          [
                            0,
                            3.52
                          ],
                          [
                            0.1,
                            3.27
                          ],
                          [
                            0.35,
                            3.17
                          ],
                          [
                            13.89,
                            3.17
                          ],
                          [
                            11.33,
                            0.6
                          ],
                          [
                            11.22,
                            0.35
                          ],
                          [
                            11.33,
                            0.1
                          ],
                          [
                            11.57,
                            0
                          ],
                          [
                            11.82,
                            0.1
                          ],
                          [
                            14.99,
                            3.27
                          ],
                          [
                            15.07,
                            3.38
                          ],
                          [
                            15.09,
                            3.52
                          ],
                          [
                            15.07,
                            3.65
                          ],
                          [
                            14.99,
                            3.77
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.57,
                        0.63,
                        0.72,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1728",
    layers: [
      {
        ind: 1727,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                43.5,
                7.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                87,
                15
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            -0.19
                          ],
                          [
                            -0.06,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.18
                          ],
                          [
                            -0.06,
                            0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            0.29
                          ],
                          [
                            -0.02,
                            0.23
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            -0.29
                          ],
                          [
                            0,
                            -0.24
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.18
                          ],
                          [
                            0.07,
                            0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.06,
                            -0.18
                          ],
                          [
                            0.06,
                            -0.19
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.24
                          ],
                          [
                            0.02,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            0.23
                          ],
                          [
                            0.02,
                            0.29
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.73,
                            8.64
                          ],
                          [
                            0.73,
                            3.3
                          ],
                          [
                            1.54,
                            3.3
                          ],
                          [
                            2.57,
                            6.15
                          ],
                          [
                            2.75,
                            6.71
                          ],
                          [
                            2.95,
                            7.26
                          ],
                          [
                            2.98,
                            7.26
                          ],
                          [
                            3.16,
                            6.71
                          ],
                          [
                            3.35,
                            6.15
                          ],
                          [
                            4.36,
                            3.3
                          ],
                          [
                            5.18,
                            3.3
                          ],
                          [
                            5.18,
                            8.64
                          ],
                          [
                            4.54,
                            8.64
                          ],
                          [
                            4.54,
                            5.7
                          ],
                          [
                            4.57,
                            4.91
                          ],
                          [
                            4.63,
                            4.13
                          ],
                          [
                            4.6,
                            4.13
                          ],
                          [
                            4.18,
                            5.34
                          ],
                          [
                            3.17,
                            8.1
                          ],
                          [
                            2.72,
                            8.1
                          ],
                          [
                            1.71,
                            5.34
                          ],
                          [
                            1.29,
                            4.13
                          ],
                          [
                            1.26,
                            4.13
                          ],
                          [
                            1.31,
                            4.91
                          ],
                          [
                            1.34,
                            5.7
                          ],
                          [
                            1.34,
                            8.64
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.22,
                            0.2
                          ],
                          [
                            0,
                            0.35
                          ],
                          [
                            -0.39,
                            0.23
                          ],
                          [
                            -0.84,
                            0.09
                          ],
                          [
                            0.05,
                            0.15
                          ],
                          [
                            0.12,
                            0.09
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0.2,
                            -0.09
                          ],
                          [
                            0.16,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.27,
                            0.11
                          ],
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.21,
                            -0.3
                          ],
                          [
                            0,
                            -0.5
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.22,
                            -0.11
                          ],
                          [
                            0.25,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.33,
                            0
                          ],
                          [
                            -0.21,
                            -0.2
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0.39,
                            -0.23
                          ],
                          [
                            0,
                            -0.17
                          ],
                          [
                            -0.04,
                            -0.15
                          ],
                          [
                            -0.11,
                            -0.09
                          ],
                          [
                            -0.23,
                            0
                          ],
                          [
                            -0.2,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            -0.12
                          ],
                          [
                            0.27,
                            -0.11
                          ],
                          [
                            0.48,
                            0
                          ],
                          [
                            0.22,
                            0.29
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            0.15
                          ],
                          [
                            -0.21,
                            0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.48,
                            8.73
                          ],
                          [
                            6.65,
                            8.44
                          ],
                          [
                            6.33,
                            7.61
                          ],
                          [
                            6.91,
                            6.62
                          ],
                          [
                            8.75,
                            6.13
                          ],
                          [
                            8.68,
                            5.65
                          ],
                          [
                            8.43,
                            5.29
                          ],
                          [
                            7.94,
                            5.14
                          ],
                          [
                            7.3,
                            5.27
                          ],
                          [
                            6.76,
                            5.56
                          ],
                          [
                            6.5,
                            5.1
                          ],
                          [
                            7.17,
                            4.76
                          ],
                          [
                            8.05,
                            4.59
                          ],
                          [
                            9.1,
                            5.04
                          ],
                          [
                            9.43,
                            6.21
                          ],
                          [
                            9.43,
                            8.64
                          ],
                          [
                            8.87,
                            8.64
                          ],
                          [
                            8.82,
                            8.16
                          ],
                          [
                            8.79,
                            8.16
                          ],
                          [
                            8.18,
                            8.56
                          ],
                          [
                            7.48,
                            8.73
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0.09
                          ],
                          [
                            -0.19,
                            0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.27,
                            -0.16
                          ],
                          [
                            0,
                            -0.25
                          ],
                          [
                            -0.13,
                            -0.1
                          ],
                          [
                            -0.2,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.19,
                            0
                          ],
                          [
                            0.17,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.66,
                            0.08
                          ],
                          [
                            -0.26,
                            0.16
                          ],
                          [
                            0,
                            0.22
                          ],
                          [
                            0.14,
                            0.1
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.68,
                            8.2
                          ],
                          [
                            8.21,
                            8.06
                          ],
                          [
                            8.75,
                            7.67
                          ],
                          [
                            8.75,
                            6.57
                          ],
                          [
                            7.37,
                            6.94
                          ],
                          [
                            6.98,
                            7.56
                          ],
                          [
                            7.18,
                            8.05
                          ],
                          [
                            7.68,
                            8.2
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.1
                          ],
                          [
                            0.19,
                            0.15
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            -0.09
                          ],
                          [
                            -0.23,
                            0
                          ],
                          [
                            -0.13,
                            0.12
                          ],
                          [
                            0,
                            0.17
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0.14,
                            0.06
                          ],
                          [
                            0.15,
                            0.05
                          ],
                          [
                            0.18,
                            0.09
                          ],
                          [
                            0.11,
                            0.14
                          ],
                          [
                            0,
                            0.22
                          ],
                          [
                            -0.24,
                            0.21
                          ],
                          [
                            -0.43,
                            0
                          ],
                          [
                            -0.21,
                            -0.09
                          ],
                          [
                            -0.15,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.14,
                            0.06
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0.12,
                            -0.11
                          ],
                          [
                            0,
                            -0.15
                          ],
                          [
                            -0.08,
                            -0.08
                          ],
                          [
                            -0.13,
                            -0.06
                          ],
                          [
                            -0.14,
                            -0.06
                          ],
                          [
                            -0.18,
                            -0.09
                          ],
                          [
                            -0.12,
                            -0.15
                          ],
                          [
                            0,
                            -0.25
                          ],
                          [
                            0.11,
                            -0.18
                          ],
                          [
                            0.21,
                            -0.11
                          ],
                          [
                            0.32,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.25,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.17,
                            0.14
                          ],
                          [
                            0.18,
                            0.09
                          ],
                          [
                            0.26,
                            0
                          ],
                          [
                            0.13,
                            -0.13
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            -0.09,
                            -0.09
                          ],
                          [
                            -0.13,
                            -0.07
                          ],
                          [
                            -0.18,
                            -0.07
                          ],
                          [
                            -0.18,
                            -0.09
                          ],
                          [
                            -0.11,
                            -0.14
                          ],
                          [
                            0,
                            -0.32
                          ],
                          [
                            0.25,
                            -0.22
                          ],
                          [
                            0.25,
                            0
                          ],
                          [
                            0.21,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            -0.1
                          ],
                          [
                            -0.15,
                            -0.07
                          ],
                          [
                            -0.25,
                            0
                          ],
                          [
                            -0.11,
                            0.12
                          ],
                          [
                            0,
                            0.13
                          ],
                          [
                            0.08,
                            0.08
                          ],
                          [
                            0.13,
                            0.05
                          ],
                          [
                            0.19,
                            0.07
                          ],
                          [
                            0.18,
                            0.09
                          ],
                          [
                            0.12,
                            0.15
                          ],
                          [
                            0,
                            0.21
                          ],
                          [
                            -0.11,
                            0.18
                          ],
                          [
                            -0.21,
                            0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            11.7,
                            8.73
                          ],
                          [
                            10.89,
                            8.58
                          ],
                          [
                            10.23,
                            8.19
                          ],
                          [
                            10.56,
                            7.74
                          ],
                          [
                            11.1,
                            8.08
                          ],
                          [
                            11.72,
                            8.21
                          ],
                          [
                            12.31,
                            8.04
                          ],
                          [
                            12.5,
                            7.59
                          ],
                          [
                            12.37,
                            7.25
                          ],
                          [
                            12.02,
                            7.03
                          ],
                          [
                            11.6,
                            6.85
                          ],
                          [
                            11.06,
                            6.61
                          ],
                          [
                            10.62,
                            6.26
                          ],
                          [
                            10.45,
                            5.71
                          ],
                          [
                            10.8,
                            4.91
                          ],
                          [
                            11.81,
                            4.59
                          ],
                          [
                            12.5,
                            4.72
                          ],
                          [
                            13.04,
                            5.04
                          ],
                          [
                            12.71,
                            5.46
                          ],
                          [
                            12.29,
                            5.21
                          ],
                          [
                            11.81,
                            5.11
                          ],
                          [
                            11.26,
                            5.28
                          ],
                          [
                            11.09,
                            5.68
                          ],
                          [
                            11.21,
                            5.98
                          ],
                          [
                            11.53,
                            6.19
                          ],
                          [
                            11.94,
                            6.36
                          ],
                          [
                            12.5,
                            6.61
                          ],
                          [
                            12.96,
                            6.96
                          ],
                          [
                            13.14,
                            7.55
                          ],
                          [
                            12.98,
                            8.14
                          ],
                          [
                            12.49,
                            8.57
                          ],
                          [
                            11.7,
                            8.73
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.17,
                            0.24
                          ],
                          [
                            0,
                            0.39
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.13
                          ],
                          [
                            -0.23,
                            0
                          ],
                          [
                            -0.08,
                            0.02
                          ],
                          [
                            -0.06,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            -0.03
                          ],
                          [
                            0.13,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.42,
                            0
                          ],
                          [
                            -0.16,
                            -0.24
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.24
                          ],
                          [
                            0.09,
                            0.13
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.08,
                            -0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.11,
                            0.04
                          ],
                          [
                            -0.12,
                            0.04
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            15.16,
                            8.73
                          ],
                          [
                            14.27,
                            8.37
                          ],
                          [
                            14.03,
                            7.42
                          ],
                          [
                            14.03,
                            5.23
                          ],
                          [
                            13.44,
                            5.23
                          ],
                          [
                            13.44,
                            4.73
                          ],
                          [
                            14.06,
                            4.69
                          ],
                          [
                            14.14,
                            3.58
                          ],
                          [
                            14.7,
                            3.58
                          ],
                          [
                            14.7,
                            4.69
                          ],
                          [
                            15.77,
                            4.69
                          ],
                          [
                            15.77,
                            5.23
                          ],
                          [
                            14.7,
                            5.23
                          ],
                          [
                            14.7,
                            7.43
                          ],
                          [
                            14.83,
                            7.99
                          ],
                          [
                            15.31,
                            8.19
                          ],
                          [
                            15.54,
                            8.16
                          ],
                          [
                            15.76,
                            8.08
                          ],
                          [
                            15.89,
                            8.59
                          ],
                          [
                            15.53,
                            8.68
                          ],
                          [
                            15.16,
                            8.73
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.29,
                            0.16
                          ],
                          [
                            0.17,
                            0.31
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            -0.17,
                            0.31
                          ],
                          [
                            -0.27,
                            0.17
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.27,
                            -0.34
                          ],
                          [
                            0,
                            -0.56
                          ],
                          [
                            0,
                            -0.07
                          ],
                          [
                            0.01,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.23,
                            -0.25
                          ],
                          [
                            -0.38,
                            0
                          ],
                          [
                            -0.16,
                            0.05
                          ],
                          [
                            -0.15,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            -0.08
                          ],
                          [
                            0.27,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.35,
                            0
                          ],
                          [
                            -0.29,
                            -0.17
                          ],
                          [
                            -0.17,
                            -0.31
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0.17,
                            -0.31
                          ],
                          [
                            0.27,
                            -0.17
                          ],
                          [
                            0.5,
                            0
                          ],
                          [
                            0.27,
                            0.34
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.42
                          ],
                          [
                            0.24,
                            0.25
                          ],
                          [
                            0.19,
                            0
                          ],
                          [
                            0.16,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0.11
                          ],
                          [
                            -0.21,
                            0.08
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            18.15,
                            8.73
                          ],
                          [
                            17.19,
                            8.49
                          ],
                          [
                            16.51,
                            7.77
                          ],
                          [
                            16.26,
                            6.67
                          ],
                          [
                            16.51,
                            5.55
                          ],
                          [
                            17.18,
                            4.84
                          ],
                          [
                            18.03,
                            4.59
                          ],
                          [
                            19.19,
                            5.09
                          ],
                          [
                            19.61,
                            6.44
                          ],
                          [
                            19.6,
                            6.65
                          ],
                          [
                            19.58,
                            6.82
                          ],
                          [
                            16.91,
                            6.82
                          ],
                          [
                            17.3,
                            7.82
                          ],
                          [
                            18.23,
                            8.2
                          ],
                          [
                            18.75,
                            8.12
                          ],
                          [
                            19.21,
                            7.89
                          ],
                          [
                            19.45,
                            8.33
                          ],
                          [
                            18.88,
                            8.61
                          ],
                          [
                            18.15,
                            8.73
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.21
                          ],
                          [
                            0.31,
                            0
                          ],
                          [
                            0.22,
                            -0.21
                          ],
                          [
                            0.04,
                            -0.39
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.4
                          ],
                          [
                            -0.17,
                            -0.21
                          ],
                          [
                            -0.27,
                            0
                          ],
                          [
                            -0.22,
                            0.21
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            16.91,
                            6.34
                          ],
                          [
                            19.02,
                            6.34
                          ],
                          [
                            18.76,
                            5.43
                          ],
                          [
                            18.04,
                            5.12
                          ],
                          [
                            17.3,
                            5.44
                          ],
                          [
                            16.91,
                            6.34
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.14
                          ],
                          [
                            -0.22,
                            0
                          ],
                          [
                            -0.12,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.01
                          ],
                          [
                            0.08,
                            0
                          ],
                          [
                            0.18,
                            -0.14
                          ],
                          [
                            0.14,
                            -0.34
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.14,
                            -0.25
                          ],
                          [
                            0.2,
                            -0.15
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.01
                          ],
                          [
                            -0.17,
                            0
                          ],
                          [
                            -0.18,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            20.58,
                            8.64
                          ],
                          [
                            20.58,
                            4.69
                          ],
                          [
                            21.13,
                            4.69
                          ],
                          [
                            21.19,
                            5.4
                          ],
                          [
                            21.21,
                            5.4
                          ],
                          [
                            21.71,
                            4.81
                          ],
                          [
                            22.34,
                            4.59
                          ],
                          [
                            22.76,
                            4.67
                          ],
                          [
                            22.63,
                            5.25
                          ],
                          [
                            22.45,
                            5.21
                          ],
                          [
                            22.25,
                            5.19
                          ],
                          [
                            21.72,
                            5.39
                          ],
                          [
                            21.25,
                            6.1
                          ],
                          [
                            21.25,
                            8.64
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.28,
                            0.16
                          ],
                          [
                            0.16,
                            0.31
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            -0.17,
                            0.31
                          ],
                          [
                            -0.29,
                            0.16
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.18,
                            -0.09
                          ],
                          [
                            -0.14,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0.07
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.19,
                            -0.13
                          ],
                          [
                            0.11,
                            -0.23
                          ],
                          [
                            0,
                            -0.3
                          ],
                          [
                            -0.22,
                            -0.28
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.16,
                            0.07
                          ],
                          [
                            -0.12,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            -0.09
                          ],
                          [
                            0.24,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.35,
                            0
                          ],
                          [
                            -0.28,
                            -0.16
                          ],
                          [
                            -0.16,
                            -0.31
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            0.18,
                            -0.31
                          ],
                          [
                            0.29,
                            -0.16
                          ],
                          [
                            0.26,
                            0
                          ],
                          [
                            0.19,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.11,
                            -0.1
                          ],
                          [
                            -0.12,
                            -0.07
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.19,
                            0.13
                          ],
                          [
                            -0.1,
                            0.23
                          ],
                          [
                            0,
                            0.45
                          ],
                          [
                            0.23,
                            0.28
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0.16,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            0.16
                          ],
                          [
                            -0.22,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            24.88,
                            8.73
                          ],
                          [
                            23.94,
                            8.49
                          ],
                          [
                            23.27,
                            7.78
                          ],
                          [
                            23.03,
                            6.67
                          ],
                          [
                            23.29,
                            5.54
                          ],
                          [
                            23.98,
                            4.83
                          ],
                          [
                            24.93,
                            4.59
                          ],
                          [
                            25.59,
                            4.73
                          ],
                          [
                            26.08,
                            5.05
                          ],
                          [
                            25.74,
                            5.49
                          ],
                          [
                            25.38,
                            5.24
                          ],
                          [
                            24.95,
                            5.14
                          ],
                          [
                            24.31,
                            5.34
                          ],
                          [
                            23.87,
                            5.87
                          ],
                          [
                            23.72,
                            6.67
                          ],
                          [
                            24.05,
                            7.77
                          ],
                          [
                            24.94,
                            8.18
                          ],
                          [
                            25.45,
                            8.07
                          ],
                          [
                            25.86,
                            7.78
                          ],
                          [
                            26.16,
                            8.23
                          ],
                          [
                            25.56,
                            8.6
                          ],
                          [
                            24.88,
                            8.73
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.22,
                            0.2
                          ],
                          [
                            0,
                            0.35
                          ],
                          [
                            -0.39,
                            0.23
                          ],
                          [
                            -0.84,
                            0.09
                          ],
                          [
                            0.05,
                            0.15
                          ],
                          [
                            0.12,
                            0.09
                          ],
                          [
                            0.21,
                            0
                          ],
                          [
                            0.2,
                            -0.09
                          ],
                          [
                            0.16,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.27,
                            0.11
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.21,
                            -0.3
                          ],
                          [
                            0,
                            -0.5
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.22,
                            -0.11
                          ],
                          [
                            0.25,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.33,
                            0
                          ],
                          [
                            -0.21,
                            -0.2
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0.39,
                            -0.23
                          ],
                          [
                            0,
                            -0.17
                          ],
                          [
                            -0.04,
                            -0.15
                          ],
                          [
                            -0.11,
                            -0.09
                          ],
                          [
                            -0.23,
                            0
                          ],
                          [
                            -0.2,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            -0.12
                          ],
                          [
                            0.27,
                            -0.11
                          ],
                          [
                            0.48,
                            0
                          ],
                          [
                            0.22,
                            0.29
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.18,
                            0.15
                          ],
                          [
                            -0.21,
                            0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            27.86,
                            8.73
                          ],
                          [
                            27.03,
                            8.44
                          ],
                          [
                            26.7,
                            7.61
                          ],
                          [
                            27.28,
                            6.62
                          ],
                          [
                            29.13,
                            6.13
                          ],
                          [
                            29.05,
                            5.65
                          ],
                          [
                            28.81,
                            5.29
                          ],
                          [
                            28.31,
                            5.14
                          ],
                          [
                            27.67,
                            5.27
                          ],
                          [
                            27.13,
                            5.56
                          ],
                          [
                            26.88,
                            5.1
                          ],
                          [
                            27.55,
                            4.76
                          ],
                          [
                            28.43,
                            4.59
                          ],
                          [
                            29.47,
                            5.04
                          ],
                          [
                            29.8,
                            6.21
                          ],
                          [
                            29.8,
                            8.64
                          ],
                          [
                            29.25,
                            8.64
                          ],
                          [
                            29.19,
                            8.16
                          ],
                          [
                            29.16,
                            8.16
                          ],
                          [
                            28.55,
                            8.56
                          ],
                          [
                            27.86,
                            8.73
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0.09
                          ],
                          [
                            -0.19,
                            0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.27,
                            -0.16
                          ],
                          [
                            0,
                            -0.25
                          ],
                          [
                            -0.13,
                            -0.1
                          ],
                          [
                            -0.2,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.19,
                            0
                          ],
                          [
                            0.17,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.66,
                            0.08
                          ],
                          [
                            -0.26,
                            0.16
                          ],
                          [
                            0,
                            0.22
                          ],
                          [
                            0.14,
                            0.1
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            28.05,
                            8.2
                          ],
                          [
                            28.59,
                            8.06
                          ],
                          [
                            29.13,
                            7.67
                          ],
                          [
                            29.13,
                            6.57
                          ],
                          [
                            27.74,
                            6.94
                          ],
                          [
                            27.35,
                            7.56
                          ],
                          [
                            27.55,
                            8.05
                          ],
                          [
                            28.05,
                            8.2
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.14
                          ],
                          [
                            -0.22,
                            0
                          ],
                          [
                            -0.12,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.01
                          ],
                          [
                            0.08,
                            0
                          ],
                          [
                            0.18,
                            -0.14
                          ],
                          [
                            0.14,
                            -0.34
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.14,
                            -0.25
                          ],
                          [
                            0.2,
                            -0.15
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.01
                          ],
                          [
                            -0.17,
                            0
                          ],
                          [
                            -0.18,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            31.04,
                            8.64
                          ],
                          [
                            31.04,
                            4.69
                          ],
                          [
                            31.59,
                            4.69
                          ],
                          [
                            31.65,
                            5.4
                          ],
                          [
                            31.68,
                            5.4
                          ],
                          [
                            32.17,
                            4.81
                          ],
                          [
                            32.8,
                            4.59
                          ],
                          [
                            33.22,
                            4.67
                          ],
                          [
                            33.09,
                            5.25
                          ],
                          [
                            32.91,
                            5.21
                          ],
                          [
                            32.71,
                            5.19
                          ],
                          [
                            32.18,
                            5.39
                          ],
                          [
                            31.71,
                            6.1
                          ],
                          [
                            31.71,
                            8.64
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.3,
                            0.36
                          ],
                          [
                            0,
                            0.66
                          ],
                          [
                            -0.16,
                            0.31
                          ],
                          [
                            -0.26,
                            0.17
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.17,
                            -0.08
                          ],
                          [
                            -0.18,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            -0.11
                          ],
                          [
                            0.23,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.49,
                            0
                          ],
                          [
                            -0.3,
                            -0.36
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0.16,
                            -0.31
                          ],
                          [
                            0.26,
                            -0.17
                          ],
                          [
                            0.23,
                            0
                          ],
                          [
                            0.17,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0.15
                          ],
                          [
                            -0.21,
                            0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            35.13,
                            8.73
                          ],
                          [
                            33.94,
                            8.2
                          ],
                          [
                            33.5,
                            6.67
                          ],
                          [
                            33.73,
                            5.56
                          ],
                          [
                            34.37,
                            4.84
                          ],
                          [
                            35.21,
                            4.59
                          ],
                          [
                            35.8,
                            4.71
                          ],
                          [
                            36.32,
                            5.04
                          ],
                          [
                            36.29,
                            4.37
                          ],
                          [
                            36.29,
                            2.85
                          ],
                          [
                            36.96,
                            2.85
                          ],
                          [
                            36.96,
                            8.64
                          ],
                          [
                            36.41,
                            8.64
                          ],
                          [
                            36.35,
                            8.17
                          ],
                          [
                            36.32,
                            8.17
                          ],
                          [
                            35.79,
                            8.57
                          ],
                          [
                            35.13,
                            8.73
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.33,
                            0.36
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0.06
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.18,
                            -0.13
                          ],
                          [
                            0.11,
                            -0.23
                          ],
                          [
                            0,
                            -0.3
                          ],
                          [
                            -0.19,
                            -0.27
                          ],
                          [
                            -0.35,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.34,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            -0.15
                          ],
                          [
                            -0.15,
                            -0.07
                          ],
                          [
                            -0.21,
                            0
                          ],
                          [
                            -0.17,
                            0.13
                          ],
                          [
                            -0.1,
                            0.22
                          ],
                          [
                            0,
                            0.47
                          ],
                          [
                            0.19,
                            0.27
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            35.28,
                            8.17
                          ],
                          [
                            36.29,
                            7.63
                          ],
                          [
                            36.29,
                            5.56
                          ],
                          [
                            35.8,
                            5.25
                          ],
                          [
                            35.32,
                            5.15
                          ],
                          [
                            34.75,
                            5.34
                          ],
                          [
                            34.34,
                            5.87
                          ],
                          [
                            34.19,
                            6.66
                          ],
                          [
                            34.47,
                            7.77
                          ],
                          [
                            35.28,
                            8.17
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.17,
                        0.28,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1733",
    layers: [
      {
        ind: 1732,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                31,
                6
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                62,
                12
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.26,
                            -0.08
                          ],
                          [
                            -0.15,
                            -0.21
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            0.32,
                            -0.24
                          ],
                          [
                            0.51,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.26,
                            0.09
                          ],
                          [
                            0.14,
                            0.2
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.32,
                            0.23
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.64,
                            6.75
                          ],
                          [
                            0.64,
                            2.09
                          ],
                          [
                            1.97,
                            2.09
                          ],
                          [
                            2.89,
                            2.21
                          ],
                          [
                            3.5,
                            2.65
                          ],
                          [
                            3.72,
                            3.46
                          ],
                          [
                            3.24,
                            4.55
                          ],
                          [
                            2,
                            4.9
                          ],
                          [
                            1.23,
                            4.9
                          ],
                          [
                            1.23,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.15
                          ],
                          [
                            0,
                            0.33
                          ],
                          [
                            0.21,
                            0.13
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0.2,
                            -0.16
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            -0.2,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.23,
                            4.42
                          ],
                          [
                            1.93,
                            4.42
                          ],
                          [
                            2.83,
                            4.19
                          ],
                          [
                            3.13,
                            3.46
                          ],
                          [
                            2.82,
                            2.76
                          ],
                          [
                            1.9,
                            2.56
                          ],
                          [
                            1.23,
                            2.56
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0.13
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.11,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.01
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0.12,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            -0.21
                          ],
                          [
                            0.17,
                            -0.13
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.01
                          ],
                          [
                            -0.15,
                            0
                          ],
                          [
                            -0.16,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            4.61,
                            6.75
                          ],
                          [
                            4.61,
                            3.29
                          ],
                          [
                            5.09,
                            3.29
                          ],
                          [
                            5.14,
                            3.92
                          ],
                          [
                            5.16,
                            3.92
                          ],
                          [
                            5.6,
                            3.4
                          ],
                          [
                            6.15,
                            3.21
                          ],
                          [
                            6.52,
                            3.28
                          ],
                          [
                            6.4,
                            3.79
                          ],
                          [
                            6.25,
                            3.75
                          ],
                          [
                            6.07,
                            3.73
                          ],
                          [
                            5.61,
                            3.91
                          ],
                          [
                            5.2,
                            4.53
                          ],
                          [
                            5.2,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.24,
                            0.14
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.24,
                            -0.29
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0,
                            -0.06
                          ],
                          [
                            0.01,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            -0.22
                          ],
                          [
                            -0.33,
                            0
                          ],
                          [
                            -0.14,
                            0.05
                          ],
                          [
                            -0.13,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0.23,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.15,
                            -0.27
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.15,
                            -0.27
                          ],
                          [
                            0.24,
                            -0.15
                          ],
                          [
                            0.44,
                            0
                          ],
                          [
                            0.24,
                            0.29
                          ],
                          [
                            0,
                            0.06
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            0.36
                          ],
                          [
                            0.21,
                            0.22
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0.09
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            8.41,
                            6.84
                          ],
                          [
                            7.57,
                            6.62
                          ],
                          [
                            6.97,
                            6
                          ],
                          [
                            6.75,
                            5.03
                          ],
                          [
                            6.97,
                            4.05
                          ],
                          [
                            7.55,
                            3.43
                          ],
                          [
                            8.3,
                            3.21
                          ],
                          [
                            9.32,
                            3.65
                          ],
                          [
                            9.68,
                            4.83
                          ],
                          [
                            9.68,
                            5.02
                          ],
                          [
                            9.66,
                            5.16
                          ],
                          [
                            7.33,
                            5.16
                          ],
                          [
                            7.67,
                            6.04
                          ],
                          [
                            8.48,
                            6.37
                          ],
                          [
                            8.93,
                            6.29
                          ],
                          [
                            9.34,
                            6.1
                          ],
                          [
                            9.55,
                            6.48
                          ],
                          [
                            9.04,
                            6.73
                          ],
                          [
                            8.41,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.18
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.2,
                            -0.19
                          ],
                          [
                            0.04,
                            -0.34
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.35
                          ],
                          [
                            -0.15,
                            -0.19
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.19,
                            0.18
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.32,
                            4.75
                          ],
                          [
                            9.17,
                            4.75
                          ],
                          [
                            8.94,
                            3.95
                          ],
                          [
                            8.32,
                            3.67
                          ],
                          [
                            7.66,
                            3.96
                          ],
                          [
                            7.32,
                            4.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.28,
                            0.12
                          ],
                          [
                            0.2,
                            0.21
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            -0.11
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.17,
                            0.14
                          ],
                          [
                            0,
                            0.23
                          ],
                          [
                            0.07,
                            0.09
                          ],
                          [
                            0.12,
                            0.07
                          ],
                          [
                            0.15,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.1
                          ],
                          [
                            0.1,
                            0.16
                          ],
                          [
                            0,
                            0.23
                          ],
                          [
                            -0.12,
                            0.18
                          ],
                          [
                            -0.22,
                            0.1
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.23,
                            -0.11
                          ],
                          [
                            -0.16,
                            -0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.07
                          ],
                          [
                            0.22,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0,
                            -0.21
                          ],
                          [
                            -0.07,
                            -0.1
                          ],
                          [
                            -0.12,
                            -0.06
                          ],
                          [
                            -0.12,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            -0.11
                          ],
                          [
                            -0.09,
                            -0.16
                          ],
                          [
                            0,
                            -0.23
                          ],
                          [
                            0.13,
                            -0.2
                          ],
                          [
                            0.24,
                            -0.12
                          ],
                          [
                            0.33,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.28,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0.18
                          ],
                          [
                            0.23,
                            0.11
                          ],
                          [
                            0.31,
                            0
                          ],
                          [
                            0.17,
                            -0.14
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            -0.07,
                            -0.09
                          ],
                          [
                            -0.11,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            -0.06
                          ],
                          [
                            -0.14,
                            -0.1
                          ],
                          [
                            -0.09,
                            -0.16
                          ],
                          [
                            0,
                            -0.24
                          ],
                          [
                            0.13,
                            -0.19
                          ],
                          [
                            0.22,
                            -0.11
                          ],
                          [
                            0.28,
                            0
                          ],
                          [
                            0.24,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            -0.14
                          ],
                          [
                            -0.17,
                            -0.08
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.16,
                            0.13
                          ],
                          [
                            0,
                            0.14
                          ],
                          [
                            0.08,
                            0.09
                          ],
                          [
                            0.12,
                            0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.07
                          ],
                          [
                            0.15,
                            0.1
                          ],
                          [
                            0.08,
                            0.15
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            -0.13,
                            0.2
                          ],
                          [
                            -0.24,
                            0.12
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            13.31,
                            6.84
                          ],
                          [
                            12.4,
                            6.65
                          ],
                          [
                            11.68,
                            6.14
                          ],
                          [
                            12.03,
                            5.73
                          ],
                          [
                            12.61,
                            6.16
                          ],
                          [
                            13.32,
                            6.32
                          ],
                          [
                            14.04,
                            6.11
                          ],
                          [
                            14.29,
                            5.55
                          ],
                          [
                            14.18,
                            5.17
                          ],
                          [
                            13.91,
                            4.93
                          ],
                          [
                            13.52,
                            4.73
                          ],
                          [
                            12.85,
                            4.44
                          ],
                          [
                            12.41,
                            4.2
                          ],
                          [
                            12.04,
                            3.81
                          ],
                          [
                            11.9,
                            3.24
                          ],
                          [
                            12.09,
                            2.61
                          ],
                          [
                            12.61,
                            2.16
                          ],
                          [
                            13.37,
                            2
                          ],
                          [
                            14.14,
                            2.16
                          ],
                          [
                            14.75,
                            2.57
                          ],
                          [
                            14.43,
                            2.96
                          ],
                          [
                            13.95,
                            2.64
                          ],
                          [
                            13.37,
                            2.52
                          ],
                          [
                            12.73,
                            2.7
                          ],
                          [
                            12.5,
                            3.2
                          ],
                          [
                            12.61,
                            3.57
                          ],
                          [
                            12.91,
                            3.8
                          ],
                          [
                            13.27,
                            3.98
                          ],
                          [
                            13.94,
                            4.26
                          ],
                          [
                            14.42,
                            4.54
                          ],
                          [
                            14.77,
                            4.93
                          ],
                          [
                            14.89,
                            5.5
                          ],
                          [
                            14.7,
                            6.18
                          ],
                          [
                            14.16,
                            6.66
                          ],
                          [
                            13.31,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.25,
                            0.14
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.16,
                            -0.08
                          ],
                          [
                            -0.12,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            0.06
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0.17,
                            -0.11
                          ],
                          [
                            0.09,
                            -0.2
                          ],
                          [
                            0,
                            -0.27
                          ],
                          [
                            -0.2,
                            -0.25
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.14,
                            0.07
                          ],
                          [
                            -0.11,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.08
                          ],
                          [
                            0.21,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.14,
                            -0.27
                          ],
                          [
                            0,
                            -0.39
                          ],
                          [
                            0.16,
                            -0.27
                          ],
                          [
                            0.26,
                            -0.14
                          ],
                          [
                            0.23,
                            0
                          ],
                          [
                            0.16,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.1,
                            -0.09
                          ],
                          [
                            -0.11,
                            -0.06
                          ],
                          [
                            -0.21,
                            0
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            -0.09,
                            0.2
                          ],
                          [
                            0,
                            0.39
                          ],
                          [
                            0.2,
                            0.24
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.14
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.13,
                            6.84
                          ],
                          [
                            16.3,
                            6.62
                          ],
                          [
                            15.71,
                            6
                          ],
                          [
                            15.5,
                            5.03
                          ],
                          [
                            15.73,
                            4.04
                          ],
                          [
                            16.34,
                            3.42
                          ],
                          [
                            17.17,
                            3.21
                          ],
                          [
                            17.75,
                            3.33
                          ],
                          [
                            18.18,
                            3.61
                          ],
                          [
                            17.88,
                            4
                          ],
                          [
                            17.56,
                            3.78
                          ],
                          [
                            17.19,
                            3.69
                          ],
                          [
                            16.63,
                            3.86
                          ],
                          [
                            16.24,
                            4.33
                          ],
                          [
                            16.11,
                            5.03
                          ],
                          [
                            16.4,
                            5.99
                          ],
                          [
                            17.17,
                            6.35
                          ],
                          [
                            17.62,
                            6.25
                          ],
                          [
                            17.98,
                            6
                          ],
                          [
                            18.24,
                            6.39
                          ],
                          [
                            17.72,
                            6.72
                          ],
                          [
                            17.13,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.17
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            -0.34,
                            0.2
                          ],
                          [
                            -0.73,
                            0.08
                          ],
                          [
                            0.04,
                            0.13
                          ],
                          [
                            0.11,
                            0.08
                          ],
                          [
                            0.19,
                            0
                          ],
                          [
                            0.17,
                            -0.07
                          ],
                          [
                            0.14,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.23,
                            0.09
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.19,
                            -0.26
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            -0.1
                          ],
                          [
                            0.22,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.19,
                            -0.18
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.34,
                            -0.2
                          ],
                          [
                            0,
                            -0.14
                          ],
                          [
                            -0.04,
                            -0.13
                          ],
                          [
                            -0.1,
                            -0.09
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.18,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.11
                          ],
                          [
                            0.24,
                            -0.1
                          ],
                          [
                            0.42,
                            0
                          ],
                          [
                            0.19,
                            0.26
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.13
                          ],
                          [
                            -0.19,
                            0.1
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            19.73,
                            6.84
                          ],
                          [
                            19,
                            6.58
                          ],
                          [
                            18.72,
                            5.86
                          ],
                          [
                            19.22,
                            4.98
                          ],
                          [
                            20.84,
                            4.56
                          ],
                          [
                            20.77,
                            4.14
                          ],
                          [
                            20.56,
                            3.82
                          ],
                          [
                            20.13,
                            3.69
                          ],
                          [
                            19.57,
                            3.8
                          ],
                          [
                            19.09,
                            4.06
                          ],
                          [
                            18.87,
                            3.66
                          ],
                          [
                            19.46,
                            3.36
                          ],
                          [
                            20.23,
                            3.21
                          ],
                          [
                            21.14,
                            3.6
                          ],
                          [
                            21.43,
                            4.63
                          ],
                          [
                            21.43,
                            6.75
                          ],
                          [
                            20.95,
                            6.75
                          ],
                          [
                            20.89,
                            6.34
                          ],
                          [
                            20.88,
                            6.34
                          ],
                          [
                            20.34,
                            6.69
                          ],
                          [
                            19.73,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            0.08
                          ],
                          [
                            -0.16,
                            0.15
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            -0.14
                          ],
                          [
                            0,
                            -0.22
                          ],
                          [
                            -0.12,
                            -0.09
                          ],
                          [
                            -0.17,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.17,
                            0
                          ],
                          [
                            0.15,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.57,
                            0.07
                          ],
                          [
                            -0.23,
                            0.14
                          ],
                          [
                            0,
                            0.19
                          ],
                          [
                            0.12,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            19.9,
                            6.37
                          ],
                          [
                            20.37,
                            6.25
                          ],
                          [
                            20.84,
                            5.9
                          ],
                          [
                            20.84,
                            4.95
                          ],
                          [
                            19.63,
                            5.26
                          ],
                          [
                            19.29,
                            5.81
                          ],
                          [
                            19.46,
                            6.24
                          ],
                          [
                            19.9,
                            6.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0.13
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.04
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            -0.04,
                            0.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.01
                          ],
                          [
                            0.08,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.21,
                            0
                          ],
                          [
                            -0.09,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            0.03,
                            0.04
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.02
                          ],
                          [
                            -0.05,
                            0.01
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            23.13,
                            6.84
                          ],
                          [
                            22.66,
                            6.64
                          ],
                          [
                            22.52,
                            6.05
                          ],
                          [
                            22.52,
                            1.69
                          ],
                          [
                            23.1,
                            1.69
                          ],
                          [
                            23.1,
                            6.1
                          ],
                          [
                            23.15,
                            6.29
                          ],
                          [
                            23.26,
                            6.35
                          ],
                          [
                            23.31,
                            6.35
                          ],
                          [
                            23.39,
                            6.34
                          ],
                          [
                            23.47,
                            6.78
                          ],
                          [
                            23.33,
                            6.82
                          ],
                          [
                            23.13,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.24,
                            0.14
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.24,
                            -0.29
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0,
                            -0.06
                          ],
                          [
                            0.01,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            -0.22
                          ],
                          [
                            -0.33,
                            0
                          ],
                          [
                            -0.14,
                            0.05
                          ],
                          [
                            -0.13,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0.23,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.15,
                            -0.27
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.15,
                            -0.27
                          ],
                          [
                            0.24,
                            -0.15
                          ],
                          [
                            0.44,
                            0
                          ],
                          [
                            0.24,
                            0.29
                          ],
                          [
                            0,
                            0.06
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            0.36
                          ],
                          [
                            0.21,
                            0.22
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0.09
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.73,
                            6.84
                          ],
                          [
                            24.89,
                            6.62
                          ],
                          [
                            24.29,
                            6
                          ],
                          [
                            24.07,
                            5.03
                          ],
                          [
                            24.29,
                            4.05
                          ],
                          [
                            24.88,
                            3.43
                          ],
                          [
                            25.62,
                            3.21
                          ],
                          [
                            26.64,
                            3.65
                          ],
                          [
                            27,
                            4.83
                          ],
                          [
                            27,
                            5.02
                          ],
                          [
                            26.98,
                            5.16
                          ],
                          [
                            24.65,
                            5.16
                          ],
                          [
                            24.99,
                            6.04
                          ],
                          [
                            25.8,
                            6.37
                          ],
                          [
                            26.25,
                            6.29
                          ],
                          [
                            26.66,
                            6.1
                          ],
                          [
                            26.87,
                            6.48
                          ],
                          [
                            26.36,
                            6.73
                          ],
                          [
                            25.73,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.18
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.2,
                            -0.19
                          ],
                          [
                            0.04,
                            -0.34
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.35
                          ],
                          [
                            -0.14,
                            -0.19
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.19,
                            0.18
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            24.64,
                            4.75
                          ],
                          [
                            26.49,
                            4.75
                          ],
                          [
                            26.26,
                            3.95
                          ],
                          [
                            25.64,
                            3.67
                          ],
                          [
                            24.98,
                            3.96
                          ],
                          [
                            24.64,
                            4.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0.13
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.11,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.01
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0.12,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            -0.21
                          ],
                          [
                            0.17,
                            -0.13
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.01
                          ],
                          [
                            -0.14,
                            0
                          ],
                          [
                            -0.16,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            27.86,
                            6.75
                          ],
                          [
                            27.86,
                            3.29
                          ],
                          [
                            28.34,
                            3.29
                          ],
                          [
                            28.39,
                            3.92
                          ],
                          [
                            28.41,
                            3.92
                          ],
                          [
                            28.84,
                            3.4
                          ],
                          [
                            29.39,
                            3.21
                          ],
                          [
                            29.76,
                            3.28
                          ],
                          [
                            29.65,
                            3.79
                          ],
                          [
                            29.49,
                            3.75
                          ],
                          [
                            29.31,
                            3.73
                          ],
                          [
                            28.85,
                            3.91
                          ],
                          [
                            28.44,
                            4.53
                          ],
                          [
                            28.44,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.49,
                        0.55,
                        0.65,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1757",
    layers: [
      {
        ind: 1756,
        ty: 2,
        parent: 1755,
        ks: {
          s: {
            a: 0,
            k: [
              170,
              181.82
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "0"
      },
      {
        ind: 1755,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1760",
    layers: [
      {
        ind: 1759,
        ty: 0,
        parent: 1754,
        ks: {},
        w: 8.5,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1757"
      },
      {
        ind: 1754,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1780",
    layers: [
      {
        ind: 1779,
        ty: 2,
        parent: 1778,
        ks: {
          s: {
            a: 0,
            k: [
              181.82,
              180
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "1"
      },
      {
        ind: 1778,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1783",
    layers: [
      {
        ind: 1782,
        ty: 0,
        parent: 1777,
        ks: {},
        w: 10,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1780"
      },
      {
        ind: 1777,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1814",
    layers: [
      {
        ind: 1813,
        ty: 2,
        parent: 1812,
        ks: {
          s: {
            a: 0,
            k: [
              181.25,
              183.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "12"
      },
      {
        ind: 1812,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1817",
    layers: [
      {
        ind: 1816,
        ty: 0,
        parent: 1811,
        ks: {},
        w: 14.5,
        h: 16.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1814"
      },
      {
        ind: 1811,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1828",
    layers: [
      {
        ind: 1827,
        ty: 2,
        parent: 1826,
        ks: {
          s: {
            a: 0,
            k: [
              184.38,
              185.71
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "13"
      },
      {
        ind: 1826,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1831",
    layers: [
      {
        ind: 1830,
        ty: 0,
        parent: 1825,
        ks: {},
        w: 59,
        h: 58.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1828"
      },
      {
        ind: 1825,
        ty: 3,
        parent: 1824,
        ks: {
          p: {
            a: 0,
            k: [
              -6,
              -3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1824,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              7,
              3
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1835",
    layers: [
      {
        ind: 1834,
        ty: 4,
        td: 1,
        parent: 1823,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                24.383,
                24.383
              ]
            },
            r: {
              a: 0,
              k: 24
            },
            s: {
              a: 0,
              k: [
                48.766,
                48.766
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 1833,
        ty: 0,
        tt: 1,
        parent: 1823,
        ks: {
          a: {
            a: 0,
            k: [
              7,
              3
            ]
          }
        },
        w: 66,
        h: 62,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1831"
      },
      {
        ind: 1823,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              5.418,
              5.418
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1903",
    layers: [
      {
        ind: 1902,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                5.5,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                11,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.02
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0.05,
                            0.02
                          ],
                          [
                            0.04,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.02
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            -0.04,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.1
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.04
                          ],
                          [
                            -0.05,
                            0.02
                          ],
                          [
                            -0.05,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            -0.04
                          ],
                          [
                            0.05,
                            -0.02
                          ],
                          [
                            0.05,
                            0
                          ],
                          [
                            0.05,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.1,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.1
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.75,
                            1.03
                          ],
                          [
                            7.75,
                            3.06
                          ],
                          [
                            7.64,
                            3.33
                          ],
                          [
                            7.37,
                            3.44
                          ],
                          [
                            7.1,
                            3.33
                          ],
                          [
                            6.98,
                            3.06
                          ],
                          [
                            6.98,
                            1.95
                          ],
                          [
                            4.59,
                            4.34
                          ],
                          [
                            4.46,
                            4.43
                          ],
                          [
                            4.32,
                            4.46
                          ],
                          [
                            4.17,
                            4.43
                          ],
                          [
                            4.05,
                            4.34
                          ],
                          [
                            3.05,
                            3.34
                          ],
                          [
                            1.03,
                            5.36
                          ],
                          [
                            0.76,
                            5.47
                          ],
                          [
                            0.49,
                            5.36
                          ],
                          [
                            0.38,
                            5.09
                          ],
                          [
                            0.49,
                            4.82
                          ],
                          [
                            2.78,
                            2.54
                          ],
                          [
                            2.9,
                            2.45
                          ],
                          [
                            3.05,
                            2.42
                          ],
                          [
                            3.2,
                            2.45
                          ],
                          [
                            3.32,
                            2.54
                          ],
                          [
                            4.32,
                            3.54
                          ],
                          [
                            6.45,
                            1.41
                          ],
                          [
                            5.34,
                            1.41
                          ],
                          [
                            5.07,
                            1.3
                          ],
                          [
                            4.95,
                            1.03
                          ],
                          [
                            5.07,
                            0.76
                          ],
                          [
                            5.34,
                            0.64
                          ],
                          [
                            7.37,
                            0.64
                          ],
                          [
                            7.64,
                            0.76
                          ],
                          [
                            7.75,
                            1.03
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.52,
                        0.32,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1906",
    layers: [
      {
        ind: 1905,
        ty: 0,
        parent: 1901,
        ks: {},
        w: 11,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1903"
      },
      {
        ind: 1901,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1914",
    layers: [
      {
        ind: 1913,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2.5,
                2.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                5,
                5
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.16,
                            0.16
                          ],
                          [
                            3.69,
                            0.16
                          ],
                          [
                            3.69,
                            3.69
                          ],
                          [
                            0.16,
                            3.69
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        1,
                        0.73,
                        0,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1919",
    layers: [
      {
        ind: 1918,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2.5,
                2.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                5,
                5
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0,
                            0.16
                          ],
                          [
                            3.54,
                            0.16
                          ],
                          [
                            3.54,
                            3.69
                          ],
                          [
                            0,
                            3.69
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0,
                        0.64,
                        0.94,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1924",
    layers: [
      {
        ind: 1923,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2.5,
                2.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                5,
                5
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.16,
                            0
                          ],
                          [
                            3.69,
                            0
                          ],
                          [
                            3.69,
                            3.54
                          ],
                          [
                            0.16,
                            3.54
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.5,
                        0.73,
                        0,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1929",
    layers: [
      {
        ind: 1928,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                2.5,
                2.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                5,
                5
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0,
                            0
                          ],
                          [
                            3.54,
                            0
                          ],
                          [
                            3.54,
                            3.54
                          ],
                          [
                            0,
                            3.54
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.95,
                        0.31,
                        0.13,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1934",
    layers: [
      {
        ind: 1933,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                17.5,
                4
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                35,
                8
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            0.24
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            0.25
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.03,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.03,
                            0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.01,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.17
                          ],
                          [
                            0,
                            -0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.04,
                            0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            0.33
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            3.3,
                            3.54
                          ],
                          [
                            3.09,
                            4.13
                          ],
                          [
                            3.07,
                            4.13
                          ],
                          [
                            2.87,
                            3.55
                          ],
                          [
                            1.76,
                            0.75
                          ],
                          [
                            0.67,
                            0.75
                          ],
                          [
                            0.67,
                            5.21
                          ],
                          [
                            1.39,
                            5.21
                          ],
                          [
                            1.39,
                            2.46
                          ],
                          [
                            1.38,
                            1.84
                          ],
                          [
                            1.36,
                            1.56
                          ],
                          [
                            1.38,
                            1.56
                          ],
                          [
                            1.48,
                            1.95
                          ],
                          [
                            2.82,
                            5.2
                          ],
                          [
                            3.33,
                            5.2
                          ],
                          [
                            4.66,
                            1.91
                          ],
                          [
                            4.74,
                            1.56
                          ],
                          [
                            4.76,
                            1.56
                          ],
                          [
                            4.72,
                            2.36
                          ],
                          [
                            4.72,
                            5.19
                          ],
                          [
                            5.49,
                            5.19
                          ],
                          [
                            5.49,
                            0.74
                          ],
                          [
                            4.44,
                            0.74
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            6.22,
                            2
                          ],
                          [
                            6.97,
                            2
                          ],
                          [
                            6.97,
                            5.19
                          ],
                          [
                            6.22,
                            5.19
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            -0.08
                          ],
                          [
                            0,
                            -0.13
                          ],
                          [
                            -0.09,
                            -0.08
                          ],
                          [
                            -0.12,
                            0
                          ],
                          [
                            -0.08,
                            0.07
                          ],
                          [
                            0,
                            0.12
                          ],
                          [
                            0.09,
                            0.09
                          ],
                          [
                            0.13,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.12,
                            0
                          ],
                          [
                            -0.09,
                            0.08
                          ],
                          [
                            0,
                            0.12
                          ],
                          [
                            0.09,
                            0.08
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.09,
                            -0.08
                          ],
                          [
                            0,
                            -0.12
                          ],
                          [
                            -0.07,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            6.6,
                            0.64
                          ],
                          [
                            6.28,
                            0.77
                          ],
                          [
                            6.15,
                            1.09
                          ],
                          [
                            6.28,
                            1.39
                          ],
                          [
                            6.6,
                            1.51
                          ],
                          [
                            6.91,
                            1.39
                          ],
                          [
                            7.05,
                            1.09
                          ],
                          [
                            6.91,
                            0.77
                          ],
                          [
                            6.6,
                            0.64
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0.26,
                            -0.15
                          ],
                          [
                            0.13,
                            -0.26
                          ],
                          [
                            0,
                            -0.36
                          ],
                          [
                            -0.13,
                            -0.25
                          ],
                          [
                            -0.25,
                            -0.13
                          ],
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.24,
                            0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            -0.04
                          ],
                          [
                            0.11,
                            0
                          ],
                          [
                            0.17,
                            0.19
                          ],
                          [
                            0,
                            0.32
                          ],
                          [
                            -0.18,
                            0.19
                          ],
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.23,
                            -0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.03
                          ]
                        ],
                        o: [
                          [
                            -0.14,
                            -0.03
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.26,
                            0.15
                          ],
                          [
                            -0.14,
                            0.27
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            0.13,
                            0.24
                          ],
                          [
                            0.24,
                            0.13
                          ],
                          [
                            0.36,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.11,
                            0.08
                          ],
                          [
                            -0.13,
                            0.05
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.17,
                            -0.19
                          ],
                          [
                            0,
                            -0.33
                          ],
                          [
                            0.18,
                            -0.19
                          ],
                          [
                            0.24,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.1,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            9.63,
                            1.97
                          ],
                          [
                            9.21,
                            1.92
                          ],
                          [
                            8.29,
                            2.14
                          ],
                          [
                            7.7,
                            2.76
                          ],
                          [
                            7.49,
                            3.69
                          ],
                          [
                            7.69,
                            4.51
                          ],
                          [
                            8.25,
                            5.08
                          ],
                          [
                            9.08,
                            5.28
                          ],
                          [
                            9.98,
                            5.07
                          ],
                          [
                            9.99,
                            5.06
                          ],
                          [
                            9.99,
                            4.37
                          ],
                          [
                            9.96,
                            4.39
                          ],
                          [
                            9.6,
                            4.59
                          ],
                          [
                            9.24,
                            4.66
                          ],
                          [
                            8.54,
                            4.38
                          ],
                          [
                            8.28,
                            3.62
                          ],
                          [
                            8.54,
                            2.84
                          ],
                          [
                            9.25,
                            2.55
                          ],
                          [
                            9.96,
                            2.8
                          ],
                          [
                            9.99,
                            2.82
                          ],
                          [
                            9.99,
                            2.09
                          ],
                          [
                            9.98,
                            2.08
                          ],
                          [
                            9.63,
                            1.97
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            -0.12
                          ],
                          [
                            0.07,
                            -0.18
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.13,
                            0.17
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.09,
                            -0.01
                          ],
                          [
                            -0.04,
                            -0.03
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.13,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.18,
                            0
                          ],
                          [
                            -0.13,
                            0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.28
                          ],
                          [
                            0.13,
                            -0.17
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.08,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            12.1,
                            1.95
                          ],
                          [
                            11.59,
                            2.12
                          ],
                          [
                            11.3,
                            2.55
                          ],
                          [
                            11.3,
                            2.55
                          ],
                          [
                            11.3,
                            2
                          ],
                          [
                            10.55,
                            2
                          ],
                          [
                            10.55,
                            5.19
                          ],
                          [
                            11.3,
                            5.19
                          ],
                          [
                            11.3,
                            3.56
                          ],
                          [
                            11.48,
                            2.88
                          ],
                          [
                            11.97,
                            2.63
                          ],
                          [
                            12.19,
                            2.65
                          ],
                          [
                            12.37,
                            2.73
                          ],
                          [
                            12.4,
                            2.75
                          ],
                          [
                            12.4,
                            2
                          ],
                          [
                            12.38,
                            2
                          ],
                          [
                            12.1,
                            1.95
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.29,
                            -0.3
                          ],
                          [
                            0,
                            -0.53
                          ],
                          [
                            -0.29,
                            -0.29
                          ],
                          [
                            -0.49,
                            0
                          ],
                          [
                            -0.29,
                            0.31
                          ],
                          [
                            0,
                            0.51
                          ],
                          [
                            0.28,
                            0.3
                          ],
                          [
                            0.49,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.53,
                            0
                          ],
                          [
                            -0.3,
                            0.31
                          ],
                          [
                            0,
                            0.5
                          ],
                          [
                            0.29,
                            0.29
                          ],
                          [
                            0.52,
                            0
                          ],
                          [
                            0.3,
                            -0.31
                          ],
                          [
                            0,
                            -0.51
                          ],
                          [
                            -0.27,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            14.14,
                            1.93
                          ],
                          [
                            12.9,
                            2.39
                          ],
                          [
                            12.46,
                            3.64
                          ],
                          [
                            12.9,
                            4.84
                          ],
                          [
                            14.07,
                            5.28
                          ],
                          [
                            15.29,
                            4.81
                          ],
                          [
                            15.73,
                            3.57
                          ],
                          [
                            15.31,
                            2.36
                          ],
                          [
                            14.14,
                            1.93
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.16,
                            0.19
                          ],
                          [
                            0,
                            0.33
                          ],
                          [
                            -0.15,
                            0.18
                          ],
                          [
                            -0.27,
                            0
                          ],
                          [
                            -0.15,
                            -0.18
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            0.14,
                            -0.18
                          ]
                        ],
                        o: [
                          [
                            -0.14,
                            0.18
                          ],
                          [
                            -0.27,
                            0
                          ],
                          [
                            -0.16,
                            -0.18
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            0.16,
                            -0.18
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.15,
                            0.18
                          ],
                          [
                            -0.01,
                            0.35
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            14.74,
                            4.38
                          ],
                          [
                            14.11,
                            4.65
                          ],
                          [
                            13.47,
                            4.37
                          ],
                          [
                            13.24,
                            3.61
                          ],
                          [
                            13.47,
                            2.82
                          ],
                          [
                            14.11,
                            2.54
                          ],
                          [
                            14.73,
                            2.81
                          ],
                          [
                            14.96,
                            3.59
                          ],
                          [
                            14.74,
                            4.38
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.06
                          ],
                          [
                            0,
                            0.11
                          ],
                          [
                            -0.09,
                            0.06
                          ],
                          [
                            -0.14,
                            0
                          ],
                          [
                            -0.12,
                            -0.03
                          ],
                          [
                            -0.09,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.14,
                            0.03
                          ],
                          [
                            0.11,
                            0
                          ],
                          [
                            0.23,
                            -0.19
                          ],
                          [
                            0,
                            -0.29
                          ],
                          [
                            -0.05,
                            -0.11
                          ],
                          [
                            -0.1,
                            -0.09
                          ],
                          [
                            -0.21,
                            -0.09
                          ],
                          [
                            -0.08,
                            -0.05
                          ],
                          [
                            -0.04,
                            -0.04
                          ],
                          [
                            0,
                            -0.07
                          ],
                          [
                            0.33,
                            0
                          ],
                          [
                            0.15,
                            0.05
                          ],
                          [
                            0.12,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            -0.04
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.23,
                            0.19
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            0.13,
                            0.14
                          ],
                          [
                            0.3,
                            0.12
                          ]
                        ],
                        o: [
                          [
                            -0.24,
                            -0.1
                          ],
                          [
                            -0.06,
                            -0.06
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0.09,
                            -0.06
                          ],
                          [
                            0.13,
                            0
                          ],
                          [
                            0.13,
                            0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            -0.04
                          ],
                          [
                            -0.14,
                            -0.02
                          ],
                          [
                            -0.36,
                            0
                          ],
                          [
                            -0.23,
                            0.18
                          ],
                          [
                            0,
                            0.15
                          ],
                          [
                            0.05,
                            0.11
                          ],
                          [
                            0.11,
                            0.08
                          ],
                          [
                            0.18,
                            0.08
                          ],
                          [
                            0.08,
                            0.05
                          ],
                          [
                            0.03,
                            0.04
                          ],
                          [
                            0,
                            0.21
                          ],
                          [
                            -0.13,
                            0
                          ],
                          [
                            -0.16,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            0.05
                          ],
                          [
                            0.16,
                            0.03
                          ],
                          [
                            0.39,
                            0
                          ],
                          [
                            0.23,
                            -0.19
                          ],
                          [
                            0,
                            -0.21
                          ],
                          [
                            -0.16,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.4,
                            3.32
                          ],
                          [
                            16.95,
                            3.09
                          ],
                          [
                            16.86,
                            2.84
                          ],
                          [
                            16.98,
                            2.61
                          ],
                          [
                            17.31,
                            2.53
                          ],
                          [
                            17.7,
                            2.58
                          ],
                          [
                            18.03,
                            2.74
                          ],
                          [
                            18.06,
                            2.76
                          ],
                          [
                            18.06,
                            2.06
                          ],
                          [
                            18.04,
                            2.05
                          ],
                          [
                            17.7,
                            1.96
                          ],
                          [
                            17.33,
                            1.92
                          ],
                          [
                            16.45,
                            2.2
                          ],
                          [
                            16.11,
                            2.9
                          ],
                          [
                            16.18,
                            3.29
                          ],
                          [
                            16.41,
                            3.59
                          ],
                          [
                            16.88,
                            3.85
                          ],
                          [
                            17.26,
                            4.03
                          ],
                          [
                            17.44,
                            4.17
                          ],
                          [
                            17.48,
                            4.35
                          ],
                          [
                            16.99,
                            4.67
                          ],
                          [
                            16.58,
                            4.59
                          ],
                          [
                            16.16,
                            4.38
                          ],
                          [
                            16.13,
                            4.36
                          ],
                          [
                            16.13,
                            5.09
                          ],
                          [
                            16.14,
                            5.09
                          ],
                          [
                            16.55,
                            5.22
                          ],
                          [
                            16.98,
                            5.27
                          ],
                          [
                            17.91,
                            5
                          ],
                          [
                            18.26,
                            4.27
                          ],
                          [
                            18.07,
                            3.72
                          ],
                          [
                            17.4,
                            3.32
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.29,
                            -0.3
                          ],
                          [
                            0,
                            -0.53
                          ],
                          [
                            -0.29,
                            -0.29
                          ],
                          [
                            -0.49,
                            0
                          ],
                          [
                            -0.3,
                            0.31
                          ],
                          [
                            0,
                            0.51
                          ],
                          [
                            0.29,
                            0.3
                          ],
                          [
                            0.5,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.52,
                            0
                          ],
                          [
                            -0.3,
                            0.31
                          ],
                          [
                            0,
                            0.5
                          ],
                          [
                            0.29,
                            0.29
                          ],
                          [
                            0.51,
                            0
                          ],
                          [
                            0.3,
                            -0.31
                          ],
                          [
                            0,
                            -0.51
                          ],
                          [
                            -0.27,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            20.24,
                            1.93
                          ],
                          [
                            19,
                            2.39
                          ],
                          [
                            18.55,
                            3.64
                          ],
                          [
                            18.99,
                            4.84
                          ],
                          [
                            20.16,
                            5.28
                          ],
                          [
                            21.38,
                            4.81
                          ],
                          [
                            21.82,
                            3.57
                          ],
                          [
                            21.4,
                            2.36
                          ],
                          [
                            20.24,
                            1.93
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.16,
                            0.19
                          ],
                          [
                            0,
                            0.33
                          ],
                          [
                            -0.15,
                            0.18
                          ],
                          [
                            -0.27,
                            0
                          ],
                          [
                            -0.15,
                            -0.18
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            0.14,
                            -0.18
                          ]
                        ],
                        o: [
                          [
                            -0.14,
                            0.18
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.16,
                            -0.18
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            0.16,
                            -0.18
                          ],
                          [
                            0.26,
                            0
                          ],
                          [
                            0.15,
                            0.18
                          ],
                          [
                            0,
                            0.35
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            20.83,
                            4.38
                          ],
                          [
                            20.2,
                            4.65
                          ],
                          [
                            19.56,
                            4.37
                          ],
                          [
                            19.33,
                            3.61
                          ],
                          [
                            19.56,
                            2.82
                          ],
                          [
                            20.2,
                            2.54
                          ],
                          [
                            20.82,
                            2.81
                          ],
                          [
                            21.05,
                            3.59
                          ],
                          [
                            20.83,
                            4.38
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.08,
                            0.09
                          ],
                          [
                            -0.15,
                            0
                          ],
                          [
                            -0.12,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0
                          ],
                          [
                            0.18,
                            -0.09
                          ],
                          [
                            0.1,
                            -0.18
                          ],
                          [
                            0,
                            -0.22
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.63,
                            0
                          ],
                          [
                            -0.1,
                            0.02
                          ],
                          [
                            -0.05,
                            0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            -0.02
                          ],
                          [
                            0.04,
                            0
                          ],
                          [
                            0.07,
                            0.09
                          ],
                          [
                            0,
                            0.2
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.19
                          ],
                          [
                            0.08,
                            -0.09
                          ],
                          [
                            0.1,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.1,
                            -0.04
                          ],
                          [
                            -0.23,
                            0
                          ],
                          [
                            -0.18,
                            0.1
                          ],
                          [
                            -0.1,
                            0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.67
                          ],
                          [
                            0.11,
                            0
                          ],
                          [
                            0.11,
                            -0.02
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            0.03
                          ],
                          [
                            -0.06,
                            0.02
                          ],
                          [
                            -0.15,
                            0
                          ],
                          [
                            -0.07,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.83,
                            2.61
                          ],
                          [
                            25.83,
                            2
                          ],
                          [
                            25.08,
                            2
                          ],
                          [
                            25.08,
                            1.05
                          ],
                          [
                            25.05,
                            1.05
                          ],
                          [
                            24.34,
                            1.27
                          ],
                          [
                            24.32,
                            1.27
                          ],
                          [
                            24.32,
                            2
                          ],
                          [
                            23.19,
                            2
                          ],
                          [
                            23.19,
                            1.59
                          ],
                          [
                            23.32,
                            1.17
                          ],
                          [
                            23.67,
                            1.03
                          ],
                          [
                            24,
                            1.11
                          ],
                          [
                            24.04,
                            1.13
                          ],
                          [
                            24.04,
                            0.47
                          ],
                          [
                            24.02,
                            0.47
                          ],
                          [
                            23.6,
                            0.41
                          ],
                          [
                            23,
                            0.55
                          ],
                          [
                            22.59,
                            0.96
                          ],
                          [
                            22.44,
                            1.55
                          ],
                          [
                            22.44,
                            2
                          ],
                          [
                            21.91,
                            2
                          ],
                          [
                            21.91,
                            2.61
                          ],
                          [
                            22.44,
                            2.61
                          ],
                          [
                            22.44,
                            5.19
                          ],
                          [
                            23.19,
                            5.19
                          ],
                          [
                            23.19,
                            2.61
                          ],
                          [
                            24.32,
                            2.61
                          ],
                          [
                            24.32,
                            4.26
                          ],
                          [
                            25.27,
                            5.27
                          ],
                          [
                            25.59,
                            5.24
                          ],
                          [
                            25.83,
                            5.16
                          ],
                          [
                            25.83,
                            5.16
                          ],
                          [
                            25.83,
                            4.54
                          ],
                          [
                            25.8,
                            4.56
                          ],
                          [
                            25.65,
                            4.63
                          ],
                          [
                            25.5,
                            4.66
                          ],
                          [
                            25.17,
                            4.54
                          ],
                          [
                            25.07,
                            4.13
                          ],
                          [
                            25.07,
                            2.61
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.45,
                        0.45,
                        0.45,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1937",
    layers: [
      {
        ind: 1916,
        ty: 0,
        parent: 1912,
        ks: {},
        w: 5,
        h: 5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1914"
      },
      {
        ind: 1912,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              5,
              5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1921,
        ty: 0,
        parent: 1917,
        ks: {},
        w: 5,
        h: 5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1919"
      },
      {
        ind: 1917,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1926,
        ty: 0,
        parent: 1922,
        ks: {},
        w: 5,
        h: 5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1924"
      },
      {
        ind: 1922,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              5,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1931,
        ty: 0,
        parent: 1927,
        ks: {},
        w: 5,
        h: 5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1929"
      },
      {
        ind: 1927,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 1936,
        ty: 0,
        parent: 1932,
        ks: {},
        w: 35,
        h: 8,
        ip: 0,
        op: 565,
        st: 0,
        refId: "1934"
      },
      {
        ind: 1932,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              12,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "1967",
    layers: [
      {
        ind: 1966,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                9,
                5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                18,
                10
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.07,
                            0.07
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.02,
                            -0.04
                          ],
                          [
                            0,
                            -0.05
                          ],
                          [
                            0.02,
                            -0.04
                          ],
                          [
                            0.03,
                            -0.03
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            0.07
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.09,
                            0
                          ],
                          [
                            -0.07,
                            -0.06
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.07,
                            -0.07
                          ],
                          [
                            0,
                            -0.09
                          ],
                          [
                            0.07,
                            -0.07
                          ],
                          [
                            0.09,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.03
                          ],
                          [
                            0.02,
                            0.04
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            -0.02,
                            0.04
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            13.25,
                            3.77
                          ],
                          [
                            10.08,
                            6.93
                          ],
                          [
                            9.83,
                            7.04
                          ],
                          [
                            9.59,
                            6.93
                          ],
                          [
                            9.48,
                            6.68
                          ],
                          [
                            9.59,
                            6.44
                          ],
                          [
                            12.15,
                            3.87
                          ],
                          [
                            0.35,
                            3.87
                          ],
                          [
                            0.1,
                            3.77
                          ],
                          [
                            0,
                            3.52
                          ],
                          [
                            0.1,
                            3.27
                          ],
                          [
                            0.35,
                            3.17
                          ],
                          [
                            12.15,
                            3.17
                          ],
                          [
                            9.59,
                            0.6
                          ],
                          [
                            9.48,
                            0.35
                          ],
                          [
                            9.59,
                            0.1
                          ],
                          [
                            9.83,
                            0
                          ],
                          [
                            10.08,
                            0.1
                          ],
                          [
                            13.25,
                            3.27
                          ],
                          [
                            13.32,
                            3.38
                          ],
                          [
                            13.35,
                            3.52
                          ],
                          [
                            13.32,
                            3.65
                          ],
                          [
                            13.25,
                            3.77
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.57,
                        0.63,
                        0.72,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1973",
    layers: [
      {
        ind: 1972,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                43.5,
                7.5
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                87,
                15
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            0.29
                          ],
                          [
                            0.09,
                            0.31
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.09,
                            -0.3
                          ],
                          [
                            0.1,
                            -0.3
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.1,
                            -0.3
                          ],
                          [
                            -0.09,
                            -0.3
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.08,
                            0.31
                          ],
                          [
                            -0.09,
                            0.29
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.65,
                            5.65
                          ],
                          [
                            1.4,
                            6.46
                          ],
                          [
                            3,
                            6.46
                          ],
                          [
                            2.75,
                            5.65
                          ],
                          [
                            2.47,
                            4.77
                          ],
                          [
                            2.21,
                            3.86
                          ],
                          [
                            2.18,
                            3.86
                          ],
                          [
                            1.93,
                            4.77
                          ],
                          [
                            1.65,
                            5.65
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.02,
                            8.64
                          ],
                          [
                            1.83,
                            3.3
                          ],
                          [
                            2.59,
                            3.3
                          ],
                          [
                            4.4,
                            8.64
                          ],
                          [
                            3.67,
                            8.64
                          ],
                          [
                            3.17,
                            7.01
                          ],
                          [
                            1.23,
                            7.01
                          ],
                          [
                            0.71,
                            8.64
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.3,
                            0.36
                          ],
                          [
                            0,
                            0.66
                          ],
                          [
                            -0.16,
                            0.31
                          ],
                          [
                            -0.26,
                            0.17
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.17,
                            -0.08
                          ],
                          [
                            -0.18,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.21,
                            -0.11
                          ],
                          [
                            0.23,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.49,
                            0
                          ],
                          [
                            -0.3,
                            -0.36
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0.16,
                            -0.31
                          ],
                          [
                            0.27,
                            -0.17
                          ],
                          [
                            0.23,
                            0
                          ],
                          [
                            0.17,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0.15
                          ],
                          [
                            -0.2,
                            0.11
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            6.44,
                            8.73
                          ],
                          [
                            5.25,
                            8.2
                          ],
                          [
                            4.8,
                            6.67
                          ],
                          [
                            5.04,
                            5.56
                          ],
                          [
                            5.67,
                            4.84
                          ],
                          [
                            6.52,
                            4.59
                          ],
                          [
                            7.11,
                            4.71
                          ],
                          [
                            7.63,
                            5.04
                          ],
                          [
                            7.59,
                            4.37
                          ],
                          [
                            7.59,
                            2.85
                          ],
                          [
                            8.27,
                            2.85
                          ],
                          [
                            8.27,
                            8.64
                          ],
                          [
                            7.71,
                            8.64
                          ],
                          [
                            7.66,
                            8.17
                          ],
                          [
                            7.63,
                            8.17
                          ],
                          [
                            7.09,
                            8.57
                          ],
                          [
                            6.44,
                            8.73
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.32,
                            0.36
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0.06
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.17,
                            -0.13
                          ],
                          [
                            0.1,
                            -0.23
                          ],
                          [
                            0,
                            -0.3
                          ],
                          [
                            -0.19,
                            -0.27
                          ],
                          [
                            -0.35,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.35,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            -0.15
                          ],
                          [
                            -0.15,
                            -0.07
                          ],
                          [
                            -0.21,
                            0
                          ],
                          [
                            -0.17,
                            0.13
                          ],
                          [
                            -0.1,
                            0.22
                          ],
                          [
                            0,
                            0.47
                          ],
                          [
                            0.19,
                            0.27
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            6.58,
                            8.17
                          ],
                          [
                            7.59,
                            7.63
                          ],
                          [
                            7.59,
                            5.56
                          ],
                          [
                            7.1,
                            5.25
                          ],
                          [
                            6.63,
                            5.15
                          ],
                          [
                            6.05,
                            5.34
                          ],
                          [
                            5.65,
                            5.87
                          ],
                          [
                            5.49,
                            6.66
                          ],
                          [
                            5.78,
                            7.77
                          ],
                          [
                            6.58,
                            8.17
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.28,
                            0.16
                          ],
                          [
                            0.17,
                            0.31
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            -0.17,
                            0.31
                          ],
                          [
                            -0.28,
                            0.16
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.28,
                            -0.16
                          ],
                          [
                            -0.17,
                            -0.31
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            0.18,
                            -0.31
                          ],
                          [
                            0.27,
                            -0.16
                          ],
                          [
                            0.32,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.28,
                            -0.16
                          ],
                          [
                            -0.17,
                            -0.31
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            0.17,
                            -0.31
                          ],
                          [
                            0.28,
                            -0.16
                          ],
                          [
                            0.32,
                            0
                          ],
                          [
                            0.27,
                            0.16
                          ],
                          [
                            0.18,
                            0.31
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            -0.17,
                            0.31
                          ],
                          [
                            -0.28,
                            0.16
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            11.13,
                            8.73
                          ],
                          [
                            10.23,
                            8.49
                          ],
                          [
                            9.55,
                            7.78
                          ],
                          [
                            9.3,
                            6.67
                          ],
                          [
                            9.55,
                            5.54
                          ],
                          [
                            10.23,
                            4.83
                          ],
                          [
                            11.13,
                            4.59
                          ],
                          [
                            12.04,
                            4.83
                          ],
                          [
                            12.7,
                            5.54
                          ],
                          [
                            12.96,
                            6.67
                          ],
                          [
                            12.7,
                            7.78
                          ],
                          [
                            12.04,
                            8.49
                          ],
                          [
                            11.13,
                            8.73
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            0.28
                          ],
                          [
                            0,
                            0.45
                          ],
                          [
                            0.21,
                            0.28
                          ],
                          [
                            0.34,
                            0
                          ],
                          [
                            0.21,
                            -0.28
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            -0.21,
                            -0.28
                          ],
                          [
                            -0.34,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.34,
                            0
                          ],
                          [
                            0.21,
                            -0.28
                          ],
                          [
                            0,
                            -0.45
                          ],
                          [
                            -0.21,
                            -0.28
                          ],
                          [
                            -0.34,
                            0
                          ],
                          [
                            -0.21,
                            0.28
                          ],
                          [
                            0,
                            0.45
                          ],
                          [
                            0.21,
                            0.28
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            11.13,
                            8.18
                          ],
                          [
                            11.95,
                            7.77
                          ],
                          [
                            12.27,
                            6.67
                          ],
                          [
                            11.95,
                            5.56
                          ],
                          [
                            11.13,
                            5.14
                          ],
                          [
                            10.31,
                            5.56
                          ],
                          [
                            9.99,
                            6.67
                          ],
                          [
                            10.31,
                            7.77
                          ],
                          [
                            11.13,
                            8.18
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.09
                          ],
                          [
                            0.18,
                            0.16
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            0.11
                          ],
                          [
                            -0.22,
                            0
                          ],
                          [
                            -0.27,
                            -0.36
                          ],
                          [
                            0,
                            -0.61
                          ],
                          [
                            0.16,
                            -0.32
                          ],
                          [
                            0.26,
                            -0.17
                          ],
                          [
                            0.3,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.2,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            -0.16
                          ],
                          [
                            0.22,
                            -0.11
                          ],
                          [
                            0.52,
                            0
                          ],
                          [
                            0.27,
                            0.36
                          ],
                          [
                            0,
                            0.45
                          ],
                          [
                            -0.16,
                            0.32
                          ],
                          [
                            -0.25,
                            0.17
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            15.75,
                            8.73
                          ],
                          [
                            15.17,
                            8.6
                          ],
                          [
                            14.62,
                            8.23
                          ],
                          [
                            14.59,
                            8.23
                          ],
                          [
                            14.54,
                            8.64
                          ],
                          [
                            14,
                            8.64
                          ],
                          [
                            14,
                            2.85
                          ],
                          [
                            14.67,
                            2.85
                          ],
                          [
                            14.67,
                            4.43
                          ],
                          [
                            14.65,
                            5.14
                          ],
                          [
                            15.23,
                            4.75
                          ],
                          [
                            15.89,
                            4.59
                          ],
                          [
                            17.06,
                            5.13
                          ],
                          [
                            17.45,
                            6.59
                          ],
                          [
                            17.21,
                            7.75
                          ],
                          [
                            16.59,
                            8.48
                          ],
                          [
                            15.75,
                            8.73
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.21,
                            0.28
                          ],
                          [
                            0,
                            0.48
                          ],
                          [
                            0.16,
                            0.27
                          ],
                          [
                            0.38,
                            0
                          ],
                          [
                            0.18,
                            -0.09
                          ],
                          [
                            0.19,
                            -0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            -0.06
                          ],
                          [
                            -0.13,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.33,
                            0
                          ],
                          [
                            0.22,
                            -0.28
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            -0.16,
                            -0.27
                          ],
                          [
                            -0.17,
                            0
                          ],
                          [
                            -0.17,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.17,
                            0.15
                          ],
                          [
                            0.17,
                            0.06
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            15.63,
                            8.17
                          ],
                          [
                            16.44,
                            7.76
                          ],
                          [
                            16.77,
                            6.61
                          ],
                          [
                            16.52,
                            5.55
                          ],
                          [
                            15.72,
                            5.15
                          ],
                          [
                            15.21,
                            5.29
                          ],
                          [
                            14.67,
                            5.68
                          ],
                          [
                            14.67,
                            7.76
                          ],
                          [
                            15.18,
                            8.08
                          ],
                          [
                            15.63,
                            8.17
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.29,
                            0.16
                          ],
                          [
                            0.17,
                            0.31
                          ],
                          [
                            0,
                            0.43
                          ],
                          [
                            -0.17,
                            0.31
                          ],
                          [
                            -0.27,
                            0.17
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.27,
                            -0.34
                          ],
                          [
                            0,
                            -0.56
                          ],
                          [
                            0,
                            -0.07
                          ],
                          [
                            0.01,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.23,
                            -0.25
                          ],
                          [
                            -0.38,
                            0
                          ],
                          [
                            -0.16,
                            0.05
                          ],
                          [
                            -0.15,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.22,
                            -0.08
                          ],
                          [
                            0.27,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.35,
                            0
                          ],
                          [
                            -0.29,
                            -0.17
                          ],
                          [
                            -0.17,
                            -0.31
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0.17,
                            -0.31
                          ],
                          [
                            0.27,
                            -0.17
                          ],
                          [
                            0.5,
                            0
                          ],
                          [
                            0.28,
                            0.34
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.03,
                            0.42
                          ],
                          [
                            0.24,
                            0.25
                          ],
                          [
                            0.19,
                            0
                          ],
                          [
                            0.16,
                            -0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0.11
                          ],
                          [
                            -0.21,
                            0.08
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            20.09,
                            8.73
                          ],
                          [
                            19.14,
                            8.49
                          ],
                          [
                            18.45,
                            7.77
                          ],
                          [
                            18.2,
                            6.67
                          ],
                          [
                            18.45,
                            5.55
                          ],
                          [
                            19.12,
                            4.84
                          ],
                          [
                            19.97,
                            4.59
                          ],
                          [
                            21.13,
                            5.09
                          ],
                          [
                            21.55,
                            6.44
                          ],
                          [
                            21.54,
                            6.65
                          ],
                          [
                            21.52,
                            6.82
                          ],
                          [
                            18.86,
                            6.82
                          ],
                          [
                            19.25,
                            7.82
                          ],
                          [
                            20.18,
                            8.2
                          ],
                          [
                            20.7,
                            8.12
                          ],
                          [
                            21.16,
                            7.89
                          ],
                          [
                            21.39,
                            8.33
                          ],
                          [
                            20.82,
                            8.61
                          ],
                          [
                            20.09,
                            8.73
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.21
                          ],
                          [
                            0.31,
                            0
                          ],
                          [
                            0.22,
                            -0.21
                          ],
                          [
                            0.04,
                            -0.39
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.4
                          ],
                          [
                            -0.17,
                            -0.21
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.22,
                            0.21
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            18.85,
                            6.34
                          ],
                          [
                            20.96,
                            6.34
                          ],
                          [
                            20.7,
                            5.43
                          ],
                          [
                            19.99,
                            5.12
                          ],
                          [
                            19.24,
                            5.44
                          ],
                          [
                            18.85,
                            6.34
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.1,
                        0.17,
                        0.28,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "1978",
    layers: [
      {
        ind: 1977,
        ty: 4,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                31,
                6
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                62,
                12
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          }
        ]
      },
      {
        ind: 0,
        ty: 4,
        ks: {
          s: {
            a: 0,
            k: [
              133.33,
              133.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "gr",
                it: [
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.26,
                            -0.08
                          ],
                          [
                            -0.15,
                            -0.21
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            0.32,
                            -0.24
                          ],
                          [
                            0.51,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.35,
                            0
                          ],
                          [
                            0.26,
                            0.09
                          ],
                          [
                            0.14,
                            0.2
                          ],
                          [
                            0,
                            0.49
                          ],
                          [
                            -0.32,
                            0.23
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            0.64,
                            6.75
                          ],
                          [
                            0.64,
                            2.09
                          ],
                          [
                            1.97,
                            2.09
                          ],
                          [
                            2.89,
                            2.21
                          ],
                          [
                            3.5,
                            2.65
                          ],
                          [
                            3.72,
                            3.46
                          ],
                          [
                            3.24,
                            4.55
                          ],
                          [
                            2,
                            4.9
                          ],
                          [
                            1.23,
                            4.9
                          ],
                          [
                            1.23,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            0.15
                          ],
                          [
                            0,
                            0.33
                          ],
                          [
                            0.21,
                            0.13
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0.41,
                            0
                          ],
                          [
                            0.2,
                            -0.16
                          ],
                          [
                            0,
                            -0.34
                          ],
                          [
                            -0.2,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            1.23,
                            4.42
                          ],
                          [
                            1.93,
                            4.42
                          ],
                          [
                            2.83,
                            4.19
                          ],
                          [
                            3.13,
                            3.46
                          ],
                          [
                            2.82,
                            2.76
                          ],
                          [
                            1.9,
                            2.56
                          ],
                          [
                            1.23,
                            2.56
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0.13
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.11,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.01
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0.12,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            -0.21
                          ],
                          [
                            0.17,
                            -0.13
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.05,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.01
                          ],
                          [
                            -0.15,
                            0
                          ],
                          [
                            -0.16,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            4.61,
                            6.75
                          ],
                          [
                            4.61,
                            3.29
                          ],
                          [
                            5.09,
                            3.29
                          ],
                          [
                            5.14,
                            3.92
                          ],
                          [
                            5.16,
                            3.92
                          ],
                          [
                            5.6,
                            3.4
                          ],
                          [
                            6.15,
                            3.21
                          ],
                          [
                            6.52,
                            3.28
                          ],
                          [
                            6.4,
                            3.79
                          ],
                          [
                            6.25,
                            3.75
                          ],
                          [
                            6.07,
                            3.73
                          ],
                          [
                            5.61,
                            3.91
                          ],
                          [
                            5.2,
                            4.53
                          ],
                          [
                            5.2,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.24,
                            0.14
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.24,
                            -0.29
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0,
                            -0.06
                          ],
                          [
                            0.01,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            -0.22
                          ],
                          [
                            -0.33,
                            0
                          ],
                          [
                            -0.14,
                            0.05
                          ],
                          [
                            -0.13,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0.23,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.15,
                            -0.27
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.15,
                            -0.27
                          ],
                          [
                            0.24,
                            -0.15
                          ],
                          [
                            0.44,
                            0
                          ],
                          [
                            0.24,
                            0.29
                          ],
                          [
                            0,
                            0.06
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            0.36
                          ],
                          [
                            0.21,
                            0.22
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0.09
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            8.41,
                            6.84
                          ],
                          [
                            7.57,
                            6.62
                          ],
                          [
                            6.97,
                            6
                          ],
                          [
                            6.75,
                            5.03
                          ],
                          [
                            6.97,
                            4.05
                          ],
                          [
                            7.55,
                            3.43
                          ],
                          [
                            8.3,
                            3.21
                          ],
                          [
                            9.32,
                            3.65
                          ],
                          [
                            9.68,
                            4.83
                          ],
                          [
                            9.68,
                            5.02
                          ],
                          [
                            9.66,
                            5.16
                          ],
                          [
                            7.33,
                            5.16
                          ],
                          [
                            7.67,
                            6.04
                          ],
                          [
                            8.48,
                            6.37
                          ],
                          [
                            8.93,
                            6.29
                          ],
                          [
                            9.34,
                            6.1
                          ],
                          [
                            9.55,
                            6.48
                          ],
                          [
                            9.04,
                            6.73
                          ],
                          [
                            8.41,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.18
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.2,
                            -0.19
                          ],
                          [
                            0.04,
                            -0.34
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.35
                          ],
                          [
                            -0.15,
                            -0.19
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.19,
                            0.18
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            7.32,
                            4.75
                          ],
                          [
                            9.17,
                            4.75
                          ],
                          [
                            8.94,
                            3.95
                          ],
                          [
                            8.32,
                            3.67
                          ],
                          [
                            7.66,
                            3.96
                          ],
                          [
                            7.32,
                            4.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.28,
                            0.12
                          ],
                          [
                            0.2,
                            0.21
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.22,
                            -0.11
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.17,
                            0.14
                          ],
                          [
                            0,
                            0.23
                          ],
                          [
                            0.07,
                            0.09
                          ],
                          [
                            0.12,
                            0.07
                          ],
                          [
                            0.15,
                            0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.1
                          ],
                          [
                            0.1,
                            0.16
                          ],
                          [
                            0,
                            0.23
                          ],
                          [
                            -0.12,
                            0.18
                          ],
                          [
                            -0.22,
                            0.1
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.23,
                            -0.11
                          ],
                          [
                            -0.16,
                            -0.17
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.07
                          ],
                          [
                            0.22,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0,
                            -0.21
                          ],
                          [
                            -0.07,
                            -0.1
                          ],
                          [
                            -0.12,
                            -0.06
                          ],
                          [
                            -0.12,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            -0.11
                          ],
                          [
                            -0.09,
                            -0.16
                          ],
                          [
                            0,
                            -0.23
                          ],
                          [
                            0.13,
                            -0.2
                          ],
                          [
                            0.24,
                            -0.12
                          ],
                          [
                            0.33,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.28,
                            -0.13
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            0.18
                          ],
                          [
                            0.23,
                            0.11
                          ],
                          [
                            0.31,
                            0
                          ],
                          [
                            0.17,
                            -0.14
                          ],
                          [
                            0,
                            -0.16
                          ],
                          [
                            -0.07,
                            -0.09
                          ],
                          [
                            -0.11,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            -0.06
                          ],
                          [
                            -0.14,
                            -0.1
                          ],
                          [
                            -0.09,
                            -0.16
                          ],
                          [
                            0,
                            -0.24
                          ],
                          [
                            0.13,
                            -0.19
                          ],
                          [
                            0.22,
                            -0.11
                          ],
                          [
                            0.28,
                            0
                          ],
                          [
                            0.24,
                            0.1
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            -0.14
                          ],
                          [
                            -0.17,
                            -0.08
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.16,
                            0.13
                          ],
                          [
                            0,
                            0.14
                          ],
                          [
                            0.08,
                            0.09
                          ],
                          [
                            0.12,
                            0.06
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.18,
                            0.07
                          ],
                          [
                            0.15,
                            0.1
                          ],
                          [
                            0.08,
                            0.15
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            -0.13,
                            0.2
                          ],
                          [
                            -0.24,
                            0.12
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            13.31,
                            6.84
                          ],
                          [
                            12.4,
                            6.65
                          ],
                          [
                            11.68,
                            6.14
                          ],
                          [
                            12.03,
                            5.73
                          ],
                          [
                            12.61,
                            6.16
                          ],
                          [
                            13.32,
                            6.32
                          ],
                          [
                            14.04,
                            6.11
                          ],
                          [
                            14.29,
                            5.55
                          ],
                          [
                            14.18,
                            5.17
                          ],
                          [
                            13.91,
                            4.93
                          ],
                          [
                            13.52,
                            4.73
                          ],
                          [
                            12.85,
                            4.44
                          ],
                          [
                            12.41,
                            4.2
                          ],
                          [
                            12.04,
                            3.81
                          ],
                          [
                            11.9,
                            3.24
                          ],
                          [
                            12.09,
                            2.61
                          ],
                          [
                            12.61,
                            2.16
                          ],
                          [
                            13.37,
                            2
                          ],
                          [
                            14.14,
                            2.16
                          ],
                          [
                            14.75,
                            2.57
                          ],
                          [
                            14.43,
                            2.96
                          ],
                          [
                            13.95,
                            2.64
                          ],
                          [
                            13.37,
                            2.52
                          ],
                          [
                            12.73,
                            2.7
                          ],
                          [
                            12.5,
                            3.2
                          ],
                          [
                            12.61,
                            3.57
                          ],
                          [
                            12.91,
                            3.8
                          ],
                          [
                            13.27,
                            3.98
                          ],
                          [
                            13.94,
                            4.26
                          ],
                          [
                            14.42,
                            4.54
                          ],
                          [
                            14.77,
                            4.93
                          ],
                          [
                            14.89,
                            5.5
                          ],
                          [
                            14.7,
                            6.18
                          ],
                          [
                            14.16,
                            6.66
                          ],
                          [
                            13.31,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.25,
                            0.14
                          ],
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.16,
                            -0.08
                          ],
                          [
                            -0.12,
                            -0.11
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.11,
                            0.06
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0.17,
                            -0.11
                          ],
                          [
                            0.09,
                            -0.2
                          ],
                          [
                            0,
                            -0.27
                          ],
                          [
                            -0.2,
                            -0.25
                          ],
                          [
                            -0.32,
                            0
                          ],
                          [
                            -0.14,
                            0.07
                          ],
                          [
                            -0.11,
                            0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.08
                          ],
                          [
                            0.21,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.3,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.14,
                            -0.27
                          ],
                          [
                            0,
                            -0.39
                          ],
                          [
                            0.16,
                            -0.27
                          ],
                          [
                            0.26,
                            -0.14
                          ],
                          [
                            0.23,
                            0
                          ],
                          [
                            0.16,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.1,
                            -0.09
                          ],
                          [
                            -0.11,
                            -0.06
                          ],
                          [
                            -0.21,
                            0
                          ],
                          [
                            -0.16,
                            0.11
                          ],
                          [
                            -0.09,
                            0.2
                          ],
                          [
                            0,
                            0.39
                          ],
                          [
                            0.2,
                            0.24
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.07
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.14
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            17.13,
                            6.84
                          ],
                          [
                            16.3,
                            6.62
                          ],
                          [
                            15.71,
                            6
                          ],
                          [
                            15.5,
                            5.03
                          ],
                          [
                            15.73,
                            4.04
                          ],
                          [
                            16.34,
                            3.42
                          ],
                          [
                            17.17,
                            3.21
                          ],
                          [
                            17.75,
                            3.33
                          ],
                          [
                            18.18,
                            3.61
                          ],
                          [
                            17.88,
                            4
                          ],
                          [
                            17.56,
                            3.78
                          ],
                          [
                            17.19,
                            3.69
                          ],
                          [
                            16.63,
                            3.86
                          ],
                          [
                            16.24,
                            4.33
                          ],
                          [
                            16.11,
                            5.03
                          ],
                          [
                            16.4,
                            5.99
                          ],
                          [
                            17.17,
                            6.35
                          ],
                          [
                            17.62,
                            6.25
                          ],
                          [
                            17.98,
                            6
                          ],
                          [
                            18.24,
                            6.39
                          ],
                          [
                            17.72,
                            6.72
                          ],
                          [
                            17.13,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            0.17
                          ],
                          [
                            0,
                            0.3
                          ],
                          [
                            -0.34,
                            0.2
                          ],
                          [
                            -0.73,
                            0.08
                          ],
                          [
                            0.04,
                            0.13
                          ],
                          [
                            0.11,
                            0.08
                          ],
                          [
                            0.19,
                            0
                          ],
                          [
                            0.17,
                            -0.07
                          ],
                          [
                            0.14,
                            -0.09
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.23,
                            0.09
                          ],
                          [
                            -0.28,
                            0
                          ],
                          [
                            -0.19,
                            -0.26
                          ],
                          [
                            0,
                            -0.43
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.2,
                            -0.1
                          ],
                          [
                            0.22,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.29,
                            0
                          ],
                          [
                            -0.19,
                            -0.18
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.34,
                            -0.2
                          ],
                          [
                            0,
                            -0.14
                          ],
                          [
                            -0.04,
                            -0.13
                          ],
                          [
                            -0.1,
                            -0.09
                          ],
                          [
                            -0.2,
                            0
                          ],
                          [
                            -0.18,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.16,
                            -0.11
                          ],
                          [
                            0.24,
                            -0.1
                          ],
                          [
                            0.42,
                            0
                          ],
                          [
                            0.19,
                            0.26
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.16,
                            0.13
                          ],
                          [
                            -0.19,
                            0.1
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            19.73,
                            6.84
                          ],
                          [
                            19,
                            6.58
                          ],
                          [
                            18.72,
                            5.86
                          ],
                          [
                            19.22,
                            4.98
                          ],
                          [
                            20.84,
                            4.56
                          ],
                          [
                            20.77,
                            4.14
                          ],
                          [
                            20.56,
                            3.82
                          ],
                          [
                            20.13,
                            3.69
                          ],
                          [
                            19.57,
                            3.8
                          ],
                          [
                            19.09,
                            4.06
                          ],
                          [
                            18.87,
                            3.66
                          ],
                          [
                            19.46,
                            3.36
                          ],
                          [
                            20.23,
                            3.21
                          ],
                          [
                            21.14,
                            3.6
                          ],
                          [
                            21.43,
                            4.63
                          ],
                          [
                            21.43,
                            6.75
                          ],
                          [
                            20.95,
                            6.75
                          ],
                          [
                            20.89,
                            6.34
                          ],
                          [
                            20.88,
                            6.34
                          ],
                          [
                            20.34,
                            6.69
                          ],
                          [
                            19.73,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            -0.14,
                            0.08
                          ],
                          [
                            -0.16,
                            0.15
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.23,
                            -0.14
                          ],
                          [
                            0,
                            -0.22
                          ],
                          [
                            -0.12,
                            -0.09
                          ],
                          [
                            -0.17,
                            0
                          ]
                        ],
                        o: [
                          [
                            0.17,
                            0
                          ],
                          [
                            0.15,
                            -0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.57,
                            0.07
                          ],
                          [
                            -0.23,
                            0.14
                          ],
                          [
                            0,
                            0.19
                          ],
                          [
                            0.12,
                            0.09
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            19.9,
                            6.37
                          ],
                          [
                            20.37,
                            6.25
                          ],
                          [
                            20.84,
                            5.9
                          ],
                          [
                            20.84,
                            4.95
                          ],
                          [
                            19.63,
                            5.26
                          ],
                          [
                            19.29,
                            5.81
                          ],
                          [
                            19.46,
                            6.24
                          ],
                          [
                            19.9,
                            6.37
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.1,
                            0.13
                          ],
                          [
                            0,
                            0.25
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            -0.04
                          ],
                          [
                            -0.04,
                            0
                          ],
                          [
                            -0.02,
                            0
                          ],
                          [
                            -0.04,
                            0.01
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            -0.01
                          ],
                          [
                            0.08,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.21,
                            0
                          ],
                          [
                            -0.09,
                            -0.14
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0.09
                          ],
                          [
                            0.03,
                            0.04
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0.02,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.04,
                            0.02
                          ],
                          [
                            -0.05,
                            0.01
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            23.13,
                            6.84
                          ],
                          [
                            22.66,
                            6.64
                          ],
                          [
                            22.52,
                            6.05
                          ],
                          [
                            22.52,
                            1.69
                          ],
                          [
                            23.1,
                            1.69
                          ],
                          [
                            23.1,
                            6.1
                          ],
                          [
                            23.15,
                            6.29
                          ],
                          [
                            23.26,
                            6.35
                          ],
                          [
                            23.31,
                            6.35
                          ],
                          [
                            23.39,
                            6.34
                          ],
                          [
                            23.47,
                            6.78
                          ],
                          [
                            23.33,
                            6.82
                          ],
                          [
                            23.13,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0.25,
                            0.14
                          ],
                          [
                            0.14,
                            0.27
                          ],
                          [
                            0,
                            0.38
                          ],
                          [
                            -0.15,
                            0.27
                          ],
                          [
                            -0.24,
                            0.14
                          ],
                          [
                            -0.26,
                            0
                          ],
                          [
                            -0.24,
                            -0.29
                          ],
                          [
                            0,
                            -0.49
                          ],
                          [
                            0,
                            -0.06
                          ],
                          [
                            0.01,
                            -0.04
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.2,
                            -0.22
                          ],
                          [
                            -0.33,
                            0
                          ],
                          [
                            -0.14,
                            0.05
                          ],
                          [
                            -0.13,
                            0.08
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.19,
                            -0.07
                          ],
                          [
                            0.23,
                            0
                          ]
                        ],
                        o: [
                          [
                            -0.31,
                            0
                          ],
                          [
                            -0.25,
                            -0.14
                          ],
                          [
                            -0.15,
                            -0.27
                          ],
                          [
                            0,
                            -0.38
                          ],
                          [
                            0.15,
                            -0.27
                          ],
                          [
                            0.24,
                            -0.15
                          ],
                          [
                            0.44,
                            0
                          ],
                          [
                            0.24,
                            0.29
                          ],
                          [
                            0,
                            0.06
                          ],
                          [
                            0,
                            0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.02,
                            0.36
                          ],
                          [
                            0.21,
                            0.22
                          ],
                          [
                            0.16,
                            0
                          ],
                          [
                            0.14,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.15,
                            0.09
                          ],
                          [
                            -0.19,
                            0.07
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            25.73,
                            6.84
                          ],
                          [
                            24.89,
                            6.62
                          ],
                          [
                            24.29,
                            6
                          ],
                          [
                            24.07,
                            5.03
                          ],
                          [
                            24.29,
                            4.05
                          ],
                          [
                            24.88,
                            3.43
                          ],
                          [
                            25.62,
                            3.21
                          ],
                          [
                            26.64,
                            3.65
                          ],
                          [
                            27,
                            4.83
                          ],
                          [
                            27,
                            5.02
                          ],
                          [
                            26.98,
                            5.16
                          ],
                          [
                            24.65,
                            5.16
                          ],
                          [
                            24.99,
                            6.04
                          ],
                          [
                            25.8,
                            6.37
                          ],
                          [
                            26.25,
                            6.29
                          ],
                          [
                            26.66,
                            6.1
                          ],
                          [
                            26.87,
                            6.48
                          ],
                          [
                            26.36,
                            6.73
                          ],
                          [
                            25.73,
                            6.84
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.15,
                            0.18
                          ],
                          [
                            0.27,
                            0
                          ],
                          [
                            0.2,
                            -0.19
                          ],
                          [
                            0.04,
                            -0.34
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            -0.35
                          ],
                          [
                            -0.14,
                            -0.19
                          ],
                          [
                            -0.24,
                            0
                          ],
                          [
                            -0.19,
                            0.18
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            24.64,
                            4.75
                          ],
                          [
                            26.49,
                            4.75
                          ],
                          [
                            26.26,
                            3.95
                          ],
                          [
                            25.64,
                            3.67
                          ],
                          [
                            24.98,
                            3.96
                          ],
                          [
                            24.64,
                            4.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "sh",
                    ks: {
                      a: 0,
                      k: {
                        c: !0,
                        i: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.17,
                            0.13
                          ],
                          [
                            -0.19,
                            0
                          ],
                          [
                            -0.11,
                            -0.05
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.05,
                            0.01
                          ],
                          [
                            0.07,
                            0
                          ],
                          [
                            0.16,
                            -0.12
                          ],
                          [
                            0.12,
                            -0.29
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        o: [
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0.12,
                            -0.21
                          ],
                          [
                            0.17,
                            -0.13
                          ],
                          [
                            0.14,
                            0
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            -0.06,
                            -0.02
                          ],
                          [
                            -0.05,
                            -0.01
                          ],
                          [
                            -0.14,
                            0
                          ],
                          [
                            -0.16,
                            0.12
                          ],
                          [
                            0,
                            0
                          ],
                          [
                            0,
                            0
                          ]
                        ],
                        v: [
                          [
                            27.86,
                            6.75
                          ],
                          [
                            27.86,
                            3.29
                          ],
                          [
                            28.34,
                            3.29
                          ],
                          [
                            28.39,
                            3.92
                          ],
                          [
                            28.41,
                            3.92
                          ],
                          [
                            28.84,
                            3.4
                          ],
                          [
                            29.39,
                            3.21
                          ],
                          [
                            29.76,
                            3.28
                          ],
                          [
                            29.65,
                            3.79
                          ],
                          [
                            29.49,
                            3.75
                          ],
                          [
                            29.31,
                            3.73
                          ],
                          [
                            28.85,
                            3.91
                          ],
                          [
                            28.44,
                            4.53
                          ],
                          [
                            28.44,
                            6.75
                          ]
                        ]
                      }
                    }
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [
                        0.49,
                        0.55,
                        0.65,
                        1
                      ]
                    },
                    o: {
                      a: 0,
                      k: 100
                    }
                  },
                  {
                    ty: "tr",
                    o: {
                      a: 0,
                      k: 100
                    }
                  }
                ]
              },
              {
                ty: "tr",
                o: {
                  a: 0,
                  k: 100
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: "2002",
    layers: [
      {
        ind: 2001,
        ty: 2,
        parent: 2e3,
        ks: {
          s: {
            a: 0,
            k: [
              170,
              181.82
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "0"
      },
      {
        ind: 2e3,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "2005",
    layers: [
      {
        ind: 2004,
        ty: 0,
        parent: 1999,
        ks: {},
        w: 8.5,
        h: 10,
        ip: 0,
        op: 565,
        st: 0,
        refId: "2002"
      },
      {
        ind: 1999,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "2047",
    layers: [
      {
        ind: 2046,
        ty: 2,
        parent: 2045,
        ks: {
          s: {
            a: 0,
            k: [
              181.82,
              180
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "1"
      },
      {
        ind: 2045,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "2050",
    layers: [
      {
        ind: 2049,
        ty: 0,
        parent: 2044,
        ks: {},
        w: 10,
        h: 9,
        ip: 0,
        op: 565,
        st: 0,
        refId: "2047"
      },
      {
        ind: 2044,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              0,
              1
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "2085",
    layers: [
      {
        ind: 2084,
        ty: 2,
        parent: 2083,
        ks: {
          s: {
            a: 0,
            k: [
              181.25,
              183.33
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "12"
      },
      {
        ind: 2083,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "2088",
    layers: [
      {
        ind: 2087,
        ty: 0,
        parent: 2082,
        ks: {},
        w: 14.5,
        h: 16.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "2085"
      },
      {
        ind: 2082,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              1,
              0
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "2099",
    layers: [
      {
        ind: 2098,
        ty: 2,
        parent: 2097,
        ks: {
          s: {
            a: 0,
            k: [
              198.31,
              198.31
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0,
        refId: "14"
      },
      {
        ind: 2097,
        ty: 3,
        ks: {
          s: {
            a: 0,
            k: [
              50,
              50
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "2102",
    layers: [
      {
        ind: 2101,
        ty: 0,
        parent: 2096,
        ks: {},
        w: 58.5,
        h: 58.5,
        ip: 0,
        op: 565,
        st: 0,
        refId: "2099"
      },
      {
        ind: 2096,
        ty: 3,
        parent: 2095,
        ks: {
          p: {
            a: 0,
            k: [
              -6,
              -4
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      },
      {
        ind: 2095,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              6,
              5
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  },
  {
    id: "2106",
    layers: [
      {
        ind: 2105,
        ty: 4,
        td: 1,
        parent: 2094,
        ks: {},
        ip: 0,
        op: 565,
        st: 0,
        shapes: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                24.383,
                24.383
              ]
            },
            r: {
              a: 0,
              k: 24
            },
            s: {
              a: 0,
              k: [
                48.766,
                48.766
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ind: 2104,
        ty: 0,
        tt: 1,
        parent: 2094,
        ks: {
          a: {
            a: 0,
            k: [
              6,
              5
            ]
          }
        },
        w: 65,
        h: 64,
        ip: 0,
        op: 565,
        st: 0,
        refId: "2102"
      },
      {
        ind: 2094,
        ty: 3,
        ks: {
          p: {
            a: 0,
            k: [
              5.418,
              5.418
            ]
          }
        },
        ip: 0,
        op: 565,
        st: 0
      }
    ]
  }
], E = 60, F = 185, M = 0, W = [
  {
    ind: 26,
    ty: 4,
    parent: 25,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 25,
    ty: 3,
    parent: 24,
    ks: {
      p: {
        a: 0,
        k: [
          21.813,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 28,
    ty: 4,
    parent: 27,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 27,
    ty: 3,
    parent: 24,
    ks: {
      p: {
        a: 0,
        k: [
          17.007,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 30,
    ty: 4,
    parent: 29,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.8,
                9
              ],
              [
                1.8,
                9
              ],
              [
                0.9,
                8.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                7.8
              ],
              [
                1.9,
                8
              ],
              [
                2,
                8.1
              ],
              [
                2,
                8.1
              ],
              [
                2.1,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.3,
                8.9
              ],
              [
                2.1,
                9
              ],
              [
                1.8,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 29,
    ty: 3,
    parent: 24,
    ks: {
      p: {
        a: 0,
        k: [
          14.438,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 32,
    ty: 4,
    parent: 31,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 31,
    ty: 3,
    parent: 24,
    ks: {
      p: {
        a: 0,
        k: [
          9.546,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 34,
    ty: 4,
    parent: 33,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.36
              ],
              [
                -0.36,
                0.19
              ],
              [
                -0.41,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.1
              ],
              [
                -0.17,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.13,
                0.06
              ],
              [
                0.15,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.28
              ],
              [
                0,
                -0.47
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                -0.28
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                0.08
              ],
              [
                -0.13,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.27,
                0
              ]
            ],
            v: [
              [
                2.64,
                9.02
              ],
              [
                2.64,
                9.02
              ],
              [
                1.49,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.71,
                5.26
              ],
              [
                1.57,
                4.42
              ],
              [
                2.72,
                4.13
              ],
              [
                2.72,
                4.13
              ],
              [
                3.5,
                4.28
              ],
              [
                4.09,
                4.65
              ],
              [
                4.09,
                4.65
              ],
              [
                3.56,
                5.37
              ],
              [
                3.19,
                5.11
              ],
              [
                2.78,
                5.02
              ],
              [
                2.78,
                5.02
              ],
              [
                1.86,
                5.45
              ],
              [
                1.51,
                6.58
              ],
              [
                1.51,
                6.58
              ],
              [
                1.85,
                7.7
              ],
              [
                2.75,
                8.12
              ],
              [
                2.75,
                8.12
              ],
              [
                3.27,
                8.01
              ],
              [
                3.71,
                7.73
              ],
              [
                3.71,
                7.73
              ],
              [
                4.15,
                8.45
              ],
              [
                3.43,
                8.87
              ],
              [
                2.64,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.42,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.52
              ],
              [
                0.21,
                -0.36
              ],
              [
                0.36,
                -0.19
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.22,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                -0.11
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                -0.37,
                0
              ],
              [
                -0.24,
                0.28
              ],
              [
                0,
                0
              ],
              [
                0,
                0.46
              ],
              [
                0.23,
                0.28
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0.16,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.19
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 33,
    ty: 3,
    parent: 24,
    ks: {
      p: {
        a: 0,
        k: [
          5.167,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 36,
    ty: 4,
    parent: 35,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                1,
                7.4
              ],
              [
                1.8,
                7.9
              ],
              [
                2.6,
                8.1
              ],
              [
                2.6,
                8.1
              ],
              [
                3.4,
                7.8
              ],
              [
                3.7,
                7.3
              ],
              [
                3.7,
                7.3
              ],
              [
                3.4,
                6.7
              ],
              [
                2.7,
                6.4
              ],
              [
                2.7,
                6.4
              ],
              [
                1.9,
                6
              ],
              [
                1.3,
                5.6
              ],
              [
                0.8,
                5.1
              ],
              [
                0.6,
                4.3
              ],
              [
                0.6,
                4.3
              ],
              [
                0.9,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.8,
                2.8
              ],
              [
                4.6,
                3.4
              ],
              [
                4.6,
                3.4
              ],
              [
                4.1,
                4.1
              ],
              [
                3.4,
                3.7
              ],
              [
                2.7,
                3.5
              ],
              [
                2.7,
                3.5
              ],
              [
                2,
                3.7
              ],
              [
                1.7,
                4.3
              ],
              [
                1.7,
                4.3
              ],
              [
                1.9,
                4.7
              ],
              [
                2.2,
                4.9
              ],
              [
                2.7,
                5.1
              ],
              [
                2.7,
                5.1
              ],
              [
                3.6,
                5.5
              ],
              [
                4.5,
                6.1
              ],
              [
                4.8,
                7.2
              ],
              [
                4.8,
                7.2
              ],
              [
                4.6,
                8.1
              ],
              [
                3.8,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 35,
    ty: 3,
    parent: 24,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 24,
    ty: 3,
    parent: 23,
    ks: {
      p: {
        a: 0,
        k: [
          88.876,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 39,
    ty: 4,
    parent: 38,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 38,
    ty: 3,
    parent: 37,
    ks: {
      p: {
        a: 0,
        k: [
          15.786,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 41,
    ty: 4,
    parent: 40,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 40,
    ty: 3,
    parent: 37,
    ks: {
      p: {
        a: 0,
        k: [
          10.979,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 43,
    ty: 4,
    parent: 42,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                5.1
              ],
              [
                0.3,
                5.1
              ],
              [
                0.3,
                4.3
              ],
              [
                0.9,
                4.2
              ],
              [
                0.9,
                3.8
              ],
              [
                1.2,
                2.6
              ],
              [
                2.4,
                2.1
              ],
              [
                2.4,
                2.1
              ],
              [
                2.9,
                2.1
              ],
              [
                3.3,
                2.3
              ],
              [
                3.3,
                2.3
              ],
              [
                3.1,
                3.1
              ],
              [
                2.6,
                3
              ],
              [
                2.6,
                3
              ],
              [
                2,
                3.7
              ],
              [
                2,
                3.7
              ],
              [
                2,
                4.2
              ],
              [
                2.9,
                4.2
              ],
              [
                2.9,
                5.1
              ],
              [
                2,
                5.1
              ],
              [
                2,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                5.3,
                9
              ],
              [
                5.3,
                9
              ],
              [
                4.2,
                8.5
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                5.1
              ],
              [
                3.2,
                5.1
              ],
              [
                3.2,
                4.3
              ],
              [
                3.9,
                4.2
              ],
              [
                4,
                3
              ],
              [
                5,
                3
              ],
              [
                5,
                4.2
              ],
              [
                6.1,
                4.2
              ],
              [
                6.1,
                5.1
              ],
              [
                5,
                5.1
              ],
              [
                5,
                7.3
              ],
              [
                5.6,
                8.1
              ],
              [
                5.6,
                8.1
              ],
              [
                5.9,
                8.1
              ],
              [
                6.1,
                8
              ],
              [
                6.1,
                8
              ],
              [
                6.3,
                8.8
              ],
              [
                5.9,
                9
              ],
              [
                5.3,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 42,
    ty: 3,
    parent: 37,
    ks: {
      p: {
        a: 0,
        k: [
          4.892,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 45,
    ty: 4,
    parent: 44,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 44,
    ty: 3,
    parent: 37,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 37,
    ty: 3,
    parent: 23,
    ks: {
      p: {
        a: 0,
        k: [
          67.659,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 48,
    ty: 4,
    parent: 47,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 47,
    ty: 3,
    parent: 46,
    ks: {
      p: {
        a: 0,
        k: [
          13.718,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 50,
    ty: 4,
    parent: 49,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                8.9
              ],
              [
                0.7,
                8.9
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                6.4
              ],
              [
                1.8,
                6.4
              ],
              [
                3.5,
                4.2
              ],
              [
                4.7,
                4.2
              ],
              [
                3.1,
                6.1
              ],
              [
                4.9,
                8.9
              ],
              [
                3.7,
                8.9
              ],
              [
                2.5,
                6.9
              ],
              [
                1.8,
                7.7
              ],
              [
                1.8,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 49,
    ty: 3,
    parent: 46,
    ks: {
      p: {
        a: 0,
        k: [
          8.769,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 52,
    ty: 4,
    parent: 51,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                8.9
              ],
              [
                0.7,
                8.9
              ],
              [
                0.7,
                4.2
              ],
              [
                1.8,
                4.2
              ],
              [
                1.8,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.4
              ],
              [
                1.2,
                3.4
              ],
              [
                0.8,
                3.3
              ],
              [
                0.6,
                2.8
              ],
              [
                0.6,
                2.8
              ],
              [
                0.8,
                2.4
              ],
              [
                1.2,
                2.2
              ],
              [
                1.2,
                2.2
              ],
              [
                1.7,
                2.4
              ],
              [
                1.9,
                2.8
              ],
              [
                1.9,
                2.8
              ],
              [
                1.7,
                3.3
              ],
              [
                1.2,
                3.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 51,
    ty: 3,
    parent: 46,
    ks: {
      p: {
        a: 0,
        k: [
          6.285,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 54,
    ty: 4,
    parent: 53,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.9,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                2.7
              ],
              [
                1.9,
                2.7
              ],
              [
                1.9,
                5.2
              ],
              [
                4.4,
                5.2
              ],
              [
                4.4,
                2.7
              ],
              [
                5.5,
                2.7
              ],
              [
                5.5,
                8.9
              ],
              [
                4.4,
                8.9
              ],
              [
                4.4,
                6.2
              ],
              [
                1.9,
                6.2
              ],
              [
                1.9,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 53,
    ty: 3,
    parent: 46,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 46,
    ty: 3,
    parent: 23,
    ks: {
      p: {
        a: 0,
        k: [
          47.239,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 57,
    ty: 4,
    parent: 56,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                1,
                10.8
              ],
              [
                1,
                10.8
              ],
              [
                0.7,
                10.8
              ],
              [
                0.4,
                10.7
              ],
              [
                0.4,
                10.7
              ],
              [
                0.6,
                9.9
              ],
              [
                0.8,
                9.9
              ],
              [
                0.9,
                9.9
              ],
              [
                0.9,
                9.9
              ],
              [
                1.5,
                9.7
              ],
              [
                1.9,
                9.1
              ],
              [
                1.9,
                9.1
              ],
              [
                1.9,
                8.8
              ],
              [
                0.1,
                4.2
              ],
              [
                1.2,
                4.2
              ],
              [
                2,
                6.5
              ],
              [
                2.2,
                7.2
              ],
              [
                2.4,
                7.8
              ],
              [
                2.4,
                7.8
              ],
              [
                2.5,
                7.8
              ],
              [
                2.7,
                7.2
              ],
              [
                2.8,
                6.5
              ],
              [
                2.8,
                6.5
              ],
              [
                3.5,
                4.2
              ],
              [
                4.6,
                4.2
              ],
              [
                2.9,
                9.1
              ],
              [
                2.2,
                10.4
              ],
              [
                1,
                10.8
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.5
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 56,
    ty: 3,
    parent: 55,
    ks: {
      p: {
        a: 0,
        k: [
          21.055,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 59,
    ty: 4,
    parent: 58,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 58,
    ty: 3,
    parent: 55,
    ks: {
      p: {
        a: 0,
        k: [
          17.519,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 61,
    ty: 4,
    parent: 60,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 60,
    ty: 3,
    parent: 55,
    ks: {
      p: {
        a: 0,
        k: [
          12.627,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 63,
    ty: 4,
    parent: 62,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.8,
                9
              ],
              [
                1.8,
                9
              ],
              [
                0.9,
                8.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                7.8
              ],
              [
                1.9,
                8
              ],
              [
                2,
                8.1
              ],
              [
                2,
                8.1
              ],
              [
                2.1,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.3,
                8.9
              ],
              [
                2.1,
                9
              ],
              [
                1.8,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 62,
    ty: 3,
    parent: 55,
    ks: {
      p: {
        a: 0,
        k: [
          10.058,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 65,
    ty: 4,
    parent: 64,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 64,
    ty: 3,
    parent: 55,
    ks: {
      p: {
        a: 0,
        k: [
          5.167,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 67,
    ty: 4,
    parent: 66,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                1,
                7.4
              ],
              [
                1.8,
                7.9
              ],
              [
                2.6,
                8.1
              ],
              [
                2.6,
                8.1
              ],
              [
                3.4,
                7.8
              ],
              [
                3.7,
                7.3
              ],
              [
                3.7,
                7.3
              ],
              [
                3.4,
                6.7
              ],
              [
                2.7,
                6.4
              ],
              [
                2.7,
                6.4
              ],
              [
                1.9,
                6
              ],
              [
                1.3,
                5.6
              ],
              [
                0.8,
                5.1
              ],
              [
                0.6,
                4.3
              ],
              [
                0.6,
                4.3
              ],
              [
                0.9,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.8,
                2.8
              ],
              [
                4.6,
                3.4
              ],
              [
                4.6,
                3.4
              ],
              [
                4.1,
                4.1
              ],
              [
                3.4,
                3.7
              ],
              [
                2.7,
                3.5
              ],
              [
                2.7,
                3.5
              ],
              [
                2,
                3.7
              ],
              [
                1.7,
                4.3
              ],
              [
                1.7,
                4.3
              ],
              [
                1.9,
                4.7
              ],
              [
                2.2,
                4.9
              ],
              [
                2.7,
                5.1
              ],
              [
                2.7,
                5.1
              ],
              [
                3.6,
                5.5
              ],
              [
                4.5,
                6.1
              ],
              [
                4.8,
                7.2
              ],
              [
                4.8,
                7.2
              ],
              [
                4.6,
                8.1
              ],
              [
                3.8,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 66,
    ty: 3,
    parent: 55,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 55,
    ty: 3,
    parent: 23,
    ks: {
      p: {
        a: 0,
        k: [
          19.595,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 70,
    ty: 4,
    parent: 69,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                1.8,
                6.5
              ],
              [
                1.8,
                6.5
              ],
              [
                0.7,
                6
              ],
              [
                0.3,
                4.5
              ],
              [
                0.3,
                4.5
              ],
              [
                0.7,
                3.1
              ],
              [
                1.8,
                2.6
              ],
              [
                1.8,
                2.6
              ],
              [
                2.8,
                3.1
              ],
              [
                3.2,
                4.5
              ],
              [
                3.2,
                4.5
              ],
              [
                2.8,
                6
              ],
              [
                1.8,
                6.5
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                1.8,
                5.9
              ],
              [
                1.8,
                5.9
              ],
              [
                2.3,
                5.6
              ],
              [
                2.5,
                4.5
              ],
              [
                2.5,
                4.5
              ],
              [
                2.3,
                3.5
              ],
              [
                1.8,
                3.2
              ],
              [
                1.8,
                3.2
              ],
              [
                1.3,
                3.5
              ],
              [
                1.1,
                4.5
              ],
              [
                1.1,
                4.5
              ],
              [
                1.3,
                5.6
              ],
              [
                1.8,
                5.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2,
                9
              ],
              [
                5.3,
                2.6
              ],
              [
                6,
                2.6
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                6.2,
                9
              ],
              [
                6.2,
                9
              ],
              [
                5.1,
                8.5
              ],
              [
                4.7,
                7
              ],
              [
                4.7,
                7
              ],
              [
                5.1,
                5.6
              ],
              [
                6.2,
                5.1
              ],
              [
                6.2,
                5.1
              ],
              [
                7.3,
                5.6
              ],
              [
                7.7,
                7
              ],
              [
                7.7,
                7
              ],
              [
                7.3,
                8.5
              ],
              [
                6.2,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                6.2,
                8.4
              ],
              [
                6.2,
                8.4
              ],
              [
                6.7,
                8.1
              ],
              [
                6.9,
                7
              ],
              [
                6.9,
                7
              ],
              [
                6.7,
                6
              ],
              [
                6.2,
                5.7
              ],
              [
                6.2,
                5.7
              ],
              [
                5.7,
                6
              ],
              [
                5.5,
                7
              ],
              [
                5.5,
                7
              ],
              [
                5.7,
                8.1
              ],
              [
                6.2,
                8.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 69,
    ty: 3,
    parent: 68,
    ks: {
      p: {
        a: 0,
        k: [
          9.726,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 72,
    ty: 4,
    parent: 71,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.3,
                9
              ],
              [
                2.3,
                9
              ],
              [
                1.1,
                8.8
              ],
              [
                0.2,
                8.2
              ],
              [
                0.2,
                8.2
              ],
              [
                0.7,
                7.5
              ],
              [
                1.3,
                7.9
              ],
              [
                2.1,
                8.1
              ],
              [
                2.1,
                8.1
              ],
              [
                3,
                7.8
              ],
              [
                3.3,
                7
              ],
              [
                3.3,
                7
              ],
              [
                3,
                6.1
              ],
              [
                2.2,
                5.8
              ],
              [
                2.2,
                5.8
              ],
              [
                1.7,
                5.9
              ],
              [
                1.2,
                6.2
              ],
              [
                1.2,
                6.2
              ],
              [
                0.7,
                5.8
              ],
              [
                0.9,
                2.9
              ],
              [
                4.1,
                2.9
              ],
              [
                4.1,
                3.8
              ],
              [
                1.8,
                3.8
              ],
              [
                1.7,
                5.3
              ],
              [
                2.1,
                5.1
              ],
              [
                2.5,
                5.1
              ],
              [
                2.5,
                5.1
              ],
              [
                3.5,
                5.3
              ],
              [
                4.1,
                5.9
              ],
              [
                4.4,
                6.9
              ],
              [
                4.4,
                6.9
              ],
              [
                4.1,
                8.1
              ],
              [
                3.3,
                8.8
              ],
              [
                2.3,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 71,
    ty: 3,
    parent: 68,
    ks: {
      p: {
        a: 0,
        k: [
          4.863,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 74,
    ty: 4,
    parent: 73,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                4.8
              ],
              [
                1.3,
                6.5
              ],
              [
                2.8,
                6.5
              ],
              [
                2.8,
                5.1
              ],
              [
                2.9,
                4.5
              ],
              [
                2.9,
                3.9
              ],
              [
                2.9,
                3.9
              ],
              [
                2.8,
                3.9
              ],
              [
                2.6,
                4.4
              ],
              [
                2.4,
                4.8
              ],
              [
                2.4,
                4.8
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                3.9,
                8.9
              ],
              [
                2.8,
                8.9
              ],
              [
                2.8,
                7.3
              ],
              [
                0.2,
                7.3
              ],
              [
                0.2,
                6.6
              ],
              [
                2.6,
                2.9
              ],
              [
                3.9,
                2.9
              ],
              [
                3.9,
                6.5
              ],
              [
                4.6,
                6.5
              ],
              [
                4.6,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 73,
    ty: 3,
    parent: 68,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 68,
    ty: 3,
    parent: 23,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 23,
    ty: 3,
    parent: 22,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 22,
    ty: 3,
    parent: 21,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 21,
    ty: 3,
    parent: 20,
    ks: {
      p: {
        a: 0,
        k: [
          17.029,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 83,
    ty: 0,
    parent: 75,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.582
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    w: 10.837,
    h: 10.837,
    ip: 0,
    op: 565,
    st: 0,
    refId: "81"
  },
  {
    ind: 75,
    ty: 3,
    parent: 20,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 20,
    ty: 3,
    parent: 19,
    ks: {
      p: {
        a: 0,
        k: [
          40.144,
          2.709
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 19,
    ty: 3,
    parent: 18,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          35.897
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 183,
    ty: 0,
    parent: 86,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          10.548
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          10.548
        ]
      }
    },
    w: 46.443,
    h: 10.582,
    ip: 0,
    op: 565,
    st: 0,
    refId: "181"
  },
  {
    ind: 86,
    ty: 3,
    parent: 85,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          10.548
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 188,
    ty: 4,
    parent: 187,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.13
              ],
              [
                -0.19,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.11,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.01
              ],
              [
                0.07,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.12
              ],
              [
                0.12,
                -0.29
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.14,
                6.54
              ],
              [
                0.57,
                6.54
              ],
              [
                0.57,
                3.15
              ],
              [
                1.04,
                3.15
              ],
              [
                1.09,
                3.77
              ],
              [
                1.11,
                3.77
              ],
              [
                1.54,
                3.26
              ],
              [
                2.08,
                3.07
              ],
              [
                2.08,
                3.07
              ],
              [
                2.44,
                3.14
              ],
              [
                2.44,
                3.14
              ],
              [
                2.33,
                3.64
              ],
              [
                2.17,
                3.6
              ],
              [
                2,
                3.59
              ],
              [
                2,
                3.59
              ],
              [
                1.55,
                3.76
              ],
              [
                1.14,
                4.37
              ],
              [
                1.14,
                4.37
              ],
              [
                1.14,
                6.54
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.12,
                -0.21
              ],
              [
                0.17,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.13,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.06,
                -0.02
              ],
              [
                -0.05,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0
              ],
              [
                -0.16,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 187,
    ty: 3,
    parent: 186,
    ks: {
      p: {
        a: 0,
        k: [
          15.625,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 190,
    ty: 4,
    parent: 189,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                0.14
              ],
              [
                0.14,
                0.26
              ],
              [
                0,
                0.37
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.23,
                0.14
              ],
              [
                -0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                -0.29
              ],
              [
                0,
                -0.48
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.06
              ],
              [
                0.01,
                -0.04
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.21
              ],
              [
                -0.33,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0.05
              ],
              [
                -0.13,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.18,
                -0.07
              ],
              [
                0.23,
                0
              ]
            ],
            v: [
              [
                1.94,
                6.62
              ],
              [
                1.94,
                6.62
              ],
              [
                1.12,
                6.41
              ],
              [
                0.54,
                5.8
              ],
              [
                0.32,
                4.85
              ],
              [
                0.32,
                4.85
              ],
              [
                0.54,
                3.9
              ],
              [
                1.11,
                3.29
              ],
              [
                1.84,
                3.07
              ],
              [
                1.84,
                3.07
              ],
              [
                2.84,
                3.5
              ],
              [
                3.19,
                4.66
              ],
              [
                3.19,
                4.66
              ],
              [
                3.19,
                4.84
              ],
              [
                3.17,
                4.99
              ],
              [
                3.17,
                4.99
              ],
              [
                0.88,
                4.99
              ],
              [
                1.22,
                5.84
              ],
              [
                2.01,
                6.16
              ],
              [
                2.01,
                6.16
              ],
              [
                2.46,
                6.09
              ],
              [
                2.86,
                5.9
              ],
              [
                2.86,
                5.9
              ],
              [
                3.06,
                6.28
              ],
              [
                2.57,
                6.52
              ],
              [
                1.94,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.25,
                -0.14
              ],
              [
                -0.14,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.37
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.23,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0.43,
                0
              ],
              [
                0.23,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0,
                0.06
              ],
              [
                0,
                0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.02,
                0.36
              ],
              [
                0.2,
                0.21
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0
              ],
              [
                0.14,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0.09
              ],
              [
                -0.18,
                0.07
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.18
              ],
              [
                0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.18
              ],
              [
                0.04,
                -0.33
              ]
            ],
            v: [
              [
                0.88,
                4.58
              ],
              [
                0.88,
                4.58
              ],
              [
                2.69,
                4.58
              ],
              [
                2.47,
                3.79
              ],
              [
                1.85,
                3.52
              ],
              [
                1.85,
                3.52
              ],
              [
                1.22,
                3.8
              ],
              [
                0.88,
                4.58
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.34
              ],
              [
                -0.15,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                0
              ],
              [
                -0.19,
                0.18
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 189,
    ty: 3,
    parent: 186,
    ks: {
      p: {
        a: 0,
        k: [
          12.173,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 192,
    ty: 4,
    parent: 191,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.2,
                6.6
              ],
              [
                1.2,
                6.6
              ],
              [
                0.7,
                6.4
              ],
              [
                0.6,
                5.9
              ],
              [
                0.6,
                5.9
              ],
              [
                0.6,
                1.6
              ],
              [
                1.1,
                1.6
              ],
              [
                1.1,
                5.9
              ],
              [
                1.2,
                6.1
              ],
              [
                1.3,
                6.2
              ],
              [
                1.3,
                6.2
              ],
              [
                1.4,
                6.1
              ],
              [
                1.4,
                6.1
              ],
              [
                1.4,
                6.1
              ],
              [
                1.5,
                6.6
              ],
              [
                1.4,
                6.6
              ],
              [
                1.2,
                6.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 191,
    ty: 3,
    parent: 186,
    ks: {
      p: {
        a: 0,
        k: [
          10.398,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 194,
    ty: 4,
    parent: 193,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                0.17
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.72,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0.04,
                0.13
              ],
              [
                0.1,
                0.08
              ],
              [
                0.19,
                0
              ],
              [
                0,
                0
              ],
              [
                0.17,
                -0.07
              ],
              [
                0.13,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                -0.25
              ],
              [
                0,
                -0.42
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.1
              ],
              [
                0.21,
                0
              ]
            ],
            v: [
              [
                1.35,
                6.62
              ],
              [
                1.35,
                6.62
              ],
              [
                0.64,
                6.37
              ],
              [
                0.36,
                5.66
              ],
              [
                0.36,
                5.66
              ],
              [
                0.86,
                4.81
              ],
              [
                2.44,
                4.39
              ],
              [
                2.44,
                4.39
              ],
              [
                2.38,
                3.98
              ],
              [
                2.17,
                3.67
              ],
              [
                1.74,
                3.54
              ],
              [
                1.74,
                3.54
              ],
              [
                1.19,
                3.66
              ],
              [
                0.73,
                3.91
              ],
              [
                0.73,
                3.91
              ],
              [
                0.51,
                3.51
              ],
              [
                1.09,
                3.21
              ],
              [
                1.84,
                3.07
              ],
              [
                1.84,
                3.07
              ],
              [
                2.74,
                3.45
              ],
              [
                3.02,
                4.46
              ],
              [
                3.02,
                4.46
              ],
              [
                3.02,
                6.54
              ],
              [
                2.54,
                6.54
              ],
              [
                2.49,
                6.14
              ],
              [
                2.47,
                6.14
              ],
              [
                1.95,
                6.48
              ],
              [
                1.35,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.28,
                0
              ],
              [
                -0.19,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.14
              ],
              [
                -0.04,
                -0.13
              ],
              [
                -0.1,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.17,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.1
              ],
              [
                0.23,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.41,
                0
              ],
              [
                0.19,
                0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                0.13
              ],
              [
                -0.19,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0.08
              ],
              [
                -0.16,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.14
              ],
              [
                0,
                -0.22
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                -0.09
              ],
              [
                -0.17,
                0
              ]
            ],
            v: [
              [
                1.52,
                6.16
              ],
              [
                1.52,
                6.16
              ],
              [
                1.98,
                6.05
              ],
              [
                2.44,
                5.71
              ],
              [
                2.44,
                5.71
              ],
              [
                2.44,
                4.77
              ],
              [
                1.26,
                5.08
              ],
              [
                0.92,
                5.62
              ],
              [
                0.92,
                5.62
              ],
              [
                1.09,
                6.04
              ],
              [
                1.52,
                6.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.16,
                0
              ],
              [
                0.14,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.56,
                0.07
              ],
              [
                -0.23,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0.19
              ],
              [
                0.12,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 193,
    ty: 3,
    parent: 186,
    ks: {
      p: {
        a: 0,
        k: [
          6.89,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 196,
    ty: 4,
    parent: 195,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.14
              ],
              [
                0.14,
                0.26
              ],
              [
                0,
                0.37
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.25,
                0.14
              ],
              [
                -0.29,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.08
              ],
              [
                -0.12,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.11,
                0.06
              ],
              [
                0.13,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.11
              ],
              [
                0.09,
                -0.2
              ],
              [
                0,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                -0.24
              ],
              [
                -0.31,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                0.07
              ],
              [
                -0.1,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.08
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.91,
                6.62
              ],
              [
                1.91,
                6.62
              ],
              [
                1.1,
                6.42
              ],
              [
                0.53,
                5.81
              ],
              [
                0.32,
                4.85
              ],
              [
                0.32,
                4.85
              ],
              [
                0.55,
                3.89
              ],
              [
                1.15,
                3.28
              ],
              [
                1.95,
                3.07
              ],
              [
                1.95,
                3.07
              ],
              [
                2.53,
                3.19
              ],
              [
                2.94,
                3.47
              ],
              [
                2.94,
                3.47
              ],
              [
                2.65,
                3.84
              ],
              [
                2.34,
                3.63
              ],
              [
                1.97,
                3.54
              ],
              [
                1.97,
                3.54
              ],
              [
                1.42,
                3.71
              ],
              [
                1.05,
                4.17
              ],
              [
                0.91,
                4.85
              ],
              [
                0.91,
                4.85
              ],
              [
                1.2,
                5.79
              ],
              [
                1.96,
                6.15
              ],
              [
                1.96,
                6.15
              ],
              [
                2.4,
                6.05
              ],
              [
                2.75,
                5.81
              ],
              [
                2.75,
                5.81
              ],
              [
                3,
                6.19
              ],
              [
                2.49,
                6.51
              ],
              [
                1.91,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.24,
                -0.14
              ],
              [
                -0.14,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.38
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.25,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.16,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.09
              ],
              [
                -0.11,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.16,
                0.11
              ],
              [
                -0.09,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.39
              ],
              [
                0.19,
                0.24
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0
              ],
              [
                0.13,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.13
              ],
              [
                -0.19,
                0.08
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 195,
    ty: 3,
    parent: 186,
    ks: {
      p: {
        a: 0,
        k: [
          3.717,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 198,
    ty: 4,
    parent: 197,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                0.12
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.1
              ],
              [
                -0.24,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.14
              ],
              [
                0,
                0.22
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.09
              ],
              [
                0.11,
                0.07
              ],
              [
                0.14,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.1
              ],
              [
                0.1,
                0.15
              ],
              [
                0,
                0.22
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                0.18
              ],
              [
                -0.22,
                0.1
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                -0.1
              ],
              [
                -0.16,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.17,
                0.08
              ],
              [
                0.21,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.12
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.1
              ],
              [
                -0.12,
                -0.06
              ],
              [
                -0.12,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.1
              ],
              [
                -0.08,
                -0.15
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0.13,
                -0.2
              ],
              [
                0.23,
                -0.12
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                1.89,
                6.62
              ],
              [
                1.89,
                6.62
              ],
              [
                1,
                6.44
              ],
              [
                0.29,
                5.95
              ],
              [
                0.29,
                5.95
              ],
              [
                0.64,
                5.54
              ],
              [
                1.22,
                5.96
              ],
              [
                1.9,
                6.12
              ],
              [
                1.9,
                6.12
              ],
              [
                2.61,
                5.91
              ],
              [
                2.86,
                5.37
              ],
              [
                2.86,
                5.37
              ],
              [
                2.76,
                4.99
              ],
              [
                2.48,
                4.76
              ],
              [
                2.1,
                4.56
              ],
              [
                2.1,
                4.56
              ],
              [
                1.44,
                4.28
              ],
              [
                1.01,
                4.04
              ],
              [
                0.66,
                3.66
              ],
              [
                0.52,
                3.1
              ],
              [
                0.52,
                3.1
              ],
              [
                0.7,
                2.48
              ],
              [
                1.21,
                2.04
              ],
              [
                1.95,
                1.89
              ],
              [
                1.95,
                1.89
              ],
              [
                2.71,
                2.04
              ],
              [
                3.3,
                2.45
              ],
              [
                3.3,
                2.45
              ],
              [
                2.99,
                2.83
              ],
              [
                2.53,
                2.51
              ],
              [
                1.95,
                2.4
              ],
              [
                1.95,
                2.4
              ],
              [
                1.33,
                2.58
              ],
              [
                1.1,
                3.06
              ],
              [
                1.1,
                3.06
              ],
              [
                1.22,
                3.42
              ],
              [
                1.5,
                3.66
              ],
              [
                1.86,
                3.82
              ],
              [
                1.86,
                3.82
              ],
              [
                2.51,
                4.1
              ],
              [
                2.99,
                4.37
              ],
              [
                3.32,
                4.75
              ],
              [
                3.45,
                5.32
              ],
              [
                3.45,
                5.32
              ],
              [
                3.26,
                5.98
              ],
              [
                2.72,
                6.45
              ],
              [
                1.89,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.27,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.17
              ],
              [
                0.22,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.17,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.16
              ],
              [
                -0.07,
                -0.09
              ],
              [
                -0.11,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.06
              ],
              [
                -0.14,
                -0.1
              ],
              [
                -0.1,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.23
              ],
              [
                0.12,
                -0.18
              ],
              [
                0.22,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.27,
                0
              ],
              [
                0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.13
              ],
              [
                -0.17,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                -0.26,
                0
              ],
              [
                -0.16,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0.14
              ],
              [
                0.08,
                0.1
              ],
              [
                0.12,
                0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0.07
              ],
              [
                0.14,
                0.1
              ],
              [
                0.08,
                0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                0.24
              ],
              [
                -0.13,
                0.2
              ],
              [
                -0.23,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 197,
    ty: 3,
    parent: 186,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 186,
    ty: 3,
    parent: 185,
    ks: {
      p: {
        a: 0,
        k: [
          14.372,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 201,
    ty: 4,
    parent: 200,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.21
              ],
              [
                0,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.11
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.07,
                0.02
              ],
              [
                -0.06,
                0.02
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.11,
                -0.03
              ],
              [
                0.11,
                0
              ]
            ],
            v: [
              [
                1.64,
                6.62
              ],
              [
                1.64,
                6.62
              ],
              [
                0.88,
                6.31
              ],
              [
                0.67,
                5.5
              ],
              [
                0.67,
                5.5
              ],
              [
                0.67,
                3.62
              ],
              [
                0.17,
                3.62
              ],
              [
                0.17,
                3.19
              ],
              [
                0.7,
                3.15
              ],
              [
                0.77,
                2.21
              ],
              [
                1.25,
                2.21
              ],
              [
                1.25,
                3.15
              ],
              [
                2.16,
                3.15
              ],
              [
                2.16,
                3.62
              ],
              [
                1.25,
                3.62
              ],
              [
                1.25,
                5.5
              ],
              [
                1.36,
                5.99
              ],
              [
                1.77,
                6.16
              ],
              [
                1.77,
                6.16
              ],
              [
                1.96,
                6.13
              ],
              [
                2.15,
                6.07
              ],
              [
                2.15,
                6.07
              ],
              [
                2.26,
                6.5
              ],
              [
                1.96,
                6.59
              ],
              [
                1.64,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.36,
                0
              ],
              [
                -0.14,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.08,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.06,
                0
              ],
              [
                0.07,
                -0.02
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.09,
                0.03
              ],
              [
                -0.11,
                0.03
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 200,
    ty: 3,
    parent: 199,
    ks: {
      p: {
        a: 0,
        k: [
          10.628,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 203,
    ty: 4,
    parent: 202,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0.09
              ],
              [
                0.16,
                0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.08
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.11,
                0.1
              ],
              [
                0,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0.08,
                0.08
              ],
              [
                0.12,
                0.05
              ],
              [
                0.13,
                0.05
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.08
              ],
              [
                0.1,
                0.12
              ],
              [
                0,
                0.19
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                -0.07
              ],
              [
                -0.13,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.13,
                0.06
              ],
              [
                0.15,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                -0.07,
                -0.07
              ],
              [
                -0.11,
                -0.05
              ],
              [
                -0.13,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.08
              ],
              [
                -0.1,
                -0.13
              ],
              [
                0,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.15
              ],
              [
                0.18,
                -0.09
              ],
              [
                0.27,
                0
              ]
            ],
            v: [
              [
                1.46,
                6.62
              ],
              [
                1.46,
                6.62
              ],
              [
                0.77,
                6.49
              ],
              [
                0.2,
                6.16
              ],
              [
                0.2,
                6.16
              ],
              [
                0.48,
                5.77
              ],
              [
                0.94,
                6.06
              ],
              [
                1.48,
                6.18
              ],
              [
                1.48,
                6.18
              ],
              [
                1.98,
                6.02
              ],
              [
                2.15,
                5.65
              ],
              [
                2.15,
                5.65
              ],
              [
                2.03,
                5.36
              ],
              [
                1.74,
                5.16
              ],
              [
                1.37,
                5.01
              ],
              [
                1.37,
                5.01
              ],
              [
                0.91,
                4.8
              ],
              [
                0.53,
                4.5
              ],
              [
                0.38,
                4.03
              ],
              [
                0.38,
                4.03
              ],
              [
                0.69,
                3.35
              ],
              [
                1.55,
                3.07
              ],
              [
                1.55,
                3.07
              ],
              [
                2.14,
                3.18
              ],
              [
                2.61,
                3.45
              ],
              [
                2.61,
                3.45
              ],
              [
                2.33,
                3.82
              ],
              [
                1.96,
                3.6
              ],
              [
                1.55,
                3.52
              ],
              [
                1.55,
                3.52
              ],
              [
                1.08,
                3.66
              ],
              [
                0.93,
                4
              ],
              [
                0.93,
                4
              ],
              [
                1.04,
                4.27
              ],
              [
                1.31,
                4.44
              ],
              [
                1.66,
                4.59
              ],
              [
                1.66,
                4.59
              ],
              [
                2.15,
                4.8
              ],
              [
                2.54,
                5.1
              ],
              [
                2.7,
                5.61
              ],
              [
                2.7,
                5.61
              ],
              [
                2.55,
                6.12
              ],
              [
                2.14,
                6.48
              ],
              [
                1.46,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.24,
                0
              ],
              [
                -0.22,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.12
              ],
              [
                0.16,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.11,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.12
              ],
              [
                -0.08,
                -0.08
              ],
              [
                -0.12,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.06
              ],
              [
                -0.15,
                -0.08
              ],
              [
                -0.1,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.27
              ],
              [
                0.21,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                0.21,
                0
              ],
              [
                0.18,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                -0.09
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.11
              ],
              [
                0.07,
                0.07
              ],
              [
                0.11,
                0.05
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.06
              ],
              [
                0.16,
                0.08
              ],
              [
                0.1,
                0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0.18
              ],
              [
                -0.1,
                0.15
              ],
              [
                -0.18,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 202,
    ty: 3,
    parent: 199,
    ks: {
      p: {
        a: 0,
        k: [
          7.712,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 205,
    ty: 4,
    parent: 204,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.14
              ],
              [
                0.15,
                0.26
              ],
              [
                0,
                0.37
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.24,
                0.14
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                -0.14
              ],
              [
                -0.15,
                -0.26
              ],
              [
                0,
                -0.38
              ],
              [
                0,
                0
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.24,
                -0.14
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.89,
                6.62
              ],
              [
                1.89,
                6.62
              ],
              [
                1.12,
                6.42
              ],
              [
                0.54,
                5.81
              ],
              [
                0.32,
                4.85
              ],
              [
                0.32,
                4.85
              ],
              [
                0.54,
                3.89
              ],
              [
                1.12,
                3.28
              ],
              [
                1.89,
                3.07
              ],
              [
                1.89,
                3.07
              ],
              [
                2.66,
                3.28
              ],
              [
                3.24,
                3.89
              ],
              [
                3.46,
                4.85
              ],
              [
                3.46,
                4.85
              ],
              [
                3.24,
                5.81
              ],
              [
                2.66,
                6.42
              ],
              [
                1.89,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.24,
                -0.14
              ],
              [
                -0.15,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.38
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.24,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0.28,
                0
              ],
              [
                0.24,
                0.14
              ],
              [
                0.15,
                0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                0.37
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.24,
                0.14
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0.24
              ],
              [
                0,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0.24
              ],
              [
                0.29,
                0
              ],
              [
                0,
                0
              ],
              [
                0.18,
                -0.24
              ],
              [
                0,
                -0.39
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                -0.24
              ],
              [
                -0.29,
                0
              ]
            ],
            v: [
              [
                1.89,
                6.15
              ],
              [
                1.89,
                6.15
              ],
              [
                2.6,
                5.79
              ],
              [
                2.86,
                4.85
              ],
              [
                2.86,
                4.85
              ],
              [
                2.6,
                3.91
              ],
              [
                1.89,
                3.54
              ],
              [
                1.89,
                3.54
              ],
              [
                1.18,
                3.91
              ],
              [
                0.91,
                4.85
              ],
              [
                0.91,
                4.85
              ],
              [
                1.18,
                5.79
              ],
              [
                1.89,
                6.15
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.29,
                0
              ],
              [
                0.18,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.39
              ],
              [
                -0.18,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                0
              ],
              [
                -0.18,
                0.24
              ],
              [
                0,
                0
              ],
              [
                0,
                0.39
              ],
              [
                0.18,
                0.24
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 204,
    ty: 3,
    parent: 199,
    ks: {
      p: {
        a: 0,
        k: [
          3.939,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 207,
    ty: 4,
    parent: 206,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.26,
                -0.08
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.23
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.21,
                6.54
              ],
              [
                0.63,
                6.54
              ],
              [
                0.63,
                1.97
              ],
              [
                1.93,
                1.97
              ],
              [
                2.83,
                2.1
              ],
              [
                3.43,
                2.52
              ],
              [
                3.64,
                3.31
              ],
              [
                3.64,
                3.31
              ],
              [
                3.18,
                4.38
              ],
              [
                1.96,
                4.73
              ],
              [
                1.96,
                4.73
              ],
              [
                1.21,
                4.73
              ],
              [
                1.21,
                6.54
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0
              ],
              [
                0.26,
                0.08
              ],
              [
                0.14,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.48
              ],
              [
                -0.31,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.15
              ],
              [
                0,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.13
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.21,
                2.44
              ],
              [
                1.21,
                4.26
              ],
              [
                1.89,
                4.26
              ],
              [
                2.78,
                4.03
              ],
              [
                3.07,
                3.31
              ],
              [
                3.07,
                3.31
              ],
              [
                2.76,
                2.63
              ],
              [
                1.86,
                2.44
              ],
              [
                1.86,
                2.44
              ],
              [
                1.21,
                2.44
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.19,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.33
              ],
              [
                -0.2,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 206,
    ty: 3,
    parent: 199,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 199,
    ty: 3,
    parent: 185,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 185,
    ty: 3,
    parent: 184,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 184,
    ty: 3,
    parent: 85,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 85,
    ty: 3,
    parent: 84,
    ks: {
      p: {
        a: 0,
        k: [
          143.636,
          1.965
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 213,
    ty: 0,
    parent: 209,
    ks: {},
    w: 21,
    h: 10,
    ip: 0,
    op: 565,
    st: 0,
    refId: "211"
  },
  {
    ind: 209,
    ty: 3,
    parent: 208,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 208,
    ty: 3,
    parent: 84,
    ks: {
      p: {
        a: 0,
        k: [
          115.383,
          7.839
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 219,
    ty: 4,
    parent: 218,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                10.2
              ],
              [
                0.9,
                10.2
              ],
              [
                0.9,
                2.5
              ],
              [
                1.8,
                2.5
              ],
              [
                1.8,
                7.7
              ],
              [
                1.8,
                7.7
              ],
              [
                4,
                4.9
              ],
              [
                5,
                4.9
              ],
              [
                3.3,
                7
              ],
              [
                5.3,
                10.2
              ],
              [
                4.3,
                10.2
              ],
              [
                2.8,
                7.6
              ],
              [
                1.8,
                8.8
              ],
              [
                1.8,
                10.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 218,
    ty: 3,
    parent: 217,
    ks: {
      p: {
        a: 0,
        k: [
          38.847,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 221,
    ty: 4,
    parent: 220,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.4
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.2,
                -0.4
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.4,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.9,
                10.3
              ],
              [
                2.9,
                10.3
              ],
              [
                1.7,
                10
              ],
              [
                0.8,
                9
              ],
              [
                0.5,
                7.6
              ],
              [
                0.5,
                7.6
              ],
              [
                0.8,
                6
              ],
              [
                1.7,
                5.1
              ],
              [
                2.9,
                4.8
              ],
              [
                2.9,
                4.8
              ],
              [
                4.1,
                5.1
              ],
              [
                5,
                6
              ],
              [
                5.4,
                7.6
              ],
              [
                5.4,
                7.6
              ],
              [
                5,
                9
              ],
              [
                4.1,
                10
              ],
              [
                2.9,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.2,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.4,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.4
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.4
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                -0.4,
                0
              ]
            ],
            v: [
              [
                2.9,
                9.6
              ],
              [
                2.9,
                9.6
              ],
              [
                4,
                9
              ],
              [
                4.5,
                7.6
              ],
              [
                4.5,
                7.6
              ],
              [
                4,
                6.1
              ],
              [
                2.9,
                5.5
              ],
              [
                2.9,
                5.5
              ],
              [
                1.8,
                6.1
              ],
              [
                1.4,
                7.6
              ],
              [
                1.4,
                7.6
              ],
              [
                1.8,
                9
              ],
              [
                2.9,
                9.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 220,
    ty: 3,
    parent: 217,
    ks: {
      p: {
        a: 0,
        k: [
          32.977,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 223,
    ty: 4,
    parent: 222,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.4
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.2,
                -0.4
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.4,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.9,
                10.3
              ],
              [
                2.9,
                10.3
              ],
              [
                1.7,
                10
              ],
              [
                0.8,
                9
              ],
              [
                0.5,
                7.6
              ],
              [
                0.5,
                7.6
              ],
              [
                0.8,
                6
              ],
              [
                1.7,
                5.1
              ],
              [
                2.9,
                4.8
              ],
              [
                2.9,
                4.8
              ],
              [
                4.1,
                5.1
              ],
              [
                5,
                6
              ],
              [
                5.4,
                7.6
              ],
              [
                5.4,
                7.6
              ],
              [
                5,
                9
              ],
              [
                4.1,
                10
              ],
              [
                2.9,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.2,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.4,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.4
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.4
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                -0.4,
                0
              ]
            ],
            v: [
              [
                2.9,
                9.6
              ],
              [
                2.9,
                9.6
              ],
              [
                4,
                9
              ],
              [
                4.5,
                7.6
              ],
              [
                4.5,
                7.6
              ],
              [
                4,
                6.1
              ],
              [
                2.9,
                5.5
              ],
              [
                2.9,
                5.5
              ],
              [
                1.8,
                6.1
              ],
              [
                1.4,
                7.6
              ],
              [
                1.4,
                7.6
              ],
              [
                1.8,
                9
              ],
              [
                2.9,
                9.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 222,
    ty: 3,
    parent: 217,
    ks: {
      p: {
        a: 0,
        k: [
          27.107,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 225,
    ty: 4,
    parent: 224,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                3.2,
                10.3
              ],
              [
                3.2,
                10.3
              ],
              [
                2.5,
                10.1
              ],
              [
                1.7,
                9.6
              ],
              [
                1.7,
                9.6
              ],
              [
                1.7,
                9.6
              ],
              [
                1.6,
                10.2
              ],
              [
                0.9,
                10.2
              ],
              [
                0.9,
                2.5
              ],
              [
                1.8,
                2.5
              ],
              [
                1.8,
                4.6
              ],
              [
                1.8,
                5.5
              ],
              [
                2.5,
                5
              ],
              [
                3.4,
                4.8
              ],
              [
                3.4,
                4.8
              ],
              [
                5,
                5.5
              ],
              [
                5.5,
                7.5
              ],
              [
                5.5,
                7.5
              ],
              [
                5.2,
                9
              ],
              [
                4.3,
                10
              ],
              [
                3.2,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.4
              ],
              [
                0,
                0.7
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.4
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                3.1,
                9.6
              ],
              [
                3.1,
                9.6
              ],
              [
                4.1,
                9
              ],
              [
                4.6,
                7.5
              ],
              [
                4.6,
                7.5
              ],
              [
                4.3,
                6.1
              ],
              [
                3.2,
                5.5
              ],
              [
                3.2,
                5.5
              ],
              [
                2.5,
                5.7
              ],
              [
                1.8,
                6.2
              ],
              [
                1.8,
                6.2
              ],
              [
                1.8,
                9
              ],
              [
                2.5,
                9.4
              ],
              [
                3.1,
                9.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                -0.2,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 224,
    ty: 3,
    parent: 217,
    ks: {
      p: {
        a: 0,
        k: [
          21.118,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 227,
    ty: 4,
    parent: 226,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.4
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                3,
                10.3
              ],
              [
                3,
                10.3
              ],
              [
                1.7,
                10
              ],
              [
                0.8,
                9
              ],
              [
                0.5,
                7.6
              ],
              [
                0.5,
                7.6
              ],
              [
                0.8,
                6.1
              ],
              [
                1.7,
                5.1
              ],
              [
                2.9,
                4.8
              ],
              [
                2.9,
                4.8
              ],
              [
                4.4,
                5.4
              ],
              [
                5,
                7.2
              ],
              [
                5,
                7.2
              ],
              [
                5,
                7.5
              ],
              [
                4.9,
                7.8
              ],
              [
                4.9,
                7.8
              ],
              [
                1.4,
                7.8
              ],
              [
                1.9,
                9.1
              ],
              [
                3.1,
                9.6
              ],
              [
                3.1,
                9.6
              ],
              [
                3.8,
                9.5
              ],
              [
                4.4,
                9.2
              ],
              [
                4.4,
                9.2
              ],
              [
                4.8,
                9.8
              ],
              [
                4,
                10.1
              ],
              [
                3,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.2,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.1,
                -0.5
              ]
            ],
            v: [
              [
                1.4,
                7.1
              ],
              [
                1.4,
                7.1
              ],
              [
                4.2,
                7.1
              ],
              [
                3.8,
                5.9
              ],
              [
                2.9,
                5.5
              ],
              [
                2.9,
                5.5
              ],
              [
                1.9,
                5.9
              ],
              [
                1.4,
                7.1
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 226,
    ty: 3,
    parent: 217,
    ks: {
      p: {
        a: 0,
        k: [
          15.747,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 229,
    ty: 4,
    parent: 228,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.4
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                3,
                10.3
              ],
              [
                3,
                10.3
              ],
              [
                1.7,
                10
              ],
              [
                0.8,
                9
              ],
              [
                0.5,
                7.6
              ],
              [
                0.5,
                7.6
              ],
              [
                0.9,
                6
              ],
              [
                1.8,
                5.1
              ],
              [
                3,
                4.8
              ],
              [
                3,
                4.8
              ],
              [
                3.9,
                5
              ],
              [
                4.6,
                5.4
              ],
              [
                4.6,
                5.4
              ],
              [
                4.1,
                6
              ],
              [
                3.6,
                5.6
              ],
              [
                3.1,
                5.5
              ],
              [
                3.1,
                5.5
              ],
              [
                2.2,
                5.8
              ],
              [
                1.6,
                6.5
              ],
              [
                1.4,
                7.6
              ],
              [
                1.4,
                7.6
              ],
              [
                1.9,
                9
              ],
              [
                3,
                9.6
              ],
              [
                3,
                9.6
              ],
              [
                3.7,
                9.4
              ],
              [
                4.3,
                9
              ],
              [
                4.3,
                9
              ],
              [
                4.7,
                9.6
              ],
              [
                3.9,
                10.1
              ],
              [
                3,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.2,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 228,
    ty: 3,
    parent: 217,
    ks: {
      p: {
        a: 0,
        k: [
          10.808,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 231,
    ty: 4,
    parent: 230,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.5,
                0.3
              ],
              [
                -1.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.7
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.1,
                10.3
              ],
              [
                2.1,
                10.3
              ],
              [
                1,
                9.9
              ],
              [
                0.6,
                8.8
              ],
              [
                0.6,
                8.8
              ],
              [
                1.3,
                7.5
              ],
              [
                3.8,
                6.8
              ],
              [
                3.8,
                6.8
              ],
              [
                3.7,
                6.2
              ],
              [
                3.4,
                5.7
              ],
              [
                2.7,
                5.5
              ],
              [
                2.7,
                5.5
              ],
              [
                1.9,
                5.7
              ],
              [
                1.1,
                6.1
              ],
              [
                1.1,
                6.1
              ],
              [
                0.8,
                5.5
              ],
              [
                1.7,
                5
              ],
              [
                2.9,
                4.8
              ],
              [
                2.9,
                4.8
              ],
              [
                4.3,
                5.4
              ],
              [
                4.7,
                6.9
              ],
              [
                4.7,
                6.9
              ],
              [
                4.7,
                10.2
              ],
              [
                4,
                10.2
              ],
              [
                3.9,
                9.5
              ],
              [
                3.8,
                9.5
              ],
              [
                3,
                10.1
              ],
              [
                2.1,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.5,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.4,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.4,
                9.6
              ],
              [
                2.4,
                9.6
              ],
              [
                3.1,
                9.4
              ],
              [
                3.8,
                8.9
              ],
              [
                3.8,
                8.9
              ],
              [
                3.8,
                7.4
              ],
              [
                2,
                7.9
              ],
              [
                1.4,
                8.7
              ],
              [
                1.4,
                8.7
              ],
              [
                1.7,
                9.4
              ],
              [
                2.4,
                9.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.9,
                0.1
              ],
              [
                -0.4,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 230,
    ty: 3,
    parent: 217,
    ks: {
      p: {
        a: 0,
        k: [
          5.35,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 233,
    ty: 4,
    parent: 232,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.9,
                10.2
              ],
              [
                1,
                10.2
              ],
              [
                1,
                3.1
              ],
              [
                5.1,
                3.1
              ],
              [
                5.1,
                3.8
              ],
              [
                1.9,
                3.8
              ],
              [
                1.9,
                6.2
              ],
              [
                4.6,
                6.2
              ],
              [
                4.6,
                7
              ],
              [
                1.9,
                7
              ],
              [
                1.9,
                10.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 232,
    ty: 3,
    parent: 217,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 217,
    ty: 3,
    parent: 216,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 216,
    ty: 3,
    parent: 215,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 215,
    ty: 3,
    parent: 214,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          11.514
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 238,
    ty: 0,
    parent: 234,
    ks: {},
    w: 62,
    h: 12,
    ip: 0,
    op: 565,
    st: 0,
    refId: "236"
  },
  {
    ind: 234,
    ty: 3,
    parent: 214,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 214,
    ty: 3,
    parent: 84,
    ks: {
      p: {
        a: 0,
        k: [
          21.238,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 84,
    ty: 3,
    parent: 18,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 18,
    ty: 3,
    parent: 17,
    ks: {
      p: {
        a: 0,
        k: [
          8.128,
          78.567
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 247,
    ty: 4,
    parent: 246,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                4.3
              ],
              [
                1.6,
                4.3
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.3
              ],
              [
                1.2,
                3.3
              ],
              [
                0.8,
                3.2
              ],
              [
                0.7,
                2.8
              ],
              [
                0.7,
                2.8
              ],
              [
                0.8,
                2.5
              ],
              [
                1.2,
                2.3
              ],
              [
                1.2,
                2.3
              ],
              [
                1.6,
                2.5
              ],
              [
                1.7,
                2.8
              ],
              [
                1.7,
                2.8
              ],
              [
                1.6,
                3.2
              ],
              [
                1.2,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 246,
    ty: 3,
    parent: 245,
    ks: {
      p: {
        a: 0,
        k: [
          18.107,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 249,
    ty: 4,
    parent: 248,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                2.2
              ],
              [
                1.6,
                2.2
              ],
              [
                1.6,
                4
              ],
              [
                1.5,
                4.9
              ],
              [
                2.2,
                4.4
              ],
              [
                3.1,
                4.2
              ],
              [
                3.1,
                4.2
              ],
              [
                4.1,
                4.6
              ],
              [
                4.5,
                6
              ],
              [
                4.5,
                6
              ],
              [
                4.5,
                8.9
              ],
              [
                3.7,
                8.9
              ],
              [
                3.7,
                6.1
              ],
              [
                3.5,
                5.1
              ],
              [
                2.8,
                4.9
              ],
              [
                2.8,
                4.9
              ],
              [
                2.2,
                5
              ],
              [
                1.6,
                5.6
              ],
              [
                1.6,
                5.6
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 248,
    ty: 3,
    parent: 245,
    ks: {
      p: {
        a: 0,
        k: [
          12.95,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 251,
    ty: 4,
    parent: 250,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.1
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.6,
                9
              ],
              [
                1.6,
                9
              ],
              [
                1,
                8.7
              ],
              [
                0.8,
                8
              ],
              [
                0.8,
                8
              ],
              [
                0.8,
                2.2
              ],
              [
                1.6,
                2.2
              ],
              [
                1.6,
                8
              ],
              [
                1.6,
                8.3
              ],
              [
                1.8,
                8.4
              ],
              [
                1.8,
                8.4
              ],
              [
                1.8,
                8.4
              ],
              [
                1.9,
                8.4
              ],
              [
                1.9,
                8.4
              ],
              [
                2,
                8.9
              ],
              [
                1.9,
                9
              ],
              [
                1.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 250,
    ty: 3,
    parent: 245,
    ks: {
      p: {
        a: 0,
        k: [
          10.532,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 253,
    ty: 4,
    parent: 252,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.2
              ],
              [
                -0.35,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.39
              ],
              [
                0,
                -0.66
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.08
              ],
              [
                0.01,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                -0.29
              ],
              [
                -0.44,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.07
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.09
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                2.65,
                9.02
              ],
              [
                2.65,
                9.02
              ],
              [
                1.53,
                8.73
              ],
              [
                0.73,
                7.9
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.31
              ],
              [
                1.51,
                4.47
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.86,
                4.77
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.58
              ],
              [
                4.31,
                6.79
              ],
              [
                4.31,
                6.79
              ],
              [
                1.2,
                6.79
              ],
              [
                1.66,
                7.95
              ],
              [
                2.74,
                8.39
              ],
              [
                2.74,
                8.39
              ],
              [
                3.35,
                8.29
              ],
              [
                3.89,
                8.03
              ],
              [
                3.89,
                8.03
              ],
              [
                4.16,
                8.54
              ],
              [
                3.49,
                8.87
              ],
              [
                2.65,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.41,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.59,
                0
              ],
              [
                0.32,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.03,
                0.49
              ],
              [
                0.27,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.19,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.13
              ],
              [
                -0.25,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.24
              ],
              [
                0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.25
              ],
              [
                0.05,
                -0.46
              ]
            ],
            v: [
              [
                1.19,
                6.23
              ],
              [
                1.19,
                6.23
              ],
              [
                3.66,
                6.23
              ],
              [
                3.36,
                5.16
              ],
              [
                2.52,
                4.8
              ],
              [
                2.52,
                4.8
              ],
              [
                1.65,
                5.17
              ],
              [
                1.19,
                6.23
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.47
              ],
              [
                -0.2,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.26,
                0.25
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 252,
    ty: 3,
    parent: 245,
    ks: {
      p: {
        a: 0,
        k: [
          5.83,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 255,
    ty: 4,
    parent: 254,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.5,
                -0.5
              ],
              [
                0,
                -1
              ],
              [
                0,
                0
              ],
              [
                0.5,
                -0.5
              ],
              [
                0.9,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                2.7
              ],
              [
                2.4,
                2.7
              ],
              [
                4.6,
                3.5
              ],
              [
                5.3,
                5.8
              ],
              [
                5.3,
                5.8
              ],
              [
                4.6,
                8.1
              ],
              [
                2.4,
                8.9
              ],
              [
                2.4,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                1,
                0
              ],
              [
                0.5,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                1
              ],
              [
                -0.5,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.4
              ],
              [
                0,
                0.8
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0.7,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                3.3
              ],
              [
                1.6,
                8.3
              ],
              [
                2.4,
                8.3
              ],
              [
                4,
                7.6
              ],
              [
                4.5,
                5.8
              ],
              [
                4.5,
                5.8
              ],
              [
                4,
                4
              ],
              [
                2.4,
                3.3
              ],
              [
                2.4,
                3.3
              ],
              [
                1.6,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.8
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 254,
    ty: 3,
    parent: 245,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 245,
    ty: 3,
    parent: 244,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 244,
    ty: 3,
    parent: 243,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 243,
    ty: 3,
    parent: 242,
    ks: {
      p: {
        a: 0,
        k: [
          16.255,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 265,
    ty: 0,
    parent: 256,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.582
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    w: 10.837,
    h: 10.837,
    ip: 0,
    op: 565,
    st: 0,
    refId: "263"
  },
  {
    ind: 256,
    ty: 3,
    parent: 242,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 242,
    ty: 3,
    parent: 241,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          14.709
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 271,
    ty: 4,
    parent: 270,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                2.2,
                9
              ],
              [
                2.2,
                9
              ],
              [
                1.2,
                8.6
              ],
              [
                0.9,
                7.5
              ],
              [
                0.9,
                7.5
              ],
              [
                0.9,
                4.9
              ],
              [
                0.2,
                4.9
              ],
              [
                0.2,
                4.3
              ],
              [
                0.9,
                4.3
              ],
              [
                1,
                3
              ],
              [
                1.7,
                3
              ],
              [
                1.7,
                4.3
              ],
              [
                2.9,
                4.3
              ],
              [
                2.9,
                4.9
              ],
              [
                1.7,
                4.9
              ],
              [
                1.7,
                7.5
              ],
              [
                1.9,
                8.1
              ],
              [
                2.4,
                8.4
              ],
              [
                2.4,
                8.4
              ],
              [
                2.7,
                8.3
              ],
              [
                2.9,
                8.3
              ],
              [
                2.9,
                8.3
              ],
              [
                3.1,
                8.8
              ],
              [
                2.7,
                9
              ],
              [
                2.2,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 270,
    ty: 3,
    parent: 269,
    ks: {
      p: {
        a: 0,
        k: [
          31.113,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 273,
    ty: 4,
    parent: 272,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.12
              ],
              [
                0.22,
                0.18
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                -0.1
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.14
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.11
              ],
              [
                0.16,
                0.07
              ],
              [
                0.17,
                0.06
              ],
              [
                0,
                0
              ],
              [
                0.21,
                0.1
              ],
              [
                0.13,
                0.17
              ],
              [
                0,
                0.26
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                0.25
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.1
              ],
              [
                -0.18,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.17,
                0.08
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                -0.13
              ],
              [
                0,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.09,
                -0.09
              ],
              [
                -0.15,
                -0.07
              ],
              [
                -0.17,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                -0.1
              ],
              [
                -0.14,
                -0.17
              ],
              [
                0,
                -0.29
              ],
              [
                0,
                0
              ],
              [
                0.13,
                -0.21
              ],
              [
                0.25,
                -0.13
              ],
              [
                0.37,
                0
              ]
            ],
            v: [
              [
                1.98,
                9.02
              ],
              [
                1.98,
                9.02
              ],
              [
                1.04,
                8.83
              ],
              [
                0.27,
                8.38
              ],
              [
                0.27,
                8.38
              ],
              [
                0.65,
                7.86
              ],
              [
                1.28,
                8.25
              ],
              [
                2.01,
                8.41
              ],
              [
                2.01,
                8.41
              ],
              [
                2.69,
                8.2
              ],
              [
                2.92,
                7.69
              ],
              [
                2.92,
                7.69
              ],
              [
                2.76,
                7.29
              ],
              [
                2.37,
                7.02
              ],
              [
                1.87,
                6.82
              ],
              [
                1.87,
                6.82
              ],
              [
                1.23,
                6.54
              ],
              [
                0.72,
                6.13
              ],
              [
                0.52,
                5.49
              ],
              [
                0.52,
                5.49
              ],
              [
                0.94,
                4.55
              ],
              [
                2.11,
                4.18
              ],
              [
                2.11,
                4.18
              ],
              [
                2.91,
                4.33
              ],
              [
                3.55,
                4.7
              ],
              [
                3.55,
                4.7
              ],
              [
                3.17,
                5.19
              ],
              [
                2.67,
                4.9
              ],
              [
                2.11,
                4.79
              ],
              [
                2.11,
                4.79
              ],
              [
                1.47,
                4.99
              ],
              [
                1.27,
                5.45
              ],
              [
                1.27,
                5.45
              ],
              [
                1.41,
                5.81
              ],
              [
                1.78,
                6.04
              ],
              [
                2.27,
                6.25
              ],
              [
                2.27,
                6.25
              ],
              [
                2.92,
                6.53
              ],
              [
                3.46,
                6.94
              ],
              [
                3.67,
                7.64
              ],
              [
                3.67,
                7.64
              ],
              [
                3.48,
                8.32
              ],
              [
                2.91,
                8.83
              ],
              [
                1.98,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.33,
                0
              ],
              [
                -0.3,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.16
              ],
              [
                0.21,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.15,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.16
              ],
              [
                -0.1,
                -0.11
              ],
              [
                -0.16,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                -0.08
              ],
              [
                -0.21,
                -0.1
              ],
              [
                -0.13,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.37
              ],
              [
                0.28,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0.28,
                0
              ],
              [
                0.25,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.17,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                0
              ],
              [
                -0.14,
                0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0.15
              ],
              [
                0.09,
                0.09
              ],
              [
                0.15,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0.08
              ],
              [
                0.21,
                0.1
              ],
              [
                0.14,
                0.17
              ],
              [
                0,
                0
              ],
              [
                0,
                0.25
              ],
              [
                -0.13,
                0.21
              ],
              [
                -0.25,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 272,
    ty: 3,
    parent: 269,
    ks: {
      p: {
        a: 0,
        k: [
          27.141,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 275,
    ty: 4,
    parent: 274,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                4.3
              ],
              [
                1.6,
                4.3
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.3
              ],
              [
                1.2,
                3.3
              ],
              [
                0.8,
                3.2
              ],
              [
                0.7,
                2.8
              ],
              [
                0.7,
                2.8
              ],
              [
                0.8,
                2.5
              ],
              [
                1.2,
                2.3
              ],
              [
                1.2,
                2.3
              ],
              [
                1.6,
                2.5
              ],
              [
                1.7,
                2.8
              ],
              [
                1.7,
                2.8
              ],
              [
                1.6,
                3.2
              ],
              [
                1.2,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 274,
    ty: 3,
    parent: 269,
    ks: {
      p: {
        a: 0,
        k: [
          24.809,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 277,
    ty: 4,
    parent: 276,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                2.2,
                9
              ],
              [
                2.2,
                9
              ],
              [
                1.2,
                8.6
              ],
              [
                0.9,
                7.5
              ],
              [
                0.9,
                7.5
              ],
              [
                0.9,
                4.9
              ],
              [
                0.2,
                4.9
              ],
              [
                0.2,
                4.3
              ],
              [
                0.9,
                4.3
              ],
              [
                1,
                3
              ],
              [
                1.7,
                3
              ],
              [
                1.7,
                4.3
              ],
              [
                2.9,
                4.3
              ],
              [
                2.9,
                4.9
              ],
              [
                1.7,
                4.9
              ],
              [
                1.7,
                7.5
              ],
              [
                1.9,
                8.1
              ],
              [
                2.4,
                8.4
              ],
              [
                2.4,
                8.4
              ],
              [
                2.7,
                8.3
              ],
              [
                2.9,
                8.3
              ],
              [
                2.9,
                8.3
              ],
              [
                3.1,
                8.8
              ],
              [
                2.7,
                9
              ],
              [
                2.2,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 276,
    ty: 3,
    parent: 269,
    ks: {
      p: {
        a: 0,
        k: [
          21.605,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 279,
    ty: 4,
    parent: 278,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                0.15
              ],
              [
                -0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.31
              ],
              [
                0,
                -0.59
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.12
              ],
              [
                0.23,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                4.96
              ],
              [
                1.52,
                4.96
              ],
              [
                2.22,
                4.4
              ],
              [
                3.06,
                4.18
              ],
              [
                3.06,
                4.18
              ],
              [
                4.13,
                4.64
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                8.9
              ],
              [
                3.69,
                8.9
              ],
              [
                3.69,
                6.09
              ],
              [
                3.48,
                5.15
              ],
              [
                2.82,
                4.85
              ],
              [
                2.82,
                4.85
              ],
              [
                2.19,
                5.03
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.22
              ],
              [
                0.25,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0.49,
                0
              ],
              [
                0.22,
                0.31
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.43
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.19,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 278,
    ty: 3,
    parent: 269,
    ks: {
      p: {
        a: 0,
        k: [
          16.419,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 281,
    ty: 4,
    parent: 280,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.2
              ],
              [
                -0.35,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.39
              ],
              [
                0,
                -0.66
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.08
              ],
              [
                0.01,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                -0.29
              ],
              [
                -0.44,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.07
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.09
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                2.65,
                9.02
              ],
              [
                2.65,
                9.02
              ],
              [
                1.53,
                8.73
              ],
              [
                0.73,
                7.9
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.31
              ],
              [
                1.51,
                4.47
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.86,
                4.77
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.58
              ],
              [
                4.31,
                6.79
              ],
              [
                4.31,
                6.79
              ],
              [
                1.2,
                6.79
              ],
              [
                1.66,
                7.95
              ],
              [
                2.74,
                8.39
              ],
              [
                2.74,
                8.39
              ],
              [
                3.35,
                8.29
              ],
              [
                3.89,
                8.03
              ],
              [
                3.89,
                8.03
              ],
              [
                4.16,
                8.54
              ],
              [
                3.49,
                8.87
              ],
              [
                2.65,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.41,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.59,
                0
              ],
              [
                0.32,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.03,
                0.49
              ],
              [
                0.27,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.19,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.13
              ],
              [
                -0.25,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.24
              ],
              [
                0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.25
              ],
              [
                0.05,
                -0.46
              ]
            ],
            v: [
              [
                1.19,
                6.23
              ],
              [
                1.19,
                6.23
              ],
              [
                3.66,
                6.23
              ],
              [
                3.36,
                5.16
              ],
              [
                2.52,
                4.8
              ],
              [
                2.52,
                4.8
              ],
              [
                1.65,
                5.17
              ],
              [
                1.19,
                6.23
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.47
              ],
              [
                -0.2,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.26,
                0.25
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 280,
    ty: 3,
    parent: 269,
    ks: {
      p: {
        a: 0,
        k: [
          11.717,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 283,
    ty: 4,
    parent: 282,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                4.3
              ],
              [
                1.6,
                4.3
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.3
              ],
              [
                1.2,
                3.3
              ],
              [
                0.8,
                3.2
              ],
              [
                0.7,
                2.8
              ],
              [
                0.7,
                2.8
              ],
              [
                0.8,
                2.5
              ],
              [
                1.2,
                2.3
              ],
              [
                1.2,
                2.3
              ],
              [
                1.6,
                2.5
              ],
              [
                1.7,
                2.8
              ],
              [
                1.7,
                2.8
              ],
              [
                1.6,
                3.2
              ],
              [
                1.2,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 282,
    ty: 3,
    parent: 269,
    ks: {
      p: {
        a: 0,
        k: [
          9.385,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 285,
    ty: 4,
    parent: 284,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.33,
                0.19
              ],
              [
                0.19,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.36
              ],
              [
                -0.34,
                0.19
              ],
              [
                -0.39,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.11
              ],
              [
                -0.16,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.08
              ],
              [
                0.18,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.15
              ],
              [
                0.12,
                -0.27
              ],
              [
                0,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                -0.26,
                -0.33
              ],
              [
                -0.42,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0.09
              ],
              [
                -0.14,
                0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.1
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                2.6,
                9.02
              ],
              [
                2.6,
                9.02
              ],
              [
                1.5,
                8.73
              ],
              [
                0.72,
                7.91
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.74,
                5.29
              ],
              [
                1.56,
                4.46
              ],
              [
                2.66,
                4.18
              ],
              [
                2.66,
                4.18
              ],
              [
                3.44,
                4.34
              ],
              [
                4,
                4.72
              ],
              [
                4,
                4.72
              ],
              [
                3.6,
                5.23
              ],
              [
                3.18,
                4.94
              ],
              [
                2.68,
                4.82
              ],
              [
                2.68,
                4.82
              ],
              [
                1.94,
                5.05
              ],
              [
                1.43,
                5.67
              ],
              [
                1.24,
                6.61
              ],
              [
                1.24,
                6.61
              ],
              [
                1.64,
                7.88
              ],
              [
                2.66,
                8.37
              ],
              [
                2.66,
                8.37
              ],
              [
                3.26,
                8.23
              ],
              [
                3.75,
                7.91
              ],
              [
                3.75,
                7.91
              ],
              [
                4.09,
                8.43
              ],
              [
                3.39,
                8.86
              ],
              [
                2.6,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.33,
                -0.19
              ],
              [
                -0.19,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.52
              ],
              [
                0.21,
                -0.36
              ],
              [
                0.34,
                -0.19
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.22,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.12
              ],
              [
                -0.15,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.12,
                0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                0.52
              ],
              [
                0.26,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0.21,
                0
              ],
              [
                0.18,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.25,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 284,
    ty: 3,
    parent: 269,
    ks: {
      p: {
        a: 0,
        k: [
          5.062,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 287,
    ty: 4,
    parent: 286,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                0.9,
                7.5
              ],
              [
                1.7,
                8.1
              ],
              [
                2.6,
                8.3
              ],
              [
                2.6,
                8.3
              ],
              [
                3.5,
                8
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.8,
                6.8
              ],
              [
                3.4,
                6.5
              ],
              [
                2.9,
                6.2
              ],
              [
                2.9,
                6.2
              ],
              [
                2,
                5.8
              ],
              [
                1.4,
                5.5
              ],
              [
                0.9,
                5
              ],
              [
                0.7,
                4.2
              ],
              [
                0.7,
                4.2
              ],
              [
                1,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.7,
                2.8
              ],
              [
                4.5,
                3.3
              ],
              [
                4.5,
                3.3
              ],
              [
                4.1,
                3.8
              ],
              [
                3.4,
                3.4
              ],
              [
                2.7,
                3.3
              ],
              [
                2.7,
                3.3
              ],
              [
                1.8,
                3.5
              ],
              [
                1.5,
                4.2
              ],
              [
                1.5,
                4.2
              ],
              [
                1.7,
                4.7
              ],
              [
                2,
                5
              ],
              [
                2.5,
                5.2
              ],
              [
                2.5,
                5.2
              ],
              [
                3.4,
                5.6
              ],
              [
                4.1,
                5.9
              ],
              [
                4.5,
                6.5
              ],
              [
                4.7,
                7.2
              ],
              [
                4.7,
                7.2
              ],
              [
                4.4,
                8.1
              ],
              [
                3.7,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 286,
    ty: 3,
    parent: 269,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 269,
    ty: 3,
    parent: 268,
    ks: {
      p: {
        a: 0,
        k: [
          48.092,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 290,
    ty: 4,
    parent: 289,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.23
              ],
              [
                0,
                0.41
              ],
              [
                0,
                0
              ],
              [
                -0.45,
                0.27
              ],
              [
                -0.98,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.18
              ],
              [
                0.14,
                0.11
              ],
              [
                0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.1
              ],
              [
                0.18,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.31,
                0.13
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.34
              ],
              [
                0,
                -0.58
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.13
              ],
              [
                0.29,
                0
              ]
            ],
            v: [
              [
                1.84,
                9.02
              ],
              [
                1.84,
                9.02
              ],
              [
                0.88,
                8.67
              ],
              [
                0.49,
                7.71
              ],
              [
                0.49,
                7.71
              ],
              [
                1.17,
                6.55
              ],
              [
                3.32,
                5.98
              ],
              [
                3.32,
                5.98
              ],
              [
                3.24,
                5.42
              ],
              [
                2.95,
                4.99
              ],
              [
                2.37,
                4.82
              ],
              [
                2.37,
                4.82
              ],
              [
                1.62,
                4.98
              ],
              [
                1,
                5.32
              ],
              [
                1,
                5.32
              ],
              [
                0.69,
                4.78
              ],
              [
                1.48,
                4.37
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.73,
                4.7
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                8.9
              ],
              [
                3.46,
                8.9
              ],
              [
                3.39,
                8.35
              ],
              [
                3.37,
                8.35
              ],
              [
                2.66,
                8.82
              ],
              [
                1.84,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.26,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.45,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.05,
                -0.18
              ],
              [
                -0.14,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.14
              ],
              [
                0.31,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.56,
                0
              ],
              [
                0.25,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.26,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.11
              ],
              [
                -0.22,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.19
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.23,
                0
              ]
            ],
            v: [
              [
                2.07,
                8.39
              ],
              [
                2.07,
                8.39
              ],
              [
                2.69,
                8.23
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                6.49
              ],
              [
                1.71,
                6.92
              ],
              [
                1.25,
                7.65
              ],
              [
                1.25,
                7.65
              ],
              [
                1.49,
                8.21
              ],
              [
                2.07,
                8.39
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.2,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.76,
                0.09
              ],
              [
                -0.31,
                0.19
              ],
              [
                0,
                0
              ],
              [
                0,
                0.26
              ],
              [
                0.16,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 289,
    ty: 3,
    parent: 288,
    ks: {
      p: {
        a: 0,
        k: [
          13.812,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 292,
    ty: 4,
    parent: 291,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                2.2,
                9
              ],
              [
                2.2,
                9
              ],
              [
                1.2,
                8.6
              ],
              [
                0.9,
                7.5
              ],
              [
                0.9,
                7.5
              ],
              [
                0.9,
                4.9
              ],
              [
                0.2,
                4.9
              ],
              [
                0.2,
                4.3
              ],
              [
                0.9,
                4.3
              ],
              [
                1,
                3
              ],
              [
                1.7,
                3
              ],
              [
                1.7,
                4.3
              ],
              [
                2.9,
                4.3
              ],
              [
                2.9,
                4.9
              ],
              [
                1.7,
                4.9
              ],
              [
                1.7,
                7.5
              ],
              [
                1.9,
                8.1
              ],
              [
                2.4,
                8.4
              ],
              [
                2.4,
                8.4
              ],
              [
                2.7,
                8.3
              ],
              [
                2.9,
                8.3
              ],
              [
                2.9,
                8.3
              ],
              [
                3.1,
                8.8
              ],
              [
                2.7,
                9
              ],
              [
                2.2,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 291,
    ty: 3,
    parent: 288,
    ks: {
      p: {
        a: 0,
        k: [
          10.608,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 294,
    ty: 4,
    parent: 293,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.23
              ],
              [
                0,
                0.41
              ],
              [
                0,
                0
              ],
              [
                -0.45,
                0.27
              ],
              [
                -0.98,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.18
              ],
              [
                0.14,
                0.11
              ],
              [
                0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.1
              ],
              [
                0.18,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.31,
                0.13
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.34
              ],
              [
                0,
                -0.58
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.13
              ],
              [
                0.29,
                0
              ]
            ],
            v: [
              [
                1.84,
                9.02
              ],
              [
                1.84,
                9.02
              ],
              [
                0.88,
                8.67
              ],
              [
                0.49,
                7.71
              ],
              [
                0.49,
                7.71
              ],
              [
                1.17,
                6.55
              ],
              [
                3.32,
                5.98
              ],
              [
                3.32,
                5.98
              ],
              [
                3.24,
                5.42
              ],
              [
                2.95,
                4.99
              ],
              [
                2.37,
                4.82
              ],
              [
                2.37,
                4.82
              ],
              [
                1.62,
                4.98
              ],
              [
                1,
                5.32
              ],
              [
                1,
                5.32
              ],
              [
                0.69,
                4.78
              ],
              [
                1.48,
                4.37
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.73,
                4.7
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                8.9
              ],
              [
                3.46,
                8.9
              ],
              [
                3.39,
                8.35
              ],
              [
                3.37,
                8.35
              ],
              [
                2.66,
                8.82
              ],
              [
                1.84,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.26,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.45,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.05,
                -0.18
              ],
              [
                -0.14,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.14
              ],
              [
                0.31,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.56,
                0
              ],
              [
                0.25,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.26,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.11
              ],
              [
                -0.22,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.19
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.23,
                0
              ]
            ],
            v: [
              [
                2.07,
                8.39
              ],
              [
                2.07,
                8.39
              ],
              [
                2.69,
                8.23
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                6.49
              ],
              [
                1.71,
                6.92
              ],
              [
                1.25,
                7.65
              ],
              [
                1.25,
                7.65
              ],
              [
                1.49,
                8.21
              ],
              [
                2.07,
                8.39
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.2,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.76,
                0.09
              ],
              [
                -0.31,
                0.19
              ],
              [
                0,
                0
              ],
              [
                0,
                0.26
              ],
              [
                0.16,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 293,
    ty: 3,
    parent: 288,
    ks: {
      p: {
        a: 0,
        k: [
          5.83,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 296,
    ty: 4,
    parent: 295,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.5,
                -0.5
              ],
              [
                0,
                -1
              ],
              [
                0,
                0
              ],
              [
                0.5,
                -0.5
              ],
              [
                0.9,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                2.7
              ],
              [
                2.4,
                2.7
              ],
              [
                4.6,
                3.5
              ],
              [
                5.3,
                5.8
              ],
              [
                5.3,
                5.8
              ],
              [
                4.6,
                8.1
              ],
              [
                2.4,
                8.9
              ],
              [
                2.4,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                1,
                0
              ],
              [
                0.5,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                1
              ],
              [
                -0.5,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.4
              ],
              [
                0,
                0.8
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0.7,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                3.3
              ],
              [
                1.6,
                8.3
              ],
              [
                2.4,
                8.3
              ],
              [
                4,
                7.6
              ],
              [
                4.5,
                5.8
              ],
              [
                4.5,
                5.8
              ],
              [
                4,
                4
              ],
              [
                2.4,
                3.3
              ],
              [
                2.4,
                3.3
              ],
              [
                1.6,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.8
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 295,
    ty: 3,
    parent: 288,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 288,
    ty: 3,
    parent: 268,
    ks: {
      p: {
        a: 0,
        k: [
          27.606,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 299,
    ty: 4,
    parent: 298,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.17
              ],
              [
                -0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.06,
                0.01
              ],
              [
                0.09,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.16
              ],
              [
                0.16,
                -0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                5.13
              ],
              [
                1.52,
                5.13
              ],
              [
                2.1,
                4.44
              ],
              [
                2.83,
                4.18
              ],
              [
                2.83,
                4.18
              ],
              [
                3.32,
                4.27
              ],
              [
                3.32,
                4.27
              ],
              [
                3.17,
                4.96
              ],
              [
                2.96,
                4.9
              ],
              [
                2.72,
                4.88
              ],
              [
                2.72,
                4.88
              ],
              [
                2.11,
                5.12
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.29
              ],
              [
                0.23,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.06,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.21,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 298,
    ty: 3,
    parent: 297,
    ks: {
      p: {
        a: 0,
        k: [
          22.42,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 301,
    ty: 4,
    parent: 300,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.33,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.33,
                0.19
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                -0.52
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.19
              ],
              [
                0.38,
                0
              ]
            ],
            v: [
              [
                2.57,
                9.02
              ],
              [
                2.57,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.73,
                7.91
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.29
              ],
              [
                1.52,
                4.46
              ],
              [
                2.57,
                4.18
              ],
              [
                2.57,
                4.18
              ],
              [
                3.62,
                4.46
              ],
              [
                4.4,
                5.29
              ],
              [
                4.7,
                6.61
              ],
              [
                4.7,
                6.61
              ],
              [
                4.4,
                7.91
              ],
              [
                3.62,
                8.73
              ],
              [
                2.57,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.37,
                0
              ],
              [
                -0.33,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.52
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.33,
                -0.19
              ],
              [
                0,
                0
              ],
              [
                0.38,
                0
              ],
              [
                0.32,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                0.51
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.19
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                0.33
              ],
              [
                0,
                0.52
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.33
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.33
              ],
              [
                0,
                -0.53
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.33
              ],
              [
                -0.39,
                0
              ]
            ],
            v: [
              [
                2.57,
                8.37
              ],
              [
                2.57,
                8.37
              ],
              [
                3.53,
                7.88
              ],
              [
                3.9,
                6.61
              ],
              [
                3.9,
                6.61
              ],
              [
                3.53,
                5.32
              ],
              [
                2.57,
                4.82
              ],
              [
                2.57,
                4.82
              ],
              [
                1.61,
                5.32
              ],
              [
                1.24,
                6.61
              ],
              [
                1.24,
                6.61
              ],
              [
                1.61,
                7.88
              ],
              [
                2.57,
                8.37
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.24,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.53
              ],
              [
                -0.24,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.25,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.52
              ],
              [
                0.25,
                0.33
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 300,
    ty: 3,
    parent: 297,
    ks: {
      p: {
        a: 0,
        k: [
          17.282,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 303,
    ty: 4,
    parent: 302,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                4.3
              ],
              [
                1.6,
                4.3
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.3
              ],
              [
                1.2,
                3.3
              ],
              [
                0.8,
                3.2
              ],
              [
                0.7,
                2.8
              ],
              [
                0.7,
                2.8
              ],
              [
                0.8,
                2.5
              ],
              [
                1.2,
                2.3
              ],
              [
                1.2,
                2.3
              ],
              [
                1.6,
                2.5
              ],
              [
                1.7,
                2.8
              ],
              [
                1.7,
                2.8
              ],
              [
                1.6,
                3.2
              ],
              [
                1.2,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 302,
    ty: 3,
    parent: 297,
    ks: {
      p: {
        a: 0,
        k: [
          14.95,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 305,
    ty: 4,
    parent: 304,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                0.15
              ],
              [
                -0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.31
              ],
              [
                0,
                -0.59
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.12
              ],
              [
                0.23,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                4.96
              ],
              [
                1.52,
                4.96
              ],
              [
                2.22,
                4.4
              ],
              [
                3.06,
                4.18
              ],
              [
                3.06,
                4.18
              ],
              [
                4.13,
                4.64
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                8.9
              ],
              [
                3.69,
                8.9
              ],
              [
                3.69,
                6.09
              ],
              [
                3.48,
                5.15
              ],
              [
                2.82,
                4.85
              ],
              [
                2.82,
                4.85
              ],
              [
                2.19,
                5.03
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.22
              ],
              [
                0.25,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0.49,
                0
              ],
              [
                0.22,
                0.31
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.43
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.19,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 304,
    ty: 3,
    parent: 297,
    ks: {
      p: {
        a: 0,
        k: [
          9.764,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 307,
    ty: 4,
    parent: 306,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.2
              ],
              [
                -0.35,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.39
              ],
              [
                0,
                -0.66
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.08
              ],
              [
                0.01,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                -0.29
              ],
              [
                -0.44,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.07
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.09
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                2.65,
                9.02
              ],
              [
                2.65,
                9.02
              ],
              [
                1.53,
                8.73
              ],
              [
                0.73,
                7.9
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.31
              ],
              [
                1.51,
                4.47
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.86,
                4.77
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.58
              ],
              [
                4.31,
                6.79
              ],
              [
                4.31,
                6.79
              ],
              [
                1.2,
                6.79
              ],
              [
                1.66,
                7.95
              ],
              [
                2.74,
                8.39
              ],
              [
                2.74,
                8.39
              ],
              [
                3.35,
                8.29
              ],
              [
                3.89,
                8.03
              ],
              [
                3.89,
                8.03
              ],
              [
                4.16,
                8.54
              ],
              [
                3.49,
                8.87
              ],
              [
                2.65,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.41,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.59,
                0
              ],
              [
                0.32,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.03,
                0.49
              ],
              [
                0.27,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.19,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.13
              ],
              [
                -0.25,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.24
              ],
              [
                0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.25
              ],
              [
                0.05,
                -0.46
              ]
            ],
            v: [
              [
                1.19,
                6.23
              ],
              [
                1.19,
                6.23
              ],
              [
                3.66,
                6.23
              ],
              [
                3.36,
                5.16
              ],
              [
                2.52,
                4.8
              ],
              [
                2.52,
                4.8
              ],
              [
                1.65,
                5.17
              ],
              [
                1.19,
                6.23
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.47
              ],
              [
                -0.2,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.26,
                0.25
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 306,
    ty: 3,
    parent: 297,
    ks: {
      p: {
        a: 0,
        k: [
          5.062,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 309,
    ty: 4,
    parent: 308,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                0.9,
                7.5
              ],
              [
                1.7,
                8.1
              ],
              [
                2.6,
                8.3
              ],
              [
                2.6,
                8.3
              ],
              [
                3.5,
                8
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.8,
                6.8
              ],
              [
                3.4,
                6.5
              ],
              [
                2.9,
                6.2
              ],
              [
                2.9,
                6.2
              ],
              [
                2,
                5.8
              ],
              [
                1.4,
                5.5
              ],
              [
                0.9,
                5
              ],
              [
                0.7,
                4.2
              ],
              [
                0.7,
                4.2
              ],
              [
                1,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.7,
                2.8
              ],
              [
                4.5,
                3.3
              ],
              [
                4.5,
                3.3
              ],
              [
                4.1,
                3.8
              ],
              [
                3.4,
                3.4
              ],
              [
                2.7,
                3.3
              ],
              [
                2.7,
                3.3
              ],
              [
                1.8,
                3.5
              ],
              [
                1.5,
                4.2
              ],
              [
                1.5,
                4.2
              ],
              [
                1.7,
                4.7
              ],
              [
                2,
                5
              ],
              [
                2.5,
                5.2
              ],
              [
                2.5,
                5.2
              ],
              [
                3.4,
                5.6
              ],
              [
                4.1,
                5.9
              ],
              [
                4.5,
                6.5
              ],
              [
                4.7,
                7.2
              ],
              [
                4.7,
                7.2
              ],
              [
                4.4,
                8.1
              ],
              [
                3.7,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 308,
    ty: 3,
    parent: 297,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 297,
    ty: 3,
    parent: 268,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 268,
    ty: 3,
    parent: 267,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.469
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 267,
    ty: 3,
    parent: 266,
    ks: {
      p: {
        a: 0,
        k: [
          16.255,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 319,
    ty: 0,
    parent: 310,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.582
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    w: 10.837,
    h: 10.837,
    ip: 0,
    op: 565,
    st: 0,
    refId: "317"
  },
  {
    ind: 310,
    ty: 3,
    parent: 266,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 266,
    ty: 3,
    parent: 241,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 241,
    ty: 3,
    parent: 240,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          27.418
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 325,
    ty: 4,
    parent: 324,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.6,
                0.4
              ],
              [
                -1.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.3
              ],
              [
                2.3,
                15.3
              ],
              [
                1.1,
                14.8
              ],
              [
                0.6,
                13.6
              ],
              [
                0.6,
                13.6
              ],
              [
                1.4,
                12.1
              ],
              [
                4.1,
                11.3
              ],
              [
                4.1,
                11.3
              ],
              [
                3.8,
                10.5
              ],
              [
                3,
                10.2
              ],
              [
                3,
                10.2
              ],
              [
                2.1,
                10.3
              ],
              [
                1.3,
                10.8
              ],
              [
                1.3,
                10.8
              ],
              [
                0.8,
                9.8
              ],
              [
                1.9,
                9.3
              ],
              [
                3.3,
                9
              ],
              [
                3.3,
                9
              ],
              [
                4.9,
                9.7
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                15.2
              ],
              [
                4.3,
                15.2
              ],
              [
                4.2,
                14.5
              ],
              [
                4.2,
                14.5
              ],
              [
                3.3,
                15.1
              ],
              [
                2.3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.6,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.8,
                14.2
              ],
              [
                2.8,
                14.2
              ],
              [
                3.5,
                14
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                12.2
              ],
              [
                2.4,
                12.7
              ],
              [
                1.9,
                13.5
              ],
              [
                1.9,
                13.5
              ],
              [
                2.2,
                14
              ],
              [
                2.8,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.8,
                0.1
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 324,
    ty: 3,
    parent: 323,
    ks: {
      p: {
        a: 0,
        k: [
          25.709,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 327,
    ty: 4,
    parent: 326,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                3,
                15.3
              ],
              [
                3,
                15.3
              ],
              [
                1.5,
                14.7
              ],
              [
                1.1,
                13.1
              ],
              [
                1.1,
                13.1
              ],
              [
                1.1,
                10.3
              ],
              [
                0.2,
                10.3
              ],
              [
                0.2,
                9.2
              ],
              [
                1.2,
                9.2
              ],
              [
                1.3,
                7.6
              ],
              [
                2.5,
                7.6
              ],
              [
                2.5,
                9.2
              ],
              [
                4,
                9.2
              ],
              [
                4,
                10.3
              ],
              [
                2.5,
                10.3
              ],
              [
                2.5,
                13.1
              ],
              [
                3.4,
                14.2
              ],
              [
                3.4,
                14.2
              ],
              [
                3.7,
                14.2
              ],
              [
                4,
                14.1
              ],
              [
                4,
                14.1
              ],
              [
                4.2,
                15.1
              ],
              [
                3.7,
                15.3
              ],
              [
                3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.7,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.7
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 326,
    ty: 3,
    parent: 323,
    ks: {
      p: {
        a: 0,
        k: [
          21.308,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 329,
    ty: 4,
    parent: 328,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.6
              ],
              [
                0,
                -0.9
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.5
              ],
              [
                0.4,
                -0.3
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                17.5
              ],
              [
                0.9,
                17.5
              ],
              [
                0.9,
                9.2
              ],
              [
                2,
                9.2
              ],
              [
                2.1,
                9.8
              ],
              [
                2.2,
                9.8
              ],
              [
                3,
                9.3
              ],
              [
                4,
                9
              ],
              [
                4,
                9
              ],
              [
                5.7,
                9.9
              ],
              [
                6.4,
                12.1
              ],
              [
                6.4,
                12.1
              ],
              [
                6,
                13.8
              ],
              [
                5,
                14.9
              ],
              [
                3.8,
                15.3
              ],
              [
                3.8,
                15.3
              ],
              [
                3,
                15.1
              ],
              [
                2.3,
                14.7
              ],
              [
                2.3,
                14.7
              ],
              [
                2.3,
                15.7
              ],
              [
                2.3,
                17.5
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                0.7
              ],
              [
                -0.2,
                0.5
              ],
              [
                -0.4,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0.7
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                3.5,
                14.2
              ],
              [
                3.5,
                14.2
              ],
              [
                4.5,
                13.6
              ],
              [
                4.9,
                12.1
              ],
              [
                4.9,
                12.1
              ],
              [
                4.6,
                10.7
              ],
              [
                3.6,
                10.2
              ],
              [
                3.6,
                10.2
              ],
              [
                2.3,
                10.9
              ],
              [
                2.3,
                10.9
              ],
              [
                2.3,
                13.7
              ],
              [
                2.9,
                14
              ],
              [
                3.5,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 328,
    ty: 3,
    parent: 323,
    ks: {
      p: {
        a: 0,
        k: [
          14.433,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 331,
    ty: 4,
    parent: 330,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.7,
                15.3
              ],
              [
                2.7,
                15.3
              ],
              [
                1.3,
                14.7
              ],
              [
                0.8,
                12.9
              ],
              [
                0.8,
                12.9
              ],
              [
                0.8,
                9.2
              ],
              [
                2.2,
                9.2
              ],
              [
                2.2,
                12.8
              ],
              [
                2.5,
                13.8
              ],
              [
                3.2,
                14.1
              ],
              [
                3.2,
                14.1
              ],
              [
                3.8,
                13.9
              ],
              [
                4.5,
                13.3
              ],
              [
                4.5,
                13.3
              ],
              [
                4.5,
                9.2
              ],
              [
                5.9,
                9.2
              ],
              [
                5.9,
                15.2
              ],
              [
                4.7,
                15.2
              ],
              [
                4.6,
                14.3
              ],
              [
                4.6,
                14.3
              ],
              [
                3.7,
                15
              ],
              [
                2.7,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 330,
    ty: 3,
    parent: 323,
    ks: {
      p: {
        a: 0,
        k: [
          7.655,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 333,
    ty: 4,
    parent: 332,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0.3
              ],
              [
                0.3,
                0.6
              ],
              [
                0,
                0.9
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.6
              ],
              [
                -0.6,
                0.3
              ],
              [
                -0.7,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.5
              ],
              [
                0,
                -0.9
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                -0.8,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                4.4,
                15.3
              ],
              [
                4.4,
                15.3
              ],
              [
                2.4,
                14.8
              ],
              [
                1.1,
                13.4
              ],
              [
                0.6,
                11.2
              ],
              [
                0.6,
                11.2
              ],
              [
                1.1,
                9
              ],
              [
                2.5,
                7.5
              ],
              [
                4.4,
                7.1
              ],
              [
                4.4,
                7.1
              ],
              [
                5.8,
                7.4
              ],
              [
                6.8,
                8.1
              ],
              [
                6.8,
                8.1
              ],
              [
                6,
                9
              ],
              [
                5.3,
                8.5
              ],
              [
                4.4,
                8.3
              ],
              [
                4.4,
                8.3
              ],
              [
                2.7,
                9.1
              ],
              [
                2,
                11.2
              ],
              [
                2,
                11.2
              ],
              [
                2.7,
                13.3
              ],
              [
                4.5,
                14.1
              ],
              [
                4.5,
                14.1
              ],
              [
                5.1,
                14
              ],
              [
                5.6,
                13.7
              ],
              [
                5.6,
                13.7
              ],
              [
                5.6,
                12
              ],
              [
                4.1,
                12
              ],
              [
                4.1,
                10.9
              ],
              [
                6.9,
                10.9
              ],
              [
                6.9,
                14.4
              ],
              [
                5.8,
                15
              ],
              [
                4.4,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.7,
                0
              ],
              [
                -0.6,
                -0.3
              ],
              [
                -0.3,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.9
              ],
              [
                0.3,
                -0.6
              ],
              [
                0.6,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.7,
                0
              ],
              [
                -0.4,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0.9
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.4,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 332,
    ty: 3,
    parent: 323,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 323,
    ty: 3,
    parent: 322,
    ks: {
      p: {
        a: 0,
        k: [
          40.081,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 336,
    ty: 4,
    parent: 335,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.3
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                3.9,
                15.2
              ],
              [
                2.2,
                15.2
              ],
              [
                0.1,
                9.2
              ],
              [
                1.6,
                9.2
              ],
              [
                2.5,
                12.3
              ],
              [
                2.8,
                13.2
              ],
              [
                3,
                14.1
              ],
              [
                3,
                14.1
              ],
              [
                3.1,
                14.1
              ],
              [
                3.3,
                13.2
              ],
              [
                3.6,
                12.3
              ],
              [
                3.6,
                12.3
              ],
              [
                4.5,
                9.2
              ],
              [
                5.9,
                9.2
              ],
              [
                3.9,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.3
              ],
              [
                0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.3
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 335,
    ty: 3,
    parent: 334,
    ks: {
      p: {
        a: 0,
        k: [
          31.609,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 338,
    ty: 4,
    parent: 337,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.2,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                9.2
              ],
              [
                2,
                9.2
              ],
              [
                2.1,
                10.2
              ],
              [
                2.2,
                10.2
              ],
              [
                3,
                9.3
              ],
              [
                3.9,
                9
              ],
              [
                3.9,
                9
              ],
              [
                4.6,
                9.2
              ],
              [
                4.6,
                9.2
              ],
              [
                4.3,
                10.4
              ],
              [
                4,
                10.3
              ],
              [
                3.7,
                10.3
              ],
              [
                3.7,
                10.3
              ],
              [
                3,
                10.6
              ],
              [
                2.3,
                11.5
              ],
              [
                2.3,
                11.5
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 337,
    ty: 3,
    parent: 334,
    ks: {
      p: {
        a: 0,
        k: [
          27.062,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 340,
    ty: 4,
    parent: 339,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.5
              ],
              [
                0,
                0.7
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.5
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.3,
                -0.5
              ],
              [
                0,
                -0.7
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.5
              ],
              [
                0.4,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                3.3,
                15.3
              ],
              [
                3.3,
                15.3
              ],
              [
                2,
                14.9
              ],
              [
                0.9,
                13.9
              ],
              [
                0.5,
                12.2
              ],
              [
                0.5,
                12.2
              ],
              [
                0.9,
                10.5
              ],
              [
                2,
                9.4
              ],
              [
                3.3,
                9
              ],
              [
                3.3,
                9
              ],
              [
                4.7,
                9.4
              ],
              [
                5.8,
                10.5
              ],
              [
                6.2,
                12.2
              ],
              [
                6.2,
                12.2
              ],
              [
                5.8,
                13.9
              ],
              [
                4.7,
                14.9
              ],
              [
                3.3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.3,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.7
              ],
              [
                0.3,
                -0.5
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0.7
              ],
              [
                -0.3,
                0.5
              ],
              [
                -0.4,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.4
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.4
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.4
              ],
              [
                -0.4,
                0
              ]
            ],
            v: [
              [
                3.3,
                14.2
              ],
              [
                3.3,
                14.2
              ],
              [
                4.4,
                13.6
              ],
              [
                4.8,
                12.2
              ],
              [
                4.8,
                12.2
              ],
              [
                4.4,
                10.7
              ],
              [
                3.3,
                10.2
              ],
              [
                3.3,
                10.2
              ],
              [
                2.3,
                10.7
              ],
              [
                1.9,
                12.2
              ],
              [
                1.9,
                12.2
              ],
              [
                2.3,
                13.6
              ],
              [
                3.3,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.2,
                0.4
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 339,
    ty: 3,
    parent: 334,
    ks: {
      p: {
        a: 0,
        k: [
          20.369,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 342,
    ty: 4,
    parent: 341,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.5
              ],
              [
                0,
                0.7
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.5
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.3,
                -0.5
              ],
              [
                0,
                -0.7
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.5
              ],
              [
                0.4,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                3.3,
                15.3
              ],
              [
                3.3,
                15.3
              ],
              [
                2,
                14.9
              ],
              [
                0.9,
                13.9
              ],
              [
                0.5,
                12.2
              ],
              [
                0.5,
                12.2
              ],
              [
                0.9,
                10.5
              ],
              [
                2,
                9.4
              ],
              [
                3.3,
                9
              ],
              [
                3.3,
                9
              ],
              [
                4.7,
                9.4
              ],
              [
                5.8,
                10.5
              ],
              [
                6.2,
                12.2
              ],
              [
                6.2,
                12.2
              ],
              [
                5.8,
                13.9
              ],
              [
                4.7,
                14.9
              ],
              [
                3.3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.3,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.7
              ],
              [
                0.3,
                -0.5
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0.7
              ],
              [
                -0.3,
                0.5
              ],
              [
                -0.4,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.4
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.4
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.4
              ],
              [
                -0.4,
                0
              ]
            ],
            v: [
              [
                3.3,
                14.2
              ],
              [
                3.3,
                14.2
              ],
              [
                4.4,
                13.6
              ],
              [
                4.8,
                12.2
              ],
              [
                4.8,
                12.2
              ],
              [
                4.4,
                10.7
              ],
              [
                3.3,
                10.2
              ],
              [
                3.3,
                10.2
              ],
              [
                2.3,
                10.7
              ],
              [
                1.9,
                12.2
              ],
              [
                1.9,
                12.2
              ],
              [
                2.3,
                13.6
              ],
              [
                3.3,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.2,
                0.4
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 341,
    ty: 3,
    parent: 334,
    ks: {
      p: {
        a: 0,
        k: [
          13.677,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 344,
    ty: 4,
    parent: 343,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.6
              ],
              [
                0,
                -0.9
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.5
              ],
              [
                0.4,
                -0.3
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                17.5
              ],
              [
                0.9,
                17.5
              ],
              [
                0.9,
                9.2
              ],
              [
                2,
                9.2
              ],
              [
                2.1,
                9.8
              ],
              [
                2.2,
                9.8
              ],
              [
                3,
                9.3
              ],
              [
                4,
                9
              ],
              [
                4,
                9
              ],
              [
                5.7,
                9.9
              ],
              [
                6.4,
                12.1
              ],
              [
                6.4,
                12.1
              ],
              [
                6,
                13.8
              ],
              [
                5,
                14.9
              ],
              [
                3.8,
                15.3
              ],
              [
                3.8,
                15.3
              ],
              [
                3,
                15.1
              ],
              [
                2.3,
                14.7
              ],
              [
                2.3,
                14.7
              ],
              [
                2.3,
                15.7
              ],
              [
                2.3,
                17.5
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                0.7
              ],
              [
                -0.2,
                0.5
              ],
              [
                -0.4,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0.7
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                3.5,
                14.2
              ],
              [
                3.5,
                14.2
              ],
              [
                4.5,
                13.6
              ],
              [
                4.9,
                12.1
              ],
              [
                4.9,
                12.1
              ],
              [
                4.6,
                10.7
              ],
              [
                3.6,
                10.2
              ],
              [
                3.6,
                10.2
              ],
              [
                2.3,
                10.9
              ],
              [
                2.3,
                10.9
              ],
              [
                2.3,
                13.7
              ],
              [
                2.9,
                14
              ],
              [
                3.5,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 343,
    ty: 3,
    parent: 334,
    ks: {
      p: {
        a: 0,
        k: [
          6.802,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 346,
    ty: 4,
    parent: 345,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.4
              ],
              [
                0.1,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.4
              ],
              [
                0.1,
                -0.4
              ]
            ],
            v: [
              [
                2.6,
                10.9
              ],
              [
                2.6,
                10.9
              ],
              [
                2.4,
                11.9
              ],
              [
                4.4,
                11.9
              ],
              [
                4.1,
                10.9
              ],
              [
                3.7,
                9.6
              ],
              [
                3.4,
                8.3
              ],
              [
                3.4,
                8.3
              ],
              [
                3.4,
                8.3
              ],
              [
                3,
                9.6
              ],
              [
                2.6,
                10.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.4
              ],
              [
                -0.1,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.4
              ],
              [
                -0.1,
                0.4
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.4,
                15.2
              ],
              [
                0,
                15.2
              ],
              [
                2.6,
                7.2
              ],
              [
                4.2,
                7.2
              ],
              [
                6.8,
                15.2
              ],
              [
                5.3,
                15.2
              ],
              [
                4.7,
                13
              ],
              [
                2,
                13
              ],
              [
                1.4,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 345,
    ty: 3,
    parent: 334,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 334,
    ty: 3,
    parent: 322,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 322,
    ty: 3,
    parent: 321,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.163
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 321,
    ty: 3,
    parent: 320,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 320,
    ty: 3,
    parent: 240,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 240,
    ty: 3,
    parent: 239,
    ks: {
      p: {
        a: 0,
        k: [
          70.439,
          2.737
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 357,
    ty: 0,
    parent: 348,
    ks: {
      a: {
        a: 0,
        k: [
          41.997,
          42.67
        ]
      },
      p: {
        a: 0,
        k: [
          41.997,
          42.67
        ]
      }
    },
    w: 16.255,
    h: 16.255,
    ip: 0,
    op: 565,
    st: 0,
    refId: "355"
  },
  {
    ind: 348,
    ty: 3,
    parent: 347,
    ks: {
      p: {
        a: 0,
        k: [
          41.997,
          42.67
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 360,
    ty: 4,
    td: 1,
    parent: 358,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            29.801,
            29.801
          ]
        },
        r: {
          a: 0,
          k: 46
        },
        s: {
          a: 0,
          k: [
            59.602,
            59.602
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0,
            0,
            0
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 359,
    ty: 4,
    tt: 1,
    parent: 358,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                29.801,
                29.801
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                62.989,
                62.989
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ty: "gr",
        it: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                29.801,
                29.801
              ]
            },
            r: {
              a: 0,
              k: 46
            },
            s: {
              a: 0,
              k: [
                59.602,
                59.602
              ]
            }
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.427,
                0.184,
                0.604
              ]
            },
            lj: 1,
            ml: 10,
            o: {
              a: 0,
              k: 100
            },
            w: {
              a: 0,
              k: 3.387
            }
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      }
    ]
  },
  {
    ind: 376,
    ty: 4,
    td: 1,
    parent: 358,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            29.801,
            29.801
          ]
        },
        r: {
          a: 0,
          k: 46
        },
        s: {
          a: 0,
          k: [
            59.602,
            59.602
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0,
            0,
            0
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 375,
    ty: 0,
    tt: 1,
    parent: 358,
    ks: {},
    w: 55,
    h: 55,
    ip: 0,
    op: 565,
    st: 0,
    refId: "373"
  },
  {
    ind: 358,
    ty: 3,
    parent: 347,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 347,
    ty: 3,
    parent: 239,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 239,
    ty: 3,
    parent: 17,
    ks: {
      p: {
        a: 0,
        k: [
          8.128,
          8.128
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 377,
    ty: 4,
    parent: 17,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            113.787,
            70.005
          ]
        },
        r: {
          a: 0,
          k: 5
        },
        s: {
          a: 0,
          k: [
            227.573,
            140.01
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            1,
            1,
            1
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 17,
    ty: 3,
    parent: 16,
    ks: {
      p: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              334.574,
              22.207
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 132,
            s: [
              602.574,
              22.207
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 276,
            s: [
              870.574,
              22.207
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 420,
            s: [
              1138.574,
              22.207
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              1406.574,
              22.207
            ],
            h: 1
          }
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 387,
    ty: 4,
    parent: 386,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 386,
    ty: 3,
    parent: 385,
    ks: {
      p: {
        a: 0,
        k: [
          21.813,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 389,
    ty: 4,
    parent: 388,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 388,
    ty: 3,
    parent: 385,
    ks: {
      p: {
        a: 0,
        k: [
          17.007,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 391,
    ty: 4,
    parent: 390,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.8,
                9
              ],
              [
                1.8,
                9
              ],
              [
                0.9,
                8.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                7.8
              ],
              [
                1.9,
                8
              ],
              [
                2,
                8.1
              ],
              [
                2,
                8.1
              ],
              [
                2.1,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.3,
                8.9
              ],
              [
                2.1,
                9
              ],
              [
                1.8,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 390,
    ty: 3,
    parent: 385,
    ks: {
      p: {
        a: 0,
        k: [
          14.438,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 393,
    ty: 4,
    parent: 392,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 392,
    ty: 3,
    parent: 385,
    ks: {
      p: {
        a: 0,
        k: [
          9.546,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 395,
    ty: 4,
    parent: 394,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.36
              ],
              [
                -0.36,
                0.19
              ],
              [
                -0.41,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.1
              ],
              [
                -0.17,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.13,
                0.06
              ],
              [
                0.15,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.28
              ],
              [
                0,
                -0.47
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                -0.28
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                0.08
              ],
              [
                -0.13,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.27,
                0
              ]
            ],
            v: [
              [
                2.64,
                9.02
              ],
              [
                2.64,
                9.02
              ],
              [
                1.49,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.71,
                5.26
              ],
              [
                1.57,
                4.42
              ],
              [
                2.72,
                4.13
              ],
              [
                2.72,
                4.13
              ],
              [
                3.5,
                4.28
              ],
              [
                4.09,
                4.65
              ],
              [
                4.09,
                4.65
              ],
              [
                3.56,
                5.37
              ],
              [
                3.19,
                5.11
              ],
              [
                2.78,
                5.02
              ],
              [
                2.78,
                5.02
              ],
              [
                1.86,
                5.45
              ],
              [
                1.51,
                6.58
              ],
              [
                1.51,
                6.58
              ],
              [
                1.85,
                7.7
              ],
              [
                2.75,
                8.12
              ],
              [
                2.75,
                8.12
              ],
              [
                3.27,
                8.01
              ],
              [
                3.71,
                7.73
              ],
              [
                3.71,
                7.73
              ],
              [
                4.15,
                8.45
              ],
              [
                3.43,
                8.87
              ],
              [
                2.64,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.42,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.52
              ],
              [
                0.21,
                -0.36
              ],
              [
                0.36,
                -0.19
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.22,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                -0.11
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                -0.37,
                0
              ],
              [
                -0.24,
                0.28
              ],
              [
                0,
                0
              ],
              [
                0,
                0.46
              ],
              [
                0.23,
                0.28
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0.16,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.19
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 394,
    ty: 3,
    parent: 385,
    ks: {
      p: {
        a: 0,
        k: [
          5.167,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 397,
    ty: 4,
    parent: 396,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                1,
                7.4
              ],
              [
                1.8,
                7.9
              ],
              [
                2.6,
                8.1
              ],
              [
                2.6,
                8.1
              ],
              [
                3.4,
                7.8
              ],
              [
                3.7,
                7.3
              ],
              [
                3.7,
                7.3
              ],
              [
                3.4,
                6.7
              ],
              [
                2.7,
                6.4
              ],
              [
                2.7,
                6.4
              ],
              [
                1.9,
                6
              ],
              [
                1.3,
                5.6
              ],
              [
                0.8,
                5.1
              ],
              [
                0.6,
                4.3
              ],
              [
                0.6,
                4.3
              ],
              [
                0.9,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.8,
                2.8
              ],
              [
                4.6,
                3.4
              ],
              [
                4.6,
                3.4
              ],
              [
                4.1,
                4.1
              ],
              [
                3.4,
                3.7
              ],
              [
                2.7,
                3.5
              ],
              [
                2.7,
                3.5
              ],
              [
                2,
                3.7
              ],
              [
                1.7,
                4.3
              ],
              [
                1.7,
                4.3
              ],
              [
                1.9,
                4.7
              ],
              [
                2.2,
                4.9
              ],
              [
                2.7,
                5.1
              ],
              [
                2.7,
                5.1
              ],
              [
                3.6,
                5.5
              ],
              [
                4.5,
                6.1
              ],
              [
                4.8,
                7.2
              ],
              [
                4.8,
                7.2
              ],
              [
                4.6,
                8.1
              ],
              [
                3.8,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 396,
    ty: 3,
    parent: 385,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 385,
    ty: 3,
    parent: 384,
    ks: {
      p: {
        a: 0,
        k: [
          93.74,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 400,
    ty: 4,
    parent: 399,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 399,
    ty: 3,
    parent: 398,
    ks: {
      p: {
        a: 0,
        k: [
          15.786,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 402,
    ty: 4,
    parent: 401,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 401,
    ty: 3,
    parent: 398,
    ks: {
      p: {
        a: 0,
        k: [
          10.979,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 404,
    ty: 4,
    parent: 403,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                5.1
              ],
              [
                0.3,
                5.1
              ],
              [
                0.3,
                4.3
              ],
              [
                0.9,
                4.2
              ],
              [
                0.9,
                3.8
              ],
              [
                1.2,
                2.6
              ],
              [
                2.4,
                2.1
              ],
              [
                2.4,
                2.1
              ],
              [
                2.9,
                2.1
              ],
              [
                3.3,
                2.3
              ],
              [
                3.3,
                2.3
              ],
              [
                3.1,
                3.1
              ],
              [
                2.6,
                3
              ],
              [
                2.6,
                3
              ],
              [
                2,
                3.7
              ],
              [
                2,
                3.7
              ],
              [
                2,
                4.2
              ],
              [
                2.9,
                4.2
              ],
              [
                2.9,
                5.1
              ],
              [
                2,
                5.1
              ],
              [
                2,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                5.3,
                9
              ],
              [
                5.3,
                9
              ],
              [
                4.2,
                8.5
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                5.1
              ],
              [
                3.2,
                5.1
              ],
              [
                3.2,
                4.3
              ],
              [
                3.9,
                4.2
              ],
              [
                4,
                3
              ],
              [
                5,
                3
              ],
              [
                5,
                4.2
              ],
              [
                6.1,
                4.2
              ],
              [
                6.1,
                5.1
              ],
              [
                5,
                5.1
              ],
              [
                5,
                7.3
              ],
              [
                5.6,
                8.1
              ],
              [
                5.6,
                8.1
              ],
              [
                5.9,
                8.1
              ],
              [
                6.1,
                8
              ],
              [
                6.1,
                8
              ],
              [
                6.3,
                8.8
              ],
              [
                5.9,
                9
              ],
              [
                5.3,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 403,
    ty: 3,
    parent: 398,
    ks: {
      p: {
        a: 0,
        k: [
          4.892,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 406,
    ty: 4,
    parent: 405,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 405,
    ty: 3,
    parent: 398,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 398,
    ty: 3,
    parent: 384,
    ks: {
      p: {
        a: 0,
        k: [
          72.522,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 409,
    ty: 4,
    parent: 408,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 408,
    ty: 3,
    parent: 407,
    ks: {
      p: {
        a: 0,
        k: [
          13.718,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 411,
    ty: 4,
    parent: 410,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                8.9
              ],
              [
                0.7,
                8.9
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                6.4
              ],
              [
                1.8,
                6.4
              ],
              [
                3.5,
                4.2
              ],
              [
                4.7,
                4.2
              ],
              [
                3.1,
                6.1
              ],
              [
                4.9,
                8.9
              ],
              [
                3.7,
                8.9
              ],
              [
                2.5,
                6.9
              ],
              [
                1.8,
                7.7
              ],
              [
                1.8,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 410,
    ty: 3,
    parent: 407,
    ks: {
      p: {
        a: 0,
        k: [
          8.769,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 413,
    ty: 4,
    parent: 412,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                8.9
              ],
              [
                0.7,
                8.9
              ],
              [
                0.7,
                4.2
              ],
              [
                1.8,
                4.2
              ],
              [
                1.8,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.4
              ],
              [
                1.2,
                3.4
              ],
              [
                0.8,
                3.3
              ],
              [
                0.6,
                2.8
              ],
              [
                0.6,
                2.8
              ],
              [
                0.8,
                2.4
              ],
              [
                1.2,
                2.2
              ],
              [
                1.2,
                2.2
              ],
              [
                1.7,
                2.4
              ],
              [
                1.9,
                2.8
              ],
              [
                1.9,
                2.8
              ],
              [
                1.7,
                3.3
              ],
              [
                1.2,
                3.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 412,
    ty: 3,
    parent: 407,
    ks: {
      p: {
        a: 0,
        k: [
          6.285,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 415,
    ty: 4,
    parent: 414,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.9,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                2.7
              ],
              [
                1.9,
                2.7
              ],
              [
                1.9,
                5.2
              ],
              [
                4.4,
                5.2
              ],
              [
                4.4,
                2.7
              ],
              [
                5.5,
                2.7
              ],
              [
                5.5,
                8.9
              ],
              [
                4.4,
                8.9
              ],
              [
                4.4,
                6.2
              ],
              [
                1.9,
                6.2
              ],
              [
                1.9,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 414,
    ty: 3,
    parent: 407,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 407,
    ty: 3,
    parent: 384,
    ks: {
      p: {
        a: 0,
        k: [
          52.102,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 418,
    ty: 4,
    parent: 417,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                1,
                10.8
              ],
              [
                1,
                10.8
              ],
              [
                0.7,
                10.8
              ],
              [
                0.4,
                10.7
              ],
              [
                0.4,
                10.7
              ],
              [
                0.6,
                9.9
              ],
              [
                0.8,
                9.9
              ],
              [
                0.9,
                9.9
              ],
              [
                0.9,
                9.9
              ],
              [
                1.5,
                9.7
              ],
              [
                1.9,
                9.1
              ],
              [
                1.9,
                9.1
              ],
              [
                1.9,
                8.8
              ],
              [
                0.1,
                4.2
              ],
              [
                1.2,
                4.2
              ],
              [
                2,
                6.5
              ],
              [
                2.2,
                7.2
              ],
              [
                2.4,
                7.8
              ],
              [
                2.4,
                7.8
              ],
              [
                2.5,
                7.8
              ],
              [
                2.7,
                7.2
              ],
              [
                2.8,
                6.5
              ],
              [
                2.8,
                6.5
              ],
              [
                3.5,
                4.2
              ],
              [
                4.6,
                4.2
              ],
              [
                2.9,
                9.1
              ],
              [
                2.2,
                10.4
              ],
              [
                1,
                10.8
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.5
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 417,
    ty: 3,
    parent: 416,
    ks: {
      p: {
        a: 0,
        k: [
          21.055,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 420,
    ty: 4,
    parent: 419,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 419,
    ty: 3,
    parent: 416,
    ks: {
      p: {
        a: 0,
        k: [
          17.519,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 422,
    ty: 4,
    parent: 421,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 421,
    ty: 3,
    parent: 416,
    ks: {
      p: {
        a: 0,
        k: [
          12.627,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 424,
    ty: 4,
    parent: 423,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.8,
                9
              ],
              [
                1.8,
                9
              ],
              [
                0.9,
                8.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                7.8
              ],
              [
                1.9,
                8
              ],
              [
                2,
                8.1
              ],
              [
                2,
                8.1
              ],
              [
                2.1,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.3,
                8.9
              ],
              [
                2.1,
                9
              ],
              [
                1.8,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 423,
    ty: 3,
    parent: 416,
    ks: {
      p: {
        a: 0,
        k: [
          10.058,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 426,
    ty: 4,
    parent: 425,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 425,
    ty: 3,
    parent: 416,
    ks: {
      p: {
        a: 0,
        k: [
          5.167,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 428,
    ty: 4,
    parent: 427,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                1,
                7.4
              ],
              [
                1.8,
                7.9
              ],
              [
                2.6,
                8.1
              ],
              [
                2.6,
                8.1
              ],
              [
                3.4,
                7.8
              ],
              [
                3.7,
                7.3
              ],
              [
                3.7,
                7.3
              ],
              [
                3.4,
                6.7
              ],
              [
                2.7,
                6.4
              ],
              [
                2.7,
                6.4
              ],
              [
                1.9,
                6
              ],
              [
                1.3,
                5.6
              ],
              [
                0.8,
                5.1
              ],
              [
                0.6,
                4.3
              ],
              [
                0.6,
                4.3
              ],
              [
                0.9,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.8,
                2.8
              ],
              [
                4.6,
                3.4
              ],
              [
                4.6,
                3.4
              ],
              [
                4.1,
                4.1
              ],
              [
                3.4,
                3.7
              ],
              [
                2.7,
                3.5
              ],
              [
                2.7,
                3.5
              ],
              [
                2,
                3.7
              ],
              [
                1.7,
                4.3
              ],
              [
                1.7,
                4.3
              ],
              [
                1.9,
                4.7
              ],
              [
                2.2,
                4.9
              ],
              [
                2.7,
                5.1
              ],
              [
                2.7,
                5.1
              ],
              [
                3.6,
                5.5
              ],
              [
                4.5,
                6.1
              ],
              [
                4.8,
                7.2
              ],
              [
                4.8,
                7.2
              ],
              [
                4.6,
                8.1
              ],
              [
                3.8,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 427,
    ty: 3,
    parent: 416,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 416,
    ty: 3,
    parent: 384,
    ks: {
      p: {
        a: 0,
        k: [
          24.458,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 431,
    ty: 4,
    parent: 430,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                1.8,
                6.5
              ],
              [
                1.8,
                6.5
              ],
              [
                0.7,
                6
              ],
              [
                0.3,
                4.5
              ],
              [
                0.3,
                4.5
              ],
              [
                0.7,
                3.1
              ],
              [
                1.8,
                2.6
              ],
              [
                1.8,
                2.6
              ],
              [
                2.8,
                3.1
              ],
              [
                3.2,
                4.5
              ],
              [
                3.2,
                4.5
              ],
              [
                2.8,
                6
              ],
              [
                1.8,
                6.5
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                1.8,
                5.9
              ],
              [
                1.8,
                5.9
              ],
              [
                2.3,
                5.6
              ],
              [
                2.5,
                4.5
              ],
              [
                2.5,
                4.5
              ],
              [
                2.3,
                3.5
              ],
              [
                1.8,
                3.2
              ],
              [
                1.8,
                3.2
              ],
              [
                1.3,
                3.5
              ],
              [
                1.1,
                4.5
              ],
              [
                1.1,
                4.5
              ],
              [
                1.3,
                5.6
              ],
              [
                1.8,
                5.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2,
                9
              ],
              [
                5.3,
                2.6
              ],
              [
                6,
                2.6
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                6.2,
                9
              ],
              [
                6.2,
                9
              ],
              [
                5.1,
                8.5
              ],
              [
                4.7,
                7
              ],
              [
                4.7,
                7
              ],
              [
                5.1,
                5.6
              ],
              [
                6.2,
                5.1
              ],
              [
                6.2,
                5.1
              ],
              [
                7.3,
                5.6
              ],
              [
                7.7,
                7
              ],
              [
                7.7,
                7
              ],
              [
                7.3,
                8.5
              ],
              [
                6.2,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                6.2,
                8.4
              ],
              [
                6.2,
                8.4
              ],
              [
                6.7,
                8.1
              ],
              [
                6.9,
                7
              ],
              [
                6.9,
                7
              ],
              [
                6.7,
                6
              ],
              [
                6.2,
                5.7
              ],
              [
                6.2,
                5.7
              ],
              [
                5.7,
                6
              ],
              [
                5.5,
                7
              ],
              [
                5.5,
                7
              ],
              [
                5.7,
                8.1
              ],
              [
                6.2,
                8.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 430,
    ty: 3,
    parent: 429,
    ks: {
      p: {
        a: 0,
        k: [
          14.59,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 433,
    ty: 4,
    parent: 432,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.5
              ],
              [
                -0.6,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                0,
                -1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.5
              ],
              [
                0.6,
                0
              ]
            ],
            v: [
              [
                2.4,
                9
              ],
              [
                2.4,
                9
              ],
              [
                0.9,
                8.2
              ],
              [
                0.4,
                5.9
              ],
              [
                0.4,
                5.9
              ],
              [
                0.9,
                3.5
              ],
              [
                2.4,
                2.8
              ],
              [
                2.4,
                2.8
              ],
              [
                3.9,
                3.5
              ],
              [
                4.5,
                5.9
              ],
              [
                4.5,
                5.9
              ],
              [
                3.9,
                8.2
              ],
              [
                2.4,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                -1
              ],
              [
                0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                1
              ],
              [
                -0.4,
                0.5
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.2
              ],
              [
                2.4,
                8.2
              ],
              [
                2.9,
                7.9
              ],
              [
                3.3,
                7.2
              ],
              [
                3.4,
                5.9
              ],
              [
                3.4,
                5.9
              ],
              [
                3.3,
                4.5
              ],
              [
                2.9,
                3.8
              ],
              [
                2.4,
                3.6
              ],
              [
                2.4,
                3.6
              ],
              [
                1.9,
                3.8
              ],
              [
                1.6,
                4.5
              ],
              [
                1.4,
                5.9
              ],
              [
                1.4,
                5.9
              ],
              [
                1.6,
                7.2
              ],
              [
                1.9,
                7.9
              ],
              [
                2.4,
                8.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.1,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 432,
    ty: 3,
    parent: 429,
    ks: {
      p: {
        a: 0,
        k: [
          9.726,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 435,
    ty: 4,
    parent: 434,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.5
              ],
              [
                -0.6,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                0,
                -1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.5
              ],
              [
                0.6,
                0
              ]
            ],
            v: [
              [
                2.4,
                9
              ],
              [
                2.4,
                9
              ],
              [
                0.9,
                8.2
              ],
              [
                0.4,
                5.9
              ],
              [
                0.4,
                5.9
              ],
              [
                0.9,
                3.5
              ],
              [
                2.4,
                2.8
              ],
              [
                2.4,
                2.8
              ],
              [
                3.9,
                3.5
              ],
              [
                4.5,
                5.9
              ],
              [
                4.5,
                5.9
              ],
              [
                3.9,
                8.2
              ],
              [
                2.4,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                -1
              ],
              [
                0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                1
              ],
              [
                -0.4,
                0.5
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.2
              ],
              [
                2.4,
                8.2
              ],
              [
                2.9,
                7.9
              ],
              [
                3.3,
                7.2
              ],
              [
                3.4,
                5.9
              ],
              [
                3.4,
                5.9
              ],
              [
                3.3,
                4.5
              ],
              [
                2.9,
                3.8
              ],
              [
                2.4,
                3.6
              ],
              [
                2.4,
                3.6
              ],
              [
                1.9,
                3.8
              ],
              [
                1.6,
                4.5
              ],
              [
                1.4,
                5.9
              ],
              [
                1.4,
                5.9
              ],
              [
                1.6,
                7.2
              ],
              [
                1.9,
                7.9
              ],
              [
                2.4,
                8.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.1,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 434,
    ty: 3,
    parent: 429,
    ks: {
      p: {
        a: 0,
        k: [
          4.863,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 437,
    ty: 4,
    parent: 436,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                4.3,
                8.9
              ],
              [
                0.7,
                8.9
              ],
              [
                0.7,
                8
              ],
              [
                2,
                8
              ],
              [
                2,
                4
              ],
              [
                0.9,
                4
              ],
              [
                0.9,
                3.4
              ],
              [
                1.7,
                3.2
              ],
              [
                2.3,
                2.9
              ],
              [
                2.3,
                2.9
              ],
              [
                3.1,
                2.9
              ],
              [
                3.1,
                8
              ],
              [
                4.3,
                8
              ],
              [
                4.3,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 436,
    ty: 3,
    parent: 429,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 429,
    ty: 3,
    parent: 384,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 384,
    ty: 3,
    parent: 383,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 383,
    ty: 3,
    parent: 382,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 382,
    ty: 3,
    parent: 381,
    ks: {
      p: {
        a: 0,
        k: [
          18.29,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 447,
    ty: 0,
    parent: 438,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.623
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.623
        ]
      }
    },
    w: 11.639,
    h: 11.611,
    ip: 0,
    op: 565,
    st: 0,
    refId: "445"
  },
  {
    ind: 438,
    ty: 3,
    parent: 381,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.623
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 381,
    ty: 3,
    parent: 380,
    ks: {
      p: {
        a: 0,
        k: [
          40.432,
          2.903
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 380,
    ty: 3,
    parent: 379,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          38.461
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 483,
    ty: 0,
    parent: 450,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          11.302
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          11.302
        ]
      }
    },
    w: 49.883,
    h: 10.629,
    ip: 0,
    op: 565,
    st: 0,
    refId: "481"
  },
  {
    ind: 450,
    ty: 3,
    parent: 449,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          11.302
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 488,
    ty: 4,
    parent: 487,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.13
              ],
              [
                -0.19,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.11,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.01
              ],
              [
                0.07,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.12
              ],
              [
                0.12,
                -0.29
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.14,
                6.54
              ],
              [
                0.57,
                6.54
              ],
              [
                0.57,
                3.15
              ],
              [
                1.04,
                3.15
              ],
              [
                1.09,
                3.77
              ],
              [
                1.11,
                3.77
              ],
              [
                1.54,
                3.26
              ],
              [
                2.08,
                3.07
              ],
              [
                2.08,
                3.07
              ],
              [
                2.44,
                3.14
              ],
              [
                2.44,
                3.14
              ],
              [
                2.33,
                3.64
              ],
              [
                2.17,
                3.6
              ],
              [
                2,
                3.59
              ],
              [
                2,
                3.59
              ],
              [
                1.55,
                3.76
              ],
              [
                1.14,
                4.37
              ],
              [
                1.14,
                4.37
              ],
              [
                1.14,
                6.54
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.12,
                -0.21
              ],
              [
                0.17,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.13,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.06,
                -0.02
              ],
              [
                -0.05,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0
              ],
              [
                -0.16,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 487,
    ty: 3,
    parent: 486,
    ks: {
      p: {
        a: 0,
        k: [
          15.625,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 490,
    ty: 4,
    parent: 489,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                0.14
              ],
              [
                0.14,
                0.26
              ],
              [
                0,
                0.37
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.23,
                0.14
              ],
              [
                -0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                -0.29
              ],
              [
                0,
                -0.48
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.06
              ],
              [
                0.01,
                -0.04
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.21
              ],
              [
                -0.33,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0.05
              ],
              [
                -0.13,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.18,
                -0.07
              ],
              [
                0.23,
                0
              ]
            ],
            v: [
              [
                1.94,
                6.62
              ],
              [
                1.94,
                6.62
              ],
              [
                1.12,
                6.41
              ],
              [
                0.54,
                5.8
              ],
              [
                0.32,
                4.85
              ],
              [
                0.32,
                4.85
              ],
              [
                0.54,
                3.9
              ],
              [
                1.11,
                3.29
              ],
              [
                1.84,
                3.07
              ],
              [
                1.84,
                3.07
              ],
              [
                2.84,
                3.5
              ],
              [
                3.19,
                4.66
              ],
              [
                3.19,
                4.66
              ],
              [
                3.19,
                4.84
              ],
              [
                3.17,
                4.99
              ],
              [
                3.17,
                4.99
              ],
              [
                0.88,
                4.99
              ],
              [
                1.22,
                5.84
              ],
              [
                2.01,
                6.16
              ],
              [
                2.01,
                6.16
              ],
              [
                2.46,
                6.09
              ],
              [
                2.86,
                5.9
              ],
              [
                2.86,
                5.9
              ],
              [
                3.06,
                6.28
              ],
              [
                2.57,
                6.52
              ],
              [
                1.94,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.25,
                -0.14
              ],
              [
                -0.14,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.37
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.23,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0.43,
                0
              ],
              [
                0.23,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0,
                0.06
              ],
              [
                0,
                0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.02,
                0.36
              ],
              [
                0.2,
                0.21
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0
              ],
              [
                0.14,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0.09
              ],
              [
                -0.18,
                0.07
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.18
              ],
              [
                0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.18
              ],
              [
                0.04,
                -0.33
              ]
            ],
            v: [
              [
                0.88,
                4.58
              ],
              [
                0.88,
                4.58
              ],
              [
                2.69,
                4.58
              ],
              [
                2.47,
                3.79
              ],
              [
                1.85,
                3.52
              ],
              [
                1.85,
                3.52
              ],
              [
                1.22,
                3.8
              ],
              [
                0.88,
                4.58
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.34
              ],
              [
                -0.15,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                0
              ],
              [
                -0.19,
                0.18
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 489,
    ty: 3,
    parent: 486,
    ks: {
      p: {
        a: 0,
        k: [
          12.173,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 492,
    ty: 4,
    parent: 491,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.2,
                6.6
              ],
              [
                1.2,
                6.6
              ],
              [
                0.7,
                6.4
              ],
              [
                0.6,
                5.9
              ],
              [
                0.6,
                5.9
              ],
              [
                0.6,
                1.6
              ],
              [
                1.1,
                1.6
              ],
              [
                1.1,
                5.9
              ],
              [
                1.2,
                6.1
              ],
              [
                1.3,
                6.2
              ],
              [
                1.3,
                6.2
              ],
              [
                1.4,
                6.1
              ],
              [
                1.4,
                6.1
              ],
              [
                1.4,
                6.1
              ],
              [
                1.5,
                6.6
              ],
              [
                1.4,
                6.6
              ],
              [
                1.2,
                6.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 491,
    ty: 3,
    parent: 486,
    ks: {
      p: {
        a: 0,
        k: [
          10.398,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 494,
    ty: 4,
    parent: 493,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                0.17
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.72,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0.04,
                0.13
              ],
              [
                0.1,
                0.08
              ],
              [
                0.19,
                0
              ],
              [
                0,
                0
              ],
              [
                0.17,
                -0.07
              ],
              [
                0.13,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                -0.25
              ],
              [
                0,
                -0.42
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.1
              ],
              [
                0.21,
                0
              ]
            ],
            v: [
              [
                1.35,
                6.62
              ],
              [
                1.35,
                6.62
              ],
              [
                0.64,
                6.37
              ],
              [
                0.36,
                5.66
              ],
              [
                0.36,
                5.66
              ],
              [
                0.86,
                4.81
              ],
              [
                2.44,
                4.39
              ],
              [
                2.44,
                4.39
              ],
              [
                2.38,
                3.98
              ],
              [
                2.17,
                3.67
              ],
              [
                1.74,
                3.54
              ],
              [
                1.74,
                3.54
              ],
              [
                1.19,
                3.66
              ],
              [
                0.73,
                3.91
              ],
              [
                0.73,
                3.91
              ],
              [
                0.51,
                3.51
              ],
              [
                1.09,
                3.21
              ],
              [
                1.84,
                3.07
              ],
              [
                1.84,
                3.07
              ],
              [
                2.74,
                3.45
              ],
              [
                3.02,
                4.46
              ],
              [
                3.02,
                4.46
              ],
              [
                3.02,
                6.54
              ],
              [
                2.54,
                6.54
              ],
              [
                2.49,
                6.14
              ],
              [
                2.47,
                6.14
              ],
              [
                1.95,
                6.48
              ],
              [
                1.35,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.28,
                0
              ],
              [
                -0.19,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.14
              ],
              [
                -0.04,
                -0.13
              ],
              [
                -0.1,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.17,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.1
              ],
              [
                0.23,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.41,
                0
              ],
              [
                0.19,
                0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                0.13
              ],
              [
                -0.19,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0.08
              ],
              [
                -0.16,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.14
              ],
              [
                0,
                -0.22
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                -0.09
              ],
              [
                -0.17,
                0
              ]
            ],
            v: [
              [
                1.52,
                6.16
              ],
              [
                1.52,
                6.16
              ],
              [
                1.98,
                6.05
              ],
              [
                2.44,
                5.71
              ],
              [
                2.44,
                5.71
              ],
              [
                2.44,
                4.77
              ],
              [
                1.26,
                5.08
              ],
              [
                0.92,
                5.62
              ],
              [
                0.92,
                5.62
              ],
              [
                1.09,
                6.04
              ],
              [
                1.52,
                6.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.16,
                0
              ],
              [
                0.14,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.56,
                0.07
              ],
              [
                -0.23,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0.19
              ],
              [
                0.12,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 493,
    ty: 3,
    parent: 486,
    ks: {
      p: {
        a: 0,
        k: [
          6.89,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 496,
    ty: 4,
    parent: 495,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.14
              ],
              [
                0.14,
                0.26
              ],
              [
                0,
                0.37
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.25,
                0.14
              ],
              [
                -0.29,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.08
              ],
              [
                -0.12,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.11,
                0.06
              ],
              [
                0.13,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.11
              ],
              [
                0.09,
                -0.2
              ],
              [
                0,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                -0.24
              ],
              [
                -0.31,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                0.07
              ],
              [
                -0.1,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.08
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.91,
                6.62
              ],
              [
                1.91,
                6.62
              ],
              [
                1.1,
                6.42
              ],
              [
                0.53,
                5.81
              ],
              [
                0.32,
                4.85
              ],
              [
                0.32,
                4.85
              ],
              [
                0.55,
                3.89
              ],
              [
                1.15,
                3.28
              ],
              [
                1.95,
                3.07
              ],
              [
                1.95,
                3.07
              ],
              [
                2.53,
                3.19
              ],
              [
                2.94,
                3.47
              ],
              [
                2.94,
                3.47
              ],
              [
                2.65,
                3.84
              ],
              [
                2.34,
                3.63
              ],
              [
                1.97,
                3.54
              ],
              [
                1.97,
                3.54
              ],
              [
                1.42,
                3.71
              ],
              [
                1.05,
                4.17
              ],
              [
                0.91,
                4.85
              ],
              [
                0.91,
                4.85
              ],
              [
                1.2,
                5.79
              ],
              [
                1.96,
                6.15
              ],
              [
                1.96,
                6.15
              ],
              [
                2.4,
                6.05
              ],
              [
                2.75,
                5.81
              ],
              [
                2.75,
                5.81
              ],
              [
                3,
                6.19
              ],
              [
                2.49,
                6.51
              ],
              [
                1.91,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.24,
                -0.14
              ],
              [
                -0.14,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.38
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.25,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.16,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.09
              ],
              [
                -0.11,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.16,
                0.11
              ],
              [
                -0.09,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.39
              ],
              [
                0.19,
                0.24
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0
              ],
              [
                0.13,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.13
              ],
              [
                -0.19,
                0.08
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 495,
    ty: 3,
    parent: 486,
    ks: {
      p: {
        a: 0,
        k: [
          3.717,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 498,
    ty: 4,
    parent: 497,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                0.12
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.1
              ],
              [
                -0.24,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.14
              ],
              [
                0,
                0.22
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.09
              ],
              [
                0.11,
                0.07
              ],
              [
                0.14,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.1
              ],
              [
                0.1,
                0.15
              ],
              [
                0,
                0.22
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                0.18
              ],
              [
                -0.22,
                0.1
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                -0.1
              ],
              [
                -0.16,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.17,
                0.08
              ],
              [
                0.21,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.12
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.1
              ],
              [
                -0.12,
                -0.06
              ],
              [
                -0.12,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.1
              ],
              [
                -0.08,
                -0.15
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0.13,
                -0.2
              ],
              [
                0.23,
                -0.12
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                1.89,
                6.62
              ],
              [
                1.89,
                6.62
              ],
              [
                1,
                6.44
              ],
              [
                0.29,
                5.95
              ],
              [
                0.29,
                5.95
              ],
              [
                0.64,
                5.54
              ],
              [
                1.22,
                5.96
              ],
              [
                1.9,
                6.12
              ],
              [
                1.9,
                6.12
              ],
              [
                2.61,
                5.91
              ],
              [
                2.86,
                5.37
              ],
              [
                2.86,
                5.37
              ],
              [
                2.76,
                4.99
              ],
              [
                2.48,
                4.76
              ],
              [
                2.1,
                4.56
              ],
              [
                2.1,
                4.56
              ],
              [
                1.44,
                4.28
              ],
              [
                1.01,
                4.04
              ],
              [
                0.66,
                3.66
              ],
              [
                0.52,
                3.1
              ],
              [
                0.52,
                3.1
              ],
              [
                0.7,
                2.48
              ],
              [
                1.21,
                2.04
              ],
              [
                1.95,
                1.89
              ],
              [
                1.95,
                1.89
              ],
              [
                2.71,
                2.04
              ],
              [
                3.3,
                2.45
              ],
              [
                3.3,
                2.45
              ],
              [
                2.99,
                2.83
              ],
              [
                2.53,
                2.51
              ],
              [
                1.95,
                2.4
              ],
              [
                1.95,
                2.4
              ],
              [
                1.33,
                2.58
              ],
              [
                1.1,
                3.06
              ],
              [
                1.1,
                3.06
              ],
              [
                1.22,
                3.42
              ],
              [
                1.5,
                3.66
              ],
              [
                1.86,
                3.82
              ],
              [
                1.86,
                3.82
              ],
              [
                2.51,
                4.1
              ],
              [
                2.99,
                4.37
              ],
              [
                3.32,
                4.75
              ],
              [
                3.45,
                5.32
              ],
              [
                3.45,
                5.32
              ],
              [
                3.26,
                5.98
              ],
              [
                2.72,
                6.45
              ],
              [
                1.89,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.27,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.17
              ],
              [
                0.22,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.17,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.16
              ],
              [
                -0.07,
                -0.09
              ],
              [
                -0.11,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.06
              ],
              [
                -0.14,
                -0.1
              ],
              [
                -0.1,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.23
              ],
              [
                0.12,
                -0.18
              ],
              [
                0.22,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.27,
                0
              ],
              [
                0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.13
              ],
              [
                -0.17,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                -0.26,
                0
              ],
              [
                -0.16,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0.14
              ],
              [
                0.08,
                0.1
              ],
              [
                0.12,
                0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0.07
              ],
              [
                0.14,
                0.1
              ],
              [
                0.08,
                0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                0.24
              ],
              [
                -0.13,
                0.2
              ],
              [
                -0.23,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 497,
    ty: 3,
    parent: 486,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 486,
    ty: 3,
    parent: 485,
    ks: {
      p: {
        a: 0,
        k: [
          14.372,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 501,
    ty: 4,
    parent: 500,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.21
              ],
              [
                0,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.11
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.07,
                0.02
              ],
              [
                -0.06,
                0.02
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.11,
                -0.03
              ],
              [
                0.11,
                0
              ]
            ],
            v: [
              [
                1.64,
                6.62
              ],
              [
                1.64,
                6.62
              ],
              [
                0.88,
                6.31
              ],
              [
                0.67,
                5.5
              ],
              [
                0.67,
                5.5
              ],
              [
                0.67,
                3.62
              ],
              [
                0.17,
                3.62
              ],
              [
                0.17,
                3.19
              ],
              [
                0.7,
                3.15
              ],
              [
                0.77,
                2.21
              ],
              [
                1.25,
                2.21
              ],
              [
                1.25,
                3.15
              ],
              [
                2.16,
                3.15
              ],
              [
                2.16,
                3.62
              ],
              [
                1.25,
                3.62
              ],
              [
                1.25,
                5.5
              ],
              [
                1.36,
                5.99
              ],
              [
                1.77,
                6.16
              ],
              [
                1.77,
                6.16
              ],
              [
                1.96,
                6.13
              ],
              [
                2.15,
                6.07
              ],
              [
                2.15,
                6.07
              ],
              [
                2.26,
                6.5
              ],
              [
                1.96,
                6.59
              ],
              [
                1.64,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.36,
                0
              ],
              [
                -0.14,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.08,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.06,
                0
              ],
              [
                0.07,
                -0.02
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.09,
                0.03
              ],
              [
                -0.11,
                0.03
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 500,
    ty: 3,
    parent: 499,
    ks: {
      p: {
        a: 0,
        k: [
          10.628,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 503,
    ty: 4,
    parent: 502,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0.09
              ],
              [
                0.16,
                0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.08
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.11,
                0.1
              ],
              [
                0,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0.08,
                0.08
              ],
              [
                0.12,
                0.05
              ],
              [
                0.13,
                0.05
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.08
              ],
              [
                0.1,
                0.12
              ],
              [
                0,
                0.19
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                -0.07
              ],
              [
                -0.13,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.13,
                0.06
              ],
              [
                0.15,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                -0.07,
                -0.07
              ],
              [
                -0.11,
                -0.05
              ],
              [
                -0.13,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.08
              ],
              [
                -0.1,
                -0.13
              ],
              [
                0,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.15
              ],
              [
                0.18,
                -0.09
              ],
              [
                0.27,
                0
              ]
            ],
            v: [
              [
                1.46,
                6.62
              ],
              [
                1.46,
                6.62
              ],
              [
                0.77,
                6.49
              ],
              [
                0.2,
                6.16
              ],
              [
                0.2,
                6.16
              ],
              [
                0.48,
                5.77
              ],
              [
                0.94,
                6.06
              ],
              [
                1.48,
                6.18
              ],
              [
                1.48,
                6.18
              ],
              [
                1.98,
                6.02
              ],
              [
                2.15,
                5.65
              ],
              [
                2.15,
                5.65
              ],
              [
                2.03,
                5.36
              ],
              [
                1.74,
                5.16
              ],
              [
                1.37,
                5.01
              ],
              [
                1.37,
                5.01
              ],
              [
                0.91,
                4.8
              ],
              [
                0.53,
                4.5
              ],
              [
                0.38,
                4.03
              ],
              [
                0.38,
                4.03
              ],
              [
                0.69,
                3.35
              ],
              [
                1.55,
                3.07
              ],
              [
                1.55,
                3.07
              ],
              [
                2.14,
                3.18
              ],
              [
                2.61,
                3.45
              ],
              [
                2.61,
                3.45
              ],
              [
                2.33,
                3.82
              ],
              [
                1.96,
                3.6
              ],
              [
                1.55,
                3.52
              ],
              [
                1.55,
                3.52
              ],
              [
                1.08,
                3.66
              ],
              [
                0.93,
                4
              ],
              [
                0.93,
                4
              ],
              [
                1.04,
                4.27
              ],
              [
                1.31,
                4.44
              ],
              [
                1.66,
                4.59
              ],
              [
                1.66,
                4.59
              ],
              [
                2.15,
                4.8
              ],
              [
                2.54,
                5.1
              ],
              [
                2.7,
                5.61
              ],
              [
                2.7,
                5.61
              ],
              [
                2.55,
                6.12
              ],
              [
                2.14,
                6.48
              ],
              [
                1.46,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.24,
                0
              ],
              [
                -0.22,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.12
              ],
              [
                0.16,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.11,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.12
              ],
              [
                -0.08,
                -0.08
              ],
              [
                -0.12,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.06
              ],
              [
                -0.15,
                -0.08
              ],
              [
                -0.1,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.27
              ],
              [
                0.21,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                0.21,
                0
              ],
              [
                0.18,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                -0.09
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.11
              ],
              [
                0.07,
                0.07
              ],
              [
                0.11,
                0.05
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.06
              ],
              [
                0.16,
                0.08
              ],
              [
                0.1,
                0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0.18
              ],
              [
                -0.1,
                0.15
              ],
              [
                -0.18,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 502,
    ty: 3,
    parent: 499,
    ks: {
      p: {
        a: 0,
        k: [
          7.712,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 505,
    ty: 4,
    parent: 504,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.14
              ],
              [
                0.15,
                0.26
              ],
              [
                0,
                0.37
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.24,
                0.14
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                -0.14
              ],
              [
                -0.15,
                -0.26
              ],
              [
                0,
                -0.38
              ],
              [
                0,
                0
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.24,
                -0.14
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.89,
                6.62
              ],
              [
                1.89,
                6.62
              ],
              [
                1.12,
                6.42
              ],
              [
                0.54,
                5.81
              ],
              [
                0.32,
                4.85
              ],
              [
                0.32,
                4.85
              ],
              [
                0.54,
                3.89
              ],
              [
                1.12,
                3.28
              ],
              [
                1.89,
                3.07
              ],
              [
                1.89,
                3.07
              ],
              [
                2.66,
                3.28
              ],
              [
                3.24,
                3.89
              ],
              [
                3.46,
                4.85
              ],
              [
                3.46,
                4.85
              ],
              [
                3.24,
                5.81
              ],
              [
                2.66,
                6.42
              ],
              [
                1.89,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.24,
                -0.14
              ],
              [
                -0.15,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.38
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.24,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0.28,
                0
              ],
              [
                0.24,
                0.14
              ],
              [
                0.15,
                0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                0.37
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.24,
                0.14
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0.24
              ],
              [
                0,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0.24
              ],
              [
                0.29,
                0
              ],
              [
                0,
                0
              ],
              [
                0.18,
                -0.24
              ],
              [
                0,
                -0.39
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                -0.24
              ],
              [
                -0.29,
                0
              ]
            ],
            v: [
              [
                1.89,
                6.15
              ],
              [
                1.89,
                6.15
              ],
              [
                2.6,
                5.79
              ],
              [
                2.86,
                4.85
              ],
              [
                2.86,
                4.85
              ],
              [
                2.6,
                3.91
              ],
              [
                1.89,
                3.54
              ],
              [
                1.89,
                3.54
              ],
              [
                1.18,
                3.91
              ],
              [
                0.91,
                4.85
              ],
              [
                0.91,
                4.85
              ],
              [
                1.18,
                5.79
              ],
              [
                1.89,
                6.15
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.29,
                0
              ],
              [
                0.18,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.39
              ],
              [
                -0.18,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                0
              ],
              [
                -0.18,
                0.24
              ],
              [
                0,
                0
              ],
              [
                0,
                0.39
              ],
              [
                0.18,
                0.24
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 504,
    ty: 3,
    parent: 499,
    ks: {
      p: {
        a: 0,
        k: [
          3.939,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 507,
    ty: 4,
    parent: 506,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.26,
                -0.08
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.23
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.21,
                6.54
              ],
              [
                0.63,
                6.54
              ],
              [
                0.63,
                1.97
              ],
              [
                1.93,
                1.97
              ],
              [
                2.83,
                2.1
              ],
              [
                3.43,
                2.52
              ],
              [
                3.64,
                3.31
              ],
              [
                3.64,
                3.31
              ],
              [
                3.18,
                4.38
              ],
              [
                1.96,
                4.73
              ],
              [
                1.96,
                4.73
              ],
              [
                1.21,
                4.73
              ],
              [
                1.21,
                6.54
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0
              ],
              [
                0.26,
                0.08
              ],
              [
                0.14,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.48
              ],
              [
                -0.31,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.15
              ],
              [
                0,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.13
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.21,
                2.44
              ],
              [
                1.21,
                4.26
              ],
              [
                1.89,
                4.26
              ],
              [
                2.78,
                4.03
              ],
              [
                3.07,
                3.31
              ],
              [
                3.07,
                3.31
              ],
              [
                2.76,
                2.63
              ],
              [
                1.86,
                2.44
              ],
              [
                1.86,
                2.44
              ],
              [
                1.21,
                2.44
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.19,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.33
              ],
              [
                -0.2,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 506,
    ty: 3,
    parent: 499,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 499,
    ty: 3,
    parent: 485,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 485,
    ty: 3,
    parent: 484,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 484,
    ty: 3,
    parent: 449,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 449,
    ty: 3,
    parent: 448,
    ks: {
      p: {
        a: 0,
        k: [
          154.274,
          2.46
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 514,
    ty: 0,
    parent: 510,
    ks: {},
    w: 21,
    h: 10,
    ip: 0,
    op: 565,
    st: 0,
    refId: "512"
  },
  {
    ind: 510,
    ty: 3,
    parent: 509,
    ks: {
      s: {
        a: 0,
        k: [
          107.41,
          107.14
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 509,
    ty: 3,
    parent: 508,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 508,
    ty: 3,
    parent: 448,
    ks: {
      p: {
        a: 0,
        k: [
          123.928,
          8.399
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 520,
    ty: 4,
    parent: 519,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.4
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                3,
                10.3
              ],
              [
                3,
                10.3
              ],
              [
                1.7,
                10
              ],
              [
                0.8,
                9
              ],
              [
                0.5,
                7.6
              ],
              [
                0.5,
                7.6
              ],
              [
                0.8,
                6.1
              ],
              [
                1.7,
                5.1
              ],
              [
                2.9,
                4.8
              ],
              [
                2.9,
                4.8
              ],
              [
                4.4,
                5.4
              ],
              [
                5,
                7.2
              ],
              [
                5,
                7.2
              ],
              [
                5,
                7.5
              ],
              [
                4.9,
                7.8
              ],
              [
                4.9,
                7.8
              ],
              [
                1.4,
                7.8
              ],
              [
                1.9,
                9.1
              ],
              [
                3.1,
                9.6
              ],
              [
                3.1,
                9.6
              ],
              [
                3.8,
                9.5
              ],
              [
                4.4,
                9.2
              ],
              [
                4.4,
                9.2
              ],
              [
                4.8,
                9.8
              ],
              [
                4,
                10.1
              ],
              [
                3,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.2,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.1,
                -0.5
              ]
            ],
            v: [
              [
                1.4,
                7.1
              ],
              [
                1.4,
                7.1
              ],
              [
                4.2,
                7.1
              ],
              [
                3.8,
                5.9
              ],
              [
                2.9,
                5.5
              ],
              [
                2.9,
                5.5
              ],
              [
                1.9,
                5.9
              ],
              [
                1.4,
                7.1
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 519,
    ty: 3,
    parent: 518,
    ks: {
      p: {
        a: 0,
        k: [
          31.18,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 522,
    ty: 4,
    parent: 521,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.2,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                10.2
              ],
              [
                0.9,
                10.2
              ],
              [
                0.9,
                4.9
              ],
              [
                1.6,
                4.9
              ],
              [
                1.7,
                5.9
              ],
              [
                1.7,
                5.9
              ],
              [
                2.4,
                5.1
              ],
              [
                3.2,
                4.8
              ],
              [
                3.2,
                4.8
              ],
              [
                3.8,
                4.9
              ],
              [
                3.8,
                4.9
              ],
              [
                3.6,
                5.7
              ],
              [
                3.4,
                5.6
              ],
              [
                3.1,
                5.6
              ],
              [
                3.1,
                5.6
              ],
              [
                2.4,
                5.9
              ],
              [
                1.8,
                6.8
              ],
              [
                1.8,
                6.8
              ],
              [
                1.8,
                10.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 521,
    ty: 3,
    parent: 518,
    ks: {
      p: {
        a: 0,
        k: [
          27.422,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 524,
    ty: 4,
    parent: 523,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.5,
                0.3
              ],
              [
                -1.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.7
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.1,
                10.3
              ],
              [
                2.1,
                10.3
              ],
              [
                1,
                9.9
              ],
              [
                0.6,
                8.8
              ],
              [
                0.6,
                8.8
              ],
              [
                1.3,
                7.5
              ],
              [
                3.8,
                6.8
              ],
              [
                3.8,
                6.8
              ],
              [
                3.7,
                6.2
              ],
              [
                3.4,
                5.7
              ],
              [
                2.7,
                5.5
              ],
              [
                2.7,
                5.5
              ],
              [
                1.9,
                5.7
              ],
              [
                1.1,
                6.1
              ],
              [
                1.1,
                6.1
              ],
              [
                0.8,
                5.5
              ],
              [
                1.7,
                5
              ],
              [
                2.9,
                4.8
              ],
              [
                2.9,
                4.8
              ],
              [
                4.3,
                5.4
              ],
              [
                4.7,
                6.9
              ],
              [
                4.7,
                6.9
              ],
              [
                4.7,
                10.2
              ],
              [
                4,
                10.2
              ],
              [
                3.9,
                9.5
              ],
              [
                3.8,
                9.5
              ],
              [
                3,
                10.1
              ],
              [
                2.1,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.5,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.4,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.4,
                9.6
              ],
              [
                2.4,
                9.6
              ],
              [
                3.1,
                9.4
              ],
              [
                3.8,
                8.9
              ],
              [
                3.8,
                8.9
              ],
              [
                3.8,
                7.4
              ],
              [
                2,
                7.9
              ],
              [
                1.4,
                8.7
              ],
              [
                1.4,
                8.7
              ],
              [
                1.7,
                9.4
              ],
              [
                2.4,
                9.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.9,
                0.1
              ],
              [
                -0.4,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 523,
    ty: 3,
    parent: 518,
    ks: {
      p: {
        a: 0,
        k: [
          21.963,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 526,
    ty: 4,
    parent: 525,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.4
              ],
              [
                -0.1,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.4
              ],
              [
                -0.1,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.4
              ],
              [
                -0.1,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.4
              ],
              [
                -0.1,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.3
              ],
              [
                0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.3
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.8,
                10.2
              ],
              [
                1.8,
                10.2
              ],
              [
                0.2,
                3.1
              ],
              [
                1.2,
                3.1
              ],
              [
                1.9,
                6.9
              ],
              [
                2.1,
                8.1
              ],
              [
                2.3,
                9.2
              ],
              [
                2.3,
                9.2
              ],
              [
                2.4,
                9.2
              ],
              [
                2.6,
                8.1
              ],
              [
                2.9,
                6.9
              ],
              [
                2.9,
                6.9
              ],
              [
                3.9,
                3.1
              ],
              [
                4.7,
                3.1
              ],
              [
                5.7,
                6.9
              ],
              [
                5.9,
                8.1
              ],
              [
                6.2,
                9.2
              ],
              [
                6.2,
                9.2
              ],
              [
                6.2,
                9.2
              ],
              [
                6.4,
                8.1
              ],
              [
                6.6,
                6.9
              ],
              [
                6.6,
                6.9
              ],
              [
                7.4,
                3.1
              ],
              [
                8.3,
                3.1
              ],
              [
                6.8,
                10.2
              ],
              [
                5.7,
                10.2
              ],
              [
                4.6,
                5.9
              ],
              [
                4.4,
                5.1
              ],
              [
                4.3,
                4.3
              ],
              [
                4.3,
                4.3
              ],
              [
                4.2,
                4.3
              ],
              [
                4.1,
                5.1
              ],
              [
                3.9,
                5.9
              ],
              [
                3.9,
                5.9
              ],
              [
                2.8,
                10.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.4
              ],
              [
                0.1,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.4
              ],
              [
                0.1,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.4
              ],
              [
                0.1,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.4
              ],
              [
                0.1,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.3
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 525,
    ty: 3,
    parent: 518,
    ks: {
      p: {
        a: 0,
        k: [
          13.451,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 528,
    ty: 4,
    parent: 527,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                10.2
              ],
              [
                1,
                10.2
              ],
              [
                1,
                3.1
              ],
              [
                2.1,
                3.1
              ],
              [
                3.4,
                6.9
              ],
              [
                3.7,
                7.6
              ],
              [
                3.9,
                8.3
              ],
              [
                3.9,
                8.3
              ],
              [
                4,
                8.3
              ],
              [
                4.2,
                7.6
              ],
              [
                4.5,
                6.9
              ],
              [
                4.5,
                6.9
              ],
              [
                5.8,
                3.1
              ],
              [
                6.9,
                3.1
              ],
              [
                6.9,
                10.2
              ],
              [
                6.1,
                10.2
              ],
              [
                6.1,
                6.3
              ],
              [
                6.1,
                5.2
              ],
              [
                6.2,
                4.2
              ],
              [
                6.2,
                4.2
              ],
              [
                6.1,
                4.2
              ],
              [
                5.6,
                5.8
              ],
              [
                4.2,
                9.5
              ],
              [
                3.6,
                9.5
              ],
              [
                2.3,
                5.8
              ],
              [
                1.7,
                4.2
              ],
              [
                1.7,
                4.2
              ],
              [
                1.8,
                5.2
              ],
              [
                1.8,
                6.3
              ],
              [
                1.8,
                6.3
              ],
              [
                1.8,
                10.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 527,
    ty: 3,
    parent: 518,
    ks: {
      p: {
        a: 0,
        k: [
          5.577,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 530,
    ty: 4,
    parent: 529,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.4
              ],
              [
                -0.1,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.4
              ],
              [
                -0.1,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                3.3,
                10.2
              ],
              [
                2.3,
                10.2
              ],
              [
                0,
                3.1
              ],
              [
                1,
                3.1
              ],
              [
                2.1,
                6.9
              ],
              [
                2.4,
                8.1
              ],
              [
                2.8,
                9.3
              ],
              [
                2.8,
                9.3
              ],
              [
                2.8,
                9.3
              ],
              [
                3.2,
                8.1
              ],
              [
                3.5,
                6.9
              ],
              [
                3.5,
                6.9
              ],
              [
                4.7,
                3.1
              ],
              [
                5.6,
                3.1
              ],
              [
                3.3,
                10.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.4
              ],
              [
                0.1,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.4
              ],
              [
                0.1,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 529,
    ty: 3,
    parent: 518,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 518,
    ty: 3,
    parent: 517,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 517,
    ty: 3,
    parent: 516,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 516,
    ty: 3,
    parent: 515,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          12.336
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 536,
    ty: 0,
    parent: 532,
    ks: {},
    w: 62,
    h: 12,
    ip: 0,
    op: 565,
    st: 0,
    refId: "534"
  },
  {
    ind: 532,
    ty: 3,
    parent: 531,
    ks: {
      s: {
        a: 0,
        k: [
          107.41,
          107.14
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 531,
    ty: 3,
    parent: 515,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 515,
    ty: 3,
    parent: 448,
    ks: {
      p: {
        a: 0,
        k: [
          22.811,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 448,
    ty: 3,
    parent: 379,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 379,
    ty: 3,
    parent: 378,
    ks: {
      p: {
        a: 0,
        k: [
          8.73,
          84.178
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 545,
    ty: 4,
    parent: 544,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.2
              ],
              [
                -0.35,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.39
              ],
              [
                0,
                -0.66
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.08
              ],
              [
                0.01,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                -0.29
              ],
              [
                -0.44,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.07
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.09
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                2.65,
                9.02
              ],
              [
                2.65,
                9.02
              ],
              [
                1.53,
                8.73
              ],
              [
                0.73,
                7.9
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.31
              ],
              [
                1.51,
                4.47
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.86,
                4.77
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.58
              ],
              [
                4.31,
                6.79
              ],
              [
                4.31,
                6.79
              ],
              [
                1.2,
                6.79
              ],
              [
                1.66,
                7.95
              ],
              [
                2.74,
                8.39
              ],
              [
                2.74,
                8.39
              ],
              [
                3.35,
                8.29
              ],
              [
                3.89,
                8.03
              ],
              [
                3.89,
                8.03
              ],
              [
                4.16,
                8.54
              ],
              [
                3.49,
                8.87
              ],
              [
                2.65,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.41,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.59,
                0
              ],
              [
                0.32,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.03,
                0.49
              ],
              [
                0.27,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.19,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.13
              ],
              [
                -0.25,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.24
              ],
              [
                0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.25
              ],
              [
                0.05,
                -0.46
              ]
            ],
            v: [
              [
                1.19,
                6.23
              ],
              [
                1.19,
                6.23
              ],
              [
                3.66,
                6.23
              ],
              [
                3.36,
                5.16
              ],
              [
                2.52,
                4.8
              ],
              [
                2.52,
                4.8
              ],
              [
                1.65,
                5.17
              ],
              [
                1.19,
                6.23
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.47
              ],
              [
                -0.2,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.26,
                0.25
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 544,
    ty: 3,
    parent: 543,
    ks: {
      p: {
        a: 0,
        k: [
          35.939,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 547,
    ty: 4,
    parent: 546,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.17
              ],
              [
                -0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.06,
                0.01
              ],
              [
                0.09,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.16
              ],
              [
                0.16,
                -0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                5.13
              ],
              [
                1.52,
                5.13
              ],
              [
                2.1,
                4.44
              ],
              [
                2.83,
                4.18
              ],
              [
                2.83,
                4.18
              ],
              [
                3.32,
                4.27
              ],
              [
                3.32,
                4.27
              ],
              [
                3.17,
                4.96
              ],
              [
                2.96,
                4.9
              ],
              [
                2.72,
                4.88
              ],
              [
                2.72,
                4.88
              ],
              [
                2.11,
                5.12
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.29
              ],
              [
                0.23,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.06,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.21,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 546,
    ty: 3,
    parent: 543,
    ks: {
      p: {
        a: 0,
        k: [
          32.649,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 549,
    ty: 4,
    parent: 548,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.33,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.33,
                0.19
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                -0.52
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.19
              ],
              [
                0.38,
                0
              ]
            ],
            v: [
              [
                2.57,
                9.02
              ],
              [
                2.57,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.73,
                7.91
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.29
              ],
              [
                1.52,
                4.46
              ],
              [
                2.57,
                4.18
              ],
              [
                2.57,
                4.18
              ],
              [
                3.62,
                4.46
              ],
              [
                4.4,
                5.29
              ],
              [
                4.7,
                6.61
              ],
              [
                4.7,
                6.61
              ],
              [
                4.4,
                7.91
              ],
              [
                3.62,
                8.73
              ],
              [
                2.57,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.37,
                0
              ],
              [
                -0.33,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.52
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.33,
                -0.19
              ],
              [
                0,
                0
              ],
              [
                0.38,
                0
              ],
              [
                0.32,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                0.51
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.19
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                0.33
              ],
              [
                0,
                0.52
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.33
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.33
              ],
              [
                0,
                -0.53
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.33
              ],
              [
                -0.39,
                0
              ]
            ],
            v: [
              [
                2.57,
                8.37
              ],
              [
                2.57,
                8.37
              ],
              [
                3.53,
                7.88
              ],
              [
                3.9,
                6.61
              ],
              [
                3.9,
                6.61
              ],
              [
                3.53,
                5.32
              ],
              [
                2.57,
                4.82
              ],
              [
                2.57,
                4.82
              ],
              [
                1.61,
                5.32
              ],
              [
                1.24,
                6.61
              ],
              [
                1.24,
                6.61
              ],
              [
                1.61,
                7.88
              ],
              [
                2.57,
                8.37
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.24,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.53
              ],
              [
                -0.24,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.25,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.52
              ],
              [
                0.25,
                0.33
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 548,
    ty: 3,
    parent: 543,
    ks: {
      p: {
        a: 0,
        k: [
          27.511,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 551,
    ty: 4,
    parent: 550,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.1
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.6,
                9
              ],
              [
                1.6,
                9
              ],
              [
                1,
                8.7
              ],
              [
                0.8,
                8
              ],
              [
                0.8,
                8
              ],
              [
                0.8,
                2.2
              ],
              [
                1.6,
                2.2
              ],
              [
                1.6,
                8
              ],
              [
                1.6,
                8.3
              ],
              [
                1.8,
                8.4
              ],
              [
                1.8,
                8.4
              ],
              [
                1.8,
                8.4
              ],
              [
                1.9,
                8.4
              ],
              [
                1.9,
                8.4
              ],
              [
                2,
                8.9
              ],
              [
                1.9,
                9
              ],
              [
                1.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 550,
    ty: 3,
    parent: 543,
    ks: {
      p: {
        a: 0,
        k: [
          25.094,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 553,
    ty: 4,
    parent: 552,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.23
              ],
              [
                0,
                0.41
              ],
              [
                0,
                0
              ],
              [
                -0.45,
                0.27
              ],
              [
                -0.98,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.18
              ],
              [
                0.14,
                0.11
              ],
              [
                0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.1
              ],
              [
                0.18,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.31,
                0.13
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.34
              ],
              [
                0,
                -0.58
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.13
              ],
              [
                0.29,
                0
              ]
            ],
            v: [
              [
                1.84,
                9.02
              ],
              [
                1.84,
                9.02
              ],
              [
                0.88,
                8.67
              ],
              [
                0.49,
                7.71
              ],
              [
                0.49,
                7.71
              ],
              [
                1.17,
                6.55
              ],
              [
                3.32,
                5.98
              ],
              [
                3.32,
                5.98
              ],
              [
                3.24,
                5.42
              ],
              [
                2.95,
                4.99
              ],
              [
                2.37,
                4.82
              ],
              [
                2.37,
                4.82
              ],
              [
                1.62,
                4.98
              ],
              [
                1,
                5.32
              ],
              [
                1,
                5.32
              ],
              [
                0.69,
                4.78
              ],
              [
                1.48,
                4.37
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.73,
                4.7
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                8.9
              ],
              [
                3.46,
                8.9
              ],
              [
                3.39,
                8.35
              ],
              [
                3.37,
                8.35
              ],
              [
                2.66,
                8.82
              ],
              [
                1.84,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.26,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.45,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.05,
                -0.18
              ],
              [
                -0.14,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.14
              ],
              [
                0.31,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.56,
                0
              ],
              [
                0.25,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.26,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.11
              ],
              [
                -0.22,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.19
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.23,
                0
              ]
            ],
            v: [
              [
                2.07,
                8.39
              ],
              [
                2.07,
                8.39
              ],
              [
                2.69,
                8.23
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                6.49
              ],
              [
                1.71,
                6.92
              ],
              [
                1.25,
                7.65
              ],
              [
                1.25,
                7.65
              ],
              [
                1.49,
                8.21
              ],
              [
                2.07,
                8.39
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.2,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.76,
                0.09
              ],
              [
                -0.31,
                0.19
              ],
              [
                0,
                0
              ],
              [
                0,
                0.26
              ],
              [
                0.16,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 552,
    ty: 3,
    parent: 543,
    ks: {
      p: {
        a: 0,
        k: [
          20.316,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 555,
    ty: 4,
    parent: 554,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.3,
                11
              ],
              [
                2.3,
                11
              ],
              [
                1,
                10.7
              ],
              [
                0.4,
                9.8
              ],
              [
                0.4,
                9.8
              ],
              [
                0.6,
                9.2
              ],
              [
                1.1,
                8.7
              ],
              [
                1.1,
                8.7
              ],
              [
                1.1,
                8.7
              ],
              [
                0.8,
                8.4
              ],
              [
                0.7,
                8
              ],
              [
                0.7,
                8
              ],
              [
                0.9,
                7.4
              ],
              [
                1.2,
                7.1
              ],
              [
                1.2,
                7.1
              ],
              [
                1.2,
                7.1
              ],
              [
                0.8,
                6.6
              ],
              [
                0.6,
                5.8
              ],
              [
                0.6,
                5.8
              ],
              [
                0.8,
                4.9
              ],
              [
                1.5,
                4.4
              ],
              [
                2.3,
                4.2
              ],
              [
                2.3,
                4.2
              ],
              [
                2.7,
                4.2
              ],
              [
                3,
                4.3
              ],
              [
                3,
                4.3
              ],
              [
                4.6,
                4.3
              ],
              [
                4.6,
                4.9
              ],
              [
                3.6,
                4.9
              ],
              [
                3.9,
                5.3
              ],
              [
                4,
                5.8
              ],
              [
                4,
                5.8
              ],
              [
                3.8,
                6.7
              ],
              [
                3.2,
                7.2
              ],
              [
                2.3,
                7.4
              ],
              [
                2.3,
                7.4
              ],
              [
                1.6,
                7.3
              ],
              [
                1.6,
                7.3
              ],
              [
                1.4,
                7.5
              ],
              [
                1.3,
                7.8
              ],
              [
                1.3,
                7.8
              ],
              [
                1.5,
                8.2
              ],
              [
                2.2,
                8.3
              ],
              [
                2.2,
                8.3
              ],
              [
                3.1,
                8.3
              ],
              [
                4.3,
                8.6
              ],
              [
                4.7,
                9.4
              ],
              [
                4.7,
                9.4
              ],
              [
                4.4,
                10.2
              ],
              [
                3.6,
                10.8
              ],
              [
                2.3,
                11
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.3,
                6.9
              ],
              [
                2.3,
                6.9
              ],
              [
                3,
                6.6
              ],
              [
                3.3,
                5.8
              ],
              [
                3.3,
                5.8
              ],
              [
                3,
                5
              ],
              [
                2.3,
                4.7
              ],
              [
                2.3,
                4.7
              ],
              [
                1.6,
                5
              ],
              [
                1.4,
                5.8
              ],
              [
                1.4,
                5.8
              ],
              [
                1.6,
                6.6
              ],
              [
                2.3,
                6.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.4,
                0
              ]
            ],
            v: [
              [
                2.4,
                10.5
              ],
              [
                2.4,
                10.5
              ],
              [
                3.5,
                10.2
              ],
              [
                3.9,
                9.5
              ],
              [
                3.9,
                9.5
              ],
              [
                3.7,
                9.1
              ],
              [
                3,
                9
              ],
              [
                3,
                9
              ],
              [
                2.2,
                9
              ],
              [
                1.9,
                9
              ],
              [
                1.6,
                8.9
              ],
              [
                1.6,
                8.9
              ],
              [
                1.2,
                9.3
              ],
              [
                1.1,
                9.7
              ],
              [
                1.1,
                9.7
              ],
              [
                1.5,
                10.3
              ],
              [
                2.4,
                10.5
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 554,
    ty: 3,
    parent: 543,
    ks: {
      p: {
        a: 0,
        k: [
          15.538,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 557,
    ty: 4,
    parent: 556,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                0.15
              ],
              [
                -0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.31
              ],
              [
                0,
                -0.59
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.12
              ],
              [
                0.23,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                4.96
              ],
              [
                1.52,
                4.96
              ],
              [
                2.22,
                4.4
              ],
              [
                3.06,
                4.18
              ],
              [
                3.06,
                4.18
              ],
              [
                4.13,
                4.64
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                8.9
              ],
              [
                3.69,
                8.9
              ],
              [
                3.69,
                6.09
              ],
              [
                3.48,
                5.15
              ],
              [
                2.82,
                4.85
              ],
              [
                2.82,
                4.85
              ],
              [
                2.19,
                5.03
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.22
              ],
              [
                0.25,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0.49,
                0
              ],
              [
                0.22,
                0.31
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.43
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.19,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 556,
    ty: 3,
    parent: 543,
    ks: {
      p: {
        a: 0,
        k: [
          10.352,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 559,
    ty: 4,
    parent: 558,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.23
              ],
              [
                0,
                0.41
              ],
              [
                0,
                0
              ],
              [
                -0.45,
                0.27
              ],
              [
                -0.98,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.18
              ],
              [
                0.14,
                0.11
              ],
              [
                0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.1
              ],
              [
                0.18,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.31,
                0.13
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.34
              ],
              [
                0,
                -0.58
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.13
              ],
              [
                0.29,
                0
              ]
            ],
            v: [
              [
                1.84,
                9.02
              ],
              [
                1.84,
                9.02
              ],
              [
                0.88,
                8.67
              ],
              [
                0.49,
                7.71
              ],
              [
                0.49,
                7.71
              ],
              [
                1.17,
                6.55
              ],
              [
                3.32,
                5.98
              ],
              [
                3.32,
                5.98
              ],
              [
                3.24,
                5.42
              ],
              [
                2.95,
                4.99
              ],
              [
                2.37,
                4.82
              ],
              [
                2.37,
                4.82
              ],
              [
                1.62,
                4.98
              ],
              [
                1,
                5.32
              ],
              [
                1,
                5.32
              ],
              [
                0.69,
                4.78
              ],
              [
                1.48,
                4.37
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.73,
                4.7
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                8.9
              ],
              [
                3.46,
                8.9
              ],
              [
                3.39,
                8.35
              ],
              [
                3.37,
                8.35
              ],
              [
                2.66,
                8.82
              ],
              [
                1.84,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.26,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.45,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.05,
                -0.18
              ],
              [
                -0.14,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.14
              ],
              [
                0.31,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.56,
                0
              ],
              [
                0.25,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.26,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.11
              ],
              [
                -0.22,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.19
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.23,
                0
              ]
            ],
            v: [
              [
                2.07,
                8.39
              ],
              [
                2.07,
                8.39
              ],
              [
                2.69,
                8.23
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                6.49
              ],
              [
                1.71,
                6.92
              ],
              [
                1.25,
                7.65
              ],
              [
                1.25,
                7.65
              ],
              [
                1.49,
                8.21
              ],
              [
                2.07,
                8.39
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.2,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.76,
                0.09
              ],
              [
                -0.31,
                0.19
              ],
              [
                0,
                0
              ],
              [
                0,
                0.26
              ],
              [
                0.16,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 558,
    ty: 3,
    parent: 543,
    ks: {
      p: {
        a: 0,
        k: [
          5.574,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 561,
    ty: 4,
    parent: 560,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.4,
                -0.1
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.8,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                2.7
              ],
              [
                2.7,
                2.7
              ],
              [
                3.8,
                2.8
              ],
              [
                4.6,
                3.3
              ],
              [
                4.8,
                4.2
              ],
              [
                4.8,
                4.2
              ],
              [
                4.6,
                5
              ],
              [
                3.9,
                5.6
              ],
              [
                3.9,
                5.6
              ],
              [
                3.9,
                5.6
              ],
              [
                4.8,
                6.1
              ],
              [
                5.2,
                7.1
              ],
              [
                5.2,
                7.1
              ],
              [
                4.9,
                8.1
              ],
              [
                4.1,
                8.7
              ],
              [
                2.8,
                8.9
              ],
              [
                2.8,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.4,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                3.3
              ],
              [
                1.6,
                5.3
              ],
              [
                2.6,
                5.3
              ],
              [
                3.7,
                5.1
              ],
              [
                4.1,
                4.3
              ],
              [
                4.1,
                4.3
              ],
              [
                3.7,
                3.5
              ],
              [
                2.6,
                3.3
              ],
              [
                2.6,
                3.3
              ],
              [
                1.6,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                5.9
              ],
              [
                1.6,
                8.3
              ],
              [
                2.7,
                8.3
              ],
              [
                4,
                8
              ],
              [
                4.4,
                7.1
              ],
              [
                4.4,
                7.1
              ],
              [
                4,
                6.2
              ],
              [
                2.7,
                5.9
              ],
              [
                2.7,
                5.9
              ],
              [
                1.6,
                5.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 560,
    ty: 3,
    parent: 543,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 543,
    ty: 3,
    parent: 542,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 542,
    ty: 3,
    parent: 541,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 541,
    ty: 3,
    parent: 540,
    ks: {
      p: {
        a: 0,
        k: [
          17.459,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 571,
    ty: 0,
    parent: 562,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.623
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.623
        ]
      }
    },
    w: 11.639,
    h: 11.611,
    ip: 0,
    op: 565,
    st: 0,
    refId: "569"
  },
  {
    ind: 562,
    ty: 3,
    parent: 540,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.623
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 540,
    ty: 3,
    parent: 539,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          15.76
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 577,
    ty: 4,
    parent: 576,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.17
              ],
              [
                -0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.06,
                0.01
              ],
              [
                0.09,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.16
              ],
              [
                0.16,
                -0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                5.13
              ],
              [
                1.52,
                5.13
              ],
              [
                2.1,
                4.44
              ],
              [
                2.83,
                4.18
              ],
              [
                2.83,
                4.18
              ],
              [
                3.32,
                4.27
              ],
              [
                3.32,
                4.27
              ],
              [
                3.17,
                4.96
              ],
              [
                2.96,
                4.9
              ],
              [
                2.72,
                4.88
              ],
              [
                2.72,
                4.88
              ],
              [
                2.11,
                5.12
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.29
              ],
              [
                0.23,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.06,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.21,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 576,
    ty: 3,
    parent: 575,
    ks: {
      p: {
        a: 0,
        k: [
          31.881,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 579,
    ty: 4,
    parent: 578,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.2
              ],
              [
                -0.35,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.39
              ],
              [
                0,
                -0.66
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.08
              ],
              [
                0.01,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                -0.29
              ],
              [
                -0.44,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.07
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.09
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                2.65,
                9.02
              ],
              [
                2.65,
                9.02
              ],
              [
                1.53,
                8.73
              ],
              [
                0.73,
                7.9
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.31
              ],
              [
                1.51,
                4.47
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.86,
                4.77
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.58
              ],
              [
                4.31,
                6.79
              ],
              [
                4.31,
                6.79
              ],
              [
                1.2,
                6.79
              ],
              [
                1.66,
                7.95
              ],
              [
                2.74,
                8.39
              ],
              [
                2.74,
                8.39
              ],
              [
                3.35,
                8.29
              ],
              [
                3.89,
                8.03
              ],
              [
                3.89,
                8.03
              ],
              [
                4.16,
                8.54
              ],
              [
                3.49,
                8.87
              ],
              [
                2.65,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.41,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.59,
                0
              ],
              [
                0.32,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.03,
                0.49
              ],
              [
                0.27,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.19,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.13
              ],
              [
                -0.25,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.24
              ],
              [
                0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.25
              ],
              [
                0.05,
                -0.46
              ]
            ],
            v: [
              [
                1.19,
                6.23
              ],
              [
                1.19,
                6.23
              ],
              [
                3.66,
                6.23
              ],
              [
                3.36,
                5.16
              ],
              [
                2.52,
                4.8
              ],
              [
                2.52,
                4.8
              ],
              [
                1.65,
                5.17
              ],
              [
                1.19,
                6.23
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.47
              ],
              [
                -0.2,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.26,
                0.25
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 578,
    ty: 3,
    parent: 575,
    ks: {
      p: {
        a: 0,
        k: [
          27.179,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 581,
    ty: 4,
    parent: 580,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.2
              ],
              [
                -0.35,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.39
              ],
              [
                0,
                -0.66
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.08
              ],
              [
                0.01,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                -0.29
              ],
              [
                -0.44,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.07
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.09
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                2.65,
                9.02
              ],
              [
                2.65,
                9.02
              ],
              [
                1.53,
                8.73
              ],
              [
                0.73,
                7.9
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.31
              ],
              [
                1.51,
                4.47
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.86,
                4.77
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.58
              ],
              [
                4.31,
                6.79
              ],
              [
                4.31,
                6.79
              ],
              [
                1.2,
                6.79
              ],
              [
                1.66,
                7.95
              ],
              [
                2.74,
                8.39
              ],
              [
                2.74,
                8.39
              ],
              [
                3.35,
                8.29
              ],
              [
                3.89,
                8.03
              ],
              [
                3.89,
                8.03
              ],
              [
                4.16,
                8.54
              ],
              [
                3.49,
                8.87
              ],
              [
                2.65,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.41,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.59,
                0
              ],
              [
                0.32,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.03,
                0.49
              ],
              [
                0.27,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.19,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.13
              ],
              [
                -0.25,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.24
              ],
              [
                0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.25
              ],
              [
                0.05,
                -0.46
              ]
            ],
            v: [
              [
                1.19,
                6.23
              ],
              [
                1.19,
                6.23
              ],
              [
                3.66,
                6.23
              ],
              [
                3.36,
                5.16
              ],
              [
                2.52,
                4.8
              ],
              [
                2.52,
                4.8
              ],
              [
                1.65,
                5.17
              ],
              [
                1.19,
                6.23
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.47
              ],
              [
                -0.2,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.26,
                0.25
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 580,
    ty: 3,
    parent: 575,
    ks: {
      p: {
        a: 0,
        k: [
          22.477,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 583,
    ty: 4,
    parent: 582,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                0.15
              ],
              [
                -0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.31
              ],
              [
                0,
                -0.59
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.12
              ],
              [
                0.23,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                4.96
              ],
              [
                1.52,
                4.96
              ],
              [
                2.22,
                4.4
              ],
              [
                3.06,
                4.18
              ],
              [
                3.06,
                4.18
              ],
              [
                4.13,
                4.64
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                8.9
              ],
              [
                3.69,
                8.9
              ],
              [
                3.69,
                6.09
              ],
              [
                3.48,
                5.15
              ],
              [
                2.82,
                4.85
              ],
              [
                2.82,
                4.85
              ],
              [
                2.19,
                5.03
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.22
              ],
              [
                0.25,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0.49,
                0
              ],
              [
                0.22,
                0.31
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.43
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.19,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 582,
    ty: 3,
    parent: 575,
    ks: {
      p: {
        a: 0,
        k: [
          17.291,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 585,
    ty: 4,
    parent: 584,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                4.3
              ],
              [
                1.6,
                4.3
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.3
              ],
              [
                1.2,
                3.3
              ],
              [
                0.8,
                3.2
              ],
              [
                0.7,
                2.8
              ],
              [
                0.7,
                2.8
              ],
              [
                0.8,
                2.5
              ],
              [
                1.2,
                2.3
              ],
              [
                1.2,
                2.3
              ],
              [
                1.6,
                2.5
              ],
              [
                1.7,
                2.8
              ],
              [
                1.7,
                2.8
              ],
              [
                1.6,
                3.2
              ],
              [
                1.2,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 584,
    ty: 3,
    parent: 575,
    ks: {
      p: {
        a: 0,
        k: [
          14.959,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 587,
    ty: 4,
    parent: 586,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.3,
                11
              ],
              [
                2.3,
                11
              ],
              [
                1,
                10.7
              ],
              [
                0.4,
                9.8
              ],
              [
                0.4,
                9.8
              ],
              [
                0.6,
                9.2
              ],
              [
                1.1,
                8.7
              ],
              [
                1.1,
                8.7
              ],
              [
                1.1,
                8.7
              ],
              [
                0.8,
                8.4
              ],
              [
                0.7,
                8
              ],
              [
                0.7,
                8
              ],
              [
                0.9,
                7.4
              ],
              [
                1.2,
                7.1
              ],
              [
                1.2,
                7.1
              ],
              [
                1.2,
                7.1
              ],
              [
                0.8,
                6.6
              ],
              [
                0.6,
                5.8
              ],
              [
                0.6,
                5.8
              ],
              [
                0.8,
                4.9
              ],
              [
                1.5,
                4.4
              ],
              [
                2.3,
                4.2
              ],
              [
                2.3,
                4.2
              ],
              [
                2.7,
                4.2
              ],
              [
                3,
                4.3
              ],
              [
                3,
                4.3
              ],
              [
                4.6,
                4.3
              ],
              [
                4.6,
                4.9
              ],
              [
                3.6,
                4.9
              ],
              [
                3.9,
                5.3
              ],
              [
                4,
                5.8
              ],
              [
                4,
                5.8
              ],
              [
                3.8,
                6.7
              ],
              [
                3.2,
                7.2
              ],
              [
                2.3,
                7.4
              ],
              [
                2.3,
                7.4
              ],
              [
                1.6,
                7.3
              ],
              [
                1.6,
                7.3
              ],
              [
                1.4,
                7.5
              ],
              [
                1.3,
                7.8
              ],
              [
                1.3,
                7.8
              ],
              [
                1.5,
                8.2
              ],
              [
                2.2,
                8.3
              ],
              [
                2.2,
                8.3
              ],
              [
                3.1,
                8.3
              ],
              [
                4.3,
                8.6
              ],
              [
                4.7,
                9.4
              ],
              [
                4.7,
                9.4
              ],
              [
                4.4,
                10.2
              ],
              [
                3.6,
                10.8
              ],
              [
                2.3,
                11
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.3,
                6.9
              ],
              [
                2.3,
                6.9
              ],
              [
                3,
                6.6
              ],
              [
                3.3,
                5.8
              ],
              [
                3.3,
                5.8
              ],
              [
                3,
                5
              ],
              [
                2.3,
                4.7
              ],
              [
                2.3,
                4.7
              ],
              [
                1.6,
                5
              ],
              [
                1.4,
                5.8
              ],
              [
                1.4,
                5.8
              ],
              [
                1.6,
                6.6
              ],
              [
                2.3,
                6.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.4,
                0
              ]
            ],
            v: [
              [
                2.4,
                10.5
              ],
              [
                2.4,
                10.5
              ],
              [
                3.5,
                10.2
              ],
              [
                3.9,
                9.5
              ],
              [
                3.9,
                9.5
              ],
              [
                3.7,
                9.1
              ],
              [
                3,
                9
              ],
              [
                3,
                9
              ],
              [
                2.2,
                9
              ],
              [
                1.9,
                9
              ],
              [
                1.6,
                8.9
              ],
              [
                1.6,
                8.9
              ],
              [
                1.2,
                9.3
              ],
              [
                1.1,
                9.7
              ],
              [
                1.1,
                9.7
              ],
              [
                1.5,
                10.3
              ],
              [
                2.4,
                10.5
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 586,
    ty: 3,
    parent: 575,
    ks: {
      p: {
        a: 0,
        k: [
          10.182,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 589,
    ty: 4,
    parent: 588,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                0.15
              ],
              [
                -0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.31
              ],
              [
                0,
                -0.59
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.12
              ],
              [
                0.23,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                4.96
              ],
              [
                1.52,
                4.96
              ],
              [
                2.22,
                4.4
              ],
              [
                3.06,
                4.18
              ],
              [
                3.06,
                4.18
              ],
              [
                4.13,
                4.64
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                8.9
              ],
              [
                3.69,
                8.9
              ],
              [
                3.69,
                6.09
              ],
              [
                3.48,
                5.15
              ],
              [
                2.82,
                4.85
              ],
              [
                2.82,
                4.85
              ],
              [
                2.19,
                5.03
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.22
              ],
              [
                0.25,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0.49,
                0
              ],
              [
                0.22,
                0.31
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.43
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.19,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 588,
    ty: 3,
    parent: 575,
    ks: {
      p: {
        a: 0,
        k: [
          4.996,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 591,
    ty: 4,
    parent: 590,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                4.5,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                2.7
              ],
              [
                4.4,
                2.7
              ],
              [
                4.4,
                3.3
              ],
              [
                1.6,
                3.3
              ],
              [
                1.6,
                5.3
              ],
              [
                4,
                5.3
              ],
              [
                4,
                6
              ],
              [
                1.6,
                6
              ],
              [
                1.6,
                8.2
              ],
              [
                4.5,
                8.2
              ],
              [
                4.5,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 590,
    ty: 3,
    parent: 575,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 575,
    ty: 3,
    parent: 574,
    ks: {
      p: {
        a: 0,
        k: [
          64.911,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 594,
    ty: 4,
    parent: 593,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.2
              ],
              [
                -0.35,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.39
              ],
              [
                0,
                -0.66
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.08
              ],
              [
                0.01,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                -0.29
              ],
              [
                -0.44,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.07
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.09
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                2.65,
                9.02
              ],
              [
                2.65,
                9.02
              ],
              [
                1.53,
                8.73
              ],
              [
                0.73,
                7.9
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.31
              ],
              [
                1.51,
                4.47
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.86,
                4.77
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.58
              ],
              [
                4.31,
                6.79
              ],
              [
                4.31,
                6.79
              ],
              [
                1.2,
                6.79
              ],
              [
                1.66,
                7.95
              ],
              [
                2.74,
                8.39
              ],
              [
                2.74,
                8.39
              ],
              [
                3.35,
                8.29
              ],
              [
                3.89,
                8.03
              ],
              [
                3.89,
                8.03
              ],
              [
                4.16,
                8.54
              ],
              [
                3.49,
                8.87
              ],
              [
                2.65,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.41,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.59,
                0
              ],
              [
                0.32,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.03,
                0.49
              ],
              [
                0.27,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.19,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.13
              ],
              [
                -0.25,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.24
              ],
              [
                0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.25
              ],
              [
                0.05,
                -0.46
              ]
            ],
            v: [
              [
                1.19,
                6.23
              ],
              [
                1.19,
                6.23
              ],
              [
                3.66,
                6.23
              ],
              [
                3.36,
                5.16
              ],
              [
                2.52,
                4.8
              ],
              [
                2.52,
                4.8
              ],
              [
                1.65,
                5.17
              ],
              [
                1.19,
                6.23
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.47
              ],
              [
                -0.2,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.26,
                0.25
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 593,
    ty: 3,
    parent: 592,
    ks: {
      p: {
        a: 0,
        k: [
          30.707,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 596,
    ty: 4,
    parent: 595,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.17
              ],
              [
                -0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.06,
                0.01
              ],
              [
                0.09,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.16
              ],
              [
                0.16,
                -0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                5.13
              ],
              [
                1.52,
                5.13
              ],
              [
                2.1,
                4.44
              ],
              [
                2.83,
                4.18
              ],
              [
                2.83,
                4.18
              ],
              [
                3.32,
                4.27
              ],
              [
                3.32,
                4.27
              ],
              [
                3.17,
                4.96
              ],
              [
                2.96,
                4.9
              ],
              [
                2.72,
                4.88
              ],
              [
                2.72,
                4.88
              ],
              [
                2.11,
                5.12
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.29
              ],
              [
                0.23,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.06,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.21,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 595,
    ty: 3,
    parent: 592,
    ks: {
      p: {
        a: 0,
        k: [
          27.417,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 598,
    ty: 4,
    parent: 597,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.23
              ],
              [
                0,
                0.41
              ],
              [
                0,
                0
              ],
              [
                -0.45,
                0.27
              ],
              [
                -0.98,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.18
              ],
              [
                0.14,
                0.11
              ],
              [
                0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.1
              ],
              [
                0.18,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.31,
                0.13
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.34
              ],
              [
                0,
                -0.58
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.13
              ],
              [
                0.29,
                0
              ]
            ],
            v: [
              [
                1.84,
                9.02
              ],
              [
                1.84,
                9.02
              ],
              [
                0.88,
                8.67
              ],
              [
                0.49,
                7.71
              ],
              [
                0.49,
                7.71
              ],
              [
                1.17,
                6.55
              ],
              [
                3.32,
                5.98
              ],
              [
                3.32,
                5.98
              ],
              [
                3.24,
                5.42
              ],
              [
                2.95,
                4.99
              ],
              [
                2.37,
                4.82
              ],
              [
                2.37,
                4.82
              ],
              [
                1.62,
                4.98
              ],
              [
                1,
                5.32
              ],
              [
                1,
                5.32
              ],
              [
                0.69,
                4.78
              ],
              [
                1.48,
                4.37
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.73,
                4.7
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                8.9
              ],
              [
                3.46,
                8.9
              ],
              [
                3.39,
                8.35
              ],
              [
                3.37,
                8.35
              ],
              [
                2.66,
                8.82
              ],
              [
                1.84,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.26,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.45,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.05,
                -0.18
              ],
              [
                -0.14,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.14
              ],
              [
                0.31,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.56,
                0
              ],
              [
                0.25,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.26,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.11
              ],
              [
                -0.22,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.19
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.23,
                0
              ]
            ],
            v: [
              [
                2.07,
                8.39
              ],
              [
                2.07,
                8.39
              ],
              [
                2.69,
                8.23
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                6.49
              ],
              [
                1.71,
                6.92
              ],
              [
                1.25,
                7.65
              ],
              [
                1.25,
                7.65
              ],
              [
                1.49,
                8.21
              ],
              [
                2.07,
                8.39
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.2,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.76,
                0.09
              ],
              [
                -0.31,
                0.19
              ],
              [
                0,
                0
              ],
              [
                0,
                0.26
              ],
              [
                0.16,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 597,
    ty: 3,
    parent: 592,
    ks: {
      p: {
        a: 0,
        k: [
          22.64,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 600,
    ty: 4,
    parent: 599,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.9
              ],
              [
                1.5,
                8.9
              ],
              [
                0.2,
                4.3
              ],
              [
                1,
                4.3
              ],
              [
                1.7,
                7
              ],
              [
                1.8,
                7.6
              ],
              [
                2,
                8.2
              ],
              [
                2,
                8.2
              ],
              [
                2,
                8.2
              ],
              [
                2.2,
                7.6
              ],
              [
                2.3,
                7
              ],
              [
                2.3,
                7
              ],
              [
                3,
                4.3
              ],
              [
                3.8,
                4.3
              ],
              [
                4.5,
                7
              ],
              [
                4.7,
                7.6
              ],
              [
                4.8,
                8.2
              ],
              [
                4.8,
                8.2
              ],
              [
                4.9,
                8.2
              ],
              [
                5,
                7.6
              ],
              [
                5.2,
                7
              ],
              [
                5.2,
                7
              ],
              [
                5.8,
                4.3
              ],
              [
                6.6,
                4.3
              ],
              [
                5.3,
                8.9
              ],
              [
                4.4,
                8.9
              ],
              [
                3.7,
                6.4
              ],
              [
                3.6,
                5.8
              ],
              [
                3.4,
                5.1
              ],
              [
                3.4,
                5.1
              ],
              [
                3.4,
                5.1
              ],
              [
                3.2,
                5.8
              ],
              [
                3.1,
                6.4
              ],
              [
                3.1,
                6.4
              ],
              [
                2.4,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 599,
    ty: 3,
    parent: 592,
    ks: {
      p: {
        a: 0,
        k: [
          15.833,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 602,
    ty: 4,
    parent: 601,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.7,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                4.9
              ],
              [
                0.3,
                4.9
              ],
              [
                0.3,
                4.3
              ],
              [
                0.9,
                4.3
              ],
              [
                0.9,
                3.6
              ],
              [
                1.2,
                2.4
              ],
              [
                2.3,
                2
              ],
              [
                2.3,
                2
              ],
              [
                2.7,
                2.1
              ],
              [
                3,
                2.2
              ],
              [
                3,
                2.2
              ],
              [
                2.9,
                2.8
              ],
              [
                2.3,
                2.7
              ],
              [
                2.3,
                2.7
              ],
              [
                1.7,
                3.6
              ],
              [
                1.7,
                3.6
              ],
              [
                1.7,
                4.3
              ],
              [
                2.7,
                4.3
              ],
              [
                2.7,
                4.9
              ],
              [
                1.7,
                4.9
              ],
              [
                1.7,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                5,
                9
              ],
              [
                5,
                9
              ],
              [
                4,
                8.6
              ],
              [
                3.7,
                7.5
              ],
              [
                3.7,
                7.5
              ],
              [
                3.7,
                4.9
              ],
              [
                3,
                4.9
              ],
              [
                3,
                4.3
              ],
              [
                3.7,
                4.3
              ],
              [
                3.8,
                3
              ],
              [
                4.5,
                3
              ],
              [
                4.5,
                4.3
              ],
              [
                5.7,
                4.3
              ],
              [
                5.7,
                4.9
              ],
              [
                4.5,
                4.9
              ],
              [
                4.5,
                7.5
              ],
              [
                4.6,
                8.1
              ],
              [
                5.2,
                8.4
              ],
              [
                5.2,
                8.4
              ],
              [
                5.4,
                8.3
              ],
              [
                5.7,
                8.3
              ],
              [
                5.7,
                8.3
              ],
              [
                5.9,
                8.8
              ],
              [
                5.4,
                9
              ],
              [
                5,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 601,
    ty: 3,
    parent: 592,
    ks: {
      p: {
        a: 0,
        k: [
          10.2,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 604,
    ty: 4,
    parent: 603,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.33,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.33,
                0.19
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                -0.52
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.19
              ],
              [
                0.38,
                0
              ]
            ],
            v: [
              [
                2.57,
                9.02
              ],
              [
                2.57,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.73,
                7.91
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.29
              ],
              [
                1.52,
                4.46
              ],
              [
                2.57,
                4.18
              ],
              [
                2.57,
                4.18
              ],
              [
                3.62,
                4.46
              ],
              [
                4.4,
                5.29
              ],
              [
                4.7,
                6.61
              ],
              [
                4.7,
                6.61
              ],
              [
                4.4,
                7.91
              ],
              [
                3.62,
                8.73
              ],
              [
                2.57,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.37,
                0
              ],
              [
                -0.33,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.52
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.33,
                -0.19
              ],
              [
                0,
                0
              ],
              [
                0.38,
                0
              ],
              [
                0.32,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                0.51
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.19
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                0.33
              ],
              [
                0,
                0.52
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.33
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.33
              ],
              [
                0,
                -0.53
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.33
              ],
              [
                -0.39,
                0
              ]
            ],
            v: [
              [
                2.57,
                8.37
              ],
              [
                2.57,
                8.37
              ],
              [
                3.53,
                7.88
              ],
              [
                3.9,
                6.61
              ],
              [
                3.9,
                6.61
              ],
              [
                3.53,
                5.32
              ],
              [
                2.57,
                4.82
              ],
              [
                2.57,
                4.82
              ],
              [
                1.61,
                5.32
              ],
              [
                1.24,
                6.61
              ],
              [
                1.24,
                6.61
              ],
              [
                1.61,
                7.88
              ],
              [
                2.57,
                8.37
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.24,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.53
              ],
              [
                -0.24,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.25,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.52
              ],
              [
                0.25,
                0.33
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 603,
    ty: 3,
    parent: 592,
    ks: {
      p: {
        a: 0,
        k: [
          5.062,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 606,
    ty: 4,
    parent: 605,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                0.9,
                7.5
              ],
              [
                1.7,
                8.1
              ],
              [
                2.6,
                8.3
              ],
              [
                2.6,
                8.3
              ],
              [
                3.5,
                8
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.8,
                6.8
              ],
              [
                3.4,
                6.5
              ],
              [
                2.9,
                6.2
              ],
              [
                2.9,
                6.2
              ],
              [
                2,
                5.8
              ],
              [
                1.4,
                5.5
              ],
              [
                0.9,
                5
              ],
              [
                0.7,
                4.2
              ],
              [
                0.7,
                4.2
              ],
              [
                1,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.7,
                2.8
              ],
              [
                4.5,
                3.3
              ],
              [
                4.5,
                3.3
              ],
              [
                4.1,
                3.8
              ],
              [
                3.4,
                3.4
              ],
              [
                2.7,
                3.3
              ],
              [
                2.7,
                3.3
              ],
              [
                1.8,
                3.5
              ],
              [
                1.5,
                4.2
              ],
              [
                1.5,
                4.2
              ],
              [
                1.7,
                4.7
              ],
              [
                2,
                5
              ],
              [
                2.5,
                5.2
              ],
              [
                2.5,
                5.2
              ],
              [
                3.4,
                5.6
              ],
              [
                4.1,
                5.9
              ],
              [
                4.5,
                6.5
              ],
              [
                4.7,
                7.2
              ],
              [
                4.7,
                7.2
              ],
              [
                4.4,
                8.1
              ],
              [
                3.7,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 605,
    ty: 3,
    parent: 592,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 592,
    ty: 3,
    parent: 574,
    ks: {
      p: {
        a: 0,
        k: [
          27.606,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 609,
    ty: 4,
    parent: 608,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.17
              ],
              [
                -0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.06,
                0.01
              ],
              [
                0.09,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.16
              ],
              [
                0.16,
                -0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                5.13
              ],
              [
                1.52,
                5.13
              ],
              [
                2.1,
                4.44
              ],
              [
                2.83,
                4.18
              ],
              [
                2.83,
                4.18
              ],
              [
                3.32,
                4.27
              ],
              [
                3.32,
                4.27
              ],
              [
                3.17,
                4.96
              ],
              [
                2.96,
                4.9
              ],
              [
                2.72,
                4.88
              ],
              [
                2.72,
                4.88
              ],
              [
                2.11,
                5.12
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.29
              ],
              [
                0.23,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.06,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.21,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 608,
    ty: 3,
    parent: 607,
    ks: {
      p: {
        a: 0,
        k: [
          22.42,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 611,
    ty: 4,
    parent: 610,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.33,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.33,
                0.19
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                -0.52
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.19
              ],
              [
                0.38,
                0
              ]
            ],
            v: [
              [
                2.57,
                9.02
              ],
              [
                2.57,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.73,
                7.91
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.29
              ],
              [
                1.52,
                4.46
              ],
              [
                2.57,
                4.18
              ],
              [
                2.57,
                4.18
              ],
              [
                3.62,
                4.46
              ],
              [
                4.4,
                5.29
              ],
              [
                4.7,
                6.61
              ],
              [
                4.7,
                6.61
              ],
              [
                4.4,
                7.91
              ],
              [
                3.62,
                8.73
              ],
              [
                2.57,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.37,
                0
              ],
              [
                -0.33,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.52
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.33,
                -0.19
              ],
              [
                0,
                0
              ],
              [
                0.38,
                0
              ],
              [
                0.32,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                0.51
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.19
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                0.33
              ],
              [
                0,
                0.52
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.33
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.33
              ],
              [
                0,
                -0.53
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.33
              ],
              [
                -0.39,
                0
              ]
            ],
            v: [
              [
                2.57,
                8.37
              ],
              [
                2.57,
                8.37
              ],
              [
                3.53,
                7.88
              ],
              [
                3.9,
                6.61
              ],
              [
                3.9,
                6.61
              ],
              [
                3.53,
                5.32
              ],
              [
                2.57,
                4.82
              ],
              [
                2.57,
                4.82
              ],
              [
                1.61,
                5.32
              ],
              [
                1.24,
                6.61
              ],
              [
                1.24,
                6.61
              ],
              [
                1.61,
                7.88
              ],
              [
                2.57,
                8.37
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.24,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.53
              ],
              [
                -0.24,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.25,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.52
              ],
              [
                0.25,
                0.33
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 610,
    ty: 3,
    parent: 607,
    ks: {
      p: {
        a: 0,
        k: [
          17.282,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 613,
    ty: 4,
    parent: 612,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                4.3
              ],
              [
                1.6,
                4.3
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.3
              ],
              [
                1.2,
                3.3
              ],
              [
                0.8,
                3.2
              ],
              [
                0.7,
                2.8
              ],
              [
                0.7,
                2.8
              ],
              [
                0.8,
                2.5
              ],
              [
                1.2,
                2.3
              ],
              [
                1.2,
                2.3
              ],
              [
                1.6,
                2.5
              ],
              [
                1.7,
                2.8
              ],
              [
                1.7,
                2.8
              ],
              [
                1.6,
                3.2
              ],
              [
                1.2,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 612,
    ty: 3,
    parent: 607,
    ks: {
      p: {
        a: 0,
        k: [
          14.95,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 615,
    ty: 4,
    parent: 614,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                0.15
              ],
              [
                -0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.31
              ],
              [
                0,
                -0.59
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.12
              ],
              [
                0.23,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                4.96
              ],
              [
                1.52,
                4.96
              ],
              [
                2.22,
                4.4
              ],
              [
                3.06,
                4.18
              ],
              [
                3.06,
                4.18
              ],
              [
                4.13,
                4.64
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                8.9
              ],
              [
                3.69,
                8.9
              ],
              [
                3.69,
                6.09
              ],
              [
                3.48,
                5.15
              ],
              [
                2.82,
                4.85
              ],
              [
                2.82,
                4.85
              ],
              [
                2.19,
                5.03
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.22
              ],
              [
                0.25,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0.49,
                0
              ],
              [
                0.22,
                0.31
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.43
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.19,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 614,
    ty: 3,
    parent: 607,
    ks: {
      p: {
        a: 0,
        k: [
          9.764,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 617,
    ty: 4,
    parent: 616,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.2
              ],
              [
                -0.35,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.39
              ],
              [
                0,
                -0.66
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.08
              ],
              [
                0.01,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                -0.29
              ],
              [
                -0.44,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.07
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.09
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                2.65,
                9.02
              ],
              [
                2.65,
                9.02
              ],
              [
                1.53,
                8.73
              ],
              [
                0.73,
                7.9
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.31
              ],
              [
                1.51,
                4.47
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.86,
                4.77
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.58
              ],
              [
                4.31,
                6.79
              ],
              [
                4.31,
                6.79
              ],
              [
                1.2,
                6.79
              ],
              [
                1.66,
                7.95
              ],
              [
                2.74,
                8.39
              ],
              [
                2.74,
                8.39
              ],
              [
                3.35,
                8.29
              ],
              [
                3.89,
                8.03
              ],
              [
                3.89,
                8.03
              ],
              [
                4.16,
                8.54
              ],
              [
                3.49,
                8.87
              ],
              [
                2.65,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.41,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.59,
                0
              ],
              [
                0.32,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.03,
                0.49
              ],
              [
                0.27,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.19,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.13
              ],
              [
                -0.25,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.24
              ],
              [
                0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.25
              ],
              [
                0.05,
                -0.46
              ]
            ],
            v: [
              [
                1.19,
                6.23
              ],
              [
                1.19,
                6.23
              ],
              [
                3.66,
                6.23
              ],
              [
                3.36,
                5.16
              ],
              [
                2.52,
                4.8
              ],
              [
                2.52,
                4.8
              ],
              [
                1.65,
                5.17
              ],
              [
                1.19,
                6.23
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.47
              ],
              [
                -0.2,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.26,
                0.25
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 616,
    ty: 3,
    parent: 607,
    ks: {
      p: {
        a: 0,
        k: [
          5.062,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 619,
    ty: 4,
    parent: 618,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                0.9,
                7.5
              ],
              [
                1.7,
                8.1
              ],
              [
                2.6,
                8.3
              ],
              [
                2.6,
                8.3
              ],
              [
                3.5,
                8
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.8,
                6.8
              ],
              [
                3.4,
                6.5
              ],
              [
                2.9,
                6.2
              ],
              [
                2.9,
                6.2
              ],
              [
                2,
                5.8
              ],
              [
                1.4,
                5.5
              ],
              [
                0.9,
                5
              ],
              [
                0.7,
                4.2
              ],
              [
                0.7,
                4.2
              ],
              [
                1,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.7,
                2.8
              ],
              [
                4.5,
                3.3
              ],
              [
                4.5,
                3.3
              ],
              [
                4.1,
                3.8
              ],
              [
                3.4,
                3.4
              ],
              [
                2.7,
                3.3
              ],
              [
                2.7,
                3.3
              ],
              [
                1.8,
                3.5
              ],
              [
                1.5,
                4.2
              ],
              [
                1.5,
                4.2
              ],
              [
                1.7,
                4.7
              ],
              [
                2,
                5
              ],
              [
                2.5,
                5.2
              ],
              [
                2.5,
                5.2
              ],
              [
                3.4,
                5.6
              ],
              [
                4.1,
                5.9
              ],
              [
                4.5,
                6.5
              ],
              [
                4.7,
                7.2
              ],
              [
                4.7,
                7.2
              ],
              [
                4.4,
                8.1
              ],
              [
                3.7,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 618,
    ty: 3,
    parent: 607,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 607,
    ty: 3,
    parent: 574,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 574,
    ty: 3,
    parent: 573,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.897
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 573,
    ty: 3,
    parent: 572,
    ks: {
      p: {
        a: 0,
        k: [
          17.459,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 629,
    ty: 0,
    parent: 620,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.623
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.623
        ]
      }
    },
    w: 11.639,
    h: 11.611,
    ip: 0,
    op: 565,
    st: 0,
    refId: "627"
  },
  {
    ind: 620,
    ty: 3,
    parent: 572,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.623
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 572,
    ty: 3,
    parent: 539,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 539,
    ty: 3,
    parent: 538,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          29.377
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 635,
    ty: 4,
    parent: 634,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.3
              ],
              [
                2.3,
                15.3
              ],
              [
                1.2,
                14.9
              ],
              [
                0.9,
                13.6
              ],
              [
                0.9,
                13.6
              ],
              [
                0.9,
                6.6
              ],
              [
                2.3,
                6.6
              ],
              [
                2.3,
                13.7
              ],
              [
                2.4,
                14.1
              ],
              [
                2.6,
                14.2
              ],
              [
                2.6,
                14.2
              ],
              [
                2.7,
                14.2
              ],
              [
                2.8,
                14.1
              ],
              [
                2.8,
                14.1
              ],
              [
                3,
                15.2
              ],
              [
                2.7,
                15.3
              ],
              [
                2.3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 634,
    ty: 3,
    parent: 633,
    ks: {
      p: {
        a: 0,
        k: [
          23.966,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 637,
    ty: 4,
    parent: 636,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.5
              ],
              [
                0,
                0.7
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.5
              ],
              [
                -0.4,
                0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.2,
                -0.4
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                3.5,
                15.3
              ],
              [
                3.5,
                15.3
              ],
              [
                2,
                14.9
              ],
              [
                0.9,
                13.9
              ],
              [
                0.5,
                12.2
              ],
              [
                0.5,
                12.2
              ],
              [
                0.9,
                10.5
              ],
              [
                1.9,
                9.4
              ],
              [
                3.3,
                9
              ],
              [
                3.3,
                9
              ],
              [
                4.6,
                9.4
              ],
              [
                5.4,
                10.4
              ],
              [
                5.7,
                11.9
              ],
              [
                5.7,
                11.9
              ],
              [
                5.7,
                12.6
              ],
              [
                5.7,
                12.6
              ],
              [
                1.9,
                12.6
              ],
              [
                2.4,
                13.8
              ],
              [
                3.6,
                14.2
              ],
              [
                3.6,
                14.2
              ],
              [
                4.4,
                14.1
              ],
              [
                5,
                13.8
              ],
              [
                5,
                13.8
              ],
              [
                5.5,
                14.7
              ],
              [
                4.5,
                15.1
              ],
              [
                3.5,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.3,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.7
              ],
              [
                0.3,
                -0.5
              ],
              [
                0.4,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.5
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.1,
                -0.5
              ]
            ],
            v: [
              [
                1.9,
                11.6
              ],
              [
                1.9,
                11.6
              ],
              [
                4.5,
                11.6
              ],
              [
                4.2,
                10.5
              ],
              [
                3.3,
                10.1
              ],
              [
                3.3,
                10.1
              ],
              [
                2.4,
                10.5
              ],
              [
                1.9,
                11.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 636,
    ty: 3,
    parent: 633,
    ks: {
      p: {
        a: 0,
        k: [
          17.785,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 639,
    ty: 4,
    parent: 638,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                3,
                15.3
              ],
              [
                3,
                15.3
              ],
              [
                1.5,
                14.7
              ],
              [
                1.1,
                13.1
              ],
              [
                1.1,
                13.1
              ],
              [
                1.1,
                10.3
              ],
              [
                0.2,
                10.3
              ],
              [
                0.2,
                9.2
              ],
              [
                1.2,
                9.2
              ],
              [
                1.3,
                7.6
              ],
              [
                2.5,
                7.6
              ],
              [
                2.5,
                9.2
              ],
              [
                4,
                9.2
              ],
              [
                4,
                10.3
              ],
              [
                2.5,
                10.3
              ],
              [
                2.5,
                13.1
              ],
              [
                3.4,
                14.2
              ],
              [
                3.4,
                14.2
              ],
              [
                3.7,
                14.2
              ],
              [
                4,
                14.1
              ],
              [
                4,
                14.1
              ],
              [
                4.2,
                15.1
              ],
              [
                3.7,
                15.3
              ],
              [
                3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.7,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.7
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 638,
    ty: 3,
    parent: 633,
    ks: {
      p: {
        a: 0,
        k: [
          13.385,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 641,
    ty: 4,
    parent: 640,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.6,
                0.4
              ],
              [
                -1.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.3
              ],
              [
                2.3,
                15.3
              ],
              [
                1.1,
                14.8
              ],
              [
                0.6,
                13.6
              ],
              [
                0.6,
                13.6
              ],
              [
                1.4,
                12.1
              ],
              [
                4.1,
                11.3
              ],
              [
                4.1,
                11.3
              ],
              [
                3.8,
                10.5
              ],
              [
                3,
                10.2
              ],
              [
                3,
                10.2
              ],
              [
                2.1,
                10.3
              ],
              [
                1.3,
                10.8
              ],
              [
                1.3,
                10.8
              ],
              [
                0.8,
                9.8
              ],
              [
                1.9,
                9.3
              ],
              [
                3.3,
                9
              ],
              [
                3.3,
                9
              ],
              [
                4.9,
                9.7
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                15.2
              ],
              [
                4.3,
                15.2
              ],
              [
                4.2,
                14.5
              ],
              [
                4.2,
                14.5
              ],
              [
                3.3,
                15.1
              ],
              [
                2.3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.6,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.8,
                14.2
              ],
              [
                2.8,
                14.2
              ],
              [
                3.5,
                14
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                12.2
              ],
              [
                2.4,
                12.7
              ],
              [
                1.9,
                13.5
              ],
              [
                1.9,
                13.5
              ],
              [
                2.2,
                14
              ],
              [
                2.8,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.8,
                0.1
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 640,
    ty: 3,
    parent: 633,
    ks: {
      p: {
        a: 0,
        k: [
          7.095,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 643,
    ty: 4,
    parent: 642,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.5,
                -0.2
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.4
              ],
              [
                0.5,
                -0.2
              ],
              [
                0.6,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                15.2
              ],
              [
                1,
                15.2
              ],
              [
                1,
                7.2
              ],
              [
                3.5,
                7.2
              ],
              [
                5.1,
                7.4
              ],
              [
                6.2,
                8.2
              ],
              [
                6.6,
                9.7
              ],
              [
                6.6,
                9.7
              ],
              [
                6.2,
                11.1
              ],
              [
                5.1,
                12
              ],
              [
                3.6,
                12.2
              ],
              [
                3.6,
                12.2
              ],
              [
                2.4,
                12.2
              ],
              [
                2.4,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.5,
                0.2
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.3,
                0.4
              ],
              [
                -0.5,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0.6,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.3
              ],
              [
                2.4,
                11.1
              ],
              [
                3.5,
                11.1
              ],
              [
                5.2,
                9.7
              ],
              [
                5.2,
                9.7
              ],
              [
                4.8,
                8.6
              ],
              [
                3.4,
                8.3
              ],
              [
                3.4,
                8.3
              ],
              [
                2.4,
                8.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                1.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 642,
    ty: 3,
    parent: 633,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 633,
    ty: 3,
    parent: 632,
    ks: {
      p: {
        a: 0,
        k: [
          45.737,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 646,
    ty: 4,
    parent: 645,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                9.2
              ],
              [
                2.3,
                9.2
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.1
              ],
              [
                1.6,
                8.1
              ],
              [
                1,
                7.9
              ],
              [
                0.8,
                7.3
              ],
              [
                0.8,
                7.3
              ],
              [
                1,
                6.8
              ],
              [
                1.6,
                6.5
              ],
              [
                1.6,
                6.5
              ],
              [
                2.2,
                6.8
              ],
              [
                2.4,
                7.3
              ],
              [
                2.4,
                7.3
              ],
              [
                2.2,
                7.9
              ],
              [
                1.6,
                8.1
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 645,
    ty: 3,
    parent: 644,
    ks: {
      p: {
        a: 0,
        k: [
          40.105,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 648,
    ty: 4,
    parent: 647,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                9.2
              ],
              [
                2,
                9.2
              ],
              [
                2.1,
                10
              ],
              [
                2.2,
                10
              ],
              [
                3.1,
                9.3
              ],
              [
                4.2,
                9
              ],
              [
                4.2,
                9
              ],
              [
                5.6,
                9.7
              ],
              [
                6,
                11.4
              ],
              [
                6,
                11.4
              ],
              [
                6,
                15.2
              ],
              [
                4.6,
                15.2
              ],
              [
                4.6,
                11.6
              ],
              [
                4.4,
                10.6
              ],
              [
                3.7,
                10.2
              ],
              [
                3.7,
                10.2
              ],
              [
                3,
                10.4
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 647,
    ty: 3,
    parent: 644,
    ks: {
      p: {
        a: 0,
        k: [
          33.279,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 650,
    ty: 4,
    parent: 649,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.6,
                0.4
              ],
              [
                -1.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.3
              ],
              [
                2.3,
                15.3
              ],
              [
                1.1,
                14.8
              ],
              [
                0.6,
                13.6
              ],
              [
                0.6,
                13.6
              ],
              [
                1.4,
                12.1
              ],
              [
                4.1,
                11.3
              ],
              [
                4.1,
                11.3
              ],
              [
                3.8,
                10.5
              ],
              [
                3,
                10.2
              ],
              [
                3,
                10.2
              ],
              [
                2.1,
                10.3
              ],
              [
                1.3,
                10.8
              ],
              [
                1.3,
                10.8
              ],
              [
                0.8,
                9.8
              ],
              [
                1.9,
                9.3
              ],
              [
                3.3,
                9
              ],
              [
                3.3,
                9
              ],
              [
                4.9,
                9.7
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                15.2
              ],
              [
                4.3,
                15.2
              ],
              [
                4.2,
                14.5
              ],
              [
                4.2,
                14.5
              ],
              [
                3.3,
                15.1
              ],
              [
                2.3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.6,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.8,
                14.2
              ],
              [
                2.8,
                14.2
              ],
              [
                3.5,
                14
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                12.2
              ],
              [
                2.4,
                12.7
              ],
              [
                1.9,
                13.5
              ],
              [
                1.9,
                13.5
              ],
              [
                2.2,
                14
              ],
              [
                2.8,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.8,
                0.1
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 649,
    ty: 3,
    parent: 644,
    ks: {
      p: {
        a: 0,
        k: [
          26.989,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 652,
    ty: 4,
    parent: 651,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                -0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                9.2
              ],
              [
                2,
                9.2
              ],
              [
                2.1,
                10
              ],
              [
                2.2,
                10
              ],
              [
                3,
                9.3
              ],
              [
                4,
                9
              ],
              [
                4,
                9
              ],
              [
                5.1,
                9.3
              ],
              [
                5.7,
                10.1
              ],
              [
                5.7,
                10.1
              ],
              [
                6.6,
                9.3
              ],
              [
                7.6,
                9
              ],
              [
                7.6,
                9
              ],
              [
                9,
                9.7
              ],
              [
                9.5,
                11.4
              ],
              [
                9.5,
                11.4
              ],
              [
                9.5,
                15.2
              ],
              [
                8,
                15.2
              ],
              [
                8,
                11.6
              ],
              [
                7.8,
                10.6
              ],
              [
                7.1,
                10.2
              ],
              [
                7.1,
                10.2
              ],
              [
                5.9,
                11
              ],
              [
                5.9,
                11
              ],
              [
                5.9,
                15.2
              ],
              [
                4.5,
                15.2
              ],
              [
                4.5,
                11.6
              ],
              [
                4.2,
                10.6
              ],
              [
                3.5,
                10.2
              ],
              [
                3.5,
                10.2
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 651,
    ty: 3,
    parent: 644,
    ks: {
      p: {
        a: 0,
        k: [
          16.712,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 654,
    ty: 4,
    parent: 653,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                0.4,
                17.7
              ],
              [
                0.4,
                17.7
              ],
              [
                -0.2,
                17.6
              ],
              [
                -0.6,
                17.5
              ],
              [
                -0.6,
                17.5
              ],
              [
                -0.3,
                16.5
              ],
              [
                0,
                16.5
              ],
              [
                0.2,
                16.6
              ],
              [
                0.2,
                16.6
              ],
              [
                0.8,
                16.3
              ],
              [
                0.9,
                15.5
              ],
              [
                0.9,
                15.5
              ],
              [
                0.9,
                9.2
              ],
              [
                2.3,
                9.2
              ],
              [
                2.3,
                15.5
              ],
              [
                2.1,
                16.6
              ],
              [
                1.5,
                17.4
              ],
              [
                0.4,
                17.7
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.1,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.1
              ],
              [
                1.6,
                8.1
              ],
              [
                1,
                7.9
              ],
              [
                0.8,
                7.3
              ],
              [
                0.8,
                7.3
              ],
              [
                1,
                6.8
              ],
              [
                1.6,
                6.5
              ],
              [
                1.6,
                6.5
              ],
              [
                2.2,
                6.8
              ],
              [
                2.5,
                7.3
              ],
              [
                2.5,
                7.3
              ],
              [
                2.2,
                7.9
              ],
              [
                1.6,
                8.1
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 653,
    ty: 3,
    parent: 644,
    ks: {
      p: {
        a: 0,
        k: [
          13.507,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 656,
    ty: 4,
    parent: 655,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.6,
                0.4
              ],
              [
                -1.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.3
              ],
              [
                2.3,
                15.3
              ],
              [
                1.1,
                14.8
              ],
              [
                0.6,
                13.6
              ],
              [
                0.6,
                13.6
              ],
              [
                1.4,
                12.1
              ],
              [
                4.1,
                11.3
              ],
              [
                4.1,
                11.3
              ],
              [
                3.8,
                10.5
              ],
              [
                3,
                10.2
              ],
              [
                3,
                10.2
              ],
              [
                2.1,
                10.3
              ],
              [
                1.3,
                10.8
              ],
              [
                1.3,
                10.8
              ],
              [
                0.8,
                9.8
              ],
              [
                1.9,
                9.3
              ],
              [
                3.3,
                9
              ],
              [
                3.3,
                9
              ],
              [
                4.9,
                9.7
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                15.2
              ],
              [
                4.3,
                15.2
              ],
              [
                4.2,
                14.5
              ],
              [
                4.2,
                14.5
              ],
              [
                3.3,
                15.1
              ],
              [
                2.3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.6,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.8,
                14.2
              ],
              [
                2.8,
                14.2
              ],
              [
                3.5,
                14
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                12.2
              ],
              [
                2.4,
                12.7
              ],
              [
                1.9,
                13.5
              ],
              [
                1.9,
                13.5
              ],
              [
                2.2,
                14
              ],
              [
                2.8,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.8,
                0.1
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 655,
    ty: 3,
    parent: 644,
    ks: {
      p: {
        a: 0,
        k: [
          7.216,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 658,
    ty: 4,
    parent: 657,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.1
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.4
              ],
              [
                0.5,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                15.2
              ],
              [
                1,
                15.2
              ],
              [
                1,
                7.2
              ],
              [
                3.7,
                7.2
              ],
              [
                5.2,
                7.4
              ],
              [
                6.2,
                8.2
              ],
              [
                6.6,
                9.6
              ],
              [
                6.6,
                9.6
              ],
              [
                6.2,
                11
              ],
              [
                5,
                11.8
              ],
              [
                5,
                11.8
              ],
              [
                6.9,
                15.2
              ],
              [
                5.4,
                15.2
              ],
              [
                3.6,
                12
              ],
              [
                2.4,
                12
              ],
              [
                2.4,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.4,
                0.1
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.3
              ],
              [
                2.4,
                10.9
              ],
              [
                3.6,
                10.9
              ],
              [
                4.8,
                10.6
              ],
              [
                5.2,
                9.6
              ],
              [
                5.2,
                9.6
              ],
              [
                4.8,
                8.6
              ],
              [
                3.6,
                8.3
              ],
              [
                3.6,
                8.3
              ],
              [
                2.4,
                8.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 657,
    ty: 3,
    parent: 644,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 644,
    ty: 3,
    parent: 632,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 632,
    ty: 3,
    parent: 631,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.949
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 631,
    ty: 3,
    parent: 630,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 630,
    ty: 3,
    parent: 538,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 538,
    ty: 3,
    parent: 537,
    ks: {
      p: {
        a: 0,
        k: [
          75.656,
          2.933
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 669,
    ty: 0,
    parent: 660,
    ks: {
      a: {
        a: 0,
        k: [
          45.106,
          45.717
        ]
      },
      p: {
        a: 0,
        k: [
          45.106,
          45.717
        ]
      }
    },
    w: 17.459,
    h: 17.416,
    ip: 0,
    op: 565,
    st: 0,
    refId: "667"
  },
  {
    ind: 660,
    ty: 3,
    parent: 659,
    ks: {
      p: {
        a: 0,
        k: [
          45.106,
          45.717
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 672,
    ty: 4,
    td: 1,
    parent: 670,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            32.008,
            31.93
          ]
        },
        r: {
          a: 0,
          k: 46
        },
        s: {
          a: 0,
          k: [
            64.017,
            63.859
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0,
            0,
            0
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 671,
    ty: 4,
    tt: 1,
    parent: 670,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                32.008,
                31.93
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                67.403,
                67.246
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ty: "gr",
        it: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                32.008,
                31.93
              ]
            },
            r: {
              a: 0,
              k: 46
            },
            s: {
              a: 0,
              k: [
                64.017,
                63.859
              ]
            }
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.427,
                0.184,
                0.604
              ]
            },
            lj: 1,
            ml: 10,
            o: {
              a: 0,
              k: 100
            },
            w: {
              a: 0,
              k: 3.387
            }
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      }
    ]
  },
  {
    ind: 688,
    ty: 4,
    td: 1,
    parent: 670,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            32.008,
            31.93
          ]
        },
        r: {
          a: 0,
          k: 46
        },
        s: {
          a: 0,
          k: [
            64.017,
            63.859
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0,
            0,
            0
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 687,
    ty: 0,
    tt: 1,
    parent: 670,
    ks: {},
    w: 59,
    h: 59,
    ip: 0,
    op: 565,
    st: 0,
    refId: "685"
  },
  {
    ind: 670,
    ty: 3,
    parent: 659,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 659,
    ty: 3,
    parent: 537,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 537,
    ty: 3,
    parent: 378,
    ks: {
      p: {
        a: 0,
        k: [
          8.73,
          8.708
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 689,
    ty: 4,
    parent: 378,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            122.213,
            75.005
          ]
        },
        r: {
          a: 0,
          k: 5
        },
        s: {
          a: 0,
          k: [
            244.427,
            150.01
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            1,
            1,
            1
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 378,
    ty: 3,
    parent: 16,
    ks: {
      a: {
        a: 0,
        k: [
          122.213,
          75.005
        ]
      },
      p: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              179.907,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 132,
            s: [
              447.907,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 276,
            s: [
              715.907,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 420,
            s: [
              983.907,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              1251.907,
              92.212
            ],
            h: 1
          }
        ]
      },
      s: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              100,
              100
            ],
            i: {
              x: [
                0.2,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 132,
            s: [
              93,
              93
            ],
            i: {
              x: [
                1,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              93,
              93
            ],
            h: 1
          }
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 699,
    ty: 4,
    parent: 698,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 698,
    ty: 3,
    parent: 697,
    ks: {
      p: {
        a: 0,
        k: [
          21.813,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 701,
    ty: 4,
    parent: 700,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 700,
    ty: 3,
    parent: 697,
    ks: {
      p: {
        a: 0,
        k: [
          17.007,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 703,
    ty: 4,
    parent: 702,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.8,
                9
              ],
              [
                1.8,
                9
              ],
              [
                0.9,
                8.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                7.8
              ],
              [
                1.9,
                8
              ],
              [
                2,
                8.1
              ],
              [
                2,
                8.1
              ],
              [
                2.1,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.3,
                8.9
              ],
              [
                2.1,
                9
              ],
              [
                1.8,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 702,
    ty: 3,
    parent: 697,
    ks: {
      p: {
        a: 0,
        k: [
          14.438,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 705,
    ty: 4,
    parent: 704,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 704,
    ty: 3,
    parent: 697,
    ks: {
      p: {
        a: 0,
        k: [
          9.546,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 707,
    ty: 4,
    parent: 706,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.36
              ],
              [
                -0.36,
                0.19
              ],
              [
                -0.41,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.1
              ],
              [
                -0.17,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.13,
                0.06
              ],
              [
                0.15,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.28
              ],
              [
                0,
                -0.47
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                -0.28
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                0.08
              ],
              [
                -0.13,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.27,
                0
              ]
            ],
            v: [
              [
                2.64,
                9.02
              ],
              [
                2.64,
                9.02
              ],
              [
                1.49,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.71,
                5.26
              ],
              [
                1.57,
                4.42
              ],
              [
                2.72,
                4.13
              ],
              [
                2.72,
                4.13
              ],
              [
                3.5,
                4.28
              ],
              [
                4.09,
                4.65
              ],
              [
                4.09,
                4.65
              ],
              [
                3.56,
                5.37
              ],
              [
                3.19,
                5.11
              ],
              [
                2.78,
                5.02
              ],
              [
                2.78,
                5.02
              ],
              [
                1.86,
                5.45
              ],
              [
                1.51,
                6.58
              ],
              [
                1.51,
                6.58
              ],
              [
                1.85,
                7.7
              ],
              [
                2.75,
                8.12
              ],
              [
                2.75,
                8.12
              ],
              [
                3.27,
                8.01
              ],
              [
                3.71,
                7.73
              ],
              [
                3.71,
                7.73
              ],
              [
                4.15,
                8.45
              ],
              [
                3.43,
                8.87
              ],
              [
                2.64,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.42,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.52
              ],
              [
                0.21,
                -0.36
              ],
              [
                0.36,
                -0.19
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.22,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                -0.11
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                -0.37,
                0
              ],
              [
                -0.24,
                0.28
              ],
              [
                0,
                0
              ],
              [
                0,
                0.46
              ],
              [
                0.23,
                0.28
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0.16,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.19
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 706,
    ty: 3,
    parent: 697,
    ks: {
      p: {
        a: 0,
        k: [
          5.167,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 709,
    ty: 4,
    parent: 708,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                1,
                7.4
              ],
              [
                1.8,
                7.9
              ],
              [
                2.6,
                8.1
              ],
              [
                2.6,
                8.1
              ],
              [
                3.4,
                7.8
              ],
              [
                3.7,
                7.3
              ],
              [
                3.7,
                7.3
              ],
              [
                3.4,
                6.7
              ],
              [
                2.7,
                6.4
              ],
              [
                2.7,
                6.4
              ],
              [
                1.9,
                6
              ],
              [
                1.3,
                5.6
              ],
              [
                0.8,
                5.1
              ],
              [
                0.6,
                4.3
              ],
              [
                0.6,
                4.3
              ],
              [
                0.9,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.8,
                2.8
              ],
              [
                4.6,
                3.4
              ],
              [
                4.6,
                3.4
              ],
              [
                4.1,
                4.1
              ],
              [
                3.4,
                3.7
              ],
              [
                2.7,
                3.5
              ],
              [
                2.7,
                3.5
              ],
              [
                2,
                3.7
              ],
              [
                1.7,
                4.3
              ],
              [
                1.7,
                4.3
              ],
              [
                1.9,
                4.7
              ],
              [
                2.2,
                4.9
              ],
              [
                2.7,
                5.1
              ],
              [
                2.7,
                5.1
              ],
              [
                3.6,
                5.5
              ],
              [
                4.5,
                6.1
              ],
              [
                4.8,
                7.2
              ],
              [
                4.8,
                7.2
              ],
              [
                4.6,
                8.1
              ],
              [
                3.8,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 708,
    ty: 3,
    parent: 697,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 697,
    ty: 3,
    parent: 696,
    ks: {
      p: {
        a: 0,
        k: [
          93.74,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 712,
    ty: 4,
    parent: 711,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 711,
    ty: 3,
    parent: 710,
    ks: {
      p: {
        a: 0,
        k: [
          15.786,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 714,
    ty: 4,
    parent: 713,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 713,
    ty: 3,
    parent: 710,
    ks: {
      p: {
        a: 0,
        k: [
          10.979,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 716,
    ty: 4,
    parent: 715,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                5.1
              ],
              [
                0.3,
                5.1
              ],
              [
                0.3,
                4.3
              ],
              [
                0.9,
                4.2
              ],
              [
                0.9,
                3.8
              ],
              [
                1.2,
                2.6
              ],
              [
                2.4,
                2.1
              ],
              [
                2.4,
                2.1
              ],
              [
                2.9,
                2.1
              ],
              [
                3.3,
                2.3
              ],
              [
                3.3,
                2.3
              ],
              [
                3.1,
                3.1
              ],
              [
                2.6,
                3
              ],
              [
                2.6,
                3
              ],
              [
                2,
                3.7
              ],
              [
                2,
                3.7
              ],
              [
                2,
                4.2
              ],
              [
                2.9,
                4.2
              ],
              [
                2.9,
                5.1
              ],
              [
                2,
                5.1
              ],
              [
                2,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                5.3,
                9
              ],
              [
                5.3,
                9
              ],
              [
                4.2,
                8.5
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                5.1
              ],
              [
                3.2,
                5.1
              ],
              [
                3.2,
                4.3
              ],
              [
                3.9,
                4.2
              ],
              [
                4,
                3
              ],
              [
                5,
                3
              ],
              [
                5,
                4.2
              ],
              [
                6.1,
                4.2
              ],
              [
                6.1,
                5.1
              ],
              [
                5,
                5.1
              ],
              [
                5,
                7.3
              ],
              [
                5.6,
                8.1
              ],
              [
                5.6,
                8.1
              ],
              [
                5.9,
                8.1
              ],
              [
                6.1,
                8
              ],
              [
                6.1,
                8
              ],
              [
                6.3,
                8.8
              ],
              [
                5.9,
                9
              ],
              [
                5.3,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 715,
    ty: 3,
    parent: 710,
    ks: {
      p: {
        a: 0,
        k: [
          4.892,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 718,
    ty: 4,
    parent: 717,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 717,
    ty: 3,
    parent: 710,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 710,
    ty: 3,
    parent: 696,
    ks: {
      p: {
        a: 0,
        k: [
          72.522,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 721,
    ty: 4,
    parent: 720,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 720,
    ty: 3,
    parent: 719,
    ks: {
      p: {
        a: 0,
        k: [
          13.718,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 723,
    ty: 4,
    parent: 722,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                8.9
              ],
              [
                0.7,
                8.9
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                6.4
              ],
              [
                1.8,
                6.4
              ],
              [
                3.5,
                4.2
              ],
              [
                4.7,
                4.2
              ],
              [
                3.1,
                6.1
              ],
              [
                4.9,
                8.9
              ],
              [
                3.7,
                8.9
              ],
              [
                2.5,
                6.9
              ],
              [
                1.8,
                7.7
              ],
              [
                1.8,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 722,
    ty: 3,
    parent: 719,
    ks: {
      p: {
        a: 0,
        k: [
          8.769,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 725,
    ty: 4,
    parent: 724,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                8.9
              ],
              [
                0.7,
                8.9
              ],
              [
                0.7,
                4.2
              ],
              [
                1.8,
                4.2
              ],
              [
                1.8,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.4
              ],
              [
                1.2,
                3.4
              ],
              [
                0.8,
                3.3
              ],
              [
                0.6,
                2.8
              ],
              [
                0.6,
                2.8
              ],
              [
                0.8,
                2.4
              ],
              [
                1.2,
                2.2
              ],
              [
                1.2,
                2.2
              ],
              [
                1.7,
                2.4
              ],
              [
                1.9,
                2.8
              ],
              [
                1.9,
                2.8
              ],
              [
                1.7,
                3.3
              ],
              [
                1.2,
                3.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 724,
    ty: 3,
    parent: 719,
    ks: {
      p: {
        a: 0,
        k: [
          6.285,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 727,
    ty: 4,
    parent: 726,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.9,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                2.7
              ],
              [
                1.9,
                2.7
              ],
              [
                1.9,
                5.2
              ],
              [
                4.4,
                5.2
              ],
              [
                4.4,
                2.7
              ],
              [
                5.5,
                2.7
              ],
              [
                5.5,
                8.9
              ],
              [
                4.4,
                8.9
              ],
              [
                4.4,
                6.2
              ],
              [
                1.9,
                6.2
              ],
              [
                1.9,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 726,
    ty: 3,
    parent: 719,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 719,
    ty: 3,
    parent: 696,
    ks: {
      p: {
        a: 0,
        k: [
          52.102,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 730,
    ty: 4,
    parent: 729,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                1,
                10.8
              ],
              [
                1,
                10.8
              ],
              [
                0.7,
                10.8
              ],
              [
                0.4,
                10.7
              ],
              [
                0.4,
                10.7
              ],
              [
                0.6,
                9.9
              ],
              [
                0.8,
                9.9
              ],
              [
                0.9,
                9.9
              ],
              [
                0.9,
                9.9
              ],
              [
                1.5,
                9.7
              ],
              [
                1.9,
                9.1
              ],
              [
                1.9,
                9.1
              ],
              [
                1.9,
                8.8
              ],
              [
                0.1,
                4.2
              ],
              [
                1.2,
                4.2
              ],
              [
                2,
                6.5
              ],
              [
                2.2,
                7.2
              ],
              [
                2.4,
                7.8
              ],
              [
                2.4,
                7.8
              ],
              [
                2.5,
                7.8
              ],
              [
                2.7,
                7.2
              ],
              [
                2.8,
                6.5
              ],
              [
                2.8,
                6.5
              ],
              [
                3.5,
                4.2
              ],
              [
                4.6,
                4.2
              ],
              [
                2.9,
                9.1
              ],
              [
                2.2,
                10.4
              ],
              [
                1,
                10.8
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.5
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 729,
    ty: 3,
    parent: 728,
    ks: {
      p: {
        a: 0,
        k: [
          21.055,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 732,
    ty: 4,
    parent: 731,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 731,
    ty: 3,
    parent: 728,
    ks: {
      p: {
        a: 0,
        k: [
          17.519,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 734,
    ty: 4,
    parent: 733,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 733,
    ty: 3,
    parent: 728,
    ks: {
      p: {
        a: 0,
        k: [
          12.627,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 736,
    ty: 4,
    parent: 735,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.8,
                9
              ],
              [
                1.8,
                9
              ],
              [
                0.9,
                8.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                7.8
              ],
              [
                1.9,
                8
              ],
              [
                2,
                8.1
              ],
              [
                2,
                8.1
              ],
              [
                2.1,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.3,
                8.9
              ],
              [
                2.1,
                9
              ],
              [
                1.8,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 735,
    ty: 3,
    parent: 728,
    ks: {
      p: {
        a: 0,
        k: [
          10.058,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 738,
    ty: 4,
    parent: 737,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 737,
    ty: 3,
    parent: 728,
    ks: {
      p: {
        a: 0,
        k: [
          5.167,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 740,
    ty: 4,
    parent: 739,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                1,
                7.4
              ],
              [
                1.8,
                7.9
              ],
              [
                2.6,
                8.1
              ],
              [
                2.6,
                8.1
              ],
              [
                3.4,
                7.8
              ],
              [
                3.7,
                7.3
              ],
              [
                3.7,
                7.3
              ],
              [
                3.4,
                6.7
              ],
              [
                2.7,
                6.4
              ],
              [
                2.7,
                6.4
              ],
              [
                1.9,
                6
              ],
              [
                1.3,
                5.6
              ],
              [
                0.8,
                5.1
              ],
              [
                0.6,
                4.3
              ],
              [
                0.6,
                4.3
              ],
              [
                0.9,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.8,
                2.8
              ],
              [
                4.6,
                3.4
              ],
              [
                4.6,
                3.4
              ],
              [
                4.1,
                4.1
              ],
              [
                3.4,
                3.7
              ],
              [
                2.7,
                3.5
              ],
              [
                2.7,
                3.5
              ],
              [
                2,
                3.7
              ],
              [
                1.7,
                4.3
              ],
              [
                1.7,
                4.3
              ],
              [
                1.9,
                4.7
              ],
              [
                2.2,
                4.9
              ],
              [
                2.7,
                5.1
              ],
              [
                2.7,
                5.1
              ],
              [
                3.6,
                5.5
              ],
              [
                4.5,
                6.1
              ],
              [
                4.8,
                7.2
              ],
              [
                4.8,
                7.2
              ],
              [
                4.6,
                8.1
              ],
              [
                3.8,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 739,
    ty: 3,
    parent: 728,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 728,
    ty: 3,
    parent: 696,
    ks: {
      p: {
        a: 0,
        k: [
          24.458,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 743,
    ty: 4,
    parent: 742,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                1.8,
                6.5
              ],
              [
                1.8,
                6.5
              ],
              [
                0.7,
                6
              ],
              [
                0.3,
                4.5
              ],
              [
                0.3,
                4.5
              ],
              [
                0.7,
                3.1
              ],
              [
                1.8,
                2.6
              ],
              [
                1.8,
                2.6
              ],
              [
                2.8,
                3.1
              ],
              [
                3.2,
                4.5
              ],
              [
                3.2,
                4.5
              ],
              [
                2.8,
                6
              ],
              [
                1.8,
                6.5
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                1.8,
                5.9
              ],
              [
                1.8,
                5.9
              ],
              [
                2.3,
                5.6
              ],
              [
                2.5,
                4.5
              ],
              [
                2.5,
                4.5
              ],
              [
                2.3,
                3.5
              ],
              [
                1.8,
                3.2
              ],
              [
                1.8,
                3.2
              ],
              [
                1.3,
                3.5
              ],
              [
                1.1,
                4.5
              ],
              [
                1.1,
                4.5
              ],
              [
                1.3,
                5.6
              ],
              [
                1.8,
                5.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2,
                9
              ],
              [
                5.3,
                2.6
              ],
              [
                6,
                2.6
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                6.2,
                9
              ],
              [
                6.2,
                9
              ],
              [
                5.1,
                8.5
              ],
              [
                4.7,
                7
              ],
              [
                4.7,
                7
              ],
              [
                5.1,
                5.6
              ],
              [
                6.2,
                5.1
              ],
              [
                6.2,
                5.1
              ],
              [
                7.3,
                5.6
              ],
              [
                7.7,
                7
              ],
              [
                7.7,
                7
              ],
              [
                7.3,
                8.5
              ],
              [
                6.2,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                6.2,
                8.4
              ],
              [
                6.2,
                8.4
              ],
              [
                6.7,
                8.1
              ],
              [
                6.9,
                7
              ],
              [
                6.9,
                7
              ],
              [
                6.7,
                6
              ],
              [
                6.2,
                5.7
              ],
              [
                6.2,
                5.7
              ],
              [
                5.7,
                6
              ],
              [
                5.5,
                7
              ],
              [
                5.5,
                7
              ],
              [
                5.7,
                8.1
              ],
              [
                6.2,
                8.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 742,
    ty: 3,
    parent: 741,
    ks: {
      p: {
        a: 0,
        k: [
          14.59,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 745,
    ty: 4,
    parent: 744,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.5
              ],
              [
                -0.6,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                0,
                -1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.5
              ],
              [
                0.6,
                0
              ]
            ],
            v: [
              [
                2.4,
                9
              ],
              [
                2.4,
                9
              ],
              [
                0.9,
                8.2
              ],
              [
                0.4,
                5.9
              ],
              [
                0.4,
                5.9
              ],
              [
                0.9,
                3.5
              ],
              [
                2.4,
                2.8
              ],
              [
                2.4,
                2.8
              ],
              [
                3.9,
                3.5
              ],
              [
                4.5,
                5.9
              ],
              [
                4.5,
                5.9
              ],
              [
                3.9,
                8.2
              ],
              [
                2.4,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                -1
              ],
              [
                0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                1
              ],
              [
                -0.4,
                0.5
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.2
              ],
              [
                2.4,
                8.2
              ],
              [
                2.9,
                7.9
              ],
              [
                3.3,
                7.2
              ],
              [
                3.4,
                5.9
              ],
              [
                3.4,
                5.9
              ],
              [
                3.3,
                4.5
              ],
              [
                2.9,
                3.8
              ],
              [
                2.4,
                3.6
              ],
              [
                2.4,
                3.6
              ],
              [
                1.9,
                3.8
              ],
              [
                1.6,
                4.5
              ],
              [
                1.4,
                5.9
              ],
              [
                1.4,
                5.9
              ],
              [
                1.6,
                7.2
              ],
              [
                1.9,
                7.9
              ],
              [
                2.4,
                8.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.1,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 744,
    ty: 3,
    parent: 741,
    ks: {
      p: {
        a: 0,
        k: [
          9.726,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 747,
    ty: 4,
    parent: 746,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.5
              ],
              [
                -0.6,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                0,
                -1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.5
              ],
              [
                0.6,
                0
              ]
            ],
            v: [
              [
                2.4,
                9
              ],
              [
                2.4,
                9
              ],
              [
                0.9,
                8.2
              ],
              [
                0.4,
                5.9
              ],
              [
                0.4,
                5.9
              ],
              [
                0.9,
                3.5
              ],
              [
                2.4,
                2.8
              ],
              [
                2.4,
                2.8
              ],
              [
                3.9,
                3.5
              ],
              [
                4.5,
                5.9
              ],
              [
                4.5,
                5.9
              ],
              [
                3.9,
                8.2
              ],
              [
                2.4,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                -1
              ],
              [
                0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                1
              ],
              [
                -0.4,
                0.5
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.2
              ],
              [
                2.4,
                8.2
              ],
              [
                2.9,
                7.9
              ],
              [
                3.3,
                7.2
              ],
              [
                3.4,
                5.9
              ],
              [
                3.4,
                5.9
              ],
              [
                3.3,
                4.5
              ],
              [
                2.9,
                3.8
              ],
              [
                2.4,
                3.6
              ],
              [
                2.4,
                3.6
              ],
              [
                1.9,
                3.8
              ],
              [
                1.6,
                4.5
              ],
              [
                1.4,
                5.9
              ],
              [
                1.4,
                5.9
              ],
              [
                1.6,
                7.2
              ],
              [
                1.9,
                7.9
              ],
              [
                2.4,
                8.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.1,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 746,
    ty: 3,
    parent: 741,
    ks: {
      p: {
        a: 0,
        k: [
          4.863,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 749,
    ty: 4,
    parent: 748,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.3,
                9
              ],
              [
                2.3,
                9
              ],
              [
                1.1,
                8.8
              ],
              [
                0.2,
                8.2
              ],
              [
                0.2,
                8.2
              ],
              [
                0.7,
                7.5
              ],
              [
                1.3,
                7.9
              ],
              [
                2.1,
                8.1
              ],
              [
                2.1,
                8.1
              ],
              [
                3,
                7.8
              ],
              [
                3.3,
                7
              ],
              [
                3.3,
                7
              ],
              [
                3,
                6.1
              ],
              [
                2.2,
                5.8
              ],
              [
                2.2,
                5.8
              ],
              [
                1.7,
                5.9
              ],
              [
                1.2,
                6.2
              ],
              [
                1.2,
                6.2
              ],
              [
                0.7,
                5.8
              ],
              [
                0.9,
                2.9
              ],
              [
                4.1,
                2.9
              ],
              [
                4.1,
                3.8
              ],
              [
                1.8,
                3.8
              ],
              [
                1.7,
                5.3
              ],
              [
                2.1,
                5.1
              ],
              [
                2.5,
                5.1
              ],
              [
                2.5,
                5.1
              ],
              [
                3.5,
                5.3
              ],
              [
                4.1,
                5.9
              ],
              [
                4.4,
                6.9
              ],
              [
                4.4,
                6.9
              ],
              [
                4.1,
                8.1
              ],
              [
                3.3,
                8.8
              ],
              [
                2.3,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 748,
    ty: 3,
    parent: 741,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 741,
    ty: 3,
    parent: 696,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 696,
    ty: 3,
    parent: 695,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 695,
    ty: 3,
    parent: 694,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 694,
    ty: 3,
    parent: 693,
    ks: {
      p: {
        a: 0,
        k: [
          17.029,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 758,
    ty: 0,
    parent: 750,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.582
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    w: 10.837,
    h: 10.837,
    ip: 0,
    op: 565,
    st: 0,
    refId: "756"
  },
  {
    ind: 750,
    ty: 3,
    parent: 693,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 693,
    ty: 3,
    parent: 692,
    ks: {
      p: {
        a: 0,
        k: [
          37.644,
          2.709
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 692,
    ty: 3,
    parent: 691,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          35.897
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 827,
    ty: 0,
    parent: 761,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          10.548
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          10.548
        ]
      }
    },
    w: 46.443,
    h: 10.549,
    ip: 0,
    op: 565,
    st: 0,
    refId: "825"
  },
  {
    ind: 761,
    ty: 3,
    parent: 760,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          10.548
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 832,
    ty: 4,
    parent: 831,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.13
              ],
              [
                -0.19,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.11,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.01
              ],
              [
                0.07,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.12
              ],
              [
                0.12,
                -0.29
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.14,
                6.54
              ],
              [
                0.57,
                6.54
              ],
              [
                0.57,
                3.15
              ],
              [
                1.04,
                3.15
              ],
              [
                1.09,
                3.77
              ],
              [
                1.11,
                3.77
              ],
              [
                1.54,
                3.26
              ],
              [
                2.08,
                3.07
              ],
              [
                2.08,
                3.07
              ],
              [
                2.44,
                3.14
              ],
              [
                2.44,
                3.14
              ],
              [
                2.33,
                3.64
              ],
              [
                2.17,
                3.6
              ],
              [
                2,
                3.59
              ],
              [
                2,
                3.59
              ],
              [
                1.55,
                3.76
              ],
              [
                1.14,
                4.37
              ],
              [
                1.14,
                4.37
              ],
              [
                1.14,
                6.54
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.12,
                -0.21
              ],
              [
                0.17,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.13,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.06,
                -0.02
              ],
              [
                -0.05,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0
              ],
              [
                -0.16,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 831,
    ty: 3,
    parent: 830,
    ks: {
      p: {
        a: 0,
        k: [
          15.625,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 834,
    ty: 4,
    parent: 833,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                0.14
              ],
              [
                0.14,
                0.26
              ],
              [
                0,
                0.37
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.23,
                0.14
              ],
              [
                -0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                -0.29
              ],
              [
                0,
                -0.48
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.06
              ],
              [
                0.01,
                -0.04
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.21
              ],
              [
                -0.33,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0.05
              ],
              [
                -0.13,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.18,
                -0.07
              ],
              [
                0.23,
                0
              ]
            ],
            v: [
              [
                1.94,
                6.62
              ],
              [
                1.94,
                6.62
              ],
              [
                1.12,
                6.41
              ],
              [
                0.54,
                5.8
              ],
              [
                0.32,
                4.85
              ],
              [
                0.32,
                4.85
              ],
              [
                0.54,
                3.9
              ],
              [
                1.11,
                3.29
              ],
              [
                1.84,
                3.07
              ],
              [
                1.84,
                3.07
              ],
              [
                2.84,
                3.5
              ],
              [
                3.19,
                4.66
              ],
              [
                3.19,
                4.66
              ],
              [
                3.19,
                4.84
              ],
              [
                3.17,
                4.99
              ],
              [
                3.17,
                4.99
              ],
              [
                0.88,
                4.99
              ],
              [
                1.22,
                5.84
              ],
              [
                2.01,
                6.16
              ],
              [
                2.01,
                6.16
              ],
              [
                2.46,
                6.09
              ],
              [
                2.86,
                5.9
              ],
              [
                2.86,
                5.9
              ],
              [
                3.06,
                6.28
              ],
              [
                2.57,
                6.52
              ],
              [
                1.94,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.25,
                -0.14
              ],
              [
                -0.14,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.37
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.23,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0.43,
                0
              ],
              [
                0.23,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0,
                0.06
              ],
              [
                0,
                0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.02,
                0.36
              ],
              [
                0.2,
                0.21
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0
              ],
              [
                0.14,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0.09
              ],
              [
                -0.18,
                0.07
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.18
              ],
              [
                0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.18
              ],
              [
                0.04,
                -0.33
              ]
            ],
            v: [
              [
                0.88,
                4.58
              ],
              [
                0.88,
                4.58
              ],
              [
                2.69,
                4.58
              ],
              [
                2.47,
                3.79
              ],
              [
                1.85,
                3.52
              ],
              [
                1.85,
                3.52
              ],
              [
                1.22,
                3.8
              ],
              [
                0.88,
                4.58
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.34
              ],
              [
                -0.15,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                0
              ],
              [
                -0.19,
                0.18
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 833,
    ty: 3,
    parent: 830,
    ks: {
      p: {
        a: 0,
        k: [
          12.173,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 836,
    ty: 4,
    parent: 835,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.2,
                6.6
              ],
              [
                1.2,
                6.6
              ],
              [
                0.7,
                6.4
              ],
              [
                0.6,
                5.9
              ],
              [
                0.6,
                5.9
              ],
              [
                0.6,
                1.6
              ],
              [
                1.1,
                1.6
              ],
              [
                1.1,
                5.9
              ],
              [
                1.2,
                6.1
              ],
              [
                1.3,
                6.2
              ],
              [
                1.3,
                6.2
              ],
              [
                1.4,
                6.1
              ],
              [
                1.4,
                6.1
              ],
              [
                1.4,
                6.1
              ],
              [
                1.5,
                6.6
              ],
              [
                1.4,
                6.6
              ],
              [
                1.2,
                6.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 835,
    ty: 3,
    parent: 830,
    ks: {
      p: {
        a: 0,
        k: [
          10.398,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 838,
    ty: 4,
    parent: 837,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                0.17
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.72,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0.04,
                0.13
              ],
              [
                0.1,
                0.08
              ],
              [
                0.19,
                0
              ],
              [
                0,
                0
              ],
              [
                0.17,
                -0.07
              ],
              [
                0.13,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                -0.25
              ],
              [
                0,
                -0.42
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.1
              ],
              [
                0.21,
                0
              ]
            ],
            v: [
              [
                1.35,
                6.62
              ],
              [
                1.35,
                6.62
              ],
              [
                0.64,
                6.37
              ],
              [
                0.36,
                5.66
              ],
              [
                0.36,
                5.66
              ],
              [
                0.86,
                4.81
              ],
              [
                2.44,
                4.39
              ],
              [
                2.44,
                4.39
              ],
              [
                2.38,
                3.98
              ],
              [
                2.17,
                3.67
              ],
              [
                1.74,
                3.54
              ],
              [
                1.74,
                3.54
              ],
              [
                1.19,
                3.66
              ],
              [
                0.73,
                3.91
              ],
              [
                0.73,
                3.91
              ],
              [
                0.51,
                3.51
              ],
              [
                1.09,
                3.21
              ],
              [
                1.84,
                3.07
              ],
              [
                1.84,
                3.07
              ],
              [
                2.74,
                3.45
              ],
              [
                3.02,
                4.46
              ],
              [
                3.02,
                4.46
              ],
              [
                3.02,
                6.54
              ],
              [
                2.54,
                6.54
              ],
              [
                2.49,
                6.14
              ],
              [
                2.47,
                6.14
              ],
              [
                1.95,
                6.48
              ],
              [
                1.35,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.28,
                0
              ],
              [
                -0.19,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.14
              ],
              [
                -0.04,
                -0.13
              ],
              [
                -0.1,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.17,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.1
              ],
              [
                0.23,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.41,
                0
              ],
              [
                0.19,
                0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                0.13
              ],
              [
                -0.19,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0.08
              ],
              [
                -0.16,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.14
              ],
              [
                0,
                -0.22
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                -0.09
              ],
              [
                -0.17,
                0
              ]
            ],
            v: [
              [
                1.52,
                6.16
              ],
              [
                1.52,
                6.16
              ],
              [
                1.98,
                6.05
              ],
              [
                2.44,
                5.71
              ],
              [
                2.44,
                5.71
              ],
              [
                2.44,
                4.77
              ],
              [
                1.26,
                5.08
              ],
              [
                0.92,
                5.62
              ],
              [
                0.92,
                5.62
              ],
              [
                1.09,
                6.04
              ],
              [
                1.52,
                6.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.16,
                0
              ],
              [
                0.14,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.56,
                0.07
              ],
              [
                -0.23,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0.19
              ],
              [
                0.12,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 837,
    ty: 3,
    parent: 830,
    ks: {
      p: {
        a: 0,
        k: [
          6.89,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 840,
    ty: 4,
    parent: 839,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.14
              ],
              [
                0.14,
                0.26
              ],
              [
                0,
                0.37
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.25,
                0.14
              ],
              [
                -0.29,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.08
              ],
              [
                -0.12,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.11,
                0.06
              ],
              [
                0.13,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.11
              ],
              [
                0.09,
                -0.2
              ],
              [
                0,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                -0.24
              ],
              [
                -0.31,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                0.07
              ],
              [
                -0.1,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.08
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.91,
                6.62
              ],
              [
                1.91,
                6.62
              ],
              [
                1.1,
                6.42
              ],
              [
                0.53,
                5.81
              ],
              [
                0.32,
                4.85
              ],
              [
                0.32,
                4.85
              ],
              [
                0.55,
                3.89
              ],
              [
                1.15,
                3.28
              ],
              [
                1.95,
                3.07
              ],
              [
                1.95,
                3.07
              ],
              [
                2.53,
                3.19
              ],
              [
                2.94,
                3.47
              ],
              [
                2.94,
                3.47
              ],
              [
                2.65,
                3.84
              ],
              [
                2.34,
                3.63
              ],
              [
                1.97,
                3.54
              ],
              [
                1.97,
                3.54
              ],
              [
                1.42,
                3.71
              ],
              [
                1.05,
                4.17
              ],
              [
                0.91,
                4.85
              ],
              [
                0.91,
                4.85
              ],
              [
                1.2,
                5.79
              ],
              [
                1.96,
                6.15
              ],
              [
                1.96,
                6.15
              ],
              [
                2.4,
                6.05
              ],
              [
                2.75,
                5.81
              ],
              [
                2.75,
                5.81
              ],
              [
                3,
                6.19
              ],
              [
                2.49,
                6.51
              ],
              [
                1.91,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.24,
                -0.14
              ],
              [
                -0.14,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.38
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.25,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.16,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.09
              ],
              [
                -0.11,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.16,
                0.11
              ],
              [
                -0.09,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.39
              ],
              [
                0.19,
                0.24
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0
              ],
              [
                0.13,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.13
              ],
              [
                -0.19,
                0.08
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 839,
    ty: 3,
    parent: 830,
    ks: {
      p: {
        a: 0,
        k: [
          3.717,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 842,
    ty: 4,
    parent: 841,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                0.12
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.1
              ],
              [
                -0.24,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.14
              ],
              [
                0,
                0.22
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.09
              ],
              [
                0.11,
                0.07
              ],
              [
                0.14,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.1
              ],
              [
                0.1,
                0.15
              ],
              [
                0,
                0.22
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                0.18
              ],
              [
                -0.22,
                0.1
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                -0.1
              ],
              [
                -0.16,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.17,
                0.08
              ],
              [
                0.21,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.12
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.1
              ],
              [
                -0.12,
                -0.06
              ],
              [
                -0.12,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.1
              ],
              [
                -0.08,
                -0.15
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0.13,
                -0.2
              ],
              [
                0.23,
                -0.12
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                1.89,
                6.62
              ],
              [
                1.89,
                6.62
              ],
              [
                1,
                6.44
              ],
              [
                0.29,
                5.95
              ],
              [
                0.29,
                5.95
              ],
              [
                0.64,
                5.54
              ],
              [
                1.22,
                5.96
              ],
              [
                1.9,
                6.12
              ],
              [
                1.9,
                6.12
              ],
              [
                2.61,
                5.91
              ],
              [
                2.86,
                5.37
              ],
              [
                2.86,
                5.37
              ],
              [
                2.76,
                4.99
              ],
              [
                2.48,
                4.76
              ],
              [
                2.1,
                4.56
              ],
              [
                2.1,
                4.56
              ],
              [
                1.44,
                4.28
              ],
              [
                1.01,
                4.04
              ],
              [
                0.66,
                3.66
              ],
              [
                0.52,
                3.1
              ],
              [
                0.52,
                3.1
              ],
              [
                0.7,
                2.48
              ],
              [
                1.21,
                2.04
              ],
              [
                1.95,
                1.89
              ],
              [
                1.95,
                1.89
              ],
              [
                2.71,
                2.04
              ],
              [
                3.3,
                2.45
              ],
              [
                3.3,
                2.45
              ],
              [
                2.99,
                2.83
              ],
              [
                2.53,
                2.51
              ],
              [
                1.95,
                2.4
              ],
              [
                1.95,
                2.4
              ],
              [
                1.33,
                2.58
              ],
              [
                1.1,
                3.06
              ],
              [
                1.1,
                3.06
              ],
              [
                1.22,
                3.42
              ],
              [
                1.5,
                3.66
              ],
              [
                1.86,
                3.82
              ],
              [
                1.86,
                3.82
              ],
              [
                2.51,
                4.1
              ],
              [
                2.99,
                4.37
              ],
              [
                3.32,
                4.75
              ],
              [
                3.45,
                5.32
              ],
              [
                3.45,
                5.32
              ],
              [
                3.26,
                5.98
              ],
              [
                2.72,
                6.45
              ],
              [
                1.89,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.27,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.17
              ],
              [
                0.22,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.17,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.16
              ],
              [
                -0.07,
                -0.09
              ],
              [
                -0.11,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.06
              ],
              [
                -0.14,
                -0.1
              ],
              [
                -0.1,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.23
              ],
              [
                0.12,
                -0.18
              ],
              [
                0.22,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.27,
                0
              ],
              [
                0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.13
              ],
              [
                -0.17,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                -0.26,
                0
              ],
              [
                -0.16,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0.14
              ],
              [
                0.08,
                0.1
              ],
              [
                0.12,
                0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0.07
              ],
              [
                0.14,
                0.1
              ],
              [
                0.08,
                0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                0.24
              ],
              [
                -0.13,
                0.2
              ],
              [
                -0.23,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 841,
    ty: 3,
    parent: 830,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 830,
    ty: 3,
    parent: 829,
    ks: {
      p: {
        a: 0,
        k: [
          14.372,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 845,
    ty: 4,
    parent: 844,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.21
              ],
              [
                0,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.11
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.07,
                0.02
              ],
              [
                -0.06,
                0.02
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.11,
                -0.03
              ],
              [
                0.11,
                0
              ]
            ],
            v: [
              [
                1.64,
                6.62
              ],
              [
                1.64,
                6.62
              ],
              [
                0.88,
                6.31
              ],
              [
                0.67,
                5.5
              ],
              [
                0.67,
                5.5
              ],
              [
                0.67,
                3.62
              ],
              [
                0.17,
                3.62
              ],
              [
                0.17,
                3.19
              ],
              [
                0.7,
                3.15
              ],
              [
                0.77,
                2.21
              ],
              [
                1.25,
                2.21
              ],
              [
                1.25,
                3.15
              ],
              [
                2.16,
                3.15
              ],
              [
                2.16,
                3.62
              ],
              [
                1.25,
                3.62
              ],
              [
                1.25,
                5.5
              ],
              [
                1.36,
                5.99
              ],
              [
                1.77,
                6.16
              ],
              [
                1.77,
                6.16
              ],
              [
                1.96,
                6.13
              ],
              [
                2.15,
                6.07
              ],
              [
                2.15,
                6.07
              ],
              [
                2.26,
                6.5
              ],
              [
                1.96,
                6.59
              ],
              [
                1.64,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.36,
                0
              ],
              [
                -0.14,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.08,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.06,
                0
              ],
              [
                0.07,
                -0.02
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.09,
                0.03
              ],
              [
                -0.11,
                0.03
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 844,
    ty: 3,
    parent: 843,
    ks: {
      p: {
        a: 0,
        k: [
          10.628,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 847,
    ty: 4,
    parent: 846,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0.09
              ],
              [
                0.16,
                0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.08
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.11,
                0.1
              ],
              [
                0,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0.08,
                0.08
              ],
              [
                0.12,
                0.05
              ],
              [
                0.13,
                0.05
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.08
              ],
              [
                0.1,
                0.12
              ],
              [
                0,
                0.19
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                -0.07
              ],
              [
                -0.13,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.13,
                0.06
              ],
              [
                0.15,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                -0.07,
                -0.07
              ],
              [
                -0.11,
                -0.05
              ],
              [
                -0.13,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.08
              ],
              [
                -0.1,
                -0.13
              ],
              [
                0,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.15
              ],
              [
                0.18,
                -0.09
              ],
              [
                0.27,
                0
              ]
            ],
            v: [
              [
                1.46,
                6.62
              ],
              [
                1.46,
                6.62
              ],
              [
                0.77,
                6.49
              ],
              [
                0.2,
                6.16
              ],
              [
                0.2,
                6.16
              ],
              [
                0.48,
                5.77
              ],
              [
                0.94,
                6.06
              ],
              [
                1.48,
                6.18
              ],
              [
                1.48,
                6.18
              ],
              [
                1.98,
                6.02
              ],
              [
                2.15,
                5.65
              ],
              [
                2.15,
                5.65
              ],
              [
                2.03,
                5.36
              ],
              [
                1.74,
                5.16
              ],
              [
                1.37,
                5.01
              ],
              [
                1.37,
                5.01
              ],
              [
                0.91,
                4.8
              ],
              [
                0.53,
                4.5
              ],
              [
                0.38,
                4.03
              ],
              [
                0.38,
                4.03
              ],
              [
                0.69,
                3.35
              ],
              [
                1.55,
                3.07
              ],
              [
                1.55,
                3.07
              ],
              [
                2.14,
                3.18
              ],
              [
                2.61,
                3.45
              ],
              [
                2.61,
                3.45
              ],
              [
                2.33,
                3.82
              ],
              [
                1.96,
                3.6
              ],
              [
                1.55,
                3.52
              ],
              [
                1.55,
                3.52
              ],
              [
                1.08,
                3.66
              ],
              [
                0.93,
                4
              ],
              [
                0.93,
                4
              ],
              [
                1.04,
                4.27
              ],
              [
                1.31,
                4.44
              ],
              [
                1.66,
                4.59
              ],
              [
                1.66,
                4.59
              ],
              [
                2.15,
                4.8
              ],
              [
                2.54,
                5.1
              ],
              [
                2.7,
                5.61
              ],
              [
                2.7,
                5.61
              ],
              [
                2.55,
                6.12
              ],
              [
                2.14,
                6.48
              ],
              [
                1.46,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.24,
                0
              ],
              [
                -0.22,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.12
              ],
              [
                0.16,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.11,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.12
              ],
              [
                -0.08,
                -0.08
              ],
              [
                -0.12,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.06
              ],
              [
                -0.15,
                -0.08
              ],
              [
                -0.1,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.27
              ],
              [
                0.21,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                0.21,
                0
              ],
              [
                0.18,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                -0.09
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.11
              ],
              [
                0.07,
                0.07
              ],
              [
                0.11,
                0.05
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.06
              ],
              [
                0.16,
                0.08
              ],
              [
                0.1,
                0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0.18
              ],
              [
                -0.1,
                0.15
              ],
              [
                -0.18,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 846,
    ty: 3,
    parent: 843,
    ks: {
      p: {
        a: 0,
        k: [
          7.712,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 849,
    ty: 4,
    parent: 848,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.14
              ],
              [
                0.15,
                0.26
              ],
              [
                0,
                0.37
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.24,
                0.14
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                -0.14
              ],
              [
                -0.15,
                -0.26
              ],
              [
                0,
                -0.38
              ],
              [
                0,
                0
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.24,
                -0.14
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.89,
                6.62
              ],
              [
                1.89,
                6.62
              ],
              [
                1.12,
                6.42
              ],
              [
                0.54,
                5.81
              ],
              [
                0.32,
                4.85
              ],
              [
                0.32,
                4.85
              ],
              [
                0.54,
                3.89
              ],
              [
                1.12,
                3.28
              ],
              [
                1.89,
                3.07
              ],
              [
                1.89,
                3.07
              ],
              [
                2.66,
                3.28
              ],
              [
                3.24,
                3.89
              ],
              [
                3.46,
                4.85
              ],
              [
                3.46,
                4.85
              ],
              [
                3.24,
                5.81
              ],
              [
                2.66,
                6.42
              ],
              [
                1.89,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.24,
                -0.14
              ],
              [
                -0.15,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.38
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.24,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0.28,
                0
              ],
              [
                0.24,
                0.14
              ],
              [
                0.15,
                0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                0.37
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.24,
                0.14
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0.24
              ],
              [
                0,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0.24
              ],
              [
                0.29,
                0
              ],
              [
                0,
                0
              ],
              [
                0.18,
                -0.24
              ],
              [
                0,
                -0.39
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                -0.24
              ],
              [
                -0.29,
                0
              ]
            ],
            v: [
              [
                1.89,
                6.15
              ],
              [
                1.89,
                6.15
              ],
              [
                2.6,
                5.79
              ],
              [
                2.86,
                4.85
              ],
              [
                2.86,
                4.85
              ],
              [
                2.6,
                3.91
              ],
              [
                1.89,
                3.54
              ],
              [
                1.89,
                3.54
              ],
              [
                1.18,
                3.91
              ],
              [
                0.91,
                4.85
              ],
              [
                0.91,
                4.85
              ],
              [
                1.18,
                5.79
              ],
              [
                1.89,
                6.15
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.29,
                0
              ],
              [
                0.18,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.39
              ],
              [
                -0.18,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                0
              ],
              [
                -0.18,
                0.24
              ],
              [
                0,
                0
              ],
              [
                0,
                0.39
              ],
              [
                0.18,
                0.24
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 848,
    ty: 3,
    parent: 843,
    ks: {
      p: {
        a: 0,
        k: [
          3.939,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 851,
    ty: 4,
    parent: 850,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.26,
                -0.08
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.23
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.21,
                6.54
              ],
              [
                0.63,
                6.54
              ],
              [
                0.63,
                1.97
              ],
              [
                1.93,
                1.97
              ],
              [
                2.83,
                2.1
              ],
              [
                3.43,
                2.52
              ],
              [
                3.64,
                3.31
              ],
              [
                3.64,
                3.31
              ],
              [
                3.18,
                4.38
              ],
              [
                1.96,
                4.73
              ],
              [
                1.96,
                4.73
              ],
              [
                1.21,
                4.73
              ],
              [
                1.21,
                6.54
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0
              ],
              [
                0.26,
                0.08
              ],
              [
                0.14,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.48
              ],
              [
                -0.31,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.15
              ],
              [
                0,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.13
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.21,
                2.44
              ],
              [
                1.21,
                4.26
              ],
              [
                1.89,
                4.26
              ],
              [
                2.78,
                4.03
              ],
              [
                3.07,
                3.31
              ],
              [
                3.07,
                3.31
              ],
              [
                2.76,
                2.63
              ],
              [
                1.86,
                2.44
              ],
              [
                1.86,
                2.44
              ],
              [
                1.21,
                2.44
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.19,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.33
              ],
              [
                -0.2,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 850,
    ty: 3,
    parent: 843,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 843,
    ty: 3,
    parent: 829,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 829,
    ty: 3,
    parent: 828,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 828,
    ty: 3,
    parent: 760,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 760,
    ty: 3,
    parent: 759,
    ks: {
      p: {
        a: 0,
        k: [
          143.636,
          1.982
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 857,
    ty: 0,
    parent: 853,
    ks: {},
    w: 21,
    h: 10,
    ip: 0,
    op: 565,
    st: 0,
    refId: "855"
  },
  {
    ind: 853,
    ty: 3,
    parent: 852,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 852,
    ty: 3,
    parent: 759,
    ks: {
      p: {
        a: 0,
        k: [
          115.383,
          7.839
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 863,
    ty: 4,
    parent: 862,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.2,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                10.2
              ],
              [
                0.9,
                10.2
              ],
              [
                0.9,
                4.9
              ],
              [
                1.6,
                4.9
              ],
              [
                1.7,
                5.9
              ],
              [
                1.7,
                5.9
              ],
              [
                2.4,
                5.1
              ],
              [
                3.2,
                4.8
              ],
              [
                3.2,
                4.8
              ],
              [
                3.8,
                4.9
              ],
              [
                3.8,
                4.9
              ],
              [
                3.6,
                5.7
              ],
              [
                3.4,
                5.6
              ],
              [
                3.1,
                5.6
              ],
              [
                3.1,
                5.6
              ],
              [
                2.4,
                5.9
              ],
              [
                1.8,
                6.8
              ],
              [
                1.8,
                6.8
              ],
              [
                1.8,
                10.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 862,
    ty: 3,
    parent: 861,
    ks: {
      p: {
        a: 0,
        k: [
          60.193,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 865,
    ty: 4,
    parent: 864,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.4
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                3,
                10.3
              ],
              [
                3,
                10.3
              ],
              [
                1.7,
                10
              ],
              [
                0.8,
                9
              ],
              [
                0.5,
                7.6
              ],
              [
                0.5,
                7.6
              ],
              [
                0.8,
                6.1
              ],
              [
                1.7,
                5.1
              ],
              [
                2.9,
                4.8
              ],
              [
                2.9,
                4.8
              ],
              [
                4.4,
                5.4
              ],
              [
                5,
                7.2
              ],
              [
                5,
                7.2
              ],
              [
                5,
                7.5
              ],
              [
                4.9,
                7.8
              ],
              [
                4.9,
                7.8
              ],
              [
                1.4,
                7.8
              ],
              [
                1.9,
                9.1
              ],
              [
                3.1,
                9.6
              ],
              [
                3.1,
                9.6
              ],
              [
                3.8,
                9.5
              ],
              [
                4.4,
                9.2
              ],
              [
                4.4,
                9.2
              ],
              [
                4.8,
                9.8
              ],
              [
                4,
                10.1
              ],
              [
                3,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.2,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.1,
                -0.5
              ]
            ],
            v: [
              [
                1.4,
                7.1
              ],
              [
                1.4,
                7.1
              ],
              [
                4.2,
                7.1
              ],
              [
                3.8,
                5.9
              ],
              [
                2.9,
                5.5
              ],
              [
                2.9,
                5.5
              ],
              [
                1.9,
                5.9
              ],
              [
                1.4,
                7.1
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 864,
    ty: 3,
    parent: 861,
    ks: {
      p: {
        a: 0,
        k: [
          54.821,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 867,
    ty: 4,
    parent: 866,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.4,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.7,
                12.6
              ],
              [
                2.7,
                12.6
              ],
              [
                1.1,
                12.2
              ],
              [
                0.5,
                11.2
              ],
              [
                0.5,
                11.2
              ],
              [
                0.7,
                10.5
              ],
              [
                1.3,
                10
              ],
              [
                1.3,
                10
              ],
              [
                1.3,
                9.9
              ],
              [
                0.9,
                9.6
              ],
              [
                0.8,
                9.1
              ],
              [
                0.8,
                9.1
              ],
              [
                1,
                8.5
              ],
              [
                1.4,
                8.1
              ],
              [
                1.4,
                8.1
              ],
              [
                1.4,
                8.1
              ],
              [
                0.9,
                7.5
              ],
              [
                0.7,
                6.7
              ],
              [
                0.7,
                6.7
              ],
              [
                1,
                5.7
              ],
              [
                1.7,
                5
              ],
              [
                2.7,
                4.8
              ],
              [
                2.7,
                4.8
              ],
              [
                3.1,
                4.8
              ],
              [
                3.4,
                4.9
              ],
              [
                3.4,
                4.9
              ],
              [
                5.2,
                4.9
              ],
              [
                5.2,
                5.6
              ],
              [
                4.2,
                5.6
              ],
              [
                4.5,
                6.1
              ],
              [
                4.6,
                6.7
              ],
              [
                4.6,
                6.7
              ],
              [
                4.3,
                7.6
              ],
              [
                3.6,
                8.3
              ],
              [
                2.7,
                8.5
              ],
              [
                2.7,
                8.5
              ],
              [
                1.9,
                8.3
              ],
              [
                1.9,
                8.3
              ],
              [
                1.6,
                8.6
              ],
              [
                1.5,
                8.9
              ],
              [
                1.5,
                8.9
              ],
              [
                1.7,
                9.4
              ],
              [
                2.5,
                9.5
              ],
              [
                2.5,
                9.5
              ],
              [
                3.5,
                9.5
              ],
              [
                4.9,
                9.8
              ],
              [
                5.3,
                10.8
              ],
              [
                5.3,
                10.8
              ],
              [
                5,
                11.7
              ],
              [
                4.1,
                12.3
              ],
              [
                2.7,
                12.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.4,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.7,
                7.9
              ],
              [
                2.7,
                7.9
              ],
              [
                3.5,
                7.6
              ],
              [
                3.8,
                6.7
              ],
              [
                3.8,
                6.7
              ],
              [
                3.5,
                5.8
              ],
              [
                2.7,
                5.4
              ],
              [
                2.7,
                5.4
              ],
              [
                1.9,
                5.8
              ],
              [
                1.5,
                6.7
              ],
              [
                1.5,
                6.7
              ],
              [
                1.9,
                7.6
              ],
              [
                2.7,
                7.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                -0.5,
                0
              ]
            ],
            v: [
              [
                2.8,
                12
              ],
              [
                2.8,
                12
              ],
              [
                4,
                11.7
              ],
              [
                4.5,
                10.9
              ],
              [
                4.5,
                10.9
              ],
              [
                4.2,
                10.4
              ],
              [
                3.4,
                10.3
              ],
              [
                3.4,
                10.3
              ],
              [
                2.5,
                10.3
              ],
              [
                2.2,
                10.2
              ],
              [
                1.8,
                10.2
              ],
              [
                1.8,
                10.2
              ],
              [
                1.4,
                10.6
              ],
              [
                1.3,
                11.1
              ],
              [
                1.3,
                11.1
              ],
              [
                1.7,
                11.7
              ],
              [
                2.8,
                12
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 866,
    ty: 3,
    parent: 861,
    ks: {
      p: {
        a: 0,
        k: [
          49.363,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 869,
    ty: 4,
    parent: 868,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.2,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                10.2
              ],
              [
                0.9,
                10.2
              ],
              [
                0.9,
                4.9
              ],
              [
                1.6,
                4.9
              ],
              [
                1.7,
                5.9
              ],
              [
                1.7,
                5.9
              ],
              [
                2.4,
                5.1
              ],
              [
                3.2,
                4.8
              ],
              [
                3.2,
                4.8
              ],
              [
                3.8,
                4.9
              ],
              [
                3.8,
                4.9
              ],
              [
                3.6,
                5.7
              ],
              [
                3.4,
                5.6
              ],
              [
                3.1,
                5.6
              ],
              [
                3.1,
                5.6
              ],
              [
                2.4,
                5.9
              ],
              [
                1.8,
                6.8
              ],
              [
                1.8,
                6.8
              ],
              [
                1.8,
                10.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 868,
    ty: 3,
    parent: 861,
    ks: {
      p: {
        a: 0,
        k: [
          45.605,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 871,
    ty: 4,
    parent: 870,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.4
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                3,
                10.3
              ],
              [
                3,
                10.3
              ],
              [
                1.7,
                10
              ],
              [
                0.8,
                9
              ],
              [
                0.5,
                7.6
              ],
              [
                0.5,
                7.6
              ],
              [
                0.8,
                6.1
              ],
              [
                1.7,
                5.1
              ],
              [
                2.9,
                4.8
              ],
              [
                2.9,
                4.8
              ],
              [
                4.4,
                5.4
              ],
              [
                5,
                7.2
              ],
              [
                5,
                7.2
              ],
              [
                5,
                7.5
              ],
              [
                4.9,
                7.8
              ],
              [
                4.9,
                7.8
              ],
              [
                1.4,
                7.8
              ],
              [
                1.9,
                9.1
              ],
              [
                3.1,
                9.6
              ],
              [
                3.1,
                9.6
              ],
              [
                3.8,
                9.5
              ],
              [
                4.4,
                9.2
              ],
              [
                4.4,
                9.2
              ],
              [
                4.8,
                9.8
              ],
              [
                4,
                10.1
              ],
              [
                3,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.2,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.1,
                -0.5
              ]
            ],
            v: [
              [
                1.4,
                7.1
              ],
              [
                1.4,
                7.1
              ],
              [
                4.2,
                7.1
              ],
              [
                3.8,
                5.9
              ],
              [
                2.9,
                5.5
              ],
              [
                2.9,
                5.5
              ],
              [
                1.9,
                5.9
              ],
              [
                1.4,
                7.1
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 870,
    ty: 3,
    parent: 861,
    ks: {
      p: {
        a: 0,
        k: [
          40.233,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 873,
    ty: 4,
    parent: 872,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                3.2,
                10.3
              ],
              [
                3.2,
                10.3
              ],
              [
                2.5,
                10.1
              ],
              [
                1.7,
                9.6
              ],
              [
                1.7,
                9.6
              ],
              [
                1.7,
                9.6
              ],
              [
                1.6,
                10.2
              ],
              [
                0.9,
                10.2
              ],
              [
                0.9,
                2.5
              ],
              [
                1.8,
                2.5
              ],
              [
                1.8,
                4.6
              ],
              [
                1.8,
                5.5
              ],
              [
                2.5,
                5
              ],
              [
                3.4,
                4.8
              ],
              [
                3.4,
                4.8
              ],
              [
                5,
                5.5
              ],
              [
                5.5,
                7.5
              ],
              [
                5.5,
                7.5
              ],
              [
                5.2,
                9
              ],
              [
                4.3,
                10
              ],
              [
                3.2,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.4
              ],
              [
                0,
                0.7
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.4
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                3.1,
                9.6
              ],
              [
                3.1,
                9.6
              ],
              [
                4.1,
                9
              ],
              [
                4.6,
                7.5
              ],
              [
                4.6,
                7.5
              ],
              [
                4.3,
                6.1
              ],
              [
                3.2,
                5.5
              ],
              [
                3.2,
                5.5
              ],
              [
                2.5,
                5.7
              ],
              [
                1.8,
                6.2
              ],
              [
                1.8,
                6.2
              ],
              [
                1.8,
                9
              ],
              [
                2.5,
                9.4
              ],
              [
                3.1,
                9.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                -0.2,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 872,
    ty: 3,
    parent: 861,
    ks: {
      p: {
        a: 0,
        k: [
          34.244,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 875,
    ty: 4,
    parent: 874,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.7
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                10.2
              ],
              [
                0.9,
                10.2
              ],
              [
                0.9,
                4.9
              ],
              [
                1.6,
                4.9
              ],
              [
                1.7,
                5.7
              ],
              [
                1.7,
                5.7
              ],
              [
                2.5,
                5
              ],
              [
                3.4,
                4.8
              ],
              [
                3.4,
                4.8
              ],
              [
                4.3,
                5
              ],
              [
                4.8,
                5.8
              ],
              [
                4.8,
                5.8
              ],
              [
                5.7,
                5.1
              ],
              [
                6.6,
                4.8
              ],
              [
                6.6,
                4.8
              ],
              [
                7.8,
                5.3
              ],
              [
                8.2,
                6.8
              ],
              [
                8.2,
                6.8
              ],
              [
                8.2,
                10.2
              ],
              [
                7.3,
                10.2
              ],
              [
                7.3,
                7
              ],
              [
                7,
                5.9
              ],
              [
                6.3,
                5.5
              ],
              [
                6.3,
                5.5
              ],
              [
                5,
                6.4
              ],
              [
                5,
                6.4
              ],
              [
                5,
                10.2
              ],
              [
                4.1,
                10.2
              ],
              [
                4.1,
                7
              ],
              [
                3.8,
                5.9
              ],
              [
                3.1,
                5.5
              ],
              [
                3.1,
                5.5
              ],
              [
                1.8,
                6.4
              ],
              [
                1.8,
                6.4
              ],
              [
                1.8,
                10.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 874,
    ty: 3,
    parent: 861,
    ks: {
      p: {
        a: 0,
        k: [
          25.266,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 877,
    ty: 4,
    parent: 876,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0.7
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.4,
                10.3
              ],
              [
                2.4,
                10.3
              ],
              [
                1.2,
                9.8
              ],
              [
                0.8,
                8.2
              ],
              [
                0.8,
                8.2
              ],
              [
                0.8,
                4.9
              ],
              [
                1.7,
                4.9
              ],
              [
                1.7,
                8.1
              ],
              [
                1.9,
                9.2
              ],
              [
                2.7,
                9.5
              ],
              [
                2.7,
                9.5
              ],
              [
                3.4,
                9.3
              ],
              [
                4.1,
                8.6
              ],
              [
                4.1,
                8.6
              ],
              [
                4.1,
                4.9
              ],
              [
                5,
                4.9
              ],
              [
                5,
                10.2
              ],
              [
                4.3,
                10.2
              ],
              [
                4.2,
                9.4
              ],
              [
                4.2,
                9.4
              ],
              [
                3.4,
                10
              ],
              [
                2.4,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 876,
    ty: 3,
    parent: 861,
    ks: {
      p: {
        a: 0,
        k: [
          19.375,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 879,
    ty: 4,
    parent: 878,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.8,
                10.3
              ],
              [
                1.8,
                10.3
              ],
              [
                1.1,
                10
              ],
              [
                0.9,
                9.1
              ],
              [
                0.9,
                9.1
              ],
              [
                0.9,
                2.5
              ],
              [
                1.8,
                2.5
              ],
              [
                1.8,
                9.2
              ],
              [
                1.9,
                9.5
              ],
              [
                2,
                9.6
              ],
              [
                2,
                9.6
              ],
              [
                2.1,
                9.6
              ],
              [
                2.2,
                9.5
              ],
              [
                2.2,
                9.5
              ],
              [
                2.3,
                10.2
              ],
              [
                2.1,
                10.3
              ],
              [
                1.8,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 878,
    ty: 3,
    parent: 861,
    ks: {
      p: {
        a: 0,
        k: [
          16.613,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 881,
    ty: 4,
    parent: 880,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.7
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                10.2
              ],
              [
                0.9,
                10.2
              ],
              [
                0.9,
                2.5
              ],
              [
                1.8,
                2.5
              ],
              [
                1.8,
                4.6
              ],
              [
                1.7,
                5.6
              ],
              [
                2.5,
                5
              ],
              [
                3.5,
                4.8
              ],
              [
                3.5,
                4.8
              ],
              [
                4.7,
                5.3
              ],
              [
                5.1,
                6.8
              ],
              [
                5.1,
                6.8
              ],
              [
                5.1,
                10.2
              ],
              [
                4.2,
                10.2
              ],
              [
                4.2,
                7
              ],
              [
                4,
                5.9
              ],
              [
                3.2,
                5.5
              ],
              [
                3.2,
                5.5
              ],
              [
                2.5,
                5.8
              ],
              [
                1.8,
                6.4
              ],
              [
                1.8,
                6.4
              ],
              [
                1.8,
                10.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 880,
    ty: 3,
    parent: 861,
    ks: {
      p: {
        a: 0,
        k: [
          10.722,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 883,
    ty: 4,
    parent: 882,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.4
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                3,
                10.3
              ],
              [
                3,
                10.3
              ],
              [
                1.7,
                10
              ],
              [
                0.8,
                9
              ],
              [
                0.5,
                7.6
              ],
              [
                0.5,
                7.6
              ],
              [
                0.9,
                6
              ],
              [
                1.8,
                5.1
              ],
              [
                3,
                4.8
              ],
              [
                3,
                4.8
              ],
              [
                3.9,
                5
              ],
              [
                4.6,
                5.4
              ],
              [
                4.6,
                5.4
              ],
              [
                4.1,
                6
              ],
              [
                3.6,
                5.6
              ],
              [
                3.1,
                5.5
              ],
              [
                3.1,
                5.5
              ],
              [
                2.2,
                5.8
              ],
              [
                1.6,
                6.5
              ],
              [
                1.4,
                7.6
              ],
              [
                1.4,
                7.6
              ],
              [
                1.9,
                9
              ],
              [
                3,
                9.6
              ],
              [
                3,
                9.6
              ],
              [
                3.7,
                9.4
              ],
              [
                4.3,
                9
              ],
              [
                4.3,
                9
              ],
              [
                4.7,
                9.6
              ],
              [
                3.9,
                10.1
              ],
              [
                3,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.2,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 882,
    ty: 3,
    parent: 861,
    ks: {
      p: {
        a: 0,
        k: [
          5.783,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 885,
    ty: 4,
    parent: 884,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.4,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.9,
                10.3
              ],
              [
                2.9,
                10.3
              ],
              [
                1.6,
                10
              ],
              [
                0.5,
                9.3
              ],
              [
                0.5,
                9.3
              ],
              [
                1,
                8.6
              ],
              [
                1.9,
                9.3
              ],
              [
                3,
                9.5
              ],
              [
                3,
                9.5
              ],
              [
                4.1,
                9.2
              ],
              [
                4.4,
                8.4
              ],
              [
                4.4,
                8.4
              ],
              [
                4.3,
                7.8
              ],
              [
                3.9,
                7.4
              ],
              [
                3.3,
                7.1
              ],
              [
                3.3,
                7.1
              ],
              [
                2.2,
                6.7
              ],
              [
                1.6,
                6.3
              ],
              [
                1,
                5.7
              ],
              [
                0.8,
                4.8
              ],
              [
                0.8,
                4.8
              ],
              [
                1.1,
                3.9
              ],
              [
                1.9,
                3.2
              ],
              [
                3,
                2.9
              ],
              [
                3,
                2.9
              ],
              [
                4.2,
                3.2
              ],
              [
                5.1,
                3.8
              ],
              [
                5.1,
                3.8
              ],
              [
                4.6,
                4.4
              ],
              [
                3.9,
                3.9
              ],
              [
                3,
                3.7
              ],
              [
                3,
                3.7
              ],
              [
                2.1,
                4
              ],
              [
                1.7,
                4.8
              ],
              [
                1.7,
                4.8
              ],
              [
                1.9,
                5.3
              ],
              [
                2.3,
                5.7
              ],
              [
                2.9,
                5.9
              ],
              [
                2.9,
                5.9
              ],
              [
                3.9,
                6.4
              ],
              [
                4.6,
                6.8
              ],
              [
                5.2,
                7.4
              ],
              [
                5.4,
                8.3
              ],
              [
                5.4,
                8.3
              ],
              [
                5.1,
                9.3
              ],
              [
                4.2,
                10
              ],
              [
                2.9,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.4,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 884,
    ty: 3,
    parent: 861,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 861,
    ty: 3,
    parent: 860,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 860,
    ty: 3,
    parent: 859,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 859,
    ty: 3,
    parent: 858,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          11.514
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 890,
    ty: 0,
    parent: 886,
    ks: {},
    w: 62,
    h: 12,
    ip: 0,
    op: 565,
    st: 0,
    refId: "888"
  },
  {
    ind: 886,
    ty: 3,
    parent: 858,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 858,
    ty: 3,
    parent: 759,
    ks: {
      p: {
        a: 0,
        k: [
          21.238,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 759,
    ty: 3,
    parent: 691,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 691,
    ty: 3,
    parent: 690,
    ks: {
      p: {
        a: 0,
        k: [
          8.128,
          78.567
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 899,
    ty: 4,
    parent: 898,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                4.3
              ],
              [
                1.6,
                4.3
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.3
              ],
              [
                1.2,
                3.3
              ],
              [
                0.8,
                3.2
              ],
              [
                0.7,
                2.8
              ],
              [
                0.7,
                2.8
              ],
              [
                0.8,
                2.5
              ],
              [
                1.2,
                2.3
              ],
              [
                1.2,
                2.3
              ],
              [
                1.6,
                2.5
              ],
              [
                1.7,
                2.8
              ],
              [
                1.7,
                2.8
              ],
              [
                1.6,
                3.2
              ],
              [
                1.2,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 898,
    ty: 3,
    parent: 897,
    ks: {
      p: {
        a: 0,
        k: [
          29.928,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 901,
    ty: 4,
    parent: 900,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.23
              ],
              [
                0,
                0.41
              ],
              [
                0,
                0
              ],
              [
                -0.45,
                0.27
              ],
              [
                -0.98,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.18
              ],
              [
                0.14,
                0.11
              ],
              [
                0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.1
              ],
              [
                0.18,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.31,
                0.13
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.34
              ],
              [
                0,
                -0.58
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.13
              ],
              [
                0.29,
                0
              ]
            ],
            v: [
              [
                1.84,
                9.02
              ],
              [
                1.84,
                9.02
              ],
              [
                0.88,
                8.67
              ],
              [
                0.49,
                7.71
              ],
              [
                0.49,
                7.71
              ],
              [
                1.17,
                6.55
              ],
              [
                3.32,
                5.98
              ],
              [
                3.32,
                5.98
              ],
              [
                3.24,
                5.42
              ],
              [
                2.95,
                4.99
              ],
              [
                2.37,
                4.82
              ],
              [
                2.37,
                4.82
              ],
              [
                1.62,
                4.98
              ],
              [
                1,
                5.32
              ],
              [
                1,
                5.32
              ],
              [
                0.69,
                4.78
              ],
              [
                1.48,
                4.37
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.73,
                4.7
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                8.9
              ],
              [
                3.46,
                8.9
              ],
              [
                3.39,
                8.35
              ],
              [
                3.37,
                8.35
              ],
              [
                2.66,
                8.82
              ],
              [
                1.84,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.26,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.45,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.05,
                -0.18
              ],
              [
                -0.14,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.14
              ],
              [
                0.31,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.56,
                0
              ],
              [
                0.25,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.26,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.11
              ],
              [
                -0.22,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.19
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.23,
                0
              ]
            ],
            v: [
              [
                2.07,
                8.39
              ],
              [
                2.07,
                8.39
              ],
              [
                2.69,
                8.23
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                6.49
              ],
              [
                1.71,
                6.92
              ],
              [
                1.25,
                7.65
              ],
              [
                1.25,
                7.65
              ],
              [
                1.49,
                8.21
              ],
              [
                2.07,
                8.39
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.2,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.76,
                0.09
              ],
              [
                -0.31,
                0.19
              ],
              [
                0,
                0
              ],
              [
                0,
                0.26
              ],
              [
                0.16,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 900,
    ty: 3,
    parent: 897,
    ks: {
      p: {
        a: 0,
        k: [
          25.15,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 903,
    ty: 4,
    parent: 902,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.7
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.8,
                9
              ],
              [
                2.8,
                9
              ],
              [
                2.1,
                8.9
              ],
              [
                1.5,
                8.4
              ],
              [
                1.5,
                8.4
              ],
              [
                1.5,
                8.4
              ],
              [
                1.4,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                2.2
              ],
              [
                1.6,
                2.2
              ],
              [
                1.6,
                4
              ],
              [
                1.5,
                4.8
              ],
              [
                2.2,
                4.4
              ],
              [
                3,
                4.2
              ],
              [
                3,
                4.2
              ],
              [
                4.3,
                4.8
              ],
              [
                4.8,
                6.5
              ],
              [
                4.8,
                6.5
              ],
              [
                4.5,
                7.9
              ],
              [
                3.8,
                8.7
              ],
              [
                2.8,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.7,
                8.4
              ],
              [
                2.7,
                8.4
              ],
              [
                3.6,
                7.9
              ],
              [
                4,
                6.5
              ],
              [
                4,
                6.5
              ],
              [
                3.7,
                5.3
              ],
              [
                2.8,
                4.8
              ],
              [
                2.8,
                4.8
              ],
              [
                2.2,
                5
              ],
              [
                1.6,
                5.5
              ],
              [
                1.6,
                5.5
              ],
              [
                1.6,
                7.9
              ],
              [
                2.2,
                8.3
              ],
              [
                2.7,
                8.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 902,
    ty: 3,
    parent: 897,
    ks: {
      p: {
        a: 0,
        k: [
          19.908,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 905,
    ty: 4,
    parent: 904,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                4.3
              ],
              [
                1.4,
                4.3
              ],
              [
                1.5,
                5
              ],
              [
                1.5,
                5
              ],
              [
                2.2,
                4.4
              ],
              [
                2.9,
                4.2
              ],
              [
                2.9,
                4.2
              ],
              [
                3.8,
                4.4
              ],
              [
                4.2,
                5.1
              ],
              [
                4.2,
                5.1
              ],
              [
                4.9,
                4.4
              ],
              [
                5.7,
                4.2
              ],
              [
                5.7,
                4.2
              ],
              [
                6.8,
                4.6
              ],
              [
                7.1,
                6
              ],
              [
                7.1,
                6
              ],
              [
                7.1,
                8.9
              ],
              [
                6.4,
                8.9
              ],
              [
                6.4,
                6.1
              ],
              [
                6.2,
                5.1
              ],
              [
                5.5,
                4.9
              ],
              [
                5.5,
                4.9
              ],
              [
                4.4,
                5.6
              ],
              [
                4.4,
                5.6
              ],
              [
                4.4,
                8.9
              ],
              [
                3.6,
                8.9
              ],
              [
                3.6,
                6.1
              ],
              [
                3.4,
                5.1
              ],
              [
                2.7,
                4.9
              ],
              [
                2.7,
                4.9
              ],
              [
                1.6,
                5.6
              ],
              [
                1.6,
                5.6
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 904,
    ty: 3,
    parent: 897,
    ks: {
      p: {
        a: 0,
        k: [
          12.049,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 907,
    ty: 4,
    parent: 906,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                0.31
              ],
              [
                0,
                0.59
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.12
              ],
              [
                -0.21,
                0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.15
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                2.12,
                9.02
              ],
              [
                2.12,
                9.02
              ],
              [
                1.05,
                8.56
              ],
              [
                0.71,
                7.21
              ],
              [
                0.71,
                7.21
              ],
              [
                0.71,
                4.29
              ],
              [
                1.5,
                4.29
              ],
              [
                1.5,
                7.11
              ],
              [
                1.7,
                8.05
              ],
              [
                2.36,
                8.34
              ],
              [
                2.36,
                8.34
              ],
              [
                3,
                8.16
              ],
              [
                3.6,
                7.57
              ],
              [
                3.6,
                7.57
              ],
              [
                3.6,
                4.29
              ],
              [
                4.38,
                4.29
              ],
              [
                4.38,
                8.9
              ],
              [
                3.74,
                8.9
              ],
              [
                3.67,
                8.18
              ],
              [
                3.64,
                8.18
              ],
              [
                2.96,
                8.79
              ],
              [
                2.12,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.49,
                0
              ],
              [
                -0.23,
                -0.31
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.43
              ],
              [
                0.14,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0
              ],
              [
                0.19,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.25
              ],
              [
                -0.24,
                0.15
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 906,
    ty: 3,
    parent: 897,
    ks: {
      p: {
        a: 0,
        k: [
          6.892,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 909,
    ty: 4,
    parent: 908,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                2.7
              ],
              [
                1.8,
                2.7
              ],
              [
                3,
                6
              ],
              [
                3.2,
                6.7
              ],
              [
                3.4,
                7.3
              ],
              [
                3.4,
                7.3
              ],
              [
                3.5,
                7.3
              ],
              [
                3.7,
                6.7
              ],
              [
                3.9,
                6
              ],
              [
                3.9,
                6
              ],
              [
                5.1,
                2.7
              ],
              [
                6,
                2.7
              ],
              [
                6,
                8.9
              ],
              [
                5.3,
                8.9
              ],
              [
                5.3,
                5.5
              ],
              [
                5.3,
                4.6
              ],
              [
                5.4,
                3.6
              ],
              [
                5.4,
                3.6
              ],
              [
                5.4,
                3.6
              ],
              [
                4.9,
                5.1
              ],
              [
                3.7,
                8.3
              ],
              [
                3.2,
                8.3
              ],
              [
                2,
                5.1
              ],
              [
                1.5,
                3.6
              ],
              [
                1.5,
                3.6
              ],
              [
                1.5,
                4.6
              ],
              [
                1.6,
                5.5
              ],
              [
                1.6,
                5.5
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 908,
    ty: 3,
    parent: 897,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 897,
    ty: 3,
    parent: 896,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 896,
    ty: 3,
    parent: 895,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 895,
    ty: 3,
    parent: 894,
    ks: {
      p: {
        a: 0,
        k: [
          16.255,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 919,
    ty: 0,
    parent: 910,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.582
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    w: 10.837,
    h: 10.837,
    ip: 0,
    op: 565,
    st: 0,
    refId: "917"
  },
  {
    ind: 910,
    ty: 3,
    parent: 894,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 894,
    ty: 3,
    parent: 893,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          14.709
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 925,
    ty: 4,
    parent: 924,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                2.2,
                9
              ],
              [
                2.2,
                9
              ],
              [
                1.2,
                8.6
              ],
              [
                0.9,
                7.5
              ],
              [
                0.9,
                7.5
              ],
              [
                0.9,
                4.9
              ],
              [
                0.2,
                4.9
              ],
              [
                0.2,
                4.3
              ],
              [
                0.9,
                4.3
              ],
              [
                1,
                3
              ],
              [
                1.7,
                3
              ],
              [
                1.7,
                4.3
              ],
              [
                2.9,
                4.3
              ],
              [
                2.9,
                4.9
              ],
              [
                1.7,
                4.9
              ],
              [
                1.7,
                7.5
              ],
              [
                1.9,
                8.1
              ],
              [
                2.4,
                8.4
              ],
              [
                2.4,
                8.4
              ],
              [
                2.7,
                8.3
              ],
              [
                2.9,
                8.3
              ],
              [
                2.9,
                8.3
              ],
              [
                3.1,
                8.8
              ],
              [
                2.7,
                9
              ],
              [
                2.2,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 924,
    ty: 3,
    parent: 923,
    ks: {
      p: {
        a: 0,
        k: [
          31.113,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 927,
    ty: 4,
    parent: 926,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.12
              ],
              [
                0.22,
                0.18
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                -0.1
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.14
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.11
              ],
              [
                0.16,
                0.07
              ],
              [
                0.17,
                0.06
              ],
              [
                0,
                0
              ],
              [
                0.21,
                0.1
              ],
              [
                0.13,
                0.17
              ],
              [
                0,
                0.26
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                0.25
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.1
              ],
              [
                -0.18,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.17,
                0.08
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                -0.13
              ],
              [
                0,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.09,
                -0.09
              ],
              [
                -0.15,
                -0.07
              ],
              [
                -0.17,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                -0.1
              ],
              [
                -0.14,
                -0.17
              ],
              [
                0,
                -0.29
              ],
              [
                0,
                0
              ],
              [
                0.13,
                -0.21
              ],
              [
                0.25,
                -0.13
              ],
              [
                0.37,
                0
              ]
            ],
            v: [
              [
                1.98,
                9.02
              ],
              [
                1.98,
                9.02
              ],
              [
                1.04,
                8.83
              ],
              [
                0.27,
                8.38
              ],
              [
                0.27,
                8.38
              ],
              [
                0.65,
                7.86
              ],
              [
                1.28,
                8.25
              ],
              [
                2.01,
                8.41
              ],
              [
                2.01,
                8.41
              ],
              [
                2.69,
                8.2
              ],
              [
                2.92,
                7.69
              ],
              [
                2.92,
                7.69
              ],
              [
                2.76,
                7.29
              ],
              [
                2.37,
                7.02
              ],
              [
                1.87,
                6.82
              ],
              [
                1.87,
                6.82
              ],
              [
                1.23,
                6.54
              ],
              [
                0.72,
                6.13
              ],
              [
                0.52,
                5.49
              ],
              [
                0.52,
                5.49
              ],
              [
                0.94,
                4.55
              ],
              [
                2.11,
                4.18
              ],
              [
                2.11,
                4.18
              ],
              [
                2.91,
                4.33
              ],
              [
                3.55,
                4.7
              ],
              [
                3.55,
                4.7
              ],
              [
                3.17,
                5.19
              ],
              [
                2.67,
                4.9
              ],
              [
                2.11,
                4.79
              ],
              [
                2.11,
                4.79
              ],
              [
                1.47,
                4.99
              ],
              [
                1.27,
                5.45
              ],
              [
                1.27,
                5.45
              ],
              [
                1.41,
                5.81
              ],
              [
                1.78,
                6.04
              ],
              [
                2.27,
                6.25
              ],
              [
                2.27,
                6.25
              ],
              [
                2.92,
                6.53
              ],
              [
                3.46,
                6.94
              ],
              [
                3.67,
                7.64
              ],
              [
                3.67,
                7.64
              ],
              [
                3.48,
                8.32
              ],
              [
                2.91,
                8.83
              ],
              [
                1.98,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.33,
                0
              ],
              [
                -0.3,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.16
              ],
              [
                0.21,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.15,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.16
              ],
              [
                -0.1,
                -0.11
              ],
              [
                -0.16,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                -0.08
              ],
              [
                -0.21,
                -0.1
              ],
              [
                -0.13,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.37
              ],
              [
                0.28,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0.28,
                0
              ],
              [
                0.25,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.17,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                0
              ],
              [
                -0.14,
                0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0.15
              ],
              [
                0.09,
                0.09
              ],
              [
                0.15,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0.08
              ],
              [
                0.21,
                0.1
              ],
              [
                0.14,
                0.17
              ],
              [
                0,
                0
              ],
              [
                0,
                0.25
              ],
              [
                -0.13,
                0.21
              ],
              [
                -0.25,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 926,
    ty: 3,
    parent: 923,
    ks: {
      p: {
        a: 0,
        k: [
          27.141,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 929,
    ty: 4,
    parent: 928,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                4.3
              ],
              [
                1.6,
                4.3
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.3
              ],
              [
                1.2,
                3.3
              ],
              [
                0.8,
                3.2
              ],
              [
                0.7,
                2.8
              ],
              [
                0.7,
                2.8
              ],
              [
                0.8,
                2.5
              ],
              [
                1.2,
                2.3
              ],
              [
                1.2,
                2.3
              ],
              [
                1.6,
                2.5
              ],
              [
                1.7,
                2.8
              ],
              [
                1.7,
                2.8
              ],
              [
                1.6,
                3.2
              ],
              [
                1.2,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 928,
    ty: 3,
    parent: 923,
    ks: {
      p: {
        a: 0,
        k: [
          24.809,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 931,
    ty: 4,
    parent: 930,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                2.2,
                9
              ],
              [
                2.2,
                9
              ],
              [
                1.2,
                8.6
              ],
              [
                0.9,
                7.5
              ],
              [
                0.9,
                7.5
              ],
              [
                0.9,
                4.9
              ],
              [
                0.2,
                4.9
              ],
              [
                0.2,
                4.3
              ],
              [
                0.9,
                4.3
              ],
              [
                1,
                3
              ],
              [
                1.7,
                3
              ],
              [
                1.7,
                4.3
              ],
              [
                2.9,
                4.3
              ],
              [
                2.9,
                4.9
              ],
              [
                1.7,
                4.9
              ],
              [
                1.7,
                7.5
              ],
              [
                1.9,
                8.1
              ],
              [
                2.4,
                8.4
              ],
              [
                2.4,
                8.4
              ],
              [
                2.7,
                8.3
              ],
              [
                2.9,
                8.3
              ],
              [
                2.9,
                8.3
              ],
              [
                3.1,
                8.8
              ],
              [
                2.7,
                9
              ],
              [
                2.2,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 930,
    ty: 3,
    parent: 923,
    ks: {
      p: {
        a: 0,
        k: [
          21.605,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 933,
    ty: 4,
    parent: 932,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                0.15
              ],
              [
                -0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.31
              ],
              [
                0,
                -0.59
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.12
              ],
              [
                0.23,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                4.96
              ],
              [
                1.52,
                4.96
              ],
              [
                2.22,
                4.4
              ],
              [
                3.06,
                4.18
              ],
              [
                3.06,
                4.18
              ],
              [
                4.13,
                4.64
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                8.9
              ],
              [
                3.69,
                8.9
              ],
              [
                3.69,
                6.09
              ],
              [
                3.48,
                5.15
              ],
              [
                2.82,
                4.85
              ],
              [
                2.82,
                4.85
              ],
              [
                2.19,
                5.03
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.22
              ],
              [
                0.25,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0.49,
                0
              ],
              [
                0.22,
                0.31
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.43
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.19,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 932,
    ty: 3,
    parent: 923,
    ks: {
      p: {
        a: 0,
        k: [
          16.419,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 935,
    ty: 4,
    parent: 934,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.2
              ],
              [
                -0.35,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.39
              ],
              [
                0,
                -0.66
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.08
              ],
              [
                0.01,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                -0.29
              ],
              [
                -0.44,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.07
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.09
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                2.65,
                9.02
              ],
              [
                2.65,
                9.02
              ],
              [
                1.53,
                8.73
              ],
              [
                0.73,
                7.9
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.31
              ],
              [
                1.51,
                4.47
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.86,
                4.77
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.58
              ],
              [
                4.31,
                6.79
              ],
              [
                4.31,
                6.79
              ],
              [
                1.2,
                6.79
              ],
              [
                1.66,
                7.95
              ],
              [
                2.74,
                8.39
              ],
              [
                2.74,
                8.39
              ],
              [
                3.35,
                8.29
              ],
              [
                3.89,
                8.03
              ],
              [
                3.89,
                8.03
              ],
              [
                4.16,
                8.54
              ],
              [
                3.49,
                8.87
              ],
              [
                2.65,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.41,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.59,
                0
              ],
              [
                0.32,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.03,
                0.49
              ],
              [
                0.27,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.19,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.13
              ],
              [
                -0.25,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.24
              ],
              [
                0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.25
              ],
              [
                0.05,
                -0.46
              ]
            ],
            v: [
              [
                1.19,
                6.23
              ],
              [
                1.19,
                6.23
              ],
              [
                3.66,
                6.23
              ],
              [
                3.36,
                5.16
              ],
              [
                2.52,
                4.8
              ],
              [
                2.52,
                4.8
              ],
              [
                1.65,
                5.17
              ],
              [
                1.19,
                6.23
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.47
              ],
              [
                -0.2,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.26,
                0.25
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 934,
    ty: 3,
    parent: 923,
    ks: {
      p: {
        a: 0,
        k: [
          11.717,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 937,
    ty: 4,
    parent: 936,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                4.3
              ],
              [
                1.6,
                4.3
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.3
              ],
              [
                1.2,
                3.3
              ],
              [
                0.8,
                3.2
              ],
              [
                0.7,
                2.8
              ],
              [
                0.7,
                2.8
              ],
              [
                0.8,
                2.5
              ],
              [
                1.2,
                2.3
              ],
              [
                1.2,
                2.3
              ],
              [
                1.6,
                2.5
              ],
              [
                1.7,
                2.8
              ],
              [
                1.7,
                2.8
              ],
              [
                1.6,
                3.2
              ],
              [
                1.2,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 936,
    ty: 3,
    parent: 923,
    ks: {
      p: {
        a: 0,
        k: [
          9.385,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 939,
    ty: 4,
    parent: 938,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.33,
                0.19
              ],
              [
                0.19,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.36
              ],
              [
                -0.34,
                0.19
              ],
              [
                -0.39,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.11
              ],
              [
                -0.16,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.08
              ],
              [
                0.18,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.15
              ],
              [
                0.12,
                -0.27
              ],
              [
                0,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                -0.26,
                -0.33
              ],
              [
                -0.42,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0.09
              ],
              [
                -0.14,
                0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.1
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                2.6,
                9.02
              ],
              [
                2.6,
                9.02
              ],
              [
                1.5,
                8.73
              ],
              [
                0.72,
                7.91
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.74,
                5.29
              ],
              [
                1.56,
                4.46
              ],
              [
                2.66,
                4.18
              ],
              [
                2.66,
                4.18
              ],
              [
                3.44,
                4.34
              ],
              [
                4,
                4.72
              ],
              [
                4,
                4.72
              ],
              [
                3.6,
                5.23
              ],
              [
                3.18,
                4.94
              ],
              [
                2.68,
                4.82
              ],
              [
                2.68,
                4.82
              ],
              [
                1.94,
                5.05
              ],
              [
                1.43,
                5.67
              ],
              [
                1.24,
                6.61
              ],
              [
                1.24,
                6.61
              ],
              [
                1.64,
                7.88
              ],
              [
                2.66,
                8.37
              ],
              [
                2.66,
                8.37
              ],
              [
                3.26,
                8.23
              ],
              [
                3.75,
                7.91
              ],
              [
                3.75,
                7.91
              ],
              [
                4.09,
                8.43
              ],
              [
                3.39,
                8.86
              ],
              [
                2.6,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.33,
                -0.19
              ],
              [
                -0.19,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.52
              ],
              [
                0.21,
                -0.36
              ],
              [
                0.34,
                -0.19
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.22,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.12
              ],
              [
                -0.15,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.12,
                0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                0.52
              ],
              [
                0.26,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0.21,
                0
              ],
              [
                0.18,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.25,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 938,
    ty: 3,
    parent: 923,
    ks: {
      p: {
        a: 0,
        k: [
          5.062,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 941,
    ty: 4,
    parent: 940,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                0.9,
                7.5
              ],
              [
                1.7,
                8.1
              ],
              [
                2.6,
                8.3
              ],
              [
                2.6,
                8.3
              ],
              [
                3.5,
                8
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.8,
                6.8
              ],
              [
                3.4,
                6.5
              ],
              [
                2.9,
                6.2
              ],
              [
                2.9,
                6.2
              ],
              [
                2,
                5.8
              ],
              [
                1.4,
                5.5
              ],
              [
                0.9,
                5
              ],
              [
                0.7,
                4.2
              ],
              [
                0.7,
                4.2
              ],
              [
                1,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.7,
                2.8
              ],
              [
                4.5,
                3.3
              ],
              [
                4.5,
                3.3
              ],
              [
                4.1,
                3.8
              ],
              [
                3.4,
                3.4
              ],
              [
                2.7,
                3.3
              ],
              [
                2.7,
                3.3
              ],
              [
                1.8,
                3.5
              ],
              [
                1.5,
                4.2
              ],
              [
                1.5,
                4.2
              ],
              [
                1.7,
                4.7
              ],
              [
                2,
                5
              ],
              [
                2.5,
                5.2
              ],
              [
                2.5,
                5.2
              ],
              [
                3.4,
                5.6
              ],
              [
                4.1,
                5.9
              ],
              [
                4.5,
                6.5
              ],
              [
                4.7,
                7.2
              ],
              [
                4.7,
                7.2
              ],
              [
                4.4,
                8.1
              ],
              [
                3.7,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 940,
    ty: 3,
    parent: 923,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 923,
    ty: 3,
    parent: 922,
    ks: {
      p: {
        a: 0,
        k: [
          53.505,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 944,
    ty: 4,
    parent: 943,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.23
              ],
              [
                0,
                0.41
              ],
              [
                0,
                0
              ],
              [
                -0.45,
                0.27
              ],
              [
                -0.98,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.18
              ],
              [
                0.14,
                0.11
              ],
              [
                0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.1
              ],
              [
                0.18,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.31,
                0.13
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.34
              ],
              [
                0,
                -0.58
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.13
              ],
              [
                0.29,
                0
              ]
            ],
            v: [
              [
                1.84,
                9.02
              ],
              [
                1.84,
                9.02
              ],
              [
                0.88,
                8.67
              ],
              [
                0.49,
                7.71
              ],
              [
                0.49,
                7.71
              ],
              [
                1.17,
                6.55
              ],
              [
                3.32,
                5.98
              ],
              [
                3.32,
                5.98
              ],
              [
                3.24,
                5.42
              ],
              [
                2.95,
                4.99
              ],
              [
                2.37,
                4.82
              ],
              [
                2.37,
                4.82
              ],
              [
                1.62,
                4.98
              ],
              [
                1,
                5.32
              ],
              [
                1,
                5.32
              ],
              [
                0.69,
                4.78
              ],
              [
                1.48,
                4.37
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.73,
                4.7
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                8.9
              ],
              [
                3.46,
                8.9
              ],
              [
                3.39,
                8.35
              ],
              [
                3.37,
                8.35
              ],
              [
                2.66,
                8.82
              ],
              [
                1.84,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.26,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.45,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.05,
                -0.18
              ],
              [
                -0.14,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.14
              ],
              [
                0.31,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.56,
                0
              ],
              [
                0.25,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.26,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.11
              ],
              [
                -0.22,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.19
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.23,
                0
              ]
            ],
            v: [
              [
                2.07,
                8.39
              ],
              [
                2.07,
                8.39
              ],
              [
                2.69,
                8.23
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                6.49
              ],
              [
                1.71,
                6.92
              ],
              [
                1.25,
                7.65
              ],
              [
                1.25,
                7.65
              ],
              [
                1.49,
                8.21
              ],
              [
                2.07,
                8.39
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.2,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.76,
                0.09
              ],
              [
                -0.31,
                0.19
              ],
              [
                0,
                0
              ],
              [
                0,
                0.26
              ],
              [
                0.16,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 943,
    ty: 3,
    parent: 942,
    ks: {
      p: {
        a: 0,
        k: [
          13.812,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 946,
    ty: 4,
    parent: 945,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                2.2,
                9
              ],
              [
                2.2,
                9
              ],
              [
                1.2,
                8.6
              ],
              [
                0.9,
                7.5
              ],
              [
                0.9,
                7.5
              ],
              [
                0.9,
                4.9
              ],
              [
                0.2,
                4.9
              ],
              [
                0.2,
                4.3
              ],
              [
                0.9,
                4.3
              ],
              [
                1,
                3
              ],
              [
                1.7,
                3
              ],
              [
                1.7,
                4.3
              ],
              [
                2.9,
                4.3
              ],
              [
                2.9,
                4.9
              ],
              [
                1.7,
                4.9
              ],
              [
                1.7,
                7.5
              ],
              [
                1.9,
                8.1
              ],
              [
                2.4,
                8.4
              ],
              [
                2.4,
                8.4
              ],
              [
                2.7,
                8.3
              ],
              [
                2.9,
                8.3
              ],
              [
                2.9,
                8.3
              ],
              [
                3.1,
                8.8
              ],
              [
                2.7,
                9
              ],
              [
                2.2,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 945,
    ty: 3,
    parent: 942,
    ks: {
      p: {
        a: 0,
        k: [
          10.608,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 948,
    ty: 4,
    parent: 947,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.23
              ],
              [
                0,
                0.41
              ],
              [
                0,
                0
              ],
              [
                -0.45,
                0.27
              ],
              [
                -0.98,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.18
              ],
              [
                0.14,
                0.11
              ],
              [
                0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.1
              ],
              [
                0.18,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.31,
                0.13
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.34
              ],
              [
                0,
                -0.58
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.13
              ],
              [
                0.29,
                0
              ]
            ],
            v: [
              [
                1.84,
                9.02
              ],
              [
                1.84,
                9.02
              ],
              [
                0.88,
                8.67
              ],
              [
                0.49,
                7.71
              ],
              [
                0.49,
                7.71
              ],
              [
                1.17,
                6.55
              ],
              [
                3.32,
                5.98
              ],
              [
                3.32,
                5.98
              ],
              [
                3.24,
                5.42
              ],
              [
                2.95,
                4.99
              ],
              [
                2.37,
                4.82
              ],
              [
                2.37,
                4.82
              ],
              [
                1.62,
                4.98
              ],
              [
                1,
                5.32
              ],
              [
                1,
                5.32
              ],
              [
                0.69,
                4.78
              ],
              [
                1.48,
                4.37
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.73,
                4.7
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                8.9
              ],
              [
                3.46,
                8.9
              ],
              [
                3.39,
                8.35
              ],
              [
                3.37,
                8.35
              ],
              [
                2.66,
                8.82
              ],
              [
                1.84,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.26,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.45,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.05,
                -0.18
              ],
              [
                -0.14,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.14
              ],
              [
                0.31,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.56,
                0
              ],
              [
                0.25,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.26,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.11
              ],
              [
                -0.22,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.19
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.23,
                0
              ]
            ],
            v: [
              [
                2.07,
                8.39
              ],
              [
                2.07,
                8.39
              ],
              [
                2.69,
                8.23
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                6.49
              ],
              [
                1.71,
                6.92
              ],
              [
                1.25,
                7.65
              ],
              [
                1.25,
                7.65
              ],
              [
                1.49,
                8.21
              ],
              [
                2.07,
                8.39
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.2,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.76,
                0.09
              ],
              [
                -0.31,
                0.19
              ],
              [
                0,
                0
              ],
              [
                0,
                0.26
              ],
              [
                0.16,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 947,
    ty: 3,
    parent: 942,
    ks: {
      p: {
        a: 0,
        k: [
          5.83,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 950,
    ty: 4,
    parent: 949,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.5,
                -0.5
              ],
              [
                0,
                -1
              ],
              [
                0,
                0
              ],
              [
                0.5,
                -0.5
              ],
              [
                0.9,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                2.7
              ],
              [
                2.4,
                2.7
              ],
              [
                4.6,
                3.5
              ],
              [
                5.3,
                5.8
              ],
              [
                5.3,
                5.8
              ],
              [
                4.6,
                8.1
              ],
              [
                2.4,
                8.9
              ],
              [
                2.4,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                1,
                0
              ],
              [
                0.5,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                1
              ],
              [
                -0.5,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.4
              ],
              [
                0,
                0.8
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0.7,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                3.3
              ],
              [
                1.6,
                8.3
              ],
              [
                2.4,
                8.3
              ],
              [
                4,
                7.6
              ],
              [
                4.5,
                5.8
              ],
              [
                4.5,
                5.8
              ],
              [
                4,
                4
              ],
              [
                2.4,
                3.3
              ],
              [
                2.4,
                3.3
              ],
              [
                1.6,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.8
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 949,
    ty: 3,
    parent: 942,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 942,
    ty: 3,
    parent: 922,
    ks: {
      p: {
        a: 0,
        k: [
          33.019,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 953,
    ty: 4,
    parent: 952,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                0.15
              ],
              [
                -0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.31
              ],
              [
                0,
                -0.59
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.12
              ],
              [
                0.23,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                4.96
              ],
              [
                1.52,
                4.96
              ],
              [
                2.22,
                4.4
              ],
              [
                3.06,
                4.18
              ],
              [
                3.06,
                4.18
              ],
              [
                4.13,
                4.64
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                8.9
              ],
              [
                3.69,
                8.9
              ],
              [
                3.69,
                6.09
              ],
              [
                3.48,
                5.15
              ],
              [
                2.82,
                4.85
              ],
              [
                2.82,
                4.85
              ],
              [
                2.19,
                5.03
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.22
              ],
              [
                0.25,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0.49,
                0
              ],
              [
                0.22,
                0.31
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.43
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.19,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 952,
    ty: 3,
    parent: 951,
    ks: {
      p: {
        a: 0,
        k: [
          25.937,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 955,
    ty: 4,
    parent: 954,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                4.3
              ],
              [
                1.6,
                4.3
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.3
              ],
              [
                1.2,
                3.3
              ],
              [
                0.8,
                3.2
              ],
              [
                0.7,
                2.8
              ],
              [
                0.7,
                2.8
              ],
              [
                0.8,
                2.5
              ],
              [
                1.2,
                2.3
              ],
              [
                1.2,
                2.3
              ],
              [
                1.6,
                2.5
              ],
              [
                1.7,
                2.8
              ],
              [
                1.7,
                2.8
              ],
              [
                1.6,
                3.2
              ],
              [
                1.2,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 954,
    ty: 3,
    parent: 951,
    ks: {
      p: {
        a: 0,
        k: [
          23.605,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 957,
    ty: 4,
    parent: 956,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.23
              ],
              [
                0,
                0.41
              ],
              [
                0,
                0
              ],
              [
                -0.45,
                0.27
              ],
              [
                -0.98,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.18
              ],
              [
                0.14,
                0.11
              ],
              [
                0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.1
              ],
              [
                0.18,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.31,
                0.13
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.34
              ],
              [
                0,
                -0.58
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.13
              ],
              [
                0.29,
                0
              ]
            ],
            v: [
              [
                1.84,
                9.02
              ],
              [
                1.84,
                9.02
              ],
              [
                0.88,
                8.67
              ],
              [
                0.49,
                7.71
              ],
              [
                0.49,
                7.71
              ],
              [
                1.17,
                6.55
              ],
              [
                3.32,
                5.98
              ],
              [
                3.32,
                5.98
              ],
              [
                3.24,
                5.42
              ],
              [
                2.95,
                4.99
              ],
              [
                2.37,
                4.82
              ],
              [
                2.37,
                4.82
              ],
              [
                1.62,
                4.98
              ],
              [
                1,
                5.32
              ],
              [
                1,
                5.32
              ],
              [
                0.69,
                4.78
              ],
              [
                1.48,
                4.37
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.73,
                4.7
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                8.9
              ],
              [
                3.46,
                8.9
              ],
              [
                3.39,
                8.35
              ],
              [
                3.37,
                8.35
              ],
              [
                2.66,
                8.82
              ],
              [
                1.84,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.26,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.45,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.05,
                -0.18
              ],
              [
                -0.14,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.14
              ],
              [
                0.31,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.56,
                0
              ],
              [
                0.25,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.26,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.11
              ],
              [
                -0.22,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.19
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.23,
                0
              ]
            ],
            v: [
              [
                2.07,
                8.39
              ],
              [
                2.07,
                8.39
              ],
              [
                2.69,
                8.23
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                6.49
              ],
              [
                1.71,
                6.92
              ],
              [
                1.25,
                7.65
              ],
              [
                1.25,
                7.65
              ],
              [
                1.49,
                8.21
              ],
              [
                2.07,
                8.39
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.2,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.76,
                0.09
              ],
              [
                -0.31,
                0.19
              ],
              [
                0,
                0
              ],
              [
                0,
                0.26
              ],
              [
                0.16,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 956,
    ty: 3,
    parent: 951,
    ks: {
      p: {
        a: 0,
        k: [
          18.827,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 959,
    ty: 4,
    parent: 958,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                4.3
              ],
              [
                1.4,
                4.3
              ],
              [
                1.5,
                5
              ],
              [
                1.5,
                5
              ],
              [
                2.2,
                4.4
              ],
              [
                2.9,
                4.2
              ],
              [
                2.9,
                4.2
              ],
              [
                3.8,
                4.4
              ],
              [
                4.2,
                5.1
              ],
              [
                4.2,
                5.1
              ],
              [
                4.9,
                4.4
              ],
              [
                5.7,
                4.2
              ],
              [
                5.7,
                4.2
              ],
              [
                6.8,
                4.6
              ],
              [
                7.1,
                6
              ],
              [
                7.1,
                6
              ],
              [
                7.1,
                8.9
              ],
              [
                6.4,
                8.9
              ],
              [
                6.4,
                6.1
              ],
              [
                6.2,
                5.1
              ],
              [
                5.5,
                4.9
              ],
              [
                5.5,
                4.9
              ],
              [
                4.4,
                5.6
              ],
              [
                4.4,
                5.6
              ],
              [
                4.4,
                8.9
              ],
              [
                3.6,
                8.9
              ],
              [
                3.6,
                6.1
              ],
              [
                3.4,
                5.1
              ],
              [
                2.7,
                4.9
              ],
              [
                2.7,
                4.9
              ],
              [
                1.6,
                5.6
              ],
              [
                1.6,
                5.6
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 958,
    ty: 3,
    parent: 951,
    ks: {
      p: {
        a: 0,
        k: [
          10.968,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 961,
    ty: 4,
    parent: 960,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.33,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.33,
                0.19
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                -0.52
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.19
              ],
              [
                0.38,
                0
              ]
            ],
            v: [
              [
                2.57,
                9.02
              ],
              [
                2.57,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.73,
                7.91
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.29
              ],
              [
                1.52,
                4.46
              ],
              [
                2.57,
                4.18
              ],
              [
                2.57,
                4.18
              ],
              [
                3.62,
                4.46
              ],
              [
                4.4,
                5.29
              ],
              [
                4.7,
                6.61
              ],
              [
                4.7,
                6.61
              ],
              [
                4.4,
                7.91
              ],
              [
                3.62,
                8.73
              ],
              [
                2.57,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.37,
                0
              ],
              [
                -0.33,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.52
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.33,
                -0.19
              ],
              [
                0,
                0
              ],
              [
                0.38,
                0
              ],
              [
                0.32,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                0.51
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.19
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                0.33
              ],
              [
                0,
                0.52
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.33
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.33
              ],
              [
                0,
                -0.53
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.33
              ],
              [
                -0.39,
                0
              ]
            ],
            v: [
              [
                2.57,
                8.37
              ],
              [
                2.57,
                8.37
              ],
              [
                3.53,
                7.88
              ],
              [
                3.9,
                6.61
              ],
              [
                3.9,
                6.61
              ],
              [
                3.53,
                5.32
              ],
              [
                2.57,
                4.82
              ],
              [
                2.57,
                4.82
              ],
              [
                1.61,
                5.32
              ],
              [
                1.24,
                6.61
              ],
              [
                1.24,
                6.61
              ],
              [
                1.61,
                7.88
              ],
              [
                2.57,
                8.37
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.24,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.53
              ],
              [
                -0.24,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.25,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.52
              ],
              [
                0.25,
                0.33
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 960,
    ty: 3,
    parent: 951,
    ks: {
      p: {
        a: 0,
        k: [
          5.83,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 963,
    ty: 4,
    parent: 962,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.5,
                -0.5
              ],
              [
                0,
                -1
              ],
              [
                0,
                0
              ],
              [
                0.5,
                -0.5
              ],
              [
                0.9,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                2.7
              ],
              [
                2.4,
                2.7
              ],
              [
                4.6,
                3.5
              ],
              [
                5.3,
                5.8
              ],
              [
                5.3,
                5.8
              ],
              [
                4.6,
                8.1
              ],
              [
                2.4,
                8.9
              ],
              [
                2.4,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                1,
                0
              ],
              [
                0.5,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                1
              ],
              [
                -0.5,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.4
              ],
              [
                0,
                0.8
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0.7,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                3.3
              ],
              [
                1.6,
                8.3
              ],
              [
                2.4,
                8.3
              ],
              [
                4,
                7.6
              ],
              [
                4.5,
                5.8
              ],
              [
                4.5,
                5.8
              ],
              [
                4,
                4
              ],
              [
                2.4,
                3.3
              ],
              [
                2.4,
                3.3
              ],
              [
                1.6,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.8
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 962,
    ty: 3,
    parent: 951,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 951,
    ty: 3,
    parent: 922,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 922,
    ty: 3,
    parent: 921,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.469
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 921,
    ty: 3,
    parent: 920,
    ks: {
      p: {
        a: 0,
        k: [
          16.255,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 973,
    ty: 0,
    parent: 964,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.582
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    w: 10.837,
    h: 10.837,
    ip: 0,
    op: 565,
    st: 0,
    refId: "971"
  },
  {
    ind: 964,
    ty: 3,
    parent: 920,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 920,
    ty: 3,
    parent: 893,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 893,
    ty: 3,
    parent: 892,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          27.418
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 979,
    ty: 4,
    parent: 978,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                9.2
              ],
              [
                2,
                9.2
              ],
              [
                2.1,
                10
              ],
              [
                2.2,
                10
              ],
              [
                3.1,
                9.3
              ],
              [
                4.2,
                9
              ],
              [
                4.2,
                9
              ],
              [
                5.6,
                9.7
              ],
              [
                6,
                11.4
              ],
              [
                6,
                11.4
              ],
              [
                6,
                15.2
              ],
              [
                4.6,
                15.2
              ],
              [
                4.6,
                11.6
              ],
              [
                4.4,
                10.6
              ],
              [
                3.7,
                10.2
              ],
              [
                3.7,
                10.2
              ],
              [
                3,
                10.4
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 978,
    ty: 3,
    parent: 977,
    ks: {
      p: {
        a: 0,
        k: [
          34.851,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 981,
    ty: 4,
    parent: 980,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                9.2
              ],
              [
                2.3,
                9.2
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.1
              ],
              [
                1.6,
                8.1
              ],
              [
                1,
                7.9
              ],
              [
                0.8,
                7.3
              ],
              [
                0.8,
                7.3
              ],
              [
                1,
                6.8
              ],
              [
                1.6,
                6.5
              ],
              [
                1.6,
                6.5
              ],
              [
                2.2,
                6.8
              ],
              [
                2.4,
                7.3
              ],
              [
                2.4,
                7.3
              ],
              [
                2.2,
                7.9
              ],
              [
                1.6,
                8.1
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 980,
    ty: 3,
    parent: 977,
    ks: {
      p: {
        a: 0,
        k: [
          31.657,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 983,
    ty: 4,
    parent: 982,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.6,
                0.4
              ],
              [
                -1.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.3
              ],
              [
                2.3,
                15.3
              ],
              [
                1.1,
                14.8
              ],
              [
                0.6,
                13.6
              ],
              [
                0.6,
                13.6
              ],
              [
                1.4,
                12.1
              ],
              [
                4.1,
                11.3
              ],
              [
                4.1,
                11.3
              ],
              [
                3.8,
                10.5
              ],
              [
                3,
                10.2
              ],
              [
                3,
                10.2
              ],
              [
                2.1,
                10.3
              ],
              [
                1.3,
                10.8
              ],
              [
                1.3,
                10.8
              ],
              [
                0.8,
                9.8
              ],
              [
                1.9,
                9.3
              ],
              [
                3.3,
                9
              ],
              [
                3.3,
                9
              ],
              [
                4.9,
                9.7
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                15.2
              ],
              [
                4.3,
                15.2
              ],
              [
                4.2,
                14.5
              ],
              [
                4.2,
                14.5
              ],
              [
                3.3,
                15.1
              ],
              [
                2.3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.6,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.8,
                14.2
              ],
              [
                2.8,
                14.2
              ],
              [
                3.5,
                14
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                12.2
              ],
              [
                2.4,
                12.7
              ],
              [
                1.9,
                13.5
              ],
              [
                1.9,
                13.5
              ],
              [
                2.2,
                14
              ],
              [
                2.8,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.8,
                0.1
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 982,
    ty: 3,
    parent: 977,
    ks: {
      p: {
        a: 0,
        k: [
          25.367,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 985,
    ty: 4,
    parent: 984,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.3
              ],
              [
                -0.7,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.4
              ],
              [
                0.8,
                0
              ]
            ],
            v: [
              [
                2.6,
                15.3
              ],
              [
                2.6,
                15.3
              ],
              [
                1.3,
                15.1
              ],
              [
                0.3,
                14.5
              ],
              [
                0.3,
                14.5
              ],
              [
                1,
                13.6
              ],
              [
                1.8,
                14.1
              ],
              [
                2.6,
                14.3
              ],
              [
                2.6,
                14.3
              ],
              [
                3.3,
                14
              ],
              [
                3.6,
                13.5
              ],
              [
                3.6,
                13.5
              ],
              [
                3.4,
                13.1
              ],
              [
                2.9,
                12.8
              ],
              [
                2.3,
                12.6
              ],
              [
                2.3,
                12.6
              ],
              [
                1.5,
                12.2
              ],
              [
                0.9,
                11.7
              ],
              [
                0.6,
                10.8
              ],
              [
                0.6,
                10.8
              ],
              [
                1.2,
                9.5
              ],
              [
                2.8,
                9
              ],
              [
                2.8,
                9
              ],
              [
                3.9,
                9.3
              ],
              [
                4.8,
                9.8
              ],
              [
                4.8,
                9.8
              ],
              [
                4.2,
                10.6
              ],
              [
                3.5,
                10.2
              ],
              [
                2.8,
                10.1
              ],
              [
                2.8,
                10.1
              ],
              [
                2.2,
                10.3
              ],
              [
                2,
                10.8
              ],
              [
                2,
                10.8
              ],
              [
                2.3,
                11.3
              ],
              [
                3.2,
                11.6
              ],
              [
                3.2,
                11.6
              ],
              [
                4,
                12
              ],
              [
                4.6,
                12.6
              ],
              [
                4.9,
                13.5
              ],
              [
                4.9,
                13.5
              ],
              [
                4.3,
                14.8
              ],
              [
                2.6,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.4,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                -0.4,
                0.4
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 984,
    ty: 3,
    parent: 977,
    ks: {
      p: {
        a: 0,
        k: [
          20.113,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 987,
    ty: 4,
    parent: 986,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.3
              ],
              [
                -0.7,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.4
              ],
              [
                0.8,
                0
              ]
            ],
            v: [
              [
                2.6,
                15.3
              ],
              [
                2.6,
                15.3
              ],
              [
                1.3,
                15.1
              ],
              [
                0.3,
                14.5
              ],
              [
                0.3,
                14.5
              ],
              [
                1,
                13.6
              ],
              [
                1.8,
                14.1
              ],
              [
                2.6,
                14.3
              ],
              [
                2.6,
                14.3
              ],
              [
                3.3,
                14
              ],
              [
                3.6,
                13.5
              ],
              [
                3.6,
                13.5
              ],
              [
                3.4,
                13.1
              ],
              [
                2.9,
                12.8
              ],
              [
                2.3,
                12.6
              ],
              [
                2.3,
                12.6
              ],
              [
                1.5,
                12.2
              ],
              [
                0.9,
                11.7
              ],
              [
                0.6,
                10.8
              ],
              [
                0.6,
                10.8
              ],
              [
                1.2,
                9.5
              ],
              [
                2.8,
                9
              ],
              [
                2.8,
                9
              ],
              [
                3.9,
                9.3
              ],
              [
                4.8,
                9.8
              ],
              [
                4.8,
                9.8
              ],
              [
                4.2,
                10.6
              ],
              [
                3.5,
                10.2
              ],
              [
                2.8,
                10.1
              ],
              [
                2.8,
                10.1
              ],
              [
                2.2,
                10.3
              ],
              [
                2,
                10.8
              ],
              [
                2,
                10.8
              ],
              [
                2.3,
                11.3
              ],
              [
                3.2,
                11.6
              ],
              [
                3.2,
                11.6
              ],
              [
                4,
                12
              ],
              [
                4.6,
                12.6
              ],
              [
                4.9,
                13.5
              ],
              [
                4.9,
                13.5
              ],
              [
                4.3,
                14.8
              ],
              [
                2.6,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.4,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                -0.4,
                0.4
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 986,
    ty: 3,
    parent: 977,
    ks: {
      p: {
        a: 0,
        k: [
          14.86,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 989,
    ty: 4,
    parent: 988,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.7,
                15.3
              ],
              [
                2.7,
                15.3
              ],
              [
                1.3,
                14.7
              ],
              [
                0.8,
                12.9
              ],
              [
                0.8,
                12.9
              ],
              [
                0.8,
                9.2
              ],
              [
                2.2,
                9.2
              ],
              [
                2.2,
                12.8
              ],
              [
                2.5,
                13.8
              ],
              [
                3.2,
                14.1
              ],
              [
                3.2,
                14.1
              ],
              [
                3.8,
                13.9
              ],
              [
                4.5,
                13.3
              ],
              [
                4.5,
                13.3
              ],
              [
                4.5,
                9.2
              ],
              [
                5.9,
                9.2
              ],
              [
                5.9,
                15.2
              ],
              [
                4.7,
                15.2
              ],
              [
                4.6,
                14.3
              ],
              [
                4.6,
                14.3
              ],
              [
                3.7,
                15
              ],
              [
                2.7,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 988,
    ty: 3,
    parent: 977,
    ks: {
      p: {
        a: 0,
        k: [
          8.082,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 991,
    ty: 4,
    parent: 990,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                15.2
              ],
              [
                1,
                15.2
              ],
              [
                1,
                7.2
              ],
              [
                2.4,
                7.2
              ],
              [
                2.4,
                10.4
              ],
              [
                5.7,
                10.4
              ],
              [
                5.7,
                7.2
              ],
              [
                7.1,
                7.2
              ],
              [
                7.1,
                15.2
              ],
              [
                5.7,
                15.2
              ],
              [
                5.7,
                11.6
              ],
              [
                2.4,
                11.6
              ],
              [
                2.4,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 990,
    ty: 3,
    parent: 977,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 977,
    ty: 3,
    parent: 976,
    ks: {
      p: {
        a: 0,
        k: [
          67.411,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 994,
    ty: 4,
    parent: 993,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.6
              ],
              [
                0,
                -0.9
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.5
              ],
              [
                0.4,
                -0.3
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                3.8,
                15.3
              ],
              [
                3.8,
                15.3
              ],
              [
                2.2,
                14.5
              ],
              [
                2.2,
                14.5
              ],
              [
                2.1,
                14.5
              ],
              [
                2,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                6.6
              ],
              [
                2.3,
                6.6
              ],
              [
                2.3,
                8.8
              ],
              [
                2.3,
                9.8
              ],
              [
                3.1,
                9.2
              ],
              [
                4,
                9
              ],
              [
                4,
                9
              ],
              [
                5.7,
                9.9
              ],
              [
                6.4,
                12.1
              ],
              [
                6.4,
                12.1
              ],
              [
                6,
                13.8
              ],
              [
                5,
                14.9
              ],
              [
                3.8,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                0.7
              ],
              [
                -0.2,
                0.5
              ],
              [
                -0.4,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0.7
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                3.5,
                14.2
              ],
              [
                3.5,
                14.2
              ],
              [
                4.5,
                13.6
              ],
              [
                4.9,
                12.1
              ],
              [
                4.9,
                12.1
              ],
              [
                4.6,
                10.7
              ],
              [
                3.6,
                10.2
              ],
              [
                3.6,
                10.2
              ],
              [
                2.3,
                10.9
              ],
              [
                2.3,
                10.9
              ],
              [
                2.3,
                13.7
              ],
              [
                2.9,
                14
              ],
              [
                3.5,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 993,
    ty: 3,
    parent: 992,
    ks: {
      p: {
        a: 0,
        k: [
          29.939,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 996,
    ty: 4,
    parent: 995,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                9.2
              ],
              [
                2.3,
                9.2
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.1
              ],
              [
                1.6,
                8.1
              ],
              [
                1,
                7.9
              ],
              [
                0.8,
                7.3
              ],
              [
                0.8,
                7.3
              ],
              [
                1,
                6.8
              ],
              [
                1.6,
                6.5
              ],
              [
                1.6,
                6.5
              ],
              [
                2.2,
                6.8
              ],
              [
                2.4,
                7.3
              ],
              [
                2.4,
                7.3
              ],
              [
                2.2,
                7.9
              ],
              [
                1.6,
                8.1
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 995,
    ty: 3,
    parent: 992,
    ks: {
      p: {
        a: 0,
        k: [
          26.745,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 998,
    ty: 4,
    parent: 997,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.7,
                15.3
              ],
              [
                2.7,
                15.3
              ],
              [
                1.3,
                14.7
              ],
              [
                0.8,
                12.9
              ],
              [
                0.8,
                12.9
              ],
              [
                0.8,
                9.2
              ],
              [
                2.2,
                9.2
              ],
              [
                2.2,
                12.8
              ],
              [
                2.5,
                13.8
              ],
              [
                3.2,
                14.1
              ],
              [
                3.2,
                14.1
              ],
              [
                3.8,
                13.9
              ],
              [
                4.5,
                13.3
              ],
              [
                4.5,
                13.3
              ],
              [
                4.5,
                9.2
              ],
              [
                5.9,
                9.2
              ],
              [
                5.9,
                15.2
              ],
              [
                4.7,
                15.2
              ],
              [
                4.6,
                14.3
              ],
              [
                4.6,
                14.3
              ],
              [
                3.7,
                15
              ],
              [
                2.7,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 997,
    ty: 3,
    parent: 992,
    ks: {
      p: {
        a: 0,
        k: [
          19.967,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1e3,
    ty: 4,
    parent: 999,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.6
              ],
              [
                0,
                1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.5
              ],
              [
                -0.4,
                0.3
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                6,
                17.5
              ],
              [
                4.6,
                17.5
              ],
              [
                4.6,
                15.6
              ],
              [
                4.6,
                14.6
              ],
              [
                3.9,
                15.1
              ],
              [
                3,
                15.3
              ],
              [
                3,
                15.3
              ],
              [
                1.2,
                14.5
              ],
              [
                0.5,
                12.2
              ],
              [
                0.5,
                12.2
              ],
              [
                0.9,
                10.5
              ],
              [
                1.8,
                9.4
              ],
              [
                3.1,
                9
              ],
              [
                3.1,
                9
              ],
              [
                4,
                9.2
              ],
              [
                4.7,
                9.8
              ],
              [
                4.7,
                9.8
              ],
              [
                4.8,
                9.8
              ],
              [
                4.9,
                9.2
              ],
              [
                6,
                9.2
              ],
              [
                6,
                17.5
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                -0.7,
                0
              ],
              [
                -0.4,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.7
              ],
              [
                0.2,
                -0.5
              ],
              [
                0.4,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                -0.4,
                0
              ]
            ],
            v: [
              [
                3.3,
                14.2
              ],
              [
                3.3,
                14.2
              ],
              [
                4.6,
                13.5
              ],
              [
                4.6,
                13.5
              ],
              [
                4.6,
                10.7
              ],
              [
                4,
                10.3
              ],
              [
                3.4,
                10.2
              ],
              [
                3.4,
                10.2
              ],
              [
                2.4,
                10.7
              ],
              [
                2,
                12.2
              ],
              [
                2,
                12.2
              ],
              [
                2.3,
                13.6
              ],
              [
                3.3,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 999,
    ty: 3,
    parent: 992,
    ks: {
      p: {
        a: 0,
        k: [
          13.092,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1002,
    ty: 4,
    parent: 1001,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.6,
                0.4
              ],
              [
                -1.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.3
              ],
              [
                2.3,
                15.3
              ],
              [
                1.1,
                14.8
              ],
              [
                0.6,
                13.6
              ],
              [
                0.6,
                13.6
              ],
              [
                1.4,
                12.1
              ],
              [
                4.1,
                11.3
              ],
              [
                4.1,
                11.3
              ],
              [
                3.8,
                10.5
              ],
              [
                3,
                10.2
              ],
              [
                3,
                10.2
              ],
              [
                2.1,
                10.3
              ],
              [
                1.3,
                10.8
              ],
              [
                1.3,
                10.8
              ],
              [
                0.8,
                9.8
              ],
              [
                1.9,
                9.3
              ],
              [
                3.3,
                9
              ],
              [
                3.3,
                9
              ],
              [
                4.9,
                9.7
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                15.2
              ],
              [
                4.3,
                15.2
              ],
              [
                4.2,
                14.5
              ],
              [
                4.2,
                14.5
              ],
              [
                3.3,
                15.1
              ],
              [
                2.3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.6,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.8,
                14.2
              ],
              [
                2.8,
                14.2
              ],
              [
                3.5,
                14
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                12.2
              ],
              [
                2.4,
                12.7
              ],
              [
                1.9,
                13.5
              ],
              [
                1.9,
                13.5
              ],
              [
                2.2,
                14
              ],
              [
                2.8,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.8,
                0.1
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1001,
    ty: 3,
    parent: 992,
    ks: {
      p: {
        a: 0,
        k: [
          6.802,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1004,
    ty: 4,
    parent: 1003,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.4
              ],
              [
                0.1,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.4
              ],
              [
                0.1,
                -0.4
              ]
            ],
            v: [
              [
                2.6,
                10.9
              ],
              [
                2.6,
                10.9
              ],
              [
                2.4,
                11.9
              ],
              [
                4.4,
                11.9
              ],
              [
                4.1,
                10.9
              ],
              [
                3.7,
                9.6
              ],
              [
                3.4,
                8.3
              ],
              [
                3.4,
                8.3
              ],
              [
                3.4,
                8.3
              ],
              [
                3,
                9.6
              ],
              [
                2.6,
                10.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.4
              ],
              [
                -0.1,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.4
              ],
              [
                -0.1,
                0.4
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.4,
                15.2
              ],
              [
                0,
                15.2
              ],
              [
                2.6,
                7.2
              ],
              [
                4.2,
                7.2
              ],
              [
                6.8,
                15.2
              ],
              [
                5.3,
                15.2
              ],
              [
                4.7,
                13
              ],
              [
                2,
                13
              ],
              [
                1.4,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1003,
    ty: 3,
    parent: 992,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 992,
    ty: 3,
    parent: 976,
    ks: {
      p: {
        a: 0,
        k: [
          28.171,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1007,
    ty: 4,
    parent: 1006,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.6
              ],
              [
                0,
                1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.5
              ],
              [
                -0.4,
                0.3
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                3,
                15.3
              ],
              [
                3,
                15.3
              ],
              [
                1.2,
                14.5
              ],
              [
                0.5,
                12.2
              ],
              [
                0.5,
                12.2
              ],
              [
                0.9,
                10.5
              ],
              [
                1.8,
                9.4
              ],
              [
                3.1,
                9
              ],
              [
                3.1,
                9
              ],
              [
                3.9,
                9.2
              ],
              [
                4.6,
                9.7
              ],
              [
                4.6,
                9.7
              ],
              [
                4.6,
                8.7
              ],
              [
                4.6,
                6.6
              ],
              [
                6,
                6.6
              ],
              [
                6,
                15.2
              ],
              [
                4.8,
                15.2
              ],
              [
                4.7,
                14.5
              ],
              [
                4.7,
                14.5
              ],
              [
                3.9,
                15.1
              ],
              [
                3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.7,
                0
              ],
              [
                -0.4,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.7
              ],
              [
                0.2,
                -0.5
              ],
              [
                0.4,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                -0.4,
                0
              ]
            ],
            v: [
              [
                3.3,
                14.2
              ],
              [
                3.3,
                14.2
              ],
              [
                4.6,
                13.5
              ],
              [
                4.6,
                13.5
              ],
              [
                4.6,
                10.7
              ],
              [
                4,
                10.3
              ],
              [
                3.4,
                10.2
              ],
              [
                3.4,
                10.2
              ],
              [
                2.4,
                10.7
              ],
              [
                2,
                12.2
              ],
              [
                2,
                12.2
              ],
              [
                2.3,
                13.6
              ],
              [
                3.3,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1006,
    ty: 3,
    parent: 1005,
    ks: {
      p: {
        a: 0,
        k: [
          18.858,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1009,
    ty: 4,
    parent: 1008,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.5
              ],
              [
                0,
                0.7
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.5
              ],
              [
                -0.4,
                0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.2,
                -0.4
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                3.5,
                15.3
              ],
              [
                3.5,
                15.3
              ],
              [
                2,
                14.9
              ],
              [
                0.9,
                13.9
              ],
              [
                0.5,
                12.2
              ],
              [
                0.5,
                12.2
              ],
              [
                0.9,
                10.5
              ],
              [
                1.9,
                9.4
              ],
              [
                3.3,
                9
              ],
              [
                3.3,
                9
              ],
              [
                4.6,
                9.4
              ],
              [
                5.4,
                10.4
              ],
              [
                5.7,
                11.9
              ],
              [
                5.7,
                11.9
              ],
              [
                5.7,
                12.6
              ],
              [
                5.7,
                12.6
              ],
              [
                1.9,
                12.6
              ],
              [
                2.4,
                13.8
              ],
              [
                3.6,
                14.2
              ],
              [
                3.6,
                14.2
              ],
              [
                4.4,
                14.1
              ],
              [
                5,
                13.8
              ],
              [
                5,
                13.8
              ],
              [
                5.5,
                14.7
              ],
              [
                4.5,
                15.1
              ],
              [
                3.5,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.3,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.7
              ],
              [
                0.3,
                -0.5
              ],
              [
                0.4,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.5
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.1,
                -0.5
              ]
            ],
            v: [
              [
                1.9,
                11.6
              ],
              [
                1.9,
                11.6
              ],
              [
                4.5,
                11.6
              ],
              [
                4.2,
                10.5
              ],
              [
                3.3,
                10.1
              ],
              [
                3.3,
                10.1
              ],
              [
                2.4,
                10.5
              ],
              [
                1.9,
                11.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1008,
    ty: 3,
    parent: 1005,
    ks: {
      p: {
        a: 0,
        k: [
          12.678,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1011,
    ty: 4,
    parent: 1010,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.3
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.4
              ],
              [
                0.7,
                0
              ]
            ],
            v: [
              [
                1.3,
                17.6
              ],
              [
                1.3,
                17.6
              ],
              [
                0.9,
                17.6
              ],
              [
                0.5,
                17.5
              ],
              [
                0.5,
                17.5
              ],
              [
                0.8,
                16.4
              ],
              [
                1,
                16.5
              ],
              [
                1.2,
                16.5
              ],
              [
                1.2,
                16.5
              ],
              [
                2,
                16.2
              ],
              [
                2.4,
                15.5
              ],
              [
                2.4,
                15.5
              ],
              [
                2.5,
                15.1
              ],
              [
                0.1,
                9.2
              ],
              [
                1.6,
                9.2
              ],
              [
                2.6,
                12.1
              ],
              [
                2.9,
                12.9
              ],
              [
                3.1,
                13.8
              ],
              [
                3.1,
                13.8
              ],
              [
                3.2,
                13.8
              ],
              [
                3.4,
                13
              ],
              [
                3.6,
                12.1
              ],
              [
                3.6,
                12.1
              ],
              [
                4.5,
                9.2
              ],
              [
                5.9,
                9.2
              ],
              [
                3.7,
                15.4
              ],
              [
                2.8,
                17
              ],
              [
                1.3,
                17.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.3
              ],
              [
                0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.3
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.7
              ],
              [
                -0.4,
                0.4
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1010,
    ty: 3,
    parent: 1005,
    ks: {
      p: {
        a: 0,
        k: [
          6.644,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1013,
    ty: 4,
    parent: 1012,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0.2
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.4,
                -0.2
              ],
              [
                0.6,
                0
              ]
            ],
            v: [
              [
                3.3,
                15.3
              ],
              [
                3.3,
                15.3
              ],
              [
                1.8,
                15
              ],
              [
                0.5,
                14.1
              ],
              [
                0.5,
                14.1
              ],
              [
                1.3,
                13.2
              ],
              [
                2.3,
                13.8
              ],
              [
                3.4,
                14.1
              ],
              [
                3.4,
                14.1
              ],
              [
                4.4,
                13.8
              ],
              [
                4.8,
                13.1
              ],
              [
                4.8,
                13.1
              ],
              [
                4.4,
                12.3
              ],
              [
                3.5,
                11.9
              ],
              [
                3.5,
                11.9
              ],
              [
                2.4,
                11.4
              ],
              [
                1.7,
                11
              ],
              [
                1.1,
                10.3
              ],
              [
                0.8,
                9.3
              ],
              [
                0.8,
                9.3
              ],
              [
                1.2,
                8.2
              ],
              [
                2.1,
                7.4
              ],
              [
                3.5,
                7.1
              ],
              [
                3.5,
                7.1
              ],
              [
                4.8,
                7.3
              ],
              [
                5.9,
                8.1
              ],
              [
                5.9,
                8.1
              ],
              [
                5.2,
                9
              ],
              [
                4.4,
                8.5
              ],
              [
                3.5,
                8.3
              ],
              [
                3.5,
                8.3
              ],
              [
                2.6,
                8.5
              ],
              [
                2.2,
                9.2
              ],
              [
                2.2,
                9.2
              ],
              [
                2.4,
                9.7
              ],
              [
                2.9,
                10.1
              ],
              [
                3.5,
                10.3
              ],
              [
                3.5,
                10.3
              ],
              [
                4.6,
                10.8
              ],
              [
                5.8,
                11.6
              ],
              [
                6.2,
                13
              ],
              [
                6.2,
                13
              ],
              [
                5.9,
                14.1
              ],
              [
                4.9,
                15
              ],
              [
                3.3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.5,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                -0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.4,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1012,
    ty: 3,
    parent: 1005,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1005,
    ty: 3,
    parent: 976,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 976,
    ty: 3,
    parent: 975,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.163
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 975,
    ty: 3,
    parent: 974,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 974,
    ty: 3,
    parent: 892,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 892,
    ty: 3,
    parent: 891,
    ks: {
      p: {
        a: 0,
        k: [
          70.439,
          2.737
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1024,
    ty: 0,
    parent: 1015,
    ks: {
      a: {
        a: 0,
        k: [
          41.996,
          42.67
        ]
      },
      p: {
        a: 0,
        k: [
          41.996,
          42.67
        ]
      }
    },
    w: 16.255,
    h: 16.255,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1022"
  },
  {
    ind: 1015,
    ty: 3,
    parent: 1014,
    ks: {
      p: {
        a: 0,
        k: [
          41.996,
          42.67
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1027,
    ty: 4,
    td: 1,
    parent: 1025,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            29.801,
            29.801
          ]
        },
        r: {
          a: 0,
          k: 46
        },
        s: {
          a: 0,
          k: [
            59.602,
            59.602
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0,
            0,
            0
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1026,
    ty: 4,
    tt: 1,
    parent: 1025,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                29.801,
                29.801
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                62.989,
                62.989
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ty: "gr",
        it: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                29.801,
                29.801
              ]
            },
            r: {
              a: 0,
              k: 46
            },
            s: {
              a: 0,
              k: [
                59.602,
                59.602
              ]
            }
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.427,
                0.184,
                0.604
              ]
            },
            lj: 1,
            ml: 10,
            o: {
              a: 0,
              k: 100
            },
            w: {
              a: 0,
              k: 3.387
            }
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      }
    ]
  },
  {
    ind: 1043,
    ty: 4,
    td: 1,
    parent: 1025,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            29.801,
            29.801
          ]
        },
        r: {
          a: 0,
          k: 46
        },
        s: {
          a: 0,
          k: [
            59.602,
            59.602
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0,
            0,
            0
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1042,
    ty: 0,
    tt: 1,
    parent: 1025,
    ks: {},
    w: 55,
    h: 55,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1040"
  },
  {
    ind: 1025,
    ty: 3,
    parent: 1014,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1014,
    ty: 3,
    parent: 891,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 891,
    ty: 3,
    parent: 690,
    ks: {
      p: {
        a: 0,
        k: [
          8.128,
          8.128
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1044,
    ty: 4,
    parent: 690,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            113.787,
            70.005
          ]
        },
        r: {
          a: 0,
          k: 5
        },
        s: {
          a: 0,
          k: [
            227.573,
            140.01
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            1,
            1,
            1
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 690,
    ty: 3,
    parent: 16,
    ks: {
      a: {
        a: 0,
        k: [
          113.787,
          70.005
        ]
      },
      p: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              -88.546,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 132,
            s: [
              179.454,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 276,
            s: [
              447.454,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 420,
            s: [
              715.454,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              983.454,
              92.212
            ],
            h: 1
          }
        ]
      },
      s: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              100,
              100
            ],
            i: {
              x: [
                0,
                0
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.5,
                0.5
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 132,
            s: [
              107,
              107
            ],
            i: {
              x: [
                0.2,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 276,
            s: [
              93,
              93
            ],
            i: {
              x: [
                1,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              93,
              93
            ],
            h: 1
          }
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1054,
    ty: 4,
    parent: 1053,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1053,
    ty: 3,
    parent: 1052,
    ks: {
      p: {
        a: 0,
        k: [
          21.813,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1056,
    ty: 4,
    parent: 1055,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1055,
    ty: 3,
    parent: 1052,
    ks: {
      p: {
        a: 0,
        k: [
          17.007,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1058,
    ty: 4,
    parent: 1057,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.8,
                9
              ],
              [
                1.8,
                9
              ],
              [
                0.9,
                8.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                7.8
              ],
              [
                1.9,
                8
              ],
              [
                2,
                8.1
              ],
              [
                2,
                8.1
              ],
              [
                2.1,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.3,
                8.9
              ],
              [
                2.1,
                9
              ],
              [
                1.8,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1057,
    ty: 3,
    parent: 1052,
    ks: {
      p: {
        a: 0,
        k: [
          14.438,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1060,
    ty: 4,
    parent: 1059,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1059,
    ty: 3,
    parent: 1052,
    ks: {
      p: {
        a: 0,
        k: [
          9.546,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1062,
    ty: 4,
    parent: 1061,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.36
              ],
              [
                -0.36,
                0.19
              ],
              [
                -0.41,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.1
              ],
              [
                -0.17,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.13,
                0.06
              ],
              [
                0.15,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.28
              ],
              [
                0,
                -0.47
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                -0.28
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                0.08
              ],
              [
                -0.13,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.27,
                0
              ]
            ],
            v: [
              [
                2.64,
                9.02
              ],
              [
                2.64,
                9.02
              ],
              [
                1.49,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.71,
                5.26
              ],
              [
                1.57,
                4.42
              ],
              [
                2.72,
                4.13
              ],
              [
                2.72,
                4.13
              ],
              [
                3.5,
                4.28
              ],
              [
                4.09,
                4.65
              ],
              [
                4.09,
                4.65
              ],
              [
                3.56,
                5.37
              ],
              [
                3.19,
                5.11
              ],
              [
                2.78,
                5.02
              ],
              [
                2.78,
                5.02
              ],
              [
                1.86,
                5.45
              ],
              [
                1.51,
                6.58
              ],
              [
                1.51,
                6.58
              ],
              [
                1.85,
                7.7
              ],
              [
                2.75,
                8.12
              ],
              [
                2.75,
                8.12
              ],
              [
                3.27,
                8.01
              ],
              [
                3.71,
                7.73
              ],
              [
                3.71,
                7.73
              ],
              [
                4.15,
                8.45
              ],
              [
                3.43,
                8.87
              ],
              [
                2.64,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.42,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.52
              ],
              [
                0.21,
                -0.36
              ],
              [
                0.36,
                -0.19
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.22,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                -0.11
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                -0.37,
                0
              ],
              [
                -0.24,
                0.28
              ],
              [
                0,
                0
              ],
              [
                0,
                0.46
              ],
              [
                0.23,
                0.28
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0.16,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.19
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1061,
    ty: 3,
    parent: 1052,
    ks: {
      p: {
        a: 0,
        k: [
          5.167,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1064,
    ty: 4,
    parent: 1063,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                1,
                7.4
              ],
              [
                1.8,
                7.9
              ],
              [
                2.6,
                8.1
              ],
              [
                2.6,
                8.1
              ],
              [
                3.4,
                7.8
              ],
              [
                3.7,
                7.3
              ],
              [
                3.7,
                7.3
              ],
              [
                3.4,
                6.7
              ],
              [
                2.7,
                6.4
              ],
              [
                2.7,
                6.4
              ],
              [
                1.9,
                6
              ],
              [
                1.3,
                5.6
              ],
              [
                0.8,
                5.1
              ],
              [
                0.6,
                4.3
              ],
              [
                0.6,
                4.3
              ],
              [
                0.9,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.8,
                2.8
              ],
              [
                4.6,
                3.4
              ],
              [
                4.6,
                3.4
              ],
              [
                4.1,
                4.1
              ],
              [
                3.4,
                3.7
              ],
              [
                2.7,
                3.5
              ],
              [
                2.7,
                3.5
              ],
              [
                2,
                3.7
              ],
              [
                1.7,
                4.3
              ],
              [
                1.7,
                4.3
              ],
              [
                1.9,
                4.7
              ],
              [
                2.2,
                4.9
              ],
              [
                2.7,
                5.1
              ],
              [
                2.7,
                5.1
              ],
              [
                3.6,
                5.5
              ],
              [
                4.5,
                6.1
              ],
              [
                4.8,
                7.2
              ],
              [
                4.8,
                7.2
              ],
              [
                4.6,
                8.1
              ],
              [
                3.8,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1063,
    ty: 3,
    parent: 1052,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1052,
    ty: 3,
    parent: 1051,
    ks: {
      p: {
        a: 0,
        k: [
          93.74,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1067,
    ty: 4,
    parent: 1066,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1066,
    ty: 3,
    parent: 1065,
    ks: {
      p: {
        a: 0,
        k: [
          15.786,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1069,
    ty: 4,
    parent: 1068,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1068,
    ty: 3,
    parent: 1065,
    ks: {
      p: {
        a: 0,
        k: [
          10.979,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1071,
    ty: 4,
    parent: 1070,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                5.1
              ],
              [
                0.3,
                5.1
              ],
              [
                0.3,
                4.3
              ],
              [
                0.9,
                4.2
              ],
              [
                0.9,
                3.8
              ],
              [
                1.2,
                2.6
              ],
              [
                2.4,
                2.1
              ],
              [
                2.4,
                2.1
              ],
              [
                2.9,
                2.1
              ],
              [
                3.3,
                2.3
              ],
              [
                3.3,
                2.3
              ],
              [
                3.1,
                3.1
              ],
              [
                2.6,
                3
              ],
              [
                2.6,
                3
              ],
              [
                2,
                3.7
              ],
              [
                2,
                3.7
              ],
              [
                2,
                4.2
              ],
              [
                2.9,
                4.2
              ],
              [
                2.9,
                5.1
              ],
              [
                2,
                5.1
              ],
              [
                2,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                5.3,
                9
              ],
              [
                5.3,
                9
              ],
              [
                4.2,
                8.5
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                5.1
              ],
              [
                3.2,
                5.1
              ],
              [
                3.2,
                4.3
              ],
              [
                3.9,
                4.2
              ],
              [
                4,
                3
              ],
              [
                5,
                3
              ],
              [
                5,
                4.2
              ],
              [
                6.1,
                4.2
              ],
              [
                6.1,
                5.1
              ],
              [
                5,
                5.1
              ],
              [
                5,
                7.3
              ],
              [
                5.6,
                8.1
              ],
              [
                5.6,
                8.1
              ],
              [
                5.9,
                8.1
              ],
              [
                6.1,
                8
              ],
              [
                6.1,
                8
              ],
              [
                6.3,
                8.8
              ],
              [
                5.9,
                9
              ],
              [
                5.3,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1070,
    ty: 3,
    parent: 1065,
    ks: {
      p: {
        a: 0,
        k: [
          4.892,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1073,
    ty: 4,
    parent: 1072,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1072,
    ty: 3,
    parent: 1065,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1065,
    ty: 3,
    parent: 1051,
    ks: {
      p: {
        a: 0,
        k: [
          72.522,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1076,
    ty: 4,
    parent: 1075,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1075,
    ty: 3,
    parent: 1074,
    ks: {
      p: {
        a: 0,
        k: [
          13.718,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1078,
    ty: 4,
    parent: 1077,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                8.9
              ],
              [
                0.7,
                8.9
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                6.4
              ],
              [
                1.8,
                6.4
              ],
              [
                3.5,
                4.2
              ],
              [
                4.7,
                4.2
              ],
              [
                3.1,
                6.1
              ],
              [
                4.9,
                8.9
              ],
              [
                3.7,
                8.9
              ],
              [
                2.5,
                6.9
              ],
              [
                1.8,
                7.7
              ],
              [
                1.8,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1077,
    ty: 3,
    parent: 1074,
    ks: {
      p: {
        a: 0,
        k: [
          8.769,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1080,
    ty: 4,
    parent: 1079,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                8.9
              ],
              [
                0.7,
                8.9
              ],
              [
                0.7,
                4.2
              ],
              [
                1.8,
                4.2
              ],
              [
                1.8,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.4
              ],
              [
                1.2,
                3.4
              ],
              [
                0.8,
                3.3
              ],
              [
                0.6,
                2.8
              ],
              [
                0.6,
                2.8
              ],
              [
                0.8,
                2.4
              ],
              [
                1.2,
                2.2
              ],
              [
                1.2,
                2.2
              ],
              [
                1.7,
                2.4
              ],
              [
                1.9,
                2.8
              ],
              [
                1.9,
                2.8
              ],
              [
                1.7,
                3.3
              ],
              [
                1.2,
                3.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1079,
    ty: 3,
    parent: 1074,
    ks: {
      p: {
        a: 0,
        k: [
          6.285,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1082,
    ty: 4,
    parent: 1081,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.9,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                2.7
              ],
              [
                1.9,
                2.7
              ],
              [
                1.9,
                5.2
              ],
              [
                4.4,
                5.2
              ],
              [
                4.4,
                2.7
              ],
              [
                5.5,
                2.7
              ],
              [
                5.5,
                8.9
              ],
              [
                4.4,
                8.9
              ],
              [
                4.4,
                6.2
              ],
              [
                1.9,
                6.2
              ],
              [
                1.9,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1081,
    ty: 3,
    parent: 1074,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1074,
    ty: 3,
    parent: 1051,
    ks: {
      p: {
        a: 0,
        k: [
          52.102,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1085,
    ty: 4,
    parent: 1084,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                1,
                10.8
              ],
              [
                1,
                10.8
              ],
              [
                0.7,
                10.8
              ],
              [
                0.4,
                10.7
              ],
              [
                0.4,
                10.7
              ],
              [
                0.6,
                9.9
              ],
              [
                0.8,
                9.9
              ],
              [
                0.9,
                9.9
              ],
              [
                0.9,
                9.9
              ],
              [
                1.5,
                9.7
              ],
              [
                1.9,
                9.1
              ],
              [
                1.9,
                9.1
              ],
              [
                1.9,
                8.8
              ],
              [
                0.1,
                4.2
              ],
              [
                1.2,
                4.2
              ],
              [
                2,
                6.5
              ],
              [
                2.2,
                7.2
              ],
              [
                2.4,
                7.8
              ],
              [
                2.4,
                7.8
              ],
              [
                2.5,
                7.8
              ],
              [
                2.7,
                7.2
              ],
              [
                2.8,
                6.5
              ],
              [
                2.8,
                6.5
              ],
              [
                3.5,
                4.2
              ],
              [
                4.6,
                4.2
              ],
              [
                2.9,
                9.1
              ],
              [
                2.2,
                10.4
              ],
              [
                1,
                10.8
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.5
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1084,
    ty: 3,
    parent: 1083,
    ks: {
      p: {
        a: 0,
        k: [
          21.055,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1087,
    ty: 4,
    parent: 1086,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1086,
    ty: 3,
    parent: 1083,
    ks: {
      p: {
        a: 0,
        k: [
          17.519,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1089,
    ty: 4,
    parent: 1088,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1088,
    ty: 3,
    parent: 1083,
    ks: {
      p: {
        a: 0,
        k: [
          12.627,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1091,
    ty: 4,
    parent: 1090,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.8,
                9
              ],
              [
                1.8,
                9
              ],
              [
                0.9,
                8.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                7.8
              ],
              [
                1.9,
                8
              ],
              [
                2,
                8.1
              ],
              [
                2,
                8.1
              ],
              [
                2.1,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.3,
                8.9
              ],
              [
                2.1,
                9
              ],
              [
                1.8,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1090,
    ty: 3,
    parent: 1083,
    ks: {
      p: {
        a: 0,
        k: [
          10.058,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1093,
    ty: 4,
    parent: 1092,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1092,
    ty: 3,
    parent: 1083,
    ks: {
      p: {
        a: 0,
        k: [
          5.167,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1095,
    ty: 4,
    parent: 1094,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                1,
                7.4
              ],
              [
                1.8,
                7.9
              ],
              [
                2.6,
                8.1
              ],
              [
                2.6,
                8.1
              ],
              [
                3.4,
                7.8
              ],
              [
                3.7,
                7.3
              ],
              [
                3.7,
                7.3
              ],
              [
                3.4,
                6.7
              ],
              [
                2.7,
                6.4
              ],
              [
                2.7,
                6.4
              ],
              [
                1.9,
                6
              ],
              [
                1.3,
                5.6
              ],
              [
                0.8,
                5.1
              ],
              [
                0.6,
                4.3
              ],
              [
                0.6,
                4.3
              ],
              [
                0.9,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.8,
                2.8
              ],
              [
                4.6,
                3.4
              ],
              [
                4.6,
                3.4
              ],
              [
                4.1,
                4.1
              ],
              [
                3.4,
                3.7
              ],
              [
                2.7,
                3.5
              ],
              [
                2.7,
                3.5
              ],
              [
                2,
                3.7
              ],
              [
                1.7,
                4.3
              ],
              [
                1.7,
                4.3
              ],
              [
                1.9,
                4.7
              ],
              [
                2.2,
                4.9
              ],
              [
                2.7,
                5.1
              ],
              [
                2.7,
                5.1
              ],
              [
                3.6,
                5.5
              ],
              [
                4.5,
                6.1
              ],
              [
                4.8,
                7.2
              ],
              [
                4.8,
                7.2
              ],
              [
                4.6,
                8.1
              ],
              [
                3.8,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1094,
    ty: 3,
    parent: 1083,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1083,
    ty: 3,
    parent: 1051,
    ks: {
      p: {
        a: 0,
        k: [
          24.458,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1098,
    ty: 4,
    parent: 1097,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                1.8,
                6.5
              ],
              [
                1.8,
                6.5
              ],
              [
                0.7,
                6
              ],
              [
                0.3,
                4.5
              ],
              [
                0.3,
                4.5
              ],
              [
                0.7,
                3.1
              ],
              [
                1.8,
                2.6
              ],
              [
                1.8,
                2.6
              ],
              [
                2.8,
                3.1
              ],
              [
                3.2,
                4.5
              ],
              [
                3.2,
                4.5
              ],
              [
                2.8,
                6
              ],
              [
                1.8,
                6.5
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                1.8,
                5.9
              ],
              [
                1.8,
                5.9
              ],
              [
                2.3,
                5.6
              ],
              [
                2.5,
                4.5
              ],
              [
                2.5,
                4.5
              ],
              [
                2.3,
                3.5
              ],
              [
                1.8,
                3.2
              ],
              [
                1.8,
                3.2
              ],
              [
                1.3,
                3.5
              ],
              [
                1.1,
                4.5
              ],
              [
                1.1,
                4.5
              ],
              [
                1.3,
                5.6
              ],
              [
                1.8,
                5.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2,
                9
              ],
              [
                5.3,
                2.6
              ],
              [
                6,
                2.6
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                6.2,
                9
              ],
              [
                6.2,
                9
              ],
              [
                5.1,
                8.5
              ],
              [
                4.7,
                7
              ],
              [
                4.7,
                7
              ],
              [
                5.1,
                5.6
              ],
              [
                6.2,
                5.1
              ],
              [
                6.2,
                5.1
              ],
              [
                7.3,
                5.6
              ],
              [
                7.7,
                7
              ],
              [
                7.7,
                7
              ],
              [
                7.3,
                8.5
              ],
              [
                6.2,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                6.2,
                8.4
              ],
              [
                6.2,
                8.4
              ],
              [
                6.7,
                8.1
              ],
              [
                6.9,
                7
              ],
              [
                6.9,
                7
              ],
              [
                6.7,
                6
              ],
              [
                6.2,
                5.7
              ],
              [
                6.2,
                5.7
              ],
              [
                5.7,
                6
              ],
              [
                5.5,
                7
              ],
              [
                5.5,
                7
              ],
              [
                5.7,
                8.1
              ],
              [
                6.2,
                8.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1097,
    ty: 3,
    parent: 1096,
    ks: {
      p: {
        a: 0,
        k: [
          14.59,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1100,
    ty: 4,
    parent: 1099,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.5
              ],
              [
                -0.6,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                0,
                -1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.5
              ],
              [
                0.6,
                0
              ]
            ],
            v: [
              [
                2.4,
                9
              ],
              [
                2.4,
                9
              ],
              [
                0.9,
                8.2
              ],
              [
                0.4,
                5.9
              ],
              [
                0.4,
                5.9
              ],
              [
                0.9,
                3.5
              ],
              [
                2.4,
                2.8
              ],
              [
                2.4,
                2.8
              ],
              [
                3.9,
                3.5
              ],
              [
                4.5,
                5.9
              ],
              [
                4.5,
                5.9
              ],
              [
                3.9,
                8.2
              ],
              [
                2.4,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                -1
              ],
              [
                0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                1
              ],
              [
                -0.4,
                0.5
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.2
              ],
              [
                2.4,
                8.2
              ],
              [
                2.9,
                7.9
              ],
              [
                3.3,
                7.2
              ],
              [
                3.4,
                5.9
              ],
              [
                3.4,
                5.9
              ],
              [
                3.3,
                4.5
              ],
              [
                2.9,
                3.8
              ],
              [
                2.4,
                3.6
              ],
              [
                2.4,
                3.6
              ],
              [
                1.9,
                3.8
              ],
              [
                1.6,
                4.5
              ],
              [
                1.4,
                5.9
              ],
              [
                1.4,
                5.9
              ],
              [
                1.6,
                7.2
              ],
              [
                1.9,
                7.9
              ],
              [
                2.4,
                8.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.1,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1099,
    ty: 3,
    parent: 1096,
    ks: {
      p: {
        a: 0,
        k: [
          9.726,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1102,
    ty: 4,
    parent: 1101,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.5
              ],
              [
                -0.6,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                0,
                -1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.5
              ],
              [
                0.6,
                0
              ]
            ],
            v: [
              [
                2.4,
                9
              ],
              [
                2.4,
                9
              ],
              [
                0.9,
                8.2
              ],
              [
                0.4,
                5.9
              ],
              [
                0.4,
                5.9
              ],
              [
                0.9,
                3.5
              ],
              [
                2.4,
                2.8
              ],
              [
                2.4,
                2.8
              ],
              [
                3.9,
                3.5
              ],
              [
                4.5,
                5.9
              ],
              [
                4.5,
                5.9
              ],
              [
                3.9,
                8.2
              ],
              [
                2.4,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                -1
              ],
              [
                0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                1
              ],
              [
                -0.4,
                0.5
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.2
              ],
              [
                2.4,
                8.2
              ],
              [
                2.9,
                7.9
              ],
              [
                3.3,
                7.2
              ],
              [
                3.4,
                5.9
              ],
              [
                3.4,
                5.9
              ],
              [
                3.3,
                4.5
              ],
              [
                2.9,
                3.8
              ],
              [
                2.4,
                3.6
              ],
              [
                2.4,
                3.6
              ],
              [
                1.9,
                3.8
              ],
              [
                1.6,
                4.5
              ],
              [
                1.4,
                5.9
              ],
              [
                1.4,
                5.9
              ],
              [
                1.6,
                7.2
              ],
              [
                1.9,
                7.9
              ],
              [
                2.4,
                8.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.1,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1101,
    ty: 3,
    parent: 1096,
    ks: {
      p: {
        a: 0,
        k: [
          4.863,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1104,
    ty: 4,
    parent: 1103,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.3
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.3,
                9
              ],
              [
                2.3,
                9
              ],
              [
                1,
                8.8
              ],
              [
                0.2,
                8.2
              ],
              [
                0.2,
                8.2
              ],
              [
                0.7,
                7.5
              ],
              [
                1.4,
                7.9
              ],
              [
                2.2,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                3,
                7.9
              ],
              [
                3.3,
                7.2
              ],
              [
                3.3,
                7.2
              ],
              [
                3.1,
                6.7
              ],
              [
                2.6,
                6.3
              ],
              [
                1.5,
                6.2
              ],
              [
                1.5,
                6.2
              ],
              [
                1.5,
                5.4
              ],
              [
                2.7,
                5.1
              ],
              [
                3.1,
                4.4
              ],
              [
                3.1,
                4.4
              ],
              [
                2.9,
                3.8
              ],
              [
                2.2,
                3.6
              ],
              [
                2.2,
                3.6
              ],
              [
                1.6,
                3.8
              ],
              [
                1,
                4.2
              ],
              [
                1,
                4.2
              ],
              [
                0.4,
                3.5
              ],
              [
                1.3,
                3
              ],
              [
                2.2,
                2.8
              ],
              [
                2.2,
                2.8
              ],
              [
                3.7,
                3.2
              ],
              [
                4.2,
                4.4
              ],
              [
                4.2,
                4.4
              ],
              [
                3.9,
                5.2
              ],
              [
                3.1,
                5.7
              ],
              [
                3.1,
                5.7
              ],
              [
                3.1,
                5.8
              ],
              [
                4,
                6.3
              ],
              [
                4.4,
                7.3
              ],
              [
                4.4,
                7.3
              ],
              [
                4.1,
                8.2
              ],
              [
                3.3,
                8.8
              ],
              [
                2.3,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.4,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.1
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1103,
    ty: 3,
    parent: 1096,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1096,
    ty: 3,
    parent: 1051,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1051,
    ty: 3,
    parent: 1050,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1050,
    ty: 3,
    parent: 1049,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1049,
    ty: 3,
    parent: 1048,
    ks: {
      p: {
        a: 0,
        k: [
          14.75,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1113,
    ty: 0,
    parent: 1105,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.732
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.732
        ]
      }
    },
    w: 10.536,
    h: 10.536,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1111"
  },
  {
    ind: 1105,
    ty: 3,
    parent: 1048,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.732
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1048,
    ty: 3,
    parent: 1047,
    ks: {
      p: {
        a: 0,
        k: [
          38.784,
          2.709
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1047,
    ty: 3,
    parent: 1046,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          41.801
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1134,
    ty: 0,
    parent: 1116,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          14.107
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          14.107
        ]
      }
    },
    w: 70.948,
    h: 16.857,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1132"
  },
  {
    ind: 1116,
    ty: 3,
    parent: 1115,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          14.107
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1139,
    ty: 4,
    parent: 1138,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.17
              ],
              [
                -0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.06,
                0.01
              ],
              [
                0.09,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.16
              ],
              [
                0.16,
                -0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                5.13
              ],
              [
                1.52,
                5.13
              ],
              [
                2.1,
                4.44
              ],
              [
                2.83,
                4.18
              ],
              [
                2.83,
                4.18
              ],
              [
                3.32,
                4.27
              ],
              [
                3.32,
                4.27
              ],
              [
                3.17,
                4.96
              ],
              [
                2.96,
                4.9
              ],
              [
                2.72,
                4.88
              ],
              [
                2.72,
                4.88
              ],
              [
                2.11,
                5.12
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.29
              ],
              [
                0.23,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.06,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.21,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1138,
    ty: 3,
    parent: 1137,
    ks: {
      p: {
        a: 0,
        k: [
          21.283,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1141,
    ty: 4,
    parent: 1140,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.2
              ],
              [
                -0.35,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.39
              ],
              [
                0,
                -0.66
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.08
              ],
              [
                0.01,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                -0.29
              ],
              [
                -0.44,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.07
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.09
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                2.65,
                9.02
              ],
              [
                2.65,
                9.02
              ],
              [
                1.53,
                8.73
              ],
              [
                0.73,
                7.9
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.31
              ],
              [
                1.51,
                4.47
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.86,
                4.77
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.58
              ],
              [
                4.31,
                6.79
              ],
              [
                4.31,
                6.79
              ],
              [
                1.2,
                6.79
              ],
              [
                1.66,
                7.95
              ],
              [
                2.74,
                8.39
              ],
              [
                2.74,
                8.39
              ],
              [
                3.35,
                8.29
              ],
              [
                3.89,
                8.03
              ],
              [
                3.89,
                8.03
              ],
              [
                4.16,
                8.54
              ],
              [
                3.49,
                8.87
              ],
              [
                2.65,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.41,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.59,
                0
              ],
              [
                0.32,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.03,
                0.49
              ],
              [
                0.27,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.19,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.13
              ],
              [
                -0.25,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.24
              ],
              [
                0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.25
              ],
              [
                0.05,
                -0.46
              ]
            ],
            v: [
              [
                1.19,
                6.23
              ],
              [
                1.19,
                6.23
              ],
              [
                3.66,
                6.23
              ],
              [
                3.36,
                5.16
              ],
              [
                2.52,
                4.8
              ],
              [
                2.52,
                4.8
              ],
              [
                1.65,
                5.17
              ],
              [
                1.19,
                6.23
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.47
              ],
              [
                -0.2,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.26,
                0.25
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1140,
    ty: 3,
    parent: 1137,
    ks: {
      p: {
        a: 0,
        k: [
          16.58,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1143,
    ty: 4,
    parent: 1142,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.1
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.6,
                9
              ],
              [
                1.6,
                9
              ],
              [
                1,
                8.7
              ],
              [
                0.8,
                8
              ],
              [
                0.8,
                8
              ],
              [
                0.8,
                2.2
              ],
              [
                1.6,
                2.2
              ],
              [
                1.6,
                8
              ],
              [
                1.6,
                8.3
              ],
              [
                1.8,
                8.4
              ],
              [
                1.8,
                8.4
              ],
              [
                1.8,
                8.4
              ],
              [
                1.9,
                8.4
              ],
              [
                1.9,
                8.4
              ],
              [
                2,
                8.9
              ],
              [
                1.9,
                9
              ],
              [
                1.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1142,
    ty: 3,
    parent: 1137,
    ks: {
      p: {
        a: 0,
        k: [
          14.163,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1145,
    ty: 4,
    parent: 1144,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.23
              ],
              [
                0,
                0.41
              ],
              [
                0,
                0
              ],
              [
                -0.45,
                0.27
              ],
              [
                -0.98,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.18
              ],
              [
                0.14,
                0.11
              ],
              [
                0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.1
              ],
              [
                0.18,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.31,
                0.13
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.34
              ],
              [
                0,
                -0.58
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.13
              ],
              [
                0.29,
                0
              ]
            ],
            v: [
              [
                1.84,
                9.02
              ],
              [
                1.84,
                9.02
              ],
              [
                0.88,
                8.67
              ],
              [
                0.49,
                7.71
              ],
              [
                0.49,
                7.71
              ],
              [
                1.17,
                6.55
              ],
              [
                3.32,
                5.98
              ],
              [
                3.32,
                5.98
              ],
              [
                3.24,
                5.42
              ],
              [
                2.95,
                4.99
              ],
              [
                2.37,
                4.82
              ],
              [
                2.37,
                4.82
              ],
              [
                1.62,
                4.98
              ],
              [
                1,
                5.32
              ],
              [
                1,
                5.32
              ],
              [
                0.69,
                4.78
              ],
              [
                1.48,
                4.37
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.73,
                4.7
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                8.9
              ],
              [
                3.46,
                8.9
              ],
              [
                3.39,
                8.35
              ],
              [
                3.37,
                8.35
              ],
              [
                2.66,
                8.82
              ],
              [
                1.84,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.26,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.45,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.05,
                -0.18
              ],
              [
                -0.14,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.14
              ],
              [
                0.31,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.56,
                0
              ],
              [
                0.25,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.26,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.11
              ],
              [
                -0.22,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.19
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.23,
                0
              ]
            ],
            v: [
              [
                2.07,
                8.39
              ],
              [
                2.07,
                8.39
              ],
              [
                2.69,
                8.23
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                6.49
              ],
              [
                1.71,
                6.92
              ],
              [
                1.25,
                7.65
              ],
              [
                1.25,
                7.65
              ],
              [
                1.49,
                8.21
              ],
              [
                2.07,
                8.39
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.2,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.76,
                0.09
              ],
              [
                -0.31,
                0.19
              ],
              [
                0,
                0
              ],
              [
                0,
                0.26
              ],
              [
                0.16,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1144,
    ty: 3,
    parent: 1137,
    ks: {
      p: {
        a: 0,
        k: [
          9.385,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1147,
    ty: 4,
    parent: 1146,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.33,
                0.19
              ],
              [
                0.19,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.36
              ],
              [
                -0.34,
                0.19
              ],
              [
                -0.39,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.11
              ],
              [
                -0.16,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.08
              ],
              [
                0.18,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.15
              ],
              [
                0.12,
                -0.27
              ],
              [
                0,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                -0.26,
                -0.33
              ],
              [
                -0.42,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0.09
              ],
              [
                -0.14,
                0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.1
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                2.6,
                9.02
              ],
              [
                2.6,
                9.02
              ],
              [
                1.5,
                8.73
              ],
              [
                0.72,
                7.91
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.74,
                5.29
              ],
              [
                1.56,
                4.46
              ],
              [
                2.66,
                4.18
              ],
              [
                2.66,
                4.18
              ],
              [
                3.44,
                4.34
              ],
              [
                4,
                4.72
              ],
              [
                4,
                4.72
              ],
              [
                3.6,
                5.23
              ],
              [
                3.18,
                4.94
              ],
              [
                2.68,
                4.82
              ],
              [
                2.68,
                4.82
              ],
              [
                1.94,
                5.05
              ],
              [
                1.43,
                5.67
              ],
              [
                1.24,
                6.61
              ],
              [
                1.24,
                6.61
              ],
              [
                1.64,
                7.88
              ],
              [
                2.66,
                8.37
              ],
              [
                2.66,
                8.37
              ],
              [
                3.26,
                8.23
              ],
              [
                3.75,
                7.91
              ],
              [
                3.75,
                7.91
              ],
              [
                4.09,
                8.43
              ],
              [
                3.39,
                8.86
              ],
              [
                2.6,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.33,
                -0.19
              ],
              [
                -0.19,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.52
              ],
              [
                0.21,
                -0.36
              ],
              [
                0.34,
                -0.19
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.22,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.12
              ],
              [
                -0.15,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.12,
                0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                0.52
              ],
              [
                0.26,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0.21,
                0
              ],
              [
                0.18,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.25,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1146,
    ty: 3,
    parent: 1137,
    ks: {
      p: {
        a: 0,
        k: [
          5.062,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1149,
    ty: 4,
    parent: 1148,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                0.9,
                7.5
              ],
              [
                1.7,
                8.1
              ],
              [
                2.6,
                8.3
              ],
              [
                2.6,
                8.3
              ],
              [
                3.5,
                8
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.8,
                6.8
              ],
              [
                3.4,
                6.5
              ],
              [
                2.9,
                6.2
              ],
              [
                2.9,
                6.2
              ],
              [
                2,
                5.8
              ],
              [
                1.4,
                5.5
              ],
              [
                0.9,
                5
              ],
              [
                0.7,
                4.2
              ],
              [
                0.7,
                4.2
              ],
              [
                1,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.7,
                2.8
              ],
              [
                4.5,
                3.3
              ],
              [
                4.5,
                3.3
              ],
              [
                4.1,
                3.8
              ],
              [
                3.4,
                3.4
              ],
              [
                2.7,
                3.3
              ],
              [
                2.7,
                3.3
              ],
              [
                1.8,
                3.5
              ],
              [
                1.5,
                4.2
              ],
              [
                1.5,
                4.2
              ],
              [
                1.7,
                4.7
              ],
              [
                2,
                5
              ],
              [
                2.5,
                5.2
              ],
              [
                2.5,
                5.2
              ],
              [
                3.4,
                5.6
              ],
              [
                4.1,
                5.9
              ],
              [
                4.5,
                6.5
              ],
              [
                4.7,
                7.2
              ],
              [
                4.7,
                7.2
              ],
              [
                4.4,
                8.1
              ],
              [
                3.7,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1148,
    ty: 3,
    parent: 1137,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1137,
    ty: 3,
    parent: 1136,
    ks: {
      p: {
        a: 0,
        k: [
          19.576,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1152,
    ty: 4,
    parent: 1151,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                2.2,
                9
              ],
              [
                2.2,
                9
              ],
              [
                1.2,
                8.6
              ],
              [
                0.9,
                7.5
              ],
              [
                0.9,
                7.5
              ],
              [
                0.9,
                4.9
              ],
              [
                0.2,
                4.9
              ],
              [
                0.2,
                4.3
              ],
              [
                0.9,
                4.3
              ],
              [
                1,
                3
              ],
              [
                1.7,
                3
              ],
              [
                1.7,
                4.3
              ],
              [
                2.9,
                4.3
              ],
              [
                2.9,
                4.9
              ],
              [
                1.7,
                4.9
              ],
              [
                1.7,
                7.5
              ],
              [
                1.9,
                8.1
              ],
              [
                2.4,
                8.4
              ],
              [
                2.4,
                8.4
              ],
              [
                2.7,
                8.3
              ],
              [
                2.9,
                8.3
              ],
              [
                2.9,
                8.3
              ],
              [
                3.1,
                8.8
              ],
              [
                2.7,
                9
              ],
              [
                2.2,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1151,
    ty: 3,
    parent: 1150,
    ks: {
      p: {
        a: 0,
        k: [
          14.476,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1154,
    ty: 4,
    parent: 1153,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.12
              ],
              [
                0.22,
                0.18
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                -0.1
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.14
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.11
              ],
              [
                0.16,
                0.07
              ],
              [
                0.17,
                0.06
              ],
              [
                0,
                0
              ],
              [
                0.21,
                0.1
              ],
              [
                0.13,
                0.17
              ],
              [
                0,
                0.26
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                0.25
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.1
              ],
              [
                -0.18,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.17,
                0.08
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                -0.13
              ],
              [
                0,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.09,
                -0.09
              ],
              [
                -0.15,
                -0.07
              ],
              [
                -0.17,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                -0.1
              ],
              [
                -0.14,
                -0.17
              ],
              [
                0,
                -0.29
              ],
              [
                0,
                0
              ],
              [
                0.13,
                -0.21
              ],
              [
                0.25,
                -0.13
              ],
              [
                0.37,
                0
              ]
            ],
            v: [
              [
                1.98,
                9.02
              ],
              [
                1.98,
                9.02
              ],
              [
                1.04,
                8.83
              ],
              [
                0.27,
                8.38
              ],
              [
                0.27,
                8.38
              ],
              [
                0.65,
                7.86
              ],
              [
                1.28,
                8.25
              ],
              [
                2.01,
                8.41
              ],
              [
                2.01,
                8.41
              ],
              [
                2.69,
                8.2
              ],
              [
                2.92,
                7.69
              ],
              [
                2.92,
                7.69
              ],
              [
                2.76,
                7.29
              ],
              [
                2.37,
                7.02
              ],
              [
                1.87,
                6.82
              ],
              [
                1.87,
                6.82
              ],
              [
                1.23,
                6.54
              ],
              [
                0.72,
                6.13
              ],
              [
                0.52,
                5.49
              ],
              [
                0.52,
                5.49
              ],
              [
                0.94,
                4.55
              ],
              [
                2.11,
                4.18
              ],
              [
                2.11,
                4.18
              ],
              [
                2.91,
                4.33
              ],
              [
                3.55,
                4.7
              ],
              [
                3.55,
                4.7
              ],
              [
                3.17,
                5.19
              ],
              [
                2.67,
                4.9
              ],
              [
                2.11,
                4.79
              ],
              [
                2.11,
                4.79
              ],
              [
                1.47,
                4.99
              ],
              [
                1.27,
                5.45
              ],
              [
                1.27,
                5.45
              ],
              [
                1.41,
                5.81
              ],
              [
                1.78,
                6.04
              ],
              [
                2.27,
                6.25
              ],
              [
                2.27,
                6.25
              ],
              [
                2.92,
                6.53
              ],
              [
                3.46,
                6.94
              ],
              [
                3.67,
                7.64
              ],
              [
                3.67,
                7.64
              ],
              [
                3.48,
                8.32
              ],
              [
                2.91,
                8.83
              ],
              [
                1.98,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.33,
                0
              ],
              [
                -0.3,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.16
              ],
              [
                0.21,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.15,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.16
              ],
              [
                -0.1,
                -0.11
              ],
              [
                -0.16,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                -0.08
              ],
              [
                -0.21,
                -0.1
              ],
              [
                -0.13,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.37
              ],
              [
                0.28,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0.28,
                0
              ],
              [
                0.25,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.17,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                0
              ],
              [
                -0.14,
                0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0.15
              ],
              [
                0.09,
                0.09
              ],
              [
                0.15,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0.08
              ],
              [
                0.21,
                0.1
              ],
              [
                0.14,
                0.17
              ],
              [
                0,
                0
              ],
              [
                0,
                0.25
              ],
              [
                -0.13,
                0.21
              ],
              [
                -0.25,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1153,
    ty: 3,
    parent: 1150,
    ks: {
      p: {
        a: 0,
        k: [
          10.504,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1156,
    ty: 4,
    parent: 1155,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.33,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.33,
                0.19
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                -0.52
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.19
              ],
              [
                0.38,
                0
              ]
            ],
            v: [
              [
                2.57,
                9.02
              ],
              [
                2.57,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.73,
                7.91
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.29
              ],
              [
                1.52,
                4.46
              ],
              [
                2.57,
                4.18
              ],
              [
                2.57,
                4.18
              ],
              [
                3.62,
                4.46
              ],
              [
                4.4,
                5.29
              ],
              [
                4.7,
                6.61
              ],
              [
                4.7,
                6.61
              ],
              [
                4.4,
                7.91
              ],
              [
                3.62,
                8.73
              ],
              [
                2.57,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.37,
                0
              ],
              [
                -0.33,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.52
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.33,
                -0.19
              ],
              [
                0,
                0
              ],
              [
                0.38,
                0
              ],
              [
                0.32,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                0.51
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.19
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                0.33
              ],
              [
                0,
                0.52
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.33
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.33
              ],
              [
                0,
                -0.53
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.33
              ],
              [
                -0.39,
                0
              ]
            ],
            v: [
              [
                2.57,
                8.37
              ],
              [
                2.57,
                8.37
              ],
              [
                3.53,
                7.88
              ],
              [
                3.9,
                6.61
              ],
              [
                3.9,
                6.61
              ],
              [
                3.53,
                5.32
              ],
              [
                2.57,
                4.82
              ],
              [
                2.57,
                4.82
              ],
              [
                1.61,
                5.32
              ],
              [
                1.24,
                6.61
              ],
              [
                1.24,
                6.61
              ],
              [
                1.61,
                7.88
              ],
              [
                2.57,
                8.37
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.24,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.53
              ],
              [
                -0.24,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.25,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.52
              ],
              [
                0.25,
                0.33
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1155,
    ty: 3,
    parent: 1150,
    ks: {
      p: {
        a: 0,
        k: [
          5.366,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1158,
    ty: 4,
    parent: 1157,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.3
              ],
              [
                0.7,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                2.7
              ],
              [
                2.6,
                2.7
              ],
              [
                3.8,
                2.9
              ],
              [
                4.7,
                3.4
              ],
              [
                5,
                4.5
              ],
              [
                5,
                4.5
              ],
              [
                4.3,
                6
              ],
              [
                2.7,
                6.4
              ],
              [
                2.7,
                6.4
              ],
              [
                1.6,
                6.4
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.7
              ],
              [
                -0.4,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                3.3
              ],
              [
                1.6,
                5.8
              ],
              [
                2.6,
                5.8
              ],
              [
                3.8,
                5.5
              ],
              [
                4.2,
                4.5
              ],
              [
                4.2,
                4.5
              ],
              [
                3.8,
                3.6
              ],
              [
                2.5,
                3.3
              ],
              [
                2.5,
                3.3
              ],
              [
                1.6,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1157,
    ty: 3,
    parent: 1150,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1150,
    ty: 3,
    parent: 1136,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1136,
    ty: 3,
    parent: 1135,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1135,
    ty: 3,
    parent: 1115,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1115,
    ty: 3,
    parent: 1114,
    ks: {
      p: {
        a: 0,
        k: [
          133.437,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1164,
    ty: 0,
    parent: 1160,
    ks: {},
    w: 25,
    h: 13,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1162"
  },
  {
    ind: 1160,
    ty: 3,
    parent: 1159,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1159,
    ty: 3,
    parent: 1114,
    ks: {
      p: {
        a: 0,
        k: [
          101.077,
          9.097
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1170,
    ty: 0,
    parent: 1166,
    ks: {},
    w: 87,
    h: 15,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1168"
  },
  {
    ind: 1166,
    ty: 3,
    parent: 1165,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          11
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1175,
    ty: 0,
    parent: 1171,
    ks: {},
    w: 62,
    h: 12,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1173"
  },
  {
    ind: 1171,
    ty: 3,
    parent: 1165,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1165,
    ty: 3,
    parent: 1114,
    ks: {
      p: {
        a: 0,
        k: [
          6.932,
          2.952
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1114,
    ty: 3,
    parent: 1046,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1046,
    ty: 3,
    parent: 1045,
    ks: {
      p: {
        a: 0,
        k: [
          8.128,
          75.409
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1184,
    ty: 4,
    parent: 1183,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                0.15
              ],
              [
                -0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.31
              ],
              [
                0,
                -0.59
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.12
              ],
              [
                0.23,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                4.96
              ],
              [
                1.52,
                4.96
              ],
              [
                2.22,
                4.4
              ],
              [
                3.06,
                4.18
              ],
              [
                3.06,
                4.18
              ],
              [
                4.13,
                4.64
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                8.9
              ],
              [
                3.69,
                8.9
              ],
              [
                3.69,
                6.09
              ],
              [
                3.48,
                5.15
              ],
              [
                2.82,
                4.85
              ],
              [
                2.82,
                4.85
              ],
              [
                2.19,
                5.03
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.22
              ],
              [
                0.25,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0.49,
                0
              ],
              [
                0.22,
                0.31
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.43
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.19,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1183,
    ty: 3,
    parent: 1182,
    ks: {
      p: {
        a: 0,
        k: [
          28.99,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1186,
    ty: 4,
    parent: 1185,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.33,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.33,
                0.19
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                -0.52
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.19
              ],
              [
                0.38,
                0
              ]
            ],
            v: [
              [
                2.57,
                9.02
              ],
              [
                2.57,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.73,
                7.91
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.29
              ],
              [
                1.52,
                4.46
              ],
              [
                2.57,
                4.18
              ],
              [
                2.57,
                4.18
              ],
              [
                3.62,
                4.46
              ],
              [
                4.4,
                5.29
              ],
              [
                4.7,
                6.61
              ],
              [
                4.7,
                6.61
              ],
              [
                4.4,
                7.91
              ],
              [
                3.62,
                8.73
              ],
              [
                2.57,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.37,
                0
              ],
              [
                -0.33,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.52
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.33,
                -0.19
              ],
              [
                0,
                0
              ],
              [
                0.38,
                0
              ],
              [
                0.32,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                0.51
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.19
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                0.33
              ],
              [
                0,
                0.52
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.33
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.33
              ],
              [
                0,
                -0.53
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.33
              ],
              [
                -0.39,
                0
              ]
            ],
            v: [
              [
                2.57,
                8.37
              ],
              [
                2.57,
                8.37
              ],
              [
                3.53,
                7.88
              ],
              [
                3.9,
                6.61
              ],
              [
                3.9,
                6.61
              ],
              [
                3.53,
                5.32
              ],
              [
                2.57,
                4.82
              ],
              [
                2.57,
                4.82
              ],
              [
                1.61,
                5.32
              ],
              [
                1.24,
                6.61
              ],
              [
                1.24,
                6.61
              ],
              [
                1.61,
                7.88
              ],
              [
                2.57,
                8.37
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.24,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.53
              ],
              [
                -0.24,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.25,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.52
              ],
              [
                0.25,
                0.33
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1185,
    ty: 3,
    parent: 1182,
    ks: {
      p: {
        a: 0,
        k: [
          23.852,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1188,
    ty: 4,
    parent: 1187,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.23
              ],
              [
                0,
                0.41
              ],
              [
                0,
                0
              ],
              [
                -0.45,
                0.27
              ],
              [
                -0.98,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.18
              ],
              [
                0.14,
                0.11
              ],
              [
                0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.1
              ],
              [
                0.18,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.31,
                0.13
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.34
              ],
              [
                0,
                -0.58
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.13
              ],
              [
                0.29,
                0
              ]
            ],
            v: [
              [
                1.84,
                9.02
              ],
              [
                1.84,
                9.02
              ],
              [
                0.88,
                8.67
              ],
              [
                0.49,
                7.71
              ],
              [
                0.49,
                7.71
              ],
              [
                1.17,
                6.55
              ],
              [
                3.32,
                5.98
              ],
              [
                3.32,
                5.98
              ],
              [
                3.24,
                5.42
              ],
              [
                2.95,
                4.99
              ],
              [
                2.37,
                4.82
              ],
              [
                2.37,
                4.82
              ],
              [
                1.62,
                4.98
              ],
              [
                1,
                5.32
              ],
              [
                1,
                5.32
              ],
              [
                0.69,
                4.78
              ],
              [
                1.48,
                4.37
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.73,
                4.7
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                8.9
              ],
              [
                3.46,
                8.9
              ],
              [
                3.39,
                8.35
              ],
              [
                3.37,
                8.35
              ],
              [
                2.66,
                8.82
              ],
              [
                1.84,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.26,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.45,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.05,
                -0.18
              ],
              [
                -0.14,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.14
              ],
              [
                0.31,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.56,
                0
              ],
              [
                0.25,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.26,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.11
              ],
              [
                -0.22,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.19
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.23,
                0
              ]
            ],
            v: [
              [
                2.07,
                8.39
              ],
              [
                2.07,
                8.39
              ],
              [
                2.69,
                8.23
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                6.49
              ],
              [
                1.71,
                6.92
              ],
              [
                1.25,
                7.65
              ],
              [
                1.25,
                7.65
              ],
              [
                1.49,
                8.21
              ],
              [
                2.07,
                8.39
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.2,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.76,
                0.09
              ],
              [
                -0.31,
                0.19
              ],
              [
                0,
                0
              ],
              [
                0,
                0.26
              ],
              [
                0.16,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1187,
    ty: 3,
    parent: 1182,
    ks: {
      p: {
        a: 0,
        k: [
          19.074,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1190,
    ty: 4,
    parent: 1189,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.3,
                11
              ],
              [
                2.3,
                11
              ],
              [
                1,
                10.7
              ],
              [
                0.4,
                9.8
              ],
              [
                0.4,
                9.8
              ],
              [
                0.6,
                9.2
              ],
              [
                1.1,
                8.7
              ],
              [
                1.1,
                8.7
              ],
              [
                1.1,
                8.7
              ],
              [
                0.8,
                8.4
              ],
              [
                0.7,
                8
              ],
              [
                0.7,
                8
              ],
              [
                0.9,
                7.4
              ],
              [
                1.2,
                7.1
              ],
              [
                1.2,
                7.1
              ],
              [
                1.2,
                7.1
              ],
              [
                0.8,
                6.6
              ],
              [
                0.6,
                5.8
              ],
              [
                0.6,
                5.8
              ],
              [
                0.8,
                4.9
              ],
              [
                1.5,
                4.4
              ],
              [
                2.3,
                4.2
              ],
              [
                2.3,
                4.2
              ],
              [
                2.7,
                4.2
              ],
              [
                3,
                4.3
              ],
              [
                3,
                4.3
              ],
              [
                4.6,
                4.3
              ],
              [
                4.6,
                4.9
              ],
              [
                3.6,
                4.9
              ],
              [
                3.9,
                5.3
              ],
              [
                4,
                5.8
              ],
              [
                4,
                5.8
              ],
              [
                3.8,
                6.7
              ],
              [
                3.2,
                7.2
              ],
              [
                2.3,
                7.4
              ],
              [
                2.3,
                7.4
              ],
              [
                1.6,
                7.3
              ],
              [
                1.6,
                7.3
              ],
              [
                1.4,
                7.5
              ],
              [
                1.3,
                7.8
              ],
              [
                1.3,
                7.8
              ],
              [
                1.5,
                8.2
              ],
              [
                2.2,
                8.3
              ],
              [
                2.2,
                8.3
              ],
              [
                3.1,
                8.3
              ],
              [
                4.3,
                8.6
              ],
              [
                4.7,
                9.4
              ],
              [
                4.7,
                9.4
              ],
              [
                4.4,
                10.2
              ],
              [
                3.6,
                10.8
              ],
              [
                2.3,
                11
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.3,
                6.9
              ],
              [
                2.3,
                6.9
              ],
              [
                3,
                6.6
              ],
              [
                3.3,
                5.8
              ],
              [
                3.3,
                5.8
              ],
              [
                3,
                5
              ],
              [
                2.3,
                4.7
              ],
              [
                2.3,
                4.7
              ],
              [
                1.6,
                5
              ],
              [
                1.4,
                5.8
              ],
              [
                1.4,
                5.8
              ],
              [
                1.6,
                6.6
              ],
              [
                2.3,
                6.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.4,
                0
              ]
            ],
            v: [
              [
                2.4,
                10.5
              ],
              [
                2.4,
                10.5
              ],
              [
                3.5,
                10.2
              ],
              [
                3.9,
                9.5
              ],
              [
                3.9,
                9.5
              ],
              [
                3.7,
                9.1
              ],
              [
                3,
                9
              ],
              [
                3,
                9
              ],
              [
                2.2,
                9
              ],
              [
                1.9,
                9
              ],
              [
                1.6,
                8.9
              ],
              [
                1.6,
                8.9
              ],
              [
                1.2,
                9.3
              ],
              [
                1.1,
                9.7
              ],
              [
                1.1,
                9.7
              ],
              [
                1.5,
                10.3
              ],
              [
                2.4,
                10.5
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1189,
    ty: 3,
    parent: 1182,
    ks: {
      p: {
        a: 0,
        k: [
          14.296,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1192,
    ty: 4,
    parent: 1191,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.17
              ],
              [
                -0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.06,
                0.01
              ],
              [
                0.09,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.16
              ],
              [
                0.16,
                -0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                5.13
              ],
              [
                1.52,
                5.13
              ],
              [
                2.1,
                4.44
              ],
              [
                2.83,
                4.18
              ],
              [
                2.83,
                4.18
              ],
              [
                3.32,
                4.27
              ],
              [
                3.32,
                4.27
              ],
              [
                3.17,
                4.96
              ],
              [
                2.96,
                4.9
              ],
              [
                2.72,
                4.88
              ],
              [
                2.72,
                4.88
              ],
              [
                2.11,
                5.12
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.29
              ],
              [
                0.23,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.06,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.21,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1191,
    ty: 3,
    parent: 1182,
    ks: {
      p: {
        a: 0,
        k: [
          11.006,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1194,
    ty: 4,
    parent: 1193,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                0.31
              ],
              [
                0,
                0.59
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.12
              ],
              [
                -0.21,
                0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.15
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                2.12,
                9.02
              ],
              [
                2.12,
                9.02
              ],
              [
                1.05,
                8.56
              ],
              [
                0.71,
                7.21
              ],
              [
                0.71,
                7.21
              ],
              [
                0.71,
                4.29
              ],
              [
                1.5,
                4.29
              ],
              [
                1.5,
                7.11
              ],
              [
                1.7,
                8.05
              ],
              [
                2.36,
                8.34
              ],
              [
                2.36,
                8.34
              ],
              [
                3,
                8.16
              ],
              [
                3.6,
                7.57
              ],
              [
                3.6,
                7.57
              ],
              [
                3.6,
                4.29
              ],
              [
                4.38,
                4.29
              ],
              [
                4.38,
                8.9
              ],
              [
                3.74,
                8.9
              ],
              [
                3.67,
                8.18
              ],
              [
                3.64,
                8.18
              ],
              [
                2.96,
                8.79
              ],
              [
                2.12,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.49,
                0
              ],
              [
                -0.23,
                -0.31
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.43
              ],
              [
                0.14,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0
              ],
              [
                0.19,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.25
              ],
              [
                -0.24,
                0.15
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1193,
    ty: 3,
    parent: 1182,
    ks: {
      p: {
        a: 0,
        k: [
          5.849,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1196,
    ty: 4,
    parent: 1195,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.3
              ],
              [
                0.2,
                0.5
              ],
              [
                0,
                0.7
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.5
              ],
              [
                -0.4,
                0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.2,
                -0.4
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                -0.7,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                3.3,
                9
              ],
              [
                3.3,
                9
              ],
              [
                1.8,
                8.6
              ],
              [
                0.9,
                7.5
              ],
              [
                0.5,
                5.8
              ],
              [
                0.5,
                5.8
              ],
              [
                0.9,
                4.1
              ],
              [
                1.9,
                3
              ],
              [
                3.3,
                2.6
              ],
              [
                3.3,
                2.6
              ],
              [
                4.4,
                2.8
              ],
              [
                5.1,
                3.3
              ],
              [
                5.1,
                3.3
              ],
              [
                4.7,
                3.8
              ],
              [
                4.2,
                3.4
              ],
              [
                3.4,
                3.3
              ],
              [
                3.4,
                3.3
              ],
              [
                2.3,
                3.6
              ],
              [
                1.6,
                4.4
              ],
              [
                1.3,
                5.8
              ],
              [
                1.3,
                5.8
              ],
              [
                1.8,
                7.6
              ],
              [
                3.4,
                8.3
              ],
              [
                3.4,
                8.3
              ],
              [
                4,
                8.2
              ],
              [
                4.5,
                8
              ],
              [
                4.5,
                8
              ],
              [
                4.5,
                6.3
              ],
              [
                3.2,
                6.3
              ],
              [
                3.2,
                5.7
              ],
              [
                5.2,
                5.7
              ],
              [
                5.2,
                8.3
              ],
              [
                4.4,
                8.8
              ],
              [
                3.3,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.4,
                -0.3
              ],
              [
                -0.2,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.7
              ],
              [
                0.2,
                -0.5
              ],
              [
                0.4,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.2,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.8
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1195,
    ty: 3,
    parent: 1182,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1182,
    ty: 3,
    parent: 1181,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1181,
    ty: 3,
    parent: 1180,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1180,
    ty: 3,
    parent: 1179,
    ks: {
      p: {
        a: 0,
        k: [
          16.255,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1206,
    ty: 0,
    parent: 1197,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.582
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    w: 10.837,
    h: 10.837,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1204"
  },
  {
    ind: 1197,
    ty: 3,
    parent: 1179,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1179,
    ty: 3,
    parent: 1178,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          14.709
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1212,
    ty: 4,
    parent: 1211,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.2,
                9
              ],
              [
                2.2,
                9
              ],
              [
                1,
                8.8
              ],
              [
                0.2,
                8.2
              ],
              [
                0.2,
                8.2
              ],
              [
                0.6,
                7.7
              ],
              [
                1.3,
                8.2
              ],
              [
                2.2,
                8.4
              ],
              [
                2.2,
                8.4
              ],
              [
                3.1,
                8.1
              ],
              [
                3.4,
                7.3
              ],
              [
                3.4,
                7.3
              ],
              [
                3.3,
                6.6
              ],
              [
                2.7,
                6.2
              ],
              [
                1.5,
                6.1
              ],
              [
                1.5,
                6.1
              ],
              [
                1.5,
                5.5
              ],
              [
                2.5,
                5.3
              ],
              [
                3.1,
                4.9
              ],
              [
                3.2,
                4.3
              ],
              [
                3.2,
                4.3
              ],
              [
                2.9,
                3.6
              ],
              [
                2.2,
                3.4
              ],
              [
                2.2,
                3.4
              ],
              [
                1.5,
                3.5
              ],
              [
                0.9,
                4
              ],
              [
                0.9,
                4
              ],
              [
                0.5,
                3.5
              ],
              [
                1.3,
                3
              ],
              [
                2.2,
                2.7
              ],
              [
                2.2,
                2.7
              ],
              [
                3.5,
                3.1
              ],
              [
                4,
                4.3
              ],
              [
                4,
                4.3
              ],
              [
                3.7,
                5.2
              ],
              [
                2.9,
                5.7
              ],
              [
                2.9,
                5.7
              ],
              [
                2.9,
                5.8
              ],
              [
                3.8,
                6.3
              ],
              [
                4.2,
                7.3
              ],
              [
                4.2,
                7.3
              ],
              [
                4,
                8.2
              ],
              [
                3.2,
                8.8
              ],
              [
                2.2,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.1
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1211,
    ty: 3,
    parent: 1210,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1210,
    ty: 3,
    parent: 1209,
    ks: {
      p: {
        a: 0,
        k: [
          74.372,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1215,
    ty: 4,
    parent: 1214,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.17
              ],
              [
                -0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.06,
                0.01
              ],
              [
                0.09,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.16
              ],
              [
                0.16,
                -0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                5.13
              ],
              [
                1.52,
                5.13
              ],
              [
                2.1,
                4.44
              ],
              [
                2.83,
                4.18
              ],
              [
                2.83,
                4.18
              ],
              [
                3.32,
                4.27
              ],
              [
                3.32,
                4.27
              ],
              [
                3.17,
                4.96
              ],
              [
                2.96,
                4.9
              ],
              [
                2.72,
                4.88
              ],
              [
                2.72,
                4.88
              ],
              [
                2.11,
                5.12
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.29
              ],
              [
                0.23,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.06,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.21,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1214,
    ty: 3,
    parent: 1213,
    ks: {
      p: {
        a: 0,
        k: [
          31.881,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1217,
    ty: 4,
    parent: 1216,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.2
              ],
              [
                -0.35,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.39
              ],
              [
                0,
                -0.66
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.08
              ],
              [
                0.01,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                -0.29
              ],
              [
                -0.44,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.07
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.09
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                2.65,
                9.02
              ],
              [
                2.65,
                9.02
              ],
              [
                1.53,
                8.73
              ],
              [
                0.73,
                7.9
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.31
              ],
              [
                1.51,
                4.47
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.86,
                4.77
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.58
              ],
              [
                4.31,
                6.79
              ],
              [
                4.31,
                6.79
              ],
              [
                1.2,
                6.79
              ],
              [
                1.66,
                7.95
              ],
              [
                2.74,
                8.39
              ],
              [
                2.74,
                8.39
              ],
              [
                3.35,
                8.29
              ],
              [
                3.89,
                8.03
              ],
              [
                3.89,
                8.03
              ],
              [
                4.16,
                8.54
              ],
              [
                3.49,
                8.87
              ],
              [
                2.65,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.41,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.59,
                0
              ],
              [
                0.32,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.03,
                0.49
              ],
              [
                0.27,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.19,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.13
              ],
              [
                -0.25,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.24
              ],
              [
                0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.25
              ],
              [
                0.05,
                -0.46
              ]
            ],
            v: [
              [
                1.19,
                6.23
              ],
              [
                1.19,
                6.23
              ],
              [
                3.66,
                6.23
              ],
              [
                3.36,
                5.16
              ],
              [
                2.52,
                4.8
              ],
              [
                2.52,
                4.8
              ],
              [
                1.65,
                5.17
              ],
              [
                1.19,
                6.23
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.47
              ],
              [
                -0.2,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.26,
                0.25
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1216,
    ty: 3,
    parent: 1213,
    ks: {
      p: {
        a: 0,
        k: [
          27.179,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1219,
    ty: 4,
    parent: 1218,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.2
              ],
              [
                -0.35,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.39
              ],
              [
                0,
                -0.66
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.08
              ],
              [
                0.01,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                -0.29
              ],
              [
                -0.44,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.07
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.09
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                2.65,
                9.02
              ],
              [
                2.65,
                9.02
              ],
              [
                1.53,
                8.73
              ],
              [
                0.73,
                7.9
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.31
              ],
              [
                1.51,
                4.47
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.86,
                4.77
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.58
              ],
              [
                4.31,
                6.79
              ],
              [
                4.31,
                6.79
              ],
              [
                1.2,
                6.79
              ],
              [
                1.66,
                7.95
              ],
              [
                2.74,
                8.39
              ],
              [
                2.74,
                8.39
              ],
              [
                3.35,
                8.29
              ],
              [
                3.89,
                8.03
              ],
              [
                3.89,
                8.03
              ],
              [
                4.16,
                8.54
              ],
              [
                3.49,
                8.87
              ],
              [
                2.65,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.41,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.59,
                0
              ],
              [
                0.32,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.03,
                0.49
              ],
              [
                0.27,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.19,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.13
              ],
              [
                -0.25,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.24
              ],
              [
                0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.25
              ],
              [
                0.05,
                -0.46
              ]
            ],
            v: [
              [
                1.19,
                6.23
              ],
              [
                1.19,
                6.23
              ],
              [
                3.66,
                6.23
              ],
              [
                3.36,
                5.16
              ],
              [
                2.52,
                4.8
              ],
              [
                2.52,
                4.8
              ],
              [
                1.65,
                5.17
              ],
              [
                1.19,
                6.23
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.47
              ],
              [
                -0.2,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.26,
                0.25
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1218,
    ty: 3,
    parent: 1213,
    ks: {
      p: {
        a: 0,
        k: [
          22.477,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1221,
    ty: 4,
    parent: 1220,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                0.15
              ],
              [
                -0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.31
              ],
              [
                0,
                -0.59
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.12
              ],
              [
                0.23,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                4.96
              ],
              [
                1.52,
                4.96
              ],
              [
                2.22,
                4.4
              ],
              [
                3.06,
                4.18
              ],
              [
                3.06,
                4.18
              ],
              [
                4.13,
                4.64
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                8.9
              ],
              [
                3.69,
                8.9
              ],
              [
                3.69,
                6.09
              ],
              [
                3.48,
                5.15
              ],
              [
                2.82,
                4.85
              ],
              [
                2.82,
                4.85
              ],
              [
                2.19,
                5.03
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.22
              ],
              [
                0.25,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0.49,
                0
              ],
              [
                0.22,
                0.31
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.43
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.19,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1220,
    ty: 3,
    parent: 1213,
    ks: {
      p: {
        a: 0,
        k: [
          17.291,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1223,
    ty: 4,
    parent: 1222,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                4.3
              ],
              [
                1.6,
                4.3
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.3
              ],
              [
                1.2,
                3.3
              ],
              [
                0.8,
                3.2
              ],
              [
                0.7,
                2.8
              ],
              [
                0.7,
                2.8
              ],
              [
                0.8,
                2.5
              ],
              [
                1.2,
                2.3
              ],
              [
                1.2,
                2.3
              ],
              [
                1.6,
                2.5
              ],
              [
                1.7,
                2.8
              ],
              [
                1.7,
                2.8
              ],
              [
                1.6,
                3.2
              ],
              [
                1.2,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1222,
    ty: 3,
    parent: 1213,
    ks: {
      p: {
        a: 0,
        k: [
          14.959,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1225,
    ty: 4,
    parent: 1224,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.3,
                11
              ],
              [
                2.3,
                11
              ],
              [
                1,
                10.7
              ],
              [
                0.4,
                9.8
              ],
              [
                0.4,
                9.8
              ],
              [
                0.6,
                9.2
              ],
              [
                1.1,
                8.7
              ],
              [
                1.1,
                8.7
              ],
              [
                1.1,
                8.7
              ],
              [
                0.8,
                8.4
              ],
              [
                0.7,
                8
              ],
              [
                0.7,
                8
              ],
              [
                0.9,
                7.4
              ],
              [
                1.2,
                7.1
              ],
              [
                1.2,
                7.1
              ],
              [
                1.2,
                7.1
              ],
              [
                0.8,
                6.6
              ],
              [
                0.6,
                5.8
              ],
              [
                0.6,
                5.8
              ],
              [
                0.8,
                4.9
              ],
              [
                1.5,
                4.4
              ],
              [
                2.3,
                4.2
              ],
              [
                2.3,
                4.2
              ],
              [
                2.7,
                4.2
              ],
              [
                3,
                4.3
              ],
              [
                3,
                4.3
              ],
              [
                4.6,
                4.3
              ],
              [
                4.6,
                4.9
              ],
              [
                3.6,
                4.9
              ],
              [
                3.9,
                5.3
              ],
              [
                4,
                5.8
              ],
              [
                4,
                5.8
              ],
              [
                3.8,
                6.7
              ],
              [
                3.2,
                7.2
              ],
              [
                2.3,
                7.4
              ],
              [
                2.3,
                7.4
              ],
              [
                1.6,
                7.3
              ],
              [
                1.6,
                7.3
              ],
              [
                1.4,
                7.5
              ],
              [
                1.3,
                7.8
              ],
              [
                1.3,
                7.8
              ],
              [
                1.5,
                8.2
              ],
              [
                2.2,
                8.3
              ],
              [
                2.2,
                8.3
              ],
              [
                3.1,
                8.3
              ],
              [
                4.3,
                8.6
              ],
              [
                4.7,
                9.4
              ],
              [
                4.7,
                9.4
              ],
              [
                4.4,
                10.2
              ],
              [
                3.6,
                10.8
              ],
              [
                2.3,
                11
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.3,
                6.9
              ],
              [
                2.3,
                6.9
              ],
              [
                3,
                6.6
              ],
              [
                3.3,
                5.8
              ],
              [
                3.3,
                5.8
              ],
              [
                3,
                5
              ],
              [
                2.3,
                4.7
              ],
              [
                2.3,
                4.7
              ],
              [
                1.6,
                5
              ],
              [
                1.4,
                5.8
              ],
              [
                1.4,
                5.8
              ],
              [
                1.6,
                6.6
              ],
              [
                2.3,
                6.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.4,
                0
              ]
            ],
            v: [
              [
                2.4,
                10.5
              ],
              [
                2.4,
                10.5
              ],
              [
                3.5,
                10.2
              ],
              [
                3.9,
                9.5
              ],
              [
                3.9,
                9.5
              ],
              [
                3.7,
                9.1
              ],
              [
                3,
                9
              ],
              [
                3,
                9
              ],
              [
                2.2,
                9
              ],
              [
                1.9,
                9
              ],
              [
                1.6,
                8.9
              ],
              [
                1.6,
                8.9
              ],
              [
                1.2,
                9.3
              ],
              [
                1.1,
                9.7
              ],
              [
                1.1,
                9.7
              ],
              [
                1.5,
                10.3
              ],
              [
                2.4,
                10.5
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1224,
    ty: 3,
    parent: 1213,
    ks: {
      p: {
        a: 0,
        k: [
          10.182,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1227,
    ty: 4,
    parent: 1226,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                0.15
              ],
              [
                -0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.31
              ],
              [
                0,
                -0.59
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.12
              ],
              [
                0.23,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                4.96
              ],
              [
                1.52,
                4.96
              ],
              [
                2.22,
                4.4
              ],
              [
                3.06,
                4.18
              ],
              [
                3.06,
                4.18
              ],
              [
                4.13,
                4.64
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                8.9
              ],
              [
                3.69,
                8.9
              ],
              [
                3.69,
                6.09
              ],
              [
                3.48,
                5.15
              ],
              [
                2.82,
                4.85
              ],
              [
                2.82,
                4.85
              ],
              [
                2.19,
                5.03
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.22
              ],
              [
                0.25,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0.49,
                0
              ],
              [
                0.22,
                0.31
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.43
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.19,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1226,
    ty: 3,
    parent: 1213,
    ks: {
      p: {
        a: 0,
        k: [
          4.996,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1229,
    ty: 4,
    parent: 1228,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                4.5,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                2.7
              ],
              [
                4.4,
                2.7
              ],
              [
                4.4,
                3.3
              ],
              [
                1.6,
                3.3
              ],
              [
                1.6,
                5.3
              ],
              [
                4,
                5.3
              ],
              [
                4,
                6
              ],
              [
                1.6,
                6
              ],
              [
                1.6,
                8.2
              ],
              [
                4.5,
                8.2
              ],
              [
                4.5,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1228,
    ty: 3,
    parent: 1213,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1213,
    ty: 3,
    parent: 1209,
    ks: {
      p: {
        a: 0,
        k: [
          37.305,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1232,
    ty: 4,
    parent: 1231,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.2
              ],
              [
                -0.35,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.39
              ],
              [
                0,
                -0.66
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.08
              ],
              [
                0.01,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                -0.29
              ],
              [
                -0.44,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.07
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.09
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                2.65,
                9.02
              ],
              [
                2.65,
                9.02
              ],
              [
                1.53,
                8.73
              ],
              [
                0.73,
                7.9
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.31
              ],
              [
                1.51,
                4.47
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.86,
                4.77
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.58
              ],
              [
                4.31,
                6.79
              ],
              [
                4.31,
                6.79
              ],
              [
                1.2,
                6.79
              ],
              [
                1.66,
                7.95
              ],
              [
                2.74,
                8.39
              ],
              [
                2.74,
                8.39
              ],
              [
                3.35,
                8.29
              ],
              [
                3.89,
                8.03
              ],
              [
                3.89,
                8.03
              ],
              [
                4.16,
                8.54
              ],
              [
                3.49,
                8.87
              ],
              [
                2.65,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.41,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.59,
                0
              ],
              [
                0.32,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.03,
                0.49
              ],
              [
                0.27,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.19,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.13
              ],
              [
                -0.25,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.24
              ],
              [
                0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.25
              ],
              [
                0.05,
                -0.46
              ]
            ],
            v: [
              [
                1.19,
                6.23
              ],
              [
                1.19,
                6.23
              ],
              [
                3.66,
                6.23
              ],
              [
                3.36,
                5.16
              ],
              [
                2.52,
                4.8
              ],
              [
                2.52,
                4.8
              ],
              [
                1.65,
                5.17
              ],
              [
                1.19,
                6.23
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.47
              ],
              [
                -0.2,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.26,
                0.25
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1231,
    ty: 3,
    parent: 1230,
    ks: {
      p: {
        a: 0,
        k: [
          30.707,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1234,
    ty: 4,
    parent: 1233,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.17
              ],
              [
                -0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.06,
                0.01
              ],
              [
                0.09,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.16
              ],
              [
                0.16,
                -0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                5.13
              ],
              [
                1.52,
                5.13
              ],
              [
                2.1,
                4.44
              ],
              [
                2.83,
                4.18
              ],
              [
                2.83,
                4.18
              ],
              [
                3.32,
                4.27
              ],
              [
                3.32,
                4.27
              ],
              [
                3.17,
                4.96
              ],
              [
                2.96,
                4.9
              ],
              [
                2.72,
                4.88
              ],
              [
                2.72,
                4.88
              ],
              [
                2.11,
                5.12
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.29
              ],
              [
                0.23,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.06,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.21,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1233,
    ty: 3,
    parent: 1230,
    ks: {
      p: {
        a: 0,
        k: [
          27.417,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1236,
    ty: 4,
    parent: 1235,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.23
              ],
              [
                0,
                0.41
              ],
              [
                0,
                0
              ],
              [
                -0.45,
                0.27
              ],
              [
                -0.98,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.18
              ],
              [
                0.14,
                0.11
              ],
              [
                0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.1
              ],
              [
                0.18,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.31,
                0.13
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.34
              ],
              [
                0,
                -0.58
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.13
              ],
              [
                0.29,
                0
              ]
            ],
            v: [
              [
                1.84,
                9.02
              ],
              [
                1.84,
                9.02
              ],
              [
                0.88,
                8.67
              ],
              [
                0.49,
                7.71
              ],
              [
                0.49,
                7.71
              ],
              [
                1.17,
                6.55
              ],
              [
                3.32,
                5.98
              ],
              [
                3.32,
                5.98
              ],
              [
                3.24,
                5.42
              ],
              [
                2.95,
                4.99
              ],
              [
                2.37,
                4.82
              ],
              [
                2.37,
                4.82
              ],
              [
                1.62,
                4.98
              ],
              [
                1,
                5.32
              ],
              [
                1,
                5.32
              ],
              [
                0.69,
                4.78
              ],
              [
                1.48,
                4.37
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.73,
                4.7
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                8.9
              ],
              [
                3.46,
                8.9
              ],
              [
                3.39,
                8.35
              ],
              [
                3.37,
                8.35
              ],
              [
                2.66,
                8.82
              ],
              [
                1.84,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.26,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.45,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.05,
                -0.18
              ],
              [
                -0.14,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.14
              ],
              [
                0.31,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.56,
                0
              ],
              [
                0.25,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.26,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.11
              ],
              [
                -0.22,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.19
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.23,
                0
              ]
            ],
            v: [
              [
                2.07,
                8.39
              ],
              [
                2.07,
                8.39
              ],
              [
                2.69,
                8.23
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                6.49
              ],
              [
                1.71,
                6.92
              ],
              [
                1.25,
                7.65
              ],
              [
                1.25,
                7.65
              ],
              [
                1.49,
                8.21
              ],
              [
                2.07,
                8.39
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.2,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.76,
                0.09
              ],
              [
                -0.31,
                0.19
              ],
              [
                0,
                0
              ],
              [
                0,
                0.26
              ],
              [
                0.16,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1235,
    ty: 3,
    parent: 1230,
    ks: {
      p: {
        a: 0,
        k: [
          22.64,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1238,
    ty: 4,
    parent: 1237,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.9
              ],
              [
                1.5,
                8.9
              ],
              [
                0.2,
                4.3
              ],
              [
                1,
                4.3
              ],
              [
                1.7,
                7
              ],
              [
                1.8,
                7.6
              ],
              [
                2,
                8.2
              ],
              [
                2,
                8.2
              ],
              [
                2,
                8.2
              ],
              [
                2.2,
                7.6
              ],
              [
                2.3,
                7
              ],
              [
                2.3,
                7
              ],
              [
                3,
                4.3
              ],
              [
                3.8,
                4.3
              ],
              [
                4.5,
                7
              ],
              [
                4.7,
                7.6
              ],
              [
                4.8,
                8.2
              ],
              [
                4.8,
                8.2
              ],
              [
                4.9,
                8.2
              ],
              [
                5,
                7.6
              ],
              [
                5.2,
                7
              ],
              [
                5.2,
                7
              ],
              [
                5.8,
                4.3
              ],
              [
                6.6,
                4.3
              ],
              [
                5.3,
                8.9
              ],
              [
                4.4,
                8.9
              ],
              [
                3.7,
                6.4
              ],
              [
                3.6,
                5.8
              ],
              [
                3.4,
                5.1
              ],
              [
                3.4,
                5.1
              ],
              [
                3.4,
                5.1
              ],
              [
                3.2,
                5.8
              ],
              [
                3.1,
                6.4
              ],
              [
                3.1,
                6.4
              ],
              [
                2.4,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1237,
    ty: 3,
    parent: 1230,
    ks: {
      p: {
        a: 0,
        k: [
          15.833,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1240,
    ty: 4,
    parent: 1239,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.7,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                4.9
              ],
              [
                0.3,
                4.9
              ],
              [
                0.3,
                4.3
              ],
              [
                0.9,
                4.3
              ],
              [
                0.9,
                3.6
              ],
              [
                1.2,
                2.4
              ],
              [
                2.3,
                2
              ],
              [
                2.3,
                2
              ],
              [
                2.7,
                2.1
              ],
              [
                3,
                2.2
              ],
              [
                3,
                2.2
              ],
              [
                2.9,
                2.8
              ],
              [
                2.3,
                2.7
              ],
              [
                2.3,
                2.7
              ],
              [
                1.7,
                3.6
              ],
              [
                1.7,
                3.6
              ],
              [
                1.7,
                4.3
              ],
              [
                2.7,
                4.3
              ],
              [
                2.7,
                4.9
              ],
              [
                1.7,
                4.9
              ],
              [
                1.7,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                5,
                9
              ],
              [
                5,
                9
              ],
              [
                4,
                8.6
              ],
              [
                3.7,
                7.5
              ],
              [
                3.7,
                7.5
              ],
              [
                3.7,
                4.9
              ],
              [
                3,
                4.9
              ],
              [
                3,
                4.3
              ],
              [
                3.7,
                4.3
              ],
              [
                3.8,
                3
              ],
              [
                4.5,
                3
              ],
              [
                4.5,
                4.3
              ],
              [
                5.7,
                4.3
              ],
              [
                5.7,
                4.9
              ],
              [
                4.5,
                4.9
              ],
              [
                4.5,
                7.5
              ],
              [
                4.6,
                8.1
              ],
              [
                5.2,
                8.4
              ],
              [
                5.2,
                8.4
              ],
              [
                5.4,
                8.3
              ],
              [
                5.7,
                8.3
              ],
              [
                5.7,
                8.3
              ],
              [
                5.9,
                8.8
              ],
              [
                5.4,
                9
              ],
              [
                5,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1239,
    ty: 3,
    parent: 1230,
    ks: {
      p: {
        a: 0,
        k: [
          10.2,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1242,
    ty: 4,
    parent: 1241,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.33,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.33,
                0.19
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                -0.52
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.19
              ],
              [
                0.38,
                0
              ]
            ],
            v: [
              [
                2.57,
                9.02
              ],
              [
                2.57,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.73,
                7.91
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.29
              ],
              [
                1.52,
                4.46
              ],
              [
                2.57,
                4.18
              ],
              [
                2.57,
                4.18
              ],
              [
                3.62,
                4.46
              ],
              [
                4.4,
                5.29
              ],
              [
                4.7,
                6.61
              ],
              [
                4.7,
                6.61
              ],
              [
                4.4,
                7.91
              ],
              [
                3.62,
                8.73
              ],
              [
                2.57,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.37,
                0
              ],
              [
                -0.33,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.52
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.33,
                -0.19
              ],
              [
                0,
                0
              ],
              [
                0.38,
                0
              ],
              [
                0.32,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                0.51
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.19
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                0.33
              ],
              [
                0,
                0.52
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.33
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.33
              ],
              [
                0,
                -0.53
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.33
              ],
              [
                -0.39,
                0
              ]
            ],
            v: [
              [
                2.57,
                8.37
              ],
              [
                2.57,
                8.37
              ],
              [
                3.53,
                7.88
              ],
              [
                3.9,
                6.61
              ],
              [
                3.9,
                6.61
              ],
              [
                3.53,
                5.32
              ],
              [
                2.57,
                4.82
              ],
              [
                2.57,
                4.82
              ],
              [
                1.61,
                5.32
              ],
              [
                1.24,
                6.61
              ],
              [
                1.24,
                6.61
              ],
              [
                1.61,
                7.88
              ],
              [
                2.57,
                8.37
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.24,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.53
              ],
              [
                -0.24,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.25,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.52
              ],
              [
                0.25,
                0.33
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1241,
    ty: 3,
    parent: 1230,
    ks: {
      p: {
        a: 0,
        k: [
          5.062,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1244,
    ty: 4,
    parent: 1243,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                0.9,
                7.5
              ],
              [
                1.7,
                8.1
              ],
              [
                2.6,
                8.3
              ],
              [
                2.6,
                8.3
              ],
              [
                3.5,
                8
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.8,
                6.8
              ],
              [
                3.4,
                6.5
              ],
              [
                2.9,
                6.2
              ],
              [
                2.9,
                6.2
              ],
              [
                2,
                5.8
              ],
              [
                1.4,
                5.5
              ],
              [
                0.9,
                5
              ],
              [
                0.7,
                4.2
              ],
              [
                0.7,
                4.2
              ],
              [
                1,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.7,
                2.8
              ],
              [
                4.5,
                3.3
              ],
              [
                4.5,
                3.3
              ],
              [
                4.1,
                3.8
              ],
              [
                3.4,
                3.4
              ],
              [
                2.7,
                3.3
              ],
              [
                2.7,
                3.3
              ],
              [
                1.8,
                3.5
              ],
              [
                1.5,
                4.2
              ],
              [
                1.5,
                4.2
              ],
              [
                1.7,
                4.7
              ],
              [
                2,
                5
              ],
              [
                2.5,
                5.2
              ],
              [
                2.5,
                5.2
              ],
              [
                3.4,
                5.6
              ],
              [
                4.1,
                5.9
              ],
              [
                4.5,
                6.5
              ],
              [
                4.7,
                7.2
              ],
              [
                4.7,
                7.2
              ],
              [
                4.4,
                8.1
              ],
              [
                3.7,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1243,
    ty: 3,
    parent: 1230,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1230,
    ty: 3,
    parent: 1209,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1209,
    ty: 3,
    parent: 1208,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.469
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1208,
    ty: 3,
    parent: 1207,
    ks: {
      p: {
        a: 0,
        k: [
          16.255,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1254,
    ty: 0,
    parent: 1245,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.582
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    w: 10.837,
    h: 10.837,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1252"
  },
  {
    ind: 1245,
    ty: 3,
    parent: 1207,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1207,
    ty: 3,
    parent: 1178,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1178,
    ty: 3,
    parent: 1177,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          27.418
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1260,
    ty: 4,
    parent: 1259,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.6,
                0.4
              ],
              [
                -1.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.3
              ],
              [
                2.3,
                15.3
              ],
              [
                1.1,
                14.8
              ],
              [
                0.6,
                13.6
              ],
              [
                0.6,
                13.6
              ],
              [
                1.4,
                12.1
              ],
              [
                4.1,
                11.3
              ],
              [
                4.1,
                11.3
              ],
              [
                3.8,
                10.5
              ],
              [
                3,
                10.2
              ],
              [
                3,
                10.2
              ],
              [
                2.1,
                10.3
              ],
              [
                1.3,
                10.8
              ],
              [
                1.3,
                10.8
              ],
              [
                0.8,
                9.8
              ],
              [
                1.9,
                9.3
              ],
              [
                3.3,
                9
              ],
              [
                3.3,
                9
              ],
              [
                4.9,
                9.7
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                15.2
              ],
              [
                4.3,
                15.2
              ],
              [
                4.2,
                14.5
              ],
              [
                4.2,
                14.5
              ],
              [
                3.3,
                15.1
              ],
              [
                2.3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.6,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.8,
                14.2
              ],
              [
                2.8,
                14.2
              ],
              [
                3.5,
                14
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                12.2
              ],
              [
                2.4,
                12.7
              ],
              [
                1.9,
                13.5
              ],
              [
                1.9,
                13.5
              ],
              [
                2.2,
                14
              ],
              [
                2.8,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.8,
                0.1
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1259,
    ty: 3,
    parent: 1258,
    ks: {
      p: {
        a: 0,
        k: [
          18.383,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1262,
    ty: 4,
    parent: 1261,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.2,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                9.2
              ],
              [
                2,
                9.2
              ],
              [
                2.1,
                10.2
              ],
              [
                2.2,
                10.2
              ],
              [
                3,
                9.3
              ],
              [
                3.9,
                9
              ],
              [
                3.9,
                9
              ],
              [
                4.6,
                9.2
              ],
              [
                4.6,
                9.2
              ],
              [
                4.3,
                10.4
              ],
              [
                4,
                10.3
              ],
              [
                3.7,
                10.3
              ],
              [
                3.7,
                10.3
              ],
              [
                3,
                10.6
              ],
              [
                2.3,
                11.5
              ],
              [
                2.3,
                11.5
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1261,
    ty: 3,
    parent: 1258,
    ks: {
      p: {
        a: 0,
        k: [
          13.836,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1264,
    ty: 4,
    parent: 1263,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.5
              ],
              [
                0,
                0.7
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.5
              ],
              [
                -0.4,
                0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.2,
                -0.4
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                3.5,
                15.3
              ],
              [
                3.5,
                15.3
              ],
              [
                2,
                14.9
              ],
              [
                0.9,
                13.9
              ],
              [
                0.5,
                12.2
              ],
              [
                0.5,
                12.2
              ],
              [
                0.9,
                10.5
              ],
              [
                1.9,
                9.4
              ],
              [
                3.3,
                9
              ],
              [
                3.3,
                9
              ],
              [
                4.6,
                9.4
              ],
              [
                5.4,
                10.4
              ],
              [
                5.7,
                11.9
              ],
              [
                5.7,
                11.9
              ],
              [
                5.7,
                12.6
              ],
              [
                5.7,
                12.6
              ],
              [
                1.9,
                12.6
              ],
              [
                2.4,
                13.8
              ],
              [
                3.6,
                14.2
              ],
              [
                3.6,
                14.2
              ],
              [
                4.4,
                14.1
              ],
              [
                5,
                13.8
              ],
              [
                5,
                13.8
              ],
              [
                5.5,
                14.7
              ],
              [
                4.5,
                15.1
              ],
              [
                3.5,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.3,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.7
              ],
              [
                0.3,
                -0.5
              ],
              [
                0.4,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.5
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.1,
                -0.5
              ]
            ],
            v: [
              [
                1.9,
                11.6
              ],
              [
                1.9,
                11.6
              ],
              [
                4.5,
                11.6
              ],
              [
                4.2,
                10.5
              ],
              [
                3.3,
                10.1
              ],
              [
                3.3,
                10.1
              ],
              [
                2.4,
                10.5
              ],
              [
                1.9,
                11.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1263,
    ty: 3,
    parent: 1258,
    ks: {
      p: {
        a: 0,
        k: [
          7.655,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1266,
    ty: 4,
    parent: 1265,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0.3
              ],
              [
                0.3,
                0.6
              ],
              [
                0,
                0.9
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.6
              ],
              [
                -0.6,
                0.3
              ],
              [
                -0.7,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.5
              ],
              [
                0,
                -0.9
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                -0.8,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                4.4,
                15.3
              ],
              [
                4.4,
                15.3
              ],
              [
                2.4,
                14.8
              ],
              [
                1.1,
                13.4
              ],
              [
                0.6,
                11.2
              ],
              [
                0.6,
                11.2
              ],
              [
                1.1,
                9
              ],
              [
                2.5,
                7.5
              ],
              [
                4.4,
                7.1
              ],
              [
                4.4,
                7.1
              ],
              [
                5.8,
                7.4
              ],
              [
                6.8,
                8.1
              ],
              [
                6.8,
                8.1
              ],
              [
                6,
                9
              ],
              [
                5.3,
                8.5
              ],
              [
                4.4,
                8.3
              ],
              [
                4.4,
                8.3
              ],
              [
                2.7,
                9.1
              ],
              [
                2,
                11.2
              ],
              [
                2,
                11.2
              ],
              [
                2.7,
                13.3
              ],
              [
                4.5,
                14.1
              ],
              [
                4.5,
                14.1
              ],
              [
                5.1,
                14
              ],
              [
                5.6,
                13.7
              ],
              [
                5.6,
                13.7
              ],
              [
                5.6,
                12
              ],
              [
                4.1,
                12
              ],
              [
                4.1,
                10.9
              ],
              [
                6.9,
                10.9
              ],
              [
                6.9,
                14.4
              ],
              [
                5.8,
                15
              ],
              [
                4.4,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.7,
                0
              ],
              [
                -0.6,
                -0.3
              ],
              [
                -0.3,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.9
              ],
              [
                0.3,
                -0.6
              ],
              [
                0.6,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.7,
                0
              ],
              [
                -0.4,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0.9
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.4,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1265,
    ty: 3,
    parent: 1258,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1258,
    ty: 3,
    parent: 1257,
    ks: {
      p: {
        a: 0,
        k: [
          61.486,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1269,
    ty: 4,
    parent: 1268,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.7,
                15.3
              ],
              [
                2.7,
                15.3
              ],
              [
                1.3,
                14.7
              ],
              [
                0.8,
                12.9
              ],
              [
                0.8,
                12.9
              ],
              [
                0.8,
                9.2
              ],
              [
                2.2,
                9.2
              ],
              [
                2.2,
                12.8
              ],
              [
                2.5,
                13.8
              ],
              [
                3.2,
                14.1
              ],
              [
                3.2,
                14.1
              ],
              [
                3.8,
                13.9
              ],
              [
                4.5,
                13.3
              ],
              [
                4.5,
                13.3
              ],
              [
                4.5,
                9.2
              ],
              [
                5.9,
                9.2
              ],
              [
                5.9,
                15.2
              ],
              [
                4.7,
                15.2
              ],
              [
                4.6,
                14.3
              ],
              [
                4.6,
                14.3
              ],
              [
                3.7,
                15
              ],
              [
                2.7,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1268,
    ty: 3,
    parent: 1267,
    ks: {
      p: {
        a: 0,
        k: [
          52.271,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1271,
    ty: 4,
    parent: 1270,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                6.6
              ],
              [
                2.3,
                6.6
              ],
              [
                2.3,
                8.8
              ],
              [
                2.2,
                9.9
              ],
              [
                3.1,
                9.3
              ],
              [
                4.2,
                9
              ],
              [
                4.2,
                9
              ],
              [
                5.6,
                9.7
              ],
              [
                6,
                11.4
              ],
              [
                6,
                11.4
              ],
              [
                6,
                15.2
              ],
              [
                4.6,
                15.2
              ],
              [
                4.6,
                11.6
              ],
              [
                4.4,
                10.6
              ],
              [
                3.7,
                10.2
              ],
              [
                3.7,
                10.2
              ],
              [
                3,
                10.4
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1270,
    ty: 3,
    parent: 1267,
    ks: {
      p: {
        a: 0,
        k: [
          45.469,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1273,
    ty: 4,
    parent: 1272,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.3
              ],
              [
                -0.7,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.4
              ],
              [
                0.8,
                0
              ]
            ],
            v: [
              [
                2.6,
                15.3
              ],
              [
                2.6,
                15.3
              ],
              [
                1.3,
                15.1
              ],
              [
                0.3,
                14.5
              ],
              [
                0.3,
                14.5
              ],
              [
                1,
                13.6
              ],
              [
                1.8,
                14.1
              ],
              [
                2.6,
                14.3
              ],
              [
                2.6,
                14.3
              ],
              [
                3.3,
                14
              ],
              [
                3.6,
                13.5
              ],
              [
                3.6,
                13.5
              ],
              [
                3.4,
                13.1
              ],
              [
                2.9,
                12.8
              ],
              [
                2.3,
                12.6
              ],
              [
                2.3,
                12.6
              ],
              [
                1.5,
                12.2
              ],
              [
                0.9,
                11.7
              ],
              [
                0.6,
                10.8
              ],
              [
                0.6,
                10.8
              ],
              [
                1.2,
                9.5
              ],
              [
                2.8,
                9
              ],
              [
                2.8,
                9
              ],
              [
                3.9,
                9.3
              ],
              [
                4.8,
                9.8
              ],
              [
                4.8,
                9.8
              ],
              [
                4.2,
                10.6
              ],
              [
                3.5,
                10.2
              ],
              [
                2.8,
                10.1
              ],
              [
                2.8,
                10.1
              ],
              [
                2.2,
                10.3
              ],
              [
                2,
                10.8
              ],
              [
                2,
                10.8
              ],
              [
                2.3,
                11.3
              ],
              [
                3.2,
                11.6
              ],
              [
                3.2,
                11.6
              ],
              [
                4,
                12
              ],
              [
                4.6,
                12.6
              ],
              [
                4.9,
                13.5
              ],
              [
                4.9,
                13.5
              ],
              [
                4.3,
                14.8
              ],
              [
                2.6,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.4,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                -0.4,
                0.4
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1272,
    ty: 3,
    parent: 1267,
    ks: {
      p: {
        a: 0,
        k: [
          40.215,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1275,
    ty: 4,
    parent: 1274,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                9.2
              ],
              [
                2,
                9.2
              ],
              [
                2.1,
                10
              ],
              [
                2.2,
                10
              ],
              [
                3.1,
                9.3
              ],
              [
                4.2,
                9
              ],
              [
                4.2,
                9
              ],
              [
                5.6,
                9.7
              ],
              [
                6,
                11.4
              ],
              [
                6,
                11.4
              ],
              [
                6,
                15.2
              ],
              [
                4.6,
                15.2
              ],
              [
                4.6,
                11.6
              ],
              [
                4.4,
                10.6
              ],
              [
                3.7,
                10.2
              ],
              [
                3.7,
                10.2
              ],
              [
                3,
                10.4
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1274,
    ty: 3,
    parent: 1267,
    ks: {
      p: {
        a: 0,
        k: [
          33.388,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1277,
    ty: 4,
    parent: 1276,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.6,
                0.4
              ],
              [
                -1.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.3
              ],
              [
                2.3,
                15.3
              ],
              [
                1.1,
                14.8
              ],
              [
                0.6,
                13.6
              ],
              [
                0.6,
                13.6
              ],
              [
                1.4,
                12.1
              ],
              [
                4.1,
                11.3
              ],
              [
                4.1,
                11.3
              ],
              [
                3.8,
                10.5
              ],
              [
                3,
                10.2
              ],
              [
                3,
                10.2
              ],
              [
                2.1,
                10.3
              ],
              [
                1.3,
                10.8
              ],
              [
                1.3,
                10.8
              ],
              [
                0.8,
                9.8
              ],
              [
                1.9,
                9.3
              ],
              [
                3.3,
                9
              ],
              [
                3.3,
                9
              ],
              [
                4.9,
                9.7
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                15.2
              ],
              [
                4.3,
                15.2
              ],
              [
                4.2,
                14.5
              ],
              [
                4.2,
                14.5
              ],
              [
                3.3,
                15.1
              ],
              [
                2.3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.6,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.8,
                14.2
              ],
              [
                2.8,
                14.2
              ],
              [
                3.5,
                14
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                12.2
              ],
              [
                2.4,
                12.7
              ],
              [
                1.9,
                13.5
              ],
              [
                1.9,
                13.5
              ],
              [
                2.2,
                14
              ],
              [
                2.8,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.8,
                0.1
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1276,
    ty: 3,
    parent: 1267,
    ks: {
      p: {
        a: 0,
        k: [
          27.098,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1279,
    ty: 4,
    parent: 1278,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                6.6
              ],
              [
                2.3,
                6.6
              ],
              [
                2.3,
                8.8
              ],
              [
                2.2,
                9.9
              ],
              [
                3.1,
                9.3
              ],
              [
                4.2,
                9
              ],
              [
                4.2,
                9
              ],
              [
                5.6,
                9.7
              ],
              [
                6,
                11.4
              ],
              [
                6,
                11.4
              ],
              [
                6,
                15.2
              ],
              [
                4.6,
                15.2
              ],
              [
                4.6,
                11.6
              ],
              [
                4.4,
                10.6
              ],
              [
                3.7,
                10.2
              ],
              [
                3.7,
                10.2
              ],
              [
                3,
                10.4
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1278,
    ty: 3,
    parent: 1267,
    ks: {
      p: {
        a: 0,
        k: [
          20.296,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1281,
    ty: 4,
    parent: 1280,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.6
              ],
              [
                0,
                1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.5
              ],
              [
                -0.4,
                0.3
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                3,
                15.3
              ],
              [
                3,
                15.3
              ],
              [
                1.2,
                14.5
              ],
              [
                0.5,
                12.2
              ],
              [
                0.5,
                12.2
              ],
              [
                0.9,
                10.5
              ],
              [
                1.8,
                9.4
              ],
              [
                3.1,
                9
              ],
              [
                3.1,
                9
              ],
              [
                3.9,
                9.2
              ],
              [
                4.6,
                9.7
              ],
              [
                4.6,
                9.7
              ],
              [
                4.6,
                8.7
              ],
              [
                4.6,
                6.6
              ],
              [
                6,
                6.6
              ],
              [
                6,
                15.2
              ],
              [
                4.8,
                15.2
              ],
              [
                4.7,
                14.5
              ],
              [
                4.7,
                14.5
              ],
              [
                3.9,
                15.1
              ],
              [
                3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.7,
                0
              ],
              [
                -0.4,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.7
              ],
              [
                0.2,
                -0.5
              ],
              [
                0.4,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                -0.4,
                0
              ]
            ],
            v: [
              [
                3.3,
                14.2
              ],
              [
                3.3,
                14.2
              ],
              [
                4.6,
                13.5
              ],
              [
                4.6,
                13.5
              ],
              [
                4.6,
                10.7
              ],
              [
                4,
                10.3
              ],
              [
                3.4,
                10.2
              ],
              [
                3.4,
                10.2
              ],
              [
                2.4,
                10.7
              ],
              [
                2,
                12.2
              ],
              [
                2,
                12.2
              ],
              [
                2.3,
                13.6
              ],
              [
                3.3,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1280,
    ty: 3,
    parent: 1267,
    ks: {
      p: {
        a: 0,
        k: [
          13.421,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1283,
    ty: 4,
    parent: 1282,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.7,
                15.3
              ],
              [
                2.7,
                15.3
              ],
              [
                1.3,
                14.7
              ],
              [
                0.8,
                12.9
              ],
              [
                0.8,
                12.9
              ],
              [
                0.8,
                9.2
              ],
              [
                2.2,
                9.2
              ],
              [
                2.2,
                12.8
              ],
              [
                2.5,
                13.8
              ],
              [
                3.2,
                14.1
              ],
              [
                3.2,
                14.1
              ],
              [
                3.8,
                13.9
              ],
              [
                4.5,
                13.3
              ],
              [
                4.5,
                13.3
              ],
              [
                4.5,
                9.2
              ],
              [
                5.9,
                9.2
              ],
              [
                5.9,
                15.2
              ],
              [
                4.7,
                15.2
              ],
              [
                4.6,
                14.3
              ],
              [
                4.6,
                14.3
              ],
              [
                3.7,
                15
              ],
              [
                2.7,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1282,
    ty: 3,
    parent: 1267,
    ks: {
      p: {
        a: 0,
        k: [
          6.644,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1285,
    ty: 4,
    parent: 1284,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0.2
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.4,
                -0.2
              ],
              [
                0.6,
                0
              ]
            ],
            v: [
              [
                3.3,
                15.3
              ],
              [
                3.3,
                15.3
              ],
              [
                1.8,
                15
              ],
              [
                0.5,
                14.1
              ],
              [
                0.5,
                14.1
              ],
              [
                1.3,
                13.2
              ],
              [
                2.3,
                13.8
              ],
              [
                3.4,
                14.1
              ],
              [
                3.4,
                14.1
              ],
              [
                4.4,
                13.8
              ],
              [
                4.8,
                13.1
              ],
              [
                4.8,
                13.1
              ],
              [
                4.4,
                12.3
              ],
              [
                3.5,
                11.9
              ],
              [
                3.5,
                11.9
              ],
              [
                2.4,
                11.4
              ],
              [
                1.7,
                11
              ],
              [
                1.1,
                10.3
              ],
              [
                0.8,
                9.3
              ],
              [
                0.8,
                9.3
              ],
              [
                1.2,
                8.2
              ],
              [
                2.1,
                7.4
              ],
              [
                3.5,
                7.1
              ],
              [
                3.5,
                7.1
              ],
              [
                4.8,
                7.3
              ],
              [
                5.9,
                8.1
              ],
              [
                5.9,
                8.1
              ],
              [
                5.2,
                9
              ],
              [
                4.4,
                8.5
              ],
              [
                3.5,
                8.3
              ],
              [
                3.5,
                8.3
              ],
              [
                2.6,
                8.5
              ],
              [
                2.2,
                9.2
              ],
              [
                2.2,
                9.2
              ],
              [
                2.4,
                9.7
              ],
              [
                2.9,
                10.1
              ],
              [
                3.5,
                10.3
              ],
              [
                3.5,
                10.3
              ],
              [
                4.6,
                10.8
              ],
              [
                5.8,
                11.6
              ],
              [
                6.2,
                13
              ],
              [
                6.2,
                13
              ],
              [
                5.9,
                14.1
              ],
              [
                4.9,
                15
              ],
              [
                3.3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.5,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                -0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.4,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1284,
    ty: 3,
    parent: 1267,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1267,
    ty: 3,
    parent: 1257,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1257,
    ty: 3,
    parent: 1256,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.163
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1256,
    ty: 3,
    parent: 1255,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1255,
    ty: 3,
    parent: 1177,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1177,
    ty: 3,
    parent: 1176,
    ks: {
      p: {
        a: 0,
        k: [
          70.439,
          2.737
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1296,
    ty: 0,
    parent: 1287,
    ks: {
      a: {
        a: 0,
        k: [
          41.992,
          42.67
        ]
      },
      p: {
        a: 0,
        k: [
          41.992,
          42.67
        ]
      }
    },
    w: 16.255,
    h: 16.255,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1294"
  },
  {
    ind: 1287,
    ty: 3,
    parent: 1286,
    ks: {
      p: {
        a: 0,
        k: [
          41.992,
          42.67
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1299,
    ty: 4,
    td: 1,
    parent: 1297,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            29.801,
            29.801
          ]
        },
        r: {
          a: 0,
          k: 46
        },
        s: {
          a: 0,
          k: [
            59.602,
            59.602
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0,
            0,
            0
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1298,
    ty: 4,
    tt: 1,
    parent: 1297,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                29.801,
                29.801
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                62.989,
                62.989
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ty: "gr",
        it: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                29.801,
                29.801
              ]
            },
            r: {
              a: 0,
              k: 46
            },
            s: {
              a: 0,
              k: [
                59.602,
                59.602
              ]
            }
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.427,
                0.184,
                0.604
              ]
            },
            lj: 1,
            ml: 10,
            o: {
              a: 0,
              k: 100
            },
            w: {
              a: 0,
              k: 3.387
            }
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      }
    ]
  },
  {
    ind: 1315,
    ty: 4,
    td: 1,
    parent: 1297,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            29.801,
            29.801
          ]
        },
        r: {
          a: 0,
          k: 46
        },
        s: {
          a: 0,
          k: [
            59.602,
            59.602
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0,
            0,
            0
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1314,
    ty: 0,
    tt: 1,
    parent: 1297,
    ks: {},
    w: 55,
    h: 55,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1312"
  },
  {
    ind: 1297,
    ty: 3,
    parent: 1286,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1286,
    ty: 3,
    parent: 1176,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1176,
    ty: 3,
    parent: 1045,
    ks: {
      p: {
        a: 0,
        k: [
          8.128,
          4.97
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1316,
    ty: 4,
    parent: 1045,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            113.787,
            69.8
          ]
        },
        r: {
          a: 0,
          k: 5
        },
        s: {
          a: 0,
          k: [
            227.573,
            139.599
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            1,
            1,
            1
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1045,
    ty: 3,
    parent: 16,
    ks: {
      a: {
        a: 0,
        k: [
          113.787,
          69.8
        ]
      },
      p: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              -357,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 132,
            s: [
              -89,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 276,
            s: [
              179,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 420,
            s: [
              447,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              715,
              92.212
            ],
            h: 1
          }
        ]
      },
      s: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              100,
              100
            ],
            i: {
              x: [
                1,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 132,
            s: [
              100,
              100
            ],
            i: {
              x: [
                0.2,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 276,
            s: [
              107,
              107
            ],
            i: {
              x: [
                0.2,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 420,
            s: [
              93,
              93
            ],
            i: {
              x: [
                1,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              93,
              93
            ],
            h: 1
          }
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1326,
    ty: 4,
    parent: 1325,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1325,
    ty: 3,
    parent: 1324,
    ks: {
      p: {
        a: 0,
        k: [
          21.813,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1328,
    ty: 4,
    parent: 1327,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1327,
    ty: 3,
    parent: 1324,
    ks: {
      p: {
        a: 0,
        k: [
          17.007,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1330,
    ty: 4,
    parent: 1329,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.8,
                9
              ],
              [
                1.8,
                9
              ],
              [
                0.9,
                8.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                7.8
              ],
              [
                1.9,
                8
              ],
              [
                2,
                8.1
              ],
              [
                2,
                8.1
              ],
              [
                2.1,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.3,
                8.9
              ],
              [
                2.1,
                9
              ],
              [
                1.8,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1329,
    ty: 3,
    parent: 1324,
    ks: {
      p: {
        a: 0,
        k: [
          14.438,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1332,
    ty: 4,
    parent: 1331,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1331,
    ty: 3,
    parent: 1324,
    ks: {
      p: {
        a: 0,
        k: [
          9.546,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1334,
    ty: 4,
    parent: 1333,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.36
              ],
              [
                -0.36,
                0.19
              ],
              [
                -0.41,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.1
              ],
              [
                -0.17,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.13,
                0.06
              ],
              [
                0.15,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.28
              ],
              [
                0,
                -0.47
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                -0.28
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                0.08
              ],
              [
                -0.13,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.27,
                0
              ]
            ],
            v: [
              [
                2.64,
                9.02
              ],
              [
                2.64,
                9.02
              ],
              [
                1.49,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.71,
                5.26
              ],
              [
                1.57,
                4.42
              ],
              [
                2.72,
                4.13
              ],
              [
                2.72,
                4.13
              ],
              [
                3.5,
                4.28
              ],
              [
                4.09,
                4.65
              ],
              [
                4.09,
                4.65
              ],
              [
                3.56,
                5.37
              ],
              [
                3.19,
                5.11
              ],
              [
                2.78,
                5.02
              ],
              [
                2.78,
                5.02
              ],
              [
                1.86,
                5.45
              ],
              [
                1.51,
                6.58
              ],
              [
                1.51,
                6.58
              ],
              [
                1.85,
                7.7
              ],
              [
                2.75,
                8.12
              ],
              [
                2.75,
                8.12
              ],
              [
                3.27,
                8.01
              ],
              [
                3.71,
                7.73
              ],
              [
                3.71,
                7.73
              ],
              [
                4.15,
                8.45
              ],
              [
                3.43,
                8.87
              ],
              [
                2.64,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.42,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.52
              ],
              [
                0.21,
                -0.36
              ],
              [
                0.36,
                -0.19
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.22,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                -0.11
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                -0.37,
                0
              ],
              [
                -0.24,
                0.28
              ],
              [
                0,
                0
              ],
              [
                0,
                0.46
              ],
              [
                0.23,
                0.28
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0.16,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.19
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1333,
    ty: 3,
    parent: 1324,
    ks: {
      p: {
        a: 0,
        k: [
          5.167,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1336,
    ty: 4,
    parent: 1335,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                1,
                7.4
              ],
              [
                1.8,
                7.9
              ],
              [
                2.6,
                8.1
              ],
              [
                2.6,
                8.1
              ],
              [
                3.4,
                7.8
              ],
              [
                3.7,
                7.3
              ],
              [
                3.7,
                7.3
              ],
              [
                3.4,
                6.7
              ],
              [
                2.7,
                6.4
              ],
              [
                2.7,
                6.4
              ],
              [
                1.9,
                6
              ],
              [
                1.3,
                5.6
              ],
              [
                0.8,
                5.1
              ],
              [
                0.6,
                4.3
              ],
              [
                0.6,
                4.3
              ],
              [
                0.9,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.8,
                2.8
              ],
              [
                4.6,
                3.4
              ],
              [
                4.6,
                3.4
              ],
              [
                4.1,
                4.1
              ],
              [
                3.4,
                3.7
              ],
              [
                2.7,
                3.5
              ],
              [
                2.7,
                3.5
              ],
              [
                2,
                3.7
              ],
              [
                1.7,
                4.3
              ],
              [
                1.7,
                4.3
              ],
              [
                1.9,
                4.7
              ],
              [
                2.2,
                4.9
              ],
              [
                2.7,
                5.1
              ],
              [
                2.7,
                5.1
              ],
              [
                3.6,
                5.5
              ],
              [
                4.5,
                6.1
              ],
              [
                4.8,
                7.2
              ],
              [
                4.8,
                7.2
              ],
              [
                4.6,
                8.1
              ],
              [
                3.8,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1335,
    ty: 3,
    parent: 1324,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1324,
    ty: 3,
    parent: 1323,
    ks: {
      p: {
        a: 0,
        k: [
          93.74,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1339,
    ty: 4,
    parent: 1338,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1338,
    ty: 3,
    parent: 1337,
    ks: {
      p: {
        a: 0,
        k: [
          15.786,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1341,
    ty: 4,
    parent: 1340,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1340,
    ty: 3,
    parent: 1337,
    ks: {
      p: {
        a: 0,
        k: [
          10.979,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1343,
    ty: 4,
    parent: 1342,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                5.1
              ],
              [
                0.3,
                5.1
              ],
              [
                0.3,
                4.3
              ],
              [
                0.9,
                4.2
              ],
              [
                0.9,
                3.8
              ],
              [
                1.2,
                2.6
              ],
              [
                2.4,
                2.1
              ],
              [
                2.4,
                2.1
              ],
              [
                2.9,
                2.1
              ],
              [
                3.3,
                2.3
              ],
              [
                3.3,
                2.3
              ],
              [
                3.1,
                3.1
              ],
              [
                2.6,
                3
              ],
              [
                2.6,
                3
              ],
              [
                2,
                3.7
              ],
              [
                2,
                3.7
              ],
              [
                2,
                4.2
              ],
              [
                2.9,
                4.2
              ],
              [
                2.9,
                5.1
              ],
              [
                2,
                5.1
              ],
              [
                2,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                5.3,
                9
              ],
              [
                5.3,
                9
              ],
              [
                4.2,
                8.5
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                5.1
              ],
              [
                3.2,
                5.1
              ],
              [
                3.2,
                4.3
              ],
              [
                3.9,
                4.2
              ],
              [
                4,
                3
              ],
              [
                5,
                3
              ],
              [
                5,
                4.2
              ],
              [
                6.1,
                4.2
              ],
              [
                6.1,
                5.1
              ],
              [
                5,
                5.1
              ],
              [
                5,
                7.3
              ],
              [
                5.6,
                8.1
              ],
              [
                5.6,
                8.1
              ],
              [
                5.9,
                8.1
              ],
              [
                6.1,
                8
              ],
              [
                6.1,
                8
              ],
              [
                6.3,
                8.8
              ],
              [
                5.9,
                9
              ],
              [
                5.3,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1342,
    ty: 3,
    parent: 1337,
    ks: {
      p: {
        a: 0,
        k: [
          4.892,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1345,
    ty: 4,
    parent: 1344,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1344,
    ty: 3,
    parent: 1337,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1337,
    ty: 3,
    parent: 1323,
    ks: {
      p: {
        a: 0,
        k: [
          72.522,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1348,
    ty: 4,
    parent: 1347,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1347,
    ty: 3,
    parent: 1346,
    ks: {
      p: {
        a: 0,
        k: [
          13.718,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1350,
    ty: 4,
    parent: 1349,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                8.9
              ],
              [
                0.7,
                8.9
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                6.4
              ],
              [
                1.8,
                6.4
              ],
              [
                3.5,
                4.2
              ],
              [
                4.7,
                4.2
              ],
              [
                3.1,
                6.1
              ],
              [
                4.9,
                8.9
              ],
              [
                3.7,
                8.9
              ],
              [
                2.5,
                6.9
              ],
              [
                1.8,
                7.7
              ],
              [
                1.8,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1349,
    ty: 3,
    parent: 1346,
    ks: {
      p: {
        a: 0,
        k: [
          8.769,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1352,
    ty: 4,
    parent: 1351,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                8.9
              ],
              [
                0.7,
                8.9
              ],
              [
                0.7,
                4.2
              ],
              [
                1.8,
                4.2
              ],
              [
                1.8,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.4
              ],
              [
                1.2,
                3.4
              ],
              [
                0.8,
                3.3
              ],
              [
                0.6,
                2.8
              ],
              [
                0.6,
                2.8
              ],
              [
                0.8,
                2.4
              ],
              [
                1.2,
                2.2
              ],
              [
                1.2,
                2.2
              ],
              [
                1.7,
                2.4
              ],
              [
                1.9,
                2.8
              ],
              [
                1.9,
                2.8
              ],
              [
                1.7,
                3.3
              ],
              [
                1.2,
                3.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1351,
    ty: 3,
    parent: 1346,
    ks: {
      p: {
        a: 0,
        k: [
          6.285,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1354,
    ty: 4,
    parent: 1353,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.9,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                2.7
              ],
              [
                1.9,
                2.7
              ],
              [
                1.9,
                5.2
              ],
              [
                4.4,
                5.2
              ],
              [
                4.4,
                2.7
              ],
              [
                5.5,
                2.7
              ],
              [
                5.5,
                8.9
              ],
              [
                4.4,
                8.9
              ],
              [
                4.4,
                6.2
              ],
              [
                1.9,
                6.2
              ],
              [
                1.9,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1353,
    ty: 3,
    parent: 1346,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1346,
    ty: 3,
    parent: 1323,
    ks: {
      p: {
        a: 0,
        k: [
          52.102,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1357,
    ty: 4,
    parent: 1356,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                1,
                10.8
              ],
              [
                1,
                10.8
              ],
              [
                0.7,
                10.8
              ],
              [
                0.4,
                10.7
              ],
              [
                0.4,
                10.7
              ],
              [
                0.6,
                9.9
              ],
              [
                0.8,
                9.9
              ],
              [
                0.9,
                9.9
              ],
              [
                0.9,
                9.9
              ],
              [
                1.5,
                9.7
              ],
              [
                1.9,
                9.1
              ],
              [
                1.9,
                9.1
              ],
              [
                1.9,
                8.8
              ],
              [
                0.1,
                4.2
              ],
              [
                1.2,
                4.2
              ],
              [
                2,
                6.5
              ],
              [
                2.2,
                7.2
              ],
              [
                2.4,
                7.8
              ],
              [
                2.4,
                7.8
              ],
              [
                2.5,
                7.8
              ],
              [
                2.7,
                7.2
              ],
              [
                2.8,
                6.5
              ],
              [
                2.8,
                6.5
              ],
              [
                3.5,
                4.2
              ],
              [
                4.6,
                4.2
              ],
              [
                2.9,
                9.1
              ],
              [
                2.2,
                10.4
              ],
              [
                1,
                10.8
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.5
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1356,
    ty: 3,
    parent: 1355,
    ks: {
      p: {
        a: 0,
        k: [
          21.055,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1359,
    ty: 4,
    parent: 1358,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1358,
    ty: 3,
    parent: 1355,
    ks: {
      p: {
        a: 0,
        k: [
          17.519,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1361,
    ty: 4,
    parent: 1360,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1360,
    ty: 3,
    parent: 1355,
    ks: {
      p: {
        a: 0,
        k: [
          12.627,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1363,
    ty: 4,
    parent: 1362,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.8,
                9
              ],
              [
                1.8,
                9
              ],
              [
                0.9,
                8.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                7.8
              ],
              [
                1.9,
                8
              ],
              [
                2,
                8.1
              ],
              [
                2,
                8.1
              ],
              [
                2.1,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.3,
                8.9
              ],
              [
                2.1,
                9
              ],
              [
                1.8,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1362,
    ty: 3,
    parent: 1355,
    ks: {
      p: {
        a: 0,
        k: [
          10.058,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1365,
    ty: 4,
    parent: 1364,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1364,
    ty: 3,
    parent: 1355,
    ks: {
      p: {
        a: 0,
        k: [
          5.167,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1367,
    ty: 4,
    parent: 1366,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                1,
                7.4
              ],
              [
                1.8,
                7.9
              ],
              [
                2.6,
                8.1
              ],
              [
                2.6,
                8.1
              ],
              [
                3.4,
                7.8
              ],
              [
                3.7,
                7.3
              ],
              [
                3.7,
                7.3
              ],
              [
                3.4,
                6.7
              ],
              [
                2.7,
                6.4
              ],
              [
                2.7,
                6.4
              ],
              [
                1.9,
                6
              ],
              [
                1.3,
                5.6
              ],
              [
                0.8,
                5.1
              ],
              [
                0.6,
                4.3
              ],
              [
                0.6,
                4.3
              ],
              [
                0.9,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.8,
                2.8
              ],
              [
                4.6,
                3.4
              ],
              [
                4.6,
                3.4
              ],
              [
                4.1,
                4.1
              ],
              [
                3.4,
                3.7
              ],
              [
                2.7,
                3.5
              ],
              [
                2.7,
                3.5
              ],
              [
                2,
                3.7
              ],
              [
                1.7,
                4.3
              ],
              [
                1.7,
                4.3
              ],
              [
                1.9,
                4.7
              ],
              [
                2.2,
                4.9
              ],
              [
                2.7,
                5.1
              ],
              [
                2.7,
                5.1
              ],
              [
                3.6,
                5.5
              ],
              [
                4.5,
                6.1
              ],
              [
                4.8,
                7.2
              ],
              [
                4.8,
                7.2
              ],
              [
                4.6,
                8.1
              ],
              [
                3.8,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1366,
    ty: 3,
    parent: 1355,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1355,
    ty: 3,
    parent: 1323,
    ks: {
      p: {
        a: 0,
        k: [
          24.458,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1370,
    ty: 4,
    parent: 1369,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                1.8,
                6.5
              ],
              [
                1.8,
                6.5
              ],
              [
                0.7,
                6
              ],
              [
                0.3,
                4.5
              ],
              [
                0.3,
                4.5
              ],
              [
                0.7,
                3.1
              ],
              [
                1.8,
                2.6
              ],
              [
                1.8,
                2.6
              ],
              [
                2.8,
                3.1
              ],
              [
                3.2,
                4.5
              ],
              [
                3.2,
                4.5
              ],
              [
                2.8,
                6
              ],
              [
                1.8,
                6.5
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                1.8,
                5.9
              ],
              [
                1.8,
                5.9
              ],
              [
                2.3,
                5.6
              ],
              [
                2.5,
                4.5
              ],
              [
                2.5,
                4.5
              ],
              [
                2.3,
                3.5
              ],
              [
                1.8,
                3.2
              ],
              [
                1.8,
                3.2
              ],
              [
                1.3,
                3.5
              ],
              [
                1.1,
                4.5
              ],
              [
                1.1,
                4.5
              ],
              [
                1.3,
                5.6
              ],
              [
                1.8,
                5.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2,
                9
              ],
              [
                5.3,
                2.6
              ],
              [
                6,
                2.6
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                6.2,
                9
              ],
              [
                6.2,
                9
              ],
              [
                5.1,
                8.5
              ],
              [
                4.7,
                7
              ],
              [
                4.7,
                7
              ],
              [
                5.1,
                5.6
              ],
              [
                6.2,
                5.1
              ],
              [
                6.2,
                5.1
              ],
              [
                7.3,
                5.6
              ],
              [
                7.7,
                7
              ],
              [
                7.7,
                7
              ],
              [
                7.3,
                8.5
              ],
              [
                6.2,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                6.2,
                8.4
              ],
              [
                6.2,
                8.4
              ],
              [
                6.7,
                8.1
              ],
              [
                6.9,
                7
              ],
              [
                6.9,
                7
              ],
              [
                6.7,
                6
              ],
              [
                6.2,
                5.7
              ],
              [
                6.2,
                5.7
              ],
              [
                5.7,
                6
              ],
              [
                5.5,
                7
              ],
              [
                5.5,
                7
              ],
              [
                5.7,
                8.1
              ],
              [
                6.2,
                8.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1369,
    ty: 3,
    parent: 1368,
    ks: {
      p: {
        a: 0,
        k: [
          14.59,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1372,
    ty: 4,
    parent: 1371,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.3,
                9
              ],
              [
                2.3,
                9
              ],
              [
                1.1,
                8.8
              ],
              [
                0.2,
                8.2
              ],
              [
                0.2,
                8.2
              ],
              [
                0.7,
                7.5
              ],
              [
                1.3,
                7.9
              ],
              [
                2.1,
                8.1
              ],
              [
                2.1,
                8.1
              ],
              [
                3,
                7.8
              ],
              [
                3.3,
                7
              ],
              [
                3.3,
                7
              ],
              [
                3,
                6.1
              ],
              [
                2.2,
                5.8
              ],
              [
                2.2,
                5.8
              ],
              [
                1.7,
                5.9
              ],
              [
                1.2,
                6.2
              ],
              [
                1.2,
                6.2
              ],
              [
                0.7,
                5.8
              ],
              [
                0.9,
                2.9
              ],
              [
                4.1,
                2.9
              ],
              [
                4.1,
                3.8
              ],
              [
                1.8,
                3.8
              ],
              [
                1.7,
                5.3
              ],
              [
                2.1,
                5.1
              ],
              [
                2.5,
                5.1
              ],
              [
                2.5,
                5.1
              ],
              [
                3.5,
                5.3
              ],
              [
                4.1,
                5.9
              ],
              [
                4.4,
                6.9
              ],
              [
                4.4,
                6.9
              ],
              [
                4.1,
                8.1
              ],
              [
                3.3,
                8.8
              ],
              [
                2.3,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1371,
    ty: 3,
    parent: 1368,
    ks: {
      p: {
        a: 0,
        k: [
          9.726,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1374,
    ty: 4,
    parent: 1373,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                4.3,
                8.9
              ],
              [
                0.7,
                8.9
              ],
              [
                0.7,
                8
              ],
              [
                2,
                8
              ],
              [
                2,
                4
              ],
              [
                0.9,
                4
              ],
              [
                0.9,
                3.4
              ],
              [
                1.7,
                3.2
              ],
              [
                2.3,
                2.9
              ],
              [
                2.3,
                2.9
              ],
              [
                3.1,
                2.9
              ],
              [
                3.1,
                8
              ],
              [
                4.3,
                8
              ],
              [
                4.3,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1373,
    ty: 3,
    parent: 1368,
    ks: {
      p: {
        a: 0,
        k: [
          4.863,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1376,
    ty: 4,
    parent: 1375,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                4.8
              ],
              [
                1.3,
                6.5
              ],
              [
                2.8,
                6.5
              ],
              [
                2.8,
                5.1
              ],
              [
                2.9,
                4.5
              ],
              [
                2.9,
                3.9
              ],
              [
                2.9,
                3.9
              ],
              [
                2.8,
                3.9
              ],
              [
                2.6,
                4.4
              ],
              [
                2.4,
                4.8
              ],
              [
                2.4,
                4.8
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                3.9,
                8.9
              ],
              [
                2.8,
                8.9
              ],
              [
                2.8,
                7.3
              ],
              [
                0.2,
                7.3
              ],
              [
                0.2,
                6.6
              ],
              [
                2.6,
                2.9
              ],
              [
                3.9,
                2.9
              ],
              [
                3.9,
                6.5
              ],
              [
                4.6,
                6.5
              ],
              [
                4.6,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1375,
    ty: 3,
    parent: 1368,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1368,
    ty: 3,
    parent: 1323,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1323,
    ty: 3,
    parent: 1322,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1322,
    ty: 3,
    parent: 1321,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1321,
    ty: 3,
    parent: 1320,
    ks: {
      p: {
        a: 0,
        k: [
          17.029,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1385,
    ty: 0,
    parent: 1377,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.582
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    w: 10.837,
    h: 10.837,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1383"
  },
  {
    ind: 1377,
    ty: 3,
    parent: 1320,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1320,
    ty: 3,
    parent: 1319,
    ks: {
      p: {
        a: 0,
        k: [
          37.644,
          2.709
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1319,
    ty: 3,
    parent: 1318,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          35.897
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1421,
    ty: 0,
    parent: 1388,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          10.548
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          10.548
        ]
      }
    },
    w: 46.443,
    h: 12.354,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1419"
  },
  {
    ind: 1388,
    ty: 3,
    parent: 1387,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          10.548
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1426,
    ty: 4,
    parent: 1425,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.13
              ],
              [
                -0.19,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.11,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.01
              ],
              [
                0.07,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.12
              ],
              [
                0.12,
                -0.29
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.14,
                6.54
              ],
              [
                0.57,
                6.54
              ],
              [
                0.57,
                3.15
              ],
              [
                1.04,
                3.15
              ],
              [
                1.09,
                3.77
              ],
              [
                1.11,
                3.77
              ],
              [
                1.54,
                3.26
              ],
              [
                2.08,
                3.07
              ],
              [
                2.08,
                3.07
              ],
              [
                2.44,
                3.14
              ],
              [
                2.44,
                3.14
              ],
              [
                2.33,
                3.64
              ],
              [
                2.17,
                3.6
              ],
              [
                2,
                3.59
              ],
              [
                2,
                3.59
              ],
              [
                1.55,
                3.76
              ],
              [
                1.14,
                4.37
              ],
              [
                1.14,
                4.37
              ],
              [
                1.14,
                6.54
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.12,
                -0.21
              ],
              [
                0.17,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.13,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.06,
                -0.02
              ],
              [
                -0.05,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0
              ],
              [
                -0.16,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1425,
    ty: 3,
    parent: 1424,
    ks: {
      p: {
        a: 0,
        k: [
          15.625,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1428,
    ty: 4,
    parent: 1427,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                0.14
              ],
              [
                0.14,
                0.26
              ],
              [
                0,
                0.37
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.23,
                0.14
              ],
              [
                -0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                -0.29
              ],
              [
                0,
                -0.48
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.06
              ],
              [
                0.01,
                -0.04
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.21
              ],
              [
                -0.33,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0.05
              ],
              [
                -0.13,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.18,
                -0.07
              ],
              [
                0.23,
                0
              ]
            ],
            v: [
              [
                1.94,
                6.62
              ],
              [
                1.94,
                6.62
              ],
              [
                1.12,
                6.41
              ],
              [
                0.54,
                5.8
              ],
              [
                0.32,
                4.85
              ],
              [
                0.32,
                4.85
              ],
              [
                0.54,
                3.9
              ],
              [
                1.11,
                3.29
              ],
              [
                1.84,
                3.07
              ],
              [
                1.84,
                3.07
              ],
              [
                2.84,
                3.5
              ],
              [
                3.19,
                4.66
              ],
              [
                3.19,
                4.66
              ],
              [
                3.19,
                4.84
              ],
              [
                3.17,
                4.99
              ],
              [
                3.17,
                4.99
              ],
              [
                0.88,
                4.99
              ],
              [
                1.22,
                5.84
              ],
              [
                2.01,
                6.16
              ],
              [
                2.01,
                6.16
              ],
              [
                2.46,
                6.09
              ],
              [
                2.86,
                5.9
              ],
              [
                2.86,
                5.9
              ],
              [
                3.06,
                6.28
              ],
              [
                2.57,
                6.52
              ],
              [
                1.94,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.25,
                -0.14
              ],
              [
                -0.14,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.37
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.23,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0.43,
                0
              ],
              [
                0.23,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0,
                0.06
              ],
              [
                0,
                0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.02,
                0.36
              ],
              [
                0.2,
                0.21
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0
              ],
              [
                0.14,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0.09
              ],
              [
                -0.18,
                0.07
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.18
              ],
              [
                0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.18
              ],
              [
                0.04,
                -0.33
              ]
            ],
            v: [
              [
                0.88,
                4.58
              ],
              [
                0.88,
                4.58
              ],
              [
                2.69,
                4.58
              ],
              [
                2.47,
                3.79
              ],
              [
                1.85,
                3.52
              ],
              [
                1.85,
                3.52
              ],
              [
                1.22,
                3.8
              ],
              [
                0.88,
                4.58
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.34
              ],
              [
                -0.15,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                0
              ],
              [
                -0.19,
                0.18
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1427,
    ty: 3,
    parent: 1424,
    ks: {
      p: {
        a: 0,
        k: [
          12.173,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1430,
    ty: 4,
    parent: 1429,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.2,
                6.6
              ],
              [
                1.2,
                6.6
              ],
              [
                0.7,
                6.4
              ],
              [
                0.6,
                5.9
              ],
              [
                0.6,
                5.9
              ],
              [
                0.6,
                1.6
              ],
              [
                1.1,
                1.6
              ],
              [
                1.1,
                5.9
              ],
              [
                1.2,
                6.1
              ],
              [
                1.3,
                6.2
              ],
              [
                1.3,
                6.2
              ],
              [
                1.4,
                6.1
              ],
              [
                1.4,
                6.1
              ],
              [
                1.4,
                6.1
              ],
              [
                1.5,
                6.6
              ],
              [
                1.4,
                6.6
              ],
              [
                1.2,
                6.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1429,
    ty: 3,
    parent: 1424,
    ks: {
      p: {
        a: 0,
        k: [
          10.398,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1432,
    ty: 4,
    parent: 1431,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                0.17
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.72,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0.04,
                0.13
              ],
              [
                0.1,
                0.08
              ],
              [
                0.19,
                0
              ],
              [
                0,
                0
              ],
              [
                0.17,
                -0.07
              ],
              [
                0.13,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                -0.25
              ],
              [
                0,
                -0.42
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.1
              ],
              [
                0.21,
                0
              ]
            ],
            v: [
              [
                1.35,
                6.62
              ],
              [
                1.35,
                6.62
              ],
              [
                0.64,
                6.37
              ],
              [
                0.36,
                5.66
              ],
              [
                0.36,
                5.66
              ],
              [
                0.86,
                4.81
              ],
              [
                2.44,
                4.39
              ],
              [
                2.44,
                4.39
              ],
              [
                2.38,
                3.98
              ],
              [
                2.17,
                3.67
              ],
              [
                1.74,
                3.54
              ],
              [
                1.74,
                3.54
              ],
              [
                1.19,
                3.66
              ],
              [
                0.73,
                3.91
              ],
              [
                0.73,
                3.91
              ],
              [
                0.51,
                3.51
              ],
              [
                1.09,
                3.21
              ],
              [
                1.84,
                3.07
              ],
              [
                1.84,
                3.07
              ],
              [
                2.74,
                3.45
              ],
              [
                3.02,
                4.46
              ],
              [
                3.02,
                4.46
              ],
              [
                3.02,
                6.54
              ],
              [
                2.54,
                6.54
              ],
              [
                2.49,
                6.14
              ],
              [
                2.47,
                6.14
              ],
              [
                1.95,
                6.48
              ],
              [
                1.35,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.28,
                0
              ],
              [
                -0.19,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.14
              ],
              [
                -0.04,
                -0.13
              ],
              [
                -0.1,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.17,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.1
              ],
              [
                0.23,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.41,
                0
              ],
              [
                0.19,
                0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                0.13
              ],
              [
                -0.19,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0.08
              ],
              [
                -0.16,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.14
              ],
              [
                0,
                -0.22
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                -0.09
              ],
              [
                -0.17,
                0
              ]
            ],
            v: [
              [
                1.52,
                6.16
              ],
              [
                1.52,
                6.16
              ],
              [
                1.98,
                6.05
              ],
              [
                2.44,
                5.71
              ],
              [
                2.44,
                5.71
              ],
              [
                2.44,
                4.77
              ],
              [
                1.26,
                5.08
              ],
              [
                0.92,
                5.62
              ],
              [
                0.92,
                5.62
              ],
              [
                1.09,
                6.04
              ],
              [
                1.52,
                6.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.16,
                0
              ],
              [
                0.14,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.56,
                0.07
              ],
              [
                -0.23,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0.19
              ],
              [
                0.12,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1431,
    ty: 3,
    parent: 1424,
    ks: {
      p: {
        a: 0,
        k: [
          6.89,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1434,
    ty: 4,
    parent: 1433,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.14
              ],
              [
                0.14,
                0.26
              ],
              [
                0,
                0.37
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.25,
                0.14
              ],
              [
                -0.29,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.08
              ],
              [
                -0.12,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.11,
                0.06
              ],
              [
                0.13,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.11
              ],
              [
                0.09,
                -0.2
              ],
              [
                0,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                -0.24
              ],
              [
                -0.31,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                0.07
              ],
              [
                -0.1,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.08
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.91,
                6.62
              ],
              [
                1.91,
                6.62
              ],
              [
                1.1,
                6.42
              ],
              [
                0.53,
                5.81
              ],
              [
                0.32,
                4.85
              ],
              [
                0.32,
                4.85
              ],
              [
                0.55,
                3.89
              ],
              [
                1.15,
                3.28
              ],
              [
                1.95,
                3.07
              ],
              [
                1.95,
                3.07
              ],
              [
                2.53,
                3.19
              ],
              [
                2.94,
                3.47
              ],
              [
                2.94,
                3.47
              ],
              [
                2.65,
                3.84
              ],
              [
                2.34,
                3.63
              ],
              [
                1.97,
                3.54
              ],
              [
                1.97,
                3.54
              ],
              [
                1.42,
                3.71
              ],
              [
                1.05,
                4.17
              ],
              [
                0.91,
                4.85
              ],
              [
                0.91,
                4.85
              ],
              [
                1.2,
                5.79
              ],
              [
                1.96,
                6.15
              ],
              [
                1.96,
                6.15
              ],
              [
                2.4,
                6.05
              ],
              [
                2.75,
                5.81
              ],
              [
                2.75,
                5.81
              ],
              [
                3,
                6.19
              ],
              [
                2.49,
                6.51
              ],
              [
                1.91,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.24,
                -0.14
              ],
              [
                -0.14,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.38
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.25,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.16,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.09
              ],
              [
                -0.11,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.16,
                0.11
              ],
              [
                -0.09,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.39
              ],
              [
                0.19,
                0.24
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0
              ],
              [
                0.13,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.13
              ],
              [
                -0.19,
                0.08
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1433,
    ty: 3,
    parent: 1424,
    ks: {
      p: {
        a: 0,
        k: [
          3.717,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1436,
    ty: 4,
    parent: 1435,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                0.12
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.1
              ],
              [
                -0.24,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.14
              ],
              [
                0,
                0.22
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.09
              ],
              [
                0.11,
                0.07
              ],
              [
                0.14,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.1
              ],
              [
                0.1,
                0.15
              ],
              [
                0,
                0.22
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                0.18
              ],
              [
                -0.22,
                0.1
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                -0.1
              ],
              [
                -0.16,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.17,
                0.08
              ],
              [
                0.21,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.12
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.1
              ],
              [
                -0.12,
                -0.06
              ],
              [
                -0.12,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.1
              ],
              [
                -0.08,
                -0.15
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0.13,
                -0.2
              ],
              [
                0.23,
                -0.12
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                1.89,
                6.62
              ],
              [
                1.89,
                6.62
              ],
              [
                1,
                6.44
              ],
              [
                0.29,
                5.95
              ],
              [
                0.29,
                5.95
              ],
              [
                0.64,
                5.54
              ],
              [
                1.22,
                5.96
              ],
              [
                1.9,
                6.12
              ],
              [
                1.9,
                6.12
              ],
              [
                2.61,
                5.91
              ],
              [
                2.86,
                5.37
              ],
              [
                2.86,
                5.37
              ],
              [
                2.76,
                4.99
              ],
              [
                2.48,
                4.76
              ],
              [
                2.1,
                4.56
              ],
              [
                2.1,
                4.56
              ],
              [
                1.44,
                4.28
              ],
              [
                1.01,
                4.04
              ],
              [
                0.66,
                3.66
              ],
              [
                0.52,
                3.1
              ],
              [
                0.52,
                3.1
              ],
              [
                0.7,
                2.48
              ],
              [
                1.21,
                2.04
              ],
              [
                1.95,
                1.89
              ],
              [
                1.95,
                1.89
              ],
              [
                2.71,
                2.04
              ],
              [
                3.3,
                2.45
              ],
              [
                3.3,
                2.45
              ],
              [
                2.99,
                2.83
              ],
              [
                2.53,
                2.51
              ],
              [
                1.95,
                2.4
              ],
              [
                1.95,
                2.4
              ],
              [
                1.33,
                2.58
              ],
              [
                1.1,
                3.06
              ],
              [
                1.1,
                3.06
              ],
              [
                1.22,
                3.42
              ],
              [
                1.5,
                3.66
              ],
              [
                1.86,
                3.82
              ],
              [
                1.86,
                3.82
              ],
              [
                2.51,
                4.1
              ],
              [
                2.99,
                4.37
              ],
              [
                3.32,
                4.75
              ],
              [
                3.45,
                5.32
              ],
              [
                3.45,
                5.32
              ],
              [
                3.26,
                5.98
              ],
              [
                2.72,
                6.45
              ],
              [
                1.89,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.27,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.17
              ],
              [
                0.22,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.17,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.16
              ],
              [
                -0.07,
                -0.09
              ],
              [
                -0.11,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.06
              ],
              [
                -0.14,
                -0.1
              ],
              [
                -0.1,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.23
              ],
              [
                0.12,
                -0.18
              ],
              [
                0.22,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.27,
                0
              ],
              [
                0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.13
              ],
              [
                -0.17,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                -0.26,
                0
              ],
              [
                -0.16,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0.14
              ],
              [
                0.08,
                0.1
              ],
              [
                0.12,
                0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0.07
              ],
              [
                0.14,
                0.1
              ],
              [
                0.08,
                0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                0.24
              ],
              [
                -0.13,
                0.2
              ],
              [
                -0.23,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1435,
    ty: 3,
    parent: 1424,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1424,
    ty: 3,
    parent: 1423,
    ks: {
      p: {
        a: 0,
        k: [
          14.372,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1439,
    ty: 4,
    parent: 1438,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.21
              ],
              [
                0,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.11
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.07,
                0.02
              ],
              [
                -0.06,
                0.02
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.11,
                -0.03
              ],
              [
                0.11,
                0
              ]
            ],
            v: [
              [
                1.64,
                6.62
              ],
              [
                1.64,
                6.62
              ],
              [
                0.88,
                6.31
              ],
              [
                0.67,
                5.5
              ],
              [
                0.67,
                5.5
              ],
              [
                0.67,
                3.62
              ],
              [
                0.17,
                3.62
              ],
              [
                0.17,
                3.19
              ],
              [
                0.7,
                3.15
              ],
              [
                0.77,
                2.21
              ],
              [
                1.25,
                2.21
              ],
              [
                1.25,
                3.15
              ],
              [
                2.16,
                3.15
              ],
              [
                2.16,
                3.62
              ],
              [
                1.25,
                3.62
              ],
              [
                1.25,
                5.5
              ],
              [
                1.36,
                5.99
              ],
              [
                1.77,
                6.16
              ],
              [
                1.77,
                6.16
              ],
              [
                1.96,
                6.13
              ],
              [
                2.15,
                6.07
              ],
              [
                2.15,
                6.07
              ],
              [
                2.26,
                6.5
              ],
              [
                1.96,
                6.59
              ],
              [
                1.64,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.36,
                0
              ],
              [
                -0.14,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.08,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.06,
                0
              ],
              [
                0.07,
                -0.02
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.09,
                0.03
              ],
              [
                -0.11,
                0.03
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1438,
    ty: 3,
    parent: 1437,
    ks: {
      p: {
        a: 0,
        k: [
          10.628,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1441,
    ty: 4,
    parent: 1440,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0.09
              ],
              [
                0.16,
                0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.08
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.11,
                0.1
              ],
              [
                0,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0.08,
                0.08
              ],
              [
                0.12,
                0.05
              ],
              [
                0.13,
                0.05
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.08
              ],
              [
                0.1,
                0.12
              ],
              [
                0,
                0.19
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                -0.07
              ],
              [
                -0.13,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.13,
                0.06
              ],
              [
                0.15,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                -0.07,
                -0.07
              ],
              [
                -0.11,
                -0.05
              ],
              [
                -0.13,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.08
              ],
              [
                -0.1,
                -0.13
              ],
              [
                0,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.15
              ],
              [
                0.18,
                -0.09
              ],
              [
                0.27,
                0
              ]
            ],
            v: [
              [
                1.46,
                6.62
              ],
              [
                1.46,
                6.62
              ],
              [
                0.77,
                6.49
              ],
              [
                0.2,
                6.16
              ],
              [
                0.2,
                6.16
              ],
              [
                0.48,
                5.77
              ],
              [
                0.94,
                6.06
              ],
              [
                1.48,
                6.18
              ],
              [
                1.48,
                6.18
              ],
              [
                1.98,
                6.02
              ],
              [
                2.15,
                5.65
              ],
              [
                2.15,
                5.65
              ],
              [
                2.03,
                5.36
              ],
              [
                1.74,
                5.16
              ],
              [
                1.37,
                5.01
              ],
              [
                1.37,
                5.01
              ],
              [
                0.91,
                4.8
              ],
              [
                0.53,
                4.5
              ],
              [
                0.38,
                4.03
              ],
              [
                0.38,
                4.03
              ],
              [
                0.69,
                3.35
              ],
              [
                1.55,
                3.07
              ],
              [
                1.55,
                3.07
              ],
              [
                2.14,
                3.18
              ],
              [
                2.61,
                3.45
              ],
              [
                2.61,
                3.45
              ],
              [
                2.33,
                3.82
              ],
              [
                1.96,
                3.6
              ],
              [
                1.55,
                3.52
              ],
              [
                1.55,
                3.52
              ],
              [
                1.08,
                3.66
              ],
              [
                0.93,
                4
              ],
              [
                0.93,
                4
              ],
              [
                1.04,
                4.27
              ],
              [
                1.31,
                4.44
              ],
              [
                1.66,
                4.59
              ],
              [
                1.66,
                4.59
              ],
              [
                2.15,
                4.8
              ],
              [
                2.54,
                5.1
              ],
              [
                2.7,
                5.61
              ],
              [
                2.7,
                5.61
              ],
              [
                2.55,
                6.12
              ],
              [
                2.14,
                6.48
              ],
              [
                1.46,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.24,
                0
              ],
              [
                -0.22,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.12
              ],
              [
                0.16,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.11,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.12
              ],
              [
                -0.08,
                -0.08
              ],
              [
                -0.12,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.06
              ],
              [
                -0.15,
                -0.08
              ],
              [
                -0.1,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.27
              ],
              [
                0.21,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                0.21,
                0
              ],
              [
                0.18,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                -0.09
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.11
              ],
              [
                0.07,
                0.07
              ],
              [
                0.11,
                0.05
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.06
              ],
              [
                0.16,
                0.08
              ],
              [
                0.1,
                0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0.18
              ],
              [
                -0.1,
                0.15
              ],
              [
                -0.18,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1440,
    ty: 3,
    parent: 1437,
    ks: {
      p: {
        a: 0,
        k: [
          7.712,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1443,
    ty: 4,
    parent: 1442,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.14
              ],
              [
                0.15,
                0.26
              ],
              [
                0,
                0.37
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.24,
                0.14
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                -0.14
              ],
              [
                -0.15,
                -0.26
              ],
              [
                0,
                -0.38
              ],
              [
                0,
                0
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.24,
                -0.14
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.89,
                6.62
              ],
              [
                1.89,
                6.62
              ],
              [
                1.12,
                6.42
              ],
              [
                0.54,
                5.81
              ],
              [
                0.32,
                4.85
              ],
              [
                0.32,
                4.85
              ],
              [
                0.54,
                3.89
              ],
              [
                1.12,
                3.28
              ],
              [
                1.89,
                3.07
              ],
              [
                1.89,
                3.07
              ],
              [
                2.66,
                3.28
              ],
              [
                3.24,
                3.89
              ],
              [
                3.46,
                4.85
              ],
              [
                3.46,
                4.85
              ],
              [
                3.24,
                5.81
              ],
              [
                2.66,
                6.42
              ],
              [
                1.89,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.24,
                -0.14
              ],
              [
                -0.15,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.38
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.24,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0.28,
                0
              ],
              [
                0.24,
                0.14
              ],
              [
                0.15,
                0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                0.37
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.24,
                0.14
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0.24
              ],
              [
                0,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0.24
              ],
              [
                0.29,
                0
              ],
              [
                0,
                0
              ],
              [
                0.18,
                -0.24
              ],
              [
                0,
                -0.39
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                -0.24
              ],
              [
                -0.29,
                0
              ]
            ],
            v: [
              [
                1.89,
                6.15
              ],
              [
                1.89,
                6.15
              ],
              [
                2.6,
                5.79
              ],
              [
                2.86,
                4.85
              ],
              [
                2.86,
                4.85
              ],
              [
                2.6,
                3.91
              ],
              [
                1.89,
                3.54
              ],
              [
                1.89,
                3.54
              ],
              [
                1.18,
                3.91
              ],
              [
                0.91,
                4.85
              ],
              [
                0.91,
                4.85
              ],
              [
                1.18,
                5.79
              ],
              [
                1.89,
                6.15
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.29,
                0
              ],
              [
                0.18,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.39
              ],
              [
                -0.18,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                0
              ],
              [
                -0.18,
                0.24
              ],
              [
                0,
                0
              ],
              [
                0,
                0.39
              ],
              [
                0.18,
                0.24
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1442,
    ty: 3,
    parent: 1437,
    ks: {
      p: {
        a: 0,
        k: [
          3.939,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1445,
    ty: 4,
    parent: 1444,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.26,
                -0.08
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.23
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.21,
                6.54
              ],
              [
                0.63,
                6.54
              ],
              [
                0.63,
                1.97
              ],
              [
                1.93,
                1.97
              ],
              [
                2.83,
                2.1
              ],
              [
                3.43,
                2.52
              ],
              [
                3.64,
                3.31
              ],
              [
                3.64,
                3.31
              ],
              [
                3.18,
                4.38
              ],
              [
                1.96,
                4.73
              ],
              [
                1.96,
                4.73
              ],
              [
                1.21,
                4.73
              ],
              [
                1.21,
                6.54
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0
              ],
              [
                0.26,
                0.08
              ],
              [
                0.14,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.48
              ],
              [
                -0.31,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.15
              ],
              [
                0,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.13
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.21,
                2.44
              ],
              [
                1.21,
                4.26
              ],
              [
                1.89,
                4.26
              ],
              [
                2.78,
                4.03
              ],
              [
                3.07,
                3.31
              ],
              [
                3.07,
                3.31
              ],
              [
                2.76,
                2.63
              ],
              [
                1.86,
                2.44
              ],
              [
                1.86,
                2.44
              ],
              [
                1.21,
                2.44
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.19,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.33
              ],
              [
                -0.2,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1444,
    ty: 3,
    parent: 1437,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1437,
    ty: 3,
    parent: 1423,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1423,
    ty: 3,
    parent: 1422,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1422,
    ty: 3,
    parent: 1387,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1387,
    ty: 3,
    parent: 1386,
    ks: {
      p: {
        a: 0,
        k: [
          143.636,
          1.079
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1451,
    ty: 0,
    parent: 1447,
    ks: {},
    w: 21,
    h: 10,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1449"
  },
  {
    ind: 1447,
    ty: 3,
    parent: 1446,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1446,
    ty: 3,
    parent: 1386,
    ks: {
      p: {
        a: 0,
        k: [
          115.383,
          7.839
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1457,
    ty: 4,
    parent: 1456,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.7
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                10.2
              ],
              [
                0.9,
                10.2
              ],
              [
                0.9,
                4.9
              ],
              [
                1.6,
                4.9
              ],
              [
                1.7,
                5.7
              ],
              [
                1.7,
                5.7
              ],
              [
                2.5,
                5
              ],
              [
                3.4,
                4.8
              ],
              [
                3.4,
                4.8
              ],
              [
                4.3,
                5
              ],
              [
                4.8,
                5.8
              ],
              [
                4.8,
                5.8
              ],
              [
                5.7,
                5.1
              ],
              [
                6.6,
                4.8
              ],
              [
                6.6,
                4.8
              ],
              [
                7.8,
                5.3
              ],
              [
                8.2,
                6.8
              ],
              [
                8.2,
                6.8
              ],
              [
                8.2,
                10.2
              ],
              [
                7.3,
                10.2
              ],
              [
                7.3,
                7
              ],
              [
                7,
                5.9
              ],
              [
                6.3,
                5.5
              ],
              [
                6.3,
                5.5
              ],
              [
                5,
                6.4
              ],
              [
                5,
                6.4
              ],
              [
                5,
                10.2
              ],
              [
                4.1,
                10.2
              ],
              [
                4.1,
                7
              ],
              [
                3.8,
                5.9
              ],
              [
                3.1,
                5.5
              ],
              [
                3.1,
                5.5
              ],
              [
                1.8,
                6.4
              ],
              [
                1.8,
                6.4
              ],
              [
                1.8,
                10.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1456,
    ty: 3,
    parent: 1455,
    ks: {
      p: {
        a: 0,
        k: [
          24.411,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1459,
    ty: 4,
    parent: 1458,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.4
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                3,
                10.3
              ],
              [
                3,
                10.3
              ],
              [
                1.7,
                10
              ],
              [
                0.8,
                9
              ],
              [
                0.5,
                7.6
              ],
              [
                0.5,
                7.6
              ],
              [
                0.8,
                6.1
              ],
              [
                1.7,
                5.1
              ],
              [
                2.9,
                4.8
              ],
              [
                2.9,
                4.8
              ],
              [
                4.4,
                5.4
              ],
              [
                5,
                7.2
              ],
              [
                5,
                7.2
              ],
              [
                5,
                7.5
              ],
              [
                4.9,
                7.8
              ],
              [
                4.9,
                7.8
              ],
              [
                1.4,
                7.8
              ],
              [
                1.9,
                9.1
              ],
              [
                3.1,
                9.6
              ],
              [
                3.1,
                9.6
              ],
              [
                3.8,
                9.5
              ],
              [
                4.4,
                9.2
              ],
              [
                4.4,
                9.2
              ],
              [
                4.8,
                9.8
              ],
              [
                4,
                10.1
              ],
              [
                3,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.2,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.1,
                -0.5
              ]
            ],
            v: [
              [
                1.4,
                7.1
              ],
              [
                1.4,
                7.1
              ],
              [
                4.2,
                7.1
              ],
              [
                3.8,
                5.9
              ],
              [
                2.9,
                5.5
              ],
              [
                2.9,
                5.5
              ],
              [
                1.9,
                5.9
              ],
              [
                1.4,
                7.1
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1458,
    ty: 3,
    parent: 1455,
    ks: {
      p: {
        a: 0,
        k: [
          19.039,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1461,
    ty: 4,
    parent: 1460,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                2.5,
                10.3
              ],
              [
                2.5,
                10.3
              ],
              [
                1.4,
                9.8
              ],
              [
                1,
                8.5
              ],
              [
                1,
                8.5
              ],
              [
                1,
                5.6
              ],
              [
                0.3,
                5.6
              ],
              [
                0.3,
                5
              ],
              [
                1.1,
                4.9
              ],
              [
                1.2,
                3.4
              ],
              [
                1.9,
                3.4
              ],
              [
                1.9,
                4.9
              ],
              [
                3.4,
                4.9
              ],
              [
                3.4,
                5.6
              ],
              [
                1.9,
                5.6
              ],
              [
                1.9,
                8.6
              ],
              [
                2.1,
                9.3
              ],
              [
                2.8,
                9.6
              ],
              [
                2.8,
                9.6
              ],
              [
                3.1,
                9.5
              ],
              [
                3.3,
                9.4
              ],
              [
                3.3,
                9.4
              ],
              [
                3.5,
                10.1
              ],
              [
                3.1,
                10.2
              ],
              [
                2.5,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1460,
    ty: 3,
    parent: 1455,
    ks: {
      p: {
        a: 0,
        k: [
          15.379,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1463,
    ty: 4,
    parent: 1462,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.6,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.3,
                10.3
              ],
              [
                2.3,
                10.3
              ],
              [
                1.2,
                10.1
              ],
              [
                0.3,
                9.6
              ],
              [
                0.3,
                9.6
              ],
              [
                0.7,
                9
              ],
              [
                1.5,
                9.4
              ],
              [
                2.3,
                9.6
              ],
              [
                2.3,
                9.6
              ],
              [
                3.1,
                9.4
              ],
              [
                3.3,
                8.8
              ],
              [
                3.3,
                8.8
              ],
              [
                3.2,
                8.3
              ],
              [
                2.7,
                8
              ],
              [
                2.1,
                7.8
              ],
              [
                2.1,
                7.8
              ],
              [
                1.4,
                7.5
              ],
              [
                0.8,
                7
              ],
              [
                0.6,
                6.3
              ],
              [
                0.6,
                6.3
              ],
              [
                1.1,
                5.2
              ],
              [
                2.4,
                4.8
              ],
              [
                2.4,
                4.8
              ],
              [
                3.3,
                5
              ],
              [
                4.1,
                5.4
              ],
              [
                4.1,
                5.4
              ],
              [
                3.6,
                5.9
              ],
              [
                3.1,
                5.6
              ],
              [
                2.4,
                5.5
              ],
              [
                2.4,
                5.5
              ],
              [
                1.7,
                5.7
              ],
              [
                1.5,
                6.2
              ],
              [
                1.5,
                6.2
              ],
              [
                1.6,
                6.6
              ],
              [
                2,
                6.9
              ],
              [
                2.6,
                7.1
              ],
              [
                2.6,
                7.1
              ],
              [
                3.3,
                7.5
              ],
              [
                4,
                7.9
              ],
              [
                4.2,
                8.7
              ],
              [
                4.2,
                8.7
              ],
              [
                4,
                9.5
              ],
              [
                3.3,
                10.1
              ],
              [
                2.3,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1462,
    ty: 3,
    parent: 1455,
    ks: {
      p: {
        a: 0,
        k: [
          10.841,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1465,
    ty: 4,
    parent: 1464,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.3
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                1,
                12.4
              ],
              [
                1,
                12.4
              ],
              [
                0.6,
                12.4
              ],
              [
                0.4,
                12.3
              ],
              [
                0.4,
                12.3
              ],
              [
                0.5,
                11.6
              ],
              [
                0.7,
                11.7
              ],
              [
                0.9,
                11.7
              ],
              [
                0.9,
                11.7
              ],
              [
                1.7,
                11.4
              ],
              [
                2.1,
                10.6
              ],
              [
                2.1,
                10.6
              ],
              [
                2.2,
                10.2
              ],
              [
                0.1,
                4.9
              ],
              [
                1.1,
                4.9
              ],
              [
                2.1,
                7.8
              ],
              [
                2.4,
                8.5
              ],
              [
                2.6,
                9.3
              ],
              [
                2.6,
                9.3
              ],
              [
                2.7,
                9.3
              ],
              [
                2.9,
                8.6
              ],
              [
                3.1,
                7.8
              ],
              [
                3.1,
                7.8
              ],
              [
                4.1,
                4.9
              ],
              [
                4.9,
                4.9
              ],
              [
                2.9,
                10.6
              ],
              [
                2.5,
                11.5
              ],
              [
                1.9,
                12.2
              ],
              [
                1,
                12.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1464,
    ty: 3,
    parent: 1455,
    ks: {
      p: {
        a: 0,
        k: [
          5.783,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1467,
    ty: 4,
    parent: 1466,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.4,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.9,
                10.3
              ],
              [
                2.9,
                10.3
              ],
              [
                1.6,
                10
              ],
              [
                0.5,
                9.3
              ],
              [
                0.5,
                9.3
              ],
              [
                1,
                8.6
              ],
              [
                1.9,
                9.3
              ],
              [
                3,
                9.5
              ],
              [
                3,
                9.5
              ],
              [
                4.1,
                9.2
              ],
              [
                4.4,
                8.4
              ],
              [
                4.4,
                8.4
              ],
              [
                4.3,
                7.8
              ],
              [
                3.9,
                7.4
              ],
              [
                3.3,
                7.1
              ],
              [
                3.3,
                7.1
              ],
              [
                2.2,
                6.7
              ],
              [
                1.6,
                6.3
              ],
              [
                1,
                5.7
              ],
              [
                0.8,
                4.8
              ],
              [
                0.8,
                4.8
              ],
              [
                1.1,
                3.9
              ],
              [
                1.9,
                3.2
              ],
              [
                3,
                2.9
              ],
              [
                3,
                2.9
              ],
              [
                4.2,
                3.2
              ],
              [
                5.1,
                3.8
              ],
              [
                5.1,
                3.8
              ],
              [
                4.6,
                4.4
              ],
              [
                3.9,
                3.9
              ],
              [
                3,
                3.7
              ],
              [
                3,
                3.7
              ],
              [
                2.1,
                4
              ],
              [
                1.7,
                4.8
              ],
              [
                1.7,
                4.8
              ],
              [
                1.9,
                5.3
              ],
              [
                2.3,
                5.7
              ],
              [
                2.9,
                5.9
              ],
              [
                2.9,
                5.9
              ],
              [
                3.9,
                6.4
              ],
              [
                4.6,
                6.8
              ],
              [
                5.2,
                7.4
              ],
              [
                5.4,
                8.3
              ],
              [
                5.4,
                8.3
              ],
              [
                5.1,
                9.3
              ],
              [
                4.2,
                10
              ],
              [
                2.9,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.4,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1466,
    ty: 3,
    parent: 1455,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1455,
    ty: 3,
    parent: 1454,
    ks: {
      p: {
        a: 0,
        k: [
          47.868,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1470,
    ty: 4,
    parent: 1469,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.5,
                0.3
              ],
              [
                -1.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.7
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.1,
                10.3
              ],
              [
                2.1,
                10.3
              ],
              [
                1,
                9.9
              ],
              [
                0.6,
                8.8
              ],
              [
                0.6,
                8.8
              ],
              [
                1.3,
                7.5
              ],
              [
                3.8,
                6.8
              ],
              [
                3.8,
                6.8
              ],
              [
                3.7,
                6.2
              ],
              [
                3.4,
                5.7
              ],
              [
                2.7,
                5.5
              ],
              [
                2.7,
                5.5
              ],
              [
                1.9,
                5.7
              ],
              [
                1.1,
                6.1
              ],
              [
                1.1,
                6.1
              ],
              [
                0.8,
                5.5
              ],
              [
                1.7,
                5
              ],
              [
                2.9,
                4.8
              ],
              [
                2.9,
                4.8
              ],
              [
                4.3,
                5.4
              ],
              [
                4.7,
                6.9
              ],
              [
                4.7,
                6.9
              ],
              [
                4.7,
                10.2
              ],
              [
                4,
                10.2
              ],
              [
                3.9,
                9.5
              ],
              [
                3.8,
                9.5
              ],
              [
                3,
                10.1
              ],
              [
                2.1,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.5,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.4,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.4,
                9.6
              ],
              [
                2.4,
                9.6
              ],
              [
                3.1,
                9.4
              ],
              [
                3.8,
                8.9
              ],
              [
                3.8,
                8.9
              ],
              [
                3.8,
                7.4
              ],
              [
                2,
                7.9
              ],
              [
                1.4,
                8.7
              ],
              [
                1.4,
                8.7
              ],
              [
                1.7,
                9.4
              ],
              [
                2.4,
                9.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.9,
                0.1
              ],
              [
                -0.4,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1469,
    ty: 3,
    parent: 1468,
    ks: {
      p: {
        a: 0,
        k: [
          21.92,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1472,
    ty: 4,
    parent: 1471,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                10.2
              ],
              [
                0.9,
                10.2
              ],
              [
                0.9,
                4.9
              ],
              [
                1.8,
                4.9
              ],
              [
                1.8,
                10.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.3,
                3.8
              ],
              [
                1.3,
                3.8
              ],
              [
                0.9,
                3.7
              ],
              [
                0.7,
                3.2
              ],
              [
                0.7,
                3.2
              ],
              [
                0.9,
                2.8
              ],
              [
                1.3,
                2.7
              ],
              [
                1.3,
                2.7
              ],
              [
                1.8,
                2.8
              ],
              [
                1.9,
                3.2
              ],
              [
                1.9,
                3.2
              ],
              [
                1.8,
                3.7
              ],
              [
                1.3,
                3.8
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1471,
    ty: 3,
    parent: 1468,
    ks: {
      p: {
        a: 0,
        k: [
          19.256,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1474,
    ty: 4,
    parent: 1473,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                0.9
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.7,
                10.3
              ],
              [
                2.7,
                10.3
              ],
              [
                1.1,
                9.6
              ],
              [
                0.5,
                7.6
              ],
              [
                0.5,
                7.6
              ],
              [
                0.8,
                6.1
              ],
              [
                1.7,
                5.1
              ],
              [
                2.8,
                4.8
              ],
              [
                2.8,
                4.8
              ],
              [
                3.6,
                4.9
              ],
              [
                4.3,
                5.4
              ],
              [
                4.3,
                5.4
              ],
              [
                4.2,
                4.5
              ],
              [
                4.2,
                2.5
              ],
              [
                5.1,
                2.5
              ],
              [
                5.1,
                10.2
              ],
              [
                4.4,
                10.2
              ],
              [
                4.3,
                9.6
              ],
              [
                4.3,
                9.6
              ],
              [
                3.6,
                10.1
              ],
              [
                2.7,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.7,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                -0.5,
                0
              ]
            ],
            v: [
              [
                2.9,
                9.6
              ],
              [
                2.9,
                9.6
              ],
              [
                4.2,
                8.8
              ],
              [
                4.2,
                8.8
              ],
              [
                4.2,
                6.1
              ],
              [
                3.6,
                5.6
              ],
              [
                2.9,
                5.5
              ],
              [
                2.9,
                5.5
              ],
              [
                2.2,
                5.8
              ],
              [
                1.6,
                6.5
              ],
              [
                1.4,
                7.5
              ],
              [
                1.4,
                7.5
              ],
              [
                1.8,
                9
              ],
              [
                2.9,
                9.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1473,
    ty: 3,
    parent: 1468,
    ks: {
      p: {
        a: 0,
        k: [
          13.245,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1476,
    ty: 4,
    parent: 1475,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.4
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                3,
                10.3
              ],
              [
                3,
                10.3
              ],
              [
                1.7,
                10
              ],
              [
                0.8,
                9
              ],
              [
                0.5,
                7.6
              ],
              [
                0.5,
                7.6
              ],
              [
                0.8,
                6.1
              ],
              [
                1.7,
                5.1
              ],
              [
                2.9,
                4.8
              ],
              [
                2.9,
                4.8
              ],
              [
                4.4,
                5.4
              ],
              [
                5,
                7.2
              ],
              [
                5,
                7.2
              ],
              [
                5,
                7.5
              ],
              [
                4.9,
                7.8
              ],
              [
                4.9,
                7.8
              ],
              [
                1.4,
                7.8
              ],
              [
                1.9,
                9.1
              ],
              [
                3.1,
                9.6
              ],
              [
                3.1,
                9.6
              ],
              [
                3.8,
                9.5
              ],
              [
                4.4,
                9.2
              ],
              [
                4.4,
                9.2
              ],
              [
                4.8,
                9.8
              ],
              [
                4,
                10.1
              ],
              [
                3,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.2,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.1,
                -0.5
              ]
            ],
            v: [
              [
                1.4,
                7.1
              ],
              [
                1.4,
                7.1
              ],
              [
                4.2,
                7.1
              ],
              [
                3.8,
                5.9
              ],
              [
                2.9,
                5.5
              ],
              [
                2.9,
                5.5
              ],
              [
                1.9,
                5.9
              ],
              [
                1.4,
                7.1
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1475,
    ty: 3,
    parent: 1468,
    ks: {
      p: {
        a: 0,
        k: [
          7.873,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1478,
    ty: 4,
    parent: 1477,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                10.2
              ],
              [
                1,
                10.2
              ],
              [
                1,
                3.1
              ],
              [
                2.1,
                3.1
              ],
              [
                3.4,
                6.9
              ],
              [
                3.7,
                7.6
              ],
              [
                3.9,
                8.3
              ],
              [
                3.9,
                8.3
              ],
              [
                4,
                8.3
              ],
              [
                4.2,
                7.6
              ],
              [
                4.5,
                6.9
              ],
              [
                4.5,
                6.9
              ],
              [
                5.8,
                3.1
              ],
              [
                6.9,
                3.1
              ],
              [
                6.9,
                10.2
              ],
              [
                6.1,
                10.2
              ],
              [
                6.1,
                6.3
              ],
              [
                6.1,
                5.2
              ],
              [
                6.2,
                4.2
              ],
              [
                6.2,
                4.2
              ],
              [
                6.1,
                4.2
              ],
              [
                5.6,
                5.8
              ],
              [
                4.2,
                9.5
              ],
              [
                3.6,
                9.5
              ],
              [
                2.3,
                5.8
              ],
              [
                1.7,
                4.2
              ],
              [
                1.7,
                4.2
              ],
              [
                1.8,
                5.2
              ],
              [
                1.8,
                6.3
              ],
              [
                1.8,
                6.3
              ],
              [
                1.8,
                10.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1477,
    ty: 3,
    parent: 1468,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1468,
    ty: 3,
    parent: 1454,
    ks: {
      p: {
        a: 0,
        k: [
          18.324,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1481,
    ty: 4,
    parent: 1480,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.4,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.7,
                12.6
              ],
              [
                2.7,
                12.6
              ],
              [
                1.1,
                12.2
              ],
              [
                0.5,
                11.2
              ],
              [
                0.5,
                11.2
              ],
              [
                0.7,
                10.5
              ],
              [
                1.3,
                10
              ],
              [
                1.3,
                10
              ],
              [
                1.3,
                9.9
              ],
              [
                0.9,
                9.6
              ],
              [
                0.8,
                9.1
              ],
              [
                0.8,
                9.1
              ],
              [
                1,
                8.5
              ],
              [
                1.4,
                8.1
              ],
              [
                1.4,
                8.1
              ],
              [
                1.4,
                8.1
              ],
              [
                0.9,
                7.5
              ],
              [
                0.7,
                6.7
              ],
              [
                0.7,
                6.7
              ],
              [
                1,
                5.7
              ],
              [
                1.7,
                5
              ],
              [
                2.7,
                4.8
              ],
              [
                2.7,
                4.8
              ],
              [
                3.1,
                4.8
              ],
              [
                3.4,
                4.9
              ],
              [
                3.4,
                4.9
              ],
              [
                5.2,
                4.9
              ],
              [
                5.2,
                5.6
              ],
              [
                4.2,
                5.6
              ],
              [
                4.5,
                6.1
              ],
              [
                4.6,
                6.7
              ],
              [
                4.6,
                6.7
              ],
              [
                4.3,
                7.6
              ],
              [
                3.6,
                8.3
              ],
              [
                2.7,
                8.5
              ],
              [
                2.7,
                8.5
              ],
              [
                1.9,
                8.3
              ],
              [
                1.9,
                8.3
              ],
              [
                1.6,
                8.6
              ],
              [
                1.5,
                8.9
              ],
              [
                1.5,
                8.9
              ],
              [
                1.7,
                9.4
              ],
              [
                2.5,
                9.5
              ],
              [
                2.5,
                9.5
              ],
              [
                3.5,
                9.5
              ],
              [
                4.9,
                9.8
              ],
              [
                5.3,
                10.8
              ],
              [
                5.3,
                10.8
              ],
              [
                5,
                11.7
              ],
              [
                4.1,
                12.3
              ],
              [
                2.7,
                12.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.4,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.7,
                7.9
              ],
              [
                2.7,
                7.9
              ],
              [
                3.5,
                7.6
              ],
              [
                3.8,
                6.7
              ],
              [
                3.8,
                6.7
              ],
              [
                3.5,
                5.8
              ],
              [
                2.7,
                5.4
              ],
              [
                2.7,
                5.4
              ],
              [
                1.9,
                5.8
              ],
              [
                1.5,
                6.7
              ],
              [
                1.5,
                6.7
              ],
              [
                1.9,
                7.6
              ],
              [
                2.7,
                7.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                -0.5,
                0
              ]
            ],
            v: [
              [
                2.8,
                12
              ],
              [
                2.8,
                12
              ],
              [
                4,
                11.7
              ],
              [
                4.5,
                10.9
              ],
              [
                4.5,
                10.9
              ],
              [
                4.2,
                10.4
              ],
              [
                3.4,
                10.3
              ],
              [
                3.4,
                10.3
              ],
              [
                2.5,
                10.3
              ],
              [
                2.2,
                10.2
              ],
              [
                1.8,
                10.2
              ],
              [
                1.8,
                10.2
              ],
              [
                1.4,
                10.6
              ],
              [
                1.3,
                11.1
              ],
              [
                1.3,
                11.1
              ],
              [
                1.7,
                11.7
              ],
              [
                2.8,
                12
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1480,
    ty: 3,
    parent: 1479,
    ks: {
      p: {
        a: 0,
        k: [
          10.7,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1483,
    ty: 4,
    parent: 1482,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.6,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.3,
                10.3
              ],
              [
                2.3,
                10.3
              ],
              [
                1.2,
                10.1
              ],
              [
                0.3,
                9.6
              ],
              [
                0.3,
                9.6
              ],
              [
                0.7,
                9
              ],
              [
                1.5,
                9.4
              ],
              [
                2.3,
                9.6
              ],
              [
                2.3,
                9.6
              ],
              [
                3.1,
                9.4
              ],
              [
                3.3,
                8.8
              ],
              [
                3.3,
                8.8
              ],
              [
                3.2,
                8.3
              ],
              [
                2.7,
                8
              ],
              [
                2.1,
                7.8
              ],
              [
                2.1,
                7.8
              ],
              [
                1.4,
                7.5
              ],
              [
                0.8,
                7
              ],
              [
                0.6,
                6.3
              ],
              [
                0.6,
                6.3
              ],
              [
                1.1,
                5.2
              ],
              [
                2.4,
                4.8
              ],
              [
                2.4,
                4.8
              ],
              [
                3.3,
                5
              ],
              [
                4.1,
                5.4
              ],
              [
                4.1,
                5.4
              ],
              [
                3.6,
                5.9
              ],
              [
                3.1,
                5.6
              ],
              [
                2.4,
                5.5
              ],
              [
                2.4,
                5.5
              ],
              [
                1.7,
                5.7
              ],
              [
                1.5,
                6.2
              ],
              [
                1.5,
                6.2
              ],
              [
                1.6,
                6.6
              ],
              [
                2,
                6.9
              ],
              [
                2.6,
                7.1
              ],
              [
                2.6,
                7.1
              ],
              [
                3.3,
                7.5
              ],
              [
                4,
                7.9
              ],
              [
                4.2,
                8.7
              ],
              [
                4.2,
                8.7
              ],
              [
                4,
                9.5
              ],
              [
                3.3,
                10.1
              ],
              [
                2.3,
                10.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1482,
    ty: 3,
    parent: 1479,
    ks: {
      p: {
        a: 0,
        k: [
          6.162,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1485,
    ty: 4,
    parent: 1484,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.1
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.5,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.9,
                10.2
              ],
              [
                1,
                10.2
              ],
              [
                1,
                3.1
              ],
              [
                3.2,
                3.1
              ],
              [
                4.5,
                3.3
              ],
              [
                5.4,
                3.9
              ],
              [
                5.7,
                5.1
              ],
              [
                5.7,
                5.1
              ],
              [
                5.3,
                6.4
              ],
              [
                4.1,
                7.1
              ],
              [
                4.1,
                7.1
              ],
              [
                5.9,
                10.2
              ],
              [
                4.9,
                10.2
              ],
              [
                3.2,
                7.2
              ],
              [
                1.9,
                7.2
              ],
              [
                1.9,
                10.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.4,
                0.1
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0.6,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.9,
                3.8
              ],
              [
                1.9,
                6.4
              ],
              [
                3.1,
                6.4
              ],
              [
                4.3,
                6.1
              ],
              [
                4.8,
                5.1
              ],
              [
                4.8,
                5.1
              ],
              [
                4.3,
                4.1
              ],
              [
                3.1,
                3.8
              ],
              [
                3.1,
                3.8
              ],
              [
                1.9,
                3.8
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1484,
    ty: 3,
    parent: 1479,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1479,
    ty: 3,
    parent: 1454,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1454,
    ty: 3,
    parent: 1453,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1453,
    ty: 3,
    parent: 1452,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          11.514
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1490,
    ty: 0,
    parent: 1486,
    ks: {},
    w: 62,
    h: 12,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1488"
  },
  {
    ind: 1486,
    ty: 3,
    parent: 1452,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1452,
    ty: 3,
    parent: 1386,
    ks: {
      p: {
        a: 0,
        k: [
          21.238,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1386,
    ty: 3,
    parent: 1318,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1318,
    ty: 3,
    parent: 1317,
    ks: {
      p: {
        a: 0,
        k: [
          8.128,
          78.567
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1499,
    ty: 4,
    parent: 1498,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0.8
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.4,
                9
              ],
              [
                2.4,
                9
              ],
              [
                1,
                8.4
              ],
              [
                0.4,
                6.6
              ],
              [
                0.4,
                6.6
              ],
              [
                0.7,
                5.3
              ],
              [
                1.5,
                4.5
              ],
              [
                2.4,
                4.2
              ],
              [
                2.4,
                4.2
              ],
              [
                3.1,
                4.3
              ],
              [
                3.7,
                4.7
              ],
              [
                3.7,
                4.7
              ],
              [
                3.7,
                3.9
              ],
              [
                3.7,
                2.2
              ],
              [
                4.5,
                2.2
              ],
              [
                4.5,
                8.9
              ],
              [
                3.8,
                8.9
              ],
              [
                3.8,
                8.4
              ],
              [
                3.7,
                8.4
              ],
              [
                3.1,
                8.8
              ],
              [
                2.4,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                -0.4,
                0
              ]
            ],
            v: [
              [
                2.5,
                8.4
              ],
              [
                2.5,
                8.4
              ],
              [
                3.7,
                7.7
              ],
              [
                3.7,
                7.7
              ],
              [
                3.7,
                5.3
              ],
              [
                3.1,
                4.9
              ],
              [
                2.6,
                4.8
              ],
              [
                2.6,
                4.8
              ],
              [
                1.9,
                5.1
              ],
              [
                1.4,
                5.7
              ],
              [
                1.3,
                6.6
              ],
              [
                1.3,
                6.6
              ],
              [
                1.6,
                7.9
              ],
              [
                2.5,
                8.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1498,
    ty: 3,
    parent: 1497,
    ks: {
      p: {
        a: 0,
        k: [
          35.142,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1501,
    ty: 4,
    parent: 1500,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.23
              ],
              [
                0,
                0.41
              ],
              [
                0,
                0
              ],
              [
                -0.45,
                0.27
              ],
              [
                -0.98,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.18
              ],
              [
                0.14,
                0.11
              ],
              [
                0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.1
              ],
              [
                0.18,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.31,
                0.13
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.34
              ],
              [
                0,
                -0.58
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.13
              ],
              [
                0.29,
                0
              ]
            ],
            v: [
              [
                1.84,
                9.02
              ],
              [
                1.84,
                9.02
              ],
              [
                0.88,
                8.67
              ],
              [
                0.49,
                7.71
              ],
              [
                0.49,
                7.71
              ],
              [
                1.17,
                6.55
              ],
              [
                3.32,
                5.98
              ],
              [
                3.32,
                5.98
              ],
              [
                3.24,
                5.42
              ],
              [
                2.95,
                4.99
              ],
              [
                2.37,
                4.82
              ],
              [
                2.37,
                4.82
              ],
              [
                1.62,
                4.98
              ],
              [
                1,
                5.32
              ],
              [
                1,
                5.32
              ],
              [
                0.69,
                4.78
              ],
              [
                1.48,
                4.37
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.73,
                4.7
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                8.9
              ],
              [
                3.46,
                8.9
              ],
              [
                3.39,
                8.35
              ],
              [
                3.37,
                8.35
              ],
              [
                2.66,
                8.82
              ],
              [
                1.84,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.26,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.45,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.05,
                -0.18
              ],
              [
                -0.14,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.14
              ],
              [
                0.31,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.56,
                0
              ],
              [
                0.25,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.26,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.11
              ],
              [
                -0.22,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.19
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.23,
                0
              ]
            ],
            v: [
              [
                2.07,
                8.39
              ],
              [
                2.07,
                8.39
              ],
              [
                2.69,
                8.23
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                6.49
              ],
              [
                1.71,
                6.92
              ],
              [
                1.25,
                7.65
              ],
              [
                1.25,
                7.65
              ],
              [
                1.49,
                8.21
              ],
              [
                2.07,
                8.39
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.2,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.76,
                0.09
              ],
              [
                -0.31,
                0.19
              ],
              [
                0,
                0
              ],
              [
                0,
                0.26
              ],
              [
                0.16,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1500,
    ty: 3,
    parent: 1497,
    ks: {
      p: {
        a: 0,
        k: [
          30.364,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1503,
    ty: 4,
    parent: 1502,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.7
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.8,
                9
              ],
              [
                2.8,
                9
              ],
              [
                2.1,
                8.9
              ],
              [
                1.5,
                8.4
              ],
              [
                1.5,
                8.4
              ],
              [
                1.5,
                8.4
              ],
              [
                1.4,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                2.2
              ],
              [
                1.6,
                2.2
              ],
              [
                1.6,
                4
              ],
              [
                1.5,
                4.8
              ],
              [
                2.2,
                4.4
              ],
              [
                3,
                4.2
              ],
              [
                3,
                4.2
              ],
              [
                4.3,
                4.8
              ],
              [
                4.8,
                6.5
              ],
              [
                4.8,
                6.5
              ],
              [
                4.5,
                7.9
              ],
              [
                3.8,
                8.7
              ],
              [
                2.8,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.7,
                8.4
              ],
              [
                2.7,
                8.4
              ],
              [
                3.6,
                7.9
              ],
              [
                4,
                6.5
              ],
              [
                4,
                6.5
              ],
              [
                3.7,
                5.3
              ],
              [
                2.8,
                4.8
              ],
              [
                2.8,
                4.8
              ],
              [
                2.2,
                5
              ],
              [
                1.6,
                5.5
              ],
              [
                1.6,
                5.5
              ],
              [
                1.6,
                7.9
              ],
              [
                2.2,
                8.3
              ],
              [
                2.7,
                8.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1502,
    ty: 3,
    parent: 1497,
    ks: {
      p: {
        a: 0,
        k: [
          25.122,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1505,
    ty: 4,
    parent: 1504,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.23
              ],
              [
                0,
                0.41
              ],
              [
                0,
                0
              ],
              [
                -0.45,
                0.27
              ],
              [
                -0.98,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.18
              ],
              [
                0.14,
                0.11
              ],
              [
                0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.1
              ],
              [
                0.18,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.31,
                0.13
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.34
              ],
              [
                0,
                -0.58
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.13
              ],
              [
                0.29,
                0
              ]
            ],
            v: [
              [
                1.84,
                9.02
              ],
              [
                1.84,
                9.02
              ],
              [
                0.88,
                8.67
              ],
              [
                0.49,
                7.71
              ],
              [
                0.49,
                7.71
              ],
              [
                1.17,
                6.55
              ],
              [
                3.32,
                5.98
              ],
              [
                3.32,
                5.98
              ],
              [
                3.24,
                5.42
              ],
              [
                2.95,
                4.99
              ],
              [
                2.37,
                4.82
              ],
              [
                2.37,
                4.82
              ],
              [
                1.62,
                4.98
              ],
              [
                1,
                5.32
              ],
              [
                1,
                5.32
              ],
              [
                0.69,
                4.78
              ],
              [
                1.48,
                4.37
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.73,
                4.7
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                8.9
              ],
              [
                3.46,
                8.9
              ],
              [
                3.39,
                8.35
              ],
              [
                3.37,
                8.35
              ],
              [
                2.66,
                8.82
              ],
              [
                1.84,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.26,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.45,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.05,
                -0.18
              ],
              [
                -0.14,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.14
              ],
              [
                0.31,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.56,
                0
              ],
              [
                0.25,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.26,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.11
              ],
              [
                -0.22,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.19
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.23,
                0
              ]
            ],
            v: [
              [
                2.07,
                8.39
              ],
              [
                2.07,
                8.39
              ],
              [
                2.69,
                8.23
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                6.49
              ],
              [
                1.71,
                6.92
              ],
              [
                1.25,
                7.65
              ],
              [
                1.25,
                7.65
              ],
              [
                1.49,
                8.21
              ],
              [
                2.07,
                8.39
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.2,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.76,
                0.09
              ],
              [
                -0.31,
                0.19
              ],
              [
                0,
                0
              ],
              [
                0,
                0.26
              ],
              [
                0.16,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1504,
    ty: 3,
    parent: 1497,
    ks: {
      p: {
        a: 0,
        k: [
          20.344,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1507,
    ty: 4,
    parent: 1506,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0.8
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.4,
                9
              ],
              [
                2.4,
                9
              ],
              [
                1,
                8.4
              ],
              [
                0.4,
                6.6
              ],
              [
                0.4,
                6.6
              ],
              [
                0.7,
                5.3
              ],
              [
                1.5,
                4.5
              ],
              [
                2.4,
                4.2
              ],
              [
                2.4,
                4.2
              ],
              [
                3.1,
                4.3
              ],
              [
                3.7,
                4.7
              ],
              [
                3.7,
                4.7
              ],
              [
                3.7,
                3.9
              ],
              [
                3.7,
                2.2
              ],
              [
                4.5,
                2.2
              ],
              [
                4.5,
                8.9
              ],
              [
                3.8,
                8.9
              ],
              [
                3.8,
                8.4
              ],
              [
                3.7,
                8.4
              ],
              [
                3.1,
                8.8
              ],
              [
                2.4,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                -0.4,
                0
              ]
            ],
            v: [
              [
                2.5,
                8.4
              ],
              [
                2.5,
                8.4
              ],
              [
                3.7,
                7.7
              ],
              [
                3.7,
                7.7
              ],
              [
                3.7,
                5.3
              ],
              [
                3.1,
                4.9
              ],
              [
                2.6,
                4.8
              ],
              [
                2.6,
                4.8
              ],
              [
                1.9,
                5.1
              ],
              [
                1.4,
                5.7
              ],
              [
                1.3,
                6.6
              ],
              [
                1.3,
                6.6
              ],
              [
                1.6,
                7.9
              ],
              [
                2.5,
                8.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1506,
    ty: 3,
    parent: 1497,
    ks: {
      p: {
        a: 0,
        k: [
          15.083,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1509,
    ty: 4,
    parent: 1508,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                4.3
              ],
              [
                1.6,
                4.3
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.3
              ],
              [
                1.2,
                3.3
              ],
              [
                0.8,
                3.2
              ],
              [
                0.7,
                2.8
              ],
              [
                0.7,
                2.8
              ],
              [
                0.8,
                2.5
              ],
              [
                1.2,
                2.3
              ],
              [
                1.2,
                2.3
              ],
              [
                1.6,
                2.5
              ],
              [
                1.7,
                2.8
              ],
              [
                1.7,
                2.8
              ],
              [
                1.6,
                3.2
              ],
              [
                1.2,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1508,
    ty: 3,
    parent: 1497,
    ks: {
      p: {
        a: 0,
        k: [
          12.751,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1511,
    ty: 4,
    parent: 1510,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.17
              ],
              [
                -0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.06,
                0.01
              ],
              [
                0.09,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.16
              ],
              [
                0.16,
                -0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                5.13
              ],
              [
                1.52,
                5.13
              ],
              [
                2.1,
                4.44
              ],
              [
                2.83,
                4.18
              ],
              [
                2.83,
                4.18
              ],
              [
                3.32,
                4.27
              ],
              [
                3.32,
                4.27
              ],
              [
                3.17,
                4.96
              ],
              [
                2.96,
                4.9
              ],
              [
                2.72,
                4.88
              ],
              [
                2.72,
                4.88
              ],
              [
                2.11,
                5.12
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.29
              ],
              [
                0.23,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.06,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.21,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1510,
    ty: 3,
    parent: 1497,
    ks: {
      p: {
        a: 0,
        k: [
          9.461,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1513,
    ty: 4,
    parent: 1512,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.23
              ],
              [
                0,
                0.41
              ],
              [
                0,
                0
              ],
              [
                -0.45,
                0.27
              ],
              [
                -0.98,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.18
              ],
              [
                0.14,
                0.11
              ],
              [
                0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.1
              ],
              [
                0.18,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.31,
                0.13
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.34
              ],
              [
                0,
                -0.58
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.13
              ],
              [
                0.29,
                0
              ]
            ],
            v: [
              [
                1.84,
                9.02
              ],
              [
                1.84,
                9.02
              ],
              [
                0.88,
                8.67
              ],
              [
                0.49,
                7.71
              ],
              [
                0.49,
                7.71
              ],
              [
                1.17,
                6.55
              ],
              [
                3.32,
                5.98
              ],
              [
                3.32,
                5.98
              ],
              [
                3.24,
                5.42
              ],
              [
                2.95,
                4.99
              ],
              [
                2.37,
                4.82
              ],
              [
                2.37,
                4.82
              ],
              [
                1.62,
                4.98
              ],
              [
                1,
                5.32
              ],
              [
                1,
                5.32
              ],
              [
                0.69,
                4.78
              ],
              [
                1.48,
                4.37
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.73,
                4.7
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                8.9
              ],
              [
                3.46,
                8.9
              ],
              [
                3.39,
                8.35
              ],
              [
                3.37,
                8.35
              ],
              [
                2.66,
                8.82
              ],
              [
                1.84,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.26,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.45,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.05,
                -0.18
              ],
              [
                -0.14,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.14
              ],
              [
                0.31,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.56,
                0
              ],
              [
                0.25,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.26,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.11
              ],
              [
                -0.22,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.19
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.23,
                0
              ]
            ],
            v: [
              [
                2.07,
                8.39
              ],
              [
                2.07,
                8.39
              ],
              [
                2.69,
                8.23
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                6.49
              ],
              [
                1.71,
                6.92
              ],
              [
                1.25,
                7.65
              ],
              [
                1.25,
                7.65
              ],
              [
                1.49,
                8.21
              ],
              [
                2.07,
                8.39
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.2,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.76,
                0.09
              ],
              [
                -0.31,
                0.19
              ],
              [
                0,
                0
              ],
              [
                0,
                0.26
              ],
              [
                0.16,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1512,
    ty: 3,
    parent: 1497,
    ks: {
      p: {
        a: 0,
        k: [
          4.683,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1515,
    ty: 4,
    parent: 1514,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                2.7
              ],
              [
                4.4,
                2.7
              ],
              [
                4.4,
                3.3
              ],
              [
                1.6,
                3.3
              ],
              [
                1.6,
                5.5
              ],
              [
                4,
                5.5
              ],
              [
                4,
                6.1
              ],
              [
                1.6,
                6.1
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1514,
    ty: 3,
    parent: 1497,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1497,
    ty: 3,
    parent: 1496,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1496,
    ty: 3,
    parent: 1495,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1495,
    ty: 3,
    parent: 1494,
    ks: {
      p: {
        a: 0,
        k: [
          16.255,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1525,
    ty: 0,
    parent: 1516,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.582
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    w: 10.837,
    h: 10.837,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1523"
  },
  {
    ind: 1516,
    ty: 3,
    parent: 1494,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1494,
    ty: 3,
    parent: 1493,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          14.709
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1531,
    ty: 4,
    parent: 1530,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.2,
                9
              ],
              [
                2.2,
                9
              ],
              [
                1,
                8.8
              ],
              [
                0.2,
                8.2
              ],
              [
                0.2,
                8.2
              ],
              [
                0.6,
                7.7
              ],
              [
                1.3,
                8.2
              ],
              [
                2.2,
                8.4
              ],
              [
                2.2,
                8.4
              ],
              [
                3.1,
                8.1
              ],
              [
                3.4,
                7.3
              ],
              [
                3.4,
                7.3
              ],
              [
                3.3,
                6.6
              ],
              [
                2.7,
                6.2
              ],
              [
                1.5,
                6.1
              ],
              [
                1.5,
                6.1
              ],
              [
                1.5,
                5.5
              ],
              [
                2.5,
                5.3
              ],
              [
                3.1,
                4.9
              ],
              [
                3.2,
                4.3
              ],
              [
                3.2,
                4.3
              ],
              [
                2.9,
                3.6
              ],
              [
                2.2,
                3.4
              ],
              [
                2.2,
                3.4
              ],
              [
                1.5,
                3.5
              ],
              [
                0.9,
                4
              ],
              [
                0.9,
                4
              ],
              [
                0.5,
                3.5
              ],
              [
                1.3,
                3
              ],
              [
                2.2,
                2.7
              ],
              [
                2.2,
                2.7
              ],
              [
                3.5,
                3.1
              ],
              [
                4,
                4.3
              ],
              [
                4,
                4.3
              ],
              [
                3.7,
                5.2
              ],
              [
                2.9,
                5.7
              ],
              [
                2.9,
                5.7
              ],
              [
                2.9,
                5.8
              ],
              [
                3.8,
                6.3
              ],
              [
                4.2,
                7.3
              ],
              [
                4.2,
                7.3
              ],
              [
                4,
                8.2
              ],
              [
                3.2,
                8.8
              ],
              [
                2.2,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.1
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1530,
    ty: 3,
    parent: 1529,
    ks: {
      p: {
        a: 0,
        k: [
          13.007,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1533,
    ty: 4,
    parent: 1532,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.57,
                6.83
              ],
              [
                0.39,
                6.83
              ],
              [
                0.39,
                6.23
              ],
              [
                2.57,
                6.23
              ],
              [
                2.57,
                6.83
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1532,
    ty: 3,
    parent: 1529,
    ks: {
      p: {
        a: 0,
        k: [
          10.058,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1535,
    ty: 4,
    parent: 1534,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                4.5,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                2.7
              ],
              [
                4.4,
                2.7
              ],
              [
                4.4,
                3.3
              ],
              [
                1.6,
                3.3
              ],
              [
                1.6,
                5.3
              ],
              [
                4,
                5.3
              ],
              [
                4,
                6
              ],
              [
                1.6,
                6
              ],
              [
                1.6,
                8.2
              ],
              [
                4.5,
                8.2
              ],
              [
                4.5,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1534,
    ty: 3,
    parent: 1529,
    ks: {
      p: {
        a: 0,
        k: [
          5.062,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1537,
    ty: 4,
    parent: 1536,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                0.9,
                7.5
              ],
              [
                1.7,
                8.1
              ],
              [
                2.6,
                8.3
              ],
              [
                2.6,
                8.3
              ],
              [
                3.5,
                8
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.8,
                6.8
              ],
              [
                3.4,
                6.5
              ],
              [
                2.9,
                6.2
              ],
              [
                2.9,
                6.2
              ],
              [
                2,
                5.8
              ],
              [
                1.4,
                5.5
              ],
              [
                0.9,
                5
              ],
              [
                0.7,
                4.2
              ],
              [
                0.7,
                4.2
              ],
              [
                1,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.7,
                2.8
              ],
              [
                4.5,
                3.3
              ],
              [
                4.5,
                3.3
              ],
              [
                4.1,
                3.8
              ],
              [
                3.4,
                3.4
              ],
              [
                2.7,
                3.3
              ],
              [
                2.7,
                3.3
              ],
              [
                1.8,
                3.5
              ],
              [
                1.5,
                4.2
              ],
              [
                1.5,
                4.2
              ],
              [
                1.7,
                4.7
              ],
              [
                2,
                5
              ],
              [
                2.5,
                5.2
              ],
              [
                2.5,
                5.2
              ],
              [
                3.4,
                5.6
              ],
              [
                4.1,
                5.9
              ],
              [
                4.5,
                6.5
              ],
              [
                4.7,
                7.2
              ],
              [
                4.7,
                7.2
              ],
              [
                4.4,
                8.1
              ],
              [
                3.7,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1536,
    ty: 3,
    parent: 1529,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1529,
    ty: 3,
    parent: 1528,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1528,
    ty: 3,
    parent: 1527,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.469
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1527,
    ty: 3,
    parent: 1526,
    ks: {
      p: {
        a: 0,
        k: [
          16.255,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1547,
    ty: 0,
    parent: 1538,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.582
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    w: 10.837,
    h: 10.837,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1545"
  },
  {
    ind: 1538,
    ty: 3,
    parent: 1526,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1526,
    ty: 3,
    parent: 1493,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1493,
    ty: 3,
    parent: 1492,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          27.418
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1553,
    ty: 4,
    parent: 1552,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.2,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                9.2
              ],
              [
                2,
                9.2
              ],
              [
                2.1,
                10.2
              ],
              [
                2.2,
                10.2
              ],
              [
                3,
                9.3
              ],
              [
                3.9,
                9
              ],
              [
                3.9,
                9
              ],
              [
                4.6,
                9.2
              ],
              [
                4.6,
                9.2
              ],
              [
                4.3,
                10.4
              ],
              [
                4,
                10.3
              ],
              [
                3.7,
                10.3
              ],
              [
                3.7,
                10.3
              ],
              [
                3,
                10.6
              ],
              [
                2.3,
                11.5
              ],
              [
                2.3,
                11.5
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1552,
    ty: 3,
    parent: 1551,
    ks: {
      p: {
        a: 0,
        k: [
          30.621,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1555,
    ty: 4,
    parent: 1554,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.6,
                0.4
              ],
              [
                -1.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.3
              ],
              [
                2.3,
                15.3
              ],
              [
                1.1,
                14.8
              ],
              [
                0.6,
                13.6
              ],
              [
                0.6,
                13.6
              ],
              [
                1.4,
                12.1
              ],
              [
                4.1,
                11.3
              ],
              [
                4.1,
                11.3
              ],
              [
                3.8,
                10.5
              ],
              [
                3,
                10.2
              ],
              [
                3,
                10.2
              ],
              [
                2.1,
                10.3
              ],
              [
                1.3,
                10.8
              ],
              [
                1.3,
                10.8
              ],
              [
                0.8,
                9.8
              ],
              [
                1.9,
                9.3
              ],
              [
                3.3,
                9
              ],
              [
                3.3,
                9
              ],
              [
                4.9,
                9.7
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                15.2
              ],
              [
                4.3,
                15.2
              ],
              [
                4.2,
                14.5
              ],
              [
                4.2,
                14.5
              ],
              [
                3.3,
                15.1
              ],
              [
                2.3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.6,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.8,
                14.2
              ],
              [
                2.8,
                14.2
              ],
              [
                3.5,
                14
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                12.2
              ],
              [
                2.4,
                12.7
              ],
              [
                1.9,
                13.5
              ],
              [
                1.9,
                13.5
              ],
              [
                2.2,
                14
              ],
              [
                2.8,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.8,
                0.1
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1554,
    ty: 3,
    parent: 1551,
    ks: {
      p: {
        a: 0,
        k: [
          24.331,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1557,
    ty: 4,
    parent: 1556,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                -0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                9.2
              ],
              [
                2,
                9.2
              ],
              [
                2.1,
                10
              ],
              [
                2.2,
                10
              ],
              [
                3,
                9.3
              ],
              [
                4,
                9
              ],
              [
                4,
                9
              ],
              [
                5.1,
                9.3
              ],
              [
                5.7,
                10.1
              ],
              [
                5.7,
                10.1
              ],
              [
                6.6,
                9.3
              ],
              [
                7.6,
                9
              ],
              [
                7.6,
                9
              ],
              [
                9,
                9.7
              ],
              [
                9.5,
                11.4
              ],
              [
                9.5,
                11.4
              ],
              [
                9.5,
                15.2
              ],
              [
                8,
                15.2
              ],
              [
                8,
                11.6
              ],
              [
                7.8,
                10.6
              ],
              [
                7.1,
                10.2
              ],
              [
                7.1,
                10.2
              ],
              [
                5.9,
                11
              ],
              [
                5.9,
                11
              ],
              [
                5.9,
                15.2
              ],
              [
                4.5,
                15.2
              ],
              [
                4.5,
                11.6
              ],
              [
                4.2,
                10.6
              ],
              [
                3.5,
                10.2
              ],
              [
                3.5,
                10.2
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1556,
    ty: 3,
    parent: 1551,
    ks: {
      p: {
        a: 0,
        k: [
          14.055,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1559,
    ty: 4,
    parent: 1558,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.7,
                15.3
              ],
              [
                2.7,
                15.3
              ],
              [
                1.3,
                14.7
              ],
              [
                0.8,
                12.9
              ],
              [
                0.8,
                12.9
              ],
              [
                0.8,
                9.2
              ],
              [
                2.2,
                9.2
              ],
              [
                2.2,
                12.8
              ],
              [
                2.5,
                13.8
              ],
              [
                3.2,
                14.1
              ],
              [
                3.2,
                14.1
              ],
              [
                3.8,
                13.9
              ],
              [
                4.5,
                13.3
              ],
              [
                4.5,
                13.3
              ],
              [
                4.5,
                9.2
              ],
              [
                5.9,
                9.2
              ],
              [
                5.9,
                15.2
              ],
              [
                4.7,
                15.2
              ],
              [
                4.6,
                14.3
              ],
              [
                4.6,
                14.3
              ],
              [
                3.7,
                15
              ],
              [
                2.7,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1558,
    ty: 3,
    parent: 1551,
    ks: {
      p: {
        a: 0,
        k: [
          7.277,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1561,
    ty: 4,
    parent: 1560,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                15.2
              ],
              [
                1,
                15.2
              ],
              [
                1,
                7.2
              ],
              [
                2.4,
                7.2
              ],
              [
                2.4,
                10.8
              ],
              [
                2.5,
                10.8
              ],
              [
                5.3,
                7.2
              ],
              [
                6.9,
                7.2
              ],
              [
                4.4,
                10.3
              ],
              [
                7.3,
                15.2
              ],
              [
                5.7,
                15.2
              ],
              [
                3.6,
                11.4
              ],
              [
                2.4,
                12.8
              ],
              [
                2.4,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1560,
    ty: 3,
    parent: 1551,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1551,
    ty: 3,
    parent: 1550,
    ks: {
      p: {
        a: 0,
        k: [
          33.413,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1564,
    ty: 4,
    parent: 1563,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                9.2
              ],
              [
                2,
                9.2
              ],
              [
                2.1,
                10
              ],
              [
                2.2,
                10
              ],
              [
                3.1,
                9.3
              ],
              [
                4.2,
                9
              ],
              [
                4.2,
                9
              ],
              [
                5.6,
                9.7
              ],
              [
                6,
                11.4
              ],
              [
                6,
                11.4
              ],
              [
                6,
                15.2
              ],
              [
                4.6,
                15.2
              ],
              [
                4.6,
                11.6
              ],
              [
                4.4,
                10.6
              ],
              [
                3.7,
                10.2
              ],
              [
                3.7,
                10.2
              ],
              [
                3,
                10.4
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1563,
    ty: 3,
    parent: 1562,
    ks: {
      p: {
        a: 0,
        k: [
          24.148,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1566,
    ty: 4,
    parent: 1565,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.7,
                15.3
              ],
              [
                2.7,
                15.3
              ],
              [
                1.3,
                14.7
              ],
              [
                0.8,
                12.9
              ],
              [
                0.8,
                12.9
              ],
              [
                0.8,
                9.2
              ],
              [
                2.2,
                9.2
              ],
              [
                2.2,
                12.8
              ],
              [
                2.5,
                13.8
              ],
              [
                3.2,
                14.1
              ],
              [
                3.2,
                14.1
              ],
              [
                3.8,
                13.9
              ],
              [
                4.5,
                13.3
              ],
              [
                4.5,
                13.3
              ],
              [
                4.5,
                9.2
              ],
              [
                5.9,
                9.2
              ],
              [
                5.9,
                15.2
              ],
              [
                4.7,
                15.2
              ],
              [
                4.6,
                14.3
              ],
              [
                4.6,
                14.3
              ],
              [
                3.7,
                15
              ],
              [
                2.7,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1565,
    ty: 3,
    parent: 1562,
    ks: {
      p: {
        a: 0,
        k: [
          17.371,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1568,
    ty: 4,
    parent: 1567,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.2,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                9.2
              ],
              [
                2,
                9.2
              ],
              [
                2.1,
                10.2
              ],
              [
                2.2,
                10.2
              ],
              [
                3,
                9.3
              ],
              [
                3.9,
                9
              ],
              [
                3.9,
                9
              ],
              [
                4.6,
                9.2
              ],
              [
                4.6,
                9.2
              ],
              [
                4.3,
                10.4
              ],
              [
                4,
                10.3
              ],
              [
                3.7,
                10.3
              ],
              [
                3.7,
                10.3
              ],
              [
                3,
                10.6
              ],
              [
                2.3,
                11.5
              ],
              [
                2.3,
                11.5
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1567,
    ty: 3,
    parent: 1562,
    ks: {
      p: {
        a: 0,
        k: [
          12.824,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1570,
    ty: 4,
    parent: 1569,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.6,
                0.4
              ],
              [
                -1.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.3
              ],
              [
                2.3,
                15.3
              ],
              [
                1.1,
                14.8
              ],
              [
                0.6,
                13.6
              ],
              [
                0.6,
                13.6
              ],
              [
                1.4,
                12.1
              ],
              [
                4.1,
                11.3
              ],
              [
                4.1,
                11.3
              ],
              [
                3.8,
                10.5
              ],
              [
                3,
                10.2
              ],
              [
                3,
                10.2
              ],
              [
                2.1,
                10.3
              ],
              [
                1.3,
                10.8
              ],
              [
                1.3,
                10.8
              ],
              [
                0.8,
                9.8
              ],
              [
                1.9,
                9.3
              ],
              [
                3.3,
                9
              ],
              [
                3.3,
                9
              ],
              [
                4.9,
                9.7
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                15.2
              ],
              [
                4.3,
                15.2
              ],
              [
                4.2,
                14.5
              ],
              [
                4.2,
                14.5
              ],
              [
                3.3,
                15.1
              ],
              [
                2.3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.6,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.8,
                14.2
              ],
              [
                2.8,
                14.2
              ],
              [
                3.5,
                14
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                12.2
              ],
              [
                2.4,
                12.7
              ],
              [
                1.9,
                13.5
              ],
              [
                1.9,
                13.5
              ],
              [
                2.2,
                14
              ],
              [
                2.8,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.8,
                0.1
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1569,
    ty: 3,
    parent: 1562,
    ks: {
      p: {
        a: 0,
        k: [
          6.534,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1572,
    ty: 4,
    parent: 1571,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.4
              ],
              [
                -0.1,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.4
              ],
              [
                -0.1,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                4.1,
                15.2
              ],
              [
                2.4,
                15.2
              ],
              [
                0,
                7.2
              ],
              [
                1.5,
                7.2
              ],
              [
                2.6,
                11.2
              ],
              [
                2.9,
                12.5
              ],
              [
                3.3,
                13.8
              ],
              [
                3.3,
                13.8
              ],
              [
                3.3,
                13.8
              ],
              [
                3.7,
                12.5
              ],
              [
                4,
                11.2
              ],
              [
                4,
                11.2
              ],
              [
                5.1,
                7.2
              ],
              [
                6.6,
                7.2
              ],
              [
                4.1,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.4
              ],
              [
                0.1,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.5
              ],
              [
                0.1,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1571,
    ty: 3,
    parent: 1562,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1562,
    ty: 3,
    parent: 1550,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1550,
    ty: 3,
    parent: 1549,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.163
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1549,
    ty: 3,
    parent: 1548,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1548,
    ty: 3,
    parent: 1492,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1492,
    ty: 3,
    parent: 1491,
    ks: {
      p: {
        a: 0,
        k: [
          70.439,
          2.737
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1583,
    ty: 0,
    parent: 1574,
    ks: {
      a: {
        a: 0,
        k: [
          41.992,
          42.669
        ]
      },
      p: {
        a: 0,
        k: [
          41.992,
          42.669
        ]
      }
    },
    w: 16.255,
    h: 16.255,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1581"
  },
  {
    ind: 1574,
    ty: 3,
    parent: 1573,
    ks: {
      p: {
        a: 0,
        k: [
          41.992,
          42.669
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1586,
    ty: 4,
    td: 1,
    parent: 1584,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            29.801,
            29.801
          ]
        },
        r: {
          a: 0,
          k: 46
        },
        s: {
          a: 0,
          k: [
            59.602,
            59.602
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0,
            0,
            0
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1585,
    ty: 4,
    tt: 1,
    parent: 1584,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                29.801,
                29.801
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                62.989,
                62.989
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ty: "gr",
        it: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                29.801,
                29.801
              ]
            },
            r: {
              a: 0,
              k: 46
            },
            s: {
              a: 0,
              k: [
                59.602,
                59.602
              ]
            }
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.427,
                0.184,
                0.604
              ]
            },
            lj: 1,
            ml: 10,
            o: {
              a: 0,
              k: 100
            },
            w: {
              a: 0,
              k: 3.387
            }
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      }
    ]
  },
  {
    ind: 1602,
    ty: 4,
    td: 1,
    parent: 1584,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            29.801,
            29.801
          ]
        },
        r: {
          a: 0,
          k: 46
        },
        s: {
          a: 0,
          k: [
            59.602,
            59.602
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0,
            0,
            0
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1601,
    ty: 0,
    tt: 1,
    parent: 1584,
    ks: {},
    w: 55,
    h: 55,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1599"
  },
  {
    ind: 1584,
    ty: 3,
    parent: 1573,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1573,
    ty: 3,
    parent: 1491,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1491,
    ty: 3,
    parent: 1317,
    ks: {
      p: {
        a: 0,
        k: [
          8.128,
          8.128
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1603,
    ty: 4,
    parent: 1317,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            113.787,
            70.005
          ]
        },
        r: {
          a: 0,
          k: 5
        },
        s: {
          a: 0,
          k: [
            227.573,
            140.01
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            1,
            1,
            1
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1317,
    ty: 3,
    parent: 16,
    ks: {
      a: {
        a: 0,
        k: [
          113.787,
          70.005
        ]
      },
      p: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              -625.454,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 132,
            s: [
              -357.454,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 276,
            s: [
              -89.454,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 420,
            s: [
              178.546,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              446.546,
              92.212
            ],
            h: 1
          }
        ]
      },
      s: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              100,
              100
            ],
            i: {
              x: [
                1,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 276,
            s: [
              100,
              100
            ],
            i: {
              x: [
                0.2,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 420,
            s: [
              107,
              107
            ],
            i: {
              x: [
                0.2,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              93,
              93
            ],
            h: 1
          }
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1613,
    ty: 4,
    parent: 1612,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1612,
    ty: 3,
    parent: 1611,
    ks: {
      p: {
        a: 0,
        k: [
          21.813,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1615,
    ty: 4,
    parent: 1614,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1614,
    ty: 3,
    parent: 1611,
    ks: {
      p: {
        a: 0,
        k: [
          17.007,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1617,
    ty: 4,
    parent: 1616,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.8,
                9
              ],
              [
                1.8,
                9
              ],
              [
                0.9,
                8.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                7.8
              ],
              [
                1.9,
                8
              ],
              [
                2,
                8.1
              ],
              [
                2,
                8.1
              ],
              [
                2.1,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.3,
                8.9
              ],
              [
                2.1,
                9
              ],
              [
                1.8,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1616,
    ty: 3,
    parent: 1611,
    ks: {
      p: {
        a: 0,
        k: [
          14.438,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1619,
    ty: 4,
    parent: 1618,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1618,
    ty: 3,
    parent: 1611,
    ks: {
      p: {
        a: 0,
        k: [
          9.546,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1621,
    ty: 4,
    parent: 1620,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.36
              ],
              [
                -0.36,
                0.19
              ],
              [
                -0.41,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.1
              ],
              [
                -0.17,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.13,
                0.06
              ],
              [
                0.15,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.28
              ],
              [
                0,
                -0.47
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                -0.28
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                0.08
              ],
              [
                -0.13,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.27,
                0
              ]
            ],
            v: [
              [
                2.64,
                9.02
              ],
              [
                2.64,
                9.02
              ],
              [
                1.49,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.71,
                5.26
              ],
              [
                1.57,
                4.42
              ],
              [
                2.72,
                4.13
              ],
              [
                2.72,
                4.13
              ],
              [
                3.5,
                4.28
              ],
              [
                4.09,
                4.65
              ],
              [
                4.09,
                4.65
              ],
              [
                3.56,
                5.37
              ],
              [
                3.19,
                5.11
              ],
              [
                2.78,
                5.02
              ],
              [
                2.78,
                5.02
              ],
              [
                1.86,
                5.45
              ],
              [
                1.51,
                6.58
              ],
              [
                1.51,
                6.58
              ],
              [
                1.85,
                7.7
              ],
              [
                2.75,
                8.12
              ],
              [
                2.75,
                8.12
              ],
              [
                3.27,
                8.01
              ],
              [
                3.71,
                7.73
              ],
              [
                3.71,
                7.73
              ],
              [
                4.15,
                8.45
              ],
              [
                3.43,
                8.87
              ],
              [
                2.64,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.42,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.52
              ],
              [
                0.21,
                -0.36
              ],
              [
                0.36,
                -0.19
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.22,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                -0.11
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                -0.37,
                0
              ],
              [
                -0.24,
                0.28
              ],
              [
                0,
                0
              ],
              [
                0,
                0.46
              ],
              [
                0.23,
                0.28
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0.16,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.19
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1620,
    ty: 3,
    parent: 1611,
    ks: {
      p: {
        a: 0,
        k: [
          5.167,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1623,
    ty: 4,
    parent: 1622,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                1,
                7.4
              ],
              [
                1.8,
                7.9
              ],
              [
                2.6,
                8.1
              ],
              [
                2.6,
                8.1
              ],
              [
                3.4,
                7.8
              ],
              [
                3.7,
                7.3
              ],
              [
                3.7,
                7.3
              ],
              [
                3.4,
                6.7
              ],
              [
                2.7,
                6.4
              ],
              [
                2.7,
                6.4
              ],
              [
                1.9,
                6
              ],
              [
                1.3,
                5.6
              ],
              [
                0.8,
                5.1
              ],
              [
                0.6,
                4.3
              ],
              [
                0.6,
                4.3
              ],
              [
                0.9,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.8,
                2.8
              ],
              [
                4.6,
                3.4
              ],
              [
                4.6,
                3.4
              ],
              [
                4.1,
                4.1
              ],
              [
                3.4,
                3.7
              ],
              [
                2.7,
                3.5
              ],
              [
                2.7,
                3.5
              ],
              [
                2,
                3.7
              ],
              [
                1.7,
                4.3
              ],
              [
                1.7,
                4.3
              ],
              [
                1.9,
                4.7
              ],
              [
                2.2,
                4.9
              ],
              [
                2.7,
                5.1
              ],
              [
                2.7,
                5.1
              ],
              [
                3.6,
                5.5
              ],
              [
                4.5,
                6.1
              ],
              [
                4.8,
                7.2
              ],
              [
                4.8,
                7.2
              ],
              [
                4.6,
                8.1
              ],
              [
                3.8,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1622,
    ty: 3,
    parent: 1611,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1611,
    ty: 3,
    parent: 1610,
    ks: {
      p: {
        a: 0,
        k: [
          93.74,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1626,
    ty: 4,
    parent: 1625,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1625,
    ty: 3,
    parent: 1624,
    ks: {
      p: {
        a: 0,
        k: [
          15.786,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1628,
    ty: 4,
    parent: 1627,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1627,
    ty: 3,
    parent: 1624,
    ks: {
      p: {
        a: 0,
        k: [
          10.979,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1630,
    ty: 4,
    parent: 1629,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                5.1
              ],
              [
                0.3,
                5.1
              ],
              [
                0.3,
                4.3
              ],
              [
                0.9,
                4.2
              ],
              [
                0.9,
                3.8
              ],
              [
                1.2,
                2.6
              ],
              [
                2.4,
                2.1
              ],
              [
                2.4,
                2.1
              ],
              [
                2.9,
                2.1
              ],
              [
                3.3,
                2.3
              ],
              [
                3.3,
                2.3
              ],
              [
                3.1,
                3.1
              ],
              [
                2.6,
                3
              ],
              [
                2.6,
                3
              ],
              [
                2,
                3.7
              ],
              [
                2,
                3.7
              ],
              [
                2,
                4.2
              ],
              [
                2.9,
                4.2
              ],
              [
                2.9,
                5.1
              ],
              [
                2,
                5.1
              ],
              [
                2,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                5.3,
                9
              ],
              [
                5.3,
                9
              ],
              [
                4.2,
                8.5
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                5.1
              ],
              [
                3.2,
                5.1
              ],
              [
                3.2,
                4.3
              ],
              [
                3.9,
                4.2
              ],
              [
                4,
                3
              ],
              [
                5,
                3
              ],
              [
                5,
                4.2
              ],
              [
                6.1,
                4.2
              ],
              [
                6.1,
                5.1
              ],
              [
                5,
                5.1
              ],
              [
                5,
                7.3
              ],
              [
                5.6,
                8.1
              ],
              [
                5.6,
                8.1
              ],
              [
                5.9,
                8.1
              ],
              [
                6.1,
                8
              ],
              [
                6.1,
                8
              ],
              [
                6.3,
                8.8
              ],
              [
                5.9,
                9
              ],
              [
                5.3,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1629,
    ty: 3,
    parent: 1624,
    ks: {
      p: {
        a: 0,
        k: [
          4.892,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1632,
    ty: 4,
    parent: 1631,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1631,
    ty: 3,
    parent: 1624,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1624,
    ty: 3,
    parent: 1610,
    ks: {
      p: {
        a: 0,
        k: [
          72.522,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1635,
    ty: 4,
    parent: 1634,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1634,
    ty: 3,
    parent: 1633,
    ks: {
      p: {
        a: 0,
        k: [
          13.718,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1637,
    ty: 4,
    parent: 1636,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                8.9
              ],
              [
                0.7,
                8.9
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                6.4
              ],
              [
                1.8,
                6.4
              ],
              [
                3.5,
                4.2
              ],
              [
                4.7,
                4.2
              ],
              [
                3.1,
                6.1
              ],
              [
                4.9,
                8.9
              ],
              [
                3.7,
                8.9
              ],
              [
                2.5,
                6.9
              ],
              [
                1.8,
                7.7
              ],
              [
                1.8,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1636,
    ty: 3,
    parent: 1633,
    ks: {
      p: {
        a: 0,
        k: [
          8.769,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1639,
    ty: 4,
    parent: 1638,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                8.9
              ],
              [
                0.7,
                8.9
              ],
              [
                0.7,
                4.2
              ],
              [
                1.8,
                4.2
              ],
              [
                1.8,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.4
              ],
              [
                1.2,
                3.4
              ],
              [
                0.8,
                3.3
              ],
              [
                0.6,
                2.8
              ],
              [
                0.6,
                2.8
              ],
              [
                0.8,
                2.4
              ],
              [
                1.2,
                2.2
              ],
              [
                1.2,
                2.2
              ],
              [
                1.7,
                2.4
              ],
              [
                1.9,
                2.8
              ],
              [
                1.9,
                2.8
              ],
              [
                1.7,
                3.3
              ],
              [
                1.2,
                3.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1638,
    ty: 3,
    parent: 1633,
    ks: {
      p: {
        a: 0,
        k: [
          6.285,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1641,
    ty: 4,
    parent: 1640,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.9,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                2.7
              ],
              [
                1.9,
                2.7
              ],
              [
                1.9,
                5.2
              ],
              [
                4.4,
                5.2
              ],
              [
                4.4,
                2.7
              ],
              [
                5.5,
                2.7
              ],
              [
                5.5,
                8.9
              ],
              [
                4.4,
                8.9
              ],
              [
                4.4,
                6.2
              ],
              [
                1.9,
                6.2
              ],
              [
                1.9,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1640,
    ty: 3,
    parent: 1633,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1633,
    ty: 3,
    parent: 1610,
    ks: {
      p: {
        a: 0,
        k: [
          52.102,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1644,
    ty: 4,
    parent: 1643,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                1,
                10.8
              ],
              [
                1,
                10.8
              ],
              [
                0.7,
                10.8
              ],
              [
                0.4,
                10.7
              ],
              [
                0.4,
                10.7
              ],
              [
                0.6,
                9.9
              ],
              [
                0.8,
                9.9
              ],
              [
                0.9,
                9.9
              ],
              [
                0.9,
                9.9
              ],
              [
                1.5,
                9.7
              ],
              [
                1.9,
                9.1
              ],
              [
                1.9,
                9.1
              ],
              [
                1.9,
                8.8
              ],
              [
                0.1,
                4.2
              ],
              [
                1.2,
                4.2
              ],
              [
                2,
                6.5
              ],
              [
                2.2,
                7.2
              ],
              [
                2.4,
                7.8
              ],
              [
                2.4,
                7.8
              ],
              [
                2.5,
                7.8
              ],
              [
                2.7,
                7.2
              ],
              [
                2.8,
                6.5
              ],
              [
                2.8,
                6.5
              ],
              [
                3.5,
                4.2
              ],
              [
                4.6,
                4.2
              ],
              [
                2.9,
                9.1
              ],
              [
                2.2,
                10.4
              ],
              [
                1,
                10.8
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.5
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1643,
    ty: 3,
    parent: 1642,
    ks: {
      p: {
        a: 0,
        k: [
          21.055,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1646,
    ty: 4,
    parent: 1645,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1645,
    ty: 3,
    parent: 1642,
    ks: {
      p: {
        a: 0,
        k: [
          17.519,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1648,
    ty: 4,
    parent: 1647,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1647,
    ty: 3,
    parent: 1642,
    ks: {
      p: {
        a: 0,
        k: [
          12.627,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1650,
    ty: 4,
    parent: 1649,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.8,
                9
              ],
              [
                1.8,
                9
              ],
              [
                0.9,
                8.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                7.8
              ],
              [
                1.9,
                8
              ],
              [
                2,
                8.1
              ],
              [
                2,
                8.1
              ],
              [
                2.1,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.3,
                8.9
              ],
              [
                2.1,
                9
              ],
              [
                1.8,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1649,
    ty: 3,
    parent: 1642,
    ks: {
      p: {
        a: 0,
        k: [
          10.058,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1652,
    ty: 4,
    parent: 1651,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1651,
    ty: 3,
    parent: 1642,
    ks: {
      p: {
        a: 0,
        k: [
          5.167,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1654,
    ty: 4,
    parent: 1653,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                1,
                7.4
              ],
              [
                1.8,
                7.9
              ],
              [
                2.6,
                8.1
              ],
              [
                2.6,
                8.1
              ],
              [
                3.4,
                7.8
              ],
              [
                3.7,
                7.3
              ],
              [
                3.7,
                7.3
              ],
              [
                3.4,
                6.7
              ],
              [
                2.7,
                6.4
              ],
              [
                2.7,
                6.4
              ],
              [
                1.9,
                6
              ],
              [
                1.3,
                5.6
              ],
              [
                0.8,
                5.1
              ],
              [
                0.6,
                4.3
              ],
              [
                0.6,
                4.3
              ],
              [
                0.9,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.8,
                2.8
              ],
              [
                4.6,
                3.4
              ],
              [
                4.6,
                3.4
              ],
              [
                4.1,
                4.1
              ],
              [
                3.4,
                3.7
              ],
              [
                2.7,
                3.5
              ],
              [
                2.7,
                3.5
              ],
              [
                2,
                3.7
              ],
              [
                1.7,
                4.3
              ],
              [
                1.7,
                4.3
              ],
              [
                1.9,
                4.7
              ],
              [
                2.2,
                4.9
              ],
              [
                2.7,
                5.1
              ],
              [
                2.7,
                5.1
              ],
              [
                3.6,
                5.5
              ],
              [
                4.5,
                6.1
              ],
              [
                4.8,
                7.2
              ],
              [
                4.8,
                7.2
              ],
              [
                4.6,
                8.1
              ],
              [
                3.8,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1653,
    ty: 3,
    parent: 1642,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1642,
    ty: 3,
    parent: 1610,
    ks: {
      p: {
        a: 0,
        k: [
          24.458,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1657,
    ty: 4,
    parent: 1656,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                1.8,
                6.5
              ],
              [
                1.8,
                6.5
              ],
              [
                0.7,
                6
              ],
              [
                0.3,
                4.5
              ],
              [
                0.3,
                4.5
              ],
              [
                0.7,
                3.1
              ],
              [
                1.8,
                2.6
              ],
              [
                1.8,
                2.6
              ],
              [
                2.8,
                3.1
              ],
              [
                3.2,
                4.5
              ],
              [
                3.2,
                4.5
              ],
              [
                2.8,
                6
              ],
              [
                1.8,
                6.5
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                1.8,
                5.9
              ],
              [
                1.8,
                5.9
              ],
              [
                2.3,
                5.6
              ],
              [
                2.5,
                4.5
              ],
              [
                2.5,
                4.5
              ],
              [
                2.3,
                3.5
              ],
              [
                1.8,
                3.2
              ],
              [
                1.8,
                3.2
              ],
              [
                1.3,
                3.5
              ],
              [
                1.1,
                4.5
              ],
              [
                1.1,
                4.5
              ],
              [
                1.3,
                5.6
              ],
              [
                1.8,
                5.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2,
                9
              ],
              [
                5.3,
                2.6
              ],
              [
                6,
                2.6
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                6.2,
                9
              ],
              [
                6.2,
                9
              ],
              [
                5.1,
                8.5
              ],
              [
                4.7,
                7
              ],
              [
                4.7,
                7
              ],
              [
                5.1,
                5.6
              ],
              [
                6.2,
                5.1
              ],
              [
                6.2,
                5.1
              ],
              [
                7.3,
                5.6
              ],
              [
                7.7,
                7
              ],
              [
                7.7,
                7
              ],
              [
                7.3,
                8.5
              ],
              [
                6.2,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                6.2,
                8.4
              ],
              [
                6.2,
                8.4
              ],
              [
                6.7,
                8.1
              ],
              [
                6.9,
                7
              ],
              [
                6.9,
                7
              ],
              [
                6.7,
                6
              ],
              [
                6.2,
                5.7
              ],
              [
                6.2,
                5.7
              ],
              [
                5.7,
                6
              ],
              [
                5.5,
                7
              ],
              [
                5.5,
                7
              ],
              [
                5.7,
                8.1
              ],
              [
                6.2,
                8.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1656,
    ty: 3,
    parent: 1655,
    ks: {
      p: {
        a: 0,
        k: [
          14.59,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1659,
    ty: 4,
    parent: 1658,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.6
              ],
              [
                -0.2,
                0.5
              ],
              [
                -0.4,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.1,
                -0.4
              ],
              [
                0.1,
                -0.5
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.7,
                8.9
              ],
              [
                1.6,
                8.9
              ],
              [
                1.8,
                7
              ],
              [
                2.3,
                5.4
              ],
              [
                3.3,
                3.8
              ],
              [
                3.3,
                3.8
              ],
              [
                0.4,
                3.8
              ],
              [
                0.4,
                2.9
              ],
              [
                4.5,
                2.9
              ],
              [
                4.5,
                3.5
              ],
              [
                3.6,
                4.8
              ],
              [
                3.1,
                6
              ],
              [
                2.8,
                7.3
              ],
              [
                2.7,
                8.9
              ],
              [
                2.7,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                -0.7
              ],
              [
                0.1,
                -0.6
              ],
              [
                0.2,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.4
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.1,
                0.4
              ],
              [
                -0.1,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1658,
    ty: 3,
    parent: 1655,
    ks: {
      p: {
        a: 0,
        k: [
          9.726,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1661,
    ty: 4,
    parent: 1660,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                4.8
              ],
              [
                1.3,
                6.5
              ],
              [
                2.8,
                6.5
              ],
              [
                2.8,
                5.1
              ],
              [
                2.9,
                4.5
              ],
              [
                2.9,
                3.9
              ],
              [
                2.9,
                3.9
              ],
              [
                2.8,
                3.9
              ],
              [
                2.6,
                4.4
              ],
              [
                2.4,
                4.8
              ],
              [
                2.4,
                4.8
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                3.9,
                8.9
              ],
              [
                2.8,
                8.9
              ],
              [
                2.8,
                7.3
              ],
              [
                0.2,
                7.3
              ],
              [
                0.2,
                6.6
              ],
              [
                2.6,
                2.9
              ],
              [
                3.9,
                2.9
              ],
              [
                3.9,
                6.5
              ],
              [
                4.6,
                6.5
              ],
              [
                4.6,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1660,
    ty: 3,
    parent: 1655,
    ks: {
      p: {
        a: 0,
        k: [
          4.863,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1663,
    ty: 4,
    parent: 1662,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.4
              ],
              [
                -0.2,
                0.4
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.3,
                -0.4
              ],
              [
                0.4,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                4.4,
                8.9
              ],
              [
                0.4,
                8.9
              ],
              [
                0.4,
                8.3
              ],
              [
                1.8,
                6.8
              ],
              [
                2.8,
                5.6
              ],
              [
                3.1,
                4.7
              ],
              [
                3.1,
                4.7
              ],
              [
                2.8,
                3.9
              ],
              [
                2.1,
                3.6
              ],
              [
                2.1,
                3.6
              ],
              [
                1.5,
                3.8
              ],
              [
                0.9,
                4.3
              ],
              [
                0.9,
                4.3
              ],
              [
                0.3,
                3.7
              ],
              [
                1.2,
                3
              ],
              [
                2.2,
                2.8
              ],
              [
                2.2,
                2.8
              ],
              [
                3.6,
                3.3
              ],
              [
                4.1,
                4.6
              ],
              [
                4.1,
                4.6
              ],
              [
                3.8,
                5.7
              ],
              [
                3,
                6.8
              ],
              [
                2,
                8
              ],
              [
                2,
                8
              ],
              [
                2.5,
                8
              ],
              [
                3,
                8
              ],
              [
                3,
                8
              ],
              [
                4.4,
                8
              ],
              [
                4.4,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.6,
                -0.5
              ],
              [
                0.4,
                -0.4
              ],
              [
                0.2,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1662,
    ty: 3,
    parent: 1655,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1655,
    ty: 3,
    parent: 1610,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1610,
    ty: 3,
    parent: 1609,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1609,
    ty: 3,
    parent: 1608,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1608,
    ty: 3,
    parent: 1607,
    ks: {
      p: {
        a: 0,
        k: [
          17.029,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1672,
    ty: 0,
    parent: 1664,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.582
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    w: 10.837,
    h: 10.837,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1670"
  },
  {
    ind: 1664,
    ty: 3,
    parent: 1607,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1607,
    ty: 3,
    parent: 1606,
    ks: {
      p: {
        a: 0,
        k: [
          37.644,
          2.709
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1606,
    ty: 3,
    parent: 1605,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          35.897
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1694,
    ty: 0,
    parent: 1675,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          10.548
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          10.548
        ]
      }
    },
    w: 39.477,
    h: 11.875,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1692"
  },
  {
    ind: 1675,
    ty: 3,
    parent: 1674,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          10.548
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1699,
    ty: 4,
    parent: 1698,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.13
              ],
              [
                -0.19,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.11,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.01
              ],
              [
                0.07,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.12
              ],
              [
                0.12,
                -0.29
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.14,
                6.54
              ],
              [
                0.57,
                6.54
              ],
              [
                0.57,
                3.15
              ],
              [
                1.04,
                3.15
              ],
              [
                1.09,
                3.77
              ],
              [
                1.11,
                3.77
              ],
              [
                1.54,
                3.26
              ],
              [
                2.08,
                3.07
              ],
              [
                2.08,
                3.07
              ],
              [
                2.44,
                3.14
              ],
              [
                2.44,
                3.14
              ],
              [
                2.33,
                3.64
              ],
              [
                2.17,
                3.6
              ],
              [
                2,
                3.59
              ],
              [
                2,
                3.59
              ],
              [
                1.55,
                3.76
              ],
              [
                1.14,
                4.37
              ],
              [
                1.14,
                4.37
              ],
              [
                1.14,
                6.54
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.12,
                -0.21
              ],
              [
                0.17,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.13,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.06,
                -0.02
              ],
              [
                -0.05,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0
              ],
              [
                -0.16,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1698,
    ty: 3,
    parent: 1697,
    ks: {
      p: {
        a: 0,
        k: [
          15.625,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1701,
    ty: 4,
    parent: 1700,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                0.14
              ],
              [
                0.14,
                0.26
              ],
              [
                0,
                0.37
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.23,
                0.14
              ],
              [
                -0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                -0.29
              ],
              [
                0,
                -0.48
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.06
              ],
              [
                0.01,
                -0.04
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.21
              ],
              [
                -0.33,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0.05
              ],
              [
                -0.13,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.18,
                -0.07
              ],
              [
                0.23,
                0
              ]
            ],
            v: [
              [
                1.94,
                6.62
              ],
              [
                1.94,
                6.62
              ],
              [
                1.12,
                6.41
              ],
              [
                0.54,
                5.8
              ],
              [
                0.32,
                4.85
              ],
              [
                0.32,
                4.85
              ],
              [
                0.54,
                3.9
              ],
              [
                1.11,
                3.29
              ],
              [
                1.84,
                3.07
              ],
              [
                1.84,
                3.07
              ],
              [
                2.84,
                3.5
              ],
              [
                3.19,
                4.66
              ],
              [
                3.19,
                4.66
              ],
              [
                3.19,
                4.84
              ],
              [
                3.17,
                4.99
              ],
              [
                3.17,
                4.99
              ],
              [
                0.88,
                4.99
              ],
              [
                1.22,
                5.84
              ],
              [
                2.01,
                6.16
              ],
              [
                2.01,
                6.16
              ],
              [
                2.46,
                6.09
              ],
              [
                2.86,
                5.9
              ],
              [
                2.86,
                5.9
              ],
              [
                3.06,
                6.28
              ],
              [
                2.57,
                6.52
              ],
              [
                1.94,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.25,
                -0.14
              ],
              [
                -0.14,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.37
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.23,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0.43,
                0
              ],
              [
                0.23,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0,
                0.06
              ],
              [
                0,
                0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.02,
                0.36
              ],
              [
                0.2,
                0.21
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0
              ],
              [
                0.14,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0.09
              ],
              [
                -0.18,
                0.07
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.18
              ],
              [
                0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.18
              ],
              [
                0.04,
                -0.33
              ]
            ],
            v: [
              [
                0.88,
                4.58
              ],
              [
                0.88,
                4.58
              ],
              [
                2.69,
                4.58
              ],
              [
                2.47,
                3.79
              ],
              [
                1.85,
                3.52
              ],
              [
                1.85,
                3.52
              ],
              [
                1.22,
                3.8
              ],
              [
                0.88,
                4.58
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.34
              ],
              [
                -0.15,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                0
              ],
              [
                -0.19,
                0.18
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1700,
    ty: 3,
    parent: 1697,
    ks: {
      p: {
        a: 0,
        k: [
          12.173,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1703,
    ty: 4,
    parent: 1702,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.2,
                6.6
              ],
              [
                1.2,
                6.6
              ],
              [
                0.7,
                6.4
              ],
              [
                0.6,
                5.9
              ],
              [
                0.6,
                5.9
              ],
              [
                0.6,
                1.6
              ],
              [
                1.1,
                1.6
              ],
              [
                1.1,
                5.9
              ],
              [
                1.2,
                6.1
              ],
              [
                1.3,
                6.2
              ],
              [
                1.3,
                6.2
              ],
              [
                1.4,
                6.1
              ],
              [
                1.4,
                6.1
              ],
              [
                1.4,
                6.1
              ],
              [
                1.5,
                6.6
              ],
              [
                1.4,
                6.6
              ],
              [
                1.2,
                6.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1702,
    ty: 3,
    parent: 1697,
    ks: {
      p: {
        a: 0,
        k: [
          10.398,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1705,
    ty: 4,
    parent: 1704,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                0.17
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.72,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0.04,
                0.13
              ],
              [
                0.1,
                0.08
              ],
              [
                0.19,
                0
              ],
              [
                0,
                0
              ],
              [
                0.17,
                -0.07
              ],
              [
                0.13,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                -0.25
              ],
              [
                0,
                -0.42
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.1
              ],
              [
                0.21,
                0
              ]
            ],
            v: [
              [
                1.35,
                6.62
              ],
              [
                1.35,
                6.62
              ],
              [
                0.64,
                6.37
              ],
              [
                0.36,
                5.66
              ],
              [
                0.36,
                5.66
              ],
              [
                0.86,
                4.81
              ],
              [
                2.44,
                4.39
              ],
              [
                2.44,
                4.39
              ],
              [
                2.38,
                3.98
              ],
              [
                2.17,
                3.67
              ],
              [
                1.74,
                3.54
              ],
              [
                1.74,
                3.54
              ],
              [
                1.19,
                3.66
              ],
              [
                0.73,
                3.91
              ],
              [
                0.73,
                3.91
              ],
              [
                0.51,
                3.51
              ],
              [
                1.09,
                3.21
              ],
              [
                1.84,
                3.07
              ],
              [
                1.84,
                3.07
              ],
              [
                2.74,
                3.45
              ],
              [
                3.02,
                4.46
              ],
              [
                3.02,
                4.46
              ],
              [
                3.02,
                6.54
              ],
              [
                2.54,
                6.54
              ],
              [
                2.49,
                6.14
              ],
              [
                2.47,
                6.14
              ],
              [
                1.95,
                6.48
              ],
              [
                1.35,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.28,
                0
              ],
              [
                -0.19,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.14
              ],
              [
                -0.04,
                -0.13
              ],
              [
                -0.1,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.17,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.1
              ],
              [
                0.23,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.41,
                0
              ],
              [
                0.19,
                0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                0.13
              ],
              [
                -0.19,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0.08
              ],
              [
                -0.16,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.14
              ],
              [
                0,
                -0.22
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                -0.09
              ],
              [
                -0.17,
                0
              ]
            ],
            v: [
              [
                1.52,
                6.16
              ],
              [
                1.52,
                6.16
              ],
              [
                1.98,
                6.05
              ],
              [
                2.44,
                5.71
              ],
              [
                2.44,
                5.71
              ],
              [
                2.44,
                4.77
              ],
              [
                1.26,
                5.08
              ],
              [
                0.92,
                5.62
              ],
              [
                0.92,
                5.62
              ],
              [
                1.09,
                6.04
              ],
              [
                1.52,
                6.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.16,
                0
              ],
              [
                0.14,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.56,
                0.07
              ],
              [
                -0.23,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0.19
              ],
              [
                0.12,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1704,
    ty: 3,
    parent: 1697,
    ks: {
      p: {
        a: 0,
        k: [
          6.89,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1707,
    ty: 4,
    parent: 1706,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.14
              ],
              [
                0.14,
                0.26
              ],
              [
                0,
                0.37
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.25,
                0.14
              ],
              [
                -0.29,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.08
              ],
              [
                -0.12,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.11,
                0.06
              ],
              [
                0.13,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.11
              ],
              [
                0.09,
                -0.2
              ],
              [
                0,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                -0.24
              ],
              [
                -0.31,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                0.07
              ],
              [
                -0.1,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.08
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.91,
                6.62
              ],
              [
                1.91,
                6.62
              ],
              [
                1.1,
                6.42
              ],
              [
                0.53,
                5.81
              ],
              [
                0.32,
                4.85
              ],
              [
                0.32,
                4.85
              ],
              [
                0.55,
                3.89
              ],
              [
                1.15,
                3.28
              ],
              [
                1.95,
                3.07
              ],
              [
                1.95,
                3.07
              ],
              [
                2.53,
                3.19
              ],
              [
                2.94,
                3.47
              ],
              [
                2.94,
                3.47
              ],
              [
                2.65,
                3.84
              ],
              [
                2.34,
                3.63
              ],
              [
                1.97,
                3.54
              ],
              [
                1.97,
                3.54
              ],
              [
                1.42,
                3.71
              ],
              [
                1.05,
                4.17
              ],
              [
                0.91,
                4.85
              ],
              [
                0.91,
                4.85
              ],
              [
                1.2,
                5.79
              ],
              [
                1.96,
                6.15
              ],
              [
                1.96,
                6.15
              ],
              [
                2.4,
                6.05
              ],
              [
                2.75,
                5.81
              ],
              [
                2.75,
                5.81
              ],
              [
                3,
                6.19
              ],
              [
                2.49,
                6.51
              ],
              [
                1.91,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.24,
                -0.14
              ],
              [
                -0.14,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.38
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.25,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.16,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.09
              ],
              [
                -0.11,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.16,
                0.11
              ],
              [
                -0.09,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.39
              ],
              [
                0.19,
                0.24
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0
              ],
              [
                0.13,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.13
              ],
              [
                -0.19,
                0.08
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1706,
    ty: 3,
    parent: 1697,
    ks: {
      p: {
        a: 0,
        k: [
          3.717,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1709,
    ty: 4,
    parent: 1708,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                0.12
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.1
              ],
              [
                -0.24,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.14
              ],
              [
                0,
                0.22
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.09
              ],
              [
                0.11,
                0.07
              ],
              [
                0.14,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.1
              ],
              [
                0.1,
                0.15
              ],
              [
                0,
                0.22
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                0.18
              ],
              [
                -0.22,
                0.1
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                -0.1
              ],
              [
                -0.16,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.17,
                0.08
              ],
              [
                0.21,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.12
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.1
              ],
              [
                -0.12,
                -0.06
              ],
              [
                -0.12,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.1
              ],
              [
                -0.08,
                -0.15
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0.13,
                -0.2
              ],
              [
                0.23,
                -0.12
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                1.89,
                6.62
              ],
              [
                1.89,
                6.62
              ],
              [
                1,
                6.44
              ],
              [
                0.29,
                5.95
              ],
              [
                0.29,
                5.95
              ],
              [
                0.64,
                5.54
              ],
              [
                1.22,
                5.96
              ],
              [
                1.9,
                6.12
              ],
              [
                1.9,
                6.12
              ],
              [
                2.61,
                5.91
              ],
              [
                2.86,
                5.37
              ],
              [
                2.86,
                5.37
              ],
              [
                2.76,
                4.99
              ],
              [
                2.48,
                4.76
              ],
              [
                2.1,
                4.56
              ],
              [
                2.1,
                4.56
              ],
              [
                1.44,
                4.28
              ],
              [
                1.01,
                4.04
              ],
              [
                0.66,
                3.66
              ],
              [
                0.52,
                3.1
              ],
              [
                0.52,
                3.1
              ],
              [
                0.7,
                2.48
              ],
              [
                1.21,
                2.04
              ],
              [
                1.95,
                1.89
              ],
              [
                1.95,
                1.89
              ],
              [
                2.71,
                2.04
              ],
              [
                3.3,
                2.45
              ],
              [
                3.3,
                2.45
              ],
              [
                2.99,
                2.83
              ],
              [
                2.53,
                2.51
              ],
              [
                1.95,
                2.4
              ],
              [
                1.95,
                2.4
              ],
              [
                1.33,
                2.58
              ],
              [
                1.1,
                3.06
              ],
              [
                1.1,
                3.06
              ],
              [
                1.22,
                3.42
              ],
              [
                1.5,
                3.66
              ],
              [
                1.86,
                3.82
              ],
              [
                1.86,
                3.82
              ],
              [
                2.51,
                4.1
              ],
              [
                2.99,
                4.37
              ],
              [
                3.32,
                4.75
              ],
              [
                3.45,
                5.32
              ],
              [
                3.45,
                5.32
              ],
              [
                3.26,
                5.98
              ],
              [
                2.72,
                6.45
              ],
              [
                1.89,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.27,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.17
              ],
              [
                0.22,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.17,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.16
              ],
              [
                -0.07,
                -0.09
              ],
              [
                -0.11,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.06
              ],
              [
                -0.14,
                -0.1
              ],
              [
                -0.1,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.23
              ],
              [
                0.12,
                -0.18
              ],
              [
                0.22,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.27,
                0
              ],
              [
                0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.13
              ],
              [
                -0.17,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                -0.26,
                0
              ],
              [
                -0.16,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0.14
              ],
              [
                0.08,
                0.1
              ],
              [
                0.12,
                0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0.07
              ],
              [
                0.14,
                0.1
              ],
              [
                0.08,
                0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                0.24
              ],
              [
                -0.13,
                0.2
              ],
              [
                -0.23,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1708,
    ty: 3,
    parent: 1697,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1697,
    ty: 3,
    parent: 1696,
    ks: {
      p: {
        a: 0,
        k: [
          14.372,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1712,
    ty: 4,
    parent: 1711,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.21
              ],
              [
                0,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.11
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.07,
                0.02
              ],
              [
                -0.06,
                0.02
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.11,
                -0.03
              ],
              [
                0.11,
                0
              ]
            ],
            v: [
              [
                1.64,
                6.62
              ],
              [
                1.64,
                6.62
              ],
              [
                0.88,
                6.31
              ],
              [
                0.67,
                5.5
              ],
              [
                0.67,
                5.5
              ],
              [
                0.67,
                3.62
              ],
              [
                0.17,
                3.62
              ],
              [
                0.17,
                3.19
              ],
              [
                0.7,
                3.15
              ],
              [
                0.77,
                2.21
              ],
              [
                1.25,
                2.21
              ],
              [
                1.25,
                3.15
              ],
              [
                2.16,
                3.15
              ],
              [
                2.16,
                3.62
              ],
              [
                1.25,
                3.62
              ],
              [
                1.25,
                5.5
              ],
              [
                1.36,
                5.99
              ],
              [
                1.77,
                6.16
              ],
              [
                1.77,
                6.16
              ],
              [
                1.96,
                6.13
              ],
              [
                2.15,
                6.07
              ],
              [
                2.15,
                6.07
              ],
              [
                2.26,
                6.5
              ],
              [
                1.96,
                6.59
              ],
              [
                1.64,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.36,
                0
              ],
              [
                -0.14,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.08,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.06,
                0
              ],
              [
                0.07,
                -0.02
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.09,
                0.03
              ],
              [
                -0.11,
                0.03
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1711,
    ty: 3,
    parent: 1710,
    ks: {
      p: {
        a: 0,
        k: [
          10.628,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1714,
    ty: 4,
    parent: 1713,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0.09
              ],
              [
                0.16,
                0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.08
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.11,
                0.1
              ],
              [
                0,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0.08,
                0.08
              ],
              [
                0.12,
                0.05
              ],
              [
                0.13,
                0.05
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.08
              ],
              [
                0.1,
                0.12
              ],
              [
                0,
                0.19
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                -0.07
              ],
              [
                -0.13,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.13,
                0.06
              ],
              [
                0.15,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                -0.07,
                -0.07
              ],
              [
                -0.11,
                -0.05
              ],
              [
                -0.13,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.08
              ],
              [
                -0.1,
                -0.13
              ],
              [
                0,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.15
              ],
              [
                0.18,
                -0.09
              ],
              [
                0.27,
                0
              ]
            ],
            v: [
              [
                1.46,
                6.62
              ],
              [
                1.46,
                6.62
              ],
              [
                0.77,
                6.49
              ],
              [
                0.2,
                6.16
              ],
              [
                0.2,
                6.16
              ],
              [
                0.48,
                5.77
              ],
              [
                0.94,
                6.06
              ],
              [
                1.48,
                6.18
              ],
              [
                1.48,
                6.18
              ],
              [
                1.98,
                6.02
              ],
              [
                2.15,
                5.65
              ],
              [
                2.15,
                5.65
              ],
              [
                2.03,
                5.36
              ],
              [
                1.74,
                5.16
              ],
              [
                1.37,
                5.01
              ],
              [
                1.37,
                5.01
              ],
              [
                0.91,
                4.8
              ],
              [
                0.53,
                4.5
              ],
              [
                0.38,
                4.03
              ],
              [
                0.38,
                4.03
              ],
              [
                0.69,
                3.35
              ],
              [
                1.55,
                3.07
              ],
              [
                1.55,
                3.07
              ],
              [
                2.14,
                3.18
              ],
              [
                2.61,
                3.45
              ],
              [
                2.61,
                3.45
              ],
              [
                2.33,
                3.82
              ],
              [
                1.96,
                3.6
              ],
              [
                1.55,
                3.52
              ],
              [
                1.55,
                3.52
              ],
              [
                1.08,
                3.66
              ],
              [
                0.93,
                4
              ],
              [
                0.93,
                4
              ],
              [
                1.04,
                4.27
              ],
              [
                1.31,
                4.44
              ],
              [
                1.66,
                4.59
              ],
              [
                1.66,
                4.59
              ],
              [
                2.15,
                4.8
              ],
              [
                2.54,
                5.1
              ],
              [
                2.7,
                5.61
              ],
              [
                2.7,
                5.61
              ],
              [
                2.55,
                6.12
              ],
              [
                2.14,
                6.48
              ],
              [
                1.46,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.24,
                0
              ],
              [
                -0.22,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.12
              ],
              [
                0.16,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.11,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.12
              ],
              [
                -0.08,
                -0.08
              ],
              [
                -0.12,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.06
              ],
              [
                -0.15,
                -0.08
              ],
              [
                -0.1,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.27
              ],
              [
                0.21,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                0.21,
                0
              ],
              [
                0.18,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                -0.09
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.11
              ],
              [
                0.07,
                0.07
              ],
              [
                0.11,
                0.05
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.06
              ],
              [
                0.16,
                0.08
              ],
              [
                0.1,
                0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0.18
              ],
              [
                -0.1,
                0.15
              ],
              [
                -0.18,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1713,
    ty: 3,
    parent: 1710,
    ks: {
      p: {
        a: 0,
        k: [
          7.712,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1716,
    ty: 4,
    parent: 1715,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.14
              ],
              [
                0.15,
                0.26
              ],
              [
                0,
                0.37
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.24,
                0.14
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                -0.14
              ],
              [
                -0.15,
                -0.26
              ],
              [
                0,
                -0.38
              ],
              [
                0,
                0
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.24,
                -0.14
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.89,
                6.62
              ],
              [
                1.89,
                6.62
              ],
              [
                1.12,
                6.42
              ],
              [
                0.54,
                5.81
              ],
              [
                0.32,
                4.85
              ],
              [
                0.32,
                4.85
              ],
              [
                0.54,
                3.89
              ],
              [
                1.12,
                3.28
              ],
              [
                1.89,
                3.07
              ],
              [
                1.89,
                3.07
              ],
              [
                2.66,
                3.28
              ],
              [
                3.24,
                3.89
              ],
              [
                3.46,
                4.85
              ],
              [
                3.46,
                4.85
              ],
              [
                3.24,
                5.81
              ],
              [
                2.66,
                6.42
              ],
              [
                1.89,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.24,
                -0.14
              ],
              [
                -0.15,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.38
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.24,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0.28,
                0
              ],
              [
                0.24,
                0.14
              ],
              [
                0.15,
                0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                0.37
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.24,
                0.14
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0.24
              ],
              [
                0,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0.24
              ],
              [
                0.29,
                0
              ],
              [
                0,
                0
              ],
              [
                0.18,
                -0.24
              ],
              [
                0,
                -0.39
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                -0.24
              ],
              [
                -0.29,
                0
              ]
            ],
            v: [
              [
                1.89,
                6.15
              ],
              [
                1.89,
                6.15
              ],
              [
                2.6,
                5.79
              ],
              [
                2.86,
                4.85
              ],
              [
                2.86,
                4.85
              ],
              [
                2.6,
                3.91
              ],
              [
                1.89,
                3.54
              ],
              [
                1.89,
                3.54
              ],
              [
                1.18,
                3.91
              ],
              [
                0.91,
                4.85
              ],
              [
                0.91,
                4.85
              ],
              [
                1.18,
                5.79
              ],
              [
                1.89,
                6.15
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.29,
                0
              ],
              [
                0.18,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.39
              ],
              [
                -0.18,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                0
              ],
              [
                -0.18,
                0.24
              ],
              [
                0,
                0
              ],
              [
                0,
                0.39
              ],
              [
                0.18,
                0.24
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1715,
    ty: 3,
    parent: 1710,
    ks: {
      p: {
        a: 0,
        k: [
          3.939,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1718,
    ty: 4,
    parent: 1717,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.26,
                -0.08
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.23
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.21,
                6.54
              ],
              [
                0.63,
                6.54
              ],
              [
                0.63,
                1.97
              ],
              [
                1.93,
                1.97
              ],
              [
                2.83,
                2.1
              ],
              [
                3.43,
                2.52
              ],
              [
                3.64,
                3.31
              ],
              [
                3.64,
                3.31
              ],
              [
                3.18,
                4.38
              ],
              [
                1.96,
                4.73
              ],
              [
                1.96,
                4.73
              ],
              [
                1.21,
                4.73
              ],
              [
                1.21,
                6.54
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0
              ],
              [
                0.26,
                0.08
              ],
              [
                0.14,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.48
              ],
              [
                -0.31,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.15
              ],
              [
                0,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.13
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.21,
                2.44
              ],
              [
                1.21,
                4.26
              ],
              [
                1.89,
                4.26
              ],
              [
                2.78,
                4.03
              ],
              [
                3.07,
                3.31
              ],
              [
                3.07,
                3.31
              ],
              [
                2.76,
                2.63
              ],
              [
                1.86,
                2.44
              ],
              [
                1.86,
                2.44
              ],
              [
                1.21,
                2.44
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.19,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.33
              ],
              [
                -0.2,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1717,
    ty: 3,
    parent: 1710,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1710,
    ty: 3,
    parent: 1696,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1696,
    ty: 3,
    parent: 1695,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1695,
    ty: 3,
    parent: 1674,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1674,
    ty: 3,
    parent: 1673,
    ks: {
      p: {
        a: 0,
        k: [
          147.119,
          1.319
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1724,
    ty: 0,
    parent: 1720,
    ks: {},
    w: 21,
    h: 10,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1722"
  },
  {
    ind: 1720,
    ty: 3,
    parent: 1719,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1719,
    ty: 3,
    parent: 1673,
    ks: {
      p: {
        a: 0,
        k: [
          118.866,
          7.839
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1730,
    ty: 0,
    parent: 1726,
    ks: {},
    w: 87,
    h: 15,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1728"
  },
  {
    ind: 1726,
    ty: 3,
    parent: 1725,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          11
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1735,
    ty: 0,
    parent: 1731,
    ks: {},
    w: 62,
    h: 12,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1733"
  },
  {
    ind: 1731,
    ty: 3,
    parent: 1725,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1725,
    ty: 3,
    parent: 1673,
    ks: {
      p: {
        a: 0,
        k: [
          24.721,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1673,
    ty: 3,
    parent: 1605,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1605,
    ty: 3,
    parent: 1604,
    ks: {
      p: {
        a: 0,
        k: [
          8.128,
          78.567
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1744,
    ty: 4,
    parent: 1743,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.17
              ],
              [
                -0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.06,
                0.01
              ],
              [
                0.09,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.16
              ],
              [
                0.16,
                -0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                5.13
              ],
              [
                1.52,
                5.13
              ],
              [
                2.1,
                4.44
              ],
              [
                2.83,
                4.18
              ],
              [
                2.83,
                4.18
              ],
              [
                3.32,
                4.27
              ],
              [
                3.32,
                4.27
              ],
              [
                3.17,
                4.96
              ],
              [
                2.96,
                4.9
              ],
              [
                2.72,
                4.88
              ],
              [
                2.72,
                4.88
              ],
              [
                2.11,
                5.12
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.29
              ],
              [
                0.23,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.06,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.21,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1743,
    ty: 3,
    parent: 1742,
    ks: {
      p: {
        a: 0,
        k: [
          19.396,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1746,
    ty: 4,
    parent: 1745,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.23
              ],
              [
                0,
                0.41
              ],
              [
                0,
                0
              ],
              [
                -0.45,
                0.27
              ],
              [
                -0.98,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.18
              ],
              [
                0.14,
                0.11
              ],
              [
                0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.1
              ],
              [
                0.18,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.31,
                0.13
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.34
              ],
              [
                0,
                -0.58
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.13
              ],
              [
                0.29,
                0
              ]
            ],
            v: [
              [
                1.84,
                9.02
              ],
              [
                1.84,
                9.02
              ],
              [
                0.88,
                8.67
              ],
              [
                0.49,
                7.71
              ],
              [
                0.49,
                7.71
              ],
              [
                1.17,
                6.55
              ],
              [
                3.32,
                5.98
              ],
              [
                3.32,
                5.98
              ],
              [
                3.24,
                5.42
              ],
              [
                2.95,
                4.99
              ],
              [
                2.37,
                4.82
              ],
              [
                2.37,
                4.82
              ],
              [
                1.62,
                4.98
              ],
              [
                1,
                5.32
              ],
              [
                1,
                5.32
              ],
              [
                0.69,
                4.78
              ],
              [
                1.48,
                4.37
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.73,
                4.7
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                8.9
              ],
              [
                3.46,
                8.9
              ],
              [
                3.39,
                8.35
              ],
              [
                3.37,
                8.35
              ],
              [
                2.66,
                8.82
              ],
              [
                1.84,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.26,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.45,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.05,
                -0.18
              ],
              [
                -0.14,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.14
              ],
              [
                0.31,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.56,
                0
              ],
              [
                0.25,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.26,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.11
              ],
              [
                -0.22,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.19
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.23,
                0
              ]
            ],
            v: [
              [
                2.07,
                8.39
              ],
              [
                2.07,
                8.39
              ],
              [
                2.69,
                8.23
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                6.49
              ],
              [
                1.71,
                6.92
              ],
              [
                1.25,
                7.65
              ],
              [
                1.25,
                7.65
              ],
              [
                1.49,
                8.21
              ],
              [
                2.07,
                8.39
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.2,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.76,
                0.09
              ],
              [
                -0.31,
                0.19
              ],
              [
                0,
                0
              ],
              [
                0,
                0.26
              ],
              [
                0.16,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1745,
    ty: 3,
    parent: 1742,
    ks: {
      p: {
        a: 0,
        k: [
          14.618,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1748,
    ty: 4,
    parent: 1747,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.3,
                11
              ],
              [
                2.3,
                11
              ],
              [
                1,
                10.7
              ],
              [
                0.4,
                9.8
              ],
              [
                0.4,
                9.8
              ],
              [
                0.6,
                9.2
              ],
              [
                1.1,
                8.7
              ],
              [
                1.1,
                8.7
              ],
              [
                1.1,
                8.7
              ],
              [
                0.8,
                8.4
              ],
              [
                0.7,
                8
              ],
              [
                0.7,
                8
              ],
              [
                0.9,
                7.4
              ],
              [
                1.2,
                7.1
              ],
              [
                1.2,
                7.1
              ],
              [
                1.2,
                7.1
              ],
              [
                0.8,
                6.6
              ],
              [
                0.6,
                5.8
              ],
              [
                0.6,
                5.8
              ],
              [
                0.8,
                4.9
              ],
              [
                1.5,
                4.4
              ],
              [
                2.3,
                4.2
              ],
              [
                2.3,
                4.2
              ],
              [
                2.7,
                4.2
              ],
              [
                3,
                4.3
              ],
              [
                3,
                4.3
              ],
              [
                4.6,
                4.3
              ],
              [
                4.6,
                4.9
              ],
              [
                3.6,
                4.9
              ],
              [
                3.9,
                5.3
              ],
              [
                4,
                5.8
              ],
              [
                4,
                5.8
              ],
              [
                3.8,
                6.7
              ],
              [
                3.2,
                7.2
              ],
              [
                2.3,
                7.4
              ],
              [
                2.3,
                7.4
              ],
              [
                1.6,
                7.3
              ],
              [
                1.6,
                7.3
              ],
              [
                1.4,
                7.5
              ],
              [
                1.3,
                7.8
              ],
              [
                1.3,
                7.8
              ],
              [
                1.5,
                8.2
              ],
              [
                2.2,
                8.3
              ],
              [
                2.2,
                8.3
              ],
              [
                3.1,
                8.3
              ],
              [
                4.3,
                8.6
              ],
              [
                4.7,
                9.4
              ],
              [
                4.7,
                9.4
              ],
              [
                4.4,
                10.2
              ],
              [
                3.6,
                10.8
              ],
              [
                2.3,
                11
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.3,
                6.9
              ],
              [
                2.3,
                6.9
              ],
              [
                3,
                6.6
              ],
              [
                3.3,
                5.8
              ],
              [
                3.3,
                5.8
              ],
              [
                3,
                5
              ],
              [
                2.3,
                4.7
              ],
              [
                2.3,
                4.7
              ],
              [
                1.6,
                5
              ],
              [
                1.4,
                5.8
              ],
              [
                1.4,
                5.8
              ],
              [
                1.6,
                6.6
              ],
              [
                2.3,
                6.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.4,
                0
              ]
            ],
            v: [
              [
                2.4,
                10.5
              ],
              [
                2.4,
                10.5
              ],
              [
                3.5,
                10.2
              ],
              [
                3.9,
                9.5
              ],
              [
                3.9,
                9.5
              ],
              [
                3.7,
                9.1
              ],
              [
                3,
                9
              ],
              [
                3,
                9
              ],
              [
                2.2,
                9
              ],
              [
                1.9,
                9
              ],
              [
                1.6,
                8.9
              ],
              [
                1.6,
                8.9
              ],
              [
                1.2,
                9.3
              ],
              [
                1.1,
                9.7
              ],
              [
                1.1,
                9.7
              ],
              [
                1.5,
                10.3
              ],
              [
                2.4,
                10.5
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1747,
    ty: 3,
    parent: 1742,
    ks: {
      p: {
        a: 0,
        k: [
          9.84,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1750,
    ty: 4,
    parent: 1749,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.23
              ],
              [
                0,
                0.41
              ],
              [
                0,
                0
              ],
              [
                -0.45,
                0.27
              ],
              [
                -0.98,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.18
              ],
              [
                0.14,
                0.11
              ],
              [
                0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.1
              ],
              [
                0.18,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.31,
                0.13
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.34
              ],
              [
                0,
                -0.58
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.13
              ],
              [
                0.29,
                0
              ]
            ],
            v: [
              [
                1.84,
                9.02
              ],
              [
                1.84,
                9.02
              ],
              [
                0.88,
                8.67
              ],
              [
                0.49,
                7.71
              ],
              [
                0.49,
                7.71
              ],
              [
                1.17,
                6.55
              ],
              [
                3.32,
                5.98
              ],
              [
                3.32,
                5.98
              ],
              [
                3.24,
                5.42
              ],
              [
                2.95,
                4.99
              ],
              [
                2.37,
                4.82
              ],
              [
                2.37,
                4.82
              ],
              [
                1.62,
                4.98
              ],
              [
                1,
                5.32
              ],
              [
                1,
                5.32
              ],
              [
                0.69,
                4.78
              ],
              [
                1.48,
                4.37
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.73,
                4.7
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                8.9
              ],
              [
                3.46,
                8.9
              ],
              [
                3.39,
                8.35
              ],
              [
                3.37,
                8.35
              ],
              [
                2.66,
                8.82
              ],
              [
                1.84,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.26,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.45,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.05,
                -0.18
              ],
              [
                -0.14,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.14
              ],
              [
                0.31,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.56,
                0
              ],
              [
                0.25,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.26,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.11
              ],
              [
                -0.22,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.19
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.23,
                0
              ]
            ],
            v: [
              [
                2.07,
                8.39
              ],
              [
                2.07,
                8.39
              ],
              [
                2.69,
                8.23
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                6.49
              ],
              [
                1.71,
                6.92
              ],
              [
                1.25,
                7.65
              ],
              [
                1.25,
                7.65
              ],
              [
                1.49,
                8.21
              ],
              [
                2.07,
                8.39
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.2,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.76,
                0.09
              ],
              [
                -0.31,
                0.19
              ],
              [
                0,
                0
              ],
              [
                0,
                0.26
              ],
              [
                0.16,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1749,
    ty: 3,
    parent: 1742,
    ks: {
      p: {
        a: 0,
        k: [
          5.062,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1752,
    ty: 4,
    parent: 1751,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                0.9,
                7.5
              ],
              [
                1.7,
                8.1
              ],
              [
                2.6,
                8.3
              ],
              [
                2.6,
                8.3
              ],
              [
                3.5,
                8
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.8,
                6.8
              ],
              [
                3.4,
                6.5
              ],
              [
                2.9,
                6.2
              ],
              [
                2.9,
                6.2
              ],
              [
                2,
                5.8
              ],
              [
                1.4,
                5.5
              ],
              [
                0.9,
                5
              ],
              [
                0.7,
                4.2
              ],
              [
                0.7,
                4.2
              ],
              [
                1,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.7,
                2.8
              ],
              [
                4.5,
                3.3
              ],
              [
                4.5,
                3.3
              ],
              [
                4.1,
                3.8
              ],
              [
                3.4,
                3.4
              ],
              [
                2.7,
                3.3
              ],
              [
                2.7,
                3.3
              ],
              [
                1.8,
                3.5
              ],
              [
                1.5,
                4.2
              ],
              [
                1.5,
                4.2
              ],
              [
                1.7,
                4.7
              ],
              [
                2,
                5
              ],
              [
                2.5,
                5.2
              ],
              [
                2.5,
                5.2
              ],
              [
                3.4,
                5.6
              ],
              [
                4.1,
                5.9
              ],
              [
                4.5,
                6.5
              ],
              [
                4.7,
                7.2
              ],
              [
                4.7,
                7.2
              ],
              [
                4.4,
                8.1
              ],
              [
                3.7,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1751,
    ty: 3,
    parent: 1742,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1742,
    ty: 3,
    parent: 1741,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1741,
    ty: 3,
    parent: 1740,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1740,
    ty: 3,
    parent: 1739,
    ks: {
      p: {
        a: 0,
        k: [
          16.255,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1762,
    ty: 0,
    parent: 1753,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.582
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    w: 10.837,
    h: 10.837,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1760"
  },
  {
    ind: 1753,
    ty: 3,
    parent: 1739,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1739,
    ty: 3,
    parent: 1738,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          14.709
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1768,
    ty: 4,
    parent: 1767,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.5
              ],
              [
                -0.2,
                0.4
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.4,
                -0.4
              ],
              [
                0.5,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                4.3,
                8.9
              ],
              [
                0.4,
                8.9
              ],
              [
                0.4,
                8.4
              ],
              [
                1.9,
                6.8
              ],
              [
                2.9,
                5.6
              ],
              [
                3.2,
                4.6
              ],
              [
                3.2,
                4.6
              ],
              [
                2.9,
                3.7
              ],
              [
                2.1,
                3.4
              ],
              [
                2.1,
                3.4
              ],
              [
                1.4,
                3.6
              ],
              [
                0.8,
                4.1
              ],
              [
                0.8,
                4.1
              ],
              [
                0.3,
                3.7
              ],
              [
                1.2,
                3
              ],
              [
                2.2,
                2.7
              ],
              [
                2.2,
                2.7
              ],
              [
                3.5,
                3.2
              ],
              [
                4,
                4.5
              ],
              [
                4,
                4.5
              ],
              [
                3.7,
                5.7
              ],
              [
                2.8,
                6.9
              ],
              [
                1.5,
                8.3
              ],
              [
                1.5,
                8.3
              ],
              [
                2,
                8.2
              ],
              [
                2.5,
                8.2
              ],
              [
                2.5,
                8.2
              ],
              [
                4.3,
                8.2
              ],
              [
                4.3,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.6,
                -0.6
              ],
              [
                0.4,
                -0.5
              ],
              [
                0.2,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1767,
    ty: 3,
    parent: 1766,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1766,
    ty: 3,
    parent: 1765,
    ks: {
      p: {
        a: 0,
        k: [
          17.784,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1771,
    ty: 4,
    parent: 1770,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                4.5,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                2.7
              ],
              [
                4.4,
                2.7
              ],
              [
                4.4,
                3.3
              ],
              [
                1.6,
                3.3
              ],
              [
                1.6,
                5.3
              ],
              [
                4,
                5.3
              ],
              [
                4,
                6
              ],
              [
                1.6,
                6
              ],
              [
                1.6,
                8.2
              ],
              [
                4.5,
                8.2
              ],
              [
                4.5,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1770,
    ty: 3,
    parent: 1769,
    ks: {
      p: {
        a: 0,
        k: [
          10.893,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1773,
    ty: 4,
    parent: 1772,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.5,
                -0.5
              ],
              [
                0,
                -1
              ],
              [
                0,
                0
              ],
              [
                0.5,
                -0.5
              ],
              [
                0.9,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                2.7
              ],
              [
                2.4,
                2.7
              ],
              [
                4.6,
                3.5
              ],
              [
                5.3,
                5.8
              ],
              [
                5.3,
                5.8
              ],
              [
                4.6,
                8.1
              ],
              [
                2.4,
                8.9
              ],
              [
                2.4,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                1,
                0
              ],
              [
                0.5,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                1
              ],
              [
                -0.5,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.4
              ],
              [
                0,
                0.8
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0.7,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                3.3
              ],
              [
                1.6,
                8.3
              ],
              [
                2.4,
                8.3
              ],
              [
                4,
                7.6
              ],
              [
                4.5,
                5.8
              ],
              [
                4.5,
                5.8
              ],
              [
                4,
                4
              ],
              [
                2.4,
                3.3
              ],
              [
                2.4,
                3.3
              ],
              [
                1.6,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.8
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1772,
    ty: 3,
    parent: 1769,
    ks: {
      p: {
        a: 0,
        k: [
          5.062,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1775,
    ty: 4,
    parent: 1774,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                0.9,
                7.5
              ],
              [
                1.7,
                8.1
              ],
              [
                2.6,
                8.3
              ],
              [
                2.6,
                8.3
              ],
              [
                3.5,
                8
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.8,
                6.8
              ],
              [
                3.4,
                6.5
              ],
              [
                2.9,
                6.2
              ],
              [
                2.9,
                6.2
              ],
              [
                2,
                5.8
              ],
              [
                1.4,
                5.5
              ],
              [
                0.9,
                5
              ],
              [
                0.7,
                4.2
              ],
              [
                0.7,
                4.2
              ],
              [
                1,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.7,
                2.8
              ],
              [
                4.5,
                3.3
              ],
              [
                4.5,
                3.3
              ],
              [
                4.1,
                3.8
              ],
              [
                3.4,
                3.4
              ],
              [
                2.7,
                3.3
              ],
              [
                2.7,
                3.3
              ],
              [
                1.8,
                3.5
              ],
              [
                1.5,
                4.2
              ],
              [
                1.5,
                4.2
              ],
              [
                1.7,
                4.7
              ],
              [
                2,
                5
              ],
              [
                2.5,
                5.2
              ],
              [
                2.5,
                5.2
              ],
              [
                3.4,
                5.6
              ],
              [
                4.1,
                5.9
              ],
              [
                4.5,
                6.5
              ],
              [
                4.7,
                7.2
              ],
              [
                4.7,
                7.2
              ],
              [
                4.4,
                8.1
              ],
              [
                3.7,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1774,
    ty: 3,
    parent: 1769,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1769,
    ty: 3,
    parent: 1765,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1765,
    ty: 3,
    parent: 1764,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.469
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1764,
    ty: 3,
    parent: 1763,
    ks: {
      p: {
        a: 0,
        k: [
          16.255,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1785,
    ty: 0,
    parent: 1776,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.582
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    w: 10.837,
    h: 10.837,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1783"
  },
  {
    ind: 1776,
    ty: 3,
    parent: 1763,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1763,
    ty: 3,
    parent: 1738,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1738,
    ty: 3,
    parent: 1737,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          27.418
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1791,
    ty: 4,
    parent: 1790,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                9.2
              ],
              [
                2.3,
                9.2
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.1
              ],
              [
                1.6,
                8.1
              ],
              [
                1,
                7.9
              ],
              [
                0.8,
                7.3
              ],
              [
                0.8,
                7.3
              ],
              [
                1,
                6.8
              ],
              [
                1.6,
                6.5
              ],
              [
                1.6,
                6.5
              ],
              [
                2.2,
                6.8
              ],
              [
                2.4,
                7.3
              ],
              [
                2.4,
                7.3
              ],
              [
                2.2,
                7.9
              ],
              [
                1.6,
                8.1
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1790,
    ty: 3,
    parent: 1789,
    ks: {
      p: {
        a: 0,
        k: [
          13.507,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1793,
    ty: 4,
    parent: 1792,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.6,
                0.4
              ],
              [
                -1.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.3
              ],
              [
                2.3,
                15.3
              ],
              [
                1.1,
                14.8
              ],
              [
                0.6,
                13.6
              ],
              [
                0.6,
                13.6
              ],
              [
                1.4,
                12.1
              ],
              [
                4.1,
                11.3
              ],
              [
                4.1,
                11.3
              ],
              [
                3.8,
                10.5
              ],
              [
                3,
                10.2
              ],
              [
                3,
                10.2
              ],
              [
                2.1,
                10.3
              ],
              [
                1.3,
                10.8
              ],
              [
                1.3,
                10.8
              ],
              [
                0.8,
                9.8
              ],
              [
                1.9,
                9.3
              ],
              [
                3.3,
                9
              ],
              [
                3.3,
                9
              ],
              [
                4.9,
                9.7
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                11.6
              ],
              [
                5.5,
                15.2
              ],
              [
                4.3,
                15.2
              ],
              [
                4.2,
                14.5
              ],
              [
                4.2,
                14.5
              ],
              [
                3.3,
                15.1
              ],
              [
                2.3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.6,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.8,
                14.2
              ],
              [
                2.8,
                14.2
              ],
              [
                3.5,
                14
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                13.6
              ],
              [
                4.1,
                12.2
              ],
              [
                2.4,
                12.7
              ],
              [
                1.9,
                13.5
              ],
              [
                1.9,
                13.5
              ],
              [
                2.2,
                14
              ],
              [
                2.8,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.8,
                0.1
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1792,
    ty: 3,
    parent: 1789,
    ks: {
      p: {
        a: 0,
        k: [
          7.216,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1795,
    ty: 4,
    parent: 1794,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.1
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.4
              ],
              [
                0.5,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                15.2
              ],
              [
                1,
                15.2
              ],
              [
                1,
                7.2
              ],
              [
                3.7,
                7.2
              ],
              [
                5.2,
                7.4
              ],
              [
                6.2,
                8.2
              ],
              [
                6.6,
                9.6
              ],
              [
                6.6,
                9.6
              ],
              [
                6.2,
                11
              ],
              [
                5,
                11.8
              ],
              [
                5,
                11.8
              ],
              [
                6.9,
                15.2
              ],
              [
                5.4,
                15.2
              ],
              [
                3.6,
                12
              ],
              [
                2.4,
                12
              ],
              [
                2.4,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.4,
                0.1
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.3
              ],
              [
                2.4,
                10.9
              ],
              [
                3.6,
                10.9
              ],
              [
                4.8,
                10.6
              ],
              [
                5.2,
                9.6
              ],
              [
                5.2,
                9.6
              ],
              [
                4.8,
                8.6
              ],
              [
                3.6,
                8.3
              ],
              [
                3.6,
                8.3
              ],
              [
                2.4,
                8.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1794,
    ty: 3,
    parent: 1789,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1789,
    ty: 3,
    parent: 1788,
    ks: {
      p: {
        a: 0,
        k: [
          38.155,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1798,
    ty: 4,
    parent: 1797,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                6.6
              ],
              [
                2.3,
                6.6
              ],
              [
                2.3,
                8.8
              ],
              [
                2.2,
                9.9
              ],
              [
                3.1,
                9.3
              ],
              [
                4.2,
                9
              ],
              [
                4.2,
                9
              ],
              [
                5.6,
                9.7
              ],
              [
                6,
                11.4
              ],
              [
                6,
                11.4
              ],
              [
                6,
                15.2
              ],
              [
                4.6,
                15.2
              ],
              [
                4.6,
                11.6
              ],
              [
                4.4,
                10.6
              ],
              [
                3.7,
                10.2
              ],
              [
                3.7,
                10.2
              ],
              [
                3,
                10.4
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1797,
    ty: 3,
    parent: 1796,
    ks: {
      p: {
        a: 0,
        k: [
          28.915,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1800,
    ty: 4,
    parent: 1799,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.3
              ],
              [
                -0.7,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.4
              ],
              [
                0.8,
                0
              ]
            ],
            v: [
              [
                2.6,
                15.3
              ],
              [
                2.6,
                15.3
              ],
              [
                1.3,
                15.1
              ],
              [
                0.3,
                14.5
              ],
              [
                0.3,
                14.5
              ],
              [
                1,
                13.6
              ],
              [
                1.8,
                14.1
              ],
              [
                2.6,
                14.3
              ],
              [
                2.6,
                14.3
              ],
              [
                3.3,
                14
              ],
              [
                3.6,
                13.5
              ],
              [
                3.6,
                13.5
              ],
              [
                3.4,
                13.1
              ],
              [
                2.9,
                12.8
              ],
              [
                2.3,
                12.6
              ],
              [
                2.3,
                12.6
              ],
              [
                1.5,
                12.2
              ],
              [
                0.9,
                11.7
              ],
              [
                0.6,
                10.8
              ],
              [
                0.6,
                10.8
              ],
              [
                1.2,
                9.5
              ],
              [
                2.8,
                9
              ],
              [
                2.8,
                9
              ],
              [
                3.9,
                9.3
              ],
              [
                4.8,
                9.8
              ],
              [
                4.8,
                9.8
              ],
              [
                4.2,
                10.6
              ],
              [
                3.5,
                10.2
              ],
              [
                2.8,
                10.1
              ],
              [
                2.8,
                10.1
              ],
              [
                2.2,
                10.3
              ],
              [
                2,
                10.8
              ],
              [
                2,
                10.8
              ],
              [
                2.3,
                11.3
              ],
              [
                3.2,
                11.6
              ],
              [
                3.2,
                11.6
              ],
              [
                4,
                12
              ],
              [
                4.6,
                12.6
              ],
              [
                4.9,
                13.5
              ],
              [
                4.9,
                13.5
              ],
              [
                4.3,
                14.8
              ],
              [
                2.6,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.4,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                -0.4,
                0.4
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1799,
    ty: 3,
    parent: 1796,
    ks: {
      p: {
        a: 0,
        k: [
          23.661,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1802,
    ty: 4,
    parent: 1801,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                9.2
              ],
              [
                2.3,
                9.2
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.1
              ],
              [
                1.6,
                8.1
              ],
              [
                1,
                7.9
              ],
              [
                0.8,
                7.3
              ],
              [
                0.8,
                7.3
              ],
              [
                1,
                6.8
              ],
              [
                1.6,
                6.5
              ],
              [
                1.6,
                6.5
              ],
              [
                2.2,
                6.8
              ],
              [
                2.4,
                7.3
              ],
              [
                2.4,
                7.3
              ],
              [
                2.2,
                7.9
              ],
              [
                1.6,
                8.1
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1801,
    ty: 3,
    parent: 1796,
    ks: {
      p: {
        a: 0,
        k: [
          20.467,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1804,
    ty: 4,
    parent: 1803,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                6.6
              ],
              [
                2.3,
                6.6
              ],
              [
                2.3,
                8.8
              ],
              [
                2.2,
                9.9
              ],
              [
                3.1,
                9.3
              ],
              [
                4.2,
                9
              ],
              [
                4.2,
                9
              ],
              [
                5.6,
                9.7
              ],
              [
                6,
                11.4
              ],
              [
                6,
                11.4
              ],
              [
                6,
                15.2
              ],
              [
                4.6,
                15.2
              ],
              [
                4.6,
                11.6
              ],
              [
                4.4,
                10.6
              ],
              [
                3.7,
                10.2
              ],
              [
                3.7,
                10.2
              ],
              [
                3,
                10.4
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1803,
    ty: 3,
    parent: 1796,
    ks: {
      p: {
        a: 0,
        k: [
          13.665,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1806,
    ty: 4,
    parent: 1805,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.6
              ],
              [
                0,
                -0.9
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.5
              ],
              [
                0.4,
                -0.3
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                3.8,
                15.3
              ],
              [
                3.8,
                15.3
              ],
              [
                2.2,
                14.5
              ],
              [
                2.2,
                14.5
              ],
              [
                2.1,
                14.5
              ],
              [
                2,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                6.6
              ],
              [
                2.3,
                6.6
              ],
              [
                2.3,
                8.8
              ],
              [
                2.3,
                9.8
              ],
              [
                3.1,
                9.2
              ],
              [
                4,
                9
              ],
              [
                4,
                9
              ],
              [
                5.7,
                9.9
              ],
              [
                6.4,
                12.1
              ],
              [
                6.4,
                12.1
              ],
              [
                6,
                13.8
              ],
              [
                5,
                14.9
              ],
              [
                3.8,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                0.7
              ],
              [
                -0.2,
                0.5
              ],
              [
                -0.4,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0.7
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                3.5,
                14.2
              ],
              [
                3.5,
                14.2
              ],
              [
                4.5,
                13.6
              ],
              [
                4.9,
                12.1
              ],
              [
                4.9,
                12.1
              ],
              [
                4.6,
                10.7
              ],
              [
                3.6,
                10.2
              ],
              [
                3.6,
                10.2
              ],
              [
                2.3,
                10.9
              ],
              [
                2.3,
                10.9
              ],
              [
                2.3,
                13.7
              ],
              [
                2.9,
                14
              ],
              [
                3.5,
                14.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1805,
    ty: 3,
    parent: 1796,
    ks: {
      p: {
        a: 0,
        k: [
          6.802,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1808,
    ty: 4,
    parent: 1807,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.4
              ],
              [
                0.1,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.4
              ],
              [
                0.1,
                -0.4
              ]
            ],
            v: [
              [
                2.6,
                10.9
              ],
              [
                2.6,
                10.9
              ],
              [
                2.4,
                11.9
              ],
              [
                4.4,
                11.9
              ],
              [
                4.1,
                10.9
              ],
              [
                3.7,
                9.6
              ],
              [
                3.4,
                8.3
              ],
              [
                3.4,
                8.3
              ],
              [
                3.4,
                8.3
              ],
              [
                3,
                9.6
              ],
              [
                2.6,
                10.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.4
              ],
              [
                -0.1,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.4
              ],
              [
                -0.1,
                0.4
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.4,
                15.2
              ],
              [
                0,
                15.2
              ],
              [
                2.6,
                7.2
              ],
              [
                4.2,
                7.2
              ],
              [
                6.8,
                15.2
              ],
              [
                5.3,
                15.2
              ],
              [
                4.7,
                13
              ],
              [
                2,
                13
              ],
              [
                1.4,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1807,
    ty: 3,
    parent: 1796,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1796,
    ty: 3,
    parent: 1788,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1788,
    ty: 3,
    parent: 1787,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.163
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1787,
    ty: 3,
    parent: 1786,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1786,
    ty: 3,
    parent: 1737,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1737,
    ty: 3,
    parent: 1736,
    ks: {
      p: {
        a: 0,
        k: [
          70.439,
          2.737
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1819,
    ty: 0,
    parent: 1810,
    ks: {
      a: {
        a: 0,
        k: [
          41.994,
          42.669
        ]
      },
      p: {
        a: 0,
        k: [
          41.994,
          42.669
        ]
      }
    },
    w: 16.255,
    h: 16.255,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1817"
  },
  {
    ind: 1810,
    ty: 3,
    parent: 1809,
    ks: {
      p: {
        a: 0,
        k: [
          41.994,
          42.669
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1822,
    ty: 4,
    td: 1,
    parent: 1820,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            29.801,
            29.801
          ]
        },
        r: {
          a: 0,
          k: 46
        },
        s: {
          a: 0,
          k: [
            59.602,
            59.602
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0,
            0,
            0
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1821,
    ty: 4,
    tt: 1,
    parent: 1820,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                29.801,
                29.801
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                62.989,
                62.989
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ty: "gr",
        it: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                29.801,
                29.801
              ]
            },
            r: {
              a: 0,
              k: 46
            },
            s: {
              a: 0,
              k: [
                59.602,
                59.602
              ]
            }
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.427,
                0.184,
                0.604
              ]
            },
            lj: 1,
            ml: 10,
            o: {
              a: 0,
              k: 100
            },
            w: {
              a: 0,
              k: 3.387
            }
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      }
    ]
  },
  {
    ind: 1838,
    ty: 4,
    td: 1,
    parent: 1820,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            29.801,
            29.801
          ]
        },
        r: {
          a: 0,
          k: 46
        },
        s: {
          a: 0,
          k: [
            59.602,
            59.602
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0,
            0,
            0
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1837,
    ty: 0,
    tt: 1,
    parent: 1820,
    ks: {},
    w: 55,
    h: 55,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1835"
  },
  {
    ind: 1820,
    ty: 3,
    parent: 1809,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1809,
    ty: 3,
    parent: 1736,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1736,
    ty: 3,
    parent: 1604,
    ks: {
      p: {
        a: 0,
        k: [
          8.128,
          8.128
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1839,
    ty: 4,
    parent: 1604,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            113.787,
            70.005
          ]
        },
        r: {
          a: 0,
          k: 5
        },
        s: {
          a: 0,
          k: [
            227.573,
            140.01
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            1,
            1,
            1
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1604,
    ty: 3,
    parent: 16,
    ks: {
      a: {
        a: 0,
        k: [
          113.787,
          70.005
        ]
      },
      p: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              -893.907,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 132,
            s: [
              -625.907,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 276,
            s: [
              -357.907,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 420,
            s: [
              -89.907,
              92.212
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              178.093,
              92.212
            ],
            h: 1
          }
        ]
      },
      s: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              100,
              100
            ],
            i: {
              x: [
                1,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 420,
            s: [
              100,
              100
            ],
            i: {
              x: [
                0.2,
                0.2
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0.8
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              107,
              107
            ],
            h: 1
          }
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1849,
    ty: 4,
    parent: 1848,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1848,
    ty: 3,
    parent: 1847,
    ks: {
      p: {
        a: 0,
        k: [
          21.813,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1851,
    ty: 4,
    parent: 1850,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1850,
    ty: 3,
    parent: 1847,
    ks: {
      p: {
        a: 0,
        k: [
          17.007,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1853,
    ty: 4,
    parent: 1852,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.8,
                9
              ],
              [
                1.8,
                9
              ],
              [
                0.9,
                8.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                7.8
              ],
              [
                1.9,
                8
              ],
              [
                2,
                8.1
              ],
              [
                2,
                8.1
              ],
              [
                2.1,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.3,
                8.9
              ],
              [
                2.1,
                9
              ],
              [
                1.8,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1852,
    ty: 3,
    parent: 1847,
    ks: {
      p: {
        a: 0,
        k: [
          14.438,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1855,
    ty: 4,
    parent: 1854,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1854,
    ty: 3,
    parent: 1847,
    ks: {
      p: {
        a: 0,
        k: [
          9.546,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1857,
    ty: 4,
    parent: 1856,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.36
              ],
              [
                -0.36,
                0.19
              ],
              [
                -0.41,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.1
              ],
              [
                -0.17,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.13,
                0.06
              ],
              [
                0.15,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.28
              ],
              [
                0,
                -0.47
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                -0.28
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                0.08
              ],
              [
                -0.13,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.27,
                0
              ]
            ],
            v: [
              [
                2.64,
                9.02
              ],
              [
                2.64,
                9.02
              ],
              [
                1.49,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.71,
                5.26
              ],
              [
                1.57,
                4.42
              ],
              [
                2.72,
                4.13
              ],
              [
                2.72,
                4.13
              ],
              [
                3.5,
                4.28
              ],
              [
                4.09,
                4.65
              ],
              [
                4.09,
                4.65
              ],
              [
                3.56,
                5.37
              ],
              [
                3.19,
                5.11
              ],
              [
                2.78,
                5.02
              ],
              [
                2.78,
                5.02
              ],
              [
                1.86,
                5.45
              ],
              [
                1.51,
                6.58
              ],
              [
                1.51,
                6.58
              ],
              [
                1.85,
                7.7
              ],
              [
                2.75,
                8.12
              ],
              [
                2.75,
                8.12
              ],
              [
                3.27,
                8.01
              ],
              [
                3.71,
                7.73
              ],
              [
                3.71,
                7.73
              ],
              [
                4.15,
                8.45
              ],
              [
                3.43,
                8.87
              ],
              [
                2.64,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.42,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.52
              ],
              [
                0.21,
                -0.36
              ],
              [
                0.36,
                -0.19
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.22,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                -0.11
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                -0.37,
                0
              ],
              [
                -0.24,
                0.28
              ],
              [
                0,
                0
              ],
              [
                0,
                0.46
              ],
              [
                0.23,
                0.28
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0.16,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.19
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1856,
    ty: 3,
    parent: 1847,
    ks: {
      p: {
        a: 0,
        k: [
          5.167,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1859,
    ty: 4,
    parent: 1858,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                1,
                7.4
              ],
              [
                1.8,
                7.9
              ],
              [
                2.6,
                8.1
              ],
              [
                2.6,
                8.1
              ],
              [
                3.4,
                7.8
              ],
              [
                3.7,
                7.3
              ],
              [
                3.7,
                7.3
              ],
              [
                3.4,
                6.7
              ],
              [
                2.7,
                6.4
              ],
              [
                2.7,
                6.4
              ],
              [
                1.9,
                6
              ],
              [
                1.3,
                5.6
              ],
              [
                0.8,
                5.1
              ],
              [
                0.6,
                4.3
              ],
              [
                0.6,
                4.3
              ],
              [
                0.9,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.8,
                2.8
              ],
              [
                4.6,
                3.4
              ],
              [
                4.6,
                3.4
              ],
              [
                4.1,
                4.1
              ],
              [
                3.4,
                3.7
              ],
              [
                2.7,
                3.5
              ],
              [
                2.7,
                3.5
              ],
              [
                2,
                3.7
              ],
              [
                1.7,
                4.3
              ],
              [
                1.7,
                4.3
              ],
              [
                1.9,
                4.7
              ],
              [
                2.2,
                4.9
              ],
              [
                2.7,
                5.1
              ],
              [
                2.7,
                5.1
              ],
              [
                3.6,
                5.5
              ],
              [
                4.5,
                6.1
              ],
              [
                4.8,
                7.2
              ],
              [
                4.8,
                7.2
              ],
              [
                4.6,
                8.1
              ],
              [
                3.8,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1858,
    ty: 3,
    parent: 1847,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1847,
    ty: 3,
    parent: 1846,
    ks: {
      p: {
        a: 0,
        k: [
          93.74,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1862,
    ty: 4,
    parent: 1861,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1861,
    ty: 3,
    parent: 1860,
    ks: {
      p: {
        a: 0,
        k: [
          15.786,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1864,
    ty: 4,
    parent: 1863,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1863,
    ty: 3,
    parent: 1860,
    ks: {
      p: {
        a: 0,
        k: [
          10.979,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1866,
    ty: 4,
    parent: 1865,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                5.1
              ],
              [
                0.3,
                5.1
              ],
              [
                0.3,
                4.3
              ],
              [
                0.9,
                4.2
              ],
              [
                0.9,
                3.8
              ],
              [
                1.2,
                2.6
              ],
              [
                2.4,
                2.1
              ],
              [
                2.4,
                2.1
              ],
              [
                2.9,
                2.1
              ],
              [
                3.3,
                2.3
              ],
              [
                3.3,
                2.3
              ],
              [
                3.1,
                3.1
              ],
              [
                2.6,
                3
              ],
              [
                2.6,
                3
              ],
              [
                2,
                3.7
              ],
              [
                2,
                3.7
              ],
              [
                2,
                4.2
              ],
              [
                2.9,
                4.2
              ],
              [
                2.9,
                5.1
              ],
              [
                2,
                5.1
              ],
              [
                2,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                5.3,
                9
              ],
              [
                5.3,
                9
              ],
              [
                4.2,
                8.5
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                5.1
              ],
              [
                3.2,
                5.1
              ],
              [
                3.2,
                4.3
              ],
              [
                3.9,
                4.2
              ],
              [
                4,
                3
              ],
              [
                5,
                3
              ],
              [
                5,
                4.2
              ],
              [
                6.1,
                4.2
              ],
              [
                6.1,
                5.1
              ],
              [
                5,
                5.1
              ],
              [
                5,
                7.3
              ],
              [
                5.6,
                8.1
              ],
              [
                5.6,
                8.1
              ],
              [
                5.9,
                8.1
              ],
              [
                6.1,
                8
              ],
              [
                6.1,
                8
              ],
              [
                6.3,
                8.8
              ],
              [
                5.9,
                9
              ],
              [
                5.3,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1865,
    ty: 3,
    parent: 1860,
    ks: {
      p: {
        a: 0,
        k: [
          4.892,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1868,
    ty: 4,
    parent: 1867,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1867,
    ty: 3,
    parent: 1860,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1860,
    ty: 3,
    parent: 1846,
    ks: {
      p: {
        a: 0,
        k: [
          72.522,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1871,
    ty: 4,
    parent: 1870,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.35,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.37
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.28,
                -0.19
              ],
              [
                -0.15,
                -0.33
              ],
              [
                0,
                -0.44
              ],
              [
                0,
                0
              ],
              [
                0.03,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.23
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.06
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                -0.09
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.68,
                9.02
              ],
              [
                2.68,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.69,
                7.89
              ],
              [
                0.39,
                6.58
              ],
              [
                0.39,
                6.58
              ],
              [
                0.7,
                5.27
              ],
              [
                1.5,
                4.43
              ],
              [
                2.53,
                4.13
              ],
              [
                2.53,
                4.13
              ],
              [
                3.59,
                4.41
              ],
              [
                4.24,
                5.19
              ],
              [
                4.46,
                6.34
              ],
              [
                4.46,
                6.34
              ],
              [
                4.41,
                6.87
              ],
              [
                4.41,
                6.87
              ],
              [
                1.45,
                6.87
              ],
              [
                1.9,
                7.83
              ],
              [
                2.83,
                8.17
              ],
              [
                2.83,
                8.17
              ],
              [
                3.39,
                8.08
              ],
              [
                3.91,
                7.83
              ],
              [
                3.91,
                7.83
              ],
              [
                4.28,
                8.51
              ],
              [
                3.54,
                8.87
              ],
              [
                2.68,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.43,
                0
              ],
              [
                -0.35,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.21,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.42,
                0
              ],
              [
                0.28,
                0.19
              ],
              [
                0.15,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.41
              ],
              [
                0.25,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.17,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                0.15
              ],
              [
                -0.27,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.21
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.2
              ],
              [
                0.05,
                -0.37
              ]
            ],
            v: [
              [
                1.44,
                6.13
              ],
              [
                1.44,
                6.13
              ],
              [
                3.51,
                6.13
              ],
              [
                3.27,
                5.28
              ],
              [
                2.56,
                4.98
              ],
              [
                2.56,
                4.98
              ],
              [
                1.83,
                5.28
              ],
              [
                1.44,
                6.13
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.36
              ],
              [
                -0.16,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.21,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1870,
    ty: 3,
    parent: 1869,
    ks: {
      p: {
        a: 0,
        k: [
          13.718,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1873,
    ty: 4,
    parent: 1872,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                8.9
              ],
              [
                0.7,
                8.9
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                6.4
              ],
              [
                1.8,
                6.4
              ],
              [
                3.5,
                4.2
              ],
              [
                4.7,
                4.2
              ],
              [
                3.1,
                6.1
              ],
              [
                4.9,
                8.9
              ],
              [
                3.7,
                8.9
              ],
              [
                2.5,
                6.9
              ],
              [
                1.8,
                7.7
              ],
              [
                1.8,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1872,
    ty: 3,
    parent: 1869,
    ks: {
      p: {
        a: 0,
        k: [
          8.769,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1875,
    ty: 4,
    parent: 1874,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.8,
                8.9
              ],
              [
                0.7,
                8.9
              ],
              [
                0.7,
                4.2
              ],
              [
                1.8,
                4.2
              ],
              [
                1.8,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.4
              ],
              [
                1.2,
                3.4
              ],
              [
                0.8,
                3.3
              ],
              [
                0.6,
                2.8
              ],
              [
                0.6,
                2.8
              ],
              [
                0.8,
                2.4
              ],
              [
                1.2,
                2.2
              ],
              [
                1.2,
                2.2
              ],
              [
                1.7,
                2.4
              ],
              [
                1.9,
                2.8
              ],
              [
                1.9,
                2.8
              ],
              [
                1.7,
                3.3
              ],
              [
                1.2,
                3.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1874,
    ty: 3,
    parent: 1869,
    ks: {
      p: {
        a: 0,
        k: [
          6.285,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1877,
    ty: 4,
    parent: 1876,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.9,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                2.7
              ],
              [
                1.9,
                2.7
              ],
              [
                1.9,
                5.2
              ],
              [
                4.4,
                5.2
              ],
              [
                4.4,
                2.7
              ],
              [
                5.5,
                2.7
              ],
              [
                5.5,
                8.9
              ],
              [
                4.4,
                8.9
              ],
              [
                4.4,
                6.2
              ],
              [
                1.9,
                6.2
              ],
              [
                1.9,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1876,
    ty: 3,
    parent: 1869,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1869,
    ty: 3,
    parent: 1846,
    ks: {
      p: {
        a: 0,
        k: [
          52.102,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1880,
    ty: 4,
    parent: 1879,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                1,
                10.8
              ],
              [
                1,
                10.8
              ],
              [
                0.7,
                10.8
              ],
              [
                0.4,
                10.7
              ],
              [
                0.4,
                10.7
              ],
              [
                0.6,
                9.9
              ],
              [
                0.8,
                9.9
              ],
              [
                0.9,
                9.9
              ],
              [
                0.9,
                9.9
              ],
              [
                1.5,
                9.7
              ],
              [
                1.9,
                9.1
              ],
              [
                1.9,
                9.1
              ],
              [
                1.9,
                8.8
              ],
              [
                0.1,
                4.2
              ],
              [
                1.2,
                4.2
              ],
              [
                2,
                6.5
              ],
              [
                2.2,
                7.2
              ],
              [
                2.4,
                7.8
              ],
              [
                2.4,
                7.8
              ],
              [
                2.5,
                7.8
              ],
              [
                2.7,
                7.2
              ],
              [
                2.8,
                6.5
              ],
              [
                2.8,
                6.5
              ],
              [
                3.5,
                4.2
              ],
              [
                4.6,
                4.2
              ],
              [
                2.9,
                9.1
              ],
              [
                2.2,
                10.4
              ],
              [
                1,
                10.8
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.5
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1879,
    ty: 3,
    parent: 1878,
    ks: {
      p: {
        a: 0,
        k: [
          21.055,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1882,
    ty: 4,
    parent: 1881,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.16
              ],
              [
                -0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.01
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.14
              ],
              [
                0.15,
                -0.35
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.78,
                8.9
              ],
              [
                0.69,
                8.9
              ],
              [
                0.69,
                4.25
              ],
              [
                1.59,
                4.25
              ],
              [
                1.67,
                5.07
              ],
              [
                1.71,
                5.07
              ],
              [
                2.3,
                4.37
              ],
              [
                3.02,
                4.13
              ],
              [
                3.02,
                4.13
              ],
              [
                3.56,
                4.23
              ],
              [
                3.56,
                4.23
              ],
              [
                3.37,
                5.18
              ],
              [
                3.14,
                5.12
              ],
              [
                2.88,
                5.1
              ],
              [
                2.88,
                5.1
              ],
              [
                2.3,
                5.31
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                6.06
              ],
              [
                1.78,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.3
              ],
              [
                0.23,
                -0.16
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.07,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0
              ],
              [
                -0.2,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1881,
    ty: 3,
    parent: 1878,
    ks: {
      p: {
        a: 0,
        k: [
          17.519,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1884,
    ty: 4,
    parent: 1883,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1883,
    ty: 3,
    parent: 1878,
    ks: {
      p: {
        a: 0,
        k: [
          12.627,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1886,
    ty: 4,
    parent: 1885,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.8,
                9
              ],
              [
                1.8,
                9
              ],
              [
                0.9,
                8.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                7.7
              ],
              [
                0.7,
                2.2
              ],
              [
                1.8,
                2.2
              ],
              [
                1.8,
                7.8
              ],
              [
                1.9,
                8
              ],
              [
                2,
                8.1
              ],
              [
                2,
                8.1
              ],
              [
                2.1,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.2,
                8.1
              ],
              [
                2.3,
                8.9
              ],
              [
                2.1,
                9
              ],
              [
                1.8,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1885,
    ty: 3,
    parent: 1878,
    ks: {
      p: {
        a: 0,
        k: [
          10.058,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1888,
    ty: 4,
    parent: 1887,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.25
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.44,
                0.27
              ],
              [
                -0.95,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.12,
                0.18
              ],
              [
                0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.09
              ],
              [
                0.21,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.12
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                -0.34
              ],
              [
                0,
                -0.65
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                -0.12
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.82,
                9.02
              ],
              [
                1.82,
                9.02
              ],
              [
                0.83,
                8.64
              ],
              [
                0.45,
                7.65
              ],
              [
                0.45,
                7.65
              ],
              [
                1.1,
                6.49
              ],
              [
                3.19,
                5.92
              ],
              [
                3.19,
                5.92
              ],
              [
                2.99,
                5.28
              ],
              [
                2.33,
                5.01
              ],
              [
                2.33,
                5.01
              ],
              [
                1.66,
                5.15
              ],
              [
                1.02,
                5.47
              ],
              [
                1.02,
                5.47
              ],
              [
                0.63,
                4.74
              ],
              [
                1.5,
                4.31
              ],
              [
                2.54,
                4.13
              ],
              [
                2.54,
                4.13
              ],
              [
                3.85,
                4.65
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                6.14
              ],
              [
                4.28,
                8.9
              ],
              [
                3.38,
                8.9
              ],
              [
                3.3,
                8.39
              ],
              [
                3.26,
                8.39
              ],
              [
                2.59,
                8.84
              ],
              [
                1.82,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.26,
                -0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.44,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                -0.01,
                -0.25
              ],
              [
                -0.12,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.22,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.16
              ],
              [
                0.33,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0.58,
                0
              ],
              [
                0.29,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.24,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.09
              ],
              [
                -0.18,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.16
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                -0.09
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.17,
                8.16
              ],
              [
                2.17,
                8.16
              ],
              [
                2.69,
                8.03
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                7.65
              ],
              [
                3.19,
                6.61
              ],
              [
                1.87,
                6.97
              ],
              [
                1.5,
                7.57
              ],
              [
                1.5,
                7.57
              ],
              [
                1.69,
                8.02
              ],
              [
                2.17,
                8.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.19,
                0
              ],
              [
                0.15,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.63,
                0.08
              ],
              [
                -0.25,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.13,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1887,
    ty: 3,
    parent: 1878,
    ks: {
      p: {
        a: 0,
        k: [
          5.167,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1890,
    ty: 4,
    parent: 1889,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                1,
                7.4
              ],
              [
                1.8,
                7.9
              ],
              [
                2.6,
                8.1
              ],
              [
                2.6,
                8.1
              ],
              [
                3.4,
                7.8
              ],
              [
                3.7,
                7.3
              ],
              [
                3.7,
                7.3
              ],
              [
                3.4,
                6.7
              ],
              [
                2.7,
                6.4
              ],
              [
                2.7,
                6.4
              ],
              [
                1.9,
                6
              ],
              [
                1.3,
                5.6
              ],
              [
                0.8,
                5.1
              ],
              [
                0.6,
                4.3
              ],
              [
                0.6,
                4.3
              ],
              [
                0.9,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.8,
                2.8
              ],
              [
                4.6,
                3.4
              ],
              [
                4.6,
                3.4
              ],
              [
                4.1,
                4.1
              ],
              [
                3.4,
                3.7
              ],
              [
                2.7,
                3.5
              ],
              [
                2.7,
                3.5
              ],
              [
                2,
                3.7
              ],
              [
                1.7,
                4.3
              ],
              [
                1.7,
                4.3
              ],
              [
                1.9,
                4.7
              ],
              [
                2.2,
                4.9
              ],
              [
                2.7,
                5.1
              ],
              [
                2.7,
                5.1
              ],
              [
                3.6,
                5.5
              ],
              [
                4.5,
                6.1
              ],
              [
                4.8,
                7.2
              ],
              [
                4.8,
                7.2
              ],
              [
                4.6,
                8.1
              ],
              [
                3.8,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1889,
    ty: 3,
    parent: 1878,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1878,
    ty: 3,
    parent: 1846,
    ks: {
      p: {
        a: 0,
        k: [
          24.458,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1893,
    ty: 4,
    parent: 1892,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                1.8,
                6.5
              ],
              [
                1.8,
                6.5
              ],
              [
                0.7,
                6
              ],
              [
                0.3,
                4.5
              ],
              [
                0.3,
                4.5
              ],
              [
                0.7,
                3.1
              ],
              [
                1.8,
                2.6
              ],
              [
                1.8,
                2.6
              ],
              [
                2.8,
                3.1
              ],
              [
                3.2,
                4.5
              ],
              [
                3.2,
                4.5
              ],
              [
                2.8,
                6
              ],
              [
                1.8,
                6.5
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                1.8,
                5.9
              ],
              [
                1.8,
                5.9
              ],
              [
                2.3,
                5.6
              ],
              [
                2.5,
                4.5
              ],
              [
                2.5,
                4.5
              ],
              [
                2.3,
                3.5
              ],
              [
                1.8,
                3.2
              ],
              [
                1.8,
                3.2
              ],
              [
                1.3,
                3.5
              ],
              [
                1.1,
                4.5
              ],
              [
                1.1,
                4.5
              ],
              [
                1.3,
                5.6
              ],
              [
                1.8,
                5.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2,
                9
              ],
              [
                5.3,
                2.6
              ],
              [
                6,
                2.6
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                6.2,
                9
              ],
              [
                6.2,
                9
              ],
              [
                5.1,
                8.5
              ],
              [
                4.7,
                7
              ],
              [
                4.7,
                7
              ],
              [
                5.1,
                5.6
              ],
              [
                6.2,
                5.1
              ],
              [
                6.2,
                5.1
              ],
              [
                7.3,
                5.6
              ],
              [
                7.7,
                7
              ],
              [
                7.7,
                7
              ],
              [
                7.3,
                8.5
              ],
              [
                6.2,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.3,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                6.2,
                8.4
              ],
              [
                6.2,
                8.4
              ],
              [
                6.7,
                8.1
              ],
              [
                6.9,
                7
              ],
              [
                6.9,
                7
              ],
              [
                6.7,
                6
              ],
              [
                6.2,
                5.7
              ],
              [
                6.2,
                5.7
              ],
              [
                5.7,
                6
              ],
              [
                5.5,
                7
              ],
              [
                5.5,
                7
              ],
              [
                5.7,
                8.1
              ],
              [
                6.2,
                8.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1892,
    ty: 3,
    parent: 1891,
    ks: {
      p: {
        a: 0,
        k: [
          14.59,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1895,
    ty: 4,
    parent: 1894,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.5
              ],
              [
                -0.6,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                0,
                -1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.5
              ],
              [
                0.6,
                0
              ]
            ],
            v: [
              [
                2.4,
                9
              ],
              [
                2.4,
                9
              ],
              [
                0.9,
                8.2
              ],
              [
                0.4,
                5.9
              ],
              [
                0.4,
                5.9
              ],
              [
                0.9,
                3.5
              ],
              [
                2.4,
                2.8
              ],
              [
                2.4,
                2.8
              ],
              [
                3.9,
                3.5
              ],
              [
                4.5,
                5.9
              ],
              [
                4.5,
                5.9
              ],
              [
                3.9,
                8.2
              ],
              [
                2.4,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                -1
              ],
              [
                0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                1
              ],
              [
                -0.4,
                0.5
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.2
              ],
              [
                2.4,
                8.2
              ],
              [
                2.9,
                7.9
              ],
              [
                3.3,
                7.2
              ],
              [
                3.4,
                5.9
              ],
              [
                3.4,
                5.9
              ],
              [
                3.3,
                4.5
              ],
              [
                2.9,
                3.8
              ],
              [
                2.4,
                3.6
              ],
              [
                2.4,
                3.6
              ],
              [
                1.9,
                3.8
              ],
              [
                1.6,
                4.5
              ],
              [
                1.4,
                5.9
              ],
              [
                1.4,
                5.9
              ],
              [
                1.6,
                7.2
              ],
              [
                1.9,
                7.9
              ],
              [
                2.4,
                8.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.1,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1894,
    ty: 3,
    parent: 1891,
    ks: {
      p: {
        a: 0,
        k: [
          9.726,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1897,
    ty: 4,
    parent: 1896,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.5
              ],
              [
                -0.6,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                0,
                -1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.5
              ],
              [
                0.6,
                0
              ]
            ],
            v: [
              [
                2.4,
                9
              ],
              [
                2.4,
                9
              ],
              [
                0.9,
                8.2
              ],
              [
                0.4,
                5.9
              ],
              [
                0.4,
                5.9
              ],
              [
                0.9,
                3.5
              ],
              [
                2.4,
                2.8
              ],
              [
                2.4,
                2.8
              ],
              [
                3.9,
                3.5
              ],
              [
                4.5,
                5.9
              ],
              [
                4.5,
                5.9
              ],
              [
                3.9,
                8.2
              ],
              [
                2.4,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                -1
              ],
              [
                0.4,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.4,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                1
              ],
              [
                -0.4,
                0.5
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0.6
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.2
              ],
              [
                2.4,
                8.2
              ],
              [
                2.9,
                7.9
              ],
              [
                3.3,
                7.2
              ],
              [
                3.4,
                5.9
              ],
              [
                3.4,
                5.9
              ],
              [
                3.3,
                4.5
              ],
              [
                2.9,
                3.8
              ],
              [
                2.4,
                3.6
              ],
              [
                2.4,
                3.6
              ],
              [
                1.9,
                3.8
              ],
              [
                1.6,
                4.5
              ],
              [
                1.4,
                5.9
              ],
              [
                1.4,
                5.9
              ],
              [
                1.6,
                7.2
              ],
              [
                1.9,
                7.9
              ],
              [
                2.4,
                8.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                0.1,
                0.3
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1896,
    ty: 3,
    parent: 1891,
    ks: {
      p: {
        a: 0,
        k: [
          4.863,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1899,
    ty: 4,
    parent: 1898,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                4.3,
                8.9
              ],
              [
                0.7,
                8.9
              ],
              [
                0.7,
                8
              ],
              [
                2,
                8
              ],
              [
                2,
                4
              ],
              [
                0.9,
                4
              ],
              [
                0.9,
                3.4
              ],
              [
                1.7,
                3.2
              ],
              [
                2.3,
                2.9
              ],
              [
                2.3,
                2.9
              ],
              [
                3.1,
                2.9
              ],
              [
                3.1,
                8
              ],
              [
                4.3,
                8
              ],
              [
                4.3,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.518,
            0.322
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1898,
    ty: 3,
    parent: 1891,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1891,
    ty: 3,
    parent: 1846,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1846,
    ty: 3,
    parent: 1845,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1845,
    ty: 3,
    parent: 1844,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1844,
    ty: 3,
    parent: 1843,
    ks: {
      p: {
        a: 0,
        k: [
          17.029,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1908,
    ty: 0,
    parent: 1900,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.582
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    w: 10.837,
    h: 10.837,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1906"
  },
  {
    ind: 1900,
    ty: 3,
    parent: 1843,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1843,
    ty: 3,
    parent: 1842,
    ks: {
      p: {
        a: 0,
        k: [
          37.644,
          2.709
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1842,
    ty: 3,
    parent: 1841,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          35.897
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1939,
    ty: 0,
    parent: 1911,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          10.548
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          10.548
        ]
      }
    },
    w: 46.443,
    h: 9.92,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1937"
  },
  {
    ind: 1911,
    ty: 3,
    parent: 1910,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          10.548
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1944,
    ty: 4,
    parent: 1943,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.13
              ],
              [
                -0.19,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.11,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.01
              ],
              [
                0.07,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.12
              ],
              [
                0.12,
                -0.29
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.14,
                6.54
              ],
              [
                0.57,
                6.54
              ],
              [
                0.57,
                3.15
              ],
              [
                1.04,
                3.15
              ],
              [
                1.09,
                3.77
              ],
              [
                1.11,
                3.77
              ],
              [
                1.54,
                3.26
              ],
              [
                2.08,
                3.07
              ],
              [
                2.08,
                3.07
              ],
              [
                2.44,
                3.14
              ],
              [
                2.44,
                3.14
              ],
              [
                2.33,
                3.64
              ],
              [
                2.17,
                3.6
              ],
              [
                2,
                3.59
              ],
              [
                2,
                3.59
              ],
              [
                1.55,
                3.76
              ],
              [
                1.14,
                4.37
              ],
              [
                1.14,
                4.37
              ],
              [
                1.14,
                6.54
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.12,
                -0.21
              ],
              [
                0.17,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.13,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.06,
                -0.02
              ],
              [
                -0.05,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0
              ],
              [
                -0.16,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1943,
    ty: 3,
    parent: 1942,
    ks: {
      p: {
        a: 0,
        k: [
          15.625,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1946,
    ty: 4,
    parent: 1945,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                0.14
              ],
              [
                0.14,
                0.26
              ],
              [
                0,
                0.37
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.23,
                0.14
              ],
              [
                -0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                -0.29
              ],
              [
                0,
                -0.48
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.06
              ],
              [
                0.01,
                -0.04
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.21
              ],
              [
                -0.33,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0.05
              ],
              [
                -0.13,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.18,
                -0.07
              ],
              [
                0.23,
                0
              ]
            ],
            v: [
              [
                1.94,
                6.62
              ],
              [
                1.94,
                6.62
              ],
              [
                1.12,
                6.41
              ],
              [
                0.54,
                5.8
              ],
              [
                0.32,
                4.85
              ],
              [
                0.32,
                4.85
              ],
              [
                0.54,
                3.9
              ],
              [
                1.11,
                3.29
              ],
              [
                1.84,
                3.07
              ],
              [
                1.84,
                3.07
              ],
              [
                2.84,
                3.5
              ],
              [
                3.19,
                4.66
              ],
              [
                3.19,
                4.66
              ],
              [
                3.19,
                4.84
              ],
              [
                3.17,
                4.99
              ],
              [
                3.17,
                4.99
              ],
              [
                0.88,
                4.99
              ],
              [
                1.22,
                5.84
              ],
              [
                2.01,
                6.16
              ],
              [
                2.01,
                6.16
              ],
              [
                2.46,
                6.09
              ],
              [
                2.86,
                5.9
              ],
              [
                2.86,
                5.9
              ],
              [
                3.06,
                6.28
              ],
              [
                2.57,
                6.52
              ],
              [
                1.94,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.25,
                -0.14
              ],
              [
                -0.14,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.37
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.23,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0.43,
                0
              ],
              [
                0.23,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0,
                0.06
              ],
              [
                0,
                0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.02,
                0.36
              ],
              [
                0.2,
                0.21
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0
              ],
              [
                0.14,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0.09
              ],
              [
                -0.18,
                0.07
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.18
              ],
              [
                0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.18
              ],
              [
                0.04,
                -0.33
              ]
            ],
            v: [
              [
                0.88,
                4.58
              ],
              [
                0.88,
                4.58
              ],
              [
                2.69,
                4.58
              ],
              [
                2.47,
                3.79
              ],
              [
                1.85,
                3.52
              ],
              [
                1.85,
                3.52
              ],
              [
                1.22,
                3.8
              ],
              [
                0.88,
                4.58
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.34
              ],
              [
                -0.15,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                0
              ],
              [
                -0.19,
                0.18
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1945,
    ty: 3,
    parent: 1942,
    ks: {
      p: {
        a: 0,
        k: [
          12.173,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1948,
    ty: 4,
    parent: 1947,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                1.2,
                6.6
              ],
              [
                1.2,
                6.6
              ],
              [
                0.7,
                6.4
              ],
              [
                0.6,
                5.9
              ],
              [
                0.6,
                5.9
              ],
              [
                0.6,
                1.6
              ],
              [
                1.1,
                1.6
              ],
              [
                1.1,
                5.9
              ],
              [
                1.2,
                6.1
              ],
              [
                1.3,
                6.2
              ],
              [
                1.3,
                6.2
              ],
              [
                1.4,
                6.1
              ],
              [
                1.4,
                6.1
              ],
              [
                1.4,
                6.1
              ],
              [
                1.5,
                6.6
              ],
              [
                1.4,
                6.6
              ],
              [
                1.2,
                6.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1947,
    ty: 3,
    parent: 1942,
    ks: {
      p: {
        a: 0,
        k: [
          10.398,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1950,
    ty: 4,
    parent: 1949,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                0.17
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.33,
                0.2
              ],
              [
                -0.72,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0.04,
                0.13
              ],
              [
                0.1,
                0.08
              ],
              [
                0.19,
                0
              ],
              [
                0,
                0
              ],
              [
                0.17,
                -0.07
              ],
              [
                0.13,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                -0.25
              ],
              [
                0,
                -0.42
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.1
              ],
              [
                0.21,
                0
              ]
            ],
            v: [
              [
                1.35,
                6.62
              ],
              [
                1.35,
                6.62
              ],
              [
                0.64,
                6.37
              ],
              [
                0.36,
                5.66
              ],
              [
                0.36,
                5.66
              ],
              [
                0.86,
                4.81
              ],
              [
                2.44,
                4.39
              ],
              [
                2.44,
                4.39
              ],
              [
                2.38,
                3.98
              ],
              [
                2.17,
                3.67
              ],
              [
                1.74,
                3.54
              ],
              [
                1.74,
                3.54
              ],
              [
                1.19,
                3.66
              ],
              [
                0.73,
                3.91
              ],
              [
                0.73,
                3.91
              ],
              [
                0.51,
                3.51
              ],
              [
                1.09,
                3.21
              ],
              [
                1.84,
                3.07
              ],
              [
                1.84,
                3.07
              ],
              [
                2.74,
                3.45
              ],
              [
                3.02,
                4.46
              ],
              [
                3.02,
                4.46
              ],
              [
                3.02,
                6.54
              ],
              [
                2.54,
                6.54
              ],
              [
                2.49,
                6.14
              ],
              [
                2.47,
                6.14
              ],
              [
                1.95,
                6.48
              ],
              [
                1.35,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.28,
                0
              ],
              [
                -0.19,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.37
              ],
              [
                0.33,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.14
              ],
              [
                -0.04,
                -0.13
              ],
              [
                -0.1,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.17,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.1
              ],
              [
                0.23,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.41,
                0
              ],
              [
                0.19,
                0.25
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                0.13
              ],
              [
                -0.19,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                0.08
              ],
              [
                -0.16,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.14
              ],
              [
                0,
                -0.22
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                -0.09
              ],
              [
                -0.17,
                0
              ]
            ],
            v: [
              [
                1.52,
                6.16
              ],
              [
                1.52,
                6.16
              ],
              [
                1.98,
                6.05
              ],
              [
                2.44,
                5.71
              ],
              [
                2.44,
                5.71
              ],
              [
                2.44,
                4.77
              ],
              [
                1.26,
                5.08
              ],
              [
                0.92,
                5.62
              ],
              [
                0.92,
                5.62
              ],
              [
                1.09,
                6.04
              ],
              [
                1.52,
                6.16
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.16,
                0
              ],
              [
                0.14,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.56,
                0.07
              ],
              [
                -0.23,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                0.19
              ],
              [
                0.12,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1949,
    ty: 3,
    parent: 1942,
    ks: {
      p: {
        a: 0,
        k: [
          6.89,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1952,
    ty: 4,
    parent: 1951,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.14
              ],
              [
                0.14,
                0.26
              ],
              [
                0,
                0.37
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.25,
                0.14
              ],
              [
                -0.29,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.08
              ],
              [
                -0.12,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.11,
                0.06
              ],
              [
                0.13,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.11
              ],
              [
                0.09,
                -0.2
              ],
              [
                0,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                -0.24
              ],
              [
                -0.31,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.13,
                0.07
              ],
              [
                -0.1,
                0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.08
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.91,
                6.62
              ],
              [
                1.91,
                6.62
              ],
              [
                1.1,
                6.42
              ],
              [
                0.53,
                5.81
              ],
              [
                0.32,
                4.85
              ],
              [
                0.32,
                4.85
              ],
              [
                0.55,
                3.89
              ],
              [
                1.15,
                3.28
              ],
              [
                1.95,
                3.07
              ],
              [
                1.95,
                3.07
              ],
              [
                2.53,
                3.19
              ],
              [
                2.94,
                3.47
              ],
              [
                2.94,
                3.47
              ],
              [
                2.65,
                3.84
              ],
              [
                2.34,
                3.63
              ],
              [
                1.97,
                3.54
              ],
              [
                1.97,
                3.54
              ],
              [
                1.42,
                3.71
              ],
              [
                1.05,
                4.17
              ],
              [
                0.91,
                4.85
              ],
              [
                0.91,
                4.85
              ],
              [
                1.2,
                5.79
              ],
              [
                1.96,
                6.15
              ],
              [
                1.96,
                6.15
              ],
              [
                2.4,
                6.05
              ],
              [
                2.75,
                5.81
              ],
              [
                2.75,
                5.81
              ],
              [
                3,
                6.19
              ],
              [
                2.49,
                6.51
              ],
              [
                1.91,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.24,
                -0.14
              ],
              [
                -0.14,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.38
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.25,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.16,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.09
              ],
              [
                -0.11,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.16,
                0.11
              ],
              [
                -0.09,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.39
              ],
              [
                0.19,
                0.24
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0
              ],
              [
                0.13,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.13
              ],
              [
                -0.19,
                0.08
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1951,
    ty: 3,
    parent: 1942,
    ks: {
      p: {
        a: 0,
        k: [
          3.717,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1954,
    ty: 4,
    parent: 1953,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.27,
                0.12
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.1
              ],
              [
                -0.24,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.17,
                0.14
              ],
              [
                0,
                0.22
              ],
              [
                0,
                0
              ],
              [
                0.07,
                0.09
              ],
              [
                0.11,
                0.07
              ],
              [
                0.14,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.1
              ],
              [
                0.1,
                0.15
              ],
              [
                0,
                0.22
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                0.18
              ],
              [
                -0.22,
                0.1
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                -0.1
              ],
              [
                -0.16,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.17,
                0.08
              ],
              [
                0.21,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.12
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.1
              ],
              [
                -0.12,
                -0.06
              ],
              [
                -0.12,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.1
              ],
              [
                -0.08,
                -0.15
              ],
              [
                0,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0.13,
                -0.2
              ],
              [
                0.23,
                -0.12
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                1.89,
                6.62
              ],
              [
                1.89,
                6.62
              ],
              [
                1,
                6.44
              ],
              [
                0.29,
                5.95
              ],
              [
                0.29,
                5.95
              ],
              [
                0.64,
                5.54
              ],
              [
                1.22,
                5.96
              ],
              [
                1.9,
                6.12
              ],
              [
                1.9,
                6.12
              ],
              [
                2.61,
                5.91
              ],
              [
                2.86,
                5.37
              ],
              [
                2.86,
                5.37
              ],
              [
                2.76,
                4.99
              ],
              [
                2.48,
                4.76
              ],
              [
                2.1,
                4.56
              ],
              [
                2.1,
                4.56
              ],
              [
                1.44,
                4.28
              ],
              [
                1.01,
                4.04
              ],
              [
                0.66,
                3.66
              ],
              [
                0.52,
                3.1
              ],
              [
                0.52,
                3.1
              ],
              [
                0.7,
                2.48
              ],
              [
                1.21,
                2.04
              ],
              [
                1.95,
                1.89
              ],
              [
                1.95,
                1.89
              ],
              [
                2.71,
                2.04
              ],
              [
                3.3,
                2.45
              ],
              [
                3.3,
                2.45
              ],
              [
                2.99,
                2.83
              ],
              [
                2.53,
                2.51
              ],
              [
                1.95,
                2.4
              ],
              [
                1.95,
                2.4
              ],
              [
                1.33,
                2.58
              ],
              [
                1.1,
                3.06
              ],
              [
                1.1,
                3.06
              ],
              [
                1.22,
                3.42
              ],
              [
                1.5,
                3.66
              ],
              [
                1.86,
                3.82
              ],
              [
                1.86,
                3.82
              ],
              [
                2.51,
                4.1
              ],
              [
                2.99,
                4.37
              ],
              [
                3.32,
                4.75
              ],
              [
                3.45,
                5.32
              ],
              [
                3.45,
                5.32
              ],
              [
                3.26,
                5.98
              ],
              [
                2.72,
                6.45
              ],
              [
                1.89,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.27,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.17
              ],
              [
                0.22,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.17,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.16
              ],
              [
                -0.07,
                -0.09
              ],
              [
                -0.11,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.06
              ],
              [
                -0.14,
                -0.1
              ],
              [
                -0.1,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.23
              ],
              [
                0.12,
                -0.18
              ],
              [
                0.22,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.27,
                0
              ],
              [
                0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.14,
                -0.13
              ],
              [
                -0.17,
                -0.08
              ],
              [
                0,
                0
              ],
              [
                -0.26,
                0
              ],
              [
                -0.16,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0.14
              ],
              [
                0.08,
                0.1
              ],
              [
                0.12,
                0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0.07
              ],
              [
                0.14,
                0.1
              ],
              [
                0.08,
                0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                0.24
              ],
              [
                -0.13,
                0.2
              ],
              [
                -0.23,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1953,
    ty: 3,
    parent: 1942,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1942,
    ty: 3,
    parent: 1941,
    ks: {
      p: {
        a: 0,
        k: [
          14.372,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1957,
    ty: 4,
    parent: 1956,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.21
              ],
              [
                0,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.11
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.07,
                0.02
              ],
              [
                -0.06,
                0.02
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.11,
                -0.03
              ],
              [
                0.11,
                0
              ]
            ],
            v: [
              [
                1.64,
                6.62
              ],
              [
                1.64,
                6.62
              ],
              [
                0.88,
                6.31
              ],
              [
                0.67,
                5.5
              ],
              [
                0.67,
                5.5
              ],
              [
                0.67,
                3.62
              ],
              [
                0.17,
                3.62
              ],
              [
                0.17,
                3.19
              ],
              [
                0.7,
                3.15
              ],
              [
                0.77,
                2.21
              ],
              [
                1.25,
                2.21
              ],
              [
                1.25,
                3.15
              ],
              [
                2.16,
                3.15
              ],
              [
                2.16,
                3.62
              ],
              [
                1.25,
                3.62
              ],
              [
                1.25,
                5.5
              ],
              [
                1.36,
                5.99
              ],
              [
                1.77,
                6.16
              ],
              [
                1.77,
                6.16
              ],
              [
                1.96,
                6.13
              ],
              [
                2.15,
                6.07
              ],
              [
                2.15,
                6.07
              ],
              [
                2.26,
                6.5
              ],
              [
                1.96,
                6.59
              ],
              [
                1.64,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.36,
                0
              ],
              [
                -0.14,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.21
              ],
              [
                0.08,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.06,
                0
              ],
              [
                0.07,
                -0.02
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.09,
                0.03
              ],
              [
                -0.11,
                0.03
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1956,
    ty: 3,
    parent: 1955,
    ks: {
      p: {
        a: 0,
        k: [
          10.628,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1959,
    ty: 4,
    parent: 1958,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0.09
              ],
              [
                0.16,
                0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.08
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.11,
                0.1
              ],
              [
                0,
                0.14
              ],
              [
                0,
                0
              ],
              [
                0.08,
                0.08
              ],
              [
                0.12,
                0.05
              ],
              [
                0.13,
                0.05
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.08
              ],
              [
                0.1,
                0.12
              ],
              [
                0,
                0.19
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                -0.07
              ],
              [
                -0.13,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.13,
                0.06
              ],
              [
                0.15,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                -0.07,
                -0.07
              ],
              [
                -0.11,
                -0.05
              ],
              [
                -0.13,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.08
              ],
              [
                -0.1,
                -0.13
              ],
              [
                0,
                -0.21
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.15
              ],
              [
                0.18,
                -0.09
              ],
              [
                0.27,
                0
              ]
            ],
            v: [
              [
                1.46,
                6.62
              ],
              [
                1.46,
                6.62
              ],
              [
                0.77,
                6.49
              ],
              [
                0.2,
                6.16
              ],
              [
                0.2,
                6.16
              ],
              [
                0.48,
                5.77
              ],
              [
                0.94,
                6.06
              ],
              [
                1.48,
                6.18
              ],
              [
                1.48,
                6.18
              ],
              [
                1.98,
                6.02
              ],
              [
                2.15,
                5.65
              ],
              [
                2.15,
                5.65
              ],
              [
                2.03,
                5.36
              ],
              [
                1.74,
                5.16
              ],
              [
                1.37,
                5.01
              ],
              [
                1.37,
                5.01
              ],
              [
                0.91,
                4.8
              ],
              [
                0.53,
                4.5
              ],
              [
                0.38,
                4.03
              ],
              [
                0.38,
                4.03
              ],
              [
                0.69,
                3.35
              ],
              [
                1.55,
                3.07
              ],
              [
                1.55,
                3.07
              ],
              [
                2.14,
                3.18
              ],
              [
                2.61,
                3.45
              ],
              [
                2.61,
                3.45
              ],
              [
                2.33,
                3.82
              ],
              [
                1.96,
                3.6
              ],
              [
                1.55,
                3.52
              ],
              [
                1.55,
                3.52
              ],
              [
                1.08,
                3.66
              ],
              [
                0.93,
                4
              ],
              [
                0.93,
                4
              ],
              [
                1.04,
                4.27
              ],
              [
                1.31,
                4.44
              ],
              [
                1.66,
                4.59
              ],
              [
                1.66,
                4.59
              ],
              [
                2.15,
                4.8
              ],
              [
                2.54,
                5.1
              ],
              [
                2.7,
                5.61
              ],
              [
                2.7,
                5.61
              ],
              [
                2.55,
                6.12
              ],
              [
                2.14,
                6.48
              ],
              [
                1.46,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.24,
                0
              ],
              [
                -0.22,
                -0.09
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.15,
                0.12
              ],
              [
                0.16,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.11,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.12
              ],
              [
                -0.08,
                -0.08
              ],
              [
                -0.12,
                -0.05
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.06
              ],
              [
                -0.15,
                -0.08
              ],
              [
                -0.1,
                -0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.27
              ],
              [
                0.21,
                -0.18
              ],
              [
                0,
                0
              ],
              [
                0.21,
                0
              ],
              [
                0.18,
                0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.12,
                -0.09
              ],
              [
                -0.13,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.11
              ],
              [
                0.07,
                0.07
              ],
              [
                0.11,
                0.05
              ],
              [
                0,
                0
              ],
              [
                0.16,
                0.06
              ],
              [
                0.16,
                0.08
              ],
              [
                0.1,
                0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0.18
              ],
              [
                -0.1,
                0.15
              ],
              [
                -0.18,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1958,
    ty: 3,
    parent: 1955,
    ks: {
      p: {
        a: 0,
        k: [
          7.712,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1961,
    ty: 4,
    parent: 1960,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.14
              ],
              [
                0.15,
                0.26
              ],
              [
                0,
                0.37
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.24,
                0.14
              ],
              [
                -0.27,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                -0.14
              ],
              [
                -0.15,
                -0.26
              ],
              [
                0,
                -0.38
              ],
              [
                0,
                0
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.24,
                -0.14
              ],
              [
                0.28,
                0
              ]
            ],
            v: [
              [
                1.89,
                6.62
              ],
              [
                1.89,
                6.62
              ],
              [
                1.12,
                6.42
              ],
              [
                0.54,
                5.81
              ],
              [
                0.32,
                4.85
              ],
              [
                0.32,
                4.85
              ],
              [
                0.54,
                3.89
              ],
              [
                1.12,
                3.28
              ],
              [
                1.89,
                3.07
              ],
              [
                1.89,
                3.07
              ],
              [
                2.66,
                3.28
              ],
              [
                3.24,
                3.89
              ],
              [
                3.46,
                4.85
              ],
              [
                3.46,
                4.85
              ],
              [
                3.24,
                5.81
              ],
              [
                2.66,
                6.42
              ],
              [
                1.89,
                6.62
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.24,
                -0.14
              ],
              [
                -0.15,
                -0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.38
              ],
              [
                0.15,
                -0.26
              ],
              [
                0.24,
                -0.14
              ],
              [
                0,
                0
              ],
              [
                0.28,
                0
              ],
              [
                0.24,
                0.14
              ],
              [
                0.15,
                0.26
              ],
              [
                0,
                0
              ],
              [
                0,
                0.37
              ],
              [
                -0.15,
                0.26
              ],
              [
                -0.24,
                0.14
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                0.24
              ],
              [
                0,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0.24
              ],
              [
                0.29,
                0
              ],
              [
                0,
                0
              ],
              [
                0.18,
                -0.24
              ],
              [
                0,
                -0.39
              ],
              [
                0,
                0
              ],
              [
                -0.18,
                -0.24
              ],
              [
                -0.29,
                0
              ]
            ],
            v: [
              [
                1.89,
                6.15
              ],
              [
                1.89,
                6.15
              ],
              [
                2.6,
                5.79
              ],
              [
                2.86,
                4.85
              ],
              [
                2.86,
                4.85
              ],
              [
                2.6,
                3.91
              ],
              [
                1.89,
                3.54
              ],
              [
                1.89,
                3.54
              ],
              [
                1.18,
                3.91
              ],
              [
                0.91,
                4.85
              ],
              [
                0.91,
                4.85
              ],
              [
                1.18,
                5.79
              ],
              [
                1.89,
                6.15
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.29,
                0
              ],
              [
                0.18,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.39
              ],
              [
                -0.18,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.29,
                0
              ],
              [
                -0.18,
                0.24
              ],
              [
                0,
                0
              ],
              [
                0,
                0.39
              ],
              [
                0.18,
                0.24
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1960,
    ty: 3,
    parent: 1955,
    ks: {
      p: {
        a: 0,
        k: [
          3.939,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1963,
    ty: 4,
    parent: 1962,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.26,
                -0.08
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.23
              ],
              [
                0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.21,
                6.54
              ],
              [
                0.63,
                6.54
              ],
              [
                0.63,
                1.97
              ],
              [
                1.93,
                1.97
              ],
              [
                2.83,
                2.1
              ],
              [
                3.43,
                2.52
              ],
              [
                3.64,
                3.31
              ],
              [
                3.64,
                3.31
              ],
              [
                3.18,
                4.38
              ],
              [
                1.96,
                4.73
              ],
              [
                1.96,
                4.73
              ],
              [
                1.21,
                4.73
              ],
              [
                1.21,
                6.54
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0
              ],
              [
                0.26,
                0.08
              ],
              [
                0.14,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.48
              ],
              [
                -0.31,
                0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.15
              ],
              [
                0,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.13
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.21,
                2.44
              ],
              [
                1.21,
                4.26
              ],
              [
                1.89,
                4.26
              ],
              [
                2.78,
                4.03
              ],
              [
                3.07,
                3.31
              ],
              [
                3.07,
                3.31
              ],
              [
                2.76,
                2.63
              ],
              [
                1.86,
                2.44
              ],
              [
                1.86,
                2.44
              ],
              [
                1.21,
                2.44
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.19,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.33
              ],
              [
                -0.2,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.486,
            0.553,
            0.647
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1962,
    ty: 3,
    parent: 1955,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1955,
    ty: 3,
    parent: 1941,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1941,
    ty: 3,
    parent: 1940,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1940,
    ty: 3,
    parent: 1910,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1910,
    ty: 3,
    parent: 1909,
    ks: {
      p: {
        a: 0,
        k: [
          142.475,
          2.296
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1969,
    ty: 0,
    parent: 1965,
    ks: {},
    w: 18,
    h: 10,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1967"
  },
  {
    ind: 1965,
    ty: 3,
    parent: 1964,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1964,
    ty: 3,
    parent: 1909,
    ks: {
      p: {
        a: 0,
        k: [
          116.544,
          7.839
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1975,
    ty: 0,
    parent: 1971,
    ks: {},
    w: 87,
    h: 15,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1973"
  },
  {
    ind: 1971,
    ty: 3,
    parent: 1970,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          11
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1980,
    ty: 0,
    parent: 1976,
    ks: {},
    w: 62,
    h: 12,
    ip: 0,
    op: 565,
    st: 0,
    refId: "1978"
  },
  {
    ind: 1976,
    ty: 3,
    parent: 1970,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1970,
    ty: 3,
    parent: 1909,
    ks: {
      p: {
        a: 0,
        k: [
          22.399,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1909,
    ty: 3,
    parent: 1841,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1841,
    ty: 3,
    parent: 1840,
    ks: {
      p: {
        a: 0,
        k: [
          8.127,
          78.567
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1989,
    ty: 4,
    parent: 1988,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.23
              ],
              [
                0,
                0.41
              ],
              [
                0,
                0
              ],
              [
                -0.45,
                0.27
              ],
              [
                -0.98,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.18
              ],
              [
                0.14,
                0.11
              ],
              [
                0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.1
              ],
              [
                0.18,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.31,
                0.13
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.34
              ],
              [
                0,
                -0.58
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.13
              ],
              [
                0.29,
                0
              ]
            ],
            v: [
              [
                1.84,
                9.02
              ],
              [
                1.84,
                9.02
              ],
              [
                0.88,
                8.67
              ],
              [
                0.49,
                7.71
              ],
              [
                0.49,
                7.71
              ],
              [
                1.17,
                6.55
              ],
              [
                3.32,
                5.98
              ],
              [
                3.32,
                5.98
              ],
              [
                3.24,
                5.42
              ],
              [
                2.95,
                4.99
              ],
              [
                2.37,
                4.82
              ],
              [
                2.37,
                4.82
              ],
              [
                1.62,
                4.98
              ],
              [
                1,
                5.32
              ],
              [
                1,
                5.32
              ],
              [
                0.69,
                4.78
              ],
              [
                1.48,
                4.37
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.73,
                4.7
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                8.9
              ],
              [
                3.46,
                8.9
              ],
              [
                3.39,
                8.35
              ],
              [
                3.37,
                8.35
              ],
              [
                2.66,
                8.82
              ],
              [
                1.84,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.26,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.45,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.05,
                -0.18
              ],
              [
                -0.14,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.14
              ],
              [
                0.31,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.56,
                0
              ],
              [
                0.25,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.26,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.11
              ],
              [
                -0.22,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.19
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.23,
                0
              ]
            ],
            v: [
              [
                2.07,
                8.39
              ],
              [
                2.07,
                8.39
              ],
              [
                2.69,
                8.23
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                6.49
              ],
              [
                1.71,
                6.92
              ],
              [
                1.25,
                7.65
              ],
              [
                1.25,
                7.65
              ],
              [
                1.49,
                8.21
              ],
              [
                2.07,
                8.39
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.2,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.76,
                0.09
              ],
              [
                -0.31,
                0.19
              ],
              [
                0,
                0
              ],
              [
                0,
                0.26
              ],
              [
                0.16,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1988,
    ty: 3,
    parent: 1987,
    ks: {
      p: {
        a: 0,
        k: [
          15.272,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1991,
    ty: 4,
    parent: 1990,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                4.3
              ],
              [
                1.6,
                4.3
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.3
              ],
              [
                1.2,
                3.3
              ],
              [
                0.8,
                3.2
              ],
              [
                0.7,
                2.8
              ],
              [
                0.7,
                2.8
              ],
              [
                0.8,
                2.5
              ],
              [
                1.2,
                2.3
              ],
              [
                1.2,
                2.3
              ],
              [
                1.6,
                2.5
              ],
              [
                1.7,
                2.8
              ],
              [
                1.7,
                2.8
              ],
              [
                1.6,
                3.2
              ],
              [
                1.2,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1990,
    ty: 3,
    parent: 1987,
    ks: {
      p: {
        a: 0,
        k: [
          12.94,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1993,
    ty: 4,
    parent: 1992,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0.8
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                2.4,
                9
              ],
              [
                2.4,
                9
              ],
              [
                1,
                8.4
              ],
              [
                0.4,
                6.6
              ],
              [
                0.4,
                6.6
              ],
              [
                0.7,
                5.3
              ],
              [
                1.5,
                4.5
              ],
              [
                2.4,
                4.2
              ],
              [
                2.4,
                4.2
              ],
              [
                3.1,
                4.3
              ],
              [
                3.7,
                4.7
              ],
              [
                3.7,
                4.7
              ],
              [
                3.7,
                3.9
              ],
              [
                3.7,
                2.2
              ],
              [
                4.5,
                2.2
              ],
              [
                4.5,
                8.9
              ],
              [
                3.8,
                8.9
              ],
              [
                3.8,
                8.4
              ],
              [
                3.7,
                8.4
              ],
              [
                3.1,
                8.8
              ],
              [
                2.4,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                -0.4,
                0
              ]
            ],
            v: [
              [
                2.5,
                8.4
              ],
              [
                2.5,
                8.4
              ],
              [
                3.7,
                7.7
              ],
              [
                3.7,
                7.7
              ],
              [
                3.7,
                5.3
              ],
              [
                3.1,
                4.9
              ],
              [
                2.6,
                4.8
              ],
              [
                2.6,
                4.8
              ],
              [
                1.9,
                5.1
              ],
              [
                1.4,
                5.7
              ],
              [
                1.3,
                6.6
              ],
              [
                1.3,
                6.6
              ],
              [
                1.6,
                7.9
              ],
              [
                2.5,
                8.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1992,
    ty: 3,
    parent: 1987,
    ks: {
      p: {
        a: 0,
        k: [
          7.679,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1995,
    ty: 4,
    parent: 1994,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                0.15
              ],
              [
                -0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.31
              ],
              [
                0,
                -0.59
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.12
              ],
              [
                0.23,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                4.96
              ],
              [
                1.52,
                4.96
              ],
              [
                2.22,
                4.4
              ],
              [
                3.06,
                4.18
              ],
              [
                3.06,
                4.18
              ],
              [
                4.13,
                4.64
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                8.9
              ],
              [
                3.69,
                8.9
              ],
              [
                3.69,
                6.09
              ],
              [
                3.48,
                5.15
              ],
              [
                2.82,
                4.85
              ],
              [
                2.82,
                4.85
              ],
              [
                2.19,
                5.03
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.22
              ],
              [
                0.25,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0.49,
                0
              ],
              [
                0.22,
                0.31
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.43
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.19,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1994,
    ty: 3,
    parent: 1987,
    ks: {
      p: {
        a: 0,
        k: [
          2.493,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1997,
    ty: 4,
    parent: 1996,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                2.7
              ],
              [
                1.6,
                2.7
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1996,
    ty: 3,
    parent: 1987,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1987,
    ty: 3,
    parent: 1986,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1986,
    ty: 3,
    parent: 1985,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1985,
    ty: 3,
    parent: 1984,
    ks: {
      p: {
        a: 0,
        k: [
          16.255,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2007,
    ty: 0,
    parent: 1998,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.582
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    w: 10.837,
    h: 10.837,
    ip: 0,
    op: 565,
    st: 0,
    refId: "2005"
  },
  {
    ind: 1998,
    ty: 3,
    parent: 1984,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1984,
    ty: 3,
    parent: 1983,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          14.709
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2013,
    ty: 4,
    parent: 2012,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.17
              ],
              [
                -0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.06,
                0.01
              ],
              [
                0.09,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.16
              ],
              [
                0.16,
                -0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                5.13
              ],
              [
                1.52,
                5.13
              ],
              [
                2.1,
                4.44
              ],
              [
                2.83,
                4.18
              ],
              [
                2.83,
                4.18
              ],
              [
                3.32,
                4.27
              ],
              [
                3.32,
                4.27
              ],
              [
                3.17,
                4.96
              ],
              [
                2.96,
                4.9
              ],
              [
                2.72,
                4.88
              ],
              [
                2.72,
                4.88
              ],
              [
                2.11,
                5.12
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.29
              ],
              [
                0.23,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.06,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.21,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2012,
    ty: 3,
    parent: 2011,
    ks: {
      p: {
        a: 0,
        k: [
          31.881,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2015,
    ty: 4,
    parent: 2014,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.2
              ],
              [
                -0.35,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.39
              ],
              [
                0,
                -0.66
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.08
              ],
              [
                0.01,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                -0.29
              ],
              [
                -0.44,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.07
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.09
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                2.65,
                9.02
              ],
              [
                2.65,
                9.02
              ],
              [
                1.53,
                8.73
              ],
              [
                0.73,
                7.9
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.31
              ],
              [
                1.51,
                4.47
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.86,
                4.77
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.58
              ],
              [
                4.31,
                6.79
              ],
              [
                4.31,
                6.79
              ],
              [
                1.2,
                6.79
              ],
              [
                1.66,
                7.95
              ],
              [
                2.74,
                8.39
              ],
              [
                2.74,
                8.39
              ],
              [
                3.35,
                8.29
              ],
              [
                3.89,
                8.03
              ],
              [
                3.89,
                8.03
              ],
              [
                4.16,
                8.54
              ],
              [
                3.49,
                8.87
              ],
              [
                2.65,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.41,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.59,
                0
              ],
              [
                0.32,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.03,
                0.49
              ],
              [
                0.27,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.19,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.13
              ],
              [
                -0.25,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.24
              ],
              [
                0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.25
              ],
              [
                0.05,
                -0.46
              ]
            ],
            v: [
              [
                1.19,
                6.23
              ],
              [
                1.19,
                6.23
              ],
              [
                3.66,
                6.23
              ],
              [
                3.36,
                5.16
              ],
              [
                2.52,
                4.8
              ],
              [
                2.52,
                4.8
              ],
              [
                1.65,
                5.17
              ],
              [
                1.19,
                6.23
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.47
              ],
              [
                -0.2,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.26,
                0.25
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2014,
    ty: 3,
    parent: 2011,
    ks: {
      p: {
        a: 0,
        k: [
          27.179,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2017,
    ty: 4,
    parent: 2016,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.2
              ],
              [
                -0.35,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.39
              ],
              [
                0,
                -0.66
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.08
              ],
              [
                0.01,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                -0.29
              ],
              [
                -0.44,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.07
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.09
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                2.65,
                9.02
              ],
              [
                2.65,
                9.02
              ],
              [
                1.53,
                8.73
              ],
              [
                0.73,
                7.9
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.31
              ],
              [
                1.51,
                4.47
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.86,
                4.77
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.58
              ],
              [
                4.31,
                6.79
              ],
              [
                4.31,
                6.79
              ],
              [
                1.2,
                6.79
              ],
              [
                1.66,
                7.95
              ],
              [
                2.74,
                8.39
              ],
              [
                2.74,
                8.39
              ],
              [
                3.35,
                8.29
              ],
              [
                3.89,
                8.03
              ],
              [
                3.89,
                8.03
              ],
              [
                4.16,
                8.54
              ],
              [
                3.49,
                8.87
              ],
              [
                2.65,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.41,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.59,
                0
              ],
              [
                0.32,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.03,
                0.49
              ],
              [
                0.27,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.19,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.13
              ],
              [
                -0.25,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.24
              ],
              [
                0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.25
              ],
              [
                0.05,
                -0.46
              ]
            ],
            v: [
              [
                1.19,
                6.23
              ],
              [
                1.19,
                6.23
              ],
              [
                3.66,
                6.23
              ],
              [
                3.36,
                5.16
              ],
              [
                2.52,
                4.8
              ],
              [
                2.52,
                4.8
              ],
              [
                1.65,
                5.17
              ],
              [
                1.19,
                6.23
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.47
              ],
              [
                -0.2,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.26,
                0.25
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2016,
    ty: 3,
    parent: 2011,
    ks: {
      p: {
        a: 0,
        k: [
          22.477,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2019,
    ty: 4,
    parent: 2018,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                0.15
              ],
              [
                -0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.31
              ],
              [
                0,
                -0.59
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.12
              ],
              [
                0.23,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                4.96
              ],
              [
                1.52,
                4.96
              ],
              [
                2.22,
                4.4
              ],
              [
                3.06,
                4.18
              ],
              [
                3.06,
                4.18
              ],
              [
                4.13,
                4.64
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                8.9
              ],
              [
                3.69,
                8.9
              ],
              [
                3.69,
                6.09
              ],
              [
                3.48,
                5.15
              ],
              [
                2.82,
                4.85
              ],
              [
                2.82,
                4.85
              ],
              [
                2.19,
                5.03
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.22
              ],
              [
                0.25,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0.49,
                0
              ],
              [
                0.22,
                0.31
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.43
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.19,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2018,
    ty: 3,
    parent: 2011,
    ks: {
      p: {
        a: 0,
        k: [
          17.291,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2021,
    ty: 4,
    parent: 2020,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.9
              ],
              [
                0.8,
                8.9
              ],
              [
                0.8,
                4.3
              ],
              [
                1.6,
                4.3
              ],
              [
                1.6,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0.2,
                0
              ]
            ],
            v: [
              [
                1.2,
                3.3
              ],
              [
                1.2,
                3.3
              ],
              [
                0.8,
                3.2
              ],
              [
                0.7,
                2.8
              ],
              [
                0.7,
                2.8
              ],
              [
                0.8,
                2.5
              ],
              [
                1.2,
                2.3
              ],
              [
                1.2,
                2.3
              ],
              [
                1.6,
                2.5
              ],
              [
                1.7,
                2.8
              ],
              [
                1.7,
                2.8
              ],
              [
                1.6,
                3.2
              ],
              [
                1.2,
                3.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2020,
    ty: 3,
    parent: 2011,
    ks: {
      p: {
        a: 0,
        k: [
          14.959,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2023,
    ty: 4,
    parent: 2022,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0.5,
                0
              ]
            ],
            v: [
              [
                2.3,
                11
              ],
              [
                2.3,
                11
              ],
              [
                1,
                10.7
              ],
              [
                0.4,
                9.8
              ],
              [
                0.4,
                9.8
              ],
              [
                0.6,
                9.2
              ],
              [
                1.1,
                8.7
              ],
              [
                1.1,
                8.7
              ],
              [
                1.1,
                8.7
              ],
              [
                0.8,
                8.4
              ],
              [
                0.7,
                8
              ],
              [
                0.7,
                8
              ],
              [
                0.9,
                7.4
              ],
              [
                1.2,
                7.1
              ],
              [
                1.2,
                7.1
              ],
              [
                1.2,
                7.1
              ],
              [
                0.8,
                6.6
              ],
              [
                0.6,
                5.8
              ],
              [
                0.6,
                5.8
              ],
              [
                0.8,
                4.9
              ],
              [
                1.5,
                4.4
              ],
              [
                2.3,
                4.2
              ],
              [
                2.3,
                4.2
              ],
              [
                2.7,
                4.2
              ],
              [
                3,
                4.3
              ],
              [
                3,
                4.3
              ],
              [
                4.6,
                4.3
              ],
              [
                4.6,
                4.9
              ],
              [
                3.6,
                4.9
              ],
              [
                3.9,
                5.3
              ],
              [
                4,
                5.8
              ],
              [
                4,
                5.8
              ],
              [
                3.8,
                6.7
              ],
              [
                3.2,
                7.2
              ],
              [
                2.3,
                7.4
              ],
              [
                2.3,
                7.4
              ],
              [
                1.6,
                7.3
              ],
              [
                1.6,
                7.3
              ],
              [
                1.4,
                7.5
              ],
              [
                1.3,
                7.8
              ],
              [
                1.3,
                7.8
              ],
              [
                1.5,
                8.2
              ],
              [
                2.2,
                8.3
              ],
              [
                2.2,
                8.3
              ],
              [
                3.1,
                8.3
              ],
              [
                4.3,
                8.6
              ],
              [
                4.7,
                9.4
              ],
              [
                4.7,
                9.4
              ],
              [
                4.4,
                10.2
              ],
              [
                3.6,
                10.8
              ],
              [
                2.3,
                11
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.1
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                2.3,
                6.9
              ],
              [
                2.3,
                6.9
              ],
              [
                3,
                6.6
              ],
              [
                3.3,
                5.8
              ],
              [
                3.3,
                5.8
              ],
              [
                3,
                5
              ],
              [
                2.3,
                4.7
              ],
              [
                2.3,
                4.7
              ],
              [
                1.6,
                5
              ],
              [
                1.4,
                5.8
              ],
              [
                1.4,
                5.8
              ],
              [
                1.6,
                6.6
              ],
              [
                2.3,
                6.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.4,
                0
              ]
            ],
            v: [
              [
                2.4,
                10.5
              ],
              [
                2.4,
                10.5
              ],
              [
                3.5,
                10.2
              ],
              [
                3.9,
                9.5
              ],
              [
                3.9,
                9.5
              ],
              [
                3.7,
                9.1
              ],
              [
                3,
                9
              ],
              [
                3,
                9
              ],
              [
                2.2,
                9
              ],
              [
                1.9,
                9
              ],
              [
                1.6,
                8.9
              ],
              [
                1.6,
                8.9
              ],
              [
                1.2,
                9.3
              ],
              [
                1.1,
                9.7
              ],
              [
                1.1,
                9.7
              ],
              [
                1.5,
                10.3
              ],
              [
                2.4,
                10.5
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2022,
    ty: 3,
    parent: 2011,
    ks: {
      p: {
        a: 0,
        k: [
          10.182,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2025,
    ty: 4,
    parent: 2024,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                0.15
              ],
              [
                -0.32,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.22,
                -0.31
              ],
              [
                0,
                -0.59
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.14,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.19,
                -0.12
              ],
              [
                0.23,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                4.96
              ],
              [
                1.52,
                4.96
              ],
              [
                2.22,
                4.4
              ],
              [
                3.06,
                4.18
              ],
              [
                3.06,
                4.18
              ],
              [
                4.13,
                4.64
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                5.98
              ],
              [
                4.47,
                8.9
              ],
              [
                3.69,
                8.9
              ],
              [
                3.69,
                6.09
              ],
              [
                3.48,
                5.15
              ],
              [
                2.82,
                4.85
              ],
              [
                2.82,
                4.85
              ],
              [
                2.19,
                5.03
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                5.56
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.22,
                -0.22
              ],
              [
                0.25,
                -0.15
              ],
              [
                0,
                0
              ],
              [
                0.49,
                0
              ],
              [
                0.22,
                0.31
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.43
              ],
              [
                -0.14,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0
              ],
              [
                -0.19,
                0.12
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2024,
    ty: 3,
    parent: 2011,
    ks: {
      p: {
        a: 0,
        k: [
          4.996,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2027,
    ty: 4,
    parent: 2026,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                4.5,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                2.7
              ],
              [
                4.4,
                2.7
              ],
              [
                4.4,
                3.3
              ],
              [
                1.6,
                3.3
              ],
              [
                1.6,
                5.3
              ],
              [
                4,
                5.3
              ],
              [
                4,
                6
              ],
              [
                1.6,
                6
              ],
              [
                1.6,
                8.2
              ],
              [
                4.5,
                8.2
              ],
              [
                4.5,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2026,
    ty: 3,
    parent: 2011,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2011,
    ty: 3,
    parent: 2010,
    ks: {
      p: {
        a: 0,
        k: [
          37.305,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2030,
    ty: 4,
    parent: 2029,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.34,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.2
              ],
              [
                -0.35,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.39
              ],
              [
                0,
                -0.66
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.08
              ],
              [
                0.01,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                -0.29
              ],
              [
                -0.44,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.19,
                0.07
              ],
              [
                -0.17,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.09
              ],
              [
                0.32,
                0
              ]
            ],
            v: [
              [
                2.65,
                9.02
              ],
              [
                2.65,
                9.02
              ],
              [
                1.53,
                8.73
              ],
              [
                0.73,
                7.9
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.31
              ],
              [
                1.51,
                4.47
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.86,
                4.77
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.34
              ],
              [
                4.34,
                6.58
              ],
              [
                4.31,
                6.79
              ],
              [
                4.31,
                6.79
              ],
              [
                1.2,
                6.79
              ],
              [
                1.66,
                7.95
              ],
              [
                2.74,
                8.39
              ],
              [
                2.74,
                8.39
              ],
              [
                3.35,
                8.29
              ],
              [
                3.89,
                8.03
              ],
              [
                3.89,
                8.03
              ],
              [
                4.16,
                8.54
              ],
              [
                3.49,
                8.87
              ],
              [
                2.65,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.41,
                0
              ],
              [
                -0.34,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.59,
                0
              ],
              [
                0.32,
                0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0.08
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.03,
                0.49
              ],
              [
                0.27,
                0.29
              ],
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.19,
                -0.07
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.13
              ],
              [
                -0.25,
                0.09
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.24
              ],
              [
                0.36,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.25
              ],
              [
                0.05,
                -0.46
              ]
            ],
            v: [
              [
                1.19,
                6.23
              ],
              [
                1.19,
                6.23
              ],
              [
                3.66,
                6.23
              ],
              [
                3.36,
                5.16
              ],
              [
                2.52,
                4.8
              ],
              [
                2.52,
                4.8
              ],
              [
                1.65,
                5.17
              ],
              [
                1.19,
                6.23
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.47
              ],
              [
                -0.2,
                -0.24
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                0
              ],
              [
                -0.26,
                0.25
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2029,
    ty: 3,
    parent: 2028,
    ks: {
      p: {
        a: 0,
        k: [
          30.707,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2032,
    ty: 4,
    parent: 2031,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.23,
                0.17
              ],
              [
                -0.26,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.15,
                -0.06
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.06,
                0.01
              ],
              [
                0.09,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.16
              ],
              [
                0.16,
                -0.39
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.56,
                8.9
              ],
              [
                0.78,
                8.9
              ],
              [
                0.78,
                4.29
              ],
              [
                1.42,
                4.29
              ],
              [
                1.49,
                5.13
              ],
              [
                1.52,
                5.13
              ],
              [
                2.1,
                4.44
              ],
              [
                2.83,
                4.18
              ],
              [
                2.83,
                4.18
              ],
              [
                3.32,
                4.27
              ],
              [
                3.32,
                4.27
              ],
              [
                3.17,
                4.96
              ],
              [
                2.96,
                4.9
              ],
              [
                2.72,
                4.88
              ],
              [
                2.72,
                4.88
              ],
              [
                2.11,
                5.12
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                5.94
              ],
              [
                1.56,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.16,
                -0.29
              ],
              [
                0.23,
                -0.17
              ],
              [
                0,
                0
              ],
              [
                0.18,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.08,
                -0.03
              ],
              [
                -0.06,
                -0.01
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.21,
                0.16
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2031,
    ty: 3,
    parent: 2028,
    ks: {
      p: {
        a: 0,
        k: [
          27.417,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2034,
    ty: 4,
    parent: 2033,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                0.23
              ],
              [
                0,
                0.41
              ],
              [
                0,
                0
              ],
              [
                -0.45,
                0.27
              ],
              [
                -0.98,
                0.11
              ],
              [
                0,
                0
              ],
              [
                0.05,
                0.18
              ],
              [
                0.14,
                0.11
              ],
              [
                0.25,
                0
              ],
              [
                0,
                0
              ],
              [
                0.23,
                -0.1
              ],
              [
                0.18,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.31,
                0.13
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.34
              ],
              [
                0,
                -0.58
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.26,
                -0.13
              ],
              [
                0.29,
                0
              ]
            ],
            v: [
              [
                1.84,
                9.02
              ],
              [
                1.84,
                9.02
              ],
              [
                0.88,
                8.67
              ],
              [
                0.49,
                7.71
              ],
              [
                0.49,
                7.71
              ],
              [
                1.17,
                6.55
              ],
              [
                3.32,
                5.98
              ],
              [
                3.32,
                5.98
              ],
              [
                3.24,
                5.42
              ],
              [
                2.95,
                4.99
              ],
              [
                2.37,
                4.82
              ],
              [
                2.37,
                4.82
              ],
              [
                1.62,
                4.98
              ],
              [
                1,
                5.32
              ],
              [
                1,
                5.32
              ],
              [
                0.69,
                4.78
              ],
              [
                1.48,
                4.37
              ],
              [
                2.5,
                4.18
              ],
              [
                2.5,
                4.18
              ],
              [
                3.73,
                4.7
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                6.08
              ],
              [
                4.11,
                8.9
              ],
              [
                3.46,
                8.9
              ],
              [
                3.39,
                8.35
              ],
              [
                3.37,
                8.35
              ],
              [
                2.66,
                8.82
              ],
              [
                1.84,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.26,
                -0.23
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.51
              ],
              [
                0.45,
                -0.27
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.05,
                -0.18
              ],
              [
                -0.14,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                -0.27,
                0
              ],
              [
                -0.23,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.21,
                -0.14
              ],
              [
                0.31,
                -0.13
              ],
              [
                0,
                0
              ],
              [
                0.56,
                0
              ],
              [
                0.25,
                0.34
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.21,
                0.18
              ],
              [
                -0.26,
                0.13
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.11
              ],
              [
                -0.22,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.31,
                -0.19
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.16,
                -0.12
              ],
              [
                -0.23,
                0
              ]
            ],
            v: [
              [
                2.07,
                8.39
              ],
              [
                2.07,
                8.39
              ],
              [
                2.69,
                8.23
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                7.77
              ],
              [
                3.32,
                6.49
              ],
              [
                1.71,
                6.92
              ],
              [
                1.25,
                7.65
              ],
              [
                1.25,
                7.65
              ],
              [
                1.49,
                8.21
              ],
              [
                2.07,
                8.39
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.22,
                0
              ],
              [
                0.2,
                -0.11
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.76,
                0.09
              ],
              [
                -0.31,
                0.19
              ],
              [
                0,
                0
              ],
              [
                0,
                0.26
              ],
              [
                0.16,
                0.12
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2033,
    ty: 3,
    parent: 2028,
    ks: {
      p: {
        a: 0,
        k: [
          22.64,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2036,
    ty: 4,
    parent: 2035,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.9
              ],
              [
                1.5,
                8.9
              ],
              [
                0.2,
                4.3
              ],
              [
                1,
                4.3
              ],
              [
                1.7,
                7
              ],
              [
                1.8,
                7.6
              ],
              [
                2,
                8.2
              ],
              [
                2,
                8.2
              ],
              [
                2,
                8.2
              ],
              [
                2.2,
                7.6
              ],
              [
                2.3,
                7
              ],
              [
                2.3,
                7
              ],
              [
                3,
                4.3
              ],
              [
                3.8,
                4.3
              ],
              [
                4.5,
                7
              ],
              [
                4.7,
                7.6
              ],
              [
                4.8,
                8.2
              ],
              [
                4.8,
                8.2
              ],
              [
                4.9,
                8.2
              ],
              [
                5,
                7.6
              ],
              [
                5.2,
                7
              ],
              [
                5.2,
                7
              ],
              [
                5.8,
                4.3
              ],
              [
                6.6,
                4.3
              ],
              [
                5.3,
                8.9
              ],
              [
                4.4,
                8.9
              ],
              [
                3.7,
                6.4
              ],
              [
                3.6,
                5.8
              ],
              [
                3.4,
                5.1
              ],
              [
                3.4,
                5.1
              ],
              [
                3.4,
                5.1
              ],
              [
                3.2,
                5.8
              ],
              [
                3.1,
                6.4
              ],
              [
                3.1,
                6.4
              ],
              [
                2.4,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2035,
    ty: 3,
    parent: 2028,
    ks: {
      p: {
        a: 0,
        k: [
          15.833,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2038,
    ty: 4,
    parent: 2037,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                1.7,
                8.9
              ],
              [
                0.9,
                8.9
              ],
              [
                0.9,
                4.9
              ],
              [
                0.3,
                4.9
              ],
              [
                0.3,
                4.3
              ],
              [
                0.9,
                4.3
              ],
              [
                0.9,
                3.6
              ],
              [
                1.2,
                2.4
              ],
              [
                2.3,
                2
              ],
              [
                2.3,
                2
              ],
              [
                2.7,
                2.1
              ],
              [
                3,
                2.2
              ],
              [
                3,
                2.2
              ],
              [
                2.9,
                2.8
              ],
              [
                2.3,
                2.7
              ],
              [
                2.3,
                2.7
              ],
              [
                1.7,
                3.6
              ],
              [
                1.7,
                3.6
              ],
              [
                1.7,
                4.3
              ],
              [
                2.7,
                4.3
              ],
              [
                2.7,
                4.9
              ],
              [
                1.7,
                4.9
              ],
              [
                1.7,
                8.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ]
            ],
            v: [
              [
                5,
                9
              ],
              [
                5,
                9
              ],
              [
                4,
                8.6
              ],
              [
                3.7,
                7.5
              ],
              [
                3.7,
                7.5
              ],
              [
                3.7,
                4.9
              ],
              [
                3,
                4.9
              ],
              [
                3,
                4.3
              ],
              [
                3.7,
                4.3
              ],
              [
                3.8,
                3
              ],
              [
                4.5,
                3
              ],
              [
                4.5,
                4.3
              ],
              [
                5.7,
                4.3
              ],
              [
                5.7,
                4.9
              ],
              [
                4.5,
                4.9
              ],
              [
                4.5,
                7.5
              ],
              [
                4.6,
                8.1
              ],
              [
                5.2,
                8.4
              ],
              [
                5.2,
                8.4
              ],
              [
                5.4,
                8.3
              ],
              [
                5.7,
                8.3
              ],
              [
                5.7,
                8.3
              ],
              [
                5.9,
                8.8
              ],
              [
                5.4,
                9
              ],
              [
                5,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2037,
    ty: 3,
    parent: 2028,
    ks: {
      p: {
        a: 0,
        k: [
          10.2,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2040,
    ty: 4,
    parent: 2039,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.33,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0.51
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.33,
                0.19
              ],
              [
                -0.37,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.32,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                -0.52
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.32,
                -0.19
              ],
              [
                0.38,
                0
              ]
            ],
            v: [
              [
                2.57,
                9.02
              ],
              [
                2.57,
                9.02
              ],
              [
                1.52,
                8.73
              ],
              [
                0.73,
                7.91
              ],
              [
                0.44,
                6.61
              ],
              [
                0.44,
                6.61
              ],
              [
                0.73,
                5.29
              ],
              [
                1.52,
                4.46
              ],
              [
                2.57,
                4.18
              ],
              [
                2.57,
                4.18
              ],
              [
                3.62,
                4.46
              ],
              [
                4.4,
                5.29
              ],
              [
                4.7,
                6.61
              ],
              [
                4.7,
                6.61
              ],
              [
                4.4,
                7.91
              ],
              [
                3.62,
                8.73
              ],
              [
                2.57,
                9.02
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.37,
                0
              ],
              [
                -0.33,
                -0.19
              ],
              [
                -0.2,
                -0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.52
              ],
              [
                0.2,
                -0.36
              ],
              [
                0.33,
                -0.19
              ],
              [
                0,
                0
              ],
              [
                0.38,
                0
              ],
              [
                0.32,
                0.19
              ],
              [
                0.2,
                0.36
              ],
              [
                0,
                0
              ],
              [
                0,
                0.51
              ],
              [
                -0.2,
                0.36
              ],
              [
                -0.32,
                0.19
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.24,
                0.33
              ],
              [
                0,
                0.52
              ],
              [
                0,
                0
              ],
              [
                0.24,
                0.33
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.25,
                -0.33
              ],
              [
                0,
                -0.53
              ],
              [
                0,
                0
              ],
              [
                -0.25,
                -0.33
              ],
              [
                -0.39,
                0
              ]
            ],
            v: [
              [
                2.57,
                8.37
              ],
              [
                2.57,
                8.37
              ],
              [
                3.53,
                7.88
              ],
              [
                3.9,
                6.61
              ],
              [
                3.9,
                6.61
              ],
              [
                3.53,
                5.32
              ],
              [
                2.57,
                4.82
              ],
              [
                2.57,
                4.82
              ],
              [
                1.61,
                5.32
              ],
              [
                1.24,
                6.61
              ],
              [
                1.24,
                6.61
              ],
              [
                1.61,
                7.88
              ],
              [
                2.57,
                8.37
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.24,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.53
              ],
              [
                -0.24,
                -0.33
              ],
              [
                0,
                0
              ],
              [
                -0.39,
                0
              ],
              [
                -0.25,
                0.33
              ],
              [
                0,
                0
              ],
              [
                0,
                0.52
              ],
              [
                0.25,
                0.33
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2039,
    ty: 3,
    parent: 2028,
    ks: {
      p: {
        a: 0,
        k: [
          5.062,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2042,
    ty: 4,
    parent: 2041,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.3,
                0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.6,
                9
              ],
              [
                2.6,
                9
              ],
              [
                1.4,
                8.8
              ],
              [
                0.4,
                8.1
              ],
              [
                0.4,
                8.1
              ],
              [
                0.9,
                7.5
              ],
              [
                1.7,
                8.1
              ],
              [
                2.6,
                8.3
              ],
              [
                2.6,
                8.3
              ],
              [
                3.5,
                8
              ],
              [
                3.9,
                7.3
              ],
              [
                3.9,
                7.3
              ],
              [
                3.8,
                6.8
              ],
              [
                3.4,
                6.5
              ],
              [
                2.9,
                6.2
              ],
              [
                2.9,
                6.2
              ],
              [
                2,
                5.8
              ],
              [
                1.4,
                5.5
              ],
              [
                0.9,
                5
              ],
              [
                0.7,
                4.2
              ],
              [
                0.7,
                4.2
              ],
              [
                1,
                3.4
              ],
              [
                1.6,
                2.8
              ],
              [
                2.7,
                2.6
              ],
              [
                2.7,
                2.6
              ],
              [
                3.7,
                2.8
              ],
              [
                4.5,
                3.3
              ],
              [
                4.5,
                3.3
              ],
              [
                4.1,
                3.8
              ],
              [
                3.4,
                3.4
              ],
              [
                2.7,
                3.3
              ],
              [
                2.7,
                3.3
              ],
              [
                1.8,
                3.5
              ],
              [
                1.5,
                4.2
              ],
              [
                1.5,
                4.2
              ],
              [
                1.7,
                4.7
              ],
              [
                2,
                5
              ],
              [
                2.5,
                5.2
              ],
              [
                2.5,
                5.2
              ],
              [
                3.4,
                5.6
              ],
              [
                4.1,
                5.9
              ],
              [
                4.5,
                6.5
              ],
              [
                4.7,
                7.2
              ],
              [
                4.7,
                7.2
              ],
              [
                4.4,
                8.1
              ],
              [
                3.7,
                8.8
              ],
              [
                2.6,
                9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0.2,
                -0.2
              ],
              [
                0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.38,
            0.451,
            0.557
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2041,
    ty: 3,
    parent: 2028,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2028,
    ty: 3,
    parent: 2010,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2010,
    ty: 3,
    parent: 2009,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.469
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2009,
    ty: 3,
    parent: 2008,
    ks: {
      p: {
        a: 0,
        k: [
          16.255,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2052,
    ty: 0,
    parent: 2043,
    ks: {
      a: {
        a: 0,
        k: [
          0,
          0.582
        ]
      },
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    w: 10.837,
    h: 10.837,
    ip: 0,
    op: 565,
    st: 0,
    refId: "2050"
  },
  {
    ind: 2043,
    ty: 3,
    parent: 2008,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.582
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2008,
    ty: 3,
    parent: 1983,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1983,
    ty: 3,
    parent: 1982,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          27.418
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2058,
    ty: 4,
    parent: 2057,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                6.6
              ],
              [
                2.3,
                6.6
              ],
              [
                2.3,
                8.8
              ],
              [
                2.2,
                9.9
              ],
              [
                3.1,
                9.3
              ],
              [
                4.2,
                9
              ],
              [
                4.2,
                9
              ],
              [
                5.6,
                9.7
              ],
              [
                6,
                11.4
              ],
              [
                6,
                11.4
              ],
              [
                6,
                15.2
              ],
              [
                4.6,
                15.2
              ],
              [
                4.6,
                11.6
              ],
              [
                4.4,
                10.6
              ],
              [
                3.7,
                10.2
              ],
              [
                3.7,
                10.2
              ],
              [
                3,
                10.4
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2057,
    ty: 3,
    parent: 2056,
    ks: {
      p: {
        a: 0,
        k: [
          23.002,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2060,
    ty: 4,
    parent: 2059,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.6,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.2
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.5,
                -0.2
              ],
              [
                0.7,
                0
              ]
            ],
            v: [
              [
                3,
                17.8
              ],
              [
                3,
                17.8
              ],
              [
                1.7,
                17.6
              ],
              [
                0.8,
                17.1
              ],
              [
                0.5,
                16.3
              ],
              [
                0.5,
                16.3
              ],
              [
                1.3,
                15
              ],
              [
                1.3,
                15
              ],
              [
                1.3,
                14.9
              ],
              [
                1,
                14.5
              ],
              [
                0.8,
                13.9
              ],
              [
                0.8,
                13.9
              ],
              [
                1,
                13.3
              ],
              [
                1.5,
                12.8
              ],
              [
                1.5,
                12.8
              ],
              [
                1.5,
                12.8
              ],
              [
                0.9,
                12.1
              ],
              [
                0.7,
                11.2
              ],
              [
                0.7,
                11.2
              ],
              [
                1,
                10
              ],
              [
                1.9,
                9.3
              ],
              [
                3,
                9
              ],
              [
                3,
                9
              ],
              [
                3.5,
                9.1
              ],
              [
                3.9,
                9.2
              ],
              [
                3.9,
                9.2
              ],
              [
                6.1,
                9.2
              ],
              [
                6.1,
                10.2
              ],
              [
                5,
                10.2
              ],
              [
                5.2,
                10.7
              ],
              [
                5.3,
                11.2
              ],
              [
                5.3,
                11.2
              ],
              [
                5,
                12.3
              ],
              [
                4.2,
                13
              ],
              [
                3,
                13.3
              ],
              [
                3,
                13.3
              ],
              [
                2.6,
                13.2
              ],
              [
                2.2,
                13.1
              ],
              [
                2.2,
                13.1
              ],
              [
                2,
                13.4
              ],
              [
                1.9,
                13.7
              ],
              [
                1.9,
                13.7
              ],
              [
                2.2,
                14.1
              ],
              [
                2.9,
                14.2
              ],
              [
                2.9,
                14.2
              ],
              [
                4,
                14.2
              ],
              [
                5.6,
                14.6
              ],
              [
                6.2,
                15.7
              ],
              [
                6.2,
                15.7
              ],
              [
                5.8,
                16.8
              ],
              [
                4.7,
                17.5
              ],
              [
                3,
                17.8
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.4,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.7,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.5,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.3,
                0
              ]
            ],
            v: [
              [
                3,
                12.4
              ],
              [
                3,
                12.4
              ],
              [
                3.8,
                12.1
              ],
              [
                4.1,
                11.2
              ],
              [
                4.1,
                11.2
              ],
              [
                3.8,
                10.3
              ],
              [
                3,
                10
              ],
              [
                3,
                10
              ],
              [
                2.3,
                10.3
              ],
              [
                2,
                11.2
              ],
              [
                2,
                11.2
              ],
              [
                2.3,
                12.1
              ],
              [
                3,
                12.4
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                -0.5,
                0
              ]
            ],
            v: [
              [
                3.2,
                16.9
              ],
              [
                3.2,
                16.9
              ],
              [
                4.4,
                16.6
              ],
              [
                4.8,
                15.9
              ],
              [
                4.8,
                15.9
              ],
              [
                4.5,
                15.5
              ],
              [
                3.8,
                15.3
              ],
              [
                3.8,
                15.3
              ],
              [
                2.9,
                15.3
              ],
              [
                2.1,
                15.3
              ],
              [
                2.1,
                15.3
              ],
              [
                1.7,
                16
              ],
              [
                1.7,
                16
              ],
              [
                2.1,
                16.7
              ],
              [
                3.2,
                16.9
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.3
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2059,
    ty: 3,
    parent: 2056,
    ks: {
      p: {
        a: 0,
        k: [
          16.664,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2062,
    ty: 4,
    parent: 2061,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                9.2
              ],
              [
                2,
                9.2
              ],
              [
                2.1,
                10
              ],
              [
                2.2,
                10
              ],
              [
                3.1,
                9.3
              ],
              [
                4.2,
                9
              ],
              [
                4.2,
                9
              ],
              [
                5.6,
                9.7
              ],
              [
                6,
                11.4
              ],
              [
                6,
                11.4
              ],
              [
                6,
                15.2
              ],
              [
                4.6,
                15.2
              ],
              [
                4.6,
                11.6
              ],
              [
                4.4,
                10.6
              ],
              [
                3.7,
                10.2
              ],
              [
                3.7,
                10.2
              ],
              [
                3,
                10.4
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.3
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2061,
    ty: 3,
    parent: 2056,
    ks: {
      p: {
        a: 0,
        k: [
          9.837,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2064,
    ty: 4,
    parent: 2063,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                9.2
              ],
              [
                2.3,
                9.2
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.1
              ],
              [
                1.6,
                8.1
              ],
              [
                1,
                7.9
              ],
              [
                0.8,
                7.3
              ],
              [
                0.8,
                7.3
              ],
              [
                1,
                6.8
              ],
              [
                1.6,
                6.5
              ],
              [
                1.6,
                6.5
              ],
              [
                2.2,
                6.8
              ],
              [
                2.4,
                7.3
              ],
              [
                2.4,
                7.3
              ],
              [
                2.2,
                7.9
              ],
              [
                1.6,
                8.1
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2063,
    ty: 3,
    parent: 2056,
    ks: {
      p: {
        a: 0,
        k: [
          6.644,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2066,
    ty: 4,
    parent: 2065,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0.2
              ],
              [
                0.4,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.2
              ],
              [
                0.2,
                0.3
              ],
              [
                0,
                0.4
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.3
              ],
              [
                -0.4,
                0.2
              ],
              [
                -0.5,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.3
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.4
              ],
              [
                0.4,
                -0.2
              ],
              [
                0.6,
                0
              ]
            ],
            v: [
              [
                3.3,
                15.3
              ],
              [
                3.3,
                15.3
              ],
              [
                1.8,
                15
              ],
              [
                0.5,
                14.1
              ],
              [
                0.5,
                14.1
              ],
              [
                1.3,
                13.2
              ],
              [
                2.3,
                13.8
              ],
              [
                3.4,
                14.1
              ],
              [
                3.4,
                14.1
              ],
              [
                4.4,
                13.8
              ],
              [
                4.8,
                13.1
              ],
              [
                4.8,
                13.1
              ],
              [
                4.4,
                12.3
              ],
              [
                3.5,
                11.9
              ],
              [
                3.5,
                11.9
              ],
              [
                2.4,
                11.4
              ],
              [
                1.7,
                11
              ],
              [
                1.1,
                10.3
              ],
              [
                0.8,
                9.3
              ],
              [
                0.8,
                9.3
              ],
              [
                1.2,
                8.2
              ],
              [
                2.1,
                7.4
              ],
              [
                3.5,
                7.1
              ],
              [
                3.5,
                7.1
              ],
              [
                4.8,
                7.3
              ],
              [
                5.9,
                8.1
              ],
              [
                5.9,
                8.1
              ],
              [
                5.2,
                9
              ],
              [
                4.4,
                8.5
              ],
              [
                3.5,
                8.3
              ],
              [
                3.5,
                8.3
              ],
              [
                2.6,
                8.5
              ],
              [
                2.2,
                9.2
              ],
              [
                2.2,
                9.2
              ],
              [
                2.4,
                9.7
              ],
              [
                2.9,
                10.1
              ],
              [
                3.5,
                10.3
              ],
              [
                3.5,
                10.3
              ],
              [
                4.6,
                10.8
              ],
              [
                5.8,
                11.6
              ],
              [
                6.2,
                13
              ],
              [
                6.2,
                13
              ],
              [
                5.9,
                14.1
              ],
              [
                4.9,
                15
              ],
              [
                3.3,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.5,
                0
              ],
              [
                -0.5,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.3
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.3
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.4
              ],
              [
                0.2,
                -0.3
              ],
              [
                0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.2
              ],
              [
                -0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.5,
                0.2
              ],
              [
                0.3,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0.4
              ],
              [
                -0.2,
                0.4
              ],
              [
                -0.4,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2065,
    ty: 3,
    parent: 2056,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2056,
    ty: 3,
    parent: 2055,
    ks: {
      p: {
        a: 0,
        k: [
          37.594,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2069,
    ty: 4,
    parent: 2068,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.2
              ],
              [
                -0.4,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.2
              ],
              [
                0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                6.6
              ],
              [
                2.3,
                6.6
              ],
              [
                2.3,
                8.8
              ],
              [
                2.2,
                9.9
              ],
              [
                3.1,
                9.3
              ],
              [
                4.2,
                9
              ],
              [
                4.2,
                9
              ],
              [
                5.6,
                9.7
              ],
              [
                6,
                11.4
              ],
              [
                6,
                11.4
              ],
              [
                6,
                15.2
              ],
              [
                4.6,
                15.2
              ],
              [
                4.6,
                11.6
              ],
              [
                4.4,
                10.6
              ],
              [
                3.7,
                10.2
              ],
              [
                3.7,
                10.2
              ],
              [
                3,
                10.4
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                11
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.1,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2068,
    ty: 3,
    parent: 2067,
    ks: {
      p: {
        a: 0,
        k: [
          28.354,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2071,
    ty: 4,
    parent: 2070,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0.2
              ],
              [
                0.3,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0.3
              ],
              [
                0,
                0
              ],
              [
                -0.4,
                0.3
              ],
              [
                -0.7,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                -0.3,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.4
              ],
              [
                0.8,
                0
              ]
            ],
            v: [
              [
                2.6,
                15.3
              ],
              [
                2.6,
                15.3
              ],
              [
                1.3,
                15.1
              ],
              [
                0.3,
                14.5
              ],
              [
                0.3,
                14.5
              ],
              [
                1,
                13.6
              ],
              [
                1.8,
                14.1
              ],
              [
                2.6,
                14.3
              ],
              [
                2.6,
                14.3
              ],
              [
                3.3,
                14
              ],
              [
                3.6,
                13.5
              ],
              [
                3.6,
                13.5
              ],
              [
                3.4,
                13.1
              ],
              [
                2.9,
                12.8
              ],
              [
                2.3,
                12.6
              ],
              [
                2.3,
                12.6
              ],
              [
                1.5,
                12.2
              ],
              [
                0.9,
                11.7
              ],
              [
                0.6,
                10.8
              ],
              [
                0.6,
                10.8
              ],
              [
                1.2,
                9.5
              ],
              [
                2.8,
                9
              ],
              [
                2.8,
                9
              ],
              [
                3.9,
                9.3
              ],
              [
                4.8,
                9.8
              ],
              [
                4.8,
                9.8
              ],
              [
                4.2,
                10.6
              ],
              [
                3.5,
                10.2
              ],
              [
                2.8,
                10.1
              ],
              [
                2.8,
                10.1
              ],
              [
                2.2,
                10.3
              ],
              [
                2,
                10.8
              ],
              [
                2,
                10.8
              ],
              [
                2.3,
                11.3
              ],
              [
                3.2,
                11.6
              ],
              [
                3.2,
                11.6
              ],
              [
                4,
                12
              ],
              [
                4.6,
                12.6
              ],
              [
                4.9,
                13.5
              ],
              [
                4.9,
                13.5
              ],
              [
                4.3,
                14.8
              ],
              [
                2.6,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.4,
                0
              ],
              [
                -0.4,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                -0.1,
                -0.1
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.3,
                -0.1
              ],
              [
                -0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                0.4,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0.4,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.2
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.1,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.1
              ],
              [
                0.3,
                0.1
              ],
              [
                0.2,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                -0.4,
                0.4
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2070,
    ty: 3,
    parent: 2067,
    ks: {
      p: {
        a: 0,
        k: [
          23.1,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2073,
    ty: 4,
    parent: 2072,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0.8
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.2
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.2,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.2
              ],
              [
                0.4,
                0
              ]
            ],
            v: [
              [
                2.7,
                15.3
              ],
              [
                2.7,
                15.3
              ],
              [
                1.3,
                14.7
              ],
              [
                0.8,
                12.9
              ],
              [
                0.8,
                12.9
              ],
              [
                0.8,
                9.2
              ],
              [
                2.2,
                9.2
              ],
              [
                2.2,
                12.8
              ],
              [
                2.5,
                13.8
              ],
              [
                3.2,
                14.1
              ],
              [
                3.2,
                14.1
              ],
              [
                3.8,
                13.9
              ],
              [
                4.5,
                13.3
              ],
              [
                4.5,
                13.3
              ],
              [
                4.5,
                9.2
              ],
              [
                5.9,
                9.2
              ],
              [
                5.9,
                15.2
              ],
              [
                4.7,
                15.2
              ],
              [
                4.6,
                14.3
              ],
              [
                4.6,
                14.3
              ],
              [
                3.7,
                15
              ],
              [
                2.7,
                15.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.6,
                0
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0.5
              ],
              [
                0.1,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.3
              ],
              [
                -0.3,
                0.2
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2072,
    ty: 3,
    parent: 2067,
    ks: {
      p: {
        a: 0,
        k: [
          16.322,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2075,
    ty: 4,
    parent: 2074,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.2
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                -0.3
              ],
              [
                -0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.1,
                0.3
              ],
              [
                -0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.4,
                -0.4
              ],
              [
                0.7,
                0
              ]
            ],
            v: [
              [
                1.3,
                17.6
              ],
              [
                1.3,
                17.6
              ],
              [
                0.9,
                17.6
              ],
              [
                0.5,
                17.5
              ],
              [
                0.5,
                17.5
              ],
              [
                0.8,
                16.4
              ],
              [
                1,
                16.5
              ],
              [
                1.2,
                16.5
              ],
              [
                1.2,
                16.5
              ],
              [
                2,
                16.2
              ],
              [
                2.4,
                15.5
              ],
              [
                2.4,
                15.5
              ],
              [
                2.5,
                15.1
              ],
              [
                0.1,
                9.2
              ],
              [
                1.6,
                9.2
              ],
              [
                2.6,
                12.1
              ],
              [
                2.9,
                12.9
              ],
              [
                3.1,
                13.8
              ],
              [
                3.1,
                13.8
              ],
              [
                3.2,
                13.8
              ],
              [
                3.4,
                13
              ],
              [
                3.6,
                12.1
              ],
              [
                3.6,
                12.1
              ],
              [
                4.5,
                9.2
              ],
              [
                5.9,
                9.2
              ],
              [
                3.7,
                15.4
              ],
              [
                2.8,
                17
              ],
              [
                1.3,
                17.6
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.2,
                0
              ],
              [
                -0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0.1,
                0
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                0.3
              ],
              [
                0.1,
                0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.1,
                -0.3
              ],
              [
                0.1,
                -0.3
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.3,
                0.7
              ],
              [
                -0.4,
                0.4
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2074,
    ty: 3,
    parent: 2067,
    ks: {
      p: {
        a: 0,
        k: [
          10.288,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2077,
    ty: 4,
    parent: 2076,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.3,
                15.2
              ],
              [
                0.9,
                15.2
              ],
              [
                0.9,
                9.2
              ],
              [
                2.3,
                9.2
              ],
              [
                2.3,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0.2
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                0.1
              ],
              [
                -0.3,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0.2,
                -0.1
              ],
              [
                0.3,
                0
              ]
            ],
            v: [
              [
                1.6,
                8.1
              ],
              [
                1.6,
                8.1
              ],
              [
                1,
                7.9
              ],
              [
                0.8,
                7.3
              ],
              [
                0.8,
                7.3
              ],
              [
                1,
                6.8
              ],
              [
                1.6,
                6.5
              ],
              [
                1.6,
                6.5
              ],
              [
                2.2,
                6.8
              ],
              [
                2.4,
                7.3
              ],
              [
                2.4,
                7.3
              ],
              [
                2.2,
                7.9
              ],
              [
                1.6,
                8.1
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                -0.3,
                0
              ],
              [
                -0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.2
              ],
              [
                0.2,
                -0.1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0
              ],
              [
                0.2,
                0.1
              ],
              [
                0,
                0
              ],
              [
                0,
                0.2
              ],
              [
                -0.2,
                0.1
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2076,
    ty: 3,
    parent: 2067,
    ks: {
      p: {
        a: 0,
        k: [
          7.095,
          0
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2079,
    ty: 4,
    parent: 2078,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                -0.5,
                -0.2
              ],
              [
                -0.3,
                -0.4
              ],
              [
                0,
                -0.6
              ],
              [
                0,
                0
              ],
              [
                0.3,
                -0.4
              ],
              [
                0.5,
                -0.2
              ],
              [
                0.6,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                15.2
              ],
              [
                1,
                15.2
              ],
              [
                1,
                7.2
              ],
              [
                3.5,
                7.2
              ],
              [
                5.1,
                7.4
              ],
              [
                6.2,
                8.2
              ],
              [
                6.6,
                9.7
              ],
              [
                6.6,
                9.7
              ],
              [
                6.2,
                11.1
              ],
              [
                5.1,
                12
              ],
              [
                3.6,
                12.2
              ],
              [
                3.6,
                12.2
              ],
              [
                2.4,
                12.2
              ],
              [
                2.4,
                15.2
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0.6,
                0
              ],
              [
                0.5,
                0.2
              ],
              [
                0.3,
                0.4
              ],
              [
                0,
                0
              ],
              [
                0,
                0.6
              ],
              [
                -0.3,
                0.4
              ],
              [
                -0.5,
                0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "sh",
        ks: {
          a: 0,
          k: {
            c: !0,
            i: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                1
              ],
              [
                0,
                0
              ],
              [
                0.3,
                0.2
              ],
              [
                0.6,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ],
            v: [
              [
                2.4,
                8.3
              ],
              [
                2.4,
                11.1
              ],
              [
                3.5,
                11.1
              ],
              [
                5.2,
                9.7
              ],
              [
                5.2,
                9.7
              ],
              [
                4.8,
                8.6
              ],
              [
                3.4,
                8.3
              ],
              [
                3.4,
                8.3
              ],
              [
                2.4,
                8.3
              ]
            ],
            o: [
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                1.2,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                -0.5
              ],
              [
                -0.3,
                -0.2
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ],
              [
                0,
                0
              ]
            ]
          }
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0.102,
            0.173,
            0.278
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2078,
    ty: 3,
    parent: 2067,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2067,
    ty: 3,
    parent: 2055,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2055,
    ty: 3,
    parent: 2054,
    ks: {
      p: {
        a: 0,
        k: [
          0,
          0.163
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2054,
    ty: 3,
    parent: 2053,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2053,
    ty: 3,
    parent: 1982,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1982,
    ty: 3,
    parent: 1981,
    ks: {
      p: {
        a: 0,
        k: [
          70.439,
          2.737
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2090,
    ty: 0,
    parent: 2081,
    ks: {
      a: {
        a: 0,
        k: [
          41.996,
          42.67
        ]
      },
      p: {
        a: 0,
        k: [
          41.996,
          42.67
        ]
      }
    },
    w: 16.255,
    h: 16.255,
    ip: 0,
    op: 565,
    st: 0,
    refId: "2088"
  },
  {
    ind: 2081,
    ty: 3,
    parent: 2080,
    ks: {
      p: {
        a: 0,
        k: [
          41.996,
          42.67
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2093,
    ty: 4,
    td: 1,
    parent: 2091,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            29.801,
            29.801
          ]
        },
        r: {
          a: 0,
          k: 46
        },
        s: {
          a: 0,
          k: [
            59.602,
            59.602
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0,
            0,
            0
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2092,
    ty: 4,
    tt: 1,
    parent: 2091,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                29.801,
                29.801
              ]
            },
            r: {
              a: 0,
              k: 0
            },
            s: {
              a: 0,
              k: [
                62.989,
                62.989
              ]
            }
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0,
                0,
                0,
                0
              ]
            },
            o: {
              a: 0,
              k: 0
            }
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      },
      {
        ty: "gr",
        it: [
          {
            ty: "rc",
            p: {
              a: 0,
              k: [
                29.801,
                29.801
              ]
            },
            r: {
              a: 0,
              k: 46
            },
            s: {
              a: 0,
              k: [
                59.602,
                59.602
              ]
            }
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.427,
                0.184,
                0.604
              ]
            },
            lj: 1,
            ml: 10,
            o: {
              a: 0,
              k: 100
            },
            w: {
              a: 0,
              k: 3.387
            }
          },
          {
            ty: "tr",
            o: {
              a: 0,
              k: 100
            }
          }
        ]
      }
    ]
  },
  {
    ind: 2109,
    ty: 4,
    td: 1,
    parent: 2091,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            29.801,
            29.801
          ]
        },
        r: {
          a: 0,
          k: 46
        },
        s: {
          a: 0,
          k: [
            59.602,
            59.602
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            0,
            0,
            0
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 2108,
    ty: 0,
    tt: 1,
    parent: 2091,
    ks: {},
    w: 55,
    h: 55,
    ip: 0,
    op: 565,
    st: 0,
    refId: "2106"
  },
  {
    ind: 2091,
    ty: 3,
    parent: 2080,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2080,
    ty: 3,
    parent: 1981,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 1981,
    ty: 3,
    parent: 1840,
    ks: {
      p: {
        a: 0,
        k: [
          8.127,
          8.128
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2110,
    ty: 4,
    parent: 1840,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            113.787,
            70.005
          ]
        },
        r: {
          a: 0,
          k: 5
        },
        s: {
          a: 0,
          k: [
            227.573,
            140.01
          ]
        }
      },
      {
        ty: "fl",
        c: {
          a: 0,
          k: [
            1,
            1,
            1
          ]
        },
        o: {
          a: 0,
          k: 100
        }
      }
    ]
  },
  {
    ind: 1840,
    ty: 3,
    parent: 16,
    ks: {
      p: {
        a: 1,
        k: [
          {
            t: 0,
            s: [
              -1276.148,
              22.207
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 132,
            s: [
              -1008.148,
              22.207
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 276,
            s: [
              -740.148,
              22.207
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 420,
            s: [
              -472.148,
              22.207
            ],
            i: {
              x: [
                0.2,
                1
              ],
              y: [
                1,
                1
              ]
            },
            o: {
              x: [
                0.8,
                0
              ],
              y: [
                0,
                0
              ]
            }
          },
          {
            t: 564,
            s: [
              -204.148,
              22.207
            ],
            h: 1
          }
        ]
      }
    },
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 16,
    ty: 3,
    parent: 15,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  },
  {
    ind: 2111,
    ty: 4,
    parent: 15,
    ks: {},
    ip: 0,
    op: 565,
    st: 0,
    shapes: [
      {
        ty: "rc",
        p: {
          a: 0,
          k: [
            180,
            92.5
          ]
        },
        r: {
          a: 0,
          k: 0
        },
        s: {
          a: 0,
          k: [
            360,
            185
          ]
        }
      },
      {
        ty: "gf",
        e: {
          a: 0,
          k: [
            220.884,
            -130.222
          ]
        },
        g: {
          p: 2,
          k: {
            a: 0,
            k: [
              0,
              0,
              0.2,
              0.4,
              1,
              0.569,
              0.243,
              0.808
            ]
          }
        },
        t: 1,
        o: {
          a: 0,
          k: 100
        },
        s: {
          a: 0,
          k: [
            139.116,
            213.472
          ]
        }
      }
    ]
  },
  {
    ind: 15,
    ty: 3,
    ks: {},
    ip: 0,
    op: 565,
    st: 0
  }
], j = {
  g: "https://jitter.video"
}, z = 564, L = "5.7.4", X = 360, H = {
  assets: R,
  fr: E,
  h: F,
  ip: M,
  layers: W,
  meta: j,
  op: z,
  v: L,
  w: X
}, q = ({
  showCloseButton: k = !1,
  onClose: i = () => {
  },
  onSubmitHandler: y = () => {
  },
  wrapperClassName: a = "",
  buttonText: n = "Request an Expert Session",
  footerText: d = "Users connected with Experts",
  userCount: h = "3500+",
  title: c = ""
}) => {
  const o = g({ breakpoint: 650 });
  return /* @__PURE__ */ t.createElement(s, { className: `${a} sm:vd-flex-row vd-flex-col
    vd-bg-surface-neutral-base vd-rounded-r-[16px] vd-relative vd-max-w-fit` }, /* @__PURE__ */ t.createElement(
    A,
    {
      autoPlay: !0,
      loop: !0,
      animationData: o ? H : P,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
    }
  ), k && (o ? /* @__PURE__ */ t.createElement(
    "img",
    {
      src: x,
      alt: "close-icon",
      height: 24,
      width: 24,
      onClick: i,
      className: "vd-absolute vd-top-16 vd-right-[30px]"
    }
  ) : /* @__PURE__ */ t.createElement(
    "img",
    {
      src: I,
      alt: "close-icon",
      height: 24,
      width: 24,
      onClick: i,
      className: "vd-absolute vd-top-16 vd-right-16"
    }
  )), /* @__PURE__ */ t.createElement(s, { className: "vd-flex-col vd-justify-between" }, /* @__PURE__ */ t.createElement(s, { className: "vd-flex-col sm:vd-py-24 sm:vd-px-32 vd-p-20 vd-h-full vd-justify-between vd-gap-16" }, /* @__PURE__ */ t.createElement(s, { className: "vd-flex-col" }, /* @__PURE__ */ t.createElement(s, { className: "vd-flex-col vd-gap-24" }, /* @__PURE__ */ t.createElement(s, { className: "vd-flex-col vd-gap-8" }, /* @__PURE__ */ t.createElement(
    p,
    {
      fontSize: "h1",
      weight: "bold",
      color: "text-neutral-primary",
      className: "vd-tracking-[0.032rem]"
    },
    "Thinking about a Career Transition?"
  ), /* @__PURE__ */ t.createElement(
    p,
    {
      fontSize: "h2",
      weight: "bold",
      color: "text-accent-v2-soft",
      className: "vd-underline vd-underline-offset-2"
    },
    c
  )), /* @__PURE__ */ t.createElement(s, { className: "vd-flex-col vd-gap-16" }, /* @__PURE__ */ t.createElement(
    p,
    {
      color: "text-neutral-tertiary",
      fontSize: "b3",
      weight: "bold",
      spaced: !0,
      className: "vd-opacity-[0.6]"
    },
    "HOW IT HELPS?"
  ), /* @__PURE__ */ t.createElement(s, { className: "vd-flex-col vd-gap-8 vd-items-start" }, w.map((v, e) => (!o || e !== 3) && /* @__PURE__ */ t.createElement(s, { className: "vd-flex-row vd-gap-8", key: e }, /* @__PURE__ */ t.createElement(
    r,
    {
      name: "circle-wavy-check",
      color: "icon-alert-success-soft",
      iconSize: "sm",
      type: "fill"
    }
  ), /* @__PURE__ */ t.createElement(
    p,
    {
      color: "text-neutral-secondary",
      fontSize: "b1"
    },
    v
  ))))))), /* @__PURE__ */ t.createElement(s, { className: "vd-flex-col vd-gap-7" }, /* @__PURE__ */ t.createElement(
    f,
    {
      size: "m",
      buttonType: "solid",
      variants: "hero",
      title: n,
      upperCase: !0,
      weight: "semibold",
      spaced: !0,
      onClick: y
    }
  ), /* @__PURE__ */ t.createElement("div", { className: "vd-text-center" }, /* @__PURE__ */ t.createElement(
    p,
    {
      color: "text-neutral-secondary",
      fontSize: "caption",
      fontStyle: "italic",
      weight: "regular"
    },
    "Connect with newly transitioned scaler learners."
  )))), /* @__PURE__ */ t.createElement(s, { className: "vd-flex-col vd-gap-10 vd-py-8 vd-px-32 vd-bg-background-brand-subtlest vd-rounded-br-[16px]" }, /* @__PURE__ */ t.createElement(s, { className: "vd-flex-row vd-gap-8" }, /* @__PURE__ */ t.createElement(
    r,
    {
      name: "sparkle",
      iconSize: "sm",
      color: "icon-brand-soft",
      type: "fill"
    }
  ), /* @__PURE__ */ t.createElement(
    p,
    {
      color: "text-brand-soft",
      fontSize: "b2",
      weight: "semibold"
    },
    h
  ), /* @__PURE__ */ t.createElement(
    p,
    {
      color: "text-neutral-secondary",
      fontSize: "b2",
      weight: "semibold"
    },
    d
  )))));
};
export {
  q as AcsSessionRequest
};
